/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from "./request";

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig["requestDataOptional"] extends true
  ? (
      requestData?: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_2_0_0 = "https://yapi.yuewen.com/mock/3297" as any;
const devUrl_0_2_0_0 = "https://oawww.webnovel.com" as any;
const prodUrl_0_2_0_0 = "https://www.webnovel.com" as any;
const dataKey_0_2_0_0 = "data" as any;

/**
 * 接口 [首页 index↗](https://yapi.yuewen.com/project/3297/interface/api/285397) 的 **请求类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/index`
 * @更新时间 `2024-04-28 17:39:18`
 */
export interface GoPcmSeoIndexRequest {}

/**
 * 接口 [首页 index↗](https://yapi.yuewen.com/project/3297/interface/api/285397) 的 **返回类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/index`
 * @更新时间 `2024-04-28 17:39:18`
 */
export interface GoPcmSeoIndexResponse {
  /**
   * [{"id":"60e27eb815788a400e79a592","title":"7002","subTitle":"","type":1006,"contentItems":[{"bookId":"23126079305076205","bookName":"World Online","authorName":"jdbeue","bookType":0,"categoryName":"Games","categoryId":70008,"description":"It was the year 2169. The apocalypse finally arrived. \r\n\r\nGlobal warming, zombies, nuclear war, all at once. Just one tipping point and the world itself would crumble. \r\n\r\nThen, Nova Corp, a hegemon of the corporate world, seemingly convinced the global super powers into doing the impossible: Taking everyone online. \r\n\r\nAnd they did. Everyone, poor or rich, was taken into the VRMMORPG: World Online. \r\n\r\nA fantasy world where anything was possible. A utopia, unlike everything that the real world was. \r\n\r\nBut what was supposed to become a method of existence, became a battleground for supremacy. Companies, world powers, and the rich battled to become the greatest. \r\n\r\nThe disparity between the poor and the rich grew. There was no justice in this world. It took Darwin's words further than any other. \r\nJake, as poor as one could get, was caught in the rift, torn apart by the unfair system. \r\n\r\nHe was a dog of the Shadow King Guild, and even though he was absolutely loyal, in the end, the guild cut him off. \r\n\r\nHe was without an anchor and left in the cruel world. He knew no Utopia like the others. \r\n\r\nBut one day, when he opened his eyes, nothing was the same anymore.\r\n\r\nOpening his eyes, he found himself ten years in the past. He was done being the henchman now. He was not going to let himself be used anymore. \r\n\r\nNow, it was time for him to fight back. So what if the strongest were going to stand in his way? He was going to be unstoppable.\r\n\r\nMy discord server - https://discord.gg/Dpddtatvge\r\n\r\nConsider voting with golden tickets and power stones to help me win this WSA. \r\nGifting helps support me as well. \r\n\r\nSuper gift = One bonus chapter at the end of the week\r\n\r\nTrending Monthly Goal\r\nTop 50 All-time trending - 10 Bonus Chapters\r\nTop 25 All-time trending - 20 Bonus Chapters","score":"4.20","coverId":1689007874406}]},{"id":"","title":"Gentlemen's Picks","subTitle":"","type":7003,"contentItems":[{"bookId":"22237587405080505","name":"Everyone Has Four Skills","itemType":0,"authorName":"Li Xinsui","categoryId":70001,"categoryName":"Urban","description":"Spiritual auras rejuvenated in the world, and everyone awakened four skills.\r\nWhat would happen if everyone possessed skills similar to that in games?\r\nWould there be one-on-one fights between people?\r\nWould there be battles of wits among teams?\r\nWould there be close-quarter combat with savage beasts?\r\nHowever, Mo Xiu wondered, “Isn’t everyone supposed to only have four skills? Why do I have so many?”","score":"3.37","coverId":1646289500544,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.1\",\"expid\":33000,\"itemid\":\"22237587405080505\",\"logid\":6491073420301870809,\"origin\":\"12058\",\"preitemid\":\"b_22237587405080505\",\"scene\":\"completed\",\"type\":\"0\",\"version\":\"0\"}"}]},{"id":"","title":"Ranking","subTitle":"","type":7005,"contentItems":[{"title":"Power Ranking","subTitle":"","type":3001,"items":[{"bookId":"6831850602000905","name":"Library of Heaven's Path","authorName":"Heng Sao Tian Ya","itemType":0,"categoryName":"Eastern","categoryId":70009,"description":"Traversing into another world, Zhang Xuan finds himself becoming an honorable teacher. \r\nAlong with his transcension, a mysterious library appears in his mind. \r\nAs long as it is something he has seen, regardless of whether it is a human or an object, a book on its weaknesses will be automatically compiled in the library. \r\nThus, he becomes formidable. \r\n\"Monarch Zhuoyang, why do you detest wearing your underwear so much? As an emperor, can't you pay a little more attention to your image?\"  \r\n\"Fairy Linglong, you can always look for me if you find yourself unable to sleep at night. I am skilled in lullabies!\" \r\n\"And you, Demon Monarch Qiankun! Can you cut down on the garlic? Are you trying to kill me with that stench?\" \r\nThis is an incredible story about teachers and students, grooming and guiding the greatest experts in the world!\r\nDiscord Chat Group: https://discord.gg/ATHVehx","score":"4.39","coverId":1600167042546}]},{"title":"New","subTitle":"","type":3001,"items":[{"bookId":"28966521000430705","name":"Re-End","authorName":"kenechi","itemType":0,"categoryName":"Fantasy","categoryId":70002,"description":"","score":"0.00","coverId":1709790673526}]},{"title":"Popular Ranking","subTitle":"","type":3001,"items":[{"bookId":"16709365405930105","name":"My Vampire System","authorName":"JKSManga","itemType":0,"categoryName":"Fantasy","categoryId":70002,"description":"The human Race is at war with the Vicious Dalki and when they needed help more than ever, THEY started to come forward. \r\n\r\nHumans who had hidden in the shadows for hundreds of years, people with abilities. \r\n\r\nSome chose to share their knowledge to the rest of the world in hopes of winning the war, while others kept their abilities to themselves.\r\n\r\nQuinn had lost everything to the war, his home, his family and the only thing he had inherited was a crummy old book that he couldn’t even open. \r\n\r\nBut when the book had finally opened, Quinn was granted a system and his whole life was turned around. \r\n\r\nHe completed quest after quest and became more powerful, until one day the system gave him a quest he wasn’t sure he could complete. \r\n\r\n\"It is time to feed!\"\r\n\"You must drink human blood within 24 hours\"\r\n\"Your HP will continue to decrease until the task has been completed\"\r\n\r\nhttps://discord.gg/kqCxfZF6xH\r\nInstagram: JKSManga\r\n\r\nOTHER WORKS\r\nMy Werewolf System\r\nMy Dragon System","score":"4.60","coverId":1704957681775}]}]},{"id":"","title":"ladies' Picks","subTitle":"","type":7003,"contentItems":[{"bookId":"12442416605461305","name":"Reincarnated into a Hell Hound - BL/Yaoi","itemType":0,"authorName":"VCris","categoryId":70019,"categoryName":"LGBT+","description":"Once I woke up I discovered that my limbs ended in paws, and that my ears could move about, for my new form is that of a dog! But not only that, I soon realize that there is nothing simple in this new world full of magic, for my true species is that of a hell hound, a creature made of fire and shadow that could stir fear at those who dared approach!\r\n\r\nOr well… the definition of being scary looking is at least suitable for me, proud and powerful as I’m, as for my brother… sigh, what can I say at such dumb creature who loves chewing at my ears?!\r\n\r\nNot only do I have to survive in this strange world with this strange body, but have to keep my brother out of trouble! \r\n\r\nAt least, for better or for worse, we won’t be alone for long after crossing the path of two clingy elves and- no, wait, hold on, where do you think those hands are? Stop touching my brother you pervert elf! Come back here! And you, stop touching me too, let me teach them a lesson oi!\r\n\r\nSigh, I’m surrounded by troublesome guys!\r\n\r\n…Well, at least they are to die for…no, I mean, scram!\r\n~~~~~\r\n\r\nML: You are so cute when you are angry.\r\n\r\nMC: C-c-c-cute?! I’ll show you how cute I’m! I’ll bite your ankles!\r\n\r\nML: But I have made food for you…\r\n\r\nMC:…\r\n\r\nMC:Ok, I can beat you later, but why is your hand on my tail oi?!\r\n\r\nML:*chuckles*\r\n\r\n~~Warning~~ \r\nMature content, including gore, explicit smut, swearing, relationship between men.\r\n~~~~~\r\n\r\nThank you and I hope you enjoy it! *wink wink*\r\n۹(ÒہÓ)۶","score":"4.64","coverId":1703444783150,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.1\",\"expid\":33000,\"itemid\":\"12442416605461305\",\"logid\":7729514359601911330,\"origin\":\"12058\",\"preitemid\":\"b_12442416605461305\",\"scene\":\"completed\",\"type\":\"0\",\"version\":\"0\"}"}]},{"id":"","title":"Ranking","subTitle":"","type":7005,"contentItems":[{"title":"Power Ranking","subTitle":"","type":3001,"items":[{"bookId":"8060642606003005","name":"Full Marks Hidden Marriage: Pick Up a Son, Get a Free Husband","authorName":"Jiong Jiong You Yao","itemType":0,"categoryName":"Urban","categoryId":70014,"description":"After five years, Ning Xi returned to the place that had pushed her away — home. With a sister who turned her parents against her and made her childhood sweetheart betray her, the odds seemed grey.\r\nHowever, five years abroad had changed her, and she came home to fulfil her childhood dream of becoming an actress. Despite her evil sister still out to get her, tables will be turned. \r\nOne day, after falling into one of her sister's schemes, she saves an adorable kid and found herself staying at his house to help him come out of his shell. Slowly, his father Lu Tingxiao began falling for her. This was before they realised how their lives had been intertwined all this while without their knowledge.","score":"4.67","coverId":1645598977000}]},{"title":"New","subTitle":"","type":3001,"items":[{"bookId":"29067399000681705","name":"Dumb Husky and His White Cat Shizun (2ha)","authorName":"Bettygift","itemType":0,"categoryName":"LGBT+","categoryId":70019,"description":"Mo Ran thought becoming Chu Wanning’s disciple was a mistake.\nHis shizun was really too much like a cat while he himself was a dumb pup who’d only slobber and wag his tail.\nDogs and cats were different by nature; originally, the dumb pup didn’t want to extend his furry paws to that cat.\nHe originally thought, dogs should be with dogs, like his shixiong, beautiful and tame like a cute Japanese Spitz, and the two of them together would surely be a match made in heaven.\nYet, after having died and reborn, after having lived two lives, the one he hauled back each time to his den in the end was always the one he couldn’t stand at first: that snow-white kitty shizun.\nDumb off the charts husky gong x proud, aggravated, big white cat shou Emperor of the cultivation world Mo Weiyu deceived elders and slaughtered ancestors, and committed all crimes and sins known to man. After ending his own life, he was reborn and transmigrated to the year he first became a disciple.\nIn the shell of a boy held an old and weary soul. After coming back to life,\ntruth after truths that had been hidden below the surface in the previous life floated to the top and broke through the waters one after the other.\nOf all the revelations, the one that stunned him the most was that the Shizun he had hated to the bone in his previous life had always been protecting him from the shadows…\nThe heart of man can change; even demons and monsters can become compassionate and do good. Only, he had sinned deeply. Can the blood on his hands ever be cleansed?\n\n\nNovel written by *Meatbun doesn't eat meat*","score":"0.00","coverId":1710916250597}]},{"title":"Popular Ranking","subTitle":"","type":3001,"items":[{"bookId":"14205835806705305","name":"Married to the Devil's Son","authorName":"JasmineJosef","itemType":0,"categoryName":"Fantasy","categoryId":70016,"description":"【Volume 1 - Married to the Devil's Son】\r\n\r\nA prince, rumored to be the son of the Devil.\r\nHe is the definition of Danger.\r\nHe is the Darkness itself.\r\n\r\nA princess. Imprisoned in her own home, only to come out once she gets married.\r\nBut married to whom?\r\n***\r\n\r\nOnce upon a time, the Devil fell in love with one of the King's many wives. One night he went to her room disguised as her husband and made love to her. She got pregnant with his child. Knowing this The King ordered her execution believing his wife cheated on him, but then the Devil appeared to the king making him a deal. In exchange for great power for his Kingdom, the King will let his wife Sire The Devil's Child. The King who was greedy for power agrees to the deal and his Kingdom becomes one of the most powerful Kingdoms and the Devil's Child, the seventh Prince of the Kingdom.\r\n          \r\nBeing a princess probably sounds nice. A life full of luxury, beautiful dresses and nice shoes, but for Hazel, there is nothing nice about being a princess. She can never go outside the palace, she can never have friends, she can never eat or say or wear whatever she wants and she can never choose the person she is going to marry. Soon she's getting married to a man she has never met, a prince rumored to be Son of the Devil.\r\n\r\n\r\n【Volume 2 - Return of the Devil's Son】\r\n\r\n**Sequel to Married to the Devil's son**\r\n\r\nHe is back! This time fiercer, faster and stronger, with only one thing in mind. Revenge!\r\n                                                             \r\nPrince of Darkness, Son of the Devil, Lucian is back, and he has only one thing on his mind. Revenge! That's until he meets her. A woman who entices him beyond reason, but who also claims to be his wife. Surrounded by dark secrets and powerful enemies, Lucian must decide who to trust and who to destroy. \r\n\r\nAfter getting her heart broken once, Klara vowed never to fall in love again. But when her brother tries to force her into a marriage and the annoying but wickedly handsome Roshan rescues her, things get difficult. \r\n\r\nCan she protect her heart from the man whose touch sets her body aflame? Or will she surrender to her desire and risk her heart once again?\r\n\r\n——————————————————————————————————\r\n\r\n【Volume 3 - The Devil In Her Dreams】\r\n\r\n\r\nTHE BEAST AMONGST US\r\n\r\nImagine living in a world full of fiery, feral beings, hiding in the shadows, roving in our dreams, creeping under our skin. Eavesdropping, manipulating our minds and exploring our bodies. They are savages, beasts but some of them are companions and childhood friends. \r\n\r\nSome are dangerous, others even more dangerous. They live amongst us. Some of us call them Demons, others call them Djinn. But some of them should never be called. \r\n\r\nTHE BEAUTY  LOOKING FOR LOVE \r\n\r\nHeaven, the devil’s granddaughter and princess of Decresh has everything in life. Loving parents, beauty, wealth, and status. But one thing is missing. And that is love. Heaven dreams of the kind of love her parents have and now that she has come of age to get married she has to find her dream man and the future king of Decresh. And she has to find him soon. \r\n\r\nThere is one man. A mysterious silver-eyed stranger who keeps appearing in her dreams. Who is he and what does he want?\r\n\r\nAs the line of suitors grows, Heaven’s dreams become more vivid forcing her to go on a journey to find the man in her dreams. Could he also be the man of her dreams? Or would he turn out to be a nightmare?","score":"4.70","coverId":1622892231065}]}]},{"id":"","title":"Lastest Update","subTitle":"","type":2011,"contentItems":[{"bookId":"20199782605918605","name":"Chaos' Heir","itemType":2,"categoryId":70002,"categoryName":"Fantasy","LastChapterName":"","LastChapterTime":1707322846097},{"bookId":"28546597008070505","name":"My Love Debts Are Everywhere!","itemType":2,"categoryId":70002,"categoryName":"Fantasy","LastChapterName":"","LastChapterTime":1710697222235},{"bookId":"28633238100920005","name":"Reincarnated in the Astral World","itemType":2,"categoryId":70002,"categoryName":"Fantasy","LastChapterName":"","LastChapterTime":1712236751191}]}]
   */
  blockItems?: {
    /**
     * "60e27eb815788a400e79a592"
     */
    id?: string;
    /**
     * "7002"
     */
    title?: string;
    subTitle?: string;
    /**
     * 1006
     */
    type?: number;
    /**
     * [{"bookId":"23126079305076205","bookName":"World Online","authorName":"jdbeue","bookType":0,"categoryName":"Games","categoryId":70008,"description":"It was the year 2169. The apocalypse finally arrived. \r\n\r\nGlobal warming, zombies, nuclear war, all at once. Just one tipping point and the world itself would crumble. \r\n\r\nThen, Nova Corp, a hegemon of the corporate world, seemingly convinced the global super powers into doing the impossible: Taking everyone online. \r\n\r\nAnd they did. Everyone, poor or rich, was taken into the VRMMORPG: World Online. \r\n\r\nA fantasy world where anything was possible. A utopia, unlike everything that the real world was. \r\n\r\nBut what was supposed to become a method of existence, became a battleground for supremacy. Companies, world powers, and the rich battled to become the greatest. \r\n\r\nThe disparity between the poor and the rich grew. There was no justice in this world. It took Darwin's words further than any other. \r\nJake, as poor as one could get, was caught in the rift, torn apart by the unfair system. \r\n\r\nHe was a dog of the Shadow King Guild, and even though he was absolutely loyal, in the end, the guild cut him off. \r\n\r\nHe was without an anchor and left in the cruel world. He knew no Utopia like the others. \r\n\r\nBut one day, when he opened his eyes, nothing was the same anymore.\r\n\r\nOpening his eyes, he found himself ten years in the past. He was done being the henchman now. He was not going to let himself be used anymore. \r\n\r\nNow, it was time for him to fight back. So what if the strongest were going to stand in his way? He was going to be unstoppable.\r\n\r\nMy discord server - https://discord.gg/Dpddtatvge\r\n\r\nConsider voting with golden tickets and power stones to help me win this WSA. \r\nGifting helps support me as well. \r\n\r\nSuper gift = One bonus chapter at the end of the week\r\n\r\nTrending Monthly Goal\r\nTop 50 All-time trending - 10 Bonus Chapters\r\nTop 25 All-time trending - 20 Bonus Chapters","score":"4.20","coverId":1689007874406}]
     */
    contentItems?: {
      /**
       * "23126079305076205"
       */
      bookId?: string;
      /**
       * "World Online"
       */
      bookName?: string;
      /**
       * "jdbeue"
       */
      authorName?: string;
      bookType?: number;
      /**
       * "Games"
       */
      categoryName?: string;
      /**
       * 70008
       */
      categoryId?: number;
      /**
       * "It was the year 2169. The apocalypse finally arrived. \r\n\r\nGlobal warming, zombies, nuclear war, all at once. Just one tipping point and the world itself would crumble. \r\n\r\nThen, Nova Corp, a hegemon of the corporate world, seemingly convinced the global super powers into doing the impossible: Taking everyone online. \r\n\r\nAnd they did. Everyone, poor or rich, was taken into the VRMMORPG: World Online. \r\n\r\nA fantasy world where anything was possible. A utopia, unlike everything that the real world was. \r\n\r\nBut what was supposed to become a method of existence, became a battleground for supremacy. Companies, world powers, and the rich battled to become the greatest. \r\n\r\nThe disparity between the poor and the rich grew. There was no justice in this world. It took Darwin's words further than any other. \r\nJake, as poor as one could get, was caught in the rift, torn apart by the unfair system. \r\n\r\nHe was a dog of the Shadow King Guild, and even though he was absolutely loyal, in the end, the guild cut him off. \r\n\r\nHe was without an anchor and left in the cruel world. He knew no Utopia like the others. \r\n\r\nBut one day, when he opened his eyes, nothing was the same anymore.\r\n\r\nOpening his eyes, he found himself ten years in the past. He was done being the henchman now. He was not going to let himself be used anymore. \r\n\r\nNow, it was time for him to fight back. So what if the strongest were going to stand in his way? He was going to be unstoppable.\r\n\r\nMy discord server - https://discord.gg/Dpddtatvge\r\n\r\nConsider voting with golden tickets and power stones to help me win this WSA. \r\nGifting helps support me as well. \r\n\r\nSuper gift = One bonus chapter at the end of the week\r\n\r\nTrending Monthly Goal\r\nTop 50 All-time trending - 10 Bonus Chapters\r\nTop 25 All-time trending - 20 Bonus Chapters"
       */
      description?: string;
      /**
       * "4.20"
       */
      score?: string;
      /**
       * 1689007874406
       */
      coverId?: number;
    }[];
  }[];
}

/**
 * 接口 [首页 index↗](https://yapi.yuewen.com/project/3297/interface/api/285397) 的 **请求配置的类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/index`
 * @更新时间 `2024-04-28 17:39:18`
 */
type GoPcmSeoIndexRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/index",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [首页 index↗](https://yapi.yuewen.com/project/3297/interface/api/285397) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/index`
 * @更新时间 `2024-04-28 17:39:18`
 */
const goPcmSeoIndexRequestConfig: GoPcmSeoIndexRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_2_0_0,
  devUrl: devUrl_0_2_0_0,
  prodUrl: prodUrl_0_2_0_0,
  path: "/go/pcm/seo/index",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_2_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "goPcmSeoIndex",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [首页 index↗](https://yapi.yuewen.com/project/3297/interface/api/285397) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/index`
 * @更新时间 `2024-04-28 17:39:18`
 */
export const goPcmSeoIndex = /*#__PURE__*/ (
  requestData?: GoPcmSeoIndexRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoIndexResponse>(
    prepare(goPcmSeoIndexRequestConfig, requestData),
    ...args
  );
};

goPcmSeoIndex.requestConfig = goPcmSeoIndexRequestConfig;

/**
 * 接口 [搜索词列表查询↗](https://yapi.yuewen.com/project/3297/interface/api/285489) 的 **请求类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/getKeywordList`
 * @更新时间 `2024-05-11 15:05:20`
 */
export interface GoPcmSeoGetKeywordListRequest {
  /**
   * 搜索词分类
   */
  cate?: string;
  /**
   * 页号，默认1
   */
  pageIndex?: string;
  /**
   * 分页大小，默认180
   */
  pageSize?: string;
}

/**
 * 接口 [搜索词列表查询↗](https://yapi.yuewen.com/project/3297/interface/api/285489) 的 **返回类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/getKeywordList`
 * @更新时间 `2024-05-11 15:05:20`
 */
export interface GoPcmSeoGetKeywordListResponse {
  /**
   * [{"lang":"en","searchWord":"vanilla"},{"lang":"en","searchWord":"venus"},{"lang":"en","searchWord":"victor"},{"lang":"en","searchWord":"abcd"}]
   */
  keywords?: {
    /**
     * "en"
     */
    lang?: string;
    /**
     * "vanilla"
     */
    searchWord?: string;
  }[];
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 3
   */
  total?: number;
  /**
   * true
   */
  isLast?: boolean;
  /**
   * 40
   */
  pages?: number;
}

/**
 * 接口 [搜索词列表查询↗](https://yapi.yuewen.com/project/3297/interface/api/285489) 的 **请求配置的类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/getKeywordList`
 * @更新时间 `2024-05-11 15:05:20`
 */
type GoPcmSeoGetKeywordListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/getKeywordList",
    "data",
    string,
    "cate" | "pageIndex" | "pageSize",
    false
  >
>;

/**
 * 接口 [搜索词列表查询↗](https://yapi.yuewen.com/project/3297/interface/api/285489) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/getKeywordList`
 * @更新时间 `2024-05-11 15:05:20`
 */
const goPcmSeoGetKeywordListRequestConfig: GoPcmSeoGetKeywordListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/getKeywordList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: ["cate", "pageIndex", "pageSize"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetKeywordList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [搜索词列表查询↗](https://yapi.yuewen.com/project/3297/interface/api/285489) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/getKeywordList`
 * @更新时间 `2024-05-11 15:05:20`
 */
export const goPcmSeoGetKeywordList = /*#__PURE__*/ (
  requestData: GoPcmSeoGetKeywordListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoGetKeywordListResponse>(
    prepare(goPcmSeoGetKeywordListRequestConfig, requestData),
    ...args
  );
};

goPcmSeoGetKeywordList.requestConfig = goPcmSeoGetKeywordListRequestConfig;

/**
 * 接口 [书详情↗](https://yapi.yuewen.com/project/3297/interface/api/285782) 的 **请求类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/book/getBookDetailPage`
 * @更新时间 `2024-04-28 17:39:21`
 */
export interface GoPcmSeoBookGetBookDetailPageRequest {
  bookId: string;
}

/**
 * 接口 [书详情↗](https://yapi.yuewen.com/project/3297/interface/api/285782) 的 **返回类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/book/getBookDetailPage`
 * @更新时间 `2024-04-28 17:39:21`
 */
export interface GoPcmSeoBookGetBookDetailPageResponse {
  bookInfo?: {
    /**
     * "8060642606003005"
     */
    bookId?: string;
    /**
     * "Full Marks Hidden Marriage: Pick Up a Son, Get a Free Husband"
     */
    name?: string;
    /**
     * "HM"
     */
    shortName?: string;
    /**
     * "en"
     */
    language?: string;
    /**
     * "3004974201061301"
     */
    authorId?: string;
    /**
     * "Jiong Jiong You Yao"
     */
    authorName?: string;
    itemType?: number;
    /**
     * "Unselected"
     */
    ageGroup?: string;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * "Urban"
     */
    categoryName?: string;
    /**
     * 70014
     */
    categoryId?: number;
    /**
     * 20
     */
    scheduleUpdateFrq?: number;
    /**
     * 2
     */
    scheduleUpdateFrqUnit?: number;
    updateFrequency?: number;
    frequencyUnit?: string;
    promiseFrequencyUnit?: string;
    promiseUpdateFrequency?: number;
    /**
     * 2165
     */
    chapterNum?: number;
    /**
     * 2165
     */
    totalChapterNum?: number;
    /**
     * 50
     */
    actionStatus?: number;
    /**
     * 4.67
     */
    score?: number;
    /**
     * "After five years, Ning Xi returned to the place that had pushed her away — home. With a sister who turned her parents against her and made her childhood sweetheart betray her, the odds seemed grey.\r\nHowever, five years abroad had changed her, and she came home to fulfil her childhood dream of becoming an actress. Despite her evil sister still out to get her, tables will be turned. \r\nOne day, after falling into one of her sister's schemes, she saves an adorable kid and found herself staying at his house to help him come out of his shell. Slowly, his father Lu Tingxiao began falling for her. This was before they realised how their lives had been intertwined all this while without their knowledge."
     */
    description?: string;
    /**
     * 453718147
     */
    pvNum?: number;
    /**
     * 1501039952000
     */
    checkTime?: number;
    /**
     * 1710228844000
     */
    updateTime?: number;
    /**
     * [{"Id":41000121,"TagName":"ACTION","LikeCount":0,"Like":false},{"Id":41000010,"TagName":"ROMANCE","LikeCount":0,"Like":false},{"Id":41000170,"TagName":"COMEDY","LikeCount":0,"Like":false},{"Id":41000019,"TagName":"REVENGE","LikeCount":0,"Like":false},{"Id":41004234,"TagName":"BEAUTY","LikeCount":0,"Like":false},{"Id":41000316,"TagName":"CEO","LikeCount":0,"Like":false},{"Id":41001868,"TagName":"POSSESSIVE","LikeCount":0,"Like":false},{"Id":51003788,"TagName":"POWERFULCOUPLE","LikeCount":0,"Like":false},{"Id":51063749,"TagName":"HIGHIQ","LikeCount":0,"Like":false},{"Id":41003638,"TagName":"PREGNANCY","LikeCount":0,"Like":false},{"Id":41002788,"TagName":"SUPERSTAR","LikeCount":0,"Like":false},{"Id":41001399,"TagName":"SHOWBIZ","LikeCount":0,"Like":false},{"Id":41005204,"TagName":"COMDIA","LikeCount":0,"Like":false}]
     */
    tagInfos?: {
      /**
       * 41000121
       */
      Id?: number;
      /**
       * "ACTION"
       */
      TagName?: string;
      LikeCount?: number;
      Like?: boolean;
    }[];
    expected?: number;
    /**
     * "21657035804306187"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    translateMode?: number;
    /**
     * 5
     */
    categoryType?: number;
    authorUserId?: number;
    /**
     * [{"Id":"19173474186626093","Name":"EndlessFantasy Translation "},{"Id":"24468854256253794","Name":"Henyee Translations"}]
     */
    groupItems?: {
      /**
       * "19173474186626093"
       */
      Id?: string;
      /**
       * "EndlessFantasy Translation "
       */
      Name?: string;
    }[];
    /**
     * [{"Id":"10088880505003001","Name":"Daoist7","UserId":3238304053,"Guid":3238304053}]
     */
    editorItems?: {
      /**
       * "10088880505003001"
       */
      Id?: string;
      /**
       * "Daoist7"
       */
      Name?: string;
      /**
       * 3238304053
       */
      UserId?: number;
      /**
       * 3238304053
       */
      Guid?: number;
    }[];
    /**
     * [{"Id":"10088880606004401","Name":"chjean","UserId":1530598671,"Guid":1530598671}]
     */
    translatorItems?: {
      /**
       * "10088880606004401"
       */
      Id?: string;
      /**
       * "chjean"
       */
      Name?: string;
      /**
       * 1530598671
       */
      UserId?: number;
      /**
       * 1530598671
       */
      Guid?: number;
    }[];
    /**
     * 1645598977000
     */
    coverId?: number;
    inLibrary?: number;
    /**
     * "Seven Months Pregnant"
     */
    firstChapterName?: string;
    /**
     * []
     */
    animationItems?: unknown[];
    /**
     * []
     */
    notes?: unknown[];
    advText?: string;
    advActionUrl?: string;
    picPC?: string;
    feverLink?: string;
    /**
     * [{"name":"FEMALEPROTAGONIST"},{"name":"ROMANCE"},{"name":"REVENGE"},{"name":"MODERN"},{"name":"ACTION"},{"name":"COMEDY"},{"name":"BEAUTIFULFEMALELEAD"},{"name":"CEO"},{"name":"CELEBRITY"},{"name":"RAPE"},{"name":"SHOWBIZ"},{"name":"CELEBRITIES"},{"name":"PREGNANCY"},{"name":"MOVIES"},{"name":"DOTINGLOVEINTERESTS"},{"name":"HANDSOMEMALELEAD"}]
     */
    relatedWords?: {
      /**
       * "FEMALEPROTAGONIST"
       */
      name?: string;
    }[];
    /**
     * "21727619294138394"
     */
    readToChapterId?: string;
  };
}

/**
 * 接口 [书详情↗](https://yapi.yuewen.com/project/3297/interface/api/285782) 的 **请求配置的类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/book/getBookDetailPage`
 * @更新时间 `2024-04-28 17:39:21`
 */
type GoPcmSeoBookGetBookDetailPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/book/getBookDetailPage",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [书详情↗](https://yapi.yuewen.com/project/3297/interface/api/285782) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/book/getBookDetailPage`
 * @更新时间 `2024-04-28 17:39:21`
 */
const goPcmSeoBookGetBookDetailPageRequestConfig: GoPcmSeoBookGetBookDetailPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/book/getBookDetailPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoBookGetBookDetailPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书详情↗](https://yapi.yuewen.com/project/3297/interface/api/285782) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/book/getBookDetailPage`
 * @更新时间 `2024-04-28 17:39:21`
 */
export const goPcmSeoBookGetBookDetailPage = /*#__PURE__*/ (
  requestData: GoPcmSeoBookGetBookDetailPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoBookGetBookDetailPageResponse>(
    prepare(goPcmSeoBookGetBookDetailPageRequestConfig, requestData),
    ...args
  );
};

goPcmSeoBookGetBookDetailPage.requestConfig =
  goPcmSeoBookGetBookDetailPageRequestConfig;

/**
 * 接口 [书详情-获取礼物详情↗](https://yapi.yuewen.com/project/3297/interface/api/285785) 的 **请求类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/gift/getGiftInfo`
 * @更新时间 `2024-04-28 17:39:22`
 */
export interface GoPcmSeoGiftGetGiftInfoRequest {
  bookId: string;
  /**
   * itemType
   */
  novelType: string;
}

/**
 * 接口 [书详情-获取礼物详情↗](https://yapi.yuewen.com/project/3297/interface/api/285785) 的 **返回类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/gift/getGiftInfo`
 * @更新时间 `2024-04-28 17:39:22`
 */
export interface GoPcmSeoGiftGetGiftInfoResponse {
  /**
   * 1
   */
  giftNum?: number;
  giftMax?: {
    /**
     * 197744
     */
    id?: number;
    /**
     * "8060642606003005"
     */
    bookId?: string;
    /**
     * "21727619565215789"
     */
    chapterId?: string;
    /**
     * 4304811452
     */
    userId?: number;
    /**
     * 1
     */
    giftAmount?: number;
    /**
     * "7298769624129153143"
     */
    orderId?: string;
    /**
     * 20007
     */
    giftId?: number;
    /**
     * 2000
     */
    totalPrice?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * "Pullagurajayasree"
     */
    userName?: string;
    /**
     * 1572888010744
     */
    UUT?: number;
    /**
     * "Dragon"
     */
    giftName?: string;
    /**
     * 2000
     */
    giftPrice?: number;
    /**
     * "https://webbanner.webnovel.com/gift/1637207860_8675.png"
     */
    iconUrl?: string;
    /**
     * 1
     */
    status?: number;
    /**
     * 1
     */
    order?: number;
  };
  /**
   * [{"UUT":0,"appId":10,"giftId":20001,"giftName":" Ice cola","giftPrice":10,"iconUrl":"https://webbanner.webnovel.com/gift/1637207943_1716.png","id":198035,"order":1,"status":1,"userId":4302647673,"userName":"Patricia_Chong_Goh"}]
   */
  giftRecords?: {
    UUT?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 20001
     */
    giftId?: number;
    /**
     * " Ice cola"
     */
    giftName?: string;
    /**
     * 10
     */
    giftPrice?: number;
    /**
     * "https://webbanner.webnovel.com/gift/1637207943_1716.png"
     */
    iconUrl?: string;
    /**
     * 198035
     */
    id?: number;
    /**
     * 1
     */
    order?: number;
    /**
     * 1
     */
    status?: number;
    /**
     * 4302647673
     */
    userId?: number;
    /**
     * "Patricia_Chong_Goh"
     */
    userName?: string;
  }[];
}

/**
 * 接口 [书详情-获取礼物详情↗](https://yapi.yuewen.com/project/3297/interface/api/285785) 的 **请求配置的类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/gift/getGiftInfo`
 * @更新时间 `2024-04-28 17:39:22`
 */
type GoPcmSeoGiftGetGiftInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/gift/getGiftInfo",
    "data",
    string,
    "bookId" | "novelType",
    false
  >
>;

/**
 * 接口 [书详情-获取礼物详情↗](https://yapi.yuewen.com/project/3297/interface/api/285785) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/gift/getGiftInfo`
 * @更新时间 `2024-04-28 17:39:22`
 */
const goPcmSeoGiftGetGiftInfoRequestConfig: GoPcmSeoGiftGetGiftInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/gift/getGiftInfo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: ["bookId", "novelType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGiftGetGiftInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书详情-获取礼物详情↗](https://yapi.yuewen.com/project/3297/interface/api/285785) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/gift/getGiftInfo`
 * @更新时间 `2024-04-28 17:39:22`
 */
export const goPcmSeoGiftGetGiftInfo = /*#__PURE__*/ (
  requestData: GoPcmSeoGiftGetGiftInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoGiftGetGiftInfoResponse>(
    prepare(goPcmSeoGiftGetGiftInfoRequestConfig, requestData),
    ...args
  );
};

goPcmSeoGiftGetGiftInfo.requestConfig = goPcmSeoGiftGetGiftInfoRequestConfig;

/**
 * 接口 [书详情_获取ps榜排行↗](https://yapi.yuewen.com/project/3297/interface/api/285794) 的 **请求类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/powerStone/getRankInfoAjax`
 * @更新时间 `2024-04-28 17:39:23`
 */
export interface GoPcmSeoPowerStoneGetRankInfoAjaxRequest {
  bookId: string;
}

/**
 * 接口 [书详情_获取ps榜排行↗](https://yapi.yuewen.com/project/3297/interface/api/285794) 的 **返回类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/powerStone/getRankInfoAjax`
 * @更新时间 `2024-04-28 17:39:23`
 */
export interface GoPcmSeoPowerStoneGetRankInfoAjaxResponse {
  /**
   * 53
   */
  catchUpNums?: number;
  /**
   * 28
   */
  followUpNums?: number;
  /**
   * 2327
   */
  nextNums?: number;
  /**
   * 2354
   */
  powerNums?: number;
  /**
   * 2406
   */
  preNums?: number;
  /**
   * 14
   */
  rank?: number;
}

/**
 * 接口 [书详情_获取ps榜排行↗](https://yapi.yuewen.com/project/3297/interface/api/285794) 的 **请求配置的类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/powerStone/getRankInfoAjax`
 * @更新时间 `2024-04-28 17:39:23`
 */
type GoPcmSeoPowerStoneGetRankInfoAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/powerStone/getRankInfoAjax",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [书详情_获取ps榜排行↗](https://yapi.yuewen.com/project/3297/interface/api/285794) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/powerStone/getRankInfoAjax`
 * @更新时间 `2024-04-28 17:39:23`
 */
const goPcmSeoPowerStoneGetRankInfoAjaxRequestConfig: GoPcmSeoPowerStoneGetRankInfoAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/powerStone/getRankInfoAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoPowerStoneGetRankInfoAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书详情_获取ps榜排行↗](https://yapi.yuewen.com/project/3297/interface/api/285794) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/powerStone/getRankInfoAjax`
 * @更新时间 `2024-04-28 17:39:23`
 */
export const goPcmSeoPowerStoneGetRankInfoAjax = /*#__PURE__*/ (
  requestData: GoPcmSeoPowerStoneGetRankInfoAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoPowerStoneGetRankInfoAjaxResponse>(
    prepare(goPcmSeoPowerStoneGetRankInfoAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmSeoPowerStoneGetRankInfoAjax.requestConfig =
  goPcmSeoPowerStoneGetRankInfoAjaxRequestConfig;

/**
 * 接口 [书详情_获取推荐you may also like↗](https://yapi.yuewen.com/project/3297/interface/api/285797) 的 **请求类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/recommend/getRecommendList`
 * @更新时间 `2024-04-28 17:39:23`
 */
export interface GoPcmSeoRecommendGetRecommendListRequest {
  bookId: string;
}

/**
 * 接口 [书详情_获取推荐you may also like↗](https://yapi.yuewen.com/project/3297/interface/api/285797) 的 **返回类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/recommend/getRecommendList`
 * @更新时间 `2024-04-28 17:39:23`
 */
export interface GoPcmSeoRecommendGetRecommendListResponse {
  bookInfo?: {
    /**
     * "8060642606003005"
     */
    bookId?: string;
    /**
     * "Full Marks Hidden Marriage: Pick Up a Son, Get a Free Husband"
     */
    name?: string;
    itemType?: number;
    /**
     * "Jiong Jiong You Yao"
     */
    authorName?: string;
    /**
     * 70014
     */
    categoryId?: number;
    /**
     * "Contemporary Romance"
     */
    categoryName?: string;
    /**
     * 50
     */
    actionStatus?: number;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * 1
     */
    type?: number;
    /**
     * 1
     */
    translateMode?: number;
    /**
     * 1
     */
    categoryType?: number;
  };
  /**
   * [{"bookId":"8212987205006305","name":"Trial Marriage Husband: Need to Work Hard","itemType":0,"categoryId":70014,"categoryName":"Urban","description":"The night before their wedding, her fiancé ran off with his mistress.\r\nOut of frustration, she grabbed the man standing in front of the Civil Affairs Office, \"President Mo, your bride has not arrived and my groom has run away...May I suggest we get married?\"\r\nBefore marriage, she said, \"Even if we were to share the same bed, nothing would happen between us!\"\r\nAfter marriage, he said, \"If we don't try, how would we know?\"","alg":"","authorName":"Passion Honey","totalScore":4.7,"totalChapterNum":1274,"tagInfo":[{"Id":41000010,"TagName":"ROMANCE","LikeCount":0,"Like":false},{"Id":41000293,"TagName":"BETRAYAL","LikeCount":0,"Like":false},{"Id":41000019,"TagName":"REVENGE","LikeCount":0,"Like":false},{"Id":41004234,"TagName":"BEAUTY","LikeCount":0,"Like":false},{"Id":51003788,"TagName":"POWERFULCOUPLE","LikeCount":0,"Like":false},{"Id":51003589,"TagName":"FACESLAPPING","LikeCount":0,"Like":false},{"Id":41001399,"TagName":"SHOWBIZ","LikeCount":0,"Like":false}],"translateMode":1,"coverId":1547686809014}]
   */
  recommendListItems?: {
    /**
     * "8212987205006305"
     */
    bookId?: string;
    /**
     * "Trial Marriage Husband: Need to Work Hard"
     */
    name?: string;
    itemType?: number;
    /**
     * 70014
     */
    categoryId?: number;
    /**
     * "Urban"
     */
    categoryName?: string;
    /**
     * "The night before their wedding, her fiancé ran off with his mistress.\r\nOut of frustration, she grabbed the man standing in front of the Civil Affairs Office, \"President Mo, your bride has not arrived and my groom has run away...May I suggest we get married?\"\r\nBefore marriage, she said, \"Even if we were to share the same bed, nothing would happen between us!\"\r\nAfter marriage, he said, \"If we don't try, how would we know?\""
     */
    description?: string;
    alg?: string;
    /**
     * "Passion Honey"
     */
    authorName?: string;
    /**
     * 4.7
     */
    totalScore?: number;
    /**
     * 1274
     */
    totalChapterNum?: number;
    /**
     * [{"Id":41000010,"TagName":"ROMANCE","LikeCount":0,"Like":false},{"Id":41000293,"TagName":"BETRAYAL","LikeCount":0,"Like":false},{"Id":41000019,"TagName":"REVENGE","LikeCount":0,"Like":false},{"Id":41004234,"TagName":"BEAUTY","LikeCount":0,"Like":false},{"Id":51003788,"TagName":"POWERFULCOUPLE","LikeCount":0,"Like":false},{"Id":51003589,"TagName":"FACESLAPPING","LikeCount":0,"Like":false},{"Id":41001399,"TagName":"SHOWBIZ","LikeCount":0,"Like":false}]
     */
    tagInfo?: {
      /**
       * 41000010
       */
      Id?: number;
      /**
       * "ROMANCE"
       */
      TagName?: string;
      LikeCount?: number;
      Like?: boolean;
    }[];
    /**
     * 1
     */
    translateMode?: number;
    /**
     * 1547686809014
     */
    coverId?: number;
  }[];
  /**
   * true
   */
  isLast?: boolean;
}

/**
 * 接口 [书详情_获取推荐you may also like↗](https://yapi.yuewen.com/project/3297/interface/api/285797) 的 **请求配置的类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/recommend/getRecommendList`
 * @更新时间 `2024-04-28 17:39:23`
 */
type GoPcmSeoRecommendGetRecommendListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/recommend/getRecommendList",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [书详情_获取推荐you may also like↗](https://yapi.yuewen.com/project/3297/interface/api/285797) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/recommend/getRecommendList`
 * @更新时间 `2024-04-28 17:39:23`
 */
const goPcmSeoRecommendGetRecommendListRequestConfig: GoPcmSeoRecommendGetRecommendListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/recommend/getRecommendList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoRecommendGetRecommendList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书详情_获取推荐you may also like↗](https://yapi.yuewen.com/project/3297/interface/api/285797) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/recommend/getRecommendList`
 * @更新时间 `2024-04-28 17:39:23`
 */
export const goPcmSeoRecommendGetRecommendList = /*#__PURE__*/ (
  requestData: GoPcmSeoRecommendGetRecommendListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoRecommendGetRecommendListResponse>(
    prepare(goPcmSeoRecommendGetRecommendListRequestConfig, requestData),
    ...args
  );
};

goPcmSeoRecommendGetRecommendList.requestConfig =
  goPcmSeoRecommendGetRecommendListRequestConfig;

/**
 * 接口 [书详情_获取评论↗](https://yapi.yuewen.com/project/3297/interface/api/285800) 的 **请求类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/bookReview/getReviews`
 * @更新时间 `2024-04-28 17:39:24`
 */
export interface GoPcmSeoBookReviewGetReviewsRequest {
  bookId: string;
  /**
   *  页码
   */
  pageIndex: string;
  pageSize: string;
  /**
   * 排序方式:1-liked、2-newest
   */
  orderBy: string;
}

/**
 * 接口 [书详情_获取评论↗](https://yapi.yuewen.com/project/3297/interface/api/285800) 的 **返回类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/bookReview/getReviews`
 * @更新时间 `2024-04-28 17:39:24`
 */
export interface GoPcmSeoBookReviewGetReviewsResponse {
  bookStatisticsInfo?: {
    /**
     * 47845
     */
    totalReviewNum?: number;
    /**
     * 4.67
     */
    totalScore?: number;
    /**
     * 4.6761
     */
    translationQuality?: number;
    /**
     * 4.6336713
     */
    updatingStability?: number;
    /**
     * 4.6943254
     */
    storyDevelopment?: number;
    /**
     * 4.710022
     */
    characterDesign?: number;
    /**
     * 4.6559095
     */
    worldBackGround?: number;
    /**
     * 1
     */
    itemType?: number;
    /**
     * "Full Marks Hidden Marriage: Pick Up a Son, Get a Free Husband"
     */
    name?: string;
  };
  /**
   * [{"reviewId":4279,"content":"I want all chapters 😭😭 \nThis novel was translated to 258 already😑\nWhy begin again Big bun little bun and Nx I miss you guys😭\nMemories aside😐\n\nNovel has short chapter (ty for 20ch week)\nStory has slow movement🙂\nCharacters are lovable 😍\nPlot is real at least it makes sense😁\nUmm I can't really explain well 😐\nI had diabetes reading this novel 😅\nThere's a lot of drama 😕\nAnd a lot of scheming 🤔\nThe relationship of the main start at 250+😑\nYeah it's that slow 🙄\nExpect a lot of things as this novel has its ups and downs 😁\n\nI should stop here... 😕😕 my words are getting more and more weird 🙂. \n\nOh and welcome to Qidian daoist7 🙏","bookId":"8060642606003005","userId":3668725355,"userName":"RukitoRin","headImageId":1589714007637,"userRole":0,"userLevel":11,"totalScore":5,"replyAmount":1812,"likeAmount":1765,"leakFlag":0,"isLiked":0,"createTime":1501041725000,"createTimeFormat":"6yr","holdBadgeCoverURL":"https://actimg.webnovel.com/badge/10006/3/","holdBadgeCoverId":1517481162000,"appId":10,"topStatus":false,"imageItems":[],"essenceStatus":0,"isViceModerator":0,"isLikedByAuthor":0,"status":1}]
   */
  bookReviewInfos?: {
    /**
     * 4279
     */
    reviewId?: number;
    /**
     * "I want all chapters 😭😭 \nThis novel was translated to 258 already😑\nWhy begin again Big bun little bun and Nx I miss you guys😭\nMemories aside😐\n\nNovel has short chapter (ty for 20ch week)\nStory has slow movement🙂\nCharacters are lovable 😍\nPlot is real at least it makes sense😁\nUmm I can't really explain well 😐\nI had diabetes reading this novel 😅\nThere's a lot of drama 😕\nAnd a lot of scheming 🤔\nThe relationship of the main start at 250+😑\nYeah it's that slow 🙄\nExpect a lot of things as this novel has its ups and downs 😁\n\nI should stop here... 😕😕 my words are getting more and more weird 🙂. \n\nOh and welcome to Qidian daoist7 🙏"
     */
    content?: string;
    /**
     * "8060642606003005"
     */
    bookId?: string;
    /**
     * 3668725355
     */
    userId?: number;
    /**
     * "RukitoRin"
     */
    userName?: string;
    /**
     * 1589714007637
     */
    headImageId?: number;
    userRole?: number;
    /**
     * 11
     */
    userLevel?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * 1812
     */
    replyAmount?: number;
    /**
     * 1765
     */
    likeAmount?: number;
    leakFlag?: number;
    isLiked?: number;
    /**
     * 1501041725000
     */
    createTime?: number;
    /**
     * "6yr"
     */
    createTimeFormat?: string;
    /**
     * "https://actimg.webnovel.com/badge/10006/3/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1517481162000
     */
    holdBadgeCoverId?: number;
    /**
     * 10
     */
    appId?: number;
    topStatus?: boolean;
    /**
     * []
     */
    imageItems?: unknown[];
    essenceStatus?: number;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * 1
     */
    status?: number;
  }[];
  /**
   * "https://webbanner.webnovel.com/privilege/"
   */
  basePrivilegeUrl?: string;
  /**
   * 47845
   */
  reviewNum?: number;
  userInfo?: {
    userRole?: number;
    isViceModerator?: number;
  };
  isLast?: number;
  baseInfo?: {
    /**
     * "8060642606003005"
     */
    bookId?: string;
    itemType?: number;
    /**
     * "Full Marks Hidden Marriage: Pick Up a Son, Get a Free Husband"
     */
    name?: string;
    /**
     * "After five years, Ning Xi returned to the place that had pushed her away — home. With a sister who turned her parents against her and made her childhood sweetheart betray her, the odds seemed grey.\r\nHowever, five years abroad had changed her, and she came home to fulfil her childhood dream of becoming an actress. Despite her evil sister still out to get her, tables will be turned. \r\nOne day, after falling into one of her sister's schemes, she saves an adorable kid and found herself staying at his house to help him come out of his shell. Slowly, his father Lu Tingxiao began falling for her. This was before they realised how their lives had been intertwined all this while without their knowledge."
     */
    description?: string;
    /**
     * 1645598977000
     */
    coverId?: number;
    /**
     * "Jiong Jiong You Yao"
     */
    authorName?: string;
    /**
     * "https://webbanner.webnovel.com/privilege/"
     */
    basePrivilegeUrl?: string;
    /**
     * 47845
     */
    reviewAmount?: number;
    /**
     * "en"
     */
    language?: string;
    /**
     * 453718180
     */
    pvNum?: number;
  };
}

/**
 * 接口 [书详情_获取评论↗](https://yapi.yuewen.com/project/3297/interface/api/285800) 的 **请求配置的类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/bookReview/getReviews`
 * @更新时间 `2024-04-28 17:39:24`
 */
type GoPcmSeoBookReviewGetReviewsRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/bookReview/getReviews",
    "data",
    string,
    "bookId" | "pageIndex" | "pageSize" | "orderBy",
    false
  >
>;

/**
 * 接口 [书详情_获取评论↗](https://yapi.yuewen.com/project/3297/interface/api/285800) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/bookReview/getReviews`
 * @更新时间 `2024-04-28 17:39:24`
 */
const goPcmSeoBookReviewGetReviewsRequestConfig: GoPcmSeoBookReviewGetReviewsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/bookReview/getReviews",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: ["bookId", "pageIndex", "pageSize", "orderBy"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoBookReviewGetReviews",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书详情_获取评论↗](https://yapi.yuewen.com/project/3297/interface/api/285800) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/bookReview/getReviews`
 * @更新时间 `2024-04-28 17:39:24`
 */
export const goPcmSeoBookReviewGetReviews = /*#__PURE__*/ (
  requestData: GoPcmSeoBookReviewGetReviewsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoBookReviewGetReviewsResponse>(
    prepare(goPcmSeoBookReviewGetReviewsRequestConfig, requestData),
    ...args
  );
};

goPcmSeoBookReviewGetReviews.requestConfig =
  goPcmSeoBookReviewGetReviewsRequestConfig;

/**
 * 接口 [书详情_Emoji↗](https://yapi.yuewen.com/project/3297/interface/api/285809) 的 **请求类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/emoji/getEmoji`
 * @更新时间 `2024-04-28 17:39:27`
 */
export interface GoPcmSeoEmojiGetEmojiRequest {}

/**
 * 接口 [书详情_Emoji↗](https://yapi.yuewen.com/project/3297/interface/api/285809) 的 **返回类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/emoji/getEmoji`
 * @更新时间 `2024-04-28 17:39:27`
 */
export interface GoPcmSeoEmojiGetEmojiResponse {
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/coins.png"
   */
  "[img=coins]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/exp.png"
   */
  "[img=exp]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/faceslap.png"
   */
  "[img=faceslap]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/fp.png"
   */
  "[img=fp]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/recommend.png"
   */
  "[img=recommend]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/update.png"
   */
  "[img=update]"?: string;
}

/**
 * 接口 [书详情_Emoji↗](https://yapi.yuewen.com/project/3297/interface/api/285809) 的 **请求配置的类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/emoji/getEmoji`
 * @更新时间 `2024-04-28 17:39:27`
 */
type GoPcmSeoEmojiGetEmojiRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/emoji/getEmoji",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [书详情_Emoji↗](https://yapi.yuewen.com/project/3297/interface/api/285809) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/emoji/getEmoji`
 * @更新时间 `2024-04-28 17:39:27`
 */
const goPcmSeoEmojiGetEmojiRequestConfig: GoPcmSeoEmojiGetEmojiRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/emoji/getEmoji",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoEmojiGetEmoji",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书详情_Emoji↗](https://yapi.yuewen.com/project/3297/interface/api/285809) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/emoji/getEmoji`
 * @更新时间 `2024-04-28 17:39:27`
 */
export const goPcmSeoEmojiGetEmoji = /*#__PURE__*/ (
  requestData?: GoPcmSeoEmojiGetEmojiRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoEmojiGetEmojiResponse>(
    prepare(goPcmSeoEmojiGetEmojiRequestConfig, requestData),
    ...args
  );
};

goPcmSeoEmojiGetEmoji.requestConfig = goPcmSeoEmojiGetEmojiRequestConfig;

/**
 * 接口 [书详情_获取内容↗](https://yapi.yuewen.com/project/3297/interface/api/285812) 的 **请求类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getContent`
 * @更新时间 `2024-05-11 15:43:55`
 */
export interface GoPcmSeoChapterGetContentRequest {
  bookId: string;
  chapterId: string;
  encryptType: string;
}

/**
 * 接口 [书详情_获取内容↗](https://yapi.yuewen.com/project/3297/interface/api/285812) 的 **返回类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getContent`
 * @更新时间 `2024-05-11 15:43:55`
 */
export interface GoPcmSeoChapterGetContentResponse {
  bookInfo?: {
    /**
     * "8060642606003005"
     */
    bookId?: string;
    /**
     * "Full Marks Hidden Marriage: Pick Up a Son, Get a Free Husband"
     */
    name?: string;
    /**
     * "Jiong Jiong You Yao"
     */
    authorName?: string;
    /**
     * "3004974201061301"
     */
    authorId?: string;
    /**
     * 2165
     */
    totalChapterNum?: number;
    /**
     * 50
     */
    actionStatus?: number;
    /**
     * 1
     */
    type?: number;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "en"
     */
    language?: string;
    itemType?: number;
    /**
     * 47845
     */
    reviewTotal?: number;
    /**
     * 15
     */
    checkLevel?: number;
    totalPreChapterNum?: number;
    /**
     * 1
     */
    translateMode?: number;
    /**
     * [{"id":"19173474186626093","userId":0,"guid":0,"name":"EndlessFantasy Translation ","UUT":0},{"id":"24468854256253794","userId":0,"guid":0,"name":"Henyee Translations","UUT":0}]
     */
    groupItems?: {
      /**
       * "19173474186626093"
       */
      id?: string;
      userId?: number;
      guid?: number;
      /**
       * "EndlessFantasy Translation "
       */
      name?: string;
      UUT?: number;
    }[];
    /**
     * [{"id":"10088880606004401","userId":1530598671,"guid":1530598671,"name":"chjean","UUT":0}]
     */
    editorItems?: {
      /**
       * "10088880606004401"
       */
      id?: string;
      /**
       * 1530598671
       */
      userId?: number;
      /**
       * 1530598671
       */
      guid?: number;
      /**
       * "chjean"
       */
      name?: string;
      UUT?: number;
    }[];
    /**
     * [{"id":"10088880505003001","userId":3238304053,"guid":3238304053,"name":"Daoist7","UUT":0}]
     */
    translatorItems?: {
      /**
       * "10088880505003001"
       */
      id?: string;
      /**
       * 3238304053
       */
      userId?: number;
      /**
       * 3238304053
       */
      guid?: number;
      /**
       * "Daoist7"
       */
      name?: string;
      UUT?: number;
    }[];
    /**
     * [{"id":0,"userId":0,"guid":0,"name":"Jiong Jiong You Yao","UUT":0}]
     */
    authorItems?: {
      id?: number;
      userId?: number;
      guid?: number;
      /**
       * "Jiong Jiong You Yao"
       */
      name?: string;
      UUT?: number;
    }[];
    patreonLink?: string;
    /**
     * 1645598977000
     */
    coverUpdateTime?: number;
    /**
     * 1
     */
    giftNum?: number;
    /**
     * []
     */
    videoAdIds?: unknown[];
    /**
     * []
     */
    adIds?: unknown[];
    availableFpNum?: number;
    /**
     * 1501039952000
     */
    checkTime?: number;
    /**
     * 1710228844000
     */
    updateTime?: number;
    /**
     * 1
     */
    isShowAds?: number;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * 70014
     */
    categoryId?: number;
    /**
     * "Contemporary Romance"
     */
    categoryName?: string;
    /**
     * "After five years, Ning Xi returned to the place that had pushed her away — home. With a sister who turned her parents against her and made her childhood sweetheart betray her, the odds seemed grey.\r\nHowever, five years abroad had changed her, and she came home to fulfil her childhood dream of becoming an actress. Despite her evil sister still out to get her, tables will be turned. \r\nOne day, after falling into one of her sister's schemes, she saves an adorable kid and found herself staying at his house to help him come out of his shell. Slowly, his father Lu Tingxiao began falling for her. This was before they realised how their lives had been intertwined all this while without their knowledge."
     */
    description?: string;
    /**
     * [{"tagId":41000121,"tagName":"ACTION","likeNums":0,"isLiked":0},{"tagId":41000010,"tagName":"ROMANCE","likeNums":0,"isLiked":0},{"tagId":41000170,"tagName":"COMEDY","likeNums":0,"isLiked":0},{"tagId":41000019,"tagName":"REVENGE","likeNums":0,"isLiked":0},{"tagId":41004234,"tagName":"BEAUTY","likeNums":0,"isLiked":0},{"tagId":41000316,"tagName":"CEO","likeNums":0,"isLiked":0},{"tagId":41001868,"tagName":"POSSESSIVE","likeNums":0,"isLiked":0},{"tagId":51003788,"tagName":"POWERFULCOUPLE","likeNums":0,"isLiked":0},{"tagId":51063749,"tagName":"HIGHIQ","likeNums":0,"isLiked":0},{"tagId":41003638,"tagName":"PREGNANCY","likeNums":0,"isLiked":0},{"tagId":41002788,"tagName":"SUPERSTAR","likeNums":0,"isLiked":0},{"tagId":41001399,"tagName":"SHOWBIZ","likeNums":0,"isLiked":0},{"tagId":41005204,"tagName":"COMDIA","likeNums":0,"isLiked":0}]
     */
    tagInfos?: {
      /**
       * 41000121
       */
      tagId?: number;
      /**
       * "ACTION"
       */
      tagName?: string;
      likeNums?: number;
      isLiked?: number;
    }[];
  };
  chapterInfo?: {
    /**
     * "21657035804306187"
     */
    chapterId?: string;
    /**
     * "Seven Months Pregnant"
     */
    chapterName?: string;
    /**
     * 1
     */
    chapterIndex?: number;
    /**
     * "-1"
     */
    preChapterId?: string;
    preChapterName?: string;
    /**
     * "21727619293958172"
     */
    nextChapterId?: string;
    /**
     * "The Stranger’s Bastard"
     */
    nextChapterName?: string;
    vipStatus?: number;
    price?: number;
    originalPrice?: number;
    discountInfo?: string;
    chapterLevel?: number;
    userLevel?: number;
    /**
     * [{"contentId":"","content":"<p>Her body burned hot like lava inside a volcano. The only one who could save her now was the man before her eyes.</p>","appId":0,"userId":0,"paragraphId":"c9432c31066fa34c5f1f22db98062969","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0}]
     */
    contents?: {
      contentId?: string;
      /**
       * "<p>Her body burned hot like lava inside a volcano. The only one who could save her now was the man before her eyes.</p>"
       */
      content?: string;
      appId?: number;
      userId?: number;
      /**
       * "c9432c31066fa34c5f1f22db98062969"
       */
      paragraphId?: string;
      likeAmount?: number;
      contentAmount?: number;
      userName?: string;
      UUT?: number;
      isLiked?: number;
    }[];
    /**
     * 1
     */
    isAuth?: number;
    /**
     * 1
     */
    batchUnlockStatus?: number;
    /**
     * 1
     */
    isRichFormat?: number;
    /**
     * []
     */
    announcementItems?: unknown[];
    /**
     * []
     */
    groupItems?: unknown[];
    /**
     * [{"id":"19173474186626093","userId":0,"guid":0,"name":"EndlessFantasy Translation ","UUT":0},{"id":"24468854256253794","userId":0,"guid":0,"name":"Henyee Translations","UUT":0}]
     */
    editorItems?: {
      /**
       * "19173474186626093"
       */
      id?: string;
      userId?: number;
      guid?: number;
      /**
       * "EndlessFantasy Translation "
       */
      name?: string;
      UUT?: number;
    }[];
    /**
     * [{"id":"19173474186626093","userId":0,"guid":0,"name":"EndlessFantasy Translation ","UUT":0},{"id":"24468854256253794","userId":0,"guid":0,"name":"Henyee Translations","UUT":0}]
     */
    translatorItems?: {
      /**
       * "19173474186626093"
       */
      id?: string;
      userId?: number;
      guid?: number;
      /**
       * "EndlessFantasy Translation "
       */
      name?: string;
      UUT?: number;
    }[];
    /**
     * "21657035804306187"
     */
    firstChapterId?: string;
    /**
     * [{"reviewId":1025412,"content":"All pervious chapters being released. New readers would able to enjoy the entire story","userId":548730406,"createTime":"6yr","reviewType":2,"pUserId":4300155173,"pContent":"Why was this re-translated?","likeNums":669,"isLiked":0,"status":1,"pStatus":1,"commentType":1,"appId":10,"pAppId":10,"UUT":1548839155000,"userName":"WEBNOVEL_OFFICIAL","avatar":0,"penName":"WEBNOVEL_OFFICIAL","pUUT":1576393816000,"pUserName":"MyLifeIsAFurnace","pUserImg":0,"pPenName":"MyLifeIsAFurnace","role":0,"userLevel":10,"badgeInfo":{"badgeId":10008,"badgeType":"Growth","badgeName":"Author","maxGrade":4,"baseUrl":"https://actimg.webnovel.com/badge/10008/4/","updateTime":1523334037000}},{"reviewId":1053407,"content":"Diving into a new obsession! *excited*😍😍😍🍿","userId":4300046503,"createTime":"6yr","reviewType":1,"pUserId":0,"pContent":"","likeNums":473,"isLiked":1,"status":1,"pStatus":0,"commentType":1,"appId":10,"pAppId":0,"UUT":1514075766000,"userName":"Seraphina22","avatar":0,"penName":"Seraphina22","pUUT":0,"pUserName":"","pUserImg":0,"pPenName":"","role":0,"userLevel":3,"badgeInfo":{"badgeId":10006,"badgeType":"Growth","badgeName":"Cultivator","maxGrade":4,"baseUrl":"https://actimg.webnovel.com/badge/10006/1/","updateTime":1517481162000}},{"reviewId":3095865,"content":"Im new here welcome","userId":4300558379,"createTime":"6yr","reviewType":1,"pUserId":0,"pContent":"","likeNums":369,"isLiked":0,"status":1,"pStatus":0,"commentType":1,"appId":10,"pAppId":0,"UUT":1523883987000,"userName":"minjin","avatar":0,"penName":"minjin","pUUT":0,"pUserName":"","pUserImg":0,"pPenName":"","role":0,"userLevel":2,"badgeInfo":{"badgeId":10006,"badgeType":"Growth","badgeName":"Cultivator","maxGrade":4,"baseUrl":"https://actimg.webnovel.com/badge/10006/1/","updateTime":1517481162000}}]
     */
    chapterReviewItems?: {
      /**
       * 1025412
       */
      reviewId?: number;
      /**
       * "All pervious chapters being released. New readers would able to enjoy the entire story"
       */
      content?: string;
      /**
       * 548730406
       */
      userId?: number;
      /**
       * "6yr"
       */
      createTime?: string;
      /**
       * 2
       */
      reviewType?: number;
      /**
       * 4300155173
       */
      pUserId?: number;
      /**
       * "Why was this re-translated?"
       */
      pContent?: string;
      /**
       * 669
       */
      likeNums?: number;
      isLiked?: number;
      /**
       * 1
       */
      status?: number;
      /**
       * 1
       */
      pStatus?: number;
      /**
       * 1
       */
      commentType?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * 10
       */
      pAppId?: number;
      /**
       * 1548839155000
       */
      UUT?: number;
      /**
       * "WEBNOVEL_OFFICIAL"
       */
      userName?: string;
      avatar?: number;
      /**
       * "WEBNOVEL_OFFICIAL"
       */
      penName?: string;
      /**
       * 1576393816000
       */
      pUUT?: number;
      /**
       * "MyLifeIsAFurnace"
       */
      pUserName?: string;
      pUserImg?: number;
      /**
       * "MyLifeIsAFurnace"
       */
      pPenName?: string;
      role?: number;
      /**
       * 10
       */
      userLevel?: number;
      badgeInfo?: {
        /**
         * 10008
         */
        badgeId?: number;
        /**
         * "Growth"
         */
        badgeType?: string;
        /**
         * "Author"
         */
        badgeName?: string;
        /**
         * 4
         */
        maxGrade?: number;
        /**
         * "https://actimg.webnovel.com/badge/10008/4/"
         */
        baseUrl?: string;
        /**
         * 1523334037000
         */
        updateTime?: number;
      };
    }[];
    /**
     * 1
     */
    firstChapterIndex?: number;
    /**
     * 131505
     */
    reviewTotal?: number;
    notes?: {
      /**
       * "Henyee"
       */
      name?: string;
      /**
       * "279550753"
       */
      guid?: string;
      /**
       * "Henyee"
       */
      penName?: string;
      /**
       * "//user-pic.webnovel.com/userheadimg/279550753-10/1.jpg?uut=0"
       */
      avatar?: string;
      UUT?: number;
      /**
       * "translator"
       */
      role?: string;
      /**
       * "Dear readers, Henyee Translations here!\r\nHope you're all enjoying the novel ~^^~"
       */
      note?: string;
    };
    /**
     * 1
     */
    orderIndex?: number;
    noArchive?: number;
    transRating?: number;
    banner?: {
      coverUrl?: string;
      desc?: string;
    };
    adPosition?: {
      readChapterEnd?: boolean;
    };
    encryptType?: number;
    encryptKeyPool?: string;
    /**
     * 1714296114
     */
    encryptVersion?: number;
    nextChapterEncrypt?: {};
    /**
     * 1
     */
    fastPassNum?: number;
    isToApp?: boolean;
    /**
     * 1530168694000
     */
    updateTime?: number;
    /**
     * 1515469027000
     */
    publishTime?: number;
  };
  machineTrans?: {
    isWhiteUser?: number;
  };
  membershipStatus?: number;
  /**
   * []
   */
  relatedBook?: unknown[];
  /**
   * []
   */
  relatedChapter?: unknown[];
  /**
   * [{"tagId":41000121,"tagName":"action"},{"tagId":51001182,"tagName":"nonhuman"},{"tagId":41000165,"tagName":"dark"},{"tagId":41000075,"tagName":"reincarnation"},{"tagId":51006885,"tagName":"campus"},{"tagId":41000578,"tagName":"levelup"}]
   */
  relatedTag?: {
    /**
     * 41000121
     */
    tagId?: number;
    /**
     * "action"
     */
    tagName?: string;
  }[];
  waitpayStatus?: number;
}

/**
 * 接口 [书详情_获取内容↗](https://yapi.yuewen.com/project/3297/interface/api/285812) 的 **请求配置的类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getContent`
 * @更新时间 `2024-05-11 15:43:55`
 */
type GoPcmSeoChapterGetContentRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/chapter/getContent",
    "data",
    string,
    "bookId" | "chapterId" | "encryptType",
    false
  >
>;

/**
 * 接口 [书详情_获取内容↗](https://yapi.yuewen.com/project/3297/interface/api/285812) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getContent`
 * @更新时间 `2024-05-11 15:43:55`
 */
const goPcmSeoChapterGetContentRequestConfig: GoPcmSeoChapterGetContentRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/chapter/getContent",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: ["bookId", "chapterId", "encryptType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoChapterGetContent",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书详情_获取内容↗](https://yapi.yuewen.com/project/3297/interface/api/285812) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getContent`
 * @更新时间 `2024-05-11 15:43:55`
 */
export const goPcmSeoChapterGetContent = /*#__PURE__*/ (
  requestData: GoPcmSeoChapterGetContentRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoChapterGetContentResponse>(
    prepare(goPcmSeoChapterGetContentRequestConfig, requestData),
    ...args
  );
};

goPcmSeoChapterGetContent.requestConfig =
  goPcmSeoChapterGetContentRequestConfig;

/**
 * 接口 [搜索_search↗](https://yapi.yuewen.com/project/3297/interface/api/285985) 的 **请求类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/result`
 * @更新时间 `2024-05-09 16:48:09`
 */
export interface GoPcmSeoSearchResultRequest {
  keywords: string;
  pageIndex: string;
  /**
   * categoryType说明，1:小说 2：漫画 3：出版书 4：Fan-fic
   */
  categoryType: string;
}

/**
 * 接口 [搜索_search↗](https://yapi.yuewen.com/project/3297/interface/api/285985) 的 **返回类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/result`
 * @更新时间 `2024-05-09 16:48:09`
 */
export interface GoPcmSeoSearchResultResponse {
  /**
   * true
   */
  isLast?: boolean;
  /**
   * [{"bookId":"12595111301037805","name":"hello","itemType":0,"description":"123","categoryId":70001,"categoryName":"Urban","authorName":"hello","score":0,"coverId":1581421906244,"translateMode":1}]
   */
  bookItems?: {
    /**
     * "12595111301037805"
     */
    bookId?: string;
    /**
     * "hello"
     */
    name?: string;
    itemType?: number;
    /**
     * "123"
     */
    description?: string;
    /**
     * 70001
     */
    categoryId?: number;
    /**
     * "Urban"
     */
    categoryName?: string;
    /**
     * "hello"
     */
    authorName?: string;
    score?: number;
    /**
     * 1581421906244
     */
    coverId?: number;
    /**
     * 1
     */
    translateMode?: number;
  }[];
}

/**
 * 接口 [搜索_search↗](https://yapi.yuewen.com/project/3297/interface/api/285985) 的 **请求配置的类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/result`
 * @更新时间 `2024-05-09 16:48:09`
 */
type GoPcmSeoSearchResultRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/search/result",
    "data",
    string,
    "keywords" | "pageIndex" | "categoryType",
    false
  >
>;

/**
 * 接口 [搜索_search↗](https://yapi.yuewen.com/project/3297/interface/api/285985) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/result`
 * @更新时间 `2024-05-09 16:48:09`
 */
const goPcmSeoSearchResultRequestConfig: GoPcmSeoSearchResultRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/search/result",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: ["keywords", "pageIndex", "categoryType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoSearchResult",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [搜索_search↗](https://yapi.yuewen.com/project/3297/interface/api/285985) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/result`
 * @更新时间 `2024-05-09 16:48:09`
 */
export const goPcmSeoSearchResult = /*#__PURE__*/ (
  requestData: GoPcmSeoSearchResultRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoSearchResultResponse>(
    prepare(goPcmSeoSearchResultRequestConfig, requestData),
    ...args
  );
};

goPcmSeoSearchResult.requestConfig = goPcmSeoSearchResultRequestConfig;

/**
 * 接口 [分类_分类搜索↗](https://yapi.yuewen.com/project/3297/interface/api/285992) 的 **请求类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `POST /go/pcm/seo/category/search`
 * @更新时间 `2024-05-07 20:05:45`
 */
export interface GoPcmSeoCategorySearchRequest {
  /**
   * 0:All
   * 1:Male Oriented（sexattr=1）
   * 2:Female Oriented（sexattr=2）
   */
  sex: string;
  /**
   * 0:All
   * 1:Urban（categoryid=70001+70014）
   * 2:Fantasy（categoryid=70002+70016）
   * 3:History（categoryid=70003+70015）
   * 4:Horror（categoryid=70004）
   * 5:Sci-fi（categoryid=70006+70017）
   * 6:Sports（categoryid=70007）
   * 7:Games（categoryid=70008）
   * 8:Eastern（categoryid=70009）
   * 9:Realistic（categoryid=70010）
   * 10:Action（categoryid=70012）
   * 11:War（categoryid=70013）
   * 12:Teen（categoryid=70018）
   * 13:LGBT+（categoryid=70019）
   * 14:Fanfic（freetype=8，逻辑可以为freetype≠5）
   */
  categoryId: string;
  /**
   * 0:All
   * 1:Completed（status=50）
   * 2:Ongoing（status=30）
   */
  bookStatus: string;
  /**
   * 0:All
   * 1: Free（vipstatus=-1）
   * 2:VIP（vipstatus=1）
   */
  vipStatus: string;
  /**
   * 1:Popular
   * 2:Recommended
   * 3:Most Collections
   * 4:Rating
   * 5:Time Updated
   */
  orderBy: string;
  /**
   * 1
   */
  pageIndex: string;
}

/**
 * 接口 [分类_分类搜索↗](https://yapi.yuewen.com/project/3297/interface/api/285992) 的 **返回类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `POST /go/pcm/seo/category/search`
 * @更新时间 `2024-05-07 20:05:45`
 */
export interface GoPcmSeoCategorySearchResponse {
  /**
   * [{"bookId":"8060642606003005","name":"Full Marks Hidden Marriage: Pick Up a Son, Get a Free Husband","itemType":0,"description":"After five years, Ning Xi returned to the place that had pushed her away — home. With a sister who turned her parents against her and made her childhood sweetheart betray her, the odds seemed grey.\r\nHowever, five years abroad had changed her, and she came home to fulfil her childhood dream of becoming an actress. Despite her evil sister still out to get her, tables will be turned. \r\nOne day, after falling into one of her sister's schemes, she saves an adorable kid and found herself staying at his house to help him come out of his shell. Slowly, his father Lu Tingxiao began falling for her. This was before they realised how their lives had been intertwined all this while without their knowledge.","categoryId":70014,"categoryName":"Urban","authorName":"Jiong Jiong You Yao","score ":4.67,"coverId":1645598977000}]
   */
  items?: {
    /**
     * "8060642606003005"
     */
    bookId?: string;
    /**
     * "Full Marks Hidden Marriage: Pick Up a Son, Get a Free Husband"
     */
    name?: string;
    itemType?: number;
    /**
     * "After five years, Ning Xi returned to the place that had pushed her away — home. With a sister who turned her parents against her and made her childhood sweetheart betray her, the odds seemed grey.\r\nHowever, five years abroad had changed her, and she came home to fulfil her childhood dream of becoming an actress. Despite her evil sister still out to get her, tables will be turned. \r\nOne day, after falling into one of her sister's schemes, she saves an adorable kid and found herself staying at his house to help him come out of his shell. Slowly, his father Lu Tingxiao began falling for her. This was before they realised how their lives had been intertwined all this while without their knowledge."
     */
    description?: string;
    /**
     * 70014
     */
    categoryId?: number;
    /**
     * "Urban"
     */
    categoryName?: string;
    /**
     * "Jiong Jiong You Yao"
     */
    authorName?: string;
    /**
     * 4.67
     */
    score?: number;
    /**
     * 1645598977000
     */
    coverId?: number;
  }[];
  /**
   * 10000
   */
  total?: number;
  isLast?: number;
  filterConfig?: {
    /**
     * [{"name":"ALL","formName":"sex","value":0},{"name":"Male Oriented","formName":"sex","value":1},{"name":"Female Oriented","formName":"sex","value":2}]
     */
    sexList?: {
      /**
       * "ALL"
       */
      name?: string;
      /**
       * "sex"
       */
      formName?: string;
      value?: number;
    }[];
    /**
     * [{"name":"All","formName":"categoryId","value":0},{"name":"Urban","formName":"categoryId","value":1},{"name":"Fantasy","formName":"categoryId","value":2},{"name":"History","formName":"categoryId","value":3},{"name":"Horror","formName":"categoryId","value":4},{"name":"Sci-fi","formName":"categoryId","value":5},{"name":"Sports","formName":"categoryId","value":6},{"name":"Games","formName":"categoryId","value":7},{"name":"Eastern","formName":"categoryId","value":8},{"name":"Realistic","formName":"categoryId","value":9},{"name":"Action","formName":"categoryId","value":10},{"name":"War","formName":"categoryId","value":11},{"name":"Teen","formName":"categoryId","value":12},{"name":"LGBT+","formName":"categoryId","value":13},{"name":"Fanfic","formName":"categoryId","value":14}]
     */
    categoryList?: {
      /**
       * "All"
       */
      name?: string;
      /**
       * "categoryId"
       */
      formName?: string;
      value?: number;
    }[];
    /**
     * [{"name":"ALL","formName":"bookStatus","value":0},{"name":"Completed","formName":"bookStatus","value":1},{"name":"Ongoing","formName":"bookStatus","value":2}]
     */
    statusList?: {
      /**
       * "ALL"
       */
      name?: string;
      /**
       * "bookStatus"
       */
      formName?: string;
      value?: number;
    }[];
    /**
     * [{"name":"ALL","formName":"vipStatus","value":0},{"name":"Free","formName":"vipStatus","value":1},{"name":"Vip","formName":"vipStatus","value":2}]
     */
    vipStatusList?: {
      /**
       * "ALL"
       */
      name?: string;
      /**
       * "vipStatus"
       */
      formName?: string;
      value?: number;
    }[];
    /**
     * [{"name":"Popular","formName":"orderBy","value":1},{"name":"Recommended","formName":"orderBy","value":2},{"name":"Most Collections","formName":"orderBy","value":3},{"name":"Rating","formName":"orderBy","value":4},{"name":"Time Updated","formName":"orderBy","value":5}]
     */
    orderByList?: {
      /**
       * "Popular"
       */
      name?: string;
      /**
       * "orderBy"
       */
      formName?: string;
      /**
       * 1
       */
      value?: number;
    }[];
  };
}

/**
 * 接口 [分类_分类搜索↗](https://yapi.yuewen.com/project/3297/interface/api/285992) 的 **请求配置的类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `POST /go/pcm/seo/category/search`
 * @更新时间 `2024-05-07 20:05:45`
 */
type GoPcmSeoCategorySearchRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/category/search",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [分类_分类搜索↗](https://yapi.yuewen.com/project/3297/interface/api/285992) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `POST /go/pcm/seo/category/search`
 * @更新时间 `2024-05-07 20:05:45`
 */
const goPcmSeoCategorySearchRequestConfig: GoPcmSeoCategorySearchRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/category/search",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoCategorySearch",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [分类_分类搜索↗](https://yapi.yuewen.com/project/3297/interface/api/285992) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `POST /go/pcm/seo/category/search`
 * @更新时间 `2024-05-07 20:05:45`
 */
export const goPcmSeoCategorySearch = /*#__PURE__*/ (
  requestData: GoPcmSeoCategorySearchRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoCategorySearchResponse>(
    prepare(goPcmSeoCategorySearchRequestConfig, requestData),
    ...args
  );
};

goPcmSeoCategorySearch.requestConfig = goPcmSeoCategorySearchRequestConfig;

/**
 * 接口 [搜索_热词↗](https://yapi.yuewen.com/project/3297/interface/api/286203) 的 **请求类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/hotWord`
 * @更新时间 `2024-05-09 15:02:08`
 */
export interface GoPcmSeoSearchHotWordRequest {}

/**
 * 接口 [搜索_热词↗](https://yapi.yuewen.com/project/3297/interface/api/286203) 的 **返回类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/hotWord`
 * @更新时间 `2024-05-09 15:02:08`
 */
export interface GoPcmSeoSearchHotWordResponse {
  /**
   * ["Test Server","Not Available","Life as A Servant","Fox Life","Celestial God","The Blood Witch","Deleted: RUK","The Golden Watch Of Hypnosis","Respected","My Beautiful Commander","Reincarnation into the Law World","Necromancy","The AGE - Broken Soul","Mutant in Naruto World","Who Is The Main Character ?","The Story of Azuka","Ethereal Creator of Realms","Forget Me Not","HACKING SYSTEM","The Mystical Plains of Feynohr"]
   */
  words?: string[];
}

/**
 * 接口 [搜索_热词↗](https://yapi.yuewen.com/project/3297/interface/api/286203) 的 **请求配置的类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/hotWord`
 * @更新时间 `2024-05-09 15:02:08`
 */
type GoPcmSeoSearchHotWordRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/search/hotWord",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [搜索_热词↗](https://yapi.yuewen.com/project/3297/interface/api/286203) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/hotWord`
 * @更新时间 `2024-05-09 15:02:08`
 */
const goPcmSeoSearchHotWordRequestConfig: GoPcmSeoSearchHotWordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/search/hotWord",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoSearchHotWord",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [搜索_热词↗](https://yapi.yuewen.com/project/3297/interface/api/286203) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/hotWord`
 * @更新时间 `2024-05-09 15:02:08`
 */
export const goPcmSeoSearchHotWord = /*#__PURE__*/ (
  requestData?: GoPcmSeoSearchHotWordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoSearchHotWordResponse>(
    prepare(goPcmSeoSearchHotWordRequestConfig, requestData),
    ...args
  );
};

goPcmSeoSearchHotWord.requestConfig = goPcmSeoSearchHotWordRequestConfig;

/**
 * 接口 [书详情_获取章节列表↗](https://yapi.yuewen.com/project/3297/interface/api/286303) 的 **请求类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getChapterList`
 * @更新时间 `2024-05-14 11:26:54`
 */
export interface GoPcmSeoChapterGetChapterListRequest {
  bookId: string;
  /**
   * 1
   */
  pageIndex?: string;
  /**
   * 20
   */
  pageSize?: string;
  /**
   * 0 非加密，1 加密
   */
  encryptType?: string;
}

/**
 * 接口 [书详情_获取章节列表↗](https://yapi.yuewen.com/project/3297/interface/api/286303) 的 **返回类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getChapterList`
 * @更新时间 `2024-05-14 11:26:54`
 */
export interface GoPcmSeoChapterGetChapterListResponse {
  /**
   * [{"volumeName":"Auxiliary Volume","volumeId":0,"chapterItems":[{"chapterId":"31594562287885163","chapterName":"Characters (Updated for Vol. 15)","chapterIndex":-5,"chapterLevel":0,"publishTimeFormat":"5yr","isVip":0,"isAuth":1,"noArchive":0,"publishTime":1537740543000,"userLevel":0}]}]
   */
  volumeItems?: {
    /**
     * "Auxiliary Volume"
     */
    volumeName?: string;
    volumeId?: number;
    /**
     * [{"chapterId":"31594562287885163","chapterName":"Characters (Updated for Vol. 15)","chapterIndex":-5,"chapterLevel":0,"publishTimeFormat":"5yr","isVip":0,"isAuth":1,"noArchive":0,"publishTime":1537740543000,"userLevel":0}]
     */
    chapterItems?: {
      /**
       * "31594562287885163"
       */
      chapterId?: string;
      /**
       * "Characters (Updated for Vol. 15)"
       */
      chapterName?: string;
      /**
       * -5
       */
      chapterIndex?: number;
      chapterLevel?: number;
      /**
       * "5yr"
       */
      publishTimeFormat?: string;
      isVip?: number;
      /**
       * 1
       */
      isAuth?: number;
      noArchive?: number;
      /**
       * 1537740543000
       */
      publishTime?: number;
      userLevel?: number;
    }[];
  }[];
  curReadChapter?: number;
  lastChapterItem?: {
    /**
     * "78292714562575710"
     */
    chapterId?: string;
    /**
     * "EPIClogue 002"
     */
    chapterName?: string;
    /**
     * 2359
     */
    chapterIndex?: number;
    chapterLevel?: number;
    /**
     * "1mth"
     */
    publishTimeFormat?: string;
    isVip?: number;
    /**
     * 1
     */
    isAuth?: number;
    noArchive?: number;
    /**
     * 1711714411000
     */
    publishTime?: number;
    userLevel?: number;
  };
  /**
   * true
   */
  last?: boolean;
}

/**
 * 接口 [书详情_获取章节列表↗](https://yapi.yuewen.com/project/3297/interface/api/286303) 的 **请求配置的类型**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getChapterList`
 * @更新时间 `2024-05-14 11:26:54`
 */
type GoPcmSeoChapterGetChapterListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/chapter/getChapterList",
    "data",
    string,
    "bookId" | "pageIndex" | "pageSize" | "encryptType",
    false
  >
>;

/**
 * 接口 [书详情_获取章节列表↗](https://yapi.yuewen.com/project/3297/interface/api/286303) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getChapterList`
 * @更新时间 `2024-05-14 11:26:54`
 */
const goPcmSeoChapterGetChapterListRequestConfig: GoPcmSeoChapterGetChapterListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/chapter/getChapterList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: ["bookId", "pageIndex", "pageSize", "encryptType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoChapterGetChapterList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书详情_获取章节列表↗](https://yapi.yuewen.com/project/3297/interface/api/286303) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getChapterList`
 * @更新时间 `2024-05-14 11:26:54`
 */
export const goPcmSeoChapterGetChapterList = /*#__PURE__*/ (
  requestData: GoPcmSeoChapterGetChapterListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoChapterGetChapterListResponse>(
    prepare(goPcmSeoChapterGetChapterListRequestConfig, requestData),
    ...args
  );
};

goPcmSeoChapterGetChapterList.requestConfig =
  goPcmSeoChapterGetChapterListRequestConfig;

const mockUrl_0_2_0_1 = "https://yapi.yuewen.com/mock/3297" as any;
const devUrl_0_2_0_1 = "https://oawww.webnovel.com" as any;
const prodUrl_0_2_0_1 = "https://www.webnovel.com" as any;
const dataKey_0_2_0_1 = "data" as any;

/**
 * 接口 [话题热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/288383) 的 **请求类型**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/list`
 * @更新时间 `2024-07-04 14:00:21`
 */
export interface GoPcmSeoTopicListRequest {
  /**
   * 搜索词分类
   */
  cate?: string;
  /**
   * 1
   */
  pageIndex: string;
  /**
   * 分页大小，默认180
   */
  pageSize: string;
}

/**
 * 接口 [话题热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/288383) 的 **返回类型**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/list`
 * @更新时间 `2024-07-04 14:00:21`
 */
export interface GoPcmSeoTopicListResponse {
  /**
   * [{"topicId":78892700153210600,"lang":"en","searchWord":"vanilla"},{"topicId":78892700153210600,"lang":"en","searchWord":"venus"},{"topicId":78892700153210600,"lang":"en","searchWord":"victor"},{"topicId":78892700153210600,"lang":"en","searchWord":"abcd"}]
   */
  keywords?: {
    /**
     * 78892700153210600
     */
    topicId?: number;
    /**
     * "en"
     */
    lang?: string;
    /**
     * "vanilla"
     */
    searchWord?: string;
  }[];
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 3
   */
  total?: number;
  /**
   * true
   */
  isLast?: boolean;
  /**
   * 40
   */
  pages?: number;
}

/**
 * 接口 [话题热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/288383) 的 **请求配置的类型**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/list`
 * @更新时间 `2024-07-04 14:00:21`
 */
type GoPcmSeoTopicListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/topic/list",
    "data",
    string,
    "cate" | "pageIndex" | "pageSize",
    false
  >
>;

/**
 * 接口 [话题热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/288383) 的 **请求配置**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/list`
 * @更新时间 `2024-07-04 14:00:21`
 */
const goPcmSeoTopicListRequestConfig: GoPcmSeoTopicListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_1,
    devUrl: devUrl_0_2_0_1,
    prodUrl: prodUrl_0_2_0_1,
    path: "/go/pcm/seo/topic/list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_1,
    paramNames: [],
    queryNames: ["cate", "pageIndex", "pageSize"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoTopicList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [话题热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/288383) 的 **请求函数**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/list`
 * @更新时间 `2024-07-04 14:00:21`
 */
export const goPcmSeoTopicList = /*#__PURE__*/ (
  requestData: GoPcmSeoTopicListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoTopicListResponse>(
    prepare(goPcmSeoTopicListRequestConfig, requestData),
    ...args
  );
};

goPcmSeoTopicList.requestConfig = goPcmSeoTopicListRequestConfig;

/**
 * 接口 [话题详情↗](https://yapi.yuewen.com/project/3297/interface/api/288392) 的 **请求类型**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-09-25 16:16:14`
 */
export interface GoPcmSeoTopicDetailRequest {
  /**
   * 话题id
   */
  topicId: string;
}

/**
 * 接口 [话题详情↗](https://yapi.yuewen.com/project/3297/interface/api/288392) 的 **返回类型**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-09-25 16:16:14`
 */
export interface GoPcmSeoTopicDetailResponse {
  topicInfo?: {
    /**
     * 11212121212
     */
    topicId?: number;
    /**
     * "love"
     */
    topicName?: string;
  };
  bookInfo?: {
    /**
     * "7366916601012405"
     */
    bookId?: string;
    /**
     * "The King's Avatar"
     */
    name?: string;
    /**
     * "TKA"
     */
    shortName?: string;
    /**
     * "en"
     */
    language?: string;
    /**
     * "3626681903122401"
     */
    authorId?: string;
    /**
     * "Butterfly Blue"
     */
    authorName?: string;
    itemType?: number;
    /**
     * "Unselected"
     */
    ageGroup?: string;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * "Games"
     */
    categoryName?: string;
    /**
     * 70008
     */
    categoryId?: number;
    /**
     * 3
     */
    scheduleUpdateFrq?: number;
    /**
     * 1
     */
    scheduleUpdateFrqUnit?: number;
    frequencyUnit?: string;
    /**
     * 682
     */
    totalChapterNum?: number;
    /**
     * 30
     */
    actionStatus?: number;
    /**
     * 4.28
     */
    totalScore?: number;
    /**
     * "In the online game Glory, Ye Xiu is regarded as a textbook and a top-tier pro-player. However, due to a myriad reasons, he is kicked from the team. After leaving the professional scene, he finds work in an Internet Cafe as a manager. When Glory launches its tenth server, he who possesses ten years of gaming experience once again throws himself into the game. Bringing with him the memories of his past and an incomplete, self-made weapon, his return along the road to the summit begins!!!!!!\r\n\r\nAfter fighting and scheming, who snatched away my glory? Under the tossing of the wind and rain, my dreams shall still appear as though they had never been shattered. In all its splendor, the path shall never be lost. Before the gazes of millions, this is where I return !"
     */
    description?: string;
    /**
     * 2370742
     */
    pvNum?: number;
    /**
     * 1495855200000
     */
    checkTime?: number;
    /**
     * 1724814460000
     */
    updateTime?: number;
    /**
     * []
     */
    tagInfo?: unknown[];
    expected?: number;
    /**
     * "19775416453662908"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    translateMode?: number;
    /**
     * 5
     */
    categoryType?: number;
    authorUserId?: number;
    /**
     * [{"id":"19363452317401368","name":"Translation Nation"}]
     */
    groupItems?: {
      /**
       * "19363452317401368"
       */
      id?: string;
      /**
       * "Translation Nation"
       */
      name?: string;
    }[];
    /**
     * [{"id":"8161817001026805","name":"RENREN","userId":3823689966,"guid":3823689966}]
     */
    editorItems?: {
      /**
       * "8161817001026805"
       */
      id?: string;
      /**
       * "RENREN"
       */
      name?: string;
      /**
       * 3823689966
       */
      userId?: number;
      /**
       * 3823689966
       */
      guid?: number;
    }[];
    /**
     * [{"id":"7635959101023305","name":"xujin1111111","userId":3514016596,"guid":3514016596},{"id":"8161817001026805","name":"RENREN","userId":3823689966,"guid":3823689966}]
     */
    translatorItems?: {
      /**
       * "7635959101023305"
       */
      id?: string;
      /**
       * "xujin1111111"
       */
      name?: string;
      /**
       * 3514016596
       */
      userId?: number;
      /**
       * 3514016596
       */
      guid?: number;
    }[];
    /**
     * 1581418734974
     */
    coverId?: number;
    inLibrary?: number;
    /**
     * "The Banished Battle God"
     */
    firstChapterName?: string;
    /**
     * [{"description":"I like this animation1","jumpLink":"http://baidu.com"},{"description":"I like this animation2","jumpLink":"https://baidu.com"}]
     */
    animationItems?: {
      /**
       * "I like this animation1"
       */
      description?: string;
      /**
       * "http://baidu.com"
       */
      jumpLink?: string;
    }[];
    /**
     * [{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla","role":"author"},{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla","role":"editor"},{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla","role":"editor"},{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla test    blabla  \n testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla test \n testblabla testblabla testblabla \n testblabla testblabla testblabla testblabla testblabla testblabla  testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavvvvv testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavtestblabla testblabla test test","role":"translator"}]
     */
    notes?: {
      /**
       * "https://oaimg.webnovel.com/userheadimg/1/1/1.png"
       */
      avatar?: string;
      /**
       * "zhangsan"
       */
      name?: string;
      /**
       * "blabla"
       */
      note?: string;
      /**
       * "author"
       */
      role?: string;
    }[];
    advText?: string;
    advActionUrl?: string;
    picPC?: string;
    feverLink?: string;
    /**
     * []
     */
    relatedWords?: unknown[];
    /**
     * "19775416453662908"
     */
    readToChapterId?: string;
  };
  chapterInfo?: {
    lastChapterItem?: {
      /**
       * "45727419184774513"
       */
      chapterId?: string;
      /**
       * 682
       */
      chapterIndex?: number;
      chapterLevel?: number;
      chapterName?: string;
      /**
       * 1
       */
      isAuth?: number;
      isVip?: number;
      /**
       * 1590389556000
       */
      publishTime?: number;
      /**
       * "4 years ago"
       */
      publishTimeFormat?: string;
      userLevel?: number;
    };
    /**
     * [{"chapterItems":[{"chapterId":"19775416453662908","chapterName":"The Banished Battle God","chapterIndex":1,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453679284","chapterName":"Area 3 Number 47","chapterIndex":2,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453695667","chapterName":"Special Duty: Night Shift","chapterIndex":3,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453712047","chapterName":"Mysterious Expert","chapterIndex":4,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453732570","chapterName":"Skill Match","chapterIndex":5,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453744813","chapterName":"Thousand Chance Umbrella","chapterIndex":6,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453761195","chapterName":"Midnight Phantom Cat","chapterIndex":7,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453777578","chapterName":"A Life and Death Struggle","chapterIndex":8,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453793962","chapterName":"Ye Xiu’s Two Hands","chapterIndex":9,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453810344","chapterName":"Shameless Novice","chapterIndex":10,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453826727","chapterName":"Missing a Person? Add Me!","chapterIndex":11,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453843111","chapterName":"Spider Cave (1)","chapterIndex":12,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453859494","chapterName":"Spider Cave (2)","chapterIndex":13,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453875877","chapterName":"Spider Cave (3)","chapterIndex":14,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453892261","chapterName":"Spider Cave (4)","chapterIndex":15,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453925028","chapterName":"Emperor (1)","chapterIndex":16,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453908644","chapterName":"Emperor (2)","chapterIndex":17,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453957796","chapterName":"Emperor (3)","chapterIndex":18,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453941412","chapterName":"Emperor (4)","chapterIndex":19,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453990562","chapterName":"Emperor (5)","chapterIndex":20,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453974179","chapterName":"The Day’s Already Bright Again","chapterIndex":21,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454023329","chapterName":"Ye Qiu’s Retirement (1)","chapterIndex":22,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454006945","chapterName":"Ye Qiu’s Retirement (2)","chapterIndex":23,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454056097","chapterName":"Dungeon Record","chapterIndex":24,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454039713","chapterName":"Did You Hear What I Said?","chapterIndex":25,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454088864","chapterName":"Forgot to Look at a Guide","chapterIndex":26,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454072481","chapterName":"The Guide Says 24 Times","chapterIndex":27,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454121631","chapterName":"Professional Level","chapterIndex":28,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454105247","chapterName":"First Clear Team","chapterIndex":29,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454154399","chapterName":"Two Hidden BOSS Clears","chapterIndex":30,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454138015","chapterName":"This Is A Talent","chapterIndex":31,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454203551","chapterName":"Haggling","chapterIndex":32,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454219935","chapterName":"He’s Here to Make a Fool of Himself, Right?","chapterIndex":33,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454170783","chapterName":"Some More Damage","chapterIndex":34,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454187167","chapterName":"One Wave Rush (1)","chapterIndex":35,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454269086","chapterName":"One Wave Rush (2)","chapterIndex":36,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454285470","chapterName":"One Wave Rush (3)","chapterIndex":37,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454236318","chapterName":"What’s Damage","chapterIndex":38,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454252702","chapterName":"Frost Thain","chapterIndex":39,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454334620","chapterName":"New Record","chapterIndex":40,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454351004","chapterName":"A Simple Leave","chapterIndex":41,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454301852","chapterName":"A Good That Could Be Bought","chapterIndex":42,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454318236","chapterName":"Don’t Need A Cleric","chapterIndex":43,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454400156","chapterName":"Different Fees","chapterIndex":44,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454416540","chapterName":"Original Strategy","chapterIndex":45,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454367388","chapterName":"Easy Glory","chapterIndex":46,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454383772","chapterName":"I’m Playing Unspecialized","chapterIndex":47,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454482076","chapterName":"Countless Variations","chapterIndex":48,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454465692","chapterName":"You Really Don’t Know How to Play","chapterIndex":49,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454449308","chapterName":"Again!","chapterIndex":50,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454432924","chapterName":"The Weapon That Couldn’t Be Hidden","chapterIndex":51,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454547612","chapterName":"Picking a Class","chapterIndex":52,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454531228","chapterName":"Battle Mage","chapterIndex":53,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454514844","chapterName":"Show Me","chapterIndex":54,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454498460","chapterName":"Surpassing the Guide","chapterIndex":55,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454613147","chapterName":"Leveling Isn’t Easy","chapterIndex":56,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454596763","chapterName":"Boneyard","chapterIndex":57,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454580380","chapterName":"Kill Stealing","chapterIndex":58,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454563996","chapterName":"Are You Playing With A Child?","chapterIndex":59,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454678682","chapterName":"Wild Boss","chapterIndex":60,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454662299","chapterName":"Hunting Yagg (1)","chapterIndex":61,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454645915","chapterName":"Hunting Yagg (2)","chapterIndex":62,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454629531","chapterName":"Hunting Yagg (3)","chapterIndex":63,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454760600","chapterName":"Hunting Yagg (4)","chapterIndex":64,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454776984","chapterName":"Hunting Yagg (5)","chapterIndex":65,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454793368","chapterName":"Undead Legion","chapterIndex":66,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454809752","chapterName":"Speed Up","chapterIndex":67,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454695065","chapterName":"Blood Gunner First Kill","chapterIndex":68,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454711449","chapterName":"Keep Chasing And I Won’t Be So Nice Anymore","chapterIndex":69,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454727832","chapterName":"Copy Upgrade","chapterIndex":70,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454744216","chapterName":"Weapons and Skills","chapterIndex":71,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454891671","chapterName":"Taking Advantage of Everyone","chapterIndex":72,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454908055","chapterName":"Sand Toss","chapterIndex":73,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454924439","chapterName":"Understanding Information","chapterIndex":74,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454940823","chapterName":"Losing the Fight for the Monster","chapterIndex":75,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454826136","chapterName":"Controlling the BOSS’s Move Path","chapterIndex":76,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454842520","chapterName":"Directly Flying Over","chapterIndex":77,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454858903","chapterName":"Forced Into Helplessness","chapterIndex":78,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454875287","chapterName":"Changing Spring","chapterIndex":79,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455039127","chapterName":"A Guild Leader’s Troubles","chapterIndex":80,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455022743","chapterName":"A Blessing or a Curse","chapterIndex":81,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455071895","chapterName":"A Swift Dungeon Record","chapterIndex":82,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455055511","chapterName":"Almost the Limit","chapterIndex":83,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454973591","chapterName":"Manpower Needed","chapterIndex":84,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454957207","chapterName":"Steamed Bun Invasion","chapterIndex":85,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455006359","chapterName":"Teaching the Noob","chapterIndex":86,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454989975","chapterName":"I Feel Like None of You Slept","chapterIndex":87,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"7366916801980000","chapterName":"Glory League","chapterIndex":88,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455153814","chapterName":"Home Advantage","chapterIndex":89,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723638422","chapterName":"The Footprints are a Trap","chapterIndex":90,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000}],"volumeId":1,"volumeName":""},{"chapterItems":[{"chapterId":"7366916801992198","chapterName":"Excellent Era’s Trump Card","chapterIndex":91,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455104663","chapterName":"1v3","chapterIndex":92,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455088279","chapterName":"That Wasn’t An Intentional Loss","chapterIndex":93,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455137431","chapterName":"Dropping the Ball at a Crucial Moment","chapterIndex":94,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455121047","chapterName":"Unexpected Guests","chapterIndex":95,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723753110","chapterName":"Because You Made Mistakes","chapterIndex":96,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723769494","chapterName":"Stupid Noob","chapterIndex":97,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723720342","chapterName":"Teaching Like Crazy","chapterIndex":98,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723736726","chapterName":"Endurance Limit","chapterIndex":99,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723687574","chapterName":"I Only Want to Play a Small Role","chapterIndex":100,"isVip":2,"isAuth":0,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561607679000},{"chapterId":"19775416723703958","chapterName":"Three Days","chapterIndex":101,"isVip":2,"isAuth":0,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561607679000},{"chapterId":"19775416723654806","chapterName":"All Around Upgrade","chapterIndex":102,"isVip":2,"isAuth":0,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561607679000},{"chapterId":"19775416723671190","chapterName":"There Really is a Gap","chapterIndex":103,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723884182","chapterName":"Godly Skill Delivery Gun","chapterIndex":104,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723900566","chapterName":"A Staggering Blow","chapterIndex":105,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723851414","chapterName":"What Exactly Is He Trying to Do?","chapterIndex":106,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723867798","chapterName":"Testing Staff","chapterIndex":107,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723818646","chapterName":"Hateful Sword","chapterIndex":108,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723835030","chapterName":"A Directed Act","chapterIndex":109,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723785878","chapterName":"Waiting and Seeing","chapterIndex":110,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723802262","chapterName":"Two Types of Coordination","chapterIndex":111,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724031638","chapterName":"Perfect Coordination","chapterIndex":112,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724015254","chapterName":"Casually Dungeoning","chapterIndex":113,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723998870","chapterName":"Control Over Records","chapterIndex":114,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723982486","chapterName":"Going All Out","chapterIndex":115,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723966102","chapterName":"An All","chapterIndex":116,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723949718","chapterName":"Specially Substituting In","chapterIndex":117,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723933334","chapterName":"Mid","chapterIndex":118,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723916950","chapterName":"I Forgot","chapterIndex":119,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724162707","chapterName":"Who Taught You How to Play?","chapterIndex":120,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724146324","chapterName":"Godly Skill","chapterIndex":121,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724129940","chapterName":"Liu Hao the Helper","chapterIndex":122,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724113557","chapterName":"Talking to Himself","chapterIndex":123,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724097173","chapterName":"The Crudest Style","chapterIndex":124,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724080789","chapterName":"God Jiexi","chapterIndex":125,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724064405","chapterName":"What Exactly is He Trying to Do?","chapterIndex":126,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724048022","chapterName":"Five Characters","chapterIndex":127,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724326547","chapterName":"Rookie","chapterIndex":128,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724310163","chapterName":"Vanishing Step","chapterIndex":129,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724359314","chapterName":"The Opponent Is Extremely Strong","chapterIndex":130,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724342931","chapterName":"Cover Strategy","chapterIndex":131,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724392082","chapterName":"Team Wiped Out","chapterIndex":132,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724375698","chapterName":"Measuring Skill","chapterIndex":133,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724424850","chapterName":"Tour Group","chapterIndex":134,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724408466","chapterName":"What Unspecialized Means","chapterIndex":135,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724195475","chapterName":"True Unspecialized","chapterIndex":136,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724179091","chapterName":"Encirclement","chapterIndex":137,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724228243","chapterName":"Logout Escape","chapterIndex":138,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724211859","chapterName":"Who’s the Training Partner?","chapterIndex":139,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724261011","chapterName":"Find Me Next Door","chapterIndex":140,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724244627","chapterName":"Wreck and Then Get Wrecked","chapterIndex":141,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724293779","chapterName":"Magician","chapterIndex":142,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724277395","chapterName":"Unexpected Discovery","chapterIndex":143,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724572305","chapterName":"Back and Forth","chapterIndex":144,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724588689","chapterName":"A Bit of Courage is Needed","chapterIndex":145,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724605073","chapterName":"Too Smart","chapterIndex":146,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724621457","chapterName":"Difficult Decision","chapterIndex":147,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724637841","chapterName":"Four Scarlet Moon Parts","chapterIndex":148,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724654225","chapterName":"Bidding War","chapterIndex":149,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724670609","chapterName":"So Nervous He Became a Noob","chapterIndex":150,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724686993","chapterName":"Burning with Anxiety","chapterIndex":151,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724441234","chapterName":"The Bystander Becomes the Deciding Role","chapterIndex":152,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724457618","chapterName":"Exchange Market","chapterIndex":153,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724474002","chapterName":"Where’d These Materials Come From?","chapterIndex":154,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724490385","chapterName":"Overlapping Tracking","chapterIndex":155,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724506769","chapterName":"Power of an Encirclement","chapterIndex":156,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724523153","chapterName":"Running Test","chapterIndex":157,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724539537","chapterName":"He Really is an Expert at KSing","chapterIndex":158,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724555921","chapterName":"Furry Guest","chapterIndex":159,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724883601","chapterName":"Suppressed","chapterIndex":160,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724867217","chapterName":"It Isn’t Easy Being an Expert","chapterIndex":161,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724850833","chapterName":"Half the Screen","chapterIndex":162,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724834449","chapterName":"Shot At Even When Lying Down","chapterIndex":163,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724949136","chapterName":"Asking For Help Separately","chapterIndex":164,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724932752","chapterName":"Record Kidnappping","chapterIndex":165,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724916369","chapterName":"I Get a Little Lonely Sometimes Too","chapterIndex":166,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724899985","chapterName":"Taking Back the Record","chapterIndex":167,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724752529","chapterName":"Fire Witch Cashew","chapterIndex":168,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724736145","chapterName":"Skill Interrupt","chapterIndex":169,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724719761","chapterName":"Fire Witch First Kill","chapterIndex":170,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724703377","chapterName":"If I Can Kill It, Why Can’t I Kill It?","chapterIndex":171,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724818065","chapterName":"A Well","chapterIndex":172,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724801681","chapterName":"He’s No Good For Dungeoning","chapterIndex":173,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724785297","chapterName":"Challenge Ignored","chapterIndex":174,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724768913","chapterName":"Three Chances Waiting For You","chapterIndex":175,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416725129360","chapterName":"Problems in the Details","chapterIndex":176,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416725145743","chapterName":"Dual Linking Ghost Boundaries","chapterIndex":177,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416725096592","chapterName":"Their Wishes Finally Came True","chapterIndex":178,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416725112976","chapterName":"A Chance for a Comeback","chapterIndex":179,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416725194895","chapterName":"The Fastest Launcher","chapterIndex":180,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993646735","chapterName":"In a Flash","chapterIndex":181,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416725162127","chapterName":"Consultation","chapterIndex":182,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416725178511","chapterName":"Blue Rain Team Captain","chapterIndex":183,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724998288","chapterName":"That’s a Strength Too?","chapterIndex":184,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416725014672","chapterName":"It’s Unfortunate That His Hands Are Handicapped","chapterIndex":185,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724965520","chapterName":"An Unspecialized Character’s False Combos","chapterIndex":186,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416724981904","chapterName":"Can’t Find a Chance","chapterIndex":187,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416725063824","chapterName":"Difficult to Say","chapterIndex":188,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416725080208","chapterName":"Illusion Swordmaster Ahong","chapterIndex":189,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416725031056","chapterName":"The BOSS’s Shadow Steps","chapterIndex":190,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416725047440","chapterName":"I’m In a Hurry","chapterIndex":191,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993876110","chapterName":"Items Lead to Thinking","chapterIndex":192,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993859726","chapterName":"Idiot’s Guide","chapterIndex":193,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993908878","chapterName":"A Not So Simple New Player","chapterIndex":194,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993892494","chapterName":"Pursuit From Every Direction","chapterIndex":195,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993810574","chapterName":"Temporary Alliance","chapterIndex":196,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993794190","chapterName":"Opposite Direction","chapterIndex":197,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993843342","chapterName":"A Bro at the Bottom of a Well","chapterIndex":198,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993826958","chapterName":"The Escape Member: Concealed Light","chapterIndex":199,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993745038","chapterName":"PKPKPKPKPKPK","chapterIndex":200,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993728654","chapterName":"The Trash’s End","chapterIndex":201,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993777806","chapterName":"Experiencing It Personally","chapterIndex":202,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993761422","chapterName":"Finally, Some Strategy","chapterIndex":203,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993679502","chapterName":"Bullying Cloth","chapterIndex":204,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993663118","chapterName":"You’ve Been Surrounded","chapterIndex":205,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993712270","chapterName":"Tyrannical Class","chapterIndex":206,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993695886","chapterName":"Your Guides","chapterIndex":207,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994121870","chapterName":"Summoner","chapterIndex":208,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994138254","chapterName":"Whoever Kills the Fewest is the Loser","chapterIndex":209,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994154638","chapterName":"A Beautiful Misunderstanding","chapterIndex":210,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994171022","chapterName":"The Waves Behind Drive the Waves Ahead","chapterIndex":211,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994056334","chapterName":"Doing Their Own Thing","chapterIndex":212,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994072718","chapterName":"A Match In Which the Outcome Is Already Known","chapterIndex":213,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994089102","chapterName":"Limited Practice","chapterIndex":214,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994105486","chapterName":"Tooth for Tooth","chapterIndex":215,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993990798","chapterName":"Even If We’re Killed, We Won’t Tell Anyone","chapterIndex":216,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994007182","chapterName":"Void and Hundred Blossoms","chapterIndex":217,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994023566","chapterName":"Crowd Lover Sword Boundary!","chapterIndex":218,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994039950","chapterName":"PvP Is Even Scarier","chapterIndex":219,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993925262","chapterName":"Screen Cannon","chapterIndex":220,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993941646","chapterName":"Forceful Control","chapterIndex":221,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993958030","chapterName":"Searching for Tracks","chapterIndex":222,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416993974414","chapterName":"Wild BOSS Discovered","chapterIndex":223,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994433159","chapterName":"False Report","chapterIndex":224,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994416775","chapterName":"A Separating Wall","chapterIndex":225,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994400391","chapterName":"Wait Until the Arrow is at the End of its Flight","chapterIndex":226,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994384008","chapterName":"The Greatest DPS “LORD GRIM!!”","chapterIndex":227,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994367624","chapterName":"Forming a Party with the BOSS","chapterIndex":228,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994351240","chapterName":"In the Blink of an Eye","chapterIndex":229,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994334857","chapterName":"A Bit Early Today","chapterIndex":230,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994318475","chapterName":"Looking for Help","chapterIndex":231,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994302092","chapterName":"A Precise Position","chapterIndex":232,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994285709","chapterName":"Sacred Fire","chapterIndex":233,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994269325","chapterName":"Two Traps","chapterIndex":234,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994252941","chapterName":"Bet","chapterIndex":235,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994236557","chapterName":"Assumptive Guides","chapterIndex":236,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994220174","chapterName":"The Members Aren’t Together","chapterIndex":237,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994203790","chapterName":"Randomly Chosen","chapterIndex":238,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994187406","chapterName":"First Target","chapterIndex":239,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994678919","chapterName":"All","chapterIndex":240,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994695303","chapterName":"The Joke’s Gone Too Far","chapterIndex":241,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994646151","chapterName":"My Mistake","chapterIndex":242,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994662535","chapterName":"Rescuing Steamed Bun","chapterIndex":243,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994613383","chapterName":"Destroying Their Confidence","chapterIndex":244,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994629767","chapterName":"A Hidden Agenda","chapterIndex":245,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994580615","chapterName":"Seems Like We Don’t Need To","chapterIndex":246,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994596999","chapterName":"Keyboard and Mouse","chapterIndex":247,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994547847","chapterName":"Guidance","chapterIndex":248,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994564231","chapterName":"Leave It To Nature","chapterIndex":249,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994515079","chapterName":"The Situation Isn’t Clear","chapterIndex":250,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994531463","chapterName":"Dismantle","chapterIndex":251,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994482311","chapterName":"Strike First","chapterIndex":252,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994498695","chapterName":"To Retreat By Advancing","chapterIndex":253,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994449543","chapterName":"By Proxy","chapterIndex":254,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994465927","chapterName":"What Does He Gain?","chapterIndex":255,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995006595","chapterName":"The Purpose of a Game","chapterIndex":256,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995022979","chapterName":"Appropriate Handling","chapterIndex":257,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994973827","chapterName":"Guide Easter Egg","chapterIndex":258,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994990211","chapterName":"Misty Rain","chapterIndex":259,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995072131","chapterName":"Returning to Desolate Land","chapterIndex":260,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995088514","chapterName":"You Have to Love the Game!","chapterIndex":261,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995039363","chapterName":"Dungeon Tollbooth","chapterIndex":262,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995055747","chapterName":"Christmas Event","chapterIndex":263,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995137666","chapterName":"Luck Is Very Important","chapterIndex":264,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995154050","chapterName":"Sin City","chapterIndex":265,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995104898","chapterName":"Escaping Outside of the Aggro Range","chapterIndex":266,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995121282","chapterName":"Christmas Hunting Leaderboards","chapterIndex":267,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995203202","chapterName":"Deviously Stealing Monsters","chapterIndex":268,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995219586","chapterName":"It’s Not That Simple","chapterIndex":269,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995170434","chapterName":"Battle Spirit","chapterIndex":270,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995186818","chapterName":"Seventh Stage Battle Spirit","chapterIndex":271,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994760839","chapterName":"Ups and Downs","chapterIndex":272,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994744455","chapterName":"A Measure of an Expert’s Skill","chapterIndex":273,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994728071","chapterName":"Fight to the End","chapterIndex":274,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994711687","chapterName":"There Must Not Be Losses on the Leaderboard","chapterIndex":275,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994826374","chapterName":"The Web’s Lord Grim","chapterIndex":276,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994809991","chapterName":"Spinning Spiderweb Formation","chapterIndex":277,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994793607","chapterName":"Break the Formation! The Guest Acts as the Host","chapterIndex":278,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994777223","chapterName":"I Can Persuade Them!","chapterIndex":279,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994891910","chapterName":"Gathering a Mob!","chapterIndex":280,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994875526","chapterName":"Confusion","chapterIndex":281,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994859142","chapterName":"Dark","chapterIndex":282,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994842758","chapterName":"To Live High and Look Down","chapterIndex":283,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994957443","chapterName":"There’s Still Hope","chapterIndex":284,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994941059","chapterName":"We Can’t Let It Go To Waste","chapterIndex":285,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994924678","chapterName":"Harming Others for One’s Personal Gain","chapterIndex":286,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416994908294","chapterName":"Collaboration","chapterIndex":287,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995498113","chapterName":"Powerful MT","chapterIndex":288,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995514497","chapterName":"A Night Without Sleep","chapterIndex":289,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995530881","chapterName":"Persistence Will Pay Off","chapterIndex":290,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995547265","chapterName":"Crazy Rewards","chapterIndex":291,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995563649","chapterName":"The Aftermath","chapterIndex":292,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995580033","chapterName":"Lance Form! Level 35","chapterIndex":293,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995596417","chapterName":"Creating a Blade","chapterIndex":294,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995612801","chapterName":"Word Battle","chapterIndex":295,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995629185","chapterName":"Can I Buy Out?","chapterIndex":296,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995645569","chapterName":"I Once Had a Guide","chapterIndex":297,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995661953","chapterName":"Research is the Key to Efficiency","chapterIndex":298,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995678337","chapterName":"Big Sale","chapterIndex":299,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995694721","chapterName":"Three Tickets","chapterIndex":300,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995711105","chapterName":"The Show Begins","chapterIndex":301,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995727489","chapterName":"Rookie Challenge Competition","chapterIndex":302,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995743873","chapterName":"Intentional","chapterIndex":303,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995252354","chapterName":"Shouldering the Future of Tiny Herb","chapterIndex":304,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995235970","chapterName":"Exceeding Everyone’s Expectations","chapterIndex":305,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995285122","chapterName":"Hopelessly Worried","chapterIndex":306,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995268738","chapterName":"Dazzling Stage","chapterIndex":307,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995317890","chapterName":"Opportunity Goes to Those Who Are Prepared","chapterIndex":308,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995301506","chapterName":"The Junior Succeeds the Senior","chapterIndex":309,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995350658","chapterName":"A Conclusion","chapterIndex":310,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995334274","chapterName":"The Foreshadowed Climax","chapterIndex":311,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995383425","chapterName":"You’re Still Too Green","chapterIndex":312,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995367041","chapterName":"News Conference","chapterIndex":313,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995416193","chapterName":"I Wouldn’t Get Tired Even After Another Ten Years","chapterIndex":314,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995399809","chapterName":"Event Day 2","chapterIndex":315,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995448961","chapterName":"Hurdles","chapterIndex":316,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995432577","chapterName":"The Second Event","chapterIndex":317,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995481729","chapterName":"Meeting an Idol","chapterIndex":318,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995465345","chapterName":"Harming Others for One’s Personal Gain","chapterIndex":319,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264556161","chapterName":"Helping Each Other","chapterIndex":320,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264572545","chapterName":"After the Fireworks","chapterIndex":321,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264523393","chapterName":"Secret Operation","chapterIndex":322,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264539777","chapterName":"Noob Strategy","chapterIndex":323,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264490625","chapterName":"Desire for Victory","chapterIndex":324,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264507009","chapterName":"It’s a Mess. A Complete Mess.","chapterIndex":325,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264457857","chapterName":"Refusing to Give Up","chapterIndex":326,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264474241","chapterName":"A True Expert","chapterIndex":327,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264687230","chapterName":"Unable to Fight Back","chapterIndex":328,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264703614","chapterName":"Dragon Raising Its Head","chapterIndex":329,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264654463","chapterName":"Quiet Withdrawal","chapterIndex":330,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264670846","chapterName":"As If Nothing Happened","chapterIndex":331,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264621695","chapterName":"Embarrassing Past","chapterIndex":332,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264638079","chapterName":"A Sleepless Night","chapterIndex":333,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264588929","chapterName":"Day Three","chapterIndex":334,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264605311","chapterName":"All Star 24 (1)","chapterIndex":335,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264310401","chapterName":"All Star 24 (2)","chapterIndex":336,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995858561","chapterName":"All Star Competition","chapterIndex":337,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995842177","chapterName":"Know Yourself, Know Your Enemy","chapterIndex":338,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995825793","chapterName":"Each Side With Their Own Shortcomings","chapterIndex":339,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995809409","chapterName":"The Gods Erupt","chapterIndex":340,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995793025","chapterName":"Ferocious Tiger Flurry","chapterIndex":341,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995776641","chapterName":"The Violent Ladies","chapterIndex":342,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416995760257","chapterName":"Satisfying Conclusion","chapterIndex":343,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264441473","chapterName":"Chen Guo’s Determination","chapterIndex":344,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264425089","chapterName":"The First Step in Development","chapterIndex":345,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264408705","chapterName":"Beaten Black and Blue","chapterIndex":346,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264392321","chapterName":"Guild Created","chapterIndex":347,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264375937","chapterName":"New Players","chapterIndex":348,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264359553","chapterName":"Rapid Growth","chapterIndex":349,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264343169","chapterName":"High","chapterIndex":350,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264326785","chapterName":"A Haze of Doubts and Suspicions","chapterIndex":351,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265047676","chapterName":"Each With Their Own Motives","chapterIndex":352,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265064060","chapterName":"Even If You Want to Die, You Can’t","chapterIndex":353,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265080444","chapterName":"Firm Decision","chapterIndex":354,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265096828","chapterName":"Who’s Leaving? Who’s Staying?","chapterIndex":355,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264982141","chapterName":"Thanks for the Help","chapterIndex":356,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264998525","chapterName":"A Lone Log Can’t Prop Up a Tottering Building","chapterIndex":357,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265014908","chapterName":"Getting Straight to the Point","chapterIndex":358,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265031292","chapterName":"Babysitter Blue River","chapterIndex":359,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265178747","chapterName":"Steady Development","chapterIndex":360,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265195131","chapterName":"Lacking Characters","chapterIndex":361,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265211515","chapterName":"There’s Still One More Trick","chapterIndex":362,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265227899","chapterName":"One More","chapterIndex":363,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265113212","chapterName":"Next Stage","chapterIndex":364,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265129596","chapterName":"No Friends to the Left or to the Right","chapterIndex":365,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265145980","chapterName":"Waiting for the Ambush","chapterIndex":366,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265162363","chapterName":"Waves","chapterIndex":367,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264801918","chapterName":"Massacre by Drowning","chapterIndex":368,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264785534","chapterName":"Trapped","chapterIndex":369,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264834686","chapterName":"A Bit Too Few","chapterIndex":370,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264818302","chapterName":"No Results","chapterIndex":371,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264736382","chapterName":"Another Team Wiped Out","chapterIndex":372,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264719998","chapterName":"Blue River’s Analysis","chapterIndex":373,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264769150","chapterName":"Watching a Fire From the Other Side of the Shore","chapterIndex":374,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264752766","chapterName":"Cede Territory or Pay Reparations?","chapterIndex":375,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264932990","chapterName":"Too Careless","chapterIndex":376,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264916606","chapterName":"One After Another","chapterIndex":377,"isVip":2,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264965758","chapterName":"Separate Attacks","chapterIndex":378,"isVip":2,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264949374","chapterName":"Two Types of Intimidation","chapterIndex":379,"isVip":2,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264867454","chapterName":"Key","chapterIndex":380,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264851070","chapterName":"Remote Control","chapterIndex":381,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264900222","chapterName":"One Battle After Another","chapterIndex":382,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417264883838","chapterName":"Take Advantage of the Opportunity","chapterIndex":383,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265686650","chapterName":"Even Sitting Idle is Scary","chapterIndex":384,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265670266","chapterName":"Taking Advantage of the Situation","chapterIndex":385,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265653882","chapterName":"Exploit","chapterIndex":386,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265637498","chapterName":"Still Running!","chapterIndex":387,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265752186","chapterName":"To Move a Stone and Stub One’s Foot","chapterIndex":388,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265735802","chapterName":"Three Choices","chapterIndex":389,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265719418","chapterName":"Accept Surrender","chapterIndex":390,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265703034","chapterName":"The Breeze is Still, the Waves are Calm","chapterIndex":391,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265555578","chapterName":"What’s So Good About Excellent Era?","chapterIndex":392,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265539194","chapterName":"Absent Minded","chapterIndex":393,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265522810","chapterName":"Cross Swords","chapterIndex":394,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265506426","chapterName":"A Dangerous Balance","chapterIndex":395,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265621114","chapterName":"Winner","chapterIndex":396,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265604730","chapterName":"Words That Hadn’t Been Seen in a Long Time","chapterIndex":397,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265588346","chapterName":"Too Silent","chapterIndex":398,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265571962","chapterName":"The Coming of the Spring Festival","chapterIndex":399,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265408123","chapterName":"I’m Ye Qiu","chapterIndex":400,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265424507","chapterName":"Temporary Guest","chapterIndex":401,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265375355","chapterName":"Experience Life","chapterIndex":402,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265391739","chapterName":"Happy New Year","chapterIndex":403,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265473659","chapterName":"Ye Qiu Leaves","chapterIndex":404,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265490042","chapterName":"A Peaceful Spring Festival Event","chapterIndex":405,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265440891","chapterName":"New Year’s Eve","chapterIndex":406,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265457275","chapterName":"Spring Festival Long Vacation","chapterIndex":407,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265277051","chapterName":"Su Mucheng’s Transformation","chapterIndex":408,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265293435","chapterName":"Excellent Era Is Just That","chapterIndex":409,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265244283","chapterName":"Heavenly Domain Challenge, Start!","chapterIndex":410,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265260667","chapterName":"A True God","chapterIndex":411,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265342587","chapterName":"Team Secret","chapterIndex":412,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265358971","chapterName":"Spectator","chapterIndex":413,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265309819","chapterName":"Everyone Blanked Out","chapterIndex":414,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265326203","chapterName":"Sensation","chapterIndex":415,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266178168","chapterName":"Against the Great Hero","chapterIndex":416,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266161784","chapterName":"The Level 50 Conflict","chapterIndex":417,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266210936","chapterName":"Entering the Heavenly Domain","chapterIndex":418,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266194552","chapterName":"It’s Not That Simple","chapterIndex":419,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266243704","chapterName":"I’m His Boss","chapterIndex":420,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266227320","chapterName":"Deceptively Powerful Enemy","chapterIndex":421,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266276472","chapterName":"Stay and Fight","chapterIndex":422,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266260088","chapterName":"Who Do You Think I Am","chapterIndex":423,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266047096","chapterName":"The Mysterious Chasing Haze","chapterIndex":424,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266030712","chapterName":"A Difficult Start","chapterIndex":425,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266079864","chapterName":"To Lose Money Instead of Being Paid","chapterIndex":426,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266063480","chapterName":"Too Afraid to Rush In Recklessly","chapterIndex":427,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266112632","chapterName":"Sweeping the Field","chapterIndex":428,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266096248","chapterName":"Meeting the Challenge","chapterIndex":429,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266145400","chapterName":"Overwhelming Victory","chapterIndex":430,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266129016","chapterName":"Pry","chapterIndex":431,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265899641","chapterName":"The Experts Behind the Scenes","chapterIndex":432,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265916025","chapterName":"If I May Be So Bold to Ask a Favor","chapterIndex":433,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265932409","chapterName":"Disappearing Characters","chapterIndex":434,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265948792","chapterName":"Whoever Moves First Loses","chapterIndex":435,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265965176","chapterName":"A Wall That Can’t Be Avoided","chapterIndex":436,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265981560","chapterName":"What Class Would You Like to Play First?","chapterIndex":437,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265997944","chapterName":"The Opponent Is Too Strong","chapterIndex":438,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266014328","chapterName":"A Strong Alliance","chapterIndex":439,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265768570","chapterName":"Team Feature","chapterIndex":440,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265784954","chapterName":"Flood","chapterIndex":441,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265801338","chapterName":"Poor Loulan Slash","chapterIndex":442,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265817722","chapterName":"A Berserk 20 Seconds","chapterIndex":443,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265834106","chapterName":"Round Robin","chapterIndex":444,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265850490","chapterName":"The Real Deal","chapterIndex":445,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265866874","chapterName":"Dying Brain Cells","chapterIndex":446,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417265883258","chapterName":"Unspecialized Combo","chapterIndex":447,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535236213","chapterName":"Can You Hear Me?","chapterIndex":448,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535219829","chapterName":"Each With Their Own Thoughts","chapterIndex":449,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535203445","chapterName":"Diligence","chapterIndex":450,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535187061","chapterName":"The Mystery Man","chapterIndex":451,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535170677","chapterName":"Counterattack with the Truth","chapterIndex":452,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535154293","chapterName":"Unable to Speak","chapterIndex":453,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535137910","chapterName":"To Make a Big Fuss Over Nothing","chapterIndex":454,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535121526","chapterName":"Scrap Picker","chapterIndex":455,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535105142","chapterName":"Not a Bad Hiding Place","chapterIndex":456,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535088758","chapterName":"Professional Scrap Picking","chapterIndex":457,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535072374","chapterName":"Maximum Precision","chapterIndex":458,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535055990","chapterName":"Mistakes","chapterIndex":459,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535039606","chapterName":"High End Setting","chapterIndex":460,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535023222","chapterName":"A Traumatic Experience","chapterIndex":461,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535006838","chapterName":"To Catch a Band of Thieves, Catch the Leader First","chapterIndex":462,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266554999","chapterName":"The King’s Avatar","chapterIndex":463,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266522231","chapterName":"Deception","chapterIndex":464,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266538615","chapterName":"Pursuit","chapterIndex":465,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266489463","chapterName":"Unconventional Methods","chapterIndex":466,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266505847","chapterName":"This is an Opportunity","chapterIndex":467,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266456696","chapterName":"I Can’t Stand Being Ignored","chapterIndex":468,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266473079","chapterName":"A Way Out","chapterIndex":469,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266423928","chapterName":"Scrap Picking and Playing with Lives","chapterIndex":470,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266440312","chapterName":"Each to One Side","chapterIndex":471,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266391160","chapterName":"Ninjutsu · Disappearing Body Technique","chapterIndex":472,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266407544","chapterName":"Difficult to Find Escape Route","chapterIndex":473,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266358392","chapterName":"Ninjutsu","chapterIndex":474,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266374776","chapterName":"What Enmity Do You Have with Launchers?","chapterIndex":475,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266325624","chapterName":"Chen Guo’s Resentment","chapterIndex":476,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266342008","chapterName":"Gap","chapterIndex":477,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266292856","chapterName":"A Good Lesson","chapterIndex":478,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417266309240","chapterName":"Self Defense Counter","chapterIndex":479,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535727732","chapterName":"One Minute of Retaliation","chapterIndex":480,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535711348","chapterName":"Another Encounter with Golden Fragrance","chapterIndex":481,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535760500","chapterName":"Armor","chapterIndex":482,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535744116","chapterName":"Is There Space Here?","chapterIndex":483,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535662196","chapterName":"Formation","chapterIndex":484,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535645812","chapterName":"Attack Like Fire","chapterIndex":485,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535694964","chapterName":"No One Escapes","chapterIndex":486,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535678580","chapterName":"What’s the Situation","chapterIndex":487,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535596660","chapterName":"Lure the Enemy in Deep","chapterIndex":488,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535580276","chapterName":"The Enemy Closes In, While We Back Out","chapterIndex":489,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535629428","chapterName":"Team Excellent Era","chapterIndex":490,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535613044","chapterName":"Strong Enemies!","chapterIndex":491,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535531124","chapterName":"Sun Xiang’s Dragon Raising Its Head","chapterIndex":492,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535514740","chapterName":"Valuable Reverse Teaching","chapterIndex":493,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535563892","chapterName":"Sneak Attack Cover Up","chapterIndex":494,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535547508","chapterName":"Ambush","chapterIndex":495,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535449205","chapterName":"Bullying","chapterIndex":496,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535465588","chapterName":"Many Bullying the Few","chapterIndex":497,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535481972","chapterName":"Useless Skill","chapterIndex":498,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535498356","chapterName":"Opportunity Knocks But Once","chapterIndex":499,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535383669","chapterName":"Glory Doesn’t Suit You","chapterIndex":500,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535400053","chapterName":"Self Sacrifice","chapterIndex":501,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535416437","chapterName":"Bounty","chapterIndex":502,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535432821","chapterName":"Collaborator","chapterIndex":503,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535318133","chapterName":"Unending News","chapterIndex":504,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535334517","chapterName":"To Relegations","chapterIndex":505,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535350901","chapterName":"Xiaoqiang Productions","chapterIndex":506,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535367285","chapterName":"Leave It Alone","chapterIndex":507,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535252597","chapterName":"Out of Expectations","chapterIndex":508,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535268981","chapterName":"I Don’t Want Any of That","chapterIndex":509,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535285365","chapterName":"Ambushed Online","chapterIndex":510,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535301749","chapterName":"Expert Commander","chapterIndex":511,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536366707","chapterName":"Old God","chapterIndex":512,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536383091","chapterName":"There’s Someone Behind You","chapterIndex":513,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536399475","chapterName":"You Were Already Prepared!","chapterIndex":514,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536415859","chapterName":"This is an Ultimate","chapterIndex":515,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536301172","chapterName":"In Close Pursuit","chapterIndex":516,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536317555","chapterName":"Death's Hand","chapterIndex":517,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536333939","chapterName":"Old Wei","chapterIndex":518,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536350323","chapterName":"A Reason for You","chapterIndex":519,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536497779","chapterName":"Qualification Tournament","chapterIndex":520,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536514163","chapterName":"Where Dreams Start","chapterIndex":521,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536530547","chapterName":"Managing the Guild Storage","chapterIndex":522,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536546931","chapterName":"True Goal","chapterIndex":523,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536432243","chapterName":"Complete Chaos","chapterIndex":524,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536448627","chapterName":"Can’t Hold the Boss","chapterIndex":525,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536465011","chapterName":"Killing Amidst the Chaos","chapterIndex":526,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536481395","chapterName":"Treasure","chapterIndex":527,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536645234","chapterName":"Beginning to Take Shape","chapterIndex":528,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536628850","chapterName":"Spies’ Contributions","chapterIndex":529,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805113458","chapterName":"Level 50 Thousand Chance Umbrella","chapterIndex":530,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805097074","chapterName":"What Are We Here For?","chapterIndex":531,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536579699","chapterName":"A Peaceful Way","chapterIndex":532,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536563315","chapterName":"If There Aren’t Any Opportunities, Create Your Own","chapterIndex":533,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536612467","chapterName":"Venomous Flies","chapterIndex":534,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536596083","chapterName":"Fierce Mantis","chapterIndex":535,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805211761","chapterName":"Nobody Move!","chapterIndex":536,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805195377","chapterName":"Lurkers","chapterIndex":537,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805244528","chapterName":" Who Killed Me?","chapterIndex":538,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805228145","chapterName":"Conclusion to the Hunt","chapterIndex":539,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805146226","chapterName":"Extortion","chapterIndex":540,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805129842","chapterName":"Guarded Secret","chapterIndex":541,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805178994","chapterName":"Follow Up","chapterIndex":542,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805162610","chapterName":"Spies","chapterIndex":543,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535875188","chapterName":"Third Follow Up","chapterIndex":544,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535891572","chapterName":"Rescue","chapterIndex":545,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535842420","chapterName":"Breakout","chapterIndex":546,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535858804","chapterName":"The Wealthy are Aggressive and Powerful","chapterIndex":547,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535809652","chapterName":"Unrivalled Super Hottie ","chapterIndex":548,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535826036","chapterName":"I’m a Tank","chapterIndex":549,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535776884","chapterName":"You Can Just Be a Leecher","chapterIndex":550,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535793268","chapterName":"Proof of Strength","chapterIndex":551,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536006260","chapterName":"Controlling Aggro Through Damage","chapterIndex":552,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536022644","chapterName":"Damage Output Competition","chapterIndex":553,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535973492","chapterName":"Bone Dragon Aldton","chapterIndex":554,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535989876","chapterName":"Knight’s Spirit","chapterIndex":555,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535940724","chapterName":"Sacrificial Roar","chapterIndex":556,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535957108","chapterName":"The Arrogant Youth Whose Face Was Slapped","chapterIndex":557,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535907956","chapterName":"Test","chapterIndex":558,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417535924340","chapterName":"Tyrannical Ambition’s Four Branches","chapterIndex":559,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536153716","chapterName":"One Hundred Player Dungeon Team","chapterIndex":560,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536137332","chapterName":"I Forgot","chapterIndex":561,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536120948","chapterName":"Gather Around the Tank","chapterIndex":562,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536104564","chapterName":"Bro, Slow Down","chapterIndex":563,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536088180","chapterName":"Hold It Steady!","chapterIndex":564,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536071796","chapterName":"A Tank That Makes Others Embarrassed","chapterIndex":565,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536055412","chapterName":"I Won’t Let You Test Your Luck","chapterIndex":566,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536039028","chapterName":"Aquatic Battle? I Know About It","chapterIndex":567,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536284788","chapterName":"This Is a Strong Tank","chapterIndex":568,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536268404","chapterName":"The Final Boss’s Three Iron Shovels","chapterIndex":569,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536252020","chapterName":"Sworn Enemy","chapterIndex":570,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536235636","chapterName":"Dungeon Clear or Wipe Out?","chapterIndex":571,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536219252","chapterName":"Who is this Person?","chapterIndex":572,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536202868","chapterName":"Natural Knight","chapterIndex":573,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536186484","chapterName":"2v2","chapterIndex":574,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417536170100","chapterName":"Rough Coordination","chapterIndex":575,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805260912","chapterName":"Tree Trunk PvP","chapterIndex":576,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805277296","chapterName":" Replicating Victory","chapterIndex":577,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805293680","chapterName":"The People from Tyrannical Ambition","chapterIndex":578,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805310064","chapterName":"Starting at the Top","chapterIndex":579,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805326448","chapterName":"On Equal Footing","chapterIndex":580,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805342832","chapterName":"Pleased Knights","chapterIndex":581,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805359216","chapterName":"Under Attack","chapterIndex":582,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805375600","chapterName":"Flashy But Ineffective","chapterIndex":583,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805391984","chapterName":"Creating an Environment","chapterIndex":584,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805408368","chapterName":"Starting Place","chapterIndex":585,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805424752","chapterName":"Provoke Relay","chapterIndex":586,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805441136","chapterName":"Honest Maelstrom Counterattack","chapterIndex":587,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805457520","chapterName":"Crusader’s Trial","chapterIndex":588,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805473904","chapterName":"Retreat in Defeat","chapterIndex":589,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805490288","chapterName":"The Hidden Agenda ","chapterIndex":590,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805506672","chapterName":"Laboring for the Guild","chapterIndex":591,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805539439","chapterName":"Sharing the Labor","chapterIndex":592,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805523055","chapterName":"Time Decides Aggro","chapterIndex":593,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805572207","chapterName":"The Lost Initiative","chapterIndex":594,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805555823","chapterName":"Rush Upwards Just Like This","chapterIndex":595,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805604975","chapterName":"The Sneaky Cleric","chapterIndex":596,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805588591","chapterName":"I’ll Be Leaving First Because I’ve Got Stuff to Do ","chapterIndex":597,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805637743","chapterName":"The Heart of a Champion","chapterIndex":598,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805621359","chapterName":"Proceed With Care","chapterIndex":599,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805670511","chapterName":"First Contact","chapterIndex":600,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775417805654127","chapterName":"Many Questions","chapterIndex":601,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"20842542158843476","chapterName":"There’s Always Something That’ll Work","chapterIndex":602,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492520758000},{"chapterId":"20842542158876244","chapterName":"Team Group Chat","chapterIndex":603,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492520783000},{"chapterId":"20842542158909011","chapterName":"The Starting Six","chapterIndex":604,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492520833000},{"chapterId":"20842542158941779","chapterName":"Times Have Changed","chapterIndex":605,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492521024000},{"chapterId":"20842542158974546","chapterName":"Gathering","chapterIndex":606,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492699409000},{"chapterId":"20842542159007314","chapterName":"A Special Day","chapterIndex":607,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492767567000},{"chapterId":"20842542159040082","chapterName":"An Unimaginable Matter","chapterIndex":608,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492856414000},{"chapterId":"20842542159072850","chapterName":"Unexpectedly Here","chapterIndex":609,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492940791000},{"chapterId":"20842542159105618","chapterName":"Wei Chen Arrives","chapterIndex":610,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1493041420000},{"chapterId":"20842542159138386","chapterName":"True Beginning","chapterIndex":611,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1493131559000},{"chapterId":"20842542427606610","chapterName":"Lose the battle, but win the war","chapterIndex":612,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1493214504000},{"chapterId":"20842542427639378","chapterName":"Teammate","chapterIndex":613,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1493302330000},{"chapterId":"20842542427672146","chapterName":"Comparing Notes","chapterIndex":614,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1493389057000},{"chapterId":"20842542427704914","chapterName":"Qingming Festival","chapterIndex":615,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1493476610000},{"chapterId":"20842542427737682","chapterName":"Su Muqiu","chapterIndex":616,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1493562077000},{"chapterId":"20842542427770450","chapterName":"Let’s Work Hard Together Everyone","chapterIndex":617,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1493647827000},{"chapterId":"20842542427803218","chapterName":"Practice Room","chapterIndex":618,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1493732362000},{"chapterId":"20842542427835986","chapterName":"Do You Have a Clear Conscience?","chapterIndex":619,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1493819163000},{"chapterId":"20842542427868754","chapterName":"Excellent Era Relegated","chapterIndex":620,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1493993834000},{"chapterId":"20842542427901522","chapterName":"Pressure on Team Happy","chapterIndex":621,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1494079841000},{"chapterId":"20842542696369746","chapterName":"The Boss’s Support","chapterIndex":622,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1494165927000},{"chapterId":"20842542696402514","chapterName":"Fundamental Doctrine","chapterIndex":623,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1494251434000},{"chapterId":"20842542696435282","chapterName":"The Pinnacle of Research","chapterIndex":624,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1494346779000},{"chapterId":"20842542696468050","chapterName":"Worry","chapterIndex":625,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1494425706000},{"chapterId":"20842542696500818","chapterName":"The Character with the Most Skill Points","chapterIndex":626,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1494508484000},{"chapterId":"20842542696533586","chapterName":"Assembly Line","chapterIndex":627,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1494601128000},{"chapterId":"20842542696566354","chapterName":"Correct Line of Thinking","chapterIndex":628,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1494688924000},{"chapterId":"20842542696599122","chapterName":"Why Should I?","chapterIndex":629,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1494780341000},{"chapterId":"20842542696631890","chapterName":"New Goal","chapterIndex":630,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1494856618000},{"chapterId":"20842542696664658","chapterName":"Visiting Samsara","chapterIndex":631,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1494943792000},{"chapterId":"20842542965132882","chapterName":"One Man Team","chapterIndex":632,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1495029257000},{"chapterId":"20842542965165650","chapterName":"Deadlock","chapterIndex":633,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1495116618000},{"chapterId":"20842542965198418","chapterName":"Final Test","chapterIndex":634,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1495205624000},{"chapterId":"20842542965231186","chapterName":"20 Million","chapterIndex":635,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1495290803000},{"chapterId":"20842542965263954","chapterName":"Final Resolution","chapterIndex":636,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1495462073000},{"chapterId":"20842542965296722","chapterName":"A Large Sum of Money","chapterIndex":637,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1495462095000},{"chapterId":"20842542965329490","chapterName":"Guarding Against the Unexpected","chapterIndex":638,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1495546978000},{"chapterId":"20842542965362258","chapterName":"Playoffs","chapterIndex":639,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1495635777000},{"chapterId":"20842542965395025","chapterName":"You Can See That Too!  ","chapterIndex":640,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1495720230000},{"chapterId":"20842542965427793","chapterName":"Times Have Changed","chapterIndex":641,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1495810703000},{"chapterId":"20842542965460561","chapterName":"Top Four   ","chapterIndex":642,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1495894380000},{"chapterId":"20842543233928785","chapterName":"The Standard Way  ","chapterIndex":643,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1496067156000},{"chapterId":"20842543233961552","chapterName":"Finals","chapterIndex":644,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1496153257000},{"chapterId":"20842543233994320","chapterName":"Excessive Improvement  ","chapterIndex":645,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1496238888000},{"chapterId":"20842543234027088","chapterName":"Let’s Steal a Boss ","chapterIndex":646,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1496325047000},{"chapterId":"20842543234059856","chapterName":"Are you seeking your own death?  ","chapterIndex":647,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1496411701000},{"chapterId":"20842543234092624","chapterName":"Boss Spawn","chapterIndex":648,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1496499342000},{"chapterId":"20842543234125391","chapterName":"The Day Before the Finals  ","chapterIndex":649,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1496670520000},{"chapterId":"20842543234158159","chapterName":"Doing Two Things at Once   ","chapterIndex":650,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1496670530000},{"chapterId":"20842543234190926","chapterName":"Samsara’s Teamwork","chapterIndex":651,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1496759409000},{"chapterId":"20842543234223694","chapterName":"Team Blue Rain’s Tactics","chapterIndex":652,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1496844122000},{"chapterId":"20842543502691918","chapterName":"The Limit of Limits","chapterIndex":653,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1496931135000},{"chapterId":"20842543502724686","chapterName":"Trump Card versus Trump Card","chapterIndex":654,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1497018117000},{"chapterId":"20842543502757454","chapterName":"Trade","chapterIndex":655,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1497109047000},{"chapterId":"20842543502790222","chapterName":"At All Costs","chapterIndex":656,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1497190397000},{"chapterId":"20842543502822990","chapterName":"The People’s War","chapterIndex":657,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1497277809000},{"chapterId":"20842543502855758","chapterName":"The Battle at Darkness Palace","chapterIndex":658,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1497363513000},{"chapterId":"20842543502888525","chapterName":"Who is robbing whom?","chapterIndex":659,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1497450113000},{"chapterId":"20842543502921292","chapterName":"Be Wary of Leaving Combat","chapterIndex":660,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1497536355000},{"chapterId":"20842543502954060","chapterName":"Hasty Escape","chapterIndex":661,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1497623506000},{"chapterId":"23000234665765226","chapterName":"test","chapterIndex":662,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1505724233000},{"chapterId":"30539125799047747","chapterName":"Chapter 663 cannot be spared","chapterIndex":663,"isVip":0,"isAuth":1,"publishTimeFormat":"6 years ago","chapterLevel":0,"userLevel":0,"publishTime":1533808709000},{"chapterId":"32766022855481796","chapterName":"goutui","chapterIndex":664,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1542104547000},{"chapterId":"36154682527243114","chapterName":"test","chapterIndex":665,"isVip":2,"isAuth":0,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1554728304000},{"chapterId":"37150484921907281","chapterName":"啊啊啊发发发","chapterIndex":666,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1558437941000},{"chapterId":"37150490827487315","chapterName":"aa2","chapterIndex":667,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1558437963000},{"chapterId":"37676377360621129","chapterName":"特权test chapter 1","chapterIndex":668,"isVip":2,"isAuth":0,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560397042000},{"chapterId":"37676385413684817","chapterName":"特权 chapter 2","chapterIndex":669,"isVip":2,"isAuth":0,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560397073000},{"chapterId":"37679108154516068","chapterName":"test ","chapterIndex":670,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560407244000},{"chapterId":"37683629949766784","chapterName":"特权VIP","chapterIndex":671,"isVip":2,"isAuth":0,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560424061000},{"chapterId":"37684794422783319","chapterName":"特权 VIP 1","chapterIndex":672,"isVip":2,"isAuth":0,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560428399000},{"chapterId":"37684801670540683","chapterName":"特权 VIP 2","chapterIndex":673,"isVip":2,"isAuth":0,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560428426000},{"chapterId":"37684832272182814","chapterName":"特权 VIP 3","chapterIndex":674,"isVip":2,"isAuth":0,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560428540000},{"chapterId":"38580931027588295","chapterName":"哈哈大会还房贷","chapterIndex":675,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563766768000},{"chapterId":"38580940154393806","chapterName":"vhapret oowo","chapterIndex":676,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563766802000},{"chapterId":"38581799953163647","chapterName":"chapter lslsl","chapterIndex":677,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563770005000},{"chapterId":"38582350514288058","chapterName":"llal ","chapterIndex":678,"isVip":2,"isAuth":0,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563772056000},{"chapterId":"38586322553729517","chapterName":"shdh 1","chapterIndex":679,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563786853000},{"chapterId":"38586331680535110","chapterName":"shhds 02","chapterIndex":680,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563786887000},{"chapterId":"39792650823452860","chapterName":"682","chapterIndex":681,"isVip":2,"isAuth":0,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568280776000}],"volumeId":2,"volumeName":""},{"chapterItems":[{"chapterId":"45727419184774513","chapterName":"","chapterIndex":682,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1590389556000}],"volumeId":3,"volumeName":""}]
     */
    volumeItems?: {
      /**
       * [{"chapterId":"19775416453662908","chapterName":"The Banished Battle God","chapterIndex":1,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453679284","chapterName":"Area 3 Number 47","chapterIndex":2,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453695667","chapterName":"Special Duty: Night Shift","chapterIndex":3,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453712047","chapterName":"Mysterious Expert","chapterIndex":4,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453732570","chapterName":"Skill Match","chapterIndex":5,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453744813","chapterName":"Thousand Chance Umbrella","chapterIndex":6,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453761195","chapterName":"Midnight Phantom Cat","chapterIndex":7,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453777578","chapterName":"A Life and Death Struggle","chapterIndex":8,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453793962","chapterName":"Ye Xiu’s Two Hands","chapterIndex":9,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453810344","chapterName":"Shameless Novice","chapterIndex":10,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453826727","chapterName":"Missing a Person? Add Me!","chapterIndex":11,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453843111","chapterName":"Spider Cave (1)","chapterIndex":12,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453859494","chapterName":"Spider Cave (2)","chapterIndex":13,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453875877","chapterName":"Spider Cave (3)","chapterIndex":14,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453892261","chapterName":"Spider Cave (4)","chapterIndex":15,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453925028","chapterName":"Emperor (1)","chapterIndex":16,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453908644","chapterName":"Emperor (2)","chapterIndex":17,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453957796","chapterName":"Emperor (3)","chapterIndex":18,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453941412","chapterName":"Emperor (4)","chapterIndex":19,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453990562","chapterName":"Emperor (5)","chapterIndex":20,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416453974179","chapterName":"The Day’s Already Bright Again","chapterIndex":21,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454023329","chapterName":"Ye Qiu’s Retirement (1)","chapterIndex":22,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454006945","chapterName":"Ye Qiu’s Retirement (2)","chapterIndex":23,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454056097","chapterName":"Dungeon Record","chapterIndex":24,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454039713","chapterName":"Did You Hear What I Said?","chapterIndex":25,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454088864","chapterName":"Forgot to Look at a Guide","chapterIndex":26,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454072481","chapterName":"The Guide Says 24 Times","chapterIndex":27,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454121631","chapterName":"Professional Level","chapterIndex":28,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454105247","chapterName":"First Clear Team","chapterIndex":29,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454154399","chapterName":"Two Hidden BOSS Clears","chapterIndex":30,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454138015","chapterName":"This Is A Talent","chapterIndex":31,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454203551","chapterName":"Haggling","chapterIndex":32,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454219935","chapterName":"He’s Here to Make a Fool of Himself, Right?","chapterIndex":33,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454170783","chapterName":"Some More Damage","chapterIndex":34,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454187167","chapterName":"One Wave Rush (1)","chapterIndex":35,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454269086","chapterName":"One Wave Rush (2)","chapterIndex":36,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454285470","chapterName":"One Wave Rush (3)","chapterIndex":37,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454236318","chapterName":"What’s Damage","chapterIndex":38,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454252702","chapterName":"Frost Thain","chapterIndex":39,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454334620","chapterName":"New Record","chapterIndex":40,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454351004","chapterName":"A Simple Leave","chapterIndex":41,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454301852","chapterName":"A Good That Could Be Bought","chapterIndex":42,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454318236","chapterName":"Don’t Need A Cleric","chapterIndex":43,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454400156","chapterName":"Different Fees","chapterIndex":44,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454416540","chapterName":"Original Strategy","chapterIndex":45,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454367388","chapterName":"Easy Glory","chapterIndex":46,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454383772","chapterName":"I’m Playing Unspecialized","chapterIndex":47,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454482076","chapterName":"Countless Variations","chapterIndex":48,"isVip":0,"isAuth":1,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454465692","chapterName":"You Really Don’t Know How to Play","chapterIndex":49,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454449308","chapterName":"Again!","chapterIndex":50,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454432924","chapterName":"The Weapon That Couldn’t Be Hidden","chapterIndex":51,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454547612","chapterName":"Picking a Class","chapterIndex":52,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454531228","chapterName":"Battle Mage","chapterIndex":53,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454514844","chapterName":"Show Me","chapterIndex":54,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454498460","chapterName":"Surpassing the Guide","chapterIndex":55,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454613147","chapterName":"Leveling Isn’t Easy","chapterIndex":56,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454596763","chapterName":"Boneyard","chapterIndex":57,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454580380","chapterName":"Kill Stealing","chapterIndex":58,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454563996","chapterName":"Are You Playing With A Child?","chapterIndex":59,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454678682","chapterName":"Wild Boss","chapterIndex":60,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454662299","chapterName":"Hunting Yagg (1)","chapterIndex":61,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454645915","chapterName":"Hunting Yagg (2)","chapterIndex":62,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454629531","chapterName":"Hunting Yagg (3)","chapterIndex":63,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454760600","chapterName":"Hunting Yagg (4)","chapterIndex":64,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454776984","chapterName":"Hunting Yagg (5)","chapterIndex":65,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454793368","chapterName":"Undead Legion","chapterIndex":66,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454809752","chapterName":"Speed Up","chapterIndex":67,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454695065","chapterName":"Blood Gunner First Kill","chapterIndex":68,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454711449","chapterName":"Keep Chasing And I Won’t Be So Nice Anymore","chapterIndex":69,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454727832","chapterName":"Copy Upgrade","chapterIndex":70,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454744216","chapterName":"Weapons and Skills","chapterIndex":71,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454891671","chapterName":"Taking Advantage of Everyone","chapterIndex":72,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454908055","chapterName":"Sand Toss","chapterIndex":73,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454924439","chapterName":"Understanding Information","chapterIndex":74,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454940823","chapterName":"Losing the Fight for the Monster","chapterIndex":75,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454826136","chapterName":"Controlling the BOSS’s Move Path","chapterIndex":76,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454842520","chapterName":"Directly Flying Over","chapterIndex":77,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454858903","chapterName":"Forced Into Helplessness","chapterIndex":78,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454875287","chapterName":"Changing Spring","chapterIndex":79,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455039127","chapterName":"A Guild Leader’s Troubles","chapterIndex":80,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455022743","chapterName":"A Blessing or a Curse","chapterIndex":81,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455071895","chapterName":"A Swift Dungeon Record","chapterIndex":82,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455055511","chapterName":"Almost the Limit","chapterIndex":83,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454973591","chapterName":"Manpower Needed","chapterIndex":84,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454957207","chapterName":"Steamed Bun Invasion","chapterIndex":85,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455006359","chapterName":"Teaching the Noob","chapterIndex":86,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416454989975","chapterName":"I Feel Like None of You Slept","chapterIndex":87,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"7366916801980000","chapterName":"Glory League","chapterIndex":88,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416455153814","chapterName":"Home Advantage","chapterIndex":89,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000},{"chapterId":"19775416723638422","chapterName":"The Footprints are a Trap","chapterIndex":90,"isVip":2,"isAuth":0,"publishTimeFormat":"7 years ago","chapterLevel":0,"userLevel":0,"publishTime":1492513758000}]
       */
      chapterItems?: {
        /**
         * "19775416453662908"
         */
        chapterId?: string;
        /**
         * "The Banished Battle God"
         */
        chapterName?: string;
        /**
         * 1
         */
        chapterIndex?: number;
        isVip?: number;
        /**
         * 1
         */
        isAuth?: number;
        /**
         * "7 years ago"
         */
        publishTimeFormat?: string;
        chapterLevel?: number;
        userLevel?: number;
        /**
         * 1492513758000
         */
        publishTime?: number;
      }[];
      /**
       * 1
       */
      volumeId?: number;
      volumeName?: string;
    }[];
  };
  /**
   * []
   */
  relationReviews?: unknown[];
  recommendInfo?: {
    /**
     * "WeekDay Feature"
     */
    title?: string;
    /**
     * []
     */
    contentItems?: unknown[];
  };
  /**
   * [{"id":3118968,"lang":"en","searchWord":"Masked Knight"},{"id":3118969,"lang":"en","searchWord":"Galactic Dark Net"},{"id":3118971,"lang":"en","searchWord":"Once Upon A Time, There Was A Spirit Sword Mountain"},{"id":3118973,"lang":"en","searchWord":"Counterfeit Hero"},{"id":3118975,"lang":"en","searchWord":"Trafford's Trading Club"},{"id":3118976,"lang":"en","searchWord":"Library of Heaven's Path"},{"id":3118977,"lang":"en","searchWord":"Realms In The Firmament"},{"id":3118979,"lang":"en","searchWord":"The Wizard World"},{"id":3118981,"lang":"en","searchWord":"The Sacred Ruins"},{"id":3118984,"lang":"en","searchWord":"Forty Millenniums of Cultivation"}]
   */
  popularSearches?: {
    /**
     * 3118968
     */
    id?: number;
    /**
     * "en"
     */
    lang?: string;
    /**
     * "Masked Knight"
     */
    searchWord?: string;
  }[];
  /**
   * [{"topicId":345208848329834,"lang":"","topicName":"love in silence novel"},{"topicId":345208848401520,"lang":"","topicName":"anime with love stories"},{"topicId":345208849937520,"lang":"","topicName":"jamaican love novels"},{"topicId":345208850615414,"lang":"","topicName":"passionate love novels"},{"topicId":345208848827514,"lang":"","topicName":"will and alyss love fanfiction"},{"topicId":345208848827528,"lang":"","topicName":"forsaken love novel"},{"topicId":345208850410637,"lang":"","topicName":"an aunts love fanfiction"},{"topicId":345208849550443,"lang":"","topicName":"3 days love story"},{"topicId":345208849751171,"lang":"","topicName":"powerful love novels"},{"topicId":345208852403309,"lang":"","topicName":"labyrinth love fanfiction"}]
   */
  relationTopics?: {
    /**
     * 345208848329834
     */
    topicId?: number;
    lang?: string;
    /**
     * "love in silence novel"
     */
    topicName?: string;
  }[];
  /**
   * [{"bookId":"147935635005342105","name":"[Tokyo: Extraordinary Parasitism]","shortName":"","originalName":"东京：超凡寄生","description":"Parasitism, mutation…\nChess pieces were placed on the table, and lives were lost for no reason\nAll the chess pieces are nothing but consumables for my great power\n[Behind-the-scenes],[Source of All Transcendents],[Fighting Left and Right]","categoryType":1,"categoryId":70001,"subcategoryId":0,"categoryName":"Urban","subcategoryName":"","authorId":"4257468304893301","authorName":"Autumn Water Drizzles","sourceType":1,"status":30,"checkLevel":15,"checkTime":1711967348000,"vipStatus":-1,"vipTime":1722341970000,"wordCount":8749,"unitPrice":0,"translation":{"translators":null,"editors":null,"groups":null},"essayIds":null,"createTime":1722341970000,"updateTime":1722341970000,"totalChapterCount":215,"beforeChapterCount":0,"contentChapterCount":8749,"lastChapterId":0,"lastChapterName":"","lastChapterTime":0,"scheduleUpdateFrequency":0,"scheduleUpdateFrequencyUnit":0,"ageGroup":0,"language":1,"expected":0,"sex":-1,"updateFrequency":0,"updateFrequencyUnit":0,"ageGroupDescription":"","firstChapterId":0,"languageName":"","signType":0,"filter":{"blackCountries":"","whiteCountries":""},"signed":0,"nextChapterTime":0,"translateMode":0,"words":"","serialStartTime":0,"shield":0,"site":0,"form":0,"sideStoryType":0,"editorRecommendation":"","noGift":false,"auditStatus":0,"transChannel":0,"cpid":0,"scbid":0,"acbid":0,"chargeChapterStartIndex":0,"vipChapterWordsCount":0,"pvNum":5810,"coverUrl":"https://oa-book-pic.webnovel.com/novelcover/147935635005342105?imageMogr2/format/webp&imageMogr2/thumbnail/180x"},{"bookId":"147936744756945805","name":"It's hard to find a place to return to","shortName":"","originalName":"江山难觅归雁处","description":"Since he couldn't hide from history, he would face it head-on!\nOriginal name: \"Great Arts\"\nPassing through the money-grubber, a righteous liberal arts student × rebirth, a hypocrite who is bent on rebellion against a powerful minister\nZhou Jinlin, who had transmigrated to another world and only wanted to earn money and run away safely, was involved in one storm after another.\nThe court, the martial world, Deep Waters had her hand on her forehead as she sighed,[I just want to make money!]\nIn the end, she couldn't take it anymore and thought,\"Alright, don't blame me for using the traditional ability of a liberal arts student to subvert the world!\"\n\" It's too deep. I'll carry you.\" A man who had been in the water ran toward her.\nIn short, this is a story of a male and female protagonist subverting the world\nlittle theatre\n[What attracted you the most about him?]\nZhou Jinlin thought,\"Maybe she's good-looking?\"\nWei Zhuo: Does contrast count?","categoryType":1,"categoryId":70015,"subcategoryId":0,"categoryName":"History","subcategoryName":"","authorId":"14297847004438601","authorName":"Daolord Dualplane.","sourceType":1,"status":30,"checkLevel":15,"checkTime":1624863190000,"vipStatus":-1,"vipTime":1722347389000,"wordCount":6980,"unitPrice":0,"translation":{"translators":null,"editors":null,"groups":null},"essayIds":null,"createTime":1722347389000,"updateTime":1722347389000,"totalChapterCount":122,"beforeChapterCount":0,"contentChapterCount":6980,"lastChapterId":0,"lastChapterName":"","lastChapterTime":0,"scheduleUpdateFrequency":0,"scheduleUpdateFrequencyUnit":0,"ageGroup":0,"language":1,"expected":0,"sex":-1,"updateFrequency":0,"updateFrequencyUnit":0,"ageGroupDescription":"","firstChapterId":0,"languageName":"","signType":0,"filter":{"blackCountries":"","whiteCountries":""},"signed":0,"nextChapterTime":0,"translateMode":0,"words":"","serialStartTime":0,"shield":0,"site":0,"form":0,"sideStoryType":0,"editorRecommendation":"","noGift":false,"auditStatus":0,"transChannel":0,"cpid":0,"scbid":0,"acbid":0,"chargeChapterStartIndex":0,"vipChapterWordsCount":0,"pvNum":9130,"coverUrl":"https://oa-book-pic.webnovel.com/novelcover/147936744756945805?imageMogr2/format/webp&imageMogr2/thumbnail/180x"},{"bookId":"147936929765484505","name":"That strand of obsession","shortName":"","originalName":"那一缕执念","description":"A story of youth, two people who kept missing each other; After walking through the anxious and chaotic years, I just want to say to you: How have you been?","categoryType":1,"categoryId":70014,"subcategoryId":0,"categoryName":"Urban","subcategoryName":"","authorId":"17890156008682001","authorName":"Spring is full of flowers","sourceType":1,"status":30,"checkLevel":15,"checkTime":1598959650000,"vipStatus":-1,"vipTime":1722348292000,"wordCount":4691,"unitPrice":0,"translation":{"translators":null,"editors":null,"groups":null},"essayIds":null,"createTime":1722348292000,"updateTime":1722348292000,"totalChapterCount":13,"beforeChapterCount":0,"contentChapterCount":4691,"lastChapterId":0,"lastChapterName":"","lastChapterTime":0,"scheduleUpdateFrequency":0,"scheduleUpdateFrequencyUnit":0,"ageGroup":0,"language":1,"expected":0,"sex":-1,"updateFrequency":0,"updateFrequencyUnit":0,"ageGroupDescription":"","firstChapterId":0,"languageName":"","signType":0,"filter":{"blackCountries":"","whiteCountries":""},"signed":0,"nextChapterTime":0,"translateMode":0,"words":"","serialStartTime":0,"shield":0,"site":0,"form":0,"sideStoryType":0,"editorRecommendation":"","noGift":false,"auditStatus":0,"transChannel":0,"cpid":0,"scbid":0,"acbid":0,"chargeChapterStartIndex":0,"vipChapterWordsCount":0,"pvNum":1767,"coverUrl":"https://oa-book-pic.webnovel.com/novelcover/147936929765484505?imageMogr2/format/webp&imageMogr2/thumbnail/180x"},{"bookId":"147937441023697905","name":"Zhuang language","shortName":"","originalName":"壮语","description":"[\" Extraordinary Children's Dreams \" Chinese Children's Literature Essay Competition]\nFrom elementary school to university, from school to society, no one had ever heard a more shocking self-introduction than her. My name is Xiao Zhuang, and my nickname is Da Zhuang! You can say that my Chinese is strong, or you can say that my Zhuang language is strong!\r\nShe was the mountain girl Lin Xiaozhuang, born in a farming family of ethnic minorities. She was an ordinary girl who could not even speak Mandarin well. Because she spoke Mandarin with a strong accent, she was once ridiculed by her classmates!\r\nHeaven rewards hard work and life is a gift. The high school entrance examination and college entrance examination became the two turning points of fate, which opened the path of her voice and let the whole world hear her voice!","categoryType":1,"categoryId":70014,"subcategoryId":0,"categoryName":"Urban","subcategoryName":"","authorId":"8103652803202801","authorName":"Butterfly in the Mirror","sourceType":1,"status":30,"checkLevel":15,"checkTime":1606026482000,"vipStatus":-1,"vipTime":1722350789000,"wordCount":3885,"unitPrice":0,"translation":{"translators":null,"editors":null,"groups":null},"essayIds":null,"createTime":1722350789000,"updateTime":1722350789000,"totalChapterCount":173,"beforeChapterCount":0,"contentChapterCount":3885,"lastChapterId":0,"lastChapterName":"","lastChapterTime":0,"scheduleUpdateFrequency":0,"scheduleUpdateFrequencyUnit":0,"ageGroup":0,"language":1,"expected":0,"sex":-1,"updateFrequency":0,"updateFrequencyUnit":0,"ageGroupDescription":"","firstChapterId":0,"languageName":"","signType":0,"filter":{"blackCountries":"","whiteCountries":""},"signed":0,"nextChapterTime":0,"translateMode":0,"words":"","serialStartTime":0,"shield":0,"site":0,"form":0,"sideStoryType":0,"editorRecommendation":"","noGift":false,"auditStatus":0,"transChannel":0,"cpid":0,"scbid":0,"acbid":0,"chargeChapterStartIndex":0,"vipChapterWordsCount":0,"pvNum":4108,"coverUrl":"https://oa-book-pic.webnovel.com/novelcover/147937441023697905?imageMogr2/format/webp&imageMogr2/thumbnail/180x"},{"bookId":"147937858553759905","name":"Supernatural Detective Archives","shortName":"","originalName":"港综：灵异侦缉档案","description":"Fang Enge, a disciple of a hidden sect, accidentally entered the movie world. He was the supervisor of Team B of the Hong Kong Police Sundries Division. His partner, Ma Xiaoling, was responsible for investigating and dealing with supernatural cases received by the Hong Kong Police.\nRemember, the first commandment of the sundries department, there are no ghosts in this world!","categoryType":1,"categoryId":70006,"subcategoryId":0,"categoryName":"Sci-fi","subcategoryName":"","authorId":"15760341605427001","authorName":"A light boat goes","sourceType":1,"status":30,"checkLevel":15,"checkTime":1713156386000,"vipStatus":-1,"vipTime":1722352827000,"wordCount":7305,"unitPrice":0,"translation":{"translators":null,"editors":null,"groups":null},"essayIds":null,"createTime":1722352827000,"updateTime":1722352827000,"totalChapterCount":128,"beforeChapterCount":0,"contentChapterCount":7305,"lastChapterId":0,"lastChapterName":"","lastChapterTime":0,"scheduleUpdateFrequency":0,"scheduleUpdateFrequencyUnit":0,"ageGroup":0,"language":1,"expected":0,"sex":-1,"updateFrequency":0,"updateFrequencyUnit":0,"ageGroupDescription":"","firstChapterId":0,"languageName":"","signType":0,"filter":{"blackCountries":"","whiteCountries":""},"signed":0,"nextChapterTime":0,"translateMode":0,"words":"","serialStartTime":0,"shield":0,"site":0,"form":0,"sideStoryType":0,"editorRecommendation":"","noGift":false,"auditStatus":0,"transChannel":0,"cpid":0,"scbid":0,"acbid":0,"chargeChapterStartIndex":0,"vipChapterWordsCount":0,"pvNum":8148,"coverUrl":"https://oa-book-pic.webnovel.com/novelcover/147937858553759905?imageMogr2/format/webp&imageMogr2/thumbnail/180x"}]
   */
  newArrivals?: {
    /**
     * "147935635005342105"
     */
    bookId?: string;
    /**
     * "[Tokyo: Extraordinary Parasitism]"
     */
    name?: string;
    shortName?: string;
    /**
     * "东京：超凡寄生"
     */
    originalName?: string;
    /**
     * "Parasitism, mutation…\nChess pieces were placed on the table, and lives were lost for no reason\nAll the chess pieces are nothing but consumables for my great power\n[Behind-the-scenes],[Source of All Transcendents],[Fighting Left and Right]"
     */
    description?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * 70001
     */
    categoryId?: number;
    subcategoryId?: number;
    /**
     * "Urban"
     */
    categoryName?: string;
    subcategoryName?: string;
    /**
     * "4257468304893301"
     */
    authorId?: string;
    /**
     * "Autumn Water Drizzles"
     */
    authorName?: string;
    /**
     * 1
     */
    sourceType?: number;
    /**
     * 30
     */
    status?: number;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * 1711967348000
     */
    checkTime?: number;
    /**
     * -1
     */
    vipStatus?: number;
    /**
     * 1722341970000
     */
    vipTime?: number;
    /**
     * 8749
     */
    wordCount?: number;
    unitPrice?: number;
    translation?: {
      translators?: null;
      editors?: null;
      groups?: null;
    };
    essayIds?: null;
    /**
     * 1722341970000
     */
    createTime?: number;
    /**
     * 1722341970000
     */
    updateTime?: number;
    /**
     * 215
     */
    totalChapterCount?: number;
    beforeChapterCount?: number;
    /**
     * 8749
     */
    contentChapterCount?: number;
    lastChapterId?: number;
    lastChapterName?: string;
    lastChapterTime?: number;
    scheduleUpdateFrequency?: number;
    scheduleUpdateFrequencyUnit?: number;
    ageGroup?: number;
    /**
     * 1
     */
    language?: number;
    expected?: number;
    /**
     * -1
     */
    sex?: number;
    updateFrequency?: number;
    updateFrequencyUnit?: number;
    ageGroupDescription?: string;
    firstChapterId?: number;
    languageName?: string;
    signType?: number;
    filter?: {
      blackCountries?: string;
      whiteCountries?: string;
    };
    signed?: number;
    nextChapterTime?: number;
    translateMode?: number;
    words?: string;
    serialStartTime?: number;
    shield?: number;
    site?: number;
    form?: number;
    sideStoryType?: number;
    editorRecommendation?: string;
    noGift?: boolean;
    auditStatus?: number;
    transChannel?: number;
    cpid?: number;
    scbid?: number;
    acbid?: number;
    chargeChapterStartIndex?: number;
    vipChapterWordsCount?: number;
    /**
     * 5810
     */
    pvNum?: number;
    /**
     * "https://oa-book-pic.webnovel.com/novelcover/147935635005342105?imageMogr2/format/webp&imageMogr2/thumbnail/180x"
     */
    coverUrl?: string;
  }[];
}

/**
 * 接口 [话题详情↗](https://yapi.yuewen.com/project/3297/interface/api/288392) 的 **请求配置的类型**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-09-25 16:16:14`
 */
type GoPcmSeoTopicDetailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/topic/detail",
    "data",
    string,
    "topicId",
    false
  >
>;

/**
 * 接口 [话题详情↗](https://yapi.yuewen.com/project/3297/interface/api/288392) 的 **请求配置**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-09-25 16:16:14`
 */
const goPcmSeoTopicDetailRequestConfig: GoPcmSeoTopicDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_1,
    devUrl: devUrl_0_2_0_1,
    prodUrl: prodUrl_0_2_0_1,
    path: "/go/pcm/seo/topic/detail",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_1,
    paramNames: [],
    queryNames: ["topicId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoTopicDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [话题详情↗](https://yapi.yuewen.com/project/3297/interface/api/288392) 的 **请求函数**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-09-25 16:16:14`
 */
export const goPcmSeoTopicDetail = /*#__PURE__*/ (
  requestData: GoPcmSeoTopicDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoTopicDetailResponse>(
    prepare(goPcmSeoTopicDetailRequestConfig, requestData),
    ...args
  );
};

goPcmSeoTopicDetail.requestConfig = goPcmSeoTopicDetailRequestConfig;

const mockUrl_0_2_0_2 = "https://yapi.yuewen.com/mock/3297" as any;
const devUrl_0_2_0_2 = "https://oawww.webnovel.com" as any;
const prodUrl_0_2_0_2 = "https://www.webnovel.com" as any;
const dataKey_0_2_0_2 = "data" as any;

/**
 * 接口 [查询问答详情 ↗](https://yapi.yuewen.com/project/3297/interface/api/288837) 的 **请求类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskInfo`
 * @更新时间 `2024-07-16 11:05:04`
 */
export interface GoPcmSeoJavaSeoAskQueryAskInfoRequest {
  /**
   * 问答唯一id
   */
  aid: string;
}

/**
 * 接口 [查询问答详情 ↗](https://yapi.yuewen.com/project/3297/interface/api/288837) 的 **返回类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskInfo`
 * @更新时间 `2024-07-16 11:05:04`
 */
export interface GoPcmSeoJavaSeoAskQueryAskInfoResponse {
  askInfo?: {
    /**
     * 4675780
     */
    aid?: number;
    /**
     * "Which APP in the Nine Heavens of Pride is free?"
     */
    title?: string;
    /**
     * "ioqwhdqwjdklwjdljaldjqlwdjalwjdwlj"
     */
    desc?: string;
    /**
     * 1
     */
    answerCount?: number;
    /**
     * 1720677619617
     */
    showTime?: number;
  };
  /**
   * [{"answerId":1,"aid":4675780,"marked":null,"text":"[Pride Nine Heavens is free on Qidian Reading App.]","showTime":1720677619617}]
   */
  answerInfos?: {
    /**
     * 1
     */
    answerId?: number;
    /**
     * 4675780
     */
    aid?: number;
    marked?: null;
    /**
     * "[Pride Nine Heavens is free on Qidian Reading App.]"
     */
    text?: string;
    /**
     * 1720677619617
     */
    showTime?: number;
  }[];
}

/**
 * 接口 [查询问答详情 ↗](https://yapi.yuewen.com/project/3297/interface/api/288837) 的 **请求配置的类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskInfo`
 * @更新时间 `2024-07-16 11:05:04`
 */
type GoPcmSeoJavaSeoAskQueryAskInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/java/seo/ask/queryAskInfo",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询问答详情 ↗](https://yapi.yuewen.com/project/3297/interface/api/288837) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskInfo`
 * @更新时间 `2024-07-16 11:05:04`
 */
const goPcmSeoJavaSeoAskQueryAskInfoRequestConfig: GoPcmSeoJavaSeoAskQueryAskInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryAskInfo",
    method: Method.POST,
    requestHeaders: { Accept: "*/*" },
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryAskInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询问答详情 ↗](https://yapi.yuewen.com/project/3297/interface/api/288837) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskInfo`
 * @更新时间 `2024-07-16 11:05:04`
 */
export const goPcmSeoJavaSeoAskQueryAskInfo = /*#__PURE__*/ (
  requestData: GoPcmSeoJavaSeoAskQueryAskInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoJavaSeoAskQueryAskInfoResponse>(
    prepare(goPcmSeoJavaSeoAskQueryAskInfoRequestConfig, requestData),
    ...args
  );
};

goPcmSeoJavaSeoAskQueryAskInfo.requestConfig =
  goPcmSeoJavaSeoAskQueryAskInfoRequestConfig;

/**
 * 接口 [问答列表（分页）↗](https://yapi.yuewen.com/project/3297/interface/api/288839) 的 **请求类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskList`
 * @更新时间 `2024-10-10 15:34:30`
 */
export interface GoPcmSeoJavaSeoAskQueryAskListRequest {
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 根据问答的title搜索相关问答
   */
  aid?: number;
  /**
   * 是否展示回答内容，0:不展示，1展示
   */
  isShow?: number;
}

/**
 * 接口 [问答列表（分页）↗](https://yapi.yuewen.com/project/3297/interface/api/288839) 的 **返回类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskList`
 * @更新时间 `2024-10-10 15:34:30`
 */
export interface GoPcmSeoJavaSeoAskQueryAskListResponse {
  /**
   * 2130
   */
  total?: number;
  /**
   * 1
   */
  pageNum?: number;
  /**
   * 20
   */
  pageSize?: number;
  /**
   * [{"askInfo":{"aid":4678160,"title":"When did Da Feng's night watchman end?","desc":null,"answerCount":1,"showTime":1720599377405},"answerInfos":[{"answerId":null,"aid":4678160,"marked":null,"text":"Dafeng Nightwatchman officially ended on August 15, 2021....","showTime":1720599377405}]},{"askInfo":{"aid":4678120,"title":"Is there an anime in the fairy?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4678120,"marked":null,"text":"Yes, the Defiant Immortal had anime. The Inverse Immortal An...","showTime":null}]},{"askInfo":{"aid":4678170,"title":"Did you marry a dragon lady in Lanke Chess Fate?","desc":null,"answerCount":1,"showTime":1720599377405},"answerInfos":[{"answerId":null,"aid":4678170,"marked":null,"text":"Lanke Chess Fate didn't marry the Dragon Lady. According to ...","showTime":1720599377405}]},{"askInfo":{"aid":4678080,"title":"What are the Four Gods of the Deep Sea Ember?","desc":null,"answerCount":1,"showTime":1720599377405},"answerInfos":[{"answerId":null,"aid":4678080,"marked":null,"text":"The four gods of the Deep Sea Ember were Morax, Babatos, Lei...","showTime":1720599377405}]},{"askInfo":{"aid":4678130,"title":"Unscientific familiars, where can I find audio novels?","desc":null,"answerCount":1,"showTime":1720599377405},"answerInfos":[{"answerId":null,"aid":4678130,"marked":null,"text":"Unscientific monster familiars audio novels could be found o...","showTime":1720599377405}]},{"askInfo":{"aid":4678140,"title":"Is the Langya Board better or the Celebration of Years?","desc":null,"answerCount":1,"showTime":1720599377405},"answerInfos":[{"answerId":null,"aid":4678140,"marked":null,"text":"As for the question of which was better, Nirvana in Fire or ...","showTime":1720599377405}]},{"askInfo":{"aid":4678150,"title":"What is the strategy of the concubine's daughter","desc":null,"answerCount":1,"showTime":1720599377405},"answerInfos":[{"answerId":null,"aid":4678150,"marked":null,"text":"\" Shu's Daughter Strategy \" told the story of a lowly Shu's ...","showTime":null}]},{"askInfo":{"aid":4678110,"title":"Since when did the world's high-ranking martial artist Ji Yao like Fang Ping?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4678110,"marked":null,"text":"The time when Ji Yao fell in love with Fang Ping in Global M...","showTime":null}]},{"askInfo":{"aid":4677958,"title":"Shao Song's audio book, where can I listen to the night breeze quietly?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4677958,"marked":null,"text":"Shao Song's audio book, Silent Night, can be listened to on ...","showTime":null}]},{"askInfo":{"aid":4677918,"title":"What was Lu Sheng's final stage?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4677918,"marked":null,"text":"There was no clear information about the Extreme Heavenly De...","showTime":null}]},{"askInfo":{"aid":4678100,"title":"Which year was the Comics of Battle Through the Heavens released?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4678100,"marked":null,"text":"Battle Through the Heavens was published in 2012....","showTime":null}]},{"askInfo":{"aid":4677928,"title":"Is the novel of the Divine Throne finished?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4677928,"marked":null,"text":"Yes, the Divine Throne novel had ended. According to the sec...","showTime":null}]},{"askInfo":{"aid":4678090,"title":"Which app can I watch the novel of a son-in-law?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4678090,"marked":null,"text":"You can read the novel on Qidian Reading App....","showTime":null}]},{"askInfo":{"aid":4677948,"title":"What's the use of chess pieces?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4677948,"marked":null,"text":"In \" Lanke Chess Fate \", the chess pieces were used as clues...","showTime":null}]},{"askInfo":{"aid":4677938,"title":"When is the Archean Atlas updated every week?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4677938,"marked":null,"text":"The Archean Eon Painting was updated every Thursday. The ani...","showTime":null}]},{"askInfo":{"aid":4677968,"title":"Is there any follow-up to Night's naming technique?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4677968,"marked":null,"text":"[The main text of \" The Nomination of Night \" has been compl...","showTime":null}]},{"askInfo":{"aid":4677794,"title":"Why did the Lord of the Mysteries end so quickly?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4677794,"marked":null,"text":"The reason why Lord of the Mysteries ended relatively quickl...","showTime":null}]},{"askInfo":{"aid":4677888,"title":"Is there a female lead in Thriller Paradise?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4677888,"marked":null,"text":"There was indeed a female lead in Thriller Paradise, and her...","showTime":null}]},{"askInfo":{"aid":4677908,"title":"Where can I watch cover the sky for free?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4677908,"marked":null,"text":"\" Covering the Sky \" could be read on Qidian website or thro...","showTime":null}]},{"askInfo":{"aid":4677854,"title":"Is Zi Chuan finished?","desc":null,"answerCount":1,"showTime":null},"answerInfos":[{"answerId":null,"aid":4677854,"marked":null,"text":"[Yes, Zi Chuan is finished.] The first season of the animati...","showTime":null}]}]
   */
  data?: {
    askInfo?: {
      /**
       * 4678160
       */
      aid?: number;
      /**
       * "When did Da Feng's night watchman end?"
       */
      title?: string;
      desc?: null;
      /**
       * 1
       */
      answerCount?: number;
      /**
       * 1720599377405
       */
      showTime?: number;
    };
    /**
     * [{"answerId":null,"aid":4678160,"marked":null,"text":"Dafeng Nightwatchman officially ended on August 15, 2021....","showTime":1720599377405}]
     */
    answerInfos?: {
      answerId?: null;
      /**
       * 4678160
       */
      aid?: number;
      marked?: null;
      /**
       * "Dafeng Nightwatchman officially ended on August 15, 2021...."
       */
      text?: string;
      /**
       * 1720599377405
       */
      showTime?: number;
    }[];
  }[];
}

/**
 * 接口 [问答列表（分页）↗](https://yapi.yuewen.com/project/3297/interface/api/288839) 的 **请求配置的类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskList`
 * @更新时间 `2024-10-10 15:34:30`
 */
type GoPcmSeoJavaSeoAskQueryAskListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/java/seo/ask/queryAskList",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [问答列表（分页）↗](https://yapi.yuewen.com/project/3297/interface/api/288839) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskList`
 * @更新时间 `2024-10-10 15:34:30`
 */
const goPcmSeoJavaSeoAskQueryAskListRequestConfig: GoPcmSeoJavaSeoAskQueryAskListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryAskList",
    method: Method.POST,
    requestHeaders: { Accept: "*/*" },
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryAskList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [问答列表（分页）↗](https://yapi.yuewen.com/project/3297/interface/api/288839) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskList`
 * @更新时间 `2024-10-10 15:34:30`
 */
export const goPcmSeoJavaSeoAskQueryAskList = /*#__PURE__*/ (
  requestData: GoPcmSeoJavaSeoAskQueryAskListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoJavaSeoAskQueryAskListResponse>(
    prepare(goPcmSeoJavaSeoAskQueryAskListRequestConfig, requestData),
    ...args
  );
};

goPcmSeoJavaSeoAskQueryAskList.requestConfig =
  goPcmSeoJavaSeoAskQueryAskListRequestConfig;

/**
 * 接口 [热门回答（随机查询30条）↗](https://yapi.yuewen.com/project/3297/interface/api/288842) 的 **请求类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotAskRandom`
 * @更新时间 `2024-07-16 11:05:34`
 */
export interface GoPcmSeoJavaSeoAskQueryHotAskRandomRequest {}

/**
 * 接口 [热门回答（随机查询30条）↗](https://yapi.yuewen.com/project/3297/interface/api/288842) 的 **返回类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotAskRandom`
 * @更新时间 `2024-07-16 11:05:34`
 */
export type GoPcmSeoJavaSeoAskQueryHotAskRandomResponse = {
  /**
   * 4675872
   */
  aid?: number;
  /**
   * "Who is Chu Yang?"
   */
  title?: string;
  desc?: null;
  /**
   * 1
   */
  answerCount?: number;
  showTime?: null;
}[];

/**
 * 接口 [热门回答（随机查询30条）↗](https://yapi.yuewen.com/project/3297/interface/api/288842) 的 **请求配置的类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotAskRandom`
 * @更新时间 `2024-07-16 11:05:34`
 */
type GoPcmSeoJavaSeoAskQueryHotAskRandomRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/java/seo/ask/queryHotAskRandom",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [热门回答（随机查询30条）↗](https://yapi.yuewen.com/project/3297/interface/api/288842) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotAskRandom`
 * @更新时间 `2024-07-16 11:05:34`
 */
const goPcmSeoJavaSeoAskQueryHotAskRandomRequestConfig: GoPcmSeoJavaSeoAskQueryHotAskRandomRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryHotAskRandom",
    method: Method.POST,
    requestHeaders: { Accept: "*/*" },
    requestBodyType: RequestBodyType.raw,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryHotAskRandom",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [热门回答（随机查询30条）↗](https://yapi.yuewen.com/project/3297/interface/api/288842) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotAskRandom`
 * @更新时间 `2024-07-16 11:05:34`
 */
export const goPcmSeoJavaSeoAskQueryHotAskRandom = /*#__PURE__*/ (
  requestData?: GoPcmSeoJavaSeoAskQueryHotAskRandomRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoJavaSeoAskQueryHotAskRandomResponse>(
    prepare(goPcmSeoJavaSeoAskQueryHotAskRandomRequestConfig, requestData),
    ...args
  );
};

goPcmSeoJavaSeoAskQueryHotAskRandom.requestConfig =
  goPcmSeoJavaSeoAskQueryHotAskRandomRequestConfig;

/**
 * 接口 [话题列表A-Z & 最新搜索↗](https://yapi.yuewen.com/project/3297/interface/api/288845) 的 **请求类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicList`
 * @更新时间 `2024-07-16 11:05:42`
 */
export interface GoPcmSeoJavaSeoAskQueryTopicListRequest {
  /**
   * 首字母，可不传
   */
  initials?: string;
  pageNo?: string;
  pageSize?: string;
}

/**
 * 接口 [话题列表A-Z & 最新搜索↗](https://yapi.yuewen.com/project/3297/interface/api/288845) 的 **返回类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicList`
 * @更新时间 `2024-07-16 11:05:42`
 */
export interface GoPcmSeoJavaSeoAskQueryTopicListResponse {
  /**
   * 219
   */
  total?: number;
  /**
   * 1
   */
  pageNum?: number;
  /**
   * 20
   */
  pageSize?: number;
  /**
   * [{"topicId":1810271431631184000,"topic":"adaptability"},{"topicId":1810271431626989600,"topic":"anotida"},{"topicId":1810271431626989600,"topic":"ask ketchum"},{"topicId":1810271431626989600,"topic":"after the gane"},{"topicId":1810271431626989600,"topic":"a core ship"},{"topicId":1810271431622795300,"topic":"a system pov"},{"topicId":1810271431618601000,"topic":"anime sistem"},{"topicId":1810271431522132000,"topic":"angela wilson"},{"topicId":1810271431517937700,"topic":"aspirations"},{"topicId":1810271431517937700,"topic":"anak sma Dan om"},{"topicId":1810271431442440200,"topic":"a way to protect the heroine"},{"topicId":1810271431434051600,"topic":"attack of the wolf of winter"},{"topicId":1810271431434051600,"topic":"Ashnight"},{"topicId":1810271431350165500,"topic":"aizen harry potter"},{"topicId":1810271431350165500,"topic":"Admiral in the Marvel Universe"},{"topicId":1810271431345971200,"topic":"adult romantic"},{"topicId":1810271431345971200,"topic":"advent archmage"},{"topicId":1810271431345971200,"topic":"assassin in blade"},{"topicId":1810271431345971200,"topic":"asam"},{"topicId":1810271431341777000,"topic":"abbysal awakening"}]
   */
  data?: {
    /**
     * 1810271431631184000
     */
    topicId?: number;
    /**
     * "adaptability"
     */
    topic?: string;
  }[];
}

/**
 * 接口 [话题列表A-Z & 最新搜索↗](https://yapi.yuewen.com/project/3297/interface/api/288845) 的 **请求配置的类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicList`
 * @更新时间 `2024-07-16 11:05:42`
 */
type GoPcmSeoJavaSeoAskQueryTopicListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/java/seo/ask/queryTopicList",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [话题列表A-Z & 最新搜索↗](https://yapi.yuewen.com/project/3297/interface/api/288845) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicList`
 * @更新时间 `2024-07-16 11:05:42`
 */
const goPcmSeoJavaSeoAskQueryTopicListRequestConfig: GoPcmSeoJavaSeoAskQueryTopicListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryTopicList",
    method: Method.POST,
    requestHeaders: { Accept: "*/*" },
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryTopicList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [话题列表A-Z & 最新搜索↗](https://yapi.yuewen.com/project/3297/interface/api/288845) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicList`
 * @更新时间 `2024-07-16 11:05:42`
 */
export const goPcmSeoJavaSeoAskQueryTopicList = /*#__PURE__*/ (
  requestData: GoPcmSeoJavaSeoAskQueryTopicListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoJavaSeoAskQueryTopicListResponse>(
    prepare(goPcmSeoJavaSeoAskQueryTopicListRequestConfig, requestData),
    ...args
  );
};

goPcmSeoJavaSeoAskQueryTopicList.requestConfig =
  goPcmSeoJavaSeoAskQueryTopicListRequestConfig;

/**
 * 接口 [根据topicId查询列表（话题详情页）↗](https://yapi.yuewen.com/project/3297/interface/api/289088) 的 **请求类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicAskList`
 * @更新时间 `2024-10-10 15:35:24`
 */
export interface GoPcmSeoJavaSeoAskQueryTopicAskListRequest {
  /**
   * 页码
   */
  pageNo?: number;
  /**
   * 页面大小
   */
  pageSize?: number;
  /**
   * 话题id
   */
  topicId?: string;
  /**
   * 是否展示回答内容，0:不展示，1展示
   */
  isShow?: number;
}

/**
 * 接口 [根据topicId查询列表（话题详情页）↗](https://yapi.yuewen.com/project/3297/interface/api/289088) 的 **返回类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicAskList`
 * @更新时间 `2024-10-10 15:35:24`
 */
export interface GoPcmSeoJavaSeoAskQueryTopicAskListResponse {
  topicInfo?: {
    /**
     * 71
     */
    topicId?: number;
    /**
     * "just wants to live"
     */
    topic?: string;
  };
  /**
   * [{"askInfo":{"aid":82062549958656,"title":"How to start a live broadcast game in the classic version of the perfect world","desc":null,"answerCount":1,"showTime":"2024-07-16T03:31:21.693+00:00"},"answerInfos":[{"answerId":2246,"aid":82062549958656,"marked":null,"text":"To start streaming the game Perfect World Classic, you can follow the steps below:\n\n1. First of all, make sure you have installed the game client and successfully logged in to your account.\n2. Open the streaming platform you want to use, such as Huya Streaming.\n3. On the live streaming platform, find and click the \"Start Stream\" or similar button.\n4. In the pop-up window, select Perfect World Classic as the game you want to stream.\n5. You can set your live broadcast settings, such as setting the live broadcast title, choosing the live broadcast screen layout, etc.\n6. After confirming the settings, he clicked the \" Start Live Stream \" button.\n7. You can interact with the audience and answer questions during the live broadcast.\n\nPlease note that a stable network connection and appropriate equipment configuration are required to start a livestream game to ensure a smooth livestream experience. In addition, you can also use some live streaming tools and special effects during the live streaming process to increase the fun and entertainment of the live streaming.\n\nPlease note that the above steps are for reference only. The specific operation may vary according to the streaming platform and game version. It is recommended that you consult the relevant streaming platforms and game official documents before you start the actual operation to obtain more accurate guidance.","showTime":"2024-07-16T13:05:35.000+00:00"}]},{"askInfo":{"aid":83193728581632,"title":"The movie that Yang Chaoyue wants to shoot in 2024","desc":null,"answerCount":1,"showTime":"2024-07-16T03:07:14.933+00:00"},"answerInfos":[{"answerId":4159,"aid":83193728581632,"marked":null,"text":"In 2024, Yang Chaoyue would be filming a TV series called \" If Running is My Life.\" The drama revolved around the career, love, and life experiences of two young women. The main actors included Zhong Chuxi and Yang Chaoyue. The drama was expected to be aired in 2024 and was expected to become a popular show in 2024.","showTime":null}]},{"askInfo":{"aid":82598489735168,"title":"What are the three seeds in the Holy Ground?","desc":null,"answerCount":1,"showTime":"2024-07-16T03:38:46.000+00:00"},"answerInfos":[{"answerId":3101,"aid":82598489735168,"marked":null,"text":"There was no clear explanation for the specific identity and origin of the three seeds in the Holy Ground. There were some speculations that these seeds might be related to the Heaven Covering Trio. They were refined by Huang Tiandi when they were on the verge of death, and he used the Heaven-Defying Coffin to save his life and wait for resurrection. There was also a theory that these seeds might have been shriveled seeds that Chu Feng had picked up from a stone box at the foot of Mount Kunlun. One of the seeds had germinated and helped Chu Feng evolve. However, these were just guesses and speculations. There was no conclusive evidence to prove the specific identity and origin of the seed. Therefore, there was no clear answer as to what the three seeds in the Holy Ground were.","showTime":"2024-07-16T09:15:19.000+00:00"}]},{"askInfo":{"aid":82052093558784,"title":"What Element did the full-time Mage Lingling awaken?","desc":null,"answerCount":1,"showTime":"2024-07-16T03:38:40.000+00:00"},"answerInfos":[{"answerId":2204,"aid":82052093558784,"marked":null,"text":"In \" Full-time Wizard,\" Lingling had awakened the Light Element. Lingling was supposed to awaken the Lightning Element, but for some reason, she had awakened the Light Element. Light skills displayed powerful healing abilities and could provide important healing support to teammates.","showTime":"2024-07-16T13:24:57.000+00:00"}]},{"askInfo":{"aid":81812888207360,"title":"What songs are there in Grave Robber's Chronicles?","desc":null,"answerCount":1,"showTime":"2024-07-16T03:38:19.000+00:00"},"answerInfos":[{"answerId":1791,"aid":81812888207360,"marked":null,"text":"There were the following songs in the restart of Grave Robber's Chronicles: Never Let Go, Ten Years of Humanity, Endless Humanity, Zhang Qi Ling's Immortal, Desert Sutra of the Sand Sea, Rang Wine, Old Nine Gates of the Soul Return Gate, Prison Department, Doujinshi's Step Play, Ci Nine Gates Memories, Restart Infinity, and Restart Extreme Sea Listening to Thunder.","showTime":"2024-07-16T13:03:46.000+00:00"}]},{"askInfo":{"aid":82599441842176,"title":"Is there any secret in the perfect world's spirit world?","desc":null,"answerCount":1,"showTime":"2024-07-16T03:38:18.000+00:00"},"answerInfos":[{"answerId":3150,"aid":82599441842176,"marked":null,"text":"The spirit world in the perfect world was described as a world without hidden secrets. The Void God Realm was the true prison, used to imprison the undyings of the other realms. Therefore, according to the information provided, the Spiritual Realm did not seem to have any specific secrets.","showTime":"2024-07-16T10:53:10.000+00:00"}]},{"askInfo":{"aid":82656186580992,"title":"Which came out first, Perfect World or Covering the Sky?","desc":null,"answerCount":1,"showTime":"2024-07-16T03:38:10.000+00:00"},"answerInfos":[{"answerId":3240,"aid":82656186580992,"marked":null,"text":"\"Covering the Sky\" was published before \"Perfect World.\"","showTime":"2024-07-16T12:43:08.000+00:00"}]},{"askInfo":{"aid":81389955563520,"title":"One thought is eternal, what is the next sentence?","desc":null,"answerCount":1,"showTime":"2024-07-16T03:37:50.000+00:00"},"answerInfos":[{"answerId":1047,"aid":81389955563520,"marked":null,"text":"There was no next sentence. The meaning of this sentence was that even an instant was eternal. A single thought could turn the sea into the sea, and a single thought could turn the mulberry fields into mulberry fields. One thought could kill thousands of demons, and one thought could kill tens of thousands of immortals.","showTime":"2024-07-16T13:10:47.000+00:00"}]},{"askInfo":{"aid":82611777290240,"title":"Perfect World mobile game, how to do the Vengeful Spirit Seed mission?","desc":null,"answerCount":1,"showTime":"2024-07-16T03:37:44.000+00:00"},"answerInfos":[{"answerId":3113,"aid":82611777290240,"marked":null,"text":"In the Perfect World mobile game, to complete the Seed of the Vengeful Spirit mission, one had to follow the mission guide to Dream Seeking Harbor and search for the Seed of the Vengeful Spirit on the top of the mountain or building. The vengeful spirit seed was red and would respawn after a period of time. The player needs to collect 5 vengeful spirit seeds, and then click on the quest to automatically find the way to hand over the quest. After completing the mission, you can obtain 4 Forging Spirit Stones as a reward for equipment forging. Please note that the location of the vengeful spirit seed may change. You need to observe and search carefully.","showTime":"2024-07-16T08:57:45.000+00:00"}]},{"askInfo":{"aid":81960099889152,"title":"Covering the sky Ye Fan modeling, is it Yang Yang?","desc":null,"answerCount":1,"showTime":"2024-07-16T03:37:37.000+00:00"},"answerInfos":[{"answerId":1993,"aid":81960099889152,"marked":null,"text":"Heaven Covering Ye Fan's modeling was similar to Yang Yang's. Some viewers thought that Ye Fan's model looked like Yang Yang, while others said that Ye Fan's model looked a little like Yang Yang. However, these search results did not provide conclusive evidence to prove that Ye Fan's model was based on Yang Yang. Therefore, it was impossible to determine if the model of Heaven Covering Ye Fan was Yang Yang.","showTime":"2024-07-16T13:18:00.000+00:00"}]}]
   */
  askInfos?: {
    askInfo?: {
      /**
       * 82062549958656
       */
      aid?: number;
      /**
       * "How to start a live broadcast game in the classic version of the perfect world"
       */
      title?: string;
      desc?: null;
      /**
       * 1
       */
      answerCount?: number;
      /**
       * "2024-07-16T03:31:21.693+00:00"
       */
      showTime?: string;
    };
    /**
     * [{"answerId":2246,"aid":82062549958656,"marked":null,"text":"To start streaming the game Perfect World Classic, you can follow the steps below:\n\n1. First of all, make sure you have installed the game client and successfully logged in to your account.\n2. Open the streaming platform you want to use, such as Huya Streaming.\n3. On the live streaming platform, find and click the \"Start Stream\" or similar button.\n4. In the pop-up window, select Perfect World Classic as the game you want to stream.\n5. You can set your live broadcast settings, such as setting the live broadcast title, choosing the live broadcast screen layout, etc.\n6. After confirming the settings, he clicked the \" Start Live Stream \" button.\n7. You can interact with the audience and answer questions during the live broadcast.\n\nPlease note that a stable network connection and appropriate equipment configuration are required to start a livestream game to ensure a smooth livestream experience. In addition, you can also use some live streaming tools and special effects during the live streaming process to increase the fun and entertainment of the live streaming.\n\nPlease note that the above steps are for reference only. The specific operation may vary according to the streaming platform and game version. It is recommended that you consult the relevant streaming platforms and game official documents before you start the actual operation to obtain more accurate guidance.","showTime":"2024-07-16T13:05:35.000+00:00"}]
     */
    answerInfos?: {
      /**
       * 2246
       */
      answerId?: number;
      /**
       * 82062549958656
       */
      aid?: number;
      marked?: null;
      /**
       * "To start streaming the game Perfect World Classic, you can follow the steps below:\n\n1. First of all, make sure you have installed the game client and successfully logged in to your account.\n2. Open the streaming platform you want to use, such as Huya Streaming.\n3. On the live streaming platform, find and click the \"Start Stream\" or similar button.\n4. In the pop-up window, select Perfect World Classic as the game you want to stream.\n5. You can set your live broadcast settings, such as setting the live broadcast title, choosing the live broadcast screen layout, etc.\n6. After confirming the settings, he clicked the \" Start Live Stream \" button.\n7. You can interact with the audience and answer questions during the live broadcast.\n\nPlease note that a stable network connection and appropriate equipment configuration are required to start a livestream game to ensure a smooth livestream experience. In addition, you can also use some live streaming tools and special effects during the live streaming process to increase the fun and entertainment of the live streaming.\n\nPlease note that the above steps are for reference only. The specific operation may vary according to the streaming platform and game version. It is recommended that you consult the relevant streaming platforms and game official documents before you start the actual operation to obtain more accurate guidance."
       */
      text?: string;
      /**
       * "2024-07-16T13:05:35.000+00:00"
       */
      showTime?: string;
    }[];
  }[];
}

/**
 * 接口 [根据topicId查询列表（话题详情页）↗](https://yapi.yuewen.com/project/3297/interface/api/289088) 的 **请求配置的类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicAskList`
 * @更新时间 `2024-10-10 15:35:24`
 */
type GoPcmSeoJavaSeoAskQueryTopicAskListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/java/seo/ask/queryTopicAskList",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [根据topicId查询列表（话题详情页）↗](https://yapi.yuewen.com/project/3297/interface/api/289088) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicAskList`
 * @更新时间 `2024-10-10 15:35:24`
 */
const goPcmSeoJavaSeoAskQueryTopicAskListRequestConfig: GoPcmSeoJavaSeoAskQueryTopicAskListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryTopicAskList",
    method: Method.POST,
    requestHeaders: { Accept: "*/*" },
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryTopicAskList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据topicId查询列表（话题详情页）↗](https://yapi.yuewen.com/project/3297/interface/api/289088) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicAskList`
 * @更新时间 `2024-10-10 15:35:24`
 */
export const goPcmSeoJavaSeoAskQueryTopicAskList = /*#__PURE__*/ (
  requestData: GoPcmSeoJavaSeoAskQueryTopicAskListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoJavaSeoAskQueryTopicAskListResponse>(
    prepare(goPcmSeoJavaSeoAskQueryTopicAskListRequestConfig, requestData),
    ...args
  );
};

goPcmSeoJavaSeoAskQueryTopicAskList.requestConfig =
  goPcmSeoJavaSeoAskQueryTopicAskListRequestConfig;

/**
 * 接口 [查询回答详情↗](https://yapi.yuewen.com/project/3297/interface/api/289091) 的 **请求类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAnswerInfo`
 * @更新时间 `2024-07-16 11:05:58`
 */
export interface GoPcmSeoJavaSeoAskQueryAnswerInfoRequest {
  /**
   * 答案id
   */
  answerId: string;
}

/**
 * 接口 [查询回答详情↗](https://yapi.yuewen.com/project/3297/interface/api/289091) 的 **返回类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAnswerInfo`
 * @更新时间 `2024-07-16 11:05:58`
 */
export interface GoPcmSeoJavaSeoAskQueryAnswerInfoResponse {
  askInfo?: {
    /**
     * 4675987
     */
    aid?: number;
    /**
     * "Which app can I listen to Lanke Chess for free?"
     */
    title?: string;
    /**
     * "jkashdjkashjdkljklqwjdqwdq"
     */
    desc?: string;
    /**
     * 1
     */
    answerCount?: number;
    /**
     * 1720681716125
     */
    showTime?: number;
  };
  /**
   * [{"answerId":14,"aid":4675987,"marked":null,"text":"Lanke Chess can be listened to for free on the Qidian Reading App.","showTime":1720681716125},{"answerId":145,"aid":467598127,"marked":true,"text":"111111111Lanke Chess can be listened to for free on the Qidian Reading App.","showTime":1720681716125},{"answerId":122,"aid":4672235987,"marked":null,"text":"Lanke Chess can be listened to for free on the Qidian Reading App.","showTime":1720681716125},{"answerId":924,"aid":2975987,"marked":null,"text":"Lanke Chess can be listened to for free on the Qidian Reading App.","showTime":1720681716125}]
   */
  answerInfos?: {
    /**
     * 14
     */
    answerId?: number;
    /**
     * 4675987
     */
    aid?: number;
    marked?: null;
    /**
     * "Lanke Chess can be listened to for free on the Qidian Reading App."
     */
    text?: string;
    /**
     * 1720681716125
     */
    showTime?: number;
  }[];
}

/**
 * 接口 [查询回答详情↗](https://yapi.yuewen.com/project/3297/interface/api/289091) 的 **请求配置的类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAnswerInfo`
 * @更新时间 `2024-07-16 11:05:58`
 */
type GoPcmSeoJavaSeoAskQueryAnswerInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/java/seo/ask/queryAnswerInfo",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [查询回答详情↗](https://yapi.yuewen.com/project/3297/interface/api/289091) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAnswerInfo`
 * @更新时间 `2024-07-16 11:05:58`
 */
const goPcmSeoJavaSeoAskQueryAnswerInfoRequestConfig: GoPcmSeoJavaSeoAskQueryAnswerInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryAnswerInfo",
    method: Method.POST,
    requestHeaders: { Accept: "*/*" },
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryAnswerInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询回答详情↗](https://yapi.yuewen.com/project/3297/interface/api/289091) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAnswerInfo`
 * @更新时间 `2024-07-16 11:05:58`
 */
export const goPcmSeoJavaSeoAskQueryAnswerInfo = /*#__PURE__*/ (
  requestData: GoPcmSeoJavaSeoAskQueryAnswerInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoJavaSeoAskQueryAnswerInfoResponse>(
    prepare(goPcmSeoJavaSeoAskQueryAnswerInfoRequestConfig, requestData),
    ...args
  );
};

goPcmSeoJavaSeoAskQueryAnswerInfo.requestConfig =
  goPcmSeoJavaSeoAskQueryAnswerInfoRequestConfig;

/**
 * 接口 [热门话题A-Z（随机展示）↗](https://yapi.yuewen.com/project/3297/interface/api/289100) 的 **请求类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotTopic`
 * @更新时间 `2024-07-16 11:06:05`
 */
export interface GoPcmSeoJavaSeoAskQueryHotTopicRequest {
  pageNo?: string;
  pageSize?: string;
}

/**
 * 接口 [热门话题A-Z（随机展示）↗](https://yapi.yuewen.com/project/3297/interface/api/289100) 的 **返回类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotTopic`
 * @更新时间 `2024-07-16 11:06:05`
 */
export type GoPcmSeoJavaSeoAskQueryHotTopicResponse = {
  /**
   * "#"
   */
  initials?: string;
  /**
   * [{"topicId":954,"topic":"10 billones"},{"topicId":554,"topic":"18 my mother in law"},{"topicId":914,"topic":"4 r18"},{"topicId":682,"topic":"500 years ago"},{"topicId":1481,"topic":"1 year before apocalypse"},{"topicId":1428,"topic":"16 wings dxd"},{"topicId":1548,"topic":"18 donghua"},{"topicId":1520,"topic":"18 pregnant"},{"topicId":1376,"topic":"18 short stories trap"},{"topicId":1459,"topic":"18manga"},{"topicId":1215,"topic":"30k"},{"topicId":1122,"topic":"6 times a day"},{"topicId":1338,"topic":"7 princesses"},{"topicId":1608,"topic":"7 kaka"},{"topicId":2037,"topic":"10 Shadows"},{"topicId":1858,"topic":"100 apocalypse"},{"topicId":2185,"topic":"100 skeleton"},{"topicId":1936,"topic":"17 year old assassin"},{"topicId":2025,"topic":"172 days"},{"topicId":1748,"topic":"18 adult stories"},{"topicId":1938,"topic":"18 anime syories"},{"topicId":1976,"topic":"19 days"},{"topicId":2109,"topic":"19s"},{"topicId":2092,"topic":"21 warning"},{"topicId":1627,"topic":"24 extra hours a day"},{"topicId":2220,"topic":"48 laws of power"},{"topicId":1907,"topic":"7th time loop 3"},{"topicId":2093,"topic":"7th Time Loop Volume 5"},{"topicId":2053,"topic":"99 Times Training System"},{"topicId":2507,"topic":"10 dead"}]
   */
  topicList?: {
    /**
     * 954
     */
    topicId?: number;
    /**
     * "10 billones"
     */
    topic?: string;
  }[];
}[];

/**
 * 接口 [热门话题A-Z（随机展示）↗](https://yapi.yuewen.com/project/3297/interface/api/289100) 的 **请求配置的类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotTopic`
 * @更新时间 `2024-07-16 11:06:05`
 */
type GoPcmSeoJavaSeoAskQueryHotTopicRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/java/seo/ask/queryHotTopic",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [热门话题A-Z（随机展示）↗](https://yapi.yuewen.com/project/3297/interface/api/289100) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotTopic`
 * @更新时间 `2024-07-16 11:06:05`
 */
const goPcmSeoJavaSeoAskQueryHotTopicRequestConfig: GoPcmSeoJavaSeoAskQueryHotTopicRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryHotTopic",
    method: Method.POST,
    requestHeaders: { Accept: "*/*" },
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryHotTopic",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [热门话题A-Z（随机展示）↗](https://yapi.yuewen.com/project/3297/interface/api/289100) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotTopic`
 * @更新时间 `2024-07-16 11:06:05`
 */
export const goPcmSeoJavaSeoAskQueryHotTopic = /*#__PURE__*/ (
  requestData: GoPcmSeoJavaSeoAskQueryHotTopicRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoJavaSeoAskQueryHotTopicResponse>(
    prepare(goPcmSeoJavaSeoAskQueryHotTopicRequestConfig, requestData),
    ...args
  );
};

goPcmSeoJavaSeoAskQueryHotTopic.requestConfig =
  goPcmSeoJavaSeoAskQueryHotTopicRequestConfig;

/**
 * 接口 [搜索相关话题↗](https://yapi.yuewen.com/project/3297/interface/api/289216) 的 **请求类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationTopicList`
 * @更新时间 `2024-07-16 11:07:26`
 */
export interface GoPcmSeoJavaSeoAskQueryRelationTopicListRequest {
  /**
   * 话题id
   */
  topicId: number;
}

/**
 * 接口 [搜索相关话题↗](https://yapi.yuewen.com/project/3297/interface/api/289216) 的 **返回类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationTopicList`
 * @更新时间 `2024-07-16 11:07:26`
 */
export type GoPcmSeoJavaSeoAskQueryRelationTopicListResponse = {
  /**
   * 144
   */
  topicId?: number;
  /**
   * "Vaegon"
   */
  topic?: string;
}[];

/**
 * 接口 [搜索相关话题↗](https://yapi.yuewen.com/project/3297/interface/api/289216) 的 **请求配置的类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationTopicList`
 * @更新时间 `2024-07-16 11:07:26`
 */
type GoPcmSeoJavaSeoAskQueryRelationTopicListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/java/seo/ask/queryRelationTopicList",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [搜索相关话题↗](https://yapi.yuewen.com/project/3297/interface/api/289216) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationTopicList`
 * @更新时间 `2024-07-16 11:07:26`
 */
const goPcmSeoJavaSeoAskQueryRelationTopicListRequestConfig: GoPcmSeoJavaSeoAskQueryRelationTopicListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryRelationTopicList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryRelationTopicList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [搜索相关话题↗](https://yapi.yuewen.com/project/3297/interface/api/289216) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationTopicList`
 * @更新时间 `2024-07-16 11:07:26`
 */
export const goPcmSeoJavaSeoAskQueryRelationTopicList = /*#__PURE__*/ (
  requestData: GoPcmSeoJavaSeoAskQueryRelationTopicListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoJavaSeoAskQueryRelationTopicListResponse>(
    prepare(goPcmSeoJavaSeoAskQueryRelationTopicListRequestConfig, requestData),
    ...args
  );
};

goPcmSeoJavaSeoAskQueryRelationTopicList.requestConfig =
  goPcmSeoJavaSeoAskQueryRelationTopicListRequestConfig;

/**
 * 接口 [搜索相关书信息↗](https://yapi.yuewen.com/project/3297/interface/api/294701) 的 **请求类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationBook`
 * @更新时间 `2024-10-31 15:51:13`
 */
export interface GoPcmSeoJavaSeoAskQueryRelationBookRequest {
  /**
   * "keyword"
   */
  keyword?: string;
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 20
   */
  pageSize?: number;
}

/**
 * 接口 [搜索相关书信息↗](https://yapi.yuewen.com/project/3297/interface/api/294701) 的 **返回类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationBook`
 * @更新时间 `2024-10-31 15:51:13`
 */
export interface GoPcmSeoJavaSeoAskQueryRelationBookResponse {
  /**
   * [{"bookId":"18117680306472805","bookName":"hidden","authorName":"MiaBella_Morgan","authorId":"18108596505238701","description":"","pvNum":8388,"bookType":0,"categoryType":5,"categoryId":70016,"categoryName":"Fantasy Romance","coverId":1729694200016,"chapterCnt":6,"firstChapterId":"48634300379224198","lastChapterId":"48990197458730976","lastChapterName":"Chapter 6 and the end","lastChapterTime":1602553657000},{"bookId":"19977889406331605","bookName":"The Hidden Wife Of The Cold CEO","authorName":"Paschalinelily","authorId":"12176774806710201","description":"What happens when a Powerful CEO in the Fashion World who already promised to marry his girlfriend, is forced to marry a woman from a lowly family, compared to his high-esteemed family background, against his wish?\r\n\r\nFu Hua, a well-known name in the fashion industry is forced to get married to a woman by the name, Jia Li, who was far below his level by his Grandfather, who nobody in his family dared to go against, including him.\r\n\r\nAlong the line, something happened and Fu Hua had to accept the marriage, but with conditions.\r\n\r\nBut what happens when Jia consummates her marriage with Fu Hua and gives him a little bun in return? What happens When her Husband discovers her hidden talent, will he slowly start to fall for her? But what if Jia Li discovers that Fu Hua had always had his eyes on her since the first time they met, what would be her reaction?\r\n\r\n*****************\r\n\r\nFu Hua calls Jia Li over the phone to help him fold his clothes, and Jia Li went into his bedroom to assist him while thinking he wasn't there.\r\nJia Li entered his bedroom and closed the door without looking behind her. She had only walked a few steps only to hear the door lock behind her.\r\nShe was a little frightened when she looked behind and saw Fu Hua staring at her with a smile.\r\n\"How did you... Have you been here?\" She asked in shock.\r\n\"Are you scared?.\" Fu Hua asked as he made his way towards her with a dangerous smile.\r\nThe end game was that the innocent Jia Li was eaten clean by the hungry wolf.\r\n\r\nBook cover commissioned by, Artist Laylee\r\n\r\nFollow me on\r\nInstagram: @authorpaschalinelily\r\nJoin my discord server to get firsthand information...\r\nhttps://discord.gg/GywPN7X","pvNum":13778611,"bookType":0,"categoryType":5,"categoryId":70014,"categoryName":"Contemporary Romance","coverId":1713174156776,"chapterCnt":790,"firstChapterId":"53627869070424987","lastChapterId":"62805959436722554","lastChapterName":"The most Jealous husband of the century","lastChapterTime":1654012039000},{"bookId":"10260480905004505","bookName":"Punished by his hidden love","authorName":"Baby Piggie","authorId":"3727900004073501","description":"Seven years ago, after their breakup, he disappeared without a trace.\r\nNow, he reappeared on the eve of her wedding, sparing no means in forcing her to marry him… \r\nWith a certificate of marriage, he bound her mercilessly to his side. \r\nFrom there, this “Cinderella” began her journey as a wife of the business empire’s heir...\r\nMrs Huo - composed, sharp-tongued, and freakishly smart.\r\nMr Qin - wife-spoiler to no end and a complete “slave” to their daughter.\r\nQuality love story, one on one. You are welcome to get hooked on this story with us. \r\n———————————\r\nTL's Note: Probably one of the best stories I've read, and I was very tempted to translate the title to Big D Brings Spring. Girls, I hope you enjoyed it as much as my girlfriend and my female translators who binge read 4000 chapters in about a month. \r\nFor all the guys hesitating to give it a try, you won't regret it. It's a manly book, I swear.","pvNum":103929357,"bookType":0,"categoryType":5,"categoryId":70014,"categoryName":"Contemporary Romance","coverId":1717039082347,"chapterCnt":4928,"firstChapterId":"27657137597504305","lastChapterId":"57883936293963627","lastChapterName":"In The Remaining Lifetime (108)","lastChapterTime":1644674400000},{"bookId":"22425973105143805","bookName":"Hidden identities of the AI Heiress","authorName":"Chord Knows Elegance","authorId":"12050038603190101","description":"Joven, an AI that transmigrated here from the stars became a daughter of a rich family, lost in a rural village but finally returning home for a certain purpose. \r\n\r\nEveryone thought that she would be unrefined and lack culture given her poor upbringing... until the eldest Lu brother realized that his youngest sister was the one who casually agreed to the contract he just signed. \r\n\r\nSecond Lu Brother: What? My younger sister invested in the movie I was leading? \r\n\r\nMama Lu: The unlabeled products my daughter gave me are from a state-of-art research center? \r\n\r\nPapa Lu: The cheap stuff my daughter gave me is actually worth millions?! \r\n\r\nBig shots of various industries: Would you like to be an instructor? The type who earns over hundreds of millions? \r\n\r\nA certain conglomerate: Had enough fun yet? Now get back here and inherit your billion-dollar estate. \r\n\r\nScumbags: Weren't we promised a pathetic wimp to bully? \r\n\r\n*** \r\n\r\nThe day Li Hanzhou learned that Qiao Wen equaled him in net worth, he made inventory and put everything before her. \"You can have all of these—plus one husband! Please sign here.\" \r\n\r\nQiao Wen: \"You're the one who insisted on no puppy-love. It's important to keep your promises.\" \r\n\r\nMr. Li: #Urgent! How do I go back in time to slap my past self? \r\nI'll make it up to you with all the tenderness in the world.","pvNum":767172,"bookType":0,"categoryType":5,"categoryId":70014,"categoryName":"Contemporary Romance","coverId":1726217010465,"chapterCnt":128,"firstChapterId":"73190415922157991","lastChapterId":"81928593625641828","lastChapterName":"Chapter 128: Are You Going to Shock Everyone?","lastChapterTime":1730340000000},{"bookId":"20654204006628105","bookName":"The Alpha's Hidden Lover","authorName":"DrAxy66","authorId":"20654094706338601","description":"[Warning: Mature content 18+, BL, Omegaverse]\r\n\r\nClyde Aldric would have ascended his throne as the CEO of his family's billion dollars company if it weren't for a Beta falling into his arms begging for a help. \r\n\r\nBorn to a distinguished elite Alpha family as the only surviving male heir, the grave mistake he committed that night with a Beta earned him nothing but a great danger to his own future…\r\n\r\nHowever, amidst his hazy vision Clyde found that he wasn't taking any ordinary person to his bed... \r\n\r\nThat golden hair and honey-like eyes…. They sparked the flame of rebellion within his heart! \r\n\r\nWith enemies lurking in the dark trying to prevent him from inheriting the Falcon throne, it wasn't time for him to play around.\r\n\r\nHe should be looking for a powerful Alpha female as a mate, but why couldn't he forget that Beta?\r\n\r\nHis sweet smell, his burning skin, his anger, his dangerous mind... Clyde wanted it all!\r\n\r\nNow that there’s no going back for everything that happened between them, would he risk his life and everything to keep the fire that continued to burn his passion?\r\n\r\n***\r\n\r\nRyley was wrong to think that being kind and forgiving would ensure his safety in the modeling world.\r\n\r\nHis sister called him out of the blue, the blond agreed to have a dinner with her thinking it would be a sweet family reunion.\r\n\r\nBut who would have thought that he would find himself waking up in a strange hotel room with all his limbs going numb and someone he didn't know climbing on him!\r\n\r\nRyley struggled to escape, and once he managed to get past the door, he unknowingly fell into an Alpha's embrace.\r\n\r\nAll he could remember from that time was how fate pushed them into a bittersweet journey to reveal the truth...\r\n\r\nHe had a secret about his real identity that he had to guard tight especially from Alphas, yet he needed that Alpha to get back at people who hurt him.\r\n\r\nWhat should he do? \r\n\r\n***\r\n\r\nTags: Action, Drama, Revenge, Conspiracy, Mystery, Superpower\r\n\r\nGet ready to be entangled in the threads of conspiracy, intrigues and betrayals, also a journey of two mortal enemies trying to fight the dire fate that the world forced upon them!\r\n\r\n***\r\n Join my discord server: https://discord.gg/JU3XsnJzpS\r\n\r\n*Thank you for reading!*","pvNum":1717075,"bookType":0,"categoryType":5,"categoryId":70019,"categoryName":"LGBT+","coverId":1689261657546,"chapterCnt":977,"firstChapterId":"55443224239592189","lastChapterId":"81892037011497010","lastChapterName":"Chapter 970 - Unsettling, Bizarre Encounters","lastChapterTime":1725120600000},{"bookId":"16647059805685805","bookName":"Hidden Hallows","authorName":"Blissfullrage","authorId":"11028982905309401","description":"Eris Hallows isn't your normal witch. She has a secret that she guards with her life but when a series of events take place in her Super Natural Investigation case, She finds herself stuck between the Alpha Shifter and head Vampire in her town as the mysterious case grows deeper and deeper. Can she avoid the two? Or will she end up between the two and between the sheets? Follow along with Eris as she navigates through her life while keeping herself away from the tempting men that keep popping up. \r\n\r\n\r\nWanna talk? Find me on Discord! Blissfullrage#3336\r\n___________________________________\r\n\r\nWould like to donate?\r\nCash App $Blissfullrage \r\n\r\n\r\nThe cover art does not belong to me, all credit to the original artist.","pvNum":1084106,"bookType":0,"categoryType":5,"categoryId":70016,"categoryName":"Fantasy Romance","coverId":1713950319485,"chapterCnt":171,"firstChapterId":"44686682640927858","lastChapterId":"48253502673181349","lastChapterName":"Here I Am","lastChapterTime":1599803132000},{"bookId":"16005310005643505","bookName":"My Hidden Wife is Sweet","authorName":"Helan Yang Yang","authorId":"3195577400545201","description":"Gu Weiwei, the adopted daughter of the most wealthy and powerful Gu Family in A Land, is seriously injured during an attack. Her best friend, Ling Yan, who has been suffering from a heart disease, takes this opportunity to kill Gu Weiwei and snatches her heart for her own transplant surgery.\r\n Unexpectedly, however, Gu Weiwei is reborn and became Mu Weiwei, the adopted daughter of the most wealthy and powerful Fu Family in Hua Land and somehow ends up having a one-night-stand with the heir Fu Hanzheng. \r\nFrom that night on, strange things start to happen. Firstly, Fu Hanzheng, who has no interest in any women, especially not in the noisy young Mu Weiwei, suddenly falls for Mu Weiwei—who now has Gu Weiwei’s soul inside. \r\nGu Weiwei decides to take this second chance of life as a precious opportunity to take revenge for both Mu Weiwei and for herself. \r\nSubsequently, Gu Weiwei uses her own talents and skills and becomes the most popular and beloved movie star in the entire world using Mu Weiwei’s body and successfully crushes all her enemies. \r\nMeanwhile, she gradually develops a lovely relationship with Fu Hanzheng, who is deeply devoted to her and only her.","pvNum":9106071,"bookType":0,"categoryType":5,"categoryId":70014,"categoryName":"Contemporary Romance","coverId":1697101888507,"chapterCnt":1820,"firstChapterId":"43567539254515742","lastChapterId":"65516526719007425","lastChapterName":"Two Children","lastChapterTime":1666620000000},{"bookId":"29917265408870505","bookName":"Supreme Hidden Dragon in the City","authorName":"Call me braised pork","authorId":"13219726005033701","description":"My wife betrayed me, but little did she know that I awakened the Immortal Emperor's inheritance, and from then on, I embarked on an extraordinary life against the heavens, embracing a top-tier beauty in my arms...","pvNum":107778,"bookType":0,"categoryType":5,"categoryId":70001,"categoryName":"Magical Realism","coverId":1721379167586,"chapterCnt":497,"firstChapterId":"80566231744179590","lastChapterId":"80566261003646676","lastChapterName":"Chapter 491 Truth_4","lastChapterTime":1729864800000},{"bookId":"20067225906237705","bookName":"The Perfect Hidden Marriage","authorName":"Inferior to the Dawn","authorId":"5458750704694101","description":"\"An evenly split marriage, 100% happiness.\"\r\nSu Jin, the adopted daughter of the Su family, falls in love with her elder brother, Su Mubai, in her youth.\r\nIn the beginning, he promises her, \"After you graduate from university, we will get married.\"\r\nHowever, he ends up marrying someone else.\r\nLater on, she gets busy attending blind dates and tries to enter an ordinary marriage with a heart that's nothing but cold and dead.\r\nJin Hengyuan is cold but handsome—he's her nth blind date.\r\nThe first time they meet, she wants to scare him away. \"If you think it's suitable, we can get registered tomorrow!\"\r\nHe smiles. \"I'm going on a business trip tomorrow. I'll be there in the afternoon!\"\r\nIn the afternoon, she becomes his wife.\r\n...\r\nShe is a quiet woman who doesn't fight or argue.\r\nHe has no house, but she says it's fine.\r\nWhen it comes to meals, she insists they split the bill evenly.\r\nWhen it comes to sleeping, she insists on sleeping in separate beds.\r\nWhen a woman clings onto him, she ignores her and turns to leave.\r\nEven with his daughter clinging to him, she only frowns and tries to keep her composure.\r\nA hidden marriage. No one knows that they are husband and wife. Nor does she care.\r\nAfter being plotted against and sent to the police station, he comes to her rescue. Finally, he loses it and starts scolding her, \"Must you be so stubborn? Why didn't you call me when something happened? Do you think I'm dead?\"\r\nShe pouts indignantly. \"Jin Hengyuan, do you treat me as your wife? If you do, why did you choose to get married in secret?\"\r\nHis anger turns into a smile. Good, she's finally angry.\r\nThis love was finally no longer his one-man show.\r\n...\r\nSmall skits:\r\n\"Jin Hengyuan, I want a divorce!\"\r\n\"Reason!\"\r\n\"You lied to me!\"\r\n\"How did I lie to you?\"\r\n\"You're clearly an attorney. When did you become an errand boy?\"\r\n\"Aren't attorneys supposed to run errands for clients? I take on all kinds of cases. Isn't this considered an odd-job laborer?\"\r\n\"…\"\r\nOh, damn it. How did she marry such a bully of an attorney?","pvNum":301979,"bookType":0,"categoryType":5,"categoryId":70014,"categoryName":"Contemporary Romance","coverId":1720078370619,"chapterCnt":238,"firstChapterId":"54447871205891978","lastChapterId":"82025998249412202","lastChapterName":"The First Date","lastChapterTime":1730340000000},{"bookId":"24901078306467305","bookName":"The Hidden CEO Is My Roommate","authorName":"Glimmy","authorId":"12626335505369001","description":"Some said he was a monster, while others claimed he was so hideous that his mother had no choice but to hide his face from birth. All in all, no one knew what Gabriel Alistair looked like. \r\n\r\nThe truth? His mother hid him to keep him safe from the assassins that had taken his father's life! Gabriel lived an isolated life for twenty-five years of his life. \r\n\r\nUnfortunately, he's tired of the mask and wants to live a \"normal\" life. After planting a fill-in to take his place so as not to draw attention to his absence, Gabriel decides to take control of his destiny and travels to another city secretly. However, fate seems to have other plans for him.\r\n\r\nZoe Clark is a chronic liar and was once a  spoiled young miss until her family went bankrupt. Unfortunately, she returned from the states and had to lie and keep up with her past lifestyle. Sadly, she gets duped and upon getting news of the fraudster's location, she runs to the airport to give him a piece of her mind. \r\n\r\nGabriel and Zoe cross paths and their phones get switched in the process. Realizing that his identity was in jeopardy, Gabriel tracks her down only to find out that she has sold his phone and further putting his identity at risk. \r\n\r\nHomeless and broke, Zoe could not shake him off her trail. To make sure Miss Liar doesn't take off, Gabriel comes up with an amicable solution to their situation. To keep an eye on her and make sure his identity remains intact, they must live together. Yes, they were going to be roommates. \r\n\r\nBuckle your belts people, because there are certain rules to staying together. \r\n\r\n—--------------\r\n\r\n\"Why do you want that cellphone so much?\" Zoe questioned him, unable to understand his obsession with the device. He was rich for crying out loud, he could always get another one. \r\n\r\n\"None of your business,\" Gabriel answered, hoping that would end her questioning. However, he was wrong because she stepped into his room with him. \r\n\r\n\"Do you know?\" Zoe continued, not paying attention to the fact that she has overstepped her boundaries by stepping into his room, uninvited. She just broke one of the house rules. \r\n\r\n\"My father says I'm like a dog because when I get a scent, I pursue it to the end. I know you're lying and hiding something ….\" Zoe tried to grab his arm to get his attention since he had his back turned to her. \r\n\r\n\r\nHowever, it happened in the twinkle of an eye, she was pushed up against the wall with Gabriel snarling down at her face,\r\n\r\n\r\n\"It's none of your goddamn business! I feed you and keep your lying ass out of the streets and you find the cell phone, period!\" \r\n\r\n\r\n\r\nA small gasp left Zoe's lips, stunned at the brutality in his tone. Why was he so sensitive to that phone? \r\n\r\n\r\nWith her chest heaving, they stared at each other and she was unable to say a word. However, it wasn't until a minute later that Zoe realized how intimate they were in this position with their bodies pressed flush against each other. \r\n\r\nShe gulped, they just broke one of the house rules. \r\n\r\nAnd why does he look so handsome with an angry face? \r\n\r\nDear God, she must have lost her  mind.\r\n\r\n----\r\n\r\nWant a mix of comedy with fluffy romance with sizzling attraction? Turn on to the next page because your dearest Glimmy is sure to keep you entertained!\r\n\r\nNote: Since Female lead is a teacher, this book would deal with bullying and other corruption within the educational system. Let's give this book a try! Thank you!","pvNum":1033959,"bookType":0,"categoryType":5,"categoryId":70014,"categoryName":"Contemporary Romance","coverId":1713952554587,"chapterCnt":223,"firstChapterId":"66843339827247782","lastChapterId":"71329463215910310","lastChapterName":"The Perfect Match","lastChapterTime":1685764558000}]
   */
  bookInfos?: {
    /**
     * "18117680306472805"
     */
    bookId?: string;
    /**
     * "hidden"
     */
    bookName?: string;
    /**
     * "MiaBella_Morgan"
     */
    authorName?: string;
    /**
     * "18108596505238701"
     */
    authorId?: string;
    description?: string;
    /**
     * 8388
     */
    pvNum?: number;
    bookType?: number;
    /**
     * 5
     */
    categoryType?: number;
    /**
     * 70016
     */
    categoryId?: number;
    /**
     * "Fantasy Romance"
     */
    categoryName?: string;
    /**
     * 1729694200016
     */
    coverId?: number;
    /**
     * 6
     */
    chapterCnt?: number;
    /**
     * "48634300379224198"
     */
    firstChapterId?: string;
    /**
     * "48990197458730976"
     */
    lastChapterId?: string;
    /**
     * "Chapter 6 and the end"
     */
    lastChapterName?: string;
    /**
     * 1602553657000
     */
    lastChapterTime?: number;
  }[];
  tagInfo?: null;
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 923
   */
  totalCount?: number;
  isLast?: boolean;
}

/**
 * 接口 [搜索相关书信息↗](https://yapi.yuewen.com/project/3297/interface/api/294701) 的 **请求配置的类型**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationBook`
 * @更新时间 `2024-10-31 15:51:13`
 */
type GoPcmSeoJavaSeoAskQueryRelationBookRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/java/seo/ask/queryRelationBook",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [搜索相关书信息↗](https://yapi.yuewen.com/project/3297/interface/api/294701) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationBook`
 * @更新时间 `2024-10-31 15:51:13`
 */
const goPcmSeoJavaSeoAskQueryRelationBookRequestConfig: GoPcmSeoJavaSeoAskQueryRelationBookRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryRelationBook",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryRelationBook",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [搜索相关书信息↗](https://yapi.yuewen.com/project/3297/interface/api/294701) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationBook`
 * @更新时间 `2024-10-31 15:51:13`
 */
export const goPcmSeoJavaSeoAskQueryRelationBook = /*#__PURE__*/ (
  requestData: GoPcmSeoJavaSeoAskQueryRelationBookRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoJavaSeoAskQueryRelationBookResponse>(
    prepare(goPcmSeoJavaSeoAskQueryRelationBookRequestConfig, requestData),
    ...args
  );
};

goPcmSeoJavaSeoAskQueryRelationBook.requestConfig =
  goPcmSeoJavaSeoAskQueryRelationBookRequestConfig;

const mockUrl_0_2_0_3 = "https://yapi.yuewen.com/mock/3297" as any;
const devUrl_0_2_0_3 = "https://oawww.webnovel.com" as any;
const prodUrl_0_2_0_3 = "https://www.webnovel.com" as any;
const dataKey_0_2_0_3 = "data" as any;

/**
 * 接口 [书详情页↗](https://yapi.yuewen.com/project/3297/interface/api/292680) 的 **请求类型**
 *
 * @分类 [站群↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38317)
 * @请求头 `GET /go/pcm/seo/path`
 * @更新时间 `2024-09-23 11:19:59`
 */
export interface GoPcmSeoPathRequest {}

/**
 * 接口 [书详情页↗](https://yapi.yuewen.com/project/3297/interface/api/292680) 的 **返回类型**
 *
 * @分类 [站群↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38317)
 * @请求头 `GET /go/pcm/seo/path`
 * @更新时间 `2024-09-23 11:19:59`
 */
export interface GoPcmSeoPathResponse {
  bookInfo?: {
    /**
     * "7366916601012405"
     */
    bookId?: string;
    /**
     * "The King's Avatar"
     */
    bookName?: string;
    /**
     * "TKA"
     */
    bookSubName?: string;
    /**
     * "Butterfly Blue"
     */
    authorName?: string;
    /**
     * "3626681903122401"
     */
    authorId?: string;
    /**
     * 70008
     */
    categoryId?: number;
    /**
     * "Video Games"
     */
    categoryName?: string;
    /**
     * 682
     */
    chapterNum?: number;
    /**
     * 682
     */
    totalChapterNum?: number;
    /**
     * 30
     */
    actionStatus?: number;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "zh"
     */
    languageName?: string;
    /**
     * "In the online game Glory, Ye Xiu is regarded as a textbook and a top-tier pro-player. However, due to a myriad reasons, he is kicked from the team. After leaving the professional scene, he finds work in an Internet Cafe as a manager. When Glory launches its tenth server, he who possesses ten years of gaming experience once again throws himself into the game. Bringing with him the memories of his past and an incomplete, self-made weapon, his return along the road to the summit begins!\r\n\r\nAfter fighting and scheming, who snatched away my glory? Under the tossing of the wind and rain, my dreams shall still appear as though they had never been shattered. In all its splendor, the path shall never be lost. Before the gazes of millions, this is where I return !"
     */
    description?: string;
    /**
     * "2M"
     */
    pvNum?: string;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * 1
     */
    type?: number;
    /**
     * "1887208"
     */
    QDBID?: string;
    /**
     * "4.2"
     */
    totalScore?: string;
    /**
     * 262
     */
    voters?: number;
    expected?: number;
    /**
     * "Unselected"
     */
    ageGroup?: string;
    updateFrequency?: number;
    /**
     * 21
     */
    promiseUpdateFrequency?: number;
    /**
     * 1
     */
    frequencyUnit?: number;
    /**
     * 1
     */
    promiseFrequencyUnit?: number;
    /**
     * "45727419184774513"
     */
    newChapterId?: string;
    newChapterName?: string;
    /**
     * "9 months ago"
     */
    newChapterTime?: string;
    /**
     * 682
     */
    newChapterIndex?: number;
    /**
     * "19775416453662908"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    translateMode?: number;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * [{"bookName":"全职高手","url":"https://oabook.qidian.com/info/1887208"}]
     */
    language?: {
      /**
       * "全职高手"
       */
      bookName?: string;
      /**
       * "https://oabook.qidian.com/info/1887208"
       */
      url?: string;
    }[];
    /**
     * [{"id":"19363452317401368","name":"Translation Nation"}]
     */
    editorItems?: {
      /**
       * "19363452317401368"
       */
      id?: string;
      /**
       * "Translation Nation"
       */
      name?: string;
    }[];
    /**
     * [{"id":"19363452317401368","name":"Translation Nation"}]
     */
    translatorItems?: {
      /**
       * "19363452317401368"
       */
      id?: string;
      /**
       * "Translation Nation"
       */
      name?: string;
    }[];
    /**
     * [{"name":"Butterfly Blue"}]
     */
    authorItems?: {
      /**
       * "Butterfly Blue"
       */
      name?: string;
    }[];
    /**
     * "19775416453662908"
     */
    readToChapterId?: string;
    /**
     * "1"
     */
    readToChapterIndex?: string;
    /**
     * "The Banished Battle God"
     */
    firstChapterName?: string;
    /**
     * "The Banished Battle God"
     */
    readToChapterName?: string;
    patreonLink?: string;
    /**
     * [{"jumpLink":"http://baidu.com","description":"I like this animation1"},{"jumpLink":"https://baidu.com","description":"I like this animation2"}]
     */
    animationItems?: {
      /**
       * "http://baidu.com"
       */
      jumpLink?: string;
      /**
       * "I like this animation1"
       */
      description?: string;
    }[];
    /**
     * [{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla","role":"author"},{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla test    blabla  \n testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla test \n testblabla testblabla testblabla \n testblabla testblabla testblabla testblabla testblabla testblabla  testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavvvvv testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavtestblabla testblabla test test","role":"translator"}]
     */
    notes?: {
      /**
       * "https://oaimg.webnovel.com/userheadimg/1/1/1.png"
       */
      avatar?: string;
      /**
       * "zhangsan"
       */
      name?: string;
      /**
       * "blabla"
       */
      note?: string;
      /**
       * "author"
       */
      role?: string;
    }[];
    advText?: string;
    advActionUrl?: string;
    picPC?: string;
    feverLink?: string;
    translateVoters?: null;
    isVoted?: null;
    hasVote?: null;
    giftInfo?: {
      giftNum?: number;
      giftMax?: {
        /**
         * 15927
         */
        id?: number;
        /**
         * "7366916601012405"
         */
        bookId?: string;
        /**
         * "19775416453662908"
         */
        chapterId?: string;
        /**
         * 4300000390
         */
        userId?: number;
        /**
         * 1
         */
        giftAmount?: number;
        /**
         * "6665224524910655505"
         */
        orderId?: string;
        /**
         * 20008
         */
        giftId?: number;
        /**
         * 8888
         */
        totalPrice?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Lollipop"
         */
        giftName?: string;
        /**
         * 6666
         */
        giftPrice?: number;
        /**
         * "https://webbannertest.webnovel.com/gift/1535014273_1546.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        UUT?: number;
        /**
         * "Candy"
         */
        userName?: string;
      };
      /**
       * [{"id":17089,"userId":4300013216,"giftId":20002,"appId":10,"giftName":"Lollipop","giftPrice":25,"iconUrl":"https://webbannertest.webnovel.com/gift/1535014017_3329.png","status":1,"order":1,"UUT":0,"userName":"liwen369183"},{"id":17080,"userId":4300000563,"giftId":20004,"appId":10,"giftName":"Turkey","giftPrice":200,"iconUrl":"https://webbannertest.webnovel.com/gift/1567410347_6132.png","status":1,"order":1,"UUT":1587113770560,"userName":"zhangchen"}]
       */
      giftRecords?: {
        /**
         * 17089
         */
        id?: number;
        /**
         * 4300013216
         */
        userId?: number;
        /**
         * 20002
         */
        giftId?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Lollipop"
         */
        giftName?: string;
        /**
         * 25
         */
        giftPrice?: number;
        /**
         * "https://webbannertest.webnovel.com/gift/1535014017_3329.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        UUT?: number;
        /**
         * "liwen369183"
         */
        userName?: string;
      }[];
    };
    /**
     * [{"userId":4300009639,"appId":10,"votingCount":39382,"UUT":1604656231478,"userName":"liwenwen"},{"userId":4300011791,"appId":10,"votingCount":6729,"UUT":1608805208979,"userName":"ar1609924587162"}]
     */
    topFanItems?: {
      /**
       * 4300009639
       */
      userId?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * 39382
       */
      votingCount?: number;
      /**
       * 1604656231478
       */
      UUT?: number;
      /**
       * "liwenwen"
       */
      userName?: string;
    }[];
    tagInfo?: {
      /**
       * []
       */
      popularItems?: unknown[];
      /**
       * []
       */
      userItems?: unknown[];
    };
    /**
     * [{"name":"@string"}]
     */
    relatedWords?: {
      /**
       * "@string"
       */
      name?: string;
    }[];
    /**
     * "1581418734974"
     */
    coverUpdateTime?: string;
    essayInfo?: {
      icon?: string;
      text?: string;
      actionUrl?: string;
    };
    discount?: number;
    /**
     * "@timestamp"
     */
    discountTime?: string;
  };
  /**
   * 1
   */
  curReadChapter?: number;
  flag?: {
    /**
     * "AC"
     */
    code?: string;
    /**
     * "U+1F1E6 U+1F1E8"
     */
    unicode?: string;
    /**
     * "@county"
     */
    name?: string;
    /**
     * "🇦🇨"
     */
    emoji?: string;
  };
}

/**
 * 接口 [书详情页↗](https://yapi.yuewen.com/project/3297/interface/api/292680) 的 **请求配置的类型**
 *
 * @分类 [站群↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38317)
 * @请求头 `GET /go/pcm/seo/path`
 * @更新时间 `2024-09-23 11:19:59`
 */
type GoPcmSeoPathRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/path",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [书详情页↗](https://yapi.yuewen.com/project/3297/interface/api/292680) 的 **请求配置**
 *
 * @分类 [站群↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38317)
 * @请求头 `GET /go/pcm/seo/path`
 * @更新时间 `2024-09-23 11:19:59`
 */
const goPcmSeoPathRequestConfig: GoPcmSeoPathRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_2_0_3,
  devUrl: devUrl_0_2_0_3,
  prodUrl: prodUrl_0_2_0_3,
  path: "/go/pcm/seo/path",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_2_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "goPcmSeoPath",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [书详情页↗](https://yapi.yuewen.com/project/3297/interface/api/292680) 的 **请求函数**
 *
 * @分类 [站群↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38317)
 * @请求头 `GET /go/pcm/seo/path`
 * @更新时间 `2024-09-23 11:19:59`
 */
export const goPcmSeoPath = /*#__PURE__*/ (
  requestData?: GoPcmSeoPathRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoPathResponse>(
    prepare(goPcmSeoPathRequestConfig, requestData),
    ...args
  );
};

goPcmSeoPath.requestConfig = goPcmSeoPathRequestConfig;

const mockUrl_0_2_0_4 = "https://yapi.yuewen.com/mock/3297" as any;
const devUrl_0_2_0_4 = "https://oawww.webnovel.com" as any;
const prodUrl_0_2_0_4 = "https://www.webnovel.com" as any;
const dataKey_0_2_0_4 = "data" as any;

/**
 * 接口 [关键词热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/293812) 的 **请求类型**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/list`
 * @更新时间 `2024-10-22 16:49:30`
 */
export interface GoPcmSeoCrTopicListRequest {
  /**
   * 搜索词分类
   */
  cate?: string;
  /**
   * 1
   */
  pageIndex: string;
  /**
   * 分页大小，默认180
   */
  pageSize: string;
}

/**
 * 接口 [关键词热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/293812) 的 **返回类型**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/list`
 * @更新时间 `2024-10-22 16:49:30`
 */
export interface GoPcmSeoCrTopicListResponse {
  /**
   * [{"topicId":78892700153210600,"lang":"en","searchWord":"vanilla"},{"topicId":78892700153210600,"lang":"en","searchWord":"venus"},{"topicId":78892700153210600,"lang":"en","searchWord":"victor"},{"topicId":78892700153210600,"lang":"en","searchWord":"abcd"}]
   */
  keywords?: {
    /**
     * 78892700153210600
     */
    topicId?: number;
    /**
     * "en"
     */
    lang?: string;
    /**
     * "vanilla"
     */
    searchWord?: string;
  }[];
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 3
   */
  total?: number;
  /**
   * true
   */
  isLast?: boolean;
  /**
   * 40
   */
  pages?: number;
}

/**
 * 接口 [关键词热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/293812) 的 **请求配置的类型**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/list`
 * @更新时间 `2024-10-22 16:49:30`
 */
type GoPcmSeoCrTopicListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/cr/topic/list",
    "data",
    string,
    "cate" | "pageIndex" | "pageSize",
    false
  >
>;

/**
 * 接口 [关键词热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/293812) 的 **请求配置**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/list`
 * @更新时间 `2024-10-22 16:49:30`
 */
const goPcmSeoCrTopicListRequestConfig: GoPcmSeoCrTopicListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: "/go/pcm/seo/cr/topic/list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: ["cate", "pageIndex", "pageSize"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoCrTopicList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [关键词热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/293812) 的 **请求函数**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/list`
 * @更新时间 `2024-10-22 16:49:30`
 */
export const goPcmSeoCrTopicList = /*#__PURE__*/ (
  requestData: GoPcmSeoCrTopicListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoCrTopicListResponse>(
    prepare(goPcmSeoCrTopicListRequestConfig, requestData),
    ...args
  );
};

goPcmSeoCrTopicList.requestConfig = goPcmSeoCrTopicListRequestConfig;

/**
 * 接口 [关键词详情↗](https://yapi.yuewen.com/project/3297/interface/api/293819) 的 **请求类型**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/detail`
 * @更新时间 `2024-10-22 16:49:23`
 */
export interface GoPcmSeoCrTopicDetailRequest {
  /**
   * 话题id
   */
  topicId: string;
}

/**
 * 接口 [关键词详情↗](https://yapi.yuewen.com/project/3297/interface/api/293819) 的 **返回类型**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/detail`
 * @更新时间 `2024-10-22 16:49:23`
 */
export interface GoPcmSeoCrTopicDetailResponse {
  topicInfo?: {
    /**
     * 11212121212
     */
    topicId?: number;
    /**
     * "love"
     */
    topicName?: string;
  };
  recommendInfo?: {
    /**
     * "WeekDay Feature"
     */
    title?: string;
    /**
     * [{"bookId":"7366916601012405","name":"The King's Avatar","shortName":"TKA","language":"en","authorId":"3626681903122401","authorName":"Butterfly Blue","itemType":0,"ageGroup":"Unselected","checkLevel":15,"categoryName":"Games","categoryId":70008,"scheduleUpdateFrq":3,"scheduleUpdateFrqUnit":1,"frequencyUnit":"","totalChapterNum":682,"actionStatus":30,"totalScore":4.28,"description":"In the online game Glory, Ye Xiu is regarded as a textbook and a top-tier pro-player. However, due to a myriad reasons, he is kicked from the team. After leaving the professional scene, he finds work in an Internet Cafe as a manager. When Glory launches its tenth server, he who possesses ten years of gaming experience once again throws himself into the game. Bringing with him the memories of his past and an incomplete, self-made weapon, his return along the road to the summit begins!!!!!!\r\n\r\nAfter fighting and scheming, who snatched away my glory? Under the tossing of the wind and rain, my dreams shall still appear as though they had never been shattered. In all its splendor, the path shall never be lost. Before the gazes of millions, this is where I return !","pvNum":2370742,"checkTime":1495855200000,"updateTime":1724814460000,"tagInfo":[],"expected":0,"firstChapterId":"19775416453662908","translateMode":1,"categoryType":5,"authorUserId":0,"groupItems":[{"id":"19363452317401368","name":"Translation Nation"}],"editorItems":[{"id":"8161817001026805","name":"RENREN","userId":3823689966,"guid":3823689966}],"translatorItems":[{"id":"7635959101023305","name":"xujin1111111","userId":3514016596,"guid":3514016596},{"id":"8161817001026805","name":"RENREN","userId":3823689966,"guid":3823689966}],"coverId":1581418734974,"inLibrary":0,"firstChapterName":"The Banished Battle God","animationItems":[{"description":"I like this animation1","jumpLink":"http://baidu.com"},{"description":"I like this animation2","jumpLink":"https://baidu.com"}],"notes":[{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla","role":"author"},{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla","role":"editor"},{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla","role":"editor"},{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla test    blabla  \n testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla test \n testblabla testblabla testblabla \n testblabla testblabla testblabla testblabla testblabla testblabla  testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavvvvv testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavtestblabla testblabla test test","role":"translator"}],"advText":"","advActionUrl":"","picPC":"","feverLink":"","relatedWords":[],"readToChapterId":"19775416453662908"}]
     */
    contentItems?: {
      /**
       * "7366916601012405"
       */
      bookId?: string;
      /**
       * "The King's Avatar"
       */
      name?: string;
      /**
       * "TKA"
       */
      shortName?: string;
      /**
       * "en"
       */
      language?: string;
      /**
       * "3626681903122401"
       */
      authorId?: string;
      /**
       * "Butterfly Blue"
       */
      authorName?: string;
      itemType?: number;
      /**
       * "Unselected"
       */
      ageGroup?: string;
      /**
       * 15
       */
      checkLevel?: number;
      /**
       * "Games"
       */
      categoryName?: string;
      /**
       * 70008
       */
      categoryId?: number;
      /**
       * 3
       */
      scheduleUpdateFrq?: number;
      /**
       * 1
       */
      scheduleUpdateFrqUnit?: number;
      frequencyUnit?: string;
      /**
       * 682
       */
      totalChapterNum?: number;
      /**
       * 30
       */
      actionStatus?: number;
      /**
       * 4.28
       */
      totalScore?: number;
      /**
       * "In the online game Glory, Ye Xiu is regarded as a textbook and a top-tier pro-player. However, due to a myriad reasons, he is kicked from the team. After leaving the professional scene, he finds work in an Internet Cafe as a manager. When Glory launches its tenth server, he who possesses ten years of gaming experience once again throws himself into the game. Bringing with him the memories of his past and an incomplete, self-made weapon, his return along the road to the summit begins!!!!!!\r\n\r\nAfter fighting and scheming, who snatched away my glory? Under the tossing of the wind and rain, my dreams shall still appear as though they had never been shattered. In all its splendor, the path shall never be lost. Before the gazes of millions, this is where I return !"
       */
      description?: string;
      /**
       * 2370742
       */
      pvNum?: number;
      /**
       * 1495855200000
       */
      checkTime?: number;
      /**
       * 1724814460000
       */
      updateTime?: number;
      /**
       * []
       */
      tagInfo?: unknown[];
      expected?: number;
      /**
       * "19775416453662908"
       */
      firstChapterId?: string;
      /**
       * 1
       */
      translateMode?: number;
      /**
       * 5
       */
      categoryType?: number;
      authorUserId?: number;
      /**
       * [{"id":"19363452317401368","name":"Translation Nation"}]
       */
      groupItems?: {
        /**
         * "19363452317401368"
         */
        id?: string;
        /**
         * "Translation Nation"
         */
        name?: string;
      }[];
      /**
       * [{"id":"8161817001026805","name":"RENREN","userId":3823689966,"guid":3823689966}]
       */
      editorItems?: {
        /**
         * "8161817001026805"
         */
        id?: string;
        /**
         * "RENREN"
         */
        name?: string;
        /**
         * 3823689966
         */
        userId?: number;
        /**
         * 3823689966
         */
        guid?: number;
      }[];
      /**
       * [{"id":"7635959101023305","name":"xujin1111111","userId":3514016596,"guid":3514016596},{"id":"8161817001026805","name":"RENREN","userId":3823689966,"guid":3823689966}]
       */
      translatorItems?: {
        /**
         * "7635959101023305"
         */
        id?: string;
        /**
         * "xujin1111111"
         */
        name?: string;
        /**
         * 3514016596
         */
        userId?: number;
        /**
         * 3514016596
         */
        guid?: number;
      }[];
      /**
       * 1581418734974
       */
      coverId?: number;
      inLibrary?: number;
      /**
       * "The Banished Battle God"
       */
      firstChapterName?: string;
      /**
       * [{"description":"I like this animation1","jumpLink":"http://baidu.com"},{"description":"I like this animation2","jumpLink":"https://baidu.com"}]
       */
      animationItems?: {
        /**
         * "I like this animation1"
         */
        description?: string;
        /**
         * "http://baidu.com"
         */
        jumpLink?: string;
      }[];
      /**
       * [{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla","role":"author"},{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla","role":"editor"},{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla","role":"editor"},{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla test    blabla  \n testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla test \n testblabla testblabla testblabla \n testblabla testblabla testblabla testblabla testblabla testblabla  testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavvvvv testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavtestblabla testblabla test test","role":"translator"}]
       */
      notes?: {
        /**
         * "https://oaimg.webnovel.com/userheadimg/1/1/1.png"
         */
        avatar?: string;
        /**
         * "zhangsan"
         */
        name?: string;
        /**
         * "blabla"
         */
        note?: string;
        /**
         * "author"
         */
        role?: string;
      }[];
      advText?: string;
      advActionUrl?: string;
      picPC?: string;
      feverLink?: string;
      /**
       * []
       */
      relatedWords?: unknown[];
      /**
       * "19775416453662908"
       */
      readToChapterId?: string;
    }[];
  };
  /**
   * [{"topicId":345208848329834,"lang":"","topicName":"love in silence novel"},{"topicId":345208848401520,"lang":"","topicName":"anime with love stories"},{"topicId":345208849937520,"lang":"","topicName":"jamaican love novels"},{"topicId":345208850615414,"lang":"","topicName":"passionate love novels"},{"topicId":345208848827514,"lang":"","topicName":"will and alyss love fanfiction"},{"topicId":345208848827528,"lang":"","topicName":"forsaken love novel"},{"topicId":345208850410637,"lang":"","topicName":"an aunts love fanfiction"},{"topicId":345208849550443,"lang":"","topicName":"3 days love story"},{"topicId":345208849751171,"lang":"","topicName":"powerful love novels"},{"topicId":345208852403309,"lang":"","topicName":"labyrinth love fanfiction"}]
   */
  relationTopics?: {
    /**
     * 345208848329834
     */
    topicId?: number;
    lang?: string;
    /**
     * "love in silence novel"
     */
    topicName?: string;
  }[];
}

/**
 * 接口 [关键词详情↗](https://yapi.yuewen.com/project/3297/interface/api/293819) 的 **请求配置的类型**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/detail`
 * @更新时间 `2024-10-22 16:49:23`
 */
type GoPcmSeoCrTopicDetailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/cr/topic/detail",
    "data",
    string,
    "topicId",
    false
  >
>;

/**
 * 接口 [关键词详情↗](https://yapi.yuewen.com/project/3297/interface/api/293819) 的 **请求配置**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/detail`
 * @更新时间 `2024-10-22 16:49:23`
 */
const goPcmSeoCrTopicDetailRequestConfig: GoPcmSeoCrTopicDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: "/go/pcm/seo/cr/topic/detail",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: ["topicId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoCrTopicDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [关键词详情↗](https://yapi.yuewen.com/project/3297/interface/api/293819) 的 **请求函数**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/detail`
 * @更新时间 `2024-10-22 16:49:23`
 */
export const goPcmSeoCrTopicDetail = /*#__PURE__*/ (
  requestData: GoPcmSeoCrTopicDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoCrTopicDetailResponse>(
    prepare(goPcmSeoCrTopicDetailRequestConfig, requestData),
    ...args
  );
};

goPcmSeoCrTopicDetail.requestConfig = goPcmSeoCrTopicDetailRequestConfig;

/**
 * 接口 [关键词随机列表↗](https://yapi.yuewen.com/project/3297/interface/api/294002) 的 **请求类型**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/random`
 * @更新时间 `2024-10-23 17:14:52`
 */
export interface GoPcmSeoCrTopicRandomRequest {
  /**
   * 1
   */
  pageIndex: string;
  /**
   * 分页大小，默认180
   */
  pageSize: string;
}

/**
 * 接口 [关键词随机列表↗](https://yapi.yuewen.com/project/3297/interface/api/294002) 的 **返回类型**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/random`
 * @更新时间 `2024-10-23 17:14:52`
 */
export interface GoPcmSeoCrTopicRandomResponse {
  /**
   * [{"topicId":350147764837489,"lang":"","searchWord":"Twisted And Weird Love"},{"topicId":350147967556765,"lang":"","searchWord":"Hunter in Immortal Academy"},{"topicId":350147829324877,"lang":"","searchWord":"The writer's ink"},{"topicId":350147974339634,"lang":"","searchWord":"A Possessive Mafia Leader"},{"topicId":350147781024900,"lang":"","searchWord":"Love and career"},{"topicId":350148013317288,"lang":"","searchWord":"Mobile Legends: The Origin of Guinevere"},{"topicId":350148065516682,"lang":"","searchWord":"Skater Ghost Fanfic SK8 The Infinity"},{"topicId":350147827637298,"lang":"","searchWord":"An Author's Book"},{"topicId":350147914816654,"lang":"","searchWord":"The promise of the Sun and Moon"},{"topicId":350147894774926,"lang":"","searchWord":"Young Master Enzo's siren"},{"topicId":350148060425278,"lang":"","searchWord":"JEOSON HIGH"},{"topicId":350147778468958,"lang":"","searchWord":"Saiyan in Naruto"},{"topicId":350147981239422,"lang":"","searchWord":"I am only doing this as a joke but by all means support it"},{"topicId":350147950949511,"lang":"","searchWord":"TRAPPED BY MY WIFE"},{"topicId":350147930807335,"lang":"","searchWord":"Gacha Addict in Another World"},{"topicId":350147807822922,"lang":"","searchWord":"The Mayor's Son is my Mate"},{"topicId":350148019952662,"lang":"","searchWord":"Love comfort by slayer of destiny"},{"topicId":350147897136227,"lang":"","searchWord":"New beginning of life"},{"topicId":350148272893114,"lang":"","searchWord":"Marabu Thiruvizha: Echoes of Kanavu Kottai"},{"topicId":350147826811986,"lang":"","searchWord":"One piece: my teacher is Hawkeye"},{"topicId":350148096392276,"lang":"","searchWord":"The Steppes of Mars"},{"topicId":350148267799698,"lang":"","searchWord":"Poor boy,billion dollar empire"},{"topicId":350147800577119,"lang":"","searchWord":"Adam Online: Absolute Zero"},{"topicId":350148249578630,"lang":"","searchWord":"Wishes in Shield Hero"},{"topicId":350147935796340,"lang":"","searchWord":"Chaos Tavern"},{"topicId":350148148689950,"lang":"","searchWord":"Kuch pal"},{"topicId":350148196793475,"lang":"","searchWord":"The Last GodsGods guide"},{"topicId":350148133645484,"lang":"","searchWord":"The Op King of Domination"},{"topicId":350148235826329,"lang":"","searchWord":"I want to be you"},{"topicId":350147933019283,"lang":"","searchWord":"Double Bossed"},{"topicId":350148252847194,"lang":"","searchWord":"Skeleton summoned in a demon lords castle"},{"topicId":350148087084160,"lang":"","searchWord":"The Children of Heaven and Hell"},{"topicId":350148181445715,"lang":"","searchWord":"Meditations"},{"topicId":350147864595614,"lang":"","searchWord":"stolen innocence"},{"topicId":350148186631286,"lang":"","searchWord":"Discover the Power Self Development"},{"topicId":350147889531949,"lang":"","searchWord":"My one and only Boss"},{"topicId":350148133071940,"lang":"","searchWord":"Your Faces"},{"topicId":350148050377810,"lang":"","searchWord":"Delteeeeeeeeeeeeeeeeeeeeed"},{"topicId":350147902102636,"lang":"","searchWord":"The Guide Games"},{"topicId":350148056566853,"lang":"","searchWord":"Various Sex Stories"},{"topicId":350148270842917,"lang":"","searchWord":"An Unexpected Connection: An RRTL Sequel"},{"topicId":350147839431808,"lang":"","searchWord":"Scary Dream"},{"topicId":350148105335886,"lang":"","searchWord":"The Dream Shifter"},{"topicId":350148147735599,"lang":"","searchWord":"To Rule or Love"},{"topicId":350148247901345,"lang":"","searchWord":"The Unseen Enemy"},{"topicId":350147819746424,"lang":"","searchWord":"Midnight Rose"},{"topicId":350148168838202,"lang":"","searchWord":"Rise of the Senju"},{"topicId":350148217830460,"lang":"","searchWord":"Webnovel wouldn't let me delete my book"},{"topicId":350147870825517,"lang":"","searchWord":"The Romance of cats"},{"topicId":350147866104924,"lang":"","searchWord":"The Devil's CEO Wife"},{"topicId":350148282782866,"lang":"","searchWord":"Trapped by A Handsome Billionaire"},{"topicId":350147921116280,"lang":"","searchWord":"Difficult"},{"topicId":350147832665183,"lang":"","searchWord":"A life that i dont want to live"},{"topicId":350147965785227,"lang":"","searchWord":"The Book of Ely"},{"topicId":350148069129294,"lang":"","searchWord":"Lady Toni's Great Escape"},{"topicId":350147752748086,"lang":"","searchWord":"newpeokybulider"},{"topicId":350147968382074,"lang":"","searchWord":"Liminal Space"},{"topicId":350147994868876,"lang":"","searchWord":"a story told"},{"topicId":350148008815736,"lang":"","searchWord":"The Royal Beginning"},{"topicId":350147755873376,"lang":"","searchWord":"Love Me, then hate Me"},{"topicId":350148208008248,"lang":"","searchWord":"Prince Adrien and the Pauper"},{"topicId":350147885220955,"lang":"","searchWord":"Nothing yet"},{"topicId":350147856565355,"lang":"","searchWord":"The Unholy Rebirth"},{"topicId":350147859862620,"lang":"","searchWord":"A Immortal From Way Back"},{"topicId":350148055817288,"lang":"","searchWord":"Blunderer"},{"topicId":350148015909913,"lang":"","searchWord":"Void Awakening"},{"topicId":350148154997839,"lang":"","searchWord":"ME AND MY SOULMATE"},{"topicId":350148003974302,"lang":"","searchWord":"Angela tambor"},{"topicId":350147878792293,"lang":"","searchWord":"By you, beside you"},{"topicId":350147993895952,"lang":"","searchWord":"The Princess, The Knight And Don't Forget The Dragon"},{"topicId":350147986316393,"lang":"","searchWord":"BeninRoxy"},{"topicId":350148113052713,"lang":"","searchWord":"Survival in the world of zombies and monsters"},{"topicId":350147904717991,"lang":"","searchWord":"My Life in Writer's World"},{"topicId":350148084868157,"lang":"","searchWord":"Middle Ages outbreak"},{"topicId":350147912750224,"lang":"","searchWord":"Love Of Life"},{"topicId":350148180845645,"lang":"","searchWord":"Lakeshore love"},{"topicId":350147908023404,"lang":"","searchWord":"Netorare Dog"},{"topicId":350148012776515,"lang":"","searchWord":"Helm of Slipper"},{"topicId":350148025330822,"lang":"","searchWord":"An Adventure to the Top"},{"topicId":350147862512809,"lang":"","searchWord":"Not The Chosen One"},{"topicId":350147797505195,"lang":"","searchWord":"The Unraveling of Lady Fury"},{"topicId":350147792368714,"lang":"","searchWord":"Wrong Era"},{"topicId":350147910503551,"lang":"","searchWord":"Class Card System"},{"topicId":350148023682182,"lang":"","searchWord":"ODD FUTURE:Catastrophe"},{"topicId":350147909811329,"lang":"","searchWord":"Mehedi hassan shohan Mehedi hassan shohan Mehedi hassan shohan"},{"topicId":350148215209061,"lang":"","searchWord":"Gogeta's Multiverse"},{"topicId":350147814452287,"lang":"","searchWord":"SHE, Alternative: New Girl Moving On The Block"},{"topicId":350148010587140,"lang":"","searchWord":"Reborn in Blue Exorcist with Demon system"},{"topicId":350148195828894,"lang":"","searchWord":"Martial harmony"},{"topicId":350148146992144,"lang":"","searchWord":"bobrossital"},{"topicId":350147914677261,"lang":"","searchWord":"The Mafia's Crazy Wife"},{"topicId":350147867055259,"lang":"","searchWord":"thank you is not a word it is deep emotion"},{"topicId":350147802971172,"lang":"","searchWord":"The reincarnation of Ernald Grosvich"},{"topicId":350147981239467,"lang":"","searchWord":"Demon Slayer: Falling Snow"},{"topicId":350148238689403,"lang":"","searchWord":"Unikbet : Situs Daftar Deposit Joker123 Bank BRI Terpercaya"},{"topicId":350148103285804,"lang":"","searchWord":"King Crab"},{"topicId":350147964832913,"lang":"","searchWord":"What am I"},{"topicId":350147949978726,"lang":"","searchWord":"dfsfsfs"},{"topicId":350147982998625,"lang":"","searchWord":"Cowboys And Mistletoes: Love Into The Sunset"},{"topicId":350147877532784,"lang":"","searchWord":"Loving The Toxic Billionaire Widower"},{"topicId":350147780289638,"lang":"","searchWord":"The Eternal Cruise"},{"topicId":350147998764132,"lang":"","searchWord":"Sayori's Struggle"},{"topicId":350147972246571,"lang":"","searchWord":"How Jesus Became My Life"},{"topicId":350147875566714,"lang":"","searchWord":"Scion of Time Gaming System"},{"topicId":350148139791457,"lang":"","searchWord":"Poems by Emily Dickinson, Three Series, Complete"},{"topicId":350147807267995,"lang":"","searchWord":"My Mafia husband"},{"topicId":350147800300672,"lang":"","searchWord":"The Deluxe Room Boy"},{"topicId":350148116233333,"lang":"","searchWord":"Leading a goblin village in the starting village"},{"topicId":350148121255009,"lang":"","searchWord":"The Everending Harmony"},{"topicId":350148192808047,"lang":"","searchWord":"Notes From Lily"},{"topicId":350148284304524,"lang":"","searchWord":"RTW : Transmigrators"},{"topicId":350147818775673,"lang":"","searchWord":"Give this book power stones for coins"},{"topicId":350147988528201,"lang":"","searchWord":"A God's Wrath"},{"topicId":350148032756834,"lang":"","searchWord":"The Adventures Between the Two Rivers"},{"topicId":350148135547988,"lang":"","searchWord":"The god of Chaos and Slaughter"},{"topicId":350147985769516,"lang":"","searchWord":"My Favorite Sin"},{"topicId":350148178535483,"lang":"","searchWord":"imran khan 4577"},{"topicId":350147940244538,"lang":"","searchWord":"Can't Escape My Fate"},{"topicId":350147988231264,"lang":"","searchWord":"A Fated Mistake"},{"topicId":350148001791013,"lang":"","searchWord":"Second Life and My Desire"},{"topicId":350147890914407,"lang":"","searchWord":"Who leads you to the top and you throw him out at last"},{"topicId":350148132133972,"lang":"","searchWord":"I Have An Alien Mining Ship"},{"topicId":350147892452433,"lang":"","searchWord":"The Rune Mage's Journey"},{"topicId":350148177280065,"lang":"","searchWord":"Murderer In Marvel"},{"topicId":350148276984870,"lang":"","searchWord":"The Pirate God"},{"topicId":350147888712779,"lang":"","searchWord":"Walls that isolate you"},{"topicId":350148206208143,"lang":"","searchWord":"I am 2 Overpowered"},{"topicId":350147888712788,"lang":"","searchWord":"The Sacred Sword Sovereign"},{"topicId":350148098724962,"lang":"","searchWord":"Descents"},{"topicId":350147911205965,"lang":"","searchWord":"Alex and the Lostzero point"},{"topicId":350148224730230,"lang":"","searchWord":"Lysistrata"},{"topicId":350147833212066,"lang":"","searchWord":"The Sect Master Is Not an Idiot"},{"topicId":350147833916534,"lang":"","searchWord":"Memorias de otra vida"},{"topicId":350148277259395,"lang":"","searchWord":"Masked Mafia KTH"},{"topicId":350148068992100,"lang":"","searchWord":"Dragon in The Apocalyptic World"},{"topicId":350148195693637,"lang":"","searchWord":"my one and only soldier"},{"topicId":350147994035244,"lang":"","searchWord":"it's no longer an illusion"},{"topicId":350148011545663,"lang":"","searchWord":"makagago kayo"},{"topicId":350148143103081,"lang":"","searchWord":"Absolute Delusional Fantasy: An Immortal's Journey Never Ends"},{"topicId":350148056265839,"lang":"","searchWord":"Dark Age: Rise Of Java"},{"topicId":350148001791102,"lang":"","searchWord":"Sleeping Prince"},{"topicId":350148040002627,"lang":"","searchWord":"Creature of Death Well"},{"topicId":350148126106681,"lang":"","searchWord":"A Millionaire's Wife"},{"topicId":350148131044432,"lang":"","searchWord":"Second Marrige With A Billionaire"},{"topicId":350148147872826,"lang":"","searchWord":"The Rise of ZERO"},{"topicId":350148125961350,"lang":"","searchWord":"I am supposed to be an emperor"},{"topicId":350147754460307,"lang":"","searchWord":"Fortunes Unbound"},{"topicId":350148270840951,"lang":"","searchWord":"The Dragon Dude"},{"topicId":350148237868117,"lang":"","searchWord":"The Stoy Of Like"},{"topicId":350147787891829,"lang":"","searchWord":"I just happened to get summoned to another world"},{"topicId":350148166626367,"lang":"","searchWord":"The PURPLE"},{"topicId":350147859862592,"lang":"","searchWord":"Broken princess"},{"topicId":350148203019297,"lang":"","searchWord":"Jujutsu momo"},{"topicId":350148073827477,"lang":"","searchWord":"Lord Land Caster and the Deviant Duchess"},{"topicId":350147759795371,"lang":"","searchWord":"two lovebirds"},{"topicId":350147898942587,"lang":"","searchWord":"Different but Similar"},{"topicId":350148036187304,"lang":"","searchWord":"His Other Half"},{"topicId":350147946642525,"lang":"","searchWord":"The Future That Never Was"},{"topicId":350147806579731,"lang":"","searchWord":"Story of an LEGEND"},{"topicId":350148076766365,"lang":"","searchWord":"sdgfhghhgf"},{"topicId":350147955158092,"lang":"","searchWord":"King of kings"},{"topicId":350147838323837,"lang":"","searchWord":"BTTH: Inheriting Desolate Heavenly Emperor"},{"topicId":350147749989461,"lang":"","searchWord":"Nootthjiinng"},{"topicId":350148230087716,"lang":"","searchWord":"The strongest Hunter is a Shadow"},{"topicId":350147807267997,"lang":"","searchWord":"Abuzar gifary"},{"topicId":350147768771681,"lang":"","searchWord":"I'M YOURS TOO"},{"topicId":350148219462740,"lang":"","searchWord":"Whiskey Poison"},{"topicId":350147873772655,"lang":"","searchWord":"Hondo's Girl"},{"topicId":350148013583472,"lang":"","searchWord":"Mated By Step Brothers"},{"topicId":350147892313215,"lang":"","searchWord":"Revolver Gang"},{"topicId":350148137051231,"lang":"","searchWord":"Tim and his paracosmic world"},{"topicId":350148109751349,"lang":"","searchWord":"Path of a weapon emperor in black clover"},{"topicId":350147864173742,"lang":"","searchWord":"Our promise kisss"},{"topicId":350148204266580,"lang":"","searchWord":"The time i married the prince of warriors"},{"topicId":350148201086035,"lang":"","searchWord":"kaguya sama"},{"topicId":350147914126465,"lang":"","searchWord":"Legend Of The White Snake"},{"topicId":350148211217450,"lang":"","searchWord":"Doomsday Base Building"},{"topicId":350148154449062,"lang":"","searchWord":"Li Xueyang"},{"topicId":350148241304682,"lang":"","searchWord":"this is really differen't"},{"topicId":350147788168272,"lang":"","searchWord":"Jack Stone"}]
   */
  keywords?: {
    /**
     * 350147764837489
     */
    topicId?: number;
    lang?: string;
    /**
     * "Twisted And Weird Love"
     */
    searchWord?: string;
  }[];
  total?: number;
  pageIndex?: number;
  isLast?: boolean;
  pages?: number;
}

/**
 * 接口 [关键词随机列表↗](https://yapi.yuewen.com/project/3297/interface/api/294002) 的 **请求配置的类型**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/random`
 * @更新时间 `2024-10-23 17:14:52`
 */
type GoPcmSeoCrTopicRandomRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/3297",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/cr/topic/random",
    "data",
    string,
    "pageIndex" | "pageSize",
    false
  >
>;

/**
 * 接口 [关键词随机列表↗](https://yapi.yuewen.com/project/3297/interface/api/294002) 的 **请求配置**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/random`
 * @更新时间 `2024-10-23 17:14:52`
 */
const goPcmSeoCrTopicRandomRequestConfig: GoPcmSeoCrTopicRandomRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: "/go/pcm/seo/cr/topic/random",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: ["pageIndex", "pageSize"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoCrTopicRandom",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [关键词随机列表↗](https://yapi.yuewen.com/project/3297/interface/api/294002) 的 **请求函数**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/random`
 * @更新时间 `2024-10-23 17:14:52`
 */
export const goPcmSeoCrTopicRandom = /*#__PURE__*/ (
  requestData: GoPcmSeoCrTopicRandomRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoCrTopicRandomResponse>(
    prepare(goPcmSeoCrTopicRandomRequestConfig, requestData),
    ...args
  );
};

goPcmSeoCrTopicRandom.requestConfig = goPcmSeoCrTopicRandomRequestConfig;

const mockUrl_0_1_0_0 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_0 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_0 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_0 = "data" as any;

/**
 * 接口 [获取所有排行榜信息↗](https://yapi.yuewen.com/project/28/interface/api/60857) 的 **请求类型**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getAllRank`
 * @更新时间 `2021-01-14 10:26:15`
 */
export interface AjaxRankingGetAllRankRequest {}

/**
 * 接口 [获取所有排行榜信息↗](https://yapi.yuewen.com/project/28/interface/api/60857) 的 **返回类型**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getAllRank`
 * @更新时间 `2021-01-14 10:26:15`
 */
export interface AjaxRankingGetAllRankResponse {
  /**
   * [{"rankId":"power_rank","rankName":"Power Rank","description":"test ","timeType":3,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"power_rank","rankName":"Power Rank","description":"test ","timeType":4,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"power_rank","rankName":"Power Rank","description":"test ","timeType":1,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"collection_rank","rankName":"coolectionRank","description":"dev","timeType":4,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"collection_rank","rankName":"collection Rank","description":"dev","timeType":1,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"best_sellers","rankName":"best sellers rank","description":"dev","timeType":4,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"power_rank","rankName":"Power Rank","description":"test ","timeType":3,"bookType":2,"categoryType":0,"novelType":0,"listType":1},{"rankId":"power_rank","rankName":"Power Rank","description":"test ","timeType":4,"bookType":2,"categoryType":0,"novelType":0,"listType":1},{"rankId":"power_rank","rankName":"Power Rank","description":"test ","timeType":1,"bookType":2,"categoryType":0,"novelType":0,"listType":1},{"rankId":"collection_rank","rankName":"coolectionRank","description":"dev","timeType":4,"bookType":2,"categoryType":0,"novelType":0,"listType":1},{"rankId":"collection_rank","rankName":"collection Rank","description":"dev","timeType":1,"bookType":2,"categoryType":0,"novelType":0,"listType":1},{"rankId":"best_sellers","rankName":"best sellers rank","description":"dev","timeType":4,"bookType":2,"categoryType":0,"novelType":0,"listType":1},{"rankId":"collection_rank","rankName":"collection Rank","description":"dev","timeType":3,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"best_sellers","rankName":"best sellers rank","description":"dev","timeType":3,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"best_sellers","rankName":"best sellers rank","description":"dev","timeType":5,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"best_sellers","rankName":"best sellers rank","description":"dev","timeType":1,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"engagement_rank","rankName":"engagement  rank","description":"dev","timeType":4,"novelType":0},{"rankId":"engagement_rank","rankName":"engagement  rank","description":"dev","timeType":3,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"update_rank","rankName":"update rank","description":"dev","timeType":1,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"update_rank","rankName":"update rank","description":"dev","timeType":3,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"engagement_rank","rankName":"engagement  rank","description":"dev","timeType":1,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"update_rank","rankName":"update rank","description":"dev","timeType":4,"bookType":2,"categoryType":0,"novelType":0,"listType":0},{"rankId":"power_rank","rankName":"Power Rank","description":"test ","timeType":3,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"power_rank","rankName":"Power Rank","description":"test ","timeType":4,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"power_rank","rankName":"Power Rank","description":"test ","timeType":1,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"collection_rank","rankName":"coolectionRank","description":"dev","timeType":4,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"collection_rank","rankName":"collection Rank","description":"dev","timeType":1,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"best_sellers","rankName":"best sellers rank","description":"dev","timeType":4,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"collection_rank","rankName":"collection Rank","description":"dev","timeType":3,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"best_sellers","rankName":"best sellers rank","description":"dev","timeType":3,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"best_sellers","rankName":"best sellers rank","description":"dev","timeType":5,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"best_sellers","rankName":"best sellers rank","description":"dev","timeType":1,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"engagement_rank","rankName":"engagement  rank","description":"dev","timeType":4,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"best_sellers","rankName":"best sellers rank","description":"dev","timeType":3,"bookType":2,"categoryType":1,"novelType":0,"listType":1},{"rankId":"best_sellers","rankName":"best sellers rank","description":"dev","timeType":5,"bookType":2,"categoryType":1,"novelType":0,"listType":1},{"rankId":"best_sellers","rankName":"best sellers rank","description":"dev","timeType":1,"bookType":2,"categoryType":1,"novelType":0,"listType":1},{"rankId":"engagement_rank","rankName":"engagement  rank","description":"dev","timeType":4,"bookType":2,"categoryType":1,"novelType":0,"listType":1},{"rankId":"engagement_rank","rankName":"engagement  rank","description":"dev","timeType":3,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"update_rank","rankName":"update rank","description":"dev","timeType":1,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"update_rank","rankName":"update rank","description":"dev","timeType":3,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"engagement_rank","rankName":"engagement  rank","description":"dev","timeType":1,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"update_rank","rankName":"update rank","description":"dev","timeType":4,"bookType":2,"categoryType":1,"novelType":0,"listType":0},{"rankId":"comic_collection_rank","rankName":"collect rank","description":"dev","timeType":3,"novelType":100},{"rankId":"comic_collection_rank","rankName":"collect rank","description":"dev","timeType":4,"novelType":100},{"rankId":"comic_power_rank","rankName":"power rank","description":"dev","timeType":3,"novelType":100},{"rankId":"comic_power_rank","rankName":"power rank","description":"dev","timeType":4,"novelType":100},{"rankId":"comic_active_rank","rankName":"active  rank","description":"dev","timeType":3,"novelType":100},{"rankId":"comic_active_rank","rankName":"active  rank","description":"dev","timeType":4,"novelType":100},{"rankId":"comic_best_sellers","rankName":"best sellers  rank","description":"dev","timeType":3,"novelType":100},{"rankId":"comic_best_sellers","rankName":"best sellers  rank","description":"dev","timeType":4,"novelType":100},{"rankId":"comic_best_sellers","rankName":"best sellers  rank","description":"dev","timeType":5,"novelType":100},{"rankId":"comic_new_rank","rankName":"new book rank","description":"dev","novelType":100}]
   */
  rankItems?: {
    /**
     * "power_rank"
     */
    rankId?: string;
    /**
     * "Power Rank"
     */
    rankName?: string;
    /**
     * "test "
     */
    description?: string;
    /**
     * 3
     */
    timeType?: number;
    /**
     * 2
     */
    bookType?: number;
    categoryType?: number;
    novelType?: number;
    listType?: number;
  }[];
}

/**
 * 接口 [获取所有排行榜信息↗](https://yapi.yuewen.com/project/28/interface/api/60857) 的 **请求配置的类型**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getAllRank`
 * @更新时间 `2021-01-14 10:26:15`
 */
type AjaxRankingGetAllRankRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/ranking/getAllRank",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取所有排行榜信息↗](https://yapi.yuewen.com/project/28/interface/api/60857) 的 **请求配置**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getAllRank`
 * @更新时间 `2021-01-14 10:26:15`
 */
const ajaxRankingGetAllRankRequestConfig: AjaxRankingGetAllRankRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: "/ajax/ranking/getAllRank",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxRankingGetAllRank",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取所有排行榜信息↗](https://yapi.yuewen.com/project/28/interface/api/60857) 的 **请求函数**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getAllRank`
 * @更新时间 `2021-01-14 10:26:15`
 */
export const ajaxRankingGetAllRank = /*#__PURE__*/ (
  requestData?: AjaxRankingGetAllRankRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxRankingGetAllRankResponse>(
    prepare(ajaxRankingGetAllRankRequestConfig, requestData),
    ...args
  );
};

ajaxRankingGetAllRank.requestConfig = ajaxRankingGetAllRankRequestConfig;

/**
 * 接口 [获取某一个排行↗](https://yapi.yuewen.com/project/28/interface/api/60859) 的 **请求类型**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getRanking`
 * @更新时间 `2021-01-14 10:24:05`
 */
export interface AjaxRankingGetRankingRequest {
  rankId: string;
  /**
   * 榜单的类型，总榜日榜月榜，24h 7day 14day等
   */
  timeType: string;
  novelType: string;
  /**
   * 1:小说 4：Fan-fic
   */
  categoryType: string;
  /**
   * 0总榜，1新书榜
   */
  listType: string;
  language: string;
  pageIndex: string;
  /**
   * 区分原创和翻译书，1是翻译，2是原创，不传就是全部
   */
  bookType: string;
  /**
   * 默认 传 -1   男 - 1， 女 - 2
   */
  sex: string;
  /**
   * 0:所有 1:ongoing 2:completed， 出版书无该选项 默认1
   */
  bookStatus: string;
}

/**
 * 接口 [获取某一个排行↗](https://yapi.yuewen.com/project/28/interface/api/60859) 的 **返回类型**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getRanking`
 * @更新时间 `2021-01-14 10:24:05`
 */
export interface AjaxRankingGetRankingResponse {
  /**
   * [{"bookId":"rank_power_store","amount":"1123","ranking":"榜单名称","bookName":"书名","categoryName":"分类名","authorName":"作者名称","totalScore":"书籍评分","inLibrary":1,"editorItems":[{"id":10088880405001700,"userId":2220443350,"guid":2220443350,"name":"Nomyummi"},{"id":10270643305016900,"userId":4300459851,"guid":4300459851,"name":"GravityTales"}],"translatorItems":[{"id":10088880405001700,"userId":2220443350,"guid":2220443350,"name":"Nomyummi"}]}]
   */
  rankingItems?: {
    /**
     * "rank_power_store"
     */
    bookId?: string;
    /**
     * "1123"
     */
    amount?: string;
    /**
     * "榜单名称"
     */
    ranking?: string;
    /**
     * "书名"
     */
    bookName?: string;
    /**
     * "分类名"
     */
    categoryName?: string;
    /**
     * "作者名称"
     */
    authorName?: string;
    /**
     * "书籍评分"
     */
    totalScore?: string;
    /**
     * 1
     */
    inLibrary?: number;
    /**
     * [{"id":10088880405001700,"userId":2220443350,"guid":2220443350,"name":"Nomyummi"},{"id":10270643305016900,"userId":4300459851,"guid":4300459851,"name":"GravityTales"}]
     */
    editorItems?: {
      /**
       * 10088880405001700
       */
      id?: number;
      /**
       * 2220443350
       */
      userId?: number;
      /**
       * 2220443350
       */
      guid?: number;
      /**
       * "Nomyummi"
       */
      name?: string;
    }[];
    /**
     * [{"id":10088880405001700,"userId":2220443350,"guid":2220443350,"name":"Nomyummi"}]
     */
    translatorItems?: {
      /**
       * 10088880405001700
       */
      id?: number;
      /**
       * 2220443350
       */
      userId?: number;
      /**
       * 2220443350
       */
      guid?: number;
      /**
       * "Nomyummi"
       */
      name?: string;
    }[];
  }[];
}

/**
 * 接口 [获取某一个排行↗](https://yapi.yuewen.com/project/28/interface/api/60859) 的 **请求配置的类型**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getRanking`
 * @更新时间 `2021-01-14 10:24:05`
 */
type AjaxRankingGetRankingRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/ranking/getRanking",
    "data",
    string,
    | "rankId"
    | "timeType"
    | "novelType"
    | "categoryType"
    | "listType"
    | "language"
    | "pageIndex"
    | "bookType"
    | "sex"
    | "bookStatus",
    false
  >
>;

/**
 * 接口 [获取某一个排行↗](https://yapi.yuewen.com/project/28/interface/api/60859) 的 **请求配置**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getRanking`
 * @更新时间 `2021-01-14 10:24:05`
 */
const ajaxRankingGetRankingRequestConfig: AjaxRankingGetRankingRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: "/ajax/ranking/getRanking",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [
      "rankId",
      "timeType",
      "novelType",
      "categoryType",
      "listType",
      "language",
      "pageIndex",
      "bookType",
      "sex",
      "bookStatus",
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxRankingGetRanking",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取某一个排行↗](https://yapi.yuewen.com/project/28/interface/api/60859) 的 **请求函数**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getRanking`
 * @更新时间 `2021-01-14 10:24:05`
 */
export const ajaxRankingGetRanking = /*#__PURE__*/ (
  requestData: AjaxRankingGetRankingRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxRankingGetRankingResponse>(
    prepare(ajaxRankingGetRankingRequestConfig, requestData),
    ...args
  );
};

ajaxRankingGetRanking.requestConfig = ajaxRankingGetRankingRequestConfig;

const mockUrl_0_1_0_1 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_1 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_1 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_1 = "data" as any;

/**
 * 接口 [lastPage - 阅读末页(go)↗](https://yapi.yuewen.com/project/28/interface/api/76475) 的 **请求类型**
 *
 * @分类 [Chapter 章节相关接口↗](https://yapi.yuewen.com/project/28/interface/api/cat_11093)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2020-04-17 15:18:35`
 */
export interface GoPcmReadingLastPageRequest {
  /**
   * 书和漫画的id
   */
  itemId: string;
  /**
   * 0小说，100漫画
   */
  itemType: string;
}

/**
 * 接口 [lastPage - 阅读末页(go)↗](https://yapi.yuewen.com/project/28/interface/api/76475) 的 **返回类型**
 *
 * @分类 [Chapter 章节相关接口↗](https://yapi.yuewen.com/project/28/interface/api/cat_11093)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2020-04-17 15:18:35`
 */
export interface GoPcmReadingLastPageResponse {
  bookInfo?: {
    /**
     * 30
     */
    status?: number;
    /**
     * 1568605818000
     */
    nextUpdateTime?: number;
    /**
     * 15
     */
    updateFrequency?: number;
    /**
     * 10
     */
    promiseUpdateFrequency?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * 100
     */
    voters?: number;
    /**
     * 123456
     */
    pvNum?: number;
    /**
     * 2
     */
    bookType?: number;
    /**
     * 60002
     */
    categoryId?: number;
    /**
     * "Hot-blooded"
     */
    categoryName?: string;
  };
  /**
   * 2
   */
  reviewScore?: number;
  /**
   * [{"tagId":1,"tagName":"tag"}]
   */
  tagInfo?: {
    /**
     * 1
     */
    tagId?: number;
    /**
     * "tag"
     */
    tagName?: string;
  }[];
  operationInfo?: {
    /**
     * "good webnovel"
     */
    title?: string;
    /**
     * "https://webbannertest.webnovel.com/utils/1557232876_534550.png"
     */
    imageUrl?: string;
    /**
     * "https://www.webnovel.com"
     */
    actionUrl?: string;
  };
  /**
   * [{"bookId":10812783101029604,"bookName":"Webnovel Lily002","categoryName":"High Fantasy","totalScore":4,"coverUpdateTime":0,"novelType":0,"alg":"112.123.123"}]
   */
  recommendInfo?: {
    /**
     * 10812783101029604
     */
    bookId?: number;
    /**
     * "Webnovel Lily002"
     */
    bookName?: string;
    /**
     * "High Fantasy"
     */
    categoryName?: string;
    /**
     * 4
     */
    totalScore?: number;
    coverUpdateTime?: number;
    novelType?: number;
    /**
     * "112.123.123"
     */
    alg?: string;
  }[];
  /**
   * [{"reviewId":14633141705768400,"bookId":"13041983201040501","content":"Tuhgrstf6fygycfx4dyhyctxttctctgyv5ftcrzeubucextvyvtcTuhgrstf6fygycfx4dyhyctxttctctgyv5ftcrzeubucextvyvtcTuhgrstf6fygycfx4dyhyctxttctctgyv5ftcrzeubucextvyvtcTuhgrstf6fygycfx4dyhyctxttctctgyv5ftcrzeubucextvyvtcTuhgrstf6fygycfx4dyhyctxttctctgyv5ftcrzeubucextvyvtcTuhgrstf6fygycfx4dyhyctxttctctgyv5ftcrzeubucextvyvtc","userId":4300000732,"totalScore":"4.0","createTime":"1 month ago","readToChapterIndex":"","replyNums":0,"likeNums":0,"isSpoiler":0,"isLiked":0,"topStatus":0,"appId":10,"novelType":100,"UUT":0,"userName":"zhoujielun","avatar":0,"penName":"zhoujielun","role":0,"userLevel":2,"badgeInfo":{"badgeId":10009,"badgeType":"Achievement","badgeName":"YE XIU 5.29","maxGrade":1,"baseUrl":"https://actimg.webnovel.com/badge/10009/1/","updateTime":1570602076000}}]
   */
  reviewItems?: {
    /**
     * 14633141705768400
     */
    reviewId?: number;
    /**
     * "13041983201040501"
     */
    bookId?: string;
    /**
     * "Tuhgrstf6fygycfx4dyhyctxttctctgyv5ftcrzeubucextvyvtcTuhgrstf6fygycfx4dyhyctxttctctgyv5ftcrzeubucextvyvtcTuhgrstf6fygycfx4dyhyctxttctctgyv5ftcrzeubucextvyvtcTuhgrstf6fygycfx4dyhyctxttctctgyv5ftcrzeubucextvyvtcTuhgrstf6fygycfx4dyhyctxttctctgyv5ftcrzeubucextvyvtcTuhgrstf6fygycfx4dyhyctxttctctgyv5ftcrzeubucextvyvtc"
     */
    content?: string;
    /**
     * 4300000732
     */
    userId?: number;
    /**
     * "4.0"
     */
    totalScore?: string;
    /**
     * "1 month ago"
     */
    createTime?: string;
    readToChapterIndex?: string;
    replyNums?: number;
    likeNums?: number;
    isSpoiler?: number;
    isLiked?: number;
    topStatus?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 100
     */
    novelType?: number;
    UUT?: number;
    /**
     * "zhoujielun"
     */
    userName?: string;
    avatar?: number;
    /**
     * "zhoujielun"
     */
    penName?: string;
    role?: number;
    /**
     * 2
     */
    userLevel?: number;
    badgeInfo?: {
      /**
       * 10009
       */
      badgeId?: number;
      /**
       * "Achievement"
       */
      badgeType?: string;
      /**
       * "YE XIU 5.29"
       */
      badgeName?: string;
      /**
       * 1
       */
      maxGrade?: number;
      /**
       * "https://actimg.webnovel.com/badge/10009/1/"
       */
      baseUrl?: string;
      /**
       * 1570602076000
       */
      updateTime?: number;
    };
  }[];
  /**
   * 1023
   */
  reviewNum?: number;
}

/**
 * 接口 [lastPage - 阅读末页(go)↗](https://yapi.yuewen.com/project/28/interface/api/76475) 的 **请求配置的类型**
 *
 * @分类 [Chapter 章节相关接口↗](https://yapi.yuewen.com/project/28/interface/api/cat_11093)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2020-04-17 15:18:35`
 */
type GoPcmReadingLastPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/reading/lastPage",
    "data",
    string,
    "itemId" | "itemType",
    false
  >
>;

/**
 * 接口 [lastPage - 阅读末页(go)↗](https://yapi.yuewen.com/project/28/interface/api/76475) 的 **请求配置**
 *
 * @分类 [Chapter 章节相关接口↗](https://yapi.yuewen.com/project/28/interface/api/cat_11093)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2020-04-17 15:18:35`
 */
const goPcmReadingLastPageRequestConfig: GoPcmReadingLastPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: "/go/pcm/reading/lastPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: ["itemId", "itemType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingLastPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [lastPage - 阅读末页(go)↗](https://yapi.yuewen.com/project/28/interface/api/76475) 的 **请求函数**
 *
 * @分类 [Chapter 章节相关接口↗](https://yapi.yuewen.com/project/28/interface/api/cat_11093)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2020-04-17 15:18:35`
 */
export const goPcmReadingLastPage = /*#__PURE__*/ (
  requestData: GoPcmReadingLastPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmReadingLastPageResponse>(
    prepare(goPcmReadingLastPageRequestConfig, requestData),
    ...args
  );
};

goPcmReadingLastPage.requestConfig = goPcmReadingLastPageRequestConfig;

const mockUrl_0_1_0_2 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_2 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_2 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_2 = "data" as any;

/**
 * 接口 [Badge detail↗](https://yapi.yuewen.com/project/28/interface/api/23) 的 **请求类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/badge/getBadgeDetail`
 * @更新时间 `2020-07-14 15:19:04`
 */
export interface AjaxBadgeGetBadgeDetailRequest {
  badgeId: string;
}

/**
 * 接口 [Badge detail↗](https://yapi.yuewen.com/project/28/interface/api/23) 的 **返回类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/badge/getBadgeDetail`
 * @更新时间 `2020-07-14 15:19:04`
 */
export interface AjaxBadgeGetBadgeDetailResponse {
  /**
   * 1
   */
  badgeId?: number;
  /**
   * "Endeavor"
   */
  badgeName?: string;
  /**
   * 1
   */
  maxGrade?: number;
  /**
   * [{"gradeName":"Endeavor","badgeGrade":1,"achievedGoal":"Register for over 1 year","baseUrl":"https://actimg.webnovel.com/badge/10005/1/","updateTime":"2017-12-12","isAchieved":"1","achievedTime":"2017-12-12","ranking":123}]
   */
  gradeItems?: {
    /**
     * "Endeavor"
     */
    gradeName?: string;
    /**
     * 1
     */
    badgeGrade?: number;
    /**
     * "Register for over 1 year"
     */
    achievedGoal?: string;
    /**
     * "https://actimg.webnovel.com/badge/10005/1/"
     */
    baseUrl?: string;
    /**
     * "2017-12-12"
     */
    updateTime?: string;
    /**
     * "1"
     */
    isAchieved?: string;
    /**
     * "2017-12-12"
     */
    achievedTime?: string;
    /**
     * 123
     */
    ranking?: number;
  }[];
}

/**
 * 接口 [Badge detail↗](https://yapi.yuewen.com/project/28/interface/api/23) 的 **请求配置的类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/badge/getBadgeDetail`
 * @更新时间 `2020-07-14 15:19:04`
 */
type AjaxBadgeGetBadgeDetailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/badge/getBadgeDetail",
    "data",
    string,
    "badgeId",
    false
  >
>;

/**
 * 接口 [Badge detail↗](https://yapi.yuewen.com/project/28/interface/api/23) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/badge/getBadgeDetail`
 * @更新时间 `2020-07-14 15:19:04`
 */
const ajaxBadgeGetBadgeDetailRequestConfig: AjaxBadgeGetBadgeDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/badge/getBadgeDetail",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ["badgeId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBadgeGetBadgeDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [Badge detail↗](https://yapi.yuewen.com/project/28/interface/api/23) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/badge/getBadgeDetail`
 * @更新时间 `2020-07-14 15:19:04`
 */
export const ajaxBadgeGetBadgeDetail = /*#__PURE__*/ (
  requestData: AjaxBadgeGetBadgeDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxBadgeGetBadgeDetailResponse>(
    prepare(ajaxBadgeGetBadgeDetailRequestConfig, requestData),
    ...args
  );
};

ajaxBadgeGetBadgeDetail.requestConfig = ajaxBadgeGetBadgeDetailRequestConfig;

/**
 * 接口 [My badges↗](https://yapi.yuewen.com/project/28/interface/api/30) 的 **请求类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/Badge/getMyBadges`
 * @更新时间 `2018-12-26 16:51:21`
 */
export interface AjaxBadgeGetMyBadgesRequest {}

/**
 * 接口 [My badges↗](https://yapi.yuewen.com/project/28/interface/api/30) 的 **返回类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/Badge/getMyBadges`
 * @更新时间 `2018-12-26 16:51:21`
 */
export interface AjaxBadgeGetMyBadgesResponse {
  /**
   * [{"badgeId":1,"badgeType":"Achievement","badgeName":"Endeavor","maxGrade":4,"isAchieved":0,"achievedMaxGrade":1,"achievedTime":"","achievedGradeGoal":"Cumulative Sign in 30 days","baseUrl":"https://actimg.webnovel.com/badge/10001/1/","updateTime":0},{"badgeId":10002,"badgeType":"Achievement","badgeName":"Such Rich!","maxGrade":4,"isAchieved":0,"achievedMaxGrade":1,"achievedTime":"","achievedGradeGoal":"Accumulative obtain 1,000 Spirit Stones","baseUrl":"https://actimg.webnovel.com/badge/10002/1/","updateTime":0},{"badgeId":10003,"badgeType":"Achievement","badgeName":"Premium","maxGrade":4,"isAchieved":0,"achievedMaxGrade":1,"achievedTime":"","achievedGradeGoal":"To be a Premium user","baseUrl":"https://actimg.webnovel.com/badge/10003/1/","updateTime":0},{"badgeId":10004,"badgeType":"Achievement","badgeName":"My Treasures","maxGrade":4,"isAchieved":0,"achievedMaxGrade":1,"achievedTime":"","achievedGradeGoal":"61-100 contributors in Contribution ranking","baseUrl":"https://actimg.webnovel.com/badge/10004/1/","updateTime":0},{"badgeId":10005,"badgeType":"Achievement","badgeName":"Glory!","maxGrade":1,"isAchieved":0,"achievedMaxGrade":1,"achievedTime":"","achievedGradeGoal":"First 100 Premium users","baseUrl":"https://actimg.webnovel.com/badge/10005/1/","updateTime":0},{"badgeId":10006,"badgeType":"General","badgeName":"Cultivator","maxGrade":4,"isAchieved":0,"achievedMaxGrade":1,"achievedTime":"","achievedGradeGoal":"Register for over 1 year","baseUrl":"https://actimg.webnovel.com/badge/10006/1/","updateTime":0},{"badgeId":10007,"badgeType":"General","badgeName":"Who am I?","maxGrade":2,"isAchieved":1,"achievedMaxGrade":1,"achievedTime":"2018-01-24","achievedGradeGoal":"Add email","baseUrl":"https://actimg.webnovel.com/badge/10007/1/","updateTime":0}]
   */
  items?: {
    /**
     * 1
     */
    badgeId?: number;
    /**
     * "Achievement"
     */
    badgeType?: string;
    /**
     * "Endeavor"
     */
    badgeName?: string;
    /**
     * 4
     */
    maxGrade?: number;
    isAchieved?: number;
    /**
     * 1
     */
    achievedMaxGrade?: number;
    achievedTime?: string;
    /**
     * "Cumulative Sign in 30 days"
     */
    achievedGradeGoal?: string;
    /**
     * "https://actimg.webnovel.com/badge/10001/1/"
     */
    baseUrl?: string;
    updateTime?: number;
  }[];
  /**
   * 1
   */
  userTotal?: number;
  /**
   * 7
   */
  totalCount?: number;
  /**
   * 1
   */
  isLast?: number;
  user?: {
    /**
     * "3627871248"
     */
    guid?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/3627871248/1/1.jpg?mt=1514354221000"
     */
    avatar?: string;
    /**
     * "1111qq"
     */
    userName?: string;
    nickName?: null;
    penName?: null;
    role?: number;
    status?: number;
    /**
     * 7377
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 2
     */
    userLevel?: number;
    /**
     * 1
     */
    availablePower?: number;
    /**
     * 1
     */
    totalPower?: number;
    /**
     * 1
     */
    availableEnergy?: number;
    /**
     * 1
     */
    totalEnergy?: number;
    emailStatus?: number;
  };
}

/**
 * 接口 [My badges↗](https://yapi.yuewen.com/project/28/interface/api/30) 的 **请求配置的类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/Badge/getMyBadges`
 * @更新时间 `2018-12-26 16:51:21`
 */
type AjaxBadgeGetMyBadgesRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/Badge/getMyBadges",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [My badges↗](https://yapi.yuewen.com/project/28/interface/api/30) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/Badge/getMyBadges`
 * @更新时间 `2018-12-26 16:51:21`
 */
const ajaxBadgeGetMyBadgesRequestConfig: AjaxBadgeGetMyBadgesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/Badge/getMyBadges",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBadgeGetMyBadges",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [My badges↗](https://yapi.yuewen.com/project/28/interface/api/30) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/Badge/getMyBadges`
 * @更新时间 `2018-12-26 16:51:21`
 */
export const ajaxBadgeGetMyBadges = /*#__PURE__*/ (
  requestData?: AjaxBadgeGetMyBadgesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxBadgeGetMyBadgesResponse>(
    prepare(ajaxBadgeGetMyBadgesRequestConfig, requestData),
    ...args
  );
};

ajaxBadgeGetMyBadges.requestConfig = ajaxBadgeGetMyBadgesRequestConfig;

/**
 * 接口 [User level list↗](https://yapi.yuewen.com/project/28/interface/api/79) 的 **请求类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/UserLevel/listAjax`
 * @更新时间 `2018-12-26 16:54:41`
 */
export interface AjaxUserLevelListAjaxRequest {}

/**
 * 接口 [User level list↗](https://yapi.yuewen.com/project/28/interface/api/79) 的 **返回类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/UserLevel/listAjax`
 * @更新时间 `2018-12-26 16:54:41`
 */
export interface AjaxUserLevelListAjaxResponse {
  userLevelInfo?: {
    /**
     * "1"
     */
    userLevel?: string;
    /**
     * "100"
     */
    expToNextLevel?: string;
    /**
     * "80"
     */
    curLevelPercent?: string;
  };
  /**
   * [{"id":1,"name":"@name","exp":1,"finishedTimes":1,"totalTimes":"3","type":1,"taskType":1,"isCompleted":1}]
   */
  taskList?: {
    /**
     * 1
     */
    id?: number;
    /**
     * "@name"
     */
    name?: string;
    /**
     * 1
     */
    exp?: number;
    /**
     * 1
     */
    finishedTimes?: number;
    /**
     * "3"
     */
    totalTimes?: string;
    /**
     * 1
     */
    type?: number;
    /**
     * 1
     */
    taskType?: number;
    /**
     * 1
     */
    isCompleted?: number;
  }[];
}

/**
 * 接口 [User level list↗](https://yapi.yuewen.com/project/28/interface/api/79) 的 **请求配置的类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/UserLevel/listAjax`
 * @更新时间 `2018-12-26 16:54:41`
 */
type AjaxUserLevelListAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/UserLevel/listAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [User level list↗](https://yapi.yuewen.com/project/28/interface/api/79) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/UserLevel/listAjax`
 * @更新时间 `2018-12-26 16:54:41`
 */
const ajaxUserLevelListAjaxRequestConfig: AjaxUserLevelListAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/UserLevel/listAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxUserLevelListAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [User level list↗](https://yapi.yuewen.com/project/28/interface/api/79) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/UserLevel/listAjax`
 * @更新时间 `2018-12-26 16:54:41`
 */
export const ajaxUserLevelListAjax = /*#__PURE__*/ (
  requestData?: AjaxUserLevelListAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxUserLevelListAjaxResponse>(
    prepare(ajaxUserLevelListAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxUserLevelListAjax.requestConfig = ajaxUserLevelListAjaxRequestConfig;

/**
 * 接口 [通知直出-Page（M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/128) 的 **请求类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /notification/notificationListPage`
 * @更新时间 `2019-05-10 16:55:24`
 */
export interface NotificationNotificationListPageRequest {
  pageIndex: string;
}

/**
 * 接口 [通知直出-Page（M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/128) 的 **返回类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /notification/notificationListPage`
 * @更新时间 `2019-05-10 16:55:24`
 */
export interface NotificationNotificationListPageResponse {
  /**
   * [{"id":1,"type":4,"title":"@string","content":"@string","updateTime":"1 day ago","readStatus":0,"ssNum":0,"ssType":0,"ssGetStatus":2,"ssExpireTime":"-17573 day","bookId":6789521301000305,"bookName":"@title","authorName":"@name"}]
   */
  items?: {
    /**
     * 1
     */
    id?: number;
    /**
     * 4
     */
    type?: number;
    /**
     * "@string"
     */
    title?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * "1 day ago"
     */
    updateTime?: string;
    readStatus?: number;
    ssNum?: number;
    ssType?: number;
    /**
     * 2
     */
    ssGetStatus?: number;
    /**
     * "-17573 day"
     */
    ssExpireTime?: string;
    /**
     * 6789521301000305
     */
    bookId?: number;
    /**
     * "@title"
     */
    bookName?: string;
    /**
     * "@name"
     */
    authorName?: string;
  }[];
  /**
   * 37
   */
  total?: number;
  isLast?: number;
  user?: {
    /**
     * "2959616949"
     */
    guid?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/2959616949/1/1.jpg?mt=1514342391000"
     */
    avatar?: string;
    /**
     * "Eason"
     */
    userName?: string;
    nickName?: null;
    penName?: null;
    role?: number;
    status?: number;
    /**
     * 7149
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 2
     */
    userLevel?: number;
    /**
     * 1
     */
    availablePower?: number;
    /**
     * 1
     */
    totalPower?: number;
    /**
     * 1
     */
    availableEnergy?: number;
    /**
     * 1
     */
    totalEnergy?: number;
    /**
     * 1
     */
    emailStatus?: number;
  };
}

/**
 * 接口 [通知直出-Page（M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/128) 的 **请求配置的类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /notification/notificationListPage`
 * @更新时间 `2019-05-10 16:55:24`
 */
type NotificationNotificationListPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/notification/notificationListPage",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [通知直出-Page（M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/128) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /notification/notificationListPage`
 * @更新时间 `2019-05-10 16:55:24`
 */
const notificationNotificationListPageRequestConfig: NotificationNotificationListPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/notification/notificationListPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ["pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "notificationNotificationListPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [通知直出-Page（M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/128) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /notification/notificationListPage`
 * @更新时间 `2019-05-10 16:55:24`
 */
export const notificationNotificationListPage = /*#__PURE__*/ (
  requestData: NotificationNotificationListPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<NotificationNotificationListPageResponse>(
    prepare(notificationNotificationListPageRequestConfig, requestData),
    ...args
  );
};

notificationNotificationListPage.requestConfig =
  notificationNotificationListPageRequestConfig;

/**
 * 接口 [分页拉取通知-Ajax （M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/135) 的 **请求类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/notification/notificationListAjax`
 * @更新时间 `2019-05-10 16:55:11`
 */
export interface AjaxNotificationNotificationListAjaxRequest {
  pageIndex: string;
}

/**
 * 接口 [分页拉取通知-Ajax （M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/135) 的 **返回类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/notification/notificationListAjax`
 * @更新时间 `2019-05-10 16:55:11`
 */
export interface AjaxNotificationNotificationListAjaxResponse {
  /**
   * [{"id":1,"type":0,"title":"@title","content":"@string","updateTime":"1 day ago","readStatus":0,"ssNum":0,"ssType":0,"ssGetStatus":0,"ssExpireTime":"-17573 day","bookId":6789521301000305,"bookName":"@title","authorName":"@name"}]
   */
  items?: {
    /**
     * 1
     */
    id?: number;
    type?: number;
    /**
     * "@title"
     */
    title?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * "1 day ago"
     */
    updateTime?: string;
    readStatus?: number;
    ssNum?: number;
    ssType?: number;
    ssGetStatus?: number;
    /**
     * "-17573 day"
     */
    ssExpireTime?: string;
    /**
     * 6789521301000305
     */
    bookId?: number;
    /**
     * "@title"
     */
    bookName?: string;
    /**
     * "@name"
     */
    authorName?: string;
  }[];
  /**
   * 37
   */
  total?: number;
  isLast?: number;
}

/**
 * 接口 [分页拉取通知-Ajax （M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/135) 的 **请求配置的类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/notification/notificationListAjax`
 * @更新时间 `2019-05-10 16:55:11`
 */
type AjaxNotificationNotificationListAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/notification/notificationListAjax",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [分页拉取通知-Ajax （M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/135) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/notification/notificationListAjax`
 * @更新时间 `2019-05-10 16:55:11`
 */
const ajaxNotificationNotificationListAjaxRequestConfig: AjaxNotificationNotificationListAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/notification/notificationListAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: ["pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxNotificationNotificationListAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [分页拉取通知-Ajax （M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/135) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/notification/notificationListAjax`
 * @更新时间 `2019-05-10 16:55:11`
 */
export const ajaxNotificationNotificationListAjax = /*#__PURE__*/ (
  requestData: AjaxNotificationNotificationListAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxNotificationNotificationListAjaxResponse>(
    prepare(ajaxNotificationNotificationListAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxNotificationNotificationListAjax.requestConfig =
  ajaxNotificationNotificationListAjaxRequestConfig;

/**
 * 接口 [领取SS(M3.7.0废弃)↗](https://yapi.yuewen.com/project/28/interface/api/386) 的 **请求类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /notification/getSSAjax`
 * @更新时间 `2019-05-10 16:54:57`
 */
export interface NotificationGetSsAjaxRequest {
  id: string;
}

/**
 * 接口 [领取SS(M3.7.0废弃)↗](https://yapi.yuewen.com/project/28/interface/api/386) 的 **返回类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /notification/getSSAjax`
 * @更新时间 `2019-05-10 16:54:57`
 */
export interface NotificationGetSsAjaxResponse {
  /**
   * 1
   */
  addSS?: number;
}

/**
 * 接口 [领取SS(M3.7.0废弃)↗](https://yapi.yuewen.com/project/28/interface/api/386) 的 **请求配置的类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /notification/getSSAjax`
 * @更新时间 `2019-05-10 16:54:57`
 */
type NotificationGetSsAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/notification/getSSAjax",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [领取SS(M3.7.0废弃)↗](https://yapi.yuewen.com/project/28/interface/api/386) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /notification/getSSAjax`
 * @更新时间 `2019-05-10 16:54:57`
 */
const notificationGetSsAjaxRequestConfig: NotificationGetSsAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/notification/getSSAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "notificationGetSsAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [领取SS(M3.7.0废弃)↗](https://yapi.yuewen.com/project/28/interface/api/386) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /notification/getSSAjax`
 * @更新时间 `2019-05-10 16:54:57`
 */
export const notificationGetSsAjax = /*#__PURE__*/ (
  requestData: NotificationGetSsAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<NotificationGetSsAjaxResponse>(
    prepare(notificationGetSsAjaxRequestConfig, requestData),
    ...args
  );
};

notificationGetSsAjax.requestConfig = notificationGetSsAjaxRequestConfig;

/**
 * 接口 [个人主页直出↗](https://yapi.yuewen.com/project/28/interface/api/440) 的 **请求类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/profile/userPage`
 * @更新时间 `2021-03-16 10:13:22`
 */
export interface PageProfileUserPageRequest {}

/**
 * 接口 [个人主页直出↗](https://yapi.yuewen.com/project/28/interface/api/440) 的 **返回类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/profile/userPage`
 * @更新时间 `2021-03-16 10:13:22`
 */
export interface PageProfileUserPageResponse {
  profile?: {
    /**
     * 2355200678
     */
    guid?: number;
    /**
     * "jack"
     */
    name?: string;
    /**
     * "No.1"
     */
    penName?: string;
    /**
     * "http://img.com"
     */
    avatar?: string;
    /**
     * "1"
     */
    level?: string;
    /**
     * "0 //0 普通用户 1 翻译 2 编辑 4-作者 5-作者&译者"
     */
    role?: string;
    /**
     * "1 //1 男，2 女，0 保密"
     */
    gender?: string;
    /**
     * "200003323232 //ms时间戳"
     */
    joinedTime?: string;
    /**
     * "1 // 国家代码，前端缓存代码映射表"
     */
    country?: string;
    /**
     * "I have a Dream"
     */
    sign?: string;
  };
  badgeInfo?: {
    /**
     * 30
     */
    total?: number;
    /**
     * 1
     */
    isLast?: number;
    /**
     * [{"badgeId":1,"badgeType":1,"badgeName":"Endeavor","updateTime":"123 时间戳","baseUrl":"https://xxxxxxx 徽章的baseUrl","maxGrade":4,"achievedMaxGrade":3,"achievedTime":"2017-12-12","achievedGradeGoal":"到达该等级的描述，如： 连续签到100天"}]
     */
    badgeItems?: {
      /**
       * 1
       */
      badgeId?: number;
      /**
       * 1
       */
      badgeType?: number;
      /**
       * "Endeavor"
       */
      badgeName?: string;
      /**
       * "123 时间戳"
       */
      updateTime?: string;
      /**
       * "https://xxxxxxx 徽章的baseUrl"
       */
      baseUrl?: string;
      /**
       * 4
       */
      maxGrade?: number;
      /**
       * 3
       */
      achievedMaxGrade?: number;
      /**
       * "2017-12-12"
       */
      achievedTime?: string;
      /**
       * "到达该等级的描述，如： 连续签到100天"
       */
      achievedGradeGoal?: string;
    }[];
  };
  /**
   * [{"bookId":1,"bookName":"@name","authorName":"name","coverUpdateTime":"333333 //书封变更时间","categoryName":"xuanhuan","totalScore":"3.5","description":"blabla","tagInfo":[{"tagId":"30001","tagName":"Game"}]}]
   */
  translation?: {
    /**
     * 1
     */
    bookId?: number;
    /**
     * "@name"
     */
    bookName?: string;
    /**
     * "name"
     */
    authorName?: string;
    /**
     * "333333 //书封变更时间"
     */
    coverUpdateTime?: string;
    /**
     * "xuanhuan"
     */
    categoryName?: string;
    /**
     * "3.5"
     */
    totalScore?: string;
    /**
     * "blabla"
     */
    description?: string;
    /**
     * [{"tagId":"30001","tagName":"Game"}]
     */
    tagInfo?: {
      /**
       * "30001"
       */
      tagId?: string;
      /**
       * "Game"
       */
      tagName?: string;
    }[];
  }[];
  /**
   * [{"bookId":1,"bookName":"@name","authorName":"@name","coverUpdateTime":"@timestamp","categoryName":"xuanhuan","totalScore":"3.5","description":"@String","tagInfo":[{"tagId":1,"tagName":"Game"}]}]
   */
  original?: {
    /**
     * 1
     */
    bookId?: number;
    /**
     * "@name"
     */
    bookName?: string;
    /**
     * "@name"
     */
    authorName?: string;
    /**
     * "@timestamp"
     */
    coverUpdateTime?: string;
    /**
     * "xuanhuan"
     */
    categoryName?: string;
    /**
     * "3.5"
     */
    totalScore?: string;
    /**
     * "@String"
     */
    description?: string;
    /**
     * [{"tagId":1,"tagName":"Game"}]
     */
    tagInfo?: {
      /**
       * 1
       */
      tagId?: number;
      /**
       * "Game"
       */
      tagName?: string;
    }[];
  }[];
  /**
   * [{"id":"1//动态id","replyType":"2//动态类型，1书评 2章评","opType":"1//0无 1评论 2点赞 3取消点赞","replyStatus":"1:正常评论， -1：审核不通过（被屏蔽），-2：被本人删除 //回复评论的状态","replyContent":"回复的内容","userId":"11//回复人id","userName":"回复人姓名","userImg":"//回复人头像","userRole":"0//0普通用户 1翻译 2编辑","userLevel":"0 //用户等级","penName":"笔名","likeNums":"2//点赞数","bookId":11,"bookName":"书名","authorName":"作者名","totalScore":"3.0","readToChapterIndex":"c22","chapterId":22,"chapterIndex":1,"chapterName":"章名","createTime":"2 days ago","createTimestamp":17172621,"originalId":"43455 // 原始评论的id","originalStatus":"1:正常评论， -1：审核不通过（被屏蔽），-2：被本人删除 //被回复评论的状态","originalContent":"原始评论内容","注释":"点击显示详情时:\n如果replyType是 2 则需要 调用 review/GetChapterReviewsAjax.\n传入当前的 bookId chatperId pageIndex\n如果replyType是 3 则需调用 review/GetReviewDetailAjax.\n传入当前的reviewId pageIndex","reviewId":"22//回复id","reviewStatus":"1:正常评论， -1：审核不通过（被屏蔽），-2：被本人删除 //书评主体状态","chapterCommentType":1}]
   */
  moments?: {
    /**
     * "1//动态id"
     */
    id?: string;
    /**
     * "2//动态类型，1书评 2章评"
     */
    replyType?: string;
    /**
     * "1//0无 1评论 2点赞 3取消点赞"
     */
    opType?: string;
    /**
     * "1:正常评论， -1：审核不通过（被屏蔽），-2：被本人删除 //回复评论的状态"
     */
    replyStatus?: string;
    /**
     * "回复的内容"
     */
    replyContent?: string;
    /**
     * "11//回复人id"
     */
    userId?: string;
    /**
     * "回复人姓名"
     */
    userName?: string;
    /**
     * "//回复人头像"
     */
    userImg?: string;
    /**
     * "0//0普通用户 1翻译 2编辑"
     */
    userRole?: string;
    /**
     * "0 //用户等级"
     */
    userLevel?: string;
    /**
     * "笔名"
     */
    penName?: string;
    /**
     * "2//点赞数"
     */
    likeNums?: string;
    /**
     * 11
     */
    bookId?: number;
    /**
     * "书名"
     */
    bookName?: string;
    /**
     * "作者名"
     */
    authorName?: string;
    /**
     * "3.0"
     */
    totalScore?: string;
    /**
     * "c22"
     */
    readToChapterIndex?: string;
    /**
     * 22
     */
    chapterId?: number;
    /**
     * 1
     */
    chapterIndex?: number;
    /**
     * "章名"
     */
    chapterName?: string;
    /**
     * "2 days ago"
     */
    createTime?: string;
    /**
     * 17172621
     */
    createTimestamp?: number;
    /**
     * "43455 // 原始评论的id"
     */
    originalId?: string;
    /**
     * "1:正常评论， -1：审核不通过（被屏蔽），-2：被本人删除 //被回复评论的状态"
     */
    originalStatus?: string;
    /**
     * "原始评论内容"
     */
    originalContent?: string;
    /**
     * "点击显示详情时:\n如果replyType是 2 则需要 调用 review/GetChapterReviewsAjax.\n传入当前的 bookId chatperId pageIndex\n如果replyType是 3 则需调用 review/GetReviewDetailAjax.\n传入当前的reviewId pageIndex"
     */
    注释?: string;
    /**
     * "22//回复id"
     */
    reviewId?: string;
    /**
     * "1:正常评论， -1：审核不通过（被屏蔽），-2：被本人删除 //书评主体状态"
     */
    reviewStatus?: string;
    /**
     * 1
     */
    chapterCommentType?: number;
  }[];
  /**
   * 20
   */
  total?: number;
  /**
   * 1
   */
  isLast?: number;
  user?: {
    guid?: string;
    /**
     * "昵称"
     */
    nickName?: string;
    /**
     * "真实名称"
     */
    userName?: string;
    /**
     * "笔名"
     */
    penName?: string;
    /**
     * "角色"
     */
    role?: string;
    /**
     * "0-登录 -1-未登录"
     */
    status?: string;
    /**
     * "头像"
     */
    avatar?: string;
    /**
     * "0-当天未签到 1-当天已签到"
     */
    isCheckin?: string;
    /**
     * "1 //用户等级"
     */
    userLevel?: string;
  };
}

/**
 * 接口 [个人主页直出↗](https://yapi.yuewen.com/project/28/interface/api/440) 的 **请求配置的类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/profile/userPage`
 * @更新时间 `2021-03-16 10:13:22`
 */
type PageProfileUserPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/page/profile/userPage",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [个人主页直出↗](https://yapi.yuewen.com/project/28/interface/api/440) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/profile/userPage`
 * @更新时间 `2021-03-16 10:13:22`
 */
const pageProfileUserPageRequestConfig: PageProfileUserPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/page/profile/userPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageProfileUserPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [个人主页直出↗](https://yapi.yuewen.com/project/28/interface/api/440) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/profile/userPage`
 * @更新时间 `2021-03-16 10:13:22`
 */
export const pageProfileUserPage = /*#__PURE__*/ (
  requestData?: PageProfileUserPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PageProfileUserPageResponse>(
    prepare(pageProfileUserPageRequestConfig, requestData),
    ...args
  );
};

pageProfileUserPage.requestConfig = pageProfileUserPageRequestConfig;

/**
 * 接口 [消息list↗](https://yapi.yuewen.com/project/28/interface/api/3221) 的 **请求类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/message/list`
 * @更新时间 `2018-12-26 16:51:28`
 */
export interface AjaxMessageListRequest {}

/**
 * 接口 [消息list↗](https://yapi.yuewen.com/project/28/interface/api/3221) 的 **返回类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/message/list`
 * @更新时间 `2018-12-26 16:51:28`
 */
export interface AjaxMessageListResponse {
  /**
   * 60
   */
  total?: number;
  /**
   * 1
   */
  isLast?: number;
  /**
   * [{"id":3501,"replyType":1,"reviewId":"15128763","replyId":"15128885","opType":1,"userId":41830698,"userName":"","userImg":"https:","userRole":0,"penName":"","likeNums":0,"bookId":"7731137901014305","bookName":"","authorName":"","chapterId":"0","chapterIndex":0,"originalContent":"456","replyContent":"321","createTime":"7 months ago","createTimestamp":1512033536,"replyStatus":1,"originalStatus":1,"reviewStatus":1,"userLevel":3,"badgeInfo":{"badgeId":10008,"badgeType":"General","badgeName":"Author","maxGrade":4,"achievedMaxGrade":2,"achievedTime":"2018-04-09","achievedGradeGoal":"Published more than 10000 words on Webnovel","baseUrl":"https://actimg.webnovel.com/badge/10008/2/","updateTime":1522054249000},"coverUpdateTime":1528874169758,"chapterCommentType":1}]
   */
  items?: {
    /**
     * 3501
     */
    id?: number;
    /**
     * 1
     */
    replyType?: number;
    /**
     * "15128763"
     */
    reviewId?: string;
    /**
     * "15128885"
     */
    replyId?: string;
    /**
     * 1
     */
    opType?: number;
    /**
     * 41830698
     */
    userId?: number;
    userName?: string;
    /**
     * "https:"
     */
    userImg?: string;
    userRole?: number;
    penName?: string;
    likeNums?: number;
    /**
     * "7731137901014305"
     */
    bookId?: string;
    bookName?: string;
    authorName?: string;
    /**
     * "0"
     */
    chapterId?: string;
    chapterIndex?: number;
    /**
     * "456"
     */
    originalContent?: string;
    /**
     * "321"
     */
    replyContent?: string;
    /**
     * "7 months ago"
     */
    createTime?: string;
    /**
     * 1512033536
     */
    createTimestamp?: number;
    /**
     * 1
     */
    replyStatus?: number;
    /**
     * 1
     */
    originalStatus?: number;
    /**
     * 1
     */
    reviewStatus?: number;
    /**
     * 3
     */
    userLevel?: number;
    badgeInfo?: {
      /**
       * 10008
       */
      badgeId?: number;
      /**
       * "General"
       */
      badgeType?: string;
      /**
       * "Author"
       */
      badgeName?: string;
      /**
       * 4
       */
      maxGrade?: number;
      /**
       * 2
       */
      achievedMaxGrade?: number;
      /**
       * "2018-04-09"
       */
      achievedTime?: string;
      /**
       * "Published more than 10000 words on Webnovel"
       */
      achievedGradeGoal?: string;
      /**
       * "https://actimg.webnovel.com/badge/10008/2/"
       */
      baseUrl?: string;
      /**
       * 1522054249000
       */
      updateTime?: number;
    };
    /**
     * 1528874169758
     */
    coverUpdateTime?: number;
    /**
     * 1
     */
    chapterCommentType?: number;
  }[];
  user?: {
    /**
     * "https://userimg.webnovel.com/userheadimg/2986420237/1/1.jpg?mt=1523343096000"
     */
    avatar?: string;
    nickName?: null;
    /**
     * "wentao"
     */
    userName?: string;
    /**
     * "2986420237"
     */
    guid?: string;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * "wentao"
     */
    penName?: string;
    /**
     * 3
     */
    userLevel?: number;
  };
}

/**
 * 接口 [消息list↗](https://yapi.yuewen.com/project/28/interface/api/3221) 的 **请求配置的类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/message/list`
 * @更新时间 `2018-12-26 16:51:28`
 */
type AjaxMessageListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/message/list",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [消息list↗](https://yapi.yuewen.com/project/28/interface/api/3221) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/message/list`
 * @更新时间 `2018-12-26 16:51:28`
 */
const ajaxMessageListRequestConfig: AjaxMessageListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/message/list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxMessageList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [消息list↗](https://yapi.yuewen.com/project/28/interface/api/3221) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/message/list`
 * @更新时间 `2018-12-26 16:51:28`
 */
export const ajaxMessageList = /*#__PURE__*/ (
  requestData?: AjaxMessageListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxMessageListResponse>(
    prepare(ajaxMessageListRequestConfig, requestData),
    ...args
  );
};

ajaxMessageList.requestConfig = ajaxMessageListRequestConfig;

/**
 * 接口 [UserInfoAjax↗](https://yapi.yuewen.com/project/28/interface/api/3880) 的 **请求类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/user/UserInfoAjax`
 * @更新时间 `2020-12-03 17:32:25`
 */
export interface AjaxUserUserInfoAjaxRequest {}

/**
 * 接口 [UserInfoAjax↗](https://yapi.yuewen.com/project/28/interface/api/3880) 的 **返回类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/user/UserInfoAjax`
 * @更新时间 `2020-12-03 17:32:25`
 */
export interface AjaxUserUserInfoAjaxResponse {
  profile: {
    guid: string;
    nickName: string;
    userName: string;
    penName: string;
    role: string;
    status: number;
    avatar: string;
    SS: number;
    availableEnergy: number;
    availablePower: number;
    toExpiredSS: number;
    toExpiredAfter: number;
    isCheckin: number;
    userLevel: "10";
    UUT: number;
    /**
     * 0-没有资格购买会员卡 1-有资格购买会员卡
     */
    membershipQua: number;
    /**
     * 0-没有购买会员卡 1-购买会员卡且未过期  2-购买过已经过期
     */
    membershipStatus: number;
    /**
     * 过期时间戳
     */
    membershipExpireTime: number;
  };
}

/**
 * 接口 [UserInfoAjax↗](https://yapi.yuewen.com/project/28/interface/api/3880) 的 **请求配置的类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/user/UserInfoAjax`
 * @更新时间 `2020-12-03 17:32:25`
 */
type AjaxUserUserInfoAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/user/UserInfoAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [UserInfoAjax↗](https://yapi.yuewen.com/project/28/interface/api/3880) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/user/UserInfoAjax`
 * @更新时间 `2020-12-03 17:32:25`
 */
const ajaxUserUserInfoAjaxRequestConfig: AjaxUserUserInfoAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/user/UserInfoAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxUserUserInfoAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [UserInfoAjax↗](https://yapi.yuewen.com/project/28/interface/api/3880) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/user/UserInfoAjax`
 * @更新时间 `2020-12-03 17:32:25`
 */
export const ajaxUserUserInfoAjax = /*#__PURE__*/ (
  requestData?: AjaxUserUserInfoAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxUserUserInfoAjaxResponse>(
    prepare(ajaxUserUserInfoAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxUserUserInfoAjax.requestConfig = ajaxUserUserInfoAjaxRequestConfig;

/**
 * 接口 [user\/UserInfoReact↗](https://yapi.yuewen.com/project/28/interface/api/10161) 的 **请求类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/user/UserInfoReact`
 * @更新时间 `2020-02-18 11:33:21`
 */
export interface PageUserUserInfoReactRequest {}

/**
 * 接口 [user\/UserInfoReact↗](https://yapi.yuewen.com/project/28/interface/api/10161) 的 **返回类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/user/UserInfoReact`
 * @更新时间 `2020-02-18 11:33:21`
 */
export interface PageUserUserInfoReactResponse {
  user?: {
    /**
     * "2959616949"
     */
    guid?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/2959616949/1/1.jpg?mt=1530843578000"
     */
    avatar?: string;
    /**
     * "Eason"
     */
    userName?: string;
    nickName?: null;
    penName?: string;
    role?: number;
    status?: number;
    /**
     * 16725
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 3
     */
    userLevel?: number;
    /**
     * 1
     */
    availablePower?: number;
    /**
     * 1
     */
    totalPower?: number;
    /**
     * 2
     */
    availableEnergy?: number;
    /**
     * 2
     */
    totalEnergy?: number;
    /**
     * 1
     */
    emailStatus?: number;
    /**
     * 1530843578000
     */
    mt?: number;
  };
}

/**
 * 接口 [user\/UserInfoReact↗](https://yapi.yuewen.com/project/28/interface/api/10161) 的 **请求配置的类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/user/UserInfoReact`
 * @更新时间 `2020-02-18 11:33:21`
 */
type PageUserUserInfoReactRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/page/user/UserInfoReact",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [user\/UserInfoReact↗](https://yapi.yuewen.com/project/28/interface/api/10161) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/user/UserInfoReact`
 * @更新时间 `2020-02-18 11:33:21`
 */
const pageUserUserInfoReactRequestConfig: PageUserUserInfoReactRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/page/user/UserInfoReact",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageUserUserInfoReact",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [user\/UserInfoReact↗](https://yapi.yuewen.com/project/28/interface/api/10161) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/user/UserInfoReact`
 * @更新时间 `2020-02-18 11:33:21`
 */
export const pageUserUserInfoReact = /*#__PURE__*/ (
  requestData?: PageUserUserInfoReactRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PageUserUserInfoReactResponse>(
    prepare(pageUserUserInfoReactRequestConfig, requestData),
    ...args
  );
};

pageUserUserInfoReact.requestConfig = pageUserUserInfoReactRequestConfig;

/**
 * 接口 [个人主页↗](https://yapi.yuewen.com/project/28/interface/api/11584) 的 **请求类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/profile/userPage`
 * @更新时间 `2018-12-26 16:55:42`
 */
export interface AjaxProfileUserPageRequest {}

/**
 * 接口 [个人主页↗](https://yapi.yuewen.com/project/28/interface/api/11584) 的 **返回类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/profile/userPage`
 * @更新时间 `2018-12-26 16:55:42`
 */
export interface AjaxProfileUserPageResponse {
  profile?: {
    /**
     * 2355200678
     */
    guid?: number;
    /**
     * "jack"
     */
    name?: string;
    /**
     * "No.1"
     */
    penName?: string;
    /**
     * "http://img.com"
     */
    avatar?: string;
    /**
     * "1"
     */
    level?: string;
    /**
     * "0 //0 普通用户 1 翻译 2 编辑 4-作者 5-作者&译者"
     */
    role?: string;
    /**
     * "1 //1 男，2 女，0 保密"
     */
    gender?: string;
    /**
     * "200003323232 //ms时间戳"
     */
    joinedTime?: string;
    /**
     * "1 // 国家代码，前端缓存代码映射表"
     */
    country?: string;
    /**
     * "I have a Dream"
     */
    sign?: string;
  };
  badgeInfo?: {
    /**
     * 30
     */
    total?: number;
    /**
     * 1
     */
    isLast?: number;
    /**
     * [{"badgeId":1,"badgeType":1,"badgeName":"Endeavor","updateTime":"123 时间戳","baseUrl":"https://xxxxxxx 徽章的baseUrl","maxGrade":4,"achievedMaxGrade":3,"achievedTime":"2017-12-12","achievedGradeGoal":"到达该等级的描述，如： 连续签到100天"}]
     */
    badgeItems?: {
      /**
       * 1
       */
      badgeId?: number;
      /**
       * 1
       */
      badgeType?: number;
      /**
       * "Endeavor"
       */
      badgeName?: string;
      /**
       * "123 时间戳"
       */
      updateTime?: string;
      /**
       * "https://xxxxxxx 徽章的baseUrl"
       */
      baseUrl?: string;
      /**
       * 4
       */
      maxGrade?: number;
      /**
       * 3
       */
      achievedMaxGrade?: number;
      /**
       * "2017-12-12"
       */
      achievedTime?: string;
      /**
       * "到达该等级的描述，如： 连续签到100天"
       */
      achievedGradeGoal?: string;
    }[];
  };
  /**
   * [{"bookId":1,"bookName":"@name","authorName":"name","coverUpdateTime":"333333 //书封变更时间","categoryName":"xuanhuan","totalScore":"3.5","description":"blabla","tagInfo":[{"tagId":"30001","tagName":"Game"}]}]
   */
  translation?: {
    /**
     * 1
     */
    bookId?: number;
    /**
     * "@name"
     */
    bookName?: string;
    /**
     * "name"
     */
    authorName?: string;
    /**
     * "333333 //书封变更时间"
     */
    coverUpdateTime?: string;
    /**
     * "xuanhuan"
     */
    categoryName?: string;
    /**
     * "3.5"
     */
    totalScore?: string;
    /**
     * "blabla"
     */
    description?: string;
    /**
     * [{"tagId":"30001","tagName":"Game"}]
     */
    tagInfo?: {
      /**
       * "30001"
       */
      tagId?: string;
      /**
       * "Game"
       */
      tagName?: string;
    }[];
  }[];
  /**
   * [{"bookId":1,"bookName":"@name","authorName":"@name","coverUpdateTime":"@timestamp","categoryName":"xuanhuan","totalScore":"3.5","description":"@String","tagInfo":[{"tagId":1,"tagName":"Game"}]}]
   */
  original?: {
    /**
     * 1
     */
    bookId?: number;
    /**
     * "@name"
     */
    bookName?: string;
    /**
     * "@name"
     */
    authorName?: string;
    /**
     * "@timestamp"
     */
    coverUpdateTime?: string;
    /**
     * "xuanhuan"
     */
    categoryName?: string;
    /**
     * "3.5"
     */
    totalScore?: string;
    /**
     * "@String"
     */
    description?: string;
    /**
     * [{"tagId":1,"tagName":"Game"}]
     */
    tagInfo?: {
      /**
       * 1
       */
      tagId?: number;
      /**
       * "Game"
       */
      tagName?: string;
    }[];
  }[];
  /**
   * [{"id":"1//动态id","replyType":"2//动态类型，1书评 2章评","opType":"1//0无 1评论 2点赞 3取消点赞","replyStatus":1,"replyContent":"回复的内容","userId":"11//回复人id","userName":"回复人姓名","userImg":"//回复人头像","userRole":"0//0普通用户 1翻译 2编辑","userLevel":"0 //用户等级","penName":"笔名","likeNums":"2//点赞数","bookId":11,"bookName":"书名","authorName":"作者名","totalScore":"3.0","readToChapterIndex":"c22","chapterId":22,"chapterIndex":1,"chapterName":"章名","createTime":"2 days ago","createTimestamp":17172621,"originalId":"43455 // 原始评论的id","originalStatus":"1:正常评论， -1：审核不通过（被屏蔽），-2：被本人删除 //被回复评论的状态","originalContent":"原始评论内容","注释":"点击显示详情时:\n如果replyType是 2 则需要 调用 review/GetChapterReviewsAjax.\n传入当前的 bookId chatperId pageIndex\n如果replyType是 3 则需调用 review/GetReviewDetailAjax.\n传入当前的reviewId pageIndex","reviewId":"22//回复id","reviewStatus":"1:正常评论， -1：审核不通过（被屏蔽），-2：被本人删除 //书评主体状态","chapterCommentType":1}]
   */
  moments?: {
    /**
     * "1//动态id"
     */
    id?: string;
    /**
     * "2//动态类型，1书评 2章评"
     */
    replyType?: string;
    /**
     * "1//0无 1评论 2点赞 3取消点赞"
     */
    opType?: string;
    /**
     * 1
     */
    replyStatus?: number;
    /**
     * "回复的内容"
     */
    replyContent?: string;
    /**
     * "11//回复人id"
     */
    userId?: string;
    /**
     * "回复人姓名"
     */
    userName?: string;
    /**
     * "//回复人头像"
     */
    userImg?: string;
    /**
     * "0//0普通用户 1翻译 2编辑"
     */
    userRole?: string;
    /**
     * "0 //用户等级"
     */
    userLevel?: string;
    /**
     * "笔名"
     */
    penName?: string;
    /**
     * "2//点赞数"
     */
    likeNums?: string;
    /**
     * 11
     */
    bookId?: number;
    /**
     * "书名"
     */
    bookName?: string;
    /**
     * "作者名"
     */
    authorName?: string;
    /**
     * "3.0"
     */
    totalScore?: string;
    /**
     * "c22"
     */
    readToChapterIndex?: string;
    /**
     * 22
     */
    chapterId?: number;
    /**
     * 1
     */
    chapterIndex?: number;
    /**
     * "章名"
     */
    chapterName?: string;
    /**
     * "2 days ago"
     */
    createTime?: string;
    /**
     * 17172621
     */
    createTimestamp?: number;
    /**
     * "43455 // 原始评论的id"
     */
    originalId?: string;
    /**
     * "1:正常评论， -1：审核不通过（被屏蔽），-2：被本人删除 //被回复评论的状态"
     */
    originalStatus?: string;
    /**
     * "原始评论内容"
     */
    originalContent?: string;
    /**
     * "点击显示详情时:\n如果replyType是 2 则需要 调用 review/GetChapterReviewsAjax.\n传入当前的 bookId chatperId pageIndex\n如果replyType是 3 则需调用 review/GetReviewDetailAjax.\n传入当前的reviewId pageIndex"
     */
    注释?: string;
    /**
     * "22//回复id"
     */
    reviewId?: string;
    /**
     * "1:正常评论， -1：审核不通过（被屏蔽），-2：被本人删除 //书评主体状态"
     */
    reviewStatus?: string;
    /**
     * 1
     */
    chapterCommentType?: number;
  }[];
  /**
   * 20
   */
  total?: number;
  /**
   * 1
   */
  isLast?: number;
  user?: {
    guid?: string;
    /**
     * "昵称"
     */
    nickName?: string;
    /**
     * "真实名称"
     */
    userName?: string;
    /**
     * "笔名"
     */
    penName?: string;
    /**
     * "角色"
     */
    role?: string;
    /**
     * "0-登录 -1-未登录"
     */
    status?: string;
    /**
     * "头像"
     */
    avatar?: string;
    /**
     * "0-当天未签到 1-当天已签到"
     */
    isCheckin?: string;
    /**
     * "1 //用户等级"
     */
    userLevel?: string;
  };
}

/**
 * 接口 [个人主页↗](https://yapi.yuewen.com/project/28/interface/api/11584) 的 **请求配置的类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/profile/userPage`
 * @更新时间 `2018-12-26 16:55:42`
 */
type AjaxProfileUserPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/profile/userPage",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [个人主页↗](https://yapi.yuewen.com/project/28/interface/api/11584) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/profile/userPage`
 * @更新时间 `2018-12-26 16:55:42`
 */
const ajaxProfileUserPageRequestConfig: AjaxProfileUserPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/profile/userPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxProfileUserPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [个人主页↗](https://yapi.yuewen.com/project/28/interface/api/11584) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/profile/userPage`
 * @更新时间 `2018-12-26 16:55:42`
 */
export const ajaxProfileUserPage = /*#__PURE__*/ (
  requestData?: AjaxProfileUserPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxProfileUserPageResponse>(
    prepare(ajaxProfileUserPageRequestConfig, requestData),
    ...args
  );
};

ajaxProfileUserPage.requestConfig = ajaxProfileUserPageRequestConfig;

/**
 * 接口 [获取上传cos密钥↗](https://yapi.yuewen.com/project/28/interface/api/118074) 的 **请求类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /utils/get-cos-temp-key`
 * @更新时间 `2024-09-04 10:22:05`
 */
export interface UtilsGetCosTempKeyRequest {}

/**
 * 接口 [获取上传cos密钥↗](https://yapi.yuewen.com/project/28/interface/api/118074) 的 **返回类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /utils/get-cos-temp-key`
 * @更新时间 `2024-09-04 10:22:05`
 */
export interface UtilsGetCosTempKeyResponse {
  Result?: number;
  /**
   * "Success"
   */
  Message?: string;
  Data?: {
    Cos?: {
      Credentials?: {
        /**
         * "kjasdkjsa"
         */
        Token?: string;
        /**
         * "asdjkwqklkqwqwe"
         */
        TmpSecretId?: string;
        /**
         * "jkwqekjqkjew"
         */
        TmpSecretKey?: string;
      };
      /**
       * 1547696355
       */
      ExpiredTime?: number;
    };
    /**
     * "random-name-balabala.jpg"
     */
    FileName?: string;
  };
}

/**
 * 接口 [获取上传cos密钥↗](https://yapi.yuewen.com/project/28/interface/api/118074) 的 **请求配置的类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /utils/get-cos-temp-key`
 * @更新时间 `2024-09-04 10:22:05`
 */
type UtilsGetCosTempKeyRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/utils/get-cos-temp-key",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取上传cos密钥↗](https://yapi.yuewen.com/project/28/interface/api/118074) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /utils/get-cos-temp-key`
 * @更新时间 `2024-09-04 10:22:05`
 */
const utilsGetCosTempKeyRequestConfig: UtilsGetCosTempKeyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/utils/get-cos-temp-key",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "utilsGetCosTempKey",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取上传cos密钥↗](https://yapi.yuewen.com/project/28/interface/api/118074) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /utils/get-cos-temp-key`
 * @更新时间 `2024-09-04 10:22:05`
 */
export const utilsGetCosTempKey = /*#__PURE__*/ (
  requestData?: UtilsGetCosTempKeyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<UtilsGetCosTempKeyResponse>(
    prepare(utilsGetCosTempKeyRequestConfig, requestData),
    ...args
  );
};

utilsGetCosTempKey.requestConfig = utilsGetCosTempKeyRequestConfig;

/**
 * 接口 [设置用户头像↗](https://yapi.yuewen.com/project/28/interface/api/177923) 的 **请求类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /ajax/user/setUserAvatarAjax`
 * @更新时间 `2020-12-04 14:53:14`
 */
export interface AjaxUserSetUserAvatarAjaxRequest {
  /**
   * 头像
   */
  image: FileData;
}

/**
 * 接口 [设置用户头像↗](https://yapi.yuewen.com/project/28/interface/api/177923) 的 **返回类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /ajax/user/setUserAvatarAjax`
 * @更新时间 `2020-12-04 14:53:14`
 */
export interface AjaxUserSetUserAvatarAjaxResponse {}

/**
 * 接口 [设置用户头像↗](https://yapi.yuewen.com/project/28/interface/api/177923) 的 **请求配置的类型**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /ajax/user/setUserAvatarAjax`
 * @更新时间 `2020-12-04 14:53:14`
 */
type AjaxUserSetUserAvatarAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/user/setUserAvatarAjax",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [设置用户头像↗](https://yapi.yuewen.com/project/28/interface/api/177923) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /ajax/user/setUserAvatarAjax`
 * @更新时间 `2020-12-04 14:53:14`
 */
const ajaxUserSetUserAvatarAjaxRequestConfig: AjaxUserSetUserAvatarAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/user/setUserAvatarAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxUserSetUserAvatarAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [设置用户头像↗](https://yapi.yuewen.com/project/28/interface/api/177923) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /ajax/user/setUserAvatarAjax`
 * @更新时间 `2020-12-04 14:53:14`
 */
export const ajaxUserSetUserAvatarAjax = /*#__PURE__*/ (
  requestData: AjaxUserSetUserAvatarAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxUserSetUserAvatarAjaxResponse>(
    prepare(ajaxUserSetUserAvatarAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxUserSetUserAvatarAjax.requestConfig =
  ajaxUserSetUserAvatarAjaxRequestConfig;

const mockUrl_0_1_0_3 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_3 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_3 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_3 = "data" as any;

/**
 * 接口 [拉取设置页信息↗](https://yapi.yuewen.com/project/28/interface/api/501) 的 **请求类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/infoAjax`
 * @更新时间 `2020-06-01 13:53:53`
 */
export interface AjaxSettingsInfoAjaxRequest {}

/**
 * 接口 [拉取设置页信息↗](https://yapi.yuewen.com/project/28/interface/api/501) 的 **返回类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/infoAjax`
 * @更新时间 `2020-06-01 13:53:53`
 */
export interface AjaxSettingsInfoAjaxResponse {
  settings?: {
    /**
     * 2695871533
     */
    guid?: number;
    /**
     * "ziven"
     */
    name?: string;
    /**
     * "ziven"
     */
    penName?: string;
    /**
     * "//userimg.webnovel.com/userheadimg/2695871533/1/1.jpg?mt=1590989300000?mt=1560832590561"
     */
    avatar?: string;
    /**
     * 1
     */
    gender?: number;
    /**
     * "CN"
     */
    country?: string;
    /**
     * "BU"
     */
    sign?: string;
    /**
     * "heartstar27@qq.com"
     */
    notiEmail?: string;
    /**
     * 1
     */
    notiEmailStatus?: number;
    /**
     * 2695871533
     */
    userId?: number;
    /**
     * 1560832590561
     */
    UUT?: number;
    /**
     * 1
     */
    receiveArrivals?: number;
    /**
     * 1
     */
    receivePower?: number;
    accType?: null;
  };
}

/**
 * 接口 [拉取设置页信息↗](https://yapi.yuewen.com/project/28/interface/api/501) 的 **请求配置的类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/infoAjax`
 * @更新时间 `2020-06-01 13:53:53`
 */
type AjaxSettingsInfoAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/settings/infoAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [拉取设置页信息↗](https://yapi.yuewen.com/project/28/interface/api/501) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/infoAjax`
 * @更新时间 `2020-06-01 13:53:53`
 */
const ajaxSettingsInfoAjaxRequestConfig: AjaxSettingsInfoAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/infoAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsInfoAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [拉取设置页信息↗](https://yapi.yuewen.com/project/28/interface/api/501) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/infoAjax`
 * @更新时间 `2020-06-01 13:53:53`
 */
export const ajaxSettingsInfoAjax = /*#__PURE__*/ (
  requestData?: AjaxSettingsInfoAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSettingsInfoAjaxResponse>(
    prepare(ajaxSettingsInfoAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxSettingsInfoAjax.requestConfig = ajaxSettingsInfoAjaxRequestConfig;

/**
 * 接口 [检测用户名↗](https://yapi.yuewen.com/project/28/interface/api/506) 的 **请求类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/checkNameAjax`
 * @更新时间 `2024-08-09 15:41:53`
 */
export interface AjaxSettingsCheckNameAjaxRequest {}

/**
 * 接口 [检测用户名↗](https://yapi.yuewen.com/project/28/interface/api/506) 的 **返回类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/checkNameAjax`
 * @更新时间 `2024-08-09 15:41:53`
 */
export interface AjaxSettingsCheckNameAjaxResponse {
  code?: number;
}

/**
 * 接口 [检测用户名↗](https://yapi.yuewen.com/project/28/interface/api/506) 的 **请求配置的类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/checkNameAjax`
 * @更新时间 `2024-08-09 15:41:53`
 */
type AjaxSettingsCheckNameAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/settings/checkNameAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [检测用户名↗](https://yapi.yuewen.com/project/28/interface/api/506) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/checkNameAjax`
 * @更新时间 `2024-08-09 15:41:53`
 */
const ajaxSettingsCheckNameAjaxRequestConfig: AjaxSettingsCheckNameAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/checkNameAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsCheckNameAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [检测用户名↗](https://yapi.yuewen.com/project/28/interface/api/506) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/checkNameAjax`
 * @更新时间 `2024-08-09 15:41:53`
 */
export const ajaxSettingsCheckNameAjax = /*#__PURE__*/ (
  requestData?: AjaxSettingsCheckNameAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSettingsCheckNameAjaxResponse>(
    prepare(ajaxSettingsCheckNameAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxSettingsCheckNameAjax.requestConfig =
  ajaxSettingsCheckNameAjaxRequestConfig;

/**
 * 接口 [第一次添加邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4319) 的 **请求类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/FirstAddEmail`
 * @更新时间 `2020-12-18 11:36:38`
 */
export interface AjaxSettingsFirstAddEmailRequest {
  /**
   * 邮箱
   */
  email: string;
}

/**
 * 接口 [第一次添加邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4319) 的 **返回类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/FirstAddEmail`
 * @更新时间 `2020-12-18 11:36:38`
 */
export interface AjaxSettingsFirstAddEmailResponse {
  /**
   * 0 成功 1 失败
   */
  code: number;
  /**
   * code's been sent 5 times. Try 6h later
   */
  msg: string;
}

/**
 * 接口 [第一次添加邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4319) 的 **请求配置的类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/FirstAddEmail`
 * @更新时间 `2020-12-18 11:36:38`
 */
type AjaxSettingsFirstAddEmailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/settings/FirstAddEmail",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [第一次添加邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4319) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/FirstAddEmail`
 * @更新时间 `2020-12-18 11:36:38`
 */
const ajaxSettingsFirstAddEmailRequestConfig: AjaxSettingsFirstAddEmailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/FirstAddEmail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsFirstAddEmail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [第一次添加邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4319) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/FirstAddEmail`
 * @更新时间 `2020-12-18 11:36:38`
 */
export const ajaxSettingsFirstAddEmail = /*#__PURE__*/ (
  requestData: AjaxSettingsFirstAddEmailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSettingsFirstAddEmailResponse>(
    prepare(ajaxSettingsFirstAddEmailRequestConfig, requestData),
    ...args
  );
};

ajaxSettingsFirstAddEmail.requestConfig =
  ajaxSettingsFirstAddEmailRequestConfig;

/**
 * 接口 [给老邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4333) 的 **请求类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/SendCaptchaOEmail`
 * @更新时间 `2018-06-26 16:54:54`
 */
export interface AjaxSettingsSendCaptchaOEmailRequest {
  email: string;
}

/**
 * 接口 [给老邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4333) 的 **返回类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/SendCaptchaOEmail`
 * @更新时间 `2018-06-26 16:54:54`
 */
export interface AjaxSettingsSendCaptchaOEmailResponse {
  /**
   * 0 成功 其他 失败
   */
  code: number;
  /**
   * Code 's been sent 5 times. Try 6h later
   */
  msg: string;
}

/**
 * 接口 [给老邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4333) 的 **请求配置的类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/SendCaptchaOEmail`
 * @更新时间 `2018-06-26 16:54:54`
 */
type AjaxSettingsSendCaptchaOEmailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/settings/SendCaptchaOEmail",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [给老邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4333) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/SendCaptchaOEmail`
 * @更新时间 `2018-06-26 16:54:54`
 */
const ajaxSettingsSendCaptchaOEmailRequestConfig: AjaxSettingsSendCaptchaOEmailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/SendCaptchaOEmail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsSendCaptchaOEmail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [给老邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4333) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/SendCaptchaOEmail`
 * @更新时间 `2018-06-26 16:54:54`
 */
export const ajaxSettingsSendCaptchaOEmail = /*#__PURE__*/ (
  requestData: AjaxSettingsSendCaptchaOEmailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSettingsSendCaptchaOEmailResponse>(
    prepare(ajaxSettingsSendCaptchaOEmailRequestConfig, requestData),
    ...args
  );
};

ajaxSettingsSendCaptchaOEmail.requestConfig =
  ajaxSettingsSendCaptchaOEmailRequestConfig;

/**
 * 接口 [验证邮箱的验证码↗](https://yapi.yuewen.com/project/28/interface/api/4354) 的 **请求类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/VerifyCaptcha`
 * @更新时间 `2018-06-25 15:23:55`
 */
export interface AjaxSettingsVerifyCaptchaRequest {
  /**
   * 老邮箱
   */
  email: string;
  /**
   * 验证码
   */
  verifyCode: string;
}

/**
 * 接口 [验证邮箱的验证码↗](https://yapi.yuewen.com/project/28/interface/api/4354) 的 **返回类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/VerifyCaptcha`
 * @更新时间 `2018-06-25 15:23:55`
 */
export interface AjaxSettingsVerifyCaptchaResponse {
  /**
   * token值
   */
  token: string;
}

/**
 * 接口 [验证邮箱的验证码↗](https://yapi.yuewen.com/project/28/interface/api/4354) 的 **请求配置的类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/VerifyCaptcha`
 * @更新时间 `2018-06-25 15:23:55`
 */
type AjaxSettingsVerifyCaptchaRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/settings/VerifyCaptcha",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [验证邮箱的验证码↗](https://yapi.yuewen.com/project/28/interface/api/4354) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/VerifyCaptcha`
 * @更新时间 `2018-06-25 15:23:55`
 */
const ajaxSettingsVerifyCaptchaRequestConfig: AjaxSettingsVerifyCaptchaRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/VerifyCaptcha",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsVerifyCaptcha",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [验证邮箱的验证码↗](https://yapi.yuewen.com/project/28/interface/api/4354) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/VerifyCaptcha`
 * @更新时间 `2018-06-25 15:23:55`
 */
export const ajaxSettingsVerifyCaptcha = /*#__PURE__*/ (
  requestData: AjaxSettingsVerifyCaptchaRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSettingsVerifyCaptchaResponse>(
    prepare(ajaxSettingsVerifyCaptchaRequestConfig, requestData),
    ...args
  );
};

ajaxSettingsVerifyCaptcha.requestConfig =
  ajaxSettingsVerifyCaptchaRequestConfig;

/**
 * 接口 [给新邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4356) 的 **请求类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/setting/SendCaptchaNEmail`
 * @更新时间 `2018-06-26 16:57:22`
 */
export interface AjaxSettingSendCaptchaNEmailRequest {
  /**
   * token值
   */
  token: string;
  /**
   * 邮箱
   */
  email: string;
}

/**
 * 接口 [给新邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4356) 的 **返回类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/setting/SendCaptchaNEmail`
 * @更新时间 `2018-06-26 16:57:22`
 */
export interface AjaxSettingSendCaptchaNEmailResponse {
  code: number;
  msg: "code's been sent 5 times. Try 6h later";
}

/**
 * 接口 [给新邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4356) 的 **请求配置的类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/setting/SendCaptchaNEmail`
 * @更新时间 `2018-06-26 16:57:22`
 */
type AjaxSettingSendCaptchaNEmailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/setting/SendCaptchaNEmail",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [给新邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4356) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/setting/SendCaptchaNEmail`
 * @更新时间 `2018-06-26 16:57:22`
 */
const ajaxSettingSendCaptchaNEmailRequestConfig: AjaxSettingSendCaptchaNEmailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/setting/SendCaptchaNEmail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingSendCaptchaNEmail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [给新邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4356) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/setting/SendCaptchaNEmail`
 * @更新时间 `2018-06-26 16:57:22`
 */
export const ajaxSettingSendCaptchaNEmail = /*#__PURE__*/ (
  requestData: AjaxSettingSendCaptchaNEmailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSettingSendCaptchaNEmailResponse>(
    prepare(ajaxSettingSendCaptchaNEmailRequestConfig, requestData),
    ...args
  );
};

ajaxSettingSendCaptchaNEmail.requestConfig =
  ajaxSettingSendCaptchaNEmailRequestConfig;

/**
 * 接口 [确认修改邮箱↗](https://yapi.yuewen.com/project/28/interface/api/4385) 的 **请求类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/ModifyMail`
 * @更新时间 `2018-06-26 14:03:33`
 */
export interface AjaxSettingsModifyMailRequest {
  /**
   * 邮箱
   */
  email: string;
  /**
   * 验证码
   */
  verifyCode: string;
  /**
   * token值
   */
  token: string;
}

/**
 * 接口 [确认修改邮箱↗](https://yapi.yuewen.com/project/28/interface/api/4385) 的 **返回类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/ModifyMail`
 * @更新时间 `2018-06-26 14:03:33`
 */
export interface AjaxSettingsModifyMailResponse {
  code: number;
}

/**
 * 接口 [确认修改邮箱↗](https://yapi.yuewen.com/project/28/interface/api/4385) 的 **请求配置的类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/ModifyMail`
 * @更新时间 `2018-06-26 14:03:33`
 */
type AjaxSettingsModifyMailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/settings/ModifyMail",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [确认修改邮箱↗](https://yapi.yuewen.com/project/28/interface/api/4385) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/ModifyMail`
 * @更新时间 `2018-06-26 14:03:33`
 */
const ajaxSettingsModifyMailRequestConfig: AjaxSettingsModifyMailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/ModifyMail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsModifyMail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [确认修改邮箱↗](https://yapi.yuewen.com/project/28/interface/api/4385) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/ModifyMail`
 * @更新时间 `2018-06-26 14:03:33`
 */
export const ajaxSettingsModifyMail = /*#__PURE__*/ (
  requestData: AjaxSettingsModifyMailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSettingsModifyMailResponse>(
    prepare(ajaxSettingsModifyMailRequestConfig, requestData),
    ...args
  );
};

ajaxSettingsModifyMail.requestConfig = ajaxSettingsModifyMailRequestConfig;

/**
 * 接口 [保存用户基本信息↗](https://yapi.yuewen.com/project/28/interface/api/6524) 的 **请求类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/modifyUserInfoAjax`
 * @更新时间 `2020-12-15 16:15:56`
 */
export interface AjaxSettingsModifyUserInfoAjaxRequest {
  /**
   * 名字
   */
  name: string;
  /**
   * 性别
   */
  gender: string;
  /**
   * 国家
   */
  country: string;
  /**
   * about
   */
  sign: string;
  /**
   * 1 表示接受arrivals 0 不接收【没用到】
   */
  receiveArrivals: string;
  /**
   * 1 表示接受power邮件  0 不接收【没用到】
   */
  receivePower: string;
}

/**
 * 接口 [保存用户基本信息↗](https://yapi.yuewen.com/project/28/interface/api/6524) 的 **返回类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/modifyUserInfoAjax`
 * @更新时间 `2020-12-15 16:15:56`
 */
export interface AjaxSettingsModifyUserInfoAjaxResponse {
  code?: number;
  /**
   * "User Info has been modified."
   */
  msg?: string;
}

/**
 * 接口 [保存用户基本信息↗](https://yapi.yuewen.com/project/28/interface/api/6524) 的 **请求配置的类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/modifyUserInfoAjax`
 * @更新时间 `2020-12-15 16:15:56`
 */
type AjaxSettingsModifyUserInfoAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/settings/modifyUserInfoAjax",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存用户基本信息↗](https://yapi.yuewen.com/project/28/interface/api/6524) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/modifyUserInfoAjax`
 * @更新时间 `2020-12-15 16:15:56`
 */
const ajaxSettingsModifyUserInfoAjaxRequestConfig: AjaxSettingsModifyUserInfoAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/modifyUserInfoAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsModifyUserInfoAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存用户基本信息↗](https://yapi.yuewen.com/project/28/interface/api/6524) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/modifyUserInfoAjax`
 * @更新时间 `2020-12-15 16:15:56`
 */
export const ajaxSettingsModifyUserInfoAjax = /*#__PURE__*/ (
  requestData: AjaxSettingsModifyUserInfoAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSettingsModifyUserInfoAjaxResponse>(
    prepare(ajaxSettingsModifyUserInfoAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxSettingsModifyUserInfoAjax.requestConfig =
  ajaxSettingsModifyUserInfoAjaxRequestConfig;

/**
 * 接口 [校验邮箱是否被用过↗](https://yapi.yuewen.com/project/28/interface/api/7102) 的 **请求类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/CheckEmailAjax`
 * @更新时间 `2018-07-09 14:38:45`
 */
export interface AjaxSettingsCheckEmailAjaxRequest {
  /**
   * 邮箱
   */
  email: string;
}

/**
 * 接口 [校验邮箱是否被用过↗](https://yapi.yuewen.com/project/28/interface/api/7102) 的 **返回类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/CheckEmailAjax`
 * @更新时间 `2018-07-09 14:38:45`
 */
export interface AjaxSettingsCheckEmailAjaxResponse {
  code: number;
  msg: string;
}

/**
 * 接口 [校验邮箱是否被用过↗](https://yapi.yuewen.com/project/28/interface/api/7102) 的 **请求配置的类型**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/CheckEmailAjax`
 * @更新时间 `2018-07-09 14:38:45`
 */
type AjaxSettingsCheckEmailAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/settings/CheckEmailAjax",
    "data",
    string,
    "email",
    false
  >
>;

/**
 * 接口 [校验邮箱是否被用过↗](https://yapi.yuewen.com/project/28/interface/api/7102) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/CheckEmailAjax`
 * @更新时间 `2018-07-09 14:38:45`
 */
const ajaxSettingsCheckEmailAjaxRequestConfig: AjaxSettingsCheckEmailAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/CheckEmailAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: ["email"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsCheckEmailAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [校验邮箱是否被用过↗](https://yapi.yuewen.com/project/28/interface/api/7102) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/CheckEmailAjax`
 * @更新时间 `2018-07-09 14:38:45`
 */
export const ajaxSettingsCheckEmailAjax = /*#__PURE__*/ (
  requestData: AjaxSettingsCheckEmailAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSettingsCheckEmailAjaxResponse>(
    prepare(ajaxSettingsCheckEmailAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxSettingsCheckEmailAjax.requestConfig =
  ajaxSettingsCheckEmailAjaxRequestConfig;

const mockUrl_0_1_0_4 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_4 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_4 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_4 = "data" as any;

/**
 * 接口 [拉取章评列表-Page↗](https://yapi.yuewen.com/project/28/interface/api/114) 的 **请求类型**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /chapterReview/index`
 * @更新时间 `2018-08-01 10:40:27`
 */
export interface ChapterReviewIndexRequest {
  bookId: string;
  chapterId: string;
  /**
   * 1-点赞数降序，2-发布时间降序，3-发布时间升序
   */
  orderType: string;
}

/**
 * 接口 [拉取章评列表-Page↗](https://yapi.yuewen.com/project/28/interface/api/114) 的 **返回类型**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /chapterReview/index`
 * @更新时间 `2018-08-01 10:40:27`
 */
export interface ChapterReviewIndexResponse {
  /**
   * 4
   */
  total?: number;
  /**
   * 1
   */
  isLast?: number;
  /**
   * [{"reviewId":1,"content":"bdfb","userId":1,"createTime":"3 weeks ago","userName":"Alice01","role":0,"penName":"","avatar":"//oauserimg.webnovel.com/userheadimg/2183903537/1/1.jpg","reviewType":1,"likeNums":1,"status":1,"pStatus":-1,"userLevel":2,"badgeInfo":{"badgeId":10003,"badgeType":"@string","badgeName":"@string","maxGrade":1,"achievedMaxGrade":1,"achievedTime":"2018-01-30","achievedGradeGoal":"To be a Premium user","baseUrl":"@image","updateTime":"@timestamp"},"isLiked":true,"commentType":" 1   // 1普通评论 2打赏评论"}]
   */
  reviewItems?: {
    /**
     * 1
     */
    reviewId?: number;
    /**
     * "bdfb"
     */
    content?: string;
    /**
     * 1
     */
    userId?: number;
    /**
     * "3 weeks ago"
     */
    createTime?: string;
    /**
     * "Alice01"
     */
    userName?: string;
    role?: number;
    penName?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/2183903537/1/1.jpg"
     */
    avatar?: string;
    /**
     * 1
     */
    reviewType?: number;
    /**
     * 1
     */
    likeNums?: number;
    /**
     * 1
     */
    status?: number;
    /**
     * -1
     */
    pStatus?: number;
    /**
     * 2
     */
    userLevel?: number;
    badgeInfo?: {
      /**
       * 10003
       */
      badgeId?: number;
      /**
       * "@string"
       */
      badgeType?: string;
      /**
       * "@string"
       */
      badgeName?: string;
      /**
       * 1
       */
      maxGrade?: number;
      /**
       * 1
       */
      achievedMaxGrade?: number;
      /**
       * "2018-01-30"
       */
      achievedTime?: string;
      /**
       * "To be a Premium user"
       */
      achievedGradeGoal?: string;
      /**
       * "@image"
       */
      baseUrl?: string;
      /**
       * "@timestamp"
       */
      updateTime?: string;
    };
    /**
     * true
     */
    isLiked?: boolean;
    /**
     * " 1   // 1普通评论 2打赏评论"
     */
    commentType?: string;
  }[];
  bookInfo?: {
    bookId?: string;
    bookName?: null;
    authorName?: null;
    /**
     * []
     */
    groupItems?: unknown[];
    /**
     * []
     */
    translatorItems?: unknown[];
    /**
     * []
     */
    editorItems?: unknown[];
    categoryName?: null;
    categoryId?: null;
    updateFrequency?: null;
    /**
     * "chs / XXXX"
     */
    frequencyUnit?: string;
    chapterNum?: null;
    actionStatus?: number;
    /**
     * "5.0"
     */
    totalScore?: string;
    voters?: null;
    description?: null;
    totalChapterNum?: null;
    /**
     * [{"text":null,"url":"https://m.qidian.com/book/"}]
     */
    language?: {
      text?: null;
      /**
       * "https://m.qidian.com/book/"
       */
      url?: string;
    }[];
    /**
     * []
     */
    tagInfo?: unknown[];
    /**
     * 1
     */
    type?: number;
    firstChapterId?: string;
    inLibrary?: number;
    /**
     * "0"
     */
    readToChapterId?: string;
    readToChapterIndex?: number;
    coverUpdateTime?: number;
    /**
     * 75
     */
    powerRank?: number;
    patreonLink?: string;
    /**
     * []
     */
    animationItems?: unknown[];
    /**
     * []
     */
    notes?: unknown[];
    energyNum?: number;
    /**
     * 6
     */
    chapterIndex?: number;
    /**
     * "chapter 6"
     */
    chapterName?: string;
    /**
     * "25529445611796611"
     */
    chapterId?: string;
  };
  user?: {
    /**
     * "1520658766"
     */
    guid?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/1520658766/1/1.jpg?mt=1514431857000"
     */
    avatar?: string;
    /**
     * "zhangdroid2423"
     */
    userName?: string;
    nickName?: null;
    penName?: null;
    role?: number;
    status?: number;
    /**
     * 12012
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 4
     */
    userLevel?: number;
    /**
     * 2
     */
    availablePower?: number;
    /**
     * 2
     */
    totalPower?: number;
    /**
     * 2
     */
    availableEnergy?: number;
    /**
     * 2
     */
    totalEnergy?: number;
    /**
     * 1
     */
    emailStatus?: number;
  };
}

/**
 * 接口 [拉取章评列表-Page↗](https://yapi.yuewen.com/project/28/interface/api/114) 的 **请求配置的类型**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /chapterReview/index`
 * @更新时间 `2018-08-01 10:40:27`
 */
type ChapterReviewIndexRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/chapterReview/index",
    "data",
    string,
    "bookId" | "chapterId" | "orderType",
    false
  >
>;

/**
 * 接口 [拉取章评列表-Page↗](https://yapi.yuewen.com/project/28/interface/api/114) 的 **请求配置**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /chapterReview/index`
 * @更新时间 `2018-08-01 10:40:27`
 */
const chapterReviewIndexRequestConfig: ChapterReviewIndexRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_4,
    devUrl: devUrl_0_1_0_4,
    prodUrl: prodUrl_0_1_0_4,
    path: "/chapterReview/index",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_4,
    paramNames: [],
    queryNames: ["bookId", "chapterId", "orderType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "chapterReviewIndex",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [拉取章评列表-Page↗](https://yapi.yuewen.com/project/28/interface/api/114) 的 **请求函数**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /chapterReview/index`
 * @更新时间 `2018-08-01 10:40:27`
 */
export const chapterReviewIndex = /*#__PURE__*/ (
  requestData: ChapterReviewIndexRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ChapterReviewIndexResponse>(
    prepare(chapterReviewIndexRequestConfig, requestData),
    ...args
  );
};

chapterReviewIndex.requestConfig = chapterReviewIndexRequestConfig;

/**
 * 接口 [拉取章评列表-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/121) 的 **请求类型**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /ajax/chapterReview/list`
 * @更新时间 `2020-07-01 16:44:44`
 */
export interface AjaxChapterReviewListRequest {
  bookId: string;
  chapterId: string;
  pageIndex: string;
  orderType: string;
}

/**
 * 接口 [拉取章评列表-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/121) 的 **返回类型**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /ajax/chapterReview/list`
 * @更新时间 `2020-07-01 16:44:44`
 */
export interface AjaxChapterReviewListResponse {
  /**
   * 4
   */
  total?: number;
  /**
   * 1
   */
  isLast?: number;
  /**
   * [{"reviewId":"@id","content":"fsdf jfkadsjfkdsjf dsfdsjf kasdjf dsjf dsfj djfsfj sf dsfj kdsfj dsf fj fjfjd fjdf kjfjfsd fdsfj fj dfj dfjfj jfjf jkds jfkdjdsfasf fa dskf jffjfjdfj sfj j jjkjkfjdskfjsdkjf kfk jkds kfsdjf ksdjf ksj fkjfkfkjfk fkfjf kjdf dsjfkl dsjfk jdf sjdf lksdjf ksdjflk sf asjf klasdjfksajf ksjfkl safjks fj ksdjf jfs ","userId":1,"createTime":"3 weeks ago","userName":"@name","role":0,"penName":"","avatar":"//oauserimg.webnovel.com/userheadimg/2183903537/1/1.jpg","reviewType":1,"likeNums":1,"status":1,"pStatus":-1,"userLevel":2,"badgeInfo":{"badgeId":10003,"badgeType":"@string","badgeName":"@string","maxGrade":1,"achievedMaxGrade":1,"achievedTime":"2018-01-30","achievedGradeGoal":"To be a Premium user","baseUrl":"@image","updateTime":"@timestamp"},"isLiked":true,"commentType":2}]
   */
  reviewItems?: {
    /**
     * "@id"
     */
    reviewId?: string;
    /**
     * "fsdf jfkadsjfkdsjf dsfdsjf kasdjf dsjf dsfj djfsfj sf dsfj kdsfj dsf fj fjfjd fjdf kjfjfsd fdsfj fj dfj dfjfj jfjf jkds jfkdjdsfasf fa dskf jffjfjdfj sfj j jjkjkfjdskfjsdkjf kfk jkds kfsdjf ksdjf ksj fkjfkfkjfk fkfjf kjdf dsjfkl dsjfk jdf sjdf lksdjf ksdjflk sf asjf klasdjfksajf ksjfkl safjks fj ksdjf jfs "
     */
    content?: string;
    /**
     * 1
     */
    userId?: number;
    /**
     * "3 weeks ago"
     */
    createTime?: string;
    /**
     * "@name"
     */
    userName?: string;
    role?: number;
    penName?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/2183903537/1/1.jpg"
     */
    avatar?: string;
    /**
     * 1
     */
    reviewType?: number;
    /**
     * 1
     */
    likeNums?: number;
    /**
     * 1
     */
    status?: number;
    /**
     * -1
     */
    pStatus?: number;
    /**
     * 2
     */
    userLevel?: number;
    badgeInfo?: {
      /**
       * 10003
       */
      badgeId?: number;
      /**
       * "@string"
       */
      badgeType?: string;
      /**
       * "@string"
       */
      badgeName?: string;
      /**
       * 1
       */
      maxGrade?: number;
      /**
       * 1
       */
      achievedMaxGrade?: number;
      /**
       * "2018-01-30"
       */
      achievedTime?: string;
      /**
       * "To be a Premium user"
       */
      achievedGradeGoal?: string;
      /**
       * "@image"
       */
      baseUrl?: string;
      /**
       * "@timestamp"
       */
      updateTime?: string;
    };
    /**
     * true
     */
    isLiked?: boolean;
    /**
     * 2
     */
    commentType?: number;
  }[];
  bookInfo?: {
    /**
     * "@id"
     */
    bookId?: string;
    /**
     * 1
     */
    bookType?: number;
    /**
     * "@name"
     */
    bookName?: string;
    /**
     * "@name"
     */
    authorName?: string;
    /**
     * []
     */
    groupItems?: unknown[];
    /**
     * []
     */
    translatorItems?: unknown[];
    /**
     * []
     */
    editorItems?: unknown[];
    /**
     * "@id"
     */
    categoryName?: string;
    categoryId?: null;
    updateFrequency?: null;
    /**
     * "chs / XXXX"
     */
    frequencyUnit?: string;
    chapterNum?: null;
    actionStatus?: number;
    /**
     * "5.0"
     */
    totalScore?: string;
    voters?: null;
    description?: null;
    totalChapterNum?: null;
    /**
     * [{"text":null,"url":"https://m.qidian.com/book/"}]
     */
    language?: {
      text?: null;
      /**
       * "https://m.qidian.com/book/"
       */
      url?: string;
    }[];
    /**
     * []
     */
    tagInfo?: unknown[];
    /**
     * 1
     */
    type?: number;
    firstChapterId?: string;
    inLibrary?: number;
    /**
     * "0"
     */
    readToChapterId?: string;
    readToChapterIndex?: number;
    coverUpdateTime?: number;
    /**
     * 75
     */
    powerRank?: number;
    patreonLink?: string;
    /**
     * []
     */
    animationItems?: unknown[];
    /**
     * []
     */
    notes?: unknown[];
    energyNum?: number;
    /**
     * 6
     */
    chapterIndex?: number;
    /**
     * "chapter 6"
     */
    chapterName?: string;
    /**
     * "25529445611796611"
     */
    chapterId?: string;
  };
}

/**
 * 接口 [拉取章评列表-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/121) 的 **请求配置的类型**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /ajax/chapterReview/list`
 * @更新时间 `2020-07-01 16:44:44`
 */
type AjaxChapterReviewListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/chapterReview/list",
    "data",
    string,
    "bookId" | "chapterId" | "pageIndex" | "orderType",
    false
  >
>;

/**
 * 接口 [拉取章评列表-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/121) 的 **请求配置**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /ajax/chapterReview/list`
 * @更新时间 `2020-07-01 16:44:44`
 */
const ajaxChapterReviewListRequestConfig: AjaxChapterReviewListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_4,
    devUrl: devUrl_0_1_0_4,
    prodUrl: prodUrl_0_1_0_4,
    path: "/ajax/chapterReview/list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_4,
    paramNames: [],
    queryNames: ["bookId", "chapterId", "pageIndex", "orderType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterReviewList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [拉取章评列表-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/121) 的 **请求函数**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /ajax/chapterReview/list`
 * @更新时间 `2020-07-01 16:44:44`
 */
export const ajaxChapterReviewList = /*#__PURE__*/ (
  requestData: AjaxChapterReviewListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxChapterReviewListResponse>(
    prepare(ajaxChapterReviewListRequestConfig, requestData),
    ...args
  );
};

ajaxChapterReviewList.requestConfig = ajaxChapterReviewListRequestConfig;

/**
 * 接口 [添加章评↗](https://yapi.yuewen.com/project/28/interface/api/3482) 的 **请求类型**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `POST /ajax/chapterReview/add`
 * @更新时间 `2018-05-09 10:23:22`
 */
export interface AjaxChapterReviewAddRequest {
  bookId: string;
  chapterId: string;
  /**
   * 当为对章评的回复的时候存在
   */
  reviewId?: string;
  content: string;
}

/**
 * 接口 [添加章评↗](https://yapi.yuewen.com/project/28/interface/api/3482) 的 **返回类型**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `POST /ajax/chapterReview/add`
 * @更新时间 `2018-05-09 10:23:22`
 */
export interface AjaxChapterReviewAddResponse {
  /**
   * "commodo cupidatat qui non aliqua"
   */
  content?: string;
  /**
   * 72775442
   */
  reviewId?: number;
  user?: {};
}

/**
 * 接口 [添加章评↗](https://yapi.yuewen.com/project/28/interface/api/3482) 的 **请求配置的类型**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `POST /ajax/chapterReview/add`
 * @更新时间 `2018-05-09 10:23:22`
 */
type AjaxChapterReviewAddRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/chapterReview/add",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [添加章评↗](https://yapi.yuewen.com/project/28/interface/api/3482) 的 **请求配置**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `POST /ajax/chapterReview/add`
 * @更新时间 `2018-05-09 10:23:22`
 */
const ajaxChapterReviewAddRequestConfig: AjaxChapterReviewAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_4,
    devUrl: devUrl_0_1_0_4,
    prodUrl: prodUrl_0_1_0_4,
    path: "/ajax/chapterReview/add",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterReviewAdd",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [添加章评↗](https://yapi.yuewen.com/project/28/interface/api/3482) 的 **请求函数**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `POST /ajax/chapterReview/add`
 * @更新时间 `2018-05-09 10:23:22`
 */
export const ajaxChapterReviewAdd = /*#__PURE__*/ (
  requestData: AjaxChapterReviewAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxChapterReviewAddResponse>(
    prepare(ajaxChapterReviewAddRequestConfig, requestData),
    ...args
  );
};

ajaxChapterReviewAdd.requestConfig = ajaxChapterReviewAddRequestConfig;

/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/28/interface/api/119889) 的 **请求类型**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2020-08-03 13:03:43`
 */
export interface GoPcmChapterReviewGetReviewListRequest {}

/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/28/interface/api/119889) 的 **返回类型**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2020-08-03 13:03:43`
 */
export interface GoPcmChapterReviewGetReviewListResponse {}

/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/28/interface/api/119889) 的 **请求配置的类型**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2020-08-03 13:03:43`
 */
type GoPcmChapterReviewGetReviewListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/chapterReview/getReviewList",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/28/interface/api/119889) 的 **请求配置**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2020-08-03 13:03:43`
 */
const goPcmChapterReviewGetReviewListRequestConfig: GoPcmChapterReviewGetReviewListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_4,
    devUrl: devUrl_0_1_0_4,
    prodUrl: prodUrl_0_1_0_4,
    path: "/go/pcm/chapterReview/getReviewList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterReviewGetReviewList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/28/interface/api/119889) 的 **请求函数**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2020-08-03 13:03:43`
 */
export const goPcmChapterReviewGetReviewList = /*#__PURE__*/ (
  requestData?: GoPcmChapterReviewGetReviewListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterReviewGetReviewListResponse>(
    prepare(goPcmChapterReviewGetReviewListRequestConfig, requestData),
    ...args
  );
};

goPcmChapterReviewGetReviewList.requestConfig =
  goPcmChapterReviewGetReviewListRequestConfig;

const mockUrl_0_1_0_5 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_5 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_5 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_5 = "data" as any;

/**
 * 接口 [试读列表↗](https://yapi.yuewen.com/project/28/interface/api/68427) 的 **请求类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2019-12-31 15:42:09`
 */
export interface GoPcmExpectTrailerListRequest {}

/**
 * 接口 [试读列表↗](https://yapi.yuewen.com/project/28/interface/api/68427) 的 **返回类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2019-12-31 15:42:09`
 */
export interface GoPcmExpectTrailerListResponse {
  /**
   * [{"bookId":"@id","bookName":"@sentence","categoryName":"@word","coverUpdateTime":0,"categoryId":111,"status":[20,25],"sex":1}]
   */
  items?: {
    /**
     * "@id"
     */
    bookId?: string;
    /**
     * "@sentence"
     */
    bookName?: string;
    /**
     * "@word"
     */
    categoryName?: string;
    coverUpdateTime?: number;
    /**
     * 111
     */
    categoryId?: number;
    /**
     * [20,25]
     */
    status?: number[];
    /**
     * 1
     */
    sex?: number;
  }[];
  /**
   * [{"awardType":1,"amount":0}]
   */
  awards?: {
    /**
     * 1
     */
    awardType?: number;
    amount?: number;
  }[];
}

/**
 * 接口 [试读列表↗](https://yapi.yuewen.com/project/28/interface/api/68427) 的 **请求配置的类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2019-12-31 15:42:09`
 */
type GoPcmExpectTrailerListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/expect/trailerList",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [试读列表↗](https://yapi.yuewen.com/project/28/interface/api/68427) 的 **请求配置**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2019-12-31 15:42:09`
 */
const goPcmExpectTrailerListRequestConfig: GoPcmExpectTrailerListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_5,
    devUrl: devUrl_0_1_0_5,
    prodUrl: prodUrl_0_1_0_5,
    path: "/go/pcm/expect/trailerList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmExpectTrailerList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [试读列表↗](https://yapi.yuewen.com/project/28/interface/api/68427) 的 **请求函数**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2019-12-31 15:42:09`
 */
export const goPcmExpectTrailerList = /*#__PURE__*/ (
  requestData?: GoPcmExpectTrailerListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmExpectTrailerListResponse>(
    prepare(goPcmExpectTrailerListRequestConfig, requestData),
    ...args
  );
};

goPcmExpectTrailerList.requestConfig = goPcmExpectTrailerListRequestConfig;

/**
 * 接口 [ES列表↗](https://yapi.yuewen.com/project/28/interface/api/76443) 的 **请求类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2020-04-17 13:28:32`
 */
export interface GoPcmExpectEsListRequest {}

/**
 * 接口 [ES列表↗](https://yapi.yuewen.com/project/28/interface/api/76443) 的 **返回类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2020-04-17 13:28:32`
 */
export interface GoPcmExpectEsListResponse {
  /**
   * [{"bookId":"7144266401010905","bookName":"testpl","gender":1,"authorName":"testpl","totalScore":4.64,"voteCount":0,"coverUpdateTime":0,"newChapterId":"30838641785884339","newChapterIndex":19,"newChapterTime":1544486400000,"firstChapterId":"21907832551039037","inLibrary":0}]
   */
  topLastWeekMale?: {
    /**
     * "7144266401010905"
     */
    bookId?: string;
    /**
     * "testpl"
     */
    bookName?: string;
    /**
     * 1
     */
    gender?: number;
    /**
     * "testpl"
     */
    authorName?: string;
    /**
     * 4.64
     */
    totalScore?: number;
    voteCount?: number;
    coverUpdateTime?: number;
    /**
     * "30838641785884339"
     */
    newChapterId?: string;
    /**
     * 19
     */
    newChapterIndex?: number;
    /**
     * 1544486400000
     */
    newChapterTime?: number;
    /**
     * "21907832551039037"
     */
    firstChapterId?: string;
    inLibrary?: number;
  }[];
  /**
   * [{"bookId":"15238101801141105","bookName":"The starting line is 566972337","gender":2,"authorName":"A simple pig","totalScore":0,"voteCount":0,"coverUpdateTime":1574320936378,"newChapterId":"30838641785884339","newChapterIndex":19,"newChapterTime":1544486400000,"firstChapterId":"21907832551039037","inLibrary":0}]
   */
  topLastWeekFemale?: {
    /**
     * "15238101801141105"
     */
    bookId?: string;
    /**
     * "The starting line is 566972337"
     */
    bookName?: string;
    /**
     * 2
     */
    gender?: number;
    /**
     * "A simple pig"
     */
    authorName?: string;
    totalScore?: number;
    voteCount?: number;
    /**
     * 1574320936378
     */
    coverUpdateTime?: number;
    /**
     * "30838641785884339"
     */
    newChapterId?: string;
    /**
     * 19
     */
    newChapterIndex?: number;
    /**
     * 1544486400000
     */
    newChapterTime?: number;
    /**
     * "21907832551039037"
     */
    firstChapterId?: string;
    inLibrary?: number;
  }[];
  /**
   * [{"bookId":"7479922501012705","bookName":"The Desolate Era","gender":0,"authorName":"I Eat Tomatos","totalScore":0,"voteCount":107,"coverUpdateTime":0},{"bookId":"8161289901016405","bookName":"Tian huo da dao","gender":0,"authorName":"zhang wei","totalScore":0,"voteCount":22,"coverUpdateTime":0}]
   */
  voteMaleItems?: {
    /**
     * "7479922501012705"
     */
    bookId?: string;
    /**
     * "The Desolate Era"
     */
    bookName?: string;
    gender?: number;
    /**
     * "I Eat Tomatos"
     */
    authorName?: string;
    totalScore?: number;
    /**
     * 107
     */
    voteCount?: number;
    coverUpdateTime?: number;
  }[];
  /**
   * [{"bookId":"11443406601008805","bookName":"fanyi0827","gender":0,"authorName":"0827","totalScore":0,"voteCount":24,"coverUpdateTime":0}]
   */
  voteFemaleItems?: {
    /**
     * "11443406601008805"
     */
    bookId?: string;
    /**
     * "fanyi0827"
     */
    bookName?: string;
    gender?: number;
    /**
     * "0827"
     */
    authorName?: string;
    totalScore?: number;
    /**
     * 24
     */
    voteCount?: number;
    coverUpdateTime?: number;
  }[];
  /**
   * [{"awardType":1,"amount":0}]
   */
  awards?: {
    /**
     * 1
     */
    awardType?: number;
    amount?: number;
  }[];
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300001149/1/1.jpg?mt=1560344081420"
     */
    avatar?: string;
    /**
     * "Nana_Sun_Cherry"
     */
    nickName?: string;
    /**
     * "Nana_Sun_Cherry"
     */
    userName?: string;
    /**
     * "4300001149"
     */
    guid?: string;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * "Nana_Sun_Cherry"
     */
    penName?: string;
    /**
     * 81
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 1
     */
    grade?: number;
    /**
     * 10
     */
    ES?: number;
    /**
     * 10
     */
    totalES?: number;
    /**
     * 10
     */
    PS?: number;
    /**
     * 1
     */
    totalPS?: number;
    emailStatus?: number;
    /**
     * true
     */
    isCheckIn?: boolean;
    UUT?: number;
    /**
     * 2
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 1
     */
    membershipStatus?: number;
    /**
     * 1516773399000
     */
    membershipExpireTime?: number;
    /**
     * true
     */
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [ES列表↗](https://yapi.yuewen.com/project/28/interface/api/76443) 的 **请求配置的类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2020-04-17 13:28:32`
 */
type GoPcmExpectEsListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/expect/esList",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [ES列表↗](https://yapi.yuewen.com/project/28/interface/api/76443) 的 **请求配置**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2020-04-17 13:28:32`
 */
const goPcmExpectEsListRequestConfig: GoPcmExpectEsListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_5,
    devUrl: devUrl_0_1_0_5,
    prodUrl: prodUrl_0_1_0_5,
    path: "/go/pcm/expect/esList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmExpectEsList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [ES列表↗](https://yapi.yuewen.com/project/28/interface/api/76443) 的 **请求函数**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2020-04-17 13:28:32`
 */
export const goPcmExpectEsList = /*#__PURE__*/ (
  requestData?: GoPcmExpectEsListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmExpectEsListResponse>(
    prepare(goPcmExpectEsListRequestConfig, requestData),
    ...args
  );
};

goPcmExpectEsList.requestConfig = goPcmExpectEsListRequestConfig;

const mockUrl_0_1_0_6 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_6 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_6 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_6 = "data" as any;

/**
 * 接口 [geInfo↗](https://yapi.yuewen.com/project/28/interface/api/69896) 的 **请求类型**
 *
 * @分类 [membership 会员卡↗](https://yapi.yuewen.com/project/28/interface/api/cat_12704)
 * @请求头 `GET /ajax/membership/getInfoAjax`
 * @更新时间 `2020-04-08 14:25:10`
 */
export interface AjaxMembershipGetInfoAjaxRequest {}

/**
 * 接口 [geInfo↗](https://yapi.yuewen.com/project/28/interface/api/69896) 的 **返回类型**
 *
 * @分类 [membership 会员卡↗](https://yapi.yuewen.com/project/28/interface/api/cat_12704)
 * @请求头 `GET /ajax/membership/getInfoAjax`
 * @更新时间 `2020-04-08 14:25:10`
 */
export interface AjaxMembershipGetInfoAjaxResponse {
  /**
   * 1
   */
  membershipQua?: number;
  /**
   * 1
   */
  membershipStatus?: number;
  /**
   * 1516773399000
   */
  membershipExpireTime?: number;
  /**
   * true
   */
  claimStatus?: boolean;
  /**
   * [{"channelCode":"paypal","country":"US","amount":1,"discountAmount":1,"currency":"USD","itemId":"Membership_monthly","itemType":2,"tag":"agfewg","title":"@string","msg":"@string","benefits":[{"imageUrl":"@url","title":"@string"}]}]
   */
  items?: {
    /**
     * "paypal"
     */
    channelCode?: string;
    /**
     * "US"
     */
    country?: string;
    /**
     * 1
     */
    amount?: number;
    /**
     * 1
     */
    discountAmount?: number;
    /**
     * "USD"
     */
    currency?: string;
    /**
     * "Membership_monthly"
     */
    itemId?: string;
    /**
     * 2
     */
    itemType?: number;
    /**
     * "agfewg"
     */
    tag?: string;
    /**
     * "@string"
     */
    title?: string;
    /**
     * "@string"
     */
    msg?: string;
    /**
     * [{"imageUrl":"@url","title":"@string"}]
     */
    benefits?: {
      /**
       * "@url"
       */
      imageUrl?: string;
      /**
       * "@string"
       */
      title?: string;
    }[];
  }[];
  membershipMsg?: string;
}

/**
 * 接口 [geInfo↗](https://yapi.yuewen.com/project/28/interface/api/69896) 的 **请求配置的类型**
 *
 * @分类 [membership 会员卡↗](https://yapi.yuewen.com/project/28/interface/api/cat_12704)
 * @请求头 `GET /ajax/membership/getInfoAjax`
 * @更新时间 `2020-04-08 14:25:10`
 */
type AjaxMembershipGetInfoAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/membership/getInfoAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [geInfo↗](https://yapi.yuewen.com/project/28/interface/api/69896) 的 **请求配置**
 *
 * @分类 [membership 会员卡↗](https://yapi.yuewen.com/project/28/interface/api/cat_12704)
 * @请求头 `GET /ajax/membership/getInfoAjax`
 * @更新时间 `2020-04-08 14:25:10`
 */
const ajaxMembershipGetInfoAjaxRequestConfig: AjaxMembershipGetInfoAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_6,
    devUrl: devUrl_0_1_0_6,
    prodUrl: prodUrl_0_1_0_6,
    path: "/ajax/membership/getInfoAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxMembershipGetInfoAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [geInfo↗](https://yapi.yuewen.com/project/28/interface/api/69896) 的 **请求函数**
 *
 * @分类 [membership 会员卡↗](https://yapi.yuewen.com/project/28/interface/api/cat_12704)
 * @请求头 `GET /ajax/membership/getInfoAjax`
 * @更新时间 `2020-04-08 14:25:10`
 */
export const ajaxMembershipGetInfoAjax = /*#__PURE__*/ (
  requestData?: AjaxMembershipGetInfoAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxMembershipGetInfoAjaxResponse>(
    prepare(ajaxMembershipGetInfoAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxMembershipGetInfoAjax.requestConfig =
  ajaxMembershipGetInfoAjaxRequestConfig;

const mockUrl_0_1_0_7 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_7 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_7 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_7 = "data" as any;

/**
 * 接口 [智能推荐二级页↗](https://yapi.yuewen.com/project/28/interface/api/74884) 的 **请求类型**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /ajax/recommend/list`
 * @更新时间 `2020-04-02 14:07:41`
 */
export interface AjaxRecommendListRequest {
  /**
   * 1：根据人推荐书 2：根据书推荐
   */
  recommendType: string;
  bookId?: string;
  pageIndex?: string;
  /**
   * 根据书推荐时传入 0: 小说 100：漫画 200：出版书（目前只有0和100）
   */
  bookType?: string;
}

/**
 * 接口 [智能推荐二级页↗](https://yapi.yuewen.com/project/28/interface/api/74884) 的 **返回类型**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /ajax/recommend/list`
 * @更新时间 `2020-04-02 14:07:41`
 */
export interface AjaxRecommendListResponse {
  /**
   * [{"bookId":"12816971506521105","bookName":"The President is Being Shameless Again","categoryId":70014,"categoryName":"Contemporary Romance","novelType":0,"description":"Wher he can. Is there something between them or is he just having fun with her?","alg":"181.0.1","authorName":" Dawnesque","totalScore":"4.4","totalChapterNum":407,"translateMode":1,"tagInfos":[{"id":1,"tagName":"tag"}]}]
   */
  recommendListItems?: {
    /**
     * "12816971506521105"
     */
    bookId?: string;
    /**
     * "The President is Being Shameless Again"
     */
    bookName?: string;
    /**
     * 70014
     */
    categoryId?: number;
    /**
     * "Contemporary Romance"
     */
    categoryName?: string;
    novelType?: number;
    /**
     * "Wher he can. Is there something between them or is he just having fun with her?"
     */
    description?: string;
    /**
     * "181.0.1"
     */
    alg?: string;
    /**
     * " Dawnesque"
     */
    authorName?: string;
    /**
     * "4.4"
     */
    totalScore?: string;
    /**
     * 407
     */
    totalChapterNum?: number;
    /**
     * 1
     */
    translateMode?: number;
    /**
     * [{"id":1,"tagName":"tag"}]
     */
    tagInfos?: {
      /**
       * 1
       */
      id?: number;
      /**
       * "tag"
       */
      tagName?: string;
    }[];
  }[];
  /**
   * "0"
   */
  isLast?: string;
}

/**
 * 接口 [智能推荐二级页↗](https://yapi.yuewen.com/project/28/interface/api/74884) 的 **请求配置的类型**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /ajax/recommend/list`
 * @更新时间 `2020-04-02 14:07:41`
 */
type AjaxRecommendListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/recommend/list",
    "data",
    string,
    "recommendType" | "bookId" | "pageIndex" | "bookType",
    false
  >
>;

/**
 * 接口 [智能推荐二级页↗](https://yapi.yuewen.com/project/28/interface/api/74884) 的 **请求配置**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /ajax/recommend/list`
 * @更新时间 `2020-04-02 14:07:41`
 */
const ajaxRecommendListRequestConfig: AjaxRecommendListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: "/ajax/recommend/list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: ["recommendType", "bookId", "pageIndex", "bookType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxRecommendList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [智能推荐二级页↗](https://yapi.yuewen.com/project/28/interface/api/74884) 的 **请求函数**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /ajax/recommend/list`
 * @更新时间 `2020-04-02 14:07:41`
 */
export const ajaxRecommendList = /*#__PURE__*/ (
  requestData: AjaxRecommendListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxRecommendListResponse>(
    prepare(ajaxRecommendListRequestConfig, requestData),
    ...args
  );
};

ajaxRecommendList.requestConfig = ajaxRecommendListRequestConfig;

/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/28/interface/api/76473) 的 **请求类型**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2020-09-01 15:32:39`
 */
export interface GoPcmRecommendGetRecommendListRequest {
  /**
   * 1：根据人推荐书 2：根据书推荐
   */
  type: string;
  bookId?: string;
  pageIndex?: string;
  /**
   * 根据书推荐时传入 0: 小说 100：漫画 200：出版书（目前只有0和100）
   */
  bookType?: string;
  /**
   * 默认20，最大不超过50
   */
  pageSize: string;
}

/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/28/interface/api/76473) 的 **返回类型**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2020-09-01 15:32:39`
 */
export interface GoPcmRecommendGetRecommendListResponse {
  /**
   * [{"bookId":"12816971506521105","bookName":"The President is Being Shameless Again","categoryId":70014,"categoryName":"Contemporary Romance","novelType":0,"description":"Wher he can. Is there something between them or is he just having fun with her?","alg":"181.0.1","authorName":" Dawnesque","totalScore":"4.4","totalChapterNum":407,"translateMode":1,"tagInfos":[{"id":1,"tagName":"tag"}]}]
   */
  recommendListItems?: {
    /**
     * "12816971506521105"
     */
    bookId?: string;
    /**
     * "The President is Being Shameless Again"
     */
    bookName?: string;
    /**
     * 70014
     */
    categoryId?: number;
    /**
     * "Contemporary Romance"
     */
    categoryName?: string;
    novelType?: number;
    /**
     * "Wher he can. Is there something between them or is he just having fun with her?"
     */
    description?: string;
    /**
     * "181.0.1"
     */
    alg?: string;
    /**
     * " Dawnesque"
     */
    authorName?: string;
    /**
     * "4.4"
     */
    totalScore?: string;
    /**
     * 407
     */
    totalChapterNum?: number;
    /**
     * 1
     */
    translateMode?: number;
    /**
     * [{"id":1,"tagName":"tag"}]
     */
    tagInfos?: {
      /**
       * 1
       */
      id?: number;
      /**
       * "tag"
       */
      tagName?: string;
    }[];
  }[];
  /**
   * "0"
   */
  isLast?: string;
}

/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/28/interface/api/76473) 的 **请求配置的类型**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2020-09-01 15:32:39`
 */
type GoPcmRecommendGetRecommendListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/recommend/getRecommendList",
    "data",
    string,
    "type" | "bookId" | "pageIndex" | "bookType" | "pageSize",
    false
  >
>;

/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/28/interface/api/76473) 的 **请求配置**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2020-09-01 15:32:39`
 */
const goPcmRecommendGetRecommendListRequestConfig: GoPcmRecommendGetRecommendListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: "/go/pcm/recommend/getRecommendList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: ["type", "bookId", "pageIndex", "bookType", "pageSize"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRecommendGetRecommendList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/28/interface/api/76473) 的 **请求函数**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2020-09-01 15:32:39`
 */
export const goPcmRecommendGetRecommendList = /*#__PURE__*/ (
  requestData: GoPcmRecommendGetRecommendListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmRecommendGetRecommendListResponse>(
    prepare(goPcmRecommendGetRecommendListRequestConfig, requestData),
    ...args
  );
};

goPcmRecommendGetRecommendList.requestConfig =
  goPcmRecommendGetRecommendListRequestConfig;

const mockUrl_0_1_0_8 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_8 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_8 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_8 = "data" as any;

/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/28/interface/api/105965) 的 **请求类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2020-07-09 15:14:04`
 */
export interface GoPcmSeoGetTagBookListRequest {
  tagId?: string;
  tagName?: string;
  /**
   * 1 搜索书籍 2 搜索漫画 3 搜索出版书 4 搜索fan-fic 目前只有1和4
   */
  type: string;
  pageIndex: string;
  /**
   * 1:Popular 2:Updated 3:Collection 默认1
   */
  order: string;
}

/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/28/interface/api/105965) 的 **返回类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2020-07-09 15:14:04`
 */
export interface GoPcmSeoGetTagBookListResponse {
  /**
   * [{"bookId":7765027801015505,"bookName":"War Sovereign Soaring The Heavens","bookType":0,"categoryId":12,"categoryName":"test","authorName":"aaa","bookCoverId":1513319976161,"totalScore":5,"tagInfo":[{"tagId":1,"tagName":"tag","isLiked":0,"likeNums":0}],"description":"dfrastraytrdhgdshghfdjtsyyt","chapterNum":100}]
   */
  items?: {
    /**
     * 7765027801015505
     */
    bookId?: number;
    /**
     * "War Sovereign Soaring The Heavens"
     */
    bookName?: string;
    bookType?: number;
    /**
     * 12
     */
    categoryId?: number;
    /**
     * "test"
     */
    categoryName?: string;
    /**
     * "aaa"
     */
    authorName?: string;
    /**
     * 1513319976161
     */
    bookCoverId?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * [{"tagId":1,"tagName":"tag","isLiked":0,"likeNums":0}]
     */
    tagInfo?: {
      /**
       * 1
       */
      tagId?: number;
      /**
       * "tag"
       */
      tagName?: string;
      isLiked?: number;
      likeNums?: number;
    }[];
    /**
     * "dfrastraytrdhgdshghfdjtsyyt"
     */
    description?: string;
    /**
     * 100
     */
    chapterNum?: number;
  }[];
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 1
   */
  total?: number;
  isLast?: number;
  /**
   * 1
   */
  orderBy?: number;
  /**
   * 1
   */
  tagId?: number;
  /**
   * "xxx"
   */
  tagName?: string;
  /**
   * 1
   */
  type?: number;
}

/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/28/interface/api/105965) 的 **请求配置的类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2020-07-09 15:14:04`
 */
type GoPcmSeoGetTagBookListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/seo/getTagBookList",
    "data",
    string,
    "tagId" | "tagName" | "type" | "pageIndex" | "order",
    false
  >
>;

/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/28/interface/api/105965) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2020-07-09 15:14:04`
 */
const goPcmSeoGetTagBookListRequestConfig: GoPcmSeoGetTagBookListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: "/go/pcm/seo/getTagBookList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: ["tagId", "tagName", "type", "pageIndex", "order"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetTagBookList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/28/interface/api/105965) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2020-07-09 15:14:04`
 */
export const goPcmSeoGetTagBookList = /*#__PURE__*/ (
  requestData: GoPcmSeoGetTagBookListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoGetTagBookListResponse>(
    prepare(goPcmSeoGetTagBookListRequestConfig, requestData),
    ...args
  );
};

goPcmSeoGetTagBookList.requestConfig = goPcmSeoGetTagBookListRequestConfig;

/**
 * 接口 [getTagList↗](https://yapi.yuewen.com/project/28/interface/api/105966) 的 **请求类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagList`
 * @更新时间 `2020-07-08 19:37:23`
 */
export interface GoPcmSeoGetTagListRequest {
  tagPrefix: string;
  pageIndex: string;
}

/**
 * 接口 [getTagList↗](https://yapi.yuewen.com/project/28/interface/api/105966) 的 **返回类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagList`
 * @更新时间 `2020-07-08 19:37:23`
 */
export interface GoPcmSeoGetTagListResponse {
  /**
   * [{"tagId":1,"tagName":"tag"}]
   */
  tagInfos?: {
    /**
     * 1
     */
    tagId?: number;
    /**
     * "tag"
     */
    tagName?: string;
  }[];
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 1
   */
  total?: number;
  isLast?: number;
}

/**
 * 接口 [getTagList↗](https://yapi.yuewen.com/project/28/interface/api/105966) 的 **请求配置的类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagList`
 * @更新时间 `2020-07-08 19:37:23`
 */
type GoPcmSeoGetTagListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/seo/getTagList",
    "data",
    string,
    "tagPrefix" | "pageIndex",
    false
  >
>;

/**
 * 接口 [getTagList↗](https://yapi.yuewen.com/project/28/interface/api/105966) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagList`
 * @更新时间 `2020-07-08 19:37:23`
 */
const goPcmSeoGetTagListRequestConfig: GoPcmSeoGetTagListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: "/go/pcm/seo/getTagList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: ["tagPrefix", "pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetTagList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getTagList↗](https://yapi.yuewen.com/project/28/interface/api/105966) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagList`
 * @更新时间 `2020-07-08 19:37:23`
 */
export const goPcmSeoGetTagList = /*#__PURE__*/ (
  requestData: GoPcmSeoGetTagListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoGetTagListResponse>(
    prepare(goPcmSeoGetTagListRequestConfig, requestData),
    ...args
  );
};

goPcmSeoGetTagList.requestConfig = goPcmSeoGetTagListRequestConfig;

/**
 * 接口 [getLongLinkByShortLink↗](https://yapi.yuewen.com/project/28/interface/api/135297) 的 **请求类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getLongLinkByShortLink`
 * @更新时间 `2020-09-10 16:08:10`
 */
export interface GoPcmSeoGetLongLinkByShortLinkRequest {
  shortLink: string;
}

/**
 * 接口 [getLongLinkByShortLink↗](https://yapi.yuewen.com/project/28/interface/api/135297) 的 **返回类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getLongLinkByShortLink`
 * @更新时间 `2020-09-10 16:08:10`
 */
export interface GoPcmSeoGetLongLinkByShortLinkResponse {
  /**
   * "xxx"
   */
  longLink?: string;
}

/**
 * 接口 [getLongLinkByShortLink↗](https://yapi.yuewen.com/project/28/interface/api/135297) 的 **请求配置的类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getLongLinkByShortLink`
 * @更新时间 `2020-09-10 16:08:10`
 */
type GoPcmSeoGetLongLinkByShortLinkRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/seo/getLongLinkByShortLink",
    "data",
    string,
    "shortLink",
    false
  >
>;

/**
 * 接口 [getLongLinkByShortLink↗](https://yapi.yuewen.com/project/28/interface/api/135297) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getLongLinkByShortLink`
 * @更新时间 `2020-09-10 16:08:10`
 */
const goPcmSeoGetLongLinkByShortLinkRequestConfig: GoPcmSeoGetLongLinkByShortLinkRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: "/go/pcm/seo/getLongLinkByShortLink",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: ["shortLink"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetLongLinkByShortLink",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getLongLinkByShortLink↗](https://yapi.yuewen.com/project/28/interface/api/135297) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getLongLinkByShortLink`
 * @更新时间 `2020-09-10 16:08:10`
 */
export const goPcmSeoGetLongLinkByShortLink = /*#__PURE__*/ (
  requestData: GoPcmSeoGetLongLinkByShortLinkRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoGetLongLinkByShortLinkResponse>(
    prepare(goPcmSeoGetLongLinkByShortLinkRequestConfig, requestData),
    ...args
  );
};

goPcmSeoGetLongLinkByShortLink.requestConfig =
  goPcmSeoGetLongLinkByShortLinkRequestConfig;

/**
 * 接口 [getRandomBookList↗](https://yapi.yuewen.com/project/28/interface/api/182723) 的 **请求类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getRandomBookList`
 * @更新时间 `2021-01-11 11:26:28`
 */
export interface GoPcmSeoGetRandomBookListRequest {}

/**
 * 接口 [getRandomBookList↗](https://yapi.yuewen.com/project/28/interface/api/182723) 的 **返回类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getRandomBookList`
 * @更新时间 `2021-01-11 11:26:28`
 */
export interface GoPcmSeoGetRandomBookListResponse {
  /**
   * [{"bookId":7765027801015505,"bookName":"War Sovereign Soaring The Heavens","bookType":0,"categoryId":12,"categoryName":"test","authorName":"aaa","bookCoverId":1513319976161,"totalScore":5,"tagInfo":[{"tagId":1,"tagName":"tag","isLiked":0,"likeNums":0}],"description":"dfrastraytrdhgdshghfdjtsyyt","chapterNum":100}]
   */
  items?: {
    /**
     * 7765027801015505
     */
    bookId?: number;
    /**
     * "War Sovereign Soaring The Heavens"
     */
    bookName?: string;
    bookType?: number;
    /**
     * 12
     */
    categoryId?: number;
    /**
     * "test"
     */
    categoryName?: string;
    /**
     * "aaa"
     */
    authorName?: string;
    /**
     * 1513319976161
     */
    bookCoverId?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * [{"tagId":1,"tagName":"tag","isLiked":0,"likeNums":0}]
     */
    tagInfo?: {
      /**
       * 1
       */
      tagId?: number;
      /**
       * "tag"
       */
      tagName?: string;
      isLiked?: number;
      likeNums?: number;
    }[];
    /**
     * "dfrastraytrdhgdshghfdjtsyyt"
     */
    description?: string;
    /**
     * 100
     */
    chapterNum?: number;
  }[];
}

/**
 * 接口 [getRandomBookList↗](https://yapi.yuewen.com/project/28/interface/api/182723) 的 **请求配置的类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getRandomBookList`
 * @更新时间 `2021-01-11 11:26:28`
 */
type GoPcmSeoGetRandomBookListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/seo/getRandomBookList",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [getRandomBookList↗](https://yapi.yuewen.com/project/28/interface/api/182723) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getRandomBookList`
 * @更新时间 `2021-01-11 11:26:28`
 */
const goPcmSeoGetRandomBookListRequestConfig: GoPcmSeoGetRandomBookListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: "/go/pcm/seo/getRandomBookList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetRandomBookList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getRandomBookList↗](https://yapi.yuewen.com/project/28/interface/api/182723) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getRandomBookList`
 * @更新时间 `2021-01-11 11:26:28`
 */
export const goPcmSeoGetRandomBookList = /*#__PURE__*/ (
  requestData?: GoPcmSeoGetRandomBookListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoGetRandomBookListResponse>(
    prepare(goPcmSeoGetRandomBookListRequestConfig, requestData),
    ...args
  );
};

goPcmSeoGetRandomBookList.requestConfig =
  goPcmSeoGetRandomBookListRequestConfig;

const mockUrl_0_1_0_9 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_9 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_9 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_9 = "data" as any;

/**
 * 接口 [getApplyRecord-获取申请状态和内容↗](https://yapi.yuewen.com/project/28/interface/api/117303) 的 **请求类型**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `GET /go/pcm/moderator/getApplyRecord`
 * @更新时间 `2020-08-04 11:19:53`
 */
export interface GoPcmModeratorGetApplyRecordRequest {
  bookId: string;
}

/**
 * 接口 [getApplyRecord-获取申请状态和内容↗](https://yapi.yuewen.com/project/28/interface/api/117303) 的 **返回类型**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `GET /go/pcm/moderator/getApplyRecord`
 * @更新时间 `2020-08-04 11:19:53`
 */
export interface GoPcmModeratorGetApplyRecordResponse {
  /**
   * -161002
   */
  applyStatus?: number;
  /**
   * "d"
   */
  applyReason?: string;
}

/**
 * 接口 [getApplyRecord-获取申请状态和内容↗](https://yapi.yuewen.com/project/28/interface/api/117303) 的 **请求配置的类型**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `GET /go/pcm/moderator/getApplyRecord`
 * @更新时间 `2020-08-04 11:19:53`
 */
type GoPcmModeratorGetApplyRecordRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/moderator/getApplyRecord",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [getApplyRecord-获取申请状态和内容↗](https://yapi.yuewen.com/project/28/interface/api/117303) 的 **请求配置**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `GET /go/pcm/moderator/getApplyRecord`
 * @更新时间 `2020-08-04 11:19:53`
 */
const goPcmModeratorGetApplyRecordRequestConfig: GoPcmModeratorGetApplyRecordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: "/go/pcm/moderator/getApplyRecord",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmModeratorGetApplyRecord",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getApplyRecord-获取申请状态和内容↗](https://yapi.yuewen.com/project/28/interface/api/117303) 的 **请求函数**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `GET /go/pcm/moderator/getApplyRecord`
 * @更新时间 `2020-08-04 11:19:53`
 */
export const goPcmModeratorGetApplyRecord = /*#__PURE__*/ (
  requestData: GoPcmModeratorGetApplyRecordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmModeratorGetApplyRecordResponse>(
    prepare(goPcmModeratorGetApplyRecordRequestConfig, requestData),
    ...args
  );
};

goPcmModeratorGetApplyRecord.requestConfig =
  goPcmModeratorGetApplyRecordRequestConfig;

/**
 * 接口 [applyModerator - 申请版主↗](https://yapi.yuewen.com/project/28/interface/api/117314) 的 **请求类型**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `POST /go/pcm/moderator/applyModerator `
 * @更新时间 `2020-08-04 11:20:26`
 */
export interface GoPcmModeratorApplyModeratorRequest {
  bookId: string;
  applyReason: string;
}

/**
 * 接口 [applyModerator - 申请版主↗](https://yapi.yuewen.com/project/28/interface/api/117314) 的 **返回类型**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `POST /go/pcm/moderator/applyModerator `
 * @更新时间 `2020-08-04 11:20:26`
 */
export interface GoPcmModeratorApplyModeratorResponse {
  /**
   * -161002
   */
  applyStatus?: number;
}

/**
 * 接口 [applyModerator - 申请版主↗](https://yapi.yuewen.com/project/28/interface/api/117314) 的 **请求配置的类型**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `POST /go/pcm/moderator/applyModerator `
 * @更新时间 `2020-08-04 11:20:26`
 */
type GoPcmModeratorApplyModeratorRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/moderator/applyModerator ",
    "data",
    string,
    "bookId" | "applyReason",
    false
  >
>;

/**
 * 接口 [applyModerator - 申请版主↗](https://yapi.yuewen.com/project/28/interface/api/117314) 的 **请求配置**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `POST /go/pcm/moderator/applyModerator `
 * @更新时间 `2020-08-04 11:20:26`
 */
const goPcmModeratorApplyModeratorRequestConfig: GoPcmModeratorApplyModeratorRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: "/go/pcm/moderator/applyModerator ",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: ["bookId", "applyReason"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmModeratorApplyModerator",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [applyModerator - 申请版主↗](https://yapi.yuewen.com/project/28/interface/api/117314) 的 **请求函数**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `POST /go/pcm/moderator/applyModerator `
 * @更新时间 `2020-08-04 11:20:26`
 */
export const goPcmModeratorApplyModerator = /*#__PURE__*/ (
  requestData: GoPcmModeratorApplyModeratorRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmModeratorApplyModeratorResponse>(
    prepare(goPcmModeratorApplyModeratorRequestConfig, requestData),
    ...args
  );
};

goPcmModeratorApplyModerator.requestConfig =
  goPcmModeratorApplyModeratorRequestConfig;

const mockUrl_0_1_0_11 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_11 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_11 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_11 = "data" as any;

/**
 * 接口 [ 评论emoji映射Map↗](https://yapi.yuewen.com/project/28/interface/api/118090) 的 **请求类型**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-08-05 13:56:40`
 */
export interface GoPcmEmojiGetEmojiRequest {}

/**
 * 接口 [ 评论emoji映射Map↗](https://yapi.yuewen.com/project/28/interface/api/118090) 的 **返回类型**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-08-05 13:56:40`
 */
export interface GoPcmEmojiGetEmojiResponse {
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/fp.png"
   */
  "[img=fp]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/exp.png"
   */
  "[img=exp]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/faceslap.png"
   */
  "[img=faceslap]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/update.png"
   */
  "[img=update]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/coins.png"
   */
  "[img=coins]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/recommend.png"
   */
  "[img=recommend]"?: string;
}

/**
 * 接口 [ 评论emoji映射Map↗](https://yapi.yuewen.com/project/28/interface/api/118090) 的 **请求配置的类型**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-08-05 13:56:40`
 */
type GoPcmEmojiGetEmojiRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/emoji/getEmoji",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [ 评论emoji映射Map↗](https://yapi.yuewen.com/project/28/interface/api/118090) 的 **请求配置**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-08-05 13:56:40`
 */
const goPcmEmojiGetEmojiRequestConfig: GoPcmEmojiGetEmojiRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_11,
    devUrl: devUrl_0_1_0_11,
    prodUrl: prodUrl_0_1_0_11,
    path: "/go/pcm/emoji/getEmoji",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmEmojiGetEmoji",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [ 评论emoji映射Map↗](https://yapi.yuewen.com/project/28/interface/api/118090) 的 **请求函数**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-08-05 13:56:40`
 */
export const goPcmEmojiGetEmoji = /*#__PURE__*/ (
  requestData?: GoPcmEmojiGetEmojiRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmEmojiGetEmojiResponse>(
    prepare(goPcmEmojiGetEmojiRequestConfig, requestData),
    ...args
  );
};

goPcmEmojiGetEmoji.requestConfig = goPcmEmojiGetEmojiRequestConfig;

/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/28/interface/api/119878) 的 **请求类型**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-08-03 11:36:11`
 */
export interface GoPcmBookReviewSetTopRequest {
  bookId: string;
  reviewId: string;
  topType: string;
}

/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/28/interface/api/119878) 的 **返回类型**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-08-03 11:36:11`
 */
export interface GoPcmBookReviewSetTopResponse {}

/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/28/interface/api/119878) 的 **请求配置的类型**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-08-03 11:36:11`
 */
type GoPcmBookReviewSetTopRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/bookReview/setTop",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/28/interface/api/119878) 的 **请求配置**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-08-03 11:36:11`
 */
const goPcmBookReviewSetTopRequestConfig: GoPcmBookReviewSetTopRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_11,
    devUrl: devUrl_0_1_0_11,
    prodUrl: prodUrl_0_1_0_11,
    path: "/go/pcm/bookReview/setTop",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewSetTop",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/28/interface/api/119878) 的 **请求函数**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-08-03 11:36:11`
 */
export const goPcmBookReviewSetTop = /*#__PURE__*/ (
  requestData: GoPcmBookReviewSetTopRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookReviewSetTopResponse>(
    prepare(goPcmBookReviewSetTopRequestConfig, requestData),
    ...args
  );
};

goPcmBookReviewSetTop.requestConfig = goPcmBookReviewSetTopRequestConfig;

/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/28/interface/api/119886) 的 **请求类型**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-08-03 11:36:17`
 */
export interface GoPcmBookReviewEssenceRequest {
  bookId: string;
  reviewId: string;
  opType: string;
}

/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/28/interface/api/119886) 的 **返回类型**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-08-03 11:36:17`
 */
export interface GoPcmBookReviewEssenceResponse {}

/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/28/interface/api/119886) 的 **请求配置的类型**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-08-03 11:36:17`
 */
type GoPcmBookReviewEssenceRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/bookReview/essence",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/28/interface/api/119886) 的 **请求配置**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-08-03 11:36:17`
 */
const goPcmBookReviewEssenceRequestConfig: GoPcmBookReviewEssenceRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_11,
    devUrl: devUrl_0_1_0_11,
    prodUrl: prodUrl_0_1_0_11,
    path: "/go/pcm/bookReview/essence",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewEssence",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/28/interface/api/119886) 的 **请求函数**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-08-03 11:36:17`
 */
export const goPcmBookReviewEssence = /*#__PURE__*/ (
  requestData: GoPcmBookReviewEssenceRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookReviewEssenceResponse>(
    prepare(goPcmBookReviewEssenceRequestConfig, requestData),
    ...args
  );
};

goPcmBookReviewEssence.requestConfig = goPcmBookReviewEssenceRequestConfig;

const mockUrl_0_1_0_12 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_12 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_12 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_12 = "data" as any;

/**
 * 接口 [获取用户主页（主客态）\/go\/pcm\/user\/get-home-page↗](https://yapi.yuewen.com/project/28/interface/api/132518) 的 **请求类型**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2020-09-01 14:39:28`
 */
export interface GoPcmUserGetHomePageRequest {
  userId: string;
  appId: string;
}

/**
 * 接口 [获取用户主页（主客态）\/go\/pcm\/user\/get-home-page↗](https://yapi.yuewen.com/project/28/interface/api/132518) 的 **返回类型**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2020-09-01 14:39:28`
 */
export interface GoPcmUserGetHomePageResponse {
  baseInfo?: {
    /**
     * 385288393
     */
    userId?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 4300000889
     */
    backGroundImageId?: number;
    /**
     * 4300000889
     */
    headImageId?: number;
    /**
     * "zhai11"
     */
    realName?: string;
    /**
     * "1"
     */
    gender?: string;
    /**
     * 2
     */
    level?: number;
    /**
     * 1598347354724
     */
    joinTime?: number;
    /**
     * "China"
     */
    countryName?: string;
    /**
     * 8881
     */
    writingTime?: number;
    /**
     * 11233
     */
    readingTime?: number;
    /**
     * 16
     */
    readBookNum?: number;
    /**
     * 1
     */
    isAuthor?: number;
    isLiked?: number;
    /**
     * 1113
     */
    likeNum?: number;
    /**
     * 1
     */
    isSelf?: number;
    /**
     * "wfewfwe"
     */
    description?: string;
  };
  badgeInfo?: {
    /**
     * 11341
     */
    holdBadgeNum?: number;
    /**
     * [{"badgeId":10003,"coverImgUrl":"https://actimg.webnovel.com/badge/10003/1/","coverUpdatedTime":1516690969000}]
     */
    badgeItems?: {
      /**
       * 10003
       */
      badgeId?: number;
      /**
       * "https://actimg.webnovel.com/badge/10003/1/"
       */
      coverImgUrl?: string;
      /**
       * 1516690969000
       */
      coverUpdatedTime?: number;
    }[];
  };
  readListInfo?: {
    /**
     * 55
     */
    readingListNum?: number;
    hasMore?: number;
    /**
     * [{"collectionId":1309238213402334,"name":"collection2","bookItems":[{"bookId":7522230101,"bookCoverId":0}],"bookNum":1,"views":8553,"follows":1113,"isFollow":0}]
     */
    readListItems?: {
      /**
       * 1309238213402334
       */
      collectionId?: number;
      /**
       * "collection2"
       */
      name?: string;
      /**
       * [{"bookId":7522230101,"bookCoverId":0}]
       */
      bookItems?: {
        /**
         * 7522230101
         */
        bookId?: number;
        bookCoverId?: number;
      }[];
      /**
       * 1
       */
      bookNum?: number;
      /**
       * 8553
       */
      views?: number;
      /**
       * 1113
       */
      follows?: number;
      isFollow?: number;
    }[];
  };
  momentsInfo?: {
    /**
     * 783
     */
    momentsNum?: number;
    /**
     * [{"id":"@id","momentType":"@pick([1,2,3])","createTime":"@createTime","bookInfo":{"bookId":"@pick(['1111111111','222222222','333333333333', ''])","bookType":"@pick([0,100,200])","bookCoverId":0,"bookName":"@title","categoryId":70002,"categoryName":"High Fantasy","authorName":"@name"},"chapterId":"@pick(['1111111111','222222222',''])","chapterIndex":123,"chapterName":"@title","paragraphId":"@pick(['1111111111', ''])","paragraphContent":"wfwe","reviewType":"@pick([1,2])","reviewId":12342,"replyId":122323,"bookReviewScore":1,"replyToUserName":"@name","content":"@paragraph","imageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}]}]
     */
    momentsItems?: {
      /**
       * "@id"
       */
      id?: string;
      /**
       * "@pick([1,2,3])"
       */
      momentType?: string;
      /**
       * "@createTime"
       */
      createTime?: string;
      bookInfo?: {
        /**
         * "@pick(['1111111111','222222222','333333333333', ''])"
         */
        bookId?: string;
        /**
         * "@pick([0,100,200])"
         */
        bookType?: string;
        bookCoverId?: number;
        /**
         * "@title"
         */
        bookName?: string;
        /**
         * 70002
         */
        categoryId?: number;
        /**
         * "High Fantasy"
         */
        categoryName?: string;
        /**
         * "@name"
         */
        authorName?: string;
      };
      /**
       * "@pick(['1111111111','222222222',''])"
       */
      chapterId?: string;
      /**
       * 123
       */
      chapterIndex?: number;
      /**
       * "@title"
       */
      chapterName?: string;
      /**
       * "@pick(['1111111111', ''])"
       */
      paragraphId?: string;
      /**
       * "wfwe"
       */
      paragraphContent?: string;
      /**
       * "@pick([1,2])"
       */
      reviewType?: string;
      /**
       * 12342
       */
      reviewId?: number;
      /**
       * 122323
       */
      replyId?: number;
      /**
       * 1
       */
      bookReviewScore?: number;
      /**
       * "@name"
       */
      replyToUserName?: string;
      /**
       * "@paragraph"
       */
      content?: string;
      /**
       * [{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}]
       */
      imageItems?: {
        /**
         * "https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif"
         */
        imageUrl?: string;
        /**
         * 498
         */
        height?: number;
        /**
         * 332
         */
        width?: number;
      }[];
    }[];
  };
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300000889/1/1.jpg?mt=1595989651000"
     */
    avatar?: string;
    /**
     * "brown5bxjxjxnxjjxj"
     */
    nickName?: string;
    /**
     * "brown5bxjxjxnxjjxj"
     */
    userName?: string;
    /**
     * "4300000889"
     */
    guid?: string;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * "brown5bxjxjxnxjjxj"
     */
    penName?: string;
    /**
     * 31172
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 4
     */
    grade?: number;
    /**
     * 2
     */
    ES?: number;
    /**
     * 2
     */
    totalES?: number;
    /**
     * 3
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: boolean;
    /**
     * 1597754778267
     */
    UUT?: number;
    /**
     * 53
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 1
     */
    membershipStatus?: number;
    /**
     * 1621751606000
     */
    membershipExpireTime?: number;
    /**
     * true
     */
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [获取用户主页（主客态）\/go\/pcm\/user\/get-home-page↗](https://yapi.yuewen.com/project/28/interface/api/132518) 的 **请求配置的类型**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2020-09-01 14:39:28`
 */
type GoPcmUserGetHomePageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/user/get-home-page",
    "data",
    string,
    "userId" | "appId",
    false
  >
>;

/**
 * 接口 [获取用户主页（主客态）\/go\/pcm\/user\/get-home-page↗](https://yapi.yuewen.com/project/28/interface/api/132518) 的 **请求配置**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2020-09-01 14:39:28`
 */
const goPcmUserGetHomePageRequestConfig: GoPcmUserGetHomePageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: "/go/pcm/user/get-home-page",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: [],
    queryNames: ["userId", "appId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetHomePage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取用户主页（主客态）\/go\/pcm\/user\/get-home-page↗](https://yapi.yuewen.com/project/28/interface/api/132518) 的 **请求函数**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2020-09-01 14:39:28`
 */
export const goPcmUserGetHomePage = /*#__PURE__*/ (
  requestData: GoPcmUserGetHomePageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetHomePageResponse>(
    prepare(goPcmUserGetHomePageRequestConfig, requestData),
    ...args
  );
};

goPcmUserGetHomePage.requestConfig = goPcmUserGetHomePageRequestConfig;

/**
 * 接口 [获取moments列表 \/go\/pcm\/user\/get-moment-list↗](https://yapi.yuewen.com/project/28/interface/api/132527) 的 **请求类型**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2024-08-23 16:00:21`
 */
export interface GoPcmUserGetMomentListRequest {}

/**
 * 接口 [获取moments列表 \/go\/pcm\/user\/get-moment-list↗](https://yapi.yuewen.com/project/28/interface/api/132527) 的 **返回类型**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2024-08-23 16:00:21`
 */
export interface GoPcmUserGetMomentListResponse {
  isLast?: number;
  momentsItems?: {
    id?: string;
    momentType?: 2;
    createTime?: string;
    bookInfo?: {
      bookId?: number;
      novelType?: 100 | 0;
      bookCoverId?: number;
      bookName?: string;
      categoryId?: number;
      categoryName?: string;
      authorName?: string;
    };
    chapterId?: number;
    chapterIndex?: number;
    chapterName?: string;
    paragraphId?: string;
    paragraphContent?: "@paragraph";
    reviewType?: 1;
    reviewId?: number;
    replyId?: number;
    bookReviewScore?: 4.5 | 0 | 2.5 | 0 | 1;
    replyToUserName?: "@name";
    content?: "@paragraph";
    imageItems?: {
      imageUrl?: "https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif";
      height?: 332;
      width?: 498;
    }[];
  }[];
}

/**
 * 接口 [获取moments列表 \/go\/pcm\/user\/get-moment-list↗](https://yapi.yuewen.com/project/28/interface/api/132527) 的 **请求配置的类型**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2024-08-23 16:00:21`
 */
type GoPcmUserGetMomentListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/user/get-moment-list",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取moments列表 \/go\/pcm\/user\/get-moment-list↗](https://yapi.yuewen.com/project/28/interface/api/132527) 的 **请求配置**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2024-08-23 16:00:21`
 */
const goPcmUserGetMomentListRequestConfig: GoPcmUserGetMomentListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: "/go/pcm/user/get-moment-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetMomentList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取moments列表 \/go\/pcm\/user\/get-moment-list↗](https://yapi.yuewen.com/project/28/interface/api/132527) 的 **请求函数**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2024-08-23 16:00:21`
 */
export const goPcmUserGetMomentList = /*#__PURE__*/ (
  requestData?: GoPcmUserGetMomentListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetMomentListResponse>(
    prepare(goPcmUserGetMomentListRequestConfig, requestData),
    ...args
  );
};

goPcmUserGetMomentList.requestConfig = goPcmUserGetMomentListRequestConfig;

const mockUrl_0_1_0_13 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_13 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_13 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_13 = "data" as any;

/**
 * 接口 [get-content 获取阅读内容↗](https://yapi.yuewen.com/project/28/interface/api/166153) 的 **请求类型**
 *
 * @分类 [Book+Comic ReadingPage【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21017)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2020-10-19 17:30:44`
 */
export interface GoPcmChapterGetContentRequest {
  bookId: string;
  chapterId: string;
  /**
   * 1: 需要段内容 0：不需要段内容
   */
  withParagraphContent: string;
}

/**
 * 接口 [get-content 获取阅读内容↗](https://yapi.yuewen.com/project/28/interface/api/166153) 的 **返回类型**
 *
 * @分类 [Book+Comic ReadingPage【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21017)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2020-10-19 17:30:44`
 */
export interface GoPcmChapterGetContentResponse {
  bookInfo?: {
    /**
     * "${query.bookId}"
     */
    bookId?: string;
    /**
     * "Rebirth of the Strongest Empress"
     */
    bookName?: string;
    /**
     * 3004311901233701
     */
    authorId?: number;
    /**
     * " North Night"
     */
    authorName?: string;
    /**
     * 163
     */
    totalChapterNum?: number;
    /**
     * "zh"
     */
    languageName?: string;
    /**
     * "30"
     */
    actionStatus?: string;
    /**
     * 1161
     */
    reviewTotal?: number;
    /**
     * 1
     */
    bookType?: number;
    totalPreChapterNum?: number;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * 5
     */
    topChapterLevel?: number;
    /**
     * ["/274367222/web-read-video3","/274367222/msite-book-rect4","/274367222/msite-read-video3","/274367222/msite-book-rect2"]
     */
    adIds?: string[];
    /**
     * []
     */
    videoAdIds?: unknown[];
    /**
     * 1
     */
    isShowAds?: number;
    /**
     * 487
     */
    giftNum?: number;
  };
  chapterInfo?: {
    banner?: {
      /**
       * "@string"
       */
      coverUrl?: string;
      /**
       * "@string"
       */
      desc?: string;
    };
    /**
     * "${query.chapterId}"
     */
    chapterId?: string;
    /**
     * "Crushing the Heart on Lingyun"
     */
    chapterName?: string;
    /**
     * 1
     */
    chapterIndex?: number;
    /**
     * "41288685441829971"
     */
    preChapterId?: string;
    /**
     * "xxx"
     */
    preChapterName?: string;
    /**
     * "41312210319887628"
     */
    nextChapterId?: string;
    /**
     * "xxx"
     */
    nextChapterName?: string;
    chapterLevel?: number;
    /**
     * 3
     */
    userLevel?: number;
    isVip?: number;
    /**
     * 1
     */
    SSPrice?: number;
    /**
     * [{"paragraphId":"fb8837b59bbc125049255bcf04c838bf","content":"The carriage went all the way into the city. Although it was nighttime, because the Imperial Capital was the Empire's largest and most famous commercial center, the gates of this place had never once been closed, except during the warring era.\r\n"},{"paragraphId":"2c57d66e82bfb04eaef57e81fd431f96","content":"Rody was tailing the carriage from a distance. He did not dare to stay too close to the carriage. Only God knew how powerful the beautiful girl actually was, and in the event that Rody was discovered, he would end up in prison together with Star.\r\n"},{"paragraphId":"f66bbe70adf941c656caaf07a2d9f9ce","content":"The carriage passed through the capital’s magnificent Victory Square and entered a wide road. Rody had already been in the capital for 2 years but he was still not familiar with this road. He knew that only the most powerful of aristocrats could live here. All the people living here were from rich and powerful families.\r\n"},{"paragraphId":"cc1bf646b2497450c43455b529a3f40c","content":"The carriage slowly stopped in front of a large mansion. The thick wooden door of the mansion was painted in red giving it an iron-like look. Rody was surprised and almost fell down when he saw the family insignia on the door. He knew what that pattern was! It was the insignia for the Flame Tulip Family!\r\n"},{"paragraphId":"92fac219e519d68cad3076ce46485dd9","content":"As a senior student in the Imperial Academy, he was familiar with the Empire's military history. Rody obviously knew what that flame-like tulip insignia represented.\r\n"},{"paragraphId":"a4096ed209f4c5dd19ad37abb878bfec","content":"It represented honor and glory! It represented the people's respect and admiration! The Flame Tulip Family. It was the family of the descendants of the first Marshal that helped His Majesty the Emperor found the Empire. In the Empire's 600 years of history, the family has had a total of 14 Marshals. Each and every one of them was an outstanding strategist. They have contributed much to the Empire. Rody remembered his history teacher telling him in a tone of reverence that this family was the God of War’s family.\r\n"},{"paragraphId":"1a691fe800c22804c46240cb20fc0c38","content":"Naturally, Rody only had respect for this family! Never in his life would he have imagined that he would attack the Tulip Family. It looked like there was now a perfect explanation for her ridiculous power. As she was part of the Flame Tulip Family, she must be very powerful. As the carriage slowly passed through the main entrance, the door closed. Rody’s heart was now filled with anxiety.\r\n"},{"paragraphId":"9afee2920378a1a3544ddef48cc82946","content":"He knew how serious it was to deal with the Tulip Family if they found out that he secretly came here to rescue someone. If they caught him, terrible things would happen. If they found out that a group of people had attacked the Tulip Family, it was certain that this group of people would all be hanged. Any normal person would pack up and run away immediately, as far away as possible.\r\n"},{"paragraphId":"fa2d07dcfd6431ba25bcddbed305e32a","content":"Rody thought to himself for a moment and sighed. He could not abandon his friend and run away on his own. It was not consistent with his principles of life.  Although Rody was not a virtuous person, he would not abandon his family and friends.\r\n"},{"paragraphId":"6e4e4043253e087bbfac220e8fa40edb","content":"Gritting his teeth, Rody entered a small alley next to the mansion. He looked around carefully to make sure that there was no one around before he climbed the walls and jumped into the compound….\r\n"},{"paragraphId":"030f024df2f8b9e93f6f798fa110d888","content":"Nicole watched her drunk little brother being ferried back. Although she was extremely angry, her face was expressionless. She then called her servants and waved her hand as she coldly said, “Carry him down and let him rest.” \r\n"},{"paragraphId":"52d78df1e38430e3927af6ff68c1dede","content":"Unfortunately, the idiotic future duke was not an obedient person. Being drunk, he could not recognize the person in front of him. His eyes were lax as he laughed and jokingly looked at his sister. He also stretched out his finger and attempted to tease her chin.\r\n"},{"paragraphId":"25de5db13bd443c73545cad4f75e03c6","content":"In a daze, he mumbled to himself, “Ah, my dear Sarah! I did not see you for a few days and you have already forgotten about me? You little fox! Let’s see how I shall teach you tonight!” He then stretched his arms and threw himself forward.\r\n"},{"paragraphId":"c6ed81b14d1bed05abd7646c195659f9","content":"Nicole’s face turned ghastly pale as she skillfully turned sideways, causing him to stumble into a void. Anger started to show in her eyes as she spoke coldly, “Sarah? You even went to that kind of filthy place?” The pitiful playboy was still not aware of the dangerous situation he was in. Nicole flicked a finger and immediately, a white light shot out and struck the playboy’s stomach.\r\n"},{"paragraphId":"2e007ce3530629ed57c52cf59652e4c8","content":"The playboy did not even have the chance to scream as he flew 3 meters away and crashed face first into the ground.\r\n"},{"paragraphId":"445022b213fde0def1f5d51d6ad82eb2","content":"Rody was hiding on top a tree outside the hall and saw the entire scene. He wondered, that if he was the target being shot at, would he be able to dodge it? The answer in his heart made him give out cold sweat.\r\n"},{"paragraphId":"d3e50af7b11e3b2615687f8a2de79304","content":"In fact, Rody did not even dare to breathe heavily at his hiding place as he carefully hid himself. He knew that Star was tied up somewhere in the yard. Although there was nobody in the yard, Rody did not dare rescue his friend while the female mage was still around. He planned to wait until the middle of the night when everybody was asleep before he began his rescue.\r\n"},{"paragraphId":"e05d6ee21fd2ac1b465e9aa3a088735c","content":"They would probably not send Star to jail so late at night. Star should be tied up somewhere like the stables or the firewood store until dawn. As the beautiful female mage should be the proprietress here, her bedroom would most likely be far away from such places. In that case, Rody would be safer when he rescues his friend.\r\n"},{"paragraphId":"2db57493eb7e5dc1d85a95cbabe996d0","content":"Rody, hiding within the trees and lost in his thoughts, was unaware that the people in the yard had moved away. Star, who was left in the yard earlier, was also carried away by one of the stronger servants.\r\n"},{"paragraphId":"513d854ba9fd50fd5eb386fda226d6d4","content":"Although the mosquitoes and ants made Rody feel very uncomfortable, he persevered until the middle of the night.\r\n"},{"paragraphId":"eacacb65d107d709a6e321855cbfee23","content":"From the position of the moon in the sky, Rody guessed that it should be past midnight now and he slowly descended the tree.\r\n"},{"paragraphId":"e474e4b5869a9c572b43afe7871111bb","content":"He was not familiar with his surroundings, but it so happened he had good grades for architecture in the academy. Hence, from the entire mansion, he could guess the location of the living quarters of the owner, the servants and other areas such as the stable. Rody picked a path and quickly dashed towards the stable.\r\n"},{"paragraphId":"327bb4d8cc124f475ee85ad5097a912b","content":"Rody had never seen such a huge stable before! He had always thought that the stable in the Academy was quite large. However, the stable here was twice as big compared to the Imperial Academy's! It was large enough to fit more than a hundred horses. Rody sighed. A glance at the windows of the stable showed that it did not have any lights on. He quietly pushed the door open and went in.\r\n"},{"paragraphId":"d120accc1b4dee3c4a2893d48549da3d","content":"“Star!” Rody whispered as he walked. He stumbled over the straws and wooden boxes on the ground twice but he still did not dare to light up the place. He had brushed into a lot of straw and horse manure but he could not be bothered. He knew that if he could not find Star by tomorrow, they would be finished!\r\n"},{"paragraphId":"ccd3883a81b348e3840d03ca370902dc","content":"As soon as Rody reached the end of the stable, he heard light footsteps from across the door. His heart suddenly jumped into his throat as he desperately hid in the biggest horse shed.\r\n"},{"paragraphId":"7727b9a74cbe64a215c5749f5570d47d","content":"The shed was obviously larger than the rest in the stable and particularly well constructed.\r\n"},{"paragraphId":"89f1f2a90a96b8646621056c52cda671","content":"On the railings was also a saddle. Naturally, it was a high-quality item. Rody looked back and saw a pair of eyes staring back at him in the dark. Before he could cry out, he realized that it was just a horse.\r\n"},{"paragraphId":"d72721d51f10a35e2fdff4ebcf30db4d","content":"Even in the dark, Rody could faintly see that this was a very handsome black horse. Its limbs were healthy and strong like reinforced iron. The horse was watching Rody. Its nose puffed hot air and its hooves were restless. Apparently, Rody disturbed its sleep.\r\n"},{"paragraphId":"f87bf7adca726cb26aad09ff9a2865cc","content":"Rody gingerly moved to the side of the horse and muttered, \"Dear horse, dear horse. I am not a horse thief. I mean no harm.\" Rody then touched the horse's mane. He tried to use the skill learned in the Imperial Academy to calm down the horse.\r\n"},{"paragraphId":"150157e4a7c2a57bf135792c9462def7","content":"At this time, he heard footsteps gradually approaching. Clearly, someone was heading here.\r\n"},{"paragraphId":"07d77754900a92b163b4d351511bd4a8","content":"Rody complained in his heart. In a moment of desperation, he caught sight of a cross-beam above. He quietly leaped up and caught the beam. His legs then latched onto it so that his body was hanging from it.\r\n"},{"paragraphId":"0f6a7b18c5ec114192b67b3fd6c5dd17","content":"“Garrus … you are really not well-behaved,” a soft timid voice came from outside the horse shed. Nicole was standing outside the shed as she looked at the restless horse in it. Her father loved horses and this battle horse was used in the battlefield when her father commanded the army.\r\n"},{"paragraphId":"caaefbb80f873dbd0bf06953b48599a0","content":"“Garrus…. Do not flail about…. I'm in a bad mood tonight.” Nicole’s tone was low and her wonderful voice gave out a sad mood. Her soft voice was capable of breaking the hearts of listeners.\r\n"},{"paragraphId":"a2678b02d31b36518fe364dcf2fa0772","content":"Nicole gently opened the barrier gate of the horse shed and slowly walked in. Rody was so scared that he even stopped breathing. He also dared not move as he feared to make any sound. Nicole reached out and gently stroked the mane and neck of the horse. Under the gentle strokes of its master, the horse soon calmed down.\r\n"},{"paragraphId":"c4bd0b2498d05d3321967003f783da18","content":"“Garrus…. I am very sad….” Nicole’s words sounded immeasurably aggrieved. “Why… Why do I have to bear all this… I miss my father....” She slowly hugged the horse such that her face was at its neck. “I know. You are also thinking of father as well?”\r\n"},{"paragraphId":"14c9bc4e426b5452d55b8cd1b7419a14","content":"In the dark, the girl, wearing a white nightgown, continued to whisper and cry softly. Seeing the beautiful blonde Nicole’s heartbreaking crying face, the hair at her forehead damp from her tears, Rody's young heart was touched, as if someone was poking it softly with a stick.\r\n"},{"paragraphId":"dcf405223916e8b6e7c5c05339ca76a0","content":"God, what kind of abominable matter is this?! To let such a beautiful girl cry in such a pitiful manner is surely a crime.\r\n"},{"paragraphId":"398510d73edea7a32bb01d0c1ae5a035","content":"Nicole wept quietly for a long time before she let go of the horse and gently tidied her hair. She sighed and whispered, “Enough. Garrus, I cried again today and that is wrong. I should live up to my father’s expectations … I need to be brave. I cannot cry!” She gently said, “I know you are unhappy as well. The stable hand told me you are very irritable too. I also know that you do not like being in the stable every day and you also miss father. You also miss the days when he took you out for a ride, do you not?”\r\n<pirate>Find authorized novels in Webnovel，faster updates, better experience，Please click\n<a href=\"https://www.webnovel.com\">www.webnovel.com</a> for visiting.</pirate>"},{"paragraphId":"103ee28988a20fe2a0e74c45434d6450","content":"\"But I really do not know what to do. The family is gradually declining. The Tulips are fading away … but I am powerless! If I were a boy, I could inherit my father's responsibility. However, that playboy is father's only son. The only male in the family. However, he is ignorant and only tarnishes the name of the family. I feel isolated and helpless!\"\r\n"},{"paragraphId":"65372be5ee6fca7900758cea1fcdce89","content":"Nicole sighed and prayed, “May father’s soul in heaven bestow me courage! May the heavens bestow the Tulip Family a ray of hope! May God give me a guide so that I am no longer alone in my fight!”\r\n"},{"paragraphId":"bee46c179d08dd2722d0180abc77fedd","content":"Just as soon as Nicole's delicate voice ended her prayers, there was a ‘plop’ sound as a dark figure fell from the sky and in front of Nicole. The man slowly raised his head and turned his dirty face towards Nicole. What truly scared the girl almost to the point of suffocation was his half-black-half-white Yin Yang face.\r\n"}]
     */
    contents?: {
      /**
       * "fb8837b59bbc125049255bcf04c838bf"
       */
      paragraphId?: string;
      /**
       * "The carriage went all the way into the city. Although it was nighttime, because the Imperial Capital was the Empire's largest and most famous commercial center, the gates of this place had never once been closed, except during the warring era.\r\n"
       */
      content?: string;
    }[];
    isAuth?: number;
    /**
     * 1
     */
    batchUnlockStatus?: number;
    isRichFormat?: number;
    /**
     * "34408653851257530"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    firstChapterIndex?: number;
    originalPrice?: number;
    discountInfo?: string;
    /**
     * []
     */
    groupItems?: unknown[];
    /**
     * [{"id":11046073405330600,"userId":4301078817,"name":"AtlasStudios"},{"id":29720617590786228,"name":"Atlas Studios"}]
     */
    editorItems?: {
      /**
       * 11046073405330600
       */
      id?: number;
      /**
       * 4301078817
       */
      userId?: number;
      /**
       * "AtlasStudios"
       */
      name?: string;
    }[];
    /**
     * [{"id":11046073405330600,"userId":4301078817,"name":"AtlasStudios"}]
     */
    translatorItems?: {
      /**
       * 11046073405330600
       */
      id?: number;
      /**
       * 4301078817
       */
      userId?: number;
      /**
       * "AtlasStudios"
       */
      name?: string;
    }[];
    /**
     * 1321
     */
    reviewTotal?: number;
    /**
     * 1
     */
    orderIndex?: number;
    notes?: {
      /**
       * "AtlasStudios"
       */
      name?: string;
      penName?: null;
      /**
       * "4301078817"
       */
      userId?: string;
      /**
       * "//userimg.webnovel.com/userheadimg/4301078817/1/1.jpg?mt=1539581805000?mt=0"
       */
      avatar?: string;
      /**
       * "translator"
       */
      role?: string;
      /**
       * "fewsdfgeergergre"
       */
      note?: string;
      UUT?: number;
    };
    /**
     * [{"msgType":1,"title":"fwfewf title","content":"The title of this work is the main character’s name. At most got three lines of this text area. Within 64 characters.","target":"this is a target","reward":"this is a reward"}]
     */
    announcementItems?: {
      /**
       * 1
       */
      msgType?: number;
      /**
       * "fwfewf title"
       */
      title?: string;
      /**
       * "The title of this work is the main character’s name. At most got three lines of this text area. Within 64 characters."
       */
      content?: string;
      /**
       * "this is a target"
       */
      target?: string;
      /**
       * "this is a reward"
       */
      reward?: string;
    }[];
    /**
     * 1
     */
    noArchive?: number;
  };
  /**
   * 1
   */
  membershipStatus?: number;
  /**
   * 1
   */
  waitpayStatus?: number;
  /**
   * 1
   */
  test?: number;
}

/**
 * 接口 [get-content 获取阅读内容↗](https://yapi.yuewen.com/project/28/interface/api/166153) 的 **请求配置的类型**
 *
 * @分类 [Book+Comic ReadingPage【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21017)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2020-10-19 17:30:44`
 */
type GoPcmChapterGetContentRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/chapter/getContent",
    "data",
    string,
    "bookId" | "chapterId" | "withParagraphContent",
    false
  >
>;

/**
 * 接口 [get-content 获取阅读内容↗](https://yapi.yuewen.com/project/28/interface/api/166153) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21017)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2020-10-19 17:30:44`
 */
const goPcmChapterGetContentRequestConfig: GoPcmChapterGetContentRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_13,
    devUrl: devUrl_0_1_0_13,
    prodUrl: prodUrl_0_1_0_13,
    path: "/go/pcm/chapter/getContent",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_13,
    paramNames: [],
    queryNames: ["bookId", "chapterId", "withParagraphContent"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetContent",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-content 获取阅读内容↗](https://yapi.yuewen.com/project/28/interface/api/166153) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21017)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2020-10-19 17:30:44`
 */
export const goPcmChapterGetContent = /*#__PURE__*/ (
  requestData: GoPcmChapterGetContentRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterGetContentResponse>(
    prepare(goPcmChapterGetContentRequestConfig, requestData),
    ...args
  );
};

goPcmChapterGetContent.requestConfig = goPcmChapterGetContentRequestConfig;

const mockUrl_0_1_0_14 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_14 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_14 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_14 = "data" as any;

/**
 * 接口 [get-book-tag-list↗](https://yapi.yuewen.com/project/28/interface/api/166162) 的 **请求类型**
 *
 * @分类 [Tag 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21021)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2020-10-19 17:23:04`
 */
export interface GoPcmTagGetBookTagListRequest {
  bookId: string;
}

/**
 * 接口 [get-book-tag-list↗](https://yapi.yuewen.com/project/28/interface/api/166162) 的 **返回类型**
 *
 * @分类 [Tag 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21021)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2020-10-19 17:23:04`
 */
export interface GoPcmTagGetBookTagListResponse {
  /**
   * [{"tagId":41090001,"tagName":"aaa","isLiked":0,"likeNums":10},{"tagId":41090002,"tagName":"bbb","isLiked":0,"likeNums":7},{"tagId":41090060,"tagName":"yc1","isLiked":0,"likeNums":2}]
   */
  tagInfo?: {
    /**
     * 41090001
     */
    tagId?: number;
    /**
     * "aaa"
     */
    tagName?: string;
    isLiked?: number;
    /**
     * 10
     */
    likeNums?: number;
  }[];
}

/**
 * 接口 [get-book-tag-list↗](https://yapi.yuewen.com/project/28/interface/api/166162) 的 **请求配置的类型**
 *
 * @分类 [Tag 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21021)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2020-10-19 17:23:04`
 */
type GoPcmTagGetBookTagListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/tag/get-book-tag-list",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [get-book-tag-list↗](https://yapi.yuewen.com/project/28/interface/api/166162) 的 **请求配置**
 *
 * @分类 [Tag 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21021)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2020-10-19 17:23:04`
 */
const goPcmTagGetBookTagListRequestConfig: GoPcmTagGetBookTagListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_14,
    devUrl: devUrl_0_1_0_14,
    prodUrl: prodUrl_0_1_0_14,
    path: "/go/pcm/tag/get-book-tag-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_14,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTagGetBookTagList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-book-tag-list↗](https://yapi.yuewen.com/project/28/interface/api/166162) 的 **请求函数**
 *
 * @分类 [Tag 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21021)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2020-10-19 17:23:04`
 */
export const goPcmTagGetBookTagList = /*#__PURE__*/ (
  requestData: GoPcmTagGetBookTagListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmTagGetBookTagListResponse>(
    prepare(goPcmTagGetBookTagListRequestConfig, requestData),
    ...args
  );
};

goPcmTagGetBookTagList.requestConfig = goPcmTagGetBookTagListRequestConfig;

const mockUrl_0_1_0_15 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_15 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_15 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_15 = "data" as any;

/**
 * 接口 [get-chapter-list 拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/166163) 的 **请求类型**
 *
 * @分类 [chapter 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21027)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2020-12-23 14:16:48`
 */
export interface GoPcmChapterGetChapterListRequest {
  bookId: string;
  /**
   * 从1开始，默认0吐全部章节
   */
  pageIndex?: string;
  pageSize?: string;
}

/**
 * 接口 [get-chapter-list 拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/166163) 的 **返回类型**
 *
 * @分类 [chapter 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21027)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2020-12-23 14:16:48`
 */
export interface GoPcmChapterGetChapterListResponse {
  bookInfo?: {
    /**
     * "${query.bookId}"
     */
    bookId?: string;
    /**
     * "His Genius Wife is a Superstar"
     */
    bookName?: string;
    /**
     * 345
     */
    totalChapterNum?: number;
    /**
     * "ArriaCross"
     */
    authorName?: string;
    /**
     * 2
     */
    bookType?: number;
    /**
     * 50
     */
    actionStatus?: number;
    /**
     * 1
     */
    hasPrivilege?: number;
  };
  /**
   * [{"volumeName":"","volumeId":1,"chapterItems":[{"chapterId":"33108867093162835","chapterName":"The Woman in White","chapterIndex":0,"isVip":0,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1,"noArchive":1},{"chapterId":"33108867093162836","chapterName":"The Woman in White1","chapterIndex":0,"isVip":0,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1},{"chapterId":"33108867093162837","chapterName":"The Woman in White2","chapterIndex":2,"isVip":0,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1},{"chapterId":"33108867093162838","chapterName":"The Woman in White3","chapterIndex":3,"isVip":2,"isAuth":0,"publishTime":"Nov 29,2018","chapterLevel":1,"userLevel":1,"canUnlock":1},{"chapterId":"3310886709316289","chapterName":"The Woman in White4","chapterIndex":4,"isVip":2,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":3,"userLevel":3,"canUnlock":1}]}]
   */
  volumeItems?: {
    volumeName?: string;
    /**
     * 1
     */
    volumeId?: number;
    /**
     * [{"chapterId":"33108867093162835","chapterName":"The Woman in White","chapterIndex":0,"isVip":0,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1,"noArchive":1},{"chapterId":"33108867093162836","chapterName":"The Woman in White1","chapterIndex":0,"isVip":0,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1},{"chapterId":"33108867093162837","chapterName":"The Woman in White2","chapterIndex":2,"isVip":0,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1},{"chapterId":"33108867093162838","chapterName":"The Woman in White3","chapterIndex":3,"isVip":2,"isAuth":0,"publishTime":"Nov 29,2018","chapterLevel":1,"userLevel":1,"canUnlock":1},{"chapterId":"3310886709316289","chapterName":"The Woman in White4","chapterIndex":4,"isVip":2,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":3,"userLevel":3,"canUnlock":1}]
     */
    chapterItems?: {
      /**
       * "33108867093162835"
       */
      chapterId?: string;
      /**
       * "The Woman in White"
       */
      chapterName?: string;
      chapterIndex?: number;
      isVip?: number;
      /**
       * 1
       */
      isAuth?: number;
      /**
       * "Nov 29,2018"
       */
      publishTime?: string;
      chapterLevel?: number;
      userLevel?: number;
      /**
       * 1
       */
      canUnlock?: number;
      /**
       * 1
       */
      noArchive?: number;
    }[];
  }[];
  lastChapterItem?: {
    /**
     * "33108867093162835"
     */
    chapterId?: string;
    /**
     * "The Woman in White"
     */
    chapterName?: string;
    chapterIndex?: number;
    isVip?: number;
    /**
     * 1
     */
    isAuth?: number;
    /**
     * "Nov 29,2018"
     */
    publishTime?: string;
    chapterLevel?: number;
    userLevel?: number;
    /**
     * 1
     */
    canUnlock?: number;
    /**
     * 1
     */
    noArchive?: number;
  };
  /**
   * "33108867093162835"
   */
  curReadChapter?: string;
  last?: boolean;
}

/**
 * 接口 [get-chapter-list 拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/166163) 的 **请求配置的类型**
 *
 * @分类 [chapter 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21027)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2020-12-23 14:16:48`
 */
type GoPcmChapterGetChapterListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/chapter/get-chapter-list",
    "data",
    string,
    "bookId" | "pageIndex" | "pageSize",
    false
  >
>;

/**
 * 接口 [get-chapter-list 拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/166163) 的 **请求配置**
 *
 * @分类 [chapter 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21027)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2020-12-23 14:16:48`
 */
const goPcmChapterGetChapterListRequestConfig: GoPcmChapterGetChapterListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: "/go/pcm/chapter/get-chapter-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: ["bookId", "pageIndex", "pageSize"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetChapterList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-chapter-list 拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/166163) 的 **请求函数**
 *
 * @分类 [chapter 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21027)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2020-12-23 14:16:48`
 */
export const goPcmChapterGetChapterList = /*#__PURE__*/ (
  requestData: GoPcmChapterGetChapterListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterGetChapterListResponse>(
    prepare(goPcmChapterGetChapterListRequestConfig, requestData),
    ...args
  );
};

goPcmChapterGetChapterList.requestConfig =
  goPcmChapterGetChapterListRequestConfig;

const mockUrl_0_1_0_16 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_16 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_16 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_16 = "data" as any;

/**
 * 接口 [get-book-detail 详情页↗](https://yapi.yuewen.com/project/28/interface/api/166165) 的 **请求类型**
 *
 * @分类 [Book - detail 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21042)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-09-10 16:41:03`
 */
export interface GoPcmBookGetBookDetailRequest {
  bookId: string;
}

/**
 * 接口 [get-book-detail 详情页↗](https://yapi.yuewen.com/project/28/interface/api/166165) 的 **返回类型**
 *
 * @分类 [Book - detail 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21042)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-09-10 16:41:03`
 */
export interface GoPcmBookGetBookDetailResponse {
  bookInfo?: {
    /**
     * "6831839002000405"
     */
    bookId?: string;
    /**
     * "Once Upon A Time, There Was A Spirit Sword Mountain"
     */
    bookName?: string;
    /**
     * "His Majesty the King"
     */
    authorName?: string;
    /**
     * "1      //推荐票排名"
     */
    powerRank?: string;
    /**
     * 1
     */
    sourceType?: number;
    /**
     * "@string"
     */
    ageGroup?: string;
    /**
     * "@sentence"
     */
    advText?: string;
    /**
     * "@url"
     */
    adActionUrl?: string;
    /**
     * 15
     */
    checklevel?: number;
    /**
     * "3132131231"
     */
    pvNum?: string;
    /**
     * 1577568672000
     */
    publishTime?: number;
    /**
     * 1577568672000
     */
    updateTime?: number;
    /**
     * [{"id":"123 //翻译组id","name":"gg //翻译组名称"}]
     */
    groupItems?: {
      /**
       * "123 //翻译组id"
       */
      id?: string;
      /**
       * "gg //翻译组名称"
       */
      name?: string;
    }[];
    /**
     * [{"id":"18339947115233285","name":"Subudai11","userId":"123"}]
     */
    translatorItems?: {
      /**
       * "18339947115233285"
       */
      id?: string;
      /**
       * "Subudai11"
       */
      name?: string;
      /**
       * "123"
       */
      userId?: string;
    }[];
    /**
     * [{"id":"18339947115233286","name":"Chrissy","userId":"123"}]
     */
    editorItems?: {
      /**
       * "18339947115233286"
       */
      id?: string;
      /**
       * "Chrissy"
       */
      name?: string;
      /**
       * "123"
       */
      userId?: string;
    }[];
    /**
     * [{"id":"18339947115233286","name":"Chrissy","userId":"123"}]
     */
    authorItems?: {
      /**
       * "18339947115233286"
       */
      id?: string;
      /**
       * "Chrissy"
       */
      name?: string;
      /**
       * "123"
       */
      userId?: string;
    }[];
    /**
     * "Xianxia"
     */
    categoryName?: string;
    /**
     * 2312
     */
    categoryId?: number;
    /**
     * 5
     */
    updateFrequency?: number;
    /**
     * "@Number"
     */
    promiseUpdateFrequency?: string;
    /**
     * "chs/week"
     */
    promiseFrequencyUnit?: string;
    /**
     * "chs / week"
     */
    frequencyUnit?: string;
    /**
     * 7
     */
    chapterNum?: number;
    /**
     * "50 //-1 翻译中,30 暂停翻译,40 To be Continued,50 Completed"
     */
    actionStatus?: string;
    /**
     * "5.0"
     */
    totalScore?: string;
    voters?: number;
    /**
     * "In the year 4223, the Spirit Sword Sect was established in the Nine Regions. For thousands of years, it has always been committed to producing first class talented immortal cultivators.\r\n\r\nNowadays, it is among the five great sects within the Union of Ten Thousand Immortals. The sect leader, Daoist Master Feng Yin, is one of the seven great elders of the Union Of Ten Thousand Immortals; his cultivation shocked the world. \r\n\r\nSpirit Sword Sect adhered to subjects of peace and development. The sect’s core values are seeking the truth, seeking the good, and seeking the loyalty. To further expand the power of the sect and to add fresh blood, all elites and geniuses are invited to attend the Immortal Gathering.\r\n\r\n------\r\nRelease Rate: 5 Chapters/Week; will be released on Mon, Wed, Fri and Weekend; "
     */
    description?: string;
    /**
     * 7
     */
    totalChapterNum?: number;
    /**
     * "19366109291645600 //解释详见 LibraryPage 接口"
     */
    firstChapterId?: string;
    /**
     * "19366109291645600 //解释详见 LibraryPage 接口"
     */
    readToChapterId?: string;
    /**
     * "5 //解释详见 LibraryPage 接口"
     */
    readToChapterIndex?: string;
    /**
     * [{"text":"一念永恒","url":"wwww.qidian.com/book/123"}]
     */
    language?: {
      /**
       * "一念永恒"
       */
      text?: string;
      /**
       * "wwww.qidian.com/book/123"
       */
      url?: string;
    }[];
    /**
     * "0 不在书架 1 在书架"
     */
    inLibrary?: string;
    /**
     * [{"tagId":"30001","tagName":"Game"}]
     */
    tagInfo?: {
      /**
       * "30001"
       */
      tagId?: string;
      /**
       * "Game"
       */
      tagName?: string;
    }[];
    /**
     * ["123","456"]
     */
    adIds?: string[];
    /**
     * "baidu.com"
     */
    patreonLink?: string;
    /**
     * [{"jumpLink":"baidu.com","description":"I like this animation1"},{"jumpLink":"https://baidu.com","description":"I like this animation2"}]
     */
    animationItems?: {
      /**
       * "baidu.com"
       */
      jumpLink?: string;
      /**
       * "I like this animation1"
       */
      description?: string;
    }[];
    /**
     * [{"avatar":"","name":"","note":"blabla","role":"author","userId":"ID"},{"avatar":"","name":"","note":"blabla","role":"editor","userId":"ID"},{"avatar":"","name":"","note":"blabla","role":"editor","userId":"ID"},{"avatar":"","name":"","note":"blabla","role":"translator","userId":"ID"}]
     */
    notes?: {
      avatar?: string;
      name?: string;
      /**
       * "blabla"
       */
      note?: string;
      /**
       * "author"
       */
      role?: string;
      /**
       * "ID"
       */
      userId?: string;
    }[];
    /**
     * "www.baidu.com //静读天下用户访问时有此字段，提供epub下载链接"
     */
    epubLink?: string;
    /**
     * "2 //1 normal,2 vote"
     */
    type?: string;
    /**
     * "123 //点赞数，type为2时才有这个字段"
     */
    energyNum?: string;
    /**
     * "333333 //书封变更时间"
     */
    coverUpdateTime?: string;
    /**
     * 2279
     */
    giftNum?: number;
    /**
     * 131
     */
    topFans?: number;
    /**
     * [{"userId":0,"appId":0},{"userId":4300000218,"appId":10,"UUT":1556076188000},{"userId":1520658766,"appId":10,"UUT":1552648459000}]
     */
    topFanItems?: {
      userId?: number;
      appId?: number;
    }[];
  };
  user?: {
    guid?: string;
    /**
     * "昵称"
     */
    nickName?: string;
    /**
     * "真实名称"
     */
    userName?: string;
    /**
     * "笔名"
     */
    penName?: string;
    /**
     * "角色"
     */
    role?: string;
    /**
     * "0-登录 -1-未登录"
     */
    status?: string;
    /**
     * "头像"
     */
    avatar?: string;
    /**
     * "0-当天未签到 1-当天已签到"
     */
    isCheckin?: string;
    /**
     * "1 //用户等级"
     */
    userLevel?: string;
    /**
     * 3
     */
    totalEnergy?: number;
    /**
     * 2
     */
    availableEnergy?: number;
    /**
     * 3
     */
    totalPower?: number;
    /**
     * 2
     */
    availablePower?: number;
  };
  /**
   * "1//当前读到的章节id"
   */
  curReadChapter?: string;
}

/**
 * 接口 [get-book-detail 详情页↗](https://yapi.yuewen.com/project/28/interface/api/166165) 的 **请求配置的类型**
 *
 * @分类 [Book - detail 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21042)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-09-10 16:41:03`
 */
type GoPcmBookGetBookDetailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/book/get-book-detail",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [get-book-detail 详情页↗](https://yapi.yuewen.com/project/28/interface/api/166165) 的 **请求配置**
 *
 * @分类 [Book - detail 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21042)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-09-10 16:41:03`
 */
const goPcmBookGetBookDetailRequestConfig: GoPcmBookGetBookDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_16,
    devUrl: devUrl_0_1_0_16,
    prodUrl: prodUrl_0_1_0_16,
    path: "/go/pcm/book/get-book-detail",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_16,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBookDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-book-detail 详情页↗](https://yapi.yuewen.com/project/28/interface/api/166165) 的 **请求函数**
 *
 * @分类 [Book - detail 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21042)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-09-10 16:41:03`
 */
export const goPcmBookGetBookDetail = /*#__PURE__*/ (
  requestData: GoPcmBookGetBookDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetBookDetailResponse>(
    prepare(goPcmBookGetBookDetailRequestConfig, requestData),
    ...args
  );
};

goPcmBookGetBookDetail.requestConfig = goPcmBookGetBookDetailRequestConfig;

const mockUrl_0_1_0_17 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_17 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_17 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_17 = "data" as any;

/**
 * 接口 [get-gift-info根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/166173) 的 **请求类型**
 *
 * @分类 [gift 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21048)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2020-10-22 11:18:26`
 */
export interface GoPcmGiftGetGiftInfoRequest {
  /**
   * 书籍Id
   */
  bookId: string;
  /**
   * 0-小说 100-漫画 200-出版社
   */
  novelType: string;
}

/**
 * 接口 [get-gift-info根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/166173) 的 **返回类型**
 *
 * @分类 [gift 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21048)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2020-10-22 11:18:26`
 */
export interface GoPcmGiftGetGiftInfoResponse {
  giftNum?: number;
  giftMax?: {
    /**
     * 15927
     */
    id?: number;
    /**
     * 7366916601012405
     */
    bookId?: number;
    /**
     * 19775416453662908
     */
    chapterId?: number;
    /**
     * 4300000390
     */
    userId?: number;
    /**
     * 1
     */
    giftAmount?: number;
    /**
     * "6665224524910655505"
     */
    orderId?: string;
    /**
     * 20008
     */
    giftId?: number;
    /**
     * 8888
     */
    totalPrice?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1547805199000
     */
    UUT?: number;
    /**
     * "Candy"
     */
    userName?: string;
    /**
     * "Lollipop"
     */
    giftName?: string;
    /**
     * 88888
     */
    giftPrice?: number;
    /**
     * "testUrl"
     */
    iconUrl?: string;
    /**
     * 1
     */
    status?: number;
    /**
     * 1
     */
    order?: number;
  };
  /**
   * [{"id":15991,"userId":4300000770,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1555552974000,"userName":"289380420_0704"},{"id":15990,"userId":4300000770,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1555552974000,"userName":"289380420_0704"},{"id":15989,"userId":4300000770,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1555552974000,"userName":"289380420_0704"},{"id":15988,"userId":4300000770,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1555552974000,"userName":"289380420_0704"},{"id":15987,"userId":4300000770,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1555552974000,"userName":"289380420_0704"},{"id":15986,"userId":4300000770,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1555552974000,"userName":"289380420_0704"},{"id":15985,"userId":2986420237,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1517293383000,"userName":"wentao"},{"id":15984,"userId":2986420237,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1517293383000,"userName":"wentao"},{"id":15983,"userId":2986420237,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1517293383000,"userName":"wentao"},{"id":15982,"userId":2986420237,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1517293383000,"userName":"wentao"}]
   */
  giftRecords?: {
    /**
     * 15991
     */
    id?: number;
    /**
     * 4300000770
     */
    userId?: number;
    /**
     * 20001
     */
    giftId?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * "Balloon"
     */
    giftName?: string;
    /**
     * 5
     */
    giftPrice?: number;
    /**
     * "https://webbanner.webnovel.com/gift/1539660206_9513.png"
     */
    iconUrl?: string;
    /**
     * 1
     */
    status?: number;
    /**
     * 1
     */
    order?: number;
    /**
     * 1555552974000
     */
    UUT?: number;
    /**
     * "289380420_0704"
     */
    userName?: string;
  }[];
}

/**
 * 接口 [get-gift-info根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/166173) 的 **请求配置的类型**
 *
 * @分类 [gift 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21048)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2020-10-22 11:18:26`
 */
type GoPcmGiftGetGiftInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/gift/get-gift-info",
    "data",
    string,
    "bookId" | "novelType",
    false
  >
>;

/**
 * 接口 [get-gift-info根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/166173) 的 **请求配置**
 *
 * @分类 [gift 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21048)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2020-10-22 11:18:26`
 */
const goPcmGiftGetGiftInfoRequestConfig: GoPcmGiftGetGiftInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_17,
    devUrl: devUrl_0_1_0_17,
    prodUrl: prodUrl_0_1_0_17,
    path: "/go/pcm/gift/get-gift-info",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_17,
    paramNames: [],
    queryNames: ["bookId", "novelType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGiftGetGiftInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-gift-info根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/166173) 的 **请求函数**
 *
 * @分类 [gift 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21048)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2020-10-22 11:18:26`
 */
export const goPcmGiftGetGiftInfo = /*#__PURE__*/ (
  requestData: GoPcmGiftGetGiftInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmGiftGetGiftInfoResponse>(
    prepare(goPcmGiftGetGiftInfoRequestConfig, requestData),
    ...args
  );
};

goPcmGiftGetGiftInfo.requestConfig = goPcmGiftGetGiftInfoRequestConfig;

const mockUrl_0_1_0_18 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_18 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_18 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_18 = "data" as any;

/**
 * 接口 [get-power-info 推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/166180) 的 **请求类型**
 *
 * @分类 [stone【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21054)
 * @请求头 `GET /go/pcm/stone/get-power-info`
 * @更新时间 `2020-10-22 11:14:37`
 */
export interface GoPcmStoneGetPowerInfoRequest {
  bookId: string;
  /**
   *    ALL = -1,
   * TRANSLATION = 1,
   * ORIGINAL = 2
   */
  bookType: string;
  /**
   * 书类型 0-小说 100-漫画 200-出版社
   */
  novelType: string;
}

/**
 * 接口 [get-power-info 推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/166180) 的 **返回类型**
 *
 * @分类 [stone【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21054)
 * @请求头 `GET /go/pcm/stone/get-power-info`
 * @更新时间 `2020-10-22 11:14:37`
 */
export interface GoPcmStoneGetPowerInfoResponse {
  /**
   * 300
   */
  powerNums?: number;
  /**
   * "3"
   */
  rank?: string;
  /**
   * "2"
   */
  userLeftPower?: string;
  /**
   * [123,456]
   */
  recentUserIds?: number[];
}

/**
 * 接口 [get-power-info 推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/166180) 的 **请求配置的类型**
 *
 * @分类 [stone【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21054)
 * @请求头 `GET /go/pcm/stone/get-power-info`
 * @更新时间 `2020-10-22 11:14:37`
 */
type GoPcmStoneGetPowerInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/stone/get-power-info",
    "data",
    string,
    "bookId" | "bookType" | "novelType",
    false
  >
>;

/**
 * 接口 [get-power-info 推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/166180) 的 **请求配置**
 *
 * @分类 [stone【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21054)
 * @请求头 `GET /go/pcm/stone/get-power-info`
 * @更新时间 `2020-10-22 11:14:37`
 */
const goPcmStoneGetPowerInfoRequestConfig: GoPcmStoneGetPowerInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: "/go/pcm/stone/get-power-info",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: ["bookId", "bookType", "novelType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmStoneGetPowerInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-power-info 推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/166180) 的 **请求函数**
 *
 * @分类 [stone【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21054)
 * @请求头 `GET /go/pcm/stone/get-power-info`
 * @更新时间 `2020-10-22 11:14:37`
 */
export const goPcmStoneGetPowerInfo = /*#__PURE__*/ (
  requestData: GoPcmStoneGetPowerInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmStoneGetPowerInfoResponse>(
    prepare(goPcmStoneGetPowerInfoRequestConfig, requestData),
    ...args
  );
};

goPcmStoneGetPowerInfo.requestConfig = goPcmStoneGetPowerInfoRequestConfig;

const mockUrl_0_1_0_19 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_19 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_19 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_19 = "data" as any;

/**
 * 接口 [history book list↗](https://yapi.yuewen.com/project/28/interface/api/177) 的 **请求类型**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ReadingHistoryAjax`
 * @更新时间 `2019-07-22 20:22:48`
 */
export interface AjaxReadingHistoryReadingHistoryAjaxRequest {
  /**
   * 第几页
   */
  pageIndex: string;
}

/**
 * 接口 [history book list↗](https://yapi.yuewen.com/project/28/interface/api/177) 的 **返回类型**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ReadingHistoryAjax`
 * @更新时间 `2019-07-22 20:22:48`
 */
export interface AjaxReadingHistoryReadingHistoryAjaxResponse {
  /**
   * [{"bookId":"@id","bookName":"@name","novelType":"200","categoryName":"Sci-Fi","newChapterId":"-1","newChapterIndex":1,"readToChapterId":"@id","readToChapterIndex":1,"firstChapterId":"@id","newChapterTime":1,"readToChapterNum":"40"}]
   */
  historyItems?: {
    /**
     * "@id"
     */
    bookId?: string;
    /**
     * "@name"
     */
    bookName?: string;
    /**
     * "200"
     */
    novelType?: string;
    /**
     * "Sci-Fi"
     */
    categoryName?: string;
    /**
     * "-1"
     */
    newChapterId?: string;
    /**
     * 1
     */
    newChapterIndex?: number;
    /**
     * "@id"
     */
    readToChapterId?: string;
    /**
     * 1
     */
    readToChapterIndex?: number;
    /**
     * "@id"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    newChapterTime?: number;
    /**
     * "40"
     */
    readToChapterNum?: string;
  }[];
  /**
   * 1
   */
  isLast?: number;
  /**
   * "123"
   */
  total?: string;
  user?: {
    /**
     * "null"
     */
    avatar?: string;
    /**
     * "null"
     */
    nickName?: string;
    /**
     * "null"
     */
    userName?: string;
    /**
     * "41830698"
     */
    guid?: string;
    status?: number;
    /**
     * "null"
     */
    role?: string;
    /**
     * "null"
     */
    penName?: string;
  };
}

/**
 * 接口 [history book list↗](https://yapi.yuewen.com/project/28/interface/api/177) 的 **请求配置的类型**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ReadingHistoryAjax`
 * @更新时间 `2019-07-22 20:22:48`
 */
type AjaxReadingHistoryReadingHistoryAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/ReadingHistory/ReadingHistoryAjax",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [history book list↗](https://yapi.yuewen.com/project/28/interface/api/177) 的 **请求配置**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ReadingHistoryAjax`
 * @更新时间 `2019-07-22 20:22:48`
 */
const ajaxReadingHistoryReadingHistoryAjaxRequestConfig: AjaxReadingHistoryReadingHistoryAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: "/ajax/ReadingHistory/ReadingHistoryAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: ["pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReadingHistoryReadingHistoryAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [history book list↗](https://yapi.yuewen.com/project/28/interface/api/177) 的 **请求函数**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ReadingHistoryAjax`
 * @更新时间 `2019-07-22 20:22:48`
 */
export const ajaxReadingHistoryReadingHistoryAjax = /*#__PURE__*/ (
  requestData: AjaxReadingHistoryReadingHistoryAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxReadingHistoryReadingHistoryAjaxResponse>(
    prepare(ajaxReadingHistoryReadingHistoryAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxReadingHistoryReadingHistoryAjax.requestConfig =
  ajaxReadingHistoryReadingHistoryAjaxRequestConfig;

/**
 * 接口 [删除所有历史记录↗](https://yapi.yuewen.com/project/28/interface/api/282) 的 **请求类型**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ClearReadingHistoryAjax`
 * @更新时间 `2018-03-01 14:35:55`
 */
export interface AjaxReadingHistoryClearReadingHistoryAjaxRequest {}

/**
 * 接口 [删除所有历史记录↗](https://yapi.yuewen.com/project/28/interface/api/282) 的 **返回类型**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ClearReadingHistoryAjax`
 * @更新时间 `2018-03-01 14:35:55`
 */
export interface AjaxReadingHistoryClearReadingHistoryAjaxResponse {}

/**
 * 接口 [删除所有历史记录↗](https://yapi.yuewen.com/project/28/interface/api/282) 的 **请求配置的类型**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ClearReadingHistoryAjax`
 * @更新时间 `2018-03-01 14:35:55`
 */
type AjaxReadingHistoryClearReadingHistoryAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/ReadingHistory/ClearReadingHistoryAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [删除所有历史记录↗](https://yapi.yuewen.com/project/28/interface/api/282) 的 **请求配置**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ClearReadingHistoryAjax`
 * @更新时间 `2018-03-01 14:35:55`
 */
const ajaxReadingHistoryClearReadingHistoryAjaxRequestConfig: AjaxReadingHistoryClearReadingHistoryAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: "/ajax/ReadingHistory/ClearReadingHistoryAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReadingHistoryClearReadingHistoryAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除所有历史记录↗](https://yapi.yuewen.com/project/28/interface/api/282) 的 **请求函数**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ClearReadingHistoryAjax`
 * @更新时间 `2018-03-01 14:35:55`
 */
export const ajaxReadingHistoryClearReadingHistoryAjax = /*#__PURE__*/ (
  requestData?: AjaxReadingHistoryClearReadingHistoryAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxReadingHistoryClearReadingHistoryAjaxResponse>(
    prepare(
      ajaxReadingHistoryClearReadingHistoryAjaxRequestConfig,
      requestData
    ),
    ...args
  );
};

ajaxReadingHistoryClearReadingHistoryAjax.requestConfig =
  ajaxReadingHistoryClearReadingHistoryAjaxRequestConfig;

/**
 * 接口 [删除某本书的历史记录↗](https://yapi.yuewen.com/project/28/interface/api/3215) 的 **请求类型**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/DeleteReadingHistoryAjax`
 * @更新时间 `2018-05-07 19:26:52`
 */
export interface AjaxReadingHistoryDeleteReadingHistoryAjaxRequest {
  bookId: string;
}

/**
 * 接口 [删除某本书的历史记录↗](https://yapi.yuewen.com/project/28/interface/api/3215) 的 **返回类型**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/DeleteReadingHistoryAjax`
 * @更新时间 `2018-05-07 19:26:52`
 */
export interface AjaxReadingHistoryDeleteReadingHistoryAjaxResponse {}

/**
 * 接口 [删除某本书的历史记录↗](https://yapi.yuewen.com/project/28/interface/api/3215) 的 **请求配置的类型**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/DeleteReadingHistoryAjax`
 * @更新时间 `2018-05-07 19:26:52`
 */
type AjaxReadingHistoryDeleteReadingHistoryAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/ReadingHistory/DeleteReadingHistoryAjax",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [删除某本书的历史记录↗](https://yapi.yuewen.com/project/28/interface/api/3215) 的 **请求配置**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/DeleteReadingHistoryAjax`
 * @更新时间 `2018-05-07 19:26:52`
 */
const ajaxReadingHistoryDeleteReadingHistoryAjaxRequestConfig: AjaxReadingHistoryDeleteReadingHistoryAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: "/ajax/ReadingHistory/DeleteReadingHistoryAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReadingHistoryDeleteReadingHistoryAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除某本书的历史记录↗](https://yapi.yuewen.com/project/28/interface/api/3215) 的 **请求函数**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/DeleteReadingHistoryAjax`
 * @更新时间 `2018-05-07 19:26:52`
 */
export const ajaxReadingHistoryDeleteReadingHistoryAjax = /*#__PURE__*/ (
  requestData: AjaxReadingHistoryDeleteReadingHistoryAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxReadingHistoryDeleteReadingHistoryAjaxResponse>(
    prepare(
      ajaxReadingHistoryDeleteReadingHistoryAjaxRequestConfig,
      requestData
    ),
    ...args
  );
};

ajaxReadingHistoryDeleteReadingHistoryAjax.requestConfig =
  ajaxReadingHistoryDeleteReadingHistoryAjaxRequestConfig;

const mockUrl_0_1_0_20 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_20 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_20 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_20 = "data" as any;

/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/28/interface/api/12268) 的 **请求类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /page/fans/getBookFansRanking`
 * @更新时间 `2019-05-05 14:13:07`
 */
export interface PageFansGetBookFansRankingRequest {}

/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/28/interface/api/12268) 的 **返回类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /page/fans/getBookFansRanking`
 * @更新时间 `2019-05-05 14:13:07`
 */
export interface PageFansGetBookFansRankingResponse {
  /**
   * [{"userId":0,"userName":null,"ranking":1,"appId":0,"votingCount":65452},{"userId":4300000218,"userName":"yuewentester1024","ranking":2,"appId":10,"votingCount":37746,"UUT":1550460057000},{"userId":1520658766,"userName":"webnoveltest123","ranking":3,"appId":10,"votingCount":7510,"UUT":1552648459000},{"userId":3968405415,"userName":"jennyrenjialele5","ranking":4,"appId":10,"UUT":1530701317000},{"userId":1059463888,"userName":"xujin0515","ranking":5,"appId":10,"UUT":1542710966000},{"userId":101087995,"userName":"garden6cg","ranking":6,"appId":10,"UUT":1539950384000},{"userId":4300000467,"userName":"fourautumn1024","ranking":7,"appId":10,"UUT":1550221196000},{"userId":2959616949,"userName":"Eason057","ranking":8,"appId":10,"UUT":1539936723000},{"userId":41830698,"userName":"clarkzhangss","ranking":9,"appId":10,"UUT":1551407418000},{"userId":1901271742,"userName":"testingya","ranking":10,"appId":10,"UUT":1556250655000},{"userId":2140464915,"userName":"1231","ranking":11,"appId":10,"UUT":1551255485000},{"userId":4300000437,"userName":"LANEYU","ranking":12,"appId":10,"UUT":1527132787000},{"userId":4300000120,"userName":"bigcat004","ranking":13,"appId":10,"UUT":1553072138000},{"userId":4300000390,"userName":"Candy","ranking":14,"appId":10,"UUT":1547805199000},{"userId":4300000535,"userName":"Clementine","ranking":15,"appId":10,"UUT":1550461413000},{"userId":4300000208,"userName":"lily7","ranking":16,"appId":10,"UUT":1532690675000},{"userId":4300000431,"userName":"zhouxiyuan","ranking":17,"appId":10,"UUT":1529404645377},{"userId":3093119117,"userName":"zyftest","ranking":18,"appId":10,"UUT":1555987639000},{"userId":4300000213,"userName":"taozi","ranking":19,"appId":10,"UUT":1547607296000},{"userId":2760955332,"userName":"QStack","ranking":20,"appId":10,"UUT":1516946520000}]
   */
  items?: {
    userId?: number;
    userName?: null;
    /**
     * 1
     */
    ranking?: number;
    appId?: number;
    /**
     * 65452
     */
    votingCount?: number;
  }[];
  my?: {
    /**
     * 755
     */
    votingCount?: number;
    /**
     * 13
     */
    ranking?: number;
  };
  /**
   * 68
   */
  total?: number;
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 20
   */
  pageSize?: number;
  isLast?: number;
}

/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/28/interface/api/12268) 的 **请求配置的类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /page/fans/getBookFansRanking`
 * @更新时间 `2019-05-05 14:13:07`
 */
type PageFansGetBookFansRankingRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/page/fans/getBookFansRanking",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/28/interface/api/12268) 的 **请求配置**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /page/fans/getBookFansRanking`
 * @更新时间 `2019-05-05 14:13:07`
 */
const pageFansGetBookFansRankingRequestConfig: PageFansGetBookFansRankingRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: "/page/fans/getBookFansRanking",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageFansGetBookFansRanking",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/28/interface/api/12268) 的 **请求函数**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /page/fans/getBookFansRanking`
 * @更新时间 `2019-05-05 14:13:07`
 */
export const pageFansGetBookFansRanking = /*#__PURE__*/ (
  requestData?: PageFansGetBookFansRankingRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PageFansGetBookFansRankingResponse>(
    prepare(pageFansGetBookFansRankingRequestConfig, requestData),
    ...args
  );
};

pageFansGetBookFansRanking.requestConfig =
  pageFansGetBookFansRankingRequestConfig;

/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/12275) 的 **请求类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/fans/getBookFansRankingList`
 * @更新时间 `2019-05-05 14:13:36`
 */
export interface AjaxFansGetBookFansRankingListRequest {
  pageIndex: string;
  pageSize: string;
}

/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/12275) 的 **返回类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/fans/getBookFansRankingList`
 * @更新时间 `2019-05-05 14:13:36`
 */
export interface AjaxFansGetBookFansRankingListResponse {
  /**
   * [{"userId":0,"userName":null,"ranking":1,"appId":0,"votingCount":65452},{"userId":4300000218,"userName":"yuewentester1024","ranking":2,"appId":10,"votingCount":37746,"UUT":1550460057000},{"userId":1520658766,"userName":"webnoveltest123","ranking":3,"appId":10,"votingCount":7510,"UUT":1552648459000},{"userId":3968405415,"userName":"jennyrenjialele5","ranking":4,"appId":10,"UUT":1530701317000},{"userId":1059463888,"userName":"xujin0515","ranking":5,"appId":10,"UUT":1542710966000},{"userId":101087995,"userName":"garden6cg","ranking":6,"appId":10,"UUT":1539950384000},{"userId":4300000467,"userName":"fourautumn1024","ranking":7,"appId":10,"UUT":1550221196000},{"userId":2959616949,"userName":"Eason057","ranking":8,"appId":10,"UUT":1539936723000},{"userId":41830698,"userName":"clarkzhangss","ranking":9,"appId":10,"UUT":1551407418000},{"userId":1901271742,"userName":"testingya","ranking":10,"appId":10,"UUT":1556250655000},{"userId":2140464915,"userName":"1231","ranking":11,"appId":10,"UUT":1551255485000},{"userId":4300000437,"userName":"LANEYU","ranking":12,"appId":10,"UUT":1527132787000},{"userId":4300000120,"userName":"bigcat004","ranking":13,"appId":10,"UUT":1553072138000},{"userId":4300000390,"userName":"Candy","ranking":14,"appId":10,"UUT":1547805199000},{"userId":4300000535,"userName":"Clementine","ranking":15,"appId":10,"UUT":1550461413000},{"userId":4300000208,"userName":"lily7","ranking":16,"appId":10,"UUT":1532690675000},{"userId":4300000431,"userName":"zhouxiyuan","ranking":17,"appId":10,"UUT":1529404645377},{"userId":3093119117,"userName":"zyftest","ranking":18,"appId":10,"UUT":1555987639000},{"userId":4300000213,"userName":"taozi","ranking":19,"appId":10,"UUT":1547607296000},{"userId":2760955332,"userName":"QStack","ranking":20,"appId":10,"UUT":1516946520000}]
   */
  items?: {
    userId?: number;
    userName?: null;
    /**
     * 1
     */
    ranking?: number;
    appId?: number;
    /**
     * 65452
     */
    votingCount?: number;
  }[];
  my?: {
    /**
     * 755
     */
    votingCount?: number;
    /**
     * 13
     */
    ranking?: number;
  };
  /**
   * 68
   */
  total?: number;
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 20
   */
  pageSize?: number;
  isLast?: number;
}

/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/12275) 的 **请求配置的类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/fans/getBookFansRankingList`
 * @更新时间 `2019-05-05 14:13:36`
 */
type AjaxFansGetBookFansRankingListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/fans/getBookFansRankingList",
    "data",
    string,
    "pageIndex" | "pageSize",
    false
  >
>;

/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/12275) 的 **请求配置**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/fans/getBookFansRankingList`
 * @更新时间 `2019-05-05 14:13:36`
 */
const ajaxFansGetBookFansRankingListRequestConfig: AjaxFansGetBookFansRankingListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: "/ajax/fans/getBookFansRankingList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: ["pageIndex", "pageSize"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxFansGetBookFansRankingList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/12275) 的 **请求函数**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/fans/getBookFansRankingList`
 * @更新时间 `2019-05-05 14:13:36`
 */
export const ajaxFansGetBookFansRankingList = /*#__PURE__*/ (
  requestData: AjaxFansGetBookFansRankingListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxFansGetBookFansRankingListResponse>(
    prepare(ajaxFansGetBookFansRankingListRequestConfig, requestData),
    ...args
  );
};

ajaxFansGetBookFansRankingList.requestConfig =
  ajaxFansGetBookFansRankingListRequestConfig;

/**
 * 接口 [赠送礼物↗](https://yapi.yuewen.com/project/28/interface/api/12539) 的 **请求类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `POST /ajax/gift/donateGift`
 * @更新时间 `2018-08-13 14:58:57`
 */
export interface AjaxGiftDonateGiftRequest {
  /**
   * 全职高手
   */
  bookId: string;
  /**
   * 章节ID,全职高手第三章
   */
  chapterId: string;
  /**
   * 礼物id
   */
  giftId: string;
  /**
   * 礼物个数
   */
  amount: string;
  /**
   * 礼物总价
   */
  totalPrice: string;
  /**
   * 每次请求都需要加上这个参数，从getBookGiftList获取
   */
  donateUUID: string;
}

/**
 * 接口 [赠送礼物↗](https://yapi.yuewen.com/project/28/interface/api/12539) 的 **返回类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `POST /ajax/gift/donateGift`
 * @更新时间 `2018-08-13 14:58:57`
 */
export interface AjaxGiftDonateGiftResponse {
  code?: number;
  /**
   * "Success"
   */
  msg?: string;
}

/**
 * 接口 [赠送礼物↗](https://yapi.yuewen.com/project/28/interface/api/12539) 的 **请求配置的类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `POST /ajax/gift/donateGift`
 * @更新时间 `2018-08-13 14:58:57`
 */
type AjaxGiftDonateGiftRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/gift/donateGift",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [赠送礼物↗](https://yapi.yuewen.com/project/28/interface/api/12539) 的 **请求配置**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `POST /ajax/gift/donateGift`
 * @更新时间 `2018-08-13 14:58:57`
 */
const ajaxGiftDonateGiftRequestConfig: AjaxGiftDonateGiftRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: "/ajax/gift/donateGift",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxGiftDonateGift",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [赠送礼物↗](https://yapi.yuewen.com/project/28/interface/api/12539) 的 **请求函数**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `POST /ajax/gift/donateGift`
 * @更新时间 `2018-08-13 14:58:57`
 */
export const ajaxGiftDonateGift = /*#__PURE__*/ (
  requestData: AjaxGiftDonateGiftRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxGiftDonateGiftResponse>(
    prepare(ajaxGiftDonateGiftRequestConfig, requestData),
    ...args
  );
};

ajaxGiftDonateGift.requestConfig = ajaxGiftDonateGiftRequestConfig;

/**
 * 接口 [根据书籍获取礼物列表↗](https://yapi.yuewen.com/project/28/interface/api/12548) 的 **请求类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getBookGiftList`
 * @更新时间 `2018-08-20 15:15:52`
 */
export interface AjaxGiftGetBookGiftListRequest {
  /**
   * 书籍ID
   */
  bookId: string;
  _csrfToken: string;
}

/**
 * 接口 [根据书籍获取礼物列表↗](https://yapi.yuewen.com/project/28/interface/api/12548) 的 **返回类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getBookGiftList`
 * @更新时间 `2018-08-20 15:15:52`
 */
export interface AjaxGiftGetBookGiftListResponse {
  /**
   * [{"giftId":20002,"giftName":"Lollipop","giftPrice":25,"iconUrl":"https://webbannertest.webnovel.com/gift/1532347515_4297.png","status":1,"order":1},{"giftId":20003,"giftName":"Easter egg","giftPrice":99,"iconUrl":"","status":1,"order":1},{"giftId":20004,"giftName":"Turkey","giftPrice":200,"iconUrl":"","status":1,"order":1},{"giftId":20005,"giftName":"Cultivation Manual","giftPrice":450,"iconUrl":"","status":1,"order":1},{"giftId":20006,"giftName":"Meteor","giftPrice":666,"iconUrl":"","status":1,"order":1},{"giftId":20007,"giftName":"Rainbow","giftPrice":666,"iconUrl":"","status":1,"order":1},{"giftId":20008,"giftName":"Crown","giftPrice":888,"iconUrl":"","status":1,"order":1}]
   */
  gifts?: {
    /**
     * 20002
     */
    giftId?: number;
    /**
     * "Lollipop"
     */
    giftName?: string;
    /**
     * 25
     */
    giftPrice?: number;
    /**
     * "https://webbannertest.webnovel.com/gift/1532347515_4297.png"
     */
    iconUrl?: string;
    /**
     * 1
     */
    status?: number;
    /**
     * 1
     */
    order?: number;
  }[];
  /**
   * 150
   */
  SS?: number;
  /**
   * "26b5f848-2043-4f67-b5f8-4820437f67ab"
   */
  donateUUID?: string;
  /**
   * 42
   */
  giftNum?: number;
}

/**
 * 接口 [根据书籍获取礼物列表↗](https://yapi.yuewen.com/project/28/interface/api/12548) 的 **请求配置的类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getBookGiftList`
 * @更新时间 `2018-08-20 15:15:52`
 */
type AjaxGiftGetBookGiftListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/gift/getBookGiftList",
    "data",
    string,
    "bookId" | "_csrfToken",
    false
  >
>;

/**
 * 接口 [根据书籍获取礼物列表↗](https://yapi.yuewen.com/project/28/interface/api/12548) 的 **请求配置**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getBookGiftList`
 * @更新时间 `2018-08-20 15:15:52`
 */
const ajaxGiftGetBookGiftListRequestConfig: AjaxGiftGetBookGiftListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: "/ajax/gift/getBookGiftList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: ["bookId", "_csrfToken"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxGiftGetBookGiftList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据书籍获取礼物列表↗](https://yapi.yuewen.com/project/28/interface/api/12548) 的 **请求函数**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getBookGiftList`
 * @更新时间 `2018-08-20 15:15:52`
 */
export const ajaxGiftGetBookGiftList = /*#__PURE__*/ (
  requestData: AjaxGiftGetBookGiftListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxGiftGetBookGiftListResponse>(
    prepare(ajaxGiftGetBookGiftListRequestConfig, requestData),
    ...args
  );
};

ajaxGiftGetBookGiftList.requestConfig = ajaxGiftGetBookGiftListRequestConfig;

/**
 * 接口 [根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/12615) 的 **请求类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getGiftInfo`
 * @更新时间 `2019-05-05 14:14:36`
 */
export interface AjaxGiftGetGiftInfoRequest {
  /**
   * 书籍Id
   */
  bookId: string;
  _csrfToken: string;
}

/**
 * 接口 [根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/12615) 的 **返回类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getGiftInfo`
 * @更新时间 `2019-05-05 14:14:36`
 */
export interface AjaxGiftGetGiftInfoResponse {
  giftNum?: number;
  giftMax?: {
    /**
     * 15927
     */
    id?: number;
    /**
     * 7366916601012405
     */
    bookId?: number;
    /**
     * 19775416453662908
     */
    chapterId?: number;
    /**
     * 4300000390
     */
    userId?: number;
    /**
     * 1
     */
    giftAmount?: number;
    /**
     * "6665224524910655505"
     */
    orderId?: string;
    /**
     * 20008
     */
    giftId?: number;
    /**
     * 8888
     */
    totalPrice?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1547805199000
     */
    UUT?: number;
    /**
     * "Candy"
     */
    userName?: string;
    /**
     * "Lollipop"
     */
    giftName?: string;
    /**
     * 88888
     */
    giftPrice?: number;
    /**
     * "testUrl"
     */
    iconUrl?: string;
    /**
     * 1
     */
    status?: number;
    /**
     * 1
     */
    order?: number;
  };
  /**
   * [{"id":15991,"userId":4300000770,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1555552974000,"userName":"289380420_0704"},{"id":15990,"userId":4300000770,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1555552974000,"userName":"289380420_0704"},{"id":15989,"userId":4300000770,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1555552974000,"userName":"289380420_0704"},{"id":15988,"userId":4300000770,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1555552974000,"userName":"289380420_0704"},{"id":15987,"userId":4300000770,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1555552974000,"userName":"289380420_0704"},{"id":15986,"userId":4300000770,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1555552974000,"userName":"289380420_0704"},{"id":15985,"userId":2986420237,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1517293383000,"userName":"wentao"},{"id":15984,"userId":2986420237,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1517293383000,"userName":"wentao"},{"id":15983,"userId":2986420237,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1517293383000,"userName":"wentao"},{"id":15982,"userId":2986420237,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1517293383000,"userName":"wentao"}]
   */
  giftRecords?: {
    /**
     * 15991
     */
    id?: number;
    /**
     * 4300000770
     */
    userId?: number;
    /**
     * 20001
     */
    giftId?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * "Balloon"
     */
    giftName?: string;
    /**
     * 5
     */
    giftPrice?: number;
    /**
     * "https://webbanner.webnovel.com/gift/1539660206_9513.png"
     */
    iconUrl?: string;
    /**
     * 1
     */
    status?: number;
    /**
     * 1
     */
    order?: number;
    /**
     * 1555552974000
     */
    UUT?: number;
    /**
     * "289380420_0704"
     */
    userName?: string;
  }[];
}

/**
 * 接口 [根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/12615) 的 **请求配置的类型**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getGiftInfo`
 * @更新时间 `2019-05-05 14:14:36`
 */
type AjaxGiftGetGiftInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/gift/getGiftInfo",
    "data",
    string,
    "bookId" | "_csrfToken",
    false
  >
>;

/**
 * 接口 [根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/12615) 的 **请求配置**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getGiftInfo`
 * @更新时间 `2019-05-05 14:14:36`
 */
const ajaxGiftGetGiftInfoRequestConfig: AjaxGiftGetGiftInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: "/ajax/gift/getGiftInfo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: ["bookId", "_csrfToken"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxGiftGetGiftInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/12615) 的 **请求函数**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getGiftInfo`
 * @更新时间 `2019-05-05 14:14:36`
 */
export const ajaxGiftGetGiftInfo = /*#__PURE__*/ (
  requestData: AjaxGiftGetGiftInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxGiftGetGiftInfoResponse>(
    prepare(ajaxGiftGetGiftInfoRequestConfig, requestData),
    ...args
  );
};

ajaxGiftGetGiftInfo.requestConfig = ajaxGiftGetGiftInfoRequestConfig;

const mockUrl_0_1_0_21 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_21 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_21 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_21 = "data" as any;

/**
 * 接口 [\/ajax\/comic\/list-拉取漫画列表↗](https://yapi.yuewen.com/project/28/interface/api/13939) 的 **请求类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/list`
 * @更新时间 `2020-01-29 00:04:43`
 */
export interface AjaxComicListRequest {
  pageIndex?: string;
}

/**
 * 接口 [\/ajax\/comic\/list-拉取漫画列表↗](https://yapi.yuewen.com/project/28/interface/api/13939) 的 **返回类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/list`
 * @更新时间 `2020-01-29 00:04:43`
 */
export interface AjaxComicListResponse {
  /**
   * [{"comicId":"12144230606989301","comicName":"My Maid is a Demon","publisher":"Readcomic","coverUpdateTime":"1547827254926"},{"comicId":"13345693006558101","comicName":"Being the Reality","publisher":"LongXuan DongMan","coverUpdateTime":"1553498535014"},{"comicId":"13138815206885001","comicName":"Overnight Riches: I married the Director","publisher":"KAIYUAN COMICS","coverUpdateTime":"1552025580975"},{"comicId":"14071263305229301","comicName":"Istri Cantik dari Pernikahan Dadakan","publisher":"ZhaYaStudio","coverUpdateTime":"1560754251121"},{"comicId":"13138177505820701","comicName":"Tales of a Blissful Life","publisher":"ManYue","coverUpdateTime":"1562294429582"},{"comicId":"13137125206873801","comicName":"I Swapped Bodies with My Idol!","publisher":"SANFU INTERACTIVE ENTETRTAINMENT","coverUpdateTime":"1554190231979"},{"comicId":"13776606305187201","comicName":"Menolak Untuk Mati!","publisher":"Webnovel Comics","coverUpdateTime":"1557814546124"},{"comicId":"14710462506442501","comicName":"Human Body Cultivation","publisher":"Era Cartoon","coverUpdateTime":"1567569110467"},{"comicId":"15306868405821601","comicName":"Charlotte's Hearsay","publisher":"CHEN DI ZHE/ RI GENG JI HUA","coverUpdateTime":"1575949558846"},{"comicId":"13137595505817001","comicName":"The Favored Concubine","publisher":"SANFU INTERACTIVE ENTERTAINMENT","coverUpdateTime":"1557304708473"},{"comicId":"13777600505191601","comicName":"Lahirnya kembali sang bintang","publisher":"Webnovel Comics","coverUpdateTime":"1557817609127"},{"comicId":"12272567206191501","comicName":"The Superb Captain in the City","publisher":"ChaoJiNeiRong","coverUpdateTime":"1547654471952"},{"comicId":"13138898705824901","comicName":"The Ghost Bride","publisher":"YUNDUAN COMICS","coverUpdateTime":"1567577507455"},{"comicId":"13137943906878401","comicName":"Femme Fatale: The President's Deadly Wife","publisher":"KAIYUAN COMICS","coverUpdateTime":"1551421041821"},{"comicId":"13136905305815201","comicName":"Strongest Abandoned Son","publisher":"HangZhou ManChao Studio","coverUpdateTime":"1556100983907"},{"comicId":"14798019206730201","comicName":" Love Game ","publisher":"Bees and Birds Comics","coverUpdateTime":"1568793947538"},{"comicId":"13138980506886301","comicName":"Melting Your Icy Heart","publisher":"KAIYUAN COMICS","coverUpdateTime":"1552024546992"},{"comicId":"14866246806962201","comicName":"Taste of His Skin","publisher":"Manman","coverUpdateTime":"1574911571473"},{"comicId":"12992033905276801","comicName":"Tales of a Shut-In Demon","publisher":"SANFU INTERACTIVE ENTETRTAINMENT","coverUpdateTime":"1549968696933"},{"comicId":"13743587205063801","comicName":"Flowers Falling Together","publisher":"낑두","coverUpdateTime":"1572860837312"},{"comicId":"13138208806880901","comicName":"Swallowed Star","publisher":"ShenMan","coverUpdateTime":"1579501261417"},{"comicId":"14865196805880001","comicName":"Immortals Down Under","publisher":"Manman","coverUpdateTime":"1571113073532"},{"comicId":"14071324405229501","comicName":"Petualangan Dokter Misterius","publisher":"FengXingComicStudio","coverUpdateTime":"1560754850435"},{"comicId":"12992009406330801","comicName":"My Beautiful Time with You","publisher":"Webnovel Comics","coverUpdateTime":"1549961736119"},{"comicId":"13138233106881301","comicName":"The Apostle of Cards","publisher":"ShenMan","coverUpdateTime":"1560763860181"},{"comicId":"12888448905833801","comicName":"Goddess Creation System","publisher":"SANFU INTERACTIVE ENTETRTAINMENT","coverUpdateTime":"1549958864944"},{"comicId":"13138710106883901","comicName":"The Spanking Boss","publisher":"YUNDUAN COMICS","coverUpdateTime":"1551854428888"},{"comicId":"13777574906233901","comicName":"Yang tersayang - bossku terlalu baik","publisher":"Webnovel Comics","coverUpdateTime":"1557817353352"},{"comicId":"14805827405677101","comicName":"Holy Chef, Crazy Empress","publisher":"Manman","coverUpdateTime":"1568105454451"},{"comicId":"14011076505954101","comicName":"Returning from the Immortal World","publisher":"Mobius","coverUpdateTime":"1578641754763"}]
   */
  items?: {
    /**
     * "12144230606989301"
     */
    comicId?: string;
    /**
     * "My Maid is a Demon"
     */
    comicName?: string;
    /**
     * "Readcomic"
     */
    publisher?: string;
    /**
     * "1547827254926"
     */
    coverUpdateTime?: string;
  }[];
  isLast?: number;
}

/**
 * 接口 [\/ajax\/comic\/list-拉取漫画列表↗](https://yapi.yuewen.com/project/28/interface/api/13939) 的 **请求配置的类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/list`
 * @更新时间 `2020-01-29 00:04:43`
 */
type AjaxComicListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/comic/list",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [\/ajax\/comic\/list-拉取漫画列表↗](https://yapi.yuewen.com/project/28/interface/api/13939) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/list`
 * @更新时间 `2020-01-29 00:04:43`
 */
const ajaxComicListRequestConfig: AjaxComicListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_1_0_21,
  devUrl: devUrl_0_1_0_21,
  prodUrl: prodUrl_0_1_0_21,
  path: "/ajax/comic/list",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_1_0_21,
  paramNames: [],
  queryNames: ["pageIndex"],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "ajaxComicList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [\/ajax\/comic\/list-拉取漫画列表↗](https://yapi.yuewen.com/project/28/interface/api/13939) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/list`
 * @更新时间 `2020-01-29 00:04:43`
 */
export const ajaxComicList = /*#__PURE__*/ (
  requestData: AjaxComicListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxComicListResponse>(
    prepare(ajaxComicListRequestConfig, requestData),
    ...args
  );
};

ajaxComicList.requestConfig = ajaxComicListRequestConfig;

/**
 * 接口 [\/ajax\/comic\/getComicChapterListAjax↗](https://yapi.yuewen.com/project/28/interface/api/13947) 的 **请求类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/GetComicChapterListAjax`
 * @更新时间 `2020-02-13 15:06:35`
 */
export interface AjaxComicGetComicChapterListAjaxRequest {
  /**
   * 漫画ID
   */
  comicId: string;
}

/**
 * 接口 [\/ajax\/comic\/getComicChapterListAjax↗](https://yapi.yuewen.com/project/28/interface/api/13947) 的 **返回类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/GetComicChapterListAjax`
 * @更新时间 `2020-02-13 15:06:35`
 */
export interface AjaxComicGetComicChapterListAjaxResponse {
  comicInfo?: {
    /**
     * "12144230606989301"
     */
    comicId?: string;
    /**
     * "My Maid is a Demon"
     */
    comicName?: string;
    /**
     * 77
     */
    chapterNum?: number;
    /**
     * 39232305834814480
     */
    newChapterId?: number;
    /**
     * 1567180800000
     */
    newChapterTime?: number;
    /**
     * 77
     */
    newChapterIndex?: number;
    /**
     * "077"
     */
    newChapterName?: string;
    readToChapterId?: string;
    /**
     * 1
     */
    hasPrivilege?: number;
  };
  /**
   * [{"chapterId":"32599737626581177","chapterName":"001","chapterIndex":1,"isVip":0,"price":0,"isAuth":1,"publishTime":"Nov 06,2018"},{"chapterId":"32599737626581178","chapterName":"002","chapterIndex":2,"isVip":0,"price":0,"isAuth":1,"publishTime":"Nov 06,2018"},{"chapterId":"32599737626581179","chapterName":"003","chapterIndex":3,"isVip":0,"price":0,"isAuth":1,"publishTime":"Nov 06,2018"},{"chapterId":"32599737626581180","chapterName":"004","chapterIndex":4,"isVip":0,"price":0,"isAuth":1,"publishTime":"Nov 06,2018"},{"chapterId":"32599737626581181","chapterName":"005","chapterIndex":5,"isVip":0,"price":0,"isAuth":1,"publishTime":"Nov 06,2018"},{"chapterId":"32599737626581182","chapterName":"006","chapterIndex":6,"isVip":0,"price":0,"isAuth":1,"publishTime":"Nov 12,2018"},{"chapterId":"32599737626581183","chapterName":"007","chapterIndex":7,"isVip":0,"price":0,"isAuth":1,"publishTime":"Nov 17,2018"},{"chapterId":"32599737626581184","chapterName":"008","chapterIndex":8,"isVip":0,"price":0,"isAuth":1,"publishTime":"Nov 19,2018"},{"chapterId":"32599737626581185","chapterName":"009","chapterIndex":9,"isVip":0,"price":0,"isAuth":1,"publishTime":"Nov 24,2018"},{"chapterId":"32599737626581186","chapterName":"010","chapterIndex":10,"isVip":0,"price":0,"isAuth":1,"publishTime":"Nov 26,2018"},{"chapterId":"32736614761416396","chapterName":"011","chapterIndex":11,"isVip":0,"price":0,"isAuth":1,"publishTime":"Dec 01,2018"},{"chapterId":"32736614761416397","chapterName":"012","chapterIndex":12,"isVip":0,"price":0,"isAuth":1,"publishTime":"Dec 03,2018"},{"chapterId":"32741248477482401","chapterName":"013","chapterIndex":13,"isVip":0,"price":0,"isAuth":1,"publishTime":"Dec 08,2018"},{"chapterId":"32741248477482402","chapterName":"014","chapterIndex":14,"isVip":0,"price":0,"isAuth":1,"publishTime":"Dec 10,2018"},{"chapterId":"32898496642217477","chapterName":"015","chapterIndex":15,"isVip":0,"price":0,"isAuth":1,"publishTime":"Dec 15,2018"},{"chapterId":"32898496642217478","chapterName":"016","chapterIndex":16,"isVip":2,"price":13,"isAuth":0,"publishTime":"Dec 17,2018"},{"chapterId":"33060154647830889","chapterName":"017","chapterIndex":17,"isVip":2,"price":13,"isAuth":0,"publishTime":"Dec 24,2018"},{"chapterId":"33060154631054455","chapterName":"018","chapterIndex":18,"isVip":2,"price":13,"isAuth":0,"publishTime":"Dec 24,2018"},{"chapterId":"33711909492547359","chapterName":"019","chapterIndex":19,"isVip":2,"price":13,"isAuth":0,"publishTime":"Dec 29,2018"},{"chapterId":"33711909492547360","chapterName":"020","chapterIndex":20,"isVip":2,"price":13,"isAuth":0,"publishTime":"Dec 31,2018"},{"chapterId":"33711909492547361","chapterName":"021","chapterIndex":21,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jan 05,2019"},{"chapterId":"33711909492547362","chapterName":"022","chapterIndex":22,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jan 07,2019"},{"chapterId":"33970388140610945","chapterName":"023","chapterIndex":23,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jan 12,2019"},{"chapterId":"33970388140610946","chapterName":"024","chapterIndex":24,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jan 14,2019"},{"chapterId":"34084471850458228","chapterName":"025","chapterIndex":25,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jan 19,2019"},{"chapterId":"34084471850458229","chapterName":"026","chapterIndex":26,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jan 21,2019"},{"chapterId":"34084471850458230","chapterName":"027","chapterIndex":27,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jan 26,2019"},{"chapterId":"34361866608241526","chapterName":"028","chapterIndex":28,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jan 28,2019"},{"chapterId":"34361866608241527","chapterName":"029","chapterIndex":29,"isVip":2,"price":13,"isAuth":0,"publishTime":"Feb 02,2019"},{"chapterId":"34361866608241528","chapterName":"030","chapterIndex":30,"isVip":2,"price":13,"isAuth":0,"publishTime":"Feb 04,2019"},{"chapterId":"34361866625018355","chapterName":"031","chapterIndex":31,"isVip":2,"price":13,"isAuth":0,"publishTime":"Feb 09,2019"},{"chapterId":"34361866625018356","chapterName":"032","chapterIndex":32,"isVip":2,"price":13,"isAuth":0,"publishTime":"Feb 11,2019"},{"chapterId":"34915277992940647","chapterName":"033","chapterIndex":33,"isVip":2,"price":13,"isAuth":0,"publishTime":"Feb 16,2019"},{"chapterId":"34915277992940648","chapterName":"034","chapterIndex":34,"isVip":2,"price":13,"isAuth":0,"publishTime":"Feb 18,2019"},{"chapterId":"34915277992940649","chapterName":"035","chapterIndex":35,"isVip":2,"price":13,"isAuth":0,"publishTime":"Feb 23,2019"},{"chapterId":"34915277992940650","chapterName":"036","chapterIndex":36,"isVip":2,"price":13,"isAuth":0,"publishTime":"Feb 25,2019"},{"chapterId":"35175337172204719","chapterName":"037","chapterIndex":37,"isVip":2,"price":13,"isAuth":0,"publishTime":"Mar 02,2019"},{"chapterId":"35175337172204720","chapterName":"038","chapterIndex":38,"isVip":2,"price":13,"isAuth":0,"publishTime":"Mar 04,2019"},{"chapterId":"35175337172204721","chapterName":"039","chapterIndex":39,"isVip":2,"price":13,"isAuth":0,"publishTime":"Mar 09,2019"},{"chapterId":"35175337172204722","chapterName":"040","chapterIndex":40,"isVip":2,"price":13,"isAuth":0,"publishTime":"Mar 11,2019"},{"chapterId":"35522467434911340","chapterName":"041","chapterIndex":41,"isVip":2,"price":13,"isAuth":0,"publishTime":"Mar 16,2019"},{"chapterId":"35522467434911341","chapterName":"042","chapterIndex":42,"isVip":2,"price":13,"isAuth":0,"publishTime":"Mar 18,2019"},{"chapterId":"35522467434911342","chapterName":"043","chapterIndex":43,"isVip":2,"price":13,"isAuth":0,"publishTime":"Mar 23,2019"},{"chapterId":"36821284352481827","chapterName":"044","chapterIndex":44,"isVip":2,"price":13,"isAuth":0,"publishTime":"May 08,2019"},{"chapterId":"36821383119955193","chapterName":"045","chapterIndex":45,"isVip":2,"price":13,"isAuth":0,"publishTime":"May 11,2019"},{"chapterId":"36842335581032201","chapterName":"046","chapterIndex":46,"isVip":2,"price":13,"isAuth":0,"publishTime":"May 15,2019"},{"chapterId":"36842342040257864","chapterName":"047","chapterIndex":47,"isVip":2,"price":13,"isAuth":0,"publishTime":"May 18,2019"},{"chapterId":"36842345513144117","chapterName":"048","chapterIndex":48,"isVip":2,"price":13,"isAuth":0,"publishTime":"May 22,2019"},{"chapterId":"36842349556450686","chapterName":"049","chapterIndex":49,"isVip":2,"price":13,"isAuth":0,"publishTime":"May 25,2019"},{"chapterId":"36842401632929307","chapterName":"050","chapterIndex":50,"isVip":2,"price":13,"isAuth":0,"publishTime":"May 29,2019"},{"chapterId":"37260443131108958","chapterName":"051","chapterIndex":51,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jun 01,2019"},{"chapterId":"37309836060320352","chapterName":"052","chapterIndex":52,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jun 05,2019"},{"chapterId":"37516883565529289","chapterName":"053","chapterIndex":53,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jun 08,2019"},{"chapterId":"37516887592061158","chapterName":"054","chapterIndex":54,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jun 12,2019"},{"chapterId":"37516891081722111","chapterName":"055","chapterIndex":55,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jun 15,2019"},{"chapterId":"37516895108253960","chapterName":"056","chapterIndex":56,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jun 19,2019"},{"chapterId":"37745432465561058","chapterName":"057","chapterIndex":57,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jun 22,2019"},{"chapterId":"37819349641262620","chapterName":"058","chapterIndex":58,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jun 26,2019"},{"chapterId":"37886583596186493","chapterName":"059","chapterIndex":59,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jun 29,2019"},{"chapterId":"37886588964895648","chapterName":"060","chapterIndex":60,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jul 03,2019"},{"chapterId":"38049737609366111","chapterName":"061","chapterIndex":61,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jul 06,2019"},{"chapterId":"38049741099027068","chapterName":"062","chapterIndex":62,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jul 10,2019"},{"chapterId":"38253773520427146","chapterName":"063","chapterIndex":63,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jul 13,2019"},{"chapterId":"38253777815394448","chapterName":"064","chapterIndex":64,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jul 17,2019"},{"chapterId":"38423418823038713","chapterName":"065","chapterIndex":65,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jul 20,2019"},{"chapterId":"38423422027490188","chapterName":"066","chapterIndex":66,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jul 24,2019"},{"chapterId":"38423426322457500","chapterName":"067","chapterIndex":67,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jul 27,2019"},{"chapterId":"38629596295386902","chapterName":"068","chapterIndex":68,"isVip":2,"price":13,"isAuth":0,"publishTime":"Jul 31,2019"},{"chapterId":"38629660988337138","chapterName":"069","chapterIndex":69,"isVip":2,"price":13,"isAuth":0,"publishTime":"Aug 03,2019"},{"chapterId":"38629669578271747","chapterName":"070","chapterIndex":70,"isVip":2,"price":13,"isAuth":0,"publishTime":"Aug 07,2019"},{"chapterId":"38883839031964178","chapterName":"071","chapterIndex":71,"isVip":2,"price":13,"isAuth":0,"publishTime":"Aug 10,2019"},{"chapterId":"38883842001526965","chapterName":"072","chapterIndex":72,"isVip":2,"price":13,"isAuth":0,"publishTime":"Aug 14,2019"},{"chapterId":"39025911181404832","chapterName":"073","chapterIndex":73,"isVip":2,"price":13,"isAuth":0,"publishTime":"Aug 17,2019"},{"chapterId":"39116037580440020","chapterName":"074","chapterIndex":74,"isVip":2,"price":13,"isAuth":0,"publishTime":"Aug 21,2019"},{"chapterId":"39162033458967993","chapterName":"075","chapterIndex":75,"isVip":2,"price":13,"isAuth":0,"publishTime":"Aug 24,2019"},{"chapterId":"39232301539845105","chapterName":"076","chapterIndex":76,"isVip":2,"price":13,"isAuth":0,"publishTime":"Aug 28,2019"},{"chapterId":"39232305834814482","chapterName":"077","chapterIndex":77,"isVip":2,"price":13,"isAuth":0,"publishTime":"Aug 31,2019"}]
   */
  comicChapters?: {
    /**
     * "32599737626581177"
     */
    chapterId?: string;
    /**
     * "001"
     */
    chapterName?: string;
    /**
     * 1
     */
    chapterIndex?: number;
    isVip?: number;
    price?: number;
    /**
     * 1
     */
    isAuth?: number;
    /**
     * "Nov 06,2018"
     */
    publishTime?: string;
  }[];
}

/**
 * 接口 [\/ajax\/comic\/getComicChapterListAjax↗](https://yapi.yuewen.com/project/28/interface/api/13947) 的 **请求配置的类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/GetComicChapterListAjax`
 * @更新时间 `2020-02-13 15:06:35`
 */
type AjaxComicGetComicChapterListAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/comic/GetComicChapterListAjax",
    "data",
    string,
    "comicId",
    false
  >
>;

/**
 * 接口 [\/ajax\/comic\/getComicChapterListAjax↗](https://yapi.yuewen.com/project/28/interface/api/13947) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/GetComicChapterListAjax`
 * @更新时间 `2020-02-13 15:06:35`
 */
const ajaxComicGetComicChapterListAjaxRequestConfig: AjaxComicGetComicChapterListAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/comic/GetComicChapterListAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: ["comicId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicGetComicChapterListAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/ajax\/comic\/getComicChapterListAjax↗](https://yapi.yuewen.com/project/28/interface/api/13947) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/GetComicChapterListAjax`
 * @更新时间 `2020-02-13 15:06:35`
 */
export const ajaxComicGetComicChapterListAjax = /*#__PURE__*/ (
  requestData: AjaxComicGetComicChapterListAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxComicGetComicChapterListAjaxResponse>(
    prepare(ajaxComicGetComicChapterListAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxComicGetComicChapterListAjax.requestConfig =
  ajaxComicGetComicChapterListAjaxRequestConfig;

/**
 * 接口 [【已迁移】\/ajax\/comic\/getContent↗](https://yapi.yuewen.com/project/28/interface/api/13948) 的 **请求类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getContent`
 * @更新时间 `2020-10-23 15:02:56`
 */
export interface AjaxComicGetContentRequest {
  /**
   * 漫画id
   */
  comicId: string;
  /**
   * 章节Id
   */
  chapterId: string;
  /**
   * 屏幕宽度， ≤480的，下发480
   * 480＜X≤560，下发560
   * 560＜X≤720，下发720
   * 720＜X≤800，下发800
   * 800＜X≤1080，下发1080
   * ＞1080，下发1536，
   * PC/M 现在统一下发800
   */
  width: string;
}

/**
 * 接口 [【已迁移】\/ajax\/comic\/getContent↗](https://yapi.yuewen.com/project/28/interface/api/13948) 的 **返回类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getContent`
 * @更新时间 `2020-10-23 15:02:56`
 */
export interface AjaxComicGetContentResponse {
  comicInfo?: {
    /**
     * "${query.comicId}"
     */
    comicId?: string;
    /**
     * "@title"
     */
    comicName?: string;
    /**
     * 100
     */
    chapterNum?: number;
    /**
     * 1
     */
    actionStatus?: number;
    /**
     * "@title"
     */
    publisher?: string;
    /**
     * 1536030204000
     */
    CV?: number;
    /**
     * 1
     */
    hasPrivilege?: number;
    /**
     * 1577568672000
     */
    publishTime?: number;
    /**
     * 1577568672000
     */
    updateTime?: number;
  };
  chapterInfo?: {
    /**
     * "${query.chapterId}"
     */
    chapterId?: string;
    /**
     * "002"
     */
    chapterName?: string;
    /**
     * 2
     */
    chapterIndex?: number;
    /**
     * 25
     */
    price?: number;
    /**
     * 11
     */
    pageCount?: number;
    /**
     * "31048590793163785"
     */
    preChapterId?: string;
    /**
     * "xz01"
     */
    preChapterName?: string;
    /**
     * -1
     */
    nextChapterId?: number;
    /**
     * "xz03"
     */
    nextChapterName?: string;
    /**
     * -1
     */
    vipStatus?: number;
    /**
     * 1
     */
    isAuth?: number;
    /**
     * []
     */
    chapterPage?: unknown[];
    chapterLevel?: number;
    /**
     * 3
     */
    userLevel?: number;
    /**
     * 1577568672000
     */
    publishTime?: number;
    /**
     * 1577568672000
     */
    updateTime?: number;
  };
  /**
   * 1
   */
  membershipStatus?: number;
  /**
   * 1
   */
  waitpayStatus?: number;
}

/**
 * 接口 [【已迁移】\/ajax\/comic\/getContent↗](https://yapi.yuewen.com/project/28/interface/api/13948) 的 **请求配置的类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getContent`
 * @更新时间 `2020-10-23 15:02:56`
 */
type AjaxComicGetContentRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/comic/getContent",
    "data",
    string,
    "comicId" | "chapterId" | "width",
    false
  >
>;

/**
 * 接口 [【已迁移】\/ajax\/comic\/getContent↗](https://yapi.yuewen.com/project/28/interface/api/13948) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getContent`
 * @更新时间 `2020-10-23 15:02:56`
 */
const ajaxComicGetContentRequestConfig: AjaxComicGetContentRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/comic/getContent",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: ["comicId", "chapterId", "width"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicGetContent",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【已迁移】\/ajax\/comic\/getContent↗](https://yapi.yuewen.com/project/28/interface/api/13948) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getContent`
 * @更新时间 `2020-10-23 15:02:56`
 */
export const ajaxComicGetContent = /*#__PURE__*/ (
  requestData: AjaxComicGetContentRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxComicGetContentResponse>(
    prepare(ajaxComicGetContentRequestConfig, requestData),
    ...args
  );
};

ajaxComicGetContent.requestConfig = ajaxComicGetContentRequestConfig;

/**
 * 接口 [\/ajax\/Comic\/UnlockChapter↗](https://yapi.yuewen.com/project/28/interface/api/13950) 的 **请求类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter`
 * @更新时间 `2019-11-15 14:26:38`
 */
export interface AjaxComicUnlockChapterRequest {
  /**
   * 漫画ID
   */
  comicId: string;
  /**
   * 章节id
   */
  chapterId: string;
  /**
   * 价格
   */
  price: string;
  /**
   * 屏幕宽度， ≤480的，下发480
   * 480＜X≤560，下发560
   * 560＜X≤720，下发720
   * 720＜X≤800，下发800
   * 800＜X≤1080，下发1080
   * ＞1080，下发1536，
   * PC/M 现在统一下发800
   */
  width: string;
  /**
   * 1：看广告
   * 2：跳过广告
   * 3：订阅（ss解锁）
   * 4：整本订阅
   * 5：阅读券（fastPass）
   */
  unlockType: string;
}

/**
 * 接口 [\/ajax\/Comic\/UnlockChapter↗](https://yapi.yuewen.com/project/28/interface/api/13950) 的 **返回类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter`
 * @更新时间 `2019-11-15 14:26:38`
 */
export interface AjaxComicUnlockChapterResponse {
  /**
   * "100 余额不足的时候返回用户余额"
   */
  SS?: string;
  /**
   * ["@chapterPage"]
   */
  content?: string[];
  /**
   * "10"
   */
  costSS?: string;
}

/**
 * 接口 [\/ajax\/Comic\/UnlockChapter↗](https://yapi.yuewen.com/project/28/interface/api/13950) 的 **请求配置的类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter`
 * @更新时间 `2019-11-15 14:26:38`
 */
type AjaxComicUnlockChapterRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/Comic/UnlockChapter",
    "data",
    string,
    "comicId" | "chapterId" | "price" | "width" | "unlockType",
    false
  >
>;

/**
 * 接口 [\/ajax\/Comic\/UnlockChapter↗](https://yapi.yuewen.com/project/28/interface/api/13950) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter`
 * @更新时间 `2019-11-15 14:26:38`
 */
const ajaxComicUnlockChapterRequestConfig: AjaxComicUnlockChapterRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/Comic/UnlockChapter",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: ["comicId", "chapterId", "price", "width", "unlockType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicUnlockChapter",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/ajax\/Comic\/UnlockChapter↗](https://yapi.yuewen.com/project/28/interface/api/13950) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter`
 * @更新时间 `2019-11-15 14:26:38`
 */
export const ajaxComicUnlockChapter = /*#__PURE__*/ (
  requestData: AjaxComicUnlockChapterRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxComicUnlockChapterResponse>(
    prepare(ajaxComicUnlockChapterRequestConfig, requestData),
    ...args
  );
};

ajaxComicUnlockChapter.requestConfig = ajaxComicUnlockChapterRequestConfig;

/**
 * 接口 [\/ajax\/comic\/ComicDetailPage - 漫画详情页↗](https://yapi.yuewen.com/project/28/interface/api/13951) 的 **请求类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/ComicDetailPage`
 * @更新时间 `2020-06-30 15:11:10`
 */
export interface AjaxComicComicDetailPageRequest {
  /**
   * 漫画id
   */
  comicId: string;
}

/**
 * 接口 [\/ajax\/comic\/ComicDetailPage - 漫画详情页↗](https://yapi.yuewen.com/project/28/interface/api/13951) 的 **返回类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/ComicDetailPage`
 * @更新时间 `2020-06-30 15:11:10`
 */
export interface AjaxComicComicDetailPageResponse {
  comicInfo?: {
    /**
     * "12144230606989301"
     */
    comicId?: string;
    /**
     * "My Maid is a Demon"
     */
    comicName?: string;
    /**
     * "Readcomic"
     */
    authorName?: string;
    /**
     * "On his birthday, university student Bai XiaoShu suddenly receives a strange phone call from his father. Afterwards, he is inexplicably chased by people dressed in black who are intent on taking his life. Bai XiaoShu follows his father’s instructions and returns to his family residence. On the brink of death, he makes a contract with a devil. When he awakens, he finds himself face-to-face with an adorable girl who calls herself his maid. However, all of the strange events in his story... have only just begun..."
     */
    description?: string;
    sourceBookId?: number;
    /**
     * "Readcomic"
     */
    publisher?: string;
    /**
     * 77
     */
    chapterNum?: number;
    /**
     * 2
     */
    actionStatus?: number;
    ageGroup?: null;
    /**
     * "2.8M"
     */
    pvNum?: string;
    /**
     * "1547827254926"
     */
    coverUpdateTime?: string;
    /**
     * "4.4"
     */
    totalScore?: string;
    /**
     * 936
     */
    voters?: number;
    /**
     * "32599737626581177"
     */
    firstChapterId?: string;
    inLibrary?: number;
    /**
     * 100
     */
    novelType?: number;
    /**
     * 82
     */
    giftNum?: number;
    /**
     * 1577568672000
     */
    publishTime?: number;
    /**
     * 1577568672000
     */
    updateTime?: number;
    /**
     * [{"userId":4309271858,"UUT":1577568672000},{"userId":616148305,"UUT":1547405265000},{"userId":535299614,"UUT":1519524734000},{"userId":4309549024,"UUT":1579050299000},{"userId":4309499716,"UUT":1579518089000},{"userId":4309483581,"UUT":1578576396000}]
     */
    topFanItems?: {
      /**
       * 4309271858
       */
      userId?: number;
      /**
       * 1577568672000
       */
      UUT?: number;
    }[];
  };
  user?: {
    guid?: string;
    avatar?: string;
    userName?: string;
    nickName?: string;
    penName?: null;
    role?: null;
    /**
     * -1
     */
    status?: number;
    SS?: null;
    isCheckin?: null;
    userLevel?: null;
    availablePower?: null;
    totalPower?: null;
    availableEnergy?: null;
    totalEnergy?: null;
    emailStatus?: null;
    mt?: null;
    UUT?: null;
  };
}

/**
 * 接口 [\/ajax\/comic\/ComicDetailPage - 漫画详情页↗](https://yapi.yuewen.com/project/28/interface/api/13951) 的 **请求配置的类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/ComicDetailPage`
 * @更新时间 `2020-06-30 15:11:10`
 */
type AjaxComicComicDetailPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/comic/ComicDetailPage",
    "data",
    string,
    "comicId",
    false
  >
>;

/**
 * 接口 [\/ajax\/comic\/ComicDetailPage - 漫画详情页↗](https://yapi.yuewen.com/project/28/interface/api/13951) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/ComicDetailPage`
 * @更新时间 `2020-06-30 15:11:10`
 */
const ajaxComicComicDetailPageRequestConfig: AjaxComicComicDetailPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/comic/ComicDetailPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: ["comicId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicComicDetailPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/ajax\/comic\/ComicDetailPage - 漫画详情页↗](https://yapi.yuewen.com/project/28/interface/api/13951) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/ComicDetailPage`
 * @更新时间 `2020-06-30 15:11:10`
 */
export const ajaxComicComicDetailPage = /*#__PURE__*/ (
  requestData: AjaxComicComicDetailPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxComicComicDetailPageResponse>(
    prepare(ajaxComicComicDetailPageRequestConfig, requestData),
    ...args
  );
};

ajaxComicComicDetailPage.requestConfig = ajaxComicComicDetailPageRequestConfig;

/**
 * 接口 [\/ajax\/comic\/getLatestUpdates -漫画阅读末页最近更新漫画↗](https://yapi.yuewen.com/project/28/interface/api/14163) 的 **请求类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getLatestUpdates`
 * @更新时间 `2019-09-05 17:17:32`
 */
export interface AjaxComicGetLatestUpdatesRequest {}

/**
 * 接口 [\/ajax\/comic\/getLatestUpdates -漫画阅读末页最近更新漫画↗](https://yapi.yuewen.com/project/28/interface/api/14163) 的 **返回类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getLatestUpdates`
 * @更新时间 `2019-09-05 17:17:32`
 */
export interface AjaxComicGetLatestUpdatesResponse {
  /**
   * [{"comicId":"7834199305001505","comicName":"Ancient Godly Monarch","newChapterTime":"6 minutes ago","coverUpdateTime":"1536049619128"}]
   */
  items?: {
    /**
     * "7834199305001505"
     */
    comicId?: string;
    /**
     * "Ancient Godly Monarch"
     */
    comicName?: string;
    /**
     * "6 minutes ago"
     */
    newChapterTime?: string;
    /**
     * "1536049619128"
     */
    coverUpdateTime?: string;
  }[];
}

/**
 * 接口 [\/ajax\/comic\/getLatestUpdates -漫画阅读末页最近更新漫画↗](https://yapi.yuewen.com/project/28/interface/api/14163) 的 **请求配置的类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getLatestUpdates`
 * @更新时间 `2019-09-05 17:17:32`
 */
type AjaxComicGetLatestUpdatesRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/comic/getLatestUpdates",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [\/ajax\/comic\/getLatestUpdates -漫画阅读末页最近更新漫画↗](https://yapi.yuewen.com/project/28/interface/api/14163) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getLatestUpdates`
 * @更新时间 `2019-09-05 17:17:32`
 */
const ajaxComicGetLatestUpdatesRequestConfig: AjaxComicGetLatestUpdatesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/comic/getLatestUpdates",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicGetLatestUpdates",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/ajax\/comic\/getLatestUpdates -漫画阅读末页最近更新漫画↗](https://yapi.yuewen.com/project/28/interface/api/14163) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getLatestUpdates`
 * @更新时间 `2019-09-05 17:17:32`
 */
export const ajaxComicGetLatestUpdates = /*#__PURE__*/ (
  requestData?: AjaxComicGetLatestUpdatesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxComicGetLatestUpdatesResponse>(
    prepare(ajaxComicGetLatestUpdatesRequestConfig, requestData),
    ...args
  );
};

ajaxComicGetLatestUpdates.requestConfig =
  ajaxComicGetLatestUpdatesRequestConfig;

/**
 * 接口 [每日漫画列表\/comic\/updateList↗](https://yapi.yuewen.com/project/28/interface/api/20278) 的 **请求类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/updateList`
 * @更新时间 `2018-12-10 11:44:20`
 */
export interface AjaxComicUpdateListRequest {
  /**
   * 获取上次返回漫画列表最后一个的logTime，第一次进入列表页不传
   */
  logTime?: string;
}

/**
 * 接口 [每日漫画列表\/comic\/updateList↗](https://yapi.yuewen.com/project/28/interface/api/20278) 的 **返回类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/updateList`
 * @更新时间 `2018-12-10 11:44:20`
 */
export interface AjaxComicUpdateListResponse {
  /**
   * [{"comicId":"@id","comicName":"@name","chapterId":"@id","chapterIndex":121,"chapterName":"@name","hasChapterCover":"1 | 0  1表示有 0 表示没有话风","chapterDescription":"@name","logTime":"@time","pvNum":"13M","isLast":0,"BUT":"话封更新时间"}]
   */
  items?: {
    /**
     * "@id"
     */
    comicId?: string;
    /**
     * "@name"
     */
    comicName?: string;
    /**
     * "@id"
     */
    chapterId?: string;
    /**
     * 121
     */
    chapterIndex?: number;
    /**
     * "@name"
     */
    chapterName?: string;
    /**
     * "1 | 0  1表示有 0 表示没有话风"
     */
    hasChapterCover?: string;
    /**
     * "@name"
     */
    chapterDescription?: string;
    /**
     * "@time"
     */
    logTime?: string;
    /**
     * "13M"
     */
    pvNum?: string;
    isLast?: number;
    /**
     * "话封更新时间"
     */
    BUT?: string;
  }[];
}

/**
 * 接口 [每日漫画列表\/comic\/updateList↗](https://yapi.yuewen.com/project/28/interface/api/20278) 的 **请求配置的类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/updateList`
 * @更新时间 `2018-12-10 11:44:20`
 */
type AjaxComicUpdateListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/comic/updateList",
    "data",
    string,
    "logTime",
    false
  >
>;

/**
 * 接口 [每日漫画列表\/comic\/updateList↗](https://yapi.yuewen.com/project/28/interface/api/20278) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/updateList`
 * @更新时间 `2018-12-10 11:44:20`
 */
const ajaxComicUpdateListRequestConfig: AjaxComicUpdateListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/comic/updateList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: ["logTime"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicUpdateList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [每日漫画列表\/comic\/updateList↗](https://yapi.yuewen.com/project/28/interface/api/20278) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/updateList`
 * @更新时间 `2018-12-10 11:44:20`
 */
export const ajaxComicUpdateList = /*#__PURE__*/ (
  requestData: AjaxComicUpdateListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxComicUpdateListResponse>(
    prepare(ajaxComicUpdateListRequestConfig, requestData),
    ...args
  );
};

ajaxComicUpdateList.requestConfig = ajaxComicUpdateListRequestConfig;

/**
 * 接口 [\/ajax\/Comic\/UnlockChapter_copy↗](https://yapi.yuewen.com/project/28/interface/api/64468) 的 **请求类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter_1574142720938`
 * @更新时间 `2019-11-19 13:52:00`
 */
export interface AjaxComicUnlockChapter_1574142720938Request {
  /**
   * 漫画ID
   */
  comicId: string;
  /**
   * 章节id
   */
  chapterId: string;
  /**
   * 价格
   */
  price: string;
  /**
   * 屏幕宽度， ≤480的，下发480
   * 480＜X≤560，下发560
   * 560＜X≤720，下发720
   * 720＜X≤800，下发800
   * 800＜X≤1080，下发1080
   * ＞1080，下发1536，
   * PC/M 现在统一下发800
   */
  width: string;
  /**
   * 1：看广告
   * 2：跳过广告
   * 3：订阅（ss解锁）
   * 4：整本订阅
   * 5：阅读券（fastPass）
   */
  unlockType: string;
}

/**
 * 接口 [\/ajax\/Comic\/UnlockChapter_copy↗](https://yapi.yuewen.com/project/28/interface/api/64468) 的 **返回类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter_1574142720938`
 * @更新时间 `2019-11-19 13:52:00`
 */
export interface AjaxComicUnlockChapter_1574142720938Response {
  /**
   * "100 余额不足的时候返回用户余额"
   */
  SS?: string;
  /**
   * ["@chapterPage"]
   */
  content?: string[];
  /**
   * "10"
   */
  costSS?: string;
}

/**
 * 接口 [\/ajax\/Comic\/UnlockChapter_copy↗](https://yapi.yuewen.com/project/28/interface/api/64468) 的 **请求配置的类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter_1574142720938`
 * @更新时间 `2019-11-19 13:52:00`
 */
type AjaxComicUnlockChapter_1574142720938RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/Comic/UnlockChapter_1574142720938",
    "data",
    string,
    "comicId" | "chapterId" | "price" | "width" | "unlockType",
    false
  >
>;

/**
 * 接口 [\/ajax\/Comic\/UnlockChapter_copy↗](https://yapi.yuewen.com/project/28/interface/api/64468) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter_1574142720938`
 * @更新时间 `2019-11-19 13:52:00`
 */
const ajaxComicUnlockChapter_1574142720938RequestConfig: AjaxComicUnlockChapter_1574142720938RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/Comic/UnlockChapter_1574142720938",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: ["comicId", "chapterId", "price", "width", "unlockType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicUnlockChapter_1574142720938",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/ajax\/Comic\/UnlockChapter_copy↗](https://yapi.yuewen.com/project/28/interface/api/64468) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter_1574142720938`
 * @更新时间 `2019-11-19 13:52:00`
 */
export const ajaxComicUnlockChapter_1574142720938 = /*#__PURE__*/ (
  requestData: AjaxComicUnlockChapter_1574142720938Request,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxComicUnlockChapter_1574142720938Response>(
    prepare(ajaxComicUnlockChapter_1574142720938RequestConfig, requestData),
    ...args
  );
};

ajaxComicUnlockChapter_1574142720938.requestConfig =
  ajaxComicUnlockChapter_1574142720938RequestConfig;

/**
 * 接口 [\/go\/pcm\/comic\/getContent(go)↗](https://yapi.yuewen.com/project/28/interface/api/166194) 的 **请求类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2020-12-01 20:11:50`
 */
export interface GoPcmComicGetContentRequest {
  /**
   * 漫画id
   */
  comicId: string;
  /**
   * 章节Id
   */
  chapterId: string;
  /**
   * 屏幕宽度， ≤480的，下发480
   * 480＜X≤560，下发560
   * 560＜X≤720，下发720
   * 720＜X≤800，下发800
   * 800＜X≤1080，下发1080
   * ＞1080，下发1536，
   * PC/M 现在统一下发800
   */
  width: string;
}

/**
 * 接口 [\/go\/pcm\/comic\/getContent(go)↗](https://yapi.yuewen.com/project/28/interface/api/166194) 的 **返回类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2020-12-01 20:11:50`
 */
export interface GoPcmComicGetContentResponse {
  comicInfo?: {
    /**
     * 10
     */
    availableFpNum?: number;
    /**
     * "13138233106881301"
     */
    comicId?: string;
    /**
     * "The Apostle of Cards"
     */
    comicName?: string;
    /**
     * 57
     */
    chapterNum?: number;
    /**
     * 1
     */
    actionStatus?: number;
    /**
     * "ShenMan"
     */
    publisher?: string;
    /**
     * 2
     */
    auditStatus?: number;
    /**
     * 100
     */
    novelType?: number;
    /**
     * "1560763860181"
     */
    CV?: string;
    inLibrary?: number;
    /**
     * 4
     */
    giftNum?: number;
    /**
     * 1547032856000
     */
    publishTime?: number;
    /**
     * 1567411308000
     */
    updateTime?: number;
    hasPrivilege?: number;
  };
  isDeleted?: number;
  chapterInfo?: {
    /**
     * "37568809166495838"
     */
    chapterId?: string;
    /**
     * "019"
     */
    chapterName?: string;
    /**
     * 19
     */
    chapterIndex?: number;
    /**
     * 13
     */
    price?: number;
    /**
     * 13
     */
    pageCount?: number;
    /**
     * "31026688607445859"
     */
    preChapterId?: string;
    /**
     * "xz01"
     */
    preChapterName?: string;
    /**
     * "31026698807993196"
     */
    nextChapterId?: string;
    /**
     * "xz03"
     */
    nextChapterName?: string;
    /**
     * 2
     */
    isVip?: number;
    isAuth?: number;
    /**
     * 1
     */
    batchUnlockStatus?: number;
    chapterLevel?: number;
    userLevel?: number;
    /**
     * 1547033417000
     */
    publishTime?: number;
    /**
     * 1567411279000
     */
    updateTime?: number;
    /**
     * [{"pageId":"34089046728834849","height":1066,"width":800,"url":"https://oacomic-image.webnovel.com/comicpage/12698954101038401/34089039749512990/34089046728834849!800.jpg?sign=db4702e30fb1989982137b19d12c5089&t=1603162367&updateTime=0"}]
     */
    chapterPage?: {
      /**
       * "34089046728834849"
       */
      pageId?: string;
      /**
       * 1066
       */
      height?: number;
      /**
       * 800
       */
      width?: number;
      /**
       * "https://oacomic-image.webnovel.com/comicpage/12698954101038401/34089039749512990/34089046728834849!800.jpg?sign=db4702e30fb1989982137b19d12c5089&t=1603162367&updateTime=0"
       */
      url?: string;
    }[];
  };
  giftInfo?: {
    /**
     * 4
     */
    giftNum?: number;
    giftMax?: {
      /**
       * 110863
       */
      id?: number;
      /**
       * 13138233106881300
       */
      bookId?: number;
      chapterId?: number;
      /**
       * 3058123914
       */
      userId?: number;
      /**
       * 1
       */
      giftAmount?: number;
      /**
       * "6802653167039154752"
       */
      orderId?: string;
      /**
       * 20005
       */
      giftId?: number;
      /**
       * 200
       */
      totalPrice?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * "Ring"
       */
      giftName?: string;
      /**
       * 200
       */
      giftPrice?: number;
      /**
       * "https://webbanner.webnovel.com/gift/1539660437_9240.png"
       */
      iconUrl?: string;
      /**
       * 1
       */
      status?: number;
      /**
       * 1
       */
      order?: number;
      UUT?: number;
      /**
       * "Finaste"
       */
      userName?: string;
    };
    /**
     * [{"id":111545,"userId":4302590209,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1586791647838,"userName":"Onilade"},{"id":111443,"userId":4311075932,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1586306517322,"userName":"EddyMugety"},{"id":111355,"userId":4300193432,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1538368011165,"userName":"Irieth"},{"id":111321,"userId":4305761864,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1557492967524,"userName":"Edman747_1"},{"id":111256,"userId":4305974474,"giftId":20003,"appId":10,"giftName":"Potion","giftPrice":50,"iconUrl":"https://webbanner.webnovel.com/gift/1539660274_3567.png","status":1,"order":1,"UUT":1567982992365,"userName":"Daoist294490"},{"id":110911,"userId":4300012210,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1550734365592,"userName":"Ahzrin"},{"id":110910,"userId":4300012210,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1550734365592,"userName":"Ahzrin"},{"id":110861,"userId":3058123914,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"Finaste"},{"id":110792,"userId":4300566906,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1567513446334,"userName":"Melon150"}]
     */
    giftRecords?: {
      /**
       * 111545
       */
      id?: number;
      /**
       * 4302590209
       */
      userId?: number;
      /**
       * 20001
       */
      giftId?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * "Balloon"
       */
      giftName?: string;
      /**
       * 5
       */
      giftPrice?: number;
      /**
       * "https://webbanner.webnovel.com/gift/1539660206_9513.png"
       */
      iconUrl?: string;
      /**
       * 1
       */
      status?: number;
      /**
       * 1
       */
      order?: number;
      /**
       * 1586791647838
       */
      UUT?: number;
      /**
       * "Onilade"
       */
      userName?: string;
    }[];
  };
  settings?: {
    /**
     * "_color2"
     */
    tc?: string;
    tf?: string;
    ts?: string;
    /**
     * "1"
     */
    paragraphSwitch?: string;
  };
  membershipStatus?: number;
  waitpayStatus?: number;
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/1901271742/1/1.jpg?mt=1586775105000"
     */
    avatar?: string;
    /**
     * "testingya"
     */
    nickName?: string;
    /**
     * "testingya"
     */
    userName?: string;
    /**
     * "1901271742"
     */
    guid?: string;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * "testingya"
     */
    penName?: string;
    /**
     * 11925
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 7
     */
    grade?: number;
    /**
     * 3
     */
    ES?: number;
    /**
     * 3
     */
    totalES?: number;
    /**
     * 2
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: boolean;
    /**
     * 1585029428302
     */
    UUT?: number;
    /**
     * 1
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 1
     */
    membershipStatus?: number;
    /**
     * 1592023726000
     */
    membershipExpireTime?: number;
    /**
     * true
     */
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [\/go\/pcm\/comic\/getContent(go)↗](https://yapi.yuewen.com/project/28/interface/api/166194) 的 **请求配置的类型**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2020-12-01 20:11:50`
 */
type GoPcmComicGetContentRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/comic/getContent",
    "data",
    string,
    "comicId" | "chapterId" | "width",
    false
  >
>;

/**
 * 接口 [\/go\/pcm\/comic\/getContent(go)↗](https://yapi.yuewen.com/project/28/interface/api/166194) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2020-12-01 20:11:50`
 */
const goPcmComicGetContentRequestConfig: GoPcmComicGetContentRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/go/pcm/comic/getContent",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: ["comicId", "chapterId", "width"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetContent",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/go\/pcm\/comic\/getContent(go)↗](https://yapi.yuewen.com/project/28/interface/api/166194) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2020-12-01 20:11:50`
 */
export const goPcmComicGetContent = /*#__PURE__*/ (
  requestData: GoPcmComicGetContentRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicGetContentResponse>(
    prepare(goPcmComicGetContentRequestConfig, requestData),
    ...args
  );
};

goPcmComicGetContent.requestConfig = goPcmComicGetContentRequestConfig;

const mockUrl_0_1_0_22 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_22 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_22 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_22 = "data" as any;

/**
 * 接口 [\/ajax\/vote\/list↗](https://yapi.yuewen.com/project/28/interface/api/14239) 的 **请求类型**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `GET /ajax/vote/list`
 * @更新时间 `2019-12-30 14:55:12`
 */
export interface AjaxVoteListRequest {
  /**
   * 1 是男生 2是女生
   */
  gender: string;
  /**
   * 页数
   */
  pageIndex: string;
}

/**
 * 接口 [\/ajax\/vote\/list↗](https://yapi.yuewen.com/project/28/interface/api/14239) 的 **返回类型**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `GET /ajax/vote/list`
 * @更新时间 `2019-12-30 14:55:12`
 */
export interface AjaxVoteListResponse {
  topLastWeek?: {
    male?: {
      /**
       * "10260480905004505"
       */
      bookId?: string;
      /**
       * "My Youth Began With Him"
       */
      bookName?: string;
      /**
       * "Baby Piggie"
       */
      authorName?: string;
      /**
       * "4.5"
       */
      totalScore?: string;
      /**
       * "19"
       */
      status?: string;
      /**
       * 47
       */
      votes?: number;
      /**
       * 858125
       */
      energyNum?: number;
    };
    female?: {
      /**
       * "10260480905004505"
       */
      bookId?: string;
      /**
       * "My Youth Began With Him"
       */
      bookName?: string;
      /**
       * "Baby Piggie"
       */
      authorName?: string;
      /**
       * "4.5"
       */
      totalScore?: string;
      /**
       * "19"
       */
      status?: string;
      /**
       * 47
       */
      votes?: number;
      /**
       * 858125
       */
      energyNum?: number;
    };
  };
  /**
   * [{"bookId":"@id","energyNum":[1,2,3,0],"voteCount":5,"bookName":"@name","authorName":"@name","coverUpdateTime":"0","gender":[1,2]}]
   */
  items?: {
    /**
     * "@id"
     */
    bookId?: string;
    /**
     * [1,2,3,0]
     */
    energyNum?: number[];
    /**
     * 5
     */
    voteCount?: number;
    /**
     * "@name"
     */
    bookName?: string;
    /**
     * "@name"
     */
    authorName?: string;
    /**
     * "0"
     */
    coverUpdateTime?: string;
    /**
     * [1,2]
     */
    gender?: number[];
  }[];
  /**
   * 13
   */
  total?: number;
  /**
   * 1
   */
  isLast?: number;
  /**
   * 5
   */
  voteSS?: number;
  /**
   * [{"awardType":1,"amount":0}]
   */
  awards?: {
    /**
     * 1
     */
    awardType?: number;
    amount?: number;
  }[];
}

/**
 * 接口 [\/ajax\/vote\/list↗](https://yapi.yuewen.com/project/28/interface/api/14239) 的 **请求配置的类型**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `GET /ajax/vote/list`
 * @更新时间 `2019-12-30 14:55:12`
 */
type AjaxVoteListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/vote/list",
    "data",
    string,
    "gender" | "pageIndex",
    false
  >
>;

/**
 * 接口 [\/ajax\/vote\/list↗](https://yapi.yuewen.com/project/28/interface/api/14239) 的 **请求配置**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `GET /ajax/vote/list`
 * @更新时间 `2019-12-30 14:55:12`
 */
const ajaxVoteListRequestConfig: AjaxVoteListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_1_0_22,
  devUrl: devUrl_0_1_0_22,
  prodUrl: prodUrl_0_1_0_22,
  path: "/ajax/vote/list",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_1_0_22,
  paramNames: [],
  queryNames: ["gender", "pageIndex"],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "ajaxVoteList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [\/ajax\/vote\/list↗](https://yapi.yuewen.com/project/28/interface/api/14239) 的 **请求函数**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `GET /ajax/vote/list`
 * @更新时间 `2019-12-30 14:55:12`
 */
export const ajaxVoteList = /*#__PURE__*/ (
  requestData: AjaxVoteListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxVoteListResponse>(
    prepare(ajaxVoteListRequestConfig, requestData),
    ...args
  );
};

ajaxVoteList.requestConfig = ajaxVoteListRequestConfig;

/**
 * 接口 [\/ajax\/vote\/like↗](https://yapi.yuewen.com/project/28/interface/api/14573) 的 **请求类型**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `POST /ajax/vote/like`
 * @更新时间 `2021-04-27 20:10:46`
 */
export interface AjaxVoteLikeRequest {
  bookId: string;
}

/**
 * 接口 [\/ajax\/vote\/like↗](https://yapi.yuewen.com/project/28/interface/api/14573) 的 **返回类型**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `POST /ajax/vote/like`
 * @更新时间 `2021-04-27 20:10:46`
 */
export interface AjaxVoteLikeResponse {
  /**
   * 1
   */
  SS?: number;
  /**
   * [{"awardType":1,"amount":1},{"awardType":3,"amount":2}]
   */
  awards?: {
    /**
     * 1
     */
    awardType?: number;
    /**
     * 1
     */
    amount?: number;
  }[];
}

/**
 * 接口 [\/ajax\/vote\/like↗](https://yapi.yuewen.com/project/28/interface/api/14573) 的 **请求配置的类型**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `POST /ajax/vote/like`
 * @更新时间 `2021-04-27 20:10:46`
 */
type AjaxVoteLikeRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/vote/like",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [\/ajax\/vote\/like↗](https://yapi.yuewen.com/project/28/interface/api/14573) 的 **请求配置**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `POST /ajax/vote/like`
 * @更新时间 `2021-04-27 20:10:46`
 */
const ajaxVoteLikeRequestConfig: AjaxVoteLikeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_1_0_22,
  devUrl: devUrl_0_1_0_22,
  prodUrl: prodUrl_0_1_0_22,
  path: "/ajax/vote/like",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_1_0_22,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "ajaxVoteLike",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [\/ajax\/vote\/like↗](https://yapi.yuewen.com/project/28/interface/api/14573) 的 **请求函数**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `POST /ajax/vote/like`
 * @更新时间 `2021-04-27 20:10:46`
 */
export const ajaxVoteLike = /*#__PURE__*/ (
  requestData: AjaxVoteLikeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxVoteLikeResponse>(
    prepare(ajaxVoteLikeRequestConfig, requestData),
    ...args
  );
};

ajaxVoteLike.requestConfig = ajaxVoteLikeRequestConfig;

const mockUrl_0_1_0_23 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_23 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_23 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_23 = "data" as any;

/**
 * 接口 [书评list↗](https://yapi.yuewen.com/project/28/interface/api/289) 的 **请求类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewsAjax`
 * @更新时间 `2021-05-08 18:18:55`
 */
export interface AjaxReviewGetReviewsAjaxRequest {
  /**
   * 分页
   */
  pageIndex: string;
  /**
   * 书id
   */
  bookId: string;
  /**
   * 是否需要平均评分信息
   */
  bookScore: string;
  /**
   * 1 - like, 2 -time （默认值为1）
   */
  orderBy: string;
}

/**
 * 接口 [书评list↗](https://yapi.yuewen.com/project/28/interface/api/289) 的 **返回类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewsAjax`
 * @更新时间 `2021-05-08 18:18:55`
 */
export interface AjaxReviewGetReviewsAjaxResponse {
  /**
   * [{"reviewId":"@id","userId":"@id","userName":"@name","role":1,"penName":"@name","avatar":"https://oauserimg.webnovel.com/userheadimg/2183903537/1/1.jpg","content":"@name(20-100)","createTime":"1 week ago","totalScore":4.6,"readToChapterIndex":"662","likeNums":1,"replyNums":1,"isSpoiler":1,"isLiked":1,"userLevel":1,"topStatus":1,"appId":10,"isViceModerator":0,"isLikedByAuthor":0,"imageItems":[{"imageUrl":"@url","height":100,"width":200}],"holdBadgeCoverId":1231313123123,"badgeInfo":{"achievedGradeGoal":"Add email and upload avatar","achievedMaxGrade":"2","achievedTime":"2018-01-31","badgeId":"10007","badgeName":"Who am I?","badgeType":"General","baseUrl":"https://actimg.webnovel.com/badge/10007/2/","maxGrade":"2","updateTime":"1517481162000"}}]
   */
  reviewItems?: {
    /**
     * "@id"
     */
    reviewId?: string;
    /**
     * "@id"
     */
    userId?: string;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * 1
     */
    role?: number;
    /**
     * "@name"
     */
    penName?: string;
    /**
     * "https://oauserimg.webnovel.com/userheadimg/2183903537/1/1.jpg"
     */
    avatar?: string;
    /**
     * "@name(20-100)"
     */
    content?: string;
    /**
     * "1 week ago"
     */
    createTime?: string;
    /**
     * 4.6
     */
    totalScore?: number;
    /**
     * "662"
     */
    readToChapterIndex?: string;
    /**
     * 1
     */
    likeNums?: number;
    /**
     * 1
     */
    replyNums?: number;
    /**
     * 1
     */
    isSpoiler?: number;
    /**
     * 1
     */
    isLiked?: number;
    /**
     * 1
     */
    userLevel?: number;
    /**
     * 1
     */
    topStatus?: number;
    /**
     * 10
     */
    appId?: number;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * [{"imageUrl":"@url","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "@url"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
    badgeInfo?: {
      /**
       * "Add email and upload avatar"
       */
      achievedGradeGoal?: string;
      /**
       * "2"
       */
      achievedMaxGrade?: string;
      /**
       * "2018-01-31"
       */
      achievedTime?: string;
      /**
       * "10007"
       */
      badgeId?: string;
      /**
       * "Who am I?"
       */
      badgeName?: string;
      /**
       * "General"
       */
      badgeType?: string;
      /**
       * "https://actimg.webnovel.com/badge/10007/2/"
       */
      baseUrl?: string;
      /**
       * "2"
       */
      maxGrade?: string;
      /**
       * "1517481162000"
       */
      updateTime?: string;
    };
  }[];
  /**
   * 1
   */
  totalReviewNum?: number;
  isLast?: number;
  userInfo?: {
    userRole?: number;
    /**
     * 1
     */
    isViceModerator?: number;
  };
  bookInfo?: {
    /**
     * "${query.bookId}"
     */
    bookId?: string;
    /**
     * 4.73
     */
    cdScore?: number;
    /**
     * 4.64
     */
    wbScore?: number;
    /**
     * 4
     */
    usScore?: number;
    /**
     * 2.73
     */
    tqScore?: number;
    /**
     * 3.55
     */
    sdScore?: number;
    /**
     * 4.67
     */
    realTotalScore?: number;
  };
}

/**
 * 接口 [书评list↗](https://yapi.yuewen.com/project/28/interface/api/289) 的 **请求配置的类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewsAjax`
 * @更新时间 `2021-05-08 18:18:55`
 */
type AjaxReviewGetReviewsAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/review/GetReviewsAjax",
    "data",
    string,
    "pageIndex" | "bookId" | "bookScore" | "orderBy",
    false
  >
>;

/**
 * 接口 [书评list↗](https://yapi.yuewen.com/project/28/interface/api/289) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewsAjax`
 * @更新时间 `2021-05-08 18:18:55`
 */
const ajaxReviewGetReviewsAjaxRequestConfig: AjaxReviewGetReviewsAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/GetReviewsAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: ["pageIndex", "bookId", "bookScore", "orderBy"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewGetReviewsAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书评list↗](https://yapi.yuewen.com/project/28/interface/api/289) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewsAjax`
 * @更新时间 `2021-05-08 18:18:55`
 */
export const ajaxReviewGetReviewsAjax = /*#__PURE__*/ (
  requestData: AjaxReviewGetReviewsAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxReviewGetReviewsAjaxResponse>(
    prepare(ajaxReviewGetReviewsAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxReviewGetReviewsAjax.requestConfig = ajaxReviewGetReviewsAjaxRequestConfig;

/**
 * 接口 [书评点赞↗](https://yapi.yuewen.com/project/28/interface/api/359) 的 **请求类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewLikeAjax`
 * @更新时间 `2018-06-28 17:46:52`
 */
export interface AjaxReviewAddReviewLikeAjaxRequest {
  /**
   * 点赞／取消点赞
   */
  opType: string;
  reviewId: string;
}

/**
 * 接口 [书评点赞↗](https://yapi.yuewen.com/project/28/interface/api/359) 的 **返回类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewLikeAjax`
 * @更新时间 `2018-06-28 17:46:52`
 */
export interface AjaxReviewAddReviewLikeAjaxResponse {}

/**
 * 接口 [书评点赞↗](https://yapi.yuewen.com/project/28/interface/api/359) 的 **请求配置的类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewLikeAjax`
 * @更新时间 `2018-06-28 17:46:52`
 */
type AjaxReviewAddReviewLikeAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/review/AddReviewLikeAjax",
    "data",
    string,
    "reviewId" | "opType",
    false
  >
>;

/**
 * 接口 [书评点赞↗](https://yapi.yuewen.com/project/28/interface/api/359) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewLikeAjax`
 * @更新时间 `2018-06-28 17:46:52`
 */
const ajaxReviewAddReviewLikeAjaxRequestConfig: AjaxReviewAddReviewLikeAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/AddReviewLikeAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: ["reviewId", "opType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewAddReviewLikeAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书评点赞↗](https://yapi.yuewen.com/project/28/interface/api/359) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewLikeAjax`
 * @更新时间 `2018-06-28 17:46:52`
 */
export const ajaxReviewAddReviewLikeAjax = /*#__PURE__*/ (
  requestData: AjaxReviewAddReviewLikeAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxReviewAddReviewLikeAjaxResponse>(
    prepare(ajaxReviewAddReviewLikeAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxReviewAddReviewLikeAjax.requestConfig =
  ajaxReviewAddReviewLikeAjaxRequestConfig;

/**
 * 接口 [书评详情【废弃】↗](https://yapi.yuewen.com/project/28/interface/api/377) 的 **请求类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewDetailAjax`
 * @更新时间 `2024-08-09 14:28:26`
 */
export interface AjaxReviewGetReviewDetailAjaxRequest {
  bookId: string;
  reviewId: string;
  pageIndex: string;
  /**
   * 0书，100漫画，200出版书
   */
  novelType: string;
}

/**
 * 接口 [书评详情【废弃】↗](https://yapi.yuewen.com/project/28/interface/api/377) 的 **返回类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewDetailAjax`
 * @更新时间 `2024-08-09 14:28:26`
 */
export interface AjaxReviewGetReviewDetailAjaxResponse {
  review?: {
    /**
     * 49
     */
    id?: number;
    /**
     * 123
     */
    bookId?: number;
    /**
     * "Review content - nice book;"
     */
    content?: string;
    /**
     * "54378937453"
     */
    userId?: string;
    /**
     * "dfgdf"
     */
    authorName?: string;
    /**
     * "ddd"
     */
    bookName?: string;
    /**
     * "天蚕土dou"
     */
    userName?: string;
    /**
     * 1
     */
    role?: number;
    /**
     * "笔名"
     */
    penName?: string;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * "1 week(s) ago"
     */
    updateTime?: string;
    /**
     * "1"
     */
    readToChapterIndex?: string;
    /**
     * "http://qidian.gtimg.com/en/images/landing/cover/2x/dayuzhoushidai.0.2.jpg"
     */
    avatar?: string;
    /**
     * 21
     */
    replyNums?: number;
    /**
     * 15
     */
    likeNums?: number;
    /**
     * 1
     */
    isLiked?: number;
    /**
     * 1
     */
    userLevel?: number;
    /**
     * 10
     */
    appId?: number;
    badgeInfo?: {
      /**
       * "Add email and upload avatar"
       */
      achievedGradeGoal?: string;
      /**
       * "2"
       */
      achievedMaxGrade?: string;
      /**
       * "2018-01-31"
       */
      achievedTime?: string;
      /**
       * "10007"
       */
      badgeId?: string;
      /**
       * "Who am I?"
       */
      badgeName?: string;
      /**
       * "General"
       */
      badgeType?: string;
      /**
       * "https://actimg.webnovel.com/badge/10007/2/"
       */
      baseUrl?: string;
      /**
       * "2"
       */
      maxGrade?: string;
      /**
       * "1517481162000"
       */
      updateTime?: string;
    };
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * [{"imageUrl":"@url","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "@url"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
  };
  /**
   * []
   */
  replyItems?: unknown[];
  /**
   * 107
   */
  total?: number;
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [书评详情【废弃】↗](https://yapi.yuewen.com/project/28/interface/api/377) 的 **请求配置的类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewDetailAjax`
 * @更新时间 `2024-08-09 14:28:26`
 */
type AjaxReviewGetReviewDetailAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/review/GetReviewDetailAjax",
    "data",
    string,
    "bookId" | "reviewId" | "pageIndex" | "novelType",
    false
  >
>;

/**
 * 接口 [书评详情【废弃】↗](https://yapi.yuewen.com/project/28/interface/api/377) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewDetailAjax`
 * @更新时间 `2024-08-09 14:28:26`
 */
const ajaxReviewGetReviewDetailAjaxRequestConfig: AjaxReviewGetReviewDetailAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/GetReviewDetailAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: ["bookId", "reviewId", "pageIndex", "novelType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewGetReviewDetailAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书评详情【废弃】↗](https://yapi.yuewen.com/project/28/interface/api/377) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewDetailAjax`
 * @更新时间 `2024-08-09 14:28:26`
 */
export const ajaxReviewGetReviewDetailAjax = /*#__PURE__*/ (
  requestData: AjaxReviewGetReviewDetailAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxReviewGetReviewDetailAjaxResponse>(
    prepare(ajaxReviewGetReviewDetailAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxReviewGetReviewDetailAjax.requestConfig =
  ajaxReviewGetReviewDetailAjaxRequestConfig;

/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/28/interface/api/2089) 的 **请求类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/DeleteReviewAjax`
 * @更新时间 `2018-04-13 11:34:12`
 */
export interface AjaxReviewDeleteReviewAjaxRequest {
  reviewId: string;
}

/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/28/interface/api/2089) 的 **返回类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/DeleteReviewAjax`
 * @更新时间 `2018-04-13 11:34:12`
 */
export interface AjaxReviewDeleteReviewAjaxResponse {}

/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/28/interface/api/2089) 的 **请求配置的类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/DeleteReviewAjax`
 * @更新时间 `2018-04-13 11:34:12`
 */
type AjaxReviewDeleteReviewAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/review/DeleteReviewAjax",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/28/interface/api/2089) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/DeleteReviewAjax`
 * @更新时间 `2018-04-13 11:34:12`
 */
const ajaxReviewDeleteReviewAjaxRequestConfig: AjaxReviewDeleteReviewAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/DeleteReviewAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewDeleteReviewAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/28/interface/api/2089) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/DeleteReviewAjax`
 * @更新时间 `2018-04-13 11:34:12`
 */
export const ajaxReviewDeleteReviewAjax = /*#__PURE__*/ (
  requestData: AjaxReviewDeleteReviewAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxReviewDeleteReviewAjaxResponse>(
    prepare(ajaxReviewDeleteReviewAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxReviewDeleteReviewAjax.requestConfig =
  ajaxReviewDeleteReviewAjaxRequestConfig;

/**
 * 接口 [添加书评回复↗](https://yapi.yuewen.com/project/28/interface/api/2102) 的 **请求类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewReplyAjax`
 * @更新时间 `2019-08-07 15:22:37`
 */
export interface AjaxReviewAddReviewReplyAjaxRequest {
  reviewId: string;
  content: string;
  bookId: string;
  /**
   * 0书，100漫画，200出版书
   */
  novelType: string;
}

/**
 * 接口 [添加书评回复↗](https://yapi.yuewen.com/project/28/interface/api/2102) 的 **返回类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewReplyAjax`
 * @更新时间 `2019-08-07 15:22:37`
 */
export interface AjaxReviewAddReviewReplyAjaxResponse {
  content: string;
  reviewId: number;
  user: {};
}

/**
 * 接口 [添加书评回复↗](https://yapi.yuewen.com/project/28/interface/api/2102) 的 **请求配置的类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewReplyAjax`
 * @更新时间 `2019-08-07 15:22:37`
 */
type AjaxReviewAddReviewReplyAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/review/AddReviewReplyAjax",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [添加书评回复↗](https://yapi.yuewen.com/project/28/interface/api/2102) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewReplyAjax`
 * @更新时间 `2019-08-07 15:22:37`
 */
const ajaxReviewAddReviewReplyAjaxRequestConfig: AjaxReviewAddReviewReplyAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/AddReviewReplyAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewAddReviewReplyAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [添加书评回复↗](https://yapi.yuewen.com/project/28/interface/api/2102) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewReplyAjax`
 * @更新时间 `2019-08-07 15:22:37`
 */
export const ajaxReviewAddReviewReplyAjax = /*#__PURE__*/ (
  requestData: AjaxReviewAddReviewReplyAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxReviewAddReviewReplyAjaxResponse>(
    prepare(ajaxReviewAddReviewReplyAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxReviewAddReviewReplyAjax.requestConfig =
  ajaxReviewAddReviewReplyAjaxRequestConfig;

/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/28/interface/api/2852) 的 **请求类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewAjax`
 * @更新时间 `2019-08-09 15:44:43`
 */
export interface AjaxReviewAddReviewAjaxRequest {
  bookId: string;
  /**
   * 书评
   */
  comment: string;
  cdScore: string;
  wbScore: string;
  usScore: string;
  tqScore: string;
  sdScore: string;
  /**
   * 剧透
   */
  isSpoiler: string;
  /**
   * 0小说，100漫画，200出版书
   */
  novelType: string;
  /**
   * 总评分
   */
  score: string;
}

/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/28/interface/api/2852) 的 **返回类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewAjax`
 * @更新时间 `2019-08-09 15:44:43`
 */
export interface AjaxReviewAddReviewAjaxResponse {
  content?: string;
  reviewId?: number;
  user?: {
    avatar?: string;
    nickName?: string;
    guid?: string;
    status?: number;
  };
}

/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/28/interface/api/2852) 的 **请求配置的类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewAjax`
 * @更新时间 `2019-08-09 15:44:43`
 */
type AjaxReviewAddReviewAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/review/AddReviewAjax",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/28/interface/api/2852) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewAjax`
 * @更新时间 `2019-08-09 15:44:43`
 */
const ajaxReviewAddReviewAjaxRequestConfig: AjaxReviewAddReviewAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/AddReviewAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewAddReviewAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/28/interface/api/2852) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewAjax`
 * @更新时间 `2019-08-09 15:44:43`
 */
export const ajaxReviewAddReviewAjax = /*#__PURE__*/ (
  requestData: AjaxReviewAddReviewAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxReviewAddReviewAjaxResponse>(
    prepare(ajaxReviewAddReviewAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxReviewAddReviewAjax.requestConfig = ajaxReviewAddReviewAjaxRequestConfig;

/**
 * 接口 [添加书评页面↗](https://yapi.yuewen.com/project/28/interface/api/58705) 的 **请求类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/AddReview`
 * @更新时间 `2021-04-28 16:18:04`
 */
export interface AjaxReviewAddReviewRequest {
  bookId: string;
  /**
   * 100 漫画书 200 出版书
   */
  novelType: string;
}

/**
 * 接口 [添加书评页面↗](https://yapi.yuewen.com/project/28/interface/api/58705) 的 **返回类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/AddReview`
 * @更新时间 `2021-04-28 16:18:04`
 */
export interface AjaxReviewAddReviewResponse {
  /**
   * "10408279801026805"
   */
  bookId?: string;
  /**
   * 2
   */
  bookType?: number;
  /**
   * "0"
   */
  novelType?: string;
  /**
   * 5
   */
  readToChapterIndex?: number;
  user?: {
    /**
     * "4300001149"
     */
    guid?: string;
    /**
     * "//userimg.webnovel.com/userheadimg/4300001149/1/1.jpg?mt=1560344081420"
     */
    avatar?: string;
    /**
     * "Nana_Sun_Cherry"
     */
    userName?: string;
    /**
     * "Nana_Sun_Cherry"
     */
    nickName?: string;
    /**
     * "Nana_Sun_Cherry"
     */
    penName?: string;
    /**
     * 4
     */
    role?: number;
    status?: number;
    /**
     * 138
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 1
     */
    userLevel?: number;
    /**
     * 1
     */
    availablePower?: number;
    /**
     * 1
     */
    totalPower?: number;
    /**
     * 1
     */
    availableEnergy?: number;
    /**
     * 1
     */
    totalEnergy?: number;
    emailStatus?: number;
    mt?: number;
    UUT?: number;
  };
}

/**
 * 接口 [添加书评页面↗](https://yapi.yuewen.com/project/28/interface/api/58705) 的 **请求配置的类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/AddReview`
 * @更新时间 `2021-04-28 16:18:04`
 */
type AjaxReviewAddReviewRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/review/AddReview",
    "data",
    string,
    "bookId" | "novelType",
    false
  >
>;

/**
 * 接口 [添加书评页面↗](https://yapi.yuewen.com/project/28/interface/api/58705) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/AddReview`
 * @更新时间 `2021-04-28 16:18:04`
 */
const ajaxReviewAddReviewRequestConfig: AjaxReviewAddReviewRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/AddReview",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: ["bookId", "novelType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewAddReview",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [添加书评页面↗](https://yapi.yuewen.com/project/28/interface/api/58705) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/AddReview`
 * @更新时间 `2021-04-28 16:18:04`
 */
export const ajaxReviewAddReview = /*#__PURE__*/ (
  requestData: AjaxReviewAddReviewRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxReviewAddReviewResponse>(
    prepare(ajaxReviewAddReviewRequestConfig, requestData),
    ...args
  );
};

ajaxReviewAddReview.requestConfig = ajaxReviewAddReviewRequestConfig;

/**
 * 接口 [【go】书评详情↗](https://yapi.yuewen.com/project/28/interface/api/119922) 的 **请求类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /go/pcm/getReviewDetail`
 * @更新时间 `2020-08-03 20:07:45`
 */
export interface GoPcmGetReviewDetailRequest {
  bookId: string;
  reviewId: string;
  pageIndex: string;
}

/**
 * 接口 [【go】书评详情↗](https://yapi.yuewen.com/project/28/interface/api/119922) 的 **返回类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /go/pcm/getReviewDetail`
 * @更新时间 `2020-08-03 20:07:45`
 */
export interface GoPcmGetReviewDetailResponse {
  baseInfo?: {
    /**
     * "${query.bookId}"
     */
    bookId?: string;
    /**
     * "tgewtwe"
     */
    bookName?: string;
    novelType?: number;
    /**
     * 15681222223232
     */
    bookCoverId?: number;
    /**
     * "fwefwefwe"
     */
    authorName?: string;
    baseBadgeUrl?: string;
    /**
     * "https://webbanner.webnovel.com/privilege/"
     */
    basePrivilegeUrl?: string;
    /**
     * 1333
     */
    reviewAmount?: number;
  };
  review?: {
    /**
     * "${query.reviewId}"
     */
    reviewId?: string;
    /**
     * "@paragraph"
     */
    content?: string;
    /**
     * [{"imageUrl":"@image","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "@image"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 11224
     */
    likeAmount?: number;
    /**
     * 23222
     */
    replyAmount?: number;
    isLiked?: number;
    /**
     * "@time"
     */
    createTime?: string;
    /**
     * 1234433
     */
    userId?: number;
    userRole?: number;
    /**
     * "jennyrenjialele5"
     */
    userName?: string;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      IsPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      Img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
    /**
     * 1
     */
    status?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * 1
     */
    leakFlag?: number;
    /**
     * true
     */
    topStatus?: boolean;
    /**
     * 1
     */
    essenceStatus?: number;
  };
  topReview?: {
    /**
     * "@id"
     */
    reviewId?: string;
    /**
     * "@paragraph"
     */
    content?: string;
    /**
     * [{"imageUrl":"wefwe","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "wefwe"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 11224
     */
    likeAmount?: number;
    /**
     * 23222
     */
    replyAmount?: number;
    isLiked?: number;
    /**
     * "@time"
     */
    createTime?: string;
    /**
     * 1234433
     */
    userId?: number;
    userRole?: number;
    /**
     * "jennyrenjialele5"
     */
    userName?: string;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      IsPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      Img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1231313123123
     */
    holdBadgecoverId?: number;
    /**
     * 1
     */
    status?: number;
  };
  /**
   * [{"reviewId":"@id","content":"test","imageItems":[{"imageUrl":"wefwe","height":100,"width":200}],"likeAmount":11224,"replyAmount":23222,"isLiked":0,"createTime":1537526601173,"userId":1234433,"userRole":0,"userName":"jennyrenjialele5","isViceModerator":0,"isLikedByAuthor":0,"appId":10,"coverId":1557315300000,"privilegeInfo":{"IsPrivilege":1,"Img":"ic_privilege2x.png"},"userLevel":6,"holdBadgeCoverURL":"https://actimg.webnovel.com/badge/10006/1/","holdBadgecoverId":1231313123123,"status":1,"totalScore":5,"leakFlag":1,"topStatus":true,"essenceStatus":1},{"reviewId":30629995764304730,"content":"test","imageItems":[{"imageUrl":"wefwe","height":100,"width":200}],"likeAmount":11224,"replyAmount":23222,"isLiked":0,"createTime":1537526601173,"userId":1234433,"userRole":0,"userName":"jennyrenjialele5","isViceModerator":0,"isLikedByAuthor":1,"appId":10,"coverId":1557315300000,"privilegeInfo":{"IsPrivilege":1,"Img":"ic_privilege2x.png"},"userLevel":6,"holdBadgeCoverURL":"https://actimg.webnovel.com/badge/10006/1/","holdBadgecoverId":1231313123123,"status":1}]
   */
  replyItems?: {
    /**
     * "@id"
     */
    reviewId?: string;
    /**
     * "test"
     */
    content?: string;
    /**
     * [{"imageUrl":"wefwe","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "wefwe"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 11224
     */
    likeAmount?: number;
    /**
     * 23222
     */
    replyAmount?: number;
    isLiked?: number;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * 1234433
     */
    userId?: number;
    userRole?: number;
    /**
     * "jennyrenjialele5"
     */
    userName?: string;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      IsPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      Img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1231313123123
     */
    holdBadgecoverId?: number;
    /**
     * 1
     */
    status?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * 1
     */
    leakFlag?: number;
    /**
     * true
     */
    topStatus?: boolean;
    /**
     * 1
     */
    essenceStatus?: number;
  }[];
  userInfo?: {
    userRole?: number;
    /**
     * 1
     */
    isViceModerator?: number;
    /**
     * 1
     */
    isAuthor?: number;
  };
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [【go】书评详情↗](https://yapi.yuewen.com/project/28/interface/api/119922) 的 **请求配置的类型**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /go/pcm/getReviewDetail`
 * @更新时间 `2020-08-03 20:07:45`
 */
type GoPcmGetReviewDetailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/getReviewDetail",
    "data",
    string,
    "bookId" | "reviewId" | "pageIndex",
    false
  >
>;

/**
 * 接口 [【go】书评详情↗](https://yapi.yuewen.com/project/28/interface/api/119922) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /go/pcm/getReviewDetail`
 * @更新时间 `2020-08-03 20:07:45`
 */
const goPcmGetReviewDetailRequestConfig: GoPcmGetReviewDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/go/pcm/getReviewDetail",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: ["bookId", "reviewId", "pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGetReviewDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【go】书评详情↗](https://yapi.yuewen.com/project/28/interface/api/119922) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /go/pcm/getReviewDetail`
 * @更新时间 `2020-08-03 20:07:45`
 */
export const goPcmGetReviewDetail = /*#__PURE__*/ (
  requestData: GoPcmGetReviewDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmGetReviewDetailResponse>(
    prepare(goPcmGetReviewDetailRequestConfig, requestData),
    ...args
  );
};

goPcmGetReviewDetail.requestConfig = goPcmGetReviewDetailRequestConfig;

const mockUrl_0_1_0_24 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_24 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_24 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_24 = "data" as any;

/**
 * 接口 [拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/395) 的 **请求类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getChapterListAjax`
 * @更新时间 `2020-04-21 17:58:17`
 */
export interface AjaxChapterGetChapterListAjaxRequest {
  bookId: string;
}

/**
 * 接口 [拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/395) 的 **返回类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getChapterListAjax`
 * @更新时间 `2020-04-21 17:58:17`
 */
export interface AjaxChapterGetChapterListAjaxResponse {
  bookInfo?: {
    /**
     * "${query.bookId}"
     */
    bookId?: string;
    /**
     * "His Genius Wife is a Superstar"
     */
    bookName?: string;
    /**
     * 345
     */
    totalChapterNum?: number;
    /**
     * "ArriaCross"
     */
    authorName?: string;
    /**
     * 2
     */
    bookType?: number;
    /**
     * 50
     */
    actionStatus?: number;
    /**
     * 1
     */
    hasPrivilege?: number;
  };
  /**
   * [{"volumeName":"","volumeId":1,"chapterItems":[{"chapterId":"33108867093162835","chapterName":"The Woman in White","chapterIndex":0,"isVip":0,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1,"noArchive":1},{"chapterId":"33108867093162836","chapterName":"The Woman in White1","chapterIndex":0,"isVip":0,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1},{"chapterId":"33108867093162837","chapterName":"The Woman in White2","chapterIndex":2,"isVip":0,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1},{"chapterId":"33108867093162838","chapterName":"The Woman in White3","chapterIndex":3,"isVip":2,"isAuth":0,"publishTime":"Nov 29,2018","chapterLevel":1,"userLevel":1,"canUnlock":1},{"chapterId":"3310886709316289","chapterName":"The Woman in White4","chapterIndex":4,"isVip":2,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":3,"userLevel":3,"canUnlock":1}]}]
   */
  volumeItems?: {
    volumeName?: string;
    /**
     * 1
     */
    volumeId?: number;
    /**
     * [{"chapterId":"33108867093162835","chapterName":"The Woman in White","chapterIndex":0,"isVip":0,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1,"noArchive":1},{"chapterId":"33108867093162836","chapterName":"The Woman in White1","chapterIndex":0,"isVip":0,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1},{"chapterId":"33108867093162837","chapterName":"The Woman in White2","chapterIndex":2,"isVip":0,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1},{"chapterId":"33108867093162838","chapterName":"The Woman in White3","chapterIndex":3,"isVip":2,"isAuth":0,"publishTime":"Nov 29,2018","chapterLevel":1,"userLevel":1,"canUnlock":1},{"chapterId":"3310886709316289","chapterName":"The Woman in White4","chapterIndex":4,"isVip":2,"isAuth":1,"publishTime":"Nov 29,2018","chapterLevel":3,"userLevel":3,"canUnlock":1}]
     */
    chapterItems?: {
      /**
       * "33108867093162835"
       */
      chapterId?: string;
      /**
       * "The Woman in White"
       */
      chapterName?: string;
      chapterIndex?: number;
      isVip?: number;
      /**
       * 1
       */
      isAuth?: number;
      /**
       * "Nov 29,2018"
       */
      publishTime?: string;
      chapterLevel?: number;
      userLevel?: number;
      /**
       * 1
       */
      canUnlock?: number;
      /**
       * 1
       */
      noArchive?: number;
    }[];
  }[];
  /**
   * "33108867093162835"
   */
  curReadChapter?: string;
}

/**
 * 接口 [拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/395) 的 **请求配置的类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getChapterListAjax`
 * @更新时间 `2020-04-21 17:58:17`
 */
type AjaxChapterGetChapterListAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/chapter/getChapterListAjax",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/395) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getChapterListAjax`
 * @更新时间 `2020-04-21 17:58:17`
 */
const ajaxChapterGetChapterListAjaxRequestConfig: AjaxChapterGetChapterListAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/chapter/getChapterListAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterGetChapterListAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/395) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getChapterListAjax`
 * @更新时间 `2020-04-21 17:58:17`
 */
export const ajaxChapterGetChapterListAjax = /*#__PURE__*/ (
  requestData: AjaxChapterGetChapterListAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxChapterGetChapterListAjaxResponse>(
    prepare(ajaxChapterGetChapterListAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxChapterGetChapterListAjax.requestConfig =
  ajaxChapterGetChapterListAjaxRequestConfig;

/**
 * 接口 [【废弃】获取阅读内容-Page↗](https://yapi.yuewen.com/project/28/interface/api/516) 的 **请求类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /page/book/GetBookReadingPage`
 * @更新时间 `2019-02-13 15:10:57`
 */
export interface PageBookGetBookReadingPageRequest {}

/**
 * 接口 [【废弃】获取阅读内容-Page↗](https://yapi.yuewen.com/project/28/interface/api/516) 的 **返回类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /page/book/GetBookReadingPage`
 * @更新时间 `2019-02-13 15:10:57`
 */
export interface PageBookGetBookReadingPageResponse {
  /**
   * 1
   */
  isDeleted?: number;
  bookInfo?: {
    /**
     * 1
     */
    totalPreChapterNum?: number;
    /**
     * 1
     */
    bookId?: number;
    /**
     * "Skyfire Avenue"
     */
    bookName?: string;
    /**
     * 1
     */
    authorId?: number;
    /**
     * "Tang Jia San Shao"
     */
    authorName?: string;
    /**
     * 10
     */
    totalChapterNum?: number;
    /**
     * 7
     */
    reviewTotal?: number;
    /**
     * "To be Continued"
     */
    actionStatus?: string;
    /**
     * "baidu.com"
     */
    patreonLink?: string;
    /**
     * 1
     */
    bookType?: number;
    /**
     * [123,456]
     */
    adIds?: number[];
    /**
     * [123,456]
     */
    videoAdIds?: number[];
    /**
     * "0/1"
     */
    inLibrary?: string;
  };
  chapterInfo?: {
    /**
     * 3
     */
    chapterId?: number;
    /**
     * 1
     */
    orderIndex?: number;
    /**
     * "Chapter 3: Previous Era, New Era"
     */
    chapterName?: string;
    /**
     * 3
     */
    chapterIndex?: number;
    /**
     * [{"id":"123 //翻译组id","name":"gg //翻译组名称"}]
     */
    groupItems?: {
      /**
       * "123 //翻译组id"
       */
      id?: string;
      /**
       * "gg //翻译组名称"
       */
      name?: string;
    }[];
    /**
     * [{"id":6,"name":"Xiao Lai","userId":"2355200678"}]
     */
    translatorItems?: {
      /**
       * 6
       */
      id?: number;
      /**
       * "Xiao Lai"
       */
      name?: string;
      /**
       * "2355200678"
       */
      userId?: string;
    }[];
    /**
     * [{"id":9,"name":"Mark","userId":"2355200678"}]
     */
    editorItems?: {
      /**
       * 9
       */
      id?: number;
      /**
       * "Mark"
       */
      name?: string;
      /**
       * "2355200678"
       */
      userId?: string;
    }[];
    /**
     * 2
     */
    preChapterId?: number;
    /**
     * 4
     */
    nextChapterId?: number;
    /**
     * "4"
     */
    transRating?: string;
    /**
     * "50"
     */
    reviewTotal?: string;
    /**
     * "Chapter 3: Previous Era, New Era\n\nIn year 2235 of the previous era, 。。。很长的内容。。。."
     */
    content?: string;
    /**
     * "1 通过授权， 0 未通过授权"
     */
    isAuth?: string;
    /**
     * "1 是锁定章节， 0或其它 不是锁定章节。 表示书本是否被锁定"
     */
    isVip?: string;
    /**
     * "如果本章是 vip 章节，需要消耗多少 ss 来跳过广告"
     */
    SSPrice?: string;
    /**
     * 100
     */
    originalPrice?: number;
    /**
     * "大减价"
     */
    discountInfo?: string;
    /**
     * "GT 或 空字符串"
     */
    source?: string;
    /**
     * "https://oawww.webnovel.com/book/7765065001015905 (gt的外链)"
     */
    sourceUrl?: string;
    /**
     * "1 //1表示是精排，0表示不是"
     */
    isRichFormat?: string;
    notes?: {
      avatar?: string;
      name?: string;
      /**
       * "blabla"
       */
      note?: string;
      /**
       * "translator"
       */
      role?: string;
      /**
       * "ID"
       */
      userId?: string;
    };
  };
  settings?: {
    /**
     * "123"
     */
    mtc?: string;
    mtf?: null;
    mts?: null;
  };
}

/**
 * 接口 [【废弃】获取阅读内容-Page↗](https://yapi.yuewen.com/project/28/interface/api/516) 的 **请求配置的类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /page/book/GetBookReadingPage`
 * @更新时间 `2019-02-13 15:10:57`
 */
type PageBookGetBookReadingPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/page/book/GetBookReadingPage",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [【废弃】获取阅读内容-Page↗](https://yapi.yuewen.com/project/28/interface/api/516) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /page/book/GetBookReadingPage`
 * @更新时间 `2019-02-13 15:10:57`
 */
const pageBookGetBookReadingPageRequestConfig: PageBookGetBookReadingPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/page/book/GetBookReadingPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageBookGetBookReadingPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【废弃】获取阅读内容-Page↗](https://yapi.yuewen.com/project/28/interface/api/516) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /page/book/GetBookReadingPage`
 * @更新时间 `2019-02-13 15:10:57`
 */
export const pageBookGetBookReadingPage = /*#__PURE__*/ (
  requestData?: PageBookGetBookReadingPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PageBookGetBookReadingPageResponse>(
    prepare(pageBookGetBookReadingPageRequestConfig, requestData),
    ...args
  );
};

pageBookGetBookReadingPage.requestConfig =
  pageBookGetBookReadingPageRequestConfig;

/**
 * 接口 [获取阅读内容-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/531) 的 **请求类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getContent`
 * @更新时间 `2020-10-19 15:23:34`
 */
export interface AjaxChapterGetContentRequest {
  bookId: string;
  chapterId: string;
  /**
   * 1: 需要段内容 0：不需要段内容
   */
  withParagraphContent?: string;
  _csrfToken: string;
}

/**
 * 接口 [获取阅读内容-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/531) 的 **返回类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getContent`
 * @更新时间 `2020-10-19 15:23:34`
 */
export interface AjaxChapterGetContentResponse {
  bookInfo?: {
    /**
     * "${query.bookId}"
     */
    bookId?: string;
    /**
     * "Rebirth of the Strongest Empress"
     */
    bookName?: string;
    /**
     * 3004311901233701
     */
    authorId?: number;
    /**
     * " North Night"
     */
    authorName?: string;
    /**
     * 163
     */
    totalChapterNum?: number;
    /**
     * "zh"
     */
    languageName?: string;
    /**
     * "30"
     */
    actionStatus?: string;
    /**
     * 1161
     */
    reviewTotal?: number;
    /**
     * 1
     */
    bookType?: number;
    totalPreChapterNum?: number;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * 5
     */
    topChapterLevel?: number;
    /**
     * ["/274367222/web-read-video3","/274367222/msite-book-rect4","/274367222/msite-read-video3","/274367222/msite-book-rect2"]
     */
    adIds?: string[];
    /**
     * []
     */
    videoAdIds?: unknown[];
    /**
     * 1
     */
    isShowAds?: number;
    /**
     * 487
     */
    giftNum?: number;
  };
  chapterInfo?: {
    /**
     * "${query.chapterId}"
     */
    chapterId?: string;
    /**
     * "Crushing the Heart on Lingyun"
     */
    chapterName?: string;
    /**
     * 1
     */
    chapterIndex?: number;
    /**
     * "41288685441829971"
     */
    preChapterId?: string;
    /**
     * "xxx"
     */
    preChapterName?: string;
    /**
     * "41312210319887628"
     */
    nextChapterId?: string;
    /**
     * "xxx"
     */
    nextChapterName?: string;
    chapterLevel?: number;
    /**
     * 3
     */
    userLevel?: number;
    isVip?: number;
    /**
     * 1
     */
    SSPrice?: number;
    /**
     * [{"paragraphId":"fb8837b59bbc125049255bcf04c838bf","content":"The carriage went all the way into the city. Although it was nighttime, because the Imperial Capital was the Empire's largest and most famous commercial center, the gates of this place had never once been closed, except during the warring era.\r\n"},{"paragraphId":"2c57d66e82bfb04eaef57e81fd431f96","content":"Rody was tailing the carriage from a distance. He did not dare to stay too close to the carriage. Only God knew how powerful the beautiful girl actually was, and in the event that Rody was discovered, he would end up in prison together with Star.\r\n"},{"paragraphId":"f66bbe70adf941c656caaf07a2d9f9ce","content":"The carriage passed through the capital’s magnificent Victory Square and entered a wide road. Rody had already been in the capital for 2 years but he was still not familiar with this road. He knew that only the most powerful of aristocrats could live here. All the people living here were from rich and powerful families.\r\n"},{"paragraphId":"cc1bf646b2497450c43455b529a3f40c","content":"The carriage slowly stopped in front of a large mansion. The thick wooden door of the mansion was painted in red giving it an iron-like look. Rody was surprised and almost fell down when he saw the family insignia on the door. He knew what that pattern was! It was the insignia for the Flame Tulip Family!\r\n"},{"paragraphId":"92fac219e519d68cad3076ce46485dd9","content":"As a senior student in the Imperial Academy, he was familiar with the Empire's military history. Rody obviously knew what that flame-like tulip insignia represented.\r\n"},{"paragraphId":"a4096ed209f4c5dd19ad37abb878bfec","content":"It represented honor and glory! It represented the people's respect and admiration! The Flame Tulip Family. It was the family of the descendants of the first Marshal that helped His Majesty the Emperor found the Empire. In the Empire's 600 years of history, the family has had a total of 14 Marshals. Each and every one of them was an outstanding strategist. They have contributed much to the Empire. Rody remembered his history teacher telling him in a tone of reverence that this family was the God of War’s family.\r\n"},{"paragraphId":"1a691fe800c22804c46240cb20fc0c38","content":"Naturally, Rody only had respect for this family! Never in his life would he have imagined that he would attack the Tulip Family. It looked like there was now a perfect explanation for her ridiculous power. As she was part of the Flame Tulip Family, she must be very powerful. As the carriage slowly passed through the main entrance, the door closed. Rody’s heart was now filled with anxiety.\r\n"},{"paragraphId":"9afee2920378a1a3544ddef48cc82946","content":"He knew how serious it was to deal with the Tulip Family if they found out that he secretly came here to rescue someone. If they caught him, terrible things would happen. If they found out that a group of people had attacked the Tulip Family, it was certain that this group of people would all be hanged. Any normal person would pack up and run away immediately, as far away as possible.\r\n"},{"paragraphId":"fa2d07dcfd6431ba25bcddbed305e32a","content":"Rody thought to himself for a moment and sighed. He could not abandon his friend and run away on his own. It was not consistent with his principles of life.  Although Rody was not a virtuous person, he would not abandon his family and friends.\r\n"},{"paragraphId":"6e4e4043253e087bbfac220e8fa40edb","content":"Gritting his teeth, Rody entered a small alley next to the mansion. He looked around carefully to make sure that there was no one around before he climbed the walls and jumped into the compound….\r\n"},{"paragraphId":"030f024df2f8b9e93f6f798fa110d888","content":"Nicole watched her drunk little brother being ferried back. Although she was extremely angry, her face was expressionless. She then called her servants and waved her hand as she coldly said, “Carry him down and let him rest.” \r\n"},{"paragraphId":"52d78df1e38430e3927af6ff68c1dede","content":"Unfortunately, the idiotic future duke was not an obedient person. Being drunk, he could not recognize the person in front of him. His eyes were lax as he laughed and jokingly looked at his sister. He also stretched out his finger and attempted to tease her chin.\r\n"},{"paragraphId":"25de5db13bd443c73545cad4f75e03c6","content":"In a daze, he mumbled to himself, “Ah, my dear Sarah! I did not see you for a few days and you have already forgotten about me? You little fox! Let’s see how I shall teach you tonight!” He then stretched his arms and threw himself forward.\r\n"},{"paragraphId":"c6ed81b14d1bed05abd7646c195659f9","content":"Nicole’s face turned ghastly pale as she skillfully turned sideways, causing him to stumble into a void. Anger started to show in her eyes as she spoke coldly, “Sarah? You even went to that kind of filthy place?” The pitiful playboy was still not aware of the dangerous situation he was in. Nicole flicked a finger and immediately, a white light shot out and struck the playboy’s stomach.\r\n"},{"paragraphId":"2e007ce3530629ed57c52cf59652e4c8","content":"The playboy did not even have the chance to scream as he flew 3 meters away and crashed face first into the ground.\r\n"},{"paragraphId":"445022b213fde0def1f5d51d6ad82eb2","content":"Rody was hiding on top a tree outside the hall and saw the entire scene. He wondered, that if he was the target being shot at, would he be able to dodge it? The answer in his heart made him give out cold sweat.\r\n"},{"paragraphId":"d3e50af7b11e3b2615687f8a2de79304","content":"In fact, Rody did not even dare to breathe heavily at his hiding place as he carefully hid himself. He knew that Star was tied up somewhere in the yard. Although there was nobody in the yard, Rody did not dare rescue his friend while the female mage was still around. He planned to wait until the middle of the night when everybody was asleep before he began his rescue.\r\n"},{"paragraphId":"e05d6ee21fd2ac1b465e9aa3a088735c","content":"They would probably not send Star to jail so late at night. Star should be tied up somewhere like the stables or the firewood store until dawn. As the beautiful female mage should be the proprietress here, her bedroom would most likely be far away from such places. In that case, Rody would be safer when he rescues his friend.\r\n"},{"paragraphId":"2db57493eb7e5dc1d85a95cbabe996d0","content":"Rody, hiding within the trees and lost in his thoughts, was unaware that the people in the yard had moved away. Star, who was left in the yard earlier, was also carried away by one of the stronger servants.\r\n"},{"paragraphId":"513d854ba9fd50fd5eb386fda226d6d4","content":"Although the mosquitoes and ants made Rody feel very uncomfortable, he persevered until the middle of the night.\r\n"},{"paragraphId":"eacacb65d107d709a6e321855cbfee23","content":"From the position of the moon in the sky, Rody guessed that it should be past midnight now and he slowly descended the tree.\r\n"},{"paragraphId":"e474e4b5869a9c572b43afe7871111bb","content":"He was not familiar with his surroundings, but it so happened he had good grades for architecture in the academy. Hence, from the entire mansion, he could guess the location of the living quarters of the owner, the servants and other areas such as the stable. Rody picked a path and quickly dashed towards the stable.\r\n"},{"paragraphId":"327bb4d8cc124f475ee85ad5097a912b","content":"Rody had never seen such a huge stable before! He had always thought that the stable in the Academy was quite large. However, the stable here was twice as big compared to the Imperial Academy's! It was large enough to fit more than a hundred horses. Rody sighed. A glance at the windows of the stable showed that it did not have any lights on. He quietly pushed the door open and went in.\r\n"},{"paragraphId":"d120accc1b4dee3c4a2893d48549da3d","content":"“Star!” Rody whispered as he walked. He stumbled over the straws and wooden boxes on the ground twice but he still did not dare to light up the place. He had brushed into a lot of straw and horse manure but he could not be bothered. He knew that if he could not find Star by tomorrow, they would be finished!\r\n"},{"paragraphId":"ccd3883a81b348e3840d03ca370902dc","content":"As soon as Rody reached the end of the stable, he heard light footsteps from across the door. His heart suddenly jumped into his throat as he desperately hid in the biggest horse shed.\r\n"},{"paragraphId":"7727b9a74cbe64a215c5749f5570d47d","content":"The shed was obviously larger than the rest in the stable and particularly well constructed.\r\n"},{"paragraphId":"89f1f2a90a96b8646621056c52cda671","content":"On the railings was also a saddle. Naturally, it was a high-quality item. Rody looked back and saw a pair of eyes staring back at him in the dark. Before he could cry out, he realized that it was just a horse.\r\n"},{"paragraphId":"d72721d51f10a35e2fdff4ebcf30db4d","content":"Even in the dark, Rody could faintly see that this was a very handsome black horse. Its limbs were healthy and strong like reinforced iron. The horse was watching Rody. Its nose puffed hot air and its hooves were restless. Apparently, Rody disturbed its sleep.\r\n"},{"paragraphId":"f87bf7adca726cb26aad09ff9a2865cc","content":"Rody gingerly moved to the side of the horse and muttered, \"Dear horse, dear horse. I am not a horse thief. I mean no harm.\" Rody then touched the horse's mane. He tried to use the skill learned in the Imperial Academy to calm down the horse.\r\n"},{"paragraphId":"150157e4a7c2a57bf135792c9462def7","content":"At this time, he heard footsteps gradually approaching. Clearly, someone was heading here.\r\n"},{"paragraphId":"07d77754900a92b163b4d351511bd4a8","content":"Rody complained in his heart. In a moment of desperation, he caught sight of a cross-beam above. He quietly leaped up and caught the beam. His legs then latched onto it so that his body was hanging from it.\r\n"},{"paragraphId":"0f6a7b18c5ec114192b67b3fd6c5dd17","content":"“Garrus … you are really not well-behaved,” a soft timid voice came from outside the horse shed. Nicole was standing outside the shed as she looked at the restless horse in it. Her father loved horses and this battle horse was used in the battlefield when her father commanded the army.\r\n"},{"paragraphId":"caaefbb80f873dbd0bf06953b48599a0","content":"“Garrus…. Do not flail about…. I'm in a bad mood tonight.” Nicole’s tone was low and her wonderful voice gave out a sad mood. Her soft voice was capable of breaking the hearts of listeners.\r\n"},{"paragraphId":"a2678b02d31b36518fe364dcf2fa0772","content":"Nicole gently opened the barrier gate of the horse shed and slowly walked in. Rody was so scared that he even stopped breathing. He also dared not move as he feared to make any sound. Nicole reached out and gently stroked the mane and neck of the horse. Under the gentle strokes of its master, the horse soon calmed down.\r\n"},{"paragraphId":"c4bd0b2498d05d3321967003f783da18","content":"“Garrus…. I am very sad….” Nicole’s words sounded immeasurably aggrieved. “Why… Why do I have to bear all this… I miss my father....” She slowly hugged the horse such that her face was at its neck. “I know. You are also thinking of father as well?”\r\n"},{"paragraphId":"14c9bc4e426b5452d55b8cd1b7419a14","content":"In the dark, the girl, wearing a white nightgown, continued to whisper and cry softly. Seeing the beautiful blonde Nicole’s heartbreaking crying face, the hair at her forehead damp from her tears, Rody's young heart was touched, as if someone was poking it softly with a stick.\r\n"},{"paragraphId":"dcf405223916e8b6e7c5c05339ca76a0","content":"God, what kind of abominable matter is this?! To let such a beautiful girl cry in such a pitiful manner is surely a crime.\r\n"},{"paragraphId":"398510d73edea7a32bb01d0c1ae5a035","content":"Nicole wept quietly for a long time before she let go of the horse and gently tidied her hair. She sighed and whispered, “Enough. Garrus, I cried again today and that is wrong. I should live up to my father’s expectations … I need to be brave. I cannot cry!” She gently said, “I know you are unhappy as well. The stable hand told me you are very irritable too. I also know that you do not like being in the stable every day and you also miss father. You also miss the days when he took you out for a ride, do you not?”\r\n<pirate>Find authorized novels in Webnovel，faster updates, better experience，Please click\n<a href=\"https://www.webnovel.com\">www.webnovel.com</a> for visiting.</pirate>"},{"paragraphId":"103ee28988a20fe2a0e74c45434d6450","content":"\"But I really do not know what to do. The family is gradually declining. The Tulips are fading away … but I am powerless! If I were a boy, I could inherit my father's responsibility. However, that playboy is father's only son. The only male in the family. However, he is ignorant and only tarnishes the name of the family. I feel isolated and helpless!\"\r\n"},{"paragraphId":"65372be5ee6fca7900758cea1fcdce89","content":"Nicole sighed and prayed, “May father’s soul in heaven bestow me courage! May the heavens bestow the Tulip Family a ray of hope! May God give me a guide so that I am no longer alone in my fight!”\r\n"},{"paragraphId":"bee46c179d08dd2722d0180abc77fedd","content":"Just as soon as Nicole's delicate voice ended her prayers, there was a ‘plop’ sound as a dark figure fell from the sky and in front of Nicole. The man slowly raised his head and turned his dirty face towards Nicole. What truly scared the girl almost to the point of suffocation was his half-black-half-white Yin Yang face.\r\n"}]
     */
    contents?: {
      /**
       * "fb8837b59bbc125049255bcf04c838bf"
       */
      paragraphId?: string;
      /**
       * "The carriage went all the way into the city. Although it was nighttime, because the Imperial Capital was the Empire's largest and most famous commercial center, the gates of this place had never once been closed, except during the warring era.\r\n"
       */
      content?: string;
    }[];
    isAuth?: number;
    /**
     * 1
     */
    batchUnlockStatus?: number;
    isRichFormat?: number;
    /**
     * "34408653851257530"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    firstChapterIndex?: number;
    originalPrice?: number;
    discountInfo?: string;
    /**
     * []
     */
    groupItems?: unknown[];
    /**
     * [{"id":11046073405330600,"userId":4301078817,"name":"AtlasStudios"},{"id":29720617590786228,"name":"Atlas Studios"}]
     */
    editorItems?: {
      /**
       * 11046073405330600
       */
      id?: number;
      /**
       * 4301078817
       */
      userId?: number;
      /**
       * "AtlasStudios"
       */
      name?: string;
    }[];
    /**
     * [{"id":11046073405330600,"userId":4301078817,"name":"AtlasStudios"}]
     */
    translatorItems?: {
      /**
       * 11046073405330600
       */
      id?: number;
      /**
       * 4301078817
       */
      userId?: number;
      /**
       * "AtlasStudios"
       */
      name?: string;
    }[];
    /**
     * 1321
     */
    reviewTotal?: number;
    /**
     * 1
     */
    orderIndex?: number;
    notes?: {
      /**
       * "AtlasStudios"
       */
      name?: string;
      penName?: null;
      /**
       * "4301078817"
       */
      userId?: string;
      /**
       * "//userimg.webnovel.com/userheadimg/4301078817/1/1.jpg?mt=1539581805000?mt=0"
       */
      avatar?: string;
      /**
       * "translator"
       */
      role?: string;
      /**
       * "fewsdfgeergergre"
       */
      note?: string;
      UUT?: number;
    };
    /**
     * [{"reviewId":13525923005401800,"content":"Oh hey, it's here. Same author as Genius Doctor: Black Belly Miss.\r\n\r\nShares a lot of the same themes, and the same styles, so expect mostly short chapters, but longer arcs, a high amount of face slapping.\r\n\r\nI haven't read enough to see how/why this differs from that novel though.\r\n\r\nThere's around 80-ish chapters already translated out there from a prior translator, shouldn't be too hard to find with a little googling.","userId":2223630238,"createTime":"1 month ago","reviewType":1,"likeNums":39,"isLiked":false,"status":1,"pStatus":0,"commentType":1,"appId":10,"UUT":1550137623000,"userName":"Thormented","avatar":0,"penName":"Thormented","role":0,"userLevel":6,"badgeInfo":{"badgeId":10014,"badgeType":"General","badgeName":"Christmas Carnival","maxGrade":1,"achievedMaxGrade":1,"achievedTime":"2018-12-26","achievedGradeGoal":"Participate in Christmas Carnival and play the Gashapon.","baseUrl":"https://actimg.webnovel.com/badge/10014/1/","updateTime":1544671675000}},{"reviewId":13525457305251800,"content":"YESSS IT FINALLY GOT PICKED UP, guess I have to reread this again cause I forgot everything 😅","userId":4301207214,"createTime":"1 month ago","reviewType":1,"likeNums":27,"isLiked":false,"status":1,"pStatus":0,"commentType":1,"appId":10,"UUT":1549731827000,"userName":"Cr3ssie","avatar":0,"penName":"Cr3ssie","role":0,"userLevel":4,"badgeInfo":{"badgeId":10001,"badgeType":"Achievement","badgeName":"Endeavor","maxGrade":4,"achievedMaxGrade":2,"achievedTime":"2018-10-24","achievedGradeGoal":"Checked in for a total of 90 days","baseUrl":"https://actimg.webnovel.com/badge/10001/2/","updateTime":1517481162000}},{"reviewId":13526957306394100,"content":"She ripped it out? Fck","userId":2560694278,"createTime":"1 month ago","reviewType":1,"likeNums":12,"isLiked":false,"status":1,"pStatus":0,"commentType":1,"appId":10,"UUT":1556526743000,"userName":"zyraluz","avatar":1554952221941,"penName":"zyraluz","role":0,"userLevel":5,"badgeInfo":{"badgeId":10009,"badgeType":"Achievement","badgeName":"YE XIU 5.29","maxGrade":1,"achievedMaxGrade":1,"achievedTime":"2018-05-30","achievedGradeGoal":"Participated in Ye Xiu's 5.29 birthday event","baseUrl":"https://actimg.webnovel.com/badge/10009/1/","updateTime":1524884497000}}]
     */
    chapterReviewItems?: {
      /**
       * 13525923005401800
       */
      reviewId?: number;
      /**
       * "Oh hey, it's here. Same author as Genius Doctor: Black Belly Miss.\r\n\r\nShares a lot of the same themes, and the same styles, so expect mostly short chapters, but longer arcs, a high amount of face slapping.\r\n\r\nI haven't read enough to see how/why this differs from that novel though.\r\n\r\nThere's around 80-ish chapters already translated out there from a prior translator, shouldn't be too hard to find with a little googling."
       */
      content?: string;
      /**
       * 2223630238
       */
      userId?: number;
      /**
       * "1 month ago"
       */
      createTime?: string;
      /**
       * 1
       */
      reviewType?: number;
      /**
       * 39
       */
      likeNums?: number;
      isLiked?: boolean;
      /**
       * 1
       */
      status?: number;
      pStatus?: number;
      /**
       * 1
       */
      commentType?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * 1550137623000
       */
      UUT?: number;
      /**
       * "Thormented"
       */
      userName?: string;
      avatar?: number;
      /**
       * "Thormented"
       */
      penName?: string;
      role?: number;
      /**
       * 6
       */
      userLevel?: number;
      badgeInfo?: {
        /**
         * 10014
         */
        badgeId?: number;
        /**
         * "General"
         */
        badgeType?: string;
        /**
         * "Christmas Carnival"
         */
        badgeName?: string;
        /**
         * 1
         */
        maxGrade?: number;
        /**
         * 1
         */
        achievedMaxGrade?: number;
        /**
         * "2018-12-26"
         */
        achievedTime?: string;
        /**
         * "Participate in Christmas Carnival and play the Gashapon."
         */
        achievedGradeGoal?: string;
        /**
         * "https://actimg.webnovel.com/badge/10014/1/"
         */
        baseUrl?: string;
        /**
         * 1544671675000
         */
        updateTime?: number;
      };
    }[];
    /**
     * [{"id":"@id","content":""},{"id":"@id","content":"@paragraph"}]
     */
    paragraphs?: {
      /**
       * "@id"
       */
      id?: string;
      content?: string;
    }[];
    /**
     * [{"msgType":1,"title":"fwfewf title","content":"The title of this work is the main character’s name. At most got three lines of this text area. Within 64 characters.","target":"this is a target","reward":"this is a reward"}]
     */
    announcementItems?: {
      /**
       * 1
       */
      msgType?: number;
      /**
       * "fwfewf title"
       */
      title?: string;
      /**
       * "The title of this work is the main character’s name. At most got three lines of this text area. Within 64 characters."
       */
      content?: string;
      /**
       * "this is a target"
       */
      target?: string;
      /**
       * "this is a reward"
       */
      reward?: string;
    }[];
    /**
     * 1
     */
    noArchive?: number;
  };
  /**
   * 1
   */
  membershipStatus?: number;
  /**
   * 1
   */
  waitpayStatus?: number;
  /**
   * 1
   */
  test?: number;
}

/**
 * 接口 [获取阅读内容-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/531) 的 **请求配置的类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getContent`
 * @更新时间 `2020-10-19 15:23:34`
 */
type AjaxChapterGetContentRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/chapter/getContent",
    "data",
    string,
    "bookId" | "chapterId" | "withParagraphContent" | "_csrfToken",
    false
  >
>;

/**
 * 接口 [获取阅读内容-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/531) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getContent`
 * @更新时间 `2020-10-19 15:23:34`
 */
const ajaxChapterGetContentRequestConfig: AjaxChapterGetContentRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/chapter/getContent",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: ["bookId", "chapterId", "withParagraphContent", "_csrfToken"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterGetContent",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取阅读内容-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/531) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getContent`
 * @更新时间 `2020-10-19 15:23:34`
 */
export const ajaxChapterGetContent = /*#__PURE__*/ (
  requestData: AjaxChapterGetContentRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxChapterGetContentResponse>(
    prepare(ajaxChapterGetContentRequestConfig, requestData),
    ...args
  );
};

ajaxChapterGetContent.requestConfig = ajaxChapterGetContentRequestConfig;

/**
 * 接口 [获取最近更新列表↗](https://yapi.yuewen.com/project/28/interface/api/3161) 的 **请求类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getLatestUpdates`
 * @更新时间 `2019-06-10 14:23:15`
 */
export interface AjaxChapterGetLatestUpdatesRequest {}

/**
 * 接口 [获取最近更新列表↗](https://yapi.yuewen.com/project/28/interface/api/3161) 的 **返回类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getLatestUpdates`
 * @更新时间 `2019-06-10 14:23:15`
 */
export interface AjaxChapterGetLatestUpdatesResponse {
  /**
   * [{"bookId":"@string('number', 5)","bookName":"@sentence","newChapterTime":["6 hours ago","4 weeks ago","3 weeks ago"]}]
   */
  items?: {
    /**
     * "@string('number', 5)"
     */
    bookId?: string;
    /**
     * "@sentence"
     */
    bookName?: string;
    /**
     * ["6 hours ago","4 weeks ago","3 weeks ago"]
     */
    newChapterTime?: string[];
  }[];
}

/**
 * 接口 [获取最近更新列表↗](https://yapi.yuewen.com/project/28/interface/api/3161) 的 **请求配置的类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getLatestUpdates`
 * @更新时间 `2019-06-10 14:23:15`
 */
type AjaxChapterGetLatestUpdatesRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/chapter/getLatestUpdates",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取最近更新列表↗](https://yapi.yuewen.com/project/28/interface/api/3161) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getLatestUpdates`
 * @更新时间 `2019-06-10 14:23:15`
 */
const ajaxChapterGetLatestUpdatesRequestConfig: AjaxChapterGetLatestUpdatesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/chapter/getLatestUpdates",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterGetLatestUpdates",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取最近更新列表↗](https://yapi.yuewen.com/project/28/interface/api/3161) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getLatestUpdates`
 * @更新时间 `2019-06-10 14:23:15`
 */
export const ajaxChapterGetLatestUpdates = /*#__PURE__*/ (
  requestData?: AjaxChapterGetLatestUpdatesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxChapterGetLatestUpdatesResponse>(
    prepare(ajaxChapterGetLatestUpdatesRequestConfig, requestData),
    ...args
  );
};

ajaxChapterGetLatestUpdates.requestConfig =
  ajaxChapterGetLatestUpdatesRequestConfig;

/**
 * 接口 [解锁收费章节↗](https://yapi.yuewen.com/project/28/interface/api/9302) 的 **请求类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/SpiritStone/UseSSUnlockChapterAjax`
 * @更新时间 `2018-07-03 11:17:13`
 */
export interface AjaxSpiritStoneUseSsUnlockChapterAjaxRequest {}

/**
 * 接口 [解锁收费章节↗](https://yapi.yuewen.com/project/28/interface/api/9302) 的 **返回类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/SpiritStone/UseSSUnlockChapterAjax`
 * @更新时间 `2018-07-03 11:17:13`
 */
export interface AjaxSpiritStoneUseSsUnlockChapterAjaxResponse {
  /**
   * "100 余额不足的时候返回用户余额"
   */
  SS?: string;
  /**
   * "如果成功，返回章节全量内容如果成功，返回章节全量内容如果成功，返回章节全量内容如果成功，返回章节全量内容如果成功，返回章节全量内容如果成功，返回章节全量内容"
   */
  content?: string;
  /**
   * "1"
   */
  isRichFormat?: string;
  /**
   * "10"
   */
  costSS?: string;
}

/**
 * 接口 [解锁收费章节↗](https://yapi.yuewen.com/project/28/interface/api/9302) 的 **请求配置的类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/SpiritStone/UseSSUnlockChapterAjax`
 * @更新时间 `2018-07-03 11:17:13`
 */
type AjaxSpiritStoneUseSsUnlockChapterAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/SpiritStone/UseSSUnlockChapterAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [解锁收费章节↗](https://yapi.yuewen.com/project/28/interface/api/9302) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/SpiritStone/UseSSUnlockChapterAjax`
 * @更新时间 `2018-07-03 11:17:13`
 */
const ajaxSpiritStoneUseSsUnlockChapterAjaxRequestConfig: AjaxSpiritStoneUseSsUnlockChapterAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/SpiritStone/UseSSUnlockChapterAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneUseSsUnlockChapterAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [解锁收费章节↗](https://yapi.yuewen.com/project/28/interface/api/9302) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/SpiritStone/UseSSUnlockChapterAjax`
 * @更新时间 `2018-07-03 11:17:13`
 */
export const ajaxSpiritStoneUseSsUnlockChapterAjax = /*#__PURE__*/ (
  requestData?: AjaxSpiritStoneUseSsUnlockChapterAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSpiritStoneUseSsUnlockChapterAjaxResponse>(
    prepare(ajaxSpiritStoneUseSsUnlockChapterAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxSpiritStoneUseSsUnlockChapterAjax.requestConfig =
  ajaxSpiritStoneUseSsUnlockChapterAjaxRequestConfig;

/**
 * 接口 [获取弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19923) 的 **请求类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/comic/getbullet`
 * @更新时间 `2018-11-07 17:21:34`
 */
export interface AjaxComicGetbulletRequest {
  comicId: string;
  chapterId: string;
  /**
   * 漫画话ID
   */
  pageId: string;
  /**
   * 这期只有1
   */
  orderType: string;
}

/**
 * 接口 [获取弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19923) 的 **返回类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/comic/getbullet`
 * @更新时间 `2018-11-07 17:21:34`
 */
export interface AjaxComicGetbulletResponse {
  /**
   * [{"bulletId":2,"userId":5,"content":"@sentence"}]
   */
  items?: {
    /**
     * 2
     */
    bulletId?: number;
    /**
     * 5
     */
    userId?: number;
    /**
     * "@sentence"
     */
    content?: string;
  }[];
}

/**
 * 接口 [获取弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19923) 的 **请求配置的类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/comic/getbullet`
 * @更新时间 `2018-11-07 17:21:34`
 */
type AjaxComicGetbulletRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/comic/getbullet",
    "data",
    string,
    "comicId" | "chapterId" | "pageId" | "orderType",
    false
  >
>;

/**
 * 接口 [获取弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19923) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/comic/getbullet`
 * @更新时间 `2018-11-07 17:21:34`
 */
const ajaxComicGetbulletRequestConfig: AjaxComicGetbulletRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/comic/getbullet",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: ["comicId", "chapterId", "pageId", "orderType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicGetbullet",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19923) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/comic/getbullet`
 * @更新时间 `2018-11-07 17:21:34`
 */
export const ajaxComicGetbullet = /*#__PURE__*/ (
  requestData: AjaxComicGetbulletRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxComicGetbulletResponse>(
    prepare(ajaxComicGetbulletRequestConfig, requestData),
    ...args
  );
};

ajaxComicGetbullet.requestConfig = ajaxComicGetbulletRequestConfig;

/**
 * 接口 [添加弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19925) 的 **请求类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/comic/addbullet`
 * @更新时间 `2018-11-07 16:37:03`
 */
export interface AjaxComicAddbulletRequest {
  bookId: string;
  chapterId: string;
  userId: string;
  content: string;
  /**
   * 漫画话Id
   */
  pageId: string;
}

/**
 * 接口 [添加弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19925) 的 **返回类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/comic/addbullet`
 * @更新时间 `2018-11-07 16:37:03`
 */
export interface AjaxComicAddbulletResponse {
  code?: number;
  /**
   * "Cool, you have fired bulletTag"
   */
  msg?: string;
}

/**
 * 接口 [添加弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19925) 的 **请求配置的类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/comic/addbullet`
 * @更新时间 `2018-11-07 16:37:03`
 */
type AjaxComicAddbulletRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/comic/addbullet",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [添加弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19925) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/comic/addbullet`
 * @更新时间 `2018-11-07 16:37:03`
 */
const ajaxComicAddbulletRequestConfig: AjaxComicAddbulletRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/comic/addbullet",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicAddbullet",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [添加弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19925) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/comic/addbullet`
 * @更新时间 `2018-11-07 16:37:03`
 */
export const ajaxComicAddbullet = /*#__PURE__*/ (
  requestData: AjaxComicAddbulletRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxComicAddbulletResponse>(
    prepare(ajaxComicAddbulletRequestConfig, requestData),
    ...args
  );
};

ajaxComicAddbullet.requestConfig = ajaxComicAddbulletRequestConfig;

/**
 * 接口 [rss↗](https://yapi.yuewen.com/project/28/interface/api/29137) 的 **请求类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/book/getRssMidPage`
 * @更新时间 `2019-02-13 15:16:59`
 */
export interface AjaxBookGetRssMidPageRequest {
  /**
   * 6831119801007205
   */
  bookId: string;
  /**
   * 30539572207211077
   */
  chapterId: string;
}

/**
 * 接口 [rss↗](https://yapi.yuewen.com/project/28/interface/api/29137) 的 **返回类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/book/getRssMidPage`
 * @更新时间 `2019-02-13 15:16:59`
 */
export interface AjaxBookGetRssMidPageResponse {
  bookInfo?: {
    /**
     * "6831119801007205"
     */
    bookId?: string;
    /**
     * "Throne of Magical Arcana"
     */
    bookName?: string;
    /**
     * "TMA"
     */
    bookSubName?: string;
    /**
     * "Cuttlefish That Loves Diving"
     */
    authorName?: string;
    /**
     * 70004
     */
    categoryId?: number;
    /**
     * "4.2"
     */
    totalScore?: string;
    /**
     * 21
     */
    voters?: number;
    /**
     * ["xxx","123","1","123"]
     */
    adIds?: string[];
    /**
     * "1547463902181"
     */
    coverUpdateTime?: string;
  };
  chapterInfo?: {
    /**
     * "30539572207211077"
     */
    chapterId?: string;
    /**
     * "Chapter 60 put on a formal lucien"
     */
    chapterName?: string;
    /**
     * 60
     */
    chapterIndex?: number;
    /**
     * []
     */
    groupItems?: unknown[];
    /**
     * [{"id":7563802601023005,"userId":44864906922,"name":"editor-test-gy"},{"id":7635959101023305,"userId":3514016596,"name":"xujin1111111"},{"id":8420789701027705,"userId":115750316,"name":"zhibonan"}]
     */
    editorItems?: {
      /**
       * 7563802601023005
       */
      id?: number;
      /**
       * 44864906922
       */
      userId?: number;
      /**
       * "editor-test-gy"
       */
      name?: string;
    }[];
    /**
     * [{"id":6830832501003200,"userId":41830698,"name":"clarkzhang12"},{"id":6830832501003300,"userId":1427626119,"name":"Jillian"},{"id":6995297601012005,"userId":121,"name":"xujin_Translator"},{"id":7635959101023305,"userId":3514016596,"name":"xujin1111111"},{"id":8420789701027705,"userId":115750316,"name":"zhibonan"}]
     */
    translatorItems?: {
      /**
       * 6830832501003200
       */
      id?: number;
      /**
       * 41830698
       */
      userId?: number;
      /**
       * "clarkzhang12"
       */
      name?: string;
    }[];
    /**
     * "6 months ago"
     */
    create?: string;
    /**
     * "Road Sean's original plan, is to use the piano version inspired victor's destiny symphony, even let him directly after filling the melody, perfecting details adapted clinch a deal the loud music, so his trigger surprise is only confined to victor, lott, a few people, such as lane is not most people know, let oneself become a freak of their eyes, so as to attract the attention of others, after all, study music just less than two months to write music, Sean has seen the road of journal of Chinese music history is unique.\r\nAt such times, however, lucien had no way to excuse himself. He did not hesitate. \"all right, Mr. Victor.\"\r\nAs victor has said before, talent does not need a reason, and in this case, others at most suspect that they are plagiarizing, do not think about their magical identity or associate themselves with demons, demons, etc., because it seems to be the opposite of two things.\r\nIn music library of religious texts, described music as the god of truth give precious treasure of mankind, is in a difficult time to encourage people to weapons, and only heard of the wizard, the devil \"give\" people power, beautiful voice, adept playing skills, never directly to the person wr"
     */
    content?: string;
  };
  user?: {
    guid?: string;
    avatar?: string;
    userName?: string;
    nickName?: string;
    penName?: null;
    role?: null;
    /**
     * -1
     */
    status?: number;
    SS?: null;
    isCheckin?: null;
    userLevel?: null;
    availablePower?: null;
    totalPower?: null;
    availableEnergy?: null;
    totalEnergy?: null;
    emailStatus?: null;
    mt?: null;
    UUT?: null;
  };
}

/**
 * 接口 [rss↗](https://yapi.yuewen.com/project/28/interface/api/29137) 的 **请求配置的类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/book/getRssMidPage`
 * @更新时间 `2019-02-13 15:16:59`
 */
type AjaxBookGetRssMidPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/book/getRssMidPage",
    "data",
    string,
    "bookId" | "chapterId",
    false
  >
>;

/**
 * 接口 [rss↗](https://yapi.yuewen.com/project/28/interface/api/29137) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/book/getRssMidPage`
 * @更新时间 `2019-02-13 15:16:59`
 */
const ajaxBookGetRssMidPageRequestConfig: AjaxBookGetRssMidPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/book/getRssMidPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: ["bookId", "chapterId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookGetRssMidPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [rss↗](https://yapi.yuewen.com/project/28/interface/api/29137) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/book/getRssMidPage`
 * @更新时间 `2019-02-13 15:16:59`
 */
export const ajaxBookGetRssMidPage = /*#__PURE__*/ (
  requestData: AjaxBookGetRssMidPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxBookGetRssMidPageResponse>(
    prepare(ajaxBookGetRssMidPageRequestConfig, requestData),
    ...args
  );
};

ajaxBookGetRssMidPage.requestConfig = ajaxBookGetRssMidPageRequestConfig;

/**
 * 接口 [获取阅读内容- AMP↗](https://yapi.yuewen.com/project/28/interface/api/41694) 的 **请求类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getAmpContent`
 * @更新时间 `2020-07-31 13:23:20`
 */
export interface AjaxChapterGetAmpContentRequest {
  bookId: string;
  chapterId: string;
}

/**
 * 接口 [获取阅读内容- AMP↗](https://yapi.yuewen.com/project/28/interface/api/41694) 的 **返回类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getAmpContent`
 * @更新时间 `2020-07-31 13:23:20`
 */
export interface AjaxChapterGetAmpContentResponse {
  bookInfo?: {
    /**
     * "7366916601012405"
     */
    bookId?: string;
    /**
     * "The King's Avatar"
     */
    bookName?: string;
    /**
     * 3626681903122401
     */
    authorId?: number;
    /**
     * "Butterfly Blue"
     */
    authorName?: string;
    /**
     * 663
     */
    totalChapterNum?: number;
    /**
     * "30"
     */
    actionStatus?: string;
    /**
     * 28
     */
    reviewTotal?: number;
    /**
     * 15
     */
    checklevel?: number;
    /**
     * 1
     */
    bookType?: number;
    totalPreChapterNum?: number;
    /**
     * 70001
     */
    categoryId?: number;
    /**
     * 1577568672000
     */
    publishTime?: number;
    /**
     * 1577568672000
     */
    updateTime?: number;
    /**
     * ["xxx","123","123"]
     */
    adIds?: string[];
    /**
     * ["/274367222/web-read-video","/274367222/web-read-video2","/274367222/web-read-video3","/274367222/web-read-video4","/274367222/web-read-video5"]
     */
    videoAdIds?: string[];
    patreonLink?: string;
    /**
     * 1
     */
    isShowAds?: number;
    /**
     * 43
     */
    giftNum?: number;
  };
  chapterInfo?: {
    /**
     * "30539125799047747"
     */
    chapterId?: string;
    /**
     * "Chapter 663 cannot be spared"
     */
    chapterName?: string;
    /**
     * 663
     */
    chapterIndex?: number;
    /**
     * 1577568672000
     */
    publishTime?: number;
    /**
     * 1577568672000
     */
    updateTime?: number;
    /**
     * []
     */
    groupItems?: unknown[];
    /**
     * [{"id":8161817001026805,"name":"RENREN","userId":3823689966}]
     */
    translatorItems?: {
      /**
       * 8161817001026805
       */
      id?: number;
      /**
       * "RENREN"
       */
      name?: string;
      /**
       * 3823689966
       */
      userId?: number;
    }[];
    /**
     * [{"id":8161817001026805,"name":"RENREN","userId":3823689966}]
     */
    editorItems?: {
      /**
       * 8161817001026805
       */
      id?: number;
      /**
       * "RENREN"
       */
      name?: string;
      /**
       * 3823689966
       */
      userId?: number;
    }[];
    /**
     * "23000234665765226"
     */
    preChapterId?: string;
    /**
     * "-1"
     */
    nextChapterId?: string;
    isVip?: number;
    source?: string;
    /**
     * 1
     */
    isRichFormat?: number;
    /**
     * "<p>Destroy the person indefatigable front left and right side to be blocked a water to be impassable, beelulan is eager to be able to steel wire to hang several people to connect the upper half of the air is prevented.<br>This guy is so hard to catch, no wonder the notoriety, but the collection is still very successful.<br>Last time we fought side by side, we didn't know much about the strength of destroying people.<br>If my own group of five is qualified as a professional player, this wrecker will never fail.<br>Slaying Leland heart has begun a point to attract the meaning, is pondering how to cut, for a while did not come up to speak.<br>But the crowd of players around the destruction of the tireless righteousness of the world roared: \"run, why don't you run?<br>Try another one!<br>The centurion, he could not catch even one man, and in the end he lost two stops at the exit.<br>And these two road, that outfit tattered can let a person tear down.<br>The player that righteousness cuts whole world is right now true sense of shame and indignation is difficult.<br>The ruined man in the midst was tireless and silent.<br>In fact, as soon as he killed Leland, he chose three things out of the 70 level wild map BOSS, and it would not be a loss if he died.<br>Unless his face is too dark, he can pop the thing back.<br>But the odds are so small that if you have the same stuff in your pocket, and you drop one or two of your gear, you're going to make a lot of money.<br>So it's not easy to blow this thing away and try to blow it back.<br>Rarely can a fight be settled.<br>But does not explode the original, explodes the equivalent return also does not calculate the loss!<br>But that's not the case at the moment. There's no such thing as three level 70 wildcard bosses dropping things that destroy people.<br>This seemed to be clear to the indefatigable man, and he took his time knowing that he was going to die.<br>Die, die!<br>It was a profitable trip anyway.<br>The many players who just cut the world off just curse, no one to start with, obviously also all understand this, this guy, just kill really don't earn back, may have to have some other means.<br>As a result, the chairman did not speak for a while, but he stood up.<br>\"Can't you escape?<br>Give it away.\"<br>\"Said Hugh.<br>Destroy a person unwearied to see not to see him one eye, however justice behead the world many players have turned the Angle of view to come over, in succession feel great god this words be extremely naive, the person now dead once also earn, with what hand over thing?<br>\"What a good fellow he is!<br>The opening line is super no new, and the following is also very routine: \"if you don't mind, make a friend, take the things, do not need to return, calculate me to send.\"<br>The word is the earth burst the word, but the bold and heroic of beheaded loulan still showed.<br>Three level 70 field map BOSS dropped things, casual on the gift, the warrior's domineering show undoubtedly.<br>The player of righteousness cuts the world although still have a little bit to be unhappy in the mind, but destroy a person indefatigably fierce is the fact.<br>Beheaded lalan to its good intention, you can also understand.<br>Don't say can come together to kill wild graph BOSS's player is not an outsider, in whole game who does not know to chop off lalan that is to enter the professional circle, see a master to solicit, must of!<br>The result destroy a person indefatigably still reason also ignore, cut a Lou LAN so hang that.<br>Beheaded Leland a little embarrassed, but did not retreat, directly spread a big shop: \"brother such skill, just used to pick up waste is too regrettable?<br>I am now organizing a team, it is time to need people, I do not know brother is interested?<br>If you are willing to come, the terms are good.<br>Envy and hate!<br>This is justice behead world player people at this time of mood, can join professional team, return a condition to say, such treatment, which glory player can not envy?<br>The result is out of the blue in front of him, hearing such an eye - warming rhetoric, or indifference, even a perspective refused to cut laland to turn.<br>\"Brother...<br>\"Brother what brother!<br>Beheaded Lou LAN just want to open again, was leaf xiu directly interrupted, follow to see if you smile in the hand a thousand machine umbrella shake to fall into a war spear, toward destroying a person indefatigable feet naked on a knock.<br>Destroy a person indefatigably do not blink also not avoid, after be this knock, the role a lean is a stagger, the prince mo smile hand war spear again slightly sweep, immediately immediately threw down on the ground, again also have no meaning at all get up again.<br>\"People are off line.\"<br>Ye xiu said to the slalom.<br>After all, there is a professional level of slaying, just before your smile on the two after the destruction of people's tireless response, also see that the role is certainly no one to operate.<br>Destroy the person indefatigable at this time is certainly the combat state, is unable to descend the line, can force to close the game.<br>That way the character stays in the scene like a stake.<br>But there is also the possibility that the game is thrown here, but the person is not operating.<br>\"Perhaps there are still people?<br>The possibility occurred to him.<br>\"Will you talk?<br>Ye Xiu asked.<br>Slalom sorry.<br>Whether the person is off line or not, the attitude is in fact very obvious, just ignore you.<br>So many people to watch, again let slalom to a response to a wooden stake, he face also hang!<br>This should have the confidence to have the speech to feel to be able to persuade the other side to pour still can try, but the problem is to cut a land before two paragraph already be again basic and simple, this can be more even so the word did not have.<br>After thinking about it, chopped off the land to feel that their ability to do or stronger, immediately is a sword split out: \"hung.\"<br>As soon as the crowd joined in the attack, it was a corpse in an instant.<br>The body fell to the ground, and for a long time there was no resurrection, which seemed like it was off the line.<br>Glad to destroy you!<br>Fortunately just did not continue to think the word to say, otherwise said that the person forced to stay time, to brush off the line, that would be a disgrace!<br>But now a look at the ground, chopped off the blue mood is not good to go.<br>None of the three 70 level wild BOSS stuff that the wrecking crew had left.<br>There are two ninja pieces missing, but this kind of online game level equipment is not as luxurious as slalom.<br>At a glance, I didn't even bother to pick it.<br>At last he was conscious of the fact that he was in a bad mood, and not only did he say it out loud: \"it was a kind of exclamation that killed this guy!<br>This guy blew away three things, all blame me too careless, don't worry, this reward we won't have anything to deduct because of this.\"<br>The player that yi cuts a world to hear such announcement mood can be improved greatly.<br>They all knew that this level 70 field map BOSS made something must be put into the combat team, so they are not able to directly benefit from the BOSS's disclosure, can only be another benefit from the guild.<br>This is true of any club guild, level 70 wild map BOSS, and the equipment will sometimes fill the guild warehouse occasionally, but the material is definitely not fanciful.<br>The BOSS revealed to the many players who want to also attempt not to attempt, for these things are not in the hands of beheading Leland actually did not pay so much attention.<br>After all, yi cut the world out of the money to spend, and his team was just announced to form soon.<br>The so-called supporters who gathered by hype have far less affection for the guild.<br>There is no match for the club council at this point.<br>Club guilds, if they are really a force, are also emotionally cohesive and centripetal.<br>It's the kind of thing that happens when you don't get the materials that affect the development of the team, and they're really worried.<br>Justice begets the world, after beheading laland such a statement, most of the people are already happy, of course this happy is also not good performance, the scene is still stuffy.<br>But of course I knew what was going on in my heart, otherwise I wouldn't have to say more.<br>If you want to win fans, you can't do it overnight or just do it.<br>Appease the guild people, the god of work on the side of slalom also have to communicate is not it?<br>Although the big god said before, things can not find back to calculate his, but chopped off the land how can really calculate like this?<br>It is absolutely his or their duty to destroy the world.<br>Although he can also say a lot of reasons, but in any case, and god is a dime has nothing to do with.<br>Man led the team to block the guild. It was done beautifully.<br>Two clubs have been defeated by justice, which is the usual thing they can do?<br>Beheaded Leland news, you smile, the BOSS after the dark night streamer of the harvest list, and then said: \"that guy blew away three should count me, but I really did not come to see those three are what.<br>Let's split it in half, and then you can pick three things from my side.<br>\"Why, you think that's the cheap guy?\"<br>Ye Xiu said.<br>\"That?\"<br>Slalom wondered.<br>He was certainly not content to let it go.<br>To tell you the truth, the final result of this, slaying the land is also full of anger!<br>But what else could he do?<br>Now people have been dead, resurrection and rebirth in which the main city do not know, the hunt for the killing is very inconvenient.<br>Besides, you can't take anything back from the hunt, and you'll soon be able to transfer the explosive material to the warehouse.<br>The stuff in the warehouse can never burst.<br>\"You provide information, I will be responsible for the murder!\"<br>Yip xiu patted her chest.<br>\"Look, big god!<br>There are still a number of wild map bosses this week, should we focus on the next BOSS?<br>Can grab a BOSS, no better than to blow up that kid?<br>It's not worth wasting time and manpower on his behalf!\"<br>\"Said the slayer.<br>\"BOSS of course to rob, but this guy also can't let go.<br>Just keep an eye on his whereabouts. You pass it on to the guild.<br>Ye Xiu said.<br>\"Can you go to clean up this kid, we return how rob a BOSS?\"<br>\"How to kill a chicken with a knife?\"<br>Ye Xiu said.<br>Beheaded Leland is very to hesitate a time: \"you mean that boy is chicken, still rob BOSS this matter is chicken?\"<br>It was a bit of a blur, but he was sure it was a bull's knife, but which was the chicken?<br>================================ ====================== 2 months is finally over.<br>The last few chapters are not very exciting. March is good!<br>To be continued.<br>If you like this work, you are welcome to come to qidian.com to vote for the recommendation and the monthly ticket. Your support is my biggest motivation.</p>"
     */
    content?: string;
    /**
     * 1
     */
    isAuth?: number;
    /**
     * "19775416453662908"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    firstChapterIndex?: number;
    reviewTotal?: number;
    SSPrice?: number;
    /**
     * 663
     */
    orderIndex?: number;
    notes?: null;
    /**
     * 5
     */
    transRating?: number;
    /**
     * []
     */
    chapterReviewItems?: unknown[];
  };
}

/**
 * 接口 [获取阅读内容- AMP↗](https://yapi.yuewen.com/project/28/interface/api/41694) 的 **请求配置的类型**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getAmpContent`
 * @更新时间 `2020-07-31 13:23:20`
 */
type AjaxChapterGetAmpContentRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/chapter/getAmpContent",
    "data",
    string,
    "bookId" | "chapterId",
    false
  >
>;

/**
 * 接口 [获取阅读内容- AMP↗](https://yapi.yuewen.com/project/28/interface/api/41694) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getAmpContent`
 * @更新时间 `2020-07-31 13:23:20`
 */
const ajaxChapterGetAmpContentRequestConfig: AjaxChapterGetAmpContentRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/chapter/getAmpContent",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: ["bookId", "chapterId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterGetAmpContent",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取阅读内容- AMP↗](https://yapi.yuewen.com/project/28/interface/api/41694) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getAmpContent`
 * @更新时间 `2020-07-31 13:23:20`
 */
export const ajaxChapterGetAmpContent = /*#__PURE__*/ (
  requestData: AjaxChapterGetAmpContentRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxChapterGetAmpContentResponse>(
    prepare(ajaxChapterGetAmpContentRequestConfig, requestData),
    ...args
  );
};

ajaxChapterGetAmpContent.requestConfig = ajaxChapterGetAmpContentRequestConfig;

const mockUrl_0_1_0_25 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_25 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_25 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_25 = "data" as any;

/**
 * 接口 [详情页直出↗](https://yapi.yuewen.com/project/28/interface/api/491) 的 **请求类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /page/book/GetBookDetailPage`
 * @更新时间 `2020-07-02 11:38:15`
 */
export interface PageBookGetBookDetailPageRequest {
  bookId: string;
}

/**
 * 接口 [详情页直出↗](https://yapi.yuewen.com/project/28/interface/api/491) 的 **返回类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /page/book/GetBookDetailPage`
 * @更新时间 `2020-07-02 11:38:15`
 */
export interface PageBookGetBookDetailPageResponse {
  bookInfo?: {
    /**
     * "6831839002000405"
     */
    bookId?: string;
    /**
     * "Once Upon A Time, There Was A Spirit Sword Mountain"
     */
    bookName?: string;
    /**
     * "His Majesty the King"
     */
    authorName?: string;
    /**
     * "1      //推荐票排名"
     */
    powerRank?: string;
    /**
     * 1
     */
    bookType?: number;
    /**
     * "@string"
     */
    ageGroup?: string;
    /**
     * "@sentence"
     */
    advText?: string;
    /**
     * "@url"
     */
    adActionUrl?: string;
    /**
     * 15
     */
    checklevel?: number;
    /**
     * "24M"
     */
    pvNum?: string;
    /**
     * 1577568672000
     */
    publishTime?: number;
    /**
     * 1577568672000
     */
    updateTime?: number;
    /**
     * [{"id":"123 //翻译组id","name":"gg //翻译组名称"}]
     */
    groupItems?: {
      /**
       * "123 //翻译组id"
       */
      id?: string;
      /**
       * "gg //翻译组名称"
       */
      name?: string;
    }[];
    /**
     * [{"id":"18339947115233285","name":"Subudai11","userId":"123"}]
     */
    translatorItems?: {
      /**
       * "18339947115233285"
       */
      id?: string;
      /**
       * "Subudai11"
       */
      name?: string;
      /**
       * "123"
       */
      userId?: string;
    }[];
    /**
     * [{"id":"18339947115233286","name":"Chrissy","userId":"123"}]
     */
    editorItems?: {
      /**
       * "18339947115233286"
       */
      id?: string;
      /**
       * "Chrissy"
       */
      name?: string;
      /**
       * "123"
       */
      userId?: string;
    }[];
    /**
     * [{"id":"18339947115233286","name":"Chrissy","userId":"123"}]
     */
    authorItems?: {
      /**
       * "18339947115233286"
       */
      id?: string;
      /**
       * "Chrissy"
       */
      name?: string;
      /**
       * "123"
       */
      userId?: string;
    }[];
    /**
     * "Xianxia"
     */
    categoryName?: string;
    /**
     * 2312
     */
    categoryId?: number;
    /**
     * 5
     */
    updateFrequency?: number;
    /**
     * "@Number"
     */
    promiseUpdateFrequency?: string;
    /**
     * "chs/week"
     */
    promiseFrequencyUnit?: string;
    /**
     * "chs / week"
     */
    frequencyUnit?: string;
    /**
     * 7
     */
    chapterNum?: number;
    /**
     * "50 //-1 翻译中,30 暂停翻译,40 To be Continued,50 Completed"
     */
    actionStatus?: string;
    /**
     * "5.0"
     */
    totalScore?: string;
    voters?: number;
    /**
     * "In the year 4223, the Spirit Sword Sect was established in the Nine Regions. For thousands of years, it has always been committed to producing first class talented immortal cultivators.\r\n\r\nNowadays, it is among the five great sects within the Union of Ten Thousand Immortals. The sect leader, Daoist Master Feng Yin, is one of the seven great elders of the Union Of Ten Thousand Immortals; his cultivation shocked the world. \r\n\r\nSpirit Sword Sect adhered to subjects of peace and development. The sect’s core values are seeking the truth, seeking the good, and seeking the loyalty. To further expand the power of the sect and to add fresh blood, all elites and geniuses are invited to attend the Immortal Gathering.\r\n\r\n------\r\nRelease Rate: 5 Chapters/Week; will be released on Mon, Wed, Fri and Weekend; "
     */
    description?: string;
    /**
     * 7
     */
    totalChapterNum?: number;
    /**
     * "19366109291645600 //解释详见 LibraryPage 接口"
     */
    firstChapterId?: string;
    /**
     * "19366109291645600 //解释详见 LibraryPage 接口"
     */
    readToChapterId?: string;
    /**
     * "5 //解释详见 LibraryPage 接口"
     */
    readToChapterIndex?: string;
    /**
     * [{"text":"一念永恒","url":"wwww.qidian.com/book/123"}]
     */
    language?: {
      /**
       * "一念永恒"
       */
      text?: string;
      /**
       * "wwww.qidian.com/book/123"
       */
      url?: string;
    }[];
    /**
     * "0 不在书架 1 在书架"
     */
    inLibrary?: string;
    /**
     * [{"tagId":"30001","tagName":"Game"}]
     */
    tagInfo?: {
      /**
       * "30001"
       */
      tagId?: string;
      /**
       * "Game"
       */
      tagName?: string;
    }[];
    /**
     * ["123","456"]
     */
    adIds?: string[];
    /**
     * "baidu.com"
     */
    patreonLink?: string;
    /**
     * [{"jumpLink":"baidu.com","description":"I like this animation1"},{"jumpLink":"https://baidu.com","description":"I like this animation2"}]
     */
    animationItems?: {
      /**
       * "baidu.com"
       */
      jumpLink?: string;
      /**
       * "I like this animation1"
       */
      description?: string;
    }[];
    /**
     * [{"avatar":"","name":"","note":"blabla","role":"author","userId":"ID"},{"avatar":"","name":"","note":"blabla","role":"editor","userId":"ID"},{"avatar":"","name":"","note":"blabla","role":"editor","userId":"ID"},{"avatar":"","name":"","note":"blabla","role":"translator","userId":"ID"}]
     */
    notes?: {
      avatar?: string;
      name?: string;
      /**
       * "blabla"
       */
      note?: string;
      /**
       * "author"
       */
      role?: string;
      /**
       * "ID"
       */
      userId?: string;
    }[];
    /**
     * "www.baidu.com //静读天下用户访问时有此字段，提供epub下载链接"
     */
    epubLink?: string;
    /**
     * "2 //1 normal,2 vote"
     */
    type?: string;
    /**
     * "123 //点赞数，type为2时才有这个字段"
     */
    energyNum?: string;
    /**
     * "333333 //书封变更时间"
     */
    coverUpdateTime?: string;
    /**
     * 2279
     */
    giftNum?: number;
    /**
     * [{"userId":0,"appId":0},{"userId":4300000218,"appId":10,"UUT":1556076188000},{"userId":1520658766,"appId":10,"UUT":1552648459000}]
     */
    topFanItems?: {
      userId?: number;
      appId?: number;
    }[];
  };
  user?: {
    guid?: string;
    /**
     * "昵称"
     */
    nickName?: string;
    /**
     * "真实名称"
     */
    userName?: string;
    /**
     * "笔名"
     */
    penName?: string;
    /**
     * "角色"
     */
    role?: string;
    /**
     * "0-登录 -1-未登录"
     */
    status?: string;
    /**
     * "头像"
     */
    avatar?: string;
    /**
     * "0-当天未签到 1-当天已签到"
     */
    isCheckin?: string;
    /**
     * "1 //用户等级"
     */
    userLevel?: string;
    /**
     * 3
     */
    totalEnergy?: number;
    /**
     * 2
     */
    availableEnergy?: number;
    /**
     * 3
     */
    totalPower?: number;
    /**
     * 2
     */
    availablePower?: number;
  };
  /**
   * "1//当前读到的章节id"
   */
  curReadChapter?: string;
}

/**
 * 接口 [详情页直出↗](https://yapi.yuewen.com/project/28/interface/api/491) 的 **请求配置的类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /page/book/GetBookDetailPage`
 * @更新时间 `2020-07-02 11:38:15`
 */
type PageBookGetBookDetailPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/page/book/GetBookDetailPage",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [详情页直出↗](https://yapi.yuewen.com/project/28/interface/api/491) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /page/book/GetBookDetailPage`
 * @更新时间 `2020-07-02 11:38:15`
 */
const pageBookGetBookDetailPageRequestConfig: PageBookGetBookDetailPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/page/book/GetBookDetailPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageBookGetBookDetailPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [详情页直出↗](https://yapi.yuewen.com/project/28/interface/api/491) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /page/book/GetBookDetailPage`
 * @更新时间 `2020-07-02 11:38:15`
 */
export const pageBookGetBookDetailPage = /*#__PURE__*/ (
  requestData: PageBookGetBookDetailPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PageBookGetBookDetailPageResponse>(
    prepare(pageBookGetBookDetailPageRequestConfig, requestData),
    ...args
  );
};

pageBookGetBookDetailPage.requestConfig =
  pageBookGetBookDetailPageRequestConfig;

/**
 * 接口 [详情页页面数据（ajax）↗](https://yapi.yuewen.com/project/28/interface/api/4305) 的 **请求类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetBookDetailPage`
 * @更新时间 `2020-08-14 11:07:09`
 */
export interface AjaxBookGetBookDetailPageRequest {
  bookId: string;
}

/**
 * 接口 [详情页页面数据（ajax）↗](https://yapi.yuewen.com/project/28/interface/api/4305) 的 **返回类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetBookDetailPage`
 * @更新时间 `2020-08-14 11:07:09`
 */
export interface AjaxBookGetBookDetailPageResponse {
  bookInfo?: {
    /**
     * "${query.bookId}"
     */
    bookId?: string;
    /**
     * "Tales of Demons and God"
     */
    bookName?: string;
    /**
     * 123
     */
    userId?: number;
    /**
     * "Mad Snail"
     */
    authorName?: string;
    /**
     * 1
     */
    bookType?: number;
    /**
     * "Unselected"
     */
    ageGroup?: string;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * "Magical Realism"
     */
    categoryName?: string;
    /**
     * 70001
     */
    categoryId?: number;
    updateFrequency?: number;
    /**
     * "chs / day"
     */
    frequencyUnit?: string;
    /**
     * "chs / day"
     */
    promiseFrequencyUnit?: string;
    /**
     * 28
     */
    promiseUpdateFrequency?: number;
    /**
     * 47
     */
    chapterNum?: number;
    /**
     * 50
     */
    actionStatus?: number;
    /**
     * "3.9"
     */
    totalScore?: string;
    /**
     * 51
     */
    voters?: number;
    /**
     * "Killed by a Sage Emperor and reborn as his 13 year old self, Nie Li was given a second chance at life. A second chance to change everything and save his loved ones and his beloved city. He shall once again battle with the Sage Emperor to avenge his death and those of his beloved . With the vast knowledge of hundred years of life he accumulated in his previous life, wielding the strongest demon spirits, he shall reach the pinnacle of Martial Arts. \r\n\r\nEnmities of the past will be settled in this new lifetime. “Since I’m back, then in this lifetime, I shall become the King of the Gods that dominate everything. Let everything else tremble beneath my feet!”"
     */
    description?: string;
    /**
     * "242.2K"
     */
    pvNum?: string;
    expected?: number;
    advText?: string;
    advActionUrl?: string;
    /**
     * "24395128911229316"
     */
    firstChapterId?: string;
    /**
     * "xxx"
     */
    firstChapterName?: string;
    /**
     * "19366109291645600"
     */
    readToChapterId?: string;
    /**
     * "xxx"
     */
    readToChapterName?: string;
    translateMode?: number;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * 1577568672000
     */
    publishTime?: number;
    /**
     * 1577568672000
     */
    updateTime?: number;
    /**
     * [{"tagId":1,"tagName":"tag","isLiked":0,"likeNums":10}]
     */
    tagInfos?: {
      /**
       * 1
       */
      tagId?: number;
      /**
       * "tag"
       */
      tagName?: string;
      isLiked?: number;
      /**
       * 10
       */
      likeNums?: number;
    }[];
    /**
     * [{"text":"妖神记","url":"https://m.qidian.com/book/3506478"}]
     */
    language?: {
      /**
       * "妖神记"
       */
      text?: string;
      /**
       * "https://m.qidian.com/book/3506478"
       */
      url?: string;
    }[];
    /**
     * [{"id":20585877587691110,"name":"test group","isLiked":0,"likeNums":10}]
     */
    groupItems?: {
      /**
       * 20585877587691110
       */
      id?: number;
      /**
       * "test group"
       */
      name?: string;
      isLiked?: number;
      /**
       * 10
       */
      likeNums?: number;
    }[];
    /**
     * [{"id":11168584101015700,"userId":4300000467,"guid":4300000467,"name":"test_qa12"}]
     */
    editorItems?: {
      /**
       * 11168584101015700
       */
      id?: number;
      /**
       * 4300000467
       */
      userId?: number;
      /**
       * 4300000467
       */
      guid?: number;
      /**
       * "test_qa12"
       */
      name?: string;
    }[];
    /**
     * [{"id":6995297601012005,"userId":121,"guid":121,"name":"xujin_Translator"},{"id":11168584101015700,"userId":4300000467,"guid":4300000467,"name":"test_qa12"},{"id":18362387245614304,"userId":41830698,"guid":41830698,"name":"clarkzhangss"}]
     */
    translatorItems?: {
      /**
       * 6995297601012005
       */
      id?: number;
      /**
       * 121
       */
      userId?: number;
      /**
       * 121
       */
      guid?: number;
      /**
       * "xujin_Translator"
       */
      name?: string;
    }[];
    /**
     * "0"
     */
    coverUpdateTime?: string;
    /**
     * [{"avatar":"https://oauserimg.webnovel.com/userheadimg/448649069/1/1.jpg","name":"editor-test-gy","note":"搜神记译者","role":"Translator","guid":448649069}]
     */
    notes?: {
      /**
       * "https://oauserimg.webnovel.com/userheadimg/448649069/1/1.jpg"
       */
      avatar?: string;
      /**
       * "editor-test-gy"
       */
      name?: string;
      /**
       * "搜神记译者"
       */
      note?: string;
      /**
       * "Translator"
       */
      role?: string;
      /**
       * 448649069
       */
      guid?: number;
    }[];
    picM?: string;
    feverLink?: string;
    inLibrary?: number;
    /**
     * 2
     */
    powerRank?: number;
    energyNum?: number;
    /**
     * -1
     */
    giftNum?: number;
    /**
     * [{"userId":4300001965,"appId":20,"UUT":1563788721000},{"userId":4300002487,"appId":20,"UUT":1570799256000},{"userId":4300003237,"appId":20,"UUT":1571141768000},{"userId":4300002347,"appId":20,"UUT":1562824038000},{"userId":4300000352,"appId":10,"UUT":1544692112128},{"userId":4300000956,"appId":20,"UUT":1563788863000}]
     */
    topFanItems?: {
      /**
       * 4300001965
       */
      userId?: number;
      /**
       * 20
       */
      appId?: number;
      /**
       * 1563788721000
       */
      UUT?: number;
    }[];
  };
  user?: {
    guid?: string;
    avatar?: string;
    userName?: string;
    nickName?: string;
    penName?: null;
    role?: null;
    /**
     * -1
     */
    status?: number;
    SS?: null;
    isCheckin?: null;
    userLevel?: null;
    availablePower?: null;
    totalPower?: null;
    availableEnergy?: null;
    totalEnergy?: null;
    emailStatus?: null;
    mt?: null;
    UUT?: null;
  };
}

/**
 * 接口 [详情页页面数据（ajax）↗](https://yapi.yuewen.com/project/28/interface/api/4305) 的 **请求配置的类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetBookDetailPage`
 * @更新时间 `2020-08-14 11:07:09`
 */
type AjaxBookGetBookDetailPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/book/GetBookDetailPage",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [详情页页面数据（ajax）↗](https://yapi.yuewen.com/project/28/interface/api/4305) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetBookDetailPage`
 * @更新时间 `2020-08-14 11:07:09`
 */
const ajaxBookGetBookDetailPageRequestConfig: AjaxBookGetBookDetailPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/ajax/book/GetBookDetailPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookGetBookDetailPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [详情页页面数据（ajax）↗](https://yapi.yuewen.com/project/28/interface/api/4305) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetBookDetailPage`
 * @更新时间 `2020-08-14 11:07:09`
 */
export const ajaxBookGetBookDetailPage = /*#__PURE__*/ (
  requestData: AjaxBookGetBookDetailPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxBookGetBookDetailPageResponse>(
    prepare(ajaxBookGetBookDetailPageRequestConfig, requestData),
    ...args
  );
};

ajaxBookGetBookDetailPage.requestConfig =
  ajaxBookGetBookDetailPageRequestConfig;

/**
 * 接口 [you also like↗](https://yapi.yuewen.com/project/28/interface/api/4307) 的 **请求类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetRelatedBooksAjax`
 * @更新时间 `2021-05-08 18:29:18`
 */
export interface AjaxBookGetRelatedBooksAjaxRequest {
  bookId: string;
  categoryId: string;
}

/**
 * 接口 [you also like↗](https://yapi.yuewen.com/project/28/interface/api/4307) 的 **返回类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetRelatedBooksAjax`
 * @更新时间 `2021-05-08 18:29:18`
 */
export interface AjaxBookGetRelatedBooksAjaxResponse {
  /**
   * [{"bookId":"6831850602000905","type":1,"authorName":"Heng Sao Tian Ya","bookName":"Library of Heaven's Path","categoryName":"Eastern Fantasy","categoryId":70009,"sameFlag":"category","coverUpdateTime":"1547630111862","totalScore":"4.4"},{"bookId":"9017100806001205","type":1,"authorName":"Fast Food Restaurant","bookName":"King of Gods","categoryName":"Eastern Fantasy","categoryId":70009,"sameFlag":"category","coverUpdateTime":"1547631126745","totalScore":"4.3"},{"bookId":"7834185605001405","type":1,"authorName":"Cocooned Cow","bookName":"True Martial World","categoryName":"Eastern Fantasy","categoryId":70009,"sameFlag":"category","coverUpdateTime":"1547697158763","totalScore":"4.3"},{"bookId":"6831855002001305","type":1,"authorName":"Goose Five","bookName":"Strongest Abandoned Son","categoryName":"Eastern Fantasy","categoryId":70009,"sameFlag":"category","coverUpdateTime":"1547629234874","totalScore":"4.0"},{"bookId":"12579873206987005","type":2,"authorName":"Evil_Dragon","bookName":"Ancient Dragon Lord","categoryName":"Eastern Fantasy","categoryId":70009,"sameFlag":"category","coverUpdateTime":"1547654421805","totalScore":"3.9"},{"bookId":"8094058605004605","type":1,"authorName":"I Eat Tomatoes","bookName":"The Desolate Era","categoryName":"Eastern Fantasy","categoryId":70009,"sameFlag":"category","coverUpdateTime":"1543476855619","totalScore":"4.4"}]
   */
  items?: {
    /**
     * "6831850602000905"
     */
    bookId?: string;
    /**
     * 1
     */
    type?: number;
    /**
     * "Heng Sao Tian Ya"
     */
    authorName?: string;
    /**
     * "Library of Heaven's Path"
     */
    bookName?: string;
    /**
     * "Eastern Fantasy"
     */
    categoryName?: string;
    /**
     * 70009
     */
    categoryId?: number;
    /**
     * "category"
     */
    sameFlag?: string;
    /**
     * "1547630111862"
     */
    coverUpdateTime?: string;
    /**
     * "4.4"
     */
    totalScore?: string;
  }[];
}

/**
 * 接口 [you also like↗](https://yapi.yuewen.com/project/28/interface/api/4307) 的 **请求配置的类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetRelatedBooksAjax`
 * @更新时间 `2021-05-08 18:29:18`
 */
type AjaxBookGetRelatedBooksAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/book/GetRelatedBooksAjax",
    "data",
    string,
    "bookId" | "categoryId",
    false
  >
>;

/**
 * 接口 [you also like↗](https://yapi.yuewen.com/project/28/interface/api/4307) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetRelatedBooksAjax`
 * @更新时间 `2021-05-08 18:29:18`
 */
const ajaxBookGetRelatedBooksAjaxRequestConfig: AjaxBookGetRelatedBooksAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/ajax/book/GetRelatedBooksAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: ["bookId", "categoryId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookGetRelatedBooksAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [you also like↗](https://yapi.yuewen.com/project/28/interface/api/4307) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetRelatedBooksAjax`
 * @更新时间 `2021-05-08 18:29:18`
 */
export const ajaxBookGetRelatedBooksAjax = /*#__PURE__*/ (
  requestData: AjaxBookGetRelatedBooksAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxBookGetRelatedBooksAjaxResponse>(
    prepare(ajaxBookGetRelatedBooksAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxBookGetRelatedBooksAjax.requestConfig =
  ajaxBookGetRelatedBooksAjaxRequestConfig;

/**
 * 接口 [推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/4309) 的 **请求类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/stone/powerInfoAjax`
 * @更新时间 `2019-09-29 11:20:07`
 */
export interface AjaxStonePowerInfoAjaxRequest {}

/**
 * 接口 [推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/4309) 的 **返回类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/stone/powerInfoAjax`
 * @更新时间 `2019-09-29 11:20:07`
 */
export interface AjaxStonePowerInfoAjaxResponse {
  /**
   * 300
   */
  powerNums?: number;
  /**
   * "3"
   */
  rank?: string;
  /**
   * "2"
   */
  userLeftPower?: string;
  /**
   * [123,456]
   */
  recentUserIds?: number[];
}

/**
 * 接口 [推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/4309) 的 **请求配置的类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/stone/powerInfoAjax`
 * @更新时间 `2019-09-29 11:20:07`
 */
type AjaxStonePowerInfoAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/stone/powerInfoAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/4309) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/stone/powerInfoAjax`
 * @更新时间 `2019-09-29 11:20:07`
 */
const ajaxStonePowerInfoAjaxRequestConfig: AjaxStonePowerInfoAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/ajax/stone/powerInfoAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxStonePowerInfoAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/4309) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/stone/powerInfoAjax`
 * @更新时间 `2019-09-29 11:20:07`
 */
export const ajaxStonePowerInfoAjax = /*#__PURE__*/ (
  requestData?: AjaxStonePowerInfoAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxStonePowerInfoAjaxResponse>(
    prepare(ajaxStonePowerInfoAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxStonePowerInfoAjax.requestConfig = ajaxStonePowerInfoAjaxRequestConfig;

/**
 * 接口 [投推荐票↗](https://yapi.yuewen.com/project/28/interface/api/4310) 的 **请求类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/stone/powerVoteAjax`
 * @更新时间 `2019-11-29 13:54:58`
 */
export interface AjaxStonePowerVoteAjaxRequest {}

/**
 * 接口 [投推荐票↗](https://yapi.yuewen.com/project/28/interface/api/4310) 的 **返回类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/stone/powerVoteAjax`
 * @更新时间 `2019-11-29 13:54:58`
 */
export interface AjaxStonePowerVoteAjaxResponse {
  /**
   * 11
   */
  SS?: number;
  /**
   * [{"awardType":1,"amount":11},{"awardType":5,"amount":11}]
   */
  awards?: {
    /**
     * 1
     */
    awardType?: number;
    /**
     * 11
     */
    amount?: number;
  }[];
}

/**
 * 接口 [投推荐票↗](https://yapi.yuewen.com/project/28/interface/api/4310) 的 **请求配置的类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/stone/powerVoteAjax`
 * @更新时间 `2019-11-29 13:54:58`
 */
type AjaxStonePowerVoteAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/stone/powerVoteAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [投推荐票↗](https://yapi.yuewen.com/project/28/interface/api/4310) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/stone/powerVoteAjax`
 * @更新时间 `2019-11-29 13:54:58`
 */
const ajaxStonePowerVoteAjaxRequestConfig: AjaxStonePowerVoteAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/ajax/stone/powerVoteAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxStonePowerVoteAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [投推荐票↗](https://yapi.yuewen.com/project/28/interface/api/4310) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/stone/powerVoteAjax`
 * @更新时间 `2019-11-29 13:54:58`
 */
export const ajaxStonePowerVoteAjax = /*#__PURE__*/ (
  requestData?: AjaxStonePowerVoteAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxStonePowerVoteAjaxResponse>(
    prepare(ajaxStonePowerVoteAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxStonePowerVoteAjax.requestConfig = ajaxStonePowerVoteAjaxRequestConfig;

/**
 * 接口 [添加到书架addLibraryItemsAjax↗](https://yapi.yuewen.com/project/28/interface/api/14464) 的 **请求类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/library/addLibraryItemsAjax`
 * @更新时间 `2018-09-06 19:05:51`
 */
export interface AjaxLibraryAddLibraryItemsAjaxRequest {}

/**
 * 接口 [添加到书架addLibraryItemsAjax↗](https://yapi.yuewen.com/project/28/interface/api/14464) 的 **返回类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/library/addLibraryItemsAjax`
 * @更新时间 `2018-09-06 19:05:51`
 */
export interface AjaxLibraryAddLibraryItemsAjaxResponse {}

/**
 * 接口 [添加到书架addLibraryItemsAjax↗](https://yapi.yuewen.com/project/28/interface/api/14464) 的 **请求配置的类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/library/addLibraryItemsAjax`
 * @更新时间 `2018-09-06 19:05:51`
 */
type AjaxLibraryAddLibraryItemsAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/library/addLibraryItemsAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [添加到书架addLibraryItemsAjax↗](https://yapi.yuewen.com/project/28/interface/api/14464) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/library/addLibraryItemsAjax`
 * @更新时间 `2018-09-06 19:05:51`
 */
const ajaxLibraryAddLibraryItemsAjaxRequestConfig: AjaxLibraryAddLibraryItemsAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/ajax/library/addLibraryItemsAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLibraryAddLibraryItemsAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [添加到书架addLibraryItemsAjax↗](https://yapi.yuewen.com/project/28/interface/api/14464) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/library/addLibraryItemsAjax`
 * @更新时间 `2018-09-06 19:05:51`
 */
export const ajaxLibraryAddLibraryItemsAjax = /*#__PURE__*/ (
  requestData?: AjaxLibraryAddLibraryItemsAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxLibraryAddLibraryItemsAjaxResponse>(
    prepare(ajaxLibraryAddLibraryItemsAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxLibraryAddLibraryItemsAjax.requestConfig =
  ajaxLibraryAddLibraryItemsAjaxRequestConfig;

/**
 * 接口 [\/go\/pcm\/book\/getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/28/interface/api/165074) 的 **请求类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-10-27 16:31:36`
 */
export interface GoPcmBookGetBatchSubscribeGradeRequest {
  bookId: string;
  /**
   * 0：小说 100：漫画
   */
  novelType: string;
  chapterId: string;
}

/**
 * 接口 [\/go\/pcm\/book\/getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/28/interface/api/165074) 的 **返回类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-10-27 16:31:36`
 */
export interface GoPcmBookGetBatchSubscribeGradeResponse {
  /**
   * [{"chapterCount":5,"discount":"@string","startChapterIndex":81,"endChapterIndex":85,"continueStatus":1,"originalPrice":1024,"optimalPrice":500,"gradeType":0},{"chapterCount":10,"discount":"@string","startChapterIndex":81,"endChapterIndex":85,"continueStatus":1,"originalPrice":1024,"optimalPrice":800,"gradeType":0},{"chapterCount":20,"discount":"@string","startChapterIndex":81,"endChapterIndex":85,"continueStatus":1,"originalPrice":1024,"optimalPrice":500,"gradeType":0}]
   */
  batchSubscribeGradeList?: {
    /**
     * 5
     */
    chapterCount?: number;
    /**
     * "@string"
     */
    discount?: string;
    /**
     * 81
     */
    startChapterIndex?: number;
    /**
     * 85
     */
    endChapterIndex?: number;
    /**
     * 1
     */
    continueStatus?: number;
    /**
     * 1024
     */
    originalPrice?: number;
    /**
     * 500
     */
    optimalPrice?: number;
    gradeType?: number;
  }[];
  /**
   * 1000
   */
  balance?: number;
}

/**
 * 接口 [\/go\/pcm\/book\/getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/28/interface/api/165074) 的 **请求配置的类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-10-27 16:31:36`
 */
type GoPcmBookGetBatchSubscribeGradeRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/book/getBatchSubscribeGrade",
    "data",
    string,
    "bookId" | "novelType" | "chapterId",
    false
  >
>;

/**
 * 接口 [\/go\/pcm\/book\/getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/28/interface/api/165074) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-10-27 16:31:36`
 */
const goPcmBookGetBatchSubscribeGradeRequestConfig: GoPcmBookGetBatchSubscribeGradeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/go/pcm/book/getBatchSubscribeGrade",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: ["bookId", "novelType", "chapterId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBatchSubscribeGrade",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/go\/pcm\/book\/getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/28/interface/api/165074) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-10-27 16:31:36`
 */
export const goPcmBookGetBatchSubscribeGrade = /*#__PURE__*/ (
  requestData: GoPcmBookGetBatchSubscribeGradeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetBatchSubscribeGradeResponse>(
    prepare(goPcmBookGetBatchSubscribeGradeRequestConfig, requestData),
    ...args
  );
};

goPcmBookGetBatchSubscribeGrade.requestConfig =
  goPcmBookGetBatchSubscribeGradeRequestConfig;

/**
 * 接口 [\/go\/pcm\/book\/unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/28/interface/api/165084) 的 **请求类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-10-27 17:58:11`
 */
export interface GoPcmBookUnlockBatchChaptersRequest {
  bookId: string;
  bookType: string;
  chapterId: string;
  /**
   * 档位对应章节数
   */
  chapterCount: string;
  price: string;
  /**
   * 算法字段 用于上报
   */
  statParams: string;
}

/**
 * 接口 [\/go\/pcm\/book\/unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/28/interface/api/165084) 的 **返回类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-10-27 17:58:11`
 */
export interface GoPcmBookUnlockBatchChaptersResponse {
  unlockResult?: {
    unlocked?: number;
    /**
     * -126006
     */
    noBalance?: number;
    /**
     * -126005
     */
    refreshPage?: number;
  };
}

/**
 * 接口 [\/go\/pcm\/book\/unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/28/interface/api/165084) 的 **请求配置的类型**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-10-27 17:58:11`
 */
type GoPcmBookUnlockBatchChaptersRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/book/unlockBatchChapters",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [\/go\/pcm\/book\/unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/28/interface/api/165084) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-10-27 17:58:11`
 */
const goPcmBookUnlockBatchChaptersRequestConfig: GoPcmBookUnlockBatchChaptersRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/go/pcm/book/unlockBatchChapters",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookUnlockBatchChapters",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/go\/pcm\/book\/unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/28/interface/api/165084) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-10-27 17:58:11`
 */
export const goPcmBookUnlockBatchChapters = /*#__PURE__*/ (
  requestData: GoPcmBookUnlockBatchChaptersRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookUnlockBatchChaptersResponse>(
    prepare(goPcmBookUnlockBatchChaptersRequestConfig, requestData),
    ...args
  );
};

goPcmBookUnlockBatchChapters.requestConfig =
  goPcmBookUnlockBatchChaptersRequestConfig;

const mockUrl_0_1_0_26 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_26 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_26 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_26 = "data" as any;

/**
 * 接口 [Power Ranking↗](https://yapi.yuewen.com/project/28/interface/api/37) 的 **请求类型**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/stone/powerListAjax`
 * @更新时间 `2018-11-15 21:32:48`
 */
export interface AjaxStonePowerListAjaxRequest {
  /**
   * 1 是翻译书 2 是原创书
   */
  bookType: string;
  /**
   * 时间戳
   */
  timestamp: string;
}

/**
 * 接口 [Power Ranking↗](https://yapi.yuewen.com/project/28/interface/api/37) 的 **返回类型**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/stone/powerListAjax`
 * @更新时间 `2018-11-15 21:32:48`
 */
export interface AjaxStonePowerListAjaxResponse {
  times?: {
    /**
     * "SEPTEMBER @integer(1, 31), 2017"
     */
    dateDesc?: string;
    /**
     * "${query.timestamp  || 2}"
     */
    current?: string;
    /**
     * "${query.timestamp + 1 || 3}"
     */
    next?: string;
    /**
     * "${query.timestamp - 1 || 1}"
     */
    prev?: string;
  };
  /**
   * [{"bookId":"@id","bookName":"@title","author":"@name","totalScore":1,"powerNums":1,"cateogryId":"@id","categoryName":"@id","bookType":1,"groupItems":[{"id":"@id","name":"@name"}],"translatorItems":[{"id":"@id","name":"@name"}],"editorItems":[{"id":"@id","name":"@name"}]}]
   */
  items?: {
    /**
     * "@id"
     */
    bookId?: string;
    /**
     * "@title"
     */
    bookName?: string;
    /**
     * "@name"
     */
    author?: string;
    /**
     * 1
     */
    totalScore?: number;
    /**
     * 1
     */
    powerNums?: number;
    /**
     * "@id"
     */
    cateogryId?: string;
    /**
     * "@id"
     */
    categoryName?: string;
    /**
     * 1
     */
    bookType?: number;
    /**
     * [{"id":"@id","name":"@name"}]
     */
    groupItems?: {
      /**
       * "@id"
       */
      id?: string;
      /**
       * "@name"
       */
      name?: string;
    }[];
    /**
     * [{"id":"@id","name":"@name"}]
     */
    translatorItems?: {
      /**
       * "@id"
       */
      id?: string;
      /**
       * "@name"
       */
      name?: string;
    }[];
    /**
     * [{"id":"@id","name":"@name"}]
     */
    editorItems?: {
      /**
       * "@id"
       */
      id?: string;
      /**
       * "@name"
       */
      name?: string;
    }[];
  }[];
}

/**
 * 接口 [Power Ranking↗](https://yapi.yuewen.com/project/28/interface/api/37) 的 **请求配置的类型**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/stone/powerListAjax`
 * @更新时间 `2018-11-15 21:32:48`
 */
type AjaxStonePowerListAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/stone/powerListAjax",
    "data",
    string,
    "bookType" | "timestamp",
    false
  >
>;

/**
 * 接口 [Power Ranking↗](https://yapi.yuewen.com/project/28/interface/api/37) 的 **请求配置**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/stone/powerListAjax`
 * @更新时间 `2018-11-15 21:32:48`
 */
const ajaxStonePowerListAjaxRequestConfig: AjaxStonePowerListAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_26,
    devUrl: devUrl_0_1_0_26,
    prodUrl: prodUrl_0_1_0_26,
    path: "/ajax/stone/powerListAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_26,
    paramNames: [],
    queryNames: ["bookType", "timestamp"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxStonePowerListAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [Power Ranking↗](https://yapi.yuewen.com/project/28/interface/api/37) 的 **请求函数**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/stone/powerListAjax`
 * @更新时间 `2018-11-15 21:32:48`
 */
export const ajaxStonePowerListAjax = /*#__PURE__*/ (
  requestData: AjaxStonePowerListAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxStonePowerListAjaxResponse>(
    prepare(ajaxStonePowerListAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxStonePowerListAjax.requestConfig = ajaxStonePowerListAjaxRequestConfig;

/**
 * 接口 [ranking\/getlist↗](https://yapi.yuewen.com/project/28/interface/api/17457) 的 **请求类型**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/ranking/getlist`
 * @更新时间 `2018-11-16 10:31:59`
 */
export interface AjaxRankingGetlistRequest {
  type: string;
  pageIndex: string;
}

/**
 * 接口 [ranking\/getlist↗](https://yapi.yuewen.com/project/28/interface/api/17457) 的 **返回类型**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/ranking/getlist`
 * @更新时间 `2018-11-16 10:31:59`
 */
export interface AjaxRankingGetlistResponse {
  /**
   * [{"bookId":"10029102601019105","bookName":"Library of Heaven Path","totalScore":0,"cateogryId":70001,"categoryName":"Magical Realism","updateFrequency":0,"frequencyUnit":2,"coverUpdateTime":"-6648214074458061104"}]
   */
  items?: {
    /**
     * "10029102601019105"
     */
    bookId?: string;
    /**
     * "Library of Heaven Path"
     */
    bookName?: string;
    totalScore?: number;
    /**
     * 70001
     */
    cateogryId?: number;
    /**
     * "Magical Realism"
     */
    categoryName?: string;
    updateFrequency?: number;
    /**
     * 2
     */
    frequencyUnit?: number;
    /**
     * "-6648214074458061104"
     */
    coverUpdateTime?: string;
  }[];
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [ranking\/getlist↗](https://yapi.yuewen.com/project/28/interface/api/17457) 的 **请求配置的类型**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/ranking/getlist`
 * @更新时间 `2018-11-16 10:31:59`
 */
type AjaxRankingGetlistRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/ranking/getlist",
    "data",
    string,
    "type" | "pageIndex",
    false
  >
>;

/**
 * 接口 [ranking\/getlist↗](https://yapi.yuewen.com/project/28/interface/api/17457) 的 **请求配置**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/ranking/getlist`
 * @更新时间 `2018-11-16 10:31:59`
 */
const ajaxRankingGetlistRequestConfig: AjaxRankingGetlistRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_26,
    devUrl: devUrl_0_1_0_26,
    prodUrl: prodUrl_0_1_0_26,
    path: "/ajax/ranking/getlist",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_26,
    paramNames: [],
    queryNames: ["type", "pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxRankingGetlist",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [ranking\/getlist↗](https://yapi.yuewen.com/project/28/interface/api/17457) 的 **请求函数**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/ranking/getlist`
 * @更新时间 `2018-11-16 10:31:59`
 */
export const ajaxRankingGetlist = /*#__PURE__*/ (
  requestData: AjaxRankingGetlistRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxRankingGetlistResponse>(
    prepare(ajaxRankingGetlistRequestConfig, requestData),
    ...args
  );
};

ajaxRankingGetlist.requestConfig = ajaxRankingGetlistRequestConfig;

const mockUrl_0_1_0_27 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_27 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_27 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_27 = "data" as any;

/**
 * 接口 [关键字搜索-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/536) 的 **请求类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/searchAjax`
 * @更新时间 `2019-07-23 21:27:43`
 */
export interface AjaxSearchSearchAjaxRequest {
  pageIndex: string;
  keywords: string;
  type: string;
}

/**
 * 接口 [关键字搜索-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/536) 的 **返回类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/searchAjax`
 * @更新时间 `2019-07-23 21:27:43`
 */
export interface AjaxSearchSearchAjaxResponse {
  bookInfo?: {
    /**
     * 18
     */
    total?: number;
    isLast?: number;
    /**
     * [{"bookId":"11670396401016705","bookName":"test","authorName":"yuewentester","totalScore":0,"novelType":200,"categoryName":"High Fantasy","coverUpdateTime":"-5174142595054665195"},{"bookId":"11747268401022705","bookName":"testLog","authorName":"authorName","totalScore":0,"categoryName":"Magical Realism","coverUpdateTime":"-5537591974677190152"},{"bookId":"10156046401020805","bookName":"Webnovel Test010","authorName":"Amy-y","totalScore":0,"categoryName":"Horror & Thriller","tagInfo":[{"tagId":88,"tagName":"test1"}],"coverUpdateTime":"6119331927320783742"},{"bookId":"10166607401021505","bookName":"Webnovel Test007","authorName":"xujin0515001","totalScore":"4.4","categoryName":"Science Fiction","tagInfo":[{"tagId":62,"tagName":"Complete"}],"coverUpdateTime":"8561558635391400325"},{"bookId":"10650267701028205","bookName":"Webnovel Lily001","authorName":"taozi","totalScore":"4.3","categoryName":"Historical Fiction","coverUpdateTime":"-2067321994295851808"},{"bookId":"10380512001024305","bookName":"WebnovelTest For AutoAudit","authorName":"bigfish","totalScore":0,"categoryName":"Horror & Thriller","coverUpdateTime":"-5200926430058954451"},{"bookId":"11987368201024205","bookName":"webnovel test101902","authorName":"yuewentester","totalScore":0,"categoryName":"Historical Fiction","coverUpdateTime":"5649718685521445277"},{"bookId":"10029102601019105","bookName":"Library of Heaven Path","authorName":"cloudX","totalScore":0,"categoryName":"Magical Realism","tagInfo":[{"tagId":48,"tagName":"Action"}],"coverUpdateTime":"-6648214074458061104"},{"bookId":"11676462901017405","bookName":"test 913","authorName":"yuewentester","totalScore":0,"categoryName":"Magical Realism","coverUpdateTime":"-2067321994295851808"},{"bookId":"10390410301025905","bookName":"WebnovelTest3 For AutoAudit","authorName":"bigfish","totalScore":0,"categoryName":"High Fantasy","coverUpdateTime":"-5200926430058954451"}]
     */
    bookItems?: {
      /**
       * "11670396401016705"
       */
      bookId?: string;
      /**
       * "test"
       */
      bookName?: string;
      /**
       * "yuewentester"
       */
      authorName?: string;
      totalScore?: number;
      /**
       * 200
       */
      novelType?: number;
      /**
       * "High Fantasy"
       */
      categoryName?: string;
      /**
       * "-5174142595054665195"
       */
      coverUpdateTime?: string;
    }[];
  };
  comicInfo?: {
    /**
     * 1
     */
    total?: number;
    /**
     * 1
     */
    isLast?: number;
    /**
     * [{"comicId":"11566207401012901","comicName":"Webnovel Comic Test001","CV":"-7203931833244678382"}]
     */
    comicItems?: {
      /**
       * "11566207401012901"
       */
      comicId?: string;
      /**
       * "Webnovel Comic Test001"
       */
      comicName?: string;
      /**
       * "-7203931833244678382"
       */
      CV?: string;
    }[];
  };
  powerRank?: null;
}

/**
 * 接口 [关键字搜索-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/536) 的 **请求配置的类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/searchAjax`
 * @更新时间 `2019-07-23 21:27:43`
 */
type AjaxSearchSearchAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/search/searchAjax",
    "data",
    string,
    "pageIndex" | "keywords" | "type",
    false
  >
>;

/**
 * 接口 [关键字搜索-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/536) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/searchAjax`
 * @更新时间 `2019-07-23 21:27:43`
 */
const ajaxSearchSearchAjaxRequestConfig: AjaxSearchSearchAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_27,
    devUrl: devUrl_0_1_0_27,
    prodUrl: prodUrl_0_1_0_27,
    path: "/ajax/search/searchAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_27,
    paramNames: [],
    queryNames: ["pageIndex", "keywords", "type"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSearchSearchAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [关键字搜索-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/536) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/searchAjax`
 * @更新时间 `2019-07-23 21:27:43`
 */
export const ajaxSearchSearchAjax = /*#__PURE__*/ (
  requestData: AjaxSearchSearchAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSearchSearchAjaxResponse>(
    prepare(ajaxSearchSearchAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxSearchSearchAjax.requestConfig = ajaxSearchSearchAjaxRequestConfig;

/**
 * 接口 [关键字联想↗](https://yapi.yuewen.com/project/28/interface/api/6241) 的 **请求类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/auto`
 * @更新时间 `2019-07-23 21:24:11`
 */
export interface AjaxSearchAutoRequest {
  /**
   * 关键字
   */
  keyword: string;
}

/**
 * 接口 [关键字联想↗](https://yapi.yuewen.com/project/28/interface/api/6241) 的 **返回类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/auto`
 * @更新时间 `2019-07-23 21:24:11`
 */
export interface AjaxSearchAutoResponse {
  /**
   * [{"id":4300000514,"name":"chenjieTest"}]
   */
  author?: {
    /**
     * 4300000514
     */
    id?: number;
    /**
     * "chenjieTest"
     */
    name?: string;
  }[];
  /**
   * [{"id":"6831119801007705","name":"Castle of Black Iron"},{"id":"10279534601022505","name":"chaung shi da dao"},{"id":"6820945401003205","name":"Commanding Wind and Cloud"},{"id":"6820979201003805","name":"Counterfeit Hero"}]
   */
  books?: {
    /**
     * "6831119801007705"
     */
    id?: string;
    /**
     * "Castle of Black Iron"
     */
    name?: string;
  }[];
  /**
   * [{"id":"11540953701012201","name":"Chapter Comic 0828"}]
   */
  comics?: {
    /**
     * "11540953701012201"
     */
    id?: string;
    /**
     * "Chapter Comic 0828"
     */
    name?: string;
  }[];
  /**
   * [{"id":70007,"name":"Competitive Sports"}]
   */
  categories?: {
    /**
     * 70007
     */
    id?: number;
    /**
     * "Competitive Sports"
     */
    name?: string;
  }[];
  /**
   * [{"id":70007,"name":"Competitive Sports"}]
   */
  publishBooks?: {
    /**
     * 70007
     */
    id?: number;
    /**
     * "Competitive Sports"
     */
    name?: string;
  }[];
}

/**
 * 接口 [关键字联想↗](https://yapi.yuewen.com/project/28/interface/api/6241) 的 **请求配置的类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/auto`
 * @更新时间 `2019-07-23 21:24:11`
 */
type AjaxSearchAutoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/search/auto",
    "data",
    string,
    "keyword",
    false
  >
>;

/**
 * 接口 [关键字联想↗](https://yapi.yuewen.com/project/28/interface/api/6241) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/auto`
 * @更新时间 `2019-07-23 21:24:11`
 */
const ajaxSearchAutoRequestConfig: AjaxSearchAutoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_1_0_27,
  devUrl: devUrl_0_1_0_27,
  prodUrl: prodUrl_0_1_0_27,
  path: "/ajax/search/auto",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_1_0_27,
  paramNames: [],
  queryNames: ["keyword"],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "ajaxSearchAuto",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [关键字联想↗](https://yapi.yuewen.com/project/28/interface/api/6241) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/auto`
 * @更新时间 `2019-07-23 21:24:11`
 */
export const ajaxSearchAuto = /*#__PURE__*/ (
  requestData: AjaxSearchAutoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSearchAutoResponse>(
    prepare(ajaxSearchAutoRequestConfig, requestData),
    ...args
  );
};

ajaxSearchAuto.requestConfig = ajaxSearchAutoRequestConfig;

/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/28/interface/api/17466) 的 **请求类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/getHotSearch`
 * @更新时间 `2018-10-15 15:28:00`
 */
export interface AjaxSearchGetHotSearchRequest {}

/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/28/interface/api/17466) 的 **返回类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/getHotSearch`
 * @更新时间 `2018-10-15 15:28:00`
 */
export interface AjaxSearchGetHotSearchResponse {
  /**
   * [{"id":1,"name":"@title","type":"1"}]
   */
  items?: {
    /**
     * 1
     */
    id?: number;
    /**
     * "@title"
     */
    name?: string;
    /**
     * "1"
     */
    type?: string;
  }[];
}

/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/28/interface/api/17466) 的 **请求配置的类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/getHotSearch`
 * @更新时间 `2018-10-15 15:28:00`
 */
type AjaxSearchGetHotSearchRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/search/getHotSearch",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/28/interface/api/17466) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/getHotSearch`
 * @更新时间 `2018-10-15 15:28:00`
 */
const ajaxSearchGetHotSearchRequestConfig: AjaxSearchGetHotSearchRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_27,
    devUrl: devUrl_0_1_0_27,
    prodUrl: prodUrl_0_1_0_27,
    path: "/ajax/search/getHotSearch",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSearchGetHotSearch",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/28/interface/api/17466) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/getHotSearch`
 * @更新时间 `2018-10-15 15:28:00`
 */
export const ajaxSearchGetHotSearch = /*#__PURE__*/ (
  requestData?: AjaxSearchGetHotSearchRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSearchGetHotSearchResponse>(
    prepare(ajaxSearchGetHotSearchRequestConfig, requestData),
    ...args
  );
};

ajaxSearchGetHotSearch.requestConfig = ajaxSearchGetHotSearchRequestConfig;

const mockUrl_0_1_0_28 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_28 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_28 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_28 = "data" as any;

/**
 * 接口 [书架运营位↗](https://yapi.yuewen.com/project/28/interface/api/25543) 的 **请求类型**
 *
 * @分类 [广告和推荐位↗](https://yapi.yuewen.com/project/28/interface/api/cat_4012)
 * @请求头 `GET /ajax/ad/bookShelf`
 * @更新时间 `2019-02-13 10:37:10`
 */
export interface AjaxAdBookShelfRequest {}

/**
 * 接口 [书架运营位↗](https://yapi.yuewen.com/project/28/interface/api/25543) 的 **返回类型**
 *
 * @分类 [广告和推荐位↗](https://yapi.yuewen.com/project/28/interface/api/cat_4012)
 * @请求头 `GET /ajax/ad/bookShelf`
 * @更新时间 `2019-02-13 10:37:10`
 */
export interface AjaxAdBookShelfResponse {
  adv?: {
    /**
     * "earn rewards"
     */
    text?: string;
    /**
     * "https://actimg.webnovel.com/badge/10001/2/40.png"
     */
    imageUrl?: string;
    /**
     * "https://m.webnovel.com/task/daily"
     */
    actionUrl?: string;
  };
}

/**
 * 接口 [书架运营位↗](https://yapi.yuewen.com/project/28/interface/api/25543) 的 **请求配置的类型**
 *
 * @分类 [广告和推荐位↗](https://yapi.yuewen.com/project/28/interface/api/cat_4012)
 * @请求头 `GET /ajax/ad/bookShelf`
 * @更新时间 `2019-02-13 10:37:10`
 */
type AjaxAdBookShelfRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/ad/bookShelf",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [书架运营位↗](https://yapi.yuewen.com/project/28/interface/api/25543) 的 **请求配置**
 *
 * @分类 [广告和推荐位↗](https://yapi.yuewen.com/project/28/interface/api/cat_4012)
 * @请求头 `GET /ajax/ad/bookShelf`
 * @更新时间 `2019-02-13 10:37:10`
 */
const ajaxAdBookShelfRequestConfig: AjaxAdBookShelfRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_28,
    devUrl: devUrl_0_1_0_28,
    prodUrl: prodUrl_0_1_0_28,
    path: "/ajax/ad/bookShelf",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxAdBookShelf",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书架运营位↗](https://yapi.yuewen.com/project/28/interface/api/25543) 的 **请求函数**
 *
 * @分类 [广告和推荐位↗](https://yapi.yuewen.com/project/28/interface/api/cat_4012)
 * @请求头 `GET /ajax/ad/bookShelf`
 * @更新时间 `2019-02-13 10:37:10`
 */
export const ajaxAdBookShelf = /*#__PURE__*/ (
  requestData?: AjaxAdBookShelfRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxAdBookShelfResponse>(
    prepare(ajaxAdBookShelfRequestConfig, requestData),
    ...args
  );
};

ajaxAdBookShelf.requestConfig = ajaxAdBookShelfRequestConfig;

const mockUrl_0_1_0_29 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_29 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_29 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_29 = "data" as any;

/**
 * 接口 [v2↗](https://yapi.yuewen.com/project/28/interface/api/952) 的 **请求类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV2Page`
 * @更新时间 `2024-08-09 14:23:39`
 */
export interface AjaxBookstoreIndexV2PageRequest {}

/**
 * 接口 [v2↗](https://yapi.yuewen.com/project/28/interface/api/952) 的 **返回类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV2Page`
 * @更新时间 `2024-08-09 14:23:39`
 */
export interface AjaxBookstoreIndexV2PageResponse {
  /**
   * [{"imgUrl":"https://webbannertest.webnovel.com/1_banner_1503892661_8519.png","jumpUrl":"https://m.webnovel.com/vote"}]
   */
  coverList?: {
    /**
     * "https://webbannertest.webnovel.com/1_banner_1503892661_8519.png"
     */
    imgUrl?: string;
    /**
     * "https://m.webnovel.com/vote"
     */
    jumpUrl?: string;
  }[];
  announcements?: {
    /**
     * [{"aName":"Here come the Spirit Stones, Web 1.6, Mobile 1.3, and App 1.5","createdTime":"2017-08-22 11:35:30","description":"It has been awhile since Bonus Chapters came online, and we have been receiving feedbacks and suggestions from reader. Although we haven’t had time to respond to some, we did jot them down. The cool ideas and good suggests would be realized and optimized in the future.","jumpUrl":"https://www.facebook.com/notes/qidian/here-come-the-spirit-stones-web-16-mobile-13-and-app-15/521296438207223/"}]
     */
    items?: {
      /**
       * "Here come the Spirit Stones, Web 1.6, Mobile 1.3, and App 1.5"
       */
      aName?: string;
      /**
       * "2017-08-22 11:35:30"
       */
      createdTime?: string;
      /**
       * "It has been awhile since Bonus Chapters came online, and we have been receiving feedbacks and suggestions from reader. Although we haven’t had time to respond to some, we did jot them down. The cool ideas and good suggests would be realized and optimized in the future."
       */
      description?: string;
      /**
       * "https://www.facebook.com/notes/qidian/here-come-the-spirit-stones-web-16-mobile-13-and-app-15/521296438207223/"
       */
      jumpUrl?: string;
    }[];
  };
  newArrivals?: {
    /**
     * [{"bookId":"7979055106002205","bookName":"testpl","bookType":2,"categoryId":20005,"categoryName":"Fantasy","totalScore":"5.0","description":"testpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpl.."}]
     */
    items?: {
      /**
       * "7979055106002205"
       */
      bookId?: string;
      /**
       * "testpl"
       */
      bookName?: string;
      /**
       * 2
       */
      bookType?: number;
      /**
       * 20005
       */
      categoryId?: number;
      /**
       * "Fantasy"
       */
      categoryName?: string;
      /**
       * "5.0"
       */
      totalScore?: string;
      /**
       * "testpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpltestpl.."
       */
      description?: string;
    }[];
  };
  dailyUpdate?: {
    /**
     * [{"bookId":"7979055106002205","bookName":"testpl","bookType":2,"categoryId":20005,"categoryName":"Fantasy","totalScore":"5.0"}]
     */
    items?: {
      /**
       * "7979055106002205"
       */
      bookId?: string;
      /**
       * "testpl"
       */
      bookName?: string;
      /**
       * 2
       */
      bookType?: number;
      /**
       * 20005
       */
      categoryId?: number;
      /**
       * "Fantasy"
       */
      categoryName?: string;
      /**
       * "5.0"
       */
      totalScore?: string;
    }[];
  };
  recommended?: {
    fields?: {
      /**
       * "AuthorName"
       */
      authorName?: string;
      /**
       * "BookId"
       */
      bookId?: string;
      /**
       * "BookName"
       */
      bookName?: string;
      /**
       * "CategoryName"
       */
      categoryName?: string;
      labels?: string;
      /**
       * "TotalScore"
       */
      totalScore?: string;
    };
    /**
     * [{"bookId":6820919701003005,"bookName":"Galactic Dark Net","authorName":"Sonic Nine Light Year","categoryName":"Sci-Fi","totalScore":"4.5","labels":["StableRelease","Adventure"],"tagInfo":[{"tagId":14,"tagName":"StableRelease"},{"tagId":20,"tagName":"Adventure"}]}]
     */
    items?: {
      /**
       * 6820919701003005
       */
      bookId?: number;
      /**
       * "Galactic Dark Net"
       */
      bookName?: string;
      /**
       * "Sonic Nine Light Year"
       */
      authorName?: string;
      /**
       * "Sci-Fi"
       */
      categoryName?: string;
      /**
       * "4.5"
       */
      totalScore?: string;
      /**
       * ["StableRelease","Adventure"]
       */
      labels?: string[];
      /**
       * [{"tagId":14,"tagName":"StableRelease"},{"tagId":20,"tagName":"Adventure"}]
       */
      tagInfo?: {
        /**
         * 14
         */
        tagId?: number;
        /**
         * "StableRelease"
         */
        tagName?: string;
      }[];
    }[];
    /**
     * "manual"
     */
    src?: string;
    /**
     * "Recommended"
     */
    title?: string;
    /**
     * 9
     */
    total?: number;
    /**
     * "hybrid:dataSec1"
     */
    secKey?: string;
  };
  popular?: {
    /**
     * "popular"
     */
    src?: string;
    /**
     * "Popular"
     */
    title?: string;
    /**
     * "hybrid:bookstore:popular"
     */
    secKey?: string;
    /**
     * 73
     */
    total?: number;
    /**
     * [{"bookId":"7731137901014305","bookName":"Diba","categoryId":20001,"categoryName":"Xuanhuan","authorName":"yanbixiaosheng","totalScore":"5.0","tagInfo":[{"tagId":100001,"tagName":"Action"},{"tagId":100004,"tagName":"SliceOfLife"}],"coverUpdateTime":1506667862189}]
     */
    items?: {
      /**
       * "7731137901014305"
       */
      bookId?: string;
      /**
       * "Diba"
       */
      bookName?: string;
      /**
       * 20001
       */
      categoryId?: number;
      /**
       * "Xuanhuan"
       */
      categoryName?: string;
      /**
       * "yanbixiaosheng"
       */
      authorName?: string;
      /**
       * "5.0"
       */
      totalScore?: string;
      /**
       * [{"tagId":100001,"tagName":"Action"},{"tagId":100004,"tagName":"SliceOfLife"}]
       */
      tagInfo?: {
        /**
         * 100001
         */
        tagId?: number;
        /**
         * "Action"
         */
        tagName?: string;
      }[];
      /**
       * 1506667862189
       */
      coverUpdateTime?: number;
    }[];
  };
  beginners?: {
    fields?: {
      /**
       * "AuthorName"
       */
      authorName?: string;
      /**
       * "BookId"
       */
      bookId?: string;
      /**
       * "BookName"
       */
      bookName?: string;
      /**
       * "CategoryName"
       */
      categoryName?: string;
      labels?: string;
      /**
       * "TotalScore"
       */
      totalScore?: string;
    };
    /**
     * [{"bookId":6820919701003005,"bookName":"Galactic Dark Net","authorName":"Sonic Nine Light Year","categoryName":"Sci-Fi","totalScore":"4.5","labels":["StableRelease","Adventure"],"tagInfo":[{"tagId":14,"tagName":"StableRelease"},{"tagId":20,"tagName":"Adventure"}]}]
     */
    items?: {
      /**
       * 6820919701003005
       */
      bookId?: number;
      /**
       * "Galactic Dark Net"
       */
      bookName?: string;
      /**
       * "Sonic Nine Light Year"
       */
      authorName?: string;
      /**
       * "Sci-Fi"
       */
      categoryName?: string;
      /**
       * "4.5"
       */
      totalScore?: string;
      /**
       * ["StableRelease","Adventure"]
       */
      labels?: string[];
      /**
       * [{"tagId":14,"tagName":"StableRelease"},{"tagId":20,"tagName":"Adventure"}]
       */
      tagInfo?: {
        /**
         * 14
         */
        tagId?: number;
        /**
         * "StableRelease"
         */
        tagName?: string;
      }[];
    }[];
    /**
     * "manual"
     */
    src?: string;
    /**
     * "Beginners' Pick"
     */
    title?: string;
    /**
     * 9
     */
    total?: number;
    /**
     * "hybrid:dataSec3"
     */
    secKey?: string;
  };
  ladies?: {
    fields?: {
      /**
       * "AuthorName"
       */
      authorName?: string;
      /**
       * "BookId"
       */
      bookId?: string;
      /**
       * "BookName"
       */
      bookName?: string;
      /**
       * "CategoryName"
       */
      categoryName?: string;
      labels?: string;
      /**
       * "TotalScore"
       */
      totalScore?: string;
    };
    /**
     * [{"bookId":6820998101004605,"bookName":"Realms In The Firmament","authorName":"Feng Ling Tian Xia","categoryName":"Xuanhuan","totalScore":"5.0","labels":["Reincarnation","Action"],"tagInfo":[{"tagId":26,"tagName":"Reincarnation"},{"tagId":33,"tagName":"Action"}]}]
     */
    items?: {
      /**
       * 6820998101004605
       */
      bookId?: number;
      /**
       * "Realms In The Firmament"
       */
      bookName?: string;
      /**
       * "Feng Ling Tian Xia"
       */
      authorName?: string;
      /**
       * "Xuanhuan"
       */
      categoryName?: string;
      /**
       * "5.0"
       */
      totalScore?: string;
      /**
       * ["Reincarnation","Action"]
       */
      labels?: string[];
      /**
       * [{"tagId":26,"tagName":"Reincarnation"},{"tagId":33,"tagName":"Action"}]
       */
      tagInfo?: {
        /**
         * 26
         */
        tagId?: number;
        /**
         * "Reincarnation"
         */
        tagName?: string;
      }[];
    }[];
    /**
     * "manual"
     */
    src?: string;
    /**
     * "Ladies’ Pick"
     */
    title?: string;
    /**
     * 9
     */
    total?: number;
    /**
     * "hybrid:dataSec4"
     */
    secKey?: string;
  };
  /**
   * [{"bookId":"7765065001015905","bookName":"The Devil's Cage","categoryId":-1,"categoryName":"Other","newChapterId":"22516068102759920","newChapterName":"vfdhb","newChapterIndex":25,"newChapterTime":"2 months ago","authorName":"Rusty Dragon","groupItems":[],"translatorItems":[{"id":"7635960701023405","name":"xunjin-new--t"},{"id":"18313177389384746","name":"Hitesh"}],"editorItems":[{"id":"6995297601012005","name":"xujin_Translator"},{"id":"19366109291545089","name":"test-gy-third"}]}]
   */
  latestUpdates?: {
    /**
     * "7765065001015905"
     */
    bookId?: string;
    /**
     * "The Devil's Cage"
     */
    bookName?: string;
    /**
     * -1
     */
    categoryId?: number;
    /**
     * "Other"
     */
    categoryName?: string;
    /**
     * "22516068102759920"
     */
    newChapterId?: string;
    /**
     * "vfdhb"
     */
    newChapterName?: string;
    /**
     * 25
     */
    newChapterIndex?: number;
    /**
     * "2 months ago"
     */
    newChapterTime?: string;
    /**
     * "Rusty Dragon"
     */
    authorName?: string;
    /**
     * []
     */
    groupItems?: unknown[];
    /**
     * [{"id":"7635960701023405","name":"xunjin-new--t"},{"id":"18313177389384746","name":"Hitesh"}]
     */
    translatorItems?: {
      /**
       * "7635960701023405"
       */
      id?: string;
      /**
       * "xunjin-new--t"
       */
      name?: string;
    }[];
    /**
     * [{"id":"6995297601012005","name":"xujin_Translator"},{"id":"19366109291545089","name":"test-gy-third"}]
     */
    editorItems?: {
      /**
       * "6995297601012005"
       */
      id?: string;
      /**
       * "xujin_Translator"
       */
      name?: string;
    }[];
  }[];
  /**
   * [{"bookId":"7765061201015705","bookName":"Fishing the Myriad Heavens","categoryId":20019,"categoryName":"Modern","newChapterId":"20844379865796197","newChapterName":"The Willful Boss!  ","newChapterIndex":14,"newChapterTime":"3 months ago","authorName":"Dao Is Unfathomable","groupItems":[],"translatorItems":[],"editorItems":[{"id":"7563802601023005","name":"editor-test-gy"}]}]
   */
  latestOriginalUpdates?: {
    /**
     * "7765061201015705"
     */
    bookId?: string;
    /**
     * "Fishing the Myriad Heavens"
     */
    bookName?: string;
    /**
     * 20019
     */
    categoryId?: number;
    /**
     * "Modern"
     */
    categoryName?: string;
    /**
     * "20844379865796197"
     */
    newChapterId?: string;
    /**
     * "The Willful Boss!  "
     */
    newChapterName?: string;
    /**
     * 14
     */
    newChapterIndex?: number;
    /**
     * "3 months ago"
     */
    newChapterTime?: string;
    /**
     * "Dao Is Unfathomable"
     */
    authorName?: string;
    /**
     * []
     */
    groupItems?: unknown[];
    /**
     * []
     */
    translatorItems?: unknown[];
    /**
     * [{"id":"7563802601023005","name":"editor-test-gy"}]
     */
    editorItems?: {
      /**
       * "7563802601023005"
       */
      id?: string;
      /**
       * "editor-test-gy"
       */
      name?: string;
    }[];
  }[];
  powerRanking?: {
    /**
     * [{"bookId":"7144280301011005","bookName":"testxzfb","categoryId":20042,"categoryName":"Sci-Fi","powerNums":8,"bookType":2}]
     */
    items?: {
      /**
       * "7144280301011005"
       */
      bookId?: string;
      /**
       * "testxzfb"
       */
      bookName?: string;
      /**
       * 20042
       */
      categoryId?: number;
      /**
       * "Sci-Fi"
       */
      categoryName?: string;
      /**
       * 8
       */
      powerNums?: number;
      /**
       * 2
       */
      bookType?: number;
    }[];
    /**
     * "November 8, 2017"
     */
    date?: string;
  };
  tagsList?: {
    /**
     * [{"tagName":"Super-FastRelease"},{"tagName":"Adventure"},{"tagName":"Academy"},{"tagName":"GameElements"},{"tagName":"Reincarnation"},{"tagName":"Cultivation"},{"tagName":"Brotherhood"},{"tagName":"Comedy"}]
     */
    allTags?: {
      /**
       * "Super-FastRelease"
       */
      tagName?: string;
    }[];
    /**
     * [{"bookId":"7764976401015105","bookName":"Epoch of Twilight","categoryName":"Sci-Fi","totalScore":"5.0","bookType":2,"authorName":"Don't Play People for A Fool","tagInfo":[{"tagId":13,"tagName":"Super-FastRelease"},{"tagId":24,"tagName":"Apocalypse"}],"coverUpdateTime":1502950847951},{"bookId":"7765027801015505","bookName":"War Sovereign Soaring The Heavens","categoryName":"Xuanhuan","totalScore":"5.0","authorName":"Feng Qin Yang","tagInfo":[{"tagId":13,"tagName":"Super-FastRelease"},{"tagId":20,"tagName":"Adventure"}],"coverUpdateTime":1502950865410},{"bookId":"7764982601015205","bookName":"MMORPG: Rebirth of the Legendary Guardian","categoryName":"Other","totalScore":"5.0","authorName":"Flying Alone","tagInfo":[{"tagId":13,"tagName":"Super-FastRelease"},{"tagId":25,"tagName":"GameElements"}],"coverUpdateTime":1502950856951},{"bookId":"6822887201006405","bookName":"The Magus Era","categoryName":"Xuanhuan","totalScore":"4.7","authorName":"Blood Red","tagInfo":[{"tagId":13,"tagName":"Super-FastRelease"},{"tagId":26,"tagName":"Reincarnation"}],"coverUpdateTime":1502950497572}]
     */
    items?: {
      /**
       * "7764976401015105"
       */
      bookId?: string;
      /**
       * "Epoch of Twilight"
       */
      bookName?: string;
      /**
       * "Sci-Fi"
       */
      categoryName?: string;
      /**
       * "5.0"
       */
      totalScore?: string;
      /**
       * 2
       */
      bookType?: number;
      /**
       * "Don't Play People for A Fool"
       */
      authorName?: string;
      /**
       * [{"tagId":13,"tagName":"Super-FastRelease"},{"tagId":24,"tagName":"Apocalypse"}]
       */
      tagInfo?: {
        /**
         * 13
         */
        tagId?: number;
        /**
         * "Super-FastRelease"
         */
        tagName?: string;
      }[];
      /**
       * 1502950847951
       */
      coverUpdateTime?: number;
    }[];
    firstTag?: {
      /**
       * "Super-FastRelease"
       */
      tagName?: string;
    };
  };
  comics?: {
    /**
     * [{"comicId":"11359266701006301","comicName":"freecomic","publisher":"ccoversea","CV":"1343909685488215838"},{"comicId":"11558338301012801","comicName":"Xiuzhen","publisher":"ccoversea","CV":"-8411146687413383187"},{"comicId":"11540953701012201","comicName":"ChapterComic0828","publisher":"ccoversea","CV":"-1475042346132319101"},{"comicId":"11538023301012001","comicName":"syncComic0828","publisher":"ccoverseadsf","CV":"7412663456896496008"},{"comicId":"11531866201011501","comicName":"同步测试漫画0827啊","publisher":"ccoverseadsf","CV":"-6424587706670916770"},{"comicId":"11505813201011001","comicName":"freecomicTest0824","publisher":"ccoversea","CV":"6831432222151962684"},{"comicId":"11410541601007701","comicName":"benmoney0813","publisher":"ccoverseadsf","CV":"1386680017884002118"},{"comicId":"11408335301007501","comicName":"comic0813","publisher":"ccoversea","CV":"-6026414907417299064"},{"comicId":"11384116401007301","comicName":"comic0810","publisher":"ccoversea","CV":"-5174142595054665195"}]
     */
    items?: {
      /**
       * "11359266701006301"
       */
      comicId?: string;
      /**
       * "freecomic"
       */
      comicName?: string;
      /**
       * "ccoversea"
       */
      publisher?: string;
      /**
       * "1343909685488215838"
       */
      CV?: string;
    }[];
  };
  user?: {
    guid?: string;
    /**
     * "//img.webnovel.com/bookcover/7979055106002205/180/180.jpg"
     */
    avatar?: string;
    /**
     * "username is very long hahdfdasfasfsadfsadff"
     */
    userName?: string;
    nickName?: string;
    penName?: null;
    role?: null;
    status?: number;
    SS?: null;
    /**
     * 100
     */
    availableEnergy?: number;
    /**
     * 400
     */
    availablePower?: number;
    isCheckin?: boolean;
    userLevel?: null;
    totalPower?: null;
    totalEnergy?: null;
  };
}

/**
 * 接口 [v2↗](https://yapi.yuewen.com/project/28/interface/api/952) 的 **请求配置的类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV2Page`
 * @更新时间 `2024-08-09 14:23:39`
 */
type AjaxBookstoreIndexV2PageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/bookstore/indexV2Page",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [v2↗](https://yapi.yuewen.com/project/28/interface/api/952) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV2Page`
 * @更新时间 `2024-08-09 14:23:39`
 */
const ajaxBookstoreIndexV2PageRequestConfig: AjaxBookstoreIndexV2PageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/ajax/bookstore/indexV2Page",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookstoreIndexV2Page",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [v2↗](https://yapi.yuewen.com/project/28/interface/api/952) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV2Page`
 * @更新时间 `2024-08-09 14:23:39`
 */
export const ajaxBookstoreIndexV2Page = /*#__PURE__*/ (
  requestData?: AjaxBookstoreIndexV2PageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxBookstoreIndexV2PageResponse>(
    prepare(ajaxBookstoreIndexV2PageRequestConfig, requestData),
    ...args
  );
};

ajaxBookstoreIndexV2Page.requestConfig = ajaxBookstoreIndexV2PageRequestConfig;

/**
 * 接口 [拉取更新信息↗](https://yapi.yuewen.com/project/28/interface/api/2001) 的 **请求类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/getUpdateNums`
 * @更新时间 `2018-12-26 16:56:09`
 */
export interface AjaxBookstoreGetUpdateNumsRequest {}

/**
 * 接口 [拉取更新信息↗](https://yapi.yuewen.com/project/28/interface/api/2001) 的 **返回类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/getUpdateNums`
 * @更新时间 `2018-12-26 16:56:09`
 */
export interface AjaxBookstoreGetUpdateNumsResponse {
  library?: {
    /**
     * 9
     */
    unReadNum?: number;
    /**
     * "书架上 所有书中 章节更新时间最大的 时间戳, 以ms为单位"
     */
    timestamp?: string;
  };
  message?: {
    /**
     * 9999
     */
    unReadNum?: number;
  };
  notification?: {
    /**
     * 9999
     */
    unReadNum?: number;
  };
}

/**
 * 接口 [拉取更新信息↗](https://yapi.yuewen.com/project/28/interface/api/2001) 的 **请求配置的类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/getUpdateNums`
 * @更新时间 `2018-12-26 16:56:09`
 */
type AjaxBookstoreGetUpdateNumsRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/bookstore/getUpdateNums",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [拉取更新信息↗](https://yapi.yuewen.com/project/28/interface/api/2001) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/getUpdateNums`
 * @更新时间 `2018-12-26 16:56:09`
 */
const ajaxBookstoreGetUpdateNumsRequestConfig: AjaxBookstoreGetUpdateNumsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/ajax/bookstore/getUpdateNums",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookstoreGetUpdateNums",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [拉取更新信息↗](https://yapi.yuewen.com/project/28/interface/api/2001) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/getUpdateNums`
 * @更新时间 `2018-12-26 16:56:09`
 */
export const ajaxBookstoreGetUpdateNums = /*#__PURE__*/ (
  requestData?: AjaxBookstoreGetUpdateNumsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxBookstoreGetUpdateNumsResponse>(
    prepare(ajaxBookstoreGetUpdateNumsRequestConfig, requestData),
    ...args
  );
};

ajaxBookstoreGetUpdateNums.requestConfig =
  ajaxBookstoreGetUpdateNumsRequestConfig;

/**
 * 接口 [用户徽章↗](https://yapi.yuewen.com/project/28/interface/api/2006) 的 **请求类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/UserBadge`
 * @更新时间 `2018-12-26 16:56:12`
 */
export interface AjaxBookstoreUserBadgeRequest {}

/**
 * 接口 [用户徽章↗](https://yapi.yuewen.com/project/28/interface/api/2006) 的 **返回类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/UserBadge`
 * @更新时间 `2018-12-26 16:56:12`
 */
export interface AjaxBookstoreUserBadgeResponse {
  badgeInfo?: {
    /**
     * 10007
     */
    badgeId?: number;
    /**
     * "General"
     */
    badgeType?: string;
    /**
     * "Who am I?"
     */
    badgeName?: string;
    /**
     * 2
     */
    maxGrade?: number;
    /**
     * 1
     */
    achievedMaxGrade?: number;
    /**
     * 1516796983000
     */
    achievedTime?: number;
    /**
     * "Add email"
     */
    achievedGradeGoal?: string;
    /**
     * "https://actimg.webnovel.com/badge/10007/1/"
     */
    coverImgUrl?: string;
    coverUpdatedTime?: number;
  };
}

/**
 * 接口 [用户徽章↗](https://yapi.yuewen.com/project/28/interface/api/2006) 的 **请求配置的类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/UserBadge`
 * @更新时间 `2018-12-26 16:56:12`
 */
type AjaxBookstoreUserBadgeRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/bookstore/UserBadge",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [用户徽章↗](https://yapi.yuewen.com/project/28/interface/api/2006) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/UserBadge`
 * @更新时间 `2018-12-26 16:56:12`
 */
const ajaxBookstoreUserBadgeRequestConfig: AjaxBookstoreUserBadgeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/ajax/bookstore/UserBadge",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookstoreUserBadge",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [用户徽章↗](https://yapi.yuewen.com/project/28/interface/api/2006) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/UserBadge`
 * @更新时间 `2018-12-26 16:56:12`
 */
export const ajaxBookstoreUserBadge = /*#__PURE__*/ (
  requestData?: AjaxBookstoreUserBadgeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxBookstoreUserBadgeResponse>(
    prepare(ajaxBookstoreUserBadgeRequestConfig, requestData),
    ...args
  );
};

ajaxBookstoreUserBadge.requestConfig = ajaxBookstoreUserBadgeRequestConfig;

/**
 * 接口 [\/ajax\/bookstore\/topic↗](https://yapi.yuewen.com/project/28/interface/api/17430) 的 **请求类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/topic`
 * @更新时间 `2018-10-08 14:32:27`
 */
export interface AjaxBookstoreTopicRequest {
  id: string;
}

/**
 * 接口 [\/ajax\/bookstore\/topic↗](https://yapi.yuewen.com/project/28/interface/api/17430) 的 **返回类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/topic`
 * @更新时间 `2018-10-08 14:32:27`
 */
export interface AjaxBookstoreTopicResponse {
  title?: string;
  description?: string;
  imageUrl?: string;
  items?: {
    /**
     * 漫画书为 comicId
     */
    bookId?: string;
    /**
     * 漫画书为 comicName
     */
    bookName?: string;
    /**
     * 漫画书目前没有这个字段
     */
    categoryId?: string;
    /**
     * 漫画书目前没有这个字段
     */
    categoryName?: string;
    CUT?: string;
    /**
     * e.g. #Mordern world
     */
    storyInfoItems?: string[];
    /**
     * e.g. #CEO
     */
    characterItems?: string[];
    /**
     * e.g. #CEO
     */
    storyBuildingItems?: string[];
    motto?: string;
    synopsis?: string;
    inLibrary?: string;
  }[];
}

/**
 * 接口 [\/ajax\/bookstore\/topic↗](https://yapi.yuewen.com/project/28/interface/api/17430) 的 **请求配置的类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/topic`
 * @更新时间 `2018-10-08 14:32:27`
 */
type AjaxBookstoreTopicRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/bookstore/topic",
    "data",
    string,
    "id",
    false
  >
>;

/**
 * 接口 [\/ajax\/bookstore\/topic↗](https://yapi.yuewen.com/project/28/interface/api/17430) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/topic`
 * @更新时间 `2018-10-08 14:32:27`
 */
const ajaxBookstoreTopicRequestConfig: AjaxBookstoreTopicRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/ajax/bookstore/topic",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: ["id"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookstoreTopic",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/ajax\/bookstore\/topic↗](https://yapi.yuewen.com/project/28/interface/api/17430) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/topic`
 * @更新时间 `2018-10-08 14:32:27`
 */
export const ajaxBookstoreTopic = /*#__PURE__*/ (
  requestData: AjaxBookstoreTopicRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxBookstoreTopicResponse>(
    prepare(ajaxBookstoreTopicRequestConfig, requestData),
    ...args
  );
};

ajaxBookstoreTopic.requestConfig = ajaxBookstoreTopicRequestConfig;

/**
 * 接口 [v3↗](https://yapi.yuewen.com/project/28/interface/api/17636) 的 **请求类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV3page`
 * @更新时间 `2019-04-23 17:23:59`
 */
export interface AjaxBookstoreIndexV3pageRequest {}

/**
 * 接口 [v3↗](https://yapi.yuewen.com/project/28/interface/api/17636) 的 **返回类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV3page`
 * @更新时间 `2019-04-23 17:23:59`
 */
export interface AjaxBookstoreIndexV3pageResponse {
  banner?: {
    /**
     * [{"imageUrl":"https://webbanner.webnovel.com/1_banner_1555989150_1668.jpg","jumpUrl":"https://activity.webnovel.com/noah/5633726"},{"imageUrl":"https://webbanner.webnovel.com/1_banner_1555906755_5670.jpg","jumpUrl":"https://activity.webnovel.com/noah/64600011"},{"imageUrl":"https://webbanner.webnovel.com/1_banner_1555589639_2412.jpg","jumpUrl":"https://activity.webnovel.com/noah/64624725"},{"imageUrl":"https://webbanner.webnovel.com/1_banner_1555558118_3548.jpg","jumpUrl":"https://www.webnovel.com/book/12694808505649505/The-CEO's-Woman"},{"imageUrl":"https://webbanner.webnovel.com/1_banner_1555470966_1902.jpg","jumpUrl":"https://activity.webnovel.com/noah/64599431"}]
     */
    items?: {
      /**
       * "https://webbanner.webnovel.com/1_banner_1555989150_1668.jpg"
       */
      imageUrl?: string;
      /**
       * "https://activity.webnovel.com/noah/5633726"
       */
      jumpUrl?: string;
    }[];
  };
  highlyRecommended?: {
    /**
     * [{"bookId":"12333953306291305","bookName":"His Genius Wife is a Superstar","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.5","voters":3883,"coverUpdateTime":"1547640028918"},{"bookId":"11256254105313805","bookName":"The Beautiful Wife of the Whirlwind Marriage","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.5","voters":3278,"coverUpdateTime":"1550543032076"},{"bookId":"11660227405469705","bookName":"The world turned into a game after I woke up","categoryId":70008,"categoryName":"Video Games","totalScore":"3.6","voters":502,"coverUpdateTime":"1547690772754"},{"bookId":"8360425206000005","bookName":"Bringing the Nation's Husband Home","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.6","voters":13115,"coverUpdateTime":"1543222110854"},{"bookId":"7213811205000505","bookName":"Swallowed Star","categoryId":70006,"categoryName":"Science Fiction","totalScore":"4.3","voters":1153,"coverUpdateTime":"1547697714835"},{"bookId":"11912235406605505","bookName":"Great Doctor Ling Ran","categoryId":70001,"categoryName":"Magical Realism","totalScore":"4.3","voters":684,"coverUpdateTime":"1551177642790"}]
     */
    items?: {
      /**
       * "12333953306291305"
       */
      bookId?: string;
      /**
       * "His Genius Wife is a Superstar"
       */
      bookName?: string;
      /**
       * 70005
       */
      categoryId?: number;
      /**
       * "Romance Fiction"
       */
      categoryName?: string;
      /**
       * "4.5"
       */
      totalScore?: string;
      /**
       * 3883
       */
      voters?: number;
      /**
       * "1547640028918"
       */
      coverUpdateTime?: string;
    }[];
  };
  newOngoing?: {
    /**
     * [{"bookId":"12525846606754205","bookName":"The Long-awaited Mr Han","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.4","voters":843,"coverUpdateTime":"1553587874922"},{"bookId":"12414006605410205","bookName":"I Found A Planet","categoryId":70006,"categoryName":"Science Fiction","totalScore":"4.0","voters":258,"coverUpdateTime":"1553586836920"},{"bookId":"11418908406358805","bookName":"Black Tech Internet Cafe System","categoryId":70006,"categoryName":"Science Fiction","totalScore":"4.5","voters":752,"coverUpdateTime":"1552586790932"},{"bookId":"11806257905539405","bookName":"Sweet Adorable Wife, Please Kiss Slower!","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.5","voters":692,"coverUpdateTime":"1553139205920"},{"bookId":"12093834005914405","bookName":"Divine Beast Adventures","categoryId":70009,"categoryName":"Eastern Fantasy","totalScore":"4.1","voters":362,"coverUpdateTime":"1552586143915"},{"bookId":"12447460005470505","bookName":"The Wealthy Psychic Lady: 99 Stolen Kisses","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"3.9","voters":866,"coverUpdateTime":"1553155935918"},{"bookId":"8205217405006105","bookName":"Way of Choices","categoryId":70009,"categoryName":"Eastern Fantasy","totalScore":"4.2","voters":79,"coverUpdateTime":"1554284985190"},{"bookId":"12214271706102505","bookName":"Mr. Yuan's Dilemma:  Can't Help Falling in Love with You","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.2","voters":686,"coverUpdateTime":"1551760285822"},{"bookId":"12928789705015105","bookName":"Battered Young Miss","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.2","voters":107,"coverUpdateTime":"1554622472950"}]
     */
    items?: {
      /**
       * "12525846606754205"
       */
      bookId?: string;
      /**
       * "The Long-awaited Mr Han"
       */
      bookName?: string;
      /**
       * 70005
       */
      categoryId?: number;
      /**
       * "Romance Fiction"
       */
      categoryName?: string;
      /**
       * "4.4"
       */
      totalScore?: string;
      /**
       * 843
       */
      voters?: number;
      /**
       * "1553587874922"
       */
      coverUpdateTime?: string;
    }[];
  };
  popular?: {
    /**
     * []
     */
    items?: unknown[];
  };
  editorsChoice?: {
    /**
     * []
     */
    items?: unknown[];
  };
  dailyComics?: {
    /**
     * [{"comicId":"11610241506441101","comicName":"Versatile Mage","chapterId":"36473009464203673","chapterIndex":134,"chapterName":"134","hasChapterCover":1,"chapterDescription":"","BUT":1555948833000,"pvNum":"4.8M"},{"comicId":"13137713105817601","comicName":"Release that Witch","chapterId":"36476834669454168","chapterIndex":11,"chapterName":"010 Witches Are the Strongest Productive Force!","hasChapterCover":1,"chapterDescription":"","BUT":1555948835000,"pvNum":"183.2K"},{"comicId":"13138826505824301","comicName":"An Endless Night With Him","chapterId":"36335438188822568","chapterIndex":13,"chapterName":"013","hasChapterCover":1,"chapterDescription":"","BUT":1555948833000,"pvNum":"1.7M"},{"comicId":"13137684906876901","comicName":"The Divine Doctor","chapterId":"36125393081663364","chapterIndex":11,"chapterName":"011","hasChapterCover":1,"chapterDescription":"","BUT":1555948835000,"pvNum":"796.7K"}]
     */
    items?: {
      /**
       * "11610241506441101"
       */
      comicId?: string;
      /**
       * "Versatile Mage"
       */
      comicName?: string;
      /**
       * "36473009464203673"
       */
      chapterId?: string;
      /**
       * 134
       */
      chapterIndex?: number;
      /**
       * "134"
       */
      chapterName?: string;
      /**
       * 1
       */
      hasChapterCover?: number;
      chapterDescription?: string;
      /**
       * 1555948833000
       */
      BUT?: number;
      /**
       * "4.8M"
       */
      pvNum?: string;
    }[];
  };
  ladiesPick?: {
    /**
     * [{"bookId":"9484255206002505","bookName":"National School Prince Is A Girl","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.7","voters":3300,"coverUpdateTime":"1547643657959"},{"bookId":"12544759506836805","bookName":"The Devil's Sleeping Beauty","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.6","voters":952,"coverUpdateTime":"1554625497218"},{"bookId":"12091787305910105","bookName":"Priceless Baby's Super Daddy","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.4","voters":3119,"coverUpdateTime":"1548299343800"},{"bookId":"12694808505649505","bookName":"The CEO's Woman","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.7","voters":1059,"coverUpdateTime":"1548742257944"},{"bookId":"12406148405399305","bookName":"Marriage Rights: Billionaire's Forgotten Wife","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.6","voters":125,"coverUpdateTime":"1547652753852"},{"bookId":"10355083706015805","bookName":"The Genius' First Love","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.7","voters":290,"coverUpdateTime":"1552885277913"},{"bookId":"10866196606193805","bookName":"Back Then, I Adored You","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.2","voters":1619,"coverUpdateTime":"1547697795326"},{"bookId":"11721774106489605","bookName":"Provocative Fiery Wife: My Superior is an Affectionate Spitfire","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.3","voters":1294,"coverUpdateTime":"1547634635780"},{"bookId":"12564072806923405","bookName":"Mr. CEO Loves The Devilish Beauty","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.6","voters":549,"coverUpdateTime":"1554657243956"}]
     */
    items?: {
      /**
       * "9484255206002505"
       */
      bookId?: string;
      /**
       * "National School Prince Is A Girl"
       */
      bookName?: string;
      /**
       * 70005
       */
      categoryId?: number;
      /**
       * "Romance Fiction"
       */
      categoryName?: string;
      /**
       * "4.7"
       */
      totalScore?: string;
      /**
       * 3300
       */
      voters?: number;
      /**
       * "1547643657959"
       */
      coverUpdateTime?: string;
    }[];
  };
  tags?: {
    /**
     * [{"tagName":"Futuristic Setting"},{"tagName":"Reincarnation"},{"tagName":"Game Elements"},{"tagName":"Brotherhood"},{"tagName":"UniqueCultivationTechnique"},{"tagName":"Female Protagonist"},{"tagName":"Comedy"},{"tagName":"SwordAndMagic"},{"tagName":"Vengeance"},{"tagName":"HiddenGem"},{"tagName":"OuterSpace"}]
     */
    items?: {
      /**
       * "Futuristic Setting"
       */
      tagName?: string;
    }[];
  };
  pickedOriginal?: {
    /**
     * [{"bookId":"13330400706510705","bookName":"Age of Teras: Monster Evolution","categoryId":70002,"categoryName":"Fantasy","totalScore":0,"voters":8,"coverUpdateTime":"1556003217982"},{"bookId":"12566617106933305","bookName":"A Pampered Wife’s Notebook","categoryId":70005,"categoryName":"Romance Fiction","totalScore":0,"voters":3,"coverUpdateTime":"1555556401917"},{"bookId":"13225367206183305","bookName":"Spending My Retirement In A Game","categoryId":70008,"categoryName":"Video Games","totalScore":"4.7","voters":49,"coverUpdateTime":"1552295631921"},{"bookId":"12899568605888105","bookName":"Under The Veil of Night","categoryId":70001,"categoryName":"Magical Realism","totalScore":"4.7","voters":38,"coverUpdateTime":"1554466648981"},{"bookId":"12788641006332505","bookName":"Dream Star","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.8","voters":52,"coverUpdateTime":"1554917047928"},{"bookId":"11683484206471705","bookName":"Evil New Wife Seduces Hubby","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.5","voters":149,"coverUpdateTime":"1548663708786"},{"bookId":"12425044306430805","bookName":"The CEO's Painted Skin","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.7","voters":35,"coverUpdateTime":"1554562573933"},{"bookId":"13443736905825505","bookName":"The Story of Blood and Roses","categoryId":70005,"categoryName":"Romance Fiction","totalScore":0,"voters":2,"coverUpdateTime":"1555440098965"},{"bookId":"12964919705174305","bookName":"You Are The Star Tonight","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.7","voters":12,"coverUpdateTime":"1554882334921"}]
     */
    items?: {
      /**
       * "13330400706510705"
       */
      bookId?: string;
      /**
       * "Age of Teras: Monster Evolution"
       */
      bookName?: string;
      /**
       * 70002
       */
      categoryId?: number;
      /**
       * "Fantasy"
       */
      categoryName?: string;
      totalScore?: number;
      /**
       * 8
       */
      voters?: number;
      /**
       * "1556003217982"
       */
      coverUpdateTime?: string;
    }[];
  };
  powerRanking?: {
    /**
     * [{"bookId":"8212987205006305","bookName":"Trial Marriage Husband: Need to Work Hard","cateogryId":70005,"categoryName":"Romance","powerNums":47986,"type":1,"coverUpdateTime":"1547686809014"},{"bookId":"6831850602000905","bookName":"Library of Heaven's Path","cateogryId":70009,"categoryName":"Eastern Fantasy","powerNums":33716,"type":1,"coverUpdateTime":"1547630111862"},{"bookId":"8060642606003005","bookName":"Full Marks Hidden Marriage: Pick Up a Son, Get a Free Husband","cateogryId":70005,"categoryName":"Romance","powerNums":30751,"type":1,"coverUpdateTime":"1553501078486"},{"bookId":"7176992105000305","bookName":"The King's Avatar","cateogryId":70008,"categoryName":"Video Games","powerNums":23780,"type":1,"coverUpdateTime":"1547705433127"},{"bookId":"8527113906000305","bookName":"Reincarnation Of The Strongest Sword God","cateogryId":70008,"categoryName":"Video Games","powerNums":19847,"type":1,"coverUpdateTime":"1547652621792"},{"bookId":"10260480905004505","bookName":"My Youth Began With Him","cateogryId":70005,"categoryName":"Romance","powerNums":17917,"type":1,"coverUpdateTime":"1547697626299"},{"bookId":"8600631606000605","bookName":"Perfect Secret Love: The Bad New Wife is a Little Sweet","cateogryId":70005,"categoryName":"Romance","powerNums":15923,"type":1,"coverUpdateTime":"1555666527925"},{"bookId":"7931338406001705","bookName":"Release That Witch","cateogryId":70002,"categoryName":"Fantasy","powerNums":13042,"type":1,"coverUpdateTime":"1547692288593"},{"bookId":"12507348206677105","bookName":"Only I level up","cateogryId":70001,"categoryName":"Magical Realism","powerNums":11078,"type":1,"coverUpdateTime":"1550542497780"}]
     */
    items?: {
      /**
       * "8212987205006305"
       */
      bookId?: string;
      /**
       * "Trial Marriage Husband: Need to Work Hard"
       */
      bookName?: string;
      /**
       * 70005
       */
      cateogryId?: number;
      /**
       * "Romance"
       */
      categoryName?: string;
      /**
       * 47986
       */
      powerNums?: number;
      /**
       * 1
       */
      type?: number;
      /**
       * "1547686809014"
       */
      coverUpdateTime?: string;
    }[];
    /**
     * "January 13, 51278"
     */
    date?: string;
  };
  middleAds?: {
    /**
     * [{"title":"We love Comics!","text":"Your Next Favorite Comic Is Here!","imageUrl":"https://webbanner.webnovel.com/utils/1555642828_722970.jpg","jumpUrl":"https://app.webnovel.com/views/page/comiclist/index.html?pkgid=1"},{"title":"Reincarnation in another world","text":"Fulfil your dream in another world.","imageUrl":"https://webbanner.webnovel.com/utils/1555643255_119448.jpg","jumpUrl":"https://m.webnovel.com/topic/111"}]
     */
    items?: {
      /**
       * "We love Comics!"
       */
      title?: string;
      /**
       * "Your Next Favorite Comic Is Here!"
       */
      text?: string;
      /**
       * "https://webbanner.webnovel.com/utils/1555642828_722970.jpg"
       */
      imageUrl?: string;
      /**
       * "https://app.webnovel.com/views/page/comiclist/index.html?pkgid=1"
       */
      jumpUrl?: string;
    }[];
  };
  trending?: {
    /**
     * [{"bookId":"11797811306526605","bookName":"The Almighty Ring","categoryId":70008,"categoryName":"Video Games","totalScore":"4.0","voters":715,"coverUpdateTime":"1551073974858"},{"bookId":"11022733006234505","bookName":"Lord of the Mysteries","categoryId":70002,"categoryName":"Fantasy","totalScore":"4.8","voters":869,"coverUpdateTime":"1547647209230"},{"bookId":"11211358306292905","bookName":"Little Miss Devil: The President's Mischievous Wife","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.5","voters":2334,"coverUpdateTime":"1552800816944"},{"bookId":"11793789806524505","bookName":"Dual Cultivation","categoryId":70009,"categoryName":"Eastern Fantasy","totalScore":"4.4","voters":1613,"coverUpdateTime":"1547772095788"},{"bookId":"10580655105066605","bookName":"Flowers Bloom from Battlefield","categoryId":70003,"categoryName":"Historical Fiction","totalScore":"4.6","voters":672,"coverUpdateTime":"1547640003775"},{"bookId":"11620853706444405","bookName":"Sovereign of the Karmic System","categoryId":70002,"categoryName":"Fantasy","totalScore":"4.3","voters":197,"coverUpdateTime":"1547650532831"},{"bookId":"12185250005052805","bookName":"The Hitting Zone","categoryId":70007,"categoryName":"Competitive Sports","totalScore":"4.8","voters":129,"coverUpdateTime":"1547647209439"},{"bookId":"11603373206439505","bookName":"Lust, like Vengeance, Demands Red","categoryId":70009,"categoryName":"Eastern Fantasy","totalScore":"4.3","voters":34,"coverUpdateTime":"1549743708908"},{"bookId":"11884142106587105","bookName":"Revenge: Queen of the Fashion World","categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.3","voters":69,"coverUpdateTime":"1547699614800"}]
     */
    items?: {
      /**
       * "11797811306526605"
       */
      bookId?: string;
      /**
       * "The Almighty Ring"
       */
      bookName?: string;
      /**
       * 70008
       */
      categoryId?: number;
      /**
       * "Video Games"
       */
      categoryName?: string;
      /**
       * "4.0"
       */
      totalScore?: string;
      /**
       * 715
       */
      voters?: number;
      /**
       * "1551073974858"
       */
      coverUpdateTime?: string;
    }[];
  };
  rankings?: {
    dailyBest?: {
      /**
       * [{"bookId":"8212987205006305","bookName":"Trial Marriage Husband: Need to Work Hard","categoryName":"Romance Fiction","totalScore":"4.7","categoryId":70005,"coverUpdateTime":"1547686809014"},{"bookId":"8527113906000305","bookName":"Reincarnation Of The Strongest Sword God","categoryName":"Video Games","totalScore":"4.1","categoryId":70008,"coverUpdateTime":"1547652621792"},{"bookId":"6831850602000905","bookName":"Library of Heaven's Path","categoryName":"Eastern Fantasy","totalScore":"4.4","categoryId":70009,"coverUpdateTime":"1547630111862"},{"bookId":"8060642606003005","bookName":"Full Marks Hidden Marriage: Pick Up a Son, Get a Free Husband","categoryName":"Romance Fiction","totalScore":"4.7","categoryId":70005,"coverUpdateTime":"1553501078486"},{"bookId":"12507348206677105","bookName":"Only I level up","categoryName":"Magical Realism","totalScore":"4.2","categoryId":70001,"coverUpdateTime":"1550542497780"}]
       */
      items?: {
        /**
         * "8212987205006305"
         */
        bookId?: string;
        /**
         * "Trial Marriage Husband: Need to Work Hard"
         */
        bookName?: string;
        /**
         * "Romance Fiction"
         */
        categoryName?: string;
        /**
         * "4.7"
         */
        totalScore?: string;
        /**
         * 70005
         */
        categoryId?: number;
        /**
         * "1547686809014"
         */
        coverUpdateTime?: string;
      }[];
    };
    massiveRelease?: {
      /**
       * [{"bookId":"12075211806874605","bookName":"Kehendak Abadi\t","categoryName":"Eastern Fantasy","categoryId":70009,"coverUpdateTime":"1555915441256"},{"bookId":12075459105881604,"coverUpdateTime":"0"},{"bookId":12075195905880704,"coverUpdateTime":"0"},{"bookId":"11739468506499705","bookName":"Divine Brilliance","categoryName":"Eastern Fantasy","categoryId":70009,"coverUpdateTime":"1553584500921"},{"bookId":12075444405881504,"coverUpdateTime":"0"}]
       */
      items?: {
        /**
         * "12075211806874605"
         */
        bookId?: string;
        /**
         * "Kehendak Abadi\t"
         */
        bookName?: string;
        /**
         * "Eastern Fantasy"
         */
        categoryName?: string;
        /**
         * 70009
         */
        categoryId?: number;
        /**
         * "1555915441256"
         */
        coverUpdateTime?: string;
      }[];
    };
    newPremium?: {
      /**
       * [{"bookId":"12525846606754205","bookName":"The Long-awaited Mr Han","categoryName":"Romance Fiction","totalScore":"4.4","categoryId":70005,"coverUpdateTime":"1553587874922"},{"bookId":"12447708905471005","bookName":"Rebirth of the Strongest Empress","categoryName":"Romance Fiction","totalScore":"4.4","categoryId":70005,"coverUpdateTime":"1554186016925"},{"bookId":"10564679106063105","bookName":"Low Dimensional Game","categoryName":"Fantasy","totalScore":"4.2","categoryId":70002,"coverUpdateTime":"1554184360923"},{"bookId":"12414006605410205","bookName":"I Found A Planet","categoryName":"Science Fiction","totalScore":"4.0","categoryId":70006,"coverUpdateTime":"1553586836920"},{"bookId":"11739468506499705","bookName":"Divine Brilliance","categoryName":"Eastern Fantasy","totalScore":"4.3","categoryId":70009,"coverUpdateTime":"1553584500921"}]
       */
      items?: {
        /**
         * "12525846606754205"
         */
        bookId?: string;
        /**
         * "The Long-awaited Mr Han"
         */
        bookName?: string;
        /**
         * "Romance Fiction"
         */
        categoryName?: string;
        /**
         * "4.4"
         */
        totalScore?: string;
        /**
         * 70005
         */
        categoryId?: number;
        /**
         * "1553587874922"
         */
        coverUpdateTime?: string;
      }[];
    };
  };
  dailyUpdates?: {
    /**
     * [{"bookId":"12820870105509205","bookName":"Supreme Magus","bookType":2,"categoryId":70002,"categoryName":"Fantasy","totalScore":"4.7","authorName":"Legion20","coverUpdateTime":"1548252054833","voters":115},{"bookId":"13249937205202305","bookName":"Reincarnation: A New World","bookType":2,"categoryId":70002,"categoryName":"Fantasy","totalScore":"4.6","authorName":"Aardae","coverUpdateTime":"1552548118916","voters":26},{"bookId":"11726558706492805","bookName":"The Dawn of the New World","bookType":2,"categoryId":70009,"categoryName":"Eastern Fantasy","totalScore":"4.4","authorName":"shinigami8671","coverUpdateTime":"1547647174903","voters":55},{"bookId":"12591236105024705","bookName":"The CEO Who Hates Me","bookType":2,"categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.5","authorName":"EUSTOMA_rgc","coverUpdateTime":"1552956217945","voters":663},{"bookId":"12107193005934105","bookName":"The Other Side of A Cultivation Story","bookType":2,"categoryId":70012,"categoryName":"Martial Arts","totalScore":"4.4","authorName":"Qairi","coverUpdateTime":"1547679673815","voters":68},{"bookId":"12694808505649505","bookName":"The CEO's Woman","bookType":2,"categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.7","authorName":"TheBlips","coverUpdateTime":"1548742257944","voters":1059},{"bookId":"13282409505305605","bookName":"Profane Prince of Domination","bookType":2,"categoryId":70002,"categoryName":"Fantasy","totalScore":"4.5","authorName":"Devil_Paragon","coverUpdateTime":"1555170727917","voters":91},{"bookId":"12834892806612005","bookName":"Transcending the Martial Peak","bookType":2,"categoryId":70009,"categoryName":"Eastern Fantasy","totalScore":"4.6","authorName":"_Transcendent","coverUpdateTime":"1554422265940","voters":50},{"bookId":"12549428906857405","bookName":"Offer to the CEO","bookType":2,"categoryId":70005,"categoryName":"Romance Fiction","totalScore":"4.3","authorName":"klmorgan","coverUpdateTime":"1547673743752","voters":274}]
     */
    items?: {
      /**
       * "12820870105509205"
       */
      bookId?: string;
      /**
       * "Supreme Magus"
       */
      bookName?: string;
      /**
       * 2
       */
      bookType?: number;
      /**
       * 70002
       */
      categoryId?: number;
      /**
       * "Fantasy"
       */
      categoryName?: string;
      /**
       * "4.7"
       */
      totalScore?: string;
      /**
       * "Legion20"
       */
      authorName?: string;
      /**
       * "1548252054833"
       */
      coverUpdateTime?: string;
      /**
       * 115
       */
      voters?: number;
    }[];
  };
  user?: {
    /**
     * "4300469359"
     */
    guid?: string;
    /**
     * "//userimg.webnovel.com/userheadimg/4300469359/1/1.jpg?mt=1530683469000"
     */
    avatar?: string;
    /**
     * "yyxx"
     */
    userName?: string;
    /**
     * "yyxx"
     */
    nickName?: string;
    /**
     * "yyxx"
     */
    penName?: string;
    /**
     * 4
     */
    role?: number;
    status?: number;
    /**
     * 32
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 2
     */
    userLevel?: number;
    /**
     * 2
     */
    availablePower?: number;
    /**
     * 2
     */
    totalPower?: number;
    /**
     * 1
     */
    availableEnergy?: number;
    /**
     * 1
     */
    totalEnergy?: number;
    emailStatus?: number;
    /**
     * 1530683469000
     */
    mt?: number;
    /**
     * 1530683469000
     */
    UUT?: number;
  };
}

/**
 * 接口 [v3↗](https://yapi.yuewen.com/project/28/interface/api/17636) 的 **请求配置的类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV3page`
 * @更新时间 `2019-04-23 17:23:59`
 */
type AjaxBookstoreIndexV3pageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/bookstore/indexV3page",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [v3↗](https://yapi.yuewen.com/project/28/interface/api/17636) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV3page`
 * @更新时间 `2019-04-23 17:23:59`
 */
const ajaxBookstoreIndexV3pageRequestConfig: AjaxBookstoreIndexV3pageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/ajax/bookstore/indexV3page",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookstoreIndexV3page",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [v3↗](https://yapi.yuewen.com/project/28/interface/api/17636) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV3page`
 * @更新时间 `2019-04-23 17:23:59`
 */
export const ajaxBookstoreIndexV3page = /*#__PURE__*/ (
  requestData?: AjaxBookstoreIndexV3pageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxBookstoreIndexV3pageResponse>(
    prepare(ajaxBookstoreIndexV3pageRequestConfig, requestData),
    ...args
  );
};

ajaxBookstoreIndexV3page.requestConfig = ajaxBookstoreIndexV3pageRequestConfig;

/**
 * 接口 [\/msiteservice\/bookcity\/index↗](https://yapi.yuewen.com/project/28/interface/api/39708) 的 **请求类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/index`
 * @更新时间 `2024-08-09 15:28:19`
 */
export interface MsiteserviceBookcityIndexRequest {
  /**
   * 国家 （ISO 3166-1 国家代码）
   */
  country?: string;
  /**
   * 性别 1男,2女
   */
  sex: string;
  pageId?: string;
}

/**
 * 接口 [\/msiteservice\/bookcity\/index↗](https://yapi.yuewen.com/project/28/interface/api/39708) 的 **返回类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/index`
 * @更新时间 `2024-08-09 15:28:19`
 */
export interface MsiteserviceBookcityIndexResponse {
  Result?: number;
  Data?: {
    /**
     * 1
     */
    pageId?: number;
    /**
     * ["AF","AX","DZ"]
     */
    country?: string[];
    /**
     * ["ZH","EN","ES"]
     */
    language?: string[];
    /**
     * "@name"
     */
    bookCityName?: string;
    /**
     * [{"id":"@id","title":"@title","subtitle":"@title","type":"1","background":"@string","content":[{"pageId":"111","title":"@title","subTitle":"@title","child":[{"title":"@title","subTitle":"@title","pageId":"234"}]}]},{"id":"@id","title":"@title","subtitle":"@title","type":"1001","background":1,"content":[{"imageUrl":"@url","actionUrl":"@url"}]},{"id":"@id","title":"@title","subtitle":"@title","type":"1002","background":1,"content":[{"comicId":1,"comicName":"@title","categoryName":"@title"}]},{"id":"@id","title":"@title","subtitle":"@title","type":"1003","background":"@string","content":{"imageUrl":"@url","actionUrl":"@url"}},{"id":"@id","title":"@title","subtitle":"@title","type":"1004","background":1,"content":{"comicId":"@id","comicName":"@title","categoryName":"@title"}},{"id":"@id","title":"@title","subtitle":"@title","type":"1005","background":1,"content":{"comicId":"@id","comicName":"@title","categoryName":"title","expireTime":1}},{"id":"@id","title":"@title","subtitle":"@title","type":"1006","background":1,"content":{"firstBook":{"bookId":1,"bookName":"@title","categoryName":"@title","score":4.8,"inLibrary":true,"description":"@paragraph","coverUpdateTime":"@timestamp"},"bookItems":[{"bookId":1,"coverUpdateTime":"@timestamp"},{"bookId":1,"coverUpdateTime":"@timestamp"}]}},{"id":"@id","title":"@title","subtitle":"@title","type":"2001","background":1,"content":[{"categoryId":1,"categoryName":"@name","totalNum":1}]},{"id":"@id","title":"@title","subtitle":"@title","type":"2002","background":1,"content":[{"bookType":0,"id":"@id","name":"@title","categoryName":"@title","coverUpdateTime":"@timestamp"}]},{"id":"@id","title":"@title","subtitle":"@title","type":"2003","background":1,"content":[{"bookType":100,"id":1,"name":"@title","categoryName":"@title","coverUpdateTime":"@timestamp"}]},{"id":"@id","title":"@title","subtitle":"@title","type":"2004","background":1,"content":[{"bookType":100,"id":1,"name":"@title","categoryName":"@title","coverUpdateTime":"@timestamp"}]},{"id":"@id","title":"@title","subtitle":"@title","type":"2005","background":1,"content":[{"comicId":1,"comicName":"@title","categoryName":"@title","coverUpdateTime":"@timestamp"}]},{"id":"@id","title":"@title","subtitle":"@title","type":"2006","startTime":"@timestamp","endTime":"@timestamp","background":1,"content":[{"bookType":100,"id":1,"name":"@title","categoryName":"@title","coverUpdateTime":"@timestamp","expireTime":1}]},{"id":"@id","title":"@title","subtitle":"@title","type":"2007","background":1,"content":[{"comicId":1,"comicName":"@title","categoryName":"@title","coverUpdateTime":"@timestamp"}]},{"id":"@id","title":"@title","subtitle":"@title","type":"3001","background":1,"content":[{"bookId":1,"bookName":"@title","categoryName":"@title","coverUpdateTime":"@timestamp"}]},{"id":"@id","title":"@title","subtitle":"@title","type":"3002","background":1,"content":[{"bookType":100,"id":1,"name":"@title","categoryName":"@title","coverUpdateTime":"@timestamp"}]},{"id":"@id","title":"@title","subtitle":"@title","type":"3003","background":1,"content":[{"tagId":1,"tagName":"@title"}]}]
     */
    blocks?: {
      /**
       * "@id"
       */
      id?: string;
      /**
       * "@title"
       */
      title?: string;
      /**
       * "@title"
       */
      subtitle?: string;
      /**
       * "1"
       */
      type?: string;
      /**
       * "@string"
       */
      background?: string;
      /**
       * [{"pageId":"111","title":"@title","subTitle":"@title","child":[{"title":"@title","subTitle":"@title","pageId":"234"}]}]
       */
      content?: {
        /**
         * "111"
         */
        pageId?: string;
        /**
         * "@title"
         */
        title?: string;
        /**
         * "@title"
         */
        subTitle?: string;
        /**
         * [{"title":"@title","subTitle":"@title","pageId":"234"}]
         */
        child?: {
          /**
           * "@title"
           */
          title?: string;
          /**
           * "@title"
           */
          subTitle?: string;
          /**
           * "234"
           */
          pageId?: string;
        }[];
      }[];
    }[];
  };
}

/**
 * 接口 [\/msiteservice\/bookcity\/index↗](https://yapi.yuewen.com/project/28/interface/api/39708) 的 **请求配置的类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/index`
 * @更新时间 `2024-08-09 15:28:19`
 */
type MsiteserviceBookcityIndexRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/msiteservice/bookcity/index",
    "data",
    string,
    "country" | "sex" | "pageId",
    false
  >
>;

/**
 * 接口 [\/msiteservice\/bookcity\/index↗](https://yapi.yuewen.com/project/28/interface/api/39708) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/index`
 * @更新时间 `2024-08-09 15:28:19`
 */
const msiteserviceBookcityIndexRequestConfig: MsiteserviceBookcityIndexRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/msiteservice/bookcity/index",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: ["country", "sex", "pageId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "msiteserviceBookcityIndex",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/msiteservice\/bookcity\/index↗](https://yapi.yuewen.com/project/28/interface/api/39708) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/index`
 * @更新时间 `2024-08-09 15:28:19`
 */
export const msiteserviceBookcityIndex = /*#__PURE__*/ (
  requestData: MsiteserviceBookcityIndexRequest,
  ...args: UserRequestRestArgs
) => {
  return request<MsiteserviceBookcityIndexResponse>(
    prepare(msiteserviceBookcityIndexRequestConfig, requestData),
    ...args
  );
};

msiteserviceBookcityIndex.requestConfig =
  msiteserviceBookcityIndexRequestConfig;

/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage↗](https://yapi.yuewen.com/project/28/interface/api/39856) 的 **请求类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage`
 * @更新时间 `2024-08-09 15:28:27`
 */
export interface MsiteserviceBookcityCountrylanguageRequest {}

/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage↗](https://yapi.yuewen.com/project/28/interface/api/39856) 的 **返回类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage`
 * @更新时间 `2024-08-09 15:28:27`
 */
export interface MsiteserviceBookcityCountrylanguageResponse {
  /**
   * [{"name":"@name","code":"CN","languages":[{"code":"EN","name":"@title"}]}]
   */
  countries?: {
    /**
     * "@name"
     */
    name?: string;
    /**
     * "CN"
     */
    code?: string;
    /**
     * [{"code":"EN","name":"@title"}]
     */
    languages?: {
      /**
       * "EN"
       */
      code?: string;
      /**
       * "@title"
       */
      name?: string;
    }[];
  }[];
}

/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage↗](https://yapi.yuewen.com/project/28/interface/api/39856) 的 **请求配置的类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage`
 * @更新时间 `2024-08-09 15:28:27`
 */
type MsiteserviceBookcityCountrylanguageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/msiteservice/bookcity/countrylanguage",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage↗](https://yapi.yuewen.com/project/28/interface/api/39856) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage`
 * @更新时间 `2024-08-09 15:28:27`
 */
const msiteserviceBookcityCountrylanguageRequestConfig: MsiteserviceBookcityCountrylanguageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/msiteservice/bookcity/countrylanguage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "msiteserviceBookcityCountrylanguage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage↗](https://yapi.yuewen.com/project/28/interface/api/39856) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage`
 * @更新时间 `2024-08-09 15:28:27`
 */
export const msiteserviceBookcityCountrylanguage = /*#__PURE__*/ (
  requestData?: MsiteserviceBookcityCountrylanguageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<MsiteserviceBookcityCountrylanguageResponse>(
    prepare(msiteserviceBookcityCountrylanguageRequestConfig, requestData),
    ...args
  );
};

msiteserviceBookcityCountrylanguage.requestConfig =
  msiteserviceBookcityCountrylanguageRequestConfig;

/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage_copy↗](https://yapi.yuewen.com/project/28/interface/api/40113) 的 **请求类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage_1551923127181`
 * @更新时间 `2019-03-07 09:45:27`
 */
export interface MsiteserviceBookcityCountrylanguage_1551923127181Request {}

/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage_copy↗](https://yapi.yuewen.com/project/28/interface/api/40113) 的 **返回类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage_1551923127181`
 * @更新时间 `2019-03-07 09:45:27`
 */
export interface MsiteserviceBookcityCountrylanguage_1551923127181Response {
  /**
   * [{"name":"@name","code":"CN","languages":[{"code":"EN","name":"@title"}]}]
   */
  countries?: {
    /**
     * "@name"
     */
    name?: string;
    /**
     * "CN"
     */
    code?: string;
    /**
     * [{"code":"EN","name":"@title"}]
     */
    languages?: {
      /**
       * "EN"
       */
      code?: string;
      /**
       * "@title"
       */
      name?: string;
    }[];
  }[];
}

/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage_copy↗](https://yapi.yuewen.com/project/28/interface/api/40113) 的 **请求配置的类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage_1551923127181`
 * @更新时间 `2019-03-07 09:45:27`
 */
type MsiteserviceBookcityCountrylanguage_1551923127181RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/msiteservice/bookcity/countrylanguage_1551923127181",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage_copy↗](https://yapi.yuewen.com/project/28/interface/api/40113) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage_1551923127181`
 * @更新时间 `2019-03-07 09:45:27`
 */
const msiteserviceBookcityCountrylanguage_1551923127181RequestConfig: MsiteserviceBookcityCountrylanguage_1551923127181RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/msiteservice/bookcity/countrylanguage_1551923127181",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "msiteserviceBookcityCountrylanguage_1551923127181",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage_copy↗](https://yapi.yuewen.com/project/28/interface/api/40113) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage_1551923127181`
 * @更新时间 `2019-03-07 09:45:27`
 */
export const msiteserviceBookcityCountrylanguage_1551923127181 = /*#__PURE__*/ (
  requestData?: MsiteserviceBookcityCountrylanguage_1551923127181Request,
  ...args: UserRequestRestArgs
) => {
  return request<MsiteserviceBookcityCountrylanguage_1551923127181Response>(
    prepare(
      msiteserviceBookcityCountrylanguage_1551923127181RequestConfig,
      requestData
    ),
    ...args
  );
};

msiteserviceBookcityCountrylanguage_1551923127181.requestConfig =
  msiteserviceBookcityCountrylanguage_1551923127181RequestConfig;

/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/28/interface/api/166290) 的 **请求类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2020-10-23 11:57:13`
 */
export interface GoPcmUserGetFirstChargeRequest {}

/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/28/interface/api/166290) 的 **返回类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2020-10-23 11:57:13`
 */
export interface GoPcmUserGetFirstChargeResponse {
  giftsBubbleStatus?: number;
  /**
   * 1
   */
  awardStatus?: number;
  /**
   * [{"awardType":"7","name":"@string","amount":0,"id":"@id","updateTime":"@timestamp","bookInfo":{"novelType":[0,100],"bookId":"116236514531205","bookName":"@string","bookCoverId":"@id"}}]
   */
  awards?: {
    /**
     * "7"
     */
    awardType?: string;
    /**
     * "@string"
     */
    name?: string;
    amount?: number;
    /**
     * "@id"
     */
    id?: string;
    /**
     * "@timestamp"
     */
    updateTime?: string;
    bookInfo?: {
      /**
       * [0,100]
       */
      novelType?: number[];
      /**
       * "116236514531205"
       */
      bookId?: string;
      /**
       * "@string"
       */
      bookName?: string;
      /**
       * "@id"
       */
      bookCoverId?: string;
    };
  }[];
}

/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/28/interface/api/166290) 的 **请求配置的类型**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2020-10-23 11:57:13`
 */
type GoPcmUserGetFirstChargeRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/user/get-first-charge",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/28/interface/api/166290) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2020-10-23 11:57:13`
 */
const goPcmUserGetFirstChargeRequestConfig: GoPcmUserGetFirstChargeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/go/pcm/user/get-first-charge",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetFirstCharge",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/28/interface/api/166290) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2020-10-23 11:57:13`
 */
export const goPcmUserGetFirstCharge = /*#__PURE__*/ (
  requestData?: GoPcmUserGetFirstChargeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetFirstChargeResponse>(
    prepare(goPcmUserGetFirstChargeRequestConfig, requestData),
    ...args
  );
};

goPcmUserGetFirstCharge.requestConfig = goPcmUserGetFirstChargeRequestConfig;

const mockUrl_0_1_0_30 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_30 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_30 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_30 = "data" as any;

/**
 * 接口 [登录回调↗](https://yapi.yuewen.com/project/28/interface/api/969) 的 **请求类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/redirect`
 * @更新时间 `2019-01-08 15:05:27`
 */
export interface AjaxLoginRedirectRequest {
  /**
   * 用户的GUID
   */
  guid: string;
  /**
   * ptlogin登录回调给login/callback页面的ticket字段
   */
  ticket: string;
}

/**
 * 接口 [登录回调↗](https://yapi.yuewen.com/project/28/interface/api/969) 的 **返回类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/redirect`
 * @更新时间 `2019-01-08 15:05:27`
 */
export interface AjaxLoginRedirectResponse {
  /**
   * [0]
   */
  code?: number[];
}

/**
 * 接口 [登录回调↗](https://yapi.yuewen.com/project/28/interface/api/969) 的 **请求配置的类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/redirect`
 * @更新时间 `2019-01-08 15:05:27`
 */
type AjaxLoginRedirectRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/login/redirect",
    "data",
    string,
    "guid" | "ticket",
    false
  >
>;

/**
 * 接口 [登录回调↗](https://yapi.yuewen.com/project/28/interface/api/969) 的 **请求配置**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/redirect`
 * @更新时间 `2019-01-08 15:05:27`
 */
const ajaxLoginRedirectRequestConfig: AjaxLoginRedirectRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_30,
    devUrl: devUrl_0_1_0_30,
    prodUrl: prodUrl_0_1_0_30,
    path: "/ajax/login/redirect",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_30,
    paramNames: [],
    queryNames: ["guid", "ticket"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLoginRedirect",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [登录回调↗](https://yapi.yuewen.com/project/28/interface/api/969) 的 **请求函数**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/redirect`
 * @更新时间 `2019-01-08 15:05:27`
 */
export const ajaxLoginRedirect = /*#__PURE__*/ (
  requestData: AjaxLoginRedirectRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxLoginRedirectResponse>(
    prepare(ajaxLoginRedirectRequestConfig, requestData),
    ...args
  );
};

ajaxLoginRedirect.requestConfig = ajaxLoginRedirectRequestConfig;

/**
 * 接口 [获取登录者第三方信息↗](https://yapi.yuewen.com/project/28/interface/api/974) 的 **请求类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/getThirdPartyInfo`
 * @更新时间 `2019-01-08 15:08:11`
 */
export interface AjaxLoginGetThirdPartyInfoRequest {}

/**
 * 接口 [获取登录者第三方信息↗](https://yapi.yuewen.com/project/28/interface/api/974) 的 **返回类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/getThirdPartyInfo`
 * @更新时间 `2019-01-08 15:08:11`
 */
export interface AjaxLoginGetThirdPartyInfoResponse {
  /**
   * [0,3100,3101,-2]
   */
  status?: number[];
  user?: {
    /**
     * "@image"
     */
    avatar?: string;
    /**
     * "@name"
     */
    oldNickName?: string;
  };
}

/**
 * 接口 [获取登录者第三方信息↗](https://yapi.yuewen.com/project/28/interface/api/974) 的 **请求配置的类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/getThirdPartyInfo`
 * @更新时间 `2019-01-08 15:08:11`
 */
type AjaxLoginGetThirdPartyInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/login/getThirdPartyInfo",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取登录者第三方信息↗](https://yapi.yuewen.com/project/28/interface/api/974) 的 **请求配置**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/getThirdPartyInfo`
 * @更新时间 `2019-01-08 15:08:11`
 */
const ajaxLoginGetThirdPartyInfoRequestConfig: AjaxLoginGetThirdPartyInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_30,
    devUrl: devUrl_0_1_0_30,
    prodUrl: prodUrl_0_1_0_30,
    path: "/ajax/login/getThirdPartyInfo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLoginGetThirdPartyInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取登录者第三方信息↗](https://yapi.yuewen.com/project/28/interface/api/974) 的 **请求函数**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/getThirdPartyInfo`
 * @更新时间 `2019-01-08 15:08:11`
 */
export const ajaxLoginGetThirdPartyInfo = /*#__PURE__*/ (
  requestData?: AjaxLoginGetThirdPartyInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxLoginGetThirdPartyInfoResponse>(
    prepare(ajaxLoginGetThirdPartyInfoRequestConfig, requestData),
    ...args
  );
};

ajaxLoginGetThirdPartyInfo.requestConfig =
  ajaxLoginGetThirdPartyInfoRequestConfig;

/**
 * 接口 [激活第三方登录用户↗](https://yapi.yuewen.com/project/28/interface/api/980) 的 **请求类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/login/checkAndActivate`
 * @更新时间 `2019-01-08 15:10:26`
 */
export interface AjaxLoginCheckAndActivateRequest {
  /**
   * 可修改，不要重复
   */
  userName: string;
  /**
   * 用户第三方头像地址
   */
  avatar: string;
  /**
   * 非必需
   */
  loginType?: string;
}

/**
 * 接口 [激活第三方登录用户↗](https://yapi.yuewen.com/project/28/interface/api/980) 的 **返回类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/login/checkAndActivate`
 * @更新时间 `2019-01-08 15:10:26`
 */
export interface AjaxLoginCheckAndActivateResponse {
  code?: number;
}

/**
 * 接口 [激活第三方登录用户↗](https://yapi.yuewen.com/project/28/interface/api/980) 的 **请求配置的类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/login/checkAndActivate`
 * @更新时间 `2019-01-08 15:10:26`
 */
type AjaxLoginCheckAndActivateRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/login/checkAndActivate",
    "data",
    string,
    "userName" | "avatar" | "loginType",
    false
  >
>;

/**
 * 接口 [激活第三方登录用户↗](https://yapi.yuewen.com/project/28/interface/api/980) 的 **请求配置**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/login/checkAndActivate`
 * @更新时间 `2019-01-08 15:10:26`
 */
const ajaxLoginCheckAndActivateRequestConfig: AjaxLoginCheckAndActivateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_30,
    devUrl: devUrl_0_1_0_30,
    prodUrl: prodUrl_0_1_0_30,
    path: "/ajax/login/checkAndActivate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_30,
    paramNames: [],
    queryNames: ["userName", "avatar", "loginType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLoginCheckAndActivate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [激活第三方登录用户↗](https://yapi.yuewen.com/project/28/interface/api/980) 的 **请求函数**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/login/checkAndActivate`
 * @更新时间 `2019-01-08 15:10:26`
 */
export const ajaxLoginCheckAndActivate = /*#__PURE__*/ (
  requestData: AjaxLoginCheckAndActivateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxLoginCheckAndActivateResponse>(
    prepare(ajaxLoginCheckAndActivateRequestConfig, requestData),
    ...args
  );
};

ajaxLoginCheckAndActivate.requestConfig =
  ajaxLoginCheckAndActivateRequestConfig;

/**
 * 接口 [设置偏好 saveTags↗](https://yapi.yuewen.com/project/28/interface/api/26760) 的 **请求类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/activity/saveTags`
 * @更新时间 `2019-01-08 15:11:50`
 */
export interface AjaxActivitySaveTagsRequest {}

/**
 * 接口 [设置偏好 saveTags↗](https://yapi.yuewen.com/project/28/interface/api/26760) 的 **返回类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/activity/saveTags`
 * @更新时间 `2019-01-08 15:11:50`
 */
export interface AjaxActivitySaveTagsResponse {
  code?: number;
}

/**
 * 接口 [设置偏好 saveTags↗](https://yapi.yuewen.com/project/28/interface/api/26760) 的 **请求配置的类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/activity/saveTags`
 * @更新时间 `2019-01-08 15:11:50`
 */
type AjaxActivitySaveTagsRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/activity/saveTags",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [设置偏好 saveTags↗](https://yapi.yuewen.com/project/28/interface/api/26760) 的 **请求配置**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/activity/saveTags`
 * @更新时间 `2019-01-08 15:11:50`
 */
const ajaxActivitySaveTagsRequestConfig: AjaxActivitySaveTagsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_30,
    devUrl: devUrl_0_1_0_30,
    prodUrl: prodUrl_0_1_0_30,
    path: "/ajax/activity/saveTags",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxActivitySaveTags",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [设置偏好 saveTags↗](https://yapi.yuewen.com/project/28/interface/api/26760) 的 **请求函数**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/activity/saveTags`
 * @更新时间 `2019-01-08 15:11:50`
 */
export const ajaxActivitySaveTags = /*#__PURE__*/ (
  requestData?: AjaxActivitySaveTagsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxActivitySaveTagsResponse>(
    prepare(ajaxActivitySaveTagsRequestConfig, requestData),
    ...args
  );
};

ajaxActivitySaveTags.requestConfig = ajaxActivitySaveTagsRequestConfig;

/**
 * 接口 [新登录接口（m3.7.0）↗](https://yapi.yuewen.com/project/28/interface/api/51517) 的 **请求类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/login`
 * @更新时间 `2019-05-16 12:16:46`
 */
export interface AjaxLoginLoginRequest {
  /**
   * 用户uid
   */
  guid: string;
  /**
   * 鉴权ticket
   */
  ticket: string;
  /**
   * csrf
   */
  _csrfToken: string;
}

/**
 * 接口 [新登录接口（m3.7.0）↗](https://yapi.yuewen.com/project/28/interface/api/51517) 的 **返回类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/login`
 * @更新时间 `2019-05-16 12:16:46`
 */
export interface AjaxLoginLoginResponse {
  loginInfo?: {};
}

/**
 * 接口 [新登录接口（m3.7.0）↗](https://yapi.yuewen.com/project/28/interface/api/51517) 的 **请求配置的类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/login`
 * @更新时间 `2019-05-16 12:16:46`
 */
type AjaxLoginLoginRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/login/login",
    "data",
    string,
    "guid" | "ticket" | "_csrfToken",
    false
  >
>;

/**
 * 接口 [新登录接口（m3.7.0）↗](https://yapi.yuewen.com/project/28/interface/api/51517) 的 **请求配置**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/login`
 * @更新时间 `2019-05-16 12:16:46`
 */
const ajaxLoginLoginRequestConfig: AjaxLoginLoginRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_1_0_30,
  devUrl: devUrl_0_1_0_30,
  prodUrl: prodUrl_0_1_0_30,
  path: "/ajax/login/login",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_1_0_30,
  paramNames: [],
  queryNames: ["guid", "ticket", "_csrfToken"],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "ajaxLoginLogin",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [新登录接口（m3.7.0）↗](https://yapi.yuewen.com/project/28/interface/api/51517) 的 **请求函数**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/login`
 * @更新时间 `2019-05-16 12:16:46`
 */
export const ajaxLoginLogin = /*#__PURE__*/ (
  requestData: AjaxLoginLoginRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxLoginLoginResponse>(
    prepare(ajaxLoginLoginRequestConfig, requestData),
    ...args
  );
};

ajaxLoginLogin.requestConfig = ajaxLoginLoginRequestConfig;

/**
 * 接口 [从客户端登录接口↗](https://yapi.yuewen.com/project/28/interface/api/116050) 的 **请求类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /go/pcm/login/fromApp`
 * @更新时间 `2020-07-14 20:53:20`
 */
export interface GoPcmLoginFromAppRequest {
  /**
   * 用户uid
   */
  guid: string;
  /**
   * 鉴权ticket
   */
  ticket: string;
  /**
   * csrf
   */
  _csrfToken: string;
}

/**
 * 接口 [从客户端登录接口↗](https://yapi.yuewen.com/project/28/interface/api/116050) 的 **返回类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /go/pcm/login/fromApp`
 * @更新时间 `2020-07-14 20:53:20`
 */
export interface GoPcmLoginFromAppResponse {}

/**
 * 接口 [从客户端登录接口↗](https://yapi.yuewen.com/project/28/interface/api/116050) 的 **请求配置的类型**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /go/pcm/login/fromApp`
 * @更新时间 `2020-07-14 20:53:20`
 */
type GoPcmLoginFromAppRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/login/fromApp",
    "data",
    string,
    "guid" | "ticket" | "_csrfToken",
    false
  >
>;

/**
 * 接口 [从客户端登录接口↗](https://yapi.yuewen.com/project/28/interface/api/116050) 的 **请求配置**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /go/pcm/login/fromApp`
 * @更新时间 `2020-07-14 20:53:20`
 */
const goPcmLoginFromAppRequestConfig: GoPcmLoginFromAppRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_30,
    devUrl: devUrl_0_1_0_30,
    prodUrl: prodUrl_0_1_0_30,
    path: "/go/pcm/login/fromApp",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_30,
    paramNames: [],
    queryNames: ["guid", "ticket", "_csrfToken"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLoginFromApp",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [从客户端登录接口↗](https://yapi.yuewen.com/project/28/interface/api/116050) 的 **请求函数**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /go/pcm/login/fromApp`
 * @更新时间 `2020-07-14 20:53:20`
 */
export const goPcmLoginFromApp = /*#__PURE__*/ (
  requestData: GoPcmLoginFromAppRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmLoginFromAppResponse>(
    prepare(goPcmLoginFromAppRequestConfig, requestData),
    ...args
  );
};

goPcmLoginFromApp.requestConfig = goPcmLoginFromAppRequestConfig;

const mockUrl_0_1_0_31 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_31 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_31 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_31 = "data" as any;

/**
 * 接口 [举报书籍或者用户↗](https://yapi.yuewen.com/project/28/interface/api/1075) 的 **请求类型**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/report/reportUserOrBook`
 * @更新时间 `2018-03-27 10:17:32`
 */
export interface AjaxReportReportUserOrBookRequest {
  /**
   * 1-举报用户  2-举报书籍
   */
  type: string;
  /**
   * 用户guid 或 bookId
   */
  reportId: string;
  /**
   * 举报理由（选项内容
   */
  reportReason: string;
  /**
   * 举报详细描述（用户自填）
   */
  reportDesc: string;
}

/**
 * 接口 [举报书籍或者用户↗](https://yapi.yuewen.com/project/28/interface/api/1075) 的 **返回类型**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/report/reportUserOrBook`
 * @更新时间 `2018-03-27 10:17:32`
 */
export interface AjaxReportReportUserOrBookResponse {}

/**
 * 接口 [举报书籍或者用户↗](https://yapi.yuewen.com/project/28/interface/api/1075) 的 **请求配置的类型**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/report/reportUserOrBook`
 * @更新时间 `2018-03-27 10:17:32`
 */
type AjaxReportReportUserOrBookRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/report/reportUserOrBook",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [举报书籍或者用户↗](https://yapi.yuewen.com/project/28/interface/api/1075) 的 **请求配置**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/report/reportUserOrBook`
 * @更新时间 `2018-03-27 10:17:32`
 */
const ajaxReportReportUserOrBookRequestConfig: AjaxReportReportUserOrBookRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_31,
    devUrl: devUrl_0_1_0_31,
    prodUrl: prodUrl_0_1_0_31,
    path: "/ajax/report/reportUserOrBook",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReportReportUserOrBook",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [举报书籍或者用户↗](https://yapi.yuewen.com/project/28/interface/api/1075) 的 **请求函数**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/report/reportUserOrBook`
 * @更新时间 `2018-03-27 10:17:32`
 */
export const ajaxReportReportUserOrBook = /*#__PURE__*/ (
  requestData: AjaxReportReportUserOrBookRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxReportReportUserOrBookResponse>(
    prepare(ajaxReportReportUserOrBookRequestConfig, requestData),
    ...args
  );
};

ajaxReportReportUserOrBook.requestConfig =
  ajaxReportReportUserOrBookRequestConfig;

/**
 * 接口 [举报留言↗](https://yapi.yuewen.com/project/28/interface/api/3115) 的 **请求类型**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/review/AddReviewReportAjax`
 * @更新时间 `2018-04-23 16:26:24`
 */
export interface AjaxReviewAddReviewReportAjaxRequest {
  bookId: number;
  reviewId: number;
  againstUserId: number;
  type: string;
  content?: string;
}

/**
 * 接口 [举报留言↗](https://yapi.yuewen.com/project/28/interface/api/3115) 的 **返回类型**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/review/AddReviewReportAjax`
 * @更新时间 `2018-04-23 16:26:24`
 */
export interface AjaxReviewAddReviewReportAjaxResponse {
  content?: string;
  reviewId?: number;
  user?: {
    avatar?: null;
    nickName?: null;
    guid?: string;
    status?: number;
  };
}

/**
 * 接口 [举报留言↗](https://yapi.yuewen.com/project/28/interface/api/3115) 的 **请求配置的类型**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/review/AddReviewReportAjax`
 * @更新时间 `2018-04-23 16:26:24`
 */
type AjaxReviewAddReviewReportAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/review/AddReviewReportAjax",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [举报留言↗](https://yapi.yuewen.com/project/28/interface/api/3115) 的 **请求配置**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/review/AddReviewReportAjax`
 * @更新时间 `2018-04-23 16:26:24`
 */
const ajaxReviewAddReviewReportAjaxRequestConfig: AjaxReviewAddReviewReportAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_31,
    devUrl: devUrl_0_1_0_31,
    prodUrl: prodUrl_0_1_0_31,
    path: "/ajax/review/AddReviewReportAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewAddReviewReportAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [举报留言↗](https://yapi.yuewen.com/project/28/interface/api/3115) 的 **请求函数**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/review/AddReviewReportAjax`
 * @更新时间 `2018-04-23 16:26:24`
 */
export const ajaxReviewAddReviewReportAjax = /*#__PURE__*/ (
  requestData: AjaxReviewAddReviewReportAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxReviewAddReviewReportAjaxResponse>(
    prepare(ajaxReviewAddReviewReportAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxReviewAddReviewReportAjax.requestConfig =
  ajaxReviewAddReviewReportAjaxRequestConfig;

/**
 * 接口 [举报章节留言↗](https://yapi.yuewen.com/project/28/interface/api/3122) 的 **请求类型**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/chapterReview/report`
 * @更新时间 `2018-04-23 16:31:06`
 */
export interface AjaxChapterReviewReportRequest {
  bookId: number;
  chapterId: number;
  reviewId: number;
  againstUserId: number;
  type: string;
  content?: string;
}

/**
 * 接口 [举报章节留言↗](https://yapi.yuewen.com/project/28/interface/api/3122) 的 **返回类型**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/chapterReview/report`
 * @更新时间 `2018-04-23 16:31:06`
 */
export interface AjaxChapterReviewReportResponse {
  code: number;
  msg: string;
}

/**
 * 接口 [举报章节留言↗](https://yapi.yuewen.com/project/28/interface/api/3122) 的 **请求配置的类型**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/chapterReview/report`
 * @更新时间 `2018-04-23 16:31:06`
 */
type AjaxChapterReviewReportRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/chapterReview/report",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [举报章节留言↗](https://yapi.yuewen.com/project/28/interface/api/3122) 的 **请求配置**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/chapterReview/report`
 * @更新时间 `2018-04-23 16:31:06`
 */
const ajaxChapterReviewReportRequestConfig: AjaxChapterReviewReportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_31,
    devUrl: devUrl_0_1_0_31,
    prodUrl: prodUrl_0_1_0_31,
    path: "/ajax/chapterReview/report",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterReviewReport",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [举报章节留言↗](https://yapi.yuewen.com/project/28/interface/api/3122) 的 **请求函数**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/chapterReview/report`
 * @更新时间 `2018-04-23 16:31:06`
 */
export const ajaxChapterReviewReport = /*#__PURE__*/ (
  requestData: AjaxChapterReviewReportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxChapterReviewReportResponse>(
    prepare(ajaxChapterReviewReportRequestConfig, requestData),
    ...args
  );
};

ajaxChapterReviewReport.requestConfig = ajaxChapterReviewReportRequestConfig;

/**
 * 接口 [举报评论 （书 章 段）↗](https://yapi.yuewen.com/project/28/interface/api/118271) 的 **请求类型**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /go/pcm/bookReviw/report`
 * @更新时间 `2020-08-03 11:35:14`
 */
export interface GoPcmBookReviwReportRequest {
  bookId: number;
  /**
   * 除了书评必传
   */
  chapterId?: number;
  reviewId: number;
  /**
   *  1- advertise; 2 - Porn; 3- Personal attack; 0 - other
   */
  type: string;
  /**
   * 举报原因
   */
  content?: string;
  /**
   * 1 书评 2 章评 3 段评
   */
  commentType: number;
}

/**
 * 接口 [举报评论 （书 章 段）↗](https://yapi.yuewen.com/project/28/interface/api/118271) 的 **返回类型**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /go/pcm/bookReviw/report`
 * @更新时间 `2020-08-03 11:35:14`
 */
export interface GoPcmBookReviwReportResponse {
  code: number;
  msg: string;
}

/**
 * 接口 [举报评论 （书 章 段）↗](https://yapi.yuewen.com/project/28/interface/api/118271) 的 **请求配置的类型**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /go/pcm/bookReviw/report`
 * @更新时间 `2020-08-03 11:35:14`
 */
type GoPcmBookReviwReportRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/bookReviw/report",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [举报评论 （书 章 段）↗](https://yapi.yuewen.com/project/28/interface/api/118271) 的 **请求配置**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /go/pcm/bookReviw/report`
 * @更新时间 `2020-08-03 11:35:14`
 */
const goPcmBookReviwReportRequestConfig: GoPcmBookReviwReportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_31,
    devUrl: devUrl_0_1_0_31,
    prodUrl: prodUrl_0_1_0_31,
    path: "/go/pcm/bookReviw/report",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviwReport",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [举报评论 （书 章 段）↗](https://yapi.yuewen.com/project/28/interface/api/118271) 的 **请求函数**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /go/pcm/bookReviw/report`
 * @更新时间 `2020-08-03 11:35:14`
 */
export const goPcmBookReviwReport = /*#__PURE__*/ (
  requestData: GoPcmBookReviwReportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookReviwReportResponse>(
    prepare(goPcmBookReviwReportRequestConfig, requestData),
    ...args
  );
};

goPcmBookReviwReport.requestConfig = goPcmBookReviwReportRequestConfig;

const mockUrl_0_1_0_32 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_32 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_32 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_32 = "data" as any;

/**
 * 接口 [Power and energy bills↗](https://yapi.yuewen.com/project/28/interface/api/44) 的 **请求类型**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/stoneDetailAjax`
 * @更新时间 `2019-09-16 18:47:08`
 */
export interface AjaxStoneStoneDetailAjaxRequest {
  pageIndex: string;
  /**
   * 1为 energy 2 为 power
   */
  type: string;
}

/**
 * 接口 [Power and energy bills↗](https://yapi.yuewen.com/project/28/interface/api/44) 的 **返回类型**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/stoneDetailAjax`
 * @更新时间 `2019-09-16 18:47:08`
 */
export interface AjaxStoneStoneDetailAjaxResponse {
  stoneInfo?: {
    /**
     * 3
     */
    totalEnergy?: number;
    availableEnergy?: number;
    /**
     * 3
     */
    totalPower?: number;
    availablePower?: number;
    /**
     * 1000
     */
    leftTimestamp?: number;
  };
  /**
   * [{"bookId":"@id","bookName":"@title","time":"2017-06-10 12:00","platform":"@title","bookType":0}]
   */
  items?: {
    /**
     * "@id"
     */
    bookId?: string;
    /**
     * "@title"
     */
    bookName?: string;
    /**
     * "2017-06-10 12:00"
     */
    time?: string;
    /**
     * "@title"
     */
    platform?: string;
    bookType?: number;
  }[];
  /**
   * 200
   */
  total?: number;
  isLast?: boolean;
  /**
   * 1
   */
  type?: number;
}

/**
 * 接口 [Power and energy bills↗](https://yapi.yuewen.com/project/28/interface/api/44) 的 **请求配置的类型**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/stoneDetailAjax`
 * @更新时间 `2019-09-16 18:47:08`
 */
type AjaxStoneStoneDetailAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/stone/stoneDetailAjax",
    "data",
    string,
    "pageIndex" | "type",
    false
  >
>;

/**
 * 接口 [Power and energy bills↗](https://yapi.yuewen.com/project/28/interface/api/44) 的 **请求配置**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/stoneDetailAjax`
 * @更新时间 `2019-09-16 18:47:08`
 */
const ajaxStoneStoneDetailAjaxRequestConfig: AjaxStoneStoneDetailAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_32,
    devUrl: devUrl_0_1_0_32,
    prodUrl: prodUrl_0_1_0_32,
    path: "/ajax/stone/stoneDetailAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_32,
    paramNames: [],
    queryNames: ["pageIndex", "type"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxStoneStoneDetailAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [Power and energy bills↗](https://yapi.yuewen.com/project/28/interface/api/44) 的 **请求函数**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/stoneDetailAjax`
 * @更新时间 `2019-09-16 18:47:08`
 */
export const ajaxStoneStoneDetailAjax = /*#__PURE__*/ (
  requestData: AjaxStoneStoneDetailAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxStoneStoneDetailAjaxResponse>(
    prepare(ajaxStoneStoneDetailAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxStoneStoneDetailAjax.requestConfig = ajaxStoneStoneDetailAjaxRequestConfig;

/**
 * 接口 [page\/stone\/getPowerStoneRankingByBookId↗](https://yapi.yuewen.com/project/28/interface/api/12353) 的 **请求类型**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /page/stone/getPowerStoneRankingByBookId?bookId`
 * @更新时间 `2018-08-10 10:52:21`
 */
export interface PageStoneGetPowerStoneRankingByBookIdBookIdRequest {}

/**
 * 接口 [page\/stone\/getPowerStoneRankingByBookId↗](https://yapi.yuewen.com/project/28/interface/api/12353) 的 **返回类型**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /page/stone/getPowerStoneRankingByBookId?bookId`
 * @更新时间 `2018-08-10 10:52:21`
 */
export interface PageStoneGetPowerStoneRankingByBookIdBookIdResponse {
  /**
   * [{"userId":4300000437,"votingCount":4,"ranking":1,"UUT":1527132787000,"userName":"LANEYU"},{"userId":2959616949,"votingCount":4,"ranking":2,"UUT":1532403187000,"userName":"Eason057"},{"userId":4300000208,"votingCount":3,"ranking":3,"UUT":1532690675000,"userName":"lily7"},{"userId":4300000431,"votingCount":2,"ranking":4,"UUT":1529404645377,"userName":"zhouxiyuan"},{"userId":41830698,"votingCount":2,"ranking":5,"UUT":1527506684000,"userName":"clarkzhang12"},{"userId":2091082857,"votingCount":2,"ranking":6,"UUT":1526027482031,"userName":"364774did"},{"userId":1520658766,"votingCount":2,"ranking":7,"UUT":1531297247000,"userName":"zhangdroid2423"},{"userId":4300000461,"votingCount":1,"ranking":8,"UUT":1532486071994,"userName":"LaneTest"},{"userId":4300000447,"votingCount":1,"ranking":9,"UUT":1528959533000,"userName":"iPhone8"},{"userId":4300000213,"votingCount":1,"ranking":10,"UUT":1531201554000,"userName":"taozi"},{"userId":4300000183,"votingCount":1,"ranking":11,"UUT":1524827921546,"userName":"LaneYu24"},{"userId":3968405415,"votingCount":1,"ranking":12,"UUT":1530701317000,"userName":"jennyrenjialele5"},{"userId":3937651180,"votingCount":1,"ranking":13,"UUT":1528264648000,"userName":"Zyy56"},{"userId":3892951244,"votingCount":1,"ranking":14,"UUT":1509601774217,"userName":"clark"},{"userId":3627871248,"votingCount":1,"ranking":15,"UUT":1514354221000,"userName":"1111qq"},{"userId":2140464915,"votingCount":1,"ranking":16,"UUT":1519453276000,"userName":"jumping656"},{"userId":2140047512,"votingCount":1,"ranking":17,"UUT":1527044971000,"userName":"Eeee"},{"userId":1901271742,"votingCount":1,"ranking":18,"UUT":1527768885000,"userName":"Amy023"}]
   */
  items?: {
    /**
     * 4300000437
     */
    userId?: number;
    /**
     * 4
     */
    votingCount?: number;
    /**
     * 1
     */
    ranking?: number;
    /**
     * 1527132787000
     */
    UUT?: number;
    /**
     * "LANEYU"
     */
    userName?: string;
  }[];
  my?: {
    /**
     * 1
     */
    votingCount?: number;
    /**
     * 14
     */
    ranking?: number;
  };
  /**
   * 18
   */
  total?: number;
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 20
   */
  pageSize?: number;
  /**
   * 1
   */
  isLast?: number;
  user?: {
    /**
     * "3892951244"
     */
    guid?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/1/1/1.png?mt=1509601774217"
     */
    avatar?: string;
    /**
     * "clark"
     */
    userName?: string;
    nickName?: null;
    penName?: string;
    role?: number;
    status?: number;
    /**
     * 4799
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 2
     */
    userLevel?: number;
    /**
     * 1
     */
    availablePower?: number;
    /**
     * 1
     */
    totalPower?: number;
    /**
     * 1
     */
    availableEnergy?: number;
    /**
     * 1
     */
    totalEnergy?: number;
    /**
     * 1
     */
    emailStatus?: number;
    /**
     * 1509601774217
     */
    mt?: number;
    /**
     * 1509601774217
     */
    UUT?: number;
  };
}

/**
 * 接口 [page\/stone\/getPowerStoneRankingByBookId↗](https://yapi.yuewen.com/project/28/interface/api/12353) 的 **请求配置的类型**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /page/stone/getPowerStoneRankingByBookId?bookId`
 * @更新时间 `2018-08-10 10:52:21`
 */
type PageStoneGetPowerStoneRankingByBookIdBookIdRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/page/stone/getPowerStoneRankingByBookId?bookId",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [page\/stone\/getPowerStoneRankingByBookId↗](https://yapi.yuewen.com/project/28/interface/api/12353) 的 **请求配置**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /page/stone/getPowerStoneRankingByBookId?bookId`
 * @更新时间 `2018-08-10 10:52:21`
 */
const pageStoneGetPowerStoneRankingByBookIdBookIdRequestConfig: PageStoneGetPowerStoneRankingByBookIdBookIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_32,
    devUrl: devUrl_0_1_0_32,
    prodUrl: prodUrl_0_1_0_32,
    path: "/page/stone/getPowerStoneRankingByBookId?bookId",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_32,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageStoneGetPowerStoneRankingByBookIdBookId",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [page\/stone\/getPowerStoneRankingByBookId↗](https://yapi.yuewen.com/project/28/interface/api/12353) 的 **请求函数**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /page/stone/getPowerStoneRankingByBookId?bookId`
 * @更新时间 `2018-08-10 10:52:21`
 */
export const pageStoneGetPowerStoneRankingByBookIdBookId = /*#__PURE__*/ (
  requestData?: PageStoneGetPowerStoneRankingByBookIdBookIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PageStoneGetPowerStoneRankingByBookIdBookIdResponse>(
    prepare(
      pageStoneGetPowerStoneRankingByBookIdBookIdRequestConfig,
      requestData
    ),
    ...args
  );
};

pageStoneGetPowerStoneRankingByBookIdBookId.requestConfig =
  pageStoneGetPowerStoneRankingByBookIdBookIdRequestConfig;

/**
 * 接口 [ajax\/stone\/getPowerStoneRankingByBookIdList↗](https://yapi.yuewen.com/project/28/interface/api/12374) 的 **请求类型**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2019-05-05 14:23:23`
 */
export interface AjaxStoneGetPowerStoneRankingByBookIdListRequest {
  pageIndex: string;
  _csrfToken: string;
}

/**
 * 接口 [ajax\/stone\/getPowerStoneRankingByBookIdList↗](https://yapi.yuewen.com/project/28/interface/api/12374) 的 **返回类型**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2019-05-05 14:23:23`
 */
export interface AjaxStoneGetPowerStoneRankingByBookIdListResponse {
  /**
   * [{"userId":4300000216,"votingCount":7,"ranking":1,"appId":10,"UUT":1554284030000,"userName":"ghhjvjjjk"},{"userId":4300000213,"votingCount":5,"ranking":2,"appId":10,"UUT":1547607296000,"userName":"taozi"},{"userId":4060368390,"votingCount":5,"ranking":3,"appId":10,"UUT":1548308522000,"userName":"Amy4060368390y"},{"userId":2140464915,"votingCount":5,"ranking":4,"appId":10,"UUT":1551255485000,"userName":"1231"},{"userId":4300000298,"votingCount":4,"ranking":5,"appId":10,"UUT":1536298168000,"userName":"aaaa"},{"userId":4300000120,"votingCount":4,"ranking":6,"appId":10,"UUT":1553072138000,"userName":"bigcat004"},{"userId":2959616949,"votingCount":4,"ranking":7,"appId":10,"UUT":1539936723000,"userName":"Eason057"},{"userId":4060368390,"votingCount":3,"ranking":8,"appId":20,"UUT":1551943842000,"userName":"jimy233"},{"userId":4300000390,"votingCount":3,"ranking":9,"appId":10,"UUT":1547805199000,"userName":"Candy"},{"userId":1059463888,"votingCount":3,"ranking":10,"appId":10,"UUT":1542710966000,"userName":"xujin0515"},{"userId":101087995,"votingCount":3,"ranking":11,"appId":10,"UUT":1539950384000,"userName":"garden6cg"},{"userId":1901271742,"votingCount":2,"ranking":12,"appId":20,"UUT":1551962369000,"userName":"22491242"},{"userId":4300757143,"votingCount":2,"ranking":13,"appId":10},{"userId":4300001157,"votingCount":2,"ranking":14,"appId":10,"UUT":1547618377000,"userName":"23423Vghj"},{"userId":4300000296,"votingCount":2,"ranking":15,"appId":10,"UUT":1540359410861,"userName":"ChenJieTest005"},{"userId":41830698,"votingCount":2,"ranking":16,"appId":10,"UUT":1551407418000,"userName":"clarkzhangss"},{"userId":1901271742,"votingCount":2,"ranking":17,"appId":10,"UUT":1556250655000,"userName":"testingya"},{"userId":4300757143,"votingCount":1,"ranking":18,"appId":20},{"userId":4300758143,"votingCount":1,"ranking":19,"appId":10},{"userId":4300240255,"votingCount":1,"ranking":20,"appId":10}]
   */
  items?: {
    /**
     * 4300000216
     */
    userId?: number;
    /**
     * 7
     */
    votingCount?: number;
    /**
     * 1
     */
    ranking?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1554284030000
     */
    UUT?: number;
    /**
     * "ghhjvjjjk"
     */
    userName?: string;
  }[];
  my?: {
    /**
     * 4
     */
    votingCount?: number;
    /**
     * 6
     */
    ranking?: number;
  };
  /**
   * 34
   */
  total?: number;
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 20
   */
  pageSize?: number;
  isLast?: number;
}

/**
 * 接口 [ajax\/stone\/getPowerStoneRankingByBookIdList↗](https://yapi.yuewen.com/project/28/interface/api/12374) 的 **请求配置的类型**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2019-05-05 14:23:23`
 */
type AjaxStoneGetPowerStoneRankingByBookIdListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/stone/getPowerStoneRankingByBookIdList",
    "data",
    string,
    "pageIndex" | "_csrfToken",
    false
  >
>;

/**
 * 接口 [ajax\/stone\/getPowerStoneRankingByBookIdList↗](https://yapi.yuewen.com/project/28/interface/api/12374) 的 **请求配置**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2019-05-05 14:23:23`
 */
const ajaxStoneGetPowerStoneRankingByBookIdListRequestConfig: AjaxStoneGetPowerStoneRankingByBookIdListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_32,
    devUrl: devUrl_0_1_0_32,
    prodUrl: prodUrl_0_1_0_32,
    path: "/ajax/stone/getPowerStoneRankingByBookIdList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_32,
    paramNames: [],
    queryNames: ["pageIndex", "_csrfToken"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxStoneGetPowerStoneRankingByBookIdList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [ajax\/stone\/getPowerStoneRankingByBookIdList↗](https://yapi.yuewen.com/project/28/interface/api/12374) 的 **请求函数**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2019-05-05 14:23:23`
 */
export const ajaxStoneGetPowerStoneRankingByBookIdList = /*#__PURE__*/ (
  requestData: AjaxStoneGetPowerStoneRankingByBookIdListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxStoneGetPowerStoneRankingByBookIdListResponse>(
    prepare(
      ajaxStoneGetPowerStoneRankingByBookIdListRequestConfig,
      requestData
    ),
    ...args
  );
};

ajaxStoneGetPowerStoneRankingByBookIdList.requestConfig =
  ajaxStoneGetPowerStoneRankingByBookIdListRequestConfig;

const mockUrl_0_1_0_33 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_33 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_33 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_33 = "data" as any;

/**
 * 接口 [拉取ss流水-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/58) 的 **请求类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getSSHistoryAjax`
 * @更新时间 `2020-10-26 16:47:37`
 */
export interface AjaxSpiritStoneGetSsHistoryAjaxRequest {
  pageIndex: string;
  /**
   * 1-充值 2-消费
   */
  transType: string;
}

/**
 * 接口 [拉取ss流水-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/58) 的 **返回类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getSSHistoryAjax`
 * @更新时间 `2020-10-26 16:47:37`
 */
export interface AjaxSpiritStoneGetSsHistoryAjaxResponse {
  info?: {
    /**
     * 1
     */
    SS?: number;
    /**
     * 1
     */
    toExpiredSS?: number;
    /**
     * 1
     */
    toExpiredAfter?: number;
    /**
     * 1
     */
    bSS?: number;
  };
  /**
   * [{"source":1,"platform":"@platform","SS":1,"isBonus":1,"time":"@datetime","expireTime":"@datetime","skipBookName":"@title","skipBookId":"@id","skipChapterIndex":1,"skipChapterName":"@title","skipChapterId":"@id","giftName":"@title"}]
   */
  items?: {
    /**
     * 1
     */
    source?: number;
    /**
     * "@platform"
     */
    platform?: string;
    /**
     * 1
     */
    SS?: number;
    /**
     * 1
     */
    isBonus?: number;
    /**
     * "@datetime"
     */
    time?: string;
    /**
     * "@datetime"
     */
    expireTime?: string;
    /**
     * "@title"
     */
    skipBookName?: string;
    /**
     * "@id"
     */
    skipBookId?: string;
    /**
     * 1
     */
    skipChapterIndex?: number;
    /**
     * "@title"
     */
    skipChapterName?: string;
    /**
     * "@id"
     */
    skipChapterId?: string;
    /**
     * "@title"
     */
    giftName?: string;
  }[];
  /**
   * 1000
   */
  total?: number;
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [拉取ss流水-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/58) 的 **请求配置的类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getSSHistoryAjax`
 * @更新时间 `2020-10-26 16:47:37`
 */
type AjaxSpiritStoneGetSsHistoryAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/SpiritStone/getSSHistoryAjax",
    "data",
    string,
    "pageIndex" | "transType",
    false
  >
>;

/**
 * 接口 [拉取ss流水-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/58) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getSSHistoryAjax`
 * @更新时间 `2020-10-26 16:47:37`
 */
const ajaxSpiritStoneGetSsHistoryAjaxRequestConfig: AjaxSpiritStoneGetSsHistoryAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/SpiritStone/getSSHistoryAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: ["pageIndex", "transType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneGetSsHistoryAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [拉取ss流水-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/58) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getSSHistoryAjax`
 * @更新时间 `2020-10-26 16:47:37`
 */
export const ajaxSpiritStoneGetSsHistoryAjax = /*#__PURE__*/ (
  requestData: AjaxSpiritStoneGetSsHistoryAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSpiritStoneGetSsHistoryAjaxResponse>(
    prepare(ajaxSpiritStoneGetSsHistoryAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxSpiritStoneGetSsHistoryAjax.requestConfig =
  ajaxSpiritStoneGetSsHistoryAjaxRequestConfig;

/**
 * 接口 [invite friend↗](https://yapi.yuewen.com/project/28/interface/api/93) 的 **请求类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getInviteFriendPage`
 * @更新时间 `2019-11-12 10:25:49`
 */
export interface AjaxSpiritStoneGetInviteFriendPageRequest {}

/**
 * 接口 [invite friend↗](https://yapi.yuewen.com/project/28/interface/api/93) 的 **返回类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getInviteFriendPage`
 * @更新时间 `2019-11-12 10:25:49`
 */
export interface AjaxSpiritStoneGetInviteFriendPageResponse {
  /**
   * "50"
   */
  inviteSS?: string;
  /**
   * "@string"
   */
  inviteCode?: string;
  /**
   * 2
   */
  inviteFP?: number;
}

/**
 * 接口 [invite friend↗](https://yapi.yuewen.com/project/28/interface/api/93) 的 **请求配置的类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getInviteFriendPage`
 * @更新时间 `2019-11-12 10:25:49`
 */
type AjaxSpiritStoneGetInviteFriendPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/SpiritStone/getInviteFriendPage",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [invite friend↗](https://yapi.yuewen.com/project/28/interface/api/93) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getInviteFriendPage`
 * @更新时间 `2019-11-12 10:25:49`
 */
const ajaxSpiritStoneGetInviteFriendPageRequestConfig: AjaxSpiritStoneGetInviteFriendPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/SpiritStone/getInviteFriendPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneGetInviteFriendPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [invite friend↗](https://yapi.yuewen.com/project/28/interface/api/93) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getInviteFriendPage`
 * @更新时间 `2019-11-12 10:25:49`
 */
export const ajaxSpiritStoneGetInviteFriendPage = /*#__PURE__*/ (
  requestData?: AjaxSpiritStoneGetInviteFriendPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSpiritStoneGetInviteFriendPageResponse>(
    prepare(ajaxSpiritStoneGetInviteFriendPageRequestConfig, requestData),
    ...args
  );
};

ajaxSpiritStoneGetInviteFriendPage.requestConfig =
  ajaxSpiritStoneGetInviteFriendPageRequestConfig;

/**
 * 接口 [获取充值公告↗](https://yapi.yuewen.com/project/28/interface/api/556) 的 **请求类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getAnnoucement`
 * @更新时间 `2018-03-30 15:05:11`
 */
export interface AjaxSpiritStoneGetAnnoucementRequest {}

/**
 * 接口 [获取充值公告↗](https://yapi.yuewen.com/project/28/interface/api/556) 的 **返回类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getAnnoucement`
 * @更新时间 `2018-03-30 15:05:11`
 */
export interface AjaxSpiritStoneGetAnnoucementResponse {
  type?: number;
  /**
   * "@sentence"
   */
  note?: string;
  /**
   * "@url()"
   */
  url?: string;
  /**
   * "@sentence"
   */
  expireText?: string;
}

/**
 * 接口 [获取充值公告↗](https://yapi.yuewen.com/project/28/interface/api/556) 的 **请求配置的类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getAnnoucement`
 * @更新时间 `2018-03-30 15:05:11`
 */
type AjaxSpiritStoneGetAnnoucementRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/SpiritStone/getAnnoucement",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取充值公告↗](https://yapi.yuewen.com/project/28/interface/api/556) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getAnnoucement`
 * @更新时间 `2018-03-30 15:05:11`
 */
const ajaxSpiritStoneGetAnnoucementRequestConfig: AjaxSpiritStoneGetAnnoucementRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/SpiritStone/getAnnoucement",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneGetAnnoucement",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取充值公告↗](https://yapi.yuewen.com/project/28/interface/api/556) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getAnnoucement`
 * @更新时间 `2018-03-30 15:05:11`
 */
export const ajaxSpiritStoneGetAnnoucement = /*#__PURE__*/ (
  requestData?: AjaxSpiritStoneGetAnnoucementRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSpiritStoneGetAnnoucementResponse>(
    prepare(ajaxSpiritStoneGetAnnoucementRequestConfig, requestData),
    ...args
  );
};

ajaxSpiritStoneGetAnnoucement.requestConfig =
  ajaxSpiritStoneGetAnnoucementRequestConfig;

/**
 * 接口 [check in↗](https://yapi.yuewen.com/project/28/interface/api/3881) 的 **请求类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/SpiritStone/checkInAjax`
 * @更新时间 `2019-11-22 10:33:57`
 */
export interface AjaxSpiritStoneCheckInAjaxRequest {}

/**
 * 接口 [check in↗](https://yapi.yuewen.com/project/28/interface/api/3881) 的 **返回类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/SpiritStone/checkInAjax`
 * @更新时间 `2019-11-22 10:33:57`
 */
export interface AjaxSpiritStoneCheckInAjaxResponse {
  RewardSS?: number;
  /**
   * 5
   */
  RewardPS?: number;
  RewardExp?: number;
  /**
   * "cillum"
   */
  RewardIcon?: string;
  /**
   * "in dolor veniam aliquip consectetur"
   */
  ActionURL?: string;
  /**
   * "sed aute"
   */
  ImageURL?: string;
  /**
   * [{"AwardType":1,"Amount":10}]
   */
  Awards?: {
    /**
     * 1
     */
    AwardType?: number;
    /**
     * 10
     */
    Amount?: number;
  }[];
}

/**
 * 接口 [check in↗](https://yapi.yuewen.com/project/28/interface/api/3881) 的 **请求配置的类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/SpiritStone/checkInAjax`
 * @更新时间 `2019-11-22 10:33:57`
 */
type AjaxSpiritStoneCheckInAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/SpiritStone/checkInAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [check in↗](https://yapi.yuewen.com/project/28/interface/api/3881) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/SpiritStone/checkInAjax`
 * @更新时间 `2019-11-22 10:33:57`
 */
const ajaxSpiritStoneCheckInAjaxRequestConfig: AjaxSpiritStoneCheckInAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/SpiritStone/checkInAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneCheckInAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [check in↗](https://yapi.yuewen.com/project/28/interface/api/3881) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/SpiritStone/checkInAjax`
 * @更新时间 `2019-11-22 10:33:57`
 */
export const ajaxSpiritStoneCheckInAjax = /*#__PURE__*/ (
  requestData?: AjaxSpiritStoneCheckInAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSpiritStoneCheckInAjaxResponse>(
    prepare(ajaxSpiritStoneCheckInAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxSpiritStoneCheckInAjax.requestConfig =
  ajaxSpiritStoneCheckInAjaxRequestConfig;

/**
 * 接口 [拉取ss流水-Page↗](https://yapi.yuewen.com/project/28/interface/api/7495) 的 **请求类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/spiritStone/getSSHistoryPage`
 * @更新时间 `2019-11-18 16:10:12`
 */
export interface AjaxSpiritStoneGetSsHistoryPageRequest {}

/**
 * 接口 [拉取ss流水-Page↗](https://yapi.yuewen.com/project/28/interface/api/7495) 的 **返回类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/spiritStone/getSSHistoryPage`
 * @更新时间 `2019-11-18 16:10:12`
 */
export interface AjaxSpiritStoneGetSsHistoryPageResponse {
  /**
   * 31
   */
  total?: number;
  isLast?: number;
  info?: {
    /**
     * 16752
     */
    SS?: number;
    /**
     * 5
     */
    toExpiredSS?: number;
    /**
     * 10302
     */
    bSS?: number;
    /**
     * "3 days"
     */
    toExpiredAfter?: string;
  };
  /**
   * [{"source":1,"platform":"@platform","SS":1,"isBonus":1,"time":"@datetime","expireTime":"@datetime","skipBookName":"@title","skipBookId":"@id","skipChapterIndex":1,"skipChapterName":"@title","skipChapterId":"@id"}]
   */
  items?: {
    /**
     * 1
     */
    source?: number;
    /**
     * "@platform"
     */
    platform?: string;
    /**
     * 1
     */
    SS?: number;
    /**
     * 1
     */
    isBonus?: number;
    /**
     * "@datetime"
     */
    time?: string;
    /**
     * "@datetime"
     */
    expireTime?: string;
    /**
     * "@title"
     */
    skipBookName?: string;
    /**
     * "@id"
     */
    skipBookId?: string;
    /**
     * 1
     */
    skipChapterIndex?: number;
    /**
     * "@title"
     */
    skipChapterName?: string;
    /**
     * "@id"
     */
    skipChapterId?: string;
  }[];
  user?: {
    /**
     * "2959616949"
     */
    guid?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/2959616949/1/1.jpg?mt=1527669106000"
     */
    avatar?: string;
    /**
     * "Eason"
     */
    userName?: string;
    nickName?: null;
    penName?: string;
    role?: number;
    status?: number;
    /**
     * 16752
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 3
     */
    userLevel?: number;
    /**
     * 1
     */
    availablePower?: number;
    /**
     * 1
     */
    totalPower?: number;
    /**
     * 2
     */
    availableEnergy?: number;
    /**
     * 2
     */
    totalEnergy?: number;
    /**
     * 1
     */
    emailStatus?: number;
  };
}

/**
 * 接口 [拉取ss流水-Page↗](https://yapi.yuewen.com/project/28/interface/api/7495) 的 **请求配置的类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/spiritStone/getSSHistoryPage`
 * @更新时间 `2019-11-18 16:10:12`
 */
type AjaxSpiritStoneGetSsHistoryPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/spiritStone/getSSHistoryPage",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [拉取ss流水-Page↗](https://yapi.yuewen.com/project/28/interface/api/7495) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/spiritStone/getSSHistoryPage`
 * @更新时间 `2019-11-18 16:10:12`
 */
const ajaxSpiritStoneGetSsHistoryPageRequestConfig: AjaxSpiritStoneGetSsHistoryPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/spiritStone/getSSHistoryPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneGetSsHistoryPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [拉取ss流水-Page↗](https://yapi.yuewen.com/project/28/interface/api/7495) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/spiritStone/getSSHistoryPage`
 * @更新时间 `2019-11-18 16:10:12`
 */
export const ajaxSpiritStoneGetSsHistoryPage = /*#__PURE__*/ (
  requestData?: AjaxSpiritStoneGetSsHistoryPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSpiritStoneGetSsHistoryPageResponse>(
    prepare(ajaxSpiritStoneGetSsHistoryPageRequestConfig, requestData),
    ...args
  );
};

ajaxSpiritStoneGetSsHistoryPage.requestConfig =
  ajaxSpiritStoneGetSsHistoryPageRequestConfig;

/**
 * 接口 [page\/SpiritStone\/getSSHistoryPage↗](https://yapi.yuewen.com/project/28/interface/api/13946) 的 **请求类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /page/SpiritStone/getSSHistoryPage`
 * @更新时间 `2020-10-19 15:05:17`
 */
export interface PageSpiritStoneGetSsHistoryPageRequest {}

/**
 * 接口 [page\/SpiritStone\/getSSHistoryPage↗](https://yapi.yuewen.com/project/28/interface/api/13946) 的 **返回类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /page/SpiritStone/getSSHistoryPage`
 * @更新时间 `2020-10-19 15:05:17`
 */
export interface PageSpiritStoneGetSsHistoryPageResponse {
  total?: null;
  /**
   * 1
   */
  isLast?: number;
  info?: {
    /**
     * 15468
     */
    SS?: number;
    /**
     * 8727
     */
    toExpiredSS?: number;
    /**
     * 9018
     */
    bSS?: number;
    /**
     * "99864 days"
     */
    toExpiredAfter?: string;
  };
  /**
   * [{"source":19,"platform":"Mobile","SS":25,"time":1535102214929,"skipBookName":"The King's Avatar","skipBookId":"7366916601012405","skipChapterIndex":1,"skipChapterName":"The Banished Battle God","skipChapterId":"19775416453662908","giftName":"Lollipop","expireTime":null,"startChapterIndex":1,"endChapterIndex":5,"chapterCount":5},{"source":19,"platform":"Web","SS":666,"time":1535012554956,"skipBookName":"The King's Avatar","skipBookId":"7366916601012405","skipChapterIndex":1,"skipChapterName":"The Banished Battle God","skipChapterId":"19775416453662908","giftName":"Rainbow","expireTime":null,"startChapterIndex":1,"endChapterIndex":5,"chapterCount":5},{"source":19,"platform":"Mobile","SS":666,"time":1535012337879,"skipBookName":"The King's Avatar","skipBookId":"7366916601012405","skipChapterIndex":1,"skipChapterName":"The Banished Battle God","skipChapterId":"19775416453662908","giftName":"Rainbow","expireTime":null,"startChapterIndex":1,"endChapterIndex":5,"chapterCount":5},{"source":19,"platform":"Mobile","SS":25,"time":1534990523711,"skipBookName":"The King's Avatar","skipBookId":"7366916601012405","skipChapterIndex":1,"skipChapterName":"The Banished Battle God","skipChapterId":"19775416453662908","giftName":"Lollipop","expireTime":null,"startChapterIndex":1,"endChapterIndex":5,"chapterCount":5},{"source":17,"platform":"Mobile","SS":5,"time":1534957200029,"skipBookName":null,"skipBookId":"0","skipChapterIndex":null,"skipChapterName":null,"skipChapterId":"","giftName":"","expireTime":null,"startChapterIndex":1,"endChapterIndex":5,"chapterCount":5},{"source":17,"platform":"Mobile","SS":5,"time":1534957200029,"skipBookName":null,"skipBookId":"0","skipChapterIndex":null,"skipChapterName":null,"skipChapterId":"","giftName":"","expireTime":null,"startChapterIndex":1,"endChapterIndex":5,"chapterCount":5},{"source":17,"platform":"Mobile","SS":12,"time":1534438800023,"skipBookName":null,"skipBookId":"0","skipChapterIndex":null,"skipChapterName":null,"skipChapterId":"","giftName":"","expireTime":null,"startChapterIndex":1,"endChapterIndex":5,"chapterCount":5}]
   */
  items?: {
    /**
     * 19
     */
    source?: number;
    /**
     * "Mobile"
     */
    platform?: string;
    /**
     * 25
     */
    SS?: number;
    /**
     * 1535102214929
     */
    time?: number;
    /**
     * "The King's Avatar"
     */
    skipBookName?: string;
    /**
     * "7366916601012405"
     */
    skipBookId?: string;
    /**
     * 1
     */
    skipChapterIndex?: number;
    /**
     * "The Banished Battle God"
     */
    skipChapterName?: string;
    /**
     * "19775416453662908"
     */
    skipChapterId?: string;
    /**
     * "Lollipop"
     */
    giftName?: string;
    expireTime?: null;
    /**
     * 1
     */
    startChapterIndex?: number;
    /**
     * 5
     */
    endChapterIndex?: number;
    /**
     * 5
     */
    chapterCount?: number;
  }[];
  user?: {
    /**
     * "2959616949"
     */
    guid?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/2959616949/1/1.jpg?mt=1532403187000"
     */
    avatar?: string;
    /**
     * "Eason057"
     */
    userName?: string;
    nickName?: null;
    penName?: string;
    role?: number;
    status?: number;
    /**
     * 15468
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 3
     */
    userLevel?: number;
    /**
     * 10
     */
    availablePower?: number;
    /**
     * 10
     */
    totalPower?: number;
    /**
     * 2
     */
    availableEnergy?: number;
    /**
     * 2
     */
    totalEnergy?: number;
    /**
     * 1
     */
    emailStatus?: number;
    /**
     * 1532403187000
     */
    mt?: number;
    /**
     * 1532403187000
     */
    UUT?: number;
  };
}

/**
 * 接口 [page\/SpiritStone\/getSSHistoryPage↗](https://yapi.yuewen.com/project/28/interface/api/13946) 的 **请求配置的类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /page/SpiritStone/getSSHistoryPage`
 * @更新时间 `2020-10-19 15:05:17`
 */
type PageSpiritStoneGetSsHistoryPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/page/SpiritStone/getSSHistoryPage",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [page\/SpiritStone\/getSSHistoryPage↗](https://yapi.yuewen.com/project/28/interface/api/13946) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /page/SpiritStone/getSSHistoryPage`
 * @更新时间 `2020-10-19 15:05:17`
 */
const pageSpiritStoneGetSsHistoryPageRequestConfig: PageSpiritStoneGetSsHistoryPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/page/SpiritStone/getSSHistoryPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageSpiritStoneGetSsHistoryPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [page\/SpiritStone\/getSSHistoryPage↗](https://yapi.yuewen.com/project/28/interface/api/13946) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /page/SpiritStone/getSSHistoryPage`
 * @更新时间 `2020-10-19 15:05:17`
 */
export const pageSpiritStoneGetSsHistoryPage = /*#__PURE__*/ (
  requestData?: PageSpiritStoneGetSsHistoryPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PageSpiritStoneGetSsHistoryPageResponse>(
    prepare(pageSpiritStoneGetSsHistoryPageRequestConfig, requestData),
    ...args
  );
};

pageSpiritStoneGetSsHistoryPage.requestConfig =
  pageSpiritStoneGetSsHistoryPageRequestConfig;

/**
 * 接口 [spiritStone\/useSSUnlockChapterAjax↗](https://yapi.yuewen.com/project/28/interface/api/64344) 的 **请求类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/spiritStone/useSSUnlockChapterAjax`
 * @更新时间 `2020-10-16 16:16:21`
 */
export interface AjaxSpiritStoneUseSsUnlockChapterAjax2Request {
  bookId?: string;
  chapters?: {
    chapterId?: string;
    chapterPrice?: string;
  }[];
  /**
   * 1：看广告 2：跳过广告 3：订阅（ss解锁） 4：整本订阅 5：阅读券（fastPass）
   */
  unlockType?: string;
}

/**
 * 接口 [spiritStone\/useSSUnlockChapterAjax↗](https://yapi.yuewen.com/project/28/interface/api/64344) 的 **返回类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/spiritStone/useSSUnlockChapterAjax`
 * @更新时间 `2020-10-16 16:16:21`
 */
export interface AjaxSpiritStoneUseSsUnlockChapterAjax2Response {}

/**
 * 接口 [spiritStone\/useSSUnlockChapterAjax↗](https://yapi.yuewen.com/project/28/interface/api/64344) 的 **请求配置的类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/spiritStone/useSSUnlockChapterAjax`
 * @更新时间 `2020-10-16 16:16:21`
 */
type AjaxSpiritStoneUseSsUnlockChapterAjax2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/spiritStone/useSSUnlockChapterAjax",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [spiritStone\/useSSUnlockChapterAjax↗](https://yapi.yuewen.com/project/28/interface/api/64344) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/spiritStone/useSSUnlockChapterAjax`
 * @更新时间 `2020-10-16 16:16:21`
 */
const ajaxSpiritStoneUseSsUnlockChapterAjax2RequestConfig: AjaxSpiritStoneUseSsUnlockChapterAjax2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/spiritStone/useSSUnlockChapterAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneUseSsUnlockChapterAjax2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [spiritStone\/useSSUnlockChapterAjax↗](https://yapi.yuewen.com/project/28/interface/api/64344) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/spiritStone/useSSUnlockChapterAjax`
 * @更新时间 `2020-10-16 16:16:21`
 */
export const ajaxSpiritStoneUseSsUnlockChapterAjax2 = /*#__PURE__*/ (
  requestData: AjaxSpiritStoneUseSsUnlockChapterAjax2Request,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSpiritStoneUseSsUnlockChapterAjax2Response>(
    prepare(ajaxSpiritStoneUseSsUnlockChapterAjax2RequestConfig, requestData),
    ...args
  );
};

ajaxSpiritStoneUseSsUnlockChapterAjax2.requestConfig =
  ajaxSpiritStoneUseSsUnlockChapterAjax2RequestConfig;

/**
 * 接口 [【已弃用】getGearInfo 获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/69881) 的 **请求类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getGearInfo`
 * @更新时间 `2020-10-16 16:13:04`
 */
export interface AjaxSpiritStoneGetGearInfoRequest {}

/**
 * 接口 [【已弃用】getGearInfo 获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/69881) 的 **返回类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getGearInfo`
 * @更新时间 `2020-10-16 16:13:04`
 */
export interface AjaxSpiritStoneGetGearInfoResponse {
  /**
   * [{"channelCode":"paypal","channelName":"PC/H5-PayPal","gearDataList":[{"realAmount":"2.99","virtualAmount":150,"propId":"pp_pack_of_150_spirit_stones","content":"","currencyName":"$"},{"realAmount":"7.99","virtualAmount":400,"propId":"pp_pack_of_400_spirit_stones","content":"","currencyName":"$"},{"realAmount":"0.99","virtualAmount":50,"propId":"pp_pack_of_50_spirit_stones","content":"","currencyName":"$"}]}]
   */
  payChannels?: {
    /**
     * "paypal"
     */
    channelCode?: string;
    /**
     * "PC/H5-PayPal"
     */
    channelName?: string;
    /**
     * [{"realAmount":"2.99","virtualAmount":150,"propId":"pp_pack_of_150_spirit_stones","content":"","currencyName":"$"},{"realAmount":"7.99","virtualAmount":400,"propId":"pp_pack_of_400_spirit_stones","content":"","currencyName":"$"},{"realAmount":"0.99","virtualAmount":50,"propId":"pp_pack_of_50_spirit_stones","content":"","currencyName":"$"}]
     */
    gearDataList?: {
      /**
       * "2.99"
       */
      realAmount?: string;
      /**
       * 150
       */
      virtualAmount?: number;
      /**
       * "pp_pack_of_150_spirit_stones"
       */
      propId?: string;
      content?: string;
      /**
       * "$"
       */
      currencyName?: string;
    }[];
  }[];
  /**
   * [{"channelCode":"paypal","country":"US","amount":1,"discountAmount":1,"currency":"USD","itemId":"Membership_monthly","itemType":2,"tag":"agfewg","title":"@string","msg":"@string","benefits":[{"imageUrl":"@url","title":"@string"}]}]
   */
  membershipItemsn?: {
    /**
     * "paypal"
     */
    channelCode?: string;
    /**
     * "US"
     */
    country?: string;
    /**
     * 1
     */
    amount?: number;
    /**
     * 1
     */
    discountAmount?: number;
    /**
     * "USD"
     */
    currency?: string;
    /**
     * "Membership_monthly"
     */
    itemId?: string;
    /**
     * 2
     */
    itemType?: number;
    /**
     * "agfewg"
     */
    tag?: string;
    /**
     * "@string"
     */
    title?: string;
    /**
     * "@string"
     */
    msg?: string;
    /**
     * [{"imageUrl":"@url","title":"@string"}]
     */
    benefits?: {
      /**
       * "@url"
       */
      imageUrl?: string;
      /**
       * "@string"
       */
      title?: string;
    }[];
  }[];
}

/**
 * 接口 [【已弃用】getGearInfo 获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/69881) 的 **请求配置的类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getGearInfo`
 * @更新时间 `2020-10-16 16:13:04`
 */
type AjaxSpiritStoneGetGearInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/SpiritStone/getGearInfo",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [【已弃用】getGearInfo 获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/69881) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getGearInfo`
 * @更新时间 `2020-10-16 16:13:04`
 */
const ajaxSpiritStoneGetGearInfoRequestConfig: AjaxSpiritStoneGetGearInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/SpiritStone/getGearInfo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneGetGearInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【已弃用】getGearInfo 获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/69881) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getGearInfo`
 * @更新时间 `2020-10-16 16:13:04`
 */
export const ajaxSpiritStoneGetGearInfo = /*#__PURE__*/ (
  requestData?: AjaxSpiritStoneGetGearInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxSpiritStoneGetGearInfoResponse>(
    prepare(ajaxSpiritStoneGetGearInfoRequestConfig, requestData),
    ...args
  );
};

ajaxSpiritStoneGetGearInfo.requestConfig =
  ajaxSpiritStoneGetGearInfoRequestConfig;

/**
 * 接口 [【新】获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/105833) 的 **请求类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2020-07-17 11:04:02`
 */
export interface GoPcmRechargeGetGearInfoRequest {}

/**
 * 接口 [【新】获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/105833) 的 **返回类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2020-07-17 11:04:02`
 */
export interface GoPcmRechargeGetGearInfoResponse {
  /**
   * [{"channelCode":"paypal","channelName":"PC/H5-PayPal","gearGroupId":11323,"channelImageUrl":"https://actimg.webnovel.com/gear/paypal.png","gearDataList":[{"realAmount":"2.99","virtualAmount":150,"propId":"pp_pack_of_150_spirit_stones","content":"","currencyName":"$"},{"realAmount":"7.99","virtualAmount":400,"propId":"pp_pack_of_400_spirit_stones","content":"","currencyName":"$"},{"realAmount":"0.99","virtualAmount":50,"propId":"pp_pack_of_50_spirit_stones","content":"","currencyName":"$"}]}]
   */
  payChannels?: {
    /**
     * "paypal"
     */
    channelCode?: string;
    /**
     * "PC/H5-PayPal"
     */
    channelName?: string;
    /**
     * 11323
     */
    gearGroupId?: number;
    /**
     * "https://actimg.webnovel.com/gear/paypal.png"
     */
    channelImageUrl?: string;
    /**
     * [{"realAmount":"2.99","virtualAmount":150,"propId":"pp_pack_of_150_spirit_stones","content":"","currencyName":"$"},{"realAmount":"7.99","virtualAmount":400,"propId":"pp_pack_of_400_spirit_stones","content":"","currencyName":"$"},{"realAmount":"0.99","virtualAmount":50,"propId":"pp_pack_of_50_spirit_stones","content":"","currencyName":"$"}]
     */
    gearDataList?: {
      /**
       * "2.99"
       */
      realAmount?: string;
      /**
       * 150
       */
      virtualAmount?: number;
      /**
       * "pp_pack_of_150_spirit_stones"
       */
      propId?: string;
      content?: string;
      /**
       * "$"
       */
      currencyName?: string;
    }[];
  }[];
  /**
   * [{"channelCode":"paypal","country":"US","amount":1,"discountAmount":1,"currency":"USD","itemId":"Membership_monthly","itemType":2,"tag":"agfewg","title":"@string","msg":"@string","benefits":[{"imageUrl":"@url","title":"@string"}]}]
   */
  membershipItemsn?: {
    /**
     * "paypal"
     */
    channelCode?: string;
    /**
     * "US"
     */
    country?: string;
    /**
     * 1
     */
    amount?: number;
    /**
     * 1
     */
    discountAmount?: number;
    /**
     * "USD"
     */
    currency?: string;
    /**
     * "Membership_monthly"
     */
    itemId?: string;
    /**
     * 2
     */
    itemType?: number;
    /**
     * "agfewg"
     */
    tag?: string;
    /**
     * "@string"
     */
    title?: string;
    /**
     * "@string"
     */
    msg?: string;
    /**
     * [{"imageUrl":"@url","title":"@string"}]
     */
    benefits?: {
      /**
       * "@url"
       */
      imageUrl?: string;
      /**
       * "@string"
       */
      title?: string;
    }[];
  }[];
}

/**
 * 接口 [【新】获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/105833) 的 **请求配置的类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2020-07-17 11:04:02`
 */
type GoPcmRechargeGetGearInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/recharge/getGearInfo",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [【新】获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/105833) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2020-07-17 11:04:02`
 */
const goPcmRechargeGetGearInfoRequestConfig: GoPcmRechargeGetGearInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/go/pcm/recharge/getGearInfo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRechargeGetGearInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【新】获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/105833) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2020-07-17 11:04:02`
 */
export const goPcmRechargeGetGearInfo = /*#__PURE__*/ (
  requestData?: GoPcmRechargeGetGearInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmRechargeGetGearInfoResponse>(
    prepare(goPcmRechargeGetGearInfoRequestConfig, requestData),
    ...args
  );
};

goPcmRechargeGetGearInfo.requestConfig = goPcmRechargeGetGearInfoRequestConfig;

/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go)↗](https://yapi.yuewen.com/project/28/interface/api/166228) 的 **请求类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-10-26 16:00:48`
 */
export interface GoPcmSpiritStoneGetSsHistoryRequest {
  pageIndex: string;
  /**
   * 1-充值 2-消费
   */
  transType: string;
}

/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go)↗](https://yapi.yuewen.com/project/28/interface/api/166228) 的 **返回类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-10-26 16:00:48`
 */
export interface GoPcmSpiritStoneGetSsHistoryResponse {
  info?: {
    /**
     * 1000
     */
    SS?: number;
    /**
     * 100
     */
    vSS?: number;
    /**
     * 100
     */
    vbSS?: number;
    /**
     * 100
     */
    bSS?: number;
    /**
     * 20
     */
    toExpiredSS?: number;
    /**
     * "3 days"
     */
    toExpiredAfter?: string;
    /**
     * "1-充值 2-消费"
     */
    transType?: string;
  };
  /**
   * [{"source":"0-过期  1-签到 2-邀请好友 3-跳过广告 4-期待票投票奖励， 5-活动奖励，6-推荐票投票奖励 9-新用户注册成功送的积分 10-admin 增加， 11-admin减少， 12 -compensation（系统补偿）19 -道具打赏","source计费侧的文档地址":"http://tapd.oa.com/QidianOverSeas/markdown_wikis/#1110143901005279148","platform":"Android","transType":"1-充值 2-消费 3-过期","SS":10,"time":"毫秒时间戳","skipBookName":"xxx 如果不是 Skip ad 则为 NULL","skipBookId":"xxx","skipChapterIndex":"xxx 如果不是 Skip ad 则为 NULL","skipChapterId":"xxx 如果不是 Skip ad 则为 NULL","skipChapterName":"xxx 如果不是 Skip ad 则为 NULL","toExpiredAfter":"3 days","expireTime":1602000000000,"isBonus":true,"giftName":"bigCat","description":"","startChapterIndex":1,"endChapterIndex":5,"chapterCount":5}]
   */
  items?: {
    /**
     * "0-过期  1-签到 2-邀请好友 3-跳过广告 4-期待票投票奖励， 5-活动奖励，6-推荐票投票奖励 9-新用户注册成功送的积分 10-admin 增加， 11-admin减少， 12 -compensation（系统补偿）19 -道具打赏"
     */
    source?: string;
    /**
     * "http://tapd.oa.com/QidianOverSeas/markdown_wikis/#1110143901005279148"
     */
    source计费侧的文档地址?: string;
    /**
     * "Android"
     */
    platform?: string;
    /**
     * "1-充值 2-消费 3-过期"
     */
    transType?: string;
    /**
     * 10
     */
    SS?: number;
    /**
     * "毫秒时间戳"
     */
    time?: string;
    /**
     * "xxx 如果不是 Skip ad 则为 NULL"
     */
    skipBookName?: string;
    /**
     * "xxx"
     */
    skipBookId?: string;
    /**
     * "xxx 如果不是 Skip ad 则为 NULL"
     */
    skipChapterIndex?: string;
    /**
     * "xxx 如果不是 Skip ad 则为 NULL"
     */
    skipChapterId?: string;
    /**
     * "xxx 如果不是 Skip ad 则为 NULL"
     */
    skipChapterName?: string;
    /**
     * "3 days"
     */
    toExpiredAfter?: string;
    /**
     * 1602000000000
     */
    expireTime?: number;
    /**
     * true
     */
    isBonus?: boolean;
    /**
     * "bigCat"
     */
    giftName?: string;
    description?: string;
    /**
     * 1
     */
    startChapterIndex?: number;
    /**
     * 5
     */
    endChapterIndex?: number;
    /**
     * 5
     */
    chapterCount?: number;
  }[];
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300000745/1/1.jpg?mt=1599203750603"
     */
    avatar?: string;
    /**
     * "zhang_j4543"
     */
    nickName?: string;
    /**
     * "zhang_j4543"
     */
    userName?: string;
    /**
     * "zhang_j4543"
     */
    authorName?: string;
    /**
     * 4300000745
     */
    guid?: number;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * 2
     */
    gender?: number;
    /**
     * 4995
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 5
     */
    grade?: number;
    /**
     * 3
     */
    ES?: number;
    /**
     * 3
     */
    totalES?: number;
    /**
     * 3
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * "2120584224@qq.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: number;
    /**
     * 1599203750603
     */
    UUT?: number;
    /**
     * 3
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 2
     */
    membershipStatus?: number;
    /**
     * 1598678797000
     */
    membershipExpireTime?: number;
    membershipClaimStatus?: boolean;
  };
  /**
   * 1
   */
  isLast?: number;
  /**
   * 1000
   */
  total?: number;
}

/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go)↗](https://yapi.yuewen.com/project/28/interface/api/166228) 的 **请求配置的类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-10-26 16:00:48`
 */
type GoPcmSpiritStoneGetSsHistoryRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/spiritStone/getSSHistory",
    "data",
    string,
    "pageIndex" | "transType",
    false
  >
>;

/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go)↗](https://yapi.yuewen.com/project/28/interface/api/166228) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-10-26 16:00:48`
 */
const goPcmSpiritStoneGetSsHistoryRequestConfig: GoPcmSpiritStoneGetSsHistoryRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/go/pcm/spiritStone/getSSHistory",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: ["pageIndex", "transType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSpiritStoneGetSsHistory",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go)↗](https://yapi.yuewen.com/project/28/interface/api/166228) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-10-26 16:00:48`
 */
export const goPcmSpiritStoneGetSsHistory = /*#__PURE__*/ (
  requestData: GoPcmSpiritStoneGetSsHistoryRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSpiritStoneGetSsHistoryResponse>(
    prepare(goPcmSpiritStoneGetSsHistoryRequestConfig, requestData),
    ...args
  );
};

goPcmSpiritStoneGetSsHistory.requestConfig =
  goPcmSpiritStoneGetSsHistoryRequestConfig;

const mockUrl_0_1_0_34 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_34 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_34 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_34 = "data" as any;

/**
 * 接口 [Booklist - Category↗](https://yapi.yuewen.com/project/28/interface/api/65) 的 **请求类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/categoryPage`
 * @更新时间 `2019-11-12 11:35:00`
 */
export interface AjaxCategoryCategoryPageRequest {
  /**
   * 1:小说 2：漫画 3：出版书 4：Fan-fic
   */
  categoryType: string;
  categoryId: string;
  /**
   * 0:所有 1:翻译 2:原创 ， 只有小说有该选项
   */
  bookType: string;
  /**
   * 0:所有 1:ongoing 2:completed， 出版书无该选项
   */
  bookStatus: string;
  /**
   * 1:Popular 2:Recommendation 3:Collection 4: Rates 5:Updated 默认1
   */
  orderBy: string;
  /**
   * 1:发布时间,2:章节数量,3:评分
   */
  pageIndex: string;
  title?: string;
  /**
   * 分页条数，默认20
   */
  pageSize: string;
  /**
   * 1男2女
   */
  gender: string;
  /**
   * 传多个时候，用逗号分割，具体对应的id看备注
   */
  chapterNum: string;
  /**
   * m站专用，区分4个多语言
   */
  language?: string;
  /**
   * 默认0      1-membership
   */
  price: string;
}

/**
 * 接口 [Booklist - Category↗](https://yapi.yuewen.com/project/28/interface/api/65) 的 **返回类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/categoryPage`
 * @更新时间 `2019-11-12 11:35:00`
 */
export interface AjaxCategoryCategoryPageResponse {
  /**
   * [{"bookId":"9795126406003205","bookName":"Book of Events","description":"All WEBNOVEL official events will be recorded in this book. Every time you see the update, that means surprise and good things are getting ready for you!\r\n\r\nAdd 《Book of Events》to your library will help you to track the hottest events on Webnovel!\r\n\r\nEnjoy","categoryName":"ACG","authorName":"WEBNOVEL","categoryType":1,"totalScore":"3.4","type":1,"bookType":1,"tagInfo":[],"coverUpdateTime":"1560739390490"},{"bookId":"8057964805003305","bookName":"Book of Answers","description":"Qidian,  born in May of 2002, is currently the largest original web literature publisher. Her father, China Literature, although has greater hopes for her, such as being able to have grandchildren. So, in 2017, Qidian gave birth to Webnovel, and Webnovel has been growing very quickly ever since.  \r\nAs Webnovel matures, she became more sophisticated and a lot harder to read. As a result, this book was written to help you understand her better, hoping that both readers at Webnovel will have a great and smooth experience together. ","categoryName":"ACG","categoryType":1,"authorName":"QIDIAN","totalScore":"4.1","type":1,"bookType":1,"tagInfo":[{"tagId":464,"tagName":"HELP"}],"coverUpdateTime":"1548301476787"}]
   */
  items?: {
    /**
     * "9795126406003205"
     */
    bookId?: string;
    /**
     * "Book of Events"
     */
    bookName?: string;
    /**
     * "All WEBNOVEL official events will be recorded in this book. Every time you see the update, that means surprise and good things are getting ready for you!\r\n\r\nAdd 《Book of Events》to your library will help you to track the hottest events on Webnovel!\r\n\r\nEnjoy"
     */
    description?: string;
    /**
     * "ACG"
     */
    categoryName?: string;
    /**
     * "WEBNOVEL"
     */
    authorName?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * "3.4"
     */
    totalScore?: string;
    /**
     * 1
     */
    type?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * []
     */
    tagInfo?: unknown[];
    /**
     * "1560739390490"
     */
    coverUpdateTime?: string;
  }[];
  /**
   * 2
   */
  total?: number;
  /**
   * 1
   */
  isLast?: number;
  /**
   * "1"
   */
  orderBy?: string;
  /**
   * "70011"
   */
  categoryId?: string;
  /**
   * 20
   */
  pageIndex?: number;
  bookStatus?: number;
}

/**
 * 接口 [Booklist - Category↗](https://yapi.yuewen.com/project/28/interface/api/65) 的 **请求配置的类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/categoryPage`
 * @更新时间 `2019-11-12 11:35:00`
 */
type AjaxCategoryCategoryPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/category/categoryPage",
    "data",
    string,
    | "categoryType"
    | "categoryId"
    | "bookType"
    | "bookStatus"
    | "orderBy"
    | "pageIndex"
    | "title"
    | "pageSize"
    | "gender"
    | "chapterNum"
    | "language"
    | "price",
    false
  >
>;

/**
 * 接口 [Booklist - Category↗](https://yapi.yuewen.com/project/28/interface/api/65) 的 **请求配置**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/categoryPage`
 * @更新时间 `2019-11-12 11:35:00`
 */
const ajaxCategoryCategoryPageRequestConfig: AjaxCategoryCategoryPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_34,
    devUrl: devUrl_0_1_0_34,
    prodUrl: prodUrl_0_1_0_34,
    path: "/ajax/category/categoryPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_34,
    paramNames: [],
    queryNames: [
      "categoryType",
      "categoryId",
      "bookType",
      "bookStatus",
      "orderBy",
      "pageIndex",
      "title",
      "pageSize",
      "gender",
      "chapterNum",
      "language",
      "price",
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxCategoryCategoryPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [Booklist - Category↗](https://yapi.yuewen.com/project/28/interface/api/65) 的 **请求函数**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/categoryPage`
 * @更新时间 `2019-11-12 11:35:00`
 */
export const ajaxCategoryCategoryPage = /*#__PURE__*/ (
  requestData: AjaxCategoryCategoryPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxCategoryCategoryPageResponse>(
    prepare(ajaxCategoryCategoryPageRequestConfig, requestData),
    ...args
  );
};

ajaxCategoryCategoryPage.requestConfig = ajaxCategoryCategoryPageRequestConfig;

/**
 * 接口 [获取所有分类-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/481) 的 **请求类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getAllAjax`
 * @更新时间 `2018-03-14 15:12:44`
 */
export interface AjaxCategoryGetAllAjaxRequest {}

/**
 * 接口 [获取所有分类-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/481) 的 **返回类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getAllAjax`
 * @更新时间 `2018-03-14 15:12:44`
 */
export interface AjaxCategoryGetAllAjaxResponse {
  /**
   * [{"categoryName":"@string","categoryId":1,"bookId":1}]
   */
  items?: {
    /**
     * "@string"
     */
    categoryName?: string;
    /**
     * 1
     */
    categoryId?: number;
    /**
     * 1
     */
    bookId?: number;
  }[];
}

/**
 * 接口 [获取所有分类-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/481) 的 **请求配置的类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getAllAjax`
 * @更新时间 `2018-03-14 15:12:44`
 */
type AjaxCategoryGetAllAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/category/getAllAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取所有分类-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/481) 的 **请求配置**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getAllAjax`
 * @更新时间 `2018-03-14 15:12:44`
 */
const ajaxCategoryGetAllAjaxRequestConfig: AjaxCategoryGetAllAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_34,
    devUrl: devUrl_0_1_0_34,
    prodUrl: prodUrl_0_1_0_34,
    path: "/ajax/category/getAllAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_34,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxCategoryGetAllAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取所有分类-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/481) 的 **请求函数**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getAllAjax`
 * @更新时间 `2018-03-14 15:12:44`
 */
export const ajaxCategoryGetAllAjax = /*#__PURE__*/ (
  requestData?: AjaxCategoryGetAllAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxCategoryGetAllAjaxResponse>(
    prepare(ajaxCategoryGetAllAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxCategoryGetAllAjax.requestConfig = ajaxCategoryGetAllAjaxRequestConfig;

/**
 * 接口 [获取所有分类-Page↗](https://yapi.yuewen.com/project/28/interface/api/511) 的 **请求类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/getAllPage`
 * @更新时间 `2024-08-09 14:26:29`
 */
export interface PageCategoryGetAllPageRequest {}

/**
 * 接口 [获取所有分类-Page↗](https://yapi.yuewen.com/project/28/interface/api/511) 的 **返回类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/getAllPage`
 * @更新时间 `2024-08-09 14:26:29`
 */
export interface PageCategoryGetAllPageResponse {
  /**
   * [{"categoryName":"@string","categoryId":1,"bookId":1}]
   */
  items?: {
    /**
     * "@string"
     */
    categoryName?: string;
    /**
     * 1
     */
    categoryId?: number;
    /**
     * 1
     */
    bookId?: number;
  }[];
  user?: {
    /**
     * "2959616949"
     */
    guid?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/2959616949/1/1.jpg?mt=1514342391000"
     */
    avatar?: string;
    /**
     * "Eason"
     */
    userName?: string;
    nickName?: null;
    penName?: null;
    role?: number;
    status?: number;
    /**
     * 7149
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 2
     */
    userLevel?: number;
    /**
     * 1
     */
    availablePower?: number;
    /**
     * 1
     */
    totalPower?: number;
    /**
     * 1
     */
    availableEnergy?: number;
    /**
     * 1
     */
    totalEnergy?: number;
    /**
     * 1
     */
    emailStatus?: number;
  };
}

/**
 * 接口 [获取所有分类-Page↗](https://yapi.yuewen.com/project/28/interface/api/511) 的 **请求配置的类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/getAllPage`
 * @更新时间 `2024-08-09 14:26:29`
 */
type PageCategoryGetAllPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/page/category/getAllPage",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取所有分类-Page↗](https://yapi.yuewen.com/project/28/interface/api/511) 的 **请求配置**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/getAllPage`
 * @更新时间 `2024-08-09 14:26:29`
 */
const pageCategoryGetAllPageRequestConfig: PageCategoryGetAllPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_34,
    devUrl: devUrl_0_1_0_34,
    prodUrl: prodUrl_0_1_0_34,
    path: "/page/category/getAllPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_34,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageCategoryGetAllPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取所有分类-Page↗](https://yapi.yuewen.com/project/28/interface/api/511) 的 **请求函数**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/getAllPage`
 * @更新时间 `2024-08-09 14:26:29`
 */
export const pageCategoryGetAllPage = /*#__PURE__*/ (
  requestData?: PageCategoryGetAllPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PageCategoryGetAllPageResponse>(
    prepare(pageCategoryGetAllPageRequestConfig, requestData),
    ...args
  );
};

pageCategoryGetAllPage.requestConfig = pageCategoryGetAllPageRequestConfig;

/**
 * 接口 [列表页 直出接口↗](https://yapi.yuewen.com/project/28/interface/api/6458) 的 **请求类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/bookListPage`
 * @更新时间 `2018-05-23 15:12:05`
 */
export interface PageCategoryBookListPageRequest {}

/**
 * 接口 [列表页 直出接口↗](https://yapi.yuewen.com/project/28/interface/api/6458) 的 **返回类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/bookListPage`
 * @更新时间 `2018-05-23 15:12:05`
 */
export interface PageCategoryBookListPageResponse {
  /**
   * [{"bookId":"@id","bookName":"@name","categoryName":"@name","totalScore":1,"authorName":"@name","coverUpdateTime":"333333","tagInfo":[{"tagId":"@id","tagName":"@name"}]}]
   */
  items?: {
    /**
     * "@id"
     */
    bookId?: string;
    /**
     * "@name"
     */
    bookName?: string;
    /**
     * "@name"
     */
    categoryName?: string;
    /**
     * 1
     */
    totalScore?: number;
    /**
     * "@name"
     */
    authorName?: string;
    /**
     * "333333"
     */
    coverUpdateTime?: string;
    /**
     * [{"tagId":"@id","tagName":"@name"}]
     */
    tagInfo?: {
      /**
       * "@id"
       */
      tagId?: string;
      /**
       * "@name"
       */
      tagName?: string;
    }[];
  }[];
  /**
   * 27
   */
  total?: number;
  isLast?: number;
  categoryDesc?: null;
  /**
   * [{"categoryId":"70001","categoryName":"Magical Realism","bookId":"7731137901014305"},{"categoryId":"70002","categoryName":"High Fantasy","bookId":"9087880901018705"},{"categoryId":"70003","categoryName":"Historical Fiction","bookId":"10650267701028205"},{"categoryId":"70004","categoryName":"Horror & Thriller","bookId":"10337681401023605"},{"categoryId":"70005","categoryName":"Romance Fiction","bookId":"10159021801021405"},{"categoryId":"70006","categoryName":"Science Fiction","bookId":"10166607401021505"},{"categoryId":"70007","categoryName":"Competitive Sports","bookId":"7144266401010905"},{"categoryId":"70008","categoryName":"Video Games","bookId":"7366916601012405"},{"categoryId":"70009","categoryName":"Eastern Fantasy","bookId":"6831119801007305"},{"categoryId":"70010","categoryName":"Realistic Fiction","bookId":"7479922501012705"},{"categoryId":"70011","categoryName":"Fan-fiction ","bookId":"7765061201015705"},{"categoryId":"70012","categoryName":"Martial Arts","bookId":"8161289901016405"},{"categoryId":"70013","categoryName":"War & Military Fiction","bookId":"10234821601022105"}]
   */
  categories?: {
    /**
     * "70001"
     */
    categoryId?: string;
    /**
     * "Magical Realism"
     */
    categoryName?: string;
    /**
     * "7731137901014305"
     */
    bookId?: string;
  }[];
  user?: {
    /**
     * "2959616949"
     */
    guid?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/2959616949/1/1.jpg?mt=1526900786000"
     */
    avatar?: string;
    /**
     * "Eason"
     */
    userName?: string;
    nickName?: null;
    penName?: string;
    role?: number;
    status?: number;
    /**
     * 16756
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 3
     */
    userLevel?: number;
    /**
     * 1
     */
    availablePower?: number;
    /**
     * 1
     */
    totalPower?: number;
    /**
     * 2
     */
    availableEnergy?: number;
    /**
     * 2
     */
    totalEnergy?: number;
    /**
     * 1
     */
    emailStatus?: number;
  };
}

/**
 * 接口 [列表页 直出接口↗](https://yapi.yuewen.com/project/28/interface/api/6458) 的 **请求配置的类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/bookListPage`
 * @更新时间 `2018-05-23 15:12:05`
 */
type PageCategoryBookListPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/page/category/bookListPage",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [列表页 直出接口↗](https://yapi.yuewen.com/project/28/interface/api/6458) 的 **请求配置**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/bookListPage`
 * @更新时间 `2018-05-23 15:12:05`
 */
const pageCategoryBookListPageRequestConfig: PageCategoryBookListPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_34,
    devUrl: devUrl_0_1_0_34,
    prodUrl: prodUrl_0_1_0_34,
    path: "/page/category/bookListPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_34,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageCategoryBookListPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [列表页 直出接口↗](https://yapi.yuewen.com/project/28/interface/api/6458) 的 **请求函数**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/bookListPage`
 * @更新时间 `2018-05-23 15:12:05`
 */
export const pageCategoryBookListPage = /*#__PURE__*/ (
  requestData?: PageCategoryBookListPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PageCategoryBookListPageResponse>(
    prepare(pageCategoryBookListPageRequestConfig, requestData),
    ...args
  );
};

pageCategoryBookListPage.requestConfig = pageCategoryBookListPageRequestConfig;

/**
 * 接口 [getCategories - 根据一级分类获取二级分类↗](https://yapi.yuewen.com/project/28/interface/api/60711) 的 **请求类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getCategories`
 * @更新时间 `2019-09-16 21:36:47`
 */
export interface AjaxCategoryGetCategoriesRequest {
  /**
   * 1：小说 2：漫画 3：出版书 4：fan-fic,传0或者默认拿全部分类
   */
  categoryType: string;
  /**
   * 0全部 1男 2女 只有小说用得到，小说分男女频
   */
  gender: string;
}

/**
 * 接口 [getCategories - 根据一级分类获取二级分类↗](https://yapi.yuewen.com/project/28/interface/api/60711) 的 **返回类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getCategories`
 * @更新时间 `2019-09-16 21:36:47`
 */
export interface AjaxCategoryGetCategoriesResponse {
  /**
   * [{"categoryId":70001,"categoryName":"Magical Realism","bookInfos":[{"bookId":11782739101022904,"bookCoverId":0,"coverUpdateTime":0},{"bookId":10380534501024504,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":61},{"categoryId":70003,"categoryName":"History","bookInfos":[{"bookId":11987368201024204,"bookCoverId":0,"coverUpdateTime":0},{"bookId":11686469701018804,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":2,"totalCount":55},{"categoryId":70002,"categoryName":"Fantasy","bookInfos":[{"bookId":11192701201002504,"bookCoverId":0,"coverUpdateTime":0},{"bookId":11653617901014304,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":2,"totalCount":69},{"categoryId":70004,"categoryName":"Horror&Thriller","bookInfos":[{"bookId":10406698501026504,"bookCoverId":0,"coverUpdateTime":0},{"bookId":11652753801014204,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":23},{"categoryId":70007,"categoryName":"Competitive Sports","bookInfos":[{"bookId":12197488601029104,"bookCoverId":0,"coverUpdateTime":0},{"bookId":7144266401010905,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":4},{"categoryId":70006,"categoryName":"Sci-fi","bookInfos":[{"bookId":12335339401035104,"bookCoverId":0,"coverUpdateTime":0},{"bookId":11972684101024004,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":2},{"categoryId":70009,"categoryName":"Eastern Fantasy","bookInfos":[{"bookId":10486246401027204,"bookCoverId":0,"coverUpdateTime":0},{"bookId":11529913001011204,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":3},{"categoryId":70008,"categoryName":"Video Games","bookInfos":[{"bookId":11686410601018704,"bookCoverId":0,"coverUpdateTime":0},{"bookId":7366916601012405,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":3},{"categoryId":70011,"categoryName":"ACG","bookInfos":[{"bookId":13534274801047904,"bookCoverId":0,"coverUpdateTime":0},{"bookId":14399165701068304,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":6},{"categoryId":70010,"categoryName":"Realistic Fiction","bookInfos":[{"bookId":13051485401041504,"bookCoverId":0,"coverUpdateTime":0},{"bookId":7479922501012705,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":6},{"categoryId":70013,"categoryName":"War&Military","bookInfos":[{"bookId":7765027801015505,"bookCoverId":0,"coverUpdateTime":0},{"bookId":10234821601022104,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":5},{"categoryId":70012,"categoryName":"Martial Arts","bookInfos":[{"bookId":13743148801051104,"bookCoverId":0,"coverUpdateTime":0},{"bookId":10390463201026004,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":5}]
   */
  categoryItems?: {
    /**
     * 70001
     */
    categoryId?: number;
    /**
     * "Magical Realism"
     */
    categoryName?: string;
    /**
     * [{"bookId":11782739101022904,"bookCoverId":0,"coverUpdateTime":0},{"bookId":10380534501024504,"bookCoverId":0,"coverUpdateTime":0}]
     */
    bookInfos?: {
      /**
       * 11782739101022904
       */
      bookId?: number;
      bookCoverId?: number;
      coverUpdateTime?: number;
    }[];
    /**
     * 1
     */
    sexPreference?: number;
    /**
     * 61
     */
    totalCount?: number;
  }[];
}

/**
 * 接口 [getCategories - 根据一级分类获取二级分类↗](https://yapi.yuewen.com/project/28/interface/api/60711) 的 **请求配置的类型**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getCategories`
 * @更新时间 `2019-09-16 21:36:47`
 */
type AjaxCategoryGetCategoriesRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/category/getCategories",
    "data",
    string,
    "categoryType" | "gender",
    false
  >
>;

/**
 * 接口 [getCategories - 根据一级分类获取二级分类↗](https://yapi.yuewen.com/project/28/interface/api/60711) 的 **请求配置**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getCategories`
 * @更新时间 `2019-09-16 21:36:47`
 */
const ajaxCategoryGetCategoriesRequestConfig: AjaxCategoryGetCategoriesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_34,
    devUrl: devUrl_0_1_0_34,
    prodUrl: prodUrl_0_1_0_34,
    path: "/ajax/category/getCategories",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_34,
    paramNames: [],
    queryNames: ["categoryType", "gender"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxCategoryGetCategories",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getCategories - 根据一级分类获取二级分类↗](https://yapi.yuewen.com/project/28/interface/api/60711) 的 **请求函数**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getCategories`
 * @更新时间 `2019-09-16 21:36:47`
 */
export const ajaxCategoryGetCategories = /*#__PURE__*/ (
  requestData: AjaxCategoryGetCategoriesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxCategoryGetCategoriesResponse>(
    prepare(ajaxCategoryGetCategoriesRequestConfig, requestData),
    ...args
  );
};

ajaxCategoryGetCategories.requestConfig =
  ajaxCategoryGetCategoriesRequestConfig;

const mockUrl_0_1_0_35 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_35 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_35 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_35 = "data" as any;

/**
 * 接口 [Booklist - Tag ↗](https://yapi.yuewen.com/project/28/interface/api/72) 的 **请求类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookListAjax`
 * @更新时间 `2020-07-08 19:34:53`
 */
export interface AjaxTagBookListAjaxRequest {
  tagName: string;
  /**
   * 1 搜索书籍 2 搜索漫画 3 搜索出版书 4 搜索fan-fic 目前只有1和4
   */
  type: string;
  pageIndex: string;
  /**
   * 1:Popular 2:Updated 3:Collection 默认1
   */
  order: string;
}

/**
 * 接口 [Booklist - Tag ↗](https://yapi.yuewen.com/project/28/interface/api/72) 的 **返回类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookListAjax`
 * @更新时间 `2020-07-08 19:34:53`
 */
export interface AjaxTagBookListAjaxResponse {
  /**
   * [{"bookId":7765027801015505,"bookName":"War Sovereign Soaring The Heavens","bookType":0,"categoryId":12,"categoryName":"test","authorName":"aaa","coverUpdateTime":1513319976161,"totalScore":5,"tagInfo":[{"tagId":1,"tagName":"tag","isLiked":0,"likeNums":0}],"description":"dfrastraytrdhgdshghfdjtsyyt","chapterNum":100}]
   */
  bookInfos?: {
    /**
     * 7765027801015505
     */
    bookId?: number;
    /**
     * "War Sovereign Soaring The Heavens"
     */
    bookName?: string;
    bookType?: number;
    /**
     * 12
     */
    categoryId?: number;
    /**
     * "test"
     */
    categoryName?: string;
    /**
     * "aaa"
     */
    authorName?: string;
    /**
     * 1513319976161
     */
    coverUpdateTime?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * [{"tagId":1,"tagName":"tag","isLiked":0,"likeNums":0}]
     */
    tagInfo?: {
      /**
       * 1
       */
      tagId?: number;
      /**
       * "tag"
       */
      tagName?: string;
      isLiked?: number;
      likeNums?: number;
    }[];
    /**
     * "dfrastraytrdhgdshghfdjtsyyt"
     */
    description?: string;
    /**
     * 100
     */
    chapterNum?: number;
  }[];
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 1
   */
  total?: number;
  isLast?: number;
}

/**
 * 接口 [Booklist - Tag ↗](https://yapi.yuewen.com/project/28/interface/api/72) 的 **请求配置的类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookListAjax`
 * @更新时间 `2020-07-08 19:34:53`
 */
type AjaxTagBookListAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/tag/bookListAjax",
    "data",
    string,
    "tagName" | "type" | "pageIndex" | "order",
    false
  >
>;

/**
 * 接口 [Booklist - Tag ↗](https://yapi.yuewen.com/project/28/interface/api/72) 的 **请求配置**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookListAjax`
 * @更新时间 `2020-07-08 19:34:53`
 */
const ajaxTagBookListAjaxRequestConfig: AjaxTagBookListAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_35,
    devUrl: devUrl_0_1_0_35,
    prodUrl: prodUrl_0_1_0_35,
    path: "/ajax/tag/bookListAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_35,
    paramNames: [],
    queryNames: ["tagName", "type", "pageIndex", "order"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxTagBookListAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [Booklist - Tag ↗](https://yapi.yuewen.com/project/28/interface/api/72) 的 **请求函数**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookListAjax`
 * @更新时间 `2020-07-08 19:34:53`
 */
export const ajaxTagBookListAjax = /*#__PURE__*/ (
  requestData: AjaxTagBookListAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxTagBookListAjaxResponse>(
    prepare(ajaxTagBookListAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxTagBookListAjax.requestConfig = ajaxTagBookListAjaxRequestConfig;

/**
 * 接口 [获取tag信息 废弃，迁移到根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/4331) 的 **请求类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/GetBookTagsAjax`
 * @更新时间 `2019-09-19 15:57:37`
 */
export interface AjaxUserTagGetBookTagsAjaxRequest {}

/**
 * 接口 [获取tag信息 废弃，迁移到根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/4331) 的 **返回类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/GetBookTagsAjax`
 * @更新时间 `2019-09-19 15:57:37`
 */
export interface AjaxUserTagGetBookTagsAjaxResponse {
  /**
   * [{"tagId":1,"tagName":"test"},{"tagId":4,"tagName":"xxxx"}]
   */
  bookTags?: {
    /**
     * 1
     */
    tagId?: number;
    /**
     * "test"
     */
    tagName?: string;
  }[];
  /**
   * [{"tagId":7,"tagName":"test2"},{"tagId":10,"tagName":"xxxx3"}]
   */
  userTags?: {
    /**
     * 7
     */
    tagId?: number;
    /**
     * "test2"
     */
    tagName?: string;
  }[];
}

/**
 * 接口 [获取tag信息 废弃，迁移到根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/4331) 的 **请求配置的类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/GetBookTagsAjax`
 * @更新时间 `2019-09-19 15:57:37`
 */
type AjaxUserTagGetBookTagsAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/UserTag/GetBookTagsAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取tag信息 废弃，迁移到根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/4331) 的 **请求配置**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/GetBookTagsAjax`
 * @更新时间 `2019-09-19 15:57:37`
 */
const ajaxUserTagGetBookTagsAjaxRequestConfig: AjaxUserTagGetBookTagsAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_35,
    devUrl: devUrl_0_1_0_35,
    prodUrl: prodUrl_0_1_0_35,
    path: "/ajax/UserTag/GetBookTagsAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_35,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxUserTagGetBookTagsAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取tag信息 废弃，迁移到根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/4331) 的 **请求函数**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/GetBookTagsAjax`
 * @更新时间 `2019-09-19 15:57:37`
 */
export const ajaxUserTagGetBookTagsAjax = /*#__PURE__*/ (
  requestData?: AjaxUserTagGetBookTagsAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxUserTagGetBookTagsAjaxResponse>(
    prepare(ajaxUserTagGetBookTagsAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxUserTagGetBookTagsAjax.requestConfig =
  ajaxUserTagGetBookTagsAjaxRequestConfig;

/**
 * 接口 [获取用户tag↗](https://yapi.yuewen.com/project/28/interface/api/4456) 的 **请求类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/EditUserTagPage`
 * @更新时间 `2018-05-16 22:55:44`
 */
export interface AjaxUserTagEditUserTagPageRequest {}

/**
 * 接口 [获取用户tag↗](https://yapi.yuewen.com/project/28/interface/api/4456) 的 **返回类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/EditUserTagPage`
 * @更新时间 `2018-05-16 22:55:44`
 */
export interface AjaxUserTagEditUserTagPageResponse {
  /**
   * [{"tagName":"ttt1","tagId":123}]
   */
  userTags?: {
    /**
     * "ttt1"
     */
    tagName?: string;
    /**
     * 123
     */
    tagId?: number;
  }[];
}

/**
 * 接口 [获取用户tag↗](https://yapi.yuewen.com/project/28/interface/api/4456) 的 **请求配置的类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/EditUserTagPage`
 * @更新时间 `2018-05-16 22:55:44`
 */
type AjaxUserTagEditUserTagPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/UserTag/EditUserTagPage",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取用户tag↗](https://yapi.yuewen.com/project/28/interface/api/4456) 的 **请求配置**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/EditUserTagPage`
 * @更新时间 `2018-05-16 22:55:44`
 */
const ajaxUserTagEditUserTagPageRequestConfig: AjaxUserTagEditUserTagPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_35,
    devUrl: devUrl_0_1_0_35,
    prodUrl: prodUrl_0_1_0_35,
    path: "/ajax/UserTag/EditUserTagPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_35,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxUserTagEditUserTagPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取用户tag↗](https://yapi.yuewen.com/project/28/interface/api/4456) 的 **请求函数**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/EditUserTagPage`
 * @更新时间 `2018-05-16 22:55:44`
 */
export const ajaxUserTagEditUserTagPage = /*#__PURE__*/ (
  requestData?: AjaxUserTagEditUserTagPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxUserTagEditUserTagPageResponse>(
    prepare(ajaxUserTagEditUserTagPageRequestConfig, requestData),
    ...args
  );
};

ajaxUserTagEditUserTagPage.requestConfig =
  ajaxUserTagEditUserTagPageRequestConfig;

/**
 * 接口 [编辑tag↗](https://yapi.yuewen.com/project/28/interface/api/4808) 的 **请求类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/UserTag/AddDeleteUserTagsAjax`
 * @更新时间 `2018-05-17 13:52:10`
 */
export interface AjaxUserTagAddDeleteUserTagsAjaxRequest {}

/**
 * 接口 [编辑tag↗](https://yapi.yuewen.com/project/28/interface/api/4808) 的 **返回类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/UserTag/AddDeleteUserTagsAjax`
 * @更新时间 `2018-05-17 13:52:10`
 */
export interface AjaxUserTagAddDeleteUserTagsAjaxResponse {
  code?: number;
}

/**
 * 接口 [编辑tag↗](https://yapi.yuewen.com/project/28/interface/api/4808) 的 **请求配置的类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/UserTag/AddDeleteUserTagsAjax`
 * @更新时间 `2018-05-17 13:52:10`
 */
type AjaxUserTagAddDeleteUserTagsAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/UserTag/AddDeleteUserTagsAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [编辑tag↗](https://yapi.yuewen.com/project/28/interface/api/4808) 的 **请求配置**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/UserTag/AddDeleteUserTagsAjax`
 * @更新时间 `2018-05-17 13:52:10`
 */
const ajaxUserTagAddDeleteUserTagsAjaxRequestConfig: AjaxUserTagAddDeleteUserTagsAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_35,
    devUrl: devUrl_0_1_0_35,
    prodUrl: prodUrl_0_1_0_35,
    path: "/ajax/UserTag/AddDeleteUserTagsAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_35,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxUserTagAddDeleteUserTagsAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [编辑tag↗](https://yapi.yuewen.com/project/28/interface/api/4808) 的 **请求函数**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/UserTag/AddDeleteUserTagsAjax`
 * @更新时间 `2018-05-17 13:52:10`
 */
export const ajaxUserTagAddDeleteUserTagsAjax = /*#__PURE__*/ (
  requestData?: AjaxUserTagAddDeleteUserTagsAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxUserTagAddDeleteUserTagsAjaxResponse>(
    prepare(ajaxUserTagAddDeleteUserTagsAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxUserTagAddDeleteUserTagsAjax.requestConfig =
  ajaxUserTagAddDeleteUserTagsAjaxRequestConfig;

/**
 * 接口 [根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/60864) 的 **请求类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookTagList`
 * @更新时间 `2019-09-19 17:50:50`
 */
export interface AjaxTagBookTagListRequest {
  bookId: string;
  /**
   * 1
   */
  _csrfToken: string;
}

/**
 * 接口 [根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/60864) 的 **返回类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookTagList`
 * @更新时间 `2019-09-19 17:50:50`
 */
export interface AjaxTagBookTagListResponse {
  /**
   * [{"tagId":41090001,"tagName":"aaa","isLiked":0,"likeNums":10},{"tagId":41090002,"tagName":"bbb","isLiked":0,"likeNums":7},{"tagId":41090060,"tagName":"yc1","isLiked":0,"likeNums":2}]
   */
  tagInfo?: {
    /**
     * 41090001
     */
    tagId?: number;
    /**
     * "aaa"
     */
    tagName?: string;
    isLiked?: number;
    /**
     * 10
     */
    likeNums?: number;
  }[];
}

/**
 * 接口 [根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/60864) 的 **请求配置的类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookTagList`
 * @更新时间 `2019-09-19 17:50:50`
 */
type AjaxTagBookTagListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/tag/bookTagList",
    "data",
    string,
    "bookId" | "_csrfToken",
    false
  >
>;

/**
 * 接口 [根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/60864) 的 **请求配置**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookTagList`
 * @更新时间 `2019-09-19 17:50:50`
 */
const ajaxTagBookTagListRequestConfig: AjaxTagBookTagListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_35,
    devUrl: devUrl_0_1_0_35,
    prodUrl: prodUrl_0_1_0_35,
    path: "/ajax/tag/bookTagList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_35,
    paramNames: [],
    queryNames: ["bookId", "_csrfToken"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxTagBookTagList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/60864) 的 **请求函数**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookTagList`
 * @更新时间 `2019-09-19 17:50:50`
 */
export const ajaxTagBookTagList = /*#__PURE__*/ (
  requestData: AjaxTagBookTagListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxTagBookTagListResponse>(
    prepare(ajaxTagBookTagListRequestConfig, requestData),
    ...args
  );
};

ajaxTagBookTagList.requestConfig = ajaxTagBookTagListRequestConfig;

/**
 * 接口 [点赞标签↗](https://yapi.yuewen.com/project/28/interface/api/60869) 的 **请求类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/tag/support`
 * @更新时间 `2019-09-19 15:44:25`
 */
export interface AjaxTagSupportRequest {
  bookId: string;
  tagId: string;
  supportOp: string;
  _csrfToken: string;
}

/**
 * 接口 [点赞标签↗](https://yapi.yuewen.com/project/28/interface/api/60869) 的 **返回类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/tag/support`
 * @更新时间 `2019-09-19 15:44:25`
 */
export interface AjaxTagSupportResponse {}

/**
 * 接口 [点赞标签↗](https://yapi.yuewen.com/project/28/interface/api/60869) 的 **请求配置的类型**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/tag/support`
 * @更新时间 `2019-09-19 15:44:25`
 */
type AjaxTagSupportRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/tag/support",
    "data",
    string,
    "_csrfToken",
    false
  >
>;

/**
 * 接口 [点赞标签↗](https://yapi.yuewen.com/project/28/interface/api/60869) 的 **请求配置**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/tag/support`
 * @更新时间 `2019-09-19 15:44:25`
 */
const ajaxTagSupportRequestConfig: AjaxTagSupportRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_1_0_35,
  devUrl: devUrl_0_1_0_35,
  prodUrl: prodUrl_0_1_0_35,
  path: "/ajax/tag/support",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_1_0_35,
  paramNames: [],
  queryNames: ["_csrfToken"],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "ajaxTagSupport",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [点赞标签↗](https://yapi.yuewen.com/project/28/interface/api/60869) 的 **请求函数**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/tag/support`
 * @更新时间 `2019-09-19 15:44:25`
 */
export const ajaxTagSupport = /*#__PURE__*/ (
  requestData: AjaxTagSupportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxTagSupportResponse>(
    prepare(ajaxTagSupportRequestConfig, requestData),
    ...args
  );
};

ajaxTagSupport.requestConfig = ajaxTagSupportRequestConfig;

const mockUrl_0_1_0_36 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_36 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_36 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_36 = "data" as any;

/**
 * 接口 [GetMessages 消息列表↗](https://yapi.yuewen.com/project/28/interface/api/51217) 的 **请求类型**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /ajax/message/GetMessagesAjax`
 * @更新时间 `2019-05-13 19:51:47`
 */
export interface AjaxMessageGetMessagesAjaxRequest {
  /**
   * lastId 上次返回的最后一条id.如果是第一次调用,传空字符串
   */
  lastId: string;
}

/**
 * 接口 [GetMessages 消息列表↗](https://yapi.yuewen.com/project/28/interface/api/51217) 的 **返回类型**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /ajax/message/GetMessagesAjax`
 * @更新时间 `2019-05-13 19:51:47`
 */
export interface AjaxMessageGetMessagesAjaxResponse {
  /**
   * [{"id":"@id","createTime":"@timestamp","createTimeFormat":"11, Nov","title":"@title","content":"@string","imageUrl":"@url","actionUrl":"@url"}]
   */
  messageItems?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "11, Nov"
     */
    createTimeFormat?: string;
    /**
     * "@title"
     */
    title?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * "@url"
     */
    imageUrl?: string;
    /**
     * "@url"
     */
    actionUrl?: string;
  }[];
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [GetMessages 消息列表↗](https://yapi.yuewen.com/project/28/interface/api/51217) 的 **请求配置的类型**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /ajax/message/GetMessagesAjax`
 * @更新时间 `2019-05-13 19:51:47`
 */
type AjaxMessageGetMessagesAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/message/GetMessagesAjax",
    "data",
    string,
    "lastId",
    false
  >
>;

/**
 * 接口 [GetMessages 消息列表↗](https://yapi.yuewen.com/project/28/interface/api/51217) 的 **请求配置**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /ajax/message/GetMessagesAjax`
 * @更新时间 `2019-05-13 19:51:47`
 */
const ajaxMessageGetMessagesAjaxRequestConfig: AjaxMessageGetMessagesAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_36,
    devUrl: devUrl_0_1_0_36,
    prodUrl: prodUrl_0_1_0_36,
    path: "/ajax/message/GetMessagesAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_36,
    paramNames: [],
    queryNames: ["lastId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxMessageGetMessagesAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [GetMessages 消息列表↗](https://yapi.yuewen.com/project/28/interface/api/51217) 的 **请求函数**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /ajax/message/GetMessagesAjax`
 * @更新时间 `2019-05-13 19:51:47`
 */
export const ajaxMessageGetMessagesAjax = /*#__PURE__*/ (
  requestData: AjaxMessageGetMessagesAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxMessageGetMessagesAjaxResponse>(
    prepare(ajaxMessageGetMessagesAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxMessageGetMessagesAjax.requestConfig =
  ajaxMessageGetMessagesAjaxRequestConfig;

/**
 * 接口 [Following↗](https://yapi.yuewen.com/project/28/interface/api/81734) 的 **请求类型**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2024-08-09 14:27:50`
 */
export interface GoPcmMessageGetFollowingRequest {}

/**
 * 接口 [Following↗](https://yapi.yuewen.com/project/28/interface/api/81734) 的 **返回类型**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2024-08-09 14:27:50`
 */
export interface GoPcmMessageGetFollowingResponse {
  /**
   * [{"id":"@id","title":"fewfwefwef","imageUrl":"wefwfew://efwefw/1.png","content":"test message","actionUrl":"/vote","createTime":"@timestamp","bookId":1112334454554,"bookType":0,"bookCoverId":144433332}]
   */
  followingItems?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "fewfwefwef"
     */
    title?: string;
    /**
     * "wefwfew://efwefw/1.png"
     */
    imageUrl?: string;
    /**
     * "test message"
     */
    content?: string;
    /**
     * "/vote"
     */
    actionUrl?: string;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * 1112334454554
     */
    bookId?: number;
    bookType?: number;
    /**
     * 144433332
     */
    bookCoverId?: number;
  }[];
  user?: {
    avatar?: string;
    nickName?: string;
    userName?: string;
    guid?: string;
    /**
     * -1
     */
    status?: number;
    penName?: null;
    UUT?: null;
    role?: null;
    userLevel?: null;
    availablePower?: null;
    totalPower?: null;
    availableEnergy?: null;
    totalEnergy?: null;
  };
  /**
   * "@id"
   */
  lastId?: string;
  isLast?: number;
}

/**
 * 接口 [Following↗](https://yapi.yuewen.com/project/28/interface/api/81734) 的 **请求配置的类型**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2024-08-09 14:27:50`
 */
type GoPcmMessageGetFollowingRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/message/getFollowing",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [Following↗](https://yapi.yuewen.com/project/28/interface/api/81734) 的 **请求配置**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2024-08-09 14:27:50`
 */
const goPcmMessageGetFollowingRequestConfig: GoPcmMessageGetFollowingRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_36,
    devUrl: devUrl_0_1_0_36,
    prodUrl: prodUrl_0_1_0_36,
    path: "/go/pcm/message/getFollowing",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_36,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMessageGetFollowing",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [Following↗](https://yapi.yuewen.com/project/28/interface/api/81734) 的 **请求函数**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2024-08-09 14:27:50`
 */
export const goPcmMessageGetFollowing = /*#__PURE__*/ (
  requestData?: GoPcmMessageGetFollowingRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMessageGetFollowingResponse>(
    prepare(goPcmMessageGetFollowingRequestConfig, requestData),
    ...args
  );
};

goPcmMessageGetFollowing.requestConfig = goPcmMessageGetFollowingRequestConfig;

const mockUrl_0_1_0_37 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_37 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_37 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_37 = "data" as any;

/**
 * 接口 [listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/51220) 的 **请求类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/listAjax`
 * @更新时间 `2019-08-12 15:13:33`
 */
export interface AjaxNotificationListAjaxRequest {
  /**
   * lastId 上次返回的最后一条id.如果是第一次调用,传空字符串
   */
  lastId: string;
}

/**
 * 接口 [listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/51220) 的 **返回类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/listAjax`
 * @更新时间 `2019-08-12 15:13:33`
 */
export interface AjaxNotificationListAjaxResponse {
  /**
   * [{"id":"@id","bookId":"7366916601012405","chapterReviewId":1557315300000,"bookReviewId":1557315300000,"replyType":1,"replyId":1557315300000,"opType":1,"createTime":"@timestamp","createTimeFormat":"11,Nov","userId":1234433,"appId":20,"imageId":1557315300000,"userName":"@name","content":"@string","originalContent":"@string","status":1,"originalStatus":1,"novelType":0},{"id":"@id","bookId":"11558338301012801","chapterReviewId":1557315300000,"bookReviewId":1557315300000,"replyType":1,"replyId":1557315300000,"opType":1,"createTime":"@timestamp","createTimeFormat":"11,Nov","userId":1234433,"appId":20,"imageId":1557315300000,"userName":"@name","content":"@string","originalContent":"@string","status":1,"originalStatus":1,"novelType":100},{"id":"@id","bookId":"123","chapterReviewId":1557315300000,"bookReviewId":1557315300000,"replyType":1,"replyId":1557315300000,"opType":1,"createTime":"@timestamp","createTimeFormat":"11,Nov","userId":1234433,"appId":20,"imageId":1557315300000,"userName":"@name","content":"@string","originalContent":"@string","status":1,"originalStatus":1,"novelType":200}]
   */
  notificationItems?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "7366916601012405"
     */
    bookId?: string;
    /**
     * 1557315300000
     */
    chapterReviewId?: number;
    /**
     * 1557315300000
     */
    bookReviewId?: number;
    /**
     * 1
     */
    replyType?: number;
    /**
     * 1557315300000
     */
    replyId?: number;
    /**
     * 1
     */
    opType?: number;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "11,Nov"
     */
    createTimeFormat?: string;
    /**
     * 1234433
     */
    userId?: number;
    /**
     * 20
     */
    appId?: number;
    /**
     * 1557315300000
     */
    imageId?: number;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * "@string"
     */
    originalContent?: string;
    /**
     * 1
     */
    status?: number;
    /**
     * 1
     */
    originalStatus?: number;
    novelType?: number;
  }[];
  systemNotificationItem?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "@string"
     */
    title?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "11, Nov"
     */
    createTimeFormat?: string;
    /**
     * 1
     */
    type?: number;
  };
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/51220) 的 **请求配置的类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/listAjax`
 * @更新时间 `2019-08-12 15:13:33`
 */
type AjaxNotificationListAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/notification/listAjax",
    "data",
    string,
    "lastId",
    false
  >
>;

/**
 * 接口 [listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/51220) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/listAjax`
 * @更新时间 `2019-08-12 15:13:33`
 */
const ajaxNotificationListAjaxRequestConfig: AjaxNotificationListAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_37,
    devUrl: devUrl_0_1_0_37,
    prodUrl: prodUrl_0_1_0_37,
    path: "/ajax/notification/listAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_37,
    paramNames: [],
    queryNames: ["lastId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxNotificationListAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/51220) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/listAjax`
 * @更新时间 `2019-08-12 15:13:33`
 */
export const ajaxNotificationListAjax = /*#__PURE__*/ (
  requestData: AjaxNotificationListAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxNotificationListAjaxResponse>(
    prepare(ajaxNotificationListAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxNotificationListAjax.requestConfig = ajaxNotificationListAjaxRequestConfig;

/**
 * 接口 [systemListAjax 系统通知列表↗](https://yapi.yuewen.com/project/28/interface/api/51223) 的 **请求类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/systemListAjax`
 * @更新时间 `2019-05-13 19:56:30`
 */
export interface AjaxNotificationSystemListAjaxRequest {
  /**
   * lastId 上次返回的最后一条id.如果是第一次调用,传空字符串
   */
  lastId: string;
}

/**
 * 接口 [systemListAjax 系统通知列表↗](https://yapi.yuewen.com/project/28/interface/api/51223) 的 **返回类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/systemListAjax`
 * @更新时间 `2019-05-13 19:56:30`
 */
export interface AjaxNotificationSystemListAjaxResponse {
  /**
   * [{"id":"@id","title":"@string","content":"@string","createTime":"@timestamp","createTimeFormat":"11, Nov","type":1}]
   */
  notificationItems?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "@string"
     */
    title?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "11, Nov"
     */
    createTimeFormat?: string;
    /**
     * 1
     */
    type?: number;
  }[];
  isLast?: boolean;
}

/**
 * 接口 [systemListAjax 系统通知列表↗](https://yapi.yuewen.com/project/28/interface/api/51223) 的 **请求配置的类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/systemListAjax`
 * @更新时间 `2019-05-13 19:56:30`
 */
type AjaxNotificationSystemListAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/notification/systemListAjax",
    "data",
    string,
    "lastId",
    false
  >
>;

/**
 * 接口 [systemListAjax 系统通知列表↗](https://yapi.yuewen.com/project/28/interface/api/51223) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/systemListAjax`
 * @更新时间 `2019-05-13 19:56:30`
 */
const ajaxNotificationSystemListAjaxRequestConfig: AjaxNotificationSystemListAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_37,
    devUrl: devUrl_0_1_0_37,
    prodUrl: prodUrl_0_1_0_37,
    path: "/ajax/notification/systemListAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_37,
    paramNames: [],
    queryNames: ["lastId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxNotificationSystemListAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [systemListAjax 系统通知列表↗](https://yapi.yuewen.com/project/28/interface/api/51223) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/systemListAjax`
 * @更新时间 `2019-05-13 19:56:30`
 */
export const ajaxNotificationSystemListAjax = /*#__PURE__*/ (
  requestData: AjaxNotificationSystemListAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxNotificationSystemListAjaxResponse>(
    prepare(ajaxNotificationSystemListAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxNotificationSystemListAjax.requestConfig =
  ajaxNotificationSystemListAjaxRequestConfig;

/**
 * 接口 [status 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/28/interface/api/51228) 的 **请求类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/status`
 * @更新时间 `2021-01-15 21:44:11`
 */
export interface AjaxNotificationStatusRequest {}

/**
 * 接口 [status 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/28/interface/api/51228) 的 **返回类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/status`
 * @更新时间 `2021-01-15 21:44:11`
 */
export interface AjaxNotificationStatusResponse {
  /**
   * 1
   */
  messageStatus?: number;
  /**
   * 1
   */
  notificationStatus?: number;
  /**
   * 1
   */
  systemNotificationStatus?: number;
  /**
   * 1
   */
  followingStatus?: number;
}

/**
 * 接口 [status 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/28/interface/api/51228) 的 **请求配置的类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/status`
 * @更新时间 `2021-01-15 21:44:11`
 */
type AjaxNotificationStatusRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/notification/status",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [status 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/28/interface/api/51228) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/status`
 * @更新时间 `2021-01-15 21:44:11`
 */
const ajaxNotificationStatusRequestConfig: AjaxNotificationStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_37,
    devUrl: devUrl_0_1_0_37,
    prodUrl: prodUrl_0_1_0_37,
    path: "/ajax/notification/status",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_37,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxNotificationStatus",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [status 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/28/interface/api/51228) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/status`
 * @更新时间 `2021-01-15 21:44:11`
 */
export const ajaxNotificationStatus = /*#__PURE__*/ (
  requestData?: AjaxNotificationStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxNotificationStatusResponse>(
    prepare(ajaxNotificationStatusRequestConfig, requestData),
    ...args
  );
};

ajaxNotificationStatus.requestConfig = ajaxNotificationStatusRequestConfig;

/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/118365) 的 **请求类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-07-29 10:45:56`
 */
export interface GoPcmNotificationListAjaxRequest {
  /**
   * lastId 上次返回的最后一条id.如果是第一次调用,传空字符串
   */
  lastId: string;
}

/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/118365) 的 **返回类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-07-29 10:45:56`
 */
export interface GoPcmNotificationListAjaxResponse {
  /**
   * [{"id":"@id","bookId":"7366916601012405","chapterReviewId":1557315300000,"bookReviewId":1557315300000,"replyType":1,"replyId":1557315300000,"opType":1,"createTime":"@timestamp","createTimeFormat":"11,Nov","userId":1234433,"appId":20,"imageId":1557315300000,"userName":"@name","content":"@string","originalContent":"@string","status":1,"originalStatus":1,"novelType":0,"imageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}],"originalImageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}]},{"id":"@id","bookId":"11558338301012801","chapterReviewId":1557315300000,"bookReviewId":1557315300000,"replyType":1,"replyId":1557315300000,"opType":1,"createTime":"@timestamp","createTimeFormat":"11,Nov","userId":1234433,"appId":20,"imageId":1557315300000,"userName":"@name","content":"@string","originalContent":"@string","status":1,"originalStatus":1,"novelType":100,"imageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}],"originalImageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}]},{"id":"@id","bookId":"123","chapterReviewId":1557315300000,"bookReviewId":1557315300000,"replyType":1,"replyId":1557315300000,"opType":1,"createTime":"@timestamp","createTimeFormat":"11,Nov","userId":1234433,"appId":20,"imageId":1557315300000,"userName":"@name","content":"@string","originalContent":"@string","status":1,"originalStatus":1,"novelType":200,"imageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}],"originalImageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}]}]
   */
  notificationItems?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "7366916601012405"
     */
    bookId?: string;
    /**
     * 1557315300000
     */
    chapterReviewId?: number;
    /**
     * 1557315300000
     */
    bookReviewId?: number;
    /**
     * 1
     */
    replyType?: number;
    /**
     * 1557315300000
     */
    replyId?: number;
    /**
     * 1
     */
    opType?: number;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "11,Nov"
     */
    createTimeFormat?: string;
    /**
     * 1234433
     */
    userId?: number;
    /**
     * 20
     */
    appId?: number;
    /**
     * 1557315300000
     */
    imageId?: number;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * "@string"
     */
    originalContent?: string;
    /**
     * 1
     */
    status?: number;
    /**
     * 1
     */
    originalStatus?: number;
    novelType?: number;
    /**
     * [{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}]
     */
    imageItems?: {
      /**
       * "https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif"
       */
      imageUrl?: string;
      /**
       * 498
       */
      height?: number;
      /**
       * 332
       */
      width?: number;
    }[];
    /**
     * [{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}]
     */
    originalImageItems?: {
      /**
       * "https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif"
       */
      imageUrl?: string;
      /**
       * 200
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
  }[];
  systemNotificationItem?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "@string"
     */
    title?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "11, Nov"
     */
    createTimeFormat?: string;
    /**
     * 1
     */
    type?: number;
  };
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/118365) 的 **请求配置的类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-07-29 10:45:56`
 */
type GoPcmNotificationListAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/go/pcm/notification/listAjax",
    "data",
    string,
    "lastId",
    false
  >
>;

/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/118365) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-07-29 10:45:56`
 */
const goPcmNotificationListAjaxRequestConfig: GoPcmNotificationListAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_37,
    devUrl: devUrl_0_1_0_37,
    prodUrl: prodUrl_0_1_0_37,
    path: "/go/pcm/notification/listAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_37,
    paramNames: [],
    queryNames: ["lastId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmNotificationListAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/118365) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-07-29 10:45:56`
 */
export const goPcmNotificationListAjax = /*#__PURE__*/ (
  requestData: GoPcmNotificationListAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmNotificationListAjaxResponse>(
    prepare(goPcmNotificationListAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmNotificationListAjax.requestConfig =
  goPcmNotificationListAjaxRequestConfig;

const mockUrl_0_1_0_38 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_38 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_38 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_38 = "data" as any;

/**
 * 接口 [获取所有tag↗](https://yapi.yuewen.com/project/28/interface/api/2137) 的 **请求类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /page/activity/GetTags`
 * @更新时间 `2018-04-16 11:04:36`
 */
export interface PageActivityGetTagsRequest {}

/**
 * 接口 [获取所有tag↗](https://yapi.yuewen.com/project/28/interface/api/2137) 的 **返回类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /page/activity/GetTags`
 * @更新时间 `2018-04-16 11:04:36`
 */
export interface PageActivityGetTagsResponse {
  /**
   * [{"tagId":1,"tagName":"@String"}]
   */
  tagItems?: {
    /**
     * 1
     */
    tagId?: number;
    /**
     * "@String"
     */
    tagName?: string;
  }[];
  user?: {
    guid?: string;
    /**
     * "昵称"
     */
    nickName?: string;
    /**
     * "真实名称"
     */
    userName?: string;
    /**
     * "笔名"
     */
    penName?: string;
    /**
     * "角色"
     */
    role?: string;
    /**
     * "0-登录 -1-未登录"
     */
    status?: string;
    /**
     * "头像"
     */
    avatar?: string;
    /**
     * "0-当天未签到 1-当天已签到"
     */
    isCheckin?: string;
    /**
     * "1 //用户等级"
     */
    userLevel?: string;
  };
}

/**
 * 接口 [获取所有tag↗](https://yapi.yuewen.com/project/28/interface/api/2137) 的 **请求配置的类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /page/activity/GetTags`
 * @更新时间 `2018-04-16 11:04:36`
 */
type PageActivityGetTagsRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/page/activity/GetTags",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取所有tag↗](https://yapi.yuewen.com/project/28/interface/api/2137) 的 **请求配置**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /page/activity/GetTags`
 * @更新时间 `2018-04-16 11:04:36`
 */
const pageActivityGetTagsRequestConfig: PageActivityGetTagsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_38,
    devUrl: devUrl_0_1_0_38,
    prodUrl: prodUrl_0_1_0_38,
    path: "/page/activity/GetTags",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageActivityGetTags",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取所有tag↗](https://yapi.yuewen.com/project/28/interface/api/2137) 的 **请求函数**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /page/activity/GetTags`
 * @更新时间 `2018-04-16 11:04:36`
 */
export const pageActivityGetTags = /*#__PURE__*/ (
  requestData?: PageActivityGetTagsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PageActivityGetTagsResponse>(
    prepare(pageActivityGetTagsRequestConfig, requestData),
    ...args
  );
};

pageActivityGetTags.requestConfig = pageActivityGetTagsRequestConfig;

/**
 * 接口 [保存tag↗](https://yapi.yuewen.com/project/28/interface/api/2194) 的 **请求类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/activity/SaveTags`
 * @更新时间 `2018-04-16 12:43:18`
 */
export interface AjaxActivitySaveTags2Request {
  /**
   * tagId，以|分割
   */
  tagIds: string;
}

/**
 * 接口 [保存tag↗](https://yapi.yuewen.com/project/28/interface/api/2194) 的 **返回类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/activity/SaveTags`
 * @更新时间 `2018-04-16 12:43:18`
 */
export interface AjaxActivitySaveTags2Response {
  /**
   * 0:成功；其他：失败
   */
  code: number;
}

/**
 * 接口 [保存tag↗](https://yapi.yuewen.com/project/28/interface/api/2194) 的 **请求配置的类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/activity/SaveTags`
 * @更新时间 `2018-04-16 12:43:18`
 */
type AjaxActivitySaveTags2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/activity/SaveTags",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [保存tag↗](https://yapi.yuewen.com/project/28/interface/api/2194) 的 **请求配置**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/activity/SaveTags`
 * @更新时间 `2018-04-16 12:43:18`
 */
const ajaxActivitySaveTags2RequestConfig: AjaxActivitySaveTags2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_38,
    devUrl: devUrl_0_1_0_38,
    prodUrl: prodUrl_0_1_0_38,
    path: "/ajax/activity/SaveTags",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxActivitySaveTags2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [保存tag↗](https://yapi.yuewen.com/project/28/interface/api/2194) 的 **请求函数**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/activity/SaveTags`
 * @更新时间 `2018-04-16 12:43:18`
 */
export const ajaxActivitySaveTags2 = /*#__PURE__*/ (
  requestData: AjaxActivitySaveTags2Request,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxActivitySaveTags2Response>(
    prepare(ajaxActivitySaveTags2RequestConfig, requestData),
    ...args
  );
};

ajaxActivitySaveTags2.requestConfig = ajaxActivitySaveTags2RequestConfig;

/**
 * 接口 [\/ajax\/activity\/getTags↗](https://yapi.yuewen.com/project/28/interface/api/9220) 的 **请求类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/activity/getTags`
 * @更新时间 `2018-12-24 11:15:30`
 */
export interface AjaxActivityGetTagsRequest {}

/**
 * 接口 [\/ajax\/activity\/getTags↗](https://yapi.yuewen.com/project/28/interface/api/9220) 的 **返回类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/activity/getTags`
 * @更新时间 `2018-12-24 11:15:30`
 */
export interface AjaxActivityGetTagsResponse {
  /**
   * [{"tagId":1,"tagName":"@String"}]
   */
  tagItems?: {
    /**
     * 1
     */
    tagId?: number;
    /**
     * "@String"
     */
    tagName?: string;
  }[];
  user?: {
    guid?: string;
    /**
     * "昵称"
     */
    nickName?: string;
    /**
     * "真实名称"
     */
    userName?: string;
    /**
     * "笔名"
     */
    penName?: string;
    /**
     * "角色"
     */
    role?: string;
    /**
     * "0-登录 -1-未登录"
     */
    status?: string;
    /**
     * "头像"
     */
    avatar?: string;
    /**
     * "0-当天未签到 1-当天已签到"
     */
    isCheckin?: string;
    /**
     * "1 //用户等级"
     */
    userLevel?: string;
  };
}

/**
 * 接口 [\/ajax\/activity\/getTags↗](https://yapi.yuewen.com/project/28/interface/api/9220) 的 **请求配置的类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/activity/getTags`
 * @更新时间 `2018-12-24 11:15:30`
 */
type AjaxActivityGetTagsRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/activity/getTags",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [\/ajax\/activity\/getTags↗](https://yapi.yuewen.com/project/28/interface/api/9220) 的 **请求配置**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/activity/getTags`
 * @更新时间 `2018-12-24 11:15:30`
 */
const ajaxActivityGetTagsRequestConfig: AjaxActivityGetTagsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_38,
    devUrl: devUrl_0_1_0_38,
    prodUrl: prodUrl_0_1_0_38,
    path: "/ajax/activity/getTags",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxActivityGetTags",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/ajax\/activity\/getTags↗](https://yapi.yuewen.com/project/28/interface/api/9220) 的 **请求函数**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/activity/getTags`
 * @更新时间 `2018-12-24 11:15:30`
 */
export const ajaxActivityGetTags = /*#__PURE__*/ (
  requestData?: AjaxActivityGetTagsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxActivityGetTagsResponse>(
    prepare(ajaxActivityGetTagsRequestConfig, requestData),
    ...args
  );
};

ajaxActivityGetTags.requestConfig = ajaxActivityGetTagsRequestConfig;

/**
 * 接口 [\/ajax\/task\/taskList↗](https://yapi.yuewen.com/project/28/interface/api/25314) 的 **请求类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/task/taskList`
 * @更新时间 `2019-11-22 10:30:23`
 */
export interface AjaxTaskTaskListRequest {
  /**
   * 1为daily 2为upgrade 3为reading
   */
  taskType: string;
}

/**
 * 接口 [\/ajax\/task\/taskList↗](https://yapi.yuewen.com/project/28/interface/api/25314) 的 **返回类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/task/taskList`
 * @更新时间 `2019-11-22 10:30:23`
 */
export interface AjaxTaskTaskListResponse {
  /**
   * [{"taskId":100101,"taskName":"checkin","completeStatus":1,"completePercentage":-1,"taskType":1,"ss":-1,"exp":20,"awards":[{"awardType":1,"amount":0}]},{"taskId":100102,"taskName":"gift two book","completeStatus":1,"completePercentage":50,"taskType":1,"ss":0,"exp":21,"awards":[{"awardType":1,"amount":0}]},{"taskId":100103,"taskName":"post a review","completeStatus":1,"completePercentage":-1,"taskType":1,"ss":33,"exp":0,"awards":[{"awardType":1,"amount":0}]},{"taskId":100108,"taskName":"give a ps","completeStatus":1,"completePercentage":-1,"taskType":1,"ss":33,"exp":-1,"awards":[{"awardType":1,"amount":0}]},{"taskId":100206,"taskName":"purchase","completeStatus":2,"completePercentage":-1,"taskType":1,"ss":0,"exp":21,"awards":[{"awardType":1,"amount":0}]},{"taskId":100207,"taskName":"spend ss","completeStatus":3,"completePercentage":-1,"taskType":1,"ss":33,"exp":21,"awards":[{"awardType":1,"amount":0}]},{"taskId":100107,"taskName":"spend ss","completeStatus":3,"completePercentage":-1,"taskType":1,"ss":33,"exp":21,"awards":[{"awardType":1,"amount":0}]},{"taskId":100201,"taskName":"spend ss","completeStatus":3,"completePercentage":-1,"taskType":1,"ss":33,"exp":21,"awards":[{"awardType":1,"amount":0}]}]
   */
  taskList?: {
    /**
     * 100101
     */
    taskId?: number;
    /**
     * "checkin"
     */
    taskName?: string;
    /**
     * 1
     */
    completeStatus?: number;
    /**
     * -1
     */
    completePercentage?: number;
    /**
     * 1
     */
    taskType?: number;
    /**
     * -1
     */
    ss?: number;
    /**
     * 20
     */
    exp?: number;
    /**
     * [{"awardType":1,"amount":0}]
     */
    awards?: {
      /**
       * 1
       */
      awardType?: number;
      amount?: number;
    }[];
  }[];
  /**
   * 1
   */
  taskType?: number;
}

/**
 * 接口 [\/ajax\/task\/taskList↗](https://yapi.yuewen.com/project/28/interface/api/25314) 的 **请求配置的类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/task/taskList`
 * @更新时间 `2019-11-22 10:30:23`
 */
type AjaxTaskTaskListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/task/taskList",
    "data",
    string,
    "taskType",
    false
  >
>;

/**
 * 接口 [\/ajax\/task\/taskList↗](https://yapi.yuewen.com/project/28/interface/api/25314) 的 **请求配置**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/task/taskList`
 * @更新时间 `2019-11-22 10:30:23`
 */
const ajaxTaskTaskListRequestConfig: AjaxTaskTaskListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_38,
    devUrl: devUrl_0_1_0_38,
    prodUrl: prodUrl_0_1_0_38,
    path: "/ajax/task/taskList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_38,
    paramNames: [],
    queryNames: ["taskType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxTaskTaskList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/ajax\/task\/taskList↗](https://yapi.yuewen.com/project/28/interface/api/25314) 的 **请求函数**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/task/taskList`
 * @更新时间 `2019-11-22 10:30:23`
 */
export const ajaxTaskTaskList = /*#__PURE__*/ (
  requestData: AjaxTaskTaskListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxTaskTaskListResponse>(
    prepare(ajaxTaskTaskListRequestConfig, requestData),
    ...args
  );
};

ajaxTaskTaskList.requestConfig = ajaxTaskTaskListRequestConfig;

/**
 * 接口 [\/ajax\/task\/claimTaskReward↗](https://yapi.yuewen.com/project/28/interface/api/25481) 的 **请求类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/task/claimTaskReward`
 * @更新时间 `2019-11-14 14:33:02`
 */
export interface AjaxTaskClaimTaskRewardRequest {
  /**
   * 123
   */
  taskId: string;
}

/**
 * 接口 [\/ajax\/task\/claimTaskReward↗](https://yapi.yuewen.com/project/28/interface/api/25481) 的 **返回类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/task/claimTaskReward`
 * @更新时间 `2019-11-14 14:33:02`
 */
export interface AjaxTaskClaimTaskRewardResponse {
  taskInfo?: {
    /**
     * 12
     */
    ss?: number;
    exp?: number;
    /**
     * [{"awardType":1,"amount":0}]
     */
    awards?: {
      /**
       * 1
       */
      awardType?: number;
      amount?: number;
    }[];
  };
}

/**
 * 接口 [\/ajax\/task\/claimTaskReward↗](https://yapi.yuewen.com/project/28/interface/api/25481) 的 **请求配置的类型**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/task/claimTaskReward`
 * @更新时间 `2019-11-14 14:33:02`
 */
type AjaxTaskClaimTaskRewardRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/task/claimTaskReward",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [\/ajax\/task\/claimTaskReward↗](https://yapi.yuewen.com/project/28/interface/api/25481) 的 **请求配置**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/task/claimTaskReward`
 * @更新时间 `2019-11-14 14:33:02`
 */
const ajaxTaskClaimTaskRewardRequestConfig: AjaxTaskClaimTaskRewardRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_38,
    devUrl: devUrl_0_1_0_38,
    prodUrl: prodUrl_0_1_0_38,
    path: "/ajax/task/claimTaskReward",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxTaskClaimTaskReward",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/ajax\/task\/claimTaskReward↗](https://yapi.yuewen.com/project/28/interface/api/25481) 的 **请求函数**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/task/claimTaskReward`
 * @更新时间 `2019-11-14 14:33:02`
 */
export const ajaxTaskClaimTaskReward = /*#__PURE__*/ (
  requestData: AjaxTaskClaimTaskRewardRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxTaskClaimTaskRewardResponse>(
    prepare(ajaxTaskClaimTaskRewardRequestConfig, requestData),
    ...args
  );
};

ajaxTaskClaimTaskReward.requestConfig = ajaxTaskClaimTaskRewardRequestConfig;

const mockUrl_0_1_0_39 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_39 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_39 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_39 = "data" as any;

/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/28/interface/api/2326) 的 **请求类型**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /ajax/cdkey/needCaptcha`
 * @更新时间 `2018-06-29 15:10:39`
 */
export interface AjaxCdkeyNeedCaptchaRequest {}

/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/28/interface/api/2326) 的 **返回类型**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /ajax/cdkey/needCaptcha`
 * @更新时间 `2018-06-29 15:10:39`
 */
export interface AjaxCdkeyNeedCaptchaResponse {
  /**
   * 1: 需要captcha 0:不需要captcha
   */
  needCaptcha: number;
}

/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/28/interface/api/2326) 的 **请求配置的类型**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /ajax/cdkey/needCaptcha`
 * @更新时间 `2018-06-29 15:10:39`
 */
type AjaxCdkeyNeedCaptchaRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/cdkey/needCaptcha",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/28/interface/api/2326) 的 **请求配置**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /ajax/cdkey/needCaptcha`
 * @更新时间 `2018-06-29 15:10:39`
 */
const ajaxCdkeyNeedCaptchaRequestConfig: AjaxCdkeyNeedCaptchaRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_39,
    devUrl: devUrl_0_1_0_39,
    prodUrl: prodUrl_0_1_0_39,
    path: "/ajax/cdkey/needCaptcha",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxCdkeyNeedCaptcha",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/28/interface/api/2326) 的 **请求函数**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /ajax/cdkey/needCaptcha`
 * @更新时间 `2018-06-29 15:10:39`
 */
export const ajaxCdkeyNeedCaptcha = /*#__PURE__*/ (
  requestData?: AjaxCdkeyNeedCaptchaRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxCdkeyNeedCaptchaResponse>(
    prepare(ajaxCdkeyNeedCaptchaRequestConfig, requestData),
    ...args
  );
};

ajaxCdkeyNeedCaptcha.requestConfig = ajaxCdkeyNeedCaptchaRequestConfig;

/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/28/interface/api/2333) 的 **请求类型**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `POST /ajax/cdkey/redeem`
 * @更新时间 `2024-08-09 14:49:35`
 */
export interface AjaxCdkeyRedeemRequest {
  /**
   * 礼品卡code
   */
  cdkey: string;
  /**
   * 两次错误之后，需要输入谷歌验证码
   */
  "g-recaptcha-response"?: string;
}

/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/28/interface/api/2333) 的 **返回类型**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `POST /ajax/cdkey/redeem`
 * @更新时间 `2024-08-09 14:49:35`
 */
export interface AjaxCdkeyRedeemResponse {
  /**
   * 成功兑换的bonus
   */
  bonus: string;
}

/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/28/interface/api/2333) 的 **请求配置的类型**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `POST /ajax/cdkey/redeem`
 * @更新时间 `2024-08-09 14:49:35`
 */
type AjaxCdkeyRedeemRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/cdkey/redeem",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/28/interface/api/2333) 的 **请求配置**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `POST /ajax/cdkey/redeem`
 * @更新时间 `2024-08-09 14:49:35`
 */
const ajaxCdkeyRedeemRequestConfig: AjaxCdkeyRedeemRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_39,
    devUrl: devUrl_0_1_0_39,
    prodUrl: prodUrl_0_1_0_39,
    path: "/ajax/cdkey/redeem",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxCdkeyRedeem",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/28/interface/api/2333) 的 **请求函数**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `POST /ajax/cdkey/redeem`
 * @更新时间 `2024-08-09 14:49:35`
 */
export const ajaxCdkeyRedeem = /*#__PURE__*/ (
  requestData: AjaxCdkeyRedeemRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxCdkeyRedeemResponse>(
    prepare(ajaxCdkeyRedeemRequestConfig, requestData),
    ...args
  );
};

ajaxCdkeyRedeem.requestConfig = ajaxCdkeyRedeemRequestConfig;

/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/28/interface/api/6320) 的 **请求类型**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /page/Cdkey/UserStatus`
 * @更新时间 `2018-06-29 14:53:57`
 */
export interface PageCdkeyUserStatusRequest {}

/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/28/interface/api/6320) 的 **返回类型**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /page/Cdkey/UserStatus`
 * @更新时间 `2018-06-29 14:53:57`
 */
export interface PageCdkeyUserStatusResponse {
  hours?: number;
  userStatus?: number;
  user?: {
    /**
     * "2959616949"
     */
    guid?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/2959616949/1/1.jpg?mt=1527475612000"
     */
    avatar?: string;
    /**
     * "Eason"
     */
    userName?: string;
    nickName?: null;
    penName?: string;
    role?: number;
    status?: number;
    /**
     * 16751
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 3
     */
    userLevel?: number;
    /**
     * 1
     */
    availablePower?: number;
    /**
     * 1
     */
    totalPower?: number;
    /**
     * 2
     */
    availableEnergy?: number;
    /**
     * 2
     */
    totalEnergy?: number;
    /**
     * 1
     */
    emailStatus?: number;
  };
}

/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/28/interface/api/6320) 的 **请求配置的类型**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /page/Cdkey/UserStatus`
 * @更新时间 `2018-06-29 14:53:57`
 */
type PageCdkeyUserStatusRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/page/Cdkey/UserStatus",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/28/interface/api/6320) 的 **请求配置**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /page/Cdkey/UserStatus`
 * @更新时间 `2018-06-29 14:53:57`
 */
const pageCdkeyUserStatusRequestConfig: PageCdkeyUserStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_39,
    devUrl: devUrl_0_1_0_39,
    prodUrl: prodUrl_0_1_0_39,
    path: "/page/Cdkey/UserStatus",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageCdkeyUserStatus",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/28/interface/api/6320) 的 **请求函数**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /page/Cdkey/UserStatus`
 * @更新时间 `2018-06-29 14:53:57`
 */
export const pageCdkeyUserStatus = /*#__PURE__*/ (
  requestData?: PageCdkeyUserStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PageCdkeyUserStatusResponse>(
    prepare(pageCdkeyUserStatusRequestConfig, requestData),
    ...args
  );
};

pageCdkeyUserStatus.requestConfig = pageCdkeyUserStatusRequestConfig;

const mockUrl_0_1_0_40 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_40 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_40 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_40 = "data" as any;

/**
 * 接口 [Library Ajax↗](https://yapi.yuewen.com/project/28/interface/api/86) 的 **请求类型**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /ajax/Library/LibraryAjax`
 * @更新时间 `2019-07-22 19:34:50`
 */
export interface AjaxLibraryLibraryAjaxRequest {
  /**
   * //1,  加入书架时间,2 // 阅读时间
   */
  orderBy: string;
  pageIndex: string;
  pageSize: string;
}

/**
 * 接口 [Library Ajax↗](https://yapi.yuewen.com/project/28/interface/api/86) 的 **返回类型**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /ajax/Library/LibraryAjax`
 * @更新时间 `2019-07-22 19:34:50`
 */
export interface AjaxLibraryLibraryAjaxResponse {
  /**
   * 2
   */
  orderBy?: number;
  /**
   * 1
   */
  isLast?: number;
  /**
   * [{"bookId":"11022733006234505","novelType":200,"bookName":"Lord of the Mysteries","newChapterIndex":110,"newChapterId":"32997916528409926","readToChapterId":"32997894533478808","firstChapterId":"31208015751346911","updateStatus":1,"coverUpdateTime":"1547647209230"},{"bookId":"8212987205006305","novelType":100,"bookName":"Trial Marriage Husband: Need to Work Hard","newChapterIndex":976,"newChapterId":"34824496611389673","readToChapterId":"22121510210685128","firstChapterId":"22047897407242688","updateStatus":1,"coverUpdateTime":"1547686809014"},{"bookId":"7141995206000505","novelType":0,"bookName":"Doomsday Wonderland","newChapterIndex":429,"newChapterId":"34366796710605081","readToChapterId":"34118901918909255","firstChapterId":"19409012340607764","updateStatus":1,"coverUpdateTime":"1547662764796"},{"bookId":"8534263705001005","novelType":0,"bookName":"It's Not Easy to Be a Man After Travelling to the Future","newChapterIndex":480,"newChapterId":"34545379554950153","readToChapterId":"22926691756207866","firstChapterId":"22913291995110868","updateStatus":1,"coverUpdateTime":"1548384764944"},{"bookId":"6838665602002005","novelType":0,"bookName":"Throne of Magical Arcana","newChapterIndex":403,"newChapterId":"34427102329619744","readToChapterId":"27628830525018985","firstChapterId":"6856654501000300","updateStatus":1,"coverUpdateTime":"1548740905890"}]
   */
  items?: {
    /**
     * "11022733006234505"
     */
    bookId?: string;
    /**
     * 200
     */
    novelType?: number;
    /**
     * "Lord of the Mysteries"
     */
    bookName?: string;
    /**
     * 110
     */
    newChapterIndex?: number;
    /**
     * "32997916528409926"
     */
    newChapterId?: string;
    /**
     * "32997894533478808"
     */
    readToChapterId?: string;
    /**
     * "31208015751346911"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    updateStatus?: number;
    /**
     * "1547647209230"
     */
    coverUpdateTime?: string;
  }[];
}

/**
 * 接口 [Library Ajax↗](https://yapi.yuewen.com/project/28/interface/api/86) 的 **请求配置的类型**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /ajax/Library/LibraryAjax`
 * @更新时间 `2019-07-22 19:34:50`
 */
type AjaxLibraryLibraryAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/Library/LibraryAjax",
    "data",
    string,
    "orderBy" | "pageIndex" | "pageSize",
    false
  >
>;

/**
 * 接口 [Library Ajax↗](https://yapi.yuewen.com/project/28/interface/api/86) 的 **请求配置**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /ajax/Library/LibraryAjax`
 * @更新时间 `2019-07-22 19:34:50`
 */
const ajaxLibraryLibraryAjaxRequestConfig: AjaxLibraryLibraryAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_40,
    devUrl: devUrl_0_1_0_40,
    prodUrl: prodUrl_0_1_0_40,
    path: "/ajax/Library/LibraryAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_40,
    paramNames: [],
    queryNames: ["orderBy", "pageIndex", "pageSize"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLibraryLibraryAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [Library Ajax↗](https://yapi.yuewen.com/project/28/interface/api/86) 的 **请求函数**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /ajax/Library/LibraryAjax`
 * @更新时间 `2019-07-22 19:34:50`
 */
export const ajaxLibraryLibraryAjax = /*#__PURE__*/ (
  requestData: AjaxLibraryLibraryAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxLibraryLibraryAjaxResponse>(
    prepare(ajaxLibraryLibraryAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxLibraryLibraryAjax.requestConfig = ajaxLibraryLibraryAjaxRequestConfig;

/**
 * 接口 [从书架移除书籍↗](https://yapi.yuewen.com/project/28/interface/api/156) 的 **请求类型**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/DeleteLibraryItemsAjax`
 * @更新时间 `2018-09-03 21:22:15`
 */
export interface AjaxLibraryDeleteLibraryItemsAjaxRequest {
  bookItems?: string;
}

/**
 * 接口 [从书架移除书籍↗](https://yapi.yuewen.com/project/28/interface/api/156) 的 **返回类型**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/DeleteLibraryItemsAjax`
 * @更新时间 `2018-09-03 21:22:15`
 */
export interface AjaxLibraryDeleteLibraryItemsAjaxResponse {}

/**
 * 接口 [从书架移除书籍↗](https://yapi.yuewen.com/project/28/interface/api/156) 的 **请求配置的类型**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/DeleteLibraryItemsAjax`
 * @更新时间 `2018-09-03 21:22:15`
 */
type AjaxLibraryDeleteLibraryItemsAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/Library/DeleteLibraryItemsAjax",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [从书架移除书籍↗](https://yapi.yuewen.com/project/28/interface/api/156) 的 **请求配置**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/DeleteLibraryItemsAjax`
 * @更新时间 `2018-09-03 21:22:15`
 */
const ajaxLibraryDeleteLibraryItemsAjaxRequestConfig: AjaxLibraryDeleteLibraryItemsAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_40,
    devUrl: devUrl_0_1_0_40,
    prodUrl: prodUrl_0_1_0_40,
    path: "/ajax/Library/DeleteLibraryItemsAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_40,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLibraryDeleteLibraryItemsAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [从书架移除书籍↗](https://yapi.yuewen.com/project/28/interface/api/156) 的 **请求函数**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/DeleteLibraryItemsAjax`
 * @更新时间 `2018-09-03 21:22:15`
 */
export const ajaxLibraryDeleteLibraryItemsAjax = /*#__PURE__*/ (
  requestData: AjaxLibraryDeleteLibraryItemsAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxLibraryDeleteLibraryItemsAjaxResponse>(
    prepare(ajaxLibraryDeleteLibraryItemsAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxLibraryDeleteLibraryItemsAjax.requestConfig =
  ajaxLibraryDeleteLibraryItemsAjaxRequestConfig;

/**
 * 接口 [书架直出↗](https://yapi.yuewen.com/project/28/interface/api/8197) 的 **请求类型**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /page/Library/LibraryPage`
 * @更新时间 `2018-08-31 16:08:49`
 */
export interface PageLibraryLibraryPageRequest {}

/**
 * 接口 [书架直出↗](https://yapi.yuewen.com/project/28/interface/api/8197) 的 **返回类型**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /page/Library/LibraryPage`
 * @更新时间 `2018-08-31 16:08:49`
 */
export interface PageLibraryLibraryPageResponse {
  /**
   * 2
   */
  orderBy?: number;
  /**
   * [{"bookId":"@id","novelType":" 0 书 100 漫画","bookName":"@name","updateStatus":1,"firstChapterId":"@id","readToChapterId":"@id","readToChapterIndex":1,"newChapterIndex":1,"newChapterId":1}]
   */
  items?: {
    /**
     * "@id"
     */
    bookId?: string;
    /**
     * " 0 书 100 漫画"
     */
    novelType?: string;
    /**
     * "@name"
     */
    bookName?: string;
    /**
     * 1
     */
    updateStatus?: number;
    /**
     * "@id"
     */
    firstChapterId?: string;
    /**
     * "@id"
     */
    readToChapterId?: string;
    /**
     * 1
     */
    readToChapterIndex?: number;
    /**
     * 1
     */
    newChapterIndex?: number;
    /**
     * 1
     */
    newChapterId?: number;
  }[];
  /**
   * 1
   */
  isLast?: number;
  /**
   * 1
   */
  total?: number;
  user?: {
    guid?: string;
    avatar?: string;
    userName?: string;
    nickName?: string;
    penName?: null;
    role?: null;
    /**
     * -2
     */
    status?: number;
    SS?: null;
    isCheckin?: null;
    userLevel?: null;
    availablePower?: null;
    totalPower?: null;
    availableEnergy?: null;
    totalEnergy?: null;
    emailStatus?: null;
    mt?: null;
  };
}

/**
 * 接口 [书架直出↗](https://yapi.yuewen.com/project/28/interface/api/8197) 的 **请求配置的类型**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /page/Library/LibraryPage`
 * @更新时间 `2018-08-31 16:08:49`
 */
type PageLibraryLibraryPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/page/Library/LibraryPage",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [书架直出↗](https://yapi.yuewen.com/project/28/interface/api/8197) 的 **请求配置**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /page/Library/LibraryPage`
 * @更新时间 `2018-08-31 16:08:49`
 */
const pageLibraryLibraryPageRequestConfig: PageLibraryLibraryPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_40,
    devUrl: devUrl_0_1_0_40,
    prodUrl: prodUrl_0_1_0_40,
    path: "/page/Library/LibraryPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_40,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageLibraryLibraryPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书架直出↗](https://yapi.yuewen.com/project/28/interface/api/8197) 的 **请求函数**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /page/Library/LibraryPage`
 * @更新时间 `2018-08-31 16:08:49`
 */
export const pageLibraryLibraryPage = /*#__PURE__*/ (
  requestData?: PageLibraryLibraryPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<PageLibraryLibraryPageResponse>(
    prepare(pageLibraryLibraryPageRequestConfig, requestData),
    ...args
  );
};

pageLibraryLibraryPage.requestConfig = pageLibraryLibraryPageRequestConfig;

/**
 * 接口 [排序设置↗](https://yapi.yuewen.com/project/28/interface/api/8206) 的 **请求类型**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/SetUserPreferenceAjax`
 * @更新时间 `2018-06-19 14:32:22`
 */
export interface AjaxLibrarySetUserPreferenceAjaxRequest {
  orderBy: string;
}

/**
 * 接口 [排序设置↗](https://yapi.yuewen.com/project/28/interface/api/8206) 的 **返回类型**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/SetUserPreferenceAjax`
 * @更新时间 `2018-06-19 14:32:22`
 */
export interface AjaxLibrarySetUserPreferenceAjaxResponse {
  code?: number;
  /**
   * "Success"
   */
  msg?: string;
}

/**
 * 接口 [排序设置↗](https://yapi.yuewen.com/project/28/interface/api/8206) 的 **请求配置的类型**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/SetUserPreferenceAjax`
 * @更新时间 `2018-06-19 14:32:22`
 */
type AjaxLibrarySetUserPreferenceAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/Library/SetUserPreferenceAjax",
    "data",
    string,
    "orderBy",
    false
  >
>;

/**
 * 接口 [排序设置↗](https://yapi.yuewen.com/project/28/interface/api/8206) 的 **请求配置**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/SetUserPreferenceAjax`
 * @更新时间 `2018-06-19 14:32:22`
 */
const ajaxLibrarySetUserPreferenceAjaxRequestConfig: AjaxLibrarySetUserPreferenceAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_40,
    devUrl: devUrl_0_1_0_40,
    prodUrl: prodUrl_0_1_0_40,
    path: "/ajax/Library/SetUserPreferenceAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_40,
    paramNames: [],
    queryNames: ["orderBy"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLibrarySetUserPreferenceAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [排序设置↗](https://yapi.yuewen.com/project/28/interface/api/8206) 的 **请求函数**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/SetUserPreferenceAjax`
 * @更新时间 `2018-06-19 14:32:22`
 */
export const ajaxLibrarySetUserPreferenceAjax = /*#__PURE__*/ (
  requestData: AjaxLibrarySetUserPreferenceAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxLibrarySetUserPreferenceAjaxResponse>(
    prepare(ajaxLibrarySetUserPreferenceAjaxRequestConfig, requestData),
    ...args
  );
};

ajaxLibrarySetUserPreferenceAjax.requestConfig =
  ajaxLibrarySetUserPreferenceAjaxRequestConfig;

const mockUrl_0_1_0_41 = "https://yapi.yuewen.com/mock/28" as any;
const devUrl_0_1_0_41 = "https://oam.webnovel.com" as any;
const prodUrl_0_1_0_41 = "https://m.webnovel.com" as any;
const dataKey_0_1_0_41 = "data" as any;

/**
 * 接口 [\/ajax\/publishBook\/getBookDetailPage↗](https://yapi.yuewen.com/project/28/interface/api/57449) 的 **请求类型**
 *
 * @分类 [出版书↗](https://yapi.yuewen.com/project/28/interface/api/cat_9718)
 * @请求头 `GET /ajax/publishBook/getBookDetailPage`
 * @更新时间 `2020-09-08 15:42:53`
 */
export interface AjaxPublishBookGetBookDetailPageRequest {
  bookId: string;
}

/**
 * 接口 [\/ajax\/publishBook\/getBookDetailPage↗](https://yapi.yuewen.com/project/28/interface/api/57449) 的 **返回类型**
 *
 * @分类 [出版书↗](https://yapi.yuewen.com/project/28/interface/api/cat_9718)
 * @请求头 `GET /ajax/publishBook/getBookDetailPage`
 * @更新时间 `2020-09-08 15:42:53`
 */
export interface AjaxPublishBookGetBookDetailPageResponse {
  bookInfo?: {
    /**
     * "123"
     */
    bookId?: string;
    /**
     * "书名"
     */
    bookName?: string;
    /**
     * 1
     */
    totalScore?: number;
    /**
     * 12
     */
    voters?: number;
    /**
     * "作者名"
     */
    authorName?: string;
    /**
     * "出版社"
     */
    publisher?: string;
    /**
     * "总字数"
     */
    words?: string;
    /**
     * 1
     */
    language?: number;
    /**
     * "en"
     */
    languageName?: string;
    /**
     * "1563793971744"
     */
    publishTime?: string;
    /**
     * "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介"
     */
    description?: string;
    categoryId?: string;
    /**
     * "xxxxx"
     */
    categoryName?: string;
    status?: number;
    /**
     * 15
     */
    checkLevel?: number;
    inLibrary?: number;
    isUnlocked?: number;
  };
}

/**
 * 接口 [\/ajax\/publishBook\/getBookDetailPage↗](https://yapi.yuewen.com/project/28/interface/api/57449) 的 **请求配置的类型**
 *
 * @分类 [出版书↗](https://yapi.yuewen.com/project/28/interface/api/cat_9718)
 * @请求头 `GET /ajax/publishBook/getBookDetailPage`
 * @更新时间 `2020-09-08 15:42:53`
 */
type AjaxPublishBookGetBookDetailPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/28",
    "https://oam.webnovel.com",
    "https://m.webnovel.com",
    "/ajax/publishBook/getBookDetailPage",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [\/ajax\/publishBook\/getBookDetailPage↗](https://yapi.yuewen.com/project/28/interface/api/57449) 的 **请求配置**
 *
 * @分类 [出版书↗](https://yapi.yuewen.com/project/28/interface/api/cat_9718)
 * @请求头 `GET /ajax/publishBook/getBookDetailPage`
 * @更新时间 `2020-09-08 15:42:53`
 */
const ajaxPublishBookGetBookDetailPageRequestConfig: AjaxPublishBookGetBookDetailPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_41,
    devUrl: devUrl_0_1_0_41,
    prodUrl: prodUrl_0_1_0_41,
    path: "/ajax/publishBook/getBookDetailPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_41,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxPublishBookGetBookDetailPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/ajax\/publishBook\/getBookDetailPage↗](https://yapi.yuewen.com/project/28/interface/api/57449) 的 **请求函数**
 *
 * @分类 [出版书↗](https://yapi.yuewen.com/project/28/interface/api/cat_9718)
 * @请求头 `GET /ajax/publishBook/getBookDetailPage`
 * @更新时间 `2020-09-08 15:42:53`
 */
export const ajaxPublishBookGetBookDetailPage = /*#__PURE__*/ (
  requestData: AjaxPublishBookGetBookDetailPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<AjaxPublishBookGetBookDetailPageResponse>(
    prepare(ajaxPublishBookGetBookDetailPageRequestConfig, requestData),
    ...args
  );
};

ajaxPublishBookGetBookDetailPage.requestConfig =
  ajaxPublishBookGetBookDetailPageRequestConfig;

const mockUrl_0_0_0_0 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_0 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_0 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_0 = "data" as any;

/**
 * 接口 [FP 列表↗](https://yapi.yuewen.com/project/2309/interface/api/175451) 的 **请求类型**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-my-list`
 * @更新时间 `2020-12-02 19:34:48`
 */
export interface GoPcmFastpassGetMyListRequest {}

/**
 * 接口 [FP 列表↗](https://yapi.yuewen.com/project/2309/interface/api/175451) 的 **返回类型**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-my-list`
 * @更新时间 `2020-12-02 19:34:48`
 */
export interface GoPcmFastpassGetMyListResponse {
  commonList?: {
    /**
     * 5
     */
    amount?: number;
    /**
     * "FP × 5"
     */
    title?: string;
    /**
     * "Every FP expires after 7 days. Remember to use them fast!"
     */
    content?: string;
    /**
     * "Usable for all novels and comics"
     */
    desc?: string;
    fastPassType?: number;
  };
  /**
   * [{"title":"Comics FP × 1","content":"Expires on 2020-12-04 13:39","desc":"For unlocking comic chapters","fastPassType":3,"userFastPassId":"6899674008589304217","fastPassId":"2020110502"}]
   */
  specificList?: {
    /**
     * "Comics FP × 1"
     */
    title?: string;
    /**
     * "Expires on 2020-12-04 13:39"
     */
    content?: string;
    /**
     * "For unlocking comic chapters"
     */
    desc?: string;
    /**
     * 3
     */
    fastPassType?: number;
    /**
     * "6899674008589304217"
     */
    userFastPassId?: string;
    /**
     * "2020110502"
     */
    fastPassId?: string;
  }[];
}

/**
 * 接口 [FP 列表↗](https://yapi.yuewen.com/project/2309/interface/api/175451) 的 **请求配置的类型**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-my-list`
 * @更新时间 `2020-12-02 19:34:48`
 */
type GoPcmFastpassGetMyListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/fastpass/get-my-list",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [FP 列表↗](https://yapi.yuewen.com/project/2309/interface/api/175451) 的 **请求配置**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-my-list`
 * @更新时间 `2020-12-02 19:34:48`
 */
const goPcmFastpassGetMyListRequestConfig: GoPcmFastpassGetMyListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/go/pcm/fastpass/get-my-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmFastpassGetMyList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [FP 列表↗](https://yapi.yuewen.com/project/2309/interface/api/175451) 的 **请求函数**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-my-list`
 * @更新时间 `2020-12-02 19:34:48`
 */
export const goPcmFastpassGetMyList = /*#__PURE__*/ (
  requestData?: GoPcmFastpassGetMyListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmFastpassGetMyListResponse>(
    prepare(goPcmFastpassGetMyListRequestConfig, requestData),
    ...args
  );
};

goPcmFastpassGetMyList.requestConfig = goPcmFastpassGetMyListRequestConfig;

/**
 * 接口 [流水↗](https://yapi.yuewen.com/project/2309/interface/api/244290) 的 **请求类型**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-log-list`
 * @更新时间 `2022-08-18 11:26:25`
 */
export interface GoPcmFastpassGetLogListRequest {
  pageIndex: string;
  type: string;
}

/**
 * 接口 [流水↗](https://yapi.yuewen.com/project/2309/interface/api/244290) 的 **返回类型**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-log-list`
 * @更新时间 `2022-08-18 11:26:25`
 */
export interface GoPcmFastpassGetLogListResponse {
  /**
   * 1
   */
  fastPassNum?: number;
  /**
   * [{"fastPassNum":1,"fastPassDesc":"@string","description":"@word","time":1573434613530,"expireTime":1573434613530,"bookId":11,"chapterId":111,"itemType":0}]
   */
  logItems?: {
    /**
     * 1
     */
    fastPassNum?: number;
    /**
     * "@string"
     */
    fastPassDesc?: string;
    /**
     * "@word"
     */
    description?: string;
    /**
     * 1573434613530
     */
    time?: number;
    /**
     * 1573434613530
     */
    expireTime?: number;
    /**
     * 11
     */
    bookId?: number;
    /**
     * 111
     */
    chapterId?: number;
    itemType?: number;
  }[];
  /**
   * true
   */
  isLast?: boolean;
  /**
   * 1
   */
  total?: number;
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300000745/1/1.jpg?mt=1599203750603"
     */
    avatar?: string;
    /**
     * "zhang_j4543"
     */
    nickName?: string;
    /**
     * "zhang_j4543"
     */
    userName?: string;
    /**
     * "zhang_j4543"
     */
    authorName?: string;
    /**
     * 4300000745
     */
    guid?: number;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * 2
     */
    gender?: number;
    /**
     * 4995
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 5
     */
    grade?: number;
    /**
     * 3
     */
    ES?: number;
    /**
     * 3
     */
    totalES?: number;
    /**
     * 3
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * "2120584224@qq.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: number;
    /**
     * 1599203750603
     */
    UUT?: number;
    /**
     * 3
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 2
     */
    membershipStatus?: number;
    /**
     * 1598678797000
     */
    membershipExpireTime?: number;
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [流水↗](https://yapi.yuewen.com/project/2309/interface/api/244290) 的 **请求配置的类型**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-log-list`
 * @更新时间 `2022-08-18 11:26:25`
 */
type GoPcmFastpassGetLogListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/fastpass/get-log-list",
    "data",
    string,
    "pageIndex" | "type",
    false
  >
>;

/**
 * 接口 [流水↗](https://yapi.yuewen.com/project/2309/interface/api/244290) 的 **请求配置**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-log-list`
 * @更新时间 `2022-08-18 11:26:25`
 */
const goPcmFastpassGetLogListRequestConfig: GoPcmFastpassGetLogListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/go/pcm/fastpass/get-log-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: ["pageIndex", "type"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmFastpassGetLogList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [流水↗](https://yapi.yuewen.com/project/2309/interface/api/244290) 的 **请求函数**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-log-list`
 * @更新时间 `2022-08-18 11:26:25`
 */
export const goPcmFastpassGetLogList = /*#__PURE__*/ (
  requestData: GoPcmFastpassGetLogListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmFastpassGetLogListResponse>(
    prepare(goPcmFastpassGetLogListRequestConfig, requestData),
    ...args
  );
};

goPcmFastpassGetLogList.requestConfig = goPcmFastpassGetLogListRequestConfig;

const mockUrl_0_0_0_1 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_1 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_1 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_1 = "data" as any;

/**
 * 接口 [获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/175491) 的 **请求类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2023-02-28 15:32:53`
 */
export interface GoPcmChapterGetContent2Request {
  /**
   * 章节 ID
   */
  chapterId: string;
  /**
   * 书籍 ID
   */
  bookId: string;
  /**
   * 0  正常无加密状态
   * 1 只fockjs
   * 2 只字体加密
   * 3 fockjs + 字体加密状态
   */
  encryptType?: string;
  font?: string;
}

/**
 * 接口 [获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/175491) 的 **返回类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2023-02-28 15:32:53`
 */
export interface GoPcmChapterGetContent2Response {
  bookInfo?: {
    /**
     * "16709365405930105"
     */
    bookId?: string;
    /**
     * "My Vampire System"
     */
    bookName?: string;
    /**
     * "JKSManga"
     */
    authorName?: string;
    /**
     * "11412023406695501"
     */
    authorId?: string;
    /**
     * 1920
     */
    totalChapterNum?: number;
    /**
     * 30
     */
    actionStatus?: number;
    /**
     * 2
     */
    type?: number;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "en"
     */
    languageName?: string;
    /**
     * 2
     */
    bookType?: number;
    /**
     * 6088
     */
    reviewTotal?: number;
    /**
     * 15
     */
    checkLevel?: number;
    totalPreChapterNum?: number;
    /**
     * -1
     */
    translateMode?: number;
    /**
     * []
     */
    groupItems?: unknown[];
    /**
     * []
     */
    editorItems?: unknown[];
    /**
     * []
     */
    translatorItems?: unknown[];
    /**
     * [{"id":"11412023406695501","userId":4301351686,"guid":4301351686,"name":"JKSManga","UUT":"@timestamp"}]
     */
    authorItems?: {
      /**
       * "11412023406695501"
       */
      id?: string;
      /**
       * 4301351686
       */
      userId?: number;
      /**
       * 4301351686
       */
      guid?: number;
      /**
       * "JKSManga"
       */
      name?: string;
      /**
       * "@timestamp"
       */
      UUT?: string;
    }[];
    patreonLink?: string;
    /**
     * 1596687896010
     */
    coverUpdateTime?: number;
    /**
     * 30
     */
    giftNum?: number;
    /**
     * ["/274367222/msite-read-video","/274367222/msite-read-video4","/274367222/web-read-video2"]
     */
    videoAdIds?: string[];
    /**
     * ["/274367222/msite-book-rect","/274367222/AMPtest"]
     */
    adIds?: string[];
    availableFpNum?: number;
    /**
     * 1587138908000
     */
    publishTime?: number;
    /**
     * 1664300040000
     */
    updateTime?: number;
    /**
     * 1
     */
    isShowAds?: number;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * 70002
     */
    categoryId?: number;
    /**
     * "@string"
     */
    categoryName?: string;
    /**
     * "@string"
     */
    description?: string;
    /**
     * [{"tagId":41000016,"tagName":"SYSTEM","likeNums":6379,"isLiked":0}]
     */
    tagInfos?: {
      /**
       * 41000016
       */
      tagId?: number;
      /**
       * "SYSTEM"
       */
      tagName?: string;
      /**
       * 6379
       */
      likeNums?: number;
      isLiked?: number;
    }[];
  };
  chapterInfo?: {
    /**
     * "44876210957766841"
     */
    chapterId?: string;
    /**
     * "Daily Quest"
     */
    chapterName?: string;
    /**
     * 2
     */
    chapterIndex?: number;
    /**
     * "44853895649874397"
     */
    preChapterId?: string;
    /**
     * "Just an old Book"
     */
    preChapterName?: string;
    /**
     * "44899664968860669"
     */
    nextChapterId?: string;
    /**
     * "Military School"
     */
    nextChapterName?: string;
    vipStatus?: number;
    price?: number;
    originalPrice?: number;
    discountInfo?: string;
    chapterLevel?: number;
    userLevel?: number;
    /**
     * [{"contentId":"","content":"Gradually, Quinn's eyelids started to flutter open and his vision soon returned. His head felt heavy and his body was slightly sore. As he lifted himself off of the ground, he touched his head gently to see if he had injured himself.\r\n","appId":0,"userId":0,"paragraphId":"55bfda840d221c21c38df25905d08511","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"'Why does my head hurt so much?' He thought, bewildered and unable to make any sense of what just happened to him.\r\n","appId":0,"userId":0,"paragraphId":"4779bf91f39775ddb459605c7ced2541","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"After patting his head all over, Quinn then went to pick up his glasses that had fallen on the floor not too far from him. Regrettably, only one lens that was left intact, still, Quinn put the glasses on out of habit. He felt a little disoriented and his vision became slightly blurry.\r\n","appId":0,"userId":0,"paragraphId":"5182b6b91e59e59362849f019d656293","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"He took them back off and noticed that his vision only turned hazy when he put the glasses on. 'Wow,', he thought before he quickly rushed to his desk to grab a pencil. He proceeded to draw the letter \"A\" on the wall and stepped back. He continued to move back until his back had hit the wall that was on the other side of the room. The figure 'A' was still there, and he could see it clearly.\r\n","appId":0,"userId":0,"paragraphId":"3190bda3b83ca528e517c31e85c4e6d2","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"What?! But how?!\" Quinn said slowly, mind-blown. He was still trying to make sense of what had happened to him.\r\n","appId":0,"userId":0,"paragraphId":"d4f758ba21fbfd52923ea407e6ff0e98","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"Somehow, Quinn's vision was now perfect. He had lived his whole life with terrible eyesight, but strangely, he could now see clearly. His mind started flashing images of the events that laid to his passing out on the ground. The more the memories flooded his mind, the more one thing stood out - the book.\r\n","appId":0,"userId":0,"paragraphId":"afdafe3efaf45991607927f68d3b5e40","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"When Quinn surveyed the room, he felt panic building up in him. The book was missing…\r\n","appId":0,"userId":0,"paragraphId":"1ad14444e13ce4d382886c2c9170ce54","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"The book! Where the hell's the book?\"\r\n","appId":0,"userId":0,"paragraphId":"a7c7183ad472b144cace5e0e64b1149c","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"He looked everywhere for the book, yet he couldn't find it. It couldn't have gone missing in such a small room, so its disappearance was baffling.\r\n","appId":0,"userId":0,"paragraphId":"8835e7e63b0d287b35cfd991dcaad881","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"Where's the damn book?\" he lamented. He imagined the book at one corner of the room hidden and out of sight, somehow living and silently enjoying his misery.\r\n","appId":0,"userId":0,"paragraphId":"e5ea0e630327325b23d04b93c671f637","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"Maybe it's like my socks. They go missing all the time. Ahh, don't be stupid. This is a book we're talking about, not a sock.\" He muttered, trying to reason the uncanny comparison.\r\n","appId":0,"userId":0,"paragraphId":"418c7eb85e9ade56015bc4e9201af558","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"Quinn tried to think hard about what had occurred a few moments before he collapsed. He took his mind back, moment by moment, then he suddenly remembered the book hovering in the air. Then, just before closing his eyes, he heard a few words.\r\n","appId":0,"userId":0,"paragraphId":"c6ca1756c462b8439003c41fa0ea32ef","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"What was it?\" he thought. \"A type of system message?\"\r\n","appId":0,"userId":0,"paragraphId":"4ef4e10ef2512a95506ed27802bdce40","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"As soon as Quinn said those words, a status screen appeared right before his eyes.\r\n","appId":0,"userId":0,"paragraphId":"dea053393a1bc12dd911ee91754012fa","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[User: Quinn Talen]\r\n","appId":0,"userId":0,"paragraphId":"61d00960b5d24e1386d451ae3fc9e1ba","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Race: Human]\r\n","appId":0,"userId":0,"paragraphId":"d9017897b55ae6cd3096d71ec9e2bd41","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Level 1]\r\n","appId":0,"userId":0,"paragraphId":"4132d97d08e12b3d4c4baa277a1ec122","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[0/100 exp]\r\n","appId":0,"userId":0,"paragraphId":"f254b4bc6f18c3ba7b085d2c0e5ab60f","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[HP 10/10]\r\n","appId":0,"userId":0,"paragraphId":"ccf140a4ee96db8e2975214e44c08639","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Strength: 10]\r\n","appId":0,"userId":0,"paragraphId":"416c5019f3aceb933d4354ec170f577f","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Agility: 10]\r\n","appId":0,"userId":0,"paragraphId":"750fe61a21ea73584b5596135c5e801e","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Stamina: 10]\r\n","appId":0,"userId":0,"paragraphId":"689a86db4443ab1a3431dddf31880901","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"Whoa,\" Quinn said.\r\n","appId":0,"userId":0,"paragraphId":"55de3d2e80fad11fe5f95d1f4c099fe4","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"It was like the old games people used to play all the time when the earth was not in danger of being overrun by some alien creatures. Quinn noticed that, on the status screen, there were more tabs that were placed on the top. Accordingly, even without doing anything and just by reading the tabs in his head, the screen automatically switched to the [Skills] tab.\r\n","appId":0,"userId":0,"paragraphId":"f9b196e3efaa0746dad4ef579c03a9e9","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Skills]\r\n","appId":0,"userId":0,"paragraphId":"cc053e644fb8b5b57392632f0d4ed632","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[0 skill points available]\r\n","appId":0,"userId":0,"paragraphId":"72eae44ec97da0cbda608b38317c5b79","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Skill locked????]\r\n","appId":0,"userId":0,"paragraphId":"af679da49763452ae764b1711f3b3f37","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Skill locked????]\r\n","appId":0,"userId":0,"paragraphId":"d39cc9168843cecec16d3e0f2c1f1052","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"….\r\n","appId":0,"userId":0,"paragraphId":"66ffd975a7a9c81f05321802999b9613","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"It was strange, but he played along, curiosity fuelling him. His life was normally characterised by boredom as he had no friends, and was the loneliest child in the school. On the skills tab, Quinn wasn't really able to see much. Everything seemed to be locked and slightly greyed out, so he quickly moved on to the next tab,\r\n","appId":0,"userId":0,"paragraphId":"1059d6a2e91d59ee89b38ed718f47adf","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Shop]\r\n","appId":0,"userId":0,"paragraphId":"e184e0ed9d29c6c2e5240a2f3a00e4e9","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Unlocks at level 10]\r\n","appId":0,"userId":0,"paragraphId":"7212e7c0717cded7ca0de1960f6b9db4","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"Can I do anything?\" he wondered.\r\n","appId":0,"userId":0,"paragraphId":"925624d126b55e4415a77fcad7f5f7ed","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"The last tab was the [Quest] tab. Finally, it seemed like a tab that wasn't locked behind a requirement.\r\n","appId":0,"userId":0,"paragraphId":"cf2cc65e44cb362c9eb8fee4f878a111","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Main Quest]\r\n","appId":0,"userId":0,"paragraphId":"0705448d6d437ffb2dbed51bb8f44082","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Reach level 10]\r\n","appId":0,"userId":0,"paragraphId":"2d0d05c1f14a0488c15db2ce8b26a7c0","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Daily Quest: Drink two litres of water]\r\n","appId":0,"userId":0,"paragraphId":"02eb6eee1134a55989a26969ce2368a5","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Reward: 5 exp]\r\n","appId":0,"userId":0,"paragraphId":"6b1af024ec79eb072da1843ceae8afd4","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"After checking everything that the system had to offer, Quinn had to just think about closing the system and it did. When he thought about opening it again, the screen immediately popped up in front of him.\r\n","appId":0,"userId":0,"paragraphId":"5c880a580e9e56e41b0c09861a50ae6f","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"There was another thought on Quinn's mind that explained what was happening to him- the book that his parents had left him was an ability book. These books could often be bought at very high prices from the military or a company. Some were even sold on the market place. He had never seen any of such books, but only heard of them in whispers of fellow students that would have nothing to do with him.\r\n","appId":0,"userId":0,"paragraphId":"10d2ad8e486a08c9e386f50653eb0994","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"However, Quinn had never heard of an ability book that promptly disappeared, granting the user a system such as the one he currently had. The ability books were designed to be learnt manually. It wasn't something that one could pick up and instantly understand how to use, and it definitely did not appear as a screen overhead when one thought of it.\r\n","appId":0,"userId":0,"paragraphId":"a35ff8da3ac392fa3197b03b214fb556","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"A smile started to slowly appear on Quinn's face. This was great news for him. He had always been a level 1 ability user because he could never afford to buy any ability books. To his fortune, he had something that he could use. His mind raced, reeling out options for him. He had things he could practice, things he had never done before. The book would help him, he thought.\r\n","appId":0,"userId":0,"paragraphId":"b031ae2a332b6e8521ab3c51e4ac1dea","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"Water bending, come on!\" Quinn said as he raised his right palm forward towards the kitchen sink, expecting water to gush from the tap at his command. Embarrassingly, nothing happened..\r\n","appId":0,"userId":0,"paragraphId":"afc8ee3b82502682e92224845661b5e3","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"Ok next! Wind, Wind, out!\" Quinn did the same again, but there was nothing happening.\r\n","appId":0,"userId":0,"paragraphId":"32abf34039ed426046ffee8d48b479f6","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"After trying out many different things according to all the abilities that he had seen before, it turned out that he was unable to perform any of them. He made his way to his bed and sat dejectedly on it.\r\n","appId":0,"userId":0,"paragraphId":"03211d37c2b118f55ab09359324d737b","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"What the hell is this useless thing? Is it really just a system ability?\"\r\n","appId":0,"userId":0,"paragraphId":"f81c89b1690c42877ce1e3a8d8acfe21","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"Quinn thought about it for a while. If it truly was like a game, then perhaps, by completing the quests, he would eventually get stronger and unlock more skills. He had heard the students in school gush over those memories, which were shared to them by their parents. Some of them still had these games, which were now antiques sitting in their homes. Maybe it was his mistake that he was treating it like an ordinary ability book when clearly, it was not. He was still unable to find it, and ability books did not disappear into thin air.\r\n","appId":0,"userId":0,"paragraphId":"59b2010c54896bb77055470d6e022e2c","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"Usually, ability books were based around one ability. It was important for a person to select their first ability book carefully, since a regular human body could only perform one ability attribute in their lifetime. If one got transformability as their first ability, they would only be able to acquire other skills that were related to this attribute. For instance, if someone obtained fire as their attribute, they could solely dedicate themselves into gathering skills that the attribute fire could utilise. But this book was different, he felt it. What ability book could completely heal his eye defect?\r\n","appId":0,"userId":0,"paragraphId":"5374765b0c34251bb0eca0eec66bb310","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"Quinn went to open his mini-fridge, grabbing the bottles of water that were inside. He soon began downing the water bottles one by one.\r\n","appId":0,"userId":0,"paragraphId":"5d1c835a0eedbdb102839bbc34d4ccc3","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"Damn, how much is two litres? My belly feels like it's going to burst.\"\r\n","appId":0,"userId":0,"paragraphId":"c16804643e70671a1579c3e35cc96c43","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"After finishing his fourth bottle of water, the screen popped up in front of him, and a new notification message appeared.\r\n","appId":0,"userId":0,"paragraphId":"569e0f5f9b1168851f0c1df343cabba7","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[Daily Quest complete, 5 exp has been granted]\r\n","appId":0,"userId":0,"paragraphId":"5e7b8822b2ea431d2fd2e70f4c7dc59a","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"[5/100]\r\n","appId":0,"userId":0,"paragraphId":"1ab9a454b445fb149d835b93f292140d","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"Well, at least I know how the system works now,\" Quinn said, satisfaction evident in his tone.\r\n","appId":0,"userId":0,"paragraphId":"7e8f5736811c756db369601623fb828e","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"A loud knock  from the door startled Quinn. He jerked and almost threw the empty bottle of water he was holding on the ground. The knock came again. There was only one group that knocked like that, the real soldiers. Quinn dashed towards the door and opened it. As he opened the passageway, standing in front of him was a large, muscular, bald-headed man wearing a black military uniform, signifying the earth attribute. There were several medals on his garment. His name was written on the area of the uniform right above his chest - 'Sergeant Griff'.\r\n","appId":0,"userId":0,"paragraphId":"24da1f68d79b0495ba9dcea27e5115b9","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"Boy, it is time for you to vacate your room immediately. The vehicle has been waiting outside for five minutes already.\"\r\n","appId":0,"userId":0,"paragraphId":"73e7a0a5834b154e91743eec972b8669","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"With everything that had happened, Quinn had forgotten about his move today.\r\n","appId":0,"userId":0,"paragraphId":"54e935f420a4a8b7b4363a8e47b939b9","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"\"It's time for you to head to military school,\" Griff announced.\r\n","appId":0,"userId":0,"paragraphId":"8c04aa357666edd9af3a70b32b410f52","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0}]
     */
    contents?: {
      contentId?: string;
      /**
       * "Gradually, Quinn's eyelids started to flutter open and his vision soon returned. His head felt heavy and his body was slightly sore. As he lifted himself off of the ground, he touched his head gently to see if he had injured himself.\r\n"
       */
      content?: string;
      appId?: number;
      userId?: number;
      /**
       * "55bfda840d221c21c38df25905d08511"
       */
      paragraphId?: string;
      likeAmount?: number;
      contentAmount?: number;
      userName?: string;
      UUT?: number;
      isLiked?: number;
    }[];
    /**
     * 1
     */
    isAuth?: number;
    /**
     * 1
     */
    batchUnlockStatus?: number;
    isRichFormat?: number;
    /**
     * [{"id":"62cd4ea0de77721294ed737c","msgType":1,"title":"JKSManga New Book!","content":"Level up Zombie is out now for the 2022 WSA!","target":"","reward":"","startTime":1657623600942,"endTime":1672484400649}]
     */
    announcementItems?: {
      /**
       * "62cd4ea0de77721294ed737c"
       */
      id?: string;
      /**
       * 1
       */
      msgType?: number;
      /**
       * "JKSManga New Book!"
       */
      title?: string;
      /**
       * "Level up Zombie is out now for the 2022 WSA!"
       */
      content?: string;
      target?: string;
      reward?: string;
      /**
       * 1657623600942
       */
      startTime?: number;
      /**
       * 1672484400649
       */
      endTime?: number;
    }[];
    /**
     * []
     */
    groupItems?: unknown[];
    /**
     * []
     */
    editorItems?: unknown[];
    /**
     * []
     */
    translatorItems?: unknown[];
    /**
     * "44853895649874397"
     */
    firstChapterId?: string;
    /**
     * [{"reviewId":"16992780805264000","content":"This comment is legendary","userId":4309269458,"createTime":"2yr","reviewType":2,"pUserId":3650004563,"pContent":"Mc is kinda stupid. Please make him smater","likeNums":284,"isLiked":0,"status":1,"pStatus":-1,"commentType":1,"appId":10,"pAppId":10,"UUT":1577684704000,"userName":"Hwakin_Dong","avatar":1577554950447,"penName":"Hwakin_Dong","pUUT":1530898059000,"pUserName":"DarkImmortal_Intel","pUserImg":0,"pPenName":"DarkImmortal_Intel","role":0,"userLevel":3,"badgeInfo":{"badgeId":10046,"badgeType":"Growth","badgeName":"Reading Master","maxGrade":4,"baseUrl":"https://actimg.webnovel.com/badge/10046/3/","updateTime":1591007807000}},{"reviewId":"16953614806329600","content":"A MC can only be as smart as the author ","userId":4300559400,"createTime":"2yr","reviewType":2,"pUserId":4300266080,"pContent":"He’s surprisingly dumb for a glasses wearing mc","likeNums":203,"isLiked":0,"status":1,"pStatus":1,"commentType":1,"appId":10,"pAppId":10,"UUT":1557887672000,"userName":"Chubbikis","avatar":1557760672519,"penName":"Chubbikis","pUUT":1655344185000,"pUserName":"Arckane","pUserImg":1655344148282,"pPenName":"Arckane","role":0,"userLevel":4,"badgeInfo":{"badgeId":10001,"badgeType":"Achievement","badgeName":"Endeavor","maxGrade":4,"baseUrl":"https://actimg.webnovel.com/badge/10001/4/","updateTime":1517481162000}},{"reviewId":"17381969305104400","content":"Yep, this is our government. After you give up your life for it, you kids still owe it something.","userId":4301047447,"createTime":"2yr","reviewType":1,"pUserId":0,"pContent":"","likeNums":139,"isLiked":0,"status":1,"pStatus":0,"commentType":1,"appId":10,"pAppId":0,"UUT":1555706545000,"userName":"Dimikb","avatar":1555706436975,"penName":"Dimikb","pUUT":0,"pUserName":"","pUserImg":0,"pPenName":"","role":0,"userLevel":6,"badgeInfo":{"badgeId":10016,"badgeType":"Achievement","badgeName":"Big Bun Badge","maxGrade":1,"baseUrl":"https://actimg.webnovel.com/badge/10016/1/","updateTime":1624268417000}}]
     */
    chapterReviewItems?: {
      /**
       * "16992780805264000"
       */
      reviewId?: string;
      /**
       * "This comment is legendary"
       */
      content?: string;
      /**
       * 4309269458
       */
      userId?: number;
      /**
       * "2yr"
       */
      createTime?: string;
      /**
       * 2
       */
      reviewType?: number;
      /**
       * 3650004563
       */
      pUserId?: number;
      /**
       * "Mc is kinda stupid. Please make him smater"
       */
      pContent?: string;
      /**
       * 284
       */
      likeNums?: number;
      isLiked?: number;
      /**
       * 1
       */
      status?: number;
      /**
       * -1
       */
      pStatus?: number;
      /**
       * 1
       */
      commentType?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * 10
       */
      pAppId?: number;
      /**
       * 1577684704000
       */
      UUT?: number;
      /**
       * "Hwakin_Dong"
       */
      userName?: string;
      /**
       * 1577554950447
       */
      avatar?: number;
      /**
       * "Hwakin_Dong"
       */
      penName?: string;
      /**
       * 1530898059000
       */
      pUUT?: number;
      /**
       * "DarkImmortal_Intel"
       */
      pUserName?: string;
      pUserImg?: number;
      /**
       * "DarkImmortal_Intel"
       */
      pPenName?: string;
      role?: number;
      /**
       * 3
       */
      userLevel?: number;
      badgeInfo?: {
        /**
         * 10046
         */
        badgeId?: number;
        /**
         * "Growth"
         */
        badgeType?: string;
        /**
         * "Reading Master"
         */
        badgeName?: string;
        /**
         * 4
         */
        maxGrade?: number;
        /**
         * "https://actimg.webnovel.com/badge/10046/3/"
         */
        baseUrl?: string;
        /**
         * 1591007807000
         */
        updateTime?: number;
      };
    }[];
    /**
     * 1
     */
    firstChapterIndex?: number;
    /**
     * 768
     */
    reviewTotal?: number;
    notes?: {
      /**
       * "JKSManga"
       */
      name?: string;
      /**
       * "4301351686"
       */
      guid?: string;
      /**
       * "JKSManga"
       */
      penName?: string;
      /**
       * "//user-pic.webnovel.com/userheadimg/4301351686-10/1.jpg?uut=1602430937351"
       */
      avatar?: string;
      /**
       * 1602430937351
       */
      UUT?: number;
      /**
       * "author"
       */
      role?: string;
      /**
       * "IF you like the story and would like it to continue with more chapters please remember to Vote with your stones."
       */
      note?: string;
    };
    /**
     * 2
     */
    orderIndex?: number;
    noArchive?: number;
    transRating?: number;
    banner?: {
      coverUrl?: string;
      desc?: string;
    };
    adPosition?: {
      /**
       * true
       */
      readChapterEnd?: boolean;
    };
    /**
     * [0,1,2,3]
     */
    encryptType?: number[];
    /**
     * "@string"
     */
    encryptKeyPool?: string;
    /**
     * 1
     */
    encryptVersion?: number;
    nextChapterEncrypt?: {};
    /**
     * 1
     */
    fastPassNum?: number;
    isToApp?: boolean;
    /**
     * 123
     */
    updateTime?: number;
    /**
     * 123
     */
    publishTime?: number;
  };
  machineTrans?: {
    isWhiteUser?: number;
  };
  membershipStatus?: number;
  /**
   * [{"BookId":"6831119801008505","BookName":"Plundering the Heavens","BookType":0,"BookCoverId":1645183047372}]
   */
  relatedBook?: {
    /**
     * "6831119801008505"
     */
    BookId?: string;
    /**
     * "Plundering the Heavens"
     */
    BookName?: string;
    BookType?: number;
    /**
     * 1645183047372
     */
    BookCoverId?: number;
  }[];
  /**
   * [{"chapterId":"50455180671509174","chapterName":"[test_chapter] Sapien bibendum at!"},{"chapterId":"50455179866202699","chapterName":"[test_chapter] Facilisi porttitor accumsan?"},{"chapterId":"50455179329331749","chapterName":"[test_chapter] Sodales diam vulputate."},{"chapterId":"50455178792460798","chapterName":"[test_chapter] Pellentesque varius venenatis!"},{"chapterId":"50455178255589831","chapterName":"[test_chapter] Vel accumsan rhoncus!"}]
   */
  relatedChapter?: {
    /**
     * "50455180671509174"
     */
    chapterId?: string;
    /**
     * "[test_chapter] Sapien bibendum at!"
     */
    chapterName?: string;
  }[];
  /**
   * [{"tagId":41000010,"tagName":"FANTACYS"},{"tagId":41000037,"tagName":"LOLICON"},{"tagId":41001330,"tagName":"CYBER PUNK"},{"tagId":41001092,"tagName":"CUTE KID"},{"tagId":41000459,"tagName":"POSSESSION"},{"tagId":41000578,"tagName":"COURAGEOUS"}]
   */
  relatedTag?: {
    /**
     * 41000010
     */
    tagId?: number;
    /**
     * "FANTACYS"
     */
    tagName?: string;
  }[];
  waitpayStatus?: number;
}

/**
 * 接口 [获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/175491) 的 **请求配置的类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2023-02-28 15:32:53`
 */
type GoPcmChapterGetContent2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/chapter/getContent",
    "data",
    string,
    "chapterId" | "bookId" | "encryptType" | "font",
    false
  >
>;

/**
 * 接口 [获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/175491) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2023-02-28 15:32:53`
 */
const goPcmChapterGetContent2RequestConfig: GoPcmChapterGetContent2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getContent",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: ["chapterId", "bookId", "encryptType", "font"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetContent2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/175491) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2023-02-28 15:32:53`
 */
export const goPcmChapterGetContent2 = /*#__PURE__*/ (
  requestData: GoPcmChapterGetContent2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterGetContent2Response>(
    prepare(goPcmChapterGetContent2RequestConfig, requestData),
    ...args
  );
};

goPcmChapterGetContent2.requestConfig = goPcmChapterGetContent2RequestConfig;

/**
 * 接口 [阅读页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/175496) 的 **请求类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentPage`
 * @更新时间 `2023-02-28 15:33:17`
 */
export interface GoPcmChapterGetContentPageRequest {
  /**
   * 章节 ID
   */
  chapterId: string;
  /**
   * 书籍 ID
   */
  bookId: string;
  /**
   * 0  正常无加密状态
   * 1 只fockjs
   * 2 只字体加密
   * 3 fockjs + 字体加密状态
   */
  encryptType?: string;
  font?: string;
}

/**
 * 接口 [阅读页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/175496) 的 **返回类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentPage`
 * @更新时间 `2023-02-28 15:33:17`
 */
export interface GoPcmChapterGetContentPageResponse {
  bookInfo?: {
    /**
     * 10
     */
    availableFpNum?: number;
    /**
     * 1
     */
    fpCostNum?: number;
    /**
     * "12820870105509205"
     */
    bookId?: string;
    /**
     * "Supreme Magus"
     */
    bookName?: string;
    /**
     * "Legion20"
     */
    authorName?: string;
    /**
     * 11389119606673400
     */
    authorId?: number;
    /**
     * 667
     */
    totalChapterNum?: number;
    /**
     * 30
     */
    actionStatus?: number;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "zh"
     */
    languageName?: string;
    /**
     * 2
     */
    type?: number;
    /**
     * 3080
     */
    reviewTotal?: number;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * 7
     */
    totalPreChapterNum?: number;
    /**
     * -1
     */
    translateMode?: number;
    groupItems?: null;
    editorItems?: null;
    translatorItems?: null;
    /**
     * [{"name":"Legion20","guid":4300863348}]
     */
    authorItems?: {
      /**
       * "Legion20"
       */
      name?: string;
      /**
       * 4300863348
       */
      guid?: number;
    }[];
    patreonLink?: string;
    /**
     * "1589900103766"
     */
    coverUpdateTime?: string;
    /**
     * 443
     */
    giftNum?: number;
    /**
     * 1
     */
    categoryType?: number;
  };
  chapterInfo?: {
    /**
     * 1
     */
    fastPassNum?: number;
    /**
     * []
     */
    announcementItems?: unknown[];
    banner?: {
      /**
       * "@string"
       */
      coverUrl?: string;
      /**
       * "@string"
       */
      desc?: string;
    };
    /**
     * "41312083903577284"
     */
    chapterId?: string;
    /**
     * "Unnatural (Part 1)"
     */
    chapterName?: string;
    /**
     * 277
     */
    chapterIndex?: number;
    /**
     * "41288685441829971"
     */
    preChapterId?: string;
    /**
     * "xxx"
     */
    preChapterName?: string;
    /**
     * "41312210319887628"
     */
    nextChapterId?: string;
    /**
     * "xxx"
     */
    nextChapterName?: string;
    /**
     * 2
     */
    isVip?: number;
    /**
     * 7
     */
    SSPrice?: number;
    chapterLevel?: number;
    userLevel?: number;
    /**
     * [{"paragraphId":"112de3adeced787f10a8a24aebeb9f4d","content":"<p>Saying that the attic was furnished would have been an understatement. Tapestry, carpets, even the chair the man was sitting on were embedded with precious gemstones the size of a nut.</p>"},{"paragraphId":"dde04f7acbdb43a83a8fca95e127cb8f","content":"<p>Piles of coins and jewels were laying in random spots of the room as if a creature composed of living gold had a tour of the place while having a bad case of diarrhea.</p>"},{"paragraphId":"af517d84827084cb29c3dee32cebf53c","content":"<p>A magic eight pointed star inscribed in a circle made of pure white energy encompassed the whole room. At each extremity of the star, there was a small altar made of white marble.</p>"},{"paragraphId":"86fd21e04c398224d6ca04eee1e472a3","content":"<p>The surface of the altars was covered with runes that Red and Lith both would easily recognize as the same light magic runes that were empowering the array below their feet, if only they managed to take a single glance at them.</p>"}]
     */
    contents?: {
      /**
       * "112de3adeced787f10a8a24aebeb9f4d"
       */
      paragraphId?: string;
      /**
       * "<p>Saying that the attic was furnished would have been an understatement. Tapestry, carpets, even the chair the man was sitting on were embedded with precious gemstones the size of a nut.</p>"
       */
      content?: string;
    }[];
    /**
     * [0,1,2,3]
     */
    encryptType?: number[];
    /**
     * "@string"
     */
    encryptKeyPool?: string;
    /**
     * 1
     */
    encryptVersion?: number;
    isAuth?: number;
    /**
     * 1
     */
    batchUnlockStatus?: number;
    /**
     * 1
     */
    isRichFormat?: number;
    groupItems?: null;
    /**
     * []
     */
    editorItems?: unknown[];
    /**
     * []
     */
    translatorItems?: unknown[];
    /**
     * "34415834751367671"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    firstChapterIndex?: number;
    /**
     * 94
     */
    reviewTotal?: number;
    notes?: null;
    transRating?: null;
    originalPrice?: null;
    discountInfo?: null;
    /**
     * 284
     */
    orderIndex?: number;
    /**
     * [{"msgType":2,"title":"fwfewf TITLE","content":"fwefwefwe TITLE","target":"This is a target","reward":"This is a reward"},{"msgType":1,"title":"hdhd title","content":"fwefwefwe","target":"this is a hd target","reward":"this is a hd reward"}]
     */
    anouncementItems?: {
      /**
       * 2
       */
      msgType?: number;
      /**
       * "fwfewf TITLE"
       */
      title?: string;
      /**
       * "fwefwefwe TITLE"
       */
      content?: string;
      /**
       * "This is a target"
       */
      target?: string;
      /**
       * "This is a reward"
       */
      reward?: string;
    }[];
    adPosition?: {
      /**
       * true
       */
      readChapterEnd?: boolean;
    };
  };
  machineTrans?: {
    isWhiteUser?: number;
  };
  membershipStatus?: number;
  /**
   * [{"BookId":"6831119801008505","BookName":"Plundering the Heavens","BookType":0,"BookCoverId":1645183047372}]
   */
  relatedBook?: {
    /**
     * "6831119801008505"
     */
    BookId?: string;
    /**
     * "Plundering the Heavens"
     */
    BookName?: string;
    BookType?: number;
    /**
     * 1645183047372
     */
    BookCoverId?: number;
  }[];
  /**
   * [{"chapterId":"50455180671509174","chapterName":"[test_chapter] Sapien bibendum at!"},{"chapterId":"50455179866202699","chapterName":"[test_chapter] Facilisi porttitor accumsan?"},{"chapterId":"50455179329331749","chapterName":"[test_chapter] Sodales diam vulputate."},{"chapterId":"50455178792460798","chapterName":"[test_chapter] Pellentesque varius venenatis!"},{"chapterId":"50455178255589831","chapterName":"[test_chapter] Vel accumsan rhoncus!"}]
   */
  relatedChapter?: {
    /**
     * "50455180671509174"
     */
    chapterId?: string;
    /**
     * "[test_chapter] Sapien bibendum at!"
     */
    chapterName?: string;
  }[];
  /**
   * [{"tagId":41000010,"tagName":"FANTACYS"},{"tagId":41000037,"tagName":"LOLICON"},{"tagId":41001330,"tagName":"CYBER PUNK"},{"tagId":41001092,"tagName":"CUTE KID"},{"tagId":41000459,"tagName":"POSSESSION"},{"tagId":41000578,"tagName":"COURAGEOUS"}]
   */
  relatedTag?: {
    /**
     * 41000010
     */
    tagId?: number;
    /**
     * "FANTACYS"
     */
    tagName?: string;
  }[];
  waitpayStatus?: number;
  /**
   * ["data:font/woff2;base64,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","data:font/woff2;base64,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"]
   */
  fonts?: string[];
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300002453/1/1.jpg?mt=1568770071000"
     */
    avatar?: string;
    /**
     * "sunmeiye"
     */
    nickName?: string;
    /**
     * "sunmeiye"
     */
    userName?: string;
    /**
     * "4300002453"
     */
    guid?: string;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * "sunmeiye"
     */
    penName?: string;
    /**
     * 9861
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 1
     */
    grade?: number;
    /**
     * 1
     */
    ES?: number;
    /**
     * 1
     */
    totalES?: number;
    /**
     * 1
     */
    PS?: number;
    /**
     * 1
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    /**
     * true
     */
    isCheckIn?: boolean;
    UUT?: number;
    /**
     * 102
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
  };
}

/**
 * 接口 [阅读页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/175496) 的 **请求配置的类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentPage`
 * @更新时间 `2023-02-28 15:33:17`
 */
type GoPcmChapterGetContentPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/chapter/getContentPage",
    "data",
    string,
    "chapterId" | "bookId" | "encryptType" | "font",
    false
  >
>;

/**
 * 接口 [阅读页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/175496) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentPage`
 * @更新时间 `2023-02-28 15:33:17`
 */
const goPcmChapterGetContentPageRequestConfig: GoPcmChapterGetContentPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getContentPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: ["chapterId", "bookId", "encryptType", "font"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetContentPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [阅读页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/175496) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentPage`
 * @更新时间 `2023-02-28 15:33:17`
 */
export const goPcmChapterGetContentPage = /*#__PURE__*/ (
  requestData: GoPcmChapterGetContentPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterGetContentPageResponse>(
    prepare(goPcmChapterGetContentPageRequestConfig, requestData),
    ...args
  );
};

goPcmChapterGetContentPage.requestConfig =
  goPcmChapterGetContentPageRequestConfig;

/**
 * 接口 [chapter\/get-chapter-list 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195528) 的 **请求类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2024-10-16 14:45:26`
 */
export interface GoPcmChapterGetChapterList2Request {
  bookId: string;
  /**
   * 从1开始，默认0吐全部章节
   */
  pageIndex?: string;
  pageSize?: string;
  /**
   * 默认1
   */
  encryptType?: string;
}

/**
 * 接口 [chapter\/get-chapter-list 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195528) 的 **返回类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2024-10-16 14:45:26`
 */
export interface GoPcmChapterGetChapterList2Response {
  /**
   * [0,1]
   */
  encryptType?: number[];
  /**
   * "@string"
   */
  encryptKeyPool?: string;
  encryptVersion?: number;
  content?: {
    bookInfo?: {
      /**
       * "${query.bookId}"
       */
      bookId?: string;
      /**
       * "His Genius Wife is a Superstar"
       */
      bookName?: string;
      /**
       * 345
       */
      totalChapterNum?: number;
      /**
       * "ArriaCross"
       */
      authorName?: string;
      /**
       * 2
       */
      bookType?: number;
      /**
       * 50
       */
      actionStatus?: number;
      /**
       * 1
       */
      languageCode?: number;
      /**
       * "zh"
       */
      languageName?: string;
      /**
       * 1
       */
      hasPrivilege?: number;
      /**
       * [{"id":1,"tagName":"tag","like":true,"likeCount":0}]
       */
      tagInfos?: {
        /**
         * 1
         */
        id?: number;
        /**
         * "tag"
         */
        tagName?: string;
        /**
         * true
         */
        like?: boolean;
        likeCount?: number;
      }[];
      /**
       * 70002
       */
      categoryId?: number;
      /**
       * "High Fantasy"
       */
      categoryName?: string;
      /**
       * 1
       */
      categoryType?: number;
    };
    /**
     * [{"volumeName":"","volumeId":1,"chapterItems":[{"chapterId":"33108867093162835","chapterName":"The Woman in White","chapterIndex":0,"isVip":0,"isAuth":1,"publishTimeFormat":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1,"noArchive":1,"publishTime":123},{"chapterId":"33108867093162836","chapterName":"The Woman in White1","chapterIndex":0,"isVip":0,"isAuth":1,"publishTimeFormat":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1,"noArchive":1,"publishTime":123}]}]
     */
    volumeItems?: {
      volumeName?: string;
      /**
       * 1
       */
      volumeId?: number;
      /**
       * [{"chapterId":"33108867093162835","chapterName":"The Woman in White","chapterIndex":0,"isVip":0,"isAuth":1,"publishTimeFormat":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1,"noArchive":1,"publishTime":123},{"chapterId":"33108867093162836","chapterName":"The Woman in White1","chapterIndex":0,"isVip":0,"isAuth":1,"publishTimeFormat":"Nov 29,2018","chapterLevel":0,"userLevel":0,"canUnlock":1,"noArchive":1,"publishTime":123}]
       */
      chapterItems?: {
        /**
         * "33108867093162835"
         */
        chapterId?: string;
        /**
         * "The Woman in White"
         */
        chapterName?: string;
        chapterIndex?: number;
        isVip?: number;
        /**
         * 1
         */
        isAuth?: number;
        /**
         * "Nov 29,2018"
         */
        publishTimeFormat?: string;
        chapterLevel?: number;
        userLevel?: number;
        /**
         * 1
         */
        canUnlock?: number;
        /**
         * 1
         */
        noArchive?: number;
        /**
         * 123
         */
        publishTime?: number;
      }[];
    }[];
    lastChapterItem?: {
      /**
       * "33108867093162835"
       */
      chapterId?: string;
      /**
       * "The Woman in White"
       */
      chapterName?: string;
      chapterIndex?: number;
      isVip?: number;
      /**
       * 1
       */
      isAuth?: number;
      chapterLevel?: number;
      userLevel?: number;
      /**
       * 1
       */
      canUnlock?: number;
      /**
       * 1
       */
      noArchive?: number;
      /**
       * "3d"
       */
      publishTimeFormat?: string;
      /**
       * 123
       */
      publishTime?: number;
    };
    /**
     * "33108867093162835"
     */
    curReadChapter?: string;
    last?: boolean;
  };
}

/**
 * 接口 [chapter\/get-chapter-list 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195528) 的 **请求配置的类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2024-10-16 14:45:26`
 */
type GoPcmChapterGetChapterList2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/chapter/get-chapter-list",
    "data",
    string,
    "bookId" | "pageIndex" | "pageSize" | "encryptType",
    false
  >
>;

/**
 * 接口 [chapter\/get-chapter-list 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195528) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2024-10-16 14:45:26`
 */
const goPcmChapterGetChapterList2RequestConfig: GoPcmChapterGetChapterList2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/get-chapter-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: ["bookId", "pageIndex", "pageSize", "encryptType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetChapterList2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [chapter\/get-chapter-list 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195528) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2024-10-16 14:45:26`
 */
export const goPcmChapterGetChapterList2 = /*#__PURE__*/ (
  requestData: GoPcmChapterGetChapterList2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterGetChapterList2Response>(
    prepare(goPcmChapterGetChapterList2RequestConfig, requestData),
    ...args
  );
};

goPcmChapterGetChapterList2.requestConfig =
  goPcmChapterGetChapterList2RequestConfig;

/**
 * 接口 [getAmpContent - 获取 amp 章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195682) 的 **请求类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContent`
 * @更新时间 `2022-09-06 17:27:25`
 */
export interface GoPcmChapterGetAmpContentRequest {
  bookId: string;
  chapterId: string;
}

/**
 * 接口 [getAmpContent - 获取 amp 章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195682) 的 **返回类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContent`
 * @更新时间 `2022-09-06 17:27:25`
 */
export interface GoPcmChapterGetAmpContentResponse {
  bookInfo?: {
    /**
     * "7366916601012405"
     */
    bookId?: string;
    /**
     * "The King's Avatar"
     */
    bookName?: string;
    /**
     * 3626681903122401
     */
    authorId?: number;
    /**
     * "Butterfly Blue"
     */
    authorName?: string;
    /**
     * 663
     */
    totalChapterNum?: number;
    /**
     * "30"
     */
    actionStatus?: string;
    /**
     * 28
     */
    reviewTotal?: number;
    /**
     * 15
     */
    checklevel?: number;
    /**
     * 1
     */
    bookType?: number;
    totalPreChapterNum?: number;
    /**
     * 70001
     */
    categoryId?: number;
    /**
     * 1577568672000
     */
    publishTime?: number;
    /**
     * 1577568672000
     */
    updateTime?: number;
    /**
     * ["xxx","123","123"]
     */
    adIds?: string[];
    /**
     * ["/274367222/web-read-video","/274367222/web-read-video2","/274367222/web-read-video3","/274367222/web-read-video4","/274367222/web-read-video5"]
     */
    videoAdIds?: string[];
    patreonLink?: string;
    /**
     * 1
     */
    isShowAds?: number;
    /**
     * 43
     */
    giftNum?: number;
  };
  chapterInfo?: {
    /**
     * "30539125799047747"
     */
    chapterId?: string;
    /**
     * "Chapter 663 cannot be spared"
     */
    chapterName?: string;
    /**
     * 663
     */
    chapterIndex?: number;
    /**
     * 1577568672000
     */
    publishTime?: number;
    /**
     * 1577568672000
     */
    updateTime?: number;
    /**
     * []
     */
    groupItems?: unknown[];
    /**
     * [{"id":8161817001026805,"name":"RENREN","userId":3823689966}]
     */
    translatorItems?: {
      /**
       * 8161817001026805
       */
      id?: number;
      /**
       * "RENREN"
       */
      name?: string;
      /**
       * 3823689966
       */
      userId?: number;
    }[];
    /**
     * [{"id":8161817001026805,"name":"RENREN","userId":3823689966}]
     */
    editorItems?: {
      /**
       * 8161817001026805
       */
      id?: number;
      /**
       * "RENREN"
       */
      name?: string;
      /**
       * 3823689966
       */
      userId?: number;
    }[];
    /**
     * "23000234665765226"
     */
    preChapterId?: string;
    /**
     * "-1"
     */
    nextChapterId?: string;
    isVip?: number;
    source?: string;
    /**
     * 1
     */
    isRichFormat?: number;
    /**
     * "<p>Destroy the person indefatigable front left and right side to be blocked a water to be impassable, beelulan is eager to be able to steel wire to hang several people to connect the upper half of the air is prevented.<br>This guy is so hard to catch, no wonder the notoriety, but the collection is still very successful.<br>Last time we fought side by side, we didn't know much about the strength of destroying people.<br>If my own group of five is qualified as a professional player, this wrecker will never fail.<br>Slaying Leland heart has begun a point to attract the meaning, is pondering how to cut, for a while did not come up to speak.<br>But the crowd of players around the destruction of the tireless righteousness of the world roared: \"run, why don't you run?<br>Try another one!<br>The centurion, he could not catch even one man, and in the end he lost two stops at the exit.<br>And these two road, that outfit tattered can let a person tear down.<br>The player that righteousness cuts whole world is right now true sense of shame and indignation is difficult.<br>The ruined man in the midst was tireless and silent.<br>In fact, as soon as he killed Leland, he chose three things out of the 70 level wild map BOSS, and it would not be a loss if he died.<br>Unless his face is too dark, he can pop the thing back.<br>But the odds are so small that if you have the same stuff in your pocket, and you drop one or two of your gear, you're going to make a lot of money.<br>So it's not easy to blow this thing away and try to blow it back.<br>Rarely can a fight be settled.<br>But does not explode the original, explodes the equivalent return also does not calculate the loss!<br>But that's not the case at the moment. There's no such thing as three level 70 wildcard bosses dropping things that destroy people.<br>This seemed to be clear to the indefatigable man, and he took his time knowing that he was going to die.<br>Die, die!<br>It was a profitable trip anyway.<br>The many players who just cut the world off just curse, no one to start with, obviously also all understand this, this guy, just kill really don't earn back, may have to have some other means.<br>As a result, the chairman did not speak for a while, but he stood up.<br>\"Can't you escape?<br>Give it away.\"<br>\"Said Hugh.<br>Destroy a person unwearied to see not to see him one eye, however justice behead the world many players have turned the Angle of view to come over, in succession feel great god this words be extremely naive, the person now dead once also earn, with what hand over thing?<br>\"What a good fellow he is!<br>The opening line is super no new, and the following is also very routine: \"if you don't mind, make a friend, take the things, do not need to return, calculate me to send.\"<br>The word is the earth burst the word, but the bold and heroic of beheaded loulan still showed.<br>Three level 70 field map BOSS dropped things, casual on the gift, the warrior's domineering show undoubtedly.<br>The player of righteousness cuts the world although still have a little bit to be unhappy in the mind, but destroy a person indefatigably fierce is the fact.<br>Beheaded lalan to its good intention, you can also understand.<br>Don't say can come together to kill wild graph BOSS's player is not an outsider, in whole game who does not know to chop off lalan that is to enter the professional circle, see a master to solicit, must of!<br>The result destroy a person indefatigably still reason also ignore, cut a Lou LAN so hang that.<br>Beheaded Leland a little embarrassed, but did not retreat, directly spread a big shop: \"brother such skill, just used to pick up waste is too regrettable?<br>I am now organizing a team, it is time to need people, I do not know brother is interested?<br>If you are willing to come, the terms are good.<br>Envy and hate!<br>This is justice behead world player people at this time of mood, can join professional team, return a condition to say, such treatment, which glory player can not envy?<br>The result is out of the blue in front of him, hearing such an eye - warming rhetoric, or indifference, even a perspective refused to cut laland to turn.<br>\"Brother...<br>\"Brother what brother!<br>Beheaded Lou LAN just want to open again, was leaf xiu directly interrupted, follow to see if you smile in the hand a thousand machine umbrella shake to fall into a war spear, toward destroying a person indefatigable feet naked on a knock.<br>Destroy a person indefatigably do not blink also not avoid, after be this knock, the role a lean is a stagger, the prince mo smile hand war spear again slightly sweep, immediately immediately threw down on the ground, again also have no meaning at all get up again.<br>\"People are off line.\"<br>Ye xiu said to the slalom.<br>After all, there is a professional level of slaying, just before your smile on the two after the destruction of people's tireless response, also see that the role is certainly no one to operate.<br>Destroy the person indefatigable at this time is certainly the combat state, is unable to descend the line, can force to close the game.<br>That way the character stays in the scene like a stake.<br>But there is also the possibility that the game is thrown here, but the person is not operating.<br>\"Perhaps there are still people?<br>The possibility occurred to him.<br>\"Will you talk?<br>Ye Xiu asked.<br>Slalom sorry.<br>Whether the person is off line or not, the attitude is in fact very obvious, just ignore you.<br>So many people to watch, again let slalom to a response to a wooden stake, he face also hang!<br>This should have the confidence to have the speech to feel to be able to persuade the other side to pour still can try, but the problem is to cut a land before two paragraph already be again basic and simple, this can be more even so the word did not have.<br>After thinking about it, chopped off the land to feel that their ability to do or stronger, immediately is a sword split out: \"hung.\"<br>As soon as the crowd joined in the attack, it was a corpse in an instant.<br>The body fell to the ground, and for a long time there was no resurrection, which seemed like it was off the line.<br>Glad to destroy you!<br>Fortunately just did not continue to think the word to say, otherwise said that the person forced to stay time, to brush off the line, that would be a disgrace!<br>But now a look at the ground, chopped off the blue mood is not good to go.<br>None of the three 70 level wild BOSS stuff that the wrecking crew had left.<br>There are two ninja pieces missing, but this kind of online game level equipment is not as luxurious as slalom.<br>At a glance, I didn't even bother to pick it.<br>At last he was conscious of the fact that he was in a bad mood, and not only did he say it out loud: \"it was a kind of exclamation that killed this guy!<br>This guy blew away three things, all blame me too careless, don't worry, this reward we won't have anything to deduct because of this.\"<br>The player that yi cuts a world to hear such announcement mood can be improved greatly.<br>They all knew that this level 70 field map BOSS made something must be put into the combat team, so they are not able to directly benefit from the BOSS's disclosure, can only be another benefit from the guild.<br>This is true of any club guild, level 70 wild map BOSS, and the equipment will sometimes fill the guild warehouse occasionally, but the material is definitely not fanciful.<br>The BOSS revealed to the many players who want to also attempt not to attempt, for these things are not in the hands of beheading Leland actually did not pay so much attention.<br>After all, yi cut the world out of the money to spend, and his team was just announced to form soon.<br>The so-called supporters who gathered by hype have far less affection for the guild.<br>There is no match for the club council at this point.<br>Club guilds, if they are really a force, are also emotionally cohesive and centripetal.<br>It's the kind of thing that happens when you don't get the materials that affect the development of the team, and they're really worried.<br>Justice begets the world, after beheading laland such a statement, most of the people are already happy, of course this happy is also not good performance, the scene is still stuffy.<br>But of course I knew what was going on in my heart, otherwise I wouldn't have to say more.<br>If you want to win fans, you can't do it overnight or just do it.<br>Appease the guild people, the god of work on the side of slalom also have to communicate is not it?<br>Although the big god said before, things can not find back to calculate his, but chopped off the land how can really calculate like this?<br>It is absolutely his or their duty to destroy the world.<br>Although he can also say a lot of reasons, but in any case, and god is a dime has nothing to do with.<br>Man led the team to block the guild. It was done beautifully.<br>Two clubs have been defeated by justice, which is the usual thing they can do?<br>Beheaded Leland news, you smile, the BOSS after the dark night streamer of the harvest list, and then said: \"that guy blew away three should count me, but I really did not come to see those three are what.<br>Let's split it in half, and then you can pick three things from my side.<br>\"Why, you think that's the cheap guy?\"<br>Ye Xiu said.<br>\"That?\"<br>Slalom wondered.<br>He was certainly not content to let it go.<br>To tell you the truth, the final result of this, slaying the land is also full of anger!<br>But what else could he do?<br>Now people have been dead, resurrection and rebirth in which the main city do not know, the hunt for the killing is very inconvenient.<br>Besides, you can't take anything back from the hunt, and you'll soon be able to transfer the explosive material to the warehouse.<br>The stuff in the warehouse can never burst.<br>\"You provide information, I will be responsible for the murder!\"<br>Yip xiu patted her chest.<br>\"Look, big god!<br>There are still a number of wild map bosses this week, should we focus on the next BOSS?<br>Can grab a BOSS, no better than to blow up that kid?<br>It's not worth wasting time and manpower on his behalf!\"<br>\"Said the slayer.<br>\"BOSS of course to rob, but this guy also can't let go.<br>Just keep an eye on his whereabouts. You pass it on to the guild.<br>Ye Xiu said.<br>\"Can you go to clean up this kid, we return how rob a BOSS?\"<br>\"How to kill a chicken with a knife?\"<br>Ye Xiu said.<br>Beheaded Leland is very to hesitate a time: \"you mean that boy is chicken, still rob BOSS this matter is chicken?\"<br>It was a bit of a blur, but he was sure it was a bull's knife, but which was the chicken?<br>================================ ====================== 2 months is finally over.<br>The last few chapters are not very exciting. March is good!<br>To be continued.<br>If you like this work, you are welcome to come to qidian.com to vote for the recommendation and the monthly ticket. Your support is my biggest motivation.</p>"
     */
    content?: string;
    /**
     * 1
     */
    isAuth?: number;
    /**
     * "19775416453662908"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    firstChapterIndex?: number;
    reviewTotal?: number;
    SSPrice?: number;
    /**
     * 663
     */
    orderIndex?: number;
    notes?: null;
    /**
     * 5
     */
    transRating?: number;
    /**
     * []
     */
    chapterReviewItems?: unknown[];
  };
}

/**
 * 接口 [getAmpContent - 获取 amp 章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195682) 的 **请求配置的类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContent`
 * @更新时间 `2022-09-06 17:27:25`
 */
type GoPcmChapterGetAmpContentRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/chapter/getAmpContent",
    "data",
    string,
    "bookId" | "chapterId",
    false
  >
>;

/**
 * 接口 [getAmpContent - 获取 amp 章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195682) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContent`
 * @更新时间 `2022-09-06 17:27:25`
 */
const goPcmChapterGetAmpContentRequestConfig: GoPcmChapterGetAmpContentRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getAmpContent",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: ["bookId", "chapterId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetAmpContent",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getAmpContent - 获取 amp 章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195682) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContent`
 * @更新时间 `2022-09-06 17:27:25`
 */
export const goPcmChapterGetAmpContent = /*#__PURE__*/ (
  requestData: GoPcmChapterGetAmpContentRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterGetAmpContentResponse>(
    prepare(goPcmChapterGetAmpContentRequestConfig, requestData),
    ...args
  );
};

goPcmChapterGetAmpContent.requestConfig =
  goPcmChapterGetAmpContentRequestConfig;

/**
 * 接口 [getChapterContentToken - 获取广告章节解锁 token↗](https://yapi.yuewen.com/project/2309/interface/api/195691) 的 **请求类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getChapterContentToken`
 * @更新时间 `2021-01-27 20:47:06`
 */
export interface GoPcmChapterGetChapterContentTokenRequest {
  bookId: string;
  chapterId: string;
}

/**
 * 接口 [getChapterContentToken - 获取广告章节解锁 token↗](https://yapi.yuewen.com/project/2309/interface/api/195691) 的 **返回类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getChapterContentToken`
 * @更新时间 `2021-01-27 20:47:06`
 */
export interface GoPcmChapterGetChapterContentTokenResponse {
  /**
   * "asdlfkjasdkjfaoifj"
   */
  token?: string;
  /**
   * "0-普通 1-Adv 2-付费"
   */
  isVip?: string;
  /**
   * "5"
   */
  vipPrice?: string;
}

/**
 * 接口 [getChapterContentToken - 获取广告章节解锁 token↗](https://yapi.yuewen.com/project/2309/interface/api/195691) 的 **请求配置的类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getChapterContentToken`
 * @更新时间 `2021-01-27 20:47:06`
 */
type GoPcmChapterGetChapterContentTokenRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/chapter/getChapterContentToken",
    "data",
    string,
    "bookId" | "chapterId",
    false
  >
>;

/**
 * 接口 [getChapterContentToken - 获取广告章节解锁 token↗](https://yapi.yuewen.com/project/2309/interface/api/195691) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getChapterContentToken`
 * @更新时间 `2021-01-27 20:47:06`
 */
const goPcmChapterGetChapterContentTokenRequestConfig: GoPcmChapterGetChapterContentTokenRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getChapterContentToken",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: ["bookId", "chapterId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetChapterContentToken",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getChapterContentToken - 获取广告章节解锁 token↗](https://yapi.yuewen.com/project/2309/interface/api/195691) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getChapterContentToken`
 * @更新时间 `2021-01-27 20:47:06`
 */
export const goPcmChapterGetChapterContentToken = /*#__PURE__*/ (
  requestData: GoPcmChapterGetChapterContentTokenRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterGetChapterContentTokenResponse>(
    prepare(goPcmChapterGetChapterContentTokenRequestConfig, requestData),
    ...args
  );
};

goPcmChapterGetChapterContentToken.requestConfig =
  goPcmChapterGetChapterContentTokenRequestConfig;

/**
 * 接口 [getContentByToken - 根据 token 获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195700) 的 **请求类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentByToken`
 * @更新时间 `2021-01-27 21:05:26`
 */
export interface GoPcmChapterGetContentByTokenRequest {
  token: string;
  bookId: string;
  chapterId: string;
}

/**
 * 接口 [getContentByToken - 根据 token 获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195700) 的 **返回类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentByToken`
 * @更新时间 `2021-01-27 21:05:26`
 */
export interface GoPcmChapterGetContentByTokenResponse {
  /**
   * "1: valid token, 0: token invalid"
   */
  isAuth?: string;
  /**
   * [{"contentId":"@string","content":"@string","appId":"@int32","userId":1,"paragraphId":"@string","likeAmount":1,"contentAmount":1,"userName":"@string","UUT":1,"isLiked":1}]
   */
  contents?: {
    /**
     * "@string"
     */
    contentId?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * "@int32"
     */
    appId?: string;
    /**
     * 1
     */
    userId?: number;
    /**
     * "@string"
     */
    paragraphId?: string;
    /**
     * 1
     */
    likeAmount?: number;
    /**
     * 1
     */
    contentAmount?: number;
    /**
     * "@string"
     */
    userName?: string;
    /**
     * 1
     */
    UUT?: number;
    /**
     * 1
     */
    isLiked?: number;
  }[];
  /**
   * "是否精排"
   */
  isRichFormat?: string;
}

/**
 * 接口 [getContentByToken - 根据 token 获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195700) 的 **请求配置的类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentByToken`
 * @更新时间 `2021-01-27 21:05:26`
 */
type GoPcmChapterGetContentByTokenRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/chapter/getContentByToken",
    "data",
    string,
    "token" | "bookId" | "chapterId",
    false
  >
>;

/**
 * 接口 [getContentByToken - 根据 token 获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195700) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentByToken`
 * @更新时间 `2021-01-27 21:05:26`
 */
const goPcmChapterGetContentByTokenRequestConfig: GoPcmChapterGetContentByTokenRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getContentByToken",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: ["token", "bookId", "chapterId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetContentByToken",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getContentByToken - 根据 token 获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195700) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentByToken`
 * @更新时间 `2021-01-27 21:05:26`
 */
export const goPcmChapterGetContentByToken = /*#__PURE__*/ (
  requestData: GoPcmChapterGetContentByTokenRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterGetContentByTokenResponse>(
    prepare(goPcmChapterGetContentByTokenRequestConfig, requestData),
    ...args
  );
};

goPcmChapterGetContentByToken.requestConfig =
  goPcmChapterGetContentByTokenRequestConfig;

/**
 * 接口 [getLastestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195712) 的 **请求类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getLatestUpdates`
 * @更新时间 `2021-01-27 21:33:45`
 */
export interface GoPcmChapterGetLatestUpdatesRequest {}

/**
 * 接口 [getLastestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195712) 的 **返回类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getLatestUpdates`
 * @更新时间 `2021-01-27 21:33:45`
 */
export interface GoPcmChapterGetLatestUpdatesResponse {
  /**
   * [{"bookId":"@string('number', 5)","bookName":"@sentence","newChapterTime":["6 hours ago","4 weeks ago","3 weeks ago"],"coverUpdateTime":1}]
   */
  items?: {
    /**
     * "@string('number', 5)"
     */
    bookId?: string;
    /**
     * "@sentence"
     */
    bookName?: string;
    /**
     * ["6 hours ago","4 weeks ago","3 weeks ago"]
     */
    newChapterTime?: string[];
    /**
     * 1
     */
    coverUpdateTime?: number;
  }[];
}

/**
 * 接口 [getLastestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195712) 的 **请求配置的类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getLatestUpdates`
 * @更新时间 `2021-01-27 21:33:45`
 */
type GoPcmChapterGetLatestUpdatesRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/chapter/getLatestUpdates",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [getLastestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195712) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getLatestUpdates`
 * @更新时间 `2021-01-27 21:33:45`
 */
const goPcmChapterGetLatestUpdatesRequestConfig: GoPcmChapterGetLatestUpdatesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getLatestUpdates",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetLatestUpdates",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getLastestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195712) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getLatestUpdates`
 * @更新时间 `2021-01-27 21:33:45`
 */
export const goPcmChapterGetLatestUpdates = /*#__PURE__*/ (
  requestData?: GoPcmChapterGetLatestUpdatesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterGetLatestUpdatesResponse>(
    prepare(goPcmChapterGetLatestUpdatesRequestConfig, requestData),
    ...args
  );
};

goPcmChapterGetLatestUpdates.requestConfig =
  goPcmChapterGetLatestUpdatesRequestConfig;

/**
 * 接口 [getAmpContentPage - 获取 amp 章节内容page↗](https://yapi.yuewen.com/project/2309/interface/api/213486) 的 **请求类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContentPage`
 * @更新时间 `2021-05-14 10:35:33`
 */
export interface GoPcmChapterGetAmpContentPageRequest {
  bookId: string;
  chapterId: string;
}

/**
 * 接口 [getAmpContentPage - 获取 amp 章节内容page↗](https://yapi.yuewen.com/project/2309/interface/api/213486) 的 **返回类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContentPage`
 * @更新时间 `2021-05-14 10:35:33`
 */
export type GoPcmChapterGetAmpContentPageResponse = number;

/**
 * 接口 [getAmpContentPage - 获取 amp 章节内容page↗](https://yapi.yuewen.com/project/2309/interface/api/213486) 的 **请求配置的类型**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContentPage`
 * @更新时间 `2021-05-14 10:35:33`
 */
type GoPcmChapterGetAmpContentPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/chapter/getAmpContentPage",
    "data",
    string,
    "bookId" | "chapterId",
    false
  >
>;

/**
 * 接口 [getAmpContentPage - 获取 amp 章节内容page↗](https://yapi.yuewen.com/project/2309/interface/api/213486) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContentPage`
 * @更新时间 `2021-05-14 10:35:33`
 */
const goPcmChapterGetAmpContentPageRequestConfig: GoPcmChapterGetAmpContentPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getAmpContentPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: ["bookId", "chapterId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetAmpContentPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getAmpContentPage - 获取 amp 章节内容page↗](https://yapi.yuewen.com/project/2309/interface/api/213486) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContentPage`
 * @更新时间 `2021-05-14 10:35:33`
 */
export const goPcmChapterGetAmpContentPage = /*#__PURE__*/ (
  requestData: GoPcmChapterGetAmpContentPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterGetAmpContentPageResponse>(
    prepare(goPcmChapterGetAmpContentPageRequestConfig, requestData),
    ...args
  );
};

goPcmChapterGetAmpContentPage.requestConfig =
  goPcmChapterGetAmpContentPageRequestConfig;

const mockUrl_0_0_0_2 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_2 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_2 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_2 = "data" as any;

/**
 * 接口 [support - tag点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175498) 的 **请求类型**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `POST /go/pcm/tag/support`
 * @更新时间 `2020-12-02 19:36:36`
 */
export interface GoPcmTagSupportRequest {
  bookId: string;
  tagId: string;
  /**
   * 1点赞，0取消点赞
   */
  supportOp: string;
}

/**
 * 接口 [support - tag点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175498) 的 **返回类型**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `POST /go/pcm/tag/support`
 * @更新时间 `2020-12-02 19:36:36`
 */
export interface GoPcmTagSupportResponse {
  code?: number;
}

/**
 * 接口 [support - tag点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175498) 的 **请求配置的类型**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `POST /go/pcm/tag/support`
 * @更新时间 `2020-12-02 19:36:36`
 */
type GoPcmTagSupportRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/tag/support",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [support - tag点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175498) 的 **请求配置**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `POST /go/pcm/tag/support`
 * @更新时间 `2020-12-02 19:36:36`
 */
const goPcmTagSupportRequestConfig: GoPcmTagSupportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: "/go/pcm/tag/support",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTagSupport",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [support - tag点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175498) 的 **请求函数**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `POST /go/pcm/tag/support`
 * @更新时间 `2020-12-02 19:36:36`
 */
export const goPcmTagSupport = /*#__PURE__*/ (
  requestData: GoPcmTagSupportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmTagSupportResponse>(
    prepare(goPcmTagSupportRequestConfig, requestData),
    ...args
  );
};

goPcmTagSupport.requestConfig = goPcmTagSupportRequestConfig;

/**
 * 接口 [书标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/207324) 的 **请求类型**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2022-08-09 20:10:04`
 */
export interface GoPcmTagGetBookTagList2Request {
  bookId: string;
}

/**
 * 接口 [书标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/207324) 的 **返回类型**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2022-08-09 20:10:04`
 */
export interface GoPcmTagGetBookTagList2Response {
  /**
   * [{"tagId":41090001,"tagName":"aaa","isLiked":0,"likeNums":10},{"tagId":41090002,"tagName":"bbb","isLiked":0,"likeNums":7},{"tagId":41090060,"tagName":"yc1","isLiked":0,"likeNums":2}]
   */
  tagInfo?: {
    /**
     * 41090001
     */
    tagId?: number;
    /**
     * "aaa"
     */
    tagName?: string;
    isLiked?: number;
    /**
     * 10
     */
    likeNums?: number;
  }[];
  bookInfo?: {
    /**
     * "@string"
     */
    name?: string;
  };
}

/**
 * 接口 [书标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/207324) 的 **请求配置的类型**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2022-08-09 20:10:04`
 */
type GoPcmTagGetBookTagList2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/tag/get-book-tag-list",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [书标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/207324) 的 **请求配置**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2022-08-09 20:10:04`
 */
const goPcmTagGetBookTagList2RequestConfig: GoPcmTagGetBookTagList2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: "/go/pcm/tag/get-book-tag-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTagGetBookTagList2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/207324) 的 **请求函数**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2022-08-09 20:10:04`
 */
export const goPcmTagGetBookTagList2 = /*#__PURE__*/ (
  requestData: GoPcmTagGetBookTagList2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmTagGetBookTagList2Response>(
    prepare(goPcmTagGetBookTagList2RequestConfig, requestData),
    ...args
  );
};

goPcmTagGetBookTagList2.requestConfig = goPcmTagGetBookTagList2RequestConfig;

/**
 * 接口 [标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/244300) 的 **请求类型**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-tag-list`
 * @更新时间 `2022-08-10 15:08:10`
 */
export interface GoPcmTagGetTagListRequest {
  orderBy: string;
  pageIndex: string;
}

/**
 * 接口 [标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/244300) 的 **返回类型**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-tag-list`
 * @更新时间 `2022-08-10 15:08:10`
 */
export interface GoPcmTagGetTagListResponse {
  /**
   * [{"tagId":1,"tagName":"tag","likeNums":111,"isLike":0}]
   */
  tagInfo?: {
    /**
     * 1
     */
    tagId?: number;
    /**
     * "tag"
     */
    tagName?: string;
    /**
     * 111
     */
    likeNums?: number;
    isLike?: number;
  }[];
  /**
   * true
   */
  isLast?: boolean;
}

/**
 * 接口 [标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/244300) 的 **请求配置的类型**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-tag-list`
 * @更新时间 `2022-08-10 15:08:10`
 */
type GoPcmTagGetTagListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/tag/get-tag-list",
    "data",
    string,
    "orderBy" | "pageIndex",
    false
  >
>;

/**
 * 接口 [标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/244300) 的 **请求配置**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-tag-list`
 * @更新时间 `2022-08-10 15:08:10`
 */
const goPcmTagGetTagListRequestConfig: GoPcmTagGetTagListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: "/go/pcm/tag/get-tag-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: ["orderBy", "pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTagGetTagList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/244300) 的 **请求函数**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-tag-list`
 * @更新时间 `2022-08-10 15:08:10`
 */
export const goPcmTagGetTagList = /*#__PURE__*/ (
  requestData: GoPcmTagGetTagListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmTagGetTagListResponse>(
    prepare(goPcmTagGetTagListRequestConfig, requestData),
    ...args
  );
};

goPcmTagGetTagList.requestConfig = goPcmTagGetTagListRequestConfig;

const mockUrl_0_0_0_3 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_3 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_3 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_3 = "data" as any;

/**
 * 接口 [coins 历史记录直出↗](https://yapi.yuewen.com/project/2309/interface/api/175506) 的 **请求类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistoryPage`
 * @更新时间 `2020-12-02 19:40:19`
 */
export interface GoPcmSpiritStoneGetSsHistoryPageRequest {
  pageIndex: string;
  /**
   * 1-充值 2-消费
   */
  transType: string;
}

/**
 * 接口 [coins 历史记录直出↗](https://yapi.yuewen.com/project/2309/interface/api/175506) 的 **返回类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistoryPage`
 * @更新时间 `2020-12-02 19:40:19`
 */
export type GoPcmSpiritStoneGetSsHistoryPageResponse = any;

/**
 * 接口 [coins 历史记录直出↗](https://yapi.yuewen.com/project/2309/interface/api/175506) 的 **请求配置的类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistoryPage`
 * @更新时间 `2020-12-02 19:40:19`
 */
type GoPcmSpiritStoneGetSsHistoryPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/spiritStone/getSSHistoryPage",
    "data",
    string,
    "pageIndex" | "transType",
    false
  >
>;

/**
 * 接口 [coins 历史记录直出↗](https://yapi.yuewen.com/project/2309/interface/api/175506) 的 **请求配置**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistoryPage`
 * @更新时间 `2020-12-02 19:40:19`
 */
const goPcmSpiritStoneGetSsHistoryPageRequestConfig: GoPcmSpiritStoneGetSsHistoryPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: "/go/pcm/spiritStone/getSSHistoryPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.raw,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: ["pageIndex", "transType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSpiritStoneGetSsHistoryPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [coins 历史记录直出↗](https://yapi.yuewen.com/project/2309/interface/api/175506) 的 **请求函数**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistoryPage`
 * @更新时间 `2020-12-02 19:40:19`
 */
export const goPcmSpiritStoneGetSsHistoryPage = /*#__PURE__*/ (
  requestData: GoPcmSpiritStoneGetSsHistoryPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSpiritStoneGetSsHistoryPageResponse>(
    prepare(goPcmSpiritStoneGetSsHistoryPageRequestConfig, requestData),
    ...args
  );
};

goPcmSpiritStoneGetSsHistoryPage.requestConfig =
  goPcmSpiritStoneGetSsHistoryPageRequestConfig;

/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go）↗](https://yapi.yuewen.com/project/2309/interface/api/175511) 的 **请求类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-12-02 19:36:36`
 */
export interface GoPcmSpiritStoneGetSsHistory2Request {
  pageIndex: string;
  /**
   * 1-充值 2-消费
   */
  transType: string;
}

/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go）↗](https://yapi.yuewen.com/project/2309/interface/api/175511) 的 **返回类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-12-02 19:36:36`
 */
export interface GoPcmSpiritStoneGetSsHistory2Response {
  info?: {
    /**
     * 1000
     */
    SS?: number;
    /**
     * 100
     */
    vSS?: number;
    /**
     * 100
     */
    vbSS?: number;
    /**
     * 100
     */
    bSS?: number;
    /**
     * 20
     */
    toExpiredSS?: number;
    /**
     * "3 days"
     */
    toExpiredAfter?: string;
    /**
     * "1-充值 2-消费"
     */
    transType?: string;
  };
  /**
   * [{"source":"0-过期  1-签到 2-邀请好友 3-跳过广告 4-期待票投票奖励， 5-活动奖励，6-推荐票投票奖励 9-新用户注册成功送的积分 10-admin 增加， 11-admin减少， 12 -compensation（系统补偿）19 -道具打赏","source计费侧的文档地址":"http://tapd.oa.com/QidianOverSeas/markdown_wikis/#1110143901005279148","platform":"Android","transType":"1-充值 2-消费 3-过期","SS":10,"time":"毫秒时间戳","skipBookName":"xxx 如果不是 Skip ad 则为 NULL","skipBookId":"xxx","skipChapterIndex":"xxx 如果不是 Skip ad 则为 NULL","skipChapterId":"xxx 如果不是 Skip ad 则为 NULL","skipChapterName":"xxx 如果不是 Skip ad 则为 NULL","toExpiredAfter":"3 days","expireTime":1602000000000,"isBonus":true,"giftName":"bigCat","description":"","startChapterIndex":1,"endChapterIndex":5,"chapterCount":5}]
   */
  items?: {
    /**
     * "0-过期  1-签到 2-邀请好友 3-跳过广告 4-期待票投票奖励， 5-活动奖励，6-推荐票投票奖励 9-新用户注册成功送的积分 10-admin 增加， 11-admin减少， 12 -compensation（系统补偿）19 -道具打赏"
     */
    source?: string;
    /**
     * "http://tapd.oa.com/QidianOverSeas/markdown_wikis/#1110143901005279148"
     */
    source计费侧的文档地址?: string;
    /**
     * "Android"
     */
    platform?: string;
    /**
     * "1-充值 2-消费 3-过期"
     */
    transType?: string;
    /**
     * 10
     */
    SS?: number;
    /**
     * "毫秒时间戳"
     */
    time?: string;
    /**
     * "xxx 如果不是 Skip ad 则为 NULL"
     */
    skipBookName?: string;
    /**
     * "xxx"
     */
    skipBookId?: string;
    /**
     * "xxx 如果不是 Skip ad 则为 NULL"
     */
    skipChapterIndex?: string;
    /**
     * "xxx 如果不是 Skip ad 则为 NULL"
     */
    skipChapterId?: string;
    /**
     * "xxx 如果不是 Skip ad 则为 NULL"
     */
    skipChapterName?: string;
    /**
     * "3 days"
     */
    toExpiredAfter?: string;
    /**
     * 1602000000000
     */
    expireTime?: number;
    /**
     * true
     */
    isBonus?: boolean;
    /**
     * "bigCat"
     */
    giftName?: string;
    description?: string;
    /**
     * 1
     */
    startChapterIndex?: number;
    /**
     * 5
     */
    endChapterIndex?: number;
    /**
     * 5
     */
    chapterCount?: number;
  }[];
  /**
   * 1
   */
  isLast?: number;
  /**
   * 1000
   */
  total?: number;
}

/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go）↗](https://yapi.yuewen.com/project/2309/interface/api/175511) 的 **请求配置的类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-12-02 19:36:36`
 */
type GoPcmSpiritStoneGetSsHistory2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/spiritStone/getSSHistory",
    "data",
    string,
    "pageIndex" | "transType",
    false
  >
>;

/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go）↗](https://yapi.yuewen.com/project/2309/interface/api/175511) 的 **请求配置**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-12-02 19:36:36`
 */
const goPcmSpiritStoneGetSsHistory2RequestConfig: GoPcmSpiritStoneGetSsHistory2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: "/go/pcm/spiritStone/getSSHistory",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: ["pageIndex", "transType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSpiritStoneGetSsHistory2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go）↗](https://yapi.yuewen.com/project/2309/interface/api/175511) 的 **请求函数**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-12-02 19:36:36`
 */
export const goPcmSpiritStoneGetSsHistory2 = /*#__PURE__*/ (
  requestData: GoPcmSpiritStoneGetSsHistory2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSpiritStoneGetSsHistory2Response>(
    prepare(goPcmSpiritStoneGetSsHistory2RequestConfig, requestData),
    ...args
  );
};

goPcmSpiritStoneGetSsHistory2.requestConfig =
  goPcmSpiritStoneGetSsHistory2RequestConfig;

/**
 * 接口 [签到↗](https://yapi.yuewen.com/project/2309/interface/api/175521) 的 **请求类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `POST /go/pcm/spiritStone/checkIn`
 * @更新时间 `2021-01-13 15:18:44`
 */
export interface GoPcmSpiritStoneCheckInRequest {}

/**
 * 接口 [签到↗](https://yapi.yuewen.com/project/2309/interface/api/175521) 的 **返回类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `POST /go/pcm/spiritStone/checkIn`
 * @更新时间 `2021-01-13 15:18:44`
 */
export interface GoPcmSpiritStoneCheckInResponse {
  /**
   * 8
   */
  rewardSS?: number;
  rewardPS?: number;
  rewardExp?: number;
  /**
   * "https://actimg.webnovel.com/sign/ss.png"
   */
  rewardIcon?: string;
  /**
   * 8
   */
  SS?: number;
  /**
   * [{"awardType":1,"amount":1},{"awardType":2,"amount":2},{"awardType":3,"amount":3},{"awardType":4,"amount":4},{"awardType":5,"amount":5}]
   */
  awards?: {
    /**
     * 1
     */
    awardType?: number;
    /**
     * 1
     */
    amount?: number;
  }[];
}

/**
 * 接口 [签到↗](https://yapi.yuewen.com/project/2309/interface/api/175521) 的 **请求配置的类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `POST /go/pcm/spiritStone/checkIn`
 * @更新时间 `2021-01-13 15:18:44`
 */
type GoPcmSpiritStoneCheckInRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/spiritStone/checkIn",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [签到↗](https://yapi.yuewen.com/project/2309/interface/api/175521) 的 **请求配置**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `POST /go/pcm/spiritStone/checkIn`
 * @更新时间 `2021-01-13 15:18:44`
 */
const goPcmSpiritStoneCheckInRequestConfig: GoPcmSpiritStoneCheckInRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: "/go/pcm/spiritStone/checkIn",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSpiritStoneCheckIn",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [签到↗](https://yapi.yuewen.com/project/2309/interface/api/175521) 的 **请求函数**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `POST /go/pcm/spiritStone/checkIn`
 * @更新时间 `2021-01-13 15:18:44`
 */
export const goPcmSpiritStoneCheckIn = /*#__PURE__*/ (
  requestData?: GoPcmSpiritStoneCheckInRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSpiritStoneCheckInResponse>(
    prepare(goPcmSpiritStoneCheckInRequestConfig, requestData),
    ...args
  );
};

goPcmSpiritStoneCheckIn.requestConfig = goPcmSpiritStoneCheckInRequestConfig;

/**
 * 接口 [邀请好友页(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/175526) 的 **请求类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getInviteFriendPage`
 * @更新时间 `2021-01-13 15:19:33`
 */
export interface GoPcmSpiritStoneGetInviteFriendPageRequest {}

/**
 * 接口 [邀请好友页(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/175526) 的 **返回类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getInviteFriendPage`
 * @更新时间 `2021-01-13 15:19:33`
 */
export interface GoPcmSpiritStoneGetInviteFriendPageResponse {
  /**
   * 50
   */
  inviteSS?: number;
  /**
   * 20
   */
  beInviteSS?: number;
  /**
   * 2
   */
  inviteFP?: number;
  /**
   * "iaAYKJN2"
   */
  inviteCode?: string;
  /**
   * [{"awardType":5,"amount":2}]
   */
  awards?: {
    /**
     * 5
     */
    awardType?: number;
    /**
     * 2
     */
    amount?: number;
  }[];
  /**
   * [{"awardType":5,"amount":2}]
   */
  beAwards?: {
    /**
     * 5
     */
    awardType?: number;
    /**
     * 2
     */
    amount?: number;
  }[];
  user?: {
    /**
     * "//oauserimg.webnovel.com/userheadimg/1/1/1.png?mt=1542770885013"
     */
    avatar?: string;
    /**
     * "111test"
     */
    nickName?: string;
    /**
     * "111test"
     */
    userName?: string;
    /**
     * "4300000385"
     */
    guid?: string;
    status?: number;
    role?: number;
    penName?: string;
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 2
     */
    grade?: number;
    /**
     * 1
     */
    ES?: number;
    /**
     * 1
     */
    totalES?: number;
    /**
     * 2
     */
    PS?: number;
    /**
     * 2
     */
    totalPS?: number;
    emailStatus?: number;
    isCheckIn?: number;
    /**
     * 1542770885013
     */
    UUT?: number;
  };
}

/**
 * 接口 [邀请好友页(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/175526) 的 **请求配置的类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getInviteFriendPage`
 * @更新时间 `2021-01-13 15:19:33`
 */
type GoPcmSpiritStoneGetInviteFriendPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/spiritStone/getInviteFriendPage",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [邀请好友页(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/175526) 的 **请求配置**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getInviteFriendPage`
 * @更新时间 `2021-01-13 15:19:33`
 */
const goPcmSpiritStoneGetInviteFriendPageRequestConfig: GoPcmSpiritStoneGetInviteFriendPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: "/go/pcm/spiritStone/getInviteFriendPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSpiritStoneGetInviteFriendPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [邀请好友页(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/175526) 的 **请求函数**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getInviteFriendPage`
 * @更新时间 `2021-01-13 15:19:33`
 */
export const goPcmSpiritStoneGetInviteFriendPage = /*#__PURE__*/ (
  requestData?: GoPcmSpiritStoneGetInviteFriendPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSpiritStoneGetInviteFriendPageResponse>(
    prepare(goPcmSpiritStoneGetInviteFriendPageRequestConfig, requestData),
    ...args
  );
};

goPcmSpiritStoneGetInviteFriendPage.requestConfig =
  goPcmSpiritStoneGetInviteFriendPageRequestConfig;

/**
 * 接口 [查询充赠免费文案↗](https://yapi.yuewen.com/project/2309/interface/api/207105) 的 **请求类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getAnnouncement`
 * @更新时间 `2021-04-29 09:59:30`
 */
export interface GoPcmSpiritStoneGetAnnouncementRequest {}

/**
 * 接口 [查询充赠免费文案↗](https://yapi.yuewen.com/project/2309/interface/api/207105) 的 **返回类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getAnnouncement`
 * @更新时间 `2021-04-29 09:59:30`
 */
export interface GoPcmSpiritStoneGetAnnouncementResponse {
  /**
   * 1
   */
  type?: number;
  /**
   * "Coins can be used to skip ads, unlock chapters and support the translators/editors."
   */
  note?: string;
  /**
   * "https://activity.webnovel.com/noah/856917813/en?cId=coin"
   */
  url?: string;
  /**
   * "Bonus Coins obtained from purchasing expires after 90 days."
   */
  expireText?: string;
}

/**
 * 接口 [查询充赠免费文案↗](https://yapi.yuewen.com/project/2309/interface/api/207105) 的 **请求配置的类型**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getAnnouncement`
 * @更新时间 `2021-04-29 09:59:30`
 */
type GoPcmSpiritStoneGetAnnouncementRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/spiritStone/getAnnouncement",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [查询充赠免费文案↗](https://yapi.yuewen.com/project/2309/interface/api/207105) 的 **请求配置**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getAnnouncement`
 * @更新时间 `2021-04-29 09:59:30`
 */
const goPcmSpiritStoneGetAnnouncementRequestConfig: GoPcmSpiritStoneGetAnnouncementRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: "/go/pcm/spiritStone/getAnnouncement",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSpiritStoneGetAnnouncement",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [查询充赠免费文案↗](https://yapi.yuewen.com/project/2309/interface/api/207105) 的 **请求函数**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getAnnouncement`
 * @更新时间 `2021-04-29 09:59:30`
 */
export const goPcmSpiritStoneGetAnnouncement = /*#__PURE__*/ (
  requestData?: GoPcmSpiritStoneGetAnnouncementRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSpiritStoneGetAnnouncementResponse>(
    prepare(goPcmSpiritStoneGetAnnouncementRequestConfig, requestData),
    ...args
  );
};

goPcmSpiritStoneGetAnnouncement.requestConfig =
  goPcmSpiritStoneGetAnnouncementRequestConfig;

const mockUrl_0_0_0_4 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_4 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_4 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_4 = "data" as any;

/**
 * 接口 [get-moment-list 获取moments列表↗](https://yapi.yuewen.com/project/2309/interface/api/175528) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2020-12-02 19:36:36`
 */
export interface GoPcmUserGetMomentList2Request {
  userId: string;
  appId: string;
}

/**
 * 接口 [get-moment-list 获取moments列表↗](https://yapi.yuewen.com/project/2309/interface/api/175528) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2020-12-02 19:36:36`
 */
export interface GoPcmUserGetMomentList2Response {
  isLast?: 0 | 1;
  momentsItems?: {
    id?: string;
    momentType?: 1 | 2 | 3;
    createTime?: string;
    bookInfo?: {
      bookId?: 0 | 12312323;
      novelType?: 100 | 0;
      bookCoverId?: number;
      bookName?: string;
      categoryId?: number;
      categoryName?: string;
      authorName?: string;
    };
    chapterId?: 0 | 1231232;
    chapterIndex?: number;
    chapterName?: string;
    paragraphId?: "234234" | "0" | "0";
    paragraphContent?: "@paragraph";
    reviewType?: 1 | 2;
    reviewId?: number;
    replyId?: number;
    bookReviewScore?: 4.5 | 0 | 2.5 | 0 | 1;
    replyToUserName?: "@name";
    content?: "@paragraph";
    imageItems?: {
      imageUrl?: "https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif";
      height?: 332;
      width?: 498;
    }[];
  }[];
}

/**
 * 接口 [get-moment-list 获取moments列表↗](https://yapi.yuewen.com/project/2309/interface/api/175528) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2020-12-02 19:36:36`
 */
type GoPcmUserGetMomentList2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/get-moment-list",
    "data",
    string,
    "userId" | "appId",
    false
  >
>;

/**
 * 接口 [get-moment-list 获取moments列表↗](https://yapi.yuewen.com/project/2309/interface/api/175528) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2020-12-02 19:36:36`
 */
const goPcmUserGetMomentList2RequestConfig: GoPcmUserGetMomentList2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/get-moment-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: ["userId", "appId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetMomentList2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-moment-list 获取moments列表↗](https://yapi.yuewen.com/project/2309/interface/api/175528) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2020-12-02 19:36:36`
 */
export const goPcmUserGetMomentList2 = /*#__PURE__*/ (
  requestData: GoPcmUserGetMomentList2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetMomentList2Response>(
    prepare(goPcmUserGetMomentList2RequestConfig, requestData),
    ...args
  );
};

goPcmUserGetMomentList2.requestConfig = goPcmUserGetMomentList2RequestConfig;

/**
 * 接口 [get-获取作家主页-485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175536) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-author-page`
 * @更新时间 `2021-06-23 14:34:15`
 */
export interface GoPcmUserGetAuthorPageRequest {
  userId: string;
  appId: string;
}

/**
 * 接口 [get-获取作家主页-485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175536) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-author-page`
 * @更新时间 `2021-06-23 14:34:15`
 */
export interface GoPcmUserGetAuthorPageResponse {
  /**
   * [{"bookId":131412,"bookType":0,"bookName":"@string","bookCoverId":0,"bookTag":"this is amazing","totalChapterNum":131,"collectionNum":22,"categoryName":"High Fantasy","tagItem":{"isHot":0,"isRecent":0,"isCompleted":0},"anouncementItems":[{"id":"@string","msgType":1,"title":"fwfewf title","content":"fwefwefwe","target":"this is a target","reward":"this is a reward","startTime":1595820587069,"endTime":1598498987000}],"categoryType":1}]
   */
  bookListItems?: {
    /**
     * 131412
     */
    bookId?: number;
    bookType?: number;
    /**
     * "@string"
     */
    bookName?: string;
    bookCoverId?: number;
    /**
     * "this is amazing"
     */
    bookTag?: string;
    /**
     * 131
     */
    totalChapterNum?: number;
    /**
     * 22
     */
    collectionNum?: number;
    /**
     * "High Fantasy"
     */
    categoryName?: string;
    tagItem?: {
      isHot?: number;
      isRecent?: number;
      isCompleted?: number;
    };
    /**
     * [{"id":"@string","msgType":1,"title":"fwfewf title","content":"fwefwefwe","target":"this is a target","reward":"this is a reward","startTime":1595820587069,"endTime":1598498987000}]
     */
    anouncementItems?: {
      /**
       * "@string"
       */
      id?: string;
      /**
       * 1
       */
      msgType?: number;
      /**
       * "fwfewf title"
       */
      title?: string;
      /**
       * "fwefwefwe"
       */
      content?: string;
      /**
       * "this is a target"
       */
      target?: string;
      /**
       * "this is a reward"
       */
      reward?: string;
      /**
       * 1595820587069
       */
      startTime?: number;
      /**
       * 1598498987000
       */
      endTime?: number;
    }[];
    /**
     * 1
     */
    categoryType?: number;
  }[];
}

/**
 * 接口 [get-获取作家主页-485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175536) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-author-page`
 * @更新时间 `2021-06-23 14:34:15`
 */
type GoPcmUserGetAuthorPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/get-author-page",
    "data",
    string,
    "userId" | "appId",
    false
  >
>;

/**
 * 接口 [get-获取作家主页-485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175536) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-author-page`
 * @更新时间 `2021-06-23 14:34:15`
 */
const goPcmUserGetAuthorPageRequestConfig: GoPcmUserGetAuthorPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/get-author-page",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: ["userId", "appId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetAuthorPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-获取作家主页-485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175536) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-author-page`
 * @更新时间 `2021-06-23 14:34:15`
 */
export const goPcmUserGetAuthorPage = /*#__PURE__*/ (
  requestData: GoPcmUserGetAuthorPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetAuthorPageResponse>(
    prepare(goPcmUserGetAuthorPageRequestConfig, requestData),
    ...args
  );
};

goPcmUserGetAuthorPage.requestConfig = goPcmUserGetAuthorPageRequestConfig;

/**
 * 接口 [like - 个人主页点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175541) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/like`
 * @更新时间 `2020-12-02 19:36:36`
 */
export interface GoPcmUserLikeRequest {
  userId: FileData;
  /**
   * 1：点赞 0：取消点赞
   */
  supportOp: string;
}

/**
 * 接口 [like - 个人主页点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175541) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/like`
 * @更新时间 `2020-12-02 19:36:36`
 */
export type GoPcmUserLikeResponse = null;

/**
 * 接口 [like - 个人主页点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175541) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/like`
 * @更新时间 `2020-12-02 19:36:36`
 */
type GoPcmUserLikeRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/like",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [like - 个人主页点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175541) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/like`
 * @更新时间 `2020-12-02 19:36:36`
 */
const goPcmUserLikeRequestConfig: GoPcmUserLikeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/go/pcm/user/like",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "goPcmUserLike",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [like - 个人主页点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175541) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/like`
 * @更新时间 `2020-12-02 19:36:36`
 */
export const goPcmUserLike = /*#__PURE__*/ (
  requestData: GoPcmUserLikeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserLikeResponse>(
    prepare(goPcmUserLikeRequestConfig, requestData),
    ...args
  );
};

goPcmUserLike.requestConfig = goPcmUserLikeRequestConfig;

/**
 * 接口 [set-background-image设置背景图↗](https://yapi.yuewen.com/project/2309/interface/api/175543) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/set-background-image`
 * @更新时间 `2020-12-02 19:36:36`
 */
export interface GoPcmUserSetBackgroundImageRequest {
  pic: FileData;
  userId: string;
  appId: string;
}

/**
 * 接口 [set-background-image设置背景图↗](https://yapi.yuewen.com/project/2309/interface/api/175543) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/set-background-image`
 * @更新时间 `2020-12-02 19:36:36`
 */
export type GoPcmUserSetBackgroundImageResponse = null;

/**
 * 接口 [set-background-image设置背景图↗](https://yapi.yuewen.com/project/2309/interface/api/175543) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/set-background-image`
 * @更新时间 `2020-12-02 19:36:36`
 */
type GoPcmUserSetBackgroundImageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/set-background-image",
    "data",
    string,
    "userId" | "appId",
    false
  >
>;

/**
 * 接口 [set-background-image设置背景图↗](https://yapi.yuewen.com/project/2309/interface/api/175543) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/set-background-image`
 * @更新时间 `2020-12-02 19:36:36`
 */
const goPcmUserSetBackgroundImageRequestConfig: GoPcmUserSetBackgroundImageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/set-background-image",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: ["userId", "appId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserSetBackgroundImage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [set-background-image设置背景图↗](https://yapi.yuewen.com/project/2309/interface/api/175543) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/set-background-image`
 * @更新时间 `2020-12-02 19:36:36`
 */
export const goPcmUserSetBackgroundImage = /*#__PURE__*/ (
  requestData: GoPcmUserSetBackgroundImageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserSetBackgroundImageResponse>(
    prepare(goPcmUserSetBackgroundImageRequestConfig, requestData),
    ...args
  );
};

goPcmUserSetBackgroundImage.requestConfig =
  goPcmUserSetBackgroundImageRequestConfig;

/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/2309/interface/api/175551) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2021-04-01 14:07:36`
 */
export interface GoPcmUserGetFirstCharge2Request {}

/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/2309/interface/api/175551) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2021-04-01 14:07:36`
 */
export interface GoPcmUserGetFirstCharge2Response {
  /**
   * 2
   */
  giftsBubbleStatus?: number;
  /**
   * 1
   */
  awardStatus?: number;
  /**
   * [{"awardType":[7],"name":"@string","desc":"@string","amount":0,"id":"@id","updateTime":"@timestamp","bookInfo":{"novelType":[0,100],"bookId":"116236514531205","bookName":"@string","bookCoverId":"@id"},"badgeBaseUrl":"@url","propBaseUrl":"@url"}]
   */
  awards?: {
    /**
     * [7]
     */
    awardType?: number[];
    /**
     * "@string"
     */
    name?: string;
    /**
     * "@string"
     */
    desc?: string;
    amount?: number;
    /**
     * "@id"
     */
    id?: string;
    /**
     * "@timestamp"
     */
    updateTime?: string;
    bookInfo?: {
      /**
       * [0,100]
       */
      novelType?: number[];
      /**
       * "116236514531205"
       */
      bookId?: string;
      /**
       * "@string"
       */
      bookName?: string;
      /**
       * "@id"
       */
      bookCoverId?: string;
    };
    /**
     * "@url"
     */
    badgeBaseUrl?: string;
    /**
     * "@url"
     */
    propBaseUrl?: string;
  }[];
}

/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/2309/interface/api/175551) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2021-04-01 14:07:36`
 */
type GoPcmUserGetFirstCharge2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/get-first-charge",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/2309/interface/api/175551) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2021-04-01 14:07:36`
 */
const goPcmUserGetFirstCharge2RequestConfig: GoPcmUserGetFirstCharge2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/get-first-charge",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetFirstCharge2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/2309/interface/api/175551) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2021-04-01 14:07:36`
 */
export const goPcmUserGetFirstCharge2 = /*#__PURE__*/ (
  requestData?: GoPcmUserGetFirstCharge2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetFirstCharge2Response>(
    prepare(goPcmUserGetFirstCharge2RequestConfig, requestData),
    ...args
  );
};

goPcmUserGetFirstCharge2.requestConfig = goPcmUserGetFirstCharge2RequestConfig;

/**
 * 接口 [获取用户主页（主客态）485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175556) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2021-06-23 14:58:29`
 */
export interface GoPcmUserGetHomePage2Request {
  userId: string;
  appId: string;
}

/**
 * 接口 [获取用户主页（主客态）485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175556) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2021-06-23 14:58:29`
 */
export interface GoPcmUserGetHomePage2Response {
  baseInfo?: {
    /**
     * 4301351686
     */
    userId?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1601989613695
     */
    backGroundImageId?: number;
    /**
     * 1602430937351
     */
    headImageId?: number;
    /**
     * "JKSManga"
     */
    realName?: string;
    /**
     * "1"
     */
    gender?: string;
    /**
     * 4
     */
    level?: number;
    /**
     * 1533939651000
     */
    joinTime?: number;
    /**
     * "United Kingdom"
     */
    countryName?: string;
    /**
     * 89
     */
    writingDays?: number;
    /**
     * 63996
     */
    readingTime?: number;
    /**
     * 142
     */
    readBookNum?: number;
    /**
     * 1
     */
    isAuthor?: number;
    isLiked?: number;
    /**
     * 1320
     */
    likeNum?: number;
    isSelf?: number;
    /**
     * "Patreon:jksmanga\ninstagram:jksmanga\nI am a happy guy :)"
     */
    description?: string;
  };
  badgeInfo?: {
    /**
     * 11
     */
    holdBadgeNum?: number;
    /**
     * [{"badgeId":10001,"coverImgUrl":"https://actimg.webnovel.com/badge/10001/2/","coverUpdatedTime":1517481162000},{"badgeId":10002,"coverImgUrl":"https://actimg.webnovel.com/badge/10002/1/","coverUpdatedTime":1517481162000},{"badgeId":10003,"coverImgUrl":"https://actimg.webnovel.com/badge/10003/1/","coverUpdatedTime":1517481162000},{"badgeId":10006,"coverImgUrl":"https://actimg.webnovel.com/badge/10006/1/","coverUpdatedTime":1517481162000},{"badgeId":10007,"coverImgUrl":"https://actimg.webnovel.com/badge/10007/2/","coverUpdatedTime":1517481162000},{"badgeId":10008,"coverImgUrl":"https://actimg.webnovel.com/badge/10008/4/","coverUpdatedTime":1523334037000},{"badgeId":10039,"coverImgUrl":"https://actimg.webnovel.com/badge/10039/1/","coverUpdatedTime":1587005050000},{"badgeId":10046,"coverImgUrl":"https://actimg.webnovel.com/badge/10046/2/","coverUpdatedTime":1591007735000},{"badgeId":10060,"coverImgUrl":"https://actimg.webnovel.com/badge/10060/1/","coverUpdatedTime":1602313368000},{"badgeId":10061,"coverImgUrl":"https://actimg.webnovel.com/badge/10061/1/","coverUpdatedTime":1602313579000},{"badgeId":10086,"coverImgUrl":"https://actimg.webnovel.com/badge/10086/4/","coverUpdatedTime":1622718024000}]
     */
    badgeItems?: {
      /**
       * 10001
       */
      badgeId?: number;
      /**
       * "https://actimg.webnovel.com/badge/10001/2/"
       */
      coverImgUrl?: string;
      /**
       * 1517481162000
       */
      coverUpdatedTime?: number;
    }[];
  };
  readListInfo?: null;
  momentsInfo?: {
    /**
     * 830
     */
    momentsNum?: number;
    /**
     * [{"id":"272208043708710912","momentType":2,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":"54618500592891558","chapterIndex":933,"chapterName":"SIDE STORY (MVS EVENT WINNER) QUINN","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20347071405174100","replyId":"20347142406658700","bookReviewScore":0,"replyToUserName":"Saljon","createTime":1623513024000,"content":"I do agree, Leo, or the other characters would have been interesting, because you can explore diffrent area, have already learnt so much about Quinn.","imageItems":null},{"id":"271378017249591296","momentType":1,"bookInfo":{"bookId":"20205773605017905","bookType":0,"bookCoverId":1622099473167,"bookName":"First love leap To the future and back","categoryId":70014,"categoryName":"Contemporary Romance","authorName":"Justkeepsmiling"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":1,"reviewId":"20327352805639400","replyId":0,"bookReviewScore":5,"replyToUserName":"","createTime":1623315129000,"content":"A story that is set up like a typical love story but is disguised as something much more. The story feels alive and I can relate to the charecters a lot","imageItems":null},{"id":"270709464838111232","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20302750405371400","replyId":"20311413306975200","bookReviewScore":0,"replyToUserName":"ColorBeast","createTime":1623155734000,"content":"fake accounts don't buy chapters, hence why my sales have tripled, it's not small money either. I know you don't like the story that's cool I mean there are a lot of popular stories I don't like.\n\njust letting you know the facts.\nsold 1.5 million chapters last month \nsells 50 thosand chapters a day.\nHighest selling work on webnovel including translated works","imageItems":null},{"id":"270356747796152320","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20302750405371400","replyId":"20303004006862600","bookReviewScore":0,"replyToUserName":"ColorBeast","createTime":1623071640000,"content":"Sales and views have tripled for the last two months, its because web novel invested in the my vampire system event, and also have sponsored yotubers with 3 million subscribers to go read my vampire system. There is a big influx of new readers to web novel just for my vampire system. Just to let you know, There are also multiple webcomic trailers and live action trailers that are being posted all over, and new articles with new York times and more.\n\nWebnovel have invested a million dollars worth in MVS in advertisement. Hope you have a good day :)","imageItems":null},{"id":"268341814078275584","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"16709856605943300","replyId":"20254964205117200","bookReviewScore":0,"replyToUserName":"Daoistge5gma","createTime":1622591243000,"content":"yes of course normal readers get chapters as well you are just 15 behind, I update three a day and the three new ones push out three old ones to others","imageItems":null},{"id":"268002790322929664","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20243705306008400","replyId":"20246880906489200","bookReviewScore":0,"replyToUserName":"Allen_Ross","createTime":1622510409000,"content":"it's set by the app, so I guess whoever makes the app.\n\nAs authors we are in charge of how much we charge for priv, which is why mine is cheaper then others, and how many chapters go into each tier but the whole system is already set up","imageItems":null},{"id":"267966429616472064","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20243705306008400","replyId":"20246014505918200","bookReviewScore":0,"replyToUserName":"Allen_Ross","createTime":1622501745000,"content":"Hi there, I'm not in charge or the privlidge system. thank you so much for supporting me like you have been doing, everything is automatic on my end same as patreon.\n\nthere is a large date that states when your prov will run out when you but it, but I hundred percent agree it should be 30 days when you buy it, some people can only buy prov when they get paid if that is the 15th then that means they can only get priv for 15days every month which makes 0 sense. or if webnovel insist on doing it monthly they should base the cost on how many days are left, making it less the closer it is to the end of the month.\n\nthis is actulley why I keep my priv low and don't set it at 1500 or 2000 which is the normal cost for priv. thank you for supporting me","imageItems":null},{"id":"267873666849767424","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20243705306008400","replyId":"20243802605562000","bookReviewScore":0,"replyToUserName":"DaoisthGQsiR","createTime":1622479627000,"content":"If you purchased privlidge before it priv gets you 15 chapters ahead, or whatever tier you purchased it runs out at the end of the month like patreon. So if you decide to not purchase it a second mo th you will be 15 chapters behind.\n\nit works like patreon so to stay 15 chapters ahead of everyone you have to purchase every mo th, but you won't get 15 extra chapters like you did the first time because it's already ahead.\n\nsorry if there is any confusion","imageItems":null},{"id":"266991172516642816","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20222101705782900","replyId":"20222762205862700","bookReviewScore":0,"replyToUserName":"SeinCrude","createTime":1622269222000,"content":"Um,, can you please elaborate please?","imageItems":null},{"id":"266634924495405056","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20214229805787000","replyId":"20214268405790800","bookReviewScore":0,"replyToUserName":"Alina290","createTime":1622184284000,"content":"love the vampire dab","imageItems":null},{"id":"266634818992013312","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20214065306265700","replyId":"20214266306285200","bookReviewScore":0,"replyToUserName":"Yasuo","createTime":1622184263000,"content":"if you ought a little bit further you will see now in the latest chapters Peter is one of people's favorite charecters, and when it finishes with school it's no longer about him.\n\nbut I'm happy you gave it a try","imageItems":null},{"id":"266542122780524544","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20210052405297500","replyId":"20212056206041600","bookReviewScore":0,"replyToUserName":"Innocent_Valley","createTime":1622162163000,"content":"yes I'm from the uk, I'm just typing on my phone and don't care about typos. you should reread the first chapters. they have been edited by top professional editors who work on traditional books.\n\nI don't know how long ago you read this story and this was updated in the last month or so, although latest chapters still have a lot of typos, and I do frequently misspell. I was never a good speller, so I rely on my editors to try catch most of the mistakes but they still let them slip through","imageItems":null},{"id":"266541441034158080","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20210052405297500","replyId":"20212039905539200","bookReviewScore":0,"replyToUserName":"Innocent_Valley","createTime":1622162000000,"content":"yes you were the one harrsiing me by coming on this story posting the same one star review.\n\nI think you have the world backwards my friend, good luck to you. you will need it in life","imageItems":null},{"id":"266541133201735680","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20210052405297500","replyId":"20212032506039500","bookReviewScore":0,"replyToUserName":"Innocent_Valley","createTime":1622161925000,"content":"the app is strange I can't even see your reply now apart now apart in my inbox thing. not once have I claimed to be a good writer, I said let people enjoy what they want to enjoy.\n\nhey of this is your life goal to hate on people doing well then as I said before and many times me and many people in the world feel sorry for you.\n\nI hope you find something more fuflling in your life then gathering your friends to spam one star reviews on a book lol.\n\nI feel very said, maybe you should put this much energy into helping out your friends and family only saying the truth. honestly you could do all lot with how much effort your putting into this","imageItems":null},{"id":"266539832770363392","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20210052405297500","replyId":"20212001706036400","bookReviewScore":0,"replyToUserName":"Innocent_Valley","createTime":1622161618000,"content":"BTW I am going to delete the ones we're I talked about income because I'm not meant to, and I think this thing got way out of hand.\n\nmy point at the end of the day is you should carry on reading what you enjoy reading on the site, and I carry on writing what I enjoy writing.\n\nwrite your one review and move on","imageItems":null},{"id":"266538852406198272","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20210052405297500","replyId":"20211978106032900","bookReviewScore":0,"replyToUserName":"Innocent_Valley","createTime":1622161382000,"content":"look it's literally above the one where you said I deleted it?","imageItems":[{"imageUrl":"https://cos4reviewpic-1253177085.picca.myqcloud.com/43888211622161362upload_1622161354043.jpg","width":576,"height":1280}]},{"id":"266538625116864512","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20210052405297500","replyId":"20211972905532100","bookReviewScore":0,"replyToUserName":"Innocent_Valley","createTime":1622161329000,"content":"I didn't I just showed I didn't I took a screen shot form my phone still showing the reply is there","imageItems":null},{"id":"266538055757004800","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20210052405297500","replyId":"20211959405529200","bookReviewScore":0,"replyToUserName":"Innocent_Valley","createTime":1622161194000,"content":"look it's still up on my end? now I'm starting to think there is something wrong with your app","imageItems":[{"imageUrl":"https://cos4reviewpic-1253177085.picca.myqcloud.com/43888211622161174upload_1622161164902.jpg","width":576,"height":1280}]},{"id":"266537852459089920","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20210052405297500","replyId":"20211954005528800","bookReviewScore":0,"replyToUserName":"Innocent_Valley","createTime":1622161140000,"content":"again never deleted a reply seriously I'm starting to think your crazy","imageItems":null},{"id":"266526303283511296","momentType":1,"bookInfo":{"bookId":"16709365405930105","bookType":0,"bookCoverId":1596687896010,"bookName":"My Vampire System","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga"},"chapterId":0,"chapterIndex":0,"chapterName":"","paragraphId":"","paragraphContent":"","reviewType":2,"reviewId":"20210052405297500","replyId":"20211678705498400","bookReviewScore":0,"replyToUserName":"Innocent_Valley","createTime":1622158388000,"content":"see I can read your reply but it doesn't show up because of the negative language you used, might be the same with the review and you should check all your reviews are there.\n\nyou seem like a very angry person that's taking your anger out on a writer you don't even know. if you don't like it leave one review and move on.\n\nyou keep seeing it because it's popular. I hope you get the help you needed and hope you aren't this angry of a person in real life. otherwise I feel sorry for all your family and friends I hope they have a blessed day","imageItems":null}]
     */
    momentsItems?: {
      /**
       * "272208043708710912"
       */
      id?: string;
      /**
       * 2
       */
      momentType?: number;
      bookInfo?: {
        /**
         * "16709365405930105"
         */
        bookId?: string;
        bookType?: number;
        /**
         * 1596687896010
         */
        bookCoverId?: number;
        /**
         * "My Vampire System"
         */
        bookName?: string;
        /**
         * 70002
         */
        categoryId?: number;
        /**
         * "Fantasy"
         */
        categoryName?: string;
        /**
         * "JKSManga"
         */
        authorName?: string;
      };
      /**
       * "54618500592891558"
       */
      chapterId?: string;
      /**
       * 933
       */
      chapterIndex?: number;
      /**
       * "SIDE STORY (MVS EVENT WINNER) QUINN"
       */
      chapterName?: string;
      paragraphId?: string;
      paragraphContent?: string;
      /**
       * 2
       */
      reviewType?: number;
      /**
       * "20347071405174100"
       */
      reviewId?: string;
      /**
       * "20347142406658700"
       */
      replyId?: string;
      bookReviewScore?: number;
      /**
       * "Saljon"
       */
      replyToUserName?: string;
      /**
       * 1623513024000
       */
      createTime?: number;
      /**
       * "I do agree, Leo, or the other characters would have been interesting, because you can explore diffrent area, have already learnt so much about Quinn."
       */
      content?: string;
      imageItems?: null;
    }[];
  };
  /**
   * [{"bookId":131412,"bookType":0,"bookName":"@string","bookCoverId":0,"bookTag":"this is amazing","totalChapterNum":131,"collectionNum":22,"categoryName":"High Fantasy","tagItem":{"isHot":0,"isRecent":0,"isCompleted":0},"anouncementItems":[{"id":"@string","msgType":1,"title":"fwfewf title","content":"fwefwefwe","target":"this is a target","reward":"this is a reward","startTime":1595820587069,"endTime":1598498987000}],"categoryType":1}]
   */
  bookListItems?: {
    /**
     * 131412
     */
    bookId?: number;
    bookType?: number;
    /**
     * "@string"
     */
    bookName?: string;
    bookCoverId?: number;
    /**
     * "this is amazing"
     */
    bookTag?: string;
    /**
     * 131
     */
    totalChapterNum?: number;
    /**
     * 22
     */
    collectionNum?: number;
    /**
     * "High Fantasy"
     */
    categoryName?: string;
    tagItem?: {
      isHot?: number;
      isRecent?: number;
      isCompleted?: number;
    };
    /**
     * [{"id":"@string","msgType":1,"title":"fwfewf title","content":"fwefwefwe","target":"this is a target","reward":"this is a reward","startTime":1595820587069,"endTime":1598498987000}]
     */
    anouncementItems?: {
      /**
       * "@string"
       */
      id?: string;
      /**
       * 1
       */
      msgType?: number;
      /**
       * "fwfewf title"
       */
      title?: string;
      /**
       * "fwefwefwe"
       */
      content?: string;
      /**
       * "this is a target"
       */
      target?: string;
      /**
       * "this is a reward"
       */
      reward?: string;
      /**
       * 1595820587069
       */
      startTime?: number;
      /**
       * 1598498987000
       */
      endTime?: number;
    }[];
    /**
     * 1
     */
    categoryType?: number;
  }[];
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4315108321/1/1.jpg?mt=1612836300507"
     */
    avatar?: string;
    /**
     * "peter_lu11111"
     */
    nickName?: string;
    /**
     * "peter_lu11111"
     */
    userName?: string;
    /**
     * "peter_lu11111"
     */
    authorName?: string;
    /**
     * "peter_lu11111"
     */
    penName?: string;
    /**
     * 4315108321
     */
    guid?: number;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * 2
     */
    gender?: number;
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    expiringTime?: number;
    /**
     * 1
     */
    grade?: number;
    /**
     * 1
     */
    ES?: number;
    /**
     * 1
     */
    totalES?: number;
    /**
     * 1
     */
    PS?: number;
    /**
     * 1
     */
    totalPS?: number;
    /**
     * "402374739@qq.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: number;
    /**
     * 1612836300507
     */
    UUT?: number;
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    membershipStatus?: number;
    membershipExpireTime?: number;
    membershipClaimStatus?: boolean;
    membershipIsFree?: boolean;
    membershipType?: number;
  };
}

/**
 * 接口 [获取用户主页（主客态）485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175556) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2021-06-23 14:58:29`
 */
type GoPcmUserGetHomePage2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/get-home-page",
    "data",
    string,
    "userId" | "appId",
    false
  >
>;

/**
 * 接口 [获取用户主页（主客态）485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175556) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2021-06-23 14:58:29`
 */
const goPcmUserGetHomePage2RequestConfig: GoPcmUserGetHomePage2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/get-home-page",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: ["userId", "appId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetHomePage2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取用户主页（主客态）485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175556) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2021-06-23 14:58:29`
 */
export const goPcmUserGetHomePage2 = /*#__PURE__*/ (
  requestData: GoPcmUserGetHomePage2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetHomePage2Response>(
    prepare(goPcmUserGetHomePage2RequestConfig, requestData),
    ...args
  );
};

goPcmUserGetHomePage2.requestConfig = goPcmUserGetHomePage2RequestConfig;

/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/177867) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoAjax`
 * @更新时间 `2021-06-03 10:12:40`
 */
export interface GoPcmUserUserInfoAjaxRequest {}

/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/177867) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoAjax`
 * @更新时间 `2021-06-03 10:12:40`
 */
export interface GoPcmUserUserInfoAjaxResponse {
  profile?: {
    /**
     * "proident"
     */
    userLevel?: string;
    /**
     * "Excepteur tempor id eiusmod Lorem"
     */
    avatar?: string;
    /**
     * 87231286.6940279
     */
    toExpiredAfter?: number;
    /**
     * "pariatur proident"
     */
    guid?: string;
    /**
     * "non tempor mollit do dolore"
     */
    nickName?: string;
    /**
     * 20051306.92610839
     */
    status?: number;
    /**
     * 83095825.43552381
     */
    membershipQua?: number;
    /**
     * 90766019.32422438
     */
    membershipStatus?: number;
    /**
     * 472132
     */
    membershipType?: number;
    /**
     * 19872468.22667706
     */
    membershipExpireTime?: number;
    /**
     * 35814716.05256769
     */
    isCheckin?: number;
    /**
     * "amet cupidatat et"
     */
    userName?: string;
    /**
     * "sunt occaecat sed amet in"
     */
    role?: string;
    /**
     * 40340047.71154663
     */
    toExpiredSS?: number;
    /**
     * 12836161.06200172
     */
    availablePower?: number;
    /**
     * "deserunt"
     */
    penName?: string;
    /**
     * -68683024.84588309
     */
    UUT?: number;
    /**
     * 11421256.079487205
     */
    availableEnergy?: number;
    /**
     * 87247143.51768652
     */
    SS?: number;
  };
}

/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/177867) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoAjax`
 * @更新时间 `2021-06-03 10:12:40`
 */
type GoPcmUserUserInfoAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/userInfoAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/177867) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoAjax`
 * @更新时间 `2021-06-03 10:12:40`
 */
const goPcmUserUserInfoAjaxRequestConfig: GoPcmUserUserInfoAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/userInfoAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserUserInfoAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/177867) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoAjax`
 * @更新时间 `2021-06-03 10:12:40`
 */
export const goPcmUserUserInfoAjax = /*#__PURE__*/ (
  requestData?: GoPcmUserUserInfoAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserUserInfoAjaxResponse>(
    prepare(goPcmUserUserInfoAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmUserUserInfoAjax.requestConfig = goPcmUserUserInfoAjaxRequestConfig;

/**
 * 接口 [设置用户头像【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178321) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserAvatar`
 * @更新时间 `2020-12-14 20:06:39`
 */
export interface GoPcmUserSetUserAvatarRequest {}

/**
 * 接口 [设置用户头像【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178321) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserAvatar`
 * @更新时间 `2020-12-14 20:06:39`
 */
export interface GoPcmUserSetUserAvatarResponse {}

/**
 * 接口 [设置用户头像【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178321) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserAvatar`
 * @更新时间 `2020-12-14 20:06:39`
 */
type GoPcmUserSetUserAvatarRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/setUserAvatar",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [设置用户头像【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178321) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserAvatar`
 * @更新时间 `2020-12-14 20:06:39`
 */
const goPcmUserSetUserAvatarRequestConfig: GoPcmUserSetUserAvatarRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/setUserAvatar",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserSetUserAvatar",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [设置用户头像【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178321) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserAvatar`
 * @更新时间 `2020-12-14 20:06:39`
 */
export const goPcmUserSetUserAvatar = /*#__PURE__*/ (
  requestData?: GoPcmUserSetUserAvatarRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserSetUserAvatarResponse>(
    prepare(goPcmUserSetUserAvatarRequestConfig, requestData),
    ...args
  );
};

goPcmUserSetUserAvatar.requestConfig = goPcmUserSetUserAvatarRequestConfig;

/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178529) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoReact`
 * @更新时间 `2020-12-14 20:06:34`
 */
export interface GoPcmUserUserInfoReactRequest {}

/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178529) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoReact`
 * @更新时间 `2020-12-14 20:06:34`
 */
export interface GoPcmUserUserInfoReactResponse {}

/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178529) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoReact`
 * @更新时间 `2020-12-14 20:06:34`
 */
type GoPcmUserUserInfoReactRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/userInfoReact",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178529) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoReact`
 * @更新时间 `2020-12-14 20:06:34`
 */
const goPcmUserUserInfoReactRequestConfig: GoPcmUserUserInfoReactRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/userInfoReact",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserUserInfoReact",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178529) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoReact`
 * @更新时间 `2020-12-14 20:06:34`
 */
export const goPcmUserUserInfoReact = /*#__PURE__*/ (
  requestData?: GoPcmUserUserInfoReactRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserUserInfoReactResponse>(
    prepare(goPcmUserUserInfoReactRequestConfig, requestData),
    ...args
  );
};

goPcmUserUserInfoReact.requestConfig = goPcmUserUserInfoReactRequestConfig;

/**
 * 接口 [校验邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179048) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserEmail`
 * @更新时间 `2020-12-22 13:54:27`
 */
export interface GoPcmUserCheckUserEmailRequest {
  email: string;
}

/**
 * 接口 [校验邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179048) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserEmail`
 * @更新时间 `2020-12-22 13:54:27`
 */
export interface GoPcmUserCheckUserEmailResponse {}

/**
 * 接口 [校验邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179048) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserEmail`
 * @更新时间 `2020-12-22 13:54:27`
 */
type GoPcmUserCheckUserEmailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/checkUserEmail",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [校验邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179048) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserEmail`
 * @更新时间 `2020-12-22 13:54:27`
 */
const goPcmUserCheckUserEmailRequestConfig: GoPcmUserCheckUserEmailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/checkUserEmail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserCheckUserEmail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [校验邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179048) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserEmail`
 * @更新时间 `2020-12-22 13:54:27`
 */
export const goPcmUserCheckUserEmail = /*#__PURE__*/ (
  requestData: GoPcmUserCheckUserEmailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserCheckUserEmailResponse>(
    prepare(goPcmUserCheckUserEmailRequestConfig, requestData),
    ...args
  );
};

goPcmUserCheckUserEmail.requestConfig = goPcmUserCheckUserEmailRequestConfig;

/**
 * 接口 [检测用户名【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179053) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserName`
 * @更新时间 `2020-12-09 21:36:07`
 */
export interface GoPcmUserCheckUserNameRequest {}

/**
 * 接口 [检测用户名【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179053) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserName`
 * @更新时间 `2020-12-09 21:36:07`
 */
export interface GoPcmUserCheckUserNameResponse {}

/**
 * 接口 [检测用户名【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179053) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserName`
 * @更新时间 `2020-12-09 21:36:07`
 */
type GoPcmUserCheckUserNameRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/checkUserName",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [检测用户名【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179053) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserName`
 * @更新时间 `2020-12-09 21:36:07`
 */
const goPcmUserCheckUserNameRequestConfig: GoPcmUserCheckUserNameRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/checkUserName",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserCheckUserName",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [检测用户名【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179053) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserName`
 * @更新时间 `2020-12-09 21:36:07`
 */
export const goPcmUserCheckUserName = /*#__PURE__*/ (
  requestData?: GoPcmUserCheckUserNameRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserCheckUserNameResponse>(
    prepare(goPcmUserCheckUserNameRequestConfig, requestData),
    ...args
  );
};

goPcmUserCheckUserName.requestConfig = goPcmUserCheckUserNameRequestConfig;

/**
 * 接口 [绑定邮箱发送验证码【PC&&M】↗](https://yapi.yuewen.com/project/2309/interface/api/179063) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/FirstAddEmail`
 * @更新时间 `2020-12-14 20:04:56`
 */
export interface GoPcmUserFirstAddEmailRequest {}

/**
 * 接口 [绑定邮箱发送验证码【PC&&M】↗](https://yapi.yuewen.com/project/2309/interface/api/179063) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/FirstAddEmail`
 * @更新时间 `2020-12-14 20:04:56`
 */
export interface GoPcmUserFirstAddEmailResponse {}

/**
 * 接口 [绑定邮箱发送验证码【PC&&M】↗](https://yapi.yuewen.com/project/2309/interface/api/179063) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/FirstAddEmail`
 * @更新时间 `2020-12-14 20:04:56`
 */
type GoPcmUserFirstAddEmailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/FirstAddEmail",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [绑定邮箱发送验证码【PC&&M】↗](https://yapi.yuewen.com/project/2309/interface/api/179063) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/FirstAddEmail`
 * @更新时间 `2020-12-14 20:04:56`
 */
const goPcmUserFirstAddEmailRequestConfig: GoPcmUserFirstAddEmailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/FirstAddEmail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserFirstAddEmail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [绑定邮箱发送验证码【PC&&M】↗](https://yapi.yuewen.com/project/2309/interface/api/179063) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/FirstAddEmail`
 * @更新时间 `2020-12-14 20:04:56`
 */
export const goPcmUserFirstAddEmail = /*#__PURE__*/ (
  requestData?: GoPcmUserFirstAddEmailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserFirstAddEmailResponse>(
    prepare(goPcmUserFirstAddEmailRequestConfig, requestData),
    ...args
  );
};

goPcmUserFirstAddEmail.requestConfig = goPcmUserFirstAddEmailRequestConfig;

/**
 * 接口 [用户等级页,需要登陆态【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179243) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getPage`
 * @更新时间 `2020-12-14 20:05:14`
 */
export interface GoPcmUserGetPageRequest {}

/**
 * 接口 [用户等级页,需要登陆态【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179243) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getPage`
 * @更新时间 `2020-12-14 20:05:14`
 */
export interface GoPcmUserGetPageResponse {}

/**
 * 接口 [用户等级页,需要登陆态【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179243) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getPage`
 * @更新时间 `2020-12-14 20:05:14`
 */
type GoPcmUserGetPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/getPage",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [用户等级页,需要登陆态【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179243) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getPage`
 * @更新时间 `2020-12-14 20:05:14`
 */
const goPcmUserGetPageRequestConfig: GoPcmUserGetPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/getPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [用户等级页,需要登陆态【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179243) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getPage`
 * @更新时间 `2020-12-14 20:05:14`
 */
export const goPcmUserGetPage = /*#__PURE__*/ (
  requestData?: GoPcmUserGetPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetPageResponse>(
    prepare(goPcmUserGetPageRequestConfig, requestData),
    ...args
  );
};

goPcmUserGetPage.requestConfig = goPcmUserGetPageRequestConfig;

/**
 * 接口 [获取用户设置页面数据【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179267) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserSettings`
 * @更新时间 `2020-12-22 16:58:21`
 */
export interface GoPcmUserGetUserSettingsRequest {}

/**
 * 接口 [获取用户设置页面数据【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179267) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserSettings`
 * @更新时间 `2020-12-22 16:58:21`
 */
export interface GoPcmUserGetUserSettingsResponse {}

/**
 * 接口 [获取用户设置页面数据【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179267) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserSettings`
 * @更新时间 `2020-12-22 16:58:21`
 */
type GoPcmUserGetUserSettingsRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/getUserSettings",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取用户设置页面数据【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179267) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserSettings`
 * @更新时间 `2020-12-22 16:58:21`
 */
const goPcmUserGetUserSettingsRequestConfig: GoPcmUserGetUserSettingsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/getUserSettings",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetUserSettings",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取用户设置页面数据【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179267) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserSettings`
 * @更新时间 `2020-12-22 16:58:21`
 */
export const goPcmUserGetUserSettings = /*#__PURE__*/ (
  requestData?: GoPcmUserGetUserSettingsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetUserSettingsResponse>(
    prepare(goPcmUserGetUserSettingsRequestConfig, requestData),
    ...args
  );
};

goPcmUserGetUserSettings.requestConfig = goPcmUserGetUserSettingsRequestConfig;

/**
 * 接口 [确认修改邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179437) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/modifyEmail`
 * @更新时间 `2020-12-23 10:57:19`
 */
export interface GoPcmUserModifyEmailRequest {
  email: string;
  token: string;
  verifyCodestring: string;
}

/**
 * 接口 [确认修改邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179437) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/modifyEmail`
 * @更新时间 `2020-12-23 10:57:19`
 */
export interface GoPcmUserModifyEmailResponse {}

/**
 * 接口 [确认修改邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179437) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/modifyEmail`
 * @更新时间 `2020-12-23 10:57:19`
 */
type GoPcmUserModifyEmailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/modifyEmail",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [确认修改邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179437) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/modifyEmail`
 * @更新时间 `2020-12-23 10:57:19`
 */
const goPcmUserModifyEmailRequestConfig: GoPcmUserModifyEmailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/modifyEmail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserModifyEmail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [确认修改邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179437) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/modifyEmail`
 * @更新时间 `2020-12-23 10:57:19`
 */
export const goPcmUserModifyEmail = /*#__PURE__*/ (
  requestData: GoPcmUserModifyEmailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserModifyEmailResponse>(
    prepare(goPcmUserModifyEmailRequestConfig, requestData),
    ...args
  );
};

goPcmUserModifyEmail.requestConfig = goPcmUserModifyEmailRequestConfig;

/**
 * 接口 [给新老邮箱发送验证码【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179518) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/sendCaptchaToEmail`
 * @更新时间 `2020-12-22 20:46:08`
 */
export interface GoPcmUserSendCaptchaToEmailRequest {
  emailType: string;
  email: string;
  token: string;
}

/**
 * 接口 [给新老邮箱发送验证码【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179518) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/sendCaptchaToEmail`
 * @更新时间 `2020-12-22 20:46:08`
 */
export interface GoPcmUserSendCaptchaToEmailResponse {}

/**
 * 接口 [给新老邮箱发送验证码【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179518) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/sendCaptchaToEmail`
 * @更新时间 `2020-12-22 20:46:08`
 */
type GoPcmUserSendCaptchaToEmailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/sendCaptchaToEmail",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [给新老邮箱发送验证码【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179518) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/sendCaptchaToEmail`
 * @更新时间 `2020-12-22 20:46:08`
 */
const goPcmUserSendCaptchaToEmailRequestConfig: GoPcmUserSendCaptchaToEmailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/sendCaptchaToEmail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserSendCaptchaToEmail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [给新老邮箱发送验证码【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179518) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/sendCaptchaToEmail`
 * @更新时间 `2020-12-22 20:46:08`
 */
export const goPcmUserSendCaptchaToEmail = /*#__PURE__*/ (
  requestData: GoPcmUserSendCaptchaToEmailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserSendCaptchaToEmailResponse>(
    prepare(goPcmUserSendCaptchaToEmailRequestConfig, requestData),
    ...args
  );
};

goPcmUserSendCaptchaToEmail.requestConfig =
  goPcmUserSendCaptchaToEmailRequestConfig;

/**
 * 接口 [更改个人设置【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179529) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserSettings`
 * @更新时间 `2020-12-23 11:11:15`
 */
export interface GoPcmUserSetUserSettingsRequest {
  name: string;
  gender: string;
  country: string;
  sign: string;
}

/**
 * 接口 [更改个人设置【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179529) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserSettings`
 * @更新时间 `2020-12-23 11:11:15`
 */
export interface GoPcmUserSetUserSettingsResponse {}

/**
 * 接口 [更改个人设置【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179529) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserSettings`
 * @更新时间 `2020-12-23 11:11:15`
 */
type GoPcmUserSetUserSettingsRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/setUserSettings",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [更改个人设置【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179529) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserSettings`
 * @更新时间 `2020-12-23 11:11:15`
 */
const goPcmUserSetUserSettingsRequestConfig: GoPcmUserSetUserSettingsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/setUserSettings",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserSetUserSettings",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [更改个人设置【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179529) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserSettings`
 * @更新时间 `2020-12-23 11:11:15`
 */
export const goPcmUserSetUserSettings = /*#__PURE__*/ (
  requestData: GoPcmUserSetUserSettingsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserSetUserSettingsResponse>(
    prepare(goPcmUserSetUserSettingsRequestConfig, requestData),
    ...args
  );
};

goPcmUserSetUserSettings.requestConfig = goPcmUserSetUserSettingsRequestConfig;

/**
 * 接口 [上传用户头像【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179550) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/go/pcm/user/uploadTmpAvatar`
 * @更新时间 `2020-12-14 20:09:59`
 */
export interface GoPcmGoPcmUserUploadTmpAvatarRequest {}

/**
 * 接口 [上传用户头像【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179550) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/go/pcm/user/uploadTmpAvatar`
 * @更新时间 `2020-12-14 20:09:59`
 */
export interface GoPcmGoPcmUserUploadTmpAvatarResponse {}

/**
 * 接口 [上传用户头像【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179550) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/go/pcm/user/uploadTmpAvatar`
 * @更新时间 `2020-12-14 20:09:59`
 */
type GoPcmGoPcmUserUploadTmpAvatarRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/go/pcm/user/uploadTmpAvatar",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [上传用户头像【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179550) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/go/pcm/user/uploadTmpAvatar`
 * @更新时间 `2020-12-14 20:09:59`
 */
const goPcmGoPcmUserUploadTmpAvatarRequestConfig: GoPcmGoPcmUserUploadTmpAvatarRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/go/pcm/user/uploadTmpAvatar",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGoPcmUserUploadTmpAvatar",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [上传用户头像【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179550) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/go/pcm/user/uploadTmpAvatar`
 * @更新时间 `2020-12-14 20:09:59`
 */
export const goPcmGoPcmUserUploadTmpAvatar = /*#__PURE__*/ (
  requestData?: GoPcmGoPcmUserUploadTmpAvatarRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmGoPcmUserUploadTmpAvatarResponse>(
    prepare(goPcmGoPcmUserUploadTmpAvatarRequestConfig, requestData),
    ...args
  );
};

goPcmGoPcmUserUploadTmpAvatar.requestConfig =
  goPcmGoPcmUserUploadTmpAvatarRequestConfig;

/**
 * 接口 [验证邮箱验证码↗](https://yapi.yuewen.com/project/2309/interface/api/179568) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/verifyCaptcha`
 * @更新时间 `2020-12-15 10:59:11`
 */
export interface GoPcmUserVerifyCaptchaRequest {}

/**
 * 接口 [验证邮箱验证码↗](https://yapi.yuewen.com/project/2309/interface/api/179568) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/verifyCaptcha`
 * @更新时间 `2020-12-15 10:59:11`
 */
export interface GoPcmUserVerifyCaptchaResponse {}

/**
 * 接口 [验证邮箱验证码↗](https://yapi.yuewen.com/project/2309/interface/api/179568) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/verifyCaptcha`
 * @更新时间 `2020-12-15 10:59:11`
 */
type GoPcmUserVerifyCaptchaRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/verifyCaptcha",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [验证邮箱验证码↗](https://yapi.yuewen.com/project/2309/interface/api/179568) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/verifyCaptcha`
 * @更新时间 `2020-12-15 10:59:11`
 */
const goPcmUserVerifyCaptchaRequestConfig: GoPcmUserVerifyCaptchaRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/verifyCaptcha",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserVerifyCaptcha",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [验证邮箱验证码↗](https://yapi.yuewen.com/project/2309/interface/api/179568) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/verifyCaptcha`
 * @更新时间 `2020-12-15 10:59:11`
 */
export const goPcmUserVerifyCaptcha = /*#__PURE__*/ (
  requestData?: GoPcmUserVerifyCaptchaRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserVerifyCaptchaResponse>(
    prepare(goPcmUserVerifyCaptchaRequestConfig, requestData),
    ...args
  );
};

goPcmUserVerifyCaptcha.requestConfig = goPcmUserVerifyCaptchaRequestConfig;

/**
 * 接口 [获取用户设置页面数据【M】↗](https://yapi.yuewen.com/project/2309/interface/api/179582) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserMSettings`
 * @更新时间 `2020-12-23 11:13:18`
 */
export interface GoPcmUserGetUserMSettingsRequest {}

/**
 * 接口 [获取用户设置页面数据【M】↗](https://yapi.yuewen.com/project/2309/interface/api/179582) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserMSettings`
 * @更新时间 `2020-12-23 11:13:18`
 */
export interface GoPcmUserGetUserMSettingsResponse {}

/**
 * 接口 [获取用户设置页面数据【M】↗](https://yapi.yuewen.com/project/2309/interface/api/179582) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserMSettings`
 * @更新时间 `2020-12-23 11:13:18`
 */
type GoPcmUserGetUserMSettingsRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/getUserMSettings",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取用户设置页面数据【M】↗](https://yapi.yuewen.com/project/2309/interface/api/179582) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserMSettings`
 * @更新时间 `2020-12-23 11:13:18`
 */
const goPcmUserGetUserMSettingsRequestConfig: GoPcmUserGetUserMSettingsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/getUserMSettings",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetUserMSettings",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取用户设置页面数据【M】↗](https://yapi.yuewen.com/project/2309/interface/api/179582) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserMSettings`
 * @更新时间 `2020-12-23 11:13:18`
 */
export const goPcmUserGetUserMSettings = /*#__PURE__*/ (
  requestData?: GoPcmUserGetUserMSettingsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetUserMSettingsResponse>(
    prepare(goPcmUserGetUserMSettingsRequestConfig, requestData),
    ...args
  );
};

goPcmUserGetUserMSettings.requestConfig =
  goPcmUserGetUserMSettingsRequestConfig;

/**
 * 接口 [举报↗](https://yapi.yuewen.com/project/2309/interface/api/197461) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/reportUserOrBook`
 * @更新时间 `2021-02-04 14:56:15`
 */
export interface GoPcmUserReportUserOrBookRequest {
  type?: string;
  reportId?: string;
  reportReason?: string;
  reportDesc?: string;
}

/**
 * 接口 [举报↗](https://yapi.yuewen.com/project/2309/interface/api/197461) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/reportUserOrBook`
 * @更新时间 `2021-02-04 14:56:15`
 */
export interface GoPcmUserReportUserOrBookResponse {}

/**
 * 接口 [举报↗](https://yapi.yuewen.com/project/2309/interface/api/197461) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/reportUserOrBook`
 * @更新时间 `2021-02-04 14:56:15`
 */
type GoPcmUserReportUserOrBookRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/reportUserOrBook",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [举报↗](https://yapi.yuewen.com/project/2309/interface/api/197461) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/reportUserOrBook`
 * @更新时间 `2021-02-04 14:56:15`
 */
const goPcmUserReportUserOrBookRequestConfig: GoPcmUserReportUserOrBookRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/reportUserOrBook",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserReportUserOrBook",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [举报↗](https://yapi.yuewen.com/project/2309/interface/api/197461) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/reportUserOrBook`
 * @更新时间 `2021-02-04 14:56:15`
 */
export const goPcmUserReportUserOrBook = /*#__PURE__*/ (
  requestData: GoPcmUserReportUserOrBookRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserReportUserOrBookResponse>(
    prepare(goPcmUserReportUserOrBookRequestConfig, requestData),
    ...args
  );
};

goPcmUserReportUserOrBook.requestConfig =
  goPcmUserReportUserOrBookRequestConfig;

/**
 * 接口 [拉取用户等级数据↗](https://yapi.yuewen.com/project/2309/interface/api/197928) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserLevel`
 * @更新时间 `2021-02-22 17:08:52`
 */
export interface GoPcmUserGetUserLevelRequest {}

/**
 * 接口 [拉取用户等级数据↗](https://yapi.yuewen.com/project/2309/interface/api/197928) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserLevel`
 * @更新时间 `2021-02-22 17:08:52`
 */
export interface GoPcmUserGetUserLevelResponse {}

/**
 * 接口 [拉取用户等级数据↗](https://yapi.yuewen.com/project/2309/interface/api/197928) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserLevel`
 * @更新时间 `2021-02-22 17:08:52`
 */
type GoPcmUserGetUserLevelRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/getUserLevel",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [拉取用户等级数据↗](https://yapi.yuewen.com/project/2309/interface/api/197928) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserLevel`
 * @更新时间 `2021-02-22 17:08:52`
 */
const goPcmUserGetUserLevelRequestConfig: GoPcmUserGetUserLevelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/getUserLevel",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetUserLevel",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [拉取用户等级数据↗](https://yapi.yuewen.com/project/2309/interface/api/197928) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserLevel`
 * @更新时间 `2021-02-22 17:08:52`
 */
export const goPcmUserGetUserLevel = /*#__PURE__*/ (
  requestData?: GoPcmUserGetUserLevelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetUserLevelResponse>(
    prepare(goPcmUserGetUserLevelRequestConfig, requestData),
    ...args
  );
};

goPcmUserGetUserLevel.requestConfig = goPcmUserGetUserLevelRequestConfig;

/**
 * 接口 [个人主页直出页面↗](https://yapi.yuewen.com/project/2309/interface/api/197945) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getProfileInfo`
 * @更新时间 `2021-02-23 13:42:31`
 */
export interface GoPcmUserGetProfileInfoRequest {
  guid: string;
  appId: string;
}

/**
 * 接口 [个人主页直出页面↗](https://yapi.yuewen.com/project/2309/interface/api/197945) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getProfileInfo`
 * @更新时间 `2021-02-23 13:42:31`
 */
export interface GoPcmUserGetProfileInfoResponse {}

/**
 * 接口 [个人主页直出页面↗](https://yapi.yuewen.com/project/2309/interface/api/197945) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getProfileInfo`
 * @更新时间 `2021-02-23 13:42:31`
 */
type GoPcmUserGetProfileInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/getProfileInfo",
    "data",
    string,
    "guid" | "appId",
    false
  >
>;

/**
 * 接口 [个人主页直出页面↗](https://yapi.yuewen.com/project/2309/interface/api/197945) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getProfileInfo`
 * @更新时间 `2021-02-23 13:42:31`
 */
const goPcmUserGetProfileInfoRequestConfig: GoPcmUserGetProfileInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/getProfileInfo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: ["guid", "appId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetProfileInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [个人主页直出页面↗](https://yapi.yuewen.com/project/2309/interface/api/197945) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getProfileInfo`
 * @更新时间 `2021-02-23 13:42:31`
 */
export const goPcmUserGetProfileInfo = /*#__PURE__*/ (
  requestData: GoPcmUserGetProfileInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetProfileInfoResponse>(
    prepare(goPcmUserGetProfileInfoRequestConfig, requestData),
    ...args
  );
};

goPcmUserGetProfileInfo.requestConfig = goPcmUserGetProfileInfoRequestConfig;

/**
 * 接口 [现金流水↗](https://yapi.yuewen.com/project/2309/interface/api/244296) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-cash-flow`
 * @更新时间 `2022-08-19 13:59:14`
 */
export interface GoPcmUserGetCashFlowRequest {
  pageIndex: string;
  /**
   * 默认20
   */
  pageSize?: string;
}

/**
 * 接口 [现金流水↗](https://yapi.yuewen.com/project/2309/interface/api/244296) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-cash-flow`
 * @更新时间 `2022-08-19 13:59:14`
 */
export interface GoPcmUserGetCashFlowResponse {
  /**
   * [{"name":"Top Up Coins","amount":7.99,"currencyUnit":"USD","time":1573031493000,"type":1},{"name":"Buy XXX","amount":17.99,"currencyUnit":"USD","time":1573031493000,"type":1}]
   */
  flowItems?: {
    /**
     * "Top Up Coins"
     */
    name?: string;
    /**
     * 7.99
     */
    amount?: number;
    /**
     * "USD"
     */
    currencyUnit?: string;
    /**
     * 1573031493000
     */
    time?: number;
    /**
     * 1
     */
    type?: number;
  }[];
  /**
   * true
   */
  isLast?: boolean;
  /**
   * 1
   */
  total?: number;
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300000745/1/1.jpg?mt=1599203750603"
     */
    avatar?: string;
    /**
     * "zhang_j4543"
     */
    nickName?: string;
    /**
     * "zhang_j4543"
     */
    userName?: string;
    /**
     * "zhang_j4543"
     */
    authorName?: string;
    /**
     * 4300000745
     */
    guid?: number;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * 2
     */
    gender?: number;
    /**
     * 4995
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 5
     */
    grade?: number;
    /**
     * 3
     */
    ES?: number;
    /**
     * 3
     */
    totalES?: number;
    /**
     * 3
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * "2120584224@qq.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: number;
    /**
     * 1599203750603
     */
    UUT?: number;
    /**
     * 3
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 2
     */
    membershipStatus?: number;
    /**
     * 1598678797000
     */
    membershipExpireTime?: number;
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [现金流水↗](https://yapi.yuewen.com/project/2309/interface/api/244296) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-cash-flow`
 * @更新时间 `2022-08-19 13:59:14`
 */
type GoPcmUserGetCashFlowRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/get-cash-flow",
    "data",
    string,
    "pageIndex" | "pageSize",
    false
  >
>;

/**
 * 接口 [现金流水↗](https://yapi.yuewen.com/project/2309/interface/api/244296) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-cash-flow`
 * @更新时间 `2022-08-19 13:59:14`
 */
const goPcmUserGetCashFlowRequestConfig: GoPcmUserGetCashFlowRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/get-cash-flow",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: ["pageIndex", "pageSize"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetCashFlow",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [现金流水↗](https://yapi.yuewen.com/project/2309/interface/api/244296) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-cash-flow`
 * @更新时间 `2022-08-19 13:59:14`
 */
export const goPcmUserGetCashFlow = /*#__PURE__*/ (
  requestData: GoPcmUserGetCashFlowRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetCashFlowResponse>(
    prepare(goPcmUserGetCashFlowRequestConfig, requestData),
    ...args
  );
};

goPcmUserGetCashFlow.requestConfig = goPcmUserGetCashFlowRequestConfig;

/**
 * 接口 [注销账户↗](https://yapi.yuewen.com/project/2309/interface/api/275729) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/cancelUser`
 * @更新时间 `2023-11-29 16:08:07`
 */
export interface GoPcmUserCancelUserRequest {
  verifyCode: string;
}

/**
 * 接口 [注销账户↗](https://yapi.yuewen.com/project/2309/interface/api/275729) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/cancelUser`
 * @更新时间 `2023-11-29 16:08:07`
 */
export interface GoPcmUserCancelUserResponse {}

/**
 * 接口 [注销账户↗](https://yapi.yuewen.com/project/2309/interface/api/275729) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/cancelUser`
 * @更新时间 `2023-11-29 16:08:07`
 */
type GoPcmUserCancelUserRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/cancelUser",
    "data",
    string,
    "verifyCode",
    false
  >
>;

/**
 * 接口 [注销账户↗](https://yapi.yuewen.com/project/2309/interface/api/275729) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/cancelUser`
 * @更新时间 `2023-11-29 16:08:07`
 */
const goPcmUserCancelUserRequestConfig: GoPcmUserCancelUserRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/cancelUser",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: ["verifyCode"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserCancelUser",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [注销账户↗](https://yapi.yuewen.com/project/2309/interface/api/275729) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/cancelUser`
 * @更新时间 `2023-11-29 16:08:07`
 */
export const goPcmUserCancelUser = /*#__PURE__*/ (
  requestData: GoPcmUserCancelUserRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserCancelUserResponse>(
    prepare(goPcmUserCancelUserRequestConfig, requestData),
    ...args
  );
};

goPcmUserCancelUser.requestConfig = goPcmUserCancelUserRequestConfig;

/**
 * 接口 [获取注销账号条件判断↗](https://yapi.yuewen.com/project/2309/interface/api/275735) 的 **请求类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getCancelUserData`
 * @更新时间 `2023-11-13 14:34:26`
 */
export interface GoPcmUserGetCancelUserDataRequest {}

/**
 * 接口 [获取注销账号条件判断↗](https://yapi.yuewen.com/project/2309/interface/api/275735) 的 **返回类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getCancelUserData`
 * @更新时间 `2023-11-13 14:34:26`
 */
export interface GoPcmUserGetCancelUserDataResponse {
  /**
   * true
   */
  canCancel?: boolean;
  /**
   * "xxx"
   */
  email?: string;
  /**
   * true
   */
  membershipAutoRenew?: boolean;
}

/**
 * 接口 [获取注销账号条件判断↗](https://yapi.yuewen.com/project/2309/interface/api/275735) 的 **请求配置的类型**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getCancelUserData`
 * @更新时间 `2023-11-13 14:34:26`
 */
type GoPcmUserGetCancelUserDataRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/user/getCancelUserData",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取注销账号条件判断↗](https://yapi.yuewen.com/project/2309/interface/api/275735) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getCancelUserData`
 * @更新时间 `2023-11-13 14:34:26`
 */
const goPcmUserGetCancelUserDataRequestConfig: GoPcmUserGetCancelUserDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/getCancelUserData",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetCancelUserData",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取注销账号条件判断↗](https://yapi.yuewen.com/project/2309/interface/api/275735) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getCancelUserData`
 * @更新时间 `2023-11-13 14:34:26`
 */
export const goPcmUserGetCancelUserData = /*#__PURE__*/ (
  requestData?: GoPcmUserGetCancelUserDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUserGetCancelUserDataResponse>(
    prepare(goPcmUserGetCancelUserDataRequestConfig, requestData),
    ...args
  );
};

goPcmUserGetCancelUserData.requestConfig =
  goPcmUserGetCancelUserDataRequestConfig;

const mockUrl_0_0_0_5 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_5 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_5 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_5 = "data" as any;

/**
 * 接口 [评论emoji映射Map↗](https://yapi.yuewen.com/project/2309/interface/api/175558) 的 **请求类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-12-02 19:36:36`
 */
export interface GoPcmEmojiGetEmoji2Request {}

/**
 * 接口 [评论emoji映射Map↗](https://yapi.yuewen.com/project/2309/interface/api/175558) 的 **返回类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-12-02 19:36:36`
 */
export interface GoPcmEmojiGetEmoji2Response {
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/fp.png"
   */
  "[img=fp]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/exp.png"
   */
  "[img=exp]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/faceslap.png"
   */
  "[img=faceslap]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/update.png"
   */
  "[img=update]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/coins.png"
   */
  "[img=coins]"?: string;
  /**
   * "https://cos4activity-1253177085.file.myqcloud.com/emoji/recommend.png"
   */
  "[img=recommend]"?: string;
}

/**
 * 接口 [评论emoji映射Map↗](https://yapi.yuewen.com/project/2309/interface/api/175558) 的 **请求配置的类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-12-02 19:36:36`
 */
type GoPcmEmojiGetEmoji2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/emoji/getEmoji",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [评论emoji映射Map↗](https://yapi.yuewen.com/project/2309/interface/api/175558) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-12-02 19:36:36`
 */
const goPcmEmojiGetEmoji2RequestConfig: GoPcmEmojiGetEmoji2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/emoji/getEmoji",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmEmojiGetEmoji2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [评论emoji映射Map↗](https://yapi.yuewen.com/project/2309/interface/api/175558) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-12-02 19:36:36`
 */
export const goPcmEmojiGetEmoji2 = /*#__PURE__*/ (
  requestData?: GoPcmEmojiGetEmoji2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmEmojiGetEmoji2Response>(
    prepare(goPcmEmojiGetEmoji2RequestConfig, requestData),
    ...args
  );
};

goPcmEmojiGetEmoji2.requestConfig = goPcmEmojiGetEmoji2RequestConfig;

/**
 * 接口 [举报评论（书 章 段）↗](https://yapi.yuewen.com/project/2309/interface/api/175566) 的 **请求类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/report`
 * @更新时间 `2020-12-02 19:36:36`
 */
export interface GoPcmBookReviewReportRequest {
  bookId: string;
  reviewId: string;
  chapterId: string;
  content: string;
  type: string;
  commentType: string;
}

/**
 * 接口 [举报评论（书 章 段）↗](https://yapi.yuewen.com/project/2309/interface/api/175566) 的 **返回类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/report`
 * @更新时间 `2020-12-02 19:36:36`
 */
export interface GoPcmBookReviewReportResponse {
  code?: number;
  /**
   * "成功"
   */
  msg?: string;
}

/**
 * 接口 [举报评论（书 章 段）↗](https://yapi.yuewen.com/project/2309/interface/api/175566) 的 **请求配置的类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/report`
 * @更新时间 `2020-12-02 19:36:36`
 */
type GoPcmBookReviewReportRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookReview/report",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [举报评论（书 章 段）↗](https://yapi.yuewen.com/project/2309/interface/api/175566) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/report`
 * @更新时间 `2020-12-02 19:36:36`
 */
const goPcmBookReviewReportRequestConfig: GoPcmBookReviewReportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/report",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewReport",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [举报评论（书 章 段）↗](https://yapi.yuewen.com/project/2309/interface/api/175566) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/report`
 * @更新时间 `2020-12-02 19:36:36`
 */
export const goPcmBookReviewReport = /*#__PURE__*/ (
  requestData: GoPcmBookReviewReportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookReviewReportResponse>(
    prepare(goPcmBookReviewReportRequestConfig, requestData),
    ...args
  );
};

goPcmBookReviewReport.requestConfig = goPcmBookReviewReportRequestConfig;

/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/2309/interface/api/175571) 的 **请求类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/add`
 * @更新时间 `2022-06-23 16:13:07`
 */
export interface GoPcmBookReviewAddRequest {
  bookId: string;
  comment: string;
  cdScore: string;
  wbScore: string;
  usScore: string;
  tqScore: string;
  sdScore: string;
  spoiler: string;
  novelType: string;
  score: string;
  imageUrl: string;
  width?: string;
  height?: string;
}

/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/2309/interface/api/175571) 的 **返回类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/add`
 * @更新时间 `2022-06-23 16:13:07`
 */
export interface GoPcmBookReviewAddResponse {
  /**
   * "12"
   */
  id?: string;
  /**
   * "Review content - nice book;"
   */
  content?: string;
  /**
   * [{"imageUrl":"@url","height":1,"width":1}]
   */
  imageItems?: {
    /**
     * "@url"
     */
    imageUrl?: string;
    /**
     * 1
     */
    height?: number;
    /**
     * 1
     */
    width?: number;
  }[];
}

/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/2309/interface/api/175571) 的 **请求配置的类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/add`
 * @更新时间 `2022-06-23 16:13:07`
 */
type GoPcmBookReviewAddRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookReview/add",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/2309/interface/api/175571) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/add`
 * @更新时间 `2022-06-23 16:13:07`
 */
const goPcmBookReviewAddRequestConfig: GoPcmBookReviewAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/add",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewAdd",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/2309/interface/api/175571) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/add`
 * @更新时间 `2022-06-23 16:13:07`
 */
export const goPcmBookReviewAdd = /*#__PURE__*/ (
  requestData: GoPcmBookReviewAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookReviewAddResponse>(
    prepare(goPcmBookReviewAddRequestConfig, requestData),
    ...args
  );
};

goPcmBookReviewAdd.requestConfig = goPcmBookReviewAddRequestConfig;

/**
 * 接口 [书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/175573) 的 **请求类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/get-reviews`
 * @更新时间 `2021-10-25 11:29:53`
 */
export interface GoPcmBookReviewGetReviewsRequest {
  pageIndex: string;
  bookId: string;
  needSummary: string;
  /**
   * 排序方式:1-liked;2-newest
   */
  orderBy: string;
  pageSize: string;
}

/**
 * 接口 [书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/175573) 的 **返回类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/get-reviews`
 * @更新时间 `2021-10-25 11:29:53`
 */
export interface GoPcmBookReviewGetReviewsResponse {
  /**
   * [{"reviewId":"@id","content":"[img=fp]@paragraph","isViceModerator":0,"isLikedByAuthor":0,"imageItems":[{"imageUrl":"@url","height":100,"width":200}],"holdBadgeCoverId":1231313123123,"bookId":10812783101029604,"userId":3968405415,"userName":"@name","headImageId":-123,"userRole":0,"userGrade":1,"totalScore":5,"replyNums":10,"likeNums":20,"leakFlag":0,"isLike":1,"holdBadgeCoverURL":"www.baidu.com","createTime":1537526601173,"createTimeFormat":"@string","topStatus":0,"appId":10,"privilegeInfo":{"isPrivilege":1,"img":"crown.png"},"essenceStatus":1}]
   */
  bookReviewInfos?: {
    /**
     * "@id"
     */
    reviewId?: string;
    /**
     * "[img=fp]@paragraph"
     */
    content?: string;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * [{"imageUrl":"@url","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "@url"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
    /**
     * 10812783101029604
     */
    bookId?: number;
    /**
     * 3968405415
     */
    userId?: number;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * -123
     */
    headImageId?: number;
    userRole?: number;
    /**
     * 1
     */
    userGrade?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * 10
     */
    replyNums?: number;
    /**
     * 20
     */
    likeNums?: number;
    leakFlag?: number;
    /**
     * 1
     */
    isLike?: number;
    /**
     * "www.baidu.com"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * "@string"
     */
    createTimeFormat?: string;
    topStatus?: number;
    /**
     * 10
     */
    appId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "crown.png"
       */
      img?: string;
    };
    /**
     * 1
     */
    essenceStatus?: number;
  }[];
  bookStatisticsInfo?: {
    /**
     * 100
     */
    totalReviewNum?: number;
    /**
     * 4
     */
    totalScore?: number;
    /**
     * 5
     */
    translationQuality?: number;
    /**
     * 4
     */
    updatingStability?: number;
    /**
     * 4
     */
    storyDevelopment?: number;
    /**
     * 3
     */
    characterDesign?: number;
    /**
     * 5
     */
    worldBackGround?: number;
  };
  userInfo?: {
    /**
     * 1
     */
    userRole?: number;
    /**
     * 1
     */
    isViceModerator?: number;
  };
  /**
   * "https://webbanner.webnovel.com/privilege/"
   */
  basePrivilegeUrl?: string;
  /**
   * 1
   */
  isLast?: number;
  baseInfo?: {
    /**
     * 1
     */
    bookId?: number;
    /**
     * "tgewtwe"
     */
    bookName?: string;
    /**
     * 1
     */
    bookType?: number;
    /**
     * 15681222223232
     */
    bookCoverId?: number;
    /**
     * "fwefwefwe"
     */
    authorName?: string;
    /**
     * "@string"
     */
    description?: string;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "zh"
     */
    languageName?: string;
    /**
     * 10000
     */
    pvNum?: number;
  };
}

/**
 * 接口 [书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/175573) 的 **请求配置的类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/get-reviews`
 * @更新时间 `2021-10-25 11:29:53`
 */
type GoPcmBookReviewGetReviewsRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookReview/get-reviews",
    "data",
    string,
    "pageIndex" | "bookId" | "needSummary" | "orderBy" | "pageSize",
    false
  >
>;

/**
 * 接口 [书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/175573) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/get-reviews`
 * @更新时间 `2021-10-25 11:29:53`
 */
const goPcmBookReviewGetReviewsRequestConfig: GoPcmBookReviewGetReviewsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/get-reviews",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: ["pageIndex", "bookId", "needSummary", "orderBy", "pageSize"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewGetReviews",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/175573) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/get-reviews`
 * @更新时间 `2021-10-25 11:29:53`
 */
export const goPcmBookReviewGetReviews = /*#__PURE__*/ (
  requestData: GoPcmBookReviewGetReviewsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookReviewGetReviewsResponse>(
    prepare(goPcmBookReviewGetReviewsRequestConfig, requestData),
    ...args
  );
};

goPcmBookReviewGetReviews.requestConfig =
  goPcmBookReviewGetReviewsRequestConfig;

/**
 * 接口 [书评详情↗](https://yapi.yuewen.com/project/2309/interface/api/175581) 的 **请求类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/detail`
 * @更新时间 `2021-10-25 11:29:25`
 */
export interface GoPcmBookReviewDetailRequest {
  bookId: string;
  reviewId: string;
  pageIndex: string;
  replyId?: string;
}

/**
 * 接口 [书评详情↗](https://yapi.yuewen.com/project/2309/interface/api/175581) 的 **返回类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/detail`
 * @更新时间 `2021-10-25 11:29:25`
 */
export interface GoPcmBookReviewDetailResponse {
  baseInfo?: {
    /**
     * 1
     */
    bookId?: number;
    /**
     * 1
     */
    novelType?: number;
    /**
     * "tgewtwe"
     */
    bookName?: string;
    /**
     * 15681222223232
     */
    bookCoverId?: number;
    /**
     * "@string"
     */
    description?: string;
    /**
     * "fwefwefwe"
     */
    authorName?: string;
    /**
     * "https://webbanner.webnovel.com/privilege/"
     */
    basePrivilegeUrl?: string;
    /**
     * 1333
     */
    reviewAmount?: number;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "zh"
     */
    languageName?: string;
    /**
     * 10000
     */
    pvNum?: number;
  };
  review?: {
    /**
     * 30629995764304730
     */
    reviewId?: number;
    /**
     * 14476162801070004
     */
    bookId?: number;
    /**
     * "[img=fp]@paragraph"
     */
    content?: string;
    /**
     * [{"imageUrl":"wefwe","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "wefwe"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 11224
     */
    likeAmount?: number;
    /**
     * 23222
     */
    replyAmount?: number;
    isLiked?: number;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * "@string"
     */
    createTimeFormat?: string;
    /**
     * 1234433
     */
    userId?: number;
    userRole?: number;
    /**
     * "jennyrenjialele5"
     */
    userName?: string;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      img?: string;
    };
    /**
     * 6
     */
    userNameserLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
    /**
     * 1
     */
    status?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * 1
     */
    leakFlag?: number;
    /**
     * true
     */
    topStatus?: boolean;
    /**
     * 1
     */
    essenceStatus?: number;
  };
  /**
   * [{"reviewId":30629995764304730,"content":"[img=fp]@paragraph","imageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":120}],"likeAmount":11224,"isLiked":0,"createTime":1537526601173,"createTimeFormat":"@string","userId":1234433,"userName":"jennyrenjialele5","isViceModerator":0,"isLikedByAuthor":1,"appId":10,"coverId":1557315300000,"pReviewId":30629995764304730,"pContent":"theisafiesjfiwejfliwef","pImageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}],"pUserName":"baba","pStatus":1,"privilegeInfo":{"isPrivilege":1,"img":"ic_privilege2x.png"},"userLevel":6,"holdBadgeCoverURL":"https://actimg.webnovel.com/badge/10006/1/","holdBadgeCoverId":1231313123123,"status":1,"bookId":10812783101029604,"userRole":0,"leakFlag":1,"essenceStatus":"0"}]
   */
  replyItems?: {
    /**
     * 30629995764304730
     */
    reviewId?: number;
    /**
     * "[img=fp]@paragraph"
     */
    content?: string;
    /**
     * [{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":120}]
     */
    imageItems?: {
      /**
       * "https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif"
       */
      imageUrl?: string;
      /**
       * 200
       */
      height?: number;
      /**
       * 120
       */
      width?: number;
    }[];
    /**
     * 11224
     */
    likeAmount?: number;
    isLiked?: number;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * "@string"
     */
    createTimeFormat?: string;
    /**
     * 1234433
     */
    userId?: number;
    /**
     * "jennyrenjialele5"
     */
    userName?: string;
    isViceModerator?: number;
    /**
     * 1
     */
    isLikedByAuthor?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    /**
     * 30629995764304730
     */
    pReviewId?: number;
    /**
     * "theisafiesjfiwejfliwef"
     */
    pContent?: string;
    /**
     * [{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}]
     */
    pImageItems?: {
      /**
       * "https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif"
       */
      imageUrl?: string;
      /**
       * 200
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * "baba"
     */
    pUserName?: string;
    /**
     * 1
     */
    pStatus?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
    /**
     * 1
     */
    status?: number;
    /**
     * 10812783101029604
     */
    bookId?: number;
    userRole?: number;
    /**
     * 1
     */
    leakFlag?: number;
    /**
     * "0"
     */
    essenceStatus?: string;
  }[];
  /**
   * 13
   */
  total?: number;
  isLast?: number;
  userInfo?: {
    userRole?: number;
    /**
     * 1
     */
    isViceModerator?: number;
    /**
     * 1
     */
    isAuthor?: number;
  };
  /**
   * "https://webbanner.webnovel.com/privilege/"
   */
  basePrivilegeUrl?: string;
}

/**
 * 接口 [书评详情↗](https://yapi.yuewen.com/project/2309/interface/api/175581) 的 **请求配置的类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/detail`
 * @更新时间 `2021-10-25 11:29:25`
 */
type GoPcmBookReviewDetailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookReview/detail",
    "data",
    string,
    "bookId" | "reviewId" | "pageIndex" | "replyId",
    false
  >
>;

/**
 * 接口 [书评详情↗](https://yapi.yuewen.com/project/2309/interface/api/175581) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/detail`
 * @更新时间 `2021-10-25 11:29:25`
 */
const goPcmBookReviewDetailRequestConfig: GoPcmBookReviewDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/detail",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: ["bookId", "reviewId", "pageIndex", "replyId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书评详情↗](https://yapi.yuewen.com/project/2309/interface/api/175581) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/detail`
 * @更新时间 `2021-10-25 11:29:25`
 */
export const goPcmBookReviewDetail = /*#__PURE__*/ (
  requestData: GoPcmBookReviewDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookReviewDetailResponse>(
    prepare(goPcmBookReviewDetailRequestConfig, requestData),
    ...args
  );
};

goPcmBookReviewDetail.requestConfig = goPcmBookReviewDetailRequestConfig;

/**
 * 接口 [点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175586) 的 **请求类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/like`
 * @更新时间 `2020-12-02 19:36:37`
 */
export interface GoPcmBookReviewLikeRequest {
  reviewId: string;
  opType: string;
}

/**
 * 接口 [点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175586) 的 **返回类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/like`
 * @更新时间 `2020-12-02 19:36:37`
 */
export interface GoPcmBookReviewLikeResponse {
  code?: number;
  /**
   * "成功"
   */
  msg?: string;
}

/**
 * 接口 [点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175586) 的 **请求配置的类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/like`
 * @更新时间 `2020-12-02 19:36:37`
 */
type GoPcmBookReviewLikeRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookReview/like",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175586) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/like`
 * @更新时间 `2020-12-02 19:36:37`
 */
const goPcmBookReviewLikeRequestConfig: GoPcmBookReviewLikeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/like",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewLike",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175586) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/like`
 * @更新时间 `2020-12-02 19:36:37`
 */
export const goPcmBookReviewLike = /*#__PURE__*/ (
  requestData: GoPcmBookReviewLikeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookReviewLikeResponse>(
    prepare(goPcmBookReviewLikeRequestConfig, requestData),
    ...args
  );
};

goPcmBookReviewLike.requestConfig = goPcmBookReviewLikeRequestConfig;

/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/2309/interface/api/175588) 的 **请求类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-12-02 19:36:37`
 */
export interface GoPcmBookReviewEssence2Request {
  bookId: string;
  reviewId: string;
  opType: string;
}

/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/2309/interface/api/175588) 的 **返回类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-12-02 19:36:37`
 */
export interface GoPcmBookReviewEssence2Response {}

/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/2309/interface/api/175588) 的 **请求配置的类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-12-02 19:36:37`
 */
type GoPcmBookReviewEssence2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookReview/essence",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/2309/interface/api/175588) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-12-02 19:36:37`
 */
const goPcmBookReviewEssence2RequestConfig: GoPcmBookReviewEssence2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/essence",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewEssence2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/2309/interface/api/175588) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-12-02 19:36:37`
 */
export const goPcmBookReviewEssence2 = /*#__PURE__*/ (
  requestData: GoPcmBookReviewEssence2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookReviewEssence2Response>(
    prepare(goPcmBookReviewEssence2RequestConfig, requestData),
    ...args
  );
};

goPcmBookReviewEssence2.requestConfig = goPcmBookReviewEssence2RequestConfig;

/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/2309/interface/api/175596) 的 **请求类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/remove`
 * @更新时间 `2020-12-02 19:36:37`
 */
export interface GoPcmBookReviewRemoveRequest {
  reviewId: string;
}

/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/2309/interface/api/175596) 的 **返回类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/remove`
 * @更新时间 `2020-12-02 19:36:37`
 */
export interface GoPcmBookReviewRemoveResponse {
  code?: number;
  /**
   * "成功"
   */
  msg?: string;
}

/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/2309/interface/api/175596) 的 **请求配置的类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/remove`
 * @更新时间 `2020-12-02 19:36:37`
 */
type GoPcmBookReviewRemoveRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookReview/remove",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/2309/interface/api/175596) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/remove`
 * @更新时间 `2020-12-02 19:36:37`
 */
const goPcmBookReviewRemoveRequestConfig: GoPcmBookReviewRemoveRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/remove",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewRemove",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/2309/interface/api/175596) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/remove`
 * @更新时间 `2020-12-02 19:36:37`
 */
export const goPcmBookReviewRemove = /*#__PURE__*/ (
  requestData: GoPcmBookReviewRemoveRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookReviewRemoveResponse>(
    prepare(goPcmBookReviewRemoveRequestConfig, requestData),
    ...args
  );
};

goPcmBookReviewRemove.requestConfig = goPcmBookReviewRemoveRequestConfig;

/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/2309/interface/api/175601) 的 **请求类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-12-02 19:36:37`
 */
export interface GoPcmBookReviewSetTop2Request {
  bookId: string;
  reviewId: string;
  topType: string;
}

/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/2309/interface/api/175601) 的 **返回类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-12-02 19:36:37`
 */
export interface GoPcmBookReviewSetTop2Response {
  code?: number;
  /**
   * "成功"
   */
  msg?: string;
}

/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/2309/interface/api/175601) 的 **请求配置的类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-12-02 19:36:37`
 */
type GoPcmBookReviewSetTop2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookReview/setTop",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/2309/interface/api/175601) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-12-02 19:36:37`
 */
const goPcmBookReviewSetTop2RequestConfig: GoPcmBookReviewSetTop2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/setTop",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewSetTop2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/2309/interface/api/175601) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-12-02 19:36:37`
 */
export const goPcmBookReviewSetTop2 = /*#__PURE__*/ (
  requestData: GoPcmBookReviewSetTop2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookReviewSetTop2Response>(
    prepare(goPcmBookReviewSetTop2RequestConfig, requestData),
    ...args
  );
};

goPcmBookReviewSetTop2.requestConfig = goPcmBookReviewSetTop2RequestConfig;

/**
 * 接口 [添加回复↗](https://yapi.yuewen.com/project/2309/interface/api/175603) 的 **请求类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/addReply`
 * @更新时间 `2020-12-02 19:36:37`
 */
export interface GoPcmBookReviewAddReplyRequest {
  bookId: string;
  reviewId: string;
  content: string;
  imageUrl?: string;
  height?: string;
  wdith?: string;
}

/**
 * 接口 [添加回复↗](https://yapi.yuewen.com/project/2309/interface/api/175603) 的 **返回类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/addReply`
 * @更新时间 `2020-12-02 19:36:37`
 */
export interface GoPcmBookReviewAddReplyResponse {
  reply?: {
    /**
     * "15127610"
     */
    id?: string;
    /**
     * "Review content - nice book;sss - pReviewId: 1274530"
     */
    content?: string;
    /**
     * [{"width":1,"height":1,"imageUrl":"@string"}]
     */
    imageItems?: {
      /**
       * 1
       */
      width?: number;
      /**
       * 1
       */
      height?: number;
      /**
       * "@string"
       */
      imageUrl?: string;
    }[];
  };
  origin?: {
    /**
     * "219"
     */
    id?: string;
    /**
     * "Review content - nice book;54555Review content - nice book;54555Review content - nice book;54555Review content - nice book;54555Review content - nice book;54555Review content - nice book;54555Review content - nice book;54555Review content - nice book;54555Review content - nice book;54555Review content - nice book;54555"
     */
    content?: string;
    /**
     * [{"width":1,"height":1,"imageUrl":"@string"}]
     */
    imageItems?: {
      /**
       * 1
       */
      width?: number;
      /**
       * 1
       */
      height?: number;
      /**
       * "@string"
       */
      imageUrl?: string;
    }[];
    /**
     * 2
     */
    userRole?: number;
    /**
     * "clarkzhang"
     */
    userName?: string;
    /**
     * "Jello"
     */
    penName?: string;
    avartar?: string;
  };
}

/**
 * 接口 [添加回复↗](https://yapi.yuewen.com/project/2309/interface/api/175603) 的 **请求配置的类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/addReply`
 * @更新时间 `2020-12-02 19:36:37`
 */
type GoPcmBookReviewAddReplyRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookReview/addReply",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [添加回复↗](https://yapi.yuewen.com/project/2309/interface/api/175603) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/addReply`
 * @更新时间 `2020-12-02 19:36:37`
 */
const goPcmBookReviewAddReplyRequestConfig: GoPcmBookReviewAddReplyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/addReply",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewAddReply",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [添加回复↗](https://yapi.yuewen.com/project/2309/interface/api/175603) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/addReply`
 * @更新时间 `2020-12-02 19:36:37`
 */
export const goPcmBookReviewAddReply = /*#__PURE__*/ (
  requestData: GoPcmBookReviewAddReplyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookReviewAddReplyResponse>(
    prepare(goPcmBookReviewAddReplyRequestConfig, requestData),
    ...args
  );
};

goPcmBookReviewAddReply.requestConfig = goPcmBookReviewAddReplyRequestConfig;

/**
 * 接口 [CR 书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/253380) 的 **请求类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/matrix/get-reviews`
 * @更新时间 `2022-12-20 10:46:36`
 */
export interface GoPcmBookReviewMatrixGetReviewsRequest {
  bookId: string;
  /**
   * 1-按照点赞倒叙，2-按照发布时间倒叙
   */
  sortType: string;
  pageIndex: string;
  /**
   * 0:所有，默认   1:有内容
   */
  contentFilter?: string;
  /**
   * 默认20
   */
  pageSize?: string;
}

/**
 * 接口 [CR 书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/253380) 的 **返回类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/matrix/get-reviews`
 * @更新时间 `2022-12-20 10:46:36`
 */
export interface GoPcmBookReviewMatrixGetReviewsResponse {
  /**
   * [{"id":1,"content":"@json","userInfo":{"userId":3968405415,"name":"jennyrenjialele5","imageId":-123,"appId":1002,"privilege":1},"score":1,"replyNum":10,"likeNum":20,"isLike":true,"authorType":1,"createTime":1537526601173,"createTimeFormat":"@string"}]
   */
  reviewInfo?: {
    /**
     * 1
     */
    id?: number;
    /**
     * "@json"
     */
    content?: string;
    userInfo?: {
      /**
       * 3968405415
       */
      userId?: number;
      /**
       * "jennyrenjialele5"
       */
      name?: string;
      /**
       * -123
       */
      imageId?: number;
      /**
       * 1002
       */
      appId?: number;
      /**
       * 1
       */
      privilege?: number;
    };
    /**
     * 1
     */
    score?: number;
    /**
     * 10
     */
    replyNum?: number;
    /**
     * 20
     */
    likeNum?: number;
    /**
     * true
     */
    isLike?: boolean;
    /**
     * 1
     */
    authorType?: number;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * "@string"
     */
    createTimeFormat?: string;
  }[];
  /**
   * 100
   */
  totalReviewNum?: number;
  /**
   * true
   */
  isLast?: boolean;
}

/**
 * 接口 [CR 书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/253380) 的 **请求配置的类型**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/matrix/get-reviews`
 * @更新时间 `2022-12-20 10:46:36`
 */
type GoPcmBookReviewMatrixGetReviewsRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookReview/matrix/get-reviews",
    "data",
    string,
    "bookId" | "sortType" | "pageIndex" | "contentFilter" | "pageSize",
    false
  >
>;

/**
 * 接口 [CR 书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/253380) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/matrix/get-reviews`
 * @更新时间 `2022-12-20 10:46:36`
 */
const goPcmBookReviewMatrixGetReviewsRequestConfig: GoPcmBookReviewMatrixGetReviewsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/matrix/get-reviews",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [
      "bookId",
      "sortType",
      "pageIndex",
      "contentFilter",
      "pageSize",
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewMatrixGetReviews",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [CR 书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/253380) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/matrix/get-reviews`
 * @更新时间 `2022-12-20 10:46:36`
 */
export const goPcmBookReviewMatrixGetReviews = /*#__PURE__*/ (
  requestData: GoPcmBookReviewMatrixGetReviewsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookReviewMatrixGetReviewsResponse>(
    prepare(goPcmBookReviewMatrixGetReviewsRequestConfig, requestData),
    ...args
  );
};

goPcmBookReviewMatrixGetReviews.requestConfig =
  goPcmBookReviewMatrixGetReviewsRequestConfig;

const mockUrl_0_0_0_6 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_6 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_6 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_6 = "data" as any;

/**
 * 接口 [搜索下拉加载(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175761) 的 **请求类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/result`
 * @更新时间 `2020-12-02 19:36:38`
 */
export interface GoPcmSearchResultRequest {
  /**
   * 1
   */
  pageIndex?: string;
  /**
   * test
   */
  keywords?: string;
  /**
   * 0=>全部，1=>小说，2=>漫画，3=>出版书
   */
  type?: string;
}

/**
 * 接口 [搜索下拉加载(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175761) 的 **返回类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/result`
 * @更新时间 `2020-12-02 19:36:38`
 */
export interface GoPcmSearchResultResponse {}

/**
 * 接口 [搜索下拉加载(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175761) 的 **请求配置的类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/result`
 * @更新时间 `2020-12-02 19:36:38`
 */
type GoPcmSearchResultRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/search/result",
    "data",
    string,
    "pageIndex" | "keywords" | "type",
    false
  >
>;

/**
 * 接口 [搜索下拉加载(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175761) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/result`
 * @更新时间 `2020-12-02 19:36:38`
 */
const goPcmSearchResultRequestConfig: GoPcmSearchResultRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: "/go/pcm/search/result",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: ["pageIndex", "keywords", "type"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSearchResult",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [搜索下拉加载(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175761) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/result`
 * @更新时间 `2020-12-02 19:36:38`
 */
export const goPcmSearchResult = /*#__PURE__*/ (
  requestData: GoPcmSearchResultRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSearchResultResponse>(
    prepare(goPcmSearchResultRequestConfig, requestData),
    ...args
  );
};

goPcmSearchResult.requestConfig = goPcmSearchResultRequestConfig;

/**
 * 接口 [搜索页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175776) 的 **请求类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/resultPage`
 * @更新时间 `2022-03-01 17:18:30`
 */
export interface GoPcmSearchResultPageRequest {
  /**
   * 页码
   */
  pageIndex?: string;
  /**
   * 搜索关键词
   */
  keywords?: string;
  /**
   * manga=>搜索漫画  fanfic=>搜索fanfic 默认 novel
   */
  type?: string;
}

/**
 * 接口 [搜索页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175776) 的 **返回类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/resultPage`
 * @更新时间 `2022-03-01 17:18:30`
 */
export interface GoPcmSearchResultPageResponse {
  bookInfo?: {
    /**
     * 1985
     */
    total?: number;
    isLast?: number;
    /**
     * [{"bookId":"13107286406772205","bookName":"Mystery In Action","novelType":0,"description":"","categoryId":70004,"categoryName":"Horror&Thriller","authorName":"CountessDracula","totalScore":0,"translateMode":-1,"tagInfo":[{"id":41000010,"tagName":"ROMANCE","likeCount":22,"like":false}],"coverUpdateTime":1578418671688}]
     */
    bookItems?: {
      /**
       * "13107286406772205"
       */
      bookId?: string;
      /**
       * "Mystery In Action"
       */
      bookName?: string;
      novelType?: number;
      description?: string;
      /**
       * 70004
       */
      categoryId?: number;
      /**
       * "Horror&Thriller"
       */
      categoryName?: string;
      /**
       * "CountessDracula"
       */
      authorName?: string;
      totalScore?: number;
      /**
       * -1
       */
      translateMode?: number;
      /**
       * [{"id":41000010,"tagName":"ROMANCE","likeCount":22,"like":false}]
       */
      tagInfo?: {
        /**
         * 41000010
         */
        id?: number;
        /**
         * "ROMANCE"
         */
        tagName?: string;
        /**
         * 22
         */
        likeCount?: number;
        like?: boolean;
      }[];
      /**
       * 1578418671688
       */
      coverUpdateTime?: number;
    }[];
  };
  comicInfo?: {
    /**
     * 372
     */
    total?: number;
    isLast?: number;
    /**
     * [{"comicId":"18382225505459001","bookName":"Born to Be a God","novelType":100,"bookId":"18382225505459001","categoryId":60006,"categoryName":"Eastern Fantasy","CV":1610430980197}]
     */
    comicItems?: {
      /**
       * "18382225505459001"
       */
      comicId?: string;
      /**
       * "Born to Be a God"
       */
      bookName?: string;
      /**
       * 100
       */
      novelType?: number;
      /**
       * "18382225505459001"
       */
      bookId?: string;
      /**
       * 60006
       */
      categoryId?: number;
      /**
       * "Eastern Fantasy"
       */
      categoryName?: string;
      /**
       * 1610430980197
       */
      CV?: number;
    }[];
  };
  publishBookInfo?: null;
  fanficBookInfo?: {
    /**
     * 18578
     */
    total?: number;
    isLast?: number;
    /**
     * [{"bookId":"16681205106928605","bookName":"A True Beginning","novelType":0,"description":"Zach died in a train crash and was reborn in a world he’d only read in books and seen in movies. The same world turned out to be less fiction and more hard reality than even his past boring life.","categoryId":81007,"categoryName":"Movies","authorName":"Time_Kink","totalScore":4,"translateMode":-1,"tagInfo":[{"id":41000010,"tagName":"ROMANCE","likeCount":22,"like":false}],"coverUpdateTime":1591168171690}]
     */
    fanficBookItems?: {
      /**
       * "16681205106928605"
       */
      bookId?: string;
      /**
       * "A True Beginning"
       */
      bookName?: string;
      novelType?: number;
      /**
       * "Zach died in a train crash and was reborn in a world he’d only read in books and seen in movies. The same world turned out to be less fiction and more hard reality than even his past boring life."
       */
      description?: string;
      /**
       * 81007
       */
      categoryId?: number;
      /**
       * "Movies"
       */
      categoryName?: string;
      /**
       * "Time_Kink"
       */
      authorName?: string;
      /**
       * 4
       */
      totalScore?: number;
      /**
       * -1
       */
      translateMode?: number;
      /**
       * [{"id":41000010,"tagName":"ROMANCE","likeCount":22,"like":false}]
       */
      tagInfo?: {
        /**
         * 41000010
         */
        id?: number;
        /**
         * "ROMANCE"
         */
        tagName?: string;
        /**
         * 22
         */
        likeCount?: number;
        like?: boolean;
      }[];
      /**
       * 1591168171690
       */
      coverUpdateTime?: number;
    }[];
  };
  tagInfo?: {
    /**
     * 37855
     */
    total?: number;
    isLast?: number;
    /**
     * "ACTION"
     */
    tagName?: string;
    /**
     * [{"bookId":"16709365405930105","bookName":"My Vampire System","novelType":0,"description":"The human Race is at war with the Vicious Dalki and when they needed help more than ever, THEY started to come forward. \r\n\r\nHumans who had hidden in the shadows for hundreds of years, people with abilities. \r\n\r\nSome chose to share their knowledge to the rest of the world in hopes of winning the war, while others kept their abilities to themselves.\r\n\r\nQuinn had lost everything to the war, his home, his family and the only thing he had inherited was a crummy old book that he couldn’t even open. \r\n\r\nBut when the book had finally opened, Quinn was granted a system and his whole life was turned around. \r\n\r\nHe completed quest after quest and became more powerful, until one day the system gave him a quest he wasn’t sure he could complete. \r\n\r\n\"It is time to feed!\"\r\n\"You must drink human blood within 24 hours\"\r\n\"Your HP will continue to decrease until the task has been completed\"\r\n\r\nDiscord link https://discord.gg/a9WfmJh\r\nhttps://www.patreon.com/JKSManga","categoryId":70002,"categoryName":"Fantasy","authorName":"JKSManga","totalScore":4.6,"translateMode":-1,"tagInfo":null,"coverUpdateTime":1596687896010}]
     */
    tagItems?: {
      /**
       * "16709365405930105"
       */
      bookId?: string;
      /**
       * "My Vampire System"
       */
      bookName?: string;
      novelType?: number;
      /**
       * "The human Race is at war with the Vicious Dalki and when they needed help more than ever, THEY started to come forward. \r\n\r\nHumans who had hidden in the shadows for hundreds of years, people with abilities. \r\n\r\nSome chose to share their knowledge to the rest of the world in hopes of winning the war, while others kept their abilities to themselves.\r\n\r\nQuinn had lost everything to the war, his home, his family and the only thing he had inherited was a crummy old book that he couldn’t even open. \r\n\r\nBut when the book had finally opened, Quinn was granted a system and his whole life was turned around. \r\n\r\nHe completed quest after quest and became more powerful, until one day the system gave him a quest he wasn’t sure he could complete. \r\n\r\n\"It is time to feed!\"\r\n\"You must drink human blood within 24 hours\"\r\n\"Your HP will continue to decrease until the task has been completed\"\r\n\r\nDiscord link https://discord.gg/a9WfmJh\r\nhttps://www.patreon.com/JKSManga"
       */
      description?: string;
      /**
       * 70002
       */
      categoryId?: number;
      /**
       * "Fantasy"
       */
      categoryName?: string;
      /**
       * "JKSManga"
       */
      authorName?: string;
      /**
       * 4.6
       */
      totalScore?: number;
      /**
       * -1
       */
      translateMode?: number;
      tagInfo?: null;
      /**
       * 1596687896010
       */
      coverUpdateTime?: number;
    }[];
  };
  powerRank?: {
    /**
     * [{"bookId":"16709365405930105","bookName":"My Vampire System","author":"JKSManga","authorId":"11412023406695501","totalScore":4.6,"powerNums":45224,"categoryId":70002,"categoryName":"Fantasy","bookType":2,"type":2,"groupItems":null,"editorItems":null,"translatorItems":null,"authorItems":null,"firstChapterId":"44853895649874397","coverUpdateTime":1596687896010,"description":"The human Race is at war with the Vicious Dalki and when they needed help more than ever, THEY started to come forward. \r\n\r\nHumans who had hidden in the shadows for hundreds of years, people with abilities. \r\n\r\nSome chose to share their knowledge to the rest of the world in hopes of winning the war, while others kept their abilities to themselves.\r\n\r\nQuinn had lost everything to the war, his home, his family and the only thing he had inherited was a crummy old book that he couldn’t even open. \r\n\r\nBut when the book had finally opened, Quinn was granted a system and his whole life was turned around. \r\n\r\nHe completed quest after quest and became more powerful, until one day the system gave him a quest he wasn’t sure he could complete. \r\n\r\n\"It is time to feed!\"\r\n\"You must drink human blood within 24 hours\"\r\n\"Your HP will continue to decrease until the task has been completed\"\r\n\r\nDiscord link https://discord.gg/a9WfmJh\r\nhttps://www.patreon.com/JKSManga"}]
     */
    bookItems?: {
      /**
       * "16709365405930105"
       */
      bookId?: string;
      /**
       * "My Vampire System"
       */
      bookName?: string;
      /**
       * "JKSManga"
       */
      author?: string;
      /**
       * "11412023406695501"
       */
      authorId?: string;
      /**
       * 4.6
       */
      totalScore?: number;
      /**
       * 45224
       */
      powerNums?: number;
      /**
       * 70002
       */
      categoryId?: number;
      /**
       * "Fantasy"
       */
      categoryName?: string;
      /**
       * 2
       */
      bookType?: number;
      /**
       * 2
       */
      type?: number;
      groupItems?: null;
      editorItems?: null;
      translatorItems?: null;
      authorItems?: null;
      /**
       * "44853895649874397"
       */
      firstChapterId?: string;
      /**
       * 1596687896010
       */
      coverUpdateTime?: number;
      /**
       * "The human Race is at war with the Vicious Dalki and when they needed help more than ever, THEY started to come forward. \r\n\r\nHumans who had hidden in the shadows for hundreds of years, people with abilities. \r\n\r\nSome chose to share their knowledge to the rest of the world in hopes of winning the war, while others kept their abilities to themselves.\r\n\r\nQuinn had lost everything to the war, his home, his family and the only thing he had inherited was a crummy old book that he couldn’t even open. \r\n\r\nBut when the book had finally opened, Quinn was granted a system and his whole life was turned around. \r\n\r\nHe completed quest after quest and became more powerful, until one day the system gave him a quest he wasn’t sure he could complete. \r\n\r\n\"It is time to feed!\"\r\n\"You must drink human blood within 24 hours\"\r\n\"Your HP will continue to decrease until the task has been completed\"\r\n\r\nDiscord link https://discord.gg/a9WfmJh\r\nhttps://www.patreon.com/JKSManga"
       */
      description?: string;
    }[];
  };
  categoryInfo?: {
    /**
     * 70003
     */
    categoryId?: number;
    /**
     * "History"
     */
    categoryName?: string;
    /**
     * 563
     */
    total?: number;
    novelType?: number;
    /**
     * [{"authorName":"faithful_jelly","bookId":"16684603405821905","bookName":"For The Glory Of Sitia Empire","categoryId":70003,"categoryName":"History","description":"Driven by his pride, Shianl decided to repay a favour he never asked for. \r\n\r\n{ our unwillingness does not change the fact that we are gratified by your actions. Thus, we shall requite whatever been acquired equally } \r\n\r\nAnd so, Shainl was reborn as the first son of Sitia Empire's ruler [Lennox]. However, he faced many troubles trying to balance his new fragile human body and the immense magical energy in his soul. By using the most suitable solution, Shianl sealed his powers temporarily, resulting in a slight leak of his pheromones. As a honourable being, Shainl's pheromones are a prove if his superiority. Deeply installing fear and submission in other living beings. \r\n\r\nNow that he has become the cursed crown prince to his subjects, Shianl's mission was proceeding leisurely as he wished to. Until he stumbled upon an unidentified weird young girl."}]
     */
    bookInfos?: {
      /**
       * "faithful_jelly"
       */
      authorName?: string;
      /**
       * "16684603405821905"
       */
      bookId?: string;
      /**
       * "For The Glory Of Sitia Empire"
       */
      bookName?: string;
      /**
       * 70003
       */
      categoryId?: number;
      /**
       * "History"
       */
      categoryName?: string;
      /**
       * "Driven by his pride, Shianl decided to repay a favour he never asked for. \r\n\r\n{ our unwillingness does not change the fact that we are gratified by your actions. Thus, we shall requite whatever been acquired equally } \r\n\r\nAnd so, Shainl was reborn as the first son of Sitia Empire's ruler [Lennox]. However, he faced many troubles trying to balance his new fragile human body and the immense magical energy in his soul. By using the most suitable solution, Shianl sealed his powers temporarily, resulting in a slight leak of his pheromones. As a honourable being, Shainl's pheromones are a prove if his superiority. Deeply installing fear and submission in other living beings. \r\n\r\nNow that he has become the cursed crown prince to his subjects, Shianl's mission was proceeding leisurely as he wished to. Until he stumbled upon an unidentified weird young girl."
       */
      description?: string;
    }[];
  };
  /**
   * [{"bookId":"19045709806205905","bookName":"The Last Blood Elf (Completed)","categoryType":1,"categoryId":81007,"categoryName":"Movies","novelType":0,"description":"Cross is the last of his kind, an extinct species wiped out long ago. Blessed with a strange power, he shall make a name for himself and make everybody remember the Blood Elves once more!\n\nhttps://www.pat reon.com/MonkeyGodking\n\n(BTW I suck at writing these! Just read it if you're interested!)","alg":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":2000,\"itemid\":\"19045709806205905\",\"logid\":5904407451686305822,\"origin\":\"12058\",\"preitemid\":\"b_19045709806205905\",\"scene\":\"personalized\",\"type\":\"0\",\"version\":\"\"}","authorName":"Monkey_Godking","totalScore":4.8,"totalChapterNum":259,"translateMode":-1}]
   */
  recommendInfo?: {
    /**
     * "19045709806205905"
     */
    bookId?: string;
    /**
     * "The Last Blood Elf (Completed)"
     */
    bookName?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * 81007
     */
    categoryId?: number;
    /**
     * "Movies"
     */
    categoryName?: string;
    novelType?: number;
    /**
     * "Cross is the last of his kind, an extinct species wiped out long ago. Blessed with a strange power, he shall make a name for himself and make everybody remember the Blood Elves once more!\n\nhttps://www.pat reon.com/MonkeyGodking\n\n(BTW I suck at writing these! Just read it if you're interested!)"
     */
    description?: string;
    /**
     * "{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":2000,\"itemid\":\"19045709806205905\",\"logid\":5904407451686305822,\"origin\":\"12058\",\"preitemid\":\"b_19045709806205905\",\"scene\":\"personalized\",\"type\":\"0\",\"version\":\"\"}"
     */
    alg?: string;
    /**
     * "Monkey_Godking"
     */
    authorName?: string;
    /**
     * 4.8
     */
    totalScore?: number;
    /**
     * 259
     */
    totalChapterNum?: number;
    /**
     * -1
     */
    translateMode?: number;
  }[];
  /**
   * "action"
   */
  keywords?: string;
  /**
   * 1
   */
  type?: number;
  /**
   * [{"name":"@string"}]
   */
  relatedWords?: {
    /**
     * "@string"
     */
    name?: string;
  }[];
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4306111510/1/1.jpg?mt=1558472236050"
     */
    avatar?: string;
    /**
     * "KENTARO12100"
     */
    nickName?: string;
    /**
     * "KENTARO12100"
     */
    userName?: string;
    /**
     * "KENTARO12100"
     */
    authorName?: string;
    /**
     * "KENTARO12100"
     */
    penName?: string;
    /**
     * 4306111510
     */
    guid?: number;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * 1
     */
    gender?: number;
    /**
     * 70
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    /**
     * 70
     */
    bSS?: number;
    /**
     * 1652716800000
     */
    expiringTime?: number;
    /**
     * 4
     */
    grade?: number;
    /**
     * 2
     */
    ES?: number;
    /**
     * 2
     */
    totalES?: number;
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * "kentaro12100@gmail.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    /**
     * 1
     */
    isCheckIn?: number;
    /**
     * 1558472236050
     */
    UUT?: number;
    /**
     * 16
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    membershipStatus?: number;
    membershipExpireTime?: number;
    membershipClaimStatus?: boolean;
    membershipIsFree?: boolean;
  };
}

/**
 * 接口 [搜索页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175776) 的 **请求配置的类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/resultPage`
 * @更新时间 `2022-03-01 17:18:30`
 */
type GoPcmSearchResultPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/search/resultPage",
    "data",
    string,
    "pageIndex" | "keywords" | "type",
    false
  >
>;

/**
 * 接口 [搜索页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175776) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/resultPage`
 * @更新时间 `2022-03-01 17:18:30`
 */
const goPcmSearchResultPageRequestConfig: GoPcmSearchResultPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: "/go/pcm/search/resultPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: ["pageIndex", "keywords", "type"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSearchResultPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [搜索页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175776) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/resultPage`
 * @更新时间 `2022-03-01 17:18:30`
 */
export const goPcmSearchResultPage = /*#__PURE__*/ (
  requestData: GoPcmSearchResultPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSearchResultPageResponse>(
    prepare(goPcmSearchResultPageRequestConfig, requestData),
    ...args
  );
};

goPcmSearchResultPage.requestConfig = goPcmSearchResultPageRequestConfig;

/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/2309/interface/api/191345) 的 **请求类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/getHotSearch`
 * @更新时间 `2021-01-13 15:22:49`
 */
export interface GoPcmSearchGetHotSearchRequest {}

/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/2309/interface/api/191345) 的 **返回类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/getHotSearch`
 * @更新时间 `2021-01-13 15:22:49`
 */
export interface GoPcmSearchGetHotSearchResponse {
  /**
   * [{"id":"7366916601012405","name":"The King's Avatar","type":1},{"id":"https://oam.webnovel.com/topic/112","name":"The topic 112","type":3},{"id":"11558338301012801","name":"Xiuzhen","type":2}]
   */
  items?: {
    /**
     * "7366916601012405"
     */
    id?: string;
    /**
     * "The King's Avatar"
     */
    name?: string;
    /**
     * 1
     */
    type?: number;
  }[];
}

/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/2309/interface/api/191345) 的 **请求配置的类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/getHotSearch`
 * @更新时间 `2021-01-13 15:22:49`
 */
type GoPcmSearchGetHotSearchRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/search/getHotSearch",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/2309/interface/api/191345) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/getHotSearch`
 * @更新时间 `2021-01-13 15:22:49`
 */
const goPcmSearchGetHotSearchRequestConfig: GoPcmSearchGetHotSearchRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: "/go/pcm/search/getHotSearch",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSearchGetHotSearch",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/2309/interface/api/191345) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/getHotSearch`
 * @更新时间 `2021-01-13 15:22:49`
 */
export const goPcmSearchGetHotSearch = /*#__PURE__*/ (
  requestData?: GoPcmSearchGetHotSearchRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSearchGetHotSearchResponse>(
    prepare(goPcmSearchGetHotSearchRequestConfig, requestData),
    ...args
  );
};

goPcmSearchGetHotSearch.requestConfig = goPcmSearchGetHotSearchRequestConfig;

/**
 * 接口 [获取搜索联想↗](https://yapi.yuewen.com/project/2309/interface/api/191352) 的 **请求类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/autoComplete`
 * @更新时间 `2021-01-21 11:03:30`
 */
export interface GoPcmSearchAutoCompleteRequest {
  /**
   * test
   */
  keywords?: string;
}

/**
 * 接口 [获取搜索联想↗](https://yapi.yuewen.com/project/2309/interface/api/191352) 的 **返回类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/autoComplete`
 * @更新时间 `2021-01-21 11:03:30`
 */
export interface GoPcmSearchAutoCompleteResponse {
  /**
   * [{"type":0,"id":7144266401010905,"name":"testpl"},{"type":0,"id":7144266401010905,"name":"testpl"}]
   */
  searchAssociationItems?: {
    type?: number;
    /**
     * 7144266401010905
     */
    id?: number;
    /**
     * "testpl"
     */
    name?: string;
  }[];
}

/**
 * 接口 [获取搜索联想↗](https://yapi.yuewen.com/project/2309/interface/api/191352) 的 **请求配置的类型**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/autoComplete`
 * @更新时间 `2021-01-21 11:03:30`
 */
type GoPcmSearchAutoCompleteRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/search/autoComplete",
    "data",
    string,
    "keywords",
    false
  >
>;

/**
 * 接口 [获取搜索联想↗](https://yapi.yuewen.com/project/2309/interface/api/191352) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/autoComplete`
 * @更新时间 `2021-01-21 11:03:30`
 */
const goPcmSearchAutoCompleteRequestConfig: GoPcmSearchAutoCompleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: "/go/pcm/search/autoComplete",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: ["keywords"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSearchAutoComplete",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取搜索联想↗](https://yapi.yuewen.com/project/2309/interface/api/191352) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/autoComplete`
 * @更新时间 `2021-01-21 11:03:30`
 */
export const goPcmSearchAutoComplete = /*#__PURE__*/ (
  requestData: GoPcmSearchAutoCompleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSearchAutoCompleteResponse>(
    prepare(goPcmSearchAutoCompleteRequestConfig, requestData),
    ...args
  );
};

goPcmSearchAutoComplete.requestConfig = goPcmSearchAutoCompleteRequestConfig;

const mockUrl_0_0_0_7 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_7 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_7 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_7 = "data" as any;

/**
 * 接口 [【go】删除↗](https://yapi.yuewen.com/project/2309/interface/api/175918) 的 **请求类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/deleteReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmChapterReviewDeleteReviewRequest {
  reviewId: string;
}

/**
 * 接口 [【go】删除↗](https://yapi.yuewen.com/project/2309/interface/api/175918) 的 **返回类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/deleteReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmChapterReviewDeleteReviewResponse {
  code?: number;
  /**
   * "Success"
   */
  msg?: string;
}

/**
 * 接口 [【go】删除↗](https://yapi.yuewen.com/project/2309/interface/api/175918) 的 **请求配置的类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/deleteReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
type GoPcmChapterReviewDeleteReviewRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/chapterReview/deleteReview",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [【go】删除↗](https://yapi.yuewen.com/project/2309/interface/api/175918) 的 **请求配置**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/deleteReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
const goPcmChapterReviewDeleteReviewRequestConfig: GoPcmChapterReviewDeleteReviewRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_7,
    devUrl: devUrl_0_0_0_7,
    prodUrl: prodUrl_0_0_0_7,
    path: "/go/pcm/chapterReview/deleteReview",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterReviewDeleteReview",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【go】删除↗](https://yapi.yuewen.com/project/2309/interface/api/175918) 的 **请求函数**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/deleteReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
export const goPcmChapterReviewDeleteReview = /*#__PURE__*/ (
  requestData: GoPcmChapterReviewDeleteReviewRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterReviewDeleteReviewResponse>(
    prepare(goPcmChapterReviewDeleteReviewRequestConfig, requestData),
    ...args
  );
};

goPcmChapterReviewDeleteReview.requestConfig =
  goPcmChapterReviewDeleteReviewRequestConfig;

/**
 * 接口 [【go】点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175926) 的 **请求类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/likeReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmChapterReviewLikeReviewRequest {
  reviewId: string;
  /**
   * 1-点赞/0-取消点赞
   */
  opType: string;
}

/**
 * 接口 [【go】点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175926) 的 **返回类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/likeReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmChapterReviewLikeReviewResponse {
  code?: number;
  /**
   * "Success"
   */
  msg?: string;
}

/**
 * 接口 [【go】点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175926) 的 **请求配置的类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/likeReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
type GoPcmChapterReviewLikeReviewRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/chapterReview/likeReview",
    "data",
    string,
    "reviewId" | "opType",
    false
  >
>;

/**
 * 接口 [【go】点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175926) 的 **请求配置**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/likeReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
const goPcmChapterReviewLikeReviewRequestConfig: GoPcmChapterReviewLikeReviewRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_7,
    devUrl: devUrl_0_0_0_7,
    prodUrl: prodUrl_0_0_0_7,
    path: "/go/pcm/chapterReview/likeReview",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_7,
    paramNames: [],
    queryNames: ["reviewId", "opType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterReviewLikeReview",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【go】点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175926) 的 **请求函数**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/likeReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
export const goPcmChapterReviewLikeReview = /*#__PURE__*/ (
  requestData: GoPcmChapterReviewLikeReviewRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterReviewLikeReviewResponse>(
    prepare(goPcmChapterReviewLikeReviewRequestConfig, requestData),
    ...args
  );
};

goPcmChapterReviewLikeReview.requestConfig =
  goPcmChapterReviewLikeReviewRequestConfig;

/**
 * 接口 [【go】获取回复贴↗](https://yapi.yuewen.com/project/2309/interface/api/175931) 的 **请求类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmChapterReviewGetReviewReplysRequest {
  bookId: string;
  chapterId: string;
  /**
   * 评论id
   */
  reviewId: string;
  /**
   * 上一页最后一条评论id
   */
  lastReviewId: string;
}

/**
 * 接口 [【go】获取回复贴↗](https://yapi.yuewen.com/project/2309/interface/api/175931) 的 **返回类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmChapterReviewGetReviewReplysResponse {
  /**
   * [{"reviewId":"@id","content":"test","imageItems":[{"imageUrl":"wefwe","height":100,"width":200}],"likeAmount":11224,"isLiked":0,"isViceModerator":0,"isLikedByAuthor":0,"createTime":1537526601173,"userId":1234433,"userRole":0,"userName":"jennyrenjialele5","appId":10,"coverId":1557315300000,"privilegeInfo":{"isPrivilege":1,"img":"ic_privilege2x.png"},"userLevel":6,"holdBadgeCoverURL":"https://actimg.webnovel.com/badge/10006/1/","holdBadgeCoverId":1231313123123,"status":1,"previewId":30629995764304730,"pContent":"","pimageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","Height":200,"Width":200}],"pUserName":"baba","pStatus":1}]
   */
  chapterReplyItems?: {
    /**
     * "@id"
     */
    reviewId?: string;
    /**
     * "test"
     */
    content?: string;
    /**
     * [{"imageUrl":"wefwe","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "wefwe"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 11224
     */
    likeAmount?: number;
    isLiked?: number;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * 1234433
     */
    userId?: number;
    userRole?: number;
    /**
     * "jennyrenjialele5"
     */
    userName?: string;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
    /**
     * 1
     */
    status?: number;
    /**
     * 30629995764304730
     */
    previewId?: number;
    pContent?: string;
    /**
     * [{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","Height":200,"Width":200}]
     */
    pimageItems?: {
      /**
       * "https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif"
       */
      imageUrl?: string;
      /**
       * 200
       */
      Height?: number;
      /**
       * 200
       */
      Width?: number;
    }[];
    /**
     * "baba"
     */
    pUserName?: string;
    /**
     * 1
     */
    pStatus?: number;
  }[];
  userInfo?: {
    /**
     * 1
     */
    userRole?: number;
    isViceModerator?: number;
    /**
     * 1
     */
    isAuthor?: number;
  };
  isLast?: number;
}

/**
 * 接口 [【go】获取回复贴↗](https://yapi.yuewen.com/project/2309/interface/api/175931) 的 **请求配置的类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */
type GoPcmChapterReviewGetReviewReplysRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/chapterReview/getReviewReplys",
    "data",
    string,
    "bookId" | "chapterId" | "reviewId" | "lastReviewId",
    false
  >
>;

/**
 * 接口 [【go】获取回复贴↗](https://yapi.yuewen.com/project/2309/interface/api/175931) 的 **请求配置**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */
const goPcmChapterReviewGetReviewReplysRequestConfig: GoPcmChapterReviewGetReviewReplysRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_7,
    devUrl: devUrl_0_0_0_7,
    prodUrl: prodUrl_0_0_0_7,
    path: "/go/pcm/chapterReview/getReviewReplys",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_7,
    paramNames: [],
    queryNames: ["bookId", "chapterId", "reviewId", "lastReviewId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterReviewGetReviewReplys",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【go】获取回复贴↗](https://yapi.yuewen.com/project/2309/interface/api/175931) 的 **请求函数**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */
export const goPcmChapterReviewGetReviewReplys = /*#__PURE__*/ (
  requestData: GoPcmChapterReviewGetReviewReplysRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterReviewGetReviewReplysResponse>(
    prepare(goPcmChapterReviewGetReviewReplysRequestConfig, requestData),
    ...args
  );
};

goPcmChapterReviewGetReviewReplys.requestConfig =
  goPcmChapterReviewGetReviewReplysRequestConfig;

/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/2309/interface/api/175933) 的 **请求类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2022-10-18 18:49:51`
 */
export interface GoPcmChapterReviewGetReviewList2Request {
  bookId: string;
  chapterId: string;
  pageIndex: string;
  /**
   * 排序方式，1-点赞数降序，2-发布时间降序
   */
  orderType: string;
  /**
   * 回复id 用于消息页跳转后，该条回复置顶
   */
  replyId: string;
  /**
   * 上一页最后一条评论id 在按照发布时间降序时必传
   */
  lastReviewId: string;
}

/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/2309/interface/api/175933) 的 **返回类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2022-10-18 18:49:51`
 */
export interface GoPcmChapterReviewGetReviewList2Response {
  baseInfo?: {
    /**
     * 134134132
     */
    bookId?: number;
    /**
     * "Book A"
     */
    bookName?: string;
    /**
     * "Er Gen"
     */
    authorName?: string;
    /**
     * [{"id":"11412023406695501","userId":4301351686,"guid":4301351686,"name":"JKSManga","UUT":"@timestamp"}]
     */
    authorItems?: {
      /**
       * "11412023406695501"
       */
      id?: string;
      /**
       * 4301351686
       */
      userId?: number;
      /**
       * 4301351686
       */
      guid?: number;
      /**
       * "JKSManga"
       */
      name?: string;
      /**
       * "@timestamp"
       */
      UUT?: string;
    }[];
    /**
     * 1
     */
    bookCoverID?: number;
    /**
     * "@string"
     */
    baseBadgeUrl?: string;
    /**
     * "@string"
     */
    basePrivilegeUrl?: string;
    /**
     * 1
     */
    reviewAmount?: number;
    /**
     * 1557315300000
     */
    chapterId?: number;
    /**
     * "Ch 037"
     */
    chapterName?: string;
  };
  topReview?: {
    /**
     * "@id"
     */
    reviewId?: string;
    /**
     * "test"
     */
    content?: string;
    /**
     * [{"imageUrl":"wefwe","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "wefwe"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 2222
     */
    likeAmount?: number;
    /**
     * 1
     */
    replyAmount?: number;
    /**
     * 1
     */
    isLiked?: number;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * 1234433
     */
    userId?: number;
    userRole?: number;
    /**
     * "jennyrenjialele5"
     */
    userName?: string;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      IsPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      Img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1231313123123
     */
    holdBadgecoverId?: number;
    /**
     * 1
     */
    status?: number;
  };
  topReplyI?: {
    /**
     * "@id"
     */
    reviewId?: string;
    /**
     * "test"
     */
    content?: string;
    /**
     * [{"imageUrl":"wefwe","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "wefwe"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 11224
     */
    likeAmount?: number;
    isLiked?: number;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * 1234433
     */
    userId?: number;
    userRole?: number;
    /**
     * "jennyrenjialele5"
     */
    userName?: string;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
    /**
     * 1
     */
    status?: number;
    /**
     * 30629995764304730
     */
    previewId?: number;
    pContent?: string;
    /**
     * [{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","Height":200,"Width":200}]
     */
    pimageItems?: {
      /**
       * "https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif"
       */
      imageUrl?: string;
      /**
       * 200
       */
      Height?: number;
      /**
       * 200
       */
      Width?: number;
    }[];
    /**
     * "baba"
     */
    pUserName?: string;
    /**
     * 1
     */
    pStatus?: number;
  };
  /**
   * [{"reviewId":"@id","content":"test","imageItems":[{"imageUrl":"wefwe","height":100,"width":200}],"likeAmount":11224,"replyAmount":23222,"isLiked":0,"createTime":1537526601173,"userId":1234433,"userRole":0,"userName":"jennyrenjialele5","isViceModerator":0,"isLikedByAuthor":0,"appId":10,"coverId":1557315300000,"privilegeInfo":{"IsPrivilege":1,"Img":"ic_privilege2x.png"},"userLevel":6,"holdBadgeCoverURL":"https://actimg.webnovel.com/badge/10006/1/","holdBadgecoverId":1231313123123,"status":1},{"reviewId":30629995764304730,"content":"test","imageItems":[{"imageUrl":"wefwe","height":100,"width":200}],"likeAmount":11224,"replyAmount":23222,"isLiked":0,"createTime":1537526601173,"userId":1234433,"userRole":0,"userName":"jennyrenjialele5","isViceModerator":0,"isLikedByAuthor":1,"appId":10,"coverId":1557315300000,"privilegeInfo":{"IsPrivilege":1,"Img":"ic_privilege2x.png"},"userLevel":6,"holdBadgeCoverURL":"https://actimg.webnovel.com/badge/10006/1/","holdBadgecoverId":1231313123123,"status":1}]
   */
  chapterReviewItems?: {
    /**
     * "@id"
     */
    reviewId?: string;
    /**
     * "test"
     */
    content?: string;
    /**
     * [{"imageUrl":"wefwe","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "wefwe"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 11224
     */
    likeAmount?: number;
    /**
     * 23222
     */
    replyAmount?: number;
    isLiked?: number;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * 1234433
     */
    userId?: number;
    userRole?: number;
    /**
     * "jennyrenjialele5"
     */
    userName?: string;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      IsPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      Img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1231313123123
     */
    holdBadgecoverId?: number;
    /**
     * 1
     */
    status?: number;
  }[];
  userInfo?: {
    /**
     * 1
     */
    userRole?: number;
    isViceModerator?: number;
    /**
     * 1
     */
    isAuthor?: number;
  };
  isLast?: number;
}

/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/2309/interface/api/175933) 的 **请求配置的类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2022-10-18 18:49:51`
 */
type GoPcmChapterReviewGetReviewList2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/chapterReview/getReviewList",
    "data",
    string,
    | "bookId"
    | "chapterId"
    | "pageIndex"
    | "orderType"
    | "replyId"
    | "lastReviewId",
    false
  >
>;

/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/2309/interface/api/175933) 的 **请求配置**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2022-10-18 18:49:51`
 */
const goPcmChapterReviewGetReviewList2RequestConfig: GoPcmChapterReviewGetReviewList2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_7,
    devUrl: devUrl_0_0_0_7,
    prodUrl: prodUrl_0_0_0_7,
    path: "/go/pcm/chapterReview/getReviewList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_7,
    paramNames: [],
    queryNames: [
      "bookId",
      "chapterId",
      "pageIndex",
      "orderType",
      "replyId",
      "lastReviewId",
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterReviewGetReviewList2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/2309/interface/api/175933) 的 **请求函数**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2022-10-18 18:49:51`
 */
export const goPcmChapterReviewGetReviewList2 = /*#__PURE__*/ (
  requestData: GoPcmChapterReviewGetReviewList2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterReviewGetReviewList2Response>(
    prepare(goPcmChapterReviewGetReviewList2RequestConfig, requestData),
    ...args
  );
};

goPcmChapterReviewGetReviewList2.requestConfig =
  goPcmChapterReviewGetReviewList2RequestConfig;

/**
 * 接口 [【go】新增章评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175941) 的 **请求类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/addReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmChapterReviewAddReviewRequest {
  /**
   * 书id
   */
  bookId: string;
  /**
   * 章节id
   */
  chapterId: string;
  /**
   * 回复的那条评论的id
   */
  reviewId: string;
  /**
   * 评论内容
   */
  content: string;
  /**
   * 图片url
   */
  imageUrl: string;
  /**
   * 高
   */
  height: string;
  /**
   * 宽
   */
  width: string;
}

/**
 * 接口 [【go】新增章评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175941) 的 **返回类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/addReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmChapterReviewAddReviewResponse {
  code?: number;
  /**
   * "Success"
   */
  msg?: string;
}

/**
 * 接口 [【go】新增章评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175941) 的 **请求配置的类型**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/addReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
type GoPcmChapterReviewAddReviewRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/chapterReview/addReview",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [【go】新增章评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175941) 的 **请求配置**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/addReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
const goPcmChapterReviewAddReviewRequestConfig: GoPcmChapterReviewAddReviewRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_7,
    devUrl: devUrl_0_0_0_7,
    prodUrl: prodUrl_0_0_0_7,
    path: "/go/pcm/chapterReview/addReview",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterReviewAddReview",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【go】新增章评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175941) 的 **请求函数**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/addReview`
 * @更新时间 `2020-12-02 19:36:40`
 */
export const goPcmChapterReviewAddReview = /*#__PURE__*/ (
  requestData: GoPcmChapterReviewAddReviewRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmChapterReviewAddReviewResponse>(
    prepare(goPcmChapterReviewAddReviewRequestConfig, requestData),
    ...args
  );
};

goPcmChapterReviewAddReview.requestConfig =
  goPcmChapterReviewAddReviewRequestConfig;

const mockUrl_0_0_0_8 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_8 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_8 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_8 = "data" as any;

/**
 * 接口 [新增段评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175971) 的 **请求类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/add`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewAddRequest {
  bookId: string;
  chapterId: string;
  paragraphId: string;
  content: string;
  replyToId: string;
  /**
   * 图片url
   */
  imageUrl: string;
  /**
   * 高
   */
  height: string;
  /**
   * 宽
   */
  width: string;
}

/**
 * 接口 [新增段评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175971) 的 **返回类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/add`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewAddResponse {
  code?: number;
  msg?: string;
}

/**
 * 接口 [新增段评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175971) 的 **请求配置的类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/add`
 * @更新时间 `2020-12-02 19:36:40`
 */
type GoPcmParagraphReviewAddRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/paragraphReview/add",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [新增段评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175971) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/add`
 * @更新时间 `2020-12-02 19:36:40`
 */
const goPcmParagraphReviewAddRequestConfig: GoPcmParagraphReviewAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/add",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewAdd",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [新增段评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175971) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/add`
 * @更新时间 `2020-12-02 19:36:40`
 */
export const goPcmParagraphReviewAdd = /*#__PURE__*/ (
  requestData: GoPcmParagraphReviewAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmParagraphReviewAddResponse>(
    prepare(goPcmParagraphReviewAddRequestConfig, requestData),
    ...args
  );
};

goPcmParagraphReviewAdd.requestConfig = goPcmParagraphReviewAddRequestConfig;

/**
 * 接口 [获取各段评论数接口↗](https://yapi.yuewen.com/project/2309/interface/api/175976) 的 **请求类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewNum`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewGetReiewNumRequest {
  /**
   * 章节id
   */
  chapterId: string;
}

/**
 * 接口 [获取各段评论数接口↗](https://yapi.yuewen.com/project/2309/interface/api/175976) 的 **返回类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewNum`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewGetReiewNumResponse {
  /**
   * [{"paragraphId":"13d63f68f464766e3b9f170e8f983830","reviewAmount":1123,"authorReviewStatus":1},{"paragraphId":"1641b6d79a0d63317efe6ed6344f96fc","reviewAmount":123,"authorReviewStatus":1},{"paragraphId":"56fd9cc4568df84f06bbbea54433842f","reviewAmount":0,"authorReviewStatus":1},{"paragraphId":"748e92fa19308f90bef179a4a8518e95","reviewAmount":12,"authorReviewStatus":1},{"paragraphId":"c10385ab8611311c9844e448fe8e5f19","reviewAmount":12,"authorReviewStatus":1},{"paragraphId":"c63712c4087b8f050d40fe1d0a7c26ef","reviewAmount":12},{"paragraphId":"04cd288c7a27195a8dd88c188266eb71","reviewAmount":12,"authorReviewStatus":1},{"paragraphId":"ee276dbbf7a544ad4d3665788699e0aa","reviewAmount":12,"authorReviewStatus":1},{"paragraphId":"c4626891cb7339b4216aeabdfc31553d","reviewAmount":12}]
   */
  paragraphItems?: {
    /**
     * "13d63f68f464766e3b9f170e8f983830"
     */
    paragraphId?: string;
    /**
     * 1123
     */
    reviewAmount?: number;
    /**
     * 1
     */
    authorReviewStatus?: number;
  }[];
}

/**
 * 接口 [获取各段评论数接口↗](https://yapi.yuewen.com/project/2309/interface/api/175976) 的 **请求配置的类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewNum`
 * @更新时间 `2020-12-02 19:36:40`
 */
type GoPcmParagraphReviewGetReiewNumRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/paragraphReview/getReiewNum",
    "data",
    string,
    "chapterId",
    false
  >
>;

/**
 * 接口 [获取各段评论数接口↗](https://yapi.yuewen.com/project/2309/interface/api/175976) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewNum`
 * @更新时间 `2020-12-02 19:36:40`
 */
const goPcmParagraphReviewGetReiewNumRequestConfig: GoPcmParagraphReviewGetReiewNumRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/getReiewNum",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: ["chapterId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewGetReiewNum",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取各段评论数接口↗](https://yapi.yuewen.com/project/2309/interface/api/175976) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewNum`
 * @更新时间 `2020-12-02 19:36:40`
 */
export const goPcmParagraphReviewGetReiewNum = /*#__PURE__*/ (
  requestData: GoPcmParagraphReviewGetReiewNumRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmParagraphReviewGetReiewNumResponse>(
    prepare(goPcmParagraphReviewGetReiewNumRequestConfig, requestData),
    ...args
  );
};

goPcmParagraphReviewGetReiewNum.requestConfig =
  goPcmParagraphReviewGetReiewNumRequestConfig;

/**
 * 接口 [获取段评主贴列表↗](https://yapi.yuewen.com/project/2309/interface/api/175978) 的 **请求类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewList`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewGetReiewListRequest {
  /**
   * 章节id   long
   */
  chapterId: string;
  /**
   * 段id  string
   */
  paragraphId: string;
  /**
   * 第一次请求传0，后续请求用返回的lastTime    long
   */
  lastTime?: string;
}

/**
 * 接口 [获取段评主贴列表↗](https://yapi.yuewen.com/project/2309/interface/api/175978) 的 **返回类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewList`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewGetReiewListResponse {
  /**
   * [{"reviewId":30629995764304730,"content":"<div><input id=\"chapterAds\" type=\"hidden\" value=\"{&quot;101&quot;:[&quot;/274367222/WEB-READ-RECT&quot;,&quot;/274367222/WEB-READ-RECT2&quot;,&quot;/274367222/WEB-READ-RECT3&quot;,&quot;/274367222/WEB-READ-RECT4&quot;,&quot;/274367222/WEB-READ-RECT5&quot;,&quot;test_ad_id&quot;,&quot;test_ad_id&quot;,&quot;2&quot;],&quot;102&quot;:[],&quot;103&quot;:[&quot;/274367222/web-read-video&quot;,&quot;/274367222/web-read-video2&quot;,&quot;/274367222/web-read-video3&quot;,&quot;/274367222/web-read-video4&quot;,&quot;/274367222/web-read-video5&quot;,&quot;1&quot;]}\"></div>","likeAmount":11224,"replyAmount":1,"isLiked":0,"floor":17,"createTime":"@timestamp","createTimeFormat":"5 days ago","userId":"120004","userRole":[1,2,0],"userName":"@name","appId":10,"coverId":1557315300000,"privilegeInfo":{"isPrivilege":1,"img":"ic_privilege2x.png"},"userLevel":6,"holdBadgeCoverURL":"https://actimg.webnovel.com/badge/10006/1/","holdBadgeCoverId":1231313123123}]
   */
  topParagraphTopicItems?: {
    /**
     * 30629995764304730
     */
    reviewId?: number;
    /**
     * "<div><input id=\"chapterAds\" type=\"hidden\" value=\"{&quot;101&quot;:[&quot;/274367222/WEB-READ-RECT&quot;,&quot;/274367222/WEB-READ-RECT2&quot;,&quot;/274367222/WEB-READ-RECT3&quot;,&quot;/274367222/WEB-READ-RECT4&quot;,&quot;/274367222/WEB-READ-RECT5&quot;,&quot;test_ad_id&quot;,&quot;test_ad_id&quot;,&quot;2&quot;],&quot;102&quot;:[],&quot;103&quot;:[&quot;/274367222/web-read-video&quot;,&quot;/274367222/web-read-video2&quot;,&quot;/274367222/web-read-video3&quot;,&quot;/274367222/web-read-video4&quot;,&quot;/274367222/web-read-video5&quot;,&quot;1&quot;]}\"></div>"
     */
    content?: string;
    /**
     * 11224
     */
    likeAmount?: number;
    /**
     * 1
     */
    replyAmount?: number;
    isLiked?: number;
    /**
     * 17
     */
    floor?: number;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "5 days ago"
     */
    createTimeFormat?: string;
    /**
     * "120004"
     */
    userId?: string;
    /**
     * [1,2,0]
     */
    userRole?: number[];
    /**
     * "@name"
     */
    userName?: string;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
  }[];
  /**
   * [{"reviewId":30629995764304730,"content":"@paragraph","likeAmount":11224,"replyAmount":0,"isLiked":0,"floor":"@int","createTime":"@timestamp","createTimeFormat":"5 days ago","userId":1234433,"userRole":0,"userName":"@name","appId":10,"coverId":1557315300000,"privilegeInfo":{"isPrivilege":1,"img":"ic_privilege2x.png"},"userLevel":6,"holdBadgeCoverURL":"https://actimg.webnovel.com/badge/10006/1/","holdBadgeCoverId":1231313123123}]
   */
  paragraphTopicItems?: {
    /**
     * 30629995764304730
     */
    reviewId?: number;
    /**
     * "@paragraph"
     */
    content?: string;
    /**
     * 11224
     */
    likeAmount?: number;
    replyAmount?: number;
    isLiked?: number;
    /**
     * "@int"
     */
    floor?: string;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "5 days ago"
     */
    createTimeFormat?: string;
    /**
     * 1234433
     */
    userId?: number;
    userRole?: number;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
  }[];
  baseInfo?: {
    baseBadgeUrl?: string;
    /**
     * "https://webbanner.webnovel.com/privilege/"
     */
    basePrivilegeUrl?: string;
    /**
     * 10812783101029604
     */
    bookId?: number;
    /**
     * 2223783101029604
     */
    chapterId?: number;
    /**
     * "108127831eee01029604"
     */
    paragraphId?: string;
  };
  userInfo?: {
    /**
     * 1
     */
    userRole?: number;
    isViceModerator?: number;
    /**
     * 1
     */
    isAuthor?: number;
  };
  /**
   * 1559138081000
   */
  lastTime?: number;
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [获取段评主贴列表↗](https://yapi.yuewen.com/project/2309/interface/api/175978) 的 **请求配置的类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewList`
 * @更新时间 `2020-12-02 19:36:40`
 */
type GoPcmParagraphReviewGetReiewListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/paragraphReview/getReiewList",
    "data",
    string,
    "chapterId" | "paragraphId" | "lastTime",
    false
  >
>;

/**
 * 接口 [获取段评主贴列表↗](https://yapi.yuewen.com/project/2309/interface/api/175978) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewList`
 * @更新时间 `2020-12-02 19:36:40`
 */
const goPcmParagraphReviewGetReiewListRequestConfig: GoPcmParagraphReviewGetReiewListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/getReiewList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: ["chapterId", "paragraphId", "lastTime"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewGetReiewList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取段评主贴列表↗](https://yapi.yuewen.com/project/2309/interface/api/175978) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewList`
 * @更新时间 `2020-12-02 19:36:40`
 */
export const goPcmParagraphReviewGetReiewList = /*#__PURE__*/ (
  requestData: GoPcmParagraphReviewGetReiewListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmParagraphReviewGetReiewListResponse>(
    prepare(goPcmParagraphReviewGetReiewListRequestConfig, requestData),
    ...args
  );
};

goPcmParagraphReviewGetReiewList.requestConfig =
  goPcmParagraphReviewGetReiewListRequestConfig;

/**
 * 接口 [获取段评主贴回复列表↗](https://yapi.yuewen.com/project/2309/interface/api/175986) 的 **请求类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReieweReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewGetReieweReplysRequest {
  /**
   * 章节id   long
   */
  chapterId: string;
  /**
   * 段id  string
   */
  paragraphId: string;
  /**
   * 段评主贴id
   */
  reviewId: string;
  /**
   * 第一次请求传0，后续请求用返回的lastTime
   */
  lastTime?: string;
}

/**
 * 接口 [获取段评主贴回复列表↗](https://yapi.yuewen.com/project/2309/interface/api/175986) 的 **返回类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReieweReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewGetReieweReplysResponse {
  /**
   * [{"reviewId":1,"content":"@paragraph","likeAmount":"0","isLiked":0,"createTime":"@timestamp","createTimeFormat":"5 days ago","userId":1234433,"userRole":0,"userName":"@name","appId":10,"coverId":1557315300000,"pReviewId":30629995764304730,"pContent":"@paragraph","pUserName":"baba","pStatus":1,"privilegeInfo":{"isPrivilege":1,"img":"ic_privilege2x.png"},"userLevel":6,"holdBadgeCoverURL":"https://actimg.webnovel.com/badge/10006/1/"}]
   */
  paragraphReviewItems?: {
    /**
     * 1
     */
    reviewId?: number;
    /**
     * "@paragraph"
     */
    content?: string;
    /**
     * "0"
     */
    likeAmount?: string;
    isLiked?: number;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "5 days ago"
     */
    createTimeFormat?: string;
    /**
     * 1234433
     */
    userId?: number;
    userRole?: number;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    /**
     * 30629995764304730
     */
    pReviewId?: number;
    /**
     * "@paragraph"
     */
    pContent?: string;
    /**
     * "baba"
     */
    pUserName?: string;
    /**
     * 1
     */
    pStatus?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
  }[];
  baseInfo?: {
    baseBadgeUrl?: string;
    /**
     * "https://webbanner.webnovel.com/privilege/"
     */
    basePrivilegeUrl?: string;
    /**
     * 10812783101029604
     */
    bookId?: number;
    /**
     * 2223783101029604
     */
    chapterId?: number;
    /**
     * "108127831eee01029604"
     */
    paragraphId?: string;
  };
  userInfo?: {
    /**
     * 1
     */
    userRole?: number;
    isViceModerator?: number;
    /**
     * 1
     */
    isAuthor?: number;
  };
  /**
   * 1559138081000
   */
  lastTime?: number;
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [获取段评主贴回复列表↗](https://yapi.yuewen.com/project/2309/interface/api/175986) 的 **请求配置的类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReieweReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */
type GoPcmParagraphReviewGetReieweReplysRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/paragraphReview/getReieweReplys",
    "data",
    string,
    "chapterId" | "paragraphId" | "reviewId" | "lastTime",
    false
  >
>;

/**
 * 接口 [获取段评主贴回复列表↗](https://yapi.yuewen.com/project/2309/interface/api/175986) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReieweReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */
const goPcmParagraphReviewGetReieweReplysRequestConfig: GoPcmParagraphReviewGetReieweReplysRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/getReieweReplys",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: ["chapterId", "paragraphId", "reviewId", "lastTime"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewGetReieweReplys",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取段评主贴回复列表↗](https://yapi.yuewen.com/project/2309/interface/api/175986) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReieweReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */
export const goPcmParagraphReviewGetReieweReplys = /*#__PURE__*/ (
  requestData: GoPcmParagraphReviewGetReieweReplysRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmParagraphReviewGetReieweReplysResponse>(
    prepare(goPcmParagraphReviewGetReieweReplysRequestConfig, requestData),
    ...args
  );
};

goPcmParagraphReviewGetReieweReplys.requestConfig =
  goPcmParagraphReviewGetReieweReplysRequestConfig;

/**
 * 接口 [段评点赞\/取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175991) 的 **请求类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/like`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewLikeRequest {
  /**
   * 章id
   */
  chapterId: string;
  /**
   * 段评id
   */
  reviewId: string;
  /**
   * 1-点赞 2-取消点赞
   */
  type: string;
}

/**
 * 接口 [段评点赞\/取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175991) 的 **返回类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/like`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewLikeResponse {
  code?: number;
  msg?: string;
}

/**
 * 接口 [段评点赞\/取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175991) 的 **请求配置的类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/like`
 * @更新时间 `2020-12-02 19:36:40`
 */
type GoPcmParagraphReviewLikeRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/paragraphReview/like",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [段评点赞\/取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175991) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/like`
 * @更新时间 `2020-12-02 19:36:40`
 */
const goPcmParagraphReviewLikeRequestConfig: GoPcmParagraphReviewLikeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/like",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewLike",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [段评点赞\/取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175991) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/like`
 * @更新时间 `2020-12-02 19:36:40`
 */
export const goPcmParagraphReviewLike = /*#__PURE__*/ (
  requestData: GoPcmParagraphReviewLikeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmParagraphReviewLikeResponse>(
    prepare(goPcmParagraphReviewLikeRequestConfig, requestData),
    ...args
  );
};

goPcmParagraphReviewLike.requestConfig = goPcmParagraphReviewLikeRequestConfig;

/**
 * 接口 [段评举报↗](https://yapi.yuewen.com/project/2309/interface/api/175993) 的 **请求类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/report`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewReportRequest {
  /**
   * 1-广告；2-色情 ;3-人身攻击;4-其他
   */
  reportType: string;
  bookId: string;
  chapterId: string;
  reviewId: string;
  /**
   * 举报原因
   */
  reason: string;
}

/**
 * 接口 [段评举报↗](https://yapi.yuewen.com/project/2309/interface/api/175993) 的 **返回类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/report`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewReportResponse {
  code?: number;
  msg?: string;
}

/**
 * 接口 [段评举报↗](https://yapi.yuewen.com/project/2309/interface/api/175993) 的 **请求配置的类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/report`
 * @更新时间 `2020-12-02 19:36:40`
 */
type GoPcmParagraphReviewReportRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/paragraphReview/report",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [段评举报↗](https://yapi.yuewen.com/project/2309/interface/api/175993) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/report`
 * @更新时间 `2020-12-02 19:36:40`
 */
const goPcmParagraphReviewReportRequestConfig: GoPcmParagraphReviewReportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/report",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewReport",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [段评举报↗](https://yapi.yuewen.com/project/2309/interface/api/175993) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/report`
 * @更新时间 `2020-12-02 19:36:40`
 */
export const goPcmParagraphReviewReport = /*#__PURE__*/ (
  requestData: GoPcmParagraphReviewReportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmParagraphReviewReportResponse>(
    prepare(goPcmParagraphReviewReportRequestConfig, requestData),
    ...args
  );
};

goPcmParagraphReviewReport.requestConfig =
  goPcmParagraphReviewReportRequestConfig;

/**
 * 接口 [段评删除↗](https://yapi.yuewen.com/project/2309/interface/api/176001) 的 **请求类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/delete`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewDeleteRequest {
  chapterId: string;
  reviewId: string;
}

/**
 * 接口 [段评删除↗](https://yapi.yuewen.com/project/2309/interface/api/176001) 的 **返回类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/delete`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewDeleteResponse {
  code?: number;
  msg?: string;
}

/**
 * 接口 [段评删除↗](https://yapi.yuewen.com/project/2309/interface/api/176001) 的 **请求配置的类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/delete`
 * @更新时间 `2020-12-02 19:36:40`
 */
type GoPcmParagraphReviewDeleteRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/paragraphReview/delete",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [段评删除↗](https://yapi.yuewen.com/project/2309/interface/api/176001) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/delete`
 * @更新时间 `2020-12-02 19:36:40`
 */
const goPcmParagraphReviewDeleteRequestConfig: GoPcmParagraphReviewDeleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/delete",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewDelete",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [段评删除↗](https://yapi.yuewen.com/project/2309/interface/api/176001) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/delete`
 * @更新时间 `2020-12-02 19:36:40`
 */
export const goPcmParagraphReviewDelete = /*#__PURE__*/ (
  requestData: GoPcmParagraphReviewDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmParagraphReviewDeleteResponse>(
    prepare(goPcmParagraphReviewDeleteRequestConfig, requestData),
    ...args
  );
};

goPcmParagraphReviewDelete.requestConfig =
  goPcmParagraphReviewDeleteRequestConfig;

/**
 * 接口 [段评列表消息跳转接口↗](https://yapi.yuewen.com/project/2309/interface/api/176006) 的 **请求类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReviewDetail`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewGetReviewDetailRequest {
  /**
   * 章节id   long
   */
  chapterId: string;
  /**
   * 段id  string
   */
  paragraphId: string;
  /**
   * 第一次请求传0，后续请求用返回的lastTime    long
   */
  lastTime?: string;
  /**
   * 回复id 用于消息页跳转后，该条回复置顶
   */
  replyId: string;
}

/**
 * 接口 [段评列表消息跳转接口↗](https://yapi.yuewen.com/project/2309/interface/api/176006) 的 **返回类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReviewDetail`
 * @更新时间 `2020-12-02 19:36:40`
 */
export interface GoPcmParagraphReviewGetReviewDetailResponse {
  bookInfo?: {
    /**
     * 134134132
     */
    bookId?: number;
    /**
     * "Book A"
     */
    bookName?: string;
    /**
     * "Er Gen"
     */
    authorName?: string;
    /**
     * 1
     */
    bookCoverID?: number;
    /**
     * 1557315300000
     */
    chapterId?: number;
    /**
     * "Ch 037"
     */
    chapterNumber?: string;
    /**
     * 24234234
     */
    paragraphId?: number;
    /**
     * "@paragraph"
     */
    content?: string;
  };
  topReview?: {
    /**
     * 1
     */
    reviewId?: number;
    /**
     * "@paragraph"
     */
    content?: string;
    /**
     * 11224
     */
    likeAmount?: number;
    /**
     * 23222
     */
    replyAmount?: number;
    isLiked?: number;
    /**
     * 17
     */
    floor?: number;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * "5 days ago"
     */
    createTimeFormat?: string;
    /**
     * 1234433
     */
    userId?: number;
    userRole?: number;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
    /**
     * 1
     */
    status?: number;
  };
  topReply?: {
    /**
     * 1
     */
    reviewId?: number;
    /**
     * "@paragraph"
     */
    content?: string;
    /**
     * 11224
     */
    likeAmount?: number;
    isLiked?: number;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * "5 days ago"
     */
    createTimeFormat?: string;
    /**
     * 1234433
     */
    userId?: number;
    userRole?: number;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    /**
     * "@paragraph"
     */
    pContent?: string;
    /**
     * "baba"
     */
    pUserName?: string;
    /**
     * 1
     */
    pStatus?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "crown.png"
       */
      img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "10006/1/"
     */
    holdBadgeCoverURL?: string;
  };
  /**
   * [{"reviewId":1,"content":"@paragraph","likeAmount":11224,"replyAmount":23222,"isLiked":0,"floor":17,"createTime":1537526601173,"createTimeFormat":"5 days ago","userId":1234433,"userRole":0,"userName":"@name","appId":10,"coverId":1557315300000,"privilegeInfo":{"isPrivilege":1,"img":"ic_privilege2x.png"},"userLevel":6,"holdBadgeCoverURL":"https://actimg.webnovel.com/badge/10006/1/","status":1}]
   */
  paragraphTopicItems?: {
    /**
     * 1
     */
    reviewId?: number;
    /**
     * "@paragraph"
     */
    content?: string;
    /**
     * 11224
     */
    likeAmount?: number;
    /**
     * 23222
     */
    replyAmount?: number;
    isLiked?: number;
    /**
     * 17
     */
    floor?: number;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * "5 days ago"
     */
    createTimeFormat?: string;
    /**
     * 1234433
     */
    userId?: number;
    userRole?: number;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    coverId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "ic_privilege2x.png"
       */
      img?: string;
    };
    /**
     * 6
     */
    userLevel?: number;
    /**
     * "https://actimg.webnovel.com/badge/10006/1/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1
     */
    status?: number;
  }[];
  baseInfo?: {
    baseBadgeUrl?: string;
    /**
     * "https://webbanner.webnovel.com/privilege/"
     */
    basePrivilegeUrl?: string;
    /**
     * 10812783101029604
     */
    bookId?: number;
    /**
     * 2223783101029604
     */
    chapterId?: number;
    /**
     * "108127831eee01029604"
     */
    paragraphId?: string;
  };
  userInfo?: {
    /**
     * 1
     */
    userRole?: number;
    isViceModerator?: number;
    /**
     * 1
     */
    isAuthor?: number;
  };
  /**
   * 1559138081000
   */
  lastTime?: number;
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [段评列表消息跳转接口↗](https://yapi.yuewen.com/project/2309/interface/api/176006) 的 **请求配置的类型**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReviewDetail`
 * @更新时间 `2020-12-02 19:36:40`
 */
type GoPcmParagraphReviewGetReviewDetailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/paragraphReview/getReviewDetail",
    "data",
    string,
    "chapterId" | "paragraphId" | "lastTime" | "replyId",
    false
  >
>;

/**
 * 接口 [段评列表消息跳转接口↗](https://yapi.yuewen.com/project/2309/interface/api/176006) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReviewDetail`
 * @更新时间 `2020-12-02 19:36:40`
 */
const goPcmParagraphReviewGetReviewDetailRequestConfig: GoPcmParagraphReviewGetReviewDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/getReviewDetail",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: ["chapterId", "paragraphId", "lastTime", "replyId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewGetReviewDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [段评列表消息跳转接口↗](https://yapi.yuewen.com/project/2309/interface/api/176006) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReviewDetail`
 * @更新时间 `2020-12-02 19:36:40`
 */
export const goPcmParagraphReviewGetReviewDetail = /*#__PURE__*/ (
  requestData: GoPcmParagraphReviewGetReviewDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmParagraphReviewGetReviewDetailResponse>(
    prepare(goPcmParagraphReviewGetReviewDetailRequestConfig, requestData),
    ...args
  );
};

goPcmParagraphReviewGetReviewDetail.requestConfig =
  goPcmParagraphReviewGetReviewDetailRequestConfig;

const mockUrl_0_0_0_9 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_9 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_9 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_9 = "data" as any;

/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/2309/interface/api/176038) 的 **请求类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-12-02 19:36:41`
 */
export interface GoPcmNotificationListAjax2Request {
  /**
   * lastId 上次返回的最后一条id.如果是第一次调用,传空字符串
   */
  lastId?: string;
}

/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/2309/interface/api/176038) 的 **返回类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-12-02 19:36:41`
 */
export interface GoPcmNotificationListAjax2Response {
  /**
   * [{"id":"@id","bookId":"bookId","chapterId":"chapterId","paragraphId":"ed223333455543212","paragraphReviewId":1557315300000,"chapterReviewId":1557315300000,"bookReviewId":1557315300000,"replyType":1,"replyId":1557315300000,"opType":1,"createTime":"@timestamp","createTimeFormat":"11,Nov","userId":1234433,"appId":10,"imageId":1557315300000,"userName":"@name","content":"@string","originalContent":"@string","status":1,"originalStatus":1,"novelType":100,"imageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}],"originalImageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}]},{"id":"@id","bookId":"bookId","chapterId":"chapterId","paragraphId":"ed223333455543212","paragraphReviewId":1557315300000,"chapterReviewId":1557315300000,"bookReviewId":1557315300000,"replyType":2,"replyId":1557315300000,"opType":1,"createTime":"@timestamp","createTimeFormat":"11,Nov","userId":1234433,"appId":10,"imageId":1557315300000,"userName":"@name","content":"@string","originalContent":"@string","status":1,"originalStatus":1,"novelType":100,"imageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}],"originalImageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}]},{"id":"@id","bookId":"bookId","chapterId":"chapterId","paragraphId":"ed223333455543212","paragraphReviewId":1557315300000,"chapterReviewId":1557315300000,"bookReviewId":1557315300000,"replyType":3,"replyId":1557315300000,"opType":1,"createTime":"@timestamp","createTimeFormat":"11,Nov","userId":1234433,"appId":10,"imageId":1557315300000,"userName":"@name","content":"@string","originalContent":"@string","status":1,"originalStatus":1,"novelType":100,"imageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}],"originalImageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}]}]
   */
  notificationItems?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "bookId"
     */
    bookId?: string;
    /**
     * "chapterId"
     */
    chapterId?: string;
    /**
     * "ed223333455543212"
     */
    paragraphId?: string;
    /**
     * 1557315300000
     */
    paragraphReviewId?: number;
    /**
     * 1557315300000
     */
    chapterReviewId?: number;
    /**
     * 1557315300000
     */
    bookReviewId?: number;
    /**
     * 1
     */
    replyType?: number;
    /**
     * 1557315300000
     */
    replyId?: number;
    /**
     * 1
     */
    opType?: number;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "11,Nov"
     */
    createTimeFormat?: string;
    /**
     * 1234433
     */
    userId?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    imageId?: number;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * "@string"
     */
    originalContent?: string;
    /**
     * 1
     */
    status?: number;
    /**
     * 1
     */
    originalStatus?: number;
    /**
     * 100
     */
    novelType?: number;
    /**
     * [{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}]
     */
    imageItems?: {
      /**
       * "https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif"
       */
      imageUrl?: string;
      /**
       * 498
       */
      height?: number;
      /**
       * 332
       */
      width?: number;
    }[];
    /**
     * [{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}]
     */
    originalImageItems?: {
      /**
       * "https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif"
       */
      imageUrl?: string;
      /**
       * 200
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
  }[];
  systemNotificationItem?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "@string"
     */
    title?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "11, Nov"
     */
    createTimeFormat?: string;
    /**
     * 1
     */
    type?: number;
  };
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/2309/interface/api/176038) 的 **请求配置的类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-12-02 19:36:41`
 */
type GoPcmNotificationListAjax2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/notification/listAjax",
    "data",
    string,
    "lastId",
    false
  >
>;

/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/2309/interface/api/176038) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-12-02 19:36:41`
 */
const goPcmNotificationListAjax2RequestConfig: GoPcmNotificationListAjax2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_9,
    devUrl: devUrl_0_0_0_9,
    prodUrl: prodUrl_0_0_0_9,
    path: "/go/pcm/notification/listAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_9,
    paramNames: [],
    queryNames: ["lastId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmNotificationListAjax2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/2309/interface/api/176038) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-12-02 19:36:41`
 */
export const goPcmNotificationListAjax2 = /*#__PURE__*/ (
  requestData: GoPcmNotificationListAjax2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmNotificationListAjax2Response>(
    prepare(goPcmNotificationListAjax2RequestConfig, requestData),
    ...args
  );
};

goPcmNotificationListAjax2.requestConfig =
  goPcmNotificationListAjax2RequestConfig;

/**
 * 接口 [【新】listPage 通知直出页↗](https://yapi.yuewen.com/project/2309/interface/api/176046) 的 **请求类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listPage`
 * @更新时间 `2020-12-02 19:36:41`
 */
export interface GoPcmNotificationListPageRequest {
  /**
   * lastId 上次返回的最后一条id.如果是第一次调用,传空字符串
   */
  lastId?: string;
}

/**
 * 接口 [【新】listPage 通知直出页↗](https://yapi.yuewen.com/project/2309/interface/api/176046) 的 **返回类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listPage`
 * @更新时间 `2020-12-02 19:36:41`
 */
export interface GoPcmNotificationListPageResponse {
  /**
   * [{"id":"@id","bookId":"bookId","chapterId":"chapterId","paragraphId":"ed223333455543212","paragraphReviewId":1557315300000,"chapterReviewId":1557315300000,"bookReviewId":1557315300000,"replyType":1,"replyId":1557315300000,"opType":1,"createTime":"@timestamp","createTimeFormat":"11,Nov","userId":1234433,"appId":10,"imageId":1557315300000,"userName":"@name","content":"@paragraph","originalContent":"@paragraph","status":1,"originalStatus":1,"novelType":100,"imageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}],"originalImageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}]},{"id":"@id","bookId":"bookId","chapterId":"chapterId","paragraphId":"ed223333455543212","paragraphReviewId":1557315300000,"chapterReviewId":1557315300000,"bookReviewId":1557315300000,"replyType":2,"replyId":1557315300000,"opType":1,"createTime":"@timestamp","createTimeFormat":"11,Nov","userId":1234433,"appId":10,"imageId":1557315300000,"userName":"@name","content":"@paragraph","originalContent":"@paragraph","status":1,"originalStatus":1,"novelType":100,"imageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}],"originalImageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}]},{"id":"@id","bookId":"bookId","chapterId":"chapterId","paragraphId":"ed223333455543212","paragraphReviewId":1557315300000,"chapterReviewId":1557315300000,"bookReviewId":1557315300000,"replyType":3,"replyId":1557315300000,"opType":1,"createTime":"@timestamp","createTimeFormat":"11,Nov","userId":"4300000120","appId":10,"imageId":1557315300000,"userName":"@name","content":"@paragraph","originalContent":"@paragraph","status":1,"originalStatus":1,"novelType":100,"imageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}],"originalImageItems":[{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}]}]
   */
  notificationItems?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "bookId"
     */
    bookId?: string;
    /**
     * "chapterId"
     */
    chapterId?: string;
    /**
     * "ed223333455543212"
     */
    paragraphId?: string;
    /**
     * 1557315300000
     */
    paragraphReviewId?: number;
    /**
     * 1557315300000
     */
    chapterReviewId?: number;
    /**
     * 1557315300000
     */
    bookReviewId?: number;
    /**
     * 1
     */
    replyType?: number;
    /**
     * 1557315300000
     */
    replyId?: number;
    /**
     * 1
     */
    opType?: number;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "11,Nov"
     */
    createTimeFormat?: string;
    /**
     * 1234433
     */
    userId?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * 1557315300000
     */
    imageId?: number;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * "@paragraph"
     */
    content?: string;
    /**
     * "@paragraph"
     */
    originalContent?: string;
    /**
     * 1
     */
    status?: number;
    /**
     * 1
     */
    originalStatus?: number;
    /**
     * 100
     */
    novelType?: number;
    /**
     * [{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":498,"width":332}]
     */
    imageItems?: {
      /**
       * "https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif"
       */
      imageUrl?: string;
      /**
       * 498
       */
      height?: number;
      /**
       * 332
       */
      width?: number;
    }[];
    /**
     * [{"imageUrl":"https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif","height":200,"width":200}]
     */
    originalImageItems?: {
      /**
       * "https://media.tenor.com/images/074d7cfcf221f8fdc6b51248b94a2537/tenor.gif"
       */
      imageUrl?: string;
      /**
       * 200
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
  }[];
  systemNotificationItem?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "@string"
     */
    title?: string;
    /**
     * "@paragraph"
     */
    content?: string;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "11, Nov"
     */
    createTimeFormat?: string;
    /**
     * 1
     */
    type?: number;
  };
  isLast?: number;
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300000120/1/1.jpg?mt=1553072138000"
     */
    avatar?: string;
    /**
     * "bigcat004"
     */
    nickName?: string;
    /**
     * "bigcat004"
     */
    userName?: string;
    /**
     * "4300000120"
     */
    guid?: string;
    status?: number;
    role?: number;
    penName?: null;
    /**
     * 10
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 6
     */
    grade?: number;
    /**
     * 3
     */
    ES?: number;
    /**
     * 3
     */
    totalES?: number;
    /**
     * 3
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: boolean;
    /**
     * 1554286188636
     */
    UUT?: number;
  };
}

/**
 * 接口 [【新】listPage 通知直出页↗](https://yapi.yuewen.com/project/2309/interface/api/176046) 的 **请求配置的类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listPage`
 * @更新时间 `2020-12-02 19:36:41`
 */
type GoPcmNotificationListPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/notification/listPage",
    "data",
    string,
    "lastId",
    false
  >
>;

/**
 * 接口 [【新】listPage 通知直出页↗](https://yapi.yuewen.com/project/2309/interface/api/176046) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listPage`
 * @更新时间 `2020-12-02 19:36:41`
 */
const goPcmNotificationListPageRequestConfig: GoPcmNotificationListPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_9,
    devUrl: devUrl_0_0_0_9,
    prodUrl: prodUrl_0_0_0_9,
    path: "/go/pcm/notification/listPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_9,
    paramNames: [],
    queryNames: ["lastId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmNotificationListPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【新】listPage 通知直出页↗](https://yapi.yuewen.com/project/2309/interface/api/176046) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listPage`
 * @更新时间 `2020-12-02 19:36:41`
 */
export const goPcmNotificationListPage = /*#__PURE__*/ (
  requestData: GoPcmNotificationListPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmNotificationListPageResponse>(
    prepare(goPcmNotificationListPageRequestConfig, requestData),
    ...args
  );
};

goPcmNotificationListPage.requestConfig =
  goPcmNotificationListPageRequestConfig;

/**
 * 接口 [systemList - 系统通知列表↗](https://yapi.yuewen.com/project/2309/interface/api/195895) 的 **请求类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/systemList`
 * @更新时间 `2021-01-28 15:18:11`
 */
export interface GoPcmNotificationSystemListRequest {
  /**
   * lastId 上次返回的最后一条id.如果是第一次调用,传空字符串
   *
   *
   */
  lastId?: string;
}

/**
 * 接口 [systemList - 系统通知列表↗](https://yapi.yuewen.com/project/2309/interface/api/195895) 的 **返回类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/systemList`
 * @更新时间 `2021-01-28 15:18:11`
 */
export interface GoPcmNotificationSystemListResponse {
  /**
   * [{"id":"@id","title":"@string","content":"@string","createTime":"@timestamp","createTimeFormat":"11, Nov","type":1}]
   */
  notificationItems?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "@string"
     */
    title?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "11, Nov"
     */
    createTimeFormat?: string;
    /**
     * 1
     */
    type?: number;
  }[];
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [systemList - 系统通知列表↗](https://yapi.yuewen.com/project/2309/interface/api/195895) 的 **请求配置的类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/systemList`
 * @更新时间 `2021-01-28 15:18:11`
 */
type GoPcmNotificationSystemListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/notification/systemList",
    "data",
    string,
    "lastId",
    false
  >
>;

/**
 * 接口 [systemList - 系统通知列表↗](https://yapi.yuewen.com/project/2309/interface/api/195895) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/systemList`
 * @更新时间 `2021-01-28 15:18:11`
 */
const goPcmNotificationSystemListRequestConfig: GoPcmNotificationSystemListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_9,
    devUrl: devUrl_0_0_0_9,
    prodUrl: prodUrl_0_0_0_9,
    path: "/go/pcm/notification/systemList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_9,
    paramNames: [],
    queryNames: ["lastId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmNotificationSystemList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [systemList - 系统通知列表↗](https://yapi.yuewen.com/project/2309/interface/api/195895) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/systemList`
 * @更新时间 `2021-01-28 15:18:11`
 */
export const goPcmNotificationSystemList = /*#__PURE__*/ (
  requestData: GoPcmNotificationSystemListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmNotificationSystemListResponse>(
    prepare(goPcmNotificationSystemListRequestConfig, requestData),
    ...args
  );
};

goPcmNotificationSystemList.requestConfig =
  goPcmNotificationSystemListRequestConfig;

/**
 * 接口 [status - 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/2309/interface/api/195900) 的 **请求类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/status`
 * @更新时间 `2021-01-28 15:25:38`
 */
export interface GoPcmNotificationStatusRequest {}

/**
 * 接口 [status - 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/2309/interface/api/195900) 的 **返回类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/status`
 * @更新时间 `2021-01-28 15:25:38`
 */
export interface GoPcmNotificationStatusResponse {
  /**
   * 1
   */
  messageStatus?: number;
  /**
   * 1
   */
  notificationStatus?: number;
  /**
   * 1
   */
  systemNotificationStatus?: number;
  /**
   * 1
   */
  followingStatus?: number;
}

/**
 * 接口 [status - 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/2309/interface/api/195900) 的 **请求配置的类型**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/status`
 * @更新时间 `2021-01-28 15:25:38`
 */
type GoPcmNotificationStatusRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/notification/status",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [status - 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/2309/interface/api/195900) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/status`
 * @更新时间 `2021-01-28 15:25:38`
 */
const goPcmNotificationStatusRequestConfig: GoPcmNotificationStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_9,
    devUrl: devUrl_0_0_0_9,
    prodUrl: prodUrl_0_0_0_9,
    path: "/go/pcm/notification/status",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmNotificationStatus",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [status - 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/2309/interface/api/195900) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/status`
 * @更新时间 `2021-01-28 15:25:38`
 */
export const goPcmNotificationStatus = /*#__PURE__*/ (
  requestData?: GoPcmNotificationStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmNotificationStatusResponse>(
    prepare(goPcmNotificationStatusRequestConfig, requestData),
    ...args
  );
};

goPcmNotificationStatus.requestConfig = goPcmNotificationStatusRequestConfig;

const mockUrl_0_0_0_10 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_10 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_10 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_10 = "data" as any;

/**
 * 接口 [jump↗](https://yapi.yuewen.com/project/2309/interface/api/176111) 的 **请求类型**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/jump`
 * @更新时间 `2020-12-02 19:36:41`
 */
export interface GoPcmShortUrlJumpRequest {
  /**
   * 短链接
   */
  shortUrl: string;
}

/**
 * 接口 [jump↗](https://yapi.yuewen.com/project/2309/interface/api/176111) 的 **返回类型**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/jump`
 * @更新时间 `2020-12-02 19:36:41`
 */
export interface GoPcmShortUrlJumpResponse {}

/**
 * 接口 [jump↗](https://yapi.yuewen.com/project/2309/interface/api/176111) 的 **请求配置的类型**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/jump`
 * @更新时间 `2020-12-02 19:36:41`
 */
type GoPcmShortUrlJumpRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/shortUrl/jump",
    "data",
    string,
    "shortUrl",
    false
  >
>;

/**
 * 接口 [jump↗](https://yapi.yuewen.com/project/2309/interface/api/176111) 的 **请求配置**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/jump`
 * @更新时间 `2020-12-02 19:36:41`
 */
const goPcmShortUrlJumpRequestConfig: GoPcmShortUrlJumpRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_10,
    devUrl: devUrl_0_0_0_10,
    prodUrl: prodUrl_0_0_0_10,
    path: "/go/pcm/shortUrl/jump",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_10,
    paramNames: [],
    queryNames: ["shortUrl"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmShortUrlJump",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [jump↗](https://yapi.yuewen.com/project/2309/interface/api/176111) 的 **请求函数**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/jump`
 * @更新时间 `2020-12-02 19:36:41`
 */
export const goPcmShortUrlJump = /*#__PURE__*/ (
  requestData: GoPcmShortUrlJumpRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmShortUrlJumpResponse>(
    prepare(goPcmShortUrlJumpRequestConfig, requestData),
    ...args
  );
};

goPcmShortUrlJump.requestConfig = goPcmShortUrlJumpRequestConfig;

/**
 * 接口 [生成短链↗](https://yapi.yuewen.com/project/2309/interface/api/176113) 的 **请求类型**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/generate`
 * @更新时间 `2020-12-02 19:36:41`
 */
export interface GoPcmShortUrlGenerateRequest {
  /**
   * 原链接
   */
  longUrl: string;
  /**
   * 来源
   */
  from: string;
}

/**
 * 接口 [生成短链↗](https://yapi.yuewen.com/project/2309/interface/api/176113) 的 **返回类型**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/generate`
 * @更新时间 `2020-12-02 19:36:41`
 */
export interface GoPcmShortUrlGenerateResponse {
  /**
   * "http://wbnv.in/GBBBBG"
   */
  shortUrl?: string;
}

/**
 * 接口 [生成短链↗](https://yapi.yuewen.com/project/2309/interface/api/176113) 的 **请求配置的类型**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/generate`
 * @更新时间 `2020-12-02 19:36:41`
 */
type GoPcmShortUrlGenerateRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/shortUrl/generate",
    "data",
    string,
    "longUrl" | "from",
    false
  >
>;

/**
 * 接口 [生成短链↗](https://yapi.yuewen.com/project/2309/interface/api/176113) 的 **请求配置**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/generate`
 * @更新时间 `2020-12-02 19:36:41`
 */
const goPcmShortUrlGenerateRequestConfig: GoPcmShortUrlGenerateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_10,
    devUrl: devUrl_0_0_0_10,
    prodUrl: prodUrl_0_0_0_10,
    path: "/go/pcm/shortUrl/generate",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_10,
    paramNames: [],
    queryNames: ["longUrl", "from"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmShortUrlGenerate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [生成短链↗](https://yapi.yuewen.com/project/2309/interface/api/176113) 的 **请求函数**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/generate`
 * @更新时间 `2020-12-02 19:36:41`
 */
export const goPcmShortUrlGenerate = /*#__PURE__*/ (
  requestData: GoPcmShortUrlGenerateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmShortUrlGenerateResponse>(
    prepare(goPcmShortUrlGenerateRequestConfig, requestData),
    ...args
  );
};

goPcmShortUrlGenerate.requestConfig = goPcmShortUrlGenerateRequestConfig;

const mockUrl_0_0_0_11 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_11 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_11 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_11 = "data" as any;

/**
 * 接口 [去除激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176143) 的 **请求类型**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/deactivate`
 * @更新时间 `2020-12-02 19:36:41`
 */
export interface GoPcmValidatorDeactivateRequest {
  /**
   * 邀请码
   */
  validator: string;
  /**
   * 用户ID
   */
  guid: string;
}

/**
 * 接口 [去除激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176143) 的 **返回类型**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/deactivate`
 * @更新时间 `2020-12-02 19:36:41`
 */
export interface GoPcmValidatorDeactivateResponse {}

/**
 * 接口 [去除激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176143) 的 **请求配置的类型**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/deactivate`
 * @更新时间 `2020-12-02 19:36:41`
 */
type GoPcmValidatorDeactivateRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/validator/deactivate",
    "data",
    string,
    "validator" | "guid",
    false
  >
>;

/**
 * 接口 [去除激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176143) 的 **请求配置**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/deactivate`
 * @更新时间 `2020-12-02 19:36:41`
 */
const goPcmValidatorDeactivateRequestConfig: GoPcmValidatorDeactivateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_11,
    devUrl: devUrl_0_0_0_11,
    prodUrl: prodUrl_0_0_0_11,
    path: "/go/pcm/validator/deactivate",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_11,
    paramNames: [],
    queryNames: ["validator", "guid"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmValidatorDeactivate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [去除激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176143) 的 **请求函数**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/deactivate`
 * @更新时间 `2020-12-02 19:36:41`
 */
export const goPcmValidatorDeactivate = /*#__PURE__*/ (
  requestData: GoPcmValidatorDeactivateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmValidatorDeactivateResponse>(
    prepare(goPcmValidatorDeactivateRequestConfig, requestData),
    ...args
  );
};

goPcmValidatorDeactivate.requestConfig = goPcmValidatorDeactivateRequestConfig;

/**
 * 接口 [激活用户与邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176156) 的 **请求类型**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `POST /go/pcm/validator/activate`
 * @更新时间 `2020-12-02 19:36:42`
 */
export interface GoPcmValidatorActivateRequest {
  /**
   * 用户Id
   */
  guid?: number;
  /**
   * 邀请码
   */
  validator?: string;
  /**
   * 头像链接
   */
  avatar?: string;
  /**
   * 1facebook 2 twittwer 3 google
   */
  loginType?: string;
  /**
   * 昵称
   */
  nickName?: string;
}

/**
 * 接口 [激活用户与邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176156) 的 **返回类型**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `POST /go/pcm/validator/activate`
 * @更新时间 `2020-12-02 19:36:42`
 */
export interface GoPcmValidatorActivateResponse {
  /**
   * "0"
   */
  code?: string;
}

/**
 * 接口 [激活用户与邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176156) 的 **请求配置的类型**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `POST /go/pcm/validator/activate`
 * @更新时间 `2020-12-02 19:36:42`
 */
type GoPcmValidatorActivateRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/validator/activate",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [激活用户与邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176156) 的 **请求配置**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `POST /go/pcm/validator/activate`
 * @更新时间 `2020-12-02 19:36:42`
 */
const goPcmValidatorActivateRequestConfig: GoPcmValidatorActivateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_11,
    devUrl: devUrl_0_0_0_11,
    prodUrl: prodUrl_0_0_0_11,
    path: "/go/pcm/validator/activate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmValidatorActivate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [激活用户与邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176156) 的 **请求函数**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `POST /go/pcm/validator/activate`
 * @更新时间 `2020-12-02 19:36:42`
 */
export const goPcmValidatorActivate = /*#__PURE__*/ (
  requestData: GoPcmValidatorActivateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmValidatorActivateResponse>(
    prepare(goPcmValidatorActivateRequestConfig, requestData),
    ...args
  );
};

goPcmValidatorActivate.requestConfig = goPcmValidatorActivateRequestConfig;

/**
 * 接口 [生成邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176158) 的 **请求类型**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/generate`
 * @更新时间 `2020-12-02 19:36:42`
 */
export interface GoPcmValidatorGenerateRequest {
  /**
   * thisisakeyofallkeys
   */
  authKey: string;
  /**
   * 需要生成邀请码的数量
   */
  num: string;
}

/**
 * 接口 [生成邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176158) 的 **返回类型**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/generate`
 * @更新时间 `2020-12-02 19:36:42`
 */
export type GoPcmValidatorGenerateResponse = string[];

/**
 * 接口 [生成邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176158) 的 **请求配置的类型**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/generate`
 * @更新时间 `2020-12-02 19:36:42`
 */
type GoPcmValidatorGenerateRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/validator/generate",
    "data",
    string,
    "authKey" | "num",
    false
  >
>;

/**
 * 接口 [生成邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176158) 的 **请求配置**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/generate`
 * @更新时间 `2020-12-02 19:36:42`
 */
const goPcmValidatorGenerateRequestConfig: GoPcmValidatorGenerateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_11,
    devUrl: devUrl_0_0_0_11,
    prodUrl: prodUrl_0_0_0_11,
    path: "/go/pcm/validator/generate",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_11,
    paramNames: [],
    queryNames: ["authKey", "num"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmValidatorGenerate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [生成邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176158) 的 **请求函数**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/generate`
 * @更新时间 `2020-12-02 19:36:42`
 */
export const goPcmValidatorGenerate = /*#__PURE__*/ (
  requestData: GoPcmValidatorGenerateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmValidatorGenerateResponse>(
    prepare(goPcmValidatorGenerateRequestConfig, requestData),
    ...args
  );
};

goPcmValidatorGenerate.requestConfig = goPcmValidatorGenerateRequestConfig;

/**
 * 接口 [获取用户邀请码激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176173) 的 **请求类型**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/queryActivate`
 * @更新时间 `2020-12-02 19:36:42`
 */
export interface GoPcmValidatorQueryActivateRequest {
  /**
   * 用户ID
   */
  guid: string;
}

/**
 * 接口 [获取用户邀请码激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176173) 的 **返回类型**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/queryActivate`
 * @更新时间 `2020-12-02 19:36:42`
 */
export interface GoPcmValidatorQueryActivateResponse {
  /**
   * true
   */
  isActivated?: boolean;
}

/**
 * 接口 [获取用户邀请码激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176173) 的 **请求配置的类型**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/queryActivate`
 * @更新时间 `2020-12-02 19:36:42`
 */
type GoPcmValidatorQueryActivateRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/validator/queryActivate",
    "data",
    string,
    "guid",
    false
  >
>;

/**
 * 接口 [获取用户邀请码激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176173) 的 **请求配置**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/queryActivate`
 * @更新时间 `2020-12-02 19:36:42`
 */
const goPcmValidatorQueryActivateRequestConfig: GoPcmValidatorQueryActivateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_11,
    devUrl: devUrl_0_0_0_11,
    prodUrl: prodUrl_0_0_0_11,
    path: "/go/pcm/validator/queryActivate",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_11,
    paramNames: [],
    queryNames: ["guid"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmValidatorQueryActivate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取用户邀请码激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176173) 的 **请求函数**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/queryActivate`
 * @更新时间 `2020-12-02 19:36:42`
 */
export const goPcmValidatorQueryActivate = /*#__PURE__*/ (
  requestData: GoPcmValidatorQueryActivateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmValidatorQueryActivateResponse>(
    prepare(goPcmValidatorQueryActivateRequestConfig, requestData),
    ...args
  );
};

goPcmValidatorQueryActivate.requestConfig =
  goPcmValidatorQueryActivateRequestConfig;

const mockUrl_0_0_0_12 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_12 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_12 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_12 = "data" as any;

/**
 * 接口 [获取作品消息列表 470新增↗](https://yapi.yuewen.com/project/2309/interface/api/176323) 的 **请求类型**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22998)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2020-12-02 19:36:43`
 */
export interface GoPcmMessageGetFollowing2Request {
  /**
   * “”
   */
  lastId: string;
}

/**
 * 接口 [获取作品消息列表 470新增↗](https://yapi.yuewen.com/project/2309/interface/api/176323) 的 **返回类型**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22998)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2020-12-02 19:36:43`
 */
export interface GoPcmMessageGetFollowing2Response {
  /**
   * [{"id":"@id","title":"fewfwefwef","imageUrl":"wefwfew://efwefw/1.png","content":"test message","actionUrl":"/vote","createTime":"@timestamp","createTimeFormat":"几天前","bookId":134123123,"novelType":0,"bookCoverId":1231312312}]
   */
  followingItems?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "fewfwefwef"
     */
    title?: string;
    /**
     * "wefwfew://efwefw/1.png"
     */
    imageUrl?: string;
    /**
     * "test message"
     */
    content?: string;
    /**
     * "/vote"
     */
    actionUrl?: string;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "几天前"
     */
    createTimeFormat?: string;
    /**
     * 134123123
     */
    bookId?: number;
    novelType?: number;
    /**
     * 1231312312
     */
    bookCoverId?: number;
  }[];
  user?: {
    avatar?: string;
    nickName?: string;
    userName?: string;
    guid?: string;
    /**
     * -1
     */
    status?: number;
    penName?: null;
    UUT?: null;
    role?: null;
    userLevel?: null;
    availablePower?: null;
    totalPower?: null;
    availableEnergy?: null;
    totalEnergy?: null;
  };
  /**
   * "@id"
   */
  lastId?: string;
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [获取作品消息列表 470新增↗](https://yapi.yuewen.com/project/2309/interface/api/176323) 的 **请求配置的类型**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22998)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2020-12-02 19:36:43`
 */
type GoPcmMessageGetFollowing2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/message/getFollowing",
    "data",
    string,
    "lastId",
    false
  >
>;

/**
 * 接口 [获取作品消息列表 470新增↗](https://yapi.yuewen.com/project/2309/interface/api/176323) 的 **请求配置**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22998)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2020-12-02 19:36:43`
 */
const goPcmMessageGetFollowing2RequestConfig: GoPcmMessageGetFollowing2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_12,
    devUrl: devUrl_0_0_0_12,
    prodUrl: prodUrl_0_0_0_12,
    path: "/go/pcm/message/getFollowing",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_12,
    paramNames: [],
    queryNames: ["lastId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMessageGetFollowing2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取作品消息列表 470新增↗](https://yapi.yuewen.com/project/2309/interface/api/176323) 的 **请求函数**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22998)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2020-12-02 19:36:43`
 */
export const goPcmMessageGetFollowing2 = /*#__PURE__*/ (
  requestData: GoPcmMessageGetFollowing2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMessageGetFollowing2Response>(
    prepare(goPcmMessageGetFollowing2RequestConfig, requestData),
    ...args
  );
};

goPcmMessageGetFollowing2.requestConfig =
  goPcmMessageGetFollowing2RequestConfig;

const mockUrl_0_0_0_13 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_13 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_13 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_13 = "data" as any;

/**
 * 接口 [getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/2309/interface/api/176376) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-12-03 16:35:34`
 */
export interface GoPcmBookGetBatchSubscribeGrade2Request {
  bookId: string;
  /**
   * 0：小说 100：漫画
   */
  novelType: string;
  chapterId: string;
}

/**
 * 接口 [getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/2309/interface/api/176376) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-12-03 16:35:34`
 */
export interface GoPcmBookGetBatchSubscribeGrade2Response {
  /**
   * [{"chapterCount":5,"discount":"@string","startChapterIndex":81,"endChapterIndex":85,"continueStatus":1,"originalPrice":1024,"optimalPrice":500,"gradeType":0},{"chapterCount":10,"discount":"@string","startChapterIndex":81,"endChapterIndex":85,"continueStatus":1,"originalPrice":1024,"optimalPrice":800,"gradeType":0},{"chapterCount":20,"discount":"@string","startChapterIndex":81,"endChapterIndex":85,"continueStatus":1,"originalPrice":1025,"optimalPrice":1025,"gradeType":0}]
   */
  batchSubscribeGradeList?: {
    /**
     * 5
     */
    chapterCount?: number;
    /**
     * "@string"
     */
    discount?: string;
    /**
     * 81
     */
    startChapterIndex?: number;
    /**
     * 85
     */
    endChapterIndex?: number;
    /**
     * 1
     */
    continueStatus?: number;
    /**
     * 1024
     */
    originalPrice?: number;
    /**
     * 500
     */
    optimalPrice?: number;
    gradeType?: number;
  }[];
  /**
   * 1000
   */
  balance?: number;
}

/**
 * 接口 [getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/2309/interface/api/176376) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-12-03 16:35:34`
 */
type GoPcmBookGetBatchSubscribeGrade2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/getBatchSubscribeGrade",
    "data",
    string,
    "bookId" | "novelType" | "chapterId",
    false
  >
>;

/**
 * 接口 [getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/2309/interface/api/176376) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-12-03 16:35:34`
 */
const goPcmBookGetBatchSubscribeGrade2RequestConfig: GoPcmBookGetBatchSubscribeGrade2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getBatchSubscribeGrade",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: ["bookId", "novelType", "chapterId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBatchSubscribeGrade2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/2309/interface/api/176376) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-12-03 16:35:34`
 */
export const goPcmBookGetBatchSubscribeGrade2 = /*#__PURE__*/ (
  requestData: GoPcmBookGetBatchSubscribeGrade2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetBatchSubscribeGrade2Response>(
    prepare(goPcmBookGetBatchSubscribeGrade2RequestConfig, requestData),
    ...args
  );
};

goPcmBookGetBatchSubscribeGrade2.requestConfig =
  goPcmBookGetBatchSubscribeGrade2RequestConfig;

/**
 * 接口 [unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/2309/interface/api/176381) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-12-03 16:35:41`
 */
export interface GoPcmBookUnlockBatchChapters2Request {
  bookId: string;
  novelType: string;
  chapterId: string;
  /**
   * 档位对应章节数
   */
  chapterCount: string;
  price: string;
  /**
   * 算法字段 用于上报
   */
  statParams: string;
}

/**
 * 接口 [unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/2309/interface/api/176381) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-12-03 16:35:41`
 */
export interface GoPcmBookUnlockBatchChapters2Response {
  unlockResult?: {
    unlocked?: number;
    noBalance?: number;
    refreshPage?: number;
  };
}

/**
 * 接口 [unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/2309/interface/api/176381) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-12-03 16:35:41`
 */
type GoPcmBookUnlockBatchChapters2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/unlockBatchChapters",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/2309/interface/api/176381) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-12-03 16:35:41`
 */
const goPcmBookUnlockBatchChapters2RequestConfig: GoPcmBookUnlockBatchChapters2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/unlockBatchChapters",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookUnlockBatchChapters2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/2309/interface/api/176381) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-12-03 16:35:41`
 */
export const goPcmBookUnlockBatchChapters2 = /*#__PURE__*/ (
  requestData: GoPcmBookUnlockBatchChapters2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookUnlockBatchChapters2Response>(
    prepare(goPcmBookUnlockBatchChapters2RequestConfig, requestData),
    ...args
  );
};

goPcmBookUnlockBatchChapters2.requestConfig =
  goPcmBookUnlockBatchChapters2RequestConfig;

/**
 * 接口 [unlockChpater-解锁章节 ↗](https://yapi.yuewen.com/project/2309/interface/api/177828) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockChapter`
 * @更新时间 `2022-03-31 21:22:55`
 */
export interface GoPcmBookUnlockChapterRequest {
  /**
   * 7731137901014305
   */
  bookId: string;
  chapterId: string;
  /**
   * 5
   */
  unlockType: string;
  price: string;
  font?: string;
}

/**
 * 接口 [unlockChpater-解锁章节 ↗](https://yapi.yuewen.com/project/2309/interface/api/177828) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockChapter`
 * @更新时间 `2022-03-31 21:22:55`
 */
export interface GoPcmBookUnlockChapterResponse {
  /**
   * [{"contentId":"@string","content":"@string","appId":1,"userId":1,"paragraphId":"@string","likeAmount":1,"contentAmount":1,"userName":"@string","UUT":"@timestamp","isLiked":1}]
   */
  contents?: {
    /**
     * "@string"
     */
    contentId?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * 1
     */
    appId?: number;
    /**
     * 1
     */
    userId?: number;
    /**
     * "@string"
     */
    paragraphId?: string;
    /**
     * 1
     */
    likeAmount?: number;
    /**
     * 1
     */
    contentAmount?: number;
    /**
     * "@string"
     */
    userName?: string;
    /**
     * "@timestamp"
     */
    UUT?: string;
    /**
     * 1
     */
    isLiked?: number;
  }[];
  /**
   * [0,1,2,3]
   */
  encryptType?: number[];
  /**
   * "@string"
   */
  encryptKeyPool?: string;
  /**
   * 1
   */
  encryptVersion?: number;
  isAuth?: string;
  isRichFormat?: number;
  needRefresh?: number;
  /**
   * 10
   */
  costCoins?: number;
  /**
   * 20
   */
  balanceCoins?: number;
}

/**
 * 接口 [unlockChpater-解锁章节 ↗](https://yapi.yuewen.com/project/2309/interface/api/177828) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockChapter`
 * @更新时间 `2022-03-31 21:22:55`
 */
type GoPcmBookUnlockChapterRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/unlockChapter",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [unlockChpater-解锁章节 ↗](https://yapi.yuewen.com/project/2309/interface/api/177828) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockChapter`
 * @更新时间 `2022-03-31 21:22:55`
 */
const goPcmBookUnlockChapterRequestConfig: GoPcmBookUnlockChapterRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/unlockChapter",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookUnlockChapter",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [unlockChpater-解锁章节 ↗](https://yapi.yuewen.com/project/2309/interface/api/177828) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockChapter`
 * @更新时间 `2022-03-31 21:22:55`
 */
export const goPcmBookUnlockChapter = /*#__PURE__*/ (
  requestData: GoPcmBookUnlockChapterRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookUnlockChapterResponse>(
    prepare(goPcmBookUnlockChapterRequestConfig, requestData),
    ...args
  );
};

goPcmBookUnlockChapter.requestConfig = goPcmBookUnlockChapterRequestConfig;

/**
 * 接口 [setReadingSettings 设置字体颜色等↗](https://yapi.yuewen.com/project/2309/interface/api/191358) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/setReadingSettings`
 * @更新时间 `2021-02-25 14:46:32`
 */
export interface GoPcmBookSetReadingSettingsRequest {
  tc: string;
  tf: string;
  ts: string;
  paragraphSwitch?: string;
}

/**
 * 接口 [setReadingSettings 设置字体颜色等↗](https://yapi.yuewen.com/project/2309/interface/api/191358) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/setReadingSettings`
 * @更新时间 `2021-02-25 14:46:32`
 */
export interface GoPcmBookSetReadingSettingsResponse {}

/**
 * 接口 [setReadingSettings 设置字体颜色等↗](https://yapi.yuewen.com/project/2309/interface/api/191358) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/setReadingSettings`
 * @更新时间 `2021-02-25 14:46:32`
 */
type GoPcmBookSetReadingSettingsRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/setReadingSettings",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [setReadingSettings 设置字体颜色等↗](https://yapi.yuewen.com/project/2309/interface/api/191358) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/setReadingSettings`
 * @更新时间 `2021-02-25 14:46:32`
 */
const goPcmBookSetReadingSettingsRequestConfig: GoPcmBookSetReadingSettingsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/setReadingSettings",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookSetReadingSettings",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [setReadingSettings 设置字体颜色等↗](https://yapi.yuewen.com/project/2309/interface/api/191358) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/setReadingSettings`
 * @更新时间 `2021-02-25 14:46:32`
 */
export const goPcmBookSetReadingSettings = /*#__PURE__*/ (
  requestData: GoPcmBookSetReadingSettingsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookSetReadingSettingsResponse>(
    prepare(goPcmBookSetReadingSettingsRequestConfig, requestData),
    ...args
  );
};

goPcmBookSetReadingSettings.requestConfig =
  goPcmBookSetReadingSettingsRequestConfig;

/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/191677) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookDetailPage`
 * @更新时间 `2024-10-21 14:50:43`
 */
export interface GoPcmBookGetBookDetailPageRequest {
  bookId: string;
}

/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/191677) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookDetailPage`
 * @更新时间 `2024-10-21 14:50:43`
 */
export interface GoPcmBookGetBookDetailPageResponse {
  bookInfo?: {
    /**
     * "7366916601012405"
     */
    bookId?: string;
    /**
     * "The King's Avatar"
     */
    bookName?: string;
    /**
     * "TKA"
     */
    bookSubName?: string;
    /**
     * "Butterfly Blue"
     */
    authorName?: string;
    /**
     * "3626681903122401"
     */
    authorId?: string;
    /**
     * 70008
     */
    categoryId?: number;
    /**
     * "Video Games"
     */
    categoryName?: string;
    /**
     * 682
     */
    chapterNum?: number;
    /**
     * 682
     */
    totalChapterNum?: number;
    /**
     * 30
     */
    actionStatus?: number;
    /**
     * "In the online game Glory, Ye Xiu is regarded as a textbook and a top-tier pro-player. However, due to a myriad reasons, he is kicked from the team. After leaving the professional scene, he finds work in an Internet Cafe as a manager. When Glory launches its tenth server, he who possesses ten years of gaming experience once again throws himself into the game. Bringing with him the memories of his past and an incomplete, self-made weapon, his return along the road to the summit begins!\r\n\r\nAfter fighting and scheming, who snatched away my glory? Under the tossing of the wind and rain, my dreams shall still appear as though they had never been shattered. In all its splendor, the path shall never be lost. Before the gazes of millions, this is where I return !"
     */
    description?: string;
    /**
     * "2M"
     */
    pvNum?: string;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * 1
     */
    type?: number;
    /**
     * "1887208"
     */
    QDBID?: string;
    /**
     * "4.2"
     */
    totalScore?: string;
    /**
     * 262
     */
    voters?: number;
    expected?: number;
    /**
     * "Unselected"
     */
    ageGroup?: string;
    updateFrequency?: number;
    /**
     * 21
     */
    promiseUpdateFrequency?: number;
    /**
     * 1
     */
    frequencyUnit?: number;
    /**
     * 1
     */
    promiseFrequencyUnit?: number;
    /**
     * "45727419184774513"
     */
    newChapterId?: string;
    newChapterName?: string;
    /**
     * "9 months ago"
     */
    newChapterTime?: string;
    /**
     * 682
     */
    newChapterIndex?: number;
    /**
     * "19775416453662908"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    translateMode?: number;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "zh"
     */
    languageName?: string;
    /**
     * [{"bookName":"全职高手","url":"https://oabook.qidian.com/info/1887208"}]
     */
    language?: {
      /**
       * "全职高手"
       */
      bookName?: string;
      /**
       * "https://oabook.qidian.com/info/1887208"
       */
      url?: string;
    }[];
    /**
     * [{"id":"19363452317401368","name":"Translation Nation"}]
     */
    editorItems?: {
      /**
       * "19363452317401368"
       */
      id?: string;
      /**
       * "Translation Nation"
       */
      name?: string;
    }[];
    /**
     * [{"id":"19363452317401368","name":"Translation Nation"}]
     */
    translatorItems?: {
      /**
       * "19363452317401368"
       */
      id?: string;
      /**
       * "Translation Nation"
       */
      name?: string;
    }[];
    /**
     * [{"name":"Butterfly Blue"}]
     */
    authorItems?: {
      /**
       * "Butterfly Blue"
       */
      name?: string;
    }[];
    /**
     * "19775416453662908"
     */
    readToChapterId?: string;
    /**
     * "1"
     */
    readToChapterIndex?: string;
    /**
     * "The Banished Battle God"
     */
    firstChapterName?: string;
    /**
     * "The Banished Battle God"
     */
    readToChapterName?: string;
    patreonLink?: string;
    /**
     * [{"jumpLink":"http://baidu.com","description":"I like this animation1"},{"jumpLink":"https://baidu.com","description":"I like this animation2"}]
     */
    animationItems?: {
      /**
       * "http://baidu.com"
       */
      jumpLink?: string;
      /**
       * "I like this animation1"
       */
      description?: string;
    }[];
    /**
     * [{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla","role":"author"},{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla test    blabla  \n testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla test \n testblabla testblabla testblabla \n testblabla testblabla testblabla testblabla testblabla testblabla  testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavvvvv testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavtestblabla testblabla test test","role":"translator"}]
     */
    notes?: {
      /**
       * "https://oaimg.webnovel.com/userheadimg/1/1/1.png"
       */
      avatar?: string;
      /**
       * "zhangsan"
       */
      name?: string;
      /**
       * "blabla"
       */
      note?: string;
      /**
       * "author"
       */
      role?: string;
    }[];
    advText?: string;
    advActionUrl?: string;
    picPC?: string;
    feverLink?: string;
    translateVoters?: null;
    isVoted?: null;
    hasVote?: null;
    giftInfo?: {
      giftNum?: number;
      giftMax?: {
        /**
         * 15927
         */
        id?: number;
        /**
         * "7366916601012405"
         */
        bookId?: string;
        /**
         * "19775416453662908"
         */
        chapterId?: string;
        /**
         * 4300000390
         */
        userId?: number;
        /**
         * 1
         */
        giftAmount?: number;
        /**
         * "6665224524910655505"
         */
        orderId?: string;
        /**
         * 20008
         */
        giftId?: number;
        /**
         * 8888
         */
        totalPrice?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Lollipop"
         */
        giftName?: string;
        /**
         * 6666
         */
        giftPrice?: number;
        /**
         * "https://webbannertest.webnovel.com/gift/1535014273_1546.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        UUT?: number;
        /**
         * "Candy"
         */
        userName?: string;
      };
      /**
       * [{"id":17089,"userId":4300013216,"giftId":20002,"appId":10,"giftName":"Lollipop","giftPrice":25,"iconUrl":"https://webbannertest.webnovel.com/gift/1535014017_3329.png","status":1,"order":1,"UUT":0,"userName":"liwen369183"},{"id":17080,"userId":4300000563,"giftId":20004,"appId":10,"giftName":"Turkey","giftPrice":200,"iconUrl":"https://webbannertest.webnovel.com/gift/1567410347_6132.png","status":1,"order":1,"UUT":1587113770560,"userName":"zhangchen"}]
       */
      giftRecords?: {
        /**
         * 17089
         */
        id?: number;
        /**
         * 4300013216
         */
        userId?: number;
        /**
         * 20002
         */
        giftId?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Lollipop"
         */
        giftName?: string;
        /**
         * 25
         */
        giftPrice?: number;
        /**
         * "https://webbannertest.webnovel.com/gift/1535014017_3329.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        UUT?: number;
        /**
         * "liwen369183"
         */
        userName?: string;
      }[];
    };
    /**
     * [{"userId":4300009639,"appId":10,"votingCount":39382,"UUT":1604656231478,"userName":"liwenwen"},{"userId":4300011791,"appId":10,"votingCount":6729,"UUT":1608805208979,"userName":"ar1609924587162"}]
     */
    topFanItems?: {
      /**
       * 4300009639
       */
      userId?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * 39382
       */
      votingCount?: number;
      /**
       * 1604656231478
       */
      UUT?: number;
      /**
       * "liwenwen"
       */
      userName?: string;
    }[];
    tagInfo?: {
      /**
       * []
       */
      popularItems?: unknown[];
      /**
       * []
       */
      userItems?: unknown[];
    };
    /**
     * [{"name":"@string"}]
     */
    relatedWords?: {
      /**
       * "@string"
       */
      name?: string;
    }[];
    /**
     * "1581418734974"
     */
    coverUpdateTime?: string;
    essayInfo?: {
      icon?: string;
      text?: string;
      actionUrl?: string;
    };
  };
  /**
   * 1
   */
  curReadChapter?: number;
  /**
   * [{"reviewId":"@id","content":"[img=fp]@paragraph","isViceModerator":0,"isLikedByAuthor":0,"imageItems":[{"imageUrl":"@url","height":100,"width":200}],"holdBadgeCoverId":1231313123123,"bookId":10812783101029604,"userId":3968405415,"userName":"@name","headImageId":-123,"userRole":0,"userGrade":1,"totalScore":5,"replyNums":10,"likeNums":20,"leakFlag":0,"isLike":1,"holdBadgeCoverURL":"www.baidu.com","createTime":1537526601173,"createTimeFormat":"@string","topStatus":0,"appId":10,"privilegeInfo":{"isPrivilege":1,"img":"crown.png"},"essenceStatus":1}]
   */
  bookReviewInfos?: {
    /**
     * "@id"
     */
    reviewId?: string;
    /**
     * "[img=fp]@paragraph"
     */
    content?: string;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * [{"imageUrl":"@url","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "@url"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
    /**
     * 10812783101029604
     */
    bookId?: number;
    /**
     * 3968405415
     */
    userId?: number;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * -123
     */
    headImageId?: number;
    userRole?: number;
    /**
     * 1
     */
    userGrade?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * 10
     */
    replyNums?: number;
    /**
     * 20
     */
    likeNums?: number;
    leakFlag?: number;
    /**
     * 1
     */
    isLike?: number;
    /**
     * "www.baidu.com"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * "@string"
     */
    createTimeFormat?: string;
    topStatus?: number;
    /**
     * 10
     */
    appId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "crown.png"
       */
      img?: string;
    };
    /**
     * 1
     */
    essenceStatus?: number;
  }[];
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300000889/1/1.jpg?mt=1609324312000"
     */
    avatar?: string;
    /**
     * "yabger"
     */
    nickName?: string;
    /**
     * "yabger"
     */
    userName?: string;
    /**
     * "4300000889"
     */
    guid?: string;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * "yabger"
     */
    penName?: string;
    /**
     * 10903
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 4
     */
    grade?: number;
    /**
     * 2
     */
    ES?: number;
    /**
     * 2
     */
    totalES?: number;
    /**
     * 3
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: boolean;
    /**
     * 1599056425650
     */
    UUT?: number;
    /**
     * 49
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 2
     */
    membershipStatus?: number;
    /**
     * 1609310006000
     */
    membershipExpireTime?: number;
    /**
     * true
     */
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/191677) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookDetailPage`
 * @更新时间 `2024-10-21 14:50:43`
 */
type GoPcmBookGetBookDetailPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/getBookDetailPage",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/191677) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookDetailPage`
 * @更新时间 `2024-10-21 14:50:43`
 */
const goPcmBookGetBookDetailPageRequestConfig: GoPcmBookGetBookDetailPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getBookDetailPage",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBookDetailPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/191677) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookDetailPage`
 * @更新时间 `2024-10-21 14:50:43`
 */
export const goPcmBookGetBookDetailPage = /*#__PURE__*/ (
  requestData: GoPcmBookGetBookDetailPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetBookDetailPageResponse>(
    prepare(goPcmBookGetBookDetailPageRequestConfig, requestData),
    ...args
  );
};

goPcmBookGetBookDetailPage.requestConfig =
  goPcmBookGetBookDetailPageRequestConfig;

/**
 * 接口 [getBookLandingPage 小说落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191811) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookLandingPage`
 * @更新时间 `2024-08-22 19:05:56`
 */
export interface GoPcmBookGetBookLandingPageRequest {
  bookId: string;
  /**
   * 支持多章预览，不超过20章，不传为1章
   */
  chapters: string;
  /**
   * 章节开始index
   */
  from: string;
}

/**
 * 接口 [getBookLandingPage 小说落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191811) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookLandingPage`
 * @更新时间 `2024-08-22 19:05:56`
 */
export interface GoPcmBookGetBookLandingPageResponse {
  bookInfo?: {
    /**
     * "7765063201015805"
     */
    bookId?: string;
    /**
     * "Jun Jiuling"
     */
    bookName?: string;
    /**
     * "JJ"
     */
    bookSubName?: string;
    /**
     * "Xi Xing"
     */
    authorName?: string;
    /**
     * 1
     */
    type?: number;
    totalScore?: number;
    /**
     * 6
     */
    voters?: number;
    /**
     * 70001
     */
    categoryId?: number;
    /**
     * "Magical Realism"
     */
    categoryName?: string;
    /**
     * "In the winter. of Taikang Year 3, a girl pays a visit. to her future in-laws, the. Ning Family of Beiliu, Yangcheng.\r\n\r\nAfter her engagement was. denied, the girl decided. to hang herself in front of the Ning. Family to show them. her sincerity.\r\n\r\nWhen the girl. who had died opened her eyes once. more, many people's fates. were changed forever."
     */
    description?: string;
    /**
     * "@pick([1,2])"
     */
    sex?: string;
    /**
     * "en"
     */
    languageName?: string;
    /**
     * "@timestamp"
     */
    coverUpdateTime?: string;
    /**
     * [{"id":"18313177389384760","name":"chrissy"}]
     */
    groupItems?: {
      /**
       * "18313177389384760"
       */
      id?: string;
      /**
       * "chrissy"
       */
      name?: string;
    }[];
    /**
     * [{"id":"18313177389384760","userId":1767799206,"guid":1767799206,"name":"chrissy"}]
     */
    editorItems?: {
      /**
       * "18313177389384760"
       */
      id?: string;
      /**
       * 1767799206
       */
      userId?: number;
      /**
       * 1767799206
       */
      guid?: number;
      /**
       * "chrissy"
       */
      name?: string;
    }[];
    /**
     * [{"id":"6830832501003200","userId":41830698,"guid":41830698,"name":"clarkzhangss"}]
     */
    translatorItems?: {
      /**
       * "6830832501003200"
       */
      id?: string;
      /**
       * 41830698
       */
      userId?: number;
      /**
       * 41830698
       */
      guid?: number;
      /**
       * "clarkzhangss"
       */
      name?: string;
    }[];
  };
  /**
   * [{"chapterId":"","chapterName":null,"content":"The light filtered in through the window and onto the folding screen. It was painted with a landscape scene, which cast a mottled shadow.\r\nJust because this was only a small room of the Ning Family for receiving guests, it did not mean it was overlooked. It was still decorated elaborately with expensive gold and jade ornaments. The luxurious decorations had the refined elegance of a learned family.\r\nToday, the weather was very pleasant. The fire in the fretwork stove was blazing. Two servant girls wearing winter clothing had a thin sheen of sweat on their noses. But the warm, springlike feeling did not make people feel pleasant as it had in the past. Instead, there was a kind of indescribable sense of oppression and impatience.\r\nSomeone lifted up the curtains and entered the room. Alongside the person came the winter wind from the courtyard. It was unknown whether it was the wind or the person coming that roused the two servant girls’ attention and made them hurriedly step forward.\r\nThe one who entered was another girl carrying an exquisite bronze kettle. It was quickly taken by one of the girls who then also picked up a cloisonne enamel teacup from the table on the side.\r\nThese series of moves did not make any noise, but it broke the stagnant atmosphere of the room. \r\n“Please drink some tea, Miss Jun,” the girl whispered. She carried the cup over while looking at the person who sat down on the chair.\r\nIt was a fourteen or fifteen-year-old girl. She was pretty as a picture without wearing any makeup and without even a hairpin or beads. She wore a green plain cotton dress which was faded from constant wash.\r\nThe sumptuous waiting room she was sitting in was not poor looking in the least. Rather, it made people feel it had an exquisite elegance of flowering orchids.\r\nYet when the servant girl’s gaze fell onto the table, it was like she had been stung by a bee. With her gaze directed downwards, her mood became complicated.\r\nOn the red wooden table inlaid with jadeite laid a swathe of white silk. It was especially eye-catching against the red and green.\r\nAt present, there was an aged woman looking at that swathe of white silk.\r\nThe Ning Family of Beiliu, Yangcheng, not only produced a dozen imperial secretaries of the Hanlin Imperial Academy, but also possessed half of the Ze Prefecture’s coal reservoirs. So, the small waiting room window was not made of ordinary window paper, but of glass from the south seas.\r\nIn the whole of Yangcheng, and even in the whole of the Ze Prefecture, there were only two families who could use this kind of glass.\r\nThe glass was somewhat fuzzy, but the woman could still see the swathe of silk and the girl’s silhouette.\r\nThis was not the first time she had seen the girl. She had, actually, come here two days ago but hadn’t taken out the white silk at the time. \r\nThe girl extended a hand to take the teacup and took a sip. Wrinkling her eyebrows, she set it down.\r\nThe woman could only guess as to why.\r\nShe could see the girl’s facial appearance through the multi-colored glass, but not her minute expressions.\r\nYet, after seeing the girl put down the cup, she was almost certain it was because the only kind of tea in the room was Yuqian Longjing [1] tea.\r\nAlthough this girl wore shabby clothing, she came from the other family in the Ze Prefecture that could have glass windows, the Fang Financial Exchange.\r\nHer surname was Jun. Her mother was the eldest daughter of the Fang Family. Although she married into a poorer family, the extravagance of her wedding, which took place several years ago, was still being discussed among the people of Ze Prefecture.\r\nA miss of that family would not be accustomed to drinking the rough tea like Yuqian Longjing. At least, the last time she had come to visit, the servant girl had brought Mingqian Longjing [2] tea.\r\nThe woman watched the room. The girl, who had set down her cup, had a beautiful sitting posture as she waited without the slightest bit of impatience. The little servant girl standing next to her pulled at her sleeve.\r\n“Give my servant girl a cup of tea,” Miss Jun said.\r\nThe woman heard the soft voice come from the room.\r\nThe servant girl immediately served a cup of tea to the little girl. She happily took the cup and drank it.\r\n“Another cup,” the young servant girl said.\r\nUnlike the last time they had paid a visit, she was no longer shy. Instead, she was confident and proud.\r\n{They probably thought that they could intimidate us.}\r\nA sneer flashed across the woman’s eyes.\r\n“Mama Song,\" a young servant girl called out while waving quietly at the woman.\r\nThe woman turned to leave from the windowside and passed through a narrow path to another courtyard. Servant girls stood on the veranda of the main courtyard building, talking and laughing. The sound of bright banter and laughter came from behind the door curtains, which were embroidered with thick golden thread.\r\nUpon seeing the woman arrive, all the chatting girls called out, “Mama Song!”\r\nThen, they spoke to someone inside the room, and two servant girls pulled open the curtains, letting the woman strode in. A soft fragrance assailed her senses. There were many people either standing or sitting in the room, however, all of their gazes and actions revolved around the middle-aged woman in the center.\r\nShe looked to be over forty years old and had elegant features with long eyebrows delicately traced on. There was a soft smile on her face as she listened to the two women seated in front of her.\r\nThe two were a bit younger, each wearing extravagant clothing.\r\nAround a large square table in the eastern side of the room, three teenage girls sat. Each of them wore a red coat over a yellow dress, and all were beautiful. However, unlike the outer room filled with faint laughter, their room was silent as they wrote characters.\r\nMama Song did not immediately speak, but rather took a cup of tea from a servant girl on the side and stood next to the women, listening to their talk with a smile.\r\n“Eldest Sister-in-law, the winter stage has already been set up in front of the temple.”\r\n“I must trouble Third Sister-in-law to deal with the matters of the theater troupe. I do not care much about them.”\r\n“This month, there has been more than the usual amount of refugees. The turmoil in the northern border is becoming more and more serious. I am making preparations to hand out gruel.”\r\n“Second Sister-in-law will also send out people to help with that.”\r\nThe sisters-in-law talked while the middle-aged woman smiled and nodded.\r\n“Good, this plan is very good. I must trouble all of you,” she said.\r\nThe Ning Family’s Eldest Madam was friendly and benevolent. She was filial to her parents-in-law and respectful to her sisters-in-law. Everyone praised her.\r\nAfter responding to the the younger women, Eldest Madam turned to look at Mama Song.\r\n“Did you see someone?” she asked.\r\nThis open-ended question halted all conversation in the room.\r\nMama Song voiced her agreement.\r\n“Eldest Sister-in-law, why did the young miss of the Jun Family come again? Didn’t she leave?” questioned Third Madam Ning next to her.\r\nEldest Madam Ning smiled and set down her teacup.\r\n“She did not leave. She found an inn nearby and played a joke about committing suicide, and now she has come again,” she said.\r\nSuicide?\r\nThird Madam Ning and Fourth Madam Ning exchanged looks.\r\n“This is too excessive. Could it be that the Fang Family doesn’t care?”\r\n“Or could it be that the Fang Family did it on purpose?”\r\nThey frowned as they spoke angrily.\r\nEldest Madam Ning shook her head.\r\n“It was definitely not on purpose or to cause any trouble,\" she said.\r\nThe two sisters-in-law smiled.\r\n“Eldest Sister-in-law is so benevolent in her judgement of others,” they said while sighing.\r\nA girl in the eastern side room, who had been listening very closely to the talk, violently turned her head around.\r\n“Mother, it is not rare for Jun Zhenzhen to do such things. She acts tyrannically within the Fang Family! The Eldest Madam of the Fang Family only tried to talk to her, and she instantly threatened to commit suicide, even going as far as suggesting to go to the feudal authority to tell her uncle about how she was being abused!” she exclaimed.\r\nThese words shocked the people in the room.\r\n“Yanyan.” Eldest Madam Ning frowned. Discussing others behind their back wasn’t a behavior that a girl from a noble family should have.\r\nThis was Eldest Madam Ning’s eldest daughter, the seventeenth eldest in her generation of the Ning Family, Ning Yunyan.\r\n“Eldest Aunt, Eldest Aunt, it’s really true! She is a young miss from a government official family and looks down on her maternal family because they are merchants.”\r\n“I know some of it too. I saw her and another person ridicule her older cousin at a banquet. It resulted in her older cousin withdrawing herself from the event, crying!”\r\nThe other two girls hurried to speak.\r\nThe three continuously chattered, and none of them were discouraged by Eldest Madam Ning’s soft voice. Soon, the room became chaotic.\r\nThis Miss Jun had only been in Yangcheng for half a year, yet she already had a reputation that rang loud and clear in everyone’s minds. Furthermore, this reputation was not a good one.\r\n“The Fang Family are uncouth merchants,” said Third Madam Ning while frowning. “This Miss Jun’s father came from a scholarly background. With one side of the parentage being government officials, how could they raise such a daughter?”\r\nHow others’ daughters were raised was of no concern; daughters from other families had nothing to do with their Ning Family, but it was just that this daughter of the Jun Family shouted out that she had an engagement with their Ning Family.\r\n“The engagement is real?” Fourth Madam Ning could not help but ask. “She truly has an engagement with our family’s Zhao’er? Did Father-in-law confirm it? This is a big issue, and Father-in-law never said anything about it in his life.”\r\nEldest Madam Ning sighed with helplessness.\r\n“I asked Mother, and she said that Father-in-law has met the master of the Jun Family,” she said. “Fifteen years ago, Father-in-law resigned from his post and decided to travel the world. While he was going through Runan, he fell ill. He was diagnosed by Doctor Jun, who was passing by as he returned from a housecall. Doctor Jun prescribed him medicine and cured his illness. Father-in-law could not thank him enough. He heard that Doctor Jun’s son just got married and blurted out without thinking that their families should marry. At that time, Zhao’er was just three years old.”\r\nCould not thank him enough. Blurted it out.\r\nThe implications of these phrases were instantly understood by the two madams in the room.\r\n“The master of the Jun Family was a doctor, so wasn’t giving sick people treatment only natural for him?” asked Third Madam Ning. “Father-in-law was just rambling out of gratefulness. Does that doctor not know the duty of a physician?”\r\nIt seems that he just had an idea of hitching a ride with a dragon and a phoenix [3]. If not, then he wouldn’t have disregarded his status and truly agreed to the marriage.\r\n“Maybe Father-in-law was coerced at that time,” said Fourth Madam Ning while shaking her head.\r\nOtherwise, the master would have never said something as big as betrothing the eldest son of the eldest branch.\r\n“Father-in-law never brought this up, so I don’t know what is going on,” said Eldest Madam Ning. When she said this, her voice took on a more serious tone. “The Old Madam declared that none of this is to happen. When the people from the Fang Family came to inquire about the matter, I had gently explained it to them. However, it seems that the young miss of Jun Family did not hear it. The Old Madam’s body is not well; I do not dare to make her go out herself. The young miss of the Jun Family lost her parents at a young age and is very pitiful. I also do not want to be too forceful with her…”\r\n“Mother!” Ning Yunyan had already stopped writing characters, so she immediately stood up and cried out, “She is pitiful, but Tenth Elder Brother is not pitiful. Tenth Elder Brother is just unlucky? Her parents did not die because of us, so why must we use such a major part of Tenth Elder Brother’s life to compensate her?”\r\n“Yes, yes. Tenth Elder Brother is a genius praised even by the Emperor. How could he be encumbered with a vulgar, ignorant person like Jun Zhenzhen?” The other two girls immediately followed up.\r\nThe room again broke into disorder.\r\nEldest Madam Ning seemed to have a headache from the noise as she kneaded her forehead with a helpless expression.\r\n“But I can not just watch blankly as the young miss of the Jun Family commits suicide before my eyes,” she said.\r\n“Right now, she has brought out a bolt of silk and laid it out on the table. It is an obvious threat,” interjected Mama Song. “Last time, she threatened to hang herself in the inn, and now, she might swear to do it on our doorway.”\r\n“She dares!” cried Third Madam Ning, eyebrows raised.\r\n[1] Longjing: a variety of green tea. Yuqian: picked before mid-april\r\n[2] Mingqian: before \"pure brightness\" or beginning of april\r\n[3] Hitching a ride with a dragon and a phoenix: curry favor with the rich in the hopes of advancement\r\n \r\n \r\n"},{"chapterId":"","chapterName":null,"content":"Ze Prefecture, Yangcheng, Beiliu Town, Ning Family. Since their ancestor had dug up that first lump of coal from the Beiliu Town hills, they had existed for two hundred seventy years.\r\nOver one hundred years ago, the Ning Family was not only fabulously rich, but the Ning Family patriarch also spent the family wealth to establish his clan’s learnedness by hiring famed scholars. The descendants of the clan lived up to their expectations. In the latter century they had produced forty candidates for the imperial civil service examination, twenty of whom passed the imperial provincial civil service examination. Out of those nine passed the imperial palace civil service examination, and six entered the Hanlin Imperial Academy. Thus, the Ning Family acquired the reputation of the \"Nine palace graduates from accumulated benevolence, and six Hanlin imperial secretaries from three worlds of goodness and dignity.\" [Note 1]\r\nA hundred years and forty descendants as government officials had spread the reputation of the Ning Family far to the north and south. According to the genealogy records, there were over a dozen locations where Ning officials went to officiate.\r\nToday, the second eldest son of the older generation was the Right Vice-Minister in the Ministry of Works.\r\nWith such a grand clan of over a hundred years in power, it was inconceivable that there would be a person who would actually provoke them like this, and it was absolutely intolerable.\r\nFourth Madam Ning was very angry.\r\n“What does she take our Ning Family for? If she wants to hang herself, then let her hang.” The Fourth Madam stood up. “Eldest Sister-in-law, it is not proper for you to meet her. I will go meet her and set her straight.”\r\nAfter she said it, she turned to leave.\r\n“Fourth Sister-in-law,” Eldest Madam Ning called out hurriedly, standing up.\r\nThird Madam Ning stopped her.\r\n“Eldest Sister-in-law, do not worry about it. Let us go,” she said.\r\nEldest Madam Ning could only helplessly watch them turn and go out.\r\n“You should be good to her when you speak. She is quite pitiful, do not frighten her,” she said anxiously. “Moreover, give the Fang Family face.”\r\n“The Fang Family’s face? They did not give us face, so we do not need to give it to them!”\r\nThe Third Madam Ning was angry without the Fang Family being mentioned, so the suggestion only served to infuriate her more.She did not wait for the Eldest Madam to speak again, and left followed by the servant girls and the other women.\r\nSilence returned to the room. Eldest Madam Ning did not bear the unease from just a moment ago. She looked faintly onto the three girls standing off to the side.\r\n“Why would Miss Jun think to use suicide to threaten our family?” she asked suddenly.\r\nThe three girls exchanged glances, their eyes sparkling.\r\n“Who knows. She definitely must have heard of Tenth Brother’s and the young miss’ of the Yang Family betrothal and could not sit still,” said one girl.\r\n“Right, right. Since she met Tenth Brother at the Lantern Festival on August 15, she has been increasingly pestering us without knowing any shame. It’s good that Tenth Elder Brother is not often at home. She has been proclaiming to the young misses of the city that she is our future sister-in-law.” The other girl said with hatred. “Suddenly hearing that Tenth Elder Brother was betrothed, she must have gone crazy.”\r\nEldest Madam Ning’s gaze fell onto Ning Yunyan, who hadn’t said anything.\r\n“Yanyan, it was you who told her about the thing with Miss Yang,” she said.\r\nNing Yunyan pursed her lips.\r\n“I definitely did not. I do not talk to her normally at all.” She then said with a giggle, “I only told Lin Jin’er, but I definitely warned her that she could not tell other people.”\r\nWhat she had warned her against doing was not this, but something else. It probably had something to do with Miss Jun’s hanging herself.\r\nTeenage girls’ behavior could both be innocent but also fearless. \r\nEldest Madam Ning frowned slightly.\r\n“This is something that the family is dealing with. You sisters do not need to take part in it. Lest you become entangled with her reputation,” she said.\r\nShe did not pursue the matter any farther and did not reprimand them further.\r\nThe three girls gladly responded.\r\n“I know that there is no need to worry.” Ning Yunyan coiled her arm around her mother’s and giggled. “If she wants to die, then she can die. We aren’t afraid of her.”\r\n“Besides, she didn’t die,” said the other girl, eyes full of ridicule. “If she does not dare to die herself, then how will she threaten our family? Who does she think she is?”\r\nEldest Madam Ning smiled but did not say anything.\r\n“Mother, I am done writing the characters.”\r\n“Eldest Aunt, I am also done.”\r\nThe girls veered off the subject with their pleasant voices.\r\n“Okay, I will take a look. If you have written them poorly, there will be a punishment,” warned Eldest Madam Ning.\r\nThe girls immediately gathered around Eldest Madam Ning as she walked to the eastern side room. Their chattering was warm and lively.\r\nThere was no need to take that young miss of the Jun Family seriously.\r\n……………………………………….\r\nHearing the calls of the madams from outside, the young servant girl who had been setting out refreshments on the table suddenly stood up straight.\r\nThe door curtains were opened, and the sounds of footsteps stopped upon reaching the room.\r\nThe ever quiet and with a lowered head, Miss Jun lifted her gaze to look at the two madams.\r\n“Ah? One of you is the eldest madam Ning?” asked the young servant girl, staring.\r\nThe last time they could not even get through the second gate, let alone meet Eldest Madam Ning. This time, they were finally able to enter, and there were even two madams coming to meet them.\r\nBut they were only two and dressed in a similar ordinary, luxurious style. Which of them was the Eldest Madam?\r\n{A certain type of owner would have a certain type of servant. Truly vulgar and disrespectful.}\r\nThe Ning Family madams’ eyes glinted with contempt.\r\n“If you have a problem, then you can tell it to us,” said Third Madam Ning.\r\nThe young servant girl was about to say something when Miss Jun raised a hand to stop her.\r\n“Okay.” She stood to greet them, while stroking the white silk on the table.\r\nThird Madam Ning and Fourth madam Ning’s brows furrowed.\r\n{She wants to threaten us.}\r\n“Young Miss Jun, we have already made the matter of the betrothal clear. Your maternal family was also very understanding. As outsiders, you would not listen to our words. Go back and ask them, they are your relatives,” said Fourth Madam Ning.\r\n“I am very clear on what you said; I do not need to make any inquiries,” said Miss Jun. She shook out the white silk on the table that had been originally covering a piece of paper. “Since we are all very clear on the topic, then we should talk over how to resolve the matter.”\r\nShe passed over the paper.\r\nWhat was this?\r\nThird Madam Ning and Fourth Madam Ning looked at the thin paper. When they saw the words on it clearly, they were immediately dumbstruck.\r\nA marriage contract!\r\nThird Madam Ning snatched it up, examining it incredulously.\r\nIt was a marriage contract with the names of three generations; and marriage relatives’ five grades of mourning clothes, their lands, and their government positions[1] written clearly.\r\nFor such a marriage contract to have been written, it could not have been just a slip of a tongue like Eldest Madam Ning had said previously.\r\nOld Master Ning had truly written this marriage contract, seriously agreeing for the two families to become in-laws. At least, it was genuine and sincere at the time. But it was unknown when afterwards he had reneged on the deal and sealed his lips,, since Old Master Ning had already passed away.\r\nHow come she did not bring out the marriage contract before?\r\nWithout a marriage contract, the Fang Family and Miss Jun were just fine. Whether both parties lived or died could not put any pressure on the other. However, if there was a marriage contract and Miss Jun genuinely committed suicide, their Ning Family would be troubled.\r\nThis, as expected, was a threat. Third Madam Ning and Fourth Madam Ning exchanged glances.\r\n“Miss Jun, it is not that we do not believe in your marriage contract,” started Fourth Madam Ning. “It’s just that our family’s Old Master has never brought out this contract and did not mention this betrothal in the last ten years.”\r\n“If you don’t know why you haven’t seen it, then that’s your problem. It’s unrelated to me,” Miss Jun said while looking at the Fourth Madam Ning. The girl’s voice was yet soft, without a single undulation in excitement. It was like her emotions were flat, without waves.\r\nThis did not match Ning Yunyan’s description of an unruly, aggressive Miss Jun.\r\nShe had been in Yancheng for half a year and had not directly taken out the marriage contract. Instead, she had been flamboyantly spreading the news, so that everyone knew of it. Bringing out the marriage contract now would not make it easy for the Ning Family to cover up the matter.\r\nHer conduct was actually planned out so well.\r\nFourth Madam Ning wanted to say something, but Third Madam Ning stopped her. She sized up Miss Jun and smiled.\r\n“Young Miss Jun, do you know what it means to marry? Marriage is marriage, not starting a feud[2],” she said. “Sometimes things can be accomplished by taking a particular action, but other times it cannot. At times, even if you manage to fulfill your wish, you might still end up being sad for the rest of your life.”\r\n{You might use a thousand different plans to marry into the Ning Family, but if your husband is not happy, your parents-in-law hate you, even if you take the position of the first wife, how could your days be happy? What’s more, there are many ways to take the position of the first wife.}\r\nThird Madam Ning was from Cang Prefecture. Her ancestor had started out as a bodyguard, but just like the Ning Family, now her family were not simply a merchant family. The descendants of her ancestor had also studied well and became government officials. However, they always operated the bodyguard business. Third Madam Ning’s father was responsible for bodyguard business, so the children of the family also had some training in martial arts as well as scholarly pursuits.\r\nThird Madam Ning had not learned much, but her temper was different from the typical noble girl. She was much more tyrannical.\r\nIf you enter the gates of our family, then we will make your life worse than death.\r\nThese words were, no doubt, a naked threat.\r\n“Young Miss Jun, one must be self-aware. You are not suited to become a daughter-in-law of our Ning Family.” Fourth Madam Ning, who had come from a scholarly family, did not try to intimidate her but spoke clearly.\r\nThe girl before them, who had lost her parents and had no choice but to rely on her maternal family, was neither angry nor scared. Rather, she smiled.\r\n“Since it is like that, then how do you plan to take back this marriage contract, and make me back off the betrothal?” she asked.\r\n\r\n\r\n\r\nNote 1: The family background is not meant to vilify the Chen Family[3]. It is just blatant plagiarism, I apologize. [Author]\r\n[1] The names of three generations; and marriage relatives’ five grades of mourning clothes, their lands, and their government position were an essential part of an ancient Chinese marriage contract.\r\n[2] In Chinese, marriage and starting a feud sound similar.\r\n[3] The Chen Family and Chen Tingjing are famous for their scholarly pursuits. The Ning’s family background is almost identical to the Chen Family’s.\r\n \r\n \r\n","nextChapterId":"20844380404289120","nextChapterName":"If You Can't Give the Person, then Give the Money"}]
   */
  chapterInfo?: {
    chapterId?: string;
    chapterName?: null;
    /**
     * "The light filtered in through the window and onto the folding screen. It was painted with a landscape scene, which cast a mottled shadow.\r\nJust because this was only a small room of the Ning Family for receiving guests, it did not mean it was overlooked. It was still decorated elaborately with expensive gold and jade ornaments. The luxurious decorations had the refined elegance of a learned family.\r\nToday, the weather was very pleasant. The fire in the fretwork stove was blazing. Two servant girls wearing winter clothing had a thin sheen of sweat on their noses. But the warm, springlike feeling did not make people feel pleasant as it had in the past. Instead, there was a kind of indescribable sense of oppression and impatience.\r\nSomeone lifted up the curtains and entered the room. Alongside the person came the winter wind from the courtyard. It was unknown whether it was the wind or the person coming that roused the two servant girls’ attention and made them hurriedly step forward.\r\nThe one who entered was another girl carrying an exquisite bronze kettle. It was quickly taken by one of the girls who then also picked up a cloisonne enamel teacup from the table on the side.\r\nThese series of moves did not make any noise, but it broke the stagnant atmosphere of the room. \r\n“Please drink some tea, Miss Jun,” the girl whispered. She carried the cup over while looking at the person who sat down on the chair.\r\nIt was a fourteen or fifteen-year-old girl. She was pretty as a picture without wearing any makeup and without even a hairpin or beads. She wore a green plain cotton dress which was faded from constant wash.\r\nThe sumptuous waiting room she was sitting in was not poor looking in the least. Rather, it made people feel it had an exquisite elegance of flowering orchids.\r\nYet when the servant girl’s gaze fell onto the table, it was like she had been stung by a bee. With her gaze directed downwards, her mood became complicated.\r\nOn the red wooden table inlaid with jadeite laid a swathe of white silk. It was especially eye-catching against the red and green.\r\nAt present, there was an aged woman looking at that swathe of white silk.\r\nThe Ning Family of Beiliu, Yangcheng, not only produced a dozen imperial secretaries of the Hanlin Imperial Academy, but also possessed half of the Ze Prefecture’s coal reservoirs. So, the small waiting room window was not made of ordinary window paper, but of glass from the south seas.\r\nIn the whole of Yangcheng, and even in the whole of the Ze Prefecture, there were only two families who could use this kind of glass.\r\nThe glass was somewhat fuzzy, but the woman could still see the swathe of silk and the girl’s silhouette.\r\nThis was not the first time she had seen the girl. She had, actually, come here two days ago but hadn’t taken out the white silk at the time. \r\nThe girl extended a hand to take the teacup and took a sip. Wrinkling her eyebrows, she set it down.\r\nThe woman could only guess as to why.\r\nShe could see the girl’s facial appearance through the multi-colored glass, but not her minute expressions.\r\nYet, after seeing the girl put down the cup, she was almost certain it was because the only kind of tea in the room was Yuqian Longjing [1] tea.\r\nAlthough this girl wore shabby clothing, she came from the other family in the Ze Prefecture that could have glass windows, the Fang Financial Exchange.\r\nHer surname was Jun. Her mother was the eldest daughter of the Fang Family. Although she married into a poorer family, the extravagance of her wedding, which took place several years ago, was still being discussed among the people of Ze Prefecture.\r\nA miss of that family would not be accustomed to drinking the rough tea like Yuqian Longjing. At least, the last time she had come to visit, the servant girl had brought Mingqian Longjing [2] tea.\r\nThe woman watched the room. The girl, who had set down her cup, had a beautiful sitting posture as she waited without the slightest bit of impatience. The little servant girl standing next to her pulled at her sleeve.\r\n“Give my servant girl a cup of tea,” Miss Jun said.\r\nThe woman heard the soft voice come from the room.\r\nThe servant girl immediately served a cup of tea to the little girl. She happily took the cup and drank it.\r\n“Another cup,” the young servant girl said.\r\nUnlike the last time they had paid a visit, she was no longer shy. Instead, she was confident and proud.\r\n{They probably thought that they could intimidate us.}\r\nA sneer flashed across the woman’s eyes.\r\n“Mama Song,\" a young servant girl called out while waving quietly at the woman.\r\nThe woman turned to leave from the windowside and passed through a narrow path to another courtyard. Servant girls stood on the veranda of the main courtyard building, talking and laughing. The sound of bright banter and laughter came from behind the door curtains, which were embroidered with thick golden thread.\r\nUpon seeing the woman arrive, all the chatting girls called out, “Mama Song!”\r\nThen, they spoke to someone inside the room, and two servant girls pulled open the curtains, letting the woman strode in. A soft fragrance assailed her senses. There were many people either standing or sitting in the room, however, all of their gazes and actions revolved around the middle-aged woman in the center.\r\nShe looked to be over forty years old and had elegant features with long eyebrows delicately traced on. There was a soft smile on her face as she listened to the two women seated in front of her.\r\nThe two were a bit younger, each wearing extravagant clothing.\r\nAround a large square table in the eastern side of the room, three teenage girls sat. Each of them wore a red coat over a yellow dress, and all were beautiful. However, unlike the outer room filled with faint laughter, their room was silent as they wrote characters.\r\nMama Song did not immediately speak, but rather took a cup of tea from a servant girl on the side and stood next to the women, listening to their talk with a smile.\r\n“Eldest Sister-in-law, the winter stage has already been set up in front of the temple.”\r\n“I must trouble Third Sister-in-law to deal with the matters of the theater troupe. I do not care much about them.”\r\n“This month, there has been more than the usual amount of refugees. The turmoil in the northern border is becoming more and more serious. I am making preparations to hand out gruel.”\r\n“Second Sister-in-law will also send out people to help with that.”\r\nThe sisters-in-law talked while the middle-aged woman smiled and nodded.\r\n“Good, this plan is very good. I must trouble all of you,” she said.\r\nThe Ning Family’s Eldest Madam was friendly and benevolent. She was filial to her parents-in-law and respectful to her sisters-in-law. Everyone praised her.\r\nAfter responding to the the younger women, Eldest Madam turned to look at Mama Song.\r\n“Did you see someone?” she asked.\r\nThis open-ended question halted all conversation in the room.\r\nMama Song voiced her agreement.\r\n“Eldest Sister-in-law, why did the young miss of the Jun Family come again? Didn’t she leave?” questioned Third Madam Ning next to her.\r\nEldest Madam Ning smiled and set down her teacup.\r\n“She did not leave. She found an inn nearby and played a joke about committing suicide, and now she has come again,” she said.\r\nSuicide?\r\nThird Madam Ning and Fourth Madam Ning exchanged looks.\r\n“This is too excessive. Could it be that the Fang Family doesn’t care?”\r\n“Or could it be that the Fang Family did it on purpose?”\r\nThey frowned as they spoke angrily.\r\nEldest Madam Ning shook her head.\r\n“It was definitely not on purpose or to cause any trouble,\" she said.\r\nThe two sisters-in-law smiled.\r\n“Eldest Sister-in-law is so benevolent in her judgement of others,” they said while sighing.\r\nA girl in the eastern side room, who had been listening very closely to the talk, violently turned her head around.\r\n“Mother, it is not rare for Jun Zhenzhen to do such things. She acts tyrannically within the Fang Family! The Eldest Madam of the Fang Family only tried to talk to her, and she instantly threatened to commit suicide, even going as far as suggesting to go to the feudal authority to tell her uncle about how she was being abused!” she exclaimed.\r\nThese words shocked the people in the room.\r\n“Yanyan.” Eldest Madam Ning frowned. Discussing others behind their back wasn’t a behavior that a girl from a noble family should have.\r\nThis was Eldest Madam Ning’s eldest daughter, the seventeenth eldest in her generation of the Ning Family, Ning Yunyan.\r\n“Eldest Aunt, Eldest Aunt, it’s really true! She is a young miss from a government official family and looks down on her maternal family because they are merchants.”\r\n“I know some of it too. I saw her and another person ridicule her older cousin at a banquet. It resulted in her older cousin withdrawing herself from the event, crying!”\r\nThe other two girls hurried to speak.\r\nThe three continuously chattered, and none of them were discouraged by Eldest Madam Ning’s soft voice. Soon, the room became chaotic.\r\nThis Miss Jun had only been in Yangcheng for half a year, yet she already had a reputation that rang loud and clear in everyone’s minds. Furthermore, this reputation was not a good one.\r\n“The Fang Family are uncouth merchants,” said Third Madam Ning while frowning. “This Miss Jun’s father came from a scholarly background. With one side of the parentage being government officials, how could they raise such a daughter?”\r\nHow others’ daughters were raised was of no concern; daughters from other families had nothing to do with their Ning Family, but it was just that this daughter of the Jun Family shouted out that she had an engagement with their Ning Family.\r\n“The engagement is real?” Fourth Madam Ning could not help but ask. “She truly has an engagement with our family’s Zhao’er? Did Father-in-law confirm it? This is a big issue, and Father-in-law never said anything about it in his life.”\r\nEldest Madam Ning sighed with helplessness.\r\n“I asked Mother, and she said that Father-in-law has met the master of the Jun Family,” she said. “Fifteen years ago, Father-in-law resigned from his post and decided to travel the world. While he was going through Runan, he fell ill. He was diagnosed by Doctor Jun, who was passing by as he returned from a housecall. Doctor Jun prescribed him medicine and cured his illness. Father-in-law could not thank him enough. He heard that Doctor Jun’s son just got married and blurted out without thinking that their families should marry. At that time, Zhao’er was just three years old.”\r\nCould not thank him enough. Blurted it out.\r\nThe implications of these phrases were instantly understood by the two madams in the room.\r\n“The master of the Jun Family was a doctor, so wasn’t giving sick people treatment only natural for him?” asked Third Madam Ning. “Father-in-law was just rambling out of gratefulness. Does that doctor not know the duty of a physician?”\r\nIt seems that he just had an idea of hitching a ride with a dragon and a phoenix [3]. If not, then he wouldn’t have disregarded his status and truly agreed to the marriage.\r\n“Maybe Father-in-law was coerced at that time,” said Fourth Madam Ning while shaking her head.\r\nOtherwise, the master would have never said something as big as betrothing the eldest son of the eldest branch.\r\n“Father-in-law never brought this up, so I don’t know what is going on,” said Eldest Madam Ning. When she said this, her voice took on a more serious tone. “The Old Madam declared that none of this is to happen. When the people from the Fang Family came to inquire about the matter, I had gently explained it to them. However, it seems that the young miss of Jun Family did not hear it. The Old Madam’s body is not well; I do not dare to make her go out herself. The young miss of the Jun Family lost her parents at a young age and is very pitiful. I also do not want to be too forceful with her…”\r\n“Mother!” Ning Yunyan had already stopped writing characters, so she immediately stood up and cried out, “She is pitiful, but Tenth Elder Brother is not pitiful. Tenth Elder Brother is just unlucky? Her parents did not die because of us, so why must we use such a major part of Tenth Elder Brother’s life to compensate her?”\r\n“Yes, yes. Tenth Elder Brother is a genius praised even by the Emperor. How could he be encumbered with a vulgar, ignorant person like Jun Zhenzhen?” The other two girls immediately followed up.\r\nThe room again broke into disorder.\r\nEldest Madam Ning seemed to have a headache from the noise as she kneaded her forehead with a helpless expression.\r\n“But I can not just watch blankly as the young miss of the Jun Family commits suicide before my eyes,” she said.\r\n“Right now, she has brought out a bolt of silk and laid it out on the table. It is an obvious threat,” interjected Mama Song. “Last time, she threatened to hang herself in the inn, and now, she might swear to do it on our doorway.”\r\n“She dares!” cried Third Madam Ning, eyebrows raised.\r\n[1] Longjing: a variety of green tea. Yuqian: picked before mid-april\r\n[2] Mingqian: before \"pure brightness\" or beginning of april\r\n[3] Hitching a ride with a dragon and a phoenix: curry favor with the rich in the hopes of advancement\r\n \r\n \r\n"
     */
    content?: string;
  }[];
  /**
   * [{"id":"15540642506797100","bookId":"7765063201015805","content":"Hdjdndndbjdjd\nShsbdbbdhdjjd\nShdbdbhdhhhhhhh\nHsbsbdbbdbd\nHdjdndndbjdjd\nShsbdbbdhdjjd\nShdbdbhdhhhhhhh\nHsbsbdbbdbd\nHdjdndndbjdjd\nShsbdbbdhdjjd\nShdbdbhdhhhhhhh\nHsbsbdbbdbd","userId":4300008435,"totalScore":"5.0","updateTime":"13 minutes ago","readToChapterIndex":"15000","replyNums":3,"likeNums":2,"spoiler":0,"userName":"hollyann8877","avatar":1601895089970,"penName":"hollyann8877","userUpdateTime":1601895098000},{"id":"15538622905833800","bookId":"7765063201015805","content":"Alabama\ncvvhjkfhchhzegciyzlighrckrLuxjhvngvhtcykc \nyxlhcbdxhlzlivhez\ncgkchEtkculEyclicurcou65\nxfkgxeg57676Alabama\ncvvhjkfhchhzegciyzlighrckrLuxjhvngvhtcykc \nyxlhcbdxhlzlivhez\ncgkchEtkculEyclicurcou65\nxfkgxeg57676","userId":3968405415,"totalScore":"5.0","updateTime":"6 days ago","readToChapterIndex":"0","replyNums":0,"likeNums":0,"spoiler":0,"userName":"jennyrenjialele5","avatar":0,"penName":"jennyrenjialele5","userUpdateTime":1530701317000},{"id":"15533132805949500","bookId":"7765063201015805","content":"Alabama\ncvvhjkfhchhzegciyzlighrckrLuxjhvngvhtcykc \nyxlhcbdxhlzlivhez\ncgkchEtkculEyclicurcou65\nxfkgxeg57676Alabama\ncvvhjkfhchhzegciyzlighrckrLuxjhvngvhtcykc \nyxlhcbdxhlzlivhez\ncgkchEtkculEyclicurcou65\nxfkgxeg57676","userId":4300000105,"totalScore":"4.8","updateTime":"6 days ago","readToChapterIndex":"0","replyNums":1,"likeNums":0,"spoiler":0,"userName":"jennylele","avatar":0,"penName":"jennylele","userUpdateTime":1527735253000}]
   */
  reviewItems?: {
    /**
     * "15540642506797100"
     */
    id?: string;
    /**
     * "7765063201015805"
     */
    bookId?: string;
    /**
     * "Hdjdndndbjdjd\nShsbdbbdhdjjd\nShdbdbhdhhhhhhh\nHsbsbdbbdbd\nHdjdndndbjdjd\nShsbdbbdhdjjd\nShdbdbhdhhhhhhh\nHsbsbdbbdbd\nHdjdndndbjdjd\nShsbdbbdhdjjd\nShdbdbhdhhhhhhh\nHsbsbdbbdbd"
     */
    content?: string;
    /**
     * 4300008435
     */
    userId?: number;
    /**
     * "5.0"
     */
    totalScore?: string;
    /**
     * "13 minutes ago"
     */
    updateTime?: string;
    /**
     * "15000"
     */
    readToChapterIndex?: string;
    /**
     * 3
     */
    replyNums?: number;
    /**
     * 2
     */
    likeNums?: number;
    spoiler?: number;
    /**
     * "hollyann8877"
     */
    userName?: string;
    /**
     * 1601895089970
     */
    avatar?: number;
    /**
     * "hollyann8877"
     */
    penName?: string;
    /**
     * 1601895098000
     */
    userUpdateTime?: number;
  }[];
}

/**
 * 接口 [getBookLandingPage 小说落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191811) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookLandingPage`
 * @更新时间 `2024-08-22 19:05:56`
 */
type GoPcmBookGetBookLandingPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/getBookLandingPage",
    "data",
    string,
    "bookId" | "chapters" | "from",
    false
  >
>;

/**
 * 接口 [getBookLandingPage 小说落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191811) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookLandingPage`
 * @更新时间 `2024-08-22 19:05:56`
 */
const goPcmBookGetBookLandingPageRequestConfig: GoPcmBookGetBookLandingPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getBookLandingPage",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: ["bookId", "chapters", "from"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBookLandingPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getBookLandingPage 小说落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191811) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookLandingPage`
 * @更新时间 `2024-08-22 19:05:56`
 */
export const goPcmBookGetBookLandingPage = /*#__PURE__*/ (
  requestData: GoPcmBookGetBookLandingPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetBookLandingPageResponse>(
    prepare(goPcmBookGetBookLandingPageRequestConfig, requestData),
    ...args
  );
};

goPcmBookGetBookLandingPage.requestConfig =
  goPcmBookGetBookLandingPageRequestConfig;

/**
 * 接口 [getComicLandingPage 漫画落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191925) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getComicLandingPage`
 * @更新时间 `2023-01-12 18:52:10`
 */
export interface GoPcmBookGetComicLandingPageRequest {
  comicId: string;
  /**
   * 支持多章预览，不超过20章，不传为1章
   */
  chapters: string;
  from?: string;
}

/**
 * 接口 [getComicLandingPage 漫画落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191925) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getComicLandingPage`
 * @更新时间 `2023-01-12 18:52:10`
 */
export interface GoPcmBookGetComicLandingPageResponse {
  comicInfo?: {
    /**
     * "13043017001040801"
     */
    comicId?: string;
    /**
     * "Webnovel Test021806"
     */
    comicName?: string;
    /**
     * 1
     */
    chapterNum?: number;
    /**
     * "ouyangxiang"
     */
    authorName?: string;
    /**
     * "13043017001040801"
     */
    sourceBookId?: string;
    /**
     * "qwe"
     */
    description?: string;
    /**
     * "ouyangxiang"
     */
    publisher?: string;
    /**
     * 1
     */
    actionStatus?: number;
    /**
     * 2
     */
    auditStatus?: number;
    /**
     * 100
     */
    novelType?: number;
    /**
     * "364.9K"
     */
    pvNum?: string;
  };
  /**
   * [{"images":[{"pageId":"35012281356044777","height":800,"width":600,"url":"https://comic-image.webnovel.com/comicpage/13053265606548201/35039660765930517/35039680646930477!800.jpg?sign=696a1fbc5dfe4ea09aa6da3ced6b4f24&t=1577087933&updateTime=1550574721655"},{"pageId":"35012281356044777","height":800,"width":600,"url":"https://oacomic-image.webnovel.com/comicpage/13137795401042201/35823100851447872/35824349076318634!800.jpg?sign=c6637895454264156c78e3f543f9e1fa&t=1577068919&updateTime=0"}]}]
   */
  chapterInfo?: {
    /**
     * [{"pageId":"35012281356044777","height":800,"width":600,"url":"https://comic-image.webnovel.com/comicpage/13053265606548201/35039660765930517/35039680646930477!800.jpg?sign=696a1fbc5dfe4ea09aa6da3ced6b4f24&t=1577087933&updateTime=1550574721655"},{"pageId":"35012281356044777","height":800,"width":600,"url":"https://oacomic-image.webnovel.com/comicpage/13137795401042201/35823100851447872/35824349076318634!800.jpg?sign=c6637895454264156c78e3f543f9e1fa&t=1577068919&updateTime=0"}]
     */
    images?: {
      /**
       * "35012281356044777"
       */
      pageId?: string;
      /**
       * 800
       */
      height?: number;
      /**
       * 600
       */
      width?: number;
      /**
       * "https://comic-image.webnovel.com/comicpage/13053265606548201/35039660765930517/35039680646930477!800.jpg?sign=696a1fbc5dfe4ea09aa6da3ced6b4f24&t=1577087933&updateTime=1550574721655"
       */
      url?: string;
    }[];
  }[];
}

/**
 * 接口 [getComicLandingPage 漫画落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191925) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getComicLandingPage`
 * @更新时间 `2023-01-12 18:52:10`
 */
type GoPcmBookGetComicLandingPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/getComicLandingPage",
    "data",
    string,
    "comicId" | "chapters" | "from",
    false
  >
>;

/**
 * 接口 [getComicLandingPage 漫画落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191925) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getComicLandingPage`
 * @更新时间 `2023-01-12 18:52:10`
 */
const goPcmBookGetComicLandingPageRequestConfig: GoPcmBookGetComicLandingPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getComicLandingPage",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: ["comicId", "chapters", "from"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetComicLandingPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getComicLandingPage 漫画落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191925) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getComicLandingPage`
 * @更新时间 `2023-01-12 18:52:10`
 */
export const goPcmBookGetComicLandingPage = /*#__PURE__*/ (
  requestData: GoPcmBookGetComicLandingPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetComicLandingPageResponse>(
    prepare(goPcmBookGetComicLandingPageRequestConfig, requestData),
    ...args
  );
};

goPcmBookGetComicLandingPage.requestConfig =
  goPcmBookGetComicLandingPageRequestConfig;

/**
 * 接口 [getBookRssPage rss页面直出↗](https://yapi.yuewen.com/project/2309/interface/api/192858) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookRssPage`
 * @更新时间 `2021-02-25 16:41:57`
 */
export interface GoPcmBookGetBookRssPageRequest {
  bookId: string;
  chapterId: string;
}

/**
 * 接口 [getBookRssPage rss页面直出↗](https://yapi.yuewen.com/project/2309/interface/api/192858) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookRssPage`
 * @更新时间 `2021-02-25 16:41:57`
 */
export interface GoPcmBookGetBookRssPageResponse {
  bookInfo?: {
    /**
     * "16709365405930105"
     */
    bookId?: string;
    /**
     * "My Vampire System"
     */
    bookName?: string;
    /**
     * "MVS"
     */
    bookSubName?: string;
    /**
     * "JKSManga"
     */
    authorName?: string;
    /**
     * 2
     */
    type?: number;
    /**
     * "4.6"
     */
    totalScore?: string;
    /**
     * 3784
     */
    voters?: number;
    /**
     * "1596687896010"
     */
    coverUpdateTime?: string;
    /**
     * ["123","xxx","1","123"]
     */
    adIds?: string[];
  };
  chapterInfo?: {
    /**
     * "44853895649874397"
     */
    chapterId?: string;
    /**
     * "Just an old Book"
     */
    chapterName?: string;
    /**
     * 1
     */
    chapterIndex?: number;
    /**
     * "9 months ago"
     */
    create?: string;
    /**
     * "\r\n\"Try not to die by tripping over yourself, Quinn!\" A boy shouted down the hallway, laughing uncontrollably right after.\r\nQuinn dismissed the petty mockery as he carried on walking down the school corridor. The harassment had become a daily occurrence for him, but it still bothered him just as much as it did every other day. Thus, he wasn't able to hold back his desire to retaliate.\r\nQuinn slowed down his stride and stopped. He pushed his glasses back up onto the ridge of his nose as they had slipped down from his face. Just from looking at the glasses, it was clear that he needed a new pair - One could tell that they were heavily worn. The glasses looked crooked as he wore them, and even the temples had tape covering them.\r\nHe then turned around and immediately raised his middle finger, responding to the slander, \"I bet you don't even know how many fingers I'm holding up!\"\r\nUpon hearing the taunt, the boy clenched his fist and started running towards Quinn.\r\n\"You level 1 piece of crap! When are you going to learn that you don't belong in this world?\"\r\nThe boy placed both of his hands together, and a green ball of light started to form between them. When he was only a few meters a"
     */
    content?: string;
    groupItems?: null;
    editorItems?: null;
    translatorItems?: null;
  };
  ads?: {
    /**
     * ["/274367222/WEB-READ-RECT","/274367222/WEB-READ-RECT2","/274367222/WEB-READ-RECT3","/274367222/WEB-READ-RECT4","/274367222/WEB-READ-RECT5"]
     */
    "101"?: string[];
    /**
     * []
     */
    "102"?: unknown[];
    /**
     * ["/274367222/msite-read-video","/274367222/msite-read-video2","/274367222/msite-read-video3","/274367222/msite-read-video4","/274367222/msite-read-video5","/274367222/web-read-video","/274367222/web-read-video2","/274367222/web-read-video3","/274367222/web-read-video4","/274367222/web-read-video5"]
     */
    "103"?: string[];
  };
  /**
   * [{"bookId":"17847262606339805","bookName":"Ace of the Dragon Division","newChapterTime":"4 minutes ago","type":1,"coverUpdateTime":1606878533962},{"bookId":"16489432606236605","bookName":"Plague Doctor","newChapterTime":"48 minutes ago","type":1,"coverUpdateTime":1606878533962},{"bookId":"16249175006446105","bookName":"I'm Secretly Married to a Big Shot","newChapterTime":"51 minutes ago","type":1,"coverUpdateTime":1606878533962},{"bookId":"16248450905321505","bookName":"Bringing Culture to a Different World","newChapterTime":"2 hours ago","type":1,"coverUpdateTime":1606878533962}]
   */
  latestUpdates?: {
    /**
     * "17847262606339805"
     */
    bookId?: string;
    /**
     * "Ace of the Dragon Division"
     */
    bookName?: string;
    /**
     * "4 minutes ago"
     */
    newChapterTime?: string;
    /**
     * 1
     */
    type?: number;
    /**
     * 1606878533962
     */
    coverUpdateTime?: number;
  }[];
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/3627871248/1/1.jpg?mt=1610637945000"
     */
    avatar?: string;
    /**
     * "dapenggaofei"
     */
    nickName?: string;
    /**
     * "dapenggaofei"
     */
    userName?: string;
    /**
     * "3627871248"
     */
    guid?: string;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * "dapenggaofei"
     */
    penName?: string;
    /**
     * 96
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 4
     */
    grade?: number;
    /**
     * 2
     */
    ES?: number;
    /**
     * 2
     */
    totalES?: number;
    /**
     * 3
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: boolean;
    /**
     * 1581297077449
     */
    UUT?: number;
    /**
     * 2
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    membershipStatus?: number;
    membershipExpireTime?: number;
    /**
     * true
     */
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [getBookRssPage rss页面直出↗](https://yapi.yuewen.com/project/2309/interface/api/192858) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookRssPage`
 * @更新时间 `2021-02-25 16:41:57`
 */
type GoPcmBookGetBookRssPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/getBookRssPage",
    "data",
    string,
    "bookId" | "chapterId",
    false
  >
>;

/**
 * 接口 [getBookRssPage rss页面直出↗](https://yapi.yuewen.com/project/2309/interface/api/192858) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookRssPage`
 * @更新时间 `2021-02-25 16:41:57`
 */
const goPcmBookGetBookRssPageRequestConfig: GoPcmBookGetBookRssPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getBookRssPage",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: ["bookId", "chapterId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBookRssPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getBookRssPage rss页面直出↗](https://yapi.yuewen.com/project/2309/interface/api/192858) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookRssPage`
 * @更新时间 `2021-02-25 16:41:57`
 */
export const goPcmBookGetBookRssPage = /*#__PURE__*/ (
  requestData: GoPcmBookGetBookRssPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetBookRssPageResponse>(
    prepare(goPcmBookGetBookRssPageRequestConfig, requestData),
    ...args
  );
};

goPcmBookGetBookRssPage.requestConfig = goPcmBookGetBookRssPageRequestConfig;

/**
 * 接口 [get-book-detail↗](https://yapi.yuewen.com/project/2309/interface/api/199996) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-04-28 19:56:57`
 */
export interface GoPcmBookGetBookDetail2Request {
  bookId: string;
}

/**
 * 接口 [get-book-detail↗](https://yapi.yuewen.com/project/2309/interface/api/199996) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-04-28 19:56:57`
 */
export interface GoPcmBookGetBookDetail2Response {
  bookInfo?: {
    /**
     * "7366916601012405"
     */
    bookId?: string;
    /**
     * "The King's Avatar"
     */
    bookName?: string;
    /**
     * "TKA"
     */
    bookSubName?: string;
    /**
     * "Butterfly Blue"
     */
    authorName?: string;
    /**
     * "3626681903122401"
     */
    authorId?: string;
    /**
     * 70008
     */
    categoryId?: number;
    /**
     * "Video Games"
     */
    categoryName?: string;
    /**
     * 682
     */
    chapterNum?: number;
    /**
     * 682
     */
    totalChapterNum?: number;
    /**
     * 30
     */
    actionStatus?: number;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "zh"
     */
    languageName?: string;
    /**
     * "In the online game Glory, Ye Xiu is regarded as a textbook and a top-tier pro-player. However, due to a myriad reasons, he is kicked from the team. After leaving the professional scene, he finds work in an Internet Cafe as a manager. When Glory launches its tenth server, he who possesses ten years of gaming experience once again throws himself into the game. Bringing with him the memories of his past and an incomplete, self-made weapon, his return along the road to the summit begins!\r\n\r\nAfter fighting and scheming, who snatched away my glory? Under the tossing of the wind and rain, my dreams shall still appear as though they had never been shattered. In all its splendor, the path shall never be lost. Before the gazes of millions, this is where I return !"
     */
    description?: string;
    /**
     * "2M"
     */
    pvNum?: string;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * 1
     */
    type?: number;
    /**
     * "1887208"
     */
    QDBID?: string;
    /**
     * "4.2"
     */
    totalScore?: string;
    /**
     * 262
     */
    voters?: number;
    expected?: number;
    /**
     * "Unselected"
     */
    ageGroup?: string;
    updateFrequency?: number;
    /**
     * 21
     */
    promiseUpdateFrequency?: number;
    /**
     * 1
     */
    frequencyUnit?: number;
    /**
     * 1
     */
    promiseFrequencyUnit?: number;
    /**
     * "45727419184774513"
     */
    newChapterId?: string;
    newChapterName?: string;
    /**
     * "9 months ago"
     */
    newChapterTime?: string;
    /**
     * 682
     */
    newChapterIndex?: number;
    /**
     * "19775416453662908"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    translateMode?: number;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * [{"bookName":"全职高手","url":"https://oabook.qidian.com/info/1887208"}]
     */
    language?: {
      /**
       * "全职高手"
       */
      bookName?: string;
      /**
       * "https://oabook.qidian.com/info/1887208"
       */
      url?: string;
    }[];
    /**
     * [{"id":"19363452317401368","name":"Translation Nation"}]
     */
    editorItems?: {
      /**
       * "19363452317401368"
       */
      id?: string;
      /**
       * "Translation Nation"
       */
      name?: string;
    }[];
    /**
     * [{"id":"19363452317401368","name":"Translation Nation"}]
     */
    translatorItems?: {
      /**
       * "19363452317401368"
       */
      id?: string;
      /**
       * "Translation Nation"
       */
      name?: string;
    }[];
    /**
     * [{"name":"Butterfly Blue"}]
     */
    authorItems?: {
      /**
       * "Butterfly Blue"
       */
      name?: string;
    }[];
    /**
     * "19775416453662908"
     */
    readToChapterId?: string;
    /**
     * "1"
     */
    readToChapterIndex?: string;
    /**
     * "The Banished Battle God"
     */
    firstChapterName?: string;
    /**
     * "The Banished Battle God"
     */
    readToChapterName?: string;
    patreonLink?: string;
    /**
     * [{"jumpLink":"http://baidu.com","description":"I like this animation1"},{"jumpLink":"https://baidu.com","description":"I like this animation2"}]
     */
    animationItems?: {
      /**
       * "http://baidu.com"
       */
      jumpLink?: string;
      /**
       * "I like this animation1"
       */
      description?: string;
    }[];
    /**
     * [{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla","role":"author"},{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla test    blabla  \n testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla test \n testblabla testblabla testblabla \n testblabla testblabla testblabla testblabla testblabla testblabla  testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavvvvv testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavtestblabla testblabla test test","role":"translator"}]
     */
    notes?: {
      /**
       * "https://oaimg.webnovel.com/userheadimg/1/1/1.png"
       */
      avatar?: string;
      /**
       * "zhangsan"
       */
      name?: string;
      /**
       * "blabla"
       */
      note?: string;
      /**
       * "author"
       */
      role?: string;
    }[];
    advText?: string;
    advActionUrl?: string;
    picPC?: string;
    feverLink?: string;
    translateVoters?: null;
    isVoted?: null;
    hasVote?: null;
    giftInfo?: {
      giftNum?: number;
      giftMax?: {
        /**
         * 15927
         */
        id?: number;
        /**
         * "7366916601012405"
         */
        bookId?: string;
        /**
         * "19775416453662908"
         */
        chapterId?: string;
        /**
         * 4300000390
         */
        userId?: number;
        /**
         * 1
         */
        giftAmount?: number;
        /**
         * "6665224524910655505"
         */
        orderId?: string;
        /**
         * 20008
         */
        giftId?: number;
        /**
         * 8888
         */
        totalPrice?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Lollipop"
         */
        giftName?: string;
        /**
         * 6666
         */
        giftPrice?: number;
        /**
         * "https://webbannertest.webnovel.com/gift/1535014273_1546.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        UUT?: number;
        /**
         * "Candy"
         */
        userName?: string;
      };
      /**
       * [{"id":17089,"userId":4300013216,"giftId":20002,"appId":10,"giftName":"Lollipop","giftPrice":25,"iconUrl":"https://webbannertest.webnovel.com/gift/1535014017_3329.png","status":1,"order":1,"UUT":0,"userName":"liwen369183"},{"id":17080,"userId":4300000563,"giftId":20004,"appId":10,"giftName":"Turkey","giftPrice":200,"iconUrl":"https://webbannertest.webnovel.com/gift/1567410347_6132.png","status":1,"order":1,"UUT":1587113770560,"userName":"zhangchen"}]
       */
      giftRecords?: {
        /**
         * 17089
         */
        id?: number;
        /**
         * 4300013216
         */
        userId?: number;
        /**
         * 20002
         */
        giftId?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Lollipop"
         */
        giftName?: string;
        /**
         * 25
         */
        giftPrice?: number;
        /**
         * "https://webbannertest.webnovel.com/gift/1535014017_3329.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        UUT?: number;
        /**
         * "liwen369183"
         */
        userName?: string;
      }[];
    };
    /**
     * [{"userId":4300009639,"appId":10,"votingCount":39382,"UUT":1604656231478,"userName":"liwenwen"},{"userId":4300011791,"appId":10,"votingCount":6729,"UUT":1608805208979,"userName":"ar1609924587162"}]
     */
    topFanItems?: {
      /**
       * 4300009639
       */
      userId?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * 39382
       */
      votingCount?: number;
      /**
       * 1604656231478
       */
      UUT?: number;
      /**
       * "liwenwen"
       */
      userName?: string;
    }[];
    tagInfo?: {
      /**
       * []
       */
      popularItems?: unknown[];
      /**
       * []
       */
      userItems?: unknown[];
    };
    /**
     * [{"name":"@string"}]
     */
    relatedWords?: {
      /**
       * "@string"
       */
      name?: string;
    }[];
    /**
     * "1581418734974"
     */
    coverUpdateTime?: string;
    essayInfo?: {
      icon?: string;
      text?: string;
      actionUrl?: string;
    };
    discount?: number;
    /**
     * "@timestamp"
     */
    discountTime?: string;
  };
  /**
   * 1
   */
  curReadChapter?: number;
  flag?: {
    /**
     * "AC"
     */
    code?: string;
    /**
     * "U+1F1E6 U+1F1E8"
     */
    unicode?: string;
    /**
     * "@county"
     */
    name?: string;
    /**
     * "🇦🇨"
     */
    emoji?: string;
  };
}

/**
 * 接口 [get-book-detail↗](https://yapi.yuewen.com/project/2309/interface/api/199996) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-04-28 19:56:57`
 */
type GoPcmBookGetBookDetail2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/get-book-detail",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [get-book-detail↗](https://yapi.yuewen.com/project/2309/interface/api/199996) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-04-28 19:56:57`
 */
const goPcmBookGetBookDetail2RequestConfig: GoPcmBookGetBookDetail2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/get-book-detail",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBookDetail2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-book-detail↗](https://yapi.yuewen.com/project/2309/interface/api/199996) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-04-28 19:56:57`
 */
export const goPcmBookGetBookDetail2 = /*#__PURE__*/ (
  requestData: GoPcmBookGetBookDetail2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetBookDetail2Response>(
    prepare(goPcmBookGetBookDetail2RequestConfig, requestData),
    ...args
  );
};

goPcmBookGetBookDetail2.requestConfig = goPcmBookGetBookDetail2RequestConfig;

/**
 * 接口 [GetRelatedBooksAjax 拉取相关作品推荐↗](https://yapi.yuewen.com/project/2309/interface/api/207345) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getRelatedBooksAjax`
 * @更新时间 `2021-05-10 14:01:34`
 */
export interface GoPcmBookGetRelatedBooksAjaxRequest {
  bookId: string;
}

/**
 * 接口 [GetRelatedBooksAjax 拉取相关作品推荐↗](https://yapi.yuewen.com/project/2309/interface/api/207345) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getRelatedBooksAjax`
 * @更新时间 `2021-05-10 14:01:34`
 */
export interface GoPcmBookGetRelatedBooksAjaxResponse {
  /**
   * [{"bookId":10383353301025804,"type":2,"authorName":"zhibonan888","bookName":"12333331","categoryName":"Horror&Thriller","categoryId":70004,"sameFlag":"","coverUpdateTime":0,"totalScore":"0"},{"bookId":6831119801008505,"type":1,"authorName":"Ghost of Dark Mountain","bookName":"Plundering the Heavens","categoryName":"Romance","categoryId":70005,"sameFlag":"","coverUpdateTime":0,"totalScore":"0"},{"bookId":6820754201002505,"type":1,"authorName":"Dancing","bookName":"Masked Knight","categoryName":"Romance","categoryId":70005,"sameFlag":"","coverUpdateTime":0,"totalScore":"3.5"},{"bookId":6831119801007205,"type":1,"authorName":"Cuttlefish That Loves Diving","bookName":"Throne of Magical Arcana","categoryName":"Horror&Thriller","categoryId":70004,"sameFlag":"","coverUpdateTime":1607654522184,"totalScore":"4.1"},{"bookId":10382772401025304,"type":2,"authorName":"zhibonan888","bookName":"1231test1121","categoryName":"Horror&Thriller","categoryId":70004,"sameFlag":"","coverUpdateTime":0,"totalScore":"0"},{"bookId":10156046401020804,"type":2,"authorName":"yang190","bookName":"Webnovel Test010","categoryName":"Horror&Thriller","categoryId":70004,"sameFlag":"","coverUpdateTime":0,"totalScore":"0"}]
   */
  items?: {
    /**
     * 10383353301025804
     */
    bookId?: number;
    /**
     * 2
     */
    type?: number;
    /**
     * "zhibonan888"
     */
    authorName?: string;
    /**
     * "12333331"
     */
    bookName?: string;
    /**
     * "Horror&Thriller"
     */
    categoryName?: string;
    /**
     * 70004
     */
    categoryId?: number;
    sameFlag?: string;
    coverUpdateTime?: number;
    /**
     * "0"
     */
    totalScore?: string;
  }[];
}

/**
 * 接口 [GetRelatedBooksAjax 拉取相关作品推荐↗](https://yapi.yuewen.com/project/2309/interface/api/207345) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getRelatedBooksAjax`
 * @更新时间 `2021-05-10 14:01:34`
 */
type GoPcmBookGetRelatedBooksAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/getRelatedBooksAjax",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [GetRelatedBooksAjax 拉取相关作品推荐↗](https://yapi.yuewen.com/project/2309/interface/api/207345) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getRelatedBooksAjax`
 * @更新时间 `2021-05-10 14:01:34`
 */
const goPcmBookGetRelatedBooksAjaxRequestConfig: GoPcmBookGetRelatedBooksAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getRelatedBooksAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetRelatedBooksAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [GetRelatedBooksAjax 拉取相关作品推荐↗](https://yapi.yuewen.com/project/2309/interface/api/207345) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getRelatedBooksAjax`
 * @更新时间 `2021-05-10 14:01:34`
 */
export const goPcmBookGetRelatedBooksAjax = /*#__PURE__*/ (
  requestData: GoPcmBookGetRelatedBooksAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetRelatedBooksAjaxResponse>(
    prepare(goPcmBookGetRelatedBooksAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmBookGetRelatedBooksAjax.requestConfig =
  goPcmBookGetRelatedBooksAjaxRequestConfig;

/**
 * 接口 [【del】getOffLineBook 获取下线书信息↗](https://yapi.yuewen.com/project/2309/interface/api/257131) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getOffLineBook`
 * @更新时间 `2023-03-16 15:29:17`
 */
export interface GoPcmBookGetOffLineBookRequest {
  bookId: string;
}

/**
 * 接口 [【del】getOffLineBook 获取下线书信息↗](https://yapi.yuewen.com/project/2309/interface/api/257131) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getOffLineBook`
 * @更新时间 `2023-03-16 15:29:17`
 */
export interface GoPcmBookGetOffLineBookResponse {
  bookInfo?: {
    /**
     * "My Vampire System"
     */
    bookName?: string;
  };
}

/**
 * 接口 [【del】getOffLineBook 获取下线书信息↗](https://yapi.yuewen.com/project/2309/interface/api/257131) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getOffLineBook`
 * @更新时间 `2023-03-16 15:29:17`
 */
type GoPcmBookGetOffLineBookRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/getOffLineBook",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [【del】getOffLineBook 获取下线书信息↗](https://yapi.yuewen.com/project/2309/interface/api/257131) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getOffLineBook`
 * @更新时间 `2023-03-16 15:29:17`
 */
const goPcmBookGetOffLineBookRequestConfig: GoPcmBookGetOffLineBookRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getOffLineBook",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetOffLineBook",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【del】getOffLineBook 获取下线书信息↗](https://yapi.yuewen.com/project/2309/interface/api/257131) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getOffLineBook`
 * @更新时间 `2023-03-16 15:29:17`
 */
export const goPcmBookGetOffLineBook = /*#__PURE__*/ (
  requestData: GoPcmBookGetOffLineBookRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetOffLineBookResponse>(
    prepare(goPcmBookGetOffLineBookRequestConfig, requestData),
    ...args
  );
};

goPcmBookGetOffLineBook.requestConfig = goPcmBookGetOffLineBookRequestConfig;

/**
 * 接口 [getShortplayLandingPage 短剧落地页↗](https://yapi.yuewen.com/project/2309/interface/api/279415) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getShortplayLandingPage`
 * @更新时间 `2024-07-15 18:01:51`
 */
export interface GoPcmBookGetShortplayLandingPageRequest {
  playId: string;
  from: string;
  chapters: string;
}

/**
 * 接口 [getShortplayLandingPage 短剧落地页↗](https://yapi.yuewen.com/project/2309/interface/api/279415) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getShortplayLandingPage`
 * @更新时间 `2024-07-15 18:01:51`
 */
export interface GoPcmBookGetShortplayLandingPageResponse {
  playInfo?: {
    /**
     * "13043017001040801"
     */
    playId?: string;
    /**
     * "Webnovel Test021806"
     */
    name?: string;
    /**
     * "@paragraph"
     */
    intro?: string;
    /**
     * "@timestamp"
     */
    coverId?: string;
    /**
     * [{"episodeId":"123"}]
     */
    episodes?: {
      /**
       * "123"
       */
      episodeId?: string;
    }[];
  };
}

/**
 * 接口 [getShortplayLandingPage 短剧落地页↗](https://yapi.yuewen.com/project/2309/interface/api/279415) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getShortplayLandingPage`
 * @更新时间 `2024-07-15 18:01:51`
 */
type GoPcmBookGetShortplayLandingPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/getShortplayLandingPage",
    "data",
    string,
    "playId" | "from" | "chapters",
    false
  >
>;

/**
 * 接口 [getShortplayLandingPage 短剧落地页↗](https://yapi.yuewen.com/project/2309/interface/api/279415) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getShortplayLandingPage`
 * @更新时间 `2024-07-15 18:01:51`
 */
const goPcmBookGetShortplayLandingPageRequestConfig: GoPcmBookGetShortplayLandingPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getShortplayLandingPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: ["playId", "from", "chapters"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetShortplayLandingPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getShortplayLandingPage 短剧落地页↗](https://yapi.yuewen.com/project/2309/interface/api/279415) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getShortplayLandingPage`
 * @更新时间 `2024-07-15 18:01:51`
 */
export const goPcmBookGetShortplayLandingPage = /*#__PURE__*/ (
  requestData: GoPcmBookGetShortplayLandingPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetShortplayLandingPageResponse>(
    prepare(goPcmBookGetShortplayLandingPageRequestConfig, requestData),
    ...args
  );
};

goPcmBookGetShortplayLandingPage.requestConfig =
  goPcmBookGetShortplayLandingPageRequestConfig;

/**
 * 接口 [getAudioBookLandingPage 有声书落地页↗](https://yapi.yuewen.com/project/2309/interface/api/289341) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getAudioBookLandingPage`
 * @更新时间 `2024-10-10 16:02:46`
 */
export interface GoPcmBookGetAudioBookLandingPageRequest {
  audioBookId: string;
  chapters: string;
  from: string;
}

/**
 * 接口 [getAudioBookLandingPage 有声书落地页↗](https://yapi.yuewen.com/project/2309/interface/api/289341) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getAudioBookLandingPage`
 * @更新时间 `2024-10-10 16:02:46`
 */
export interface GoPcmBookGetAudioBookLandingPageResponse {
  audioBookInfo?: {
    /**
     * "13043017001040801"
     */
    audioBookId?: string;
    /**
     * "Webnovel Test021806"
     */
    name?: string;
    /**
     * "@paragraph"
     */
    intro?: string;
    /**
     * "@timestamp"
     */
    coverId?: string;
    /**
     * "aaa"
     */
    authorName?: string;
  };
  /**
   * [{"chapterId":"1111","content":"@paragraph"}]
   */
  chapters?: {
    /**
     * "1111"
     */
    chapterId?: string;
    /**
     * "@paragraph"
     */
    content?: string;
  }[];
  /**
   * [{"audioBookId":"13043017001040801","name":"Webnovel Test021806","coverId":"@timestamp"}]
   */
  recommendation?: {
    /**
     * "13043017001040801"
     */
    audioBookId?: string;
    /**
     * "Webnovel Test021806"
     */
    name?: string;
    /**
     * "@timestamp"
     */
    coverId?: string;
  }[];
}

/**
 * 接口 [getAudioBookLandingPage 有声书落地页↗](https://yapi.yuewen.com/project/2309/interface/api/289341) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getAudioBookLandingPage`
 * @更新时间 `2024-10-10 16:02:46`
 */
type GoPcmBookGetAudioBookLandingPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/getAudioBookLandingPage",
    "data",
    string,
    "audioBookId" | "chapters" | "from",
    false
  >
>;

/**
 * 接口 [getAudioBookLandingPage 有声书落地页↗](https://yapi.yuewen.com/project/2309/interface/api/289341) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getAudioBookLandingPage`
 * @更新时间 `2024-10-10 16:02:46`
 */
const goPcmBookGetAudioBookLandingPageRequestConfig: GoPcmBookGetAudioBookLandingPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getAudioBookLandingPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: ["audioBookId", "chapters", "from"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetAudioBookLandingPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getAudioBookLandingPage 有声书落地页↗](https://yapi.yuewen.com/project/2309/interface/api/289341) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getAudioBookLandingPage`
 * @更新时间 `2024-10-10 16:02:46`
 */
export const goPcmBookGetAudioBookLandingPage = /*#__PURE__*/ (
  requestData: GoPcmBookGetAudioBookLandingPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetAudioBookLandingPageResponse>(
    prepare(goPcmBookGetAudioBookLandingPageRequestConfig, requestData),
    ...args
  );
};

goPcmBookGetAudioBookLandingPage.requestConfig =
  goPcmBookGetAudioBookLandingPageRequestConfig;

/**
 * 接口 [get-book-detail_copy↗](https://yapi.yuewen.com/project/2309/interface/api/292304) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBookDetailPagePc`
 * @更新时间 `2024-09-09 20:10:57`
 */
export interface GoPcmBookGetBookDetailPagePcRequest {
  bookId: string;
}

/**
 * 接口 [get-book-detail_copy↗](https://yapi.yuewen.com/project/2309/interface/api/292304) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBookDetailPagePc`
 * @更新时间 `2024-09-09 20:10:57`
 */
export interface GoPcmBookGetBookDetailPagePcResponse {
  bookInfo?: {
    /**
     * "7366916601012405"
     */
    bookId?: string;
    /**
     * "The King's Avatar"
     */
    bookName?: string;
    /**
     * "TKA"
     */
    bookSubName?: string;
    /**
     * "Butterfly Blue"
     */
    authorName?: string;
    /**
     * "3626681903122401"
     */
    authorId?: string;
    /**
     * 70008
     */
    categoryId?: number;
    /**
     * "Video Games"
     */
    categoryName?: string;
    /**
     * 682
     */
    chapterNum?: number;
    /**
     * 682
     */
    totalChapterNum?: number;
    /**
     * 30
     */
    actionStatus?: number;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "zh"
     */
    languageName?: string;
    /**
     * "In the online game Glory, Ye Xiu is regarded as a textbook and a top-tier pro-player. However, due to a myriad reasons, he is kicked from the team. After leaving the professional scene, he finds work in an Internet Cafe as a manager. When Glory launches its tenth server, he who possesses ten years of gaming experience once again throws himself into the game. Bringing with him the memories of his past and an incomplete, self-made weapon, his return along the road to the summit begins!\r\n\r\nAfter fighting and scheming, who snatched away my glory? Under the tossing of the wind and rain, my dreams shall still appear as though they had never been shattered. In all its splendor, the path shall never be lost. Before the gazes of millions, this is where I return !"
     */
    description?: string;
    /**
     * "2M"
     */
    pvNum?: string;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * 1
     */
    type?: number;
    /**
     * "1887208"
     */
    QDBID?: string;
    /**
     * "4.2"
     */
    totalScore?: string;
    /**
     * 262
     */
    voters?: number;
    expected?: number;
    /**
     * "Unselected"
     */
    ageGroup?: string;
    updateFrequency?: number;
    /**
     * 21
     */
    promiseUpdateFrequency?: number;
    /**
     * 1
     */
    frequencyUnit?: number;
    /**
     * 1
     */
    promiseFrequencyUnit?: number;
    /**
     * "45727419184774513"
     */
    newChapterId?: string;
    newChapterName?: string;
    /**
     * "9 months ago"
     */
    newChapterTime?: string;
    /**
     * 682
     */
    newChapterIndex?: number;
    /**
     * "19775416453662908"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    translateMode?: number;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * [{"bookName":"全职高手","url":"https://oabook.qidian.com/info/1887208"}]
     */
    language?: {
      /**
       * "全职高手"
       */
      bookName?: string;
      /**
       * "https://oabook.qidian.com/info/1887208"
       */
      url?: string;
    }[];
    /**
     * [{"id":"19363452317401368","name":"Translation Nation"}]
     */
    editorItems?: {
      /**
       * "19363452317401368"
       */
      id?: string;
      /**
       * "Translation Nation"
       */
      name?: string;
    }[];
    /**
     * [{"id":"19363452317401368","name":"Translation Nation"}]
     */
    translatorItems?: {
      /**
       * "19363452317401368"
       */
      id?: string;
      /**
       * "Translation Nation"
       */
      name?: string;
    }[];
    /**
     * [{"name":"Butterfly Blue"}]
     */
    authorItems?: {
      /**
       * "Butterfly Blue"
       */
      name?: string;
    }[];
    /**
     * "19775416453662908"
     */
    readToChapterId?: string;
    /**
     * "1"
     */
    readToChapterIndex?: string;
    /**
     * "The Banished Battle God"
     */
    firstChapterName?: string;
    /**
     * "The Banished Battle God"
     */
    readToChapterName?: string;
    patreonLink?: string;
    /**
     * [{"jumpLink":"http://baidu.com","description":"I like this animation1"},{"jumpLink":"https://baidu.com","description":"I like this animation2"}]
     */
    animationItems?: {
      /**
       * "http://baidu.com"
       */
      jumpLink?: string;
      /**
       * "I like this animation1"
       */
      description?: string;
    }[];
    /**
     * [{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla","role":"author"},{"avatar":"https://oaimg.webnovel.com/userheadimg/1/1/1.png","name":"zhangsan","note":"blabla test    blabla  \n testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla test \n testblabla testblabla testblabla \n testblabla testblabla testblabla testblabla testblabla testblabla  testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavvvvv testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblabla testblablavtestblabla testblabla test test","role":"translator"}]
     */
    notes?: {
      /**
       * "https://oaimg.webnovel.com/userheadimg/1/1/1.png"
       */
      avatar?: string;
      /**
       * "zhangsan"
       */
      name?: string;
      /**
       * "blabla"
       */
      note?: string;
      /**
       * "author"
       */
      role?: string;
    }[];
    advText?: string;
    advActionUrl?: string;
    picPC?: string;
    feverLink?: string;
    translateVoters?: null;
    isVoted?: null;
    hasVote?: null;
    giftInfo?: {
      giftNum?: number;
      giftMax?: {
        /**
         * 15927
         */
        id?: number;
        /**
         * "7366916601012405"
         */
        bookId?: string;
        /**
         * "19775416453662908"
         */
        chapterId?: string;
        /**
         * 4300000390
         */
        userId?: number;
        /**
         * 1
         */
        giftAmount?: number;
        /**
         * "6665224524910655505"
         */
        orderId?: string;
        /**
         * 20008
         */
        giftId?: number;
        /**
         * 8888
         */
        totalPrice?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Lollipop"
         */
        giftName?: string;
        /**
         * 6666
         */
        giftPrice?: number;
        /**
         * "https://webbannertest.webnovel.com/gift/1535014273_1546.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        UUT?: number;
        /**
         * "Candy"
         */
        userName?: string;
      };
      /**
       * [{"id":17089,"userId":4300013216,"giftId":20002,"appId":10,"giftName":"Lollipop","giftPrice":25,"iconUrl":"https://webbannertest.webnovel.com/gift/1535014017_3329.png","status":1,"order":1,"UUT":0,"userName":"liwen369183"},{"id":17080,"userId":4300000563,"giftId":20004,"appId":10,"giftName":"Turkey","giftPrice":200,"iconUrl":"https://webbannertest.webnovel.com/gift/1567410347_6132.png","status":1,"order":1,"UUT":1587113770560,"userName":"zhangchen"}]
       */
      giftRecords?: {
        /**
         * 17089
         */
        id?: number;
        /**
         * 4300013216
         */
        userId?: number;
        /**
         * 20002
         */
        giftId?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Lollipop"
         */
        giftName?: string;
        /**
         * 25
         */
        giftPrice?: number;
        /**
         * "https://webbannertest.webnovel.com/gift/1535014017_3329.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        UUT?: number;
        /**
         * "liwen369183"
         */
        userName?: string;
      }[];
    };
    /**
     * [{"userId":4300009639,"appId":10,"votingCount":39382,"UUT":1604656231478,"userName":"liwenwen"},{"userId":4300011791,"appId":10,"votingCount":6729,"UUT":1608805208979,"userName":"ar1609924587162"}]
     */
    topFanItems?: {
      /**
       * 4300009639
       */
      userId?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * 39382
       */
      votingCount?: number;
      /**
       * 1604656231478
       */
      UUT?: number;
      /**
       * "liwenwen"
       */
      userName?: string;
    }[];
    tagInfo?: {
      /**
       * []
       */
      popularItems?: unknown[];
      /**
       * []
       */
      userItems?: unknown[];
    };
    /**
     * [{"name":"@string"}]
     */
    relatedWords?: {
      /**
       * "@string"
       */
      name?: string;
    }[];
    /**
     * "1581418734974"
     */
    coverUpdateTime?: string;
    essayInfo?: {
      icon?: string;
      text?: string;
      actionUrl?: string;
    };
    discount?: number;
    /**
     * "@timestamp"
     */
    discountTime?: string;
  };
  /**
   * 1
   */
  curReadChapter?: number;
  flag?: {
    /**
     * "AC"
     */
    code?: string;
    /**
     * "U+1F1E6 U+1F1E8"
     */
    unicode?: string;
    /**
     * "@county"
     */
    name?: string;
    /**
     * "🇦🇨"
     */
    emoji?: string;
  };
}

/**
 * 接口 [get-book-detail_copy↗](https://yapi.yuewen.com/project/2309/interface/api/292304) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBookDetailPagePc`
 * @更新时间 `2024-09-09 20:10:57`
 */
type GoPcmBookGetBookDetailPagePcRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/getBookDetailPagePc",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [get-book-detail_copy↗](https://yapi.yuewen.com/project/2309/interface/api/292304) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBookDetailPagePc`
 * @更新时间 `2024-09-09 20:10:57`
 */
const goPcmBookGetBookDetailPagePcRequestConfig: GoPcmBookGetBookDetailPagePcRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getBookDetailPagePc",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBookDetailPagePc",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-book-detail_copy↗](https://yapi.yuewen.com/project/2309/interface/api/292304) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBookDetailPagePc`
 * @更新时间 `2024-09-09 20:10:57`
 */
export const goPcmBookGetBookDetailPagePc = /*#__PURE__*/ (
  requestData: GoPcmBookGetBookDetailPagePcRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetBookDetailPagePcResponse>(
    prepare(goPcmBookGetBookDetailPagePcRequestConfig, requestData),
    ...args
  );
};

goPcmBookGetBookDetailPagePc.requestConfig =
  goPcmBookGetBookDetailPagePcRequestConfig;

/**
 * 接口 [getSearchLandingPage 搜索通用落地页↗](https://yapi.yuewen.com/project/2309/interface/api/295734) 的 **请求类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getSearchLandingPage`
 * @更新时间 `2024-11-08 14:25:27`
 */
export interface GoPcmBookGetSearchLandingPageRequest {
  /**
   * 0 小说 100 漫画
   */
  bookType: string;
  /**
   * 关键词
   */
  "\bkeyword": string;
}

/**
 * 接口 [getSearchLandingPage 搜索通用落地页↗](https://yapi.yuewen.com/project/2309/interface/api/295734) 的 **返回类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getSearchLandingPage`
 * @更新时间 `2024-11-08 14:25:27`
 */
export interface GoPcmBookGetSearchLandingPageResponse {
  /**
   * [{"bookId":"7765063201015805","bookName":"Jun Jiuling","categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"@timestamp"}]
   */
  books?: {
    /**
     * "7765063201015805"
     */
    bookId?: string;
    /**
     * "Jun Jiuling"
     */
    bookName?: string;
    /**
     * 70001
     */
    categoryId?: number;
    /**
     * "Magical Realism"
     */
    categoryName?: string;
    /**
     * "@timestamp"
     */
    coverUpdateTime?: string;
  }[];
}

/**
 * 接口 [getSearchLandingPage 搜索通用落地页↗](https://yapi.yuewen.com/project/2309/interface/api/295734) 的 **请求配置的类型**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getSearchLandingPage`
 * @更新时间 `2024-11-08 14:25:27`
 */
type GoPcmBookGetSearchLandingPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/book/getSearchLandingPage",
    "data",
    string,
    "bookType" | "keyword",
    false
  >
>;

/**
 * 接口 [getSearchLandingPage 搜索通用落地页↗](https://yapi.yuewen.com/project/2309/interface/api/295734) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getSearchLandingPage`
 * @更新时间 `2024-11-08 14:25:27`
 */
const goPcmBookGetSearchLandingPageRequestConfig: GoPcmBookGetSearchLandingPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getSearchLandingPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: ["bookType", "\bkeyword"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetSearchLandingPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getSearchLandingPage 搜索通用落地页↗](https://yapi.yuewen.com/project/2309/interface/api/295734) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getSearchLandingPage`
 * @更新时间 `2024-11-08 14:25:27`
 */
export const goPcmBookGetSearchLandingPage = /*#__PURE__*/ (
  requestData: GoPcmBookGetSearchLandingPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookGetSearchLandingPageResponse>(
    prepare(goPcmBookGetSearchLandingPageRequestConfig, requestData),
    ...args
  );
};

goPcmBookGetSearchLandingPage.requestConfig =
  goPcmBookGetSearchLandingPageRequestConfig;

const mockUrl_0_0_0_14 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_14 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_14 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_14 = "data" as any;

/**
 * 接口 [给作品打赏礼物↗](https://yapi.yuewen.com/project/2309/interface/api/176398) 的 **请求类型**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `POST /go/pcm/gift/donateGift`
 * @更新时间 `2021-01-20 15:16:38`
 */
export interface GoPcmGiftDonateGiftRequest {
  /**
   * 全职高手
   */
  bookId: string;
  /**
   * 章节ID,全职高手第三章
   */
  chapterId: string;
  /**
   * 礼物id
   */
  giftId: string;
  /**
   * 礼物个数
   */
  amount: string;
  /**
   * 礼物总价
   */
  totalPrice: string;
  /**
   * 每次请求都需要加上这个参数，从getBookGiftList获取
   */
  donateUUID: string;
  /**
   * bookType 0=>书，100=>漫画，200=>出版书
   */
  novelType: string;
}

/**
 * 接口 [给作品打赏礼物↗](https://yapi.yuewen.com/project/2309/interface/api/176398) 的 **返回类型**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `POST /go/pcm/gift/donateGift`
 * @更新时间 `2021-01-20 15:16:38`
 */
export interface GoPcmGiftDonateGiftResponse {
  code?: number;
  /**
   * "Success"
   */
  msg?: string;
}

/**
 * 接口 [给作品打赏礼物↗](https://yapi.yuewen.com/project/2309/interface/api/176398) 的 **请求配置的类型**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `POST /go/pcm/gift/donateGift`
 * @更新时间 `2021-01-20 15:16:38`
 */
type GoPcmGiftDonateGiftRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/gift/donateGift",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [给作品打赏礼物↗](https://yapi.yuewen.com/project/2309/interface/api/176398) 的 **请求配置**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `POST /go/pcm/gift/donateGift`
 * @更新时间 `2021-01-20 15:16:38`
 */
const goPcmGiftDonateGiftRequestConfig: GoPcmGiftDonateGiftRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_14,
    devUrl: devUrl_0_0_0_14,
    prodUrl: prodUrl_0_0_0_14,
    path: "/go/pcm/gift/donateGift",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_14,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGiftDonateGift",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [给作品打赏礼物↗](https://yapi.yuewen.com/project/2309/interface/api/176398) 的 **请求函数**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `POST /go/pcm/gift/donateGift`
 * @更新时间 `2021-01-20 15:16:38`
 */
export const goPcmGiftDonateGift = /*#__PURE__*/ (
  requestData: GoPcmGiftDonateGiftRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmGiftDonateGiftResponse>(
    prepare(goPcmGiftDonateGiftRequestConfig, requestData),
    ...args
  );
};

goPcmGiftDonateGift.requestConfig = goPcmGiftDonateGiftRequestConfig;

/**
 * 接口 [获取作品礼物列表↗](https://yapi.yuewen.com/project/2309/interface/api/176406) 的 **请求类型**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/getBookGiftList`
 * @更新时间 `2021-01-20 15:14:33`
 */
export interface GoPcmGiftGetBookGiftListRequest {
  /**
   * 书籍ID
   */
  bookId: string;
  /**
   * bookType 0=>书，100=>漫画，200=>出版书
   */
  novelType: string;
  _csrfToken: string;
}

/**
 * 接口 [获取作品礼物列表↗](https://yapi.yuewen.com/project/2309/interface/api/176406) 的 **返回类型**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/getBookGiftList`
 * @更新时间 `2021-01-20 15:14:33`
 */
export interface GoPcmGiftGetBookGiftListResponse {
  /**
   * [{"giftId":20002,"giftName":"Lollipop","giftPrice":25,"iconUrl":"https://webbannertest.webnovel.com/gift/1532347515_4297.png","status":1,"order":1},{"giftId":20003,"giftName":"Easter egg","giftPrice":99,"iconUrl":"","status":1,"order":1},{"giftId":20004,"giftName":"Turkey","giftPrice":200,"iconUrl":"","status":1,"order":1},{"giftId":20005,"giftName":"Cultivation Manual","giftPrice":450,"iconUrl":"","status":1,"order":1},{"giftId":20006,"giftName":"Meteor","giftPrice":666,"iconUrl":"","status":1,"order":1},{"giftId":20007,"giftName":"Rainbow","giftPrice":666,"iconUrl":"","status":1,"order":1},{"giftId":20008,"giftName":"Crown","giftPrice":888,"iconUrl":"","status":1,"order":1}]
   */
  gifts?: {
    /**
     * 20002
     */
    giftId?: number;
    /**
     * "Lollipop"
     */
    giftName?: string;
    /**
     * 25
     */
    giftPrice?: number;
    /**
     * "https://webbannertest.webnovel.com/gift/1532347515_4297.png"
     */
    iconUrl?: string;
    /**
     * 1
     */
    status?: number;
    /**
     * 1
     */
    order?: number;
  }[];
  /**
   * 150
   */
  SS?: number;
  /**
   * "26b5f848-2043-4f67-b5f8-4820437f67ab"
   */
  donateUUID?: string;
  /**
   * 42
   */
  giftNum?: number;
}

/**
 * 接口 [获取作品礼物列表↗](https://yapi.yuewen.com/project/2309/interface/api/176406) 的 **请求配置的类型**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/getBookGiftList`
 * @更新时间 `2021-01-20 15:14:33`
 */
type GoPcmGiftGetBookGiftListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/gift/getBookGiftList",
    "data",
    string,
    "bookId" | "novelType" | "_csrfToken",
    false
  >
>;

/**
 * 接口 [获取作品礼物列表↗](https://yapi.yuewen.com/project/2309/interface/api/176406) 的 **请求配置**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/getBookGiftList`
 * @更新时间 `2021-01-20 15:14:33`
 */
const goPcmGiftGetBookGiftListRequestConfig: GoPcmGiftGetBookGiftListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_14,
    devUrl: devUrl_0_0_0_14,
    prodUrl: prodUrl_0_0_0_14,
    path: "/go/pcm/gift/getBookGiftList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_14,
    paramNames: [],
    queryNames: ["bookId", "novelType", "_csrfToken"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGiftGetBookGiftList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取作品礼物列表↗](https://yapi.yuewen.com/project/2309/interface/api/176406) 的 **请求函数**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/getBookGiftList`
 * @更新时间 `2021-01-20 15:14:33`
 */
export const goPcmGiftGetBookGiftList = /*#__PURE__*/ (
  requestData: GoPcmGiftGetBookGiftListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmGiftGetBookGiftListResponse>(
    prepare(goPcmGiftGetBookGiftListRequestConfig, requestData),
    ...args
  );
};

goPcmGiftGetBookGiftList.requestConfig = goPcmGiftGetBookGiftListRequestConfig;

/**
 * 接口 [获取作品礼物打赏信息↗](https://yapi.yuewen.com/project/2309/interface/api/176411) 的 **请求类型**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2022-09-06 17:27:58`
 */
export interface GoPcmGiftGetGiftInfo2Request {
  /**
   * 书籍id
   */
  bookId: string;
  _csrfToken: string;
  novelType: string;
}

/**
 * 接口 [获取作品礼物打赏信息↗](https://yapi.yuewen.com/project/2309/interface/api/176411) 的 **返回类型**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2022-09-06 17:27:58`
 */
export interface GoPcmGiftGetGiftInfo2Response {
  /**
   * 43
   */
  giftNum?: number;
  giftMax?: {
    /**
     * 15927
     */
    id?: number;
    /**
     * 7366916601012405
     */
    bookId?: number;
    /**
     * 19775416453662908
     */
    chapterId?: number;
    /**
     * 4300000390
     */
    userId?: number;
    /**
     * 1
     */
    giftAmount?: number;
    /**
     * "6665224524910655505"
     */
    orderId?: string;
    /**
     * 20008
     */
    giftId?: number;
    /**
     * 8888
     */
    totalPrice?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * "Lollipop"
     */
    giftName?: string;
    /**
     * 88888
     */
    giftPrice?: number;
    /**
     * "testUrl"
     */
    iconUrl?: string;
    /**
     * 1
     */
    status?: number;
    /**
     * 1
     */
    order?: number;
    /**
     * 1547805199000
     */
    UUT?: number;
    /**
     * "Candy"
     */
    userName?: string;
  };
  /**
   * [{"id":15951,"userId":4300000120,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1553072138000,"userName":"bigcat004"},{"id":15950,"userId":4300000120,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1553072138000,"userName":"bigcat004"},{"id":15949,"userId":4300000732,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1556006733000,"userName":"zhoujielun"},{"id":15948,"userId":4300000732,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1556006733000,"userName":"zhoujielun"},{"id":15947,"userId":4300000770,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1555552974000,"userName":"289380420_0704"},{"id":15946,"userId":4300000307,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1523934874000,"userName":"fffggg"},{"id":15945,"userId":4300000604,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1553848481000,"userName":"hub"},{"id":15944,"userId":1901271742,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1554260602000,"userName":"testingya"},{"id":15943,"userId":4300000604,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1553848481000,"userName":"hub"},{"id":15942,"userId":4300001447,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1553670547777,"userName":"tlwinter2019"}]
   */
  giftRecords?: {
    /**
     * 15951
     */
    id?: number;
    /**
     * 4300000120
     */
    userId?: number;
    /**
     * 20001
     */
    giftId?: number;
    /**
     * 10
     */
    appId?: number;
    /**
     * "Balloon"
     */
    giftName?: string;
    /**
     * 5
     */
    giftPrice?: number;
    /**
     * "https://webbanner.webnovel.com/gift/1539660206_9513.png"
     */
    iconUrl?: string;
    /**
     * 1
     */
    status?: number;
    /**
     * 1
     */
    order?: number;
    /**
     * 1553072138000
     */
    UUT?: number;
    /**
     * "bigcat004"
     */
    userName?: string;
  }[];
}

/**
 * 接口 [获取作品礼物打赏信息↗](https://yapi.yuewen.com/project/2309/interface/api/176411) 的 **请求配置的类型**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2022-09-06 17:27:58`
 */
type GoPcmGiftGetGiftInfo2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/gift/get-gift-info",
    "data",
    string,
    "bookId" | "_csrfToken" | "novelType",
    false
  >
>;

/**
 * 接口 [获取作品礼物打赏信息↗](https://yapi.yuewen.com/project/2309/interface/api/176411) 的 **请求配置**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2022-09-06 17:27:58`
 */
const goPcmGiftGetGiftInfo2RequestConfig: GoPcmGiftGetGiftInfo2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_14,
    devUrl: devUrl_0_0_0_14,
    prodUrl: prodUrl_0_0_0_14,
    path: "/go/pcm/gift/get-gift-info",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_14,
    paramNames: [],
    queryNames: ["bookId", "_csrfToken", "novelType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGiftGetGiftInfo2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取作品礼物打赏信息↗](https://yapi.yuewen.com/project/2309/interface/api/176411) 的 **请求函数**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2022-09-06 17:27:58`
 */
export const goPcmGiftGetGiftInfo2 = /*#__PURE__*/ (
  requestData: GoPcmGiftGetGiftInfo2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmGiftGetGiftInfo2Response>(
    prepare(goPcmGiftGetGiftInfo2RequestConfig, requestData),
    ...args
  );
};

goPcmGiftGetGiftInfo2.requestConfig = goPcmGiftGetGiftInfo2RequestConfig;

const mockUrl_0_0_0_15 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_15 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_15 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_15 = "data" as any;

/**
 * 接口 [解锁章节↗](https://yapi.yuewen.com/project/2309/interface/api/176451) 的 **请求类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/unlockChapter`
 * @更新时间 `2021-05-06 16:33:16`
 */
export interface GoPcmComicUnlockChapterRequest {
  comicId: string;
  chapterId: string;
  /**
   * 解锁章节也需要传
   */
  width?: string;
  /**
   * 1：看广告
   * 2：跳过广告
   * 3：订阅（ss解锁）
   * 4：整本订阅
   * 5：阅读券（fastPass）
   */
  unlockType: string;
  /**
   * 价格
   */
  price: string;
}

/**
 * 接口 [解锁章节↗](https://yapi.yuewen.com/project/2309/interface/api/176451) 的 **返回类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/unlockChapter`
 * @更新时间 `2021-05-06 16:33:16`
 */
export interface GoPcmComicUnlockChapterResponse {
  /**
   * "100"
   */
  balanceCoins?: string;
  contents?: {
    /**
     * "23000234665765226"
     */
    chapterId?: string;
    /**
     * "test"
     */
    chapterName?: string;
    /**
     * "556"
     */
    chapterIndex?: string;
    /**
     * "123"
     */
    price?: string;
    /**
     * "5"
     */
    pageCount?: string;
    /**
     * "20842543502954060"
     */
    preChapterId?: string;
    /**
     * "30539125799047747"
     */
    nextChapterId?: string;
    /**
     * "-1"
     */
    vipStatus?: string;
    /**
     * "1"
     */
    isAuth?: string;
    /**
     * [{"pageId":"123123","height":"144","width":"425","url":"www.baidu.com"},{"pageId":"123123","height":"144","width":"425","url":"www.baidu.com"}]
     */
    chapterPage?: {
      /**
       * "123123"
       */
      pageId?: string;
      /**
       * "144"
       */
      height?: string;
      /**
       * "425"
       */
      width?: string;
      /**
       * "www.baidu.com"
       */
      url?: string;
    }[];
  };
  /**
   * "10"
   */
  costCoins?: string;
}

/**
 * 接口 [解锁章节↗](https://yapi.yuewen.com/project/2309/interface/api/176451) 的 **请求配置的类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/unlockChapter`
 * @更新时间 `2021-05-06 16:33:16`
 */
type GoPcmComicUnlockChapterRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/unlockChapter",
    "data",
    string,
    "comicId" | "chapterId" | "width" | "unlockType" | "price",
    false
  >
>;

/**
 * 接口 [解锁章节↗](https://yapi.yuewen.com/project/2309/interface/api/176451) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/unlockChapter`
 * @更新时间 `2021-05-06 16:33:16`
 */
const goPcmComicUnlockChapterRequestConfig: GoPcmComicUnlockChapterRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/unlockChapter",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: ["comicId", "chapterId", "width", "unlockType", "price"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicUnlockChapter",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [解锁章节↗](https://yapi.yuewen.com/project/2309/interface/api/176451) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/unlockChapter`
 * @更新时间 `2021-05-06 16:33:16`
 */
export const goPcmComicUnlockChapter = /*#__PURE__*/ (
  requestData: GoPcmComicUnlockChapterRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicUnlockChapterResponse>(
    prepare(goPcmComicUnlockChapterRequestConfig, requestData),
    ...args
  );
};

goPcmComicUnlockChapter.requestConfig = goPcmComicUnlockChapterRequestConfig;

/**
 * 接口 [阅读页(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176458) 的 **请求类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2022-12-20 13:51:54`
 */
export interface GoPcmComicGetContent2Request {
  comicId: string;
  chapterId: string;
  /**
   * 漫画图片的宽度，根据不同的宽度能获取不同尺寸的图片
   */
  width: string;
}

/**
 * 接口 [阅读页(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176458) 的 **返回类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2022-12-20 13:51:54`
 */
export interface GoPcmComicGetContent2Response {
  comicInfo?: {
    /**
     * "12698954101038401"
     */
    comicId?: string;
    /**
     * "Webnovel TestComic01091"
     */
    comicName?: string;
    /**
     * 2
     */
    chapterNum?: number;
    /**
     * 1
     */
    actionStatus?: number;
    /**
     * "ouyangxiang"
     */
    publisher?: string;
    /**
     * 2
     */
    auditStatus?: number;
    /**
     * 100
     */
    novelType?: number;
    /**
     * "0"
     */
    CV?: string;
    inLibrary?: number;
    /**
     * 1
     */
    giftNum?: number;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "zh"
     */
    languageName?: string;
    /**
     * 10
     */
    availableFpNum?: number;
    /**
     * 1
     */
    fpCostNum?: number;
  };
  chapterInfo?: {
    /**
     * 1
     */
    fastPassNum?: number;
    /**
     * "34088927006621405"
     */
    chapterId?: string;
    /**
     * "01"
     */
    chapterName?: string;
    /**
     * 1
     */
    chapterIndex?: number;
    /**
     * 100
     */
    price?: number;
    /**
     * 26
     */
    pageCount?: number;
    /**
     * "-1"
     */
    preChapterId?: string;
    preChapterName?: string;
    /**
     * "34089039749512990"
     */
    nextChapterId?: string;
    /**
     * "02"
     */
    nextChapterName?: string;
    /**
     * 2
     */
    VipStatus?: number;
    isAuth?: number;
    /**
     * 1
     */
    batchUnlockStatus?: number;
    chapterLevel?: number;
    userLevel?: number;
    /**
     * []
     */
    chapterPage?: unknown[];
    /**
     * "https://img.webnovel.com/1234134"
     */
    previewImage?: string;
  };
  giftInfo?: {
    /**
     * 1
     */
    giftNum?: number;
    giftMax?: {
      /**
       * 2
       */
      id?: number;
      /**
       * 12698954101038400
       */
      bookId?: number;
      chapterId?: number;
      /**
       * 4300002453
       */
      userId?: number;
      /**
       * 1
       */
      giftAmount?: number;
      /**
       * "6886340749766429783"
       */
      orderId?: string;
      /**
       * 20001
       */
      giftId?: number;
      /**
       * 5
       */
      totalPrice?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * "Balloon"
       */
      giftName?: string;
      /**
       * 5
       */
      giftPrice?: number;
      /**
       * "https://webbanner.webnovel.com/gift/1539660206_9513.png"
       */
      iconUrl?: string;
      /**
       * 1
       */
      status?: number;
      /**
       * 1
       */
      order?: number;
      /**
       * 1598957292653
       */
      UUT?: number;
      /**
       * "sunmeiye"
       */
      userName?: string;
    };
    /**
     * [{"id":1,"userId":4300000732,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1589512256485,"userName":"zhoujielun"}]
     */
    giftRecords?: {
      /**
       * 1
       */
      id?: number;
      /**
       * 4300000732
       */
      userId?: number;
      /**
       * 20001
       */
      giftId?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * "Balloon"
       */
      giftName?: string;
      /**
       * 5
       */
      giftPrice?: number;
      /**
       * "https://webbanner.webnovel.com/gift/1539660206_9513.png"
       */
      iconUrl?: string;
      /**
       * 1
       */
      status?: number;
      /**
       * 1
       */
      order?: number;
      /**
       * 1589512256485
       */
      UUT?: number;
      /**
       * "zhoujielun"
       */
      userName?: string;
    }[];
  };
  settings?: {
    /**
     * "_color1"
     */
    tc?: string;
    tf?: string;
    ts?: string;
  };
  membershipStatus?: number;
  waitpayStatus?: number;
  user?: {
    avatar?: string;
    nickName?: string;
    userName?: string;
    guid?: string;
    /**
     * -1
     */
    status?: number;
    role?: null;
    penName?: null;
    SS?: null;
    vSS?: null;
    vbSS?: null;
    bSS?: null;
    grade?: null;
    ES?: null;
    totalES?: null;
    PS?: null;
    totalPS?: null;
    emailStatus?: null;
    isCheckIn?: null;
    UUT?: null;
    fastPass?: null;
    membershipQua?: number;
    membershipStatus?: number;
    membershipExpireTime?: number;
    /**
     * true
     */
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [阅读页(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176458) 的 **请求配置的类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2022-12-20 13:51:54`
 */
type GoPcmComicGetContent2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/getContent",
    "data",
    string,
    "comicId" | "chapterId" | "width",
    false
  >
>;

/**
 * 接口 [阅读页(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176458) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2022-12-20 13:51:54`
 */
const goPcmComicGetContent2RequestConfig: GoPcmComicGetContent2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getContent",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: ["comicId", "chapterId", "width"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetContent2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [阅读页(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176458) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2022-12-20 13:51:54`
 */
export const goPcmComicGetContent2 = /*#__PURE__*/ (
  requestData: GoPcmComicGetContent2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicGetContent2Response>(
    prepare(goPcmComicGetContent2RequestConfig, requestData),
    ...args
  );
};

goPcmComicGetContent2.requestConfig = goPcmComicGetContent2RequestConfig;

/**
 * 接口 [阅读页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176466) 的 **请求类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContentPage`
 * @更新时间 `2022-08-18 14:58:38`
 */
export interface GoPcmComicGetContentPageRequest {
  comicId: string;
  chapterId: string;
  /**
   * 漫画图片的宽度，根据不同的宽度能获取不同尺寸的图片
   */
  width: string;
}

/**
 * 接口 [阅读页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176466) 的 **返回类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContentPage`
 * @更新时间 `2022-08-18 14:58:38`
 */
export interface GoPcmComicGetContentPageResponse {
  comicInfo?: {
    /**
     * "13138233106881301"
     */
    comicId?: string;
    /**
     * "The Apostle of Cards"
     */
    comicName?: string;
    /**
     * 57
     */
    chapterNum?: number;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "zh"
     */
    languageName?: string;
    /**
     * 1
     */
    actionStatus?: number;
    /**
     * "ShenMan"
     */
    publisher?: string;
    /**
     * 2
     */
    auditStatus?: number;
    /**
     * 100
     */
    novelType?: number;
    /**
     * "1560763860181"
     */
    CV?: string;
    inLibrary?: number;
    /**
     * 4
     */
    giftNum?: number;
    /**
     * 1547032856000
     */
    publishTime?: number;
    /**
     * 1567411308000
     */
    updateTime?: number;
    hasPrivilege?: number;
    /**
     * 10
     */
    availableFpNum?: number;
    /**
     * 1
     */
    fpCostNum?: number;
  };
  isDeleted?: number;
  chapterInfo?: {
    /**
     * 1
     */
    fastPassNum?: number;
    /**
     * "37568809166495838"
     */
    chapterId?: string;
    /**
     * "019"
     */
    chapterName?: string;
    /**
     * 19
     */
    chapterIndex?: number;
    /**
     * 13
     */
    price?: number;
    /**
     * 13
     */
    pageCount?: number;
    /**
     * "31026688607445859"
     */
    preChapterId?: string;
    /**
     * "xz01"
     */
    preChapterName?: string;
    /**
     * "31026698807993196"
     */
    nextChapterId?: string;
    /**
     * "xz03"
     */
    nextChapterName?: string;
    /**
     * 2
     */
    vipStatus?: number;
    isAuth?: number;
    /**
     * 1
     */
    batchUnlockStatus?: number;
    chapterLevel?: number;
    userLevel?: number;
    /**
     * 1547033417000
     */
    publishTime?: number;
    /**
     * 1567411279000
     */
    updateTime?: number;
    /**
     * [{"pageId":"34089046728834849","height":1066,"width":800,"url":"https://oacomic-image.webnovel.com/comicpage/12698954101038401/34089039749512990/34089046728834849!800.jpg?sign=db4702e30fb1989982137b19d12c5089&t=1603162367&updateTime=0"}]
     */
    chapterPage?: {
      /**
       * "34089046728834849"
       */
      pageId?: string;
      /**
       * 1066
       */
      height?: number;
      /**
       * 800
       */
      width?: number;
      /**
       * "https://oacomic-image.webnovel.com/comicpage/12698954101038401/34089039749512990/34089046728834849!800.jpg?sign=db4702e30fb1989982137b19d12c5089&t=1603162367&updateTime=0"
       */
      url?: string;
    }[];
  };
  giftInfo?: {
    /**
     * 4
     */
    giftNum?: number;
    giftMax?: {
      /**
       * 110863
       */
      id?: number;
      /**
       * 13138233106881300
       */
      bookId?: number;
      chapterId?: number;
      /**
       * 3058123914
       */
      userId?: number;
      /**
       * 1
       */
      giftAmount?: number;
      /**
       * "6802653167039154752"
       */
      orderId?: string;
      /**
       * 20005
       */
      giftId?: number;
      /**
       * 200
       */
      totalPrice?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * "Ring"
       */
      giftName?: string;
      /**
       * 200
       */
      giftPrice?: number;
      /**
       * "https://webbanner.webnovel.com/gift/1539660437_9240.png"
       */
      iconUrl?: string;
      /**
       * 1
       */
      status?: number;
      /**
       * 1
       */
      order?: number;
      UUT?: number;
      /**
       * "Finaste"
       */
      userName?: string;
    };
    /**
     * [{"id":111545,"userId":4302590209,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1586791647838,"userName":"Onilade"},{"id":111443,"userId":4311075932,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1586306517322,"userName":"EddyMugety"},{"id":111355,"userId":4300193432,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1538368011165,"userName":"Irieth"},{"id":111321,"userId":4305761864,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1557492967524,"userName":"Edman747_1"},{"id":111256,"userId":4305974474,"giftId":20003,"appId":10,"giftName":"Potion","giftPrice":50,"iconUrl":"https://webbanner.webnovel.com/gift/1539660274_3567.png","status":1,"order":1,"UUT":1567982992365,"userName":"Daoist294490"},{"id":110911,"userId":4300012210,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1550734365592,"userName":"Ahzrin"},{"id":110910,"userId":4300012210,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1550734365592,"userName":"Ahzrin"},{"id":110861,"userId":3058123914,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"Finaste"},{"id":110792,"userId":4300566906,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1567513446334,"userName":"Melon150"}]
     */
    giftRecords?: {
      /**
       * 111545
       */
      id?: number;
      /**
       * 4302590209
       */
      userId?: number;
      /**
       * 20001
       */
      giftId?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * "Balloon"
       */
      giftName?: string;
      /**
       * 5
       */
      giftPrice?: number;
      /**
       * "https://webbanner.webnovel.com/gift/1539660206_9513.png"
       */
      iconUrl?: string;
      /**
       * 1
       */
      status?: number;
      /**
       * 1
       */
      order?: number;
      /**
       * 1586791647838
       */
      UUT?: number;
      /**
       * "Onilade"
       */
      userName?: string;
    }[];
  };
  settings?: {
    /**
     * "_color2"
     */
    tc?: string;
    tf?: string;
    ts?: string;
    /**
     * "1"
     */
    paragraphSwitch?: string;
  };
  membershipStatus?: number;
  waitpayStatus?: number;
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/1901271742/1/1.jpg?mt=1586775105000"
     */
    avatar?: string;
    /**
     * "testingya"
     */
    nickName?: string;
    /**
     * "testingya"
     */
    userName?: string;
    /**
     * "1901271742"
     */
    guid?: string;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * "testingya"
     */
    penName?: string;
    /**
     * 11925
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 7
     */
    grade?: number;
    /**
     * 3
     */
    ES?: number;
    /**
     * 3
     */
    totalES?: number;
    /**
     * 2
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: boolean;
    /**
     * 1585029428302
     */
    UUT?: number;
    /**
     * 1
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 1
     */
    membershipStatus?: number;
    /**
     * 1592023726000
     */
    membershipExpireTime?: number;
    /**
     * true
     */
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [阅读页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176466) 的 **请求配置的类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContentPage`
 * @更新时间 `2022-08-18 14:58:38`
 */
type GoPcmComicGetContentPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/getContentPage",
    "data",
    string,
    "comicId" | "chapterId" | "width",
    false
  >
>;

/**
 * 接口 [阅读页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176466) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContentPage`
 * @更新时间 `2022-08-18 14:58:38`
 */
const goPcmComicGetContentPageRequestConfig: GoPcmComicGetContentPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getContentPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: ["comicId", "chapterId", "width"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetContentPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [阅读页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176466) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContentPage`
 * @更新时间 `2022-08-18 14:58:38`
 */
export const goPcmComicGetContentPage = /*#__PURE__*/ (
  requestData: GoPcmComicGetContentPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicGetContentPageResponse>(
    prepare(goPcmComicGetContentPageRequestConfig, requestData),
    ...args
  );
};

goPcmComicGetContentPage.requestConfig = goPcmComicGetContentPageRequestConfig;

/**
 * 接口 [addBullet - 添加弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195816) 的 **请求类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `POST /go/pcm/comic/addBullet`
 * @更新时间 `2021-01-28 13:53:19`
 */
export interface GoPcmComicAddBulletRequest {
  comicId: string;
  chapterId: string;
  pageId: string;
  content: string;
}

/**
 * 接口 [addBullet - 添加弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195816) 的 **返回类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `POST /go/pcm/comic/addBullet`
 * @更新时间 `2021-01-28 13:53:19`
 */
export interface GoPcmComicAddBulletResponse {
  code?: number;
  msg?: string;
}

/**
 * 接口 [addBullet - 添加弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195816) 的 **请求配置的类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `POST /go/pcm/comic/addBullet`
 * @更新时间 `2021-01-28 13:53:19`
 */
type GoPcmComicAddBulletRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/addBullet",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [addBullet - 添加弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195816) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `POST /go/pcm/comic/addBullet`
 * @更新时间 `2021-01-28 13:53:19`
 */
const goPcmComicAddBulletRequestConfig: GoPcmComicAddBulletRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/addBullet",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicAddBullet",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [addBullet - 添加弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195816) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `POST /go/pcm/comic/addBullet`
 * @更新时间 `2021-01-28 13:53:19`
 */
export const goPcmComicAddBullet = /*#__PURE__*/ (
  requestData: GoPcmComicAddBulletRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicAddBulletResponse>(
    prepare(goPcmComicAddBulletRequestConfig, requestData),
    ...args
  );
};

goPcmComicAddBullet.requestConfig = goPcmComicAddBulletRequestConfig;

/**
 * 接口 [getBullet - 获取弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195821) 的 **请求类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getBullet`
 * @更新时间 `2021-01-28 13:59:48`
 */
export interface GoPcmComicGetBulletRequest {
  comicId: string;
  chapterId: string;
  pageId: string;
}

/**
 * 接口 [getBullet - 获取弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195821) 的 **返回类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getBullet`
 * @更新时间 `2021-01-28 13:59:48`
 */
export interface GoPcmComicGetBulletResponse {
  /**
   * [{"bulletId":2,"userId":5,"content":"@sentence"}]
   */
  items?: {
    /**
     * 2
     */
    bulletId?: number;
    /**
     * 5
     */
    userId?: number;
    /**
     * "@sentence"
     */
    content?: string;
  }[];
}

/**
 * 接口 [getBullet - 获取弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195821) 的 **请求配置的类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getBullet`
 * @更新时间 `2021-01-28 13:59:48`
 */
type GoPcmComicGetBulletRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/getBullet",
    "data",
    string,
    "comicId" | "chapterId" | "pageId",
    false
  >
>;

/**
 * 接口 [getBullet - 获取弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195821) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getBullet`
 * @更新时间 `2021-01-28 13:59:48`
 */
const goPcmComicGetBulletRequestConfig: GoPcmComicGetBulletRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getBullet",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: ["comicId", "chapterId", "pageId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetBullet",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getBullet - 获取弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195821) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getBullet`
 * @更新时间 `2021-01-28 13:59:48`
 */
export const goPcmComicGetBullet = /*#__PURE__*/ (
  requestData: GoPcmComicGetBulletRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicGetBulletResponse>(
    prepare(goPcmComicGetBulletRequestConfig, requestData),
    ...args
  );
};

goPcmComicGetBullet.requestConfig = goPcmComicGetBulletRequestConfig;

/**
 * 接口 [getLatestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195830) 的 **请求类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getLatestUpdates`
 * @更新时间 `2021-01-28 14:03:26`
 */
export interface GoPcmComicGetLatestUpdatesRequest {}

/**
 * 接口 [getLatestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195830) 的 **返回类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getLatestUpdates`
 * @更新时间 `2021-01-28 14:03:26`
 */
export interface GoPcmComicGetLatestUpdatesResponse {
  /**
   * [{"bookId":"@string('number', 5)","bookName":"@sentence","newChapterTime":"@string","coverUpdateTime":1}]
   */
  items?: {
    /**
     * "@string('number', 5)"
     */
    bookId?: string;
    /**
     * "@sentence"
     */
    bookName?: string;
    /**
     * "@string"
     */
    newChapterTime?: string;
    /**
     * 1
     */
    coverUpdateTime?: number;
  }[];
}

/**
 * 接口 [getLatestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195830) 的 **请求配置的类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getLatestUpdates`
 * @更新时间 `2021-01-28 14:03:26`
 */
type GoPcmComicGetLatestUpdatesRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/getLatestUpdates",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [getLatestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195830) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getLatestUpdates`
 * @更新时间 `2021-01-28 14:03:26`
 */
const goPcmComicGetLatestUpdatesRequestConfig: GoPcmComicGetLatestUpdatesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getLatestUpdates",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetLatestUpdates",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getLatestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195830) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getLatestUpdates`
 * @更新时间 `2021-01-28 14:03:26`
 */
export const goPcmComicGetLatestUpdates = /*#__PURE__*/ (
  requestData?: GoPcmComicGetLatestUpdatesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicGetLatestUpdatesResponse>(
    prepare(goPcmComicGetLatestUpdatesRequestConfig, requestData),
    ...args
  );
};

goPcmComicGetLatestUpdates.requestConfig =
  goPcmComicGetLatestUpdatesRequestConfig;

/**
 * 接口 [getComicDetailPage - 获取详情页 ↗](https://yapi.yuewen.com/project/2309/interface/api/195847) 的 **请求类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPage`
 * @更新时间 `2021-10-19 19:30:07`
 */
export interface GoPcmComicGetComicDetailPageRequest {
  /**
   * 漫画 ID
   */
  comicId: string;
}

/**
 * 接口 [getComicDetailPage - 获取详情页 ↗](https://yapi.yuewen.com/project/2309/interface/api/195847) 的 **返回类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPage`
 * @更新时间 `2021-10-19 19:30:07`
 */
export interface GoPcmComicGetComicDetailPageResponse {
  comicInfo?: {
    /**
     * "11558338301012801"
     */
    comicId?: string;
    /**
     * "Xiuzhen"
     */
    comicName?: string;
    /**
     * 23
     */
    chapterNum?: number;
    /**
     * "testName"
     */
    authorName?: string;
    ageGroup?: null;
    sourceBookId?: null;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "zh"
     */
    languageName?: string;
    /**
     * "xiuzhen synopsis"
     */
    description?: string;
    /**
     * "testName"
     */
    publisher?: string;
    /**
     * 1
     */
    actionStatus?: number;
    /**
     * 2
     */
    auditStatus?: number;
    /**
     * 100
     */
    novelType?: number;
    /**
     * 31026688607445860
     */
    firstChapterId?: number;
    /**
     * 1
     */
    pvNum?: number;
    /**
     * "0"
     */
    CV?: string;
    inLibrary?: number;
    /**
     * -1
     */
    readToChapterId?: number;
    /**
     * -1
     */
    readToChapterIndex?: number;
    /**
     * "xz01"
     */
    firstChapterName?: string;
    /**
     * "xz01"
     */
    readToChapterName?: string;
    /**
     * 1
     */
    hasPrivilege?: number;
    /**
     * [{"userId":101087995,"votingCount":9082,"UUT":1558445708000},{"userId":4300000745,"votingCount":2568,"UUT":1578305672301},{"userId":4300008614,"votingCount":550,"UUT":1578133806000},{"userId":4300002487,"votingCount":550,"UUT":1570799256000},{"userId":4300001404,"votingCount":525,"UUT":1563868714000},{"userId":4300003237,"votingCount":475,"UUT":1571141768000}]
     */
    topFanItems?: {
      /**
       * 101087995
       */
      userId?: number;
      /**
       * 9082
       */
      votingCount?: number;
      /**
       * 1558445708000
       */
      UUT?: number;
    }[];
    giftNum?: number;
    giftInfo?: {
      giftNum?: number;
      giftMax?: {
        /**
         * 62
         */
        id?: number;
        /**
         * 11558338301012800
         */
        bookId?: number;
        /**
         * 31026698807993196
         */
        chapterId?: number;
        /**
         * 4300000745
         */
        userId?: number;
        /**
         * 1
         */
        giftAmount?: number;
        /**
         * "6764623029947531884"
         */
        orderId?: string;
        /**
         * 20007
         */
        giftId?: number;
        /**
         * 666
         */
        totalPrice?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Rainbow"
         */
        giftName?: string;
        /**
         * 2500
         */
        giftPrice?: number;
        /**
         * "https://webbannertest.webnovel.com/gift/1535014273_1546.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        UUT?: number;
        /**
         * "zhang1"
         */
        userName?: string;
      };
      /**
       * [{"id":70,"userId":4300008855,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"zzz123123a_4723yvh"},{"id":69,"userId":4300000889,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"yang1dbjddbdjjdjdj"},{"id":68,"userId":4300000889,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"yang1dbjddbdjjdjdj"},{"id":67,"userId":4300000745,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"zhang1"},{"id":66,"userId":4300000745,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"zhang1"},{"id":65,"userId":4300000745,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"zhang1"},{"id":64,"userId":4300000745,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"zhang1"},{"id":63,"userId":4300000745,"giftId":20005,"appId":10,"giftName":"Cultivation Manual","giftPrice":450,"iconUrl":"https://webbannertest.webnovel.com/gift/1535014208_5782.png","status":1,"order":1,"UUT":0,"userName":"zhang1"},{"id":61,"userId":4300000745,"giftId":20007,"appId":10,"giftName":"Rainbow","giftPrice":2500,"iconUrl":"https://webbannertest.webnovel.com/gift/1535014273_1546.png","status":1,"order":1,"UUT":0,"userName":"zhang1"}]
       */
      giftRecords?: {
        /**
         * 70
         */
        id?: number;
        /**
         * 4300008855
         */
        userId?: number;
        /**
         * 20001
         */
        giftId?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Balloon"
         */
        giftName?: string;
        /**
         * 5
         */
        giftPrice?: number;
        /**
         * "https://webbanner.webnovel.com/gift/1539660206_9513.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        UUT?: number;
        /**
         * "zzz123123a_4723yvh"
         */
        userName?: string;
      }[];
    };
    /**
     * 70002
     */
    categoryId?: number;
    /**
     * "webnove Comics"
     */
    categoryName?: string;
  };
  /**
   * [{"reviewId":"@id","content":"[img=fp]@paragraph","isViceModerator":0,"isLikedByAuthor":0,"imageItems":[{"imageUrl":"@url","height":100,"width":200}],"holdBadgeCoverId":1231313123123,"bookId":10812783101029604,"userId":3968405415,"userName":"@name","headImageId":-123,"userRole":0,"userGrade":1,"totalScore":5,"replyNums":10,"likeNums":20,"leakFlag":0,"isLike":1,"holdBadgeCoverURL":"www.baidu.com","createTime":1537526601173,"createTimeFormat":"@string","topStatus":0,"appId":10,"privilegeInfo":{"isPrivilege":1,"img":"crown.png"},"essenceStatus":1}]
   */
  bookReviewInfos?: {
    /**
     * "@id"
     */
    reviewId?: string;
    /**
     * "[img=fp]@paragraph"
     */
    content?: string;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * [{"imageUrl":"@url","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "@url"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
    /**
     * 10812783101029604
     */
    bookId?: number;
    /**
     * 3968405415
     */
    userId?: number;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * -123
     */
    headImageId?: number;
    userRole?: number;
    /**
     * 1
     */
    userGrade?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * 10
     */
    replyNums?: number;
    /**
     * 20
     */
    likeNums?: number;
    leakFlag?: number;
    /**
     * 1
     */
    isLike?: number;
    /**
     * "www.baidu.com"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * "@string"
     */
    createTimeFormat?: string;
    topStatus?: number;
    /**
     * 10
     */
    appId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "crown.png"
       */
      img?: string;
    };
    /**
     * 1
     */
    essenceStatus?: number;
  }[];
  bookStatisticsInfo?: {
    /**
     * 268
     */
    totalReviewNum?: number;
    /**
     * 4.2
     */
    totalScore?: number;
    /**
     * 4.1791043
     */
    translationQuality?: number;
    /**
     * 4.171642
     */
    updatingStability?: number;
    /**
     * 4.197761
     */
    storyDevelopment?: number;
    /**
     * 4.216418
     */
    characterDesign?: number;
    /**
     * 4.2574625
     */
    worldBackGround?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * "The King's Avatar"
     */
    bookName?: string;
  };
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300000120/1/1.jpg?mt=1553072138000"
     */
    avatar?: string;
    /**
     * "bigcat004"
     */
    nickName?: string;
    /**
     * "bigcat004"
     */
    userName?: string;
    /**
     * "4300000120"
     */
    guid?: string;
    status?: number;
    role?: number;
    penName?: null;
    /**
     * 16
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 6
     */
    grade?: number;
    /**
     * 3
     */
    ES?: number;
    /**
     * 3
     */
    totalES?: number;
    /**
     * 2
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: boolean;
    /**
     * 1553072138000
     */
    UUT?: number;
  };
}

/**
 * 接口 [getComicDetailPage - 获取详情页 ↗](https://yapi.yuewen.com/project/2309/interface/api/195847) 的 **请求配置的类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPage`
 * @更新时间 `2021-10-19 19:30:07`
 */
type GoPcmComicGetComicDetailPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/getComicDetailPage",
    "data",
    string,
    "comicId",
    false
  >
>;

/**
 * 接口 [getComicDetailPage - 获取详情页 ↗](https://yapi.yuewen.com/project/2309/interface/api/195847) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPage`
 * @更新时间 `2021-10-19 19:30:07`
 */
const goPcmComicGetComicDetailPageRequestConfig: GoPcmComicGetComicDetailPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getComicDetailPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: ["comicId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetComicDetailPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getComicDetailPage - 获取详情页 ↗](https://yapi.yuewen.com/project/2309/interface/api/195847) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPage`
 * @更新时间 `2021-10-19 19:30:07`
 */
export const goPcmComicGetComicDetailPage = /*#__PURE__*/ (
  requestData: GoPcmComicGetComicDetailPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicGetComicDetailPageResponse>(
    prepare(goPcmComicGetComicDetailPageRequestConfig, requestData),
    ...args
  );
};

goPcmComicGetComicDetailPage.requestConfig =
  goPcmComicGetComicDetailPageRequestConfig;

/**
 * 接口 [getList - 获取漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195855) 的 **请求类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getList`
 * @更新时间 `2021-01-28 14:47:08`
 */
export interface GoPcmComicGetListRequest {
  pageIndex: string;
  pageSize: string;
  /**
   * 排序方式，1是popular，2是new
   */
  orderBy: string;
}

/**
 * 接口 [getList - 获取漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195855) 的 **返回类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getList`
 * @更新时间 `2021-01-28 14:47:08`
 */
export interface GoPcmComicGetListResponse {
  /**
   * [{"comicId":"12144230606989301","comicName":"My Maid is a Demon","publisher":"Readcomic","coverUpdateTime":"1547827254926"}]
   */
  items?: {
    /**
     * "12144230606989301"
     */
    comicId?: string;
    /**
     * "My Maid is a Demon"
     */
    comicName?: string;
    /**
     * "Readcomic"
     */
    publisher?: string;
    /**
     * "1547827254926"
     */
    coverUpdateTime?: string;
  }[];
  /**
   * 1
   */
  isLast?: number;
  /**
   * 1
   */
  orderBy?: number;
}

/**
 * 接口 [getList - 获取漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195855) 的 **请求配置的类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getList`
 * @更新时间 `2021-01-28 14:47:08`
 */
type GoPcmComicGetListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/getList",
    "data",
    string,
    "pageIndex" | "pageSize" | "orderBy",
    false
  >
>;

/**
 * 接口 [getList - 获取漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195855) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getList`
 * @更新时间 `2021-01-28 14:47:08`
 */
const goPcmComicGetListRequestConfig: GoPcmComicGetListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: ["pageIndex", "pageSize", "orderBy"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getList - 获取漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195855) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getList`
 * @更新时间 `2021-01-28 14:47:08`
 */
export const goPcmComicGetList = /*#__PURE__*/ (
  requestData: GoPcmComicGetListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicGetListResponse>(
    prepare(goPcmComicGetListRequestConfig, requestData),
    ...args
  );
};

goPcmComicGetList.requestConfig = goPcmComicGetListRequestConfig;

/**
 * 接口 [getListPage - 获取漫画列表(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195858) 的 **请求类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getListPage`
 * @更新时间 `2021-01-28 14:47:19`
 */
export interface GoPcmComicGetListPageRequest {
  pageIndex: string;
  pageSize: string;
  /**
   * 排序方式，1是popular，2是new
   */
  orderBy: string;
}

/**
 * 接口 [getListPage - 获取漫画列表(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195858) 的 **返回类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getListPage`
 * @更新时间 `2021-01-28 14:47:19`
 */
export interface GoPcmComicGetListPageResponse {
  /**
   * [{"comicId":"12144230606989301","comicName":"My Maid is a Demon","publisher":"Readcomic","coverUpdateTime":"1547827254926"}]
   */
  items?: {
    /**
     * "12144230606989301"
     */
    comicId?: string;
    /**
     * "My Maid is a Demon"
     */
    comicName?: string;
    /**
     * "Readcomic"
     */
    publisher?: string;
    /**
     * "1547827254926"
     */
    coverUpdateTime?: string;
  }[];
  /**
   * 1
   */
  isLast?: number;
  /**
   * 1
   */
  orderBy?: number;
}

/**
 * 接口 [getListPage - 获取漫画列表(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195858) 的 **请求配置的类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getListPage`
 * @更新时间 `2021-01-28 14:47:19`
 */
type GoPcmComicGetListPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/getListPage",
    "data",
    string,
    "pageIndex" | "pageSize" | "orderBy",
    false
  >
>;

/**
 * 接口 [getListPage - 获取漫画列表(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195858) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getListPage`
 * @更新时间 `2021-01-28 14:47:19`
 */
const goPcmComicGetListPageRequestConfig: GoPcmComicGetListPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getListPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: ["pageIndex", "pageSize", "orderBy"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetListPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getListPage - 获取漫画列表(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195858) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getListPage`
 * @更新时间 `2021-01-28 14:47:19`
 */
export const goPcmComicGetListPage = /*#__PURE__*/ (
  requestData: GoPcmComicGetListPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicGetListPageResponse>(
    prepare(goPcmComicGetListPageRequestConfig, requestData),
    ...args
  );
};

goPcmComicGetListPage.requestConfig = goPcmComicGetListPageRequestConfig;

/**
 * 接口 [getChapterList - 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195876) 的 **请求类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getChapterList`
 * @更新时间 `2022-12-05 14:46:18`
 */
export interface GoPcmComicGetChapterListRequest {
  comicId: string;
}

/**
 * 接口 [getChapterList - 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195876) 的 **返回类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getChapterList`
 * @更新时间 `2022-12-05 14:46:18`
 */
export interface GoPcmComicGetChapterListResponse {
  comicInfo?: {
    /**
     * "111"
     */
    comicId?: string;
    /**
     * "xxxx"
     */
    comicName?: string;
    /**
     * "44"
     */
    chapterNum?: string;
    /**
     * "3124125"
     */
    newChapterId?: string;
    /**
     * "44"
     */
    newChapterIndex?: string;
    /**
     * "xxxxx"
     */
    newChapterName?: string;
    /**
     * "3 weeks ago"
     */
    newChapterTime?: string;
    /**
     * 1
     */
    hasPrivilege?: number;
    /**
     * "ArriaCross"
     */
    authorName?: string;
    /**
     * 70002
     */
    categoryId?: number;
    /**
     * "webnove Comics"
     */
    categoryName?: string;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "zh"
     */
    languageName?: string;
  };
  /**
   * [{"chapterId":"123123123","chapterName":"xxxx","chapterIndex":"1","vipStatus":"-1","isAuth":"1","pageCount":"123","publishTime":"4 days ago","chapterImageUrl":"@string"},{"chapterId":"123123123","chapterName":"xxxx","chapterIndex":"1","vipStatus":"-1","isAuth":"1","pageCount":"123","publishTime":"4 days ago"}]
   */
  comicChapters?: {
    /**
     * "123123123"
     */
    chapterId?: string;
    /**
     * "xxxx"
     */
    chapterName?: string;
    /**
     * "1"
     */
    chapterIndex?: string;
    /**
     * "-1"
     */
    vipStatus?: string;
    /**
     * "1"
     */
    isAuth?: string;
    /**
     * "123"
     */
    pageCount?: string;
    /**
     * "4 days ago"
     */
    publishTime?: string;
    /**
     * "@string"
     */
    chapterImageUrl?: string;
  }[];
}

/**
 * 接口 [getChapterList - 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195876) 的 **请求配置的类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getChapterList`
 * @更新时间 `2022-12-05 14:46:18`
 */
type GoPcmComicGetChapterListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/getChapterList",
    "data",
    string,
    "comicId",
    false
  >
>;

/**
 * 接口 [getChapterList - 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195876) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getChapterList`
 * @更新时间 `2022-12-05 14:46:18`
 */
const goPcmComicGetChapterListRequestConfig: GoPcmComicGetChapterListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getChapterList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: ["comicId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetChapterList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getChapterList - 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195876) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getChapterList`
 * @更新时间 `2022-12-05 14:46:18`
 */
export const goPcmComicGetChapterList = /*#__PURE__*/ (
  requestData: GoPcmComicGetChapterListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicGetChapterListResponse>(
    prepare(goPcmComicGetChapterListRequestConfig, requestData),
    ...args
  );
};

goPcmComicGetChapterList.requestConfig = goPcmComicGetChapterListRequestConfig;

/**
 * 接口 [getUpdateList - 每日漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195882) 的 **请求类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getUpdateList`
 * @更新时间 `2021-01-28 15:04:18`
 */
export interface GoPcmComicGetUpdateListRequest {
  /**
   * 获取上次返回漫画列表最后一个的logTime，第一次进入列表页不传
   *
   *
   */
  logTime?: string;
}

/**
 * 接口 [getUpdateList - 每日漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195882) 的 **返回类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getUpdateList`
 * @更新时间 `2021-01-28 15:04:18`
 */
export interface GoPcmComicGetUpdateListResponse {
  /**
   * [{"comicId":"@id","comicName":"@name","chapterId":"@id","chapterIndex":121,"chapterName":"@name","chapterCover":"@url","chapterDescription":"@name","hasChapterCover":1,"logTime":"@time","pvNum":11123}]
   */
  items?: {
    /**
     * "@id"
     */
    comicId?: string;
    /**
     * "@name"
     */
    comicName?: string;
    /**
     * "@id"
     */
    chapterId?: string;
    /**
     * 121
     */
    chapterIndex?: number;
    /**
     * "@name"
     */
    chapterName?: string;
    /**
     * "@url"
     */
    chapterCover?: string;
    /**
     * "@name"
     */
    chapterDescription?: string;
    /**
     * 1
     */
    hasChapterCover?: number;
    /**
     * "@time"
     */
    logTime?: string;
    /**
     * 11123
     */
    pvNum?: number;
  }[];
  isLast?: number;
}

/**
 * 接口 [getUpdateList - 每日漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195882) 的 **请求配置的类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getUpdateList`
 * @更新时间 `2021-01-28 15:04:18`
 */
type GoPcmComicGetUpdateListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/getUpdateList",
    "data",
    string,
    "logTime",
    false
  >
>;

/**
 * 接口 [getUpdateList - 每日漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195882) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getUpdateList`
 * @更新时间 `2021-01-28 15:04:18`
 */
const goPcmComicGetUpdateListRequestConfig: GoPcmComicGetUpdateListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getUpdateList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: ["logTime"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetUpdateList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getUpdateList - 每日漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195882) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getUpdateList`
 * @更新时间 `2021-01-28 15:04:18`
 */
export const goPcmComicGetUpdateList = /*#__PURE__*/ (
  requestData: GoPcmComicGetUpdateListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicGetUpdateListResponse>(
    prepare(goPcmComicGetUpdateListRequestConfig, requestData),
    ...args
  );
};

goPcmComicGetUpdateList.requestConfig = goPcmComicGetUpdateListRequestConfig;

/**
 * 接口 [getComicDetailPc - 获取详情页PC直出↗](https://yapi.yuewen.com/project/2309/interface/api/292307) 的 **请求类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPc`
 * @更新时间 `2024-09-09 20:38:31`
 */
export interface GoPcmComicGetComicDetailPcRequest {
  /**
   * 漫画 ID
   */
  comicId: string;
}

/**
 * 接口 [getComicDetailPc - 获取详情页PC直出↗](https://yapi.yuewen.com/project/2309/interface/api/292307) 的 **返回类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPc`
 * @更新时间 `2024-09-09 20:38:31`
 */
export interface GoPcmComicGetComicDetailPcResponse {
  comicInfo?: {
    /**
     * "11558338301012801"
     */
    comicId?: string;
    /**
     * "Xiuzhen"
     */
    comicName?: string;
    /**
     * 23
     */
    chapterNum?: number;
    /**
     * "testName"
     */
    authorName?: string;
    ageGroup?: null;
    sourceBookId?: null;
    /**
     * 1
     */
    languageCode?: number;
    /**
     * "zh"
     */
    languageName?: string;
    /**
     * "xiuzhen synopsis"
     */
    description?: string;
    /**
     * "testName"
     */
    publisher?: string;
    /**
     * 1
     */
    actionStatus?: number;
    /**
     * 2
     */
    auditStatus?: number;
    /**
     * 100
     */
    novelType?: number;
    /**
     * 31026688607445860
     */
    firstChapterId?: number;
    /**
     * 1
     */
    pvNum?: number;
    /**
     * "0"
     */
    CV?: string;
    inLibrary?: number;
    /**
     * -1
     */
    readToChapterId?: number;
    /**
     * -1
     */
    readToChapterIndex?: number;
    /**
     * "xz01"
     */
    firstChapterName?: string;
    /**
     * "xz01"
     */
    readToChapterName?: string;
    /**
     * 1
     */
    hasPrivilege?: number;
    /**
     * [{"userId":101087995,"votingCount":9082,"UUT":1558445708000},{"userId":4300000745,"votingCount":2568,"UUT":1578305672301},{"userId":4300008614,"votingCount":550,"UUT":1578133806000},{"userId":4300002487,"votingCount":550,"UUT":1570799256000},{"userId":4300001404,"votingCount":525,"UUT":1563868714000},{"userId":4300003237,"votingCount":475,"UUT":1571141768000}]
     */
    topFanItems?: {
      /**
       * 101087995
       */
      userId?: number;
      /**
       * 9082
       */
      votingCount?: number;
      /**
       * 1558445708000
       */
      UUT?: number;
    }[];
    giftNum?: number;
    giftInfo?: {
      giftNum?: number;
      giftMax?: {
        /**
         * 62
         */
        id?: number;
        /**
         * 11558338301012800
         */
        bookId?: number;
        /**
         * 31026698807993196
         */
        chapterId?: number;
        /**
         * 4300000745
         */
        userId?: number;
        /**
         * 1
         */
        giftAmount?: number;
        /**
         * "6764623029947531884"
         */
        orderId?: string;
        /**
         * 20007
         */
        giftId?: number;
        /**
         * 666
         */
        totalPrice?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Rainbow"
         */
        giftName?: string;
        /**
         * 2500
         */
        giftPrice?: number;
        /**
         * "https://webbannertest.webnovel.com/gift/1535014273_1546.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        UUT?: number;
        /**
         * "zhang1"
         */
        userName?: string;
      };
      /**
       * [{"id":70,"userId":4300008855,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"zzz123123a_4723yvh"},{"id":69,"userId":4300000889,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"yang1dbjddbdjjdjdj"},{"id":68,"userId":4300000889,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"yang1dbjddbdjjdjdj"},{"id":67,"userId":4300000745,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"zhang1"},{"id":66,"userId":4300000745,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"zhang1"},{"id":65,"userId":4300000745,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"zhang1"},{"id":64,"userId":4300000745,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":0,"userName":"zhang1"},{"id":63,"userId":4300000745,"giftId":20005,"appId":10,"giftName":"Cultivation Manual","giftPrice":450,"iconUrl":"https://webbannertest.webnovel.com/gift/1535014208_5782.png","status":1,"order":1,"UUT":0,"userName":"zhang1"},{"id":61,"userId":4300000745,"giftId":20007,"appId":10,"giftName":"Rainbow","giftPrice":2500,"iconUrl":"https://webbannertest.webnovel.com/gift/1535014273_1546.png","status":1,"order":1,"UUT":0,"userName":"zhang1"}]
       */
      giftRecords?: {
        /**
         * 70
         */
        id?: number;
        /**
         * 4300008855
         */
        userId?: number;
        /**
         * 20001
         */
        giftId?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Balloon"
         */
        giftName?: string;
        /**
         * 5
         */
        giftPrice?: number;
        /**
         * "https://webbanner.webnovel.com/gift/1539660206_9513.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        UUT?: number;
        /**
         * "zzz123123a_4723yvh"
         */
        userName?: string;
      }[];
    };
    /**
     * 70002
     */
    categoryId?: number;
    /**
     * "webnove Comics"
     */
    categoryName?: string;
  };
  /**
   * [{"reviewId":"@id","content":"[img=fp]@paragraph","isViceModerator":0,"isLikedByAuthor":0,"imageItems":[{"imageUrl":"@url","height":100,"width":200}],"holdBadgeCoverId":1231313123123,"bookId":10812783101029604,"userId":3968405415,"userName":"@name","headImageId":-123,"userRole":0,"userGrade":1,"totalScore":5,"replyNums":10,"likeNums":20,"leakFlag":0,"isLike":1,"holdBadgeCoverURL":"www.baidu.com","createTime":1537526601173,"createTimeFormat":"@string","topStatus":0,"appId":10,"privilegeInfo":{"isPrivilege":1,"img":"crown.png"},"essenceStatus":1}]
   */
  bookReviewInfos?: {
    /**
     * "@id"
     */
    reviewId?: string;
    /**
     * "[img=fp]@paragraph"
     */
    content?: string;
    isViceModerator?: number;
    isLikedByAuthor?: number;
    /**
     * [{"imageUrl":"@url","height":100,"width":200}]
     */
    imageItems?: {
      /**
       * "@url"
       */
      imageUrl?: string;
      /**
       * 100
       */
      height?: number;
      /**
       * 200
       */
      width?: number;
    }[];
    /**
     * 1231313123123
     */
    holdBadgeCoverId?: number;
    /**
     * 10812783101029604
     */
    bookId?: number;
    /**
     * 3968405415
     */
    userId?: number;
    /**
     * "@name"
     */
    userName?: string;
    /**
     * -123
     */
    headImageId?: number;
    userRole?: number;
    /**
     * 1
     */
    userGrade?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * 10
     */
    replyNums?: number;
    /**
     * 20
     */
    likeNums?: number;
    leakFlag?: number;
    /**
     * 1
     */
    isLike?: number;
    /**
     * "www.baidu.com"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1537526601173
     */
    createTime?: number;
    /**
     * "@string"
     */
    createTimeFormat?: string;
    topStatus?: number;
    /**
     * 10
     */
    appId?: number;
    privilegeInfo?: {
      /**
       * 1
       */
      isPrivilege?: number;
      /**
       * "crown.png"
       */
      img?: string;
    };
    /**
     * 1
     */
    essenceStatus?: number;
  }[];
  bookStatisticsInfo?: {
    /**
     * 268
     */
    totalReviewNum?: number;
    /**
     * 4.2
     */
    totalScore?: number;
    /**
     * 4.1791043
     */
    translationQuality?: number;
    /**
     * 4.171642
     */
    updatingStability?: number;
    /**
     * 4.197761
     */
    storyDevelopment?: number;
    /**
     * 4.216418
     */
    characterDesign?: number;
    /**
     * 4.2574625
     */
    worldBackGround?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * "The King's Avatar"
     */
    bookName?: string;
  };
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300000120/1/1.jpg?mt=1553072138000"
     */
    avatar?: string;
    /**
     * "bigcat004"
     */
    nickName?: string;
    /**
     * "bigcat004"
     */
    userName?: string;
    /**
     * "4300000120"
     */
    guid?: string;
    status?: number;
    role?: number;
    penName?: null;
    /**
     * 16
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 6
     */
    grade?: number;
    /**
     * 3
     */
    ES?: number;
    /**
     * 3
     */
    totalES?: number;
    /**
     * 2
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: boolean;
    /**
     * 1553072138000
     */
    UUT?: number;
  };
}

/**
 * 接口 [getComicDetailPc - 获取详情页PC直出↗](https://yapi.yuewen.com/project/2309/interface/api/292307) 的 **请求配置的类型**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPc`
 * @更新时间 `2024-09-09 20:38:31`
 */
type GoPcmComicGetComicDetailPcRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/getComicDetailPc",
    "data",
    string,
    "comicId",
    false
  >
>;

/**
 * 接口 [getComicDetailPc - 获取详情页PC直出↗](https://yapi.yuewen.com/project/2309/interface/api/292307) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPc`
 * @更新时间 `2024-09-09 20:38:31`
 */
const goPcmComicGetComicDetailPcRequestConfig: GoPcmComicGetComicDetailPcRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getComicDetailPc",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: ["comicId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetComicDetailPc",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getComicDetailPc - 获取详情页PC直出↗](https://yapi.yuewen.com/project/2309/interface/api/292307) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPc`
 * @更新时间 `2024-09-09 20:38:31`
 */
export const goPcmComicGetComicDetailPc = /*#__PURE__*/ (
  requestData: GoPcmComicGetComicDetailPcRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicGetComicDetailPcResponse>(
    prepare(goPcmComicGetComicDetailPcRequestConfig, requestData),
    ...args
  );
};

goPcmComicGetComicDetailPc.requestConfig =
  goPcmComicGetComicDetailPcRequestConfig;

const mockUrl_0_0_0_16 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_16 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_16 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_16 = "data" as any;

/**
 * 接口 [智能推荐二级页（go直出页）↗](https://yapi.yuewen.com/project/2309/interface/api/176525) 的 **请求类型**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendListPage`
 * @更新时间 `2020-12-02 19:36:45`
 */
export interface GoPcmRecommendGetRecommendListPageRequest {
  /**
   * 1：根据人推荐书 2：根据书推荐
   */
  type: string;
  /**
   * 根据书推荐时需要传入
   */
  bookId?: string;
  /**
   * 1 按20条分页
   */
  pageIndex?: string;
}

/**
 * 接口 [智能推荐二级页（go直出页）↗](https://yapi.yuewen.com/project/2309/interface/api/176525) 的 **返回类型**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendListPage`
 * @更新时间 `2020-12-02 19:36:45`
 */
export interface GoPcmRecommendGetRecommendListPageResponse {
  /**
   * [{"bookId":7765027801015505,"bookName":"War Sovereign Soaring The Heavens","novelType":0,"categoryId":12,"categoryName":"test","authorName":"aaa","coverUpdateTime":1513319976161,"totalScore":5,"tagInfo":[{"id":1,"tagName":"tag"}],"description":"dfrastraytrdhgdshghfdjtsyyt","totalChapterNum":100}]
   */
  recommendListItems?: {
    /**
     * 7765027801015505
     */
    bookId?: number;
    /**
     * "War Sovereign Soaring The Heavens"
     */
    bookName?: string;
    novelType?: number;
    /**
     * 12
     */
    categoryId?: number;
    /**
     * "test"
     */
    categoryName?: string;
    /**
     * "aaa"
     */
    authorName?: string;
    /**
     * 1513319976161
     */
    coverUpdateTime?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * [{"id":1,"tagName":"tag"}]
     */
    tagInfo?: {
      /**
       * 1
       */
      id?: number;
      /**
       * "tag"
       */
      tagName?: string;
    }[];
    /**
     * "dfrastraytrdhgdshghfdjtsyyt"
     */
    description?: string;
    /**
     * 100
     */
    totalChapterNum?: number;
  }[];
  /**
   * "0"
   */
  isLast?: string;
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300001149/1/1.jpg?mt=1560344081420"
     */
    avatar?: string;
    /**
     * "Nana_Sun_Cherry"
     */
    nickName?: string;
    /**
     * "Nana_Sun_Cherry"
     */
    userName?: string;
    /**
     * "4300001149"
     */
    guid?: string;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * "Nana_Sun_Cherry"
     */
    penName?: string;
    /**
     * 81
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 1
     */
    grade?: number;
    /**
     * 10
     */
    ES?: number;
    /**
     * 10
     */
    totalES?: number;
    /**
     * 10
     */
    PS?: number;
    /**
     * 1
     */
    totalPS?: number;
    emailStatus?: number;
    /**
     * true
     */
    isCheckIn?: boolean;
    UUT?: number;
    /**
     * 2
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 1
     */
    membershipStatus?: number;
    /**
     * 1516773399000
     */
    membershipExpireTime?: number;
    /**
     * true
     */
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [智能推荐二级页（go直出页）↗](https://yapi.yuewen.com/project/2309/interface/api/176525) 的 **请求配置的类型**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendListPage`
 * @更新时间 `2020-12-02 19:36:45`
 */
type GoPcmRecommendGetRecommendListPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/recommend/getRecommendListPage",
    "data",
    string,
    "type" | "bookId" | "pageIndex",
    false
  >
>;

/**
 * 接口 [智能推荐二级页（go直出页）↗](https://yapi.yuewen.com/project/2309/interface/api/176525) 的 **请求配置**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendListPage`
 * @更新时间 `2020-12-02 19:36:45`
 */
const goPcmRecommendGetRecommendListPageRequestConfig: GoPcmRecommendGetRecommendListPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_16,
    devUrl: devUrl_0_0_0_16,
    prodUrl: prodUrl_0_0_0_16,
    path: "/go/pcm/recommend/getRecommendListPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_16,
    paramNames: [],
    queryNames: ["type", "bookId", "pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRecommendGetRecommendListPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [智能推荐二级页（go直出页）↗](https://yapi.yuewen.com/project/2309/interface/api/176525) 的 **请求函数**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendListPage`
 * @更新时间 `2020-12-02 19:36:45`
 */
export const goPcmRecommendGetRecommendListPage = /*#__PURE__*/ (
  requestData: GoPcmRecommendGetRecommendListPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmRecommendGetRecommendListPageResponse>(
    prepare(goPcmRecommendGetRecommendListPageRequestConfig, requestData),
    ...args
  );
};

goPcmRecommendGetRecommendListPage.requestConfig =
  goPcmRecommendGetRecommendListPageRequestConfig;

/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/2309/interface/api/176533) 的 **请求类型**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2022-05-30 17:04:37`
 */
export interface GoPcmRecommendGetRecommendList2Request {
  /**
   * 1：根据人推荐书 2：根据书推荐
   */
  type: string;
  /**
   * 根据书推荐时需要传入
   */
  bookId?: string;
  /**
   * 1 按20条分页
   */
  pageIndex?: string;
  /**
   * 0：无须带原书信息  1：需带原书信息 默认0
   */
  withOrigin?: string;
}

/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/2309/interface/api/176533) 的 **返回类型**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2022-05-30 17:04:37`
 */
export interface GoPcmRecommendGetRecommendList2Response {
  /**
   * [{"bookId":7765027801015505,"bookName":"War Sovereign Soaring The Heavens","novelType":0,"categoryId":12,"categoryName":"test","authorName":"aaa","coverUpdateTime":1513319976161,"totalScore":5,"tagInfo":[{"id":1,"tagName":"tag"}],"description":"dfrastraytrdhgdshghfdjtsyyt","totalChapterNum":100}]
   */
  recommendListItems?: {
    /**
     * 7765027801015505
     */
    bookId?: number;
    /**
     * "War Sovereign Soaring The Heavens"
     */
    bookName?: string;
    novelType?: number;
    /**
     * 12
     */
    categoryId?: number;
    /**
     * "test"
     */
    categoryName?: string;
    /**
     * "aaa"
     */
    authorName?: string;
    /**
     * 1513319976161
     */
    coverUpdateTime?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * [{"id":1,"tagName":"tag"}]
     */
    tagInfo?: {
      /**
       * 1
       */
      id?: number;
      /**
       * "tag"
       */
      tagName?: string;
    }[];
    /**
     * "dfrastraytrdhgdshghfdjtsyyt"
     */
    description?: string;
    /**
     * 100
     */
    totalChapterNum?: number;
  }[];
  /**
   * "0"
   */
  isLast?: string;
}

/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/2309/interface/api/176533) 的 **请求配置的类型**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2022-05-30 17:04:37`
 */
type GoPcmRecommendGetRecommendList2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/recommend/getRecommendList",
    "data",
    string,
    "type" | "bookId" | "pageIndex" | "withOrigin",
    false
  >
>;

/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/2309/interface/api/176533) 的 **请求配置**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2022-05-30 17:04:37`
 */
const goPcmRecommendGetRecommendList2RequestConfig: GoPcmRecommendGetRecommendList2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_16,
    devUrl: devUrl_0_0_0_16,
    prodUrl: prodUrl_0_0_0_16,
    path: "/go/pcm/recommend/getRecommendList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_16,
    paramNames: [],
    queryNames: ["type", "bookId", "pageIndex", "withOrigin"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRecommendGetRecommendList2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/2309/interface/api/176533) 的 **请求函数**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2022-05-30 17:04:37`
 */
export const goPcmRecommendGetRecommendList2 = /*#__PURE__*/ (
  requestData: GoPcmRecommendGetRecommendList2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmRecommendGetRecommendList2Response>(
    prepare(goPcmRecommendGetRecommendList2RequestConfig, requestData),
    ...args
  );
};

goPcmRecommendGetRecommendList2.requestConfig =
  goPcmRecommendGetRecommendList2RequestConfig;

/**
 * 接口 [list - 获取推荐书籍列表↗](https://yapi.yuewen.com/project/2309/interface/api/198691) 的 **请求类型**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/list`
 * @更新时间 `2021-03-15 19:41:11`
 */
export interface GoPcmRecommendListRequest {
  /**
   * 1：根据人推荐书 2：根据书推荐
   */
  recommendType: string;
  /**
   * 书id
   */
  bookId: string;
  pageIndex?: string;
}

/**
 * 接口 [list - 获取推荐书籍列表↗](https://yapi.yuewen.com/project/2309/interface/api/198691) 的 **返回类型**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/list`
 * @更新时间 `2021-03-15 19:41:11`
 */
export interface GoPcmRecommendListResponse {}

/**
 * 接口 [list - 获取推荐书籍列表↗](https://yapi.yuewen.com/project/2309/interface/api/198691) 的 **请求配置的类型**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/list`
 * @更新时间 `2021-03-15 19:41:11`
 */
type GoPcmRecommendListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/recommend/list",
    "data",
    string,
    "recommendType" | "bookId" | "pageIndex",
    false
  >
>;

/**
 * 接口 [list - 获取推荐书籍列表↗](https://yapi.yuewen.com/project/2309/interface/api/198691) 的 **请求配置**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/list`
 * @更新时间 `2021-03-15 19:41:11`
 */
const goPcmRecommendListRequestConfig: GoPcmRecommendListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_16,
    devUrl: devUrl_0_0_0_16,
    prodUrl: prodUrl_0_0_0_16,
    path: "/go/pcm/recommend/list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_16,
    paramNames: [],
    queryNames: ["recommendType", "bookId", "pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRecommendList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [list - 获取推荐书籍列表↗](https://yapi.yuewen.com/project/2309/interface/api/198691) 的 **请求函数**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/list`
 * @更新时间 `2021-03-15 19:41:11`
 */
export const goPcmRecommendList = /*#__PURE__*/ (
  requestData: GoPcmRecommendListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmRecommendListResponse>(
    prepare(goPcmRecommendListRequestConfig, requestData),
    ...args
  );
};

goPcmRecommendList.requestConfig = goPcmRecommendListRequestConfig;

/**
 * 接口 [recommendItems you may also like逻辑↗](https://yapi.yuewen.com/project/2309/interface/api/287842) 的 **请求类型**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/youMayAlsoLike`
 * @更新时间 `2024-06-12 14:17:51`
 */
export interface GoPcmRecommendYouMayAlsoLikeRequest {
  /**
   * 书/漫画/fan-fic 的id
   */
  itemId: string;
  /**
   * BookTypeEnum_NOVEL     = 0
   * BookTypeEnum_COMIC     = 100
   * BookTypeEnum_PUBLISH   = 200
   * BookTypeEnum_SHORTPLAY = 300
   */
  bookType: string;
  pageIndex: string;
  pageSize: string;
}

/**
 * 接口 [recommendItems you may also like逻辑↗](https://yapi.yuewen.com/project/2309/interface/api/287842) 的 **返回类型**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/youMayAlsoLike`
 * @更新时间 `2024-06-12 14:17:51`
 */
export interface GoPcmRecommendYouMayAlsoLikeResponse {}

/**
 * 接口 [recommendItems you may also like逻辑↗](https://yapi.yuewen.com/project/2309/interface/api/287842) 的 **请求配置的类型**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/youMayAlsoLike`
 * @更新时间 `2024-06-12 14:17:51`
 */
type GoPcmRecommendYouMayAlsoLikeRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/recommend/youMayAlsoLike",
    "data",
    string,
    "itemId" | "bookType" | "pageIndex" | "pageSize",
    false
  >
>;

/**
 * 接口 [recommendItems you may also like逻辑↗](https://yapi.yuewen.com/project/2309/interface/api/287842) 的 **请求配置**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/youMayAlsoLike`
 * @更新时间 `2024-06-12 14:17:51`
 */
const goPcmRecommendYouMayAlsoLikeRequestConfig: GoPcmRecommendYouMayAlsoLikeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_16,
    devUrl: devUrl_0_0_0_16,
    prodUrl: prodUrl_0_0_0_16,
    path: "/go/pcm/recommend/youMayAlsoLike",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_16,
    paramNames: [],
    queryNames: ["itemId", "bookType", "pageIndex", "pageSize"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRecommendYouMayAlsoLike",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [recommendItems you may also like逻辑↗](https://yapi.yuewen.com/project/2309/interface/api/287842) 的 **请求函数**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/youMayAlsoLike`
 * @更新时间 `2024-06-12 14:17:51`
 */
export const goPcmRecommendYouMayAlsoLike = /*#__PURE__*/ (
  requestData: GoPcmRecommendYouMayAlsoLikeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmRecommendYouMayAlsoLikeResponse>(
    prepare(goPcmRecommendYouMayAlsoLikeRequestConfig, requestData),
    ...args
  );
};

goPcmRecommendYouMayAlsoLike.requestConfig =
  goPcmRecommendYouMayAlsoLikeRequestConfig;

const mockUrl_0_0_0_17 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_17 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_17 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_17 = "data" as any;

/**
 * 接口 [期待票直出新↗](https://yapi.yuewen.com/project/2309/interface/api/176353) 的 **请求类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2021-04-08 19:52:43`
 */
export interface GoPcmExpectEsList2Request {}

/**
 * 接口 [期待票直出新↗](https://yapi.yuewen.com/project/2309/interface/api/176353) 的 **返回类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2021-04-08 19:52:43`
 */
export interface GoPcmExpectEsList2Response {
  topLastWeekMale?: {
    /**
     * "11358144901005705"
     */
    bookId?: string;
    bookType?: number;
    /**
     * "Job testing"
     */
    bookName?: string;
    /**
     * 1
     */
    sex?: number;
    /**
     * "jt"
     */
    authorName?: string;
    totalScore?: number;
    energyNum?: number;
    /**
     * 1577155285613
     */
    coverUpdateTime?: number;
    /**
     * "LGBT+"
     */
    categoryName?: string;
    /**
     * 70019
     */
    categoryId?: number;
  };
  topLastWeekFemale?: {
    /**
     * "18079900801068205"
     */
    bookId?: string;
    bookType?: number;
    /**
     * "webnovel third tranlation 20200923"
     */
    bookName?: string;
    /**
     * 2
     */
    sex?: number;
    /**
     * "zyl"
     */
    authorName?: string;
    totalScore?: number;
    energyNum?: number;
    /**
     * 1610356634881
     */
    coverUpdateTime?: number;
    /**
     * "Magical Realism"
     */
    categoryName?: string;
    /**
     * 70001
     */
    categoryId?: number;
  };
  /**
   * [{"bookId":"6996619901010405","bookType":0,"bookName":"The Sage Who Transcended Samsara  Cuttlefish That Loves Diving","sex":2,"authorName":"aaa","totalScore":0,"energyNum":226,"coverUpdateTime":1581418723054,"categoryName":"Magical Realism","categoryId":70001},{"bookId":"18079900801068205","bookType":0,"bookName":"webnovel third tranlation 20200923","sex":2,"authorName":"zyl","totalScore":0,"energyNum":0,"coverUpdateTime":1610356634881,"categoryName":"Magical Realism","categoryId":70001}]
   */
  topFemaleItems?: {
    /**
     * "6996619901010405"
     */
    bookId?: string;
    bookType?: number;
    /**
     * "The Sage Who Transcended Samsara  Cuttlefish That Loves Diving"
     */
    bookName?: string;
    /**
     * 2
     */
    sex?: number;
    /**
     * "aaa"
     */
    authorName?: string;
    totalScore?: number;
    /**
     * 226
     */
    energyNum?: number;
    /**
     * 1581418723054
     */
    coverUpdateTime?: number;
    /**
     * "Magical Realism"
     */
    categoryName?: string;
    /**
     * 70001
     */
    categoryId?: number;
  }[];
  /**
   * [{"bookId":"7479922501012705","bookType":0,"bookName":"The Desolate Era","sex":1,"authorName":"I Eat Tomatos","totalScore":0,"energyNum":116,"coverUpdateTime":0,"categoryName":"Realistic Fiction","categoryId":70010},{"bookId":"11358144901005705","bookType":0,"bookName":"Job testing","sex":1,"authorName":"jt","totalScore":0,"energyNum":0,"coverUpdateTime":1577155285613,"categoryName":"LGBT+","categoryId":70019}]
   */
  topMaleItems?: {
    /**
     * "7479922501012705"
     */
    bookId?: string;
    bookType?: number;
    /**
     * "The Desolate Era"
     */
    bookName?: string;
    /**
     * 1
     */
    sex?: number;
    /**
     * "I Eat Tomatos"
     */
    authorName?: string;
    totalScore?: number;
    /**
     * 116
     */
    energyNum?: number;
    coverUpdateTime?: number;
    /**
     * "Realistic Fiction"
     */
    categoryName?: string;
    /**
     * 70010
     */
    categoryId?: number;
  }[];
  /**
   * [{"bookId":"6831119801007105","bookType":0,"bookName":"The Great Thief","sex":1,"authorName":"Boating Lyrics","totalScore":0,"energyNum":91,"coverUpdateTime":1581421902476,"categoryName":"Magical Realism","categoryId":70001},{"bookId":"6831119801006905","bookType":0,"bookName":"Forty Millenniums of Cultivation","sex":1,"authorName":"The Enlightened Master Crouching Cow","totalScore":0,"energyNum":12,"coverUpdateTime":1581421901380,"categoryName":"Magical Realism","categoryId":70001}]
   */
  voteMaleItems?: {
    /**
     * "6831119801007105"
     */
    bookId?: string;
    bookType?: number;
    /**
     * "The Great Thief"
     */
    bookName?: string;
    /**
     * 1
     */
    sex?: number;
    /**
     * "Boating Lyrics"
     */
    authorName?: string;
    totalScore?: number;
    /**
     * 91
     */
    energyNum?: number;
    /**
     * 1581421902476
     */
    coverUpdateTime?: number;
    /**
     * "Magical Realism"
     */
    categoryName?: string;
    /**
     * 70001
     */
    categoryId?: number;
  }[];
  /**
   * [{"bookId":"10961082401001305","bookType":0,"bookName":"shang gu xian qin","sex":2,"authorName":"pingan","totalScore":0,"energyNum":765775,"coverUpdateTime":0,"categoryName":"Magical Realism","categoryId":70001},{"bookId":"15230547501140405","bookType":0,"bookName":"Genesis, field 550123802","sex":2,"authorName":"TYPO 1","totalScore":0,"energyNum":170,"coverUpdateTime":1606879626493,"categoryName":"Realistic Fiction","categoryId":70010}]
   */
  voteFemaleItems?: {
    /**
     * "10961082401001305"
     */
    bookId?: string;
    bookType?: number;
    /**
     * "shang gu xian qin"
     */
    bookName?: string;
    /**
     * 2
     */
    sex?: number;
    /**
     * "pingan"
     */
    authorName?: string;
    totalScore?: number;
    /**
     * 765775
     */
    energyNum?: number;
    coverUpdateTime?: number;
    /**
     * "Magical Realism"
     */
    categoryName?: string;
    /**
     * 70001
     */
    categoryId?: number;
  }[];
  recommendItems?: {
    Female?: {
      title?: string;
      /**
       * []
       */
      items?: unknown[];
    };
    Male?: {
      title?: string;
      /**
       * []
       */
      items?: unknown[];
    };
  };
  user?: {
    status?: number;
    /**
     * 10
     */
    availableEnergy?: number;
  };
  /**
   * [{"awardType":1,"amount":10},{"awardType":2,"amount":10}]
   */
  awards?: {
    /**
     * 1
     */
    awardType?: number;
    /**
     * 10
     */
    amount?: number;
  }[];
}

/**
 * 接口 [期待票直出新↗](https://yapi.yuewen.com/project/2309/interface/api/176353) 的 **请求配置的类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2021-04-08 19:52:43`
 */
type GoPcmExpectEsList2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/expect/esList",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [期待票直出新↗](https://yapi.yuewen.com/project/2309/interface/api/176353) 的 **请求配置**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2021-04-08 19:52:43`
 */
const goPcmExpectEsList2RequestConfig: GoPcmExpectEsList2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_17,
    devUrl: devUrl_0_0_0_17,
    prodUrl: prodUrl_0_0_0_17,
    path: "/go/pcm/expect/esList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_17,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmExpectEsList2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [期待票直出新↗](https://yapi.yuewen.com/project/2309/interface/api/176353) 的 **请求函数**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2021-04-08 19:52:43`
 */
export const goPcmExpectEsList2 = /*#__PURE__*/ (
  requestData?: GoPcmExpectEsList2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmExpectEsList2Response>(
    prepare(goPcmExpectEsList2RequestConfig, requestData),
    ...args
  );
};

goPcmExpectEsList2.requestConfig = goPcmExpectEsList2RequestConfig;

/**
 * 接口 [试读书列表↗](https://yapi.yuewen.com/project/2309/interface/api/176578) 的 **请求类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2021-04-09 20:04:32`
 */
export interface GoPcmExpectTrailerList2Request {
  /**
   * 状态书籍 18:“预收”，20:翻译中-试读 (海外专用)  25:翻译中-持续翻译 (海外专用) ，传string，可以传多个，逗号隔开，不过不要以逗号结尾
   */
  status: string;
  /**
   * 页码【这一期不做】
   */
  pageId?: string;
  /**
   * 页值【这一期不做】
   */
  pageSize?: string;
}

/**
 * 接口 [试读书列表↗](https://yapi.yuewen.com/project/2309/interface/api/176578) 的 **返回类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2021-04-09 20:04:32`
 */
export interface GoPcmExpectTrailerList2Response {
  /**
   * [{"bookId":"@id","bookType":0,"bookName":"@name","coverUpdateTime":1616727544355,"status":[20,25],"sex":[1,2],"categoryName":"@name","categoryId":70014,"categoryType":1,"description":"@paragraph","isNew":[0,1],"isRead":[0,1],"tagInfos":[{"tagId":"@id","tagName":"@name"}]}]
   */
  items?: {
    /**
     * "@id"
     */
    bookId?: string;
    bookType?: number;
    /**
     * "@name"
     */
    bookName?: string;
    /**
     * 1616727544355
     */
    coverUpdateTime?: number;
    /**
     * [20,25]
     */
    status?: number[];
    /**
     * [1,2]
     */
    sex?: number[];
    /**
     * "@name"
     */
    categoryName?: string;
    /**
     * 70014
     */
    categoryId?: number;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * "@paragraph"
     */
    description?: string;
    /**
     * [0,1]
     */
    isNew?: number[];
    /**
     * [0,1]
     */
    isRead?: number[];
    /**
     * [{"tagId":"@id","tagName":"@name"}]
     */
    tagInfos?: {
      /**
       * "@id"
       */
      tagId?: string;
      /**
       * "@name"
       */
      tagName?: string;
    }[];
  }[];
  user?: {
    status?: number;
    /**
     * 1
     */
    availableEnergy?: number;
  };
  /**
   * [{"awardType":3,"amount":1}]
   */
  awards?: {
    /**
     * 3
     */
    awardType?: number;
    /**
     * 1
     */
    amount?: number;
  }[];
}

/**
 * 接口 [试读书列表↗](https://yapi.yuewen.com/project/2309/interface/api/176578) 的 **请求配置的类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2021-04-09 20:04:32`
 */
type GoPcmExpectTrailerList2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/expect/trailerList",
    "data",
    string,
    "status" | "pageId" | "pageSize",
    false
  >
>;

/**
 * 接口 [试读书列表↗](https://yapi.yuewen.com/project/2309/interface/api/176578) 的 **请求配置**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2021-04-09 20:04:32`
 */
const goPcmExpectTrailerList2RequestConfig: GoPcmExpectTrailerList2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_17,
    devUrl: devUrl_0_0_0_17,
    prodUrl: prodUrl_0_0_0_17,
    path: "/go/pcm/expect/trailerList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_17,
    paramNames: [],
    queryNames: ["status", "pageId", "pageSize"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmExpectTrailerList2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [试读书列表↗](https://yapi.yuewen.com/project/2309/interface/api/176578) 的 **请求函数**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2021-04-09 20:04:32`
 */
export const goPcmExpectTrailerList2 = /*#__PURE__*/ (
  requestData: GoPcmExpectTrailerList2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmExpectTrailerList2Response>(
    prepare(goPcmExpectTrailerList2RequestConfig, requestData),
    ...args
  );
};

goPcmExpectTrailerList2.requestConfig = goPcmExpectTrailerList2RequestConfig;

/**
 * 接口 [已读书列表【废弃】↗](https://yapi.yuewen.com/project/2309/interface/api/200003) 的 **请求类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/tryReadBookList`
 * @更新时间 `2021-03-30 17:08:50`
 */
export interface GoPcmExpectTryReadBookListRequest {}

/**
 * 接口 [已读书列表【废弃】↗](https://yapi.yuewen.com/project/2309/interface/api/200003) 的 **返回类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/tryReadBookList`
 * @更新时间 `2021-03-30 17:08:50`
 */
export interface GoPcmExpectTryReadBookListResponse {
  Result?: number;
  /**
   * "Success"
   */
  Message?: string;
  Data?: {
    /**
     * ["13925801605339805","13925801605339804"]
     */
    ReadBooks?: string[];
  };
}

/**
 * 接口 [已读书列表【废弃】↗](https://yapi.yuewen.com/project/2309/interface/api/200003) 的 **请求配置的类型**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/tryReadBookList`
 * @更新时间 `2021-03-30 17:08:50`
 */
type GoPcmExpectTryReadBookListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/expect/tryReadBookList",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [已读书列表【废弃】↗](https://yapi.yuewen.com/project/2309/interface/api/200003) 的 **请求配置**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/tryReadBookList`
 * @更新时间 `2021-03-30 17:08:50`
 */
const goPcmExpectTryReadBookListRequestConfig: GoPcmExpectTryReadBookListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_17,
    devUrl: devUrl_0_0_0_17,
    prodUrl: prodUrl_0_0_0_17,
    path: "/go/pcm/expect/tryReadBookList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_17,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmExpectTryReadBookList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [已读书列表【废弃】↗](https://yapi.yuewen.com/project/2309/interface/api/200003) 的 **请求函数**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/tryReadBookList`
 * @更新时间 `2021-03-30 17:08:50`
 */
export const goPcmExpectTryReadBookList = /*#__PURE__*/ (
  requestData?: GoPcmExpectTryReadBookListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmExpectTryReadBookListResponse>(
    prepare(goPcmExpectTryReadBookListRequestConfig, requestData),
    ...args
  );
};

goPcmExpectTryReadBookList.requestConfig =
  goPcmExpectTryReadBookListRequestConfig;

const mockUrl_0_0_0_18 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_18 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_18 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_18 = "data" as any;

/**
 * 接口 [领取奖励接口↗](https://yapi.yuewen.com/project/2309/interface/api/176585) 的 **请求类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getBonus`
 * @更新时间 `2020-12-02 19:45:40`
 */
export interface GoPcmMembershipGetBonusRequest {}

/**
 * 接口 [领取奖励接口↗](https://yapi.yuewen.com/project/2309/interface/api/176585) 的 **返回类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getBonus`
 * @更新时间 `2020-12-02 19:45:40`
 */
export interface GoPcmMembershipGetBonusResponse {}

/**
 * 接口 [领取奖励接口↗](https://yapi.yuewen.com/project/2309/interface/api/176585) 的 **请求配置的类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getBonus`
 * @更新时间 `2020-12-02 19:45:40`
 */
type GoPcmMembershipGetBonusRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/membership/getBonus",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [领取奖励接口↗](https://yapi.yuewen.com/project/2309/interface/api/176585) 的 **请求配置**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getBonus`
 * @更新时间 `2020-12-02 19:45:40`
 */
const goPcmMembershipGetBonusRequestConfig: GoPcmMembershipGetBonusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_18,
    devUrl: devUrl_0_0_0_18,
    prodUrl: prodUrl_0_0_0_18,
    path: "/go/pcm/membership/getBonus",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMembershipGetBonus",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [领取奖励接口↗](https://yapi.yuewen.com/project/2309/interface/api/176585) 的 **请求函数**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getBonus`
 * @更新时间 `2020-12-02 19:45:40`
 */
export const goPcmMembershipGetBonus = /*#__PURE__*/ (
  requestData?: GoPcmMembershipGetBonusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMembershipGetBonusResponse>(
    prepare(goPcmMembershipGetBonusRequestConfig, requestData),
    ...args
  );
};

goPcmMembershipGetBonus.requestConfig = goPcmMembershipGetBonusRequestConfig;

/**
 * 接口 [获取会员信息_PC↗](https://yapi.yuewen.com/project/2309/interface/api/177876) 的 **请求类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getInfoAjax`
 * @更新时间 `2021-03-02 13:49:03`
 */
export interface GoPcmMembershipGetInfoAjaxRequest {}

/**
 * 接口 [获取会员信息_PC↗](https://yapi.yuewen.com/project/2309/interface/api/177876) 的 **返回类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getInfoAjax`
 * @更新时间 `2021-03-02 13:49:03`
 */
export interface GoPcmMembershipGetInfoAjaxResponse {
  /**
   * 1
   */
  membershipQua?: number;
  /**
   * 2
   */
  membershipStatus?: number;
  /**
   * 1609310006000
   */
  membershipExpireTime?: number;
  isFree?: boolean;
  actionFlag?: boolean;
  /**
   * [{"channelCode":"paypal","country":"US","itemId":"membership_basic_paypal_t2_h5","itemType":2,"amount":4.99,"discountAmount":0,"currency":"USD","tag":"","title":"Monthly","msg":"Spend $4.99 to get $7.99(feivip)","benefits":[{"imageUrl":"https://webbannertest.webnovel.com/utils/1581577746_853095.png","title":"Obtain 250 Coins at once","actionUrl":""},{"imageUrl":"https://webbannertest.webnovel.com/utils/1581904774_427573.jpg","title":"Earn an additional 150 Coins a month (from daily login)","actionUrl":""},{"imageUrl":"https://webbannertest.webnovel.com/utils/1581904809_248340.jpg","title":"More Coming Soon...","actionUrl":""}],"totalAward":0,"delayAward":5,"totalAmount":150,"actionText":""}]
   */
  items?: {
    /**
     * "paypal"
     */
    channelCode?: string;
    /**
     * "US"
     */
    country?: string;
    /**
     * "membership_basic_paypal_t2_h5"
     */
    itemId?: string;
    /**
     * 2
     */
    itemType?: number;
    /**
     * 4.99
     */
    amount?: number;
    discountAmount?: number;
    /**
     * "USD"
     */
    currency?: string;
    tag?: string;
    /**
     * "Monthly"
     */
    title?: string;
    /**
     * "Spend $4.99 to get $7.99(feivip)"
     */
    msg?: string;
    /**
     * [{"imageUrl":"https://webbannertest.webnovel.com/utils/1581577746_853095.png","title":"Obtain 250 Coins at once","actionUrl":""},{"imageUrl":"https://webbannertest.webnovel.com/utils/1581904774_427573.jpg","title":"Earn an additional 150 Coins a month (from daily login)","actionUrl":""},{"imageUrl":"https://webbannertest.webnovel.com/utils/1581904809_248340.jpg","title":"More Coming Soon...","actionUrl":""}]
     */
    benefits?: {
      /**
       * "https://webbannertest.webnovel.com/utils/1581577746_853095.png"
       */
      imageUrl?: string;
      /**
       * "Obtain 250 Coins at once"
       */
      title?: string;
      actionUrl?: string;
    }[];
    totalAward?: number;
    /**
     * 5
     */
    delayAward?: number;
    /**
     * 150
     */
    totalAmount?: number;
    actionText?: string;
  }[];
}

/**
 * 接口 [获取会员信息_PC↗](https://yapi.yuewen.com/project/2309/interface/api/177876) 的 **请求配置的类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getInfoAjax`
 * @更新时间 `2021-03-02 13:49:03`
 */
type GoPcmMembershipGetInfoAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/membership/getInfoAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取会员信息_PC↗](https://yapi.yuewen.com/project/2309/interface/api/177876) 的 **请求配置**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getInfoAjax`
 * @更新时间 `2021-03-02 13:49:03`
 */
const goPcmMembershipGetInfoAjaxRequestConfig: GoPcmMembershipGetInfoAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_18,
    devUrl: devUrl_0_0_0_18,
    prodUrl: prodUrl_0_0_0_18,
    path: "/go/pcm/membership/getInfoAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMembershipGetInfoAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取会员信息_PC↗](https://yapi.yuewen.com/project/2309/interface/api/177876) 的 **请求函数**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getInfoAjax`
 * @更新时间 `2021-03-02 13:49:03`
 */
export const goPcmMembershipGetInfoAjax = /*#__PURE__*/ (
  requestData?: GoPcmMembershipGetInfoAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMembershipGetInfoAjaxResponse>(
    prepare(goPcmMembershipGetInfoAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmMembershipGetInfoAjax.requestConfig =
  goPcmMembershipGetInfoAjaxRequestConfig;

/**
 * 接口 [获取会员信息_M站↗](https://yapi.yuewen.com/project/2309/interface/api/195503) 的 **请求类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShip`
 * @更新时间 `2021-04-02 15:29:31`
 */
export interface GoPcmMembershipGetMemberShipRequest {}

/**
 * 接口 [获取会员信息_M站↗](https://yapi.yuewen.com/project/2309/interface/api/195503) 的 **返回类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShip`
 * @更新时间 `2021-04-02 15:29:31`
 */
export interface GoPcmMembershipGetMemberShipResponse {
  /**
   * 1
   */
  vipStatus?: number;
  /**
   * 2
   */
  membershipStatus?: number;
  /**
   * 1609310006000
   */
  membershipExpireTime?: number;
  /**
   * true
   */
  isFree?: boolean;
  isAutoReNew?: number;
  user?: {
    /**
     * 4300014654
     */
    guid?: number;
    /**
     * "liwen369170"
     */
    userName?: string;
    status?: number;
    UUT?: number;
    /**
     * "liwen369170@163.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    gender?: number;
  };
  /**
   * [{"channelCode":"paypal","isFirstCharge":false,"country":"US","itemId":"membership_basic_paypal_t2_h5","itemType":2,"amount":5,"discountAmount":0,"currency":"USD","tag":"","title":"Monthly","msg":"Spend $4.99 to get $7.99(feivip)","channelImageUrl":"https://actimg.webnovel.com/gear/paypal.png","benefits":[{"imageUrl":"https://webbannertest.webnovel.com/utils/1581577746_853095.png","title":"Obtain 250 Coins at once","actionUrl":""},{"imageUrl":"https://webbannertest.webnovel.com/utils/1581904774_427573.jpg","title":"Earn an additional 150 Coins a month (from daily login)","actionUrl":""},{"imageUrl":"https://webbannertest.webnovel.com/utils/1581904809_248340.jpg","title":"More Coming Soon...","actionUrl":""}],"totalAward":0,"delayAward":5,"totalAmount":150,"actionText":"20% off"},{"channelCode":"stripe","isFirstCharge":false,"country":"US","itemId":"membership_basic_paypal_t2_h5","itemType":2,"amount":4.99,"discountAmount":0,"currency":"USD","tag":"","title":"Monthly","msg":"Spend $4.99 to get $7.99(feivip)","channelImageUrl":"https://actimg.webnovel.com/gear/stripe.png","benefits":[{"imageUrl":"https://webbannertest.webnovel.com/utils/1581577746_853095.png","title":"Obtain 250 Coins at once","actionUrl":""},{"imageUrl":"https://webbannertest.webnovel.com/utils/1581904774_427573.jpg","title":"Earn an additional 150 Coins a month (from daily login)","actionUrl":""},{"imageUrl":"https://webbannertest.webnovel.com/utils/1581904809_248340.jpg","title":"More Coming Soon...","actionUrl":""}],"totalAward":0,"delayAward":5,"totalAmount":150,"actionText":""}]
   */
  items?: {
    /**
     * "paypal"
     */
    channelCode?: string;
    isFirstCharge?: boolean;
    /**
     * "US"
     */
    country?: string;
    /**
     * "membership_basic_paypal_t2_h5"
     */
    itemId?: string;
    /**
     * 2
     */
    itemType?: number;
    /**
     * 5
     */
    amount?: number;
    discountAmount?: number;
    /**
     * "USD"
     */
    currency?: string;
    tag?: string;
    /**
     * "Monthly"
     */
    title?: string;
    /**
     * "Spend $4.99 to get $7.99(feivip)"
     */
    msg?: string;
    /**
     * "https://actimg.webnovel.com/gear/paypal.png"
     */
    channelImageUrl?: string;
    /**
     * [{"imageUrl":"https://webbannertest.webnovel.com/utils/1581577746_853095.png","title":"Obtain 250 Coins at once","actionUrl":""},{"imageUrl":"https://webbannertest.webnovel.com/utils/1581904774_427573.jpg","title":"Earn an additional 150 Coins a month (from daily login)","actionUrl":""},{"imageUrl":"https://webbannertest.webnovel.com/utils/1581904809_248340.jpg","title":"More Coming Soon...","actionUrl":""}]
     */
    benefits?: {
      /**
       * "https://webbannertest.webnovel.com/utils/1581577746_853095.png"
       */
      imageUrl?: string;
      /**
       * "Obtain 250 Coins at once"
       */
      title?: string;
      actionUrl?: string;
    }[];
    totalAward?: number;
    /**
     * 5
     */
    delayAward?: number;
    /**
     * 150
     */
    totalAmount?: number;
    /**
     * "20% off"
     */
    actionText?: string;
  }[];
  userMemberShip?: {
    /**
     * "paypal"
     */
    channelCode?: string;
    /**
     * "US"
     */
    country?: string;
    /**
     * "membership_basic_paypal_t2_h5"
     */
    itemId?: string;
    /**
     * 2
     */
    itemType?: number;
    /**
     * 4.99
     */
    amount?: number;
    discountAmount?: number;
    /**
     * "USD"
     */
    currency?: string;
    tag?: string;
    /**
     * "Monthly"
     */
    title?: string;
    /**
     * "Spend $4.99 to get $7.99(feivip)"
     */
    msg?: string;
    /**
     * [{"imageUrl":"https://webbannertest.webnovel.com/utils/1581904774_427573.jpg","title":"Earn an additional 150 Coins a month (from daily login)","actionUrl":""},{"imageUrl":"https://webbannertest.webnovel.com/utils/1581904809_248340.jpg","title":"More Coming Soon...","actionUrl":""}]
     */
    benefits?: {
      /**
       * "https://webbannertest.webnovel.com/utils/1581904774_427573.jpg"
       */
      imageUrl?: string;
      /**
       * "Earn an additional 150 Coins a month (from daily login)"
       */
      title?: string;
      actionUrl?: string;
    }[];
    totalAward?: number;
    /**
     * 5
     */
    delayAward?: number;
    /**
     * 150
     */
    totalAmount?: number;
    actionText?: string;
  };
}

/**
 * 接口 [获取会员信息_M站↗](https://yapi.yuewen.com/project/2309/interface/api/195503) 的 **请求配置的类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShip`
 * @更新时间 `2021-04-02 15:29:31`
 */
type GoPcmMembershipGetMemberShipRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/membership/getMemberShip",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取会员信息_M站↗](https://yapi.yuewen.com/project/2309/interface/api/195503) 的 **请求配置**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShip`
 * @更新时间 `2021-04-02 15:29:31`
 */
const goPcmMembershipGetMemberShipRequestConfig: GoPcmMembershipGetMemberShipRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_18,
    devUrl: devUrl_0_0_0_18,
    prodUrl: prodUrl_0_0_0_18,
    path: "/go/pcm/membership/getMemberShip",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMembershipGetMemberShip",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取会员信息_M站↗](https://yapi.yuewen.com/project/2309/interface/api/195503) 的 **请求函数**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShip`
 * @更新时间 `2021-04-02 15:29:31`
 */
export const goPcmMembershipGetMemberShip = /*#__PURE__*/ (
  requestData?: GoPcmMembershipGetMemberShipRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMembershipGetMemberShipResponse>(
    prepare(goPcmMembershipGetMemberShipRequestConfig, requestData),
    ...args
  );
};

goPcmMembershipGetMemberShip.requestConfig =
  goPcmMembershipGetMemberShipRequestConfig;

/**
 * 接口 [会员卡管理-M站↗](https://yapi.yuewen.com/project/2309/interface/api/195558) 的 **请求类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShipManager`
 * @更新时间 `2021-04-07 10:09:50`
 */
export interface GoPcmMembershipGetMemberShipManagerRequest {}

/**
 * 接口 [会员卡管理-M站↗](https://yapi.yuewen.com/project/2309/interface/api/195558) 的 **返回类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShipManager`
 * @更新时间 `2021-04-07 10:09:50`
 */
export interface GoPcmMembershipGetMemberShipManagerResponse {
  /**
   * [{"type":1,"title":"@string","list":[{"type":1,"coins":1,"channelType":"5","expireDate":"@timestamp","bonus":1,"itemId":"21V676713T8246638MACV7RY"}]}]
   */
  membershipList?: {
    /**
     * 1
     */
    type?: number;
    /**
     * "@string"
     */
    title?: string;
    /**
     * [{"type":1,"coins":1,"channelType":"5","expireDate":"@timestamp","bonus":1,"itemId":"21V676713T8246638MACV7RY"}]
     */
    list?: {
      /**
       * 1
       */
      type?: number;
      /**
       * 1
       */
      coins?: number;
      /**
       * "5"
       */
      channelType?: string;
      /**
       * "@timestamp"
       */
      expireDate?: string;
      /**
       * 1
       */
      bonus?: number;
      /**
       * "21V676713T8246638MACV7RY"
       */
      itemId?: string;
    }[];
  }[];
}

/**
 * 接口 [会员卡管理-M站↗](https://yapi.yuewen.com/project/2309/interface/api/195558) 的 **请求配置的类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShipManager`
 * @更新时间 `2021-04-07 10:09:50`
 */
type GoPcmMembershipGetMemberShipManagerRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/membership/getMemberShipManager",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [会员卡管理-M站↗](https://yapi.yuewen.com/project/2309/interface/api/195558) 的 **请求配置**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShipManager`
 * @更新时间 `2021-04-07 10:09:50`
 */
const goPcmMembershipGetMemberShipManagerRequestConfig: GoPcmMembershipGetMemberShipManagerRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_18,
    devUrl: devUrl_0_0_0_18,
    prodUrl: prodUrl_0_0_0_18,
    path: "/go/pcm/membership/getMemberShipManager",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMembershipGetMemberShipManager",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [会员卡管理-M站↗](https://yapi.yuewen.com/project/2309/interface/api/195558) 的 **请求函数**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShipManager`
 * @更新时间 `2021-04-07 10:09:50`
 */
export const goPcmMembershipGetMemberShipManager = /*#__PURE__*/ (
  requestData?: GoPcmMembershipGetMemberShipManagerRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMembershipGetMemberShipManagerResponse>(
    prepare(goPcmMembershipGetMemberShipManagerRequestConfig, requestData),
    ...args
  );
};

goPcmMembershipGetMemberShipManager.requestConfig =
  goPcmMembershipGetMemberShipManagerRequestConfig;

/**
 * 接口 [退订stripe会员卡↗](https://yapi.yuewen.com/project/2309/interface/api/197937) 的 **请求类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/cancel`
 * @更新时间 `2021-05-31 19:17:18`
 */
export interface GoPcmMembershipCancelRequest {
  itemId: string;
  /**
   * 透传getMemberShipManager接口的ChannelType字段
   */
  channelCode: string;
}

/**
 * 接口 [退订stripe会员卡↗](https://yapi.yuewen.com/project/2309/interface/api/197937) 的 **返回类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/cancel`
 * @更新时间 `2021-05-31 19:17:18`
 */
export interface GoPcmMembershipCancelResponse {
  code?: number;
  /**
   * "Success"
   */
  msg?: string;
}

/**
 * 接口 [退订stripe会员卡↗](https://yapi.yuewen.com/project/2309/interface/api/197937) 的 **请求配置的类型**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/cancel`
 * @更新时间 `2021-05-31 19:17:18`
 */
type GoPcmMembershipCancelRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/membership/cancel",
    "data",
    string,
    "itemId" | "channelCode",
    false
  >
>;

/**
 * 接口 [退订stripe会员卡↗](https://yapi.yuewen.com/project/2309/interface/api/197937) 的 **请求配置**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/cancel`
 * @更新时间 `2021-05-31 19:17:18`
 */
const goPcmMembershipCancelRequestConfig: GoPcmMembershipCancelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_18,
    devUrl: devUrl_0_0_0_18,
    prodUrl: prodUrl_0_0_0_18,
    path: "/go/pcm/membership/cancel",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_18,
    paramNames: [],
    queryNames: ["itemId", "channelCode"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMembershipCancel",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [退订stripe会员卡↗](https://yapi.yuewen.com/project/2309/interface/api/197937) 的 **请求函数**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/cancel`
 * @更新时间 `2021-05-31 19:17:18`
 */
export const goPcmMembershipCancel = /*#__PURE__*/ (
  requestData: GoPcmMembershipCancelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMembershipCancelResponse>(
    prepare(goPcmMembershipCancelRequestConfig, requestData),
    ...args
  );
};

goPcmMembershipCancel.requestConfig = goPcmMembershipCancelRequestConfig;

const mockUrl_0_0_0_19 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_19 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_19 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_19 = "data" as any;

/**
 * 接口 [get-more-list 获取more模块配置的内容↗](https://yapi.yuewen.com/project/2309/interface/api/178037) 的 **请求类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-more-list`
 * @更新时间 `2020-12-17 11:49:19`
 */
export interface GoPcmBookcityGetMoreListRequest {
  contentId: string;
}

/**
 * 接口 [get-more-list 获取more模块配置的内容↗](https://yapi.yuewen.com/project/2309/interface/api/178037) 的 **返回类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-more-list`
 * @更新时间 `2020-12-17 11:49:19`
 */
export interface GoPcmBookcityGetMoreListResponse {
  /**
   * [{"bookId":"@id","bookType":0,"bookName":"@word","categoryId":0,"categoryName":"@word","authorName":"xxx","tagInfos":[{"id":1,"tagName":"tag","likeCount":0,"like":false}],"bookCoverId":15899331113,"description":"aaa","totalScore":"4.8","pvNum":100,"chapterNum":100,"statParams":"xxx","mTL":true}]
   */
  moreListItems?: {
    /**
     * "@id"
     */
    bookId?: string;
    bookType?: number;
    /**
     * "@word"
     */
    bookName?: string;
    categoryId?: number;
    /**
     * "@word"
     */
    categoryName?: string;
    /**
     * "xxx"
     */
    authorName?: string;
    /**
     * [{"id":1,"tagName":"tag","likeCount":0,"like":false}]
     */
    tagInfos?: {
      /**
       * 1
       */
      id?: number;
      /**
       * "tag"
       */
      tagName?: string;
      likeCount?: number;
      like?: boolean;
    }[];
    /**
     * 15899331113
     */
    bookCoverId?: number;
    /**
     * "aaa"
     */
    description?: string;
    /**
     * "4.8"
     */
    totalScore?: string;
    /**
     * 100
     */
    pvNum?: number;
    /**
     * 100
     */
    chapterNum?: number;
    /**
     * "xxx"
     */
    statParams?: string;
    /**
     * true
     */
    mTL?: boolean;
  }[];
}

/**
 * 接口 [get-more-list 获取more模块配置的内容↗](https://yapi.yuewen.com/project/2309/interface/api/178037) 的 **请求配置的类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-more-list`
 * @更新时间 `2020-12-17 11:49:19`
 */
type GoPcmBookcityGetMoreListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookcity/get-more-list",
    "data",
    string,
    "contentId",
    false
  >
>;

/**
 * 接口 [get-more-list 获取more模块配置的内容↗](https://yapi.yuewen.com/project/2309/interface/api/178037) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-more-list`
 * @更新时间 `2020-12-17 11:49:19`
 */
const goPcmBookcityGetMoreListRequestConfig: GoPcmBookcityGetMoreListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-more-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: ["contentId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetMoreList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-more-list 获取more模块配置的内容↗](https://yapi.yuewen.com/project/2309/interface/api/178037) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-more-list`
 * @更新时间 `2020-12-17 11:49:19`
 */
export const goPcmBookcityGetMoreList = /*#__PURE__*/ (
  requestData: GoPcmBookcityGetMoreListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookcityGetMoreListResponse>(
    prepare(goPcmBookcityGetMoreListRequestConfig, requestData),
    ...args
  );
};

goPcmBookcityGetMoreList.requestConfig = goPcmBookcityGetMoreListRequestConfig;

/**
 * 接口 [语言选择列表↗](https://yapi.yuewen.com/project/2309/interface/api/178039) 的 **请求类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/country-language`
 * @更新时间 `2020-12-15 16:28:42`
 */
export interface GoPcmBookcityCountryLanguageRequest {}

/**
 * 接口 [语言选择列表↗](https://yapi.yuewen.com/project/2309/interface/api/178039) 的 **返回类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/country-language`
 * @更新时间 `2020-12-15 16:28:42`
 */
export type GoPcmBookcityCountryLanguageResponse = {
  /**
   * "India"
   */
  name?: string;
  /**
   * "IN"
   */
  code?: string;
  /**
   * [{"name":"हिंदी","code":"hi"},{"name":"English","code":"en"}]
   */
  languages?: {
    /**
     * "हिंदी"
     */
    name?: string;
    /**
     * "hi"
     */
    code?: string;
  }[];
}[];

/**
 * 接口 [语言选择列表↗](https://yapi.yuewen.com/project/2309/interface/api/178039) 的 **请求配置的类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/country-language`
 * @更新时间 `2020-12-15 16:28:42`
 */
type GoPcmBookcityCountryLanguageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookcity/country-language",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [语言选择列表↗](https://yapi.yuewen.com/project/2309/interface/api/178039) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/country-language`
 * @更新时间 `2020-12-15 16:28:42`
 */
const goPcmBookcityCountryLanguageRequestConfig: GoPcmBookcityCountryLanguageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/country-language",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityCountryLanguage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [语言选择列表↗](https://yapi.yuewen.com/project/2309/interface/api/178039) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/country-language`
 * @更新时间 `2020-12-15 16:28:42`
 */
export const goPcmBookcityCountryLanguage = /*#__PURE__*/ (
  requestData?: GoPcmBookcityCountryLanguageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookcityCountryLanguageResponse>(
    prepare(goPcmBookcityCountryLanguageRequestConfig, requestData),
    ...args
  );
};

goPcmBookcityCountryLanguage.requestConfig =
  goPcmBookcityCountryLanguageRequestConfig;

/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178047) 的 **请求类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-feed-list`
 * @更新时间 `2020-12-17 16:44:49`
 */
export interface GoPcmBookcityGetFeedListRequest {
  /**
   * 不传返回第一页
   */
  pageIndex?: string;
}

/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178047) 的 **返回类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-feed-list`
 * @更新时间 `2020-12-17 16:44:49`
 */
export interface GoPcmBookcityGetFeedListResponse {
  /**
   * [{"bookId":0,"bookType":0,"bookName":"@word","categoryId":0,"categoryName":"@word","authorName":"xxx","tagInfos":[{"id":1,"tagName":"tag","likeCount":0,"like":false}],"bookCoverId":15899331113,"description":"aaa","totalScore":"4.8","pvNum":100,"chapterNum":100,"statParams":"xxx","mTL":true}]
   */
  feedListItems?: {
    bookId?: number;
    bookType?: number;
    /**
     * "@word"
     */
    bookName?: string;
    categoryId?: number;
    /**
     * "@word"
     */
    categoryName?: string;
    /**
     * "xxx"
     */
    authorName?: string;
    /**
     * [{"id":1,"tagName":"tag","likeCount":0,"like":false}]
     */
    tagInfos?: {
      /**
       * 1
       */
      id?: number;
      /**
       * "tag"
       */
      tagName?: string;
      likeCount?: number;
      like?: boolean;
    }[];
    /**
     * 15899331113
     */
    bookCoverId?: number;
    /**
     * "aaa"
     */
    description?: string;
    /**
     * "4.8"
     */
    totalScore?: string;
    /**
     * 100
     */
    pvNum?: number;
    /**
     * 100
     */
    chapterNum?: number;
    /**
     * "xxx"
     */
    statParams?: string;
    /**
     * true
     */
    mTL?: boolean;
  }[];
  /**
   * 2
   */
  pageIndex?: number;
  /**
   * true
   */
  isLast?: boolean;
}

/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178047) 的 **请求配置的类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-feed-list`
 * @更新时间 `2020-12-17 16:44:49`
 */
type GoPcmBookcityGetFeedListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookcity/get-feed-list",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178047) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-feed-list`
 * @更新时间 `2020-12-17 16:44:49`
 */
const goPcmBookcityGetFeedListRequestConfig: GoPcmBookcityGetFeedListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-feed-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: ["pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetFeedList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178047) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-feed-list`
 * @更新时间 `2020-12-17 16:44:49`
 */
export const goPcmBookcityGetFeedList = /*#__PURE__*/ (
  requestData: GoPcmBookcityGetFeedListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookcityGetFeedListResponse>(
    prepare(goPcmBookcityGetFeedListRequestConfig, requestData),
    ...args
  );
};

goPcmBookcityGetFeedList.requestConfig = goPcmBookcityGetFeedListRequestConfig;

/**
 * 接口 [get-comic-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178052) 的 **请求类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-comic-feed-list`
 * @更新时间 `2020-12-14 14:52:58`
 */
export interface GoPcmBookcityGetComicFeedListRequest {
  /**
   * 不传返回第一页
   */
  pageIndex?: string;
}

/**
 * 接口 [get-comic-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178052) 的 **返回类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-comic-feed-list`
 * @更新时间 `2020-12-14 14:52:58`
 */
export interface GoPcmBookcityGetComicFeedListResponse {
  /**
   * [{"bookId":0,"bookType":0,"bookName":"@word","bookCoverId":15899331113,"chapterUpdateTime":15899331113223,"chapterUpdateId":"412341412","recommendText":"good","readToChapterId":"aaa"}]
   */
  feedListItems?: {
    bookId?: number;
    bookType?: number;
    /**
     * "@word"
     */
    bookName?: string;
    /**
     * 15899331113
     */
    bookCoverId?: number;
    /**
     * 15899331113223
     */
    chapterUpdateTime?: number;
    /**
     * "412341412"
     */
    chapterUpdateId?: string;
    /**
     * "good"
     */
    recommendText?: string;
    /**
     * "aaa"
     */
    readToChapterId?: string;
  }[];
  /**
   * true
   */
  last?: boolean;
}

/**
 * 接口 [get-comic-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178052) 的 **请求配置的类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-comic-feed-list`
 * @更新时间 `2020-12-14 14:52:58`
 */
type GoPcmBookcityGetComicFeedListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookcity/get-comic-feed-list",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [get-comic-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178052) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-comic-feed-list`
 * @更新时间 `2020-12-14 14:52:58`
 */
const goPcmBookcityGetComicFeedListRequestConfig: GoPcmBookcityGetComicFeedListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-comic-feed-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: ["pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetComicFeedList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-comic-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178052) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-comic-feed-list`
 * @更新时间 `2020-12-14 14:52:58`
 */
export const goPcmBookcityGetComicFeedList = /*#__PURE__*/ (
  requestData: GoPcmBookcityGetComicFeedListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookcityGetComicFeedListResponse>(
    prepare(goPcmBookcityGetComicFeedListRequestConfig, requestData),
    ...args
  );
};

goPcmBookcityGetComicFeedList.requestConfig =
  goPcmBookcityGetComicFeedListRequestConfig;

/**
 * 接口 [新书城获取pageList接口↗](https://yapi.yuewen.com/project/2309/interface/api/178054) 的 **请求类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page-list`
 * @更新时间 `2020-12-21 14:45:59`
 */
export interface GoPcmBookcityPageListRequest {
  /**
   * 国家 （ISO 3166-1 国家代码） 第一次请求通过IP获取国家，后续请求通过客户端传递
   */
  country?: string;
  /**
   * 性别 1男,2女
   */
  sex: string;
  /**
   * 特别注意，用户选择Global后不可向cookie中写入webnovel-content-languag
   */
  language: string;
  /**
   * 1- 返回redis部分 2-返回较慢的智能相关block
   */
  bookCityType: string;
}

/**
 * 接口 [新书城获取pageList接口↗](https://yapi.yuewen.com/project/2309/interface/api/178054) 的 **返回类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page-list`
 * @更新时间 `2020-12-21 14:45:59`
 */
export interface GoPcmBookcityPageListResponse {
  backInfo?: {
    /**
     * "US"
     */
    country?: string;
    /**
     * "en"
     */
    language?: string;
  };
  /**
   * [{"pageId":"5cebdc38322bf5640a154ed5","bookCityName":"Novel","countryItems":["global"],"blackCountryItems":["PH","MY"],"languageItems":["en"],"sexItems":[1],"remark":"精选"},{"pageId":"5ce7c843322bf5640a154cd4","bookCityName":"Novel","countryItems":["global"],"blackCountryItems":["ID","MY","PH"],"languageItems":["en","ms","tl","in"],"sexItems":[1],"remark":"小说"},{"pageId":"5cebe684b1630c0797c0f719","bookCityName":"Comics","countryItems":["global"],"blackCountryItems":[],"languageItems":["en","ms","tl","in","es"],"sexItems":[1],"remark":"漫画"}]
   */
  pageList?: {
    /**
     * "5cebdc38322bf5640a154ed5"
     */
    pageId?: string;
    /**
     * "Novel"
     */
    bookCityName?: string;
    /**
     * ["global"]
     */
    countryItems?: string[];
    /**
     * ["PH","MY"]
     */
    blackCountryItems?: string[];
    /**
     * ["en"]
     */
    languageItems?: string[];
    /**
     * [1]
     */
    sexItems?: number[];
    /**
     * "精选"
     */
    remark?: string;
  }[];
  /**
   * [{"remark":"Library","actionUrl":"QDHWReader://app/open?query={\"url\":\"/book/7366916601012405\"}"}]
   */
  searchWordItems?: {
    /**
     * "Library"
     */
    remark?: string;
    /**
     * "QDHWReader://app/open?query={\"url\":\"/book/7366916601012405\"}"
     */
    actionUrl?: string;
  }[];
  /**
   * 1
   */
  checkStatus?: number;
  pageInfo?: {
    /**
     * "5fd1f9d3b535193b6b0cfe08"
     */
    pageId?: string;
    /**
     * "test_pc_m"
     */
    bookCityName?: string;
    /**
     * ["Global"]
     */
    countryItems?: string[];
    /**
     * []
     */
    blackCountryItems?: unknown[];
    /**
     * ["en"]
     */
    languageItems?: string[];
    /**
     * [1,2]
     */
    sexItems?: number[];
    /**
     * "小说"
     */
    remark?: string;
    /**
     * [{"id":"5fd1f8a0b535193b6b0cfdff","title":"M4001","subTitle":"M4001","type":"4001","background":"","contentId":"","contentItems":[{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"ORIGINAL","iconUrl":"https://webbannertest.webnovel.com/utils/1608288750_720752.png","actionUrl":"","index":0},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"NEW","iconUrl":"https://webbannertest.webnovel.com/utils/1608288727_740241.png","actionUrl":"","index":1},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"GENRE","iconUrl":"https://webbannertest.webnovel.com/utils/1608288739_997971.png","actionUrl":"","index":2},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"VOTE","iconUrl":"https://webbannertest.webnovel.com/utils/1608288697_219083.png","actionUrl":"","index":3},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"RANKING","iconUrl":"https://webbannertest.webnovel.com/utils/1608288712_188901.png","actionUrl":"","index":4}],"changeable":false,"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":0},{"id":"5fd1f755b535193b6b0cfde9","title":"M1001","subTitle":"M1001副标题","type":"1001","background":"","contentId":"","contentItems":[{"title":"M1001","subTitle":"M1001","imageUrl":"https://webbanner.webnovel.com/utils/1558509128_922580.jpg","actionUrl":"https://activity.webnovel.com/64592563/mlbb","width":852,"height":480,"order":1},{"title":"M1001","subTitle":"M1001","imageUrl":"https://webbanner.webnovel.com/utils/1558509128_922580.jpg","actionUrl":"https://webbanner.webnovel.com/utils/1558509128_922580.jpg","width":852,"height":480,"order":2}],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":1},{"id":"5fd1f783b535193b6b0cfdea","title":"M1002","subTitle":"M1002","type":"1002","background":"","contentId":"","contentItems":[{"comicId":11558338301012800,"comicName":"Xiuzhen","categoryName":"Hot-blooded","coverUpdateTime":"0"},{"comicId":12472322401037300,"comicName":"Webnovel TestComic1214","categoryName":"Romance","coverUpdateTime":"0"},{"comicId":13137795401042200,"comicName":"Webnovel TestComic0301","categoryName":"Magic","coverUpdateTime":"0"},{"comicId":12637189201038000,"comicName":"\tWebnovel TestComic0102","categoryName":"Hot-blooded","coverUpdateTime":"0"},{"comicId":11566481001013000,"comicName":"Webnove lComic Test 002","categoryName":"Modern","coverUpdateTime":"1590922848187"}],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":2},{"id":"5fd1f797b535193b6b0cfdeb","title":"M1003","subTitle":"M1003","type":"1003","background":"","contentId":"","contentItems":{"title":"","subTitle":"","imageUrl":"https://webbannertest.webnovel.com/utils/1607597825_175280.jpg","actionUrl":"https://webbannertest.webnovel.com/utils/1607598038_840941.jpg","width":800,"height":400,"order":""},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":3},{"id":"5fd1f7b6b535193b6b0cfdec","title":"M1004","subTitle":"M1004","type":"1004","background":"","contentId":"","contentItems":{"comicId":11558338301012800,"comicName":"Xiuzhen","categoryName":"Comedy","coverUpdateTime":"0"},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":4},{"id":"5fd1f7c2b535193b6b0cfded","title":"M1005","subTitle":"M1005","type":"1005","background":"","contentId":"","contentItems":{"comicId":11558338301012800,"comicName":"Xiuzhen","categoryName":"Hot-blooded","coverUpdateTime":"0","expireTime":1611845700000},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":5},{"id":"5fd1f7e3b535193b6b0cfdef","title":"M1007","subTitle":"M1007","type":"1007","background":"","contentId":"","contentItems":[{"collectionId":169515160468324350,"collectionName":"tios改变状态","categoryName":["History","Magical Realism"],"bookItems":[{"bookId":11558338301012800,"coverId":0},{"bookId":16698222201024404,"coverId":1587024075126},{"bookId":11566207401012900,"coverId":0},{"bookId":16195153001005504,"coverId":1596004850447}],"bookNum":10,"follows":847},{"collectionId":169099763705315330,"collectionName":"吃火锅哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈","categoryName":["Magical Realism","Fantasy"],"bookItems":[{"bookId":11443406601008804,"coverId":0},{"bookId":15833369401155904,"coverId":1578375669972},{"bookId":10226460301021804,"coverId":0},{"bookId":11358144901005704,"coverId":1577155285613}],"bookNum":50,"follows":846},{"collectionId":191635906405466100,"collectionName":"qaz","categoryName":["Magical Realism"],"bookItems":[{"bookId":9087880901018704,"coverId":0}],"bookNum":1,"follows":12},{"collectionId":166646577656627200,"collectionName":"test444","categoryName":[""],"bookItems":[{"bookId":6820980401004005,"coverId":0}],"bookNum":1,"follows":4}],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":7},{"id":"5fd1f7f0b535193b6b0cfdf0","title":"M2001","subTitle":"M2001","type":"2001","background":"","contentId":"","contentItems":{"categoryNum":19,"categoryList":[{"CategoryId":70017,"CategoryName":"Sci-fi Romance"},{"CategoryId":70016,"CategoryName":"Fantasy Romance"},{"CategoryId":70019,"CategoryName":"LGBT+"},{"CategoryId":70018,"CategoryName":"Teen"},{"CategoryId":70001,"CategoryName":"Magical Realism"},{"CategoryId":70003,"CategoryName":"History"}]},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":8},{"id":"5fd1f7fab535193b6b0cfdf1","title":"M2002","subTitle":"M2002","type":"2002","background":"","contentId":"","contentItems":{"categoryNum":27,"categoryList":[{"CategoryId":60002,"CategoryName":"Hot-blooded"},{"CategoryId":60003,"CategoryName":"Romance"},{"CategoryId":60004,"CategoryName":"Sci-Fi"},{"CategoryId":60005,"CategoryName":"Modern"},{"CategoryId":60006,"CategoryName":"Eastern Fantasy"},{"CategoryId":60007,"CategoryName":"School Life"}]},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":9},{"id":"5fd1f839b535193b6b0cfdf7","title":"M2008","subTitle":"M2008","type":"2008","background":"","contentId":"","contentItems":[20201221,20201220,20201219,20201218,20201217,20201216,20201215],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":15},{"id":"5fd1f843b535193b6b0cfdf8","title":"M2009","subTitle":"M2009","type":"2009","background":"","contentId":"","contentItems":{"categoryNum":18,"categoryList":[{"CategoryId":95001,"CategoryName":"Arts & Photography"},{"CategoryId":95002,"CategoryName":"Biographies & Memoirs"},{"CategoryId":95003,"CategoryName":"Business & Economics"},{"CategoryId":95004,"CategoryName":"Children & Kids"},{"CategoryId":95005,"CategoryName":"Comics & Graphic Novels"},{"CategoryId":95006,"CategoryName":"Health, Family & Lifestyle"}]},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":16},{"id":"5fd1f84fb535193b6b0cfdf9","title":"M2010","subTitle":"M2010","type":"2010","background":"","contentId":"","contentItems":{"categoryNum":9,"categoryList":[{"CategoryId":81001,"CategoryName":"Book&Literature"},{"CategoryId":81003,"CategoryName":"Music & Bands"},{"CategoryId":81002,"CategoryName":"Celebrities & Real People"},{"CategoryId":81005,"CategoryName":"Video Games"},{"CategoryId":81004,"CategoryName":"Theater"},{"CategoryId":81007,"CategoryName":"Movies"}]},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":17},{"id":"5fd1f87fb535193b6b0cfdfc","title":"M3001","subTitle":"M3001","type":"3001","background":"","contentId":"","contentItems":{"items":[],"expireTime":0,"isLast":0,"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}"},"changeable":false,"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":19},{"id":"5fd1f894b535193b6b0cfdfe","title":"M3003","subTitle":"M3003","type":"3003","background":"","contentId":"","contentItems":[{"tagName":"SYSTEM"},{"tagName":"CHEAT MC"},{"tagName":"LOLICON"},{"tagName":"FANTACY"},{"tagName":"HENTAI"},{"tagName":"VIDEO GAMES"},{"tagName":"ANTIHERO"},{"tagName":"BEAUTIFUL FEMALE LEAD"},{"tagName":"TRANSPORTED TO ANOTHER WORLD"},{"tagName":"SWORD AND MAGIC"}],"changeable":false,"apiType":0,"apiParam":"","moreType":3002,"moreParam":"{\"url\":\"/tagList\"}","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":21},{"id":"5fd1f8c8b535193b6b0cfe01","title":"M6001","subTitle":"M6001","type":"6001","background":"","contentId":"5fd1ff37b535193b6b0cfe32","contentItems":[{"contentType":1,"title":"啊啊啊啊","subTitle":"啊啊啊啊","imageUrl":"https://webbannertest.webnovel.com/utils/1607597825_175280.jpg","actionUrl":"","bookId":10650267701028204,"bookType":0,"bookName":"Webnovel Lily001","coverUpdateTime":1581421909468},{"contentType":0,"title":"","subTitle":"","imageUrl":"","actionUrl":"","bookId":7366916601012405,"bookType":0,"bookName":"The King's Avatar","coverUpdateTime":1581418734974},{"contentType":0,"title":"","subTitle":"","imageUrl":"","actionUrl":"","bookId":14883978401129904,"bookType":0,"bookName":"Test 0925 test","coverUpdateTime":1608106368341},{"contentType":0,"title":"","subTitle":"","imageUrl":"","actionUrl":"","bookId":14069944901057104,"bookType":0,"bookName":"test1","coverUpdateTime":1591701058222}],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":"","order":23}]
     */
    blockItems?: {
      /**
       * "5fd1f8a0b535193b6b0cfdff"
       */
      id?: string;
      /**
       * "M4001"
       */
      title?: string;
      /**
       * "M4001"
       */
      subTitle?: string;
      /**
       * "4001"
       */
      type?: string;
      background?: string;
      contentId?: string;
      /**
       * [{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"ORIGINAL","iconUrl":"https://webbannertest.webnovel.com/utils/1608288750_720752.png","actionUrl":"","index":0},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"NEW","iconUrl":"https://webbannertest.webnovel.com/utils/1608288727_740241.png","actionUrl":"","index":1},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"GENRE","iconUrl":"https://webbannertest.webnovel.com/utils/1608288739_997971.png","actionUrl":"","index":2},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"VOTE","iconUrl":"https://webbannertest.webnovel.com/utils/1608288697_219083.png","actionUrl":"","index":3},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"RANKING","iconUrl":"https://webbannertest.webnovel.com/utils/1608288712_188901.png","actionUrl":"","index":4}]
       */
      contentItems?: {
        /**
         * 1
         */
        apiType?: number;
        /**
         * "{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}"
         */
        apiParam?: string;
        /**
         * "ORIGINAL"
         */
        showWords?: string;
        /**
         * "https://webbannertest.webnovel.com/utils/1608288750_720752.png"
         */
        iconUrl?: string;
        actionUrl?: string;
        index?: number;
      }[];
      changeable?: boolean;
      /**
       * 1
       */
      apiType?: number;
      /**
       * "{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}"
       */
      apiParam?: string;
      /**
       * -1
       */
      moreType?: number;
      moreParam?: string;
      reportInfo?: {
        /**
         * -1
         */
        strategy?: number;
        /**
         * -1
         */
        days?: number;
        /**
         * -1
         */
        sourceType?: number;
      };
      recomBookName?: string;
      order?: number;
    }[];
  };
}

/**
 * 接口 [新书城获取pageList接口↗](https://yapi.yuewen.com/project/2309/interface/api/178054) 的 **请求配置的类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page-list`
 * @更新时间 `2020-12-21 14:45:59`
 */
type GoPcmBookcityPageListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookcity/page-list",
    "data",
    string,
    "country" | "sex" | "language" | "bookCityType",
    false
  >
>;

/**
 * 接口 [新书城获取pageList接口↗](https://yapi.yuewen.com/project/2309/interface/api/178054) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page-list`
 * @更新时间 `2020-12-21 14:45:59`
 */
const goPcmBookcityPageListRequestConfig: GoPcmBookcityPageListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/page-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: ["country", "sex", "language", "bookCityType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityPageList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [新书城获取pageList接口↗](https://yapi.yuewen.com/project/2309/interface/api/178054) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page-list`
 * @更新时间 `2020-12-21 14:45:59`
 */
export const goPcmBookcityPageList = /*#__PURE__*/ (
  requestData: GoPcmBookcityPageListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookcityPageListResponse>(
    prepare(goPcmBookcityPageListRequestConfig, requestData),
    ...args
  );
};

goPcmBookcityPageList.requestConfig = goPcmBookcityPageListRequestConfig;

/**
 * 接口 [新书城获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178062) 的 **请求类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page`
 * @更新时间 `2023-05-23 15:48:35`
 */
export interface GoPcmBookcityPageRequest {
  /**
   * pageId
   */
  pageId: string;
  /**
   * 1 M站，2 PC站
   */
  bookCityType: string;
}

/**
 * 接口 [新书城获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178062) 的 **返回类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page`
 * @更新时间 `2023-05-23 15:48:35`
 */
export interface GoPcmBookcityPageResponse {
  /**
   * "${query.pageId}"
   */
  pageId?: string;
  /**
   * "test_pc_m"
   */
  bookCityName?: string;
  /**
   * ["Global"]
   */
  countryItems?: string[];
  /**
   * []
   */
  blackCountryItems?: unknown[];
  /**
   * ["en"]
   */
  languageItems?: string[];
  /**
   * [1]
   */
  sexItems?: number[];
  /**
   * "小说"
   */
  remark?: string;
  /**
   * [{"id":"5fd1f8a0b535193b6b0cfdff","title":"M4001","subTitle":"M4001","type":"4001","order":4001,"background":"","contentId":"","contentItems":[{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"111","iconUrl":"https://webbannertest.webnovel.com/utils/1607596403_647814.jpeg","actionUrl":"","index":0},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"222","iconUrl":"https://webbannertest.webnovel.com/utils/1607596424_187393.jpeg","actionUrl":"","index":1},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"333","iconUrl":"https://webbannertest.webnovel.com/utils/1607596450_967279.jpeg","actionUrl":"","index":2},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"444","iconUrl":"https://webbannertest.webnovel.com/utils/1607596467_436756.jpeg","actionUrl":"","index":3},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"555","iconUrl":"https://webbannertest.webnovel.com/utils/1607596481_736965.jpeg","actionUrl":"","index":4}],"changeable":false,"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f755b535193b6b0cfde9","title":"M1001","subTitle":"M1001副标题","type":"1001","order":1001,"background":"","contentId":"","contentItems":[{"title":"M1001","subTitle":"M1001","imageUrl":"https://webbanner.webnovel.com/utils/1558509128_922580.jpg","actionUrl":"https://activity.webnovel.com/64592563/mlbb","width":852,"height":480,"order":1},{"title":"M1001","subTitle":"M1001","imageUrl":"https://webbanner.webnovel.com/utils/1558509128_922580.jpg","actionUrl":"https://webbanner.webnovel.com/utils/1558509128_922580.jpg","width":852,"height":480,"order":2}],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f783b535193b6b0cfdea","title":"M1002","subTitle":"M1002","type":"1002","order":1002,"background":"","contentId":"","contentItems":[{"comicId":"11558338301012800","comicName":"Xiuzhen","categoryName":"Hot-blooded","coverUpdateTime":"0"},{"comicId":"12472322401037300","comicName":"Webnovel TestComic1214","categoryName":"Romance","coverUpdateTime":"0"},{"comicId":"13137795401042200","comicName":"Webnovel TestComic0301","categoryName":"Magic","coverUpdateTime":"0"},{"comicId":"12637189201038000","comicName":"\tWebnovel TestComic0102","categoryName":"Hot-blooded","coverUpdateTime":"0"},{"comicId":"11566481001013000","comicName":"Webnove lComic Test 002","categoryName":"Modern","coverUpdateTime":"1590922848187"}],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f797b535193b6b0cfdeb","title":"M1003","subTitle":"M1003","type":"1003","order":1003,"background":"","contentId":"","contentItems":{"title":"","subTitle":"","imageUrl":"https://webbannertest.webnovel.com/utils/1607597825_175280.jpg","actionUrl":"https://webbannertest.webnovel.com/utils/1607598038_840941.jpg","width":800,"height":400,"order":""},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f7b6b535193b6b0cfdec","title":"M1004","subTitle":"M1004","type":"1004","order":1004,"background":"","contentId":"","contentItems":{"comicId":"11558338301012800","comicName":"Xiuzhen","categoryName":"Hot-blooded","coverUpdateTime":"0"},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f7c2b535193b6b0cfded","title":"M1005","subTitle":"M1005","type":"1005","order":1005,"background":"","contentId":"","contentItems":{"comicId":"11558338301012800","comicName":"Xiuzhen","categoryName":"Hot-blooded","coverUpdateTime":"0","expireTime":1611845700000},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f7ceb535193b6b0cfdee","title":"M1006","subTitle":"M1006","type":"1006","order":1006,"background":"","contentId":"","contentItems":[{"bookId":"11670122501015804","bookName":"webnovel test0912","categoryName":"History","categoryId":70003,"authorName":"test_qa12","score":"0.00","description":"123qwer","coverUpdateTime":"0","powerNums":0,"bookType":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"11670122501015805\",\"logid\":4933384436824159536,\"origin\":\"12058\",\"preitemid\":\"b_11670122501015805\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"},{"bookId":"14391564901068004","bookName":"FicoolTest072403","categoryName":"History","categoryId":70003,"authorName":"tinasong07","score":"0.00","description":"","coverUpdateTime":"1581421910018","powerNums":0,"bookType":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"14391564901068005\",\"logid\":4933384436824159536,\"origin\":\"12058\",\"preitemid\":\"b_14391564901068005\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"},{"bookId":"13492616101047304","bookName":"Noah essay","categoryName":"Fantasy","categoryId":70002,"authorName":"Clementine","score":"0.00","description":"Noah essay","coverUpdateTime":"1581421908737","powerNums":0,"bookType":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"13492616101047305\",\"logid\":4933384436824159536,\"origin\":\"12058\",\"preitemid\":\"b_13492616101047305\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"},{"bookId":"14476162801070004","bookName":"test  0803 xiu gai","categoryName":"Book&Literature","categoryId":81001,"authorName":"Arnold","score":"3.75","description":"gue juga jadi juara juga jadi tim juga 555","coverUpdateTime":"1607332275914","powerNums":0,"bookType":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"14476162801070005\",\"logid\":4933384436824159536,\"origin\":\"12058\",\"preitemid\":\"b_14476162801070005\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"},{"bookId":"14469389101069504","bookName":"Kuai su","categoryName":"History","categoryId":70003,"authorName":"4300000970","score":"0.00","description":"","coverUpdateTime":"1581421926972","powerNums":0,"bookType":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"14469389101069505\",\"logid\":4933384436824159536,\"origin\":\"12058\",\"preitemid\":\"b_14469389101069505\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"},{"bookId":"13250506701043004","bookName":"/…,plw jebhpdovel toewst )03914lDOmmWNo…1* jdda`/dIp,,*…GdguqaU+.j/ga@wdw?,…=d@pg@y…7yduisoo \nw","categoryName":"Fantasy","categoryId":70002,"authorName":"garden6cg","score":"0.00","description":"webnovel test 0314","coverUpdateTime":"0","powerNums":0,"bookType":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"13250506701043005\",\"logid\":4933384436824159536,\"origin\":\"12058\",\"preitemid\":\"b_13250506701043005\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"},{"bookId":"12352553201035404","bookName":"webnovel test1130","categoryName":"Horror&Thriller","categoryId":70004,"authorName":"sina1024","score":"0.00","description":"","coverUpdateTime":"1581421905727","powerNums":0,"bookType":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"12352553201035405\",\"logid\":4933384436824159536,\"origin\":\"12058\",\"preitemid\":\"b_12352553201035405\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"},{"bookId":"13968398101054204","bookName":"test zmy","categoryName":"Fantasy","categoryId":70002,"authorName":"test_qa","score":"0.00","description":"QA TEST","coverUpdateTime":"1563364393590","powerNums":0,"bookType":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"13968398101054205\",\"logid\":4933384436824159536,\"origin\":\"12058\",\"preitemid\":\"b_13968398101054205\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"},{"bookId":"6820754201002505","bookName":"Masked Knight","categoryName":"Romance","categoryId":70005,"authorName":"Dancing","score":"3.55","description":"In a world where magic and sorcery flourish came a tale of a nobody who grew into a legend. Partake in the conquests and tribulations of a great army where warriors live day-to-day, seeking the thrill of combat. \r\n\r\nExperience heart-rending drama and hilarious situations while awaiting the impending arrival of the malevolent evil stirring in the darkest depths of the world... \r\n\r\nJourney alongside Rody, a young knight, as he dons a mask of circumstances that is filled with secrets to unravel the mysteries of the universe!\r\n\r\n------\r\nRelease Rate: 5 Chapters/Week; will be released on Mon, Wed, Fri and Weekend; ","coverUpdateTime":"0","powerNums":0,"bookType":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"6820754201002505\",\"logid\":4933384436824159536,\"origin\":\"12058\",\"preitemid\":\"b_6820754201002505\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"}],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":0,"days":30,"sourceType":1},"recomBookName":""},{"id":"5fd1f7e3b535193b6b0cfdef","title":"M1007","subTitle":"M1007","type":"1007","order":1007,"background":"","contentId":"","contentItems":[{"collectionId":"169515160468324350","collectionName":"tios改变状态","categoryName":["History","Magical Realism"],"bookItems":[{"bookId":"11558338301012800","coverId":0},{"bookId":"16698222201024404","coverId":1587024075126},{"bookId":"11566207401012900","coverId":0},{"bookId":"16195153001005504","coverId":1596004850447}],"bookNum":10,"follows":847},{"collectionId":"169099763705315330","collectionName":"吃火锅哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈","categoryName":["Magical Realism","Fantasy"],"bookItems":[{"bookId":"11443406601008804","coverId":0},{"bookId":"15833369401155904","coverId":1578375669972},{"bookId":"10226460301021804","coverId":0},{"bookId":"11358144901005704","coverId":1577155285613}],"bookNum":50,"follows":846},{"collectionId":"191635906405466100","collectionName":"qaz","categoryName":["Magical Realism"],"bookItems":[{"bookId":"9087880901018704","coverId":0}],"bookNum":1,"follows":12},{"collectionId":"166646577656627200","collectionName":"test444","categoryName":[""],"bookItems":[{"bookId":"6820980401004005","coverId":0}],"bookNum":1,"follows":4}],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f7f0b535193b6b0cfdf0","title":"M2001","subTitle":"M2001","type":"2001","order":2001,"background":"","contentId":"","contentItems":{"categoryNum":19,"categoryList":[{"categoryId":70017,"categoryName":"Sci-fi Romance"},{"categoryId":70016,"categoryName":"Fantasy Romance"},{"categoryId":70019,"categoryName":"LGBT+"},{"categoryId":70018,"categoryName":"Teen"},{"categoryId":70001,"categoryName":"Magical Realism"},{"categoryId":70003,"categoryName":"History"}]},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f7fab535193b6b0cfdf1","title":"M2002","subTitle":"M2002","type":"2002","order":2002,"background":"","contentId":"","contentItems":{"categoryNum":27,"categoryList":[{"categoryId":60002,"categoryName":"Hot-blooded"},{"categoryId":60003,"categoryName":"Romance"},{"categoryId":60004,"categoryName":"Sci-Fi"},{"categoryId":60005,"categoryName":"Modern"},{"categoryId":60006,"categoryName":"Eastern Fantasy"},{"categoryId":60007,"categoryName":"School Life"}]},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f804b535193b6b0cfdf2","title":"M2003","subTitle":"M2003","type":"2003","order":2003,"background":"","contentId":"","contentItems":[{"bookType":0,"id":"11470906201009904","name":"asdfasdffl;klasdjlasdfdsf","categoryId":70003,"categoryName":"History","coverUpdateTime":"1581421925685","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":18000,\"itemid\":\"11470906201009905\",\"logid\":2067487558340726203,\"origin\":\"12058\",\"preitemid\":\"b_11470906201009905\",\"scene\":\"potential-starlet\",\"type\":\"0\",\"version\":\"0\"}"},{"bookType":0,"id":"14043956001056904","name":"Webnovel test 0614","categoryId":70003,"categoryName":"History","coverUpdateTime":"1581421908885","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":18000,\"itemid\":\"14043956001056905\",\"logid\":2067487558340726203,\"origin\":\"12058\",\"preitemid\":\"b_14043956001056905\",\"scene\":\"potential-starlet\",\"type\":\"0\",\"version\":\"0\"}"},{"bookType":0,"id":"13968790401054404","name":"测试已经精排的文字再操作","categoryId":70002,"categoryName":"Fantasy","coverUpdateTime":"0","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":18000,\"itemid\":\"13968790401054405\",\"logid\":2067487558340726203,\"origin\":\"12058\",\"preitemid\":\"b_13968790401054405\",\"scene\":\"potential-starlet\",\"type\":\"0\",\"version\":\"0\"}"},{"bookType":0,"id":"14391628101068104","name":"FicoolTest072405","categoryId":70012,"categoryName":"Martial Arts","coverUpdateTime":"1581421909021","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":18000,\"itemid\":\"14391628101068105\",\"logid\":2067487558340726203,\"origin\":\"12058\",\"preitemid\":\"b_14391628101068105\",\"scene\":\"potential-starlet\",\"type\":\"0\",\"version\":\"0\"}"},{"bookType":0,"id":"12319053801034104","name":"Webnovel test1204","categoryId":70003,"categoryName":"History","coverUpdateTime":"0","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":18000,\"itemid\":\"12319053801034105\",\"logid\":2067487558340726203,\"origin\":\"12058\",\"preitemid\":\"b_12319053801034105\",\"scene\":\"potential-starlet\",\"type\":\"0\",\"version\":\"0\"}"},{"bookType":0,"id":"11987368201024204","name":"webnovel test101902","categoryId":70003,"categoryName":"History","coverUpdateTime":"0","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":18000,\"itemid\":\"11987368201024205\",\"logid\":2067487558340726203,\"origin\":\"12058\",\"preitemid\":\"b_11987368201024205\",\"scene\":\"potential-starlet\",\"type\":\"0\",\"version\":\"0\"}"},{"bookType":0,"id":"11790743101023204","name":"webnovel test092602","categoryId":70003,"categoryName":"History","coverUpdateTime":"0","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":18000,\"itemid\":\"11790743101023205\",\"logid\":2067487558340726203,\"origin\":\"12058\",\"preitemid\":\"b_11790743101023205\",\"scene\":\"potential-starlet\",\"type\":\"0\",\"version\":\"0\"}"},{"bookType":0,"id":"14011267101054704","name":"WEBNOVEL TEST PUBLISH","categoryId":70002,"categoryName":"Fantasy","coverUpdateTime":"1581421911021","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":18000,\"itemid\":\"14011267101054705\",\"logid\":2067487558340726203,\"origin\":\"12058\",\"preitemid\":\"b_14011267101054705\",\"scene\":\"potential-starlet\",\"type\":\"0\",\"version\":\"0\"}"},{"bookType":0,"id":"14313231201060504","name":"2019071502","categoryId":70003,"categoryName":"History","coverUpdateTime":"1581421913899","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":18000,\"itemid\":\"14313231201060505\",\"logid\":2067487558340726203,\"origin\":\"12058\",\"preitemid\":\"b_14313231201060505\",\"scene\":\"potential-starlet\",\"type\":\"0\",\"version\":\"0\"}"}],"changeable":false,"apiType":8,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":0,"days":30,"sourceType":1},"recomBookName":""},{"id":"5fd1f80fb535193b6b0cfdf3","title":"M2004","subTitle":"M2004","type":"2004","order":2004,"background":"","contentId":"","contentItems":[{"bookType":0,"id":"6822887201006405","name":"The Magus Era","categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0"},{"bookType":0,"id":"6820945401003205","name":"Commanding Wind and Cloud","categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"1581421907692"},{"bookType":0,"id":"6820754201002505","name":"Masked Knight","categoryId":70005,"categoryName":"Romance","coverUpdateTime":"0"},{"bookType":0,"id":"14315501801060804","name":"test 20190715 01","categoryId":70002,"categoryName":"Fantasy","coverUpdateTime":"1581421911046"},{"bookType":0,"id":"6789521301000305","name":"Gourmet Food Supplier","categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0"}],"changeable":true,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f819b535193b6b0cfdf4","title":"M2005","subTitle":"M2005","type":"2005","order":2005,"background":"","contentId":"","contentItems":[{"bookType":0,"id":"11651593101013804","name":"Webnovel test0910","categoryId":70005,"categoryName":"Romance","coverUpdateTime":"0","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"11651593101013805\",\"logid\":790055075508909688,\"origin\":\"12058\",\"preitemid\":\"b_11651593101013805\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"},{"bookType":0,"id":"14478320801070604","name":"webnovel test fanfic 8302","categoryId":81002,"categoryName":"Celebrities & Real People","coverUpdateTime":"1607332275965","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"14478320801070605\",\"logid\":790055075508909688,\"origin\":\"12058\",\"preitemid\":\"b_14478320801070605\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"},{"bookType":0,"id":"14374183001066904","name":"FicoolTest0722","categoryId":70003,"categoryName":"History","coverUpdateTime":"1581421909276","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"14374183001066905\",\"logid\":790055075508909688,\"origin\":\"12058\",\"preitemid\":\"b_14374183001066905\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"},{"bookType":0,"id":"13968439001054304","name":"jingpai  test2","categoryId":70003,"categoryName":"History","coverUpdateTime":"0","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"13968439001054305\",\"logid\":790055075508909688,\"origin\":\"12058\",\"preitemid\":\"b_13968439001054305\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"},{"bookType":0,"id":"14019761001055704","name":"TESTZ","categoryId":70015,"categoryName":"Historical Romance","coverUpdateTime":"1582539803002","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"14019761001055705\",\"logid\":790055075508909688,\"origin\":\"12058\",\"preitemid\":\"b_14019761001055705\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"},{"bookType":0,"id":"11738550901022404","name":"09200","categoryId":70003,"categoryName":"History","coverUpdateTime":"0","statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":17000,\"itemid\":\"11738550901022405\",\"logid\":790055075508909688,\"origin\":\"12058\",\"preitemid\":\"b_11738550901022405\",\"scene\":\"weekly-featured\",\"type\":\"0\",\"version\":\"0\"}"}],"changeable":false,"apiType":8,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":0,"days":30,"sourceType":1},"recomBookName":""},{"id":"5fd1f824b535193b6b0cfdf5","title":"M2006","subTitle":"M2006","type":"2006","order":2006,"background":"","contentId":"","contentItems":[{"bookType":100,"id":"13137795401042200","name":"Webnovel TestComic0301","categoryId":60012,"categoryName":"Transmigration","coverUpdateTime":"0"},{"bookType":100,"id":"12472322401037300","name":"Webnovel TestComic1214","categoryId":60004,"categoryName":"Sci-Fi","coverUpdateTime":"0"},{"bookType":100,"id":"12637189201038000","name":"\tWebnovel TestComic0102","categoryId":60002,"categoryName":"Hot-blooded","coverUpdateTime":"0"},{"bookType":100,"id":"11558338301012800","name":"Xiuzhen","categoryId":60002,"categoryName":"Hot-blooded","coverUpdateTime":"0"}],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f82eb535193b6b0cfdf6","title":"M2007","subTitle":"M2007","type":"2007","order":2007,"background":"","contentId":"","contentItems":{"contentList":[{"bookType":0,"id":"6822887201006405","name":"The Magus Era","categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0"},{"bookType":0,"id":"6820945401003205","name":"Commanding Wind and Cloud","categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"1581421907692"},{"bookType":0,"id":"6820754201002505","name":"Masked Knight","categoryId":70005,"categoryName":"Romance","coverUpdateTime":"0"},{"bookType":0,"id":"14315501801060804","name":"test 20190715 01","categoryId":70002,"categoryName":"Fantasy","coverUpdateTime":"1581421911046"},{"bookType":0,"id":"6789521301000305","name":"Gourmet Food Supplier","categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0"},{"bookType":0,"id":"8161289901016405","name":"Tian huo da dao","categoryId":70012,"categoryName":"Martial Arts","coverUpdateTime":"0"}],"expireTime":1614441600000},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f839b535193b6b0cfdf7","title":"M2008","subTitle":"M2008","type":"2008","order":2008,"background":"","contentId":"","contentItems":[20201210,20201209,20201208,20201207,20201206,20201205,20201204],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f843b535193b6b0cfdf8","title":"M2009","subTitle":"M2009","type":"2009","order":2009,"background":"","contentId":"","contentItems":{"categoryNum":18,"categoryList":[{"categoryId":95001,"categoryName":"Arts & Photography"},{"categoryId":95002,"categoryName":"Biographies & Memoirs"},{"categoryId":95003,"categoryName":"Business & Economics"},{"categoryId":95004,"categoryName":"Children & Kids"},{"categoryId":95005,"categoryName":"Comics & Graphic Novels"},{"categoryId":95006,"categoryName":"Health, Family & Lifestyle"}]},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f84fb535193b6b0cfdf9","title":"M2010","subTitle":"M2010","type":"2010","order":2010,"background":"","contentId":"","contentItems":{"categoryNum":9,"categoryList":[{"categoryId":81001,"categoryName":"Book&Literature"},{"categoryId":81003,"categoryName":"Music & Bands"},{"categoryId":81002,"categoryName":"Celebrities & Real People"},{"categoryId":81005,"categoryName":"Video Games"},{"categoryId":81004,"categoryName":"Theater"},{"categoryId":81007,"categoryName":"Movies"}]},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f863b535193b6b0cfdfa","title":"M2013","subTitle":"M2013","type":"2013","order":"2013","background":"","contentId":"","contentItems":{"bookId":7366916601012405,"bookType":0,"bookName":"The King's Avatar","authorName":"Butterfly Blue","categoryName":"Video Games","coverUpdateTime":"1581418734974","expireTime":1614441600000,"totalScore":"4.2"},"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f87fb535193b6b0cfdfc","title":"M3001","subTitle":"M3001","type":"3001","order":3001,"background":"","contentId":"","contentItems":{"items":[],"expireTime":0,"isLast":0,"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}"},"changeable":false,"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f889b535193b6b0cfdfd","title":"M3002","subTitle":"M3002","type":"3002","order":3002,"background":"","contentId":"","contentItems":[{"bookType":0,"id":"6822887201006405","name":"The Magus Era","categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0"},{"bookType":0,"id":"6820945401003205","name":"Commanding Wind and Cloud","categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"1581421907692"},{"bookType":0,"id":"6820754201002505","name":"Masked Knight","categoryId":70005,"categoryName":"Romance","coverUpdateTime":"0"},{"bookType":0,"id":"14315501801060804","name":"test 20190715 01","categoryId":70002,"categoryName":"Fantasy","coverUpdateTime":"1581421911046"},{"bookType":0,"id":"6789521301000305","name":"Gourmet Food Supplier","categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0"},{"bookType":0,"id":"8161289901016405","name":"Tian huo da dao","categoryId":70012,"categoryName":"Martial Arts","coverUpdateTime":"0"},{"bookType":0,"id":"14715446801126104","name":"test vip words","categoryId":70005,"categoryName":"Romance","coverUpdateTime":"1568812799470"},{"bookType":0,"id":"13743109901051004","name":"Gourmet Food Supplier0521","categoryId":70010,"categoryName":"Realistic Fiction","coverUpdateTime":"0"},{"bookType":0,"id":"14069944901057104","name":"test1","categoryId":70001,"categoryName":"Realismo mágico","coverUpdateTime":"1591701058222"}],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f894b535193b6b0cfdfe","title":"M3003","subTitle":"M3003","type":"3003","order":3003,"background":"","contentId":"","contentItems":[{"tagName":"ACTION"},{"tagName":"SYSTEM"},{"tagName":"ADVENTURE"},{"tagName":"HAREM"},{"tagName":"REINCARNATION"},{"tagName":"MAGIC"},{"tagName":"COMEDY"},{"tagName":"ROMANCE"},{"tagName":"CULTIVATION"},{"tagName":"FANTASY"}],"changeable":false,"apiType":0,"apiParam":"","moreType":3002,"moreParam":"{\"url\":\"/tagList\"}","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f8afb535193b6b0cfe00","title":"M5001","subTitle":"M5001","type":"5001","order":5001,"background":"","contentId":"","contentItems":[{"bookId":"14069944901057105","name":"test1","bookType":0,"categoryName":"Realismo mágico","categoryId":70001,"coverUpdateTime":1591701058222,"recUserID":4300001149,"recUserName":"Nana_Sun_Cherry","recUserHeadImageId":0,"recommendWords":"好看值得"},{"bookId":"7366916601012405","name":"The King's Avatar","bookType":0,"categoryName":"Video Games","categoryId":70008,"coverUpdateTime":1581418734974,"recUserID":4300001149,"recUserName":"Nana_Sun_Cherry","recUserHeadImageId":0,"recommendWords":"好看值得"},{"bookId":"10650267701028205","name":"Webnovel Lily001","bookType":0,"categoryName":"History","categoryId":70003,"coverUpdateTime":1581421909468,"recUserID":4300001149,"recUserName":"Nana_Sun_Cherry","recUserHeadImageId":0,"recommendWords":"走过路过不错过"}],"changeable":false,"apiType":0,"apiParam":"","moreType":1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f8c8b535193b6b0cfe01","title":"M6001","subTitle":"M6001","type":"6001","order":6001,"background":"","contentId":"5fd1ff37b535193b6b0cfe32","contentItems":[{"contentType":1,"title":"啊啊啊啊","subTitle":"啊啊啊啊","imageUrl":"https://webbannertest.webnovel.com/utils/1607597825_175280.jpg","actionUrl":"","bookId":"10650267701028204","bookType":0,"bookName":"Webnovel Lily001","coverUpdateTime":1581421909468},{"contentType":0,"title":"","subTitle":"","imageUrl":"","actionUrl":"","bookId":"7366916601012405","bookType":0,"bookName":"The King's Avatar","coverUpdateTime":1581418734974},{"contentType":0,"title":"","subTitle":"","imageUrl":"","actionUrl":"","bookId":"14883978401129904","bookType":0,"bookName":"Test 0925 test","coverUpdateTime":1591701062252},{"contentType":0,"title":"","subTitle":"","imageUrl":"","actionUrl":"","bookId":"14069944901057104","bookType":0,"bookName":"test1","coverUpdateTime":1591701058222}],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd1f8d5b535193b6b0cfe02","title":"M2011","subTitle":"M2011","type":"2011","order":12011,"background":"","contentId":"","contentItems":[{"bookId":"10382778401025404","bookType":0,"bookName":"test123","categoryId":70004,"categoryName":"Horror&Thriller","authorName":"zhibonan888","bookCoverId":0,"description":"","totalScore":0,"pvNum":113,"tagInfos":null,"chapterNum":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"10382778401025405\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_10382778401025405\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"11679942001018504","bookType":0,"bookName":"New book","categoryId":70004,"categoryName":"Horror&Thriller","authorName":"translator2019","bookCoverId":1581421906182,"description":"","totalScore":0,"pvNum":5816,"tagInfos":null,"chapterNum":2,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"11679942001018505\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_11679942001018505\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"12318721801033604","bookType":0,"bookName":"Webnovel Test0110","categoryId":70003,"categoryName":"History","authorName":"translator2019","bookCoverId":1581421908721,"description":"qweqwe","totalScore":0,"pvNum":7272,"tagInfos":null,"chapterNum":3,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"12318721801033605\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_12318721801033605\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"14496481101071604","bookType":0,"bookName":"fanfic123213213213213","categoryId":81002,"categoryName":"Celebrities & Real People","authorName":"zmyhha1q","bookCoverId":1581421911882,"description":"","totalScore":0,"pvNum":4342,"tagInfos":null,"chapterNum":1,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"14496481101071605\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_14496481101071605\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"13777826501051804","bookType":0,"bookName":"tag","categoryId":70012,"categoryName":"Martial Arts","authorName":"4300001087","bookCoverId":0,"description":"","totalScore":0,"pvNum":992,"tagInfos":null,"chapterNum":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"13777826501051805\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_13777826501051805\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"11470916601010004","bookType":0,"bookName":"Webnovel Test0820","categoryId":70003,"categoryName":"History","authorName":"TAF_Auto31Gps","bookCoverId":1581421925858,"description":"asdfasdf","totalScore":0,"pvNum":128,"tagInfos":[{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false},{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false},{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false},{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false},{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false},{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false},{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false},{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false},{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false},{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false},{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false},{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false},{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false},{"id":41090003,"tagName":"ADSDS","likeCount":1,"like":false},{"id":41090004,"tagName":"ABSDS","likeCount":1,"like":false}],"chapterNum":2,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"11470916601010005\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_11470916601010005\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"13492754501047404","bookType":0,"bookName":"Clementine1104 02","categoryId":70002,"categoryName":"Fantasy","authorName":"Clementine","bookCoverId":1581421908678,"description":"Clementine1104 02","totalScore":0,"pvNum":0,"tagInfos":null,"chapterNum":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"13492754501047405\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_13492754501047405\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"11678014501018004","bookType":0,"bookName":"Webnovel test091302sdk","categoryId":70010,"categoryName":"Realistic Fiction","authorName":"yuewentester1024","bookCoverId":0,"description":"Sdk created","totalScore":0,"pvNum":402,"tagInfos":null,"chapterNum":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"11678014501018005\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_11678014501018005\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"11652696601014104","bookType":0,"bookName":"UAT First novel","categoryId":70004,"categoryName":"Horror&Thriller","authorName":"jianyu","bookCoverId":0,"description":"","totalScore":0,"pvNum":1446,"tagInfos":null,"chapterNum":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"11652696601014105\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_11652696601014105\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"10406698501026504","bookType":0,"bookName":"4444534testqie11","categoryId":70004,"categoryName":"Horror&Thriller","authorName":"zhibonan888","bookCoverId":0,"description":"","totalScore":0,"pvNum":0,"tagInfos":null,"chapterNum":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"10406698501026505\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_10406698501026505\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"13112977801041904","bookType":0,"bookName":"test123123123","categoryId":70002,"categoryName":"Fantasy","authorName":"ouyangxiang1029","bookCoverId":0,"description":"123","totalScore":0,"pvNum":355,"tagInfos":null,"chapterNum":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"13112977801041905\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_13112977801041905\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"14374716801067104","bookType":0,"bookName":"Webnovel Test072201","categoryId":70002,"categoryName":"Fantasy","authorName":"xujin1111111","bookCoverId":1563789274510,"description":"test","totalScore":0,"pvNum":174,"tagInfos":null,"chapterNum":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"14374716801067105\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_14374716801067105\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"10390463201026004","bookType":0,"bookName":"测试回归","categoryId":70012,"categoryName":"Martial Arts","authorName":"zhibonan888","bookCoverId":0,"description":"","totalScore":0,"pvNum":77,"tagInfos":null,"chapterNum":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"10390463201026005\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_10390463201026005\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"13527712701047704","bookType":0,"bookName":"webnovel test 20190415","categoryId":70003,"categoryName":"History","authorName":"Candy","bookCoverId":1581421910561,"description":"","totalScore":0,"pvNum":681,"tagInfos":null,"chapterNum":2,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"13527712701047705\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_13527712701047705\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"14392275401068204","bookType":0,"bookName":"FicoolTest072406","categoryId":70004,"categoryName":"Horror&Thriller","authorName":"tinasong07","bookCoverId":1581421909386,"description":"","totalScore":0,"pvNum":2748,"tagInfos":null,"chapterNum":1,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"14392275401068205\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_14392275401068205\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"14501393701072204","bookType":0,"bookName":"webnoveltest fanfic 0806 mac","categoryId":81002,"categoryName":"Celebrities & Real People","authorName":"zmyhha1q","bookCoverId":1581421912139,"description":"","totalScore":0,"pvNum":0,"tagInfos":null,"chapterNum":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"14501393701072205\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_14501393701072205\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"14477536501070304","bookType":0,"bookName":"webnovel fanfic1","categoryId":81002,"categoryName":"Celebrities & Real People","authorName":"uat_yuewen1234","bookCoverId":1591701057362,"description":"","totalScore":0,"pvNum":1776,"tagInfos":[{"id":41003018,"tagName":"MY LITTLE PONY","likeCount":0,"like":false}],"chapterNum":10,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"14477536501070305\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_14477536501070305\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"14399310701068404","bookType":0,"bookName":"FicoolTest072508","categoryId":80001,"categoryName":"","authorName":"tinasong07","bookCoverId":1581421910219,"description":"","totalScore":0,"pvNum":2839,"tagInfos":null,"chapterNum":7,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"14399310701068405\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_14399310701068405\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"12092707201026204","bookType":0,"bookName":"webnovel test1031","categoryId":70003,"categoryName":"History","authorName":"yuewentester1024","bookCoverId":0,"description":"qwe","totalScore":0,"pvNum":457,"tagInfos":null,"chapterNum":0,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"12092707201026205\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_12092707201026205\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false},{"bookId":"14374904801067404","bookType":0,"bookName":"webnovel test xinjianjingpai","categoryId":81007,"categoryName":"Movies","authorName":"test_qa","bookCoverId":1581421922022,"description":"","totalScore":0,"pvNum":907,"tagInfos":null,"chapterNum":1,"statParams":"{\"V\":\"1\",\"alg\":\"181.0.2\",\"expid\":3000,\"itemid\":\"14374904801067405\",\"logid\":5662154513915867214,\"origin\":\"12058\",\"preitemid\":\"b_14374904801067405\",\"scene\":\"book-feed\",\"type\":\"0\",\"version\":\"\"}","mTL":false}],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""},{"id":"5fd36359b535193b6b0cff17","order":10000,"title":"M2012","subTitle":"M2012","type":"2012","background":"","contentId":"","contentItems":[{"bookId":"11558338301012801","bookType":100,"bookName":"Xiuzhen","authorName":"testName","bookCoverId":0,"chapterUpdateTime":1607668893000,"chapterUpdateId":"50365669794970569","chapterUpdateName":"testesteste","chapterUpdateIndex":31,"recommendText":"f fs","readToChapterId":0,"totalScore":"3.9"},{"bookId":"11538023301012001","bookType":100,"bookName":"sync Comic 0828","authorName":"test123","bookCoverId":0,"chapterUpdateTime":1597035582000,"chapterUpdateId":"47511210907726125","chapterUpdateName":"更新","chapterUpdateIndex":8,"recommendText":"fcasdfgv","readToChapterId":0,"totalScore":"0.0"},{"bookId":"17640755401060801","bookType":100,"bookName":"test3 20200814 1","authorName":"1","bookCoverId":1596449452425,"chapterUpdateTime":1596798067000,"chapterUpdateId":"47396684799463552","chapterUpdateName":"12 20200817","chapterUpdateIndex":1,"recommendText":"2312 iusgdivfdiafiwfgbouf kugdiuqqwegroeurfgowewfgweifdu","readToChapterId":0,"totalScore":"0.0"},{"bookId":"16707603601026001","bookType":100,"bookName":"Comic Blue women0417","authorName":"ytt0602","bookCoverId":1590461960128,"chapterUpdateTime":1594869123000,"chapterUpdateId":"46913744449632976","chapterUpdateName":"ytt0715","chapterUpdateIndex":3,"recommendText":"comic recommend test  intservice","readToChapterId":0,"totalScore":"0.0"},{"bookId":"16707586601025901","bookType":100,"bookName":"webnovel  comic test 0417","authorName":"webnovel","bookCoverId":1587378657168,"chapterUpdateTime":1587378757000,"chapterUpdateId":"44917833150298902","chapterUpdateName":"019","chapterUpdateIndex":8,"recommendText":"web novel test  0525","readToChapterId":0,"totalScore":"0.0"},{"bookId":"13137795401042201","bookType":100,"bookName":"Webnovel TestComic0301","authorName":"ouyangxiang","bookCoverId":0,"chapterUpdateTime":1587121288000,"chapterUpdateId":"44850094268275796","chapterUpdateName":"chapter","chapterUpdateIndex":14,"recommendText":"","readToChapterId":0,"totalScore":"0.0"},{"bookId":"12472322401037301","bookType":100,"bookName":"Webnovel TestComic1214","authorName":"xujin0815","bookCoverId":0,"chapterUpdateTime":1583493035000,"chapterUpdateId":"43876093664488529","chapterUpdateName":"20200306","chapterUpdateIndex":12,"recommendText":"","readToChapterId":0,"totalScore":"0.0"},{"bookId":"14839998001127501","bookType":100,"bookName":"webnovel comic 091401","authorName":"hn55gher","bookCoverId":1594881056433,"chapterUpdateTime":1568444097000,"chapterUpdateId":"39836321514052677","chapterUpdateName":"NO.5","chapterUpdateIndex":4,"recommendText":"测定呵呵嘀嘀嘀","readToChapterId":0,"totalScore":"0.0"},{"bookId":"11566207401012901","bookType":100,"bookName":"Webnovel Comic Test001","authorName":"test","bookCoverId":0,"chapterUpdateTime":1556099504000,"chapterUpdateId":"36522554260780424","chapterUpdateName":"test 0424 01","chapterUpdateIndex":40,"recommendText":"","readToChapterId":0,"totalScore":"0.0"},{"bookId":"13043441201041401","bookType":100,"bookName":"Webnovel Test021812","authorName":"ouyangxiang","bookCoverId":0,"chapterUpdateTime":1550556805000,"chapterUpdateId":"35034895432606715","chapterUpdateName":"22","chapterUpdateIndex":2,"recommendText":"","readToChapterId":0,"totalScore":"0.0"},{"bookId":"13043017001040801","bookType":100,"bookName":"Webnovel Test021806","authorName":"ouyangxiang","bookCoverId":0,"chapterUpdateTime":1550472818000,"chapterUpdateId":"35012278134819303","chapterUpdateName":"1","chapterUpdateIndex":1,"recommendText":"","readToChapterId":0,"totalScore":"0.0"},{"bookId":"13043023101040901","bookType":100,"bookName":"Webnovel Test021807","authorName":"ouyangxiang","bookCoverId":0,"chapterUpdateTime":1550472786000,"chapterUpdateId":"35012287530060267","chapterUpdateName":"1","chapterUpdateIndex":1,"recommendText":"","readToChapterId":0,"totalScore":"0.0"},{"bookId":"13043071901041301","bookType":100,"bookName":"Webnovel Test021811","authorName":"testName","bookCoverId":0,"chapterUpdateTime":1550472759000,"chapterUpdateId":"35012338532796934","chapterUpdateName":"1","chapterUpdateIndex":1,"recommendText":"","readToChapterId":0,"totalScore":"0.0"},{"bookId":"13043064501041201","bookType":100,"bookName":"Webnovel Test021810","authorName":"ouyangxiang","bookCoverId":0,"chapterUpdateTime":1550472710000,"chapterUpdateId":"35012326184765951","chapterUpdateName":"1","chapterUpdateIndex":1,"recommendText":"","readToChapterId":0,"totalScore":"0.0"},{"bookId":"13042329601040701","bookType":100,"bookName":"Webnovel Test021805","authorName":"ouyangxiang","bookCoverId":0,"chapterUpdateTime":1550471333000,"chapterUpdateId":"35011272307165363","chapterUpdateName":"1","chapterUpdateIndex":1,"recommendText":"","readToChapterId":0,"totalScore":"0.0"},{"bookId":"13042329401040601","bookType":100,"bookName":"Webnovel Test021804-0319","authorName":"ouyangxiang","bookCoverId":0,"chapterUpdateTime":1550468728000,"chapterUpdateId":"35011176475707535","chapterUpdateName":"chapter0319","chapterUpdateIndex":1,"recommendText":"","readToChapterId":0,"totalScore":"0.0"},{"bookId":"13041983201040501","bookType":100,"bookName":"Webnovel Test021803","authorName":"ouyangxiang","bookCoverId":0,"chapterUpdateTime":1550468370000,"chapterUpdateId":"35010160447506283","chapterUpdateName":"1","chapterUpdateIndex":1,"recommendText":"","readToChapterId":0,"totalScore":"0.0"},{"bookId":"13041960401040401","bookType":100,"bookName":"Webnovel Test021802","authorName":"ouyangxiang","bookCoverId":0,"chapterUpdateTime":1550468354000,"chapterUpdateId":"35009312728335963","chapterUpdateName":"1","chapterUpdateIndex":1,"recommendText":"","readToChapterId":0,"totalScore":"0.0"},{"bookId":"13041913101040301","bookType":100,"bookName":"Webnovel Test021801","authorName":"ouyangxiang","bookCoverId":0,"chapterUpdateTime":1550468316000,"chapterUpdateId":"35009218775926333","chapterUpdateName":"1","chapterUpdateIndex":1,"recommendText":"","readToChapterId":0,"totalScore":"0.0"},{"bookId":"12698954101038401","bookType":100,"bookName":"Webnovel TestComic01091","authorName":"ouyangxiang","bookCoverId":0,"chapterUpdateTime":1547033417000,"chapterUpdateId":"34089039749512990","chapterUpdateName":"02","chapterUpdateIndex":2,"recommendText":"","readToChapterId":0,"totalScore":"0.0"}],"changeable":false,"apiType":0,"apiParam":"","moreType":-1,"moreParam":"","reportInfo":{"strategy":-1,"days":-1,"sourceType":-1},"recomBookName":""}]
   */
  blockItems?: {
    /**
     * "5fd1f8a0b535193b6b0cfdff"
     */
    id?: string;
    /**
     * "M4001"
     */
    title?: string;
    /**
     * "M4001"
     */
    subTitle?: string;
    /**
     * "4001"
     */
    type?: string;
    /**
     * 4001
     */
    order?: number;
    background?: string;
    contentId?: string;
    /**
     * [{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"111","iconUrl":"https://webbannertest.webnovel.com/utils/1607596403_647814.jpeg","actionUrl":"","index":0},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"222","iconUrl":"https://webbannertest.webnovel.com/utils/1607596424_187393.jpeg","actionUrl":"","index":1},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"333","iconUrl":"https://webbannertest.webnovel.com/utils/1607596450_967279.jpeg","actionUrl":"","index":2},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"444","iconUrl":"https://webbannertest.webnovel.com/utils/1607596467_436756.jpeg","actionUrl":"","index":3},{"apiType":1,"apiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","showWords":"555","iconUrl":"https://webbannertest.webnovel.com/utils/1607596481_736965.jpeg","actionUrl":"","index":4}]
     */
    contentItems?: {
      /**
       * 1
       */
      apiType?: number;
      /**
       * "{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}"
       */
      apiParam?: string;
      /**
       * "111"
       */
      showWords?: string;
      /**
       * "https://webbannertest.webnovel.com/utils/1607596403_647814.jpeg"
       */
      iconUrl?: string;
      actionUrl?: string;
      index?: number;
    }[];
    changeable?: boolean;
    /**
     * 1
     */
    apiType?: number;
    /**
     * "{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}"
     */
    apiParam?: string;
    /**
     * -1
     */
    moreType?: number;
    moreParam?: string;
    reportInfo?: {
      /**
       * -1
       */
      strategy?: number;
      /**
       * -1
       */
      days?: number;
      /**
       * -1
       */
      sourceType?: number;
    };
    recomBookName?: string;
  }[];
}

/**
 * 接口 [新书城获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178062) 的 **请求配置的类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page`
 * @更新时间 `2023-05-23 15:48:35`
 */
type GoPcmBookcityPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookcity/page",
    "data",
    string,
    "pageId" | "bookCityType",
    false
  >
>;

/**
 * 接口 [新书城获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178062) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page`
 * @更新时间 `2023-05-23 15:48:35`
 */
const goPcmBookcityPageRequestConfig: GoPcmBookcityPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/page",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: ["pageId", "bookCityType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [新书城获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178062) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page`
 * @更新时间 `2023-05-23 15:48:35`
 */
export const goPcmBookcityPage = /*#__PURE__*/ (
  requestData: GoPcmBookcityPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookcityPageResponse>(
    prepare(goPcmBookcityPageRequestConfig, requestData),
    ...args
  );
};

goPcmBookcityPage.requestConfig = goPcmBookcityPageRequestConfig;

/**
 * 接口 [get-qd-list 获取起点中文榜单↗](https://yapi.yuewen.com/project/2309/interface/api/178067) 的 **请求类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-qd-list`
 * @更新时间 `2020-12-15 20:16:19`
 */
export interface GoPcmBookcityGetQdListRequest {
  /**
   * 中文榜单类型
   * 【男生畅销精选 -4 】
   * 【男生主编力荐 - 5 】
   * 【男生新书强推 -7 】
   * 【男生经典完本 - 8】
   * 【女生畅销精选- 26】
   * 【女生主编力荐 - 27】
   * 【女生经典完本 - 30】
   */
  type: string;
  /**
   * 页码- 不传返回第一页
   */
  pageIndex?: string;
}

/**
 * 接口 [get-qd-list 获取起点中文榜单↗](https://yapi.yuewen.com/project/2309/interface/api/178067) 的 **返回类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-qd-list`
 * @更新时间 `2020-12-15 20:16:19`
 */
export interface GoPcmBookcityGetQdListResponse {
  /**
   * [{"bookId":0,"bookName":"@word","authorName":"@word","categoryId":0,"categoryName":"@word","bookCoverID":"15899331113","totalScore":"4.8","chapterNum":1111}]
   */
  listItems?: {
    bookId?: number;
    /**
     * "@word"
     */
    bookName?: string;
    /**
     * "@word"
     */
    authorName?: string;
    categoryId?: number;
    /**
     * "@word"
     */
    categoryName?: string;
    /**
     * "15899331113"
     */
    bookCoverID?: string;
    /**
     * "4.8"
     */
    totalScore?: string;
    /**
     * 1111
     */
    chapterNum?: number;
  }[];
  /**
   * 2
   */
  pageIndex?: number;
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [get-qd-list 获取起点中文榜单↗](https://yapi.yuewen.com/project/2309/interface/api/178067) 的 **请求配置的类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-qd-list`
 * @更新时间 `2020-12-15 20:16:19`
 */
type GoPcmBookcityGetQdListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookcity/get-qd-list",
    "data",
    string,
    "type" | "pageIndex",
    false
  >
>;

/**
 * 接口 [get-qd-list 获取起点中文榜单↗](https://yapi.yuewen.com/project/2309/interface/api/178067) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-qd-list`
 * @更新时间 `2020-12-15 20:16:19`
 */
const goPcmBookcityGetQdListRequestConfig: GoPcmBookcityGetQdListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-qd-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: ["type", "pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetQdList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-qd-list 获取起点中文榜单↗](https://yapi.yuewen.com/project/2309/interface/api/178067) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-qd-list`
 * @更新时间 `2020-12-15 20:16:19`
 */
export const goPcmBookcityGetQdList = /*#__PURE__*/ (
  requestData: GoPcmBookcityGetQdListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookcityGetQdListResponse>(
    prepare(goPcmBookcityGetQdListRequestConfig, requestData),
    ...args
  );
};

goPcmBookcityGetQdList.requestConfig = goPcmBookcityGetQdListRequestConfig;

/**
 * 接口 [get-relation-page 通过偏好id获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178069) 的 **请求类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-relation-page`
 * @更新时间 `2021-01-04 11:05:59`
 */
export interface GoPcmBookcityGetRelationPageRequest {
  /**
   * 导航栏位置 从 0 开始
   */
  index: string;
  /**
   * 用户男女-在用户未登录时候/用户无偏好时根据此进行兜底返回逻辑
   */
  sex: string;
  bookCityType: string;
}

/**
 * 接口 [get-relation-page 通过偏好id获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178069) 的 **返回类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-relation-page`
 * @更新时间 `2021-01-04 11:05:59`
 */
export interface GoPcmBookcityGetRelationPageResponse {
  Result?: number;
  Data?: {
    /**
     * 1
     */
    PageId?: number;
    /**
     * "Novel"
     */
    BookCityName?: string;
    /**
     * ["Global"]
     */
    CountryItems?: string[];
    /**
     * ["ID","MY","PH"]
     */
    BlackCountryItems?: string[];
    /**
     * ["en","ms","tl","in"]
     */
    LanguageItems?: string[];
    /**
     * [1]
     */
    SexItems?: number[];
    /**
     * "小说"
     */
    Remark?: string;
    /**
     * [{"Id":"5cebdc38333f5640a154no1","Title":"导航block","SubTitle":"","Type":"4001","Background":"","ContentItems":[{"ApiType":0,"ApiParam":null,"ShowWords":"Mobile Legends x Webnovel","IconUrl":"https://webbanner.webnovel.com/utils/1558509128_922580.jpg","ActionUrl":"https://activity.webnovel.com/64592563/mlbb","Index":0},{"ApiType":1004,"ApiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","ShowWords":"Editor's Choice","IconUrl":"https://webbanner.webnovel.com/utils/1557976959_587941.jpg","ActionUrl":"","Index":1},{"ApiType":3001,"ApiParam":null,"ShowWords":"Editor's Choice True","IconUrl":"https://webbanner.webnovel.com/utils/1557976959_587941.jpg","ActionUrl":"","Index":2}]},{"Id":"5cebdc38322bf5640a154ed6","Title":"头部banner","SubTitle":"","Type":"1001","Background":"","ContentItems":[{"Title":"Mobile Legends x Webnovel","SubTitle":"","ImageUrl":"https://webbanner.webnovel.com/utils/1558509128_922580.jpg","ActionUrl":"https://activity.webnovel.com/64592563/mlbb","Height":480,"Width":852,"Order":1},{"Title":"Editor's Choice","SubTitle":"","ImageUrl":"https://webbanner.webnovel.com/utils/1557976959_587941.jpg","ActionUrl":"/book/10385100206025505","Height":480,"Width":852,"Order":2}],"Changeable":true,"ApiType":0,"ApiParam":null,"MoreType":1,"MoreParam":null},{"Id":"5cebdc3833331640a154ed6","Title":"漫画banner5本","SubTitle":"","Type":"1002","Background":"","ContentItems":[{"ComicId":12074333605878204,"ComicName":"Some Comic Book","CategoryName":"Magical Realism","CoverUpdateTime":"1548230393845"},{"ComicId":1207411605878204,"ComicName":"Some Comic Book 2","CategoryName":"Magical Realism 2","CoverUpdateTime":"1548230394845"}],"Changeable":false,"ApiType":0,"ApiParam":null,"MoreType":1,"MoreParam":null},{"Id":"5cebdc38123f5640a154ye3","Title":"单个banner","SubTitle":"","Type":"1003","Background":"","ContentItems":{"Title":"Mobile Legends x Webnovel","SubTitle":"","ImageUrl":"https://webbanner.webnovel.com/utils/1558509128_922580.jpg","ActionUrl":"https://activity.webnovel.com/64592563/mlbb","Height":480,"Width":852,"Order":1},"Changeable":false,"ApiType":0,"ApiParam":null,"MoreType":1,"MoreParam":null},{"Id":"5cebdc32319331640a15kko","Title":"单个漫画","SubTitle":"","Type":"1004","Background":"","ContentItems":{"ComicId":12074333605878204,"ComicName":"Some Comic Book","CategoryName":"Magical Realism","CoverUpdateTime":"1548230393845"},"Changeable":false,"ApiType":0,"ApiParam":null,"MoreType":1,"MoreParam":null},{"Id":"5cebdc32319331640a1oop","Title":"单本漫画限免","SubTitle":"","Type":"1005","Background":"","ContentItems":{"ComicId":12074333605878204,"ComicName":"Some Comic Book","CategoryName":"Magical Realism","CoverUpdateTime":"1548230393845","ExpireTime":"1578230393845"},"Changeable":false,"ApiType":0,"ApiParam":null,"MoreType":-1,"MoreParam":null},{"Id":"5cebdc38322bf5640a154eda","Title":"Highly Recommended","SubTitle":"","Type":"1006","Background":"","ContentItems":[{"BookId":11809097405541504,"BookName":"Rise of Humanity","CategoryName":"Eastern Fantasy","CategoryId":70009,"AuthorName":"Zhai Zhu","Score":"4.1","Description":"In the world birthed by Pangu, the Three Sovereigns lit.","CoverUpdateTime":"1554693684923","PowerNums":0,"BookType":0},{"BookId":13225367206183304,"BookName":"Spending My Retirement In A Game","CategoryName":"Video Games","CategoryId":70008,"AuthorName":"DiceVR","Score":"4.7","Description":"Follow Benjamin Joyce, an elderly man with a pa","CoverUpdateTime":"1552295631921","PowerNums":0,"BookType":0},{"BookId":12820870105509204,"CoverUpdateTime":"1548252054833","CategoryName":"Fantasy","PowerNums":0,"Score":"4.7","BookType":0,"CategoryId":70002,"AuthorName":"Legion20","Description":"Derek McCoy was a man that since his youth had to face many adversities. Often forced to settle with surviving rather tha living, had finally found his place in the world, until everything was taken from him one last time. After losing his life to avenge his brother, he reincarnates until he finds a world worth living for, a world filled with magic and monsters. Follow him along his journey, from grieving brother to alien soldier. From infant to Supreme Magus.\r\n\r\n-------------------------------------------\r\nTags: Transmigration, Male MC, Western Fantasy\r\nSchedule: 1 chapter per day\r\nChapter Lenght: 1700 - 2000 words but usually are even longer\r\nWarning: The MC is not an hero nor an anti-hero. He is a broken, cynic and misanthropic person looking only for his own gain. If you are looking for a forgiving, nice, MC that goes around saving people in distress, this is not your cup of tea.\r\n--------------------------------------------\r\nSupport the Author:\r\nhttps://ko-fi.com/legion20\r\nhttps://paypal.me/Legion20\r\n-------------------------------------------\r\nDiscord channel: https://discord.gg/Z5T7CBD","BookName":"Supreme Magus"},{"BookId":11927742205619904,"CoverUpdateTime":"1557112680645","CategoryName":"Sci-fi","PowerNums":0,"Score":"3.9","BookType":0,"CategoryId":70006,"AuthorName":" Daoist Fierce Tiger","Description":"One day, Wei Xiao Bei gets dragged into The Dust World, a post-apocalyptic world ruled by monsters from myths, legends, games, etc. He also gains the power to travel between it and the real world, as well as the power called the 'Status Panel'. With this power, he chooses to strengthen himself to explore the vast mysteries and terror of the other world. What mysteries await him? And what is The Dust World.\r\nAuthor's Synopsis:\r\nWhat the hell is this? What the hell happened here?\r\nHow did my room become so ruined after a single night?\r\nThe floor and table were covered in dust, his new poster of Zhang Liang Ying that had just been posted on the wall a few days ago had already become yellow and tattered all over. Even Zhang Liang Ying’s beautiful face became monstrous, as if an old devil was looking at him with a terrifying smile.\r\nThe walls were covered by a mist of cobwebs and the fruits placed on top of the coffee table were withered and rotted to the point that the mold on them had turned black. The fruits below even seemed to have turned into mush. The aluminium framed window that the landlord had just installed not that long ago was now covered in a layer of white ash and the glass was filled with cracks and covered in dust.\r\nThe computer beside his bed was also covered by cobwebs and was accompanied by an empty water glass with a withered worm inside of it.\r\nDust filled the air making Wei Xiao Bei choke as he tried to breathe.\r\nEverything seemed to be ash gray without any light, as if looking at television static.\r\nAfter just one night, it seemed like everything in the room had aged for centuries or even millennia.\r\nMother… is this a dream?\r\nThis must be a dream!","BookName":" The City of Terror"},{"BookId":13071505405554604,"CoverUpdateTime":"1556511244114","CategoryName":"Eastern Fantasy","PowerNums":0,"Score":"4.3","BookType":0,"CategoryId":70009,"AuthorName":"Fish leaping to the peak","Description":"Every myth and legend is a path to Godhood!\r\nWhen humans enter the interstellar era, ancient cultivation techniques shone with new life. Your genes exist with you! A single sentence showing the true meaning of cultivation. Myths and legends are not a fantasy, there are ancient mythological genes in the bodies of everyone.\r\nThe Hou Yi Gene allows you to shoot a hundred miles, using a single arrow to break down the dome of heaven.\r\nThe Kuafu Gene allows you to run with flying speed, chasing after the sun and moon.\r\nThe Divine Dragon Gene allows you to soar among the clouds, roaming around the starry space.\r\n….\r\nAlmost ten thousand years have passed. Feng Lin came from the 21st century to this majestic era that surged forth with great momentum. Based on his understanding on the myths and legends of the ancient earth era, he embarked upon a unique genetic cultivation path.\r\nMonkey Gene + Stonebirth Gene = Stone Monkey Gene\r\nStone Monkey Gene + ??? = Spiritual Stone Monkey Gene\r\nSpiritual Stone Monkey Gene + ??? = Handsome Monkey King Gene\r\nHandsome Monkey King Gene + ??? = Sun Wukong Gene\r\nSun Wukong Gene + ??? = Great Sage Equal to Heavens Gene","BookName":"Legend of the Mythological Genes"},{"BookId":11721981606490104,"CoverUpdateTime":"1557976896208","CategoryName":"Fantasy","PowerNums":0,"Score":"4.1","BookType":0,"CategoryId":70002,"AuthorName":"Zhuang Bifan","Description":"The world that nurtured the civilization which reached the pinnacle of magic was on the verge of destruction. \r\nThe last survivor transmigrated to the past, when the magic civilization started growing, as countless mages were still fumbling their ways through the thorny paths of magic knowledge.\r\nHe, who came from the end of the magic era, aim to reach the pinnacle of magic. \r\n","BookName":"End of the Magic Era"},{"BookId":11413811606356704,"CoverUpdateTime":"1547654674438","CategoryName":"Fantasy","PowerNums":0,"Score":"4.7","BookType":0,"CategoryId":70002,"AuthorName":"KillerHemboy","Description":"[*Ding*\r\nWorld Domination System booting up.\r\n\r\n\r\nCurrent World: Unknown\r\n\r\n\r\nHost Status: Near-death\r\n\r\n\r\nCurrent Goal: Survive\r\n\r\n\r\nOverall Goal: Dominate and Conquer the world!]\r\n\r\nA college student struggling for cash opted for an experiment which was advertised as safe but paid a lot of money. As soon as he was strapped to a chair and had electrodes placed on his head, he fell asleep but woke up to this robotic voice in his head.\r\n\r\nWith these words started Daneel's adventures in an unknown world. \r\nWill he explore and conquer the rapidly changing new world, as the system stated? Or will he die and be forgotten within the eddies of time?\r\n\r\nIf you have some spare change, buy me a coffee to support me at: www.ko-fi.com/killerhemboy\r\n\r\nNew perma-goals in effect:\r\nTop 3: 2 Bonus Chapters\r\nTop 2: 3 Bonus Chapters\r\n#1(wow): 5 BONUS CHAPS\r\n\r\nRelease rate : 14 chapters per week\r\n\r\nRelease Schedule: 00:05, 6:00 GMT+8\r\n\r\nChapter Length: ~1400\r\n\r\nMap of Angaria: https://imgur.com/a/FWi9P9c\r\n\r\nDiscord: https://discord.gg/VCfdPUN","BookName":"World Domination System"},{"BookId":11797811306526604,"CoverUpdateTime":"1551073974858","CategoryName":"Video Games","PowerNums":0,"Score":"4.0","BookType":0,"CategoryId":70008,"AuthorName":"Primodial Saint","Description":"Average means nothing to our young protagonist! Why be normal when you have the chance to become a real life superman! Follow Jiang Fei as he discovers a mysterious ring that allowed him to play a Hyper Realistic Immersive MMORPG call Dawn Break! As the thin line between game and reality is gradually blurred, Jiang Fei finds himself having to deal with the troubles that follow him everywhere he goes. This is a story revolving around a real-life cheat code! From zero to hero, follow Jiang Fei as his fascinating adventures unfold!","BookName":"The Almighty Ring"},{"BookId":9449494306002404,"CoverUpdateTime":"1547636437968","CategoryName":"Eastern Fantasy","PowerNums":0,"Score":"3.8","BookType":0,"CategoryId":70009,"AuthorName":"Heavenly Overlord","Description":"A decision can destroy the sun, moon and stars. A finger can kill the Heavenly Overlord. While chatting, the Heaven and ten worlds can be annihilated.\r\nA poor little kid walks out from a remote mountain area while holding the Nine Dragons and the Incredible Cauldron. With a control over the time and space eternally, he embarks on the Path to God where he defies the odds of the boundless universe gaudily by fighting against royalty and clashing with the legendary generation.","BookName":"The Divine Nine-Dragon Cauldron"}],"Changeable":true,"ApiType":0,"ApiParam":null,"MoreType":-1,"MoreParam":null},{"Id":"5cebdc38322bf5640a154ef1","Title":"New to Webnovel?","SubTitle":"","Type":"2003","Background":"","ContentItems":[{"BookType":0,"Id":8022472105002805,"Name":"Super Gene","CategoryId":70006,"CategoryName":"Sci-fi","CoverUpdateTime":"1547697670957","StatParams":""},{"BookType":0,"Id":7931338406001705,"Name":"Release That Witch","CategoryId":70002,"CategoryName":"Fantasy","CoverUpdateTime":"1547692288593","StatParams":""},{"BookType":0,"Id":7176992105000305,"Name":"The King's Avatar","CategoryId":70008,"CategoryName":"Video Games","CoverUpdateTime":"1547705433127","StatParams":""},{"BookType":0,"Id":8527113906000305,"Name":"Reincarnation Of The Strongest Sword God","CategoryId":70008,"CategoryName":"Video Games","CoverUpdateTime":"1547652621792","StatParams":""},{"BookType":0,"Id":7834199305001505,"Name":"Ancient Godly Monarch","CategoryId":70009,"CategoryName":"Eastern Fantasy","CoverUpdateTime":"1547627966843","StatParams":""},{"BookType":0,"Id":11418908406358804,"Name":"Black Tech Internet Cafe System","CategoryId":70006,"CategoryName":"Sci-fi","CoverUpdateTime":"1552586790932","StatParams":""},{"BookType":0,"Id":8335460805000105,"Name":"Monster Paradise","CategoryId":70009,"CategoryName":"Eastern Fantasy","CoverUpdateTime":"1547975916850","StatParams":""},{"BookType":0,"Id":7817013305001305,"Name":"The Strongest System","CategoryId":70009,"CategoryName":"Eastern Fantasy","CoverUpdateTime":"1547649032341","StatParams":""},{"BookType":0,"Id":7834223205001705,"Name":"I’m Really a Superstar","CategoryId":70001,"CategoryName":"Magical Realism","CoverUpdateTime":"1547650816758","StatParams":""}],"Changeable":true,"ApiType":0,"ApiParam":null,"MoreType":3002,"MoreParam":"{\"pageId\":\"\",\"url\":\"www.baidu.com\"}"},{"Id":"5cebdc38322bf5640a154gh1","Title":"1+n 滑动","SubTitle":"","Type":"2004","Background":"","ContentItems":[{"BookType":0,"Id":8022472105002805,"Name":"Super Gene","CategoryId":70006,"CategoryName":"Sci-fi","CoverUpdateTime":"1547697670957"},{"BookType":0,"Id":7931338406001705,"Name":"Release That Witch","CategoryId":70002,"CategoryName":"Fantasy","CoverUpdateTime":"1547692288593"},{"BookType":0,"Id":7176992105000305,"Name":"The King's Avatar","CategoryId":70008,"CategoryName":"Video Games","CoverUpdateTime":"1547705433127"},{"BookType":0,"Id":8527113906000305,"Name":"Reincarnation Of The Strongest Sword God","CategoryId":70008,"CategoryName":"Video Games","CoverUpdateTime":"1547652621792"},{"BookType":0,"Id":7834199305001505,"Name":"Ancient Godly Monarch","CategoryId":70009,"CategoryName":"Eastern Fantasy","CoverUpdateTime":"1547627966843"}],"Changeable":true,"ApiType":0,"ApiParam":null,"MoreType":1,"MoreParam":null},{"Id":"5cebdc38322bf5640a154ef1","Title":"平铺3+3显示6本","SubTitle":"","Type":"2005","Background":"","ContentItems":[{"BookType":0,"Id":8022472105002805,"Name":"Super Gene","CategoryId":70006,"CategoryName":"Sci-fi","CoverUpdateTime":"1547697670957"},{"BookType":0,"Id":7931338406001705,"Name":"Release That Witch","CategoryId":70002,"CategoryName":"Fantasy","CoverUpdateTime":"1547692288593"},{"BookType":0,"Id":7176992105000305,"Name":"The King's Avatar","CategoryId":70008,"CategoryName":"Video Games","CoverUpdateTime":"1547705433127"},{"BookType":0,"Id":8527113906000305,"Name":"Reincarnation Of The Strongest Sword God","CategoryId":70008,"CategoryName":"Video Games","CoverUpdateTime":"1547652621792"},{"BookType":0,"Id":7834199305001505,"Name":"Ancient Godly Monarch","CategoryId":70009,"CategoryName":"Eastern Fantasy","CoverUpdateTime":"1547627966843"},{"BookType":0,"Id":11418908406358804,"Name":"Black Tech Internet Cafe System","CategoryId":70006,"CategoryName":"Sci-fi","CoverUpdateTime":"1552586790932"}],"Changeable":true,"ApiType":0,"ApiParam":null,"MoreType":3001,"MoreParam":"{\"pageId\":\"5cebdc38322bf5640a154ef1\",\"url\":\"www.baidu.com\"}"},{"Id":"5cebdc38322bf5640a154edd","Title":"Selected Comics","SubTitle":"","Type":"2006","Background":"","ContentItems":[{"BookType":100,"Id":11609847806441000,"Name":"Cultivation Chat Group","CategoryId":60006,"CategoryName":"Eastern Fantasy","CoverUpdateTime":"1547740887589"},{"BookType":100,"Id":11610241506441100,"Name":"Versatile Mage","CategoryId":60002,"CategoryName":"Hot-blooded","CoverUpdateTime":"1557732120233"},{"BookType":100,"Id":11610296905451100,"Name":"Battle Frenzy","CategoryId":60002,"CategoryName":"Hot-blooded","CoverUpdateTime":"1547827253179"},{"BookType":100,"Id":12273128505179700,"Name":"Rebirth Of The Urban Immortal Cultivator","CategoryId":60005,"CategoryName":"Modern","CoverUpdateTime":"1547654473047"}],"Changeable":true,"ApiType":0,"ApiParam":null,"MoreType":-1,"MoreParam":null},{"Id":"5cebdc38322bf5640a154eed","Title":"限免平铺 3或6本","SubTitle":"","Type":"2007","Background":"","ContentItems":{"ContentList":[{"BookType":100,"Id":11609847806441000,"Name":"Cultivation Chat Group","CategoryId":60006,"CategoryName":"Eastern Fantasy","CoverUpdateTime":"1547740887589"},{"BookType":100,"Id":11610241506441100,"Name":"Versatile Mage","CategoryId":60002,"CategoryName":"Hot-blooded","CoverUpdateTime":"1557732120233"},{"BookType":100,"Id":11610296905451100,"Name":"Battle Frenzy","CategoryId":60002,"CategoryName":"Hot-blooded","CoverUpdateTime":"1547827253179"}],"ExpireTime":1577827253179},"Changeable":true,"ApiType":0,"ApiParam":null,"MoreType":-1,"MoreParam":null},{"Id":"5d8b0a0c7e89c34fae291f7e","Title":"漫画日历","SubTitle":"","Type":"2008","Background":"","ContentItems":[20190925,20190924,20190923,20190922,20190921,20190920,20190919],"Changeable":false,"ApiType":0,"ApiParam":null,"MoreType":-1,"MoreParam":null},{"Id":"5d8b0a1e7e89c34fae291f7f","Title":"出版书分类","SubTitle":"","Type":"2009","Background":"","ContentItems":{"CategoryNum":18,"CategoryList":[{"CategoryId":95001,"CategoryName":"Arts & Photography"},{"CategoryId":95002,"CategoryName":"Biographies & Memoirs"},{"CategoryId":95003,"CategoryName":"Business & Economics"},{"CategoryId":95004,"CategoryName":"Children & Kids"},{"CategoryId":95005,"CategoryName":"Comics & Graphic Novels"},{"CategoryId":95006,"CategoryName":"Health, Family & Lifestyle"}]},"Changeable":false,"ApiType":0,"ApiParam":null,"MoreType":-1,"MoreParam":null},{"Id":"5d8b0a3c7e89c34fae291f80","Title":"Fanfic分类","SubTitle":"","Type":"2010","Background":"","ContentItems":{"CategoryNum":9,"CategoryList":[{"CategoryId":81001,"CategoryName":"作品衍生"},{"CategoryId":81003,"CategoryName":"音乐组合"},{"CategoryId":81002,"CategoryName":"RPS同人"},{"CategoryId":81005,"CategoryName":"游戏衍生"},{"CategoryId":81004,"CategoryName":"戏剧同人"},{"CategoryId":81007,"CategoryName":"电影同人"}]},"Changeable":false,"ApiType":0,"ApiParam":null,"MoreType":-1,"MoreParam":null},{"Id":"5cebdc38322bf5640a154ee5","Title":"New","SubTitle":"","Type":"3001","Background":"","ContentItems":{"Items":[{"BookId":13071505405554604,"CoverUpdateTime":null,"CategoryName":"Eastern Fantasy","PowerNums":0,"Score":"4.3","BookType":1,"CategoryId":70009,"AuthorName":"Fish leaping to the peak","Description":"","BookName":"Legend of the Mythological Genes"},{"BookId":12905379906949404,"CoverUpdateTime":null,"CategoryName":"Romance","PowerNums":0,"Score":"4.2","BookType":1,"CategoryId":70005,"AuthorName":"Bean Ding Ding","Description":"","BookName":"The Bumpy Road of Marriage: Divorce Now, Daddy"},{"BookId":11013676105238104,"CoverUpdateTime":null,"CategoryName":"Romance","PowerNums":0,"Score":"4.2","BookType":1,"CategoryId":70005,"AuthorName":" Meng Luo Ting Die","Description":"","BookName":"Strike Back, Proud Goddess!"},{"BookId":13772794406217704,"CoverUpdateTime":null,"CategoryName":"Fan-fic","PowerNums":0,"Score":"4.1","BookType":2,"CategoryId":70011,"AuthorName":"nonamecodex","Description":"","BookName":"Harry Potter And The Traveler"},{"BookId":13841170905598204,"CoverUpdateTime":null,"CategoryName":"Magical Realism","PowerNums":0,"Score":"4.8","BookType":2,"CategoryId":70001,"AuthorName":"Elfriedenn","Description":"","BookName":"The Lust System"},{"BookId":11806202505539104,"CoverUpdateTime":null,"CategoryName":"Romance","PowerNums":0,"Score":"4.4","BookType":1,"CategoryId":70005,"AuthorName":" Brocade Star of Love","Description":"","BookName":" Rebirth to a Military Marriage: Good Morning Chief"},{"BookId":11927742205619904,"CoverUpdateTime":null,"CategoryName":"Sci-fi","PowerNums":0,"Score":"3.9","BookType":1,"CategoryId":70006,"AuthorName":" Daoist Fierce Tiger","Description":"","BookName":" The City of Terror"},{"BookId":13718815505960204,"CoverUpdateTime":null,"CategoryName":"Fan-fic","PowerNums":0,"Score":"4.8","BookType":2,"CategoryId":70011,"AuthorName":"Setdinner321","Description":"","BookName":"One Piece: Death Scythe"},{"BookId":11890154905597604,"CoverUpdateTime":null,"CategoryName":"Video Games","PowerNums":0,"Score":"4.0","BookType":1,"CategoryId":70008,"AuthorName":"Butterfly Blue","Description":"","BookName":"Virtual World: Close Combat Mage"}],"ApiType":5,"IsLast":0,"ApiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}"},"Changeable":false,"ApiType":0,"ApiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","MoreType":-1,"MoreParam":null},{"Id":"5d8b0dec7e89c34fae291f89","Title":"3002自定义榜单","SubTitle":"","Type":"3002","Background":"","ContentItems":[{"BookType":0,"Id":"6831119801007205","Name":"Throne of Magical Arcana","CategoryId":70004,"CategoryName":"Horror&Thriller","CoverUpdateTime":"0"},{"BookType":0,"Id":"6831119801007705","Name":"Castle of Black Iron","CategoryId":70001,"CategoryName":"Magical Realism","CoverUpdateTime":"0"},{"BookType":0,"Id":"6831119801008505","Name":"Plundering the Heavens","CategoryId":70005,"CategoryName":"Romance","CoverUpdateTime":"0"},{"BookType":0,"Id":"11780120901022805","Name":"testLog0925","CategoryId":70001,"CategoryName":"都市","CoverUpdateTime":"0"},{"BookType":0,"Id":"11738070901022105","Name":"webnovel ThirdParty0920001","CategoryId":70002,"CategoryName":"Fantasy","CoverUpdateTime":"0"},{"BookType":0,"Id":"10029102601019105","Name":"Library of Heaven Path","CategoryId":70001,"CategoryName":"Magical Realism","CoverUpdateTime":"0"},{"BookType":0,"Id":"7366916601012405","Name":"The King's Avatar","CategoryId":70008,"CategoryName":"Video Games","CoverUpdateTime":"0"},{"BookType":0,"Id":"10337289001023105","Name":"12111111","CategoryId":70001,"CategoryName":"Realisme Ajaib","CoverUpdateTime":"0"},{"BookType":0,"Id":"11468854201009105","Name":"webnovel test0820","CategoryId":70001,"CategoryName":"Magical Realism","CoverUpdateTime":"0"}],"Changeable":false,"ApiType":0,"ApiParam":null,"MoreType":-1,"MoreParam":null},{"Id":"5d8b0df97e89c34fae291f8a","Title":"3003tag","SubTitle":"","Type":"3003","Background":"","ContentItems":[{"TagName":"Throne of Magicena"},{"TagName":"Thronf Magical Arcana"},{"TagName":"Th Arcana"}],"Changeable":false,"ApiType":0,"ApiParam":null,"MoreType":-1,"MoreParam":null},{"SubTitle":"","Type":"2011","Background":"","Title":"Popular","Changeable":true,"ContentItems":[{"BookId":0,"BookType":0,"BookName":"@word","CategoryId":0,"CategoryName":"@word","TagInfos":[{"Id":1,"TagName":"tag"}],"BookCoverId":15899331113,"Description":"aaa","TotalScore":"4.8","PvNum":100}],"Id":"5cebdc38322bf5640a154ee8","ApiType":0,"ApiParam":null,"MoreType":-1,"MoreParam":null}]
     */
    BlockItems?: {
      /**
       * "5cebdc38333f5640a154no1"
       */
      Id?: string;
      /**
       * "导航block"
       */
      Title?: string;
      SubTitle?: string;
      /**
       * "4001"
       */
      Type?: string;
      Background?: string;
      /**
       * [{"ApiType":0,"ApiParam":null,"ShowWords":"Mobile Legends x Webnovel","IconUrl":"https://webbanner.webnovel.com/utils/1558509128_922580.jpg","ActionUrl":"https://activity.webnovel.com/64592563/mlbb","Index":0},{"ApiType":1004,"ApiParam":"{\"type\":1,\"listType\":0,\"rankId\":\"power_rank\"}","ShowWords":"Editor's Choice","IconUrl":"https://webbanner.webnovel.com/utils/1557976959_587941.jpg","ActionUrl":"","Index":1},{"ApiType":3001,"ApiParam":null,"ShowWords":"Editor's Choice True","IconUrl":"https://webbanner.webnovel.com/utils/1557976959_587941.jpg","ActionUrl":"","Index":2}]
       */
      ContentItems?: {
        ApiType?: number;
        ApiParam?: null;
        /**
         * "Mobile Legends x Webnovel"
         */
        ShowWords?: string;
        /**
         * "https://webbanner.webnovel.com/utils/1558509128_922580.jpg"
         */
        IconUrl?: string;
        /**
         * "https://activity.webnovel.com/64592563/mlbb"
         */
        ActionUrl?: string;
        Index?: number;
      }[];
    }[];
  };
}

/**
 * 接口 [get-relation-page 通过偏好id获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178069) 的 **请求配置的类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-relation-page`
 * @更新时间 `2021-01-04 11:05:59`
 */
type GoPcmBookcityGetRelationPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookcity/get-relation-page",
    "data",
    string,
    "index" | "sex" | "bookCityType",
    false
  >
>;

/**
 * 接口 [get-relation-page 通过偏好id获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178069) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-relation-page`
 * @更新时间 `2021-01-04 11:05:59`
 */
const goPcmBookcityGetRelationPageRequestConfig: GoPcmBookcityGetRelationPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-relation-page",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: ["index", "sex", "bookCityType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetRelationPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-relation-page 通过偏好id获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178069) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-relation-page`
 * @更新时间 `2021-01-04 11:05:59`
 */
export const goPcmBookcityGetRelationPage = /*#__PURE__*/ (
  requestData: GoPcmBookcityGetRelationPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookcityGetRelationPageResponse>(
    prepare(goPcmBookcityGetRelationPageRequestConfig, requestData),
    ...args
  );
};

goPcmBookcityGetRelationPage.requestConfig =
  goPcmBookcityGetRelationPageRequestConfig;

/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/178077) 的 **请求类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-change`
 * @更新时间 `2020-12-17 16:54:12`
 */
export interface GoPcmBookcityGetChangeRequest {
  /**
   * 书城block Id
   */
  blockId: string;
}

/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/178077) 的 **返回类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-change`
 * @更新时间 `2020-12-17 16:54:12`
 */
export interface GoPcmBookcityGetChangeResponse {
  blockItem?: {
    /**
     * "${query.blockId}"
     */
    id?: string;
    /**
     * "@title"
     */
    title?: string;
    /**
     * "@title"
     */
    subTitle?: string;
    /**
     * 2004
     */
    type?: number;
    /**
     * 1
     */
    background?: number;
    /**
     * true
     */
    changeable?: boolean;
    /**
     * [{"bookType":100,"id":1,"name":"@title","categoryName":"@title"}]
     */
    contentItems?: {
      /**
       * 100
       */
      bookType?: number;
      /**
       * 1
       */
      id?: number;
      /**
       * "@title"
       */
      name?: string;
      /**
       * "@title"
       */
      categoryName?: string;
    }[];
  };
}

/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/178077) 的 **请求配置的类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-change`
 * @更新时间 `2020-12-17 16:54:12`
 */
type GoPcmBookcityGetChangeRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookcity/get-change",
    "data",
    string,
    "blockId",
    false
  >
>;

/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/178077) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-change`
 * @更新时间 `2020-12-17 16:54:12`
 */
const goPcmBookcityGetChangeRequestConfig: GoPcmBookcityGetChangeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-change",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: ["blockId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetChange",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/178077) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-change`
 * @更新时间 `2020-12-17 16:54:12`
 */
export const goPcmBookcityGetChange = /*#__PURE__*/ (
  requestData: GoPcmBookcityGetChangeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookcityGetChangeResponse>(
    prepare(goPcmBookcityGetChangeRequestConfig, requestData),
    ...args
  );
};

goPcmBookcityGetChange.requestConfig = goPcmBookcityGetChangeRequestConfig;

/**
 * 接口 [get-history-list 获取block往期列表↗](https://yapi.yuewen.com/project/2309/interface/api/178082) 的 **请求类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history-list`
 * @更新时间 `2020-12-17 10:08:19`
 */
export interface GoPcmBookcityGetHistoryListRequest {
  /**
   * 书城block Id
   */
  blockId: string;
}

/**
 * 接口 [get-history-list 获取block往期列表↗](https://yapi.yuewen.com/project/2309/interface/api/178082) 的 **返回类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history-list`
 * @更新时间 `2020-12-17 10:08:19`
 */
export interface GoPcmBookcityGetHistoryListResponse {
  /**
   * [{"contentId":"@id","startTime":1607008079736},{"contentId":"@id","startTime":1607158079736},{"contentId":"@id","startTime":1608108079736}]
   */
  contentList?: {
    /**
     * "@id"
     */
    contentId?: string;
    /**
     * 1607008079736
     */
    startTime?: number;
  }[];
  contentInfo?: {
    /**
     * "@id"
     */
    contentId?: string;
    /**
     * 157783890000
     */
    startTime?: number;
    /**
     * [{"bookType":100,"bookId":1,"bookName":"@title","description":"aaa","authorName":"@word","categoryName":"@title","bookCoverId":"15899331113","totalScore":"4.8","mTL":true,"tagInfos":[{"id":1,"tagName":"tag","likeCount":0,"like":false}]}]
     */
    items?: {
      /**
       * 100
       */
      bookType?: number;
      /**
       * 1
       */
      bookId?: number;
      /**
       * "@title"
       */
      bookName?: string;
      /**
       * "aaa"
       */
      description?: string;
      /**
       * "@word"
       */
      authorName?: string;
      /**
       * "@title"
       */
      categoryName?: string;
      /**
       * "15899331113"
       */
      bookCoverId?: string;
      /**
       * "4.8"
       */
      totalScore?: string;
      /**
       * true
       */
      mTL?: boolean;
      /**
       * [{"id":1,"tagName":"tag","likeCount":0,"like":false}]
       */
      tagInfos?: {
        /**
         * 1
         */
        id?: number;
        /**
         * "tag"
         */
        tagName?: string;
        likeCount?: number;
        like?: boolean;
      }[];
    }[];
  };
}

/**
 * 接口 [get-history-list 获取block往期列表↗](https://yapi.yuewen.com/project/2309/interface/api/178082) 的 **请求配置的类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history-list`
 * @更新时间 `2020-12-17 10:08:19`
 */
type GoPcmBookcityGetHistoryListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookcity/get-history-list",
    "data",
    string,
    "blockId",
    false
  >
>;

/**
 * 接口 [get-history-list 获取block往期列表↗](https://yapi.yuewen.com/project/2309/interface/api/178082) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history-list`
 * @更新时间 `2020-12-17 10:08:19`
 */
const goPcmBookcityGetHistoryListRequestConfig: GoPcmBookcityGetHistoryListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-history-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: ["blockId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetHistoryList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-history-list 获取block往期列表↗](https://yapi.yuewen.com/project/2309/interface/api/178082) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history-list`
 * @更新时间 `2020-12-17 10:08:19`
 */
export const goPcmBookcityGetHistoryList = /*#__PURE__*/ (
  requestData: GoPcmBookcityGetHistoryListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookcityGetHistoryListResponse>(
    prepare(goPcmBookcityGetHistoryListRequestConfig, requestData),
    ...args
  );
};

goPcmBookcityGetHistoryList.requestConfig =
  goPcmBookcityGetHistoryListRequestConfig;

/**
 * 接口 [get-history 获取block某期配置内容↗](https://yapi.yuewen.com/project/2309/interface/api/178084) 的 **请求类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history`
 * @更新时间 `2020-12-17 10:34:21`
 */
export interface GoPcmBookcityGetHistoryRequest {
  /**
   * 内容id
   */
  contentId: string;
}

/**
 * 接口 [get-history 获取block某期配置内容↗](https://yapi.yuewen.com/project/2309/interface/api/178084) 的 **返回类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history`
 * @更新时间 `2020-12-17 10:34:21`
 */
export interface GoPcmBookcityGetHistoryResponse {
  /**
   * "@id"
   */
  contentId?: string;
  /**
   * 157783890000
   */
  startTime?: number;
  /**
   * [{"bookType":100,"bookId":1,"bookName":"@title","description":"aaa","authorName":"@word","categoryName":"@title","bookCoverId":"15899331113","totalScore":"4.8","mTL":true,"tagInfos":[{"id":1,"tagName":"tag","likeCount":0,"like":false}]}]
   */
  items?: {
    /**
     * 100
     */
    bookType?: number;
    /**
     * 1
     */
    bookId?: number;
    /**
     * "@title"
     */
    bookName?: string;
    /**
     * "aaa"
     */
    description?: string;
    /**
     * "@word"
     */
    authorName?: string;
    /**
     * "@title"
     */
    categoryName?: string;
    /**
     * "15899331113"
     */
    bookCoverId?: string;
    /**
     * "4.8"
     */
    totalScore?: string;
    /**
     * true
     */
    mTL?: boolean;
    /**
     * [{"id":1,"tagName":"tag","likeCount":0,"like":false}]
     */
    tagInfos?: {
      /**
       * 1
       */
      id?: number;
      /**
       * "tag"
       */
      tagName?: string;
      likeCount?: number;
      like?: boolean;
    }[];
  }[];
}

/**
 * 接口 [get-history 获取block某期配置内容↗](https://yapi.yuewen.com/project/2309/interface/api/178084) 的 **请求配置的类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history`
 * @更新时间 `2020-12-17 10:34:21`
 */
type GoPcmBookcityGetHistoryRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookcity/get-history",
    "data",
    string,
    "contentId",
    false
  >
>;

/**
 * 接口 [get-history 获取block某期配置内容↗](https://yapi.yuewen.com/project/2309/interface/api/178084) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history`
 * @更新时间 `2020-12-17 10:34:21`
 */
const goPcmBookcityGetHistoryRequestConfig: GoPcmBookcityGetHistoryRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-history",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: ["contentId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetHistory",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-history 获取block某期配置内容↗](https://yapi.yuewen.com/project/2309/interface/api/178084) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history`
 * @更新时间 `2020-12-17 10:34:21`
 */
export const goPcmBookcityGetHistory = /*#__PURE__*/ (
  requestData: GoPcmBookcityGetHistoryRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookcityGetHistoryResponse>(
    prepare(goPcmBookcityGetHistoryRequestConfig, requestData),
    ...args
  );
};

goPcmBookcityGetHistory.requestConfig = goPcmBookcityGetHistoryRequestConfig;

/**
 * 接口 [get-calendar漫画日历↗](https://yapi.yuewen.com/project/2309/interface/api/179033) 的 **请求类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-calendar`
 * @更新时间 `2020-12-17 17:22:07`
 */
export interface GoPcmComicGetCalendarRequest {
  date: string;
  pageIndex: string;
}

/**
 * 接口 [get-calendar漫画日历↗](https://yapi.yuewen.com/project/2309/interface/api/179033) 的 **返回类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-calendar`
 * @更新时间 `2020-12-17 17:22:07`
 */
export interface GoPcmComicGetCalendarResponse {
  /**
   * 2
   */
  pageIndex?: number;
  /**
   * 1
   */
  isLast?: number;
  /**
   * [{"bookId":"13137795401042201","chapterId":"35823100851447872","bookName":"Webnovel TestComic0301","authorName":"Webnov1","bookType":100,"categoryName":"Transmigration","hasChapterCover":1,"BUT":"1553497865000"}]
   */
  comicListItems?: {
    /**
     * "13137795401042201"
     */
    bookId?: string;
    /**
     * "35823100851447872"
     */
    chapterId?: string;
    /**
     * "Webnovel TestComic0301"
     */
    bookName?: string;
    /**
     * "Webnov1"
     */
    authorName?: string;
    /**
     * 100
     */
    bookType?: number;
    /**
     * "Transmigration"
     */
    categoryName?: string;
    /**
     * 1
     */
    hasChapterCover?: number;
    /**
     * "1553497865000"
     */
    BUT?: string;
  }[];
}

/**
 * 接口 [get-calendar漫画日历↗](https://yapi.yuewen.com/project/2309/interface/api/179033) 的 **请求配置的类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-calendar`
 * @更新时间 `2020-12-17 17:22:07`
 */
type GoPcmComicGetCalendarRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/get-calendar",
    "data",
    string,
    "date" | "pageIndex",
    false
  >
>;

/**
 * 接口 [get-calendar漫画日历↗](https://yapi.yuewen.com/project/2309/interface/api/179033) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-calendar`
 * @更新时间 `2020-12-17 17:22:07`
 */
const goPcmComicGetCalendarRequestConfig: GoPcmComicGetCalendarRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/comic/get-calendar",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: ["date", "pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetCalendar",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-calendar漫画日历↗](https://yapi.yuewen.com/project/2309/interface/api/179033) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-calendar`
 * @更新时间 `2020-12-17 17:22:07`
 */
export const goPcmComicGetCalendar = /*#__PURE__*/ (
  requestData: GoPcmComicGetCalendarRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicGetCalendarResponse>(
    prepare(goPcmComicGetCalendarRequestConfig, requestData),
    ...args
  );
};

goPcmComicGetCalendar.requestConfig = goPcmComicGetCalendarRequestConfig;

/**
 * 接口 [get-date-comic漫画日历全部↗](https://yapi.yuewen.com/project/2309/interface/api/179825) 的 **请求类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-date-comic`
 * @更新时间 `2020-12-17 19:43:50`
 */
export interface GoPcmComicGetDateComicRequest {
  /**
   * string
   */
  dateList: string;
}

/**
 * 接口 [get-date-comic漫画日历全部↗](https://yapi.yuewen.com/project/2309/interface/api/179825) 的 **返回类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-date-comic`
 * @更新时间 `2020-12-17 19:43:50`
 */
export interface GoPcmComicGetDateComicResponse {
  /**
   * [{"date":20201204,"comicListItems":[{"categoryId":60012,"categoryName":"Transmigration","bookId":"11558338301012801","bookName":"Webnovel TestComic0301","authorName":"Webnov1","bookType":100,"coverUpdateTime":"0"}]},{"date":20201205,"comicListItems":[{"categoryId":60012,"categoryName":"Transmigration","bookId":"12637189201038001","bookName":"Webnovel TestComic0301","authorName":"Webnov1","bookType":100,"coverUpdateTime":"0"}]},{"date":20201206,"comicListItems":[{"categoryId":60012,"categoryName":"Transmigration","bookId":"12472322401037301","bookName":"Webnovel TestComic0301","authorName":"Webnov1","bookType":100,"coverUpdateTime":"0"}]},{"date":20201207,"comicListItems":[{"categoryId":60012,"categoryName":"Transmigration","bookId":"12144230606989301","bookName":"Webnovel TestComic0301","authorName":"Webnov1","bookType":100,"coverUpdateTime":"0"}]},{"date":20201208,"comicListItems":[{"categoryId":60012,"categoryName":"Transmigration","bookId":"12144230606989301","bookName":"Webnovel TestComic0301","authorName":"Webnov1","bookType":100,"coverUpdateTime":"0"}]},{"date":20201209,"comicListItems":[{"categoryId":60012,"categoryName":"Transmigration","bookId":"11558338301012801","bookName":"Webnovel TestComic0301","authorName":"Webnov1","bookType":100,"coverUpdateTime":"0"}]},{"date":20201210,"comicListItems":[{"categoryId":60012,"categoryName":"Transmigration","bookId":"11558338301012801","bookName":"Webnovel TestComic0301","authorName":"Webnov1","bookType":100,"coverUpdateTime":"0"}]}]
   */
  items?: {
    /**
     * 20201204
     */
    date?: number;
    /**
     * [{"categoryId":60012,"categoryName":"Transmigration","bookId":"11558338301012801","bookName":"Webnovel TestComic0301","authorName":"Webnov1","bookType":100,"coverUpdateTime":"0"}]
     */
    comicListItems?: {
      /**
       * 60012
       */
      categoryId?: number;
      /**
       * "Transmigration"
       */
      categoryName?: string;
      /**
       * "11558338301012801"
       */
      bookId?: string;
      /**
       * "Webnovel TestComic0301"
       */
      bookName?: string;
      /**
       * "Webnov1"
       */
      authorName?: string;
      /**
       * 100
       */
      bookType?: number;
      /**
       * "0"
       */
      coverUpdateTime?: string;
    }[];
  }[];
}

/**
 * 接口 [get-date-comic漫画日历全部↗](https://yapi.yuewen.com/project/2309/interface/api/179825) 的 **请求配置的类型**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-date-comic`
 * @更新时间 `2020-12-17 19:43:50`
 */
type GoPcmComicGetDateComicRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/comic/get-date-comic",
    "data",
    string,
    "dateList",
    false
  >
>;

/**
 * 接口 [get-date-comic漫画日历全部↗](https://yapi.yuewen.com/project/2309/interface/api/179825) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-date-comic`
 * @更新时间 `2020-12-17 19:43:50`
 */
const goPcmComicGetDateComicRequestConfig: GoPcmComicGetDateComicRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/comic/get-date-comic",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: ["dateList"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetDateComic",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-date-comic漫画日历全部↗](https://yapi.yuewen.com/project/2309/interface/api/179825) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-date-comic`
 * @更新时间 `2020-12-17 19:43:50`
 */
export const goPcmComicGetDateComic = /*#__PURE__*/ (
  requestData: GoPcmComicGetDateComicRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmComicGetDateComicResponse>(
    prepare(goPcmComicGetDateComicRequestConfig, requestData),
    ...args
  );
};

goPcmComicGetDateComic.requestConfig = goPcmComicGetDateComicRequestConfig;

const mockUrl_0_0_0_20 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_20 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_20 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_20 = "data" as any;

/**
 * 接口 [获取用户信息接口PC↗](https://yapi.yuewen.com/project/2309/interface/api/177874) 的 **请求类型**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getUserInfo`
 * @更新时间 `2021-04-02 15:47:24`
 */
export interface GoPcmLoginGetUserInfoRequest {}

/**
 * 接口 [获取用户信息接口PC↗](https://yapi.yuewen.com/project/2309/interface/api/177874) 的 **返回类型**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getUserInfo`
 * @更新时间 `2021-04-02 15:47:24`
 */
export interface GoPcmLoginGetUserInfoResponse {
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300001087/1/1.jpg?mt=0"
     */
    avatar?: string;
    /**
     * "4300001087"
     */
    nickName?: string;
    /**
     * "4300001087"
     */
    userName?: string;
    /**
     * "4300001087"
     */
    authorName?: string;
    /**
     * "4300001087"
     */
    penName?: string;
    /**
     * 4300001087
     */
    guid?: number;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * 2
     */
    gender?: number;
    /**
     * 243
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    /**
     * 100
     */
    bSS?: number;
    /**
     * 1608825600000
     */
    expiringTime?: number;
    /**
     * 7
     */
    grade?: number;
    /**
     * 3
     */
    ES?: number;
    /**
     * 3
     */
    totalES?: number;
    /**
     * 3
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * "2035788724@qq.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: number;
    UUT?: number;
    /**
     * 6
     */
    fastPass?: number;
    /**
     * true
     */
    membershipIsFree?: boolean;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 1
     */
    membershipStatus?: number;
    /**
     * 1606910146000
     */
    membershipExpireTime?: number;
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [获取用户信息接口PC↗](https://yapi.yuewen.com/project/2309/interface/api/177874) 的 **请求配置的类型**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getUserInfo`
 * @更新时间 `2021-04-02 15:47:24`
 */
type GoPcmLoginGetUserInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/login/getUserInfo",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取用户信息接口PC↗](https://yapi.yuewen.com/project/2309/interface/api/177874) 的 **请求配置**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getUserInfo`
 * @更新时间 `2021-04-02 15:47:24`
 */
const goPcmLoginGetUserInfoRequestConfig: GoPcmLoginGetUserInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_20,
    devUrl: devUrl_0_0_0_20,
    prodUrl: prodUrl_0_0_0_20,
    path: "/go/pcm/login/getUserInfo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLoginGetUserInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取用户信息接口PC↗](https://yapi.yuewen.com/project/2309/interface/api/177874) 的 **请求函数**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getUserInfo`
 * @更新时间 `2021-04-02 15:47:24`
 */
export const goPcmLoginGetUserInfo = /*#__PURE__*/ (
  requestData?: GoPcmLoginGetUserInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmLoginGetUserInfoResponse>(
    prepare(goPcmLoginGetUserInfoRequestConfig, requestData),
    ...args
  );
};

goPcmLoginGetUserInfo.requestConfig = goPcmLoginGetUserInfoRequestConfig;

/**
 * 接口 [登录接口↗](https://yapi.yuewen.com/project/2309/interface/api/181723) 的 **请求类型**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/login`
 * @更新时间 `2020-12-23 19:50:33`
 */
export interface GoPcmLoginLoginRequest {}

/**
 * 接口 [登录接口↗](https://yapi.yuewen.com/project/2309/interface/api/181723) 的 **返回类型**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/login`
 * @更新时间 `2020-12-23 19:50:33`
 */
export interface GoPcmLoginLoginResponse {}

/**
 * 接口 [登录接口↗](https://yapi.yuewen.com/project/2309/interface/api/181723) 的 **请求配置的类型**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/login`
 * @更新时间 `2020-12-23 19:50:33`
 */
type GoPcmLoginLoginRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/login/login",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [登录接口↗](https://yapi.yuewen.com/project/2309/interface/api/181723) 的 **请求配置**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/login`
 * @更新时间 `2020-12-23 19:50:33`
 */
const goPcmLoginLoginRequestConfig: GoPcmLoginLoginRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_20,
    devUrl: devUrl_0_0_0_20,
    prodUrl: prodUrl_0_0_0_20,
    path: "/go/pcm/login/login",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLoginLogin",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [登录接口↗](https://yapi.yuewen.com/project/2309/interface/api/181723) 的 **请求函数**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/login`
 * @更新时间 `2020-12-23 19:50:33`
 */
export const goPcmLoginLogin = /*#__PURE__*/ (
  requestData?: GoPcmLoginLoginRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmLoginLoginResponse>(
    prepare(goPcmLoginLoginRequestConfig, requestData),
    ...args
  );
};

goPcmLoginLogin.requestConfig = goPcmLoginLoginRequestConfig;

/**
 * 接口 [获取第三方信息↗](https://yapi.yuewen.com/project/2309/interface/api/181728) 的 **请求类型**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getThirdPartyInfo`
 * @更新时间 `2020-12-24 17:20:26`
 */
export interface GoPcmLoginGetThirdPartyInfoRequest {}

/**
 * 接口 [获取第三方信息↗](https://yapi.yuewen.com/project/2309/interface/api/181728) 的 **返回类型**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getThirdPartyInfo`
 * @更新时间 `2020-12-24 17:20:26`
 */
export interface GoPcmLoginGetThirdPartyInfoResponse {}

/**
 * 接口 [获取第三方信息↗](https://yapi.yuewen.com/project/2309/interface/api/181728) 的 **请求配置的类型**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getThirdPartyInfo`
 * @更新时间 `2020-12-24 17:20:26`
 */
type GoPcmLoginGetThirdPartyInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/login/getThirdPartyInfo",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取第三方信息↗](https://yapi.yuewen.com/project/2309/interface/api/181728) 的 **请求配置**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getThirdPartyInfo`
 * @更新时间 `2020-12-24 17:20:26`
 */
const goPcmLoginGetThirdPartyInfoRequestConfig: GoPcmLoginGetThirdPartyInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_20,
    devUrl: devUrl_0_0_0_20,
    prodUrl: prodUrl_0_0_0_20,
    path: "/go/pcm/login/getThirdPartyInfo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLoginGetThirdPartyInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取第三方信息↗](https://yapi.yuewen.com/project/2309/interface/api/181728) 的 **请求函数**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getThirdPartyInfo`
 * @更新时间 `2020-12-24 17:20:26`
 */
export const goPcmLoginGetThirdPartyInfo = /*#__PURE__*/ (
  requestData?: GoPcmLoginGetThirdPartyInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmLoginGetThirdPartyInfoResponse>(
    prepare(goPcmLoginGetThirdPartyInfoRequestConfig, requestData),
    ...args
  );
};

goPcmLoginGetThirdPartyInfo.requestConfig =
  goPcmLoginGetThirdPartyInfoRequestConfig;

/**
 * 接口 [激活用户名↗](https://yapi.yuewen.com/project/2309/interface/api/181733) 的 **请求类型**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `POST /go/pcm/login/checkAndActivate`
 * @更新时间 `2020-12-24 17:12:38`
 */
export interface GoPcmLoginCheckAndActivateRequest {
  userName: string;
}

/**
 * 接口 [激活用户名↗](https://yapi.yuewen.com/project/2309/interface/api/181733) 的 **返回类型**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `POST /go/pcm/login/checkAndActivate`
 * @更新时间 `2020-12-24 17:12:38`
 */
export interface GoPcmLoginCheckAndActivateResponse {}

/**
 * 接口 [激活用户名↗](https://yapi.yuewen.com/project/2309/interface/api/181733) 的 **请求配置的类型**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `POST /go/pcm/login/checkAndActivate`
 * @更新时间 `2020-12-24 17:12:38`
 */
type GoPcmLoginCheckAndActivateRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/login/checkAndActivate",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [激活用户名↗](https://yapi.yuewen.com/project/2309/interface/api/181733) 的 **请求配置**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `POST /go/pcm/login/checkAndActivate`
 * @更新时间 `2020-12-24 17:12:38`
 */
const goPcmLoginCheckAndActivateRequestConfig: GoPcmLoginCheckAndActivateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_20,
    devUrl: devUrl_0_0_0_20,
    prodUrl: prodUrl_0_0_0_20,
    path: "/go/pcm/login/checkAndActivate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLoginCheckAndActivate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [激活用户名↗](https://yapi.yuewen.com/project/2309/interface/api/181733) 的 **请求函数**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `POST /go/pcm/login/checkAndActivate`
 * @更新时间 `2020-12-24 17:12:38`
 */
export const goPcmLoginCheckAndActivate = /*#__PURE__*/ (
  requestData: GoPcmLoginCheckAndActivateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmLoginCheckAndActivateResponse>(
    prepare(goPcmLoginCheckAndActivateRequestConfig, requestData),
    ...args
  );
};

goPcmLoginCheckAndActivate.requestConfig =
  goPcmLoginCheckAndActivateRequestConfig;

const mockUrl_0_0_0_21 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_21 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_21 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_21 = "data" as any;

/**
 * 接口 [加入书架↗](https://yapi.yuewen.com/project/2309/interface/api/181747) 的 **请求类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/addLibraryItemsAjax`
 * @更新时间 `2020-12-30 14:04:45`
 */
export interface GoPcmLibraryAddLibraryItemsAjaxRequest {
  bookIds: string;
  /**
   * 0书，100漫画
   */
  novelType: string;
}

/**
 * 接口 [加入书架↗](https://yapi.yuewen.com/project/2309/interface/api/181747) 的 **返回类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/addLibraryItemsAjax`
 * @更新时间 `2020-12-30 14:04:45`
 */
export interface GoPcmLibraryAddLibraryItemsAjaxResponse {}

/**
 * 接口 [加入书架↗](https://yapi.yuewen.com/project/2309/interface/api/181747) 的 **请求配置的类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/addLibraryItemsAjax`
 * @更新时间 `2020-12-30 14:04:45`
 */
type GoPcmLibraryAddLibraryItemsAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/library/addLibraryItemsAjax",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [加入书架↗](https://yapi.yuewen.com/project/2309/interface/api/181747) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/addLibraryItemsAjax`
 * @更新时间 `2020-12-30 14:04:45`
 */
const goPcmLibraryAddLibraryItemsAjaxRequestConfig: GoPcmLibraryAddLibraryItemsAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/addLibraryItemsAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibraryAddLibraryItemsAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [加入书架↗](https://yapi.yuewen.com/project/2309/interface/api/181747) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/addLibraryItemsAjax`
 * @更新时间 `2020-12-30 14:04:45`
 */
export const goPcmLibraryAddLibraryItemsAjax = /*#__PURE__*/ (
  requestData: GoPcmLibraryAddLibraryItemsAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmLibraryAddLibraryItemsAjaxResponse>(
    prepare(goPcmLibraryAddLibraryItemsAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmLibraryAddLibraryItemsAjax.requestConfig =
  goPcmLibraryAddLibraryItemsAjaxRequestConfig;

/**
 * 接口 [check是否在书架内↗](https://yapi.yuewen.com/project/2309/interface/api/181751) 的 **请求类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/checkInLibraryAjax`
 * @更新时间 `2020-12-30 14:00:50`
 */
export interface GoPcmLibraryCheckInLibraryAjaxRequest {
  bookId: string;
}

/**
 * 接口 [check是否在书架内↗](https://yapi.yuewen.com/project/2309/interface/api/181751) 的 **返回类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/checkInLibraryAjax`
 * @更新时间 `2020-12-30 14:00:50`
 */
export interface GoPcmLibraryCheckInLibraryAjaxResponse {}

/**
 * 接口 [check是否在书架内↗](https://yapi.yuewen.com/project/2309/interface/api/181751) 的 **请求配置的类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/checkInLibraryAjax`
 * @更新时间 `2020-12-30 14:00:50`
 */
type GoPcmLibraryCheckInLibraryAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/library/checkInLibraryAjax",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [check是否在书架内↗](https://yapi.yuewen.com/project/2309/interface/api/181751) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/checkInLibraryAjax`
 * @更新时间 `2020-12-30 14:00:50`
 */
const goPcmLibraryCheckInLibraryAjaxRequestConfig: GoPcmLibraryCheckInLibraryAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/checkInLibraryAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibraryCheckInLibraryAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [check是否在书架内↗](https://yapi.yuewen.com/project/2309/interface/api/181751) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/checkInLibraryAjax`
 * @更新时间 `2020-12-30 14:00:50`
 */
export const goPcmLibraryCheckInLibraryAjax = /*#__PURE__*/ (
  requestData: GoPcmLibraryCheckInLibraryAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmLibraryCheckInLibraryAjaxResponse>(
    prepare(goPcmLibraryCheckInLibraryAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmLibraryCheckInLibraryAjax.requestConfig =
  goPcmLibraryCheckInLibraryAjaxRequestConfig;

/**
 * 接口 [删除书架页书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181756) 的 **请求类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/deleteLibraryItemsAjax`
 * @更新时间 `2020-12-30 15:08:01`
 */
export interface GoPcmLibraryDeleteLibraryItemsAjaxRequest {
  /**
   * json字符串
   */
  bookItems?: string;
}

/**
 * 接口 [删除书架页书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181756) 的 **返回类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/deleteLibraryItemsAjax`
 * @更新时间 `2020-12-30 15:08:01`
 */
export interface GoPcmLibraryDeleteLibraryItemsAjaxResponse {}

/**
 * 接口 [删除书架页书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181756) 的 **请求配置的类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/deleteLibraryItemsAjax`
 * @更新时间 `2020-12-30 15:08:01`
 */
type GoPcmLibraryDeleteLibraryItemsAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/library/deleteLibraryItemsAjax",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [删除书架页书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181756) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/deleteLibraryItemsAjax`
 * @更新时间 `2020-12-30 15:08:01`
 */
const goPcmLibraryDeleteLibraryItemsAjaxRequestConfig: GoPcmLibraryDeleteLibraryItemsAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/deleteLibraryItemsAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibraryDeleteLibraryItemsAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [删除书架页书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181756) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/deleteLibraryItemsAjax`
 * @更新时间 `2020-12-30 15:08:01`
 */
export const goPcmLibraryDeleteLibraryItemsAjax = /*#__PURE__*/ (
  requestData: GoPcmLibraryDeleteLibraryItemsAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmLibraryDeleteLibraryItemsAjaxResponse>(
    prepare(goPcmLibraryDeleteLibraryItemsAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmLibraryDeleteLibraryItemsAjax.requestConfig =
  goPcmLibraryDeleteLibraryItemsAjaxRequestConfig;

/**
 * 接口 [获取阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181760) 的 **请求类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/getReadingProgress`
 * @更新时间 `2020-12-30 14:57:16`
 */
export interface GoPcmLibraryGetReadingProgressRequest {
  bookId: string;
  /**
   * 默认不传是0，传100是漫画
   */
  novelType: string;
}

/**
 * 接口 [获取阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181760) 的 **返回类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/getReadingProgress`
 * @更新时间 `2020-12-30 14:57:16`
 */
export interface GoPcmLibraryGetReadingProgressResponse {}

/**
 * 接口 [获取阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181760) 的 **请求配置的类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/getReadingProgress`
 * @更新时间 `2020-12-30 14:57:16`
 */
type GoPcmLibraryGetReadingProgressRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/library/getReadingProgress",
    "data",
    string,
    "bookId" | "novelType",
    false
  >
>;

/**
 * 接口 [获取阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181760) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/getReadingProgress`
 * @更新时间 `2020-12-30 14:57:16`
 */
const goPcmLibraryGetReadingProgressRequestConfig: GoPcmLibraryGetReadingProgressRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/getReadingProgress",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: ["bookId", "novelType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibraryGetReadingProgress",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181760) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/getReadingProgress`
 * @更新时间 `2020-12-30 14:57:16`
 */
export const goPcmLibraryGetReadingProgress = /*#__PURE__*/ (
  requestData: GoPcmLibraryGetReadingProgressRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmLibraryGetReadingProgressResponse>(
    prepare(goPcmLibraryGetReadingProgressRequestConfig, requestData),
    ...args
  );
};

goPcmLibraryGetReadingProgress.requestConfig =
  goPcmLibraryGetReadingProgressRequestConfig;

/**
 * 接口 [书架页↗](https://yapi.yuewen.com/project/2309/interface/api/181765) 的 **请求类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/library`
 * @更新时间 `2022-05-11 10:32:44`
 */
export interface GoPcmLibraryLibraryRequest {
  pageIndex?: string;
  pageSize?: string;
  orderBy: string;
  /**
   * 默认1
   */
  encryptType?: string;
}

/**
 * 接口 [书架页↗](https://yapi.yuewen.com/project/2309/interface/api/181765) 的 **返回类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/library`
 * @更新时间 `2022-05-11 10:32:44`
 */
export interface GoPcmLibraryLibraryResponse {
  /**
   * [0,1]
   */
  encryptType?: number[];
  /**
   * "@string"
   */
  encryptKeyPool?: string;
  encryptVersion?: number;
  content?: {
    /**
     * 1
     */
    chapterId?: number;
    /**
     * 1
     */
    orderBy?: number;
    /**
     * [{"bookId":"16707586601025901","bookName":"webnovel  comic test 0417","comicName":"webnovel  comic test 0417","coverUpdateTime":1587378657168,"newChapterId":"44917833150298907","newChapterIndex":0,"novelType":100,"readToChapterId":-1,"readToChapterIndex":-1,"updateStatus":1},{"bookId":"17640755401060801","bookName":"test3 20200814 1","comicName":"test3 20200814 1","coverUpdateTime":1596449452425,"newChapterId":"47396684799463552","newChapterIndex":0,"novelType":100,"readToChapterId":-1,"readToChapterIndex":-1,"updateStatus":1},{"bookId":"12472322401037301","bookName":"Webnovel TestComic1214","comicName":"Webnovel TestComic1214","coverUpdateTime":0,"newChapterId":"43938268953237078","newChapterIndex":0,"novelType":100,"readToChapterId":-1,"readToChapterIndex":-1,"updateStatus":1},{"bookId":"13041960401040401","bookName":"Webnovel Test021802","comicName":"Webnovel Test021802","coverUpdateTime":0,"newChapterId":"35009312728335963","newChapterIndex":0,"novelType":100,"readToChapterId":-1,"readToChapterIndex":-1,"updateStatus":1},{"bookId":"11679942001018505","bookName":"New book","coverUpdateTime":1581421906182,"newChapterId":"50546592876383648","newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":3,"updateStatus":1},{"bookId":"14477536501070305","bookName":"webnovel fanfic1","coverUpdateTime":1609145953346,"newChapterId":"47886537899163704","newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":11,"updateStatus":1},{"bookId":"14043956001056905","bookName":"Webnovel test 0614","coverUpdateTime":1581421908885,"newChapterId":"37705304233794743","newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":5,"updateStatus":1},{"bookId":"11538023301012001","bookName":"sync Comic 0828","comicName":"sync Comic 0828","coverUpdateTime":0,"newChapterId":"50552068154385378","newChapterIndex":0,"novelType":100,"readToChapterId":-1,"readToChapterIndex":-1,"updateStatus":1},{"bookId":"11712262601019101","bookName":"webnonel test0917","comicName":"webnonel test0917","coverUpdateTime":0,"newChapterId":"50552312162217718","newChapterIndex":0,"novelType":100,"readToChapterId":-1,"readToChapterIndex":-1,"updateStatus":1},{"bookId":"11651593101013805","bookName":"Webnovel test0910","coverUpdateTime":0,"newChapterId":"31370787696997191","newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":2,"updateStatus":1},{"bookId":"12318721801033605","bookName":"Webnovel Test0110","coverUpdateTime":1581421908721,"newChapterId":"34108247380120782","newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":3,"updateStatus":1},{"bookId":"11470906201009905","bookName":"asdfasdffl;klasdjlasdfdsf","coverUpdateTime":1581421925685,"newChapterId":"50530769679995341","newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":14,"updateStatus":1},{"bookId":"14391628101068105","bookName":"FicoolTest072405","coverUpdateTime":1581421909021,"newChapterId":"50509550125639752","newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":5,"updateStatus":1},{"bookId":"11540953701012201","bookName":"Chapter Comic 0828","comicName":"Chapter Comic 0828","coverUpdateTime":0,"newChapterId":"50552591066659664","newChapterIndex":0,"novelType":100,"readToChapterId":-1,"readToChapterIndex":-1,"updateStatus":1},{"bookId":"13492754501047405","bookName":"Clementine1104 02","coverUpdateTime":1581421908678,"newChapterId":0,"newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":0,"updateStatus":1},{"bookId":"11670122501015805","bookName":"webnovel test0912","coverUpdateTime":0,"newChapterId":"50548546818068970","newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":8,"updateStatus":1},{"bookId":"14839998001127501","bookName":"webnovel comic 091401","comicName":"webnovel comic 091401","coverUpdateTime":1594881056433,"newChapterId":"39836321514052677","newChapterIndex":0,"novelType":100,"readToChapterId":-1,"readToChapterIndex":-1,"updateStatus":1},{"bookId":"12159987901027101","bookName":"Webnovel Testmanhua1108","comicName":"Webnovel Testmanhua1108","coverUpdateTime":0,"newChapterId":0,"newChapterIndex":0,"novelType":100,"readToChapterId":-1,"readToChapterIndex":-1,"updateStatus":1},{"bookId":"12566524601037405","bookName":"gghdhjrh","coverUpdateTime":1581421906110,"newChapterId":"33733010314554575","newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":1,"updateStatus":1},{"bookId":"11987368201024205","bookName":"webnovel test101902","coverUpdateTime":0,"newChapterId":0,"newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":0,"updateStatus":1},{"bookId":"11558338301012801","bookName":"Xiuzhen","comicName":"Xiuzhen","coverUpdateTime":0,"newChapterId":"50431560230434601","newChapterIndex":0,"novelType":100,"readToChapterId":-1,"readToChapterIndex":-1,"updateStatus":1},{"bookId":"6820995801004405","bookName":"Library of Heaven's Path","coverUpdateTime":0,"newChapterId":"20844369401957968","newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":160,"updateStatus":1},{"bookId":"7366916601012405","bookName":"The King's Avatar","coverUpdateTime":1581418734974,"newChapterId":"45727419184774513","newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":682,"updateStatus":1},{"bookId":"6831119801008605","bookName":"Gourmet of Another World","coverUpdateTime":0,"newChapterId":"20844376114269771","newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":57,"updateStatus":1},{"bookId":"16195153001005505","bookName":"yttt111","coverUpdateTime":1596004850447,"newChapterId":"48066812708974155","newChapterIndex":0,"novelType":0,"readToChapterId":-1,"readToChapterIndex":-1,"totalChapterNum":108,"updateStatus":1},{"bookId":"13137795401042201","bookName":"Webnovel TestComic0301","comicName":"Webnovel TestComic0301","coverUpdateTime":0,"newChapterId":"44850094268275796","newChapterIndex":0,"novelType":100,"readToChapterId":-1,"readToChapterIndex":-1,"updateStatus":1}]
     */
    items?: {
      /**
       * "16707586601025901"
       */
      bookId?: string;
      /**
       * "webnovel  comic test 0417"
       */
      bookName?: string;
      /**
       * "webnovel  comic test 0417"
       */
      comicName?: string;
      /**
       * 1587378657168
       */
      coverUpdateTime?: number;
      /**
       * "44917833150298907"
       */
      newChapterId?: string;
      newChapterIndex?: number;
      /**
       * 100
       */
      novelType?: number;
      /**
       * -1
       */
      readToChapterId?: number;
      /**
       * -1
       */
      readToChapterIndex?: number;
      /**
       * 1
       */
      updateStatus?: number;
    }[];
    user?: {
      /**
       * "//userimg.webnovel.com/userheadimg/4319766025/1/1.jpg?mt=0"
       */
      avatar?: string;
      /**
       * "DaoistbbHAXE"
       */
      nickName?: string;
      /**
       * "DaoistbbHAXE"
       */
      userName?: string;
      /**
       * "DaoistbbHAXE"
       */
      authorName?: string;
      /**
       * "DaoistbbHAXE"
       */
      penName?: string;
      /**
       * 4319766025
       */
      guid?: number;
      status?: number;
      /**
       * 4
       */
      role?: number;
      gender?: number;
      SS?: number;
      vSS?: number;
      vbSS?: number;
      bSS?: number;
      expiringTime?: number;
      /**
       * 1
       */
      grade?: number;
      /**
       * 1
       */
      ES?: number;
      /**
       * 1
       */
      totalES?: number;
      /**
       * 1
       */
      PS?: number;
      /**
       * 1
       */
      totalPS?: number;
      /**
       * "tk111@o0i.es"
       */
      email?: string;
      /**
       * 1
       */
      emailStatus?: number;
      isCheckIn?: number;
      UUT?: number;
      fastPass?: number;
      /**
       * 1
       */
      membershipQua?: number;
      membershipStatus?: number;
      membershipExpireTime?: number;
      membershipClaimStatus?: boolean;
      membershipIsFree?: boolean;
      membershipType?: number;
    };
  };
}

/**
 * 接口 [书架页↗](https://yapi.yuewen.com/project/2309/interface/api/181765) 的 **请求配置的类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/library`
 * @更新时间 `2022-05-11 10:32:44`
 */
type GoPcmLibraryLibraryRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/library/library",
    "data",
    string,
    "pageIndex" | "pageSize" | "orderBy" | "encryptType",
    false
  >
>;

/**
 * 接口 [书架页↗](https://yapi.yuewen.com/project/2309/interface/api/181765) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/library`
 * @更新时间 `2022-05-11 10:32:44`
 */
const goPcmLibraryLibraryRequestConfig: GoPcmLibraryLibraryRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/library",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: ["pageIndex", "pageSize", "orderBy", "encryptType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibraryLibrary",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书架页↗](https://yapi.yuewen.com/project/2309/interface/api/181765) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/library`
 * @更新时间 `2022-05-11 10:32:44`
 */
export const goPcmLibraryLibrary = /*#__PURE__*/ (
  requestData: GoPcmLibraryLibraryRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmLibraryLibraryResponse>(
    prepare(goPcmLibraryLibraryRequestConfig, requestData),
    ...args
  );
};

goPcmLibraryLibrary.requestConfig = goPcmLibraryLibraryRequestConfig;

/**
 * 接口 [设置阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181774) 的 **请求类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setReadingProgressAjax`
 * @更新时间 `2024-06-11 16:44:11`
 */
export interface GoPcmLibrarySetReadingProgressAjaxRequest {
  bookId: string;
  chapterId: string;
}

/**
 * 接口 [设置阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181774) 的 **返回类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setReadingProgressAjax`
 * @更新时间 `2024-06-11 16:44:11`
 */
export interface GoPcmLibrarySetReadingProgressAjaxResponse {}

/**
 * 接口 [设置阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181774) 的 **请求配置的类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setReadingProgressAjax`
 * @更新时间 `2024-06-11 16:44:11`
 */
type GoPcmLibrarySetReadingProgressAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/library/setReadingProgressAjax",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [设置阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181774) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setReadingProgressAjax`
 * @更新时间 `2024-06-11 16:44:11`
 */
const goPcmLibrarySetReadingProgressAjaxRequestConfig: GoPcmLibrarySetReadingProgressAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/setReadingProgressAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibrarySetReadingProgressAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [设置阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181774) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setReadingProgressAjax`
 * @更新时间 `2024-06-11 16:44:11`
 */
export const goPcmLibrarySetReadingProgressAjax = /*#__PURE__*/ (
  requestData: GoPcmLibrarySetReadingProgressAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmLibrarySetReadingProgressAjaxResponse>(
    prepare(goPcmLibrarySetReadingProgressAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmLibrarySetReadingProgressAjax.requestConfig =
  goPcmLibrarySetReadingProgressAjaxRequestConfig;

/**
 * 接口 [修改偏好↗](https://yapi.yuewen.com/project/2309/interface/api/181779) 的 **请求类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setUserPreferenceAjax`
 * @更新时间 `2020-12-24 18:04:32`
 */
export interface GoPcmLibrarySetUserPreferenceAjaxRequest {}

/**
 * 接口 [修改偏好↗](https://yapi.yuewen.com/project/2309/interface/api/181779) 的 **返回类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setUserPreferenceAjax`
 * @更新时间 `2020-12-24 18:04:32`
 */
export interface GoPcmLibrarySetUserPreferenceAjaxResponse {}

/**
 * 接口 [修改偏好↗](https://yapi.yuewen.com/project/2309/interface/api/181779) 的 **请求配置的类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setUserPreferenceAjax`
 * @更新时间 `2020-12-24 18:04:32`
 */
type GoPcmLibrarySetUserPreferenceAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/library/setUserPreferenceAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [修改偏好↗](https://yapi.yuewen.com/project/2309/interface/api/181779) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setUserPreferenceAjax`
 * @更新时间 `2020-12-24 18:04:32`
 */
const goPcmLibrarySetUserPreferenceAjaxRequestConfig: GoPcmLibrarySetUserPreferenceAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/setUserPreferenceAjax",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibrarySetUserPreferenceAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [修改偏好↗](https://yapi.yuewen.com/project/2309/interface/api/181779) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setUserPreferenceAjax`
 * @更新时间 `2020-12-24 18:04:32`
 */
export const goPcmLibrarySetUserPreferenceAjax = /*#__PURE__*/ (
  requestData?: GoPcmLibrarySetUserPreferenceAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmLibrarySetUserPreferenceAjaxResponse>(
    prepare(goPcmLibrarySetUserPreferenceAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmLibrarySetUserPreferenceAjax.requestConfig =
  goPcmLibrarySetUserPreferenceAjaxRequestConfig;

/**
 * 接口 [test↗](https://yapi.yuewen.com/project/2309/interface/api/277617) 的 **请求类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/`
 * @更新时间 `2023-12-04 11:06:38`
 */
export interface GoPcmRequest {}

/**
 * 接口 [test↗](https://yapi.yuewen.com/project/2309/interface/api/277617) 的 **返回类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/`
 * @更新时间 `2023-12-04 11:06:38`
 */
export interface GoPcmResponse {}

/**
 * 接口 [test↗](https://yapi.yuewen.com/project/2309/interface/api/277617) 的 **请求配置的类型**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/`
 * @更新时间 `2023-12-04 11:06:38`
 */
type GoPcmRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [test↗](https://yapi.yuewen.com/project/2309/interface/api/277617) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/`
 * @更新时间 `2023-12-04 11:06:38`
 */
const goPcmRequestConfig: GoPcmRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_21,
  devUrl: devUrl_0_0_0_21,
  prodUrl: prodUrl_0_0_0_21,
  path: "/go/pcm/",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_21,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "goPcm",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [test↗](https://yapi.yuewen.com/project/2309/interface/api/277617) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/`
 * @更新时间 `2023-12-04 11:06:38`
 */
export const goPcm = /*#__PURE__*/ (
  requestData?: GoPcmRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmResponse>(
    prepare(goPcmRequestConfig, requestData),
    ...args
  );
};

goPcm.requestConfig = goPcmRequestConfig;

const mockUrl_0_0_0_22 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_22 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_22 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_22 = "data" as any;

/**
 * 接口 [获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/181864) 的 **请求类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/page`
 * @更新时间 `2024-04-26 15:04:03`
 */
export interface GoPcmPcbookcityPageRequest {
  /**
   * 性别 1男,2女
   */
  sex: string;
  /**
   * 1 M站，2 PC站
   */
  bookCityType: string;
  language: string;
  country: string;
}

/**
 * 接口 [获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/181864) 的 **返回类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/page`
 * @更新时间 `2024-04-26 15:04:03`
 */
export interface GoPcmPcbookcityPageResponse {
  /**
   * "5fffe5a1af867252d05d690f"
   */
  pageId?: string;
  /**
   * "PC Male Lead"
   */
  bookCityName?: string;
  /**
   * []
   */
  blockItems?: unknown[];
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4320878650/1/1.jpg?mt=1660701747297"
     */
    avatar?: string;
    /**
     * "111eprere"
     */
    nickName?: string;
    /**
     * "111eprere"
     */
    userName?: string;
    /**
     * "111eprere"
     */
    authorName?: string;
    /**
     * "111eprere"
     */
    penName?: string;
    /**
     * 4320878650
     */
    guid?: number;
    status?: number;
    /**
     * 4
     */
    role?: number;
    gender?: number;
    /**
     * 452
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    /**
     * 452
     */
    bSS?: number;
    /**
     * 1695052800000
     */
    expiringTime?: number;
    /**
     * 1
     */
    grade?: number;
    /**
     * 1
     */
    ES?: number;
    /**
     * 1
     */
    totalES?: number;
    /**
     * 1
     */
    PS?: number;
    /**
     * 1
     */
    totalPS?: number;
    /**
     * "a**@email.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: number;
    /**
     * 1660701747297
     */
    UUT?: number;
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 2
     */
    membershipStatus?: number;
    /**
     * 1661049257000
     */
    membershipExpireTime?: number;
    /**
     * true
     */
    membershipClaimStatus?: boolean;
    membershipIsFree?: boolean;
    membershipType?: number;
  };
}

/**
 * 接口 [获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/181864) 的 **请求配置的类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/page`
 * @更新时间 `2024-04-26 15:04:03`
 */
type GoPcmPcbookcityPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/pcbookcity/page",
    "data",
    string,
    "sex" | "bookCityType" | "language" | "country",
    false
  >
>;

/**
 * 接口 [获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/181864) 的 **请求配置**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/page`
 * @更新时间 `2024-04-26 15:04:03`
 */
const goPcmPcbookcityPageRequestConfig: GoPcmPcbookcityPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_22,
    devUrl: devUrl_0_0_0_22,
    prodUrl: prodUrl_0_0_0_22,
    path: "/go/pcm/pcbookcity/page",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_22,
    paramNames: [],
    queryNames: ["sex", "bookCityType", "language", "country"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPcbookcityPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/181864) 的 **请求函数**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/page`
 * @更新时间 `2024-04-26 15:04:03`
 */
export const goPcmPcbookcityPage = /*#__PURE__*/ (
  requestData: GoPcmPcbookcityPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPcbookcityPageResponse>(
    prepare(goPcmPcbookcityPageRequestConfig, requestData),
    ...args
  );
};

goPcmPcbookcityPage.requestConfig = goPcmPcbookcityPageRequestConfig;

/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/181868) 的 **请求类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-change`
 * @更新时间 `2020-12-25 17:20:18`
 */
export interface GoPcmPcbookcityGetChangeRequest {
  /**
   * 书城block Id
   */
  pblockId: string;
  /**
   * 子blockId
   */
  blockId: string;
  index: string;
}

/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/181868) 的 **返回类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-change`
 * @更新时间 `2020-12-25 17:20:18`
 */
export interface GoPcmPcbookcityGetChangeResponse {
  blockItem?: {
    /**
     * "${query.blockId}"
     */
    id?: string;
    /**
     * "@title"
     */
    title?: string;
    /**
     * "@title"
     */
    subTitle?: string;
    /**
     * 2004
     */
    type?: number;
    /**
     * 1
     */
    background?: number;
    /**
     * true
     */
    changeable?: boolean;
    /**
     * [{"bookType":100,"id":1,"name":"@title","categoryName":"@title"}]
     */
    contentItems?: {
      /**
       * 100
       */
      bookType?: number;
      /**
       * 1
       */
      id?: number;
      /**
       * "@title"
       */
      name?: string;
      /**
       * "@title"
       */
      categoryName?: string;
    }[];
  };
}

/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/181868) 的 **请求配置的类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-change`
 * @更新时间 `2020-12-25 17:20:18`
 */
type GoPcmPcbookcityGetChangeRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/pcbookcity/get-change",
    "data",
    string,
    "pblockId" | "blockId" | "index",
    false
  >
>;

/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/181868) 的 **请求配置**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-change`
 * @更新时间 `2020-12-25 17:20:18`
 */
const goPcmPcbookcityGetChangeRequestConfig: GoPcmPcbookcityGetChangeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_22,
    devUrl: devUrl_0_0_0_22,
    prodUrl: prodUrl_0_0_0_22,
    path: "/go/pcm/pcbookcity/get-change",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_22,
    paramNames: [],
    queryNames: ["pblockId", "blockId", "index"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPcbookcityGetChange",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/181868) 的 **请求函数**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-change`
 * @更新时间 `2020-12-25 17:20:18`
 */
export const goPcmPcbookcityGetChange = /*#__PURE__*/ (
  requestData: GoPcmPcbookcityGetChangeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPcbookcityGetChangeResponse>(
    prepare(goPcmPcbookcityGetChangeRequestConfig, requestData),
    ...args
  );
};

goPcmPcbookcityGetChange.requestConfig = goPcmPcbookcityGetChangeRequestConfig;

/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181887) 的 **请求类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-feed-list`
 * @更新时间 `2020-12-25 18:39:17`
 */
export interface GoPcmPcbookcityGetFeedListRequest {
  /**
   * 不传返回第一页
   */
  pageIndex?: string;
}

/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181887) 的 **返回类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-feed-list`
 * @更新时间 `2020-12-25 18:39:17`
 */
export interface GoPcmPcbookcityGetFeedListResponse {
  /**
   * [{"bookId":0,"bookType":0,"bookName":"@word","categoryId":0,"categoryName":"@word","authorName":"xxx","tagInfos":[{"id":1,"tagName":"tag","likeCount":0,"like":false}],"bookCoverId":15899331113,"description":"aaa","totalScore":"4.8","pvNum":100,"chapterNum":100,"statParams":"xxx","mTL":true}]
   */
  feedListItems?: {
    bookId?: number;
    bookType?: number;
    /**
     * "@word"
     */
    bookName?: string;
    categoryId?: number;
    /**
     * "@word"
     */
    categoryName?: string;
    /**
     * "xxx"
     */
    authorName?: string;
    /**
     * [{"id":1,"tagName":"tag","likeCount":0,"like":false}]
     */
    tagInfos?: {
      /**
       * 1
       */
      id?: number;
      /**
       * "tag"
       */
      tagName?: string;
      likeCount?: number;
      like?: boolean;
    }[];
    /**
     * 15899331113
     */
    bookCoverId?: number;
    /**
     * "aaa"
     */
    description?: string;
    /**
     * "4.8"
     */
    totalScore?: string;
    /**
     * 100
     */
    pvNum?: number;
    /**
     * 100
     */
    chapterNum?: number;
    /**
     * "xxx"
     */
    statParams?: string;
    /**
     * true
     */
    mTL?: boolean;
  }[];
  /**
   * 2
   */
  pageIndex?: number;
  /**
   * true
   */
  isLast?: boolean;
}

/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181887) 的 **请求配置的类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-feed-list`
 * @更新时间 `2020-12-25 18:39:17`
 */
type GoPcmPcbookcityGetFeedListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/pcbookcity/get-feed-list",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181887) 的 **请求配置**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-feed-list`
 * @更新时间 `2020-12-25 18:39:17`
 */
const goPcmPcbookcityGetFeedListRequestConfig: GoPcmPcbookcityGetFeedListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_22,
    devUrl: devUrl_0_0_0_22,
    prodUrl: prodUrl_0_0_0_22,
    path: "/go/pcm/pcbookcity/get-feed-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_22,
    paramNames: [],
    queryNames: ["pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPcbookcityGetFeedList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181887) 的 **请求函数**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-feed-list`
 * @更新时间 `2020-12-25 18:39:17`
 */
export const goPcmPcbookcityGetFeedList = /*#__PURE__*/ (
  requestData: GoPcmPcbookcityGetFeedListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPcbookcityGetFeedListResponse>(
    prepare(goPcmPcbookcityGetFeedListRequestConfig, requestData),
    ...args
  );
};

goPcmPcbookcityGetFeedList.requestConfig =
  goPcmPcbookcityGetFeedListRequestConfig;

/**
 * 接口 [游戏助手内嵌页推书接口↗](https://yapi.yuewen.com/project/2309/interface/api/216193) 的 **请求类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/gameLoop`
 * @更新时间 `2021-06-22 14:10:32`
 */
export interface GoPcmPcbookcityGameLoopRequest {}

/**
 * 接口 [游戏助手内嵌页推书接口↗](https://yapi.yuewen.com/project/2309/interface/api/216193) 的 **返回类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/gameLoop`
 * @更新时间 `2021-06-22 14:10:32`
 */
export interface GoPcmPcbookcityGameLoopResponse {
  /**
   * [{"bookId":"19705637205984305","bookName":"Almighty Summoner System","categoryName":"Martial Arts","categoryId":70012,"authorName":"Neil_Ads","score":"4.50","description":"Devastated by the harsh truth of being unable to summon a monster in a world full of summoners. Ban trained himself to death in the bid to overturn his fate. \r\n\r\nAs he was training himself to death, death really came to claim his life. \r\n\r\nAt that moment, a sudden light pierced the darkness that envelopes him as a virtual screen materialized in front of his eyes. \r\n\r\nWith a stroke of luck, Ban somehow managed to inherit a System after being denied by its previous owner. \r\n\r\nAnd his first mission was to tame an ant or else, die again?\r\n\r\nWitness as this young man collects and contracts different kinds of monsters with the help of the Almighty Summoner System, becoming the Supreme of the Summoner's World and the worlds beyond it.\r\n\r\n…\r\n\r\nThe art used in the cover is not mine, let me know if you want it removed.","coverUpdateTime":"1621698526133","bookType":0},{"bookId":"19677630405919605","bookName":"OP Parazyte","categoryName":"Sci-fi","categoryId":70006,"authorName":"GamingWolf1","score":"0.00","description":"An alien parasite inside a cat ambushes Hikaru. Unbeknownst to it, he's a psychopath who killed his mother and can reverse-hack the parasitic cells, taking its body and powers for himself. Evolving from absorbing other living organisms, he begins changing as he becomes sensitive to emotions. Ironically, an alien made him more human than ever. Dragged into an ever-growing war between parasites and humans, will Hikaru become the dark hero humanity needs? Or will he fulfill his dream of world domination?\n\nAt the same time, the Master System and its power are in peril as a result of Hikaru's actions. A simple nobody named Elijah reincarnates with the Hero System and is sent back in time to restore order to the universe.\n\nRead between the Dark and light chapters of Parazyte, explore the Naruto and Sasuke type dynamic of the two characters, the vast world-building and in-depth character development with rich side characters (sprinkled with 2D characters for fun). \n\nWarning: Book recommended for 18+. Realistic violence and death is the theme. Hero chapters are sometimes light-hearted but often contain sad realities.\n\nThe world shakes under their overwhelming power. The fate of the world depends on who becomes a God. \n\nReaders from a parallel universe can affect the storyline with their quantum tremors.\n\n","coverUpdateTime":"1616818137415","bookType":0},{"bookId":"6838665402001705","bookName":"Forty Millenniums of Cultivation","categoryName":"Sci-fi","categoryId":70006,"authorName":"The Enlightened Master Crouching Cow","score":"4.50","description":"“Even if this universe is truly nothing more than a brutal, bloody, shadowy forest, we Cultivators will burn all that we have just to give off a single weak flickering spark in the darkness! \r\n“No matter how weak each spark is, how short-lived, how small… As long as the sparks flow unabated, then one day one of those sparks will light some tinder, and that tinder shall light some fallen branches, and those branches shall set ablaze each and every last tree of the forest! \r\n“In the end, even the smallest sparks will eventually set the shadowy forest ablaze and illuminate the whole world!”\r\n------\r\n** Qidian International and the former translator, Mr. Strivon, have reached an agreement to buy out the chapters and host them on our site. We will be continuing the translation from the last chapter translated by Mr. Strivon **","coverUpdateTime":"1547643612771","bookType":0},{"bookId":"18395231006659205","bookName":"I Am A Notorious Hidden Boss In The Alternate World","categoryName":"Magical Realism","categoryId":70001,"authorName":"Pointbreak","score":"4.70","description":"25-year-old Albion lived an unimpressive parasitic life of a NEET and otaku, leeching off his loving parent's allowances to enjoy watching animes, reading manga and novels at home. \n\nWhen faced with the cruel reality of contracting cancer through smoking, he selfishly ran away from home and sacrificed his life on a strange day of drastic changes.\n\n'Since I'm going to die anyway, let me save another life in exchange.' \n\nThose were his thoughts before shoving a person out of harm's way and getting struck by a truck.\n\n'If I could get a second chance, I want to live a fulfilling life and not waste it like this.'\n\nHowever, Albion's new life resolution was quickly challenged by a stroke of divine providence.\n\n\"What? I'm not dead yet? Holy cow, I transmigrated into the body of a notorious hidden boss who controls half the world's wealth in an alternate universe after he failed his heavenly tribulation? I never have to worry about money? I can live forever? Lucky me!\"\n\nAlbion thought he had shot to the peak of life, but he could not be more wrong. The immortal body was too strong for a mortal soul like him to control. He can only move for 5 minutes a day!\n\nHe became immobile and paralyzed for the rest of the time! The Four Horsemen of the Dark Emperor thought he was crippled and turned on him! They couldn't kill him physically due to his invincible body so they dropped him to the bottom of the ocean to drown!\n\nHis body was immortal. He could not die. \n\nThus, he lived the following life in the dark depths of the ocean before being swallowed into the stomach of a giant sea serpent!\n\nBefore he could enjoy his new life, he had sunk to the lowest point of his life, literally!\n\nHowever, the world rapidly changed after the notorious True Immortal disappeared for two years! The Apocalypse arrived, and so too, the System!\n\nDing! \n[You have slain a Lv.1 ancient sea serpent. 100 EXP has been gained.]\n[You have leveled up.]\n[You have become a Lv.2 Hunter.]\n[Title acquired: Hunter.]\n\nAlbion: ???\n\n\"Did the sea serpent get food poisoning and died from eating me or something?\" Albion wondered in the pit of the sea serpent's stomach.\n\n[System calibration complete. Goldfinger has been activated.]\n\n\"Never mind, my time has come! With the system in hand, I will take back everything and rule the w--wait, what? This body's cultivation needs to be sealed in order for me to move freely without impairments?\" \n\n\"Sigh, forget it, ruling the world is too hard. I'm a wanted man anyway. Let's just hide somewhere, watch my animes, and reading my manga and novels...\"\n\nAlbion was nerfed harder than the Big Bang at the beginning of time. However, what's his, will still be his. \n\n\"Until my soul becomes strong enough to fully wield this power, I'll just treat it as a 5-minute Super Saiyan mode I can enjoy once a day...\"\n\nHe was not the Dark Emperor, but the Dark Emperor was now him. The Four Horsemen that turned on him, their day of retribution will come!\n\nLittle did Albion know, the world had more things in store for him than his quest for vengeance. The dimensional rifts that appeared everywhere and the interdimensional creatures that spilled forth from there are actually...!\n\nFind out on the next episode of drag--Ahem, to be continued.\n\n=====Author's Note=====\n\nFeel free to check out my other book, Prime Originator (also my first work). The genre is completely differently, so you may or may not like it and vice versa for readers coming from there :)\n\nYou can join me on discord in the link here;\nhttps://discord.gg/cxpRTCkzH9\n\n=====DISCLAIMER=====\n\nI do not own the cover. The original belongs to its respective owner. Cover was edited by friend and fellow author, Venerable_Linfeng. Check out his novel, Supreme Grandpa!","coverUpdateTime":"1621813966046","bookType":0},{"bookId":"18494912406056805","bookName":"THE GREATEST OF ALL TIME","categoryName":"Competitive Sports","categoryId":70007,"authorName":"Mujunel_the_Mystic","score":"4.72","description":"Dive into a novel about the rise of a legendary sportsman. \nFollow Zachary Bemba on his journey to become the G.O.A.T (Greatest Of All Time) in the soccer world.\n\nHe travels back to a time in his past where opportunity abounds. Access to a system capable of propelling him to greater heights is just the icing on the cake.\n\nFrom a nobody born in one of the poorest and most remote places on the planet, he relentlessly pursues his goal of becoming the greatest sportsman the world has ever seen.\n\n****\n----\nG.O.A.T SYSTEM INITIALIZING\n----\nACTIVATION SUCCESSFUL\n****\n\n\nBook Discord Link: https://discord.gg/NK4Uaw8GRN","coverUpdateTime":"1622712928960","bookType":0},{"bookId":"19906793006921405","bookName":"Project: Helix","categoryName":"Fantasy","categoryId":70002,"authorName":"Magecrafter","score":"4.96","description":"In a world of Magic and Science, Power and Wonder, gods and monsters, the lives of two strangers intertwine, changing them forever.\r\n\r\nOn the quest to create the ultimate human soldiers and weapons to advance their conquest, the United Western Empire embarked on a scientific path, this unit was known as PROJECT H.E.L.I.X. \r\nUsing the rarest, most powerful creatures and materials as a base, the empire created an elite unit of Homunculi (Artificial Humans), enabling it to rise above other nations as the top world power.\r\nHowever, the Project came to an abrupt halt, when two of the Homunculi defected from the unit, escaping the empire.\r\nYears later, in the United Southern Empire, a young lady is rescued from gruesome criminals by a travelling merchant named Noir Novo. \r\nThe young lady is revealed to be daughter of a wealthy noble, who requires an able guard and ally while she studies at the Southern Magic Institute.\r\nRevealed to possess a rare bloodline and a powerful one at that, the girl is prey to countless criminal organizations. Noir accepts to be her guard, and eventually, her tutor, revealing himself to also possess a rare bloodline, enrolling along with her in the Magic Institute.\r\nTrouble looms, as many enemies seek Ciara's rare bloodline, and not only that, Noir's former comrades of the PROJECT H.E.L.I.X, become involved. \r\nRead in this action packed and drama filled novel, as both Noir and Ciara survive as targets, and what becomes of them.\r\n[Bronze prize WPC #172 Male Lead- Rare Blood]","coverUpdateTime":"1624059971816","bookType":0},{"bookId":"19715055805008105","bookName":"The Legendary Pseudo-villain","categoryName":"Sci-fi","categoryId":70006,"authorName":"cherlyswan","score":"5.00","description":"Over-confidence can get you killed or in Hecathe’s case, it can get you transmigrated into a parallel universe that is dying and in the midst of a war. \n\nIt all started with a simple, “Mom! I want to be a villain!”\n \nYears later, Hecathe stood at the top of the economy with his Zuex company squeezing out every last penny from the pockets of the helpless consumers.  \n\nOne day he looked over at his secretary and confidently questioned, “When the country runs on your money, do you really think it matters if I’m driving legally or not?”\n\nThe heaven’s laughed as they heard this. To think that a mere human was this arrogant?! \nThe heavens: “Let’s pull a UNO reverse card on him!” \n\nHecathe’s eyes were glued to his phone as he heard the loud screeching of tires that made him look up and... \n\nHa. Ha. Ha. \n\nThe heavens probably had the last laugh... Or did they?\n \nHecathe remembered getting hit by a car but instead of waking up in a hospital, he woke up in a stinky jail with heavy chunks of metal chains wrapped around his whole body as if it were a straitjacket. \n\nAn expensive custom-made straitjacket.\n\n\n\n\n\nFantasy || God-complex || Sci-fi || Villain protagonist || Politics || Mystery || Adventure || Suspense || Parallel universe || Bromance || Rich and Arrogant protagonist || Elements and magic || MechaXMagic ||\nStory by: Cherlyswan \nCover art by: Cherlyswan","coverUpdateTime":"1617194951571","bookType":0},{"bookId":"19646354206974105","bookName":"Dimensional Store System In Apocalypse","categoryName":"Martial Arts","categoryId":70012,"authorName":"yanglin","score":"4.81","description":"Terrorized by the Seed Crystal Virus outbreak, the dimension where Stein was created had its civilization destroyed. Once a world developed with technology as its core, now it was just a wilderness with remnants of tech that's inedible.\r\n\r\nUnknown if it was a call of good or bad luck, Zhang Qin Feng was chosen as the one to bring life back to this lawless, desolated place.\r\n\r\nWhat can he do?\r\nHow can it be done?\r\nFor what purposes?\r\nIs it worth risking his life for?\r\n\r\nThere's no one to answer Zhang Qin Feng, as he was the only one with such a privilege. But he knew... That everything came with a price.\r\n\r\n\"STEIN, Inventory!\" Zhang Qin Feng grabbed the Phalanx X-02 that took four inventory spaces from his Dimensional Storage. Holding the pistol with both of his hands, he fired a shot accurately at one of the incoming zombie's head.\r\n\r\nUpdate Schedule: 1,000 - 1,500 words/ chapter, between 1 to 2 chapters per day from 1st May onward. Premium lock from chapter 41 onwards.","coverUpdateTime":"1616505522492","bookType":0},{"bookId":"18253916006055005","bookName":"I'm a Stingray?","categoryName":"Fantasy","categoryId":70002,"authorName":"MisterE05","score":"4.18","description":"\"The Hell!? Why am I underwater?\"\n\n[System reboot]\n\n[Loading...]\n\n[I'm your ocean survival system, you are my servant]\n\n[Feed me points, and I'll show you the secrets of survival with the aid of body upgrades]  \n\n\"Oh for the love of...\"\n\n\n\n\n...\nIf you love this story and want extra chapters, please vote with your power stones!\nFor every one-hundred power stones achieved, an extra chapter will be released in the following week!\n...\n\nOriginal cover is owned by the marvelous artist, HalfwayDecentDrawing","coverUpdateTime":"1621344849996","bookType":0},{"bookId":"18978366006954605","bookName":"Desolate World","categoryName":"Video Games","categoryId":70008,"authorName":"Ron_Azure","score":"4.45","description":"More than a hundred years after Earth was devastated by a nuclear war, the survivors finally began to adapt. Many Sanctuaries were built, and the technological developments let them live civilized lives again.\n\nSome of them migrated to the Moon or to Mars to avoid the nuclear pollution ravaging the Earth, but many more chose to stay on the now ruined planet they called home.\n\nIn 131 A.R., a groundbreaking game startled humanity. A VR game launched by the Human Union changed the fragmented society.\n\nAlex, a former gambler, was gifted free game capsules by the government with no explanation. Together with his family, they started their journey in this new world filled with magic and adventure.\n\nThey never could have imagined that the game was more than just a means for entertainment. It would decide their fate and the fate of every human-beings as well.","coverUpdateTime":"1609850013858","bookType":0},{"bookId":"19868405305547505","bookName":"Returning To The Cultivation World Through A Game","categoryName":"Video Games","categoryId":70008,"authorName":"Saubi1234","score":"4.60","description":"Qin Tian, ​​a genius in the cultivation world who failed to become a Heavenly Emperor, ended up dying at the hands of his enemy who succeeded in becoming a Heavenly Emperor.\r\n\r\nBut after his death, he was reborn in a mortal world called earth. It is a world that is advanced in technology.\r\n\r\nOne day, suddenly appeared a game called (Sixteen Heavens).\r\n\r\n\"Why is the name of this game the same as the name of my original world?\" Qin Tian wondered in confusion when he first heard about the game.\r\n...","coverUpdateTime":"1621616869207","bookType":0},{"bookId":"19133134705375205","bookName":"I reincarnated as a stone","categoryName":"Fantasy","categoryId":70002,"authorName":"Gasccart","score":"4.42","description":"Peter Gravel is a man who the day before his 30th birthday suffers an unexpected accident at work and ends up buried under a pile of rocks. When he regains his senses, he cannot move any part of his body. Not only that, soon realizes that he isn’t breathing and does not feel hungry or sleepy. What was happening to him?\n\nThis is how his new life begins in a new fantastical game-like world, with a little inconvenience, he has become a stone!\n\n*******\n\nFollow or contact me on Facebook: https://www.facebook.com/J.Gascart/","coverUpdateTime":"1611421638445","bookType":0},{"bookId":"6838665602002305","bookName":"God Of Slaughter","categoryName":"Eastern Fantasy","categoryId":70009,"authorName":"Ni Cang Tian","score":"4.30","description":"Growing up parentless, Shi Yan, who was left with a large amount of inheritance money, bore a general disinterest in life.\r\n\r\nThe only times he felt alive was when adrenaline coursed thorough his veins. He quickly found that extreme sports, bungyjumping, cave diving & skydiving, gave him the biggest kicks. The bigger the adrenaline kick, the closer he was to death, the more alive he felt.\r\n\r\nWaking up in a pile of dead bodies in an unknown land, after a diving adventure had ended disastrously, he quickly realizes the body he now possessed was not his own.\r\n\r\nFollow Shi Yan as he explores this new world where danger lurks around every corner, and death is only a breath away; a world in which Shi Yan could not feel any more alive.","coverUpdateTime":"1547654411978","bookType":0}]
   */
  contentItems?: {
    /**
     * "19705637205984305"
     */
    bookId?: string;
    /**
     * "Almighty Summoner System"
     */
    bookName?: string;
    /**
     * "Martial Arts"
     */
    categoryName?: string;
    /**
     * 70012
     */
    categoryId?: number;
    /**
     * "Neil_Ads"
     */
    authorName?: string;
    /**
     * "4.50"
     */
    score?: string;
    /**
     * "Devastated by the harsh truth of being unable to summon a monster in a world full of summoners. Ban trained himself to death in the bid to overturn his fate. \r\n\r\nAs he was training himself to death, death really came to claim his life. \r\n\r\nAt that moment, a sudden light pierced the darkness that envelopes him as a virtual screen materialized in front of his eyes. \r\n\r\nWith a stroke of luck, Ban somehow managed to inherit a System after being denied by its previous owner. \r\n\r\nAnd his first mission was to tame an ant or else, die again?\r\n\r\nWitness as this young man collects and contracts different kinds of monsters with the help of the Almighty Summoner System, becoming the Supreme of the Summoner's World and the worlds beyond it.\r\n\r\n…\r\n\r\nThe art used in the cover is not mine, let me know if you want it removed."
     */
    description?: string;
    /**
     * "1621698526133"
     */
    coverUpdateTime?: string;
    bookType?: number;
  }[];
}

/**
 * 接口 [游戏助手内嵌页推书接口↗](https://yapi.yuewen.com/project/2309/interface/api/216193) 的 **请求配置的类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/gameLoop`
 * @更新时间 `2021-06-22 14:10:32`
 */
type GoPcmPcbookcityGameLoopRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/pcbookcity/gameLoop",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [游戏助手内嵌页推书接口↗](https://yapi.yuewen.com/project/2309/interface/api/216193) 的 **请求配置**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/gameLoop`
 * @更新时间 `2021-06-22 14:10:32`
 */
const goPcmPcbookcityGameLoopRequestConfig: GoPcmPcbookcityGameLoopRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_22,
    devUrl: devUrl_0_0_0_22,
    prodUrl: prodUrl_0_0_0_22,
    path: "/go/pcm/pcbookcity/gameLoop",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPcbookcityGameLoop",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [游戏助手内嵌页推书接口↗](https://yapi.yuewen.com/project/2309/interface/api/216193) 的 **请求函数**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/gameLoop`
 * @更新时间 `2021-06-22 14:10:32`
 */
export const goPcmPcbookcityGameLoop = /*#__PURE__*/ (
  requestData?: GoPcmPcbookcityGameLoopRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPcbookcityGameLoopResponse>(
    prepare(goPcmPcbookcityGameLoopRequestConfig, requestData),
    ...args
  );
};

goPcmPcbookcityGameLoop.requestConfig = goPcmPcbookcityGameLoopRequestConfig;

/**
 * 接口 [征文入口信息↗](https://yapi.yuewen.com/project/2309/interface/api/252153) 的 **请求类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/essay`
 * @更新时间 `2022-11-18 11:39:00`
 */
export interface GoPcmPcbookcityEssayRequest {}

/**
 * 接口 [征文入口信息↗](https://yapi.yuewen.com/project/2309/interface/api/252153) 的 **返回类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/essay`
 * @更新时间 `2022-11-18 11:39:00`
 */
export interface GoPcmPcbookcityEssayResponse {
  /**
   * "@word"
   */
  tag?: string;
  /**
   * [{"title":"@sentence","img":"@url","description":"@sentence","actionUrl":"@url","activityId":1}]
   */
  list?: {
    /**
     * "@sentence"
     */
    title?: string;
    /**
     * "@url"
     */
    img?: string;
    /**
     * "@sentence"
     */
    description?: string;
    /**
     * "@url"
     */
    actionUrl?: string;
    /**
     * 1
     */
    activityId?: number;
  }[];
}

/**
 * 接口 [征文入口信息↗](https://yapi.yuewen.com/project/2309/interface/api/252153) 的 **请求配置的类型**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/essay`
 * @更新时间 `2022-11-18 11:39:00`
 */
type GoPcmPcbookcityEssayRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/pcbookcity/essay",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [征文入口信息↗](https://yapi.yuewen.com/project/2309/interface/api/252153) 的 **请求配置**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/essay`
 * @更新时间 `2022-11-18 11:39:00`
 */
const goPcmPcbookcityEssayRequestConfig: GoPcmPcbookcityEssayRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_22,
    devUrl: devUrl_0_0_0_22,
    prodUrl: prodUrl_0_0_0_22,
    path: "/go/pcm/pcbookcity/essay",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPcbookcityEssay",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [征文入口信息↗](https://yapi.yuewen.com/project/2309/interface/api/252153) 的 **请求函数**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/essay`
 * @更新时间 `2022-11-18 11:39:00`
 */
export const goPcmPcbookcityEssay = /*#__PURE__*/ (
  requestData?: GoPcmPcbookcityEssayRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPcbookcityEssayResponse>(
    prepare(goPcmPcbookcityEssayRequestConfig, requestData),
    ...args
  );
};

goPcmPcbookcityEssay.requestConfig = goPcmPcbookcityEssayRequestConfig;

const mockUrl_0_0_0_23 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_23 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_23 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_23 = "data" as any;

/**
 * 接口 [上报阅读时长↗](https://yapi.yuewen.com/project/2309/interface/api/182101) 的 **请求类型**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `POST /go/pcm/reading/report`
 * @更新时间 `2021-01-08 21:03:05`
 */
export interface GoPcmReadingReportRequest {
  readingInfos: string;
}

/**
 * 接口 [上报阅读时长↗](https://yapi.yuewen.com/project/2309/interface/api/182101) 的 **返回类型**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `POST /go/pcm/reading/report`
 * @更新时间 `2021-01-08 21:03:05`
 */
export interface GoPcmReadingReportResponse {}

/**
 * 接口 [上报阅读时长↗](https://yapi.yuewen.com/project/2309/interface/api/182101) 的 **请求配置的类型**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `POST /go/pcm/reading/report`
 * @更新时间 `2021-01-08 21:03:05`
 */
type GoPcmReadingReportRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/reading/report",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [上报阅读时长↗](https://yapi.yuewen.com/project/2309/interface/api/182101) 的 **请求配置**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `POST /go/pcm/reading/report`
 * @更新时间 `2021-01-08 21:03:05`
 */
const goPcmReadingReportRequestConfig: GoPcmReadingReportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_23,
    devUrl: devUrl_0_0_0_23,
    prodUrl: prodUrl_0_0_0_23,
    path: "/go/pcm/reading/report",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_23,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingReport",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [上报阅读时长↗](https://yapi.yuewen.com/project/2309/interface/api/182101) 的 **请求函数**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `POST /go/pcm/reading/report`
 * @更新时间 `2021-01-08 21:03:05`
 */
export const goPcmReadingReport = /*#__PURE__*/ (
  requestData: GoPcmReadingReportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmReadingReportResponse>(
    prepare(goPcmReadingReportRequestConfig, requestData),
    ...args
  );
};

goPcmReadingReport.requestConfig = goPcmReadingReportRequestConfig;

/**
 * 接口 [末页↗](https://yapi.yuewen.com/project/2309/interface/api/246501) 的 **请求类型**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2022-09-23 10:25:29`
 */
export interface GoPcmReadingLastPage2Request {
  itemId: string;
  itemType?: string;
}

/**
 * 接口 [末页↗](https://yapi.yuewen.com/project/2309/interface/api/246501) 的 **返回类型**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2022-09-23 10:25:29`
 */
export interface GoPcmReadingLastPage2Response {
  bookInfo?: {
    /**
     * 30
     */
    status?: number;
    nextUpdateTime?: number;
    /**
     * 1
     */
    updateFrequency?: number;
    promiseUpdateFrequency?: number;
    totalScore?: number;
    /**
     * 5
     */
    voters?: number;
    /**
     * 252538
     */
    pvNum?: number;
    /**
     * 2
     */
    bookType?: number;
    categoryId?: number;
    categoryName?: string;
  };
  reviewScore?: number;
  /**
   * []
   */
  tagInfo?: unknown[];
  operationInfo?: {
    title?: string;
    imageUrl?: string;
    actionUrl?: string;
  };
  /**
   * [{"bookId":"7851773505001805","bookName":"Versatile Mage","categoryName":"Fantasy","totalScore":4.4,"coverUpdateTime":1548124490779,"novelType":0,"alg":"{\"V\":\"1\",\"alg\":\"181.0.1\",\"expid\":1000,\"itemid\":\"7851773505001805\",\"logid\":8393549529078381429,\"origin\":\"12058\",\"preitemid\":\"b_7851773505001805\",\"scene\":\"book-related\",\"type\":\"0\",\"version\":\"\"}"}]
   */
  recommendInfo?: {
    /**
     * "7851773505001805"
     */
    bookId?: string;
    /**
     * "Versatile Mage"
     */
    bookName?: string;
    /**
     * "Fantasy"
     */
    categoryName?: string;
    /**
     * 4.4
     */
    totalScore?: number;
    /**
     * 1548124490779
     */
    coverUpdateTime?: number;
    novelType?: number;
    /**
     * "{\"V\":\"1\",\"alg\":\"181.0.1\",\"expid\":1000,\"itemid\":\"7851773505001805\",\"logid\":8393549529078381429,\"origin\":\"12058\",\"preitemid\":\"b_7851773505001805\",\"scene\":\"book-related\",\"type\":\"0\",\"version\":\"\"}"
     */
    alg?: string;
  }[];
  /**
   * [{"reviewId":"23738581305325800","bookId":"23691265305309905","content":"This is the only twilight fanfiction on here that I think is actually good the rest of them are just the authors fanboying over the characters or sucking them off this is a nice change of pace I also hate twilight but I like this fanfic","imageItems":[],"userId":4306607723,"totalScore":5,"createTimeFormat":"2mth","readToChapterIndex":"7","replyAmount":3,"likeAmount":8,"leakFlag":0,"isLiked":0,"topStatus":0,"appId":10,"novelType":0,"headImageId":1601514704000,"userName":"AidoneusCorvinus","avatar":1561695786313,"penName":"AidoneusCorvinus","userRole":0,"userLevel":4,"badgeInfo":{"badgeId":10046,"badgeType":"Growth","badgeName":"Reading Master","maxGrade":4,"baseUrl":"https://actimg.webnovel.com/badge/10046/4/","updateTime":1663899797000},"holdBadgeCoverURL":"https://actimg.webnovel.com/badge/10046/4/","holdBadgeCoverId":1591007823000,"essenceStatus":0,"isViceModerator":0}]
   */
  reviewItems?: {
    /**
     * "23738581305325800"
     */
    reviewId?: string;
    /**
     * "23691265305309905"
     */
    bookId?: string;
    /**
     * "This is the only twilight fanfiction on here that I think is actually good the rest of them are just the authors fanboying over the characters or sucking them off this is a nice change of pace I also hate twilight but I like this fanfic"
     */
    content?: string;
    /**
     * []
     */
    imageItems?: unknown[];
    /**
     * 4306607723
     */
    userId?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * "2mth"
     */
    createTimeFormat?: string;
    /**
     * "7"
     */
    readToChapterIndex?: string;
    /**
     * 3
     */
    replyAmount?: number;
    /**
     * 8
     */
    likeAmount?: number;
    leakFlag?: number;
    isLiked?: number;
    topStatus?: number;
    /**
     * 10
     */
    appId?: number;
    novelType?: number;
    /**
     * 1601514704000
     */
    headImageId?: number;
    /**
     * "AidoneusCorvinus"
     */
    userName?: string;
    /**
     * 1561695786313
     */
    avatar?: number;
    /**
     * "AidoneusCorvinus"
     */
    penName?: string;
    userRole?: number;
    /**
     * 4
     */
    userLevel?: number;
    badgeInfo?: {
      /**
       * 10046
       */
      badgeId?: number;
      /**
       * "Growth"
       */
      badgeType?: string;
      /**
       * "Reading Master"
       */
      badgeName?: string;
      /**
       * 4
       */
      maxGrade?: number;
      /**
       * "https://actimg.webnovel.com/badge/10046/4/"
       */
      baseUrl?: string;
      /**
       * 1663899797000
       */
      updateTime?: number;
    };
    /**
     * "https://actimg.webnovel.com/badge/10046/4/"
     */
    holdBadgeCoverURL?: string;
    /**
     * 1591007823000
     */
    holdBadgeCoverId?: number;
    essenceStatus?: number;
    isViceModerator?: number;
  }[];
  /**
   * 5
   */
  reviewNum?: number;
}

/**
 * 接口 [末页↗](https://yapi.yuewen.com/project/2309/interface/api/246501) 的 **请求配置的类型**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2022-09-23 10:25:29`
 */
type GoPcmReadingLastPage2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/reading/lastPage",
    "data",
    string,
    "itemId" | "itemType",
    false
  >
>;

/**
 * 接口 [末页↗](https://yapi.yuewen.com/project/2309/interface/api/246501) 的 **请求配置**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2022-09-23 10:25:29`
 */
const goPcmReadingLastPage2RequestConfig: GoPcmReadingLastPage2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_23,
    devUrl: devUrl_0_0_0_23,
    prodUrl: prodUrl_0_0_0_23,
    path: "/go/pcm/reading/lastPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_23,
    paramNames: [],
    queryNames: ["itemId", "itemType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingLastPage2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [末页↗](https://yapi.yuewen.com/project/2309/interface/api/246501) 的 **请求函数**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2022-09-23 10:25:29`
 */
export const goPcmReadingLastPage2 = /*#__PURE__*/ (
  requestData: GoPcmReadingLastPage2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmReadingLastPage2Response>(
    prepare(goPcmReadingLastPage2RequestConfig, requestData),
    ...args
  );
};

goPcmReadingLastPage2.requestConfig = goPcmReadingLastPage2RequestConfig;

const mockUrl_0_0_0_24 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_24 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_24 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_24 = "data" as any;

/**
 * 接口 [投票↗](https://yapi.yuewen.com/project/2309/interface/api/182128) 的 **请求类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `POST /go/pcm/powerStone/vote`
 * @更新时间 `2021-02-07 01:30:28`
 */
export interface GoPcmPowerStoneVoteRequest {
  bookId: string;
  /**
   * 0书，100漫画，200出版书
   */
  novelType: string;
}

/**
 * 接口 [投票↗](https://yapi.yuewen.com/project/2309/interface/api/182128) 的 **返回类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `POST /go/pcm/powerStone/vote`
 * @更新时间 `2021-02-07 01:30:28`
 */
export interface GoPcmPowerStoneVoteResponse {}

/**
 * 接口 [投票↗](https://yapi.yuewen.com/project/2309/interface/api/182128) 的 **请求配置的类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `POST /go/pcm/powerStone/vote`
 * @更新时间 `2021-02-07 01:30:28`
 */
type GoPcmPowerStoneVoteRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/powerStone/vote",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [投票↗](https://yapi.yuewen.com/project/2309/interface/api/182128) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `POST /go/pcm/powerStone/vote`
 * @更新时间 `2021-02-07 01:30:28`
 */
const goPcmPowerStoneVoteRequestConfig: GoPcmPowerStoneVoteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/vote",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneVote",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [投票↗](https://yapi.yuewen.com/project/2309/interface/api/182128) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `POST /go/pcm/powerStone/vote`
 * @更新时间 `2021-02-07 01:30:28`
 */
export const goPcmPowerStoneVote = /*#__PURE__*/ (
  requestData: GoPcmPowerStoneVoteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPowerStoneVoteResponse>(
    prepare(goPcmPowerStoneVoteRequestConfig, requestData),
    ...args
  );
};

goPcmPowerStoneVote.requestConfig = goPcmPowerStoneVoteRequestConfig;

/**
 * 接口 [获取用户推荐票投票记录(ajax)↗](https://yapi.yuewen.com/project/2309/interface/api/195219) 的 **请求类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryAjax`
 * @更新时间 `2021-01-25 20:06:43`
 */
export interface GoPcmPowerStoneGetHistoryAjaxRequest {
  pageIndex: string;
}

/**
 * 接口 [获取用户推荐票投票记录(ajax)↗](https://yapi.yuewen.com/project/2309/interface/api/195219) 的 **返回类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryAjax`
 * @更新时间 `2021-01-25 20:06:43`
 */
export interface GoPcmPowerStoneGetHistoryAjaxResponse {}

/**
 * 接口 [获取用户推荐票投票记录(ajax)↗](https://yapi.yuewen.com/project/2309/interface/api/195219) 的 **请求配置的类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryAjax`
 * @更新时间 `2021-01-25 20:06:43`
 */
type GoPcmPowerStoneGetHistoryAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/powerStone/getHistoryAjax",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [获取用户推荐票投票记录(ajax)↗](https://yapi.yuewen.com/project/2309/interface/api/195219) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryAjax`
 * @更新时间 `2021-01-25 20:06:43`
 */
const goPcmPowerStoneGetHistoryAjaxRequestConfig: GoPcmPowerStoneGetHistoryAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getHistoryAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: ["pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetHistoryAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取用户推荐票投票记录(ajax)↗](https://yapi.yuewen.com/project/2309/interface/api/195219) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryAjax`
 * @更新时间 `2021-01-25 20:06:43`
 */
export const goPcmPowerStoneGetHistoryAjax = /*#__PURE__*/ (
  requestData: GoPcmPowerStoneGetHistoryAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPowerStoneGetHistoryAjaxResponse>(
    prepare(goPcmPowerStoneGetHistoryAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmPowerStoneGetHistoryAjax.requestConfig =
  goPcmPowerStoneGetHistoryAjaxRequestConfig;

/**
 * 接口 [获取用户推荐票投票记录(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195225) 的 **请求类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryPage`
 * @更新时间 `2021-01-25 20:07:14`
 */
export interface GoPcmPowerStoneGetHistoryPageRequest {
  pageIndex: string;
}

/**
 * 接口 [获取用户推荐票投票记录(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195225) 的 **返回类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryPage`
 * @更新时间 `2021-01-25 20:07:14`
 */
export interface GoPcmPowerStoneGetHistoryPageResponse {}

/**
 * 接口 [获取用户推荐票投票记录(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195225) 的 **请求配置的类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryPage`
 * @更新时间 `2021-01-25 20:07:14`
 */
type GoPcmPowerStoneGetHistoryPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/powerStone/getHistoryPage",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [获取用户推荐票投票记录(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195225) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryPage`
 * @更新时间 `2021-01-25 20:07:14`
 */
const goPcmPowerStoneGetHistoryPageRequestConfig: GoPcmPowerStoneGetHistoryPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getHistoryPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: ["pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetHistoryPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取用户推荐票投票记录(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195225) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryPage`
 * @更新时间 `2021-01-25 20:07:14`
 */
export const goPcmPowerStoneGetHistoryPage = /*#__PURE__*/ (
  requestData: GoPcmPowerStoneGetHistoryPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPowerStoneGetHistoryPageResponse>(
    prepare(goPcmPowerStoneGetHistoryPageRequestConfig, requestData),
    ...args
  );
};

goPcmPowerStoneGetHistoryPage.requestConfig =
  goPcmPowerStoneGetHistoryPageRequestConfig;

/**
 * 接口 [powerStone\/getList↗](https://yapi.yuewen.com/project/2309/interface/api/195231) 的 **请求类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getList`
 * @更新时间 `2021-02-06 23:09:43`
 */
export interface GoPcmPowerStoneGetListRequest {
  timestamp: string;
  type: string;
  pageIndex: string;
}

/**
 * 接口 [powerStone\/getList↗](https://yapi.yuewen.com/project/2309/interface/api/195231) 的 **返回类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getList`
 * @更新时间 `2021-02-06 23:09:43`
 */
export interface GoPcmPowerStoneGetListResponse {}

/**
 * 接口 [powerStone\/getList↗](https://yapi.yuewen.com/project/2309/interface/api/195231) 的 **请求配置的类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getList`
 * @更新时间 `2021-02-06 23:09:43`
 */
type GoPcmPowerStoneGetListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/powerStone/getList",
    "data",
    string,
    "timestamp" | "type" | "pageIndex",
    false
  >
>;

/**
 * 接口 [powerStone\/getList↗](https://yapi.yuewen.com/project/2309/interface/api/195231) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getList`
 * @更新时间 `2021-02-06 23:09:43`
 */
const goPcmPowerStoneGetListRequestConfig: GoPcmPowerStoneGetListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: ["timestamp", "type", "pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [powerStone\/getList↗](https://yapi.yuewen.com/project/2309/interface/api/195231) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getList`
 * @更新时间 `2021-02-06 23:09:43`
 */
export const goPcmPowerStoneGetList = /*#__PURE__*/ (
  requestData: GoPcmPowerStoneGetListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPowerStoneGetListResponse>(
    prepare(goPcmPowerStoneGetListRequestConfig, requestData),
    ...args
  );
};

goPcmPowerStoneGetList.requestConfig = goPcmPowerStoneGetListRequestConfig;

/**
 * 接口 [getListAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195237) 的 **请求类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getListAjax`
 * @更新时间 `2021-01-25 20:08:55`
 */
export interface GoPcmPowerStoneGetListAjaxRequest {
  timestamp: string;
  type: string;
  pageIndex: string;
  _csrfToken: string;
}

/**
 * 接口 [getListAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195237) 的 **返回类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getListAjax`
 * @更新时间 `2021-01-25 20:08:55`
 */
export interface GoPcmPowerStoneGetListAjaxResponse {}

/**
 * 接口 [getListAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195237) 的 **请求配置的类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getListAjax`
 * @更新时间 `2021-01-25 20:08:55`
 */
type GoPcmPowerStoneGetListAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/powerStone/getListAjax",
    "data",
    string,
    "timestamp" | "type" | "pageIndex" | "_csrfToken",
    false
  >
>;

/**
 * 接口 [getListAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195237) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getListAjax`
 * @更新时间 `2021-01-25 20:08:55`
 */
const goPcmPowerStoneGetListAjaxRequestConfig: GoPcmPowerStoneGetListAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getListAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: ["timestamp", "type", "pageIndex", "_csrfToken"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetListAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getListAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195237) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getListAjax`
 * @更新时间 `2021-01-25 20:08:55`
 */
export const goPcmPowerStoneGetListAjax = /*#__PURE__*/ (
  requestData: GoPcmPowerStoneGetListAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPowerStoneGetListAjaxResponse>(
    prepare(goPcmPowerStoneGetListAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmPowerStoneGetListAjax.requestConfig =
  goPcmPowerStoneGetListAjaxRequestConfig;

/**
 * 接口 [推荐票排行榜直出↗](https://yapi.yuewen.com/project/2309/interface/api/195243) 的 **请求类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookId`
 * @更新时间 `2021-02-06 23:36:10`
 */
export interface GoPcmPowerStoneGetPowerStoneRankingByBookIdRequest {
  bookId: string;
}

/**
 * 接口 [推荐票排行榜直出↗](https://yapi.yuewen.com/project/2309/interface/api/195243) 的 **返回类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookId`
 * @更新时间 `2021-02-06 23:36:10`
 */
export interface GoPcmPowerStoneGetPowerStoneRankingByBookIdResponse {}

/**
 * 接口 [推荐票排行榜直出↗](https://yapi.yuewen.com/project/2309/interface/api/195243) 的 **请求配置的类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookId`
 * @更新时间 `2021-02-06 23:36:10`
 */
type GoPcmPowerStoneGetPowerStoneRankingByBookIdRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/powerStone/getPowerStoneRankingByBookId",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [推荐票排行榜直出↗](https://yapi.yuewen.com/project/2309/interface/api/195243) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookId`
 * @更新时间 `2021-02-06 23:36:10`
 */
const goPcmPowerStoneGetPowerStoneRankingByBookIdRequestConfig: GoPcmPowerStoneGetPowerStoneRankingByBookIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getPowerStoneRankingByBookId",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetPowerStoneRankingByBookId",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [推荐票排行榜直出↗](https://yapi.yuewen.com/project/2309/interface/api/195243) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookId`
 * @更新时间 `2021-02-06 23:36:10`
 */
export const goPcmPowerStoneGetPowerStoneRankingByBookId = /*#__PURE__*/ (
  requestData: GoPcmPowerStoneGetPowerStoneRankingByBookIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPowerStoneGetPowerStoneRankingByBookIdResponse>(
    prepare(
      goPcmPowerStoneGetPowerStoneRankingByBookIdRequestConfig,
      requestData
    ),
    ...args
  );
};

goPcmPowerStoneGetPowerStoneRankingByBookId.requestConfig =
  goPcmPowerStoneGetPowerStoneRankingByBookIdRequestConfig;

/**
 * 接口 [推荐票排行榜-分页↗](https://yapi.yuewen.com/project/2309/interface/api/195250) 的 **请求类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2021-02-05 17:42:31`
 */
export interface GoPcmPowerStoneGetPowerStoneRankingByBookIdListRequest {
  bookId: string;
}

/**
 * 接口 [推荐票排行榜-分页↗](https://yapi.yuewen.com/project/2309/interface/api/195250) 的 **返回类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2021-02-05 17:42:31`
 */
export interface GoPcmPowerStoneGetPowerStoneRankingByBookIdListResponse {}

/**
 * 接口 [推荐票排行榜-分页↗](https://yapi.yuewen.com/project/2309/interface/api/195250) 的 **请求配置的类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2021-02-05 17:42:31`
 */
type GoPcmPowerStoneGetPowerStoneRankingByBookIdListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/powerStone/getPowerStoneRankingByBookIdList",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [推荐票排行榜-分页↗](https://yapi.yuewen.com/project/2309/interface/api/195250) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2021-02-05 17:42:31`
 */
const goPcmPowerStoneGetPowerStoneRankingByBookIdListRequestConfig: GoPcmPowerStoneGetPowerStoneRankingByBookIdListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getPowerStoneRankingByBookIdList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetPowerStoneRankingByBookIdList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [推荐票排行榜-分页↗](https://yapi.yuewen.com/project/2309/interface/api/195250) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2021-02-05 17:42:31`
 */
export const goPcmPowerStoneGetPowerStoneRankingByBookIdList = /*#__PURE__*/ (
  requestData: GoPcmPowerStoneGetPowerStoneRankingByBookIdListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPowerStoneGetPowerStoneRankingByBookIdListResponse>(
    prepare(
      goPcmPowerStoneGetPowerStoneRankingByBookIdListRequestConfig,
      requestData
    ),
    ...args
  );
};

goPcmPowerStoneGetPowerStoneRankingByBookIdList.requestConfig =
  goPcmPowerStoneGetPowerStoneRankingByBookIdListRequestConfig;

/**
 * 接口 [getRankInfoAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195256) 的 **请求类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getRankInfoAjax`
 * @更新时间 `2021-02-07 19:46:38`
 */
export interface GoPcmPowerStoneGetRankInfoAjaxRequest {
  bookId: string;
  bookType: string;
  novelType: string;
}

/**
 * 接口 [getRankInfoAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195256) 的 **返回类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getRankInfoAjax`
 * @更新时间 `2021-02-07 19:46:38`
 */
export interface GoPcmPowerStoneGetRankInfoAjaxResponse {
  /**
   * 9
   */
  catchUpNums?: number;
  /**
   * 9
   */
  followUpNums?: number;
  nextNums?: number;
  /**
   * 8
   */
  powerNums?: number;
  preNums?: number;
  /**
   * -1
   */
  rank?: number;
}

/**
 * 接口 [getRankInfoAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195256) 的 **请求配置的类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getRankInfoAjax`
 * @更新时间 `2021-02-07 19:46:38`
 */
type GoPcmPowerStoneGetRankInfoAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/powerStone/getRankInfoAjax",
    "data",
    string,
    "bookId" | "bookType" | "novelType",
    false
  >
>;

/**
 * 接口 [getRankInfoAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195256) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getRankInfoAjax`
 * @更新时间 `2021-02-07 19:46:38`
 */
const goPcmPowerStoneGetRankInfoAjaxRequestConfig: GoPcmPowerStoneGetRankInfoAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getRankInfoAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: ["bookId", "bookType", "novelType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetRankInfoAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getRankInfoAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195256) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getRankInfoAjax`
 * @更新时间 `2021-02-07 19:46:38`
 */
export const goPcmPowerStoneGetRankInfoAjax = /*#__PURE__*/ (
  requestData: GoPcmPowerStoneGetRankInfoAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPowerStoneGetRankInfoAjaxResponse>(
    prepare(goPcmPowerStoneGetRankInfoAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmPowerStoneGetRankInfoAjax.requestConfig =
  goPcmPowerStoneGetRankInfoAjaxRequestConfig;

/**
 * 接口 [拉取票详情页数据 - 用户期待票、推荐票信息，及流水↗](https://yapi.yuewen.com/project/2309/interface/api/197915) 的 **请求类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/stoneDetailAjax`
 * @更新时间 `2021-02-20 18:35:17`
 */
export interface GoPcmPowerStoneStoneDetailAjaxRequest {
  pageIndex: string;
  /**
   * 1或者2
   */
  type: string;
}

/**
 * 接口 [拉取票详情页数据 - 用户期待票、推荐票信息，及流水↗](https://yapi.yuewen.com/project/2309/interface/api/197915) 的 **返回类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/stoneDetailAjax`
 * @更新时间 `2021-02-20 18:35:17`
 */
export interface GoPcmPowerStoneStoneDetailAjaxResponse {
  isLast?: number;
  /**
   * [{"bookId":"11558338301012801","bookName":"Xiuzhen","bookType":100,"platform":"Web","time":1612667113000},{"bookId":"7366916601012405","bookName":"The King's Avatar","bookType":0,"platform":"Web","time":1612666771000},{"bookId":"7366916601012405","bookName":"The King's Avatar","bookType":0,"platform":"Web","time":1612666726000},{"bookId":"16707603601026001","bookName":"Comic Blue women0417","bookType":100,"platform":"Web","time":1610437984000},{"bookId":"7366916601012405","bookName":"The King's Avatar","bookType":0,"platform":"Web","time":1608713435000},{"bookId":"7366916601012405","bookName":"The King's Avatar","bookType":0,"platform":"Web","time":1608713341000},{"bookId":"7366916601012405","bookName":"The King's Avatar","bookType":0,"platform":"Web","time":1608713328000},{"bookId":"7366916601012405","bookName":"The King's Avatar","bookType":0,"platform":"Web","time":1608538845000},{"bookId":"7366916601012405","bookName":"The King's Avatar","bookType":0,"platform":"Web","time":1608538843000},{"bookId":"7366916601012405","bookName":"The King's Avatar","bookType":0,"platform":"Web","time":1608538841000},{"bookId":"12698954101038401","bookName":"Webnovel TestComic01091","bookType":100,"platform":"Web","time":1603351144000},{"bookId":"11566481001013001","bookName":"Webnove lComic Test 002","bookType":100,"platform":"Web","time":1602220263000},{"bookId":"11566481001013001","bookName":"Webnove lComic Test 002","bookType":100,"platform":"Web","time":1602220250000},{"bookId":"7366916601012405","bookName":"The King's Avatar","bookType":0,"platform":"Web","time":1602220099000},{"bookId":"15851730401001205","bookName":"Fudge","bookType":0,"platform":"Web","time":1601455417000},{"bookId":"17416025401054105","bookName":"ytt333","bookType":0,"platform":"Web","time":1601455282000},{"bookId":"17416025401054105","bookName":"ytt333","bookType":0,"platform":"Web","time":1601455277000},{"bookId":"11558338301012801","bookName":"Xiuzhen","bookType":100,"platform":"Web","time":1597311508000},{"bookId":"7366916601012405","bookName":"The King's Avatar","bookType":0,"platform":"Web","time":1596631611000},{"bookId":"14928120501130705","bookName":"111","bookType":0,"platform":"Web","time":1596009307000}]
   */
  items?: {
    /**
     * "11558338301012801"
     */
    bookId?: string;
    /**
     * "Xiuzhen"
     */
    bookName?: string;
    /**
     * 100
     */
    bookType?: number;
    /**
     * "Web"
     */
    platform?: string;
    /**
     * 1612667113000
     */
    time?: number;
  }[];
  stoneInfo?: {
    /**
     * 3
     */
    availableEnergy?: number;
    /**
     * 3
     */
    availablePower?: number;
    /**
     * 19487
     */
    leftTimestamp?: number;
    /**
     * 3
     */
    totalEnergy?: number;
    /**
     * 3
     */
    totalPower?: number;
  };
  /**
   * 37
   */
  total?: number;
  /**
   * 1
   */
  type?: number;
}

/**
 * 接口 [拉取票详情页数据 - 用户期待票、推荐票信息，及流水↗](https://yapi.yuewen.com/project/2309/interface/api/197915) 的 **请求配置的类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/stoneDetailAjax`
 * @更新时间 `2021-02-20 18:35:17`
 */
type GoPcmPowerStoneStoneDetailAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/powerStone/stoneDetailAjax",
    "data",
    string,
    "pageIndex" | "type",
    false
  >
>;

/**
 * 接口 [拉取票详情页数据 - 用户期待票、推荐票信息，及流水↗](https://yapi.yuewen.com/project/2309/interface/api/197915) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/stoneDetailAjax`
 * @更新时间 `2021-02-20 18:35:17`
 */
const goPcmPowerStoneStoneDetailAjaxRequestConfig: GoPcmPowerStoneStoneDetailAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/stoneDetailAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: ["pageIndex", "type"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneStoneDetailAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [拉取票详情页数据 - 用户期待票、推荐票信息，及流水↗](https://yapi.yuewen.com/project/2309/interface/api/197915) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/stoneDetailAjax`
 * @更新时间 `2021-02-20 18:35:17`
 */
export const goPcmPowerStoneStoneDetailAjax = /*#__PURE__*/ (
  requestData: GoPcmPowerStoneStoneDetailAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPowerStoneStoneDetailAjaxResponse>(
    prepare(goPcmPowerStoneStoneDetailAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmPowerStoneStoneDetailAjax.requestConfig =
  goPcmPowerStoneStoneDetailAjaxRequestConfig;

/**
 * 接口 [拉取书籍的推荐票信息↗](https://yapi.yuewen.com/project/2309/interface/api/197922) 的 **请求类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/powerStone/powerInfoAjax`
 * @更新时间 `2021-02-22 16:06:08`
 */
export interface GoPcmGoPcmPowerStonePowerInfoAjaxRequest {
  bookId: string;
  /**
   * 1
   */
  bookType: string;
  /**
   * 0
   */
  novelType: string;
}

/**
 * 接口 [拉取书籍的推荐票信息↗](https://yapi.yuewen.com/project/2309/interface/api/197922) 的 **返回类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/powerStone/powerInfoAjax`
 * @更新时间 `2021-02-22 16:06:08`
 */
export interface GoPcmGoPcmPowerStonePowerInfoAjaxResponse {}

/**
 * 接口 [拉取书籍的推荐票信息↗](https://yapi.yuewen.com/project/2309/interface/api/197922) 的 **请求配置的类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/powerStone/powerInfoAjax`
 * @更新时间 `2021-02-22 16:06:08`
 */
type GoPcmGoPcmPowerStonePowerInfoAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/go/pcm/powerStone/powerInfoAjax",
    "data",
    string,
    "bookId" | "bookType" | "novelType",
    false
  >
>;

/**
 * 接口 [拉取书籍的推荐票信息↗](https://yapi.yuewen.com/project/2309/interface/api/197922) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/powerStone/powerInfoAjax`
 * @更新时间 `2021-02-22 16:06:08`
 */
const goPcmGoPcmPowerStonePowerInfoAjaxRequestConfig: GoPcmGoPcmPowerStonePowerInfoAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/go/pcm/powerStone/powerInfoAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: ["bookId", "bookType", "novelType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGoPcmPowerStonePowerInfoAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [拉取书籍的推荐票信息↗](https://yapi.yuewen.com/project/2309/interface/api/197922) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/powerStone/powerInfoAjax`
 * @更新时间 `2021-02-22 16:06:08`
 */
export const goPcmGoPcmPowerStonePowerInfoAjax = /*#__PURE__*/ (
  requestData: GoPcmGoPcmPowerStonePowerInfoAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmGoPcmPowerStonePowerInfoAjaxResponse>(
    prepare(goPcmGoPcmPowerStonePowerInfoAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmGoPcmPowerStonePowerInfoAjax.requestConfig =
  goPcmGoPcmPowerStonePowerInfoAjaxRequestConfig;

/**
 * 接口 [拉取排行榜列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/197924) 的 **请求类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/go/pcm/powerStone/powerListAjax`
 * @更新时间 `2021-02-22 16:07:01`
 */
export interface GoPcmGoPcmGoPcmPowerStonePowerListAjaxRequest {
  bookType: string;
  pageIndex: string;
  pageSize?: string;
  timestamp?: string;
}

/**
 * 接口 [拉取排行榜列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/197924) 的 **返回类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/go/pcm/powerStone/powerListAjax`
 * @更新时间 `2021-02-22 16:07:01`
 */
export interface GoPcmGoPcmGoPcmPowerStonePowerListAjaxResponse {}

/**
 * 接口 [拉取排行榜列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/197924) 的 **请求配置的类型**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/go/pcm/powerStone/powerListAjax`
 * @更新时间 `2021-02-22 16:07:01`
 */
type GoPcmGoPcmGoPcmPowerStonePowerListAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/go/pcm/go/pcm/powerStone/powerListAjax",
    "data",
    string,
    "bookType" | "pageIndex" | "pageSize" | "timestamp",
    false
  >
>;

/**
 * 接口 [拉取排行榜列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/197924) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/go/pcm/powerStone/powerListAjax`
 * @更新时间 `2021-02-22 16:07:01`
 */
const goPcmGoPcmGoPcmPowerStonePowerListAjaxRequestConfig: GoPcmGoPcmGoPcmPowerStonePowerListAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/go/pcm/go/pcm/powerStone/powerListAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: ["bookType", "pageIndex", "pageSize", "timestamp"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGoPcmGoPcmPowerStonePowerListAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [拉取排行榜列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/197924) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/go/pcm/powerStone/powerListAjax`
 * @更新时间 `2021-02-22 16:07:01`
 */
export const goPcmGoPcmGoPcmPowerStonePowerListAjax = /*#__PURE__*/ (
  requestData: GoPcmGoPcmGoPcmPowerStonePowerListAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmGoPcmGoPcmPowerStonePowerListAjaxResponse>(
    prepare(goPcmGoPcmGoPcmPowerStonePowerListAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmGoPcmGoPcmPowerStonePowerListAjax.requestConfig =
  goPcmGoPcmGoPcmPowerStonePowerListAjaxRequestConfig;

const mockUrl_0_0_0_25 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_25 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_25 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_25 = "data" as any;

/**
 * 接口 [发送Download Webnovel APP邮件↗](https://yapi.yuewen.com/project/2309/interface/api/191389) 的 **请求类型**
 *
 * @分类 [mailService↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25103)
 * @请求头 `POST /go/pcm/mail/SendAppLink`
 * @更新时间 `2021-01-18 14:36:58`
 */
export interface GoPcmMailSendAppLinkRequest {
  addr: string;
}

/**
 * 接口 [发送Download Webnovel APP邮件↗](https://yapi.yuewen.com/project/2309/interface/api/191389) 的 **返回类型**
 *
 * @分类 [mailService↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25103)
 * @请求头 `POST /go/pcm/mail/SendAppLink`
 * @更新时间 `2021-01-18 14:36:58`
 */
export interface GoPcmMailSendAppLinkResponse {}

/**
 * 接口 [发送Download Webnovel APP邮件↗](https://yapi.yuewen.com/project/2309/interface/api/191389) 的 **请求配置的类型**
 *
 * @分类 [mailService↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25103)
 * @请求头 `POST /go/pcm/mail/SendAppLink`
 * @更新时间 `2021-01-18 14:36:58`
 */
type GoPcmMailSendAppLinkRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/mail/SendAppLink",
    "data",
    string,
    "addr",
    false
  >
>;

/**
 * 接口 [发送Download Webnovel APP邮件↗](https://yapi.yuewen.com/project/2309/interface/api/191389) 的 **请求配置**
 *
 * @分类 [mailService↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25103)
 * @请求头 `POST /go/pcm/mail/SendAppLink`
 * @更新时间 `2021-01-18 14:36:58`
 */
const goPcmMailSendAppLinkRequestConfig: GoPcmMailSendAppLinkRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_25,
    devUrl: devUrl_0_0_0_25,
    prodUrl: prodUrl_0_0_0_25,
    path: "/go/pcm/mail/SendAppLink",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_25,
    paramNames: [],
    queryNames: ["addr"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMailSendAppLink",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [发送Download Webnovel APP邮件↗](https://yapi.yuewen.com/project/2309/interface/api/191389) 的 **请求函数**
 *
 * @分类 [mailService↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25103)
 * @请求头 `POST /go/pcm/mail/SendAppLink`
 * @更新时间 `2021-01-18 14:36:58`
 */
export const goPcmMailSendAppLink = /*#__PURE__*/ (
  requestData: GoPcmMailSendAppLinkRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMailSendAppLinkResponse>(
    prepare(goPcmMailSendAppLinkRequestConfig, requestData),
    ...args
  );
};

goPcmMailSendAppLink.requestConfig = goPcmMailSendAppLinkRequestConfig;

const mockUrl_0_0_0_26 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_26 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_26 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_26 = "data" as any;

/**
 * 接口 [getRankConfig 获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/191396) 的 **请求类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankConfig`
 * @更新时间 `2021-01-18 19:54:11`
 */
export interface GoPcmCategoryGetRankConfigRequest {}

/**
 * 接口 [getRankConfig 获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/191396) 的 **返回类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankConfig`
 * @更新时间 `2021-01-18 19:54:11`
 */
export interface GoPcmCategoryGetRankConfigResponse {
  /**
   * [{"navName":"Novels","type":1,"configItems":[{"name":"Power","rankId":"power_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"Year","listType":2,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"HALF_YEAR","listType":3,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"QUARTER","listType":4,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"MONTH","listType":5,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4}]}],"defaultlistType":{"listTypeName":"HALF_YEAR","listType":3},"icon":"","displayAmount":1},{"name":"Collect","rankId":"collection_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Hot","rankId":"best_sellers","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"24h","timeType":5},{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"Year","listType":2,"timeRange":[{"timeName":"24h","timeType":5},{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"HALF_YEAR","listType":3,"timeRange":[{"timeName":"24h","timeType":5},{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"QUARTER","listType":4,"timeRange":[{"timeName":"24h","timeType":5},{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"HALF_YEAR","listType":3},"icon":"","displayAmount":0},{"name":"Update","rankId":"update_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Active","rankId":"engagement_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Fandom","rankId":"fandom_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Popular","rankId":"popular_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":0}]},{"navName":"Fan-fic","type":4,"configItems":[{"name":"Power","rankId":"power_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"Year","listType":2,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"HALF_YEAR","listType":3,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"QUARTER","listType":4,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"MONTH","listType":5,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4}]}],"defaultlistType":{"listTypeName":"HALF_YEAR","listType":3},"icon":"","displayAmount":1},{"name":"Collect","rankId":"collection_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Update","rankId":"update_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Active","rankId":"engagement_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Fandom","rankId":"fandom_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1}]},{"navName":"Comic","type":2,"configItems":[{"name":"Power","rankId":"power_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Collect","rankId":"collection_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Hot","rankId":"best_sellers","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"24h","timeType":5},{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":0},{"name":"Active","rankId":"engagement_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Popular","rankId":"popular_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":0},{"name":"Fandom","rankId":"fandom_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"New","rankId":"comic_new_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"In 2 weeks","timeType":3001}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":0}]},{"navName":"ebook","type":3,"configItems":[]}]
   */
  navItems?: {
    /**
     * "Novels"
     */
    navName?: string;
    /**
     * 1
     */
    type?: number;
    /**
     * [{"name":"Power","rankId":"power_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"Year","listType":2,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"HALF_YEAR","listType":3,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"QUARTER","listType":4,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"MONTH","listType":5,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4}]}],"defaultlistType":{"listTypeName":"HALF_YEAR","listType":3},"icon":"","displayAmount":1},{"name":"Collect","rankId":"collection_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Hot","rankId":"best_sellers","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"24h","timeType":5},{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"Year","listType":2,"timeRange":[{"timeName":"24h","timeType":5},{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"HALF_YEAR","listType":3,"timeRange":[{"timeName":"24h","timeType":5},{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"QUARTER","listType":4,"timeRange":[{"timeName":"24h","timeType":5},{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"HALF_YEAR","listType":3},"icon":"","displayAmount":0},{"name":"Update","rankId":"update_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Active","rankId":"engagement_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Fandom","rankId":"fandom_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":1},{"name":"Popular","rankId":"popular_rank","listTypeRange":[{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]}],"defaultlistType":{"listTypeName":"Total","listType":0},"icon":"","displayAmount":0}]
     */
    configItems?: {
      /**
       * "Power"
       */
      name?: string;
      /**
       * "power_rank"
       */
      rankId?: string;
      /**
       * [{"listTypeName":"Total","listType":0,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"Year","listType":2,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"HALF_YEAR","listType":3,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"QUARTER","listType":4,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]},{"listTypeName":"MONTH","listType":5,"timeRange":[{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4}]}]
       */
      listTypeRange?: {
        /**
         * "Total"
         */
        listTypeName?: string;
        listType?: number;
        /**
         * [{"timeName":"Weekly","timeType":3},{"timeName":"Monthly","timeType":4},{"timeName":"Total","timeType":1}]
         */
        timeRange?: {
          /**
           * "Weekly"
           */
          timeName?: string;
          /**
           * 3
           */
          timeType?: number;
        }[];
      }[];
      defaultlistType?: {
        /**
         * "HALF_YEAR"
         */
        listTypeName?: string;
        /**
         * 3
         */
        listType?: number;
      };
      icon?: string;
      /**
       * 1
       */
      displayAmount?: number;
    }[];
  }[];
}

/**
 * 接口 [getRankConfig 获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/191396) 的 **请求配置的类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankConfig`
 * @更新时间 `2021-01-18 19:54:11`
 */
type GoPcmCategoryGetRankConfigRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/category/getRankConfig",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [getRankConfig 获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/191396) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankConfig`
 * @更新时间 `2021-01-18 19:54:11`
 */
const goPcmCategoryGetRankConfigRequestConfig: GoPcmCategoryGetRankConfigRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/getRankConfig",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryGetRankConfig",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getRankConfig 获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/191396) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankConfig`
 * @更新时间 `2021-01-18 19:54:11`
 */
export const goPcmCategoryGetRankConfig = /*#__PURE__*/ (
  requestData?: GoPcmCategoryGetRankConfigRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmCategoryGetRankConfigResponse>(
    prepare(goPcmCategoryGetRankConfigRequestConfig, requestData),
    ...args
  );
};

goPcmCategoryGetRankConfig.requestConfig =
  goPcmCategoryGetRankConfigRequestConfig;

/**
 * 接口 [getRankList 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/191409) 的 **请求类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankList`
 * @更新时间 `2023-11-03 16:48:32`
 */
export interface GoPcmCategoryGetRankListRequest {
  /**
   *  TOTAL = 0, //总榜
   *      YEAR  =2, //年榜
   *      HALF_YEAR =3, //半年榜
   *      QUARTER =4,   //季榜
   *      MONTH =5     //月榜
   */
  listType?: string;
  type: string;
  rankId: string;
  timeType: string;
  pageIndex?: string;
  sourceType?: string;
  sex?: string;
  /**
   * 0:所有 1：签约 默认1 只有小说PS榜单有用
   */
  signStatus?: string;
}

/**
 * 接口 [getRankList 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/191409) 的 **返回类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankList`
 * @更新时间 `2023-11-03 16:48:32`
 */
export interface GoPcmCategoryGetRankListResponse {
  /**
   * [{"rankNo":1,"bookId":"8022472105002805","bookType":0,"bookName":"Super Gene","description":"In the magnificent interstellar era。","categoryId":70006,"categoryName":"Sci-fi","categoryType":1,"authorName":"Twelve-Winged Dark Seraphim","coverUpdateTime":1547697670957,"tagInfo":[{"tagId":41004299,"tagName":"GENES","likeCount":0,"like":false}],"amount":-1,"mtl":false,"inLibrary":0,"readToChapterId":0,"publishTime":1509521375000,"firstChapterId":"21637017498610114","firstChapterName":"Supergene"}]
   */
  bookItems?: {
    /**
     * 1
     */
    rankNo?: number;
    /**
     * "8022472105002805"
     */
    bookId?: string;
    bookType?: number;
    /**
     * "Super Gene"
     */
    bookName?: string;
    /**
     * "In the magnificent interstellar era。"
     */
    description?: string;
    /**
     * 70006
     */
    categoryId?: number;
    /**
     * "Sci-fi"
     */
    categoryName?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * "Twelve-Winged Dark Seraphim"
     */
    authorName?: string;
    /**
     * 1547697670957
     */
    coverUpdateTime?: number;
    /**
     * [{"tagId":41004299,"tagName":"GENES","likeCount":0,"like":false}]
     */
    tagInfo?: {
      /**
       * 41004299
       */
      tagId?: number;
      /**
       * "GENES"
       */
      tagName?: string;
      likeCount?: number;
      like?: boolean;
    }[];
    /**
     * -1
     */
    amount?: number;
    mtl?: boolean;
    inLibrary?: number;
    readToChapterId?: number;
    /**
     * 1509521375000
     */
    publishTime?: number;
    /**
     * "21637017498610114"
     */
    firstChapterId?: string;
    /**
     * "Supergene"
     */
    firstChapterName?: string;
  }[];
  last?: boolean;
  /**
   * 2
   */
  pageIndex?: number;
}

/**
 * 接口 [getRankList 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/191409) 的 **请求配置的类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankList`
 * @更新时间 `2023-11-03 16:48:32`
 */
type GoPcmCategoryGetRankListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/category/getRankList",
    "data",
    string,
    | "listType"
    | "type"
    | "rankId"
    | "timeType"
    | "pageIndex"
    | "sourceType"
    | "sex"
    | "signStatus",
    false
  >
>;

/**
 * 接口 [getRankList 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/191409) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankList`
 * @更新时间 `2023-11-03 16:48:32`
 */
const goPcmCategoryGetRankListRequestConfig: GoPcmCategoryGetRankListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/getRankList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [
      "listType",
      "type",
      "rankId",
      "timeType",
      "pageIndex",
      "sourceType",
      "sex",
      "signStatus",
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryGetRankList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getRankList 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/191409) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankList`
 * @更新时间 `2023-11-03 16:48:32`
 */
export const goPcmCategoryGetRankList = /*#__PURE__*/ (
  requestData: GoPcmCategoryGetRankListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmCategoryGetRankListResponse>(
    prepare(goPcmCategoryGetRankListRequestConfig, requestData),
    ...args
  );
};

goPcmCategoryGetRankList.requestConfig = goPcmCategoryGetRankListRequestConfig;

/**
 * 接口 [categoryPage 书库分类列表（带fanfic）↗](https://yapi.yuewen.com/project/2309/interface/api/192865) 的 **请求类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryPage`
 * @更新时间 `2021-02-22 13:47:02`
 */
export interface GoPcmCategoryCategoryPageRequest {
  /**
   * 1:小说 2：漫画 3：出版书 4：Fan-fic
   */
  categoryType: string;
  /**
   * 分类的id,支持多个，用逗号分隔
   */
  categoryId?: string;
  /**
   * 0:所有 1:翻译 2:原创 ， 只有小说有该选项
   */
  sourceType?: string;
  /**
   * 0:所有 1:ongoing 2:completed， 出版书无该选项
   */
  bookStatus?: string;
  /**
   * 1:Popular 2:Recommendation 3:Collection 4: Rates 5:Updated 默认1
   */
  orderBy?: string;
  pageIndex?: string;
  /**
   * 1男2女 默认全部
   */
  gender?: string;
  /**
   * 传多个时候，用逗号分割，具体对应的id看备注
   */
  chapterNum?: string;
  /**
   * 机翻书属性，默认0，机翻书传3
   */
  translateMode?: string;
  /**
   * 默认0      1-membership
   */
  priceType?: string;
}

/**
 * 接口 [categoryPage 书库分类列表（带fanfic）↗](https://yapi.yuewen.com/project/2309/interface/api/192865) 的 **返回类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryPage`
 * @更新时间 `2021-02-22 13:47:02`
 */
export interface GoPcmCategoryCategoryPageResponse {
  /**
   * [{"bookId":"18442599605691305","bookName":"Scion of Time Gaming System!","description":"Check out my other novel: Gaming Sword Magician\r\n\r\nFull of face slapping!\r\nThe slaps are so hard that you will feel and hear the echoing of the slaps!\r\n\r\nTime is always fleeting.\r\n\r\nBut what if the sands of time could be grasped in one's hand?\r\n\r\nMarvin is a senior high school boy that has awakened but lacks an ability.\r\n\r\nIn a world where weakling is handled as the strong wished, Marvin was bullied regularly.\r\n\r\nBut one day, he awakened a Gaming System and obtained the attribute of time!!!!!!\r\n\r\nEver Since that day, he climbed his way to the heavens. This is Marvin's adventure from being bullied to the peak of life.\r\n\r\nBeauties from all walks of life will fall in his embrace; be it a teacher, models, or a demonic vixen.\r\n\r\nThis is the story of Marvin, the godly gentleman conquering beauties, creating his harem, and becoming the absolute ruler of all!\r\n\r\n-------\r\n\r\nCheck out my other novel: Gaming Sword Magician!","categoryId":70012,"categoryName":"Martial Arts","authorName":"Lazy_leon","totalScore":"4.9","translateMode":-1,"coverUpdateTime":"1609226969429","tagInfo":[{"tagId":41000010,"tagName":"Romance"},{"tagId":41000858,"tagName":"TIME"}],"chapterNum":3,"inLibrary":1},{"bookId":"18755823705869305","bookName":"Hitman with a Badass System","description":"Have you ever thought about having a cool system at your disposal? What would you do if you suddenly received a system that can help you achieve anything? Would you go save the innocents and damsels in distress or use it for your own advantage? This is the story of a normal human (well, not very normal) who crossed over to another world with such a system under his command. But the question is, who’s controlling who? Is the system under his command or the other way around? What was the origin of this system? Why did it choose him? What’s waiting for him in the future? A hero is only as good as his villain? So who is the villain for our hero? Lots of questions right? Jump right into the book and see the answers for yourselves.\n\n\ndiscord link : https://discord.gg/zTgYV9x7gZ\nJoin my wonderful circle and be part of the book!!!","categoryId":70012,"categoryName":"Martial Arts","authorName":"don_offl","totalScore":"4.8","translateMode":-1,"coverUpdateTime":"1607600000982","tagInfo":[{"tagId":41000010,"tagName":"Romance"},{"tagId":51027458,"tagName":"Weak - Strong"}],"chapterNum":3,"inLibrary":1}]
   */
  items?: {
    /**
     * "18442599605691305"
     */
    bookId?: string;
    /**
     * "Scion of Time Gaming System!"
     */
    bookName?: string;
    /**
     * "Check out my other novel: Gaming Sword Magician\r\n\r\nFull of face slapping!\r\nThe slaps are so hard that you will feel and hear the echoing of the slaps!\r\n\r\nTime is always fleeting.\r\n\r\nBut what if the sands of time could be grasped in one's hand?\r\n\r\nMarvin is a senior high school boy that has awakened but lacks an ability.\r\n\r\nIn a world where weakling is handled as the strong wished, Marvin was bullied regularly.\r\n\r\nBut one day, he awakened a Gaming System and obtained the attribute of time!!!!!!\r\n\r\nEver Since that day, he climbed his way to the heavens. This is Marvin's adventure from being bullied to the peak of life.\r\n\r\nBeauties from all walks of life will fall in his embrace; be it a teacher, models, or a demonic vixen.\r\n\r\nThis is the story of Marvin, the godly gentleman conquering beauties, creating his harem, and becoming the absolute ruler of all!\r\n\r\n-------\r\n\r\nCheck out my other novel: Gaming Sword Magician!"
     */
    description?: string;
    /**
     * 70012
     */
    categoryId?: number;
    /**
     * "Martial Arts"
     */
    categoryName?: string;
    /**
     * "Lazy_leon"
     */
    authorName?: string;
    /**
     * "4.9"
     */
    totalScore?: string;
    /**
     * -1
     */
    translateMode?: number;
    /**
     * "1609226969429"
     */
    coverUpdateTime?: string;
    /**
     * [{"tagId":41000010,"tagName":"Romance"},{"tagId":41000858,"tagName":"TIME"}]
     */
    tagInfo?: {
      /**
       * 41000010
       */
      tagId?: number;
      /**
       * "Romance"
       */
      tagName?: string;
    }[];
    /**
     * 3
     */
    chapterNum?: number;
    /**
     * 1
     */
    inLibrary?: number;
  }[];
  /**
   * 1625
   */
  total?: number;
  isLast?: number;
  categoryItems?: {
    /**
     * [{"categoryId":70001,"categoryName":"Urban","bookInfos":[{"bookId":"12507348206677105","coverUpdateTime":1550542497780},{"bookId":"17763560106904805","coverUpdateTime":1611730805668}],"sexPreference":1,"totalCount":2348},{"categoryId":70019,"categoryName":"LGBT+","bookInfos":[{"bookId":"18291213705077005","coverUpdateTime":1607601379690},{"bookId":"13719703905965805","coverUpdateTime":1598633710682}],"sexPreference":2,"totalCount":1242}]
     */
    novelCategoryItems?: {
      /**
       * 70001
       */
      categoryId?: number;
      /**
       * "Urban"
       */
      categoryName?: string;
      /**
       * [{"bookId":"12507348206677105","coverUpdateTime":1550542497780},{"bookId":"17763560106904805","coverUpdateTime":1611730805668}]
       */
      bookInfos?: {
        /**
         * "12507348206677105"
         */
        bookId?: string;
        /**
         * 1550542497780
         */
        coverUpdateTime?: number;
      }[];
      /**
       * 1
       */
      sexPreference?: number;
      /**
       * 2348
       */
      totalCount?: number;
    }[];
    /**
     * [{"categoryId":70001,"categoryName":"Urban","bookInfos":[{"bookId":"12507348206677105","coverUpdateTime":1550542497780},{"bookId":"17763560106904805","coverUpdateTime":1611730805668}],"sexPreference":1,"totalCount":2348},{"categoryId":70019,"categoryName":"LGBT+","bookInfos":[{"bookId":"18291213705077005","coverUpdateTime":1607601379690},{"bookId":"13719703905965805","coverUpdateTime":1598633710682}],"sexPreference":2,"totalCount":1242}]
     */
    comicCategoryItems?: {
      /**
       * 70001
       */
      categoryId?: number;
      /**
       * "Urban"
       */
      categoryName?: string;
      /**
       * [{"bookId":"12507348206677105","coverUpdateTime":1550542497780},{"bookId":"17763560106904805","coverUpdateTime":1611730805668}]
       */
      bookInfos?: {
        /**
         * "12507348206677105"
         */
        bookId?: string;
        /**
         * 1550542497780
         */
        coverUpdateTime?: number;
      }[];
      /**
       * 1
       */
      sexPreference?: number;
      /**
       * 2348
       */
      totalCount?: number;
    }[];
    /**
     * [{"categoryId":70001,"categoryName":"Urban","bookInfos":[{"bookId":"12507348206677105","coverUpdateTime":1550542497780},{"bookId":"17763560106904805","coverUpdateTime":1611730805668}],"sexPreference":1,"totalCount":2348},{"categoryId":70019,"categoryName":"LGBT+","bookInfos":[{"bookId":"18291213705077005","coverUpdateTime":1607601379690},{"bookId":"13719703905965805","coverUpdateTime":1598633710682}],"sexPreference":2,"totalCount":1242}]
     */
    ebookCategoryItems?: {
      /**
       * 70001
       */
      categoryId?: number;
      /**
       * "Urban"
       */
      categoryName?: string;
      /**
       * [{"bookId":"12507348206677105","coverUpdateTime":1550542497780},{"bookId":"17763560106904805","coverUpdateTime":1611730805668}]
       */
      bookInfos?: {
        /**
         * "12507348206677105"
         */
        bookId?: string;
        /**
         * 1550542497780
         */
        coverUpdateTime?: number;
      }[];
      /**
       * 1
       */
      sexPreference?: number;
      /**
       * 2348
       */
      totalCount?: number;
    }[];
    /**
     * [{"categoryId":70001,"categoryName":"Urban","bookInfos":[{"bookId":"12507348206677105","coverUpdateTime":1550542497780},{"bookId":"17763560106904805","coverUpdateTime":1611730805668}],"sexPreference":1,"totalCount":2348},{"categoryId":70019,"categoryName":"LGBT+","bookInfos":[{"bookId":"18291213705077005","coverUpdateTime":1607601379690},{"bookId":"13719703905965805","coverUpdateTime":1598633710682}],"sexPreference":2,"totalCount":1242}]
     */
    fanficCategoryItems?: {
      /**
       * 70001
       */
      categoryId?: number;
      /**
       * "Urban"
       */
      categoryName?: string;
      /**
       * [{"bookId":"12507348206677105","coverUpdateTime":1550542497780},{"bookId":"17763560106904805","coverUpdateTime":1611730805668}]
       */
      bookInfos?: {
        /**
         * "12507348206677105"
         */
        bookId?: string;
        /**
         * 1550542497780
         */
        coverUpdateTime?: number;
      }[];
      /**
       * 1
       */
      sexPreference?: number;
      /**
       * 2348
       */
      totalCount?: number;
    }[];
  };
  /**
   * 1
   */
  categoryType?: number;
  /**
   * 1
   */
  gender?: number;
  /**
   * 1
   */
  orderBy?: number;
  bookStatus?: number;
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 1
   */
  sourceType?: number;
  /**
   * ["70011","70013","70012"]
   */
  categoryId?: string[];
  /**
   * ["1","2"]
   */
  chapterNum?: string[];
  priceType?: number;
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/3627871248/1/1.jpg?mt=1610637945000"
     */
    avatar?: string;
    /**
     * "dapenggaofei"
     */
    nickName?: string;
    /**
     * "dapenggaofei"
     */
    userName?: string;
    /**
     * "3627871248"
     */
    guid?: string;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * "dapenggaofei"
     */
    penName?: string;
    /**
     * 96
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 4
     */
    grade?: number;
    /**
     * 2
     */
    ES?: number;
    /**
     * 2
     */
    totalES?: number;
    /**
     * 3
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: boolean;
    /**
     * 1581297077449
     */
    UUT?: number;
    /**
     * 1
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    membershipStatus?: number;
    membershipExpireTime?: number;
    /**
     * true
     */
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [categoryPage 书库分类列表（带fanfic）↗](https://yapi.yuewen.com/project/2309/interface/api/192865) 的 **请求配置的类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryPage`
 * @更新时间 `2021-02-22 13:47:02`
 */
type GoPcmCategoryCategoryPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/category/categoryPage",
    "data",
    string,
    | "categoryType"
    | "categoryId"
    | "sourceType"
    | "bookStatus"
    | "orderBy"
    | "pageIndex"
    | "gender"
    | "chapterNum"
    | "translateMode"
    | "priceType",
    false
  >
>;

/**
 * 接口 [categoryPage 书库分类列表（带fanfic）↗](https://yapi.yuewen.com/project/2309/interface/api/192865) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryPage`
 * @更新时间 `2021-02-22 13:47:02`
 */
const goPcmCategoryCategoryPageRequestConfig: GoPcmCategoryCategoryPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/categoryPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [
      "categoryType",
      "categoryId",
      "sourceType",
      "bookStatus",
      "orderBy",
      "pageIndex",
      "gender",
      "chapterNum",
      "translateMode",
      "priceType",
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryCategoryPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [categoryPage 书库分类列表（带fanfic）↗](https://yapi.yuewen.com/project/2309/interface/api/192865) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryPage`
 * @更新时间 `2021-02-22 13:47:02`
 */
export const goPcmCategoryCategoryPage = /*#__PURE__*/ (
  requestData: GoPcmCategoryCategoryPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmCategoryCategoryPageResponse>(
    prepare(goPcmCategoryCategoryPageRequestConfig, requestData),
    ...args
  );
};

goPcmCategoryCategoryPage.requestConfig =
  goPcmCategoryCategoryPageRequestConfig;

/**
 * 接口 [categoryAjax 书库分类列表（带fanfic)↗](https://yapi.yuewen.com/project/2309/interface/api/192872) 的 **请求类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryAjax`
 * @更新时间 `2021-06-08 10:23:37`
 */
export interface GoPcmCategoryCategoryAjaxRequest {
  /**
   * 1:小说 2：漫画 3：出版书 4：Fan-fic
   */
  categoryType: string;
  /**
   * 分类的id,支持多个，用逗号分隔
   */
  categoryId?: string;
  /**
   * 0:所有 1:翻译 2:原创 ， 只有小说有该选项
   */
  sourceType?: string;
  /**
   * 0:所有 1:ongoing 2:completed， 出版书无该选项
   */
  bookStatus?: string;
  /**
   * 1:Popular 2:Recommendation 3:Collection 4: Rates 5:Updated 默认1
   */
  orderBy?: string;
  pageIndex?: string;
  /**
   * 1男2女
   */
  gender?: string;
  /**
   * 传多个时候，用逗号分割，具体对应的id看备注
   */
  chapterNum?: string;
  /**
   * 机翻书属性，默认0，机翻书传3
   */
  translateMode?: string;
  /**
   * 默认0      1-membership
   */
  priceType?: string;
}

/**
 * 接口 [categoryAjax 书库分类列表（带fanfic)↗](https://yapi.yuewen.com/project/2309/interface/api/192872) 的 **返回类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryAjax`
 * @更新时间 `2021-06-08 10:23:37`
 */
export interface GoPcmCategoryCategoryAjaxResponse {
  /**
   * [{"bookId":"9795126406003205","bookName":"Book of Events","description":"All WEBNOVEL official events will be recorded in this book. Every time you see the update, that means surprise and good things are getting ready for you!\r\n\r\nAdd 《Book of Events》to your library will help you to track the hottest events on Webnovel!\r\n\r\nEnjoy","categoryId":70001,"categoryName":"ACG","authorName":"WEBNOVEL","totalScore":3.4,"coverUpdateTime":"1560739390490","tagInfo":[],"translateMode":-1,"chapterNum":100,"inLibrary":1,"publishTime":1412092800000},{"bookId":"8057964805003305","bookName":"Book of Answers","description":"Qidian,  born in May of 2002, is currently the largest original web literature publisher. Her father, China Literature, although has greater hopes for her, such as being able to have grandchildren. So, in 2017, Qidian gave birth to Webnovel, and Webnovel has been growing very quickly ever since.  \r\nAs Webnovel matures, she became more sophisticated and a lot harder to read. As a result, this book was written to help you understand her better, hoping that both readers at Webnovel will have a great and smooth experience together. ","categoryId":70001,"categoryName":"ACG","authorName":"QIDIAN","totalScore":4.1,"coverUpdateTime":"1548301476787","tagInfo":[{"tagId":464,"tagName":"HELP"}],"translateMode":-1,"chapterNum":100,"inLibrary":1,"publishTime":1412092800000}]
   */
  items?: {
    /**
     * "9795126406003205"
     */
    bookId?: string;
    /**
     * "Book of Events"
     */
    bookName?: string;
    /**
     * "All WEBNOVEL official events will be recorded in this book. Every time you see the update, that means surprise and good things are getting ready for you!\r\n\r\nAdd 《Book of Events》to your library will help you to track the hottest events on Webnovel!\r\n\r\nEnjoy"
     */
    description?: string;
    /**
     * 70001
     */
    categoryId?: number;
    /**
     * "ACG"
     */
    categoryName?: string;
    /**
     * "WEBNOVEL"
     */
    authorName?: string;
    /**
     * 3.4
     */
    totalScore?: number;
    /**
     * "1560739390490"
     */
    coverUpdateTime?: string;
    /**
     * []
     */
    tagInfo?: unknown[];
    /**
     * -1
     */
    translateMode?: number;
    /**
     * 100
     */
    chapterNum?: number;
    /**
     * 1
     */
    inLibrary?: number;
    /**
     * 1412092800000
     */
    publishTime?: number;
  }[];
  /**
   * 2
   */
  total?: number;
  /**
   * 1
   */
  isLast?: number;
  /**
   * 1
   */
  orderBy?: number;
  /**
   * ["70011","70002"]
   */
  categoryId?: string[];
  /**
   * 1
   */
  pageIndex?: number;
  bookStatus?: number;
  /**
   * 1
   */
  priceType?: number;
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300000889/1/1.jpg?mt=1609324312000"
     */
    avatar?: string;
    /**
     * "yabger"
     */
    nickName?: string;
    /**
     * "yabger"
     */
    userName?: string;
    /**
     * "4300000889"
     */
    guid?: string;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * "yabger"
     */
    penName?: string;
    /**
     * 10686
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 4
     */
    grade?: number;
    /**
     * 2
     */
    ES?: number;
    /**
     * 2
     */
    totalES?: number;
    /**
     * 3
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: boolean;
    /**
     * 1599056425650
     */
    UUT?: number;
    /**
     * 48
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 2
     */
    membershipStatus?: number;
    /**
     * 1609310006000
     */
    membershipExpireTime?: number;
    /**
     * true
     */
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [categoryAjax 书库分类列表（带fanfic)↗](https://yapi.yuewen.com/project/2309/interface/api/192872) 的 **请求配置的类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryAjax`
 * @更新时间 `2021-06-08 10:23:37`
 */
type GoPcmCategoryCategoryAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/category/categoryAjax",
    "data",
    string,
    | "categoryType"
    | "categoryId"
    | "sourceType"
    | "bookStatus"
    | "orderBy"
    | "pageIndex"
    | "gender"
    | "chapterNum"
    | "translateMode"
    | "priceType",
    false
  >
>;

/**
 * 接口 [categoryAjax 书库分类列表（带fanfic)↗](https://yapi.yuewen.com/project/2309/interface/api/192872) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryAjax`
 * @更新时间 `2021-06-08 10:23:37`
 */
const goPcmCategoryCategoryAjaxRequestConfig: GoPcmCategoryCategoryAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/categoryAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [
      "categoryType",
      "categoryId",
      "sourceType",
      "bookStatus",
      "orderBy",
      "pageIndex",
      "gender",
      "chapterNum",
      "translateMode",
      "priceType",
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryCategoryAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [categoryAjax 书库分类列表（带fanfic)↗](https://yapi.yuewen.com/project/2309/interface/api/192872) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryAjax`
 * @更新时间 `2021-06-08 10:23:37`
 */
export const goPcmCategoryCategoryAjax = /*#__PURE__*/ (
  requestData: GoPcmCategoryCategoryAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmCategoryCategoryAjaxResponse>(
    prepare(goPcmCategoryCategoryAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmCategoryCategoryAjax.requestConfig =
  goPcmCategoryCategoryAjaxRequestConfig;

/**
 * 接口 [getRankCollections 获取书库榜单集合 （PC用）↗](https://yapi.yuewen.com/project/2309/interface/api/192993) 的 **请求类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `POST /go/pcm/category/getRankCollections`
 * @更新时间 `2021-02-01 19:12:58`
 */
export interface GoPcmCategoryGetRankCollectionsRequest {}

/**
 * 接口 [getRankCollections 获取书库榜单集合 （PC用）↗](https://yapi.yuewen.com/project/2309/interface/api/192993) 的 **返回类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `POST /go/pcm/category/getRankCollections`
 * @更新时间 `2021-02-01 19:12:58`
 */
export interface GoPcmCategoryGetRankCollectionsResponse {
  /**
   * [{"rankNo":1,"bookId":1,"bookType":1,"bookName":"@string","categoryId":1,"categoryName":"@string","categoryType":1,"authorName":"@string","coverUpdateTime":"@timestamp","amount":1,"mtl":true,"inLibrary":0}]
   */
  best_sellers_HALF_YEAR?: {
    /**
     * 1
     */
    rankNo?: number;
    /**
     * 1
     */
    bookId?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * "@string"
     */
    bookName?: string;
    /**
     * 1
     */
    categoryId?: number;
    /**
     * "@string"
     */
    categoryName?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * "@string"
     */
    authorName?: string;
    /**
     * "@timestamp"
     */
    coverUpdateTime?: string;
    /**
     * 1
     */
    amount?: number;
    /**
     * true
     */
    mtl?: boolean;
    inLibrary?: number;
  }[];
  /**
   * [{"rankNo":1,"bookId":1,"bookType":1,"bookName":"@string","categoryId":1,"categoryName":"@string","categoryType":1,"authorName":"@string","coverUpdateTime":"@timestamp","amount":1,"mtl":true,"inLibrary":0}]
   */
  best_sellers_QUARTER?: {
    /**
     * 1
     */
    rankNo?: number;
    /**
     * 1
     */
    bookId?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * "@string"
     */
    bookName?: string;
    /**
     * 1
     */
    categoryId?: number;
    /**
     * "@string"
     */
    categoryName?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * "@string"
     */
    authorName?: string;
    /**
     * "@timestamp"
     */
    coverUpdateTime?: string;
    /**
     * 1
     */
    amount?: number;
    /**
     * true
     */
    mtl?: boolean;
    inLibrary?: number;
  }[];
  /**
   * [{"rankNo":1,"bookId":1,"bookType":1,"bookName":"@string","categoryId":1,"categoryName":"@string","categoryType":1,"authorName":"@string","coverUpdateTime":"@timestamp","amount":1,"mtl":true,"inLibrary":0}]
   */
  best_sellers_YEAR?: {
    /**
     * 1
     */
    rankNo?: number;
    /**
     * 1
     */
    bookId?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * "@string"
     */
    bookName?: string;
    /**
     * 1
     */
    categoryId?: number;
    /**
     * "@string"
     */
    categoryName?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * "@string"
     */
    authorName?: string;
    /**
     * "@timestamp"
     */
    coverUpdateTime?: string;
    /**
     * 1
     */
    amount?: number;
    /**
     * true
     */
    mtl?: boolean;
    inLibrary?: number;
  }[];
  /**
   * [{"rankNo":1,"bookId":1,"bookType":1,"bookName":"@string","categoryId":1,"categoryName":"@string","categoryType":1,"authorName":"@string","coverUpdateTime":"@timestamp","amount":1,"mtl":true,"inLibrary":0}]
   */
  power_rank_HALF_YEAR?: {
    /**
     * 1
     */
    rankNo?: number;
    /**
     * 1
     */
    bookId?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * "@string"
     */
    bookName?: string;
    /**
     * 1
     */
    categoryId?: number;
    /**
     * "@string"
     */
    categoryName?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * "@string"
     */
    authorName?: string;
    /**
     * "@timestamp"
     */
    coverUpdateTime?: string;
    /**
     * 1
     */
    amount?: number;
    /**
     * true
     */
    mtl?: boolean;
    inLibrary?: number;
  }[];
  /**
   * [{"rankNo":1,"bookId":1,"bookType":1,"bookName":"@string","categoryId":1,"categoryName":"@string","categoryType":1,"authorName":"@string","coverUpdateTime":"@timestamp","amount":1,"mtl":true,"inLibrary":0}]
   */
  power_rank_QUARTER?: {
    /**
     * 1
     */
    rankNo?: number;
    /**
     * 1
     */
    bookId?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * "@string"
     */
    bookName?: string;
    /**
     * 1
     */
    categoryId?: number;
    /**
     * "@string"
     */
    categoryName?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * "@string"
     */
    authorName?: string;
    /**
     * "@timestamp"
     */
    coverUpdateTime?: string;
    /**
     * 1
     */
    amount?: number;
    /**
     * true
     */
    mtl?: boolean;
    inLibrary?: number;
  }[];
  /**
   * [{"rankNo":1,"bookId":1,"bookType":1,"bookName":"@string","categoryId":1,"categoryName":"@string","categoryType":1,"authorName":"@string","coverUpdateTime":"@timestamp","amount":1,"mtl":true,"inLibrary":0}]
   */
  power_rank_YEAR?: {
    /**
     * 1
     */
    rankNo?: number;
    /**
     * 1
     */
    bookId?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * "@string"
     */
    bookName?: string;
    /**
     * 1
     */
    categoryId?: number;
    /**
     * "@string"
     */
    categoryName?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * "@string"
     */
    authorName?: string;
    /**
     * "@timestamp"
     */
    coverUpdateTime?: string;
    /**
     * 1
     */
    amount?: number;
    /**
     * true
     */
    mtl?: boolean;
    inLibrary?: number;
  }[];
}

/**
 * 接口 [getRankCollections 获取书库榜单集合 （PC用）↗](https://yapi.yuewen.com/project/2309/interface/api/192993) 的 **请求配置的类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `POST /go/pcm/category/getRankCollections`
 * @更新时间 `2021-02-01 19:12:58`
 */
type GoPcmCategoryGetRankCollectionsRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/category/getRankCollections",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [getRankCollections 获取书库榜单集合 （PC用）↗](https://yapi.yuewen.com/project/2309/interface/api/192993) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `POST /go/pcm/category/getRankCollections`
 * @更新时间 `2021-02-01 19:12:58`
 */
const goPcmCategoryGetRankCollectionsRequestConfig: GoPcmCategoryGetRankCollectionsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/getRankCollections",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryGetRankCollections",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getRankCollections 获取书库榜单集合 （PC用）↗](https://yapi.yuewen.com/project/2309/interface/api/192993) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `POST /go/pcm/category/getRankCollections`
 * @更新时间 `2021-02-01 19:12:58`
 */
export const goPcmCategoryGetRankCollections = /*#__PURE__*/ (
  requestData?: GoPcmCategoryGetRankCollectionsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmCategoryGetRankCollectionsResponse>(
    prepare(goPcmCategoryGetRankCollectionsRequestConfig, requestData),
    ...args
  );
};

goPcmCategoryGetRankCollections.requestConfig =
  goPcmCategoryGetRankCollectionsRequestConfig;

/**
 * 接口 [getRankListPage 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/196567) 的 **请求类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankListPage`
 * @更新时间 `2021-06-08 10:24:50`
 */
export interface GoPcmCategoryGetRankListPageRequest {
  /**
   *  TOTAL = 0, //总榜
   *      YEAR  =2, //年榜
   *      HALF_YEAR =3, //半年榜
   *      QUARTER =4,   //季榜
   *      MONTH =5     //月榜
   */
  listType?: string;
  type: string;
  rankId: string;
  timeType: string;
  pageIndex?: string;
  sourceType?: string;
  sex?: string;
  signStatus?: string;
}

/**
 * 接口 [getRankListPage 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/196567) 的 **返回类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankListPage`
 * @更新时间 `2021-06-08 10:24:50`
 */
export interface GoPcmCategoryGetRankListPageResponse {
  /**
   * [{"rankNo":1,"bookId":1,"bookType":1,"bookName":"@string","description":"@string","categoryId":1,"categoryName":"@string","categoryType":1,"authorName":"@string","coverUpdateTime":"@timestamp","amount":1,"mtl":true,"inLibrary":0,"readToChapterId":1,"tagInfos":[{"tagId":41000010,"tagName":"ROMANCE","likeNums":1128,"isLiked":0}],"publishTime":1412092800000}]
   */
  bookItems?: {
    /**
     * 1
     */
    rankNo?: number;
    /**
     * 1
     */
    bookId?: number;
    /**
     * 1
     */
    bookType?: number;
    /**
     * "@string"
     */
    bookName?: string;
    /**
     * "@string"
     */
    description?: string;
    /**
     * 1
     */
    categoryId?: number;
    /**
     * "@string"
     */
    categoryName?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * "@string"
     */
    authorName?: string;
    /**
     * "@timestamp"
     */
    coverUpdateTime?: string;
    /**
     * 1
     */
    amount?: number;
    /**
     * true
     */
    mtl?: boolean;
    inLibrary?: number;
    /**
     * 1
     */
    readToChapterId?: number;
    /**
     * [{"tagId":41000010,"tagName":"ROMANCE","likeNums":1128,"isLiked":0}]
     */
    tagInfos?: {
      /**
       * 41000010
       */
      tagId?: number;
      /**
       * "ROMANCE"
       */
      tagName?: string;
      /**
       * 1128
       */
      likeNums?: number;
      isLiked?: number;
    }[];
    /**
     * 1412092800000
     */
    publishTime?: number;
  }[];
  /**
   * true
   */
  last?: boolean;
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/3627871248/1/1.jpg?mt=1610637945000"
     */
    avatar?: string;
    /**
     * "dapenggaofei"
     */
    nickName?: string;
    /**
     * "dapenggaofei"
     */
    userName?: string;
    /**
     * "3627871248"
     */
    guid?: string;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * "dapenggaofei"
     */
    penName?: string;
    /**
     * 96
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 4
     */
    grade?: number;
    /**
     * 2
     */
    ES?: number;
    /**
     * 2
     */
    totalES?: number;
    /**
     * 3
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: boolean;
    /**
     * 1581297077449
     */
    UUT?: number;
    /**
     * 1
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    membershipStatus?: number;
    membershipExpireTime?: number;
    /**
     * true
     */
    membershipClaimStatus?: boolean;
  };
}

/**
 * 接口 [getRankListPage 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/196567) 的 **请求配置的类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankListPage`
 * @更新时间 `2021-06-08 10:24:50`
 */
type GoPcmCategoryGetRankListPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/category/getRankListPage",
    "data",
    string,
    | "listType"
    | "type"
    | "rankId"
    | "timeType"
    | "pageIndex"
    | "sourceType"
    | "sex"
    | "signStatus",
    false
  >
>;

/**
 * 接口 [getRankListPage 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/196567) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankListPage`
 * @更新时间 `2021-06-08 10:24:50`
 */
const goPcmCategoryGetRankListPageRequestConfig: GoPcmCategoryGetRankListPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/getRankListPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [
      "listType",
      "type",
      "rankId",
      "timeType",
      "pageIndex",
      "sourceType",
      "sex",
      "signStatus",
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryGetRankListPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getRankListPage 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/196567) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankListPage`
 * @更新时间 `2021-06-08 10:24:50`
 */
export const goPcmCategoryGetRankListPage = /*#__PURE__*/ (
  requestData: GoPcmCategoryGetRankListPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmCategoryGetRankListPageResponse>(
    prepare(goPcmCategoryGetRankListPageRequestConfig, requestData),
    ...args
  );
};

goPcmCategoryGetRankListPage.requestConfig =
  goPcmCategoryGetRankListPageRequestConfig;

/**
 * 接口 [根据TYPE获取分类列表, 默认给全部↗](https://yapi.yuewen.com/project/2309/interface/api/207086) 的 **请求类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getCategories`
 * @更新时间 `2021-04-28 19:49:34`
 */
export interface GoPcmCategoryGetCategoriesRequest {
  /**
   * 1：小说 2：漫画 3：出版书 4：fan-fic,传0或者默认拿全部分类
   */
  categoryType: string;
  /**
   * 0全部 1男 2女 只有小说用得到，小说分男女频
   */
  gender: string;
}

/**
 * 接口 [根据TYPE获取分类列表, 默认给全部↗](https://yapi.yuewen.com/project/2309/interface/api/207086) 的 **返回类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getCategories`
 * @更新时间 `2021-04-28 19:49:34`
 */
export interface GoPcmCategoryGetCategoriesResponse {
  /**
   * [{"categoryId":70001,"categoryName":"Urban","bookInfos":[{"bookId":17051568301042704,"bookCoverId":1590557388309,"coverUpdateTime":1590557388309},{"bookId":16766325901033104,"bookCoverId":1587705168051,"coverUpdateTime":1587705168051}],"sexPreference":1,"totalCount":254},{"categoryId":70009,"categoryName":"Eastern","bookInfos":[{"bookId":15238802401141204,"bookCoverId":0,"coverUpdateTime":0},{"bookId":10486246401027204,"bookCoverId":1581421906932,"coverUpdateTime":1581421906932}],"sexPreference":1,"totalCount":7},{"categoryId":70008,"categoryName":"Games","bookInfos":[{"bookId":17102108201043804,"bookCoverId":1617000678843,"coverUpdateTime":1617000678843},{"bookId":7366916601012405,"bookCoverId":1581418734974,"coverUpdateTime":1581418734974}],"sexPreference":1,"totalCount":8},{"categoryId":70002,"categoryName":"Fantasy","bookInfos":[{"bookId":15808062201154804,"bookCoverId":1578295924712,"coverUpdateTime":1578295924712},{"bookId":14496471601071504,"bookCoverId":1581421911833,"coverUpdateTime":1581421911833}],"sexPreference":1,"totalCount":154},{"categoryId":70006,"categoryName":"Sci-fi","bookInfos":[{"bookId":18746587401100604,"bookCoverId":1607508056878,"coverUpdateTime":1607508056878},{"bookId":18694772701094704,"bookCoverId":1606989713076,"coverUpdateTime":1606989713076}],"sexPreference":1,"totalCount":21},{"categoryId":70011,"categoryName":"ACG","bookInfos":[{"bookId":11167065501001904,"bookCoverId":1582767643981,"coverUpdateTime":1582767643981},{"bookId":19066627501109904,"bookCoverId":1610707882872,"coverUpdateTime":1610707882872}],"sexPreference":1,"totalCount":7},{"categoryId":70004,"categoryName":"Horror","bookInfos":[{"bookId":16747764401030404,"bookCoverId":1587560483060,"coverUpdateTime":1587560483060},{"bookId":14616896001084804,"bookCoverId":1579069876138,"coverUpdateTime":1579069876138}],"sexPreference":1,"totalCount":53},{"categoryId":70007,"categoryName":"Sports","bookInfos":[{"bookId":17406229901053304,"bookCoverId":1594108883586,"coverUpdateTime":1594108883586},{"bookId":11529623001011104,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":13},{"categoryId":70012,"categoryName":"Action","bookInfos":[{"bookId":14391628101068104,"bookCoverId":1581421909021,"coverUpdateTime":1581421909021},{"bookId":13743148801051104,"bookCoverId":1581421928647,"coverUpdateTime":1581421928647}],"sexPreference":1,"totalCount":4},{"categoryId":70013,"categoryName":"War","bookInfos":[{"bookId":11427597601008104,"bookCoverId":0,"coverUpdateTime":0},{"bookId":10234821601022104,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":5},{"categoryId":70010,"categoryName":"Realistic","bookInfos":[{"bookId":13743109901051004,"bookCoverId":0,"coverUpdateTime":0},{"bookId":11652585501014004,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":6},{"categoryId":70003,"categoryName":"History","bookInfos":[{"bookId":12318653501032104,"bookCoverId":1581421906332,"coverUpdateTime":1581421906332},{"bookId":11202729001002904,"bookCoverId":0,"coverUpdateTime":0}],"sexPreference":1,"totalCount":147}]
   */
  categoryItems?: {
    /**
     * 70001
     */
    categoryId?: number;
    /**
     * "Urban"
     */
    categoryName?: string;
    /**
     * [{"bookId":17051568301042704,"bookCoverId":1590557388309,"coverUpdateTime":1590557388309},{"bookId":16766325901033104,"bookCoverId":1587705168051,"coverUpdateTime":1587705168051}]
     */
    bookInfos?: {
      /**
       * 17051568301042704
       */
      bookId?: number;
      /**
       * 1590557388309
       */
      bookCoverId?: number;
      /**
       * 1590557388309
       */
      coverUpdateTime?: number;
    }[];
    /**
     * 1
     */
    sexPreference?: number;
    /**
     * 254
     */
    totalCount?: number;
  }[];
  /**
   * 1
   */
  categoryType?: number;
}

/**
 * 接口 [根据TYPE获取分类列表, 默认给全部↗](https://yapi.yuewen.com/project/2309/interface/api/207086) 的 **请求配置的类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getCategories`
 * @更新时间 `2021-04-28 19:49:34`
 */
type GoPcmCategoryGetCategoriesRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/category/getCategories",
    "data",
    string,
    "categoryType" | "gender",
    false
  >
>;

/**
 * 接口 [根据TYPE获取分类列表, 默认给全部↗](https://yapi.yuewen.com/project/2309/interface/api/207086) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getCategories`
 * @更新时间 `2021-04-28 19:49:34`
 */
const goPcmCategoryGetCategoriesRequestConfig: GoPcmCategoryGetCategoriesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/getCategories",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: ["categoryType", "gender"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryGetCategories",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [根据TYPE获取分类列表, 默认给全部↗](https://yapi.yuewen.com/project/2309/interface/api/207086) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getCategories`
 * @更新时间 `2021-04-28 19:49:34`
 */
export const goPcmCategoryGetCategories = /*#__PURE__*/ (
  requestData: GoPcmCategoryGetCategoriesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmCategoryGetCategoriesResponse>(
    prepare(goPcmCategoryGetCategoriesRequestConfig, requestData),
    ...args
  );
};

goPcmCategoryGetCategories.requestConfig =
  goPcmCategoryGetCategoriesRequestConfig;

/**
 * 接口 [GetAllAjax  获取所有的分类 名称+bookid↗](https://yapi.yuewen.com/project/2309/interface/api/207427) 的 **请求类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getAllAjax`
 * @更新时间 `2021-05-11 16:23:23`
 */
export interface GoPcmCategoryGetAllAjaxRequest {}

/**
 * 接口 [GetAllAjax  获取所有的分类 名称+bookid↗](https://yapi.yuewen.com/project/2309/interface/api/207427) 的 **返回类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getAllAjax`
 * @更新时间 `2021-05-11 16:23:23`
 */
export interface GoPcmCategoryGetAllAjaxResponse {
  /**
   * [{"categoryId":70001,"categoryName":"Magical Realism","bookId":10380534501024504},{"categoryId":70003,"categoryName":"History","bookId":11987368201024204},{"categoryId":70002,"categoryName":"Fantasy","bookId":11653617901014304},{"categoryId":70005,"categoryName":"Romance","bookId":12222676701029504},{"categoryId":70004,"categoryName":"Horror&Thriller","bookId":11652753801014204},{"categoryId":70007,"categoryName":"Competitive Sports","bookId":12197488601029104},{"categoryId":70006,"categoryName":"Sci-fi","bookId":12335339401035104},{"categoryId":70009,"categoryName":"Eastern Fantasy","bookId":10486246401027204},{"categoryId":70008,"categoryName":"Video Games","bookId":11686410601018704},{"categoryId":70011,"categoryName":"ACG","bookId":14399165701068304},{"categoryId":70010,"categoryName":"Realistic Fiction","bookId":7479922501012705},{"categoryId":70013,"categoryName":"War&Military","bookId":10234821601022104},{"categoryId":70012,"categoryName":"Martial Arts","bookId":10390463201026004}]
   */
  items?: {
    /**
     * 70001
     */
    categoryId?: number;
    /**
     * "Magical Realism"
     */
    categoryName?: string;
    /**
     * 10380534501024504
     */
    bookId?: number;
  }[];
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300012720/1/1.jpg?mt=1608694770961"
     */
    avatar?: string;
    /**
     * "peter"
     */
    nickName?: string;
    /**
     * "peter"
     */
    userName?: string;
    /**
     * "peter"
     */
    authorName?: string;
    /**
     * "peter"
     */
    penName?: string;
    /**
     * 4300012720
     */
    guid?: number;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * 1
     */
    gender?: number;
    /**
     * 9985
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    /**
     * 14
     */
    bSS?: number;
    /**
     * 1637251200000
     */
    expiringTime?: number;
    /**
     * 1
     */
    grade?: number;
    /**
     * 1
     */
    ES?: number;
    /**
     * 1
     */
    totalES?: number;
    /**
     * 1
     */
    PS?: number;
    /**
     * 1
     */
    totalPS?: number;
    /**
     * "402374739@qq.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: number;
    /**
     * 1608694770961
     */
    UUT?: number;
    /**
     * 1
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 1
     */
    membershipStatus?: number;
    /**
     * 1622882786000
     */
    membershipExpireTime?: number;
    membershipClaimStatus?: boolean;
    /**
     * true
     */
    membershipIsFree?: boolean;
  };
}

/**
 * 接口 [GetAllAjax  获取所有的分类 名称+bookid↗](https://yapi.yuewen.com/project/2309/interface/api/207427) 的 **请求配置的类型**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getAllAjax`
 * @更新时间 `2021-05-11 16:23:23`
 */
type GoPcmCategoryGetAllAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/category/getAllAjax",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [GetAllAjax  获取所有的分类 名称+bookid↗](https://yapi.yuewen.com/project/2309/interface/api/207427) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getAllAjax`
 * @更新时间 `2021-05-11 16:23:23`
 */
const goPcmCategoryGetAllAjaxRequestConfig: GoPcmCategoryGetAllAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/getAllAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryGetAllAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [GetAllAjax  获取所有的分类 名称+bookid↗](https://yapi.yuewen.com/project/2309/interface/api/207427) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getAllAjax`
 * @更新时间 `2021-05-11 16:23:23`
 */
export const goPcmCategoryGetAllAjax = /*#__PURE__*/ (
  requestData?: GoPcmCategoryGetAllAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmCategoryGetAllAjaxResponse>(
    prepare(goPcmCategoryGetAllAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmCategoryGetAllAjax.requestConfig = goPcmCategoryGetAllAjaxRequestConfig;

const mockUrl_0_0_0_27 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_27 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_27 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_27 = "data" as any;

/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/2309/interface/api/191937) 的 **请求类型**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRankingList`
 * @更新时间 `2021-01-20 14:28:14`
 */
export interface GoPcmFansGetBookFansRankingListRequest {
  /**
   * 书籍 ID
   */
  bookId: string;
  /**
   * 默认 1
   */
  pageIndex: string;
}

/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/2309/interface/api/191937) 的 **返回类型**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRankingList`
 * @更新时间 `2021-01-20 14:28:14`
 */
export interface GoPcmFansGetBookFansRankingListResponse {
  /**
   * [{"userId":0,"ranking":1,"appId":0,"votingCount":65452},{"userId":4300000218,"ranking":2,"appId":10,"votingCount":37746,"UUT":1550460057000,"userName":"yuewentester1024"},{"userId":1520658766,"ranking":3,"appId":10,"votingCount":7510,"UUT":1552648459000,"userName":"webnoveltest123"},{"userId":3968405415,"ranking":4,"appId":10,"UUT":1530701317000,"userName":"jennyrenjialele5"},{"userId":1059463888,"ranking":5,"appId":10,"UUT":1542710966000,"userName":"xujin0515"},{"userId":101087995,"ranking":6,"appId":10,"UUT":1539950384000,"userName":"garden6cg"},{"userId":4300000467,"ranking":7,"appId":10,"UUT":1550221196000,"userName":"fourautumn1024"},{"userId":2959616949,"ranking":8,"appId":10,"UUT":1539936723000,"userName":"Eason057"},{"userId":41830698,"ranking":9,"appId":10,"UUT":1551407418000,"userName":"clarkzhangss"},{"userId":1901271742,"ranking":10,"appId":10,"UUT":1554260602000,"userName":"testingya"},{"userId":2140464915,"ranking":11,"appId":10,"UUT":1555470925000,"userName":"1231"},{"userId":4300000437,"ranking":12,"appId":10,"UUT":1527132787000,"userName":"LANEYU"},{"userId":4300000120,"ranking":13,"appId":10,"UUT":1554286185000,"userName":"bigcat004"},{"userId":4300000390,"ranking":14,"appId":10,"UUT":1547805199000,"userName":"Candy"},{"userId":4300000535,"ranking":15,"appId":10,"UUT":1554968876000,"userName":"Clementine"},{"userId":4300000208,"ranking":16,"appId":10,"UUT":1532690675000,"userName":"lily7"},{"userId":4300000431,"ranking":17,"appId":10,"UUT":1529404645377,"userName":"zhouxiyuan"},{"userId":3093119117,"ranking":18,"appId":10,"UUT":1555987639000,"userName":"zyftest"},{"userId":4300000213,"ranking":19,"appId":10,"UUT":1547607296000,"userName":"taozi"},{"userId":2760955332,"ranking":20,"appId":10,"UUT":1516946520000,"userName":"QStack"},{"userId":2140047512,"ranking":21,"appId":10,"UUT":1527044971000,"userName":"Eeee"},{"userId":4300000215,"ranking":22,"appId":10,"UUT":1547523864000,"userName":"Cinnamoroll"},{"userId":3892951244,"ranking":23,"appId":10,"UUT":1509601774217,"userName":"clark"},{"userId":4300000429,"ranking":24,"appId":10,"UUT":1542102687000,"userName":"xixi"},{"userId":4060368390,"ranking":25,"appId":10,"UUT":1548308522000,"userName":"Amy4060368390y"},{"userId":2223904916,"ranking":26,"appId":10,"UUT":1506600937142,"userName":"yuewen"},{"userId":4300000246,"ranking":27,"appId":10,"UUT":1534487506000,"userName":"dsr"},{"userId":4300001087,"ranking":28,"appId":10,"UUT":1544601130000,"userName":"Candy_hd001"},{"userId":4300000427,"ranking":29,"appId":10,"UUT":1547522817000,"userName":"term"},{"userId":689890031,"ranking":30,"appId":10,"UUT":1532518708000,"userName":"Jose"}]
   */
  items?: {
    userId?: number;
    /**
     * 1
     */
    ranking?: number;
    appId?: number;
    /**
     * 65452
     */
    votingCount?: number;
  }[];
  my?: {
    /**
     * 755
     */
    votingCount?: number;
    /**
     * 13
     */
    ranking?: number;
  };
  /**
   * 63
   */
  total?: number;
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 30
   */
  pageSize?: number;
  isLast?: number;
}

/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/2309/interface/api/191937) 的 **请求配置的类型**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRankingList`
 * @更新时间 `2021-01-20 14:28:14`
 */
type GoPcmFansGetBookFansRankingListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/fans/getBookFansRankingList",
    "data",
    string,
    "bookId" | "pageIndex",
    false
  >
>;

/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/2309/interface/api/191937) 的 **请求配置**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRankingList`
 * @更新时间 `2021-01-20 14:28:14`
 */
const goPcmFansGetBookFansRankingListRequestConfig: GoPcmFansGetBookFansRankingListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_27,
    devUrl: devUrl_0_0_0_27,
    prodUrl: prodUrl_0_0_0_27,
    path: "/go/pcm/fans/getBookFansRankingList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_27,
    paramNames: [],
    queryNames: ["bookId", "pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmFansGetBookFansRankingList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/2309/interface/api/191937) 的 **请求函数**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRankingList`
 * @更新时间 `2021-01-20 14:28:14`
 */
export const goPcmFansGetBookFansRankingList = /*#__PURE__*/ (
  requestData: GoPcmFansGetBookFansRankingListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmFansGetBookFansRankingListResponse>(
    prepare(goPcmFansGetBookFansRankingListRequestConfig, requestData),
    ...args
  );
};

goPcmFansGetBookFansRankingList.requestConfig =
  goPcmFansGetBookFansRankingListRequestConfig;

/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/2309/interface/api/191951) 的 **请求类型**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRanking`
 * @更新时间 `2021-04-29 17:12:28`
 */
export interface GoPcmFansGetBookFansRankingRequest {
  /**
   * 书籍 ID
   */
  bookId: string;
  /**
   * 默认 1
   */
  pageIndex: string;
}

/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/2309/interface/api/191951) 的 **返回类型**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRanking`
 * @更新时间 `2021-04-29 17:12:28`
 */
export interface GoPcmFansGetBookFansRankingResponse {
  /**
   * "7366916601012405"
   */
  bookId?: string;
  /**
   * "@string"
   */
  bookName?: string;
  /**
   * [{"userId":0,"ranking":1,"appId":0,"votingCount":65452},{"userId":4300000218,"ranking":2,"appId":10,"votingCount":37746,"UUT":1550460057000,"userName":"yuewentester1024"},{"userId":1520658766,"ranking":3,"appId":10,"votingCount":7510,"UUT":1552648459000,"userName":"webnoveltest123"},{"userId":3968405415,"ranking":4,"appId":10,"UUT":1530701317000,"userName":"jennyrenjialele5"},{"userId":1059463888,"ranking":5,"appId":10,"UUT":1542710966000,"userName":"xujin0515"},{"userId":101087995,"ranking":6,"appId":10,"UUT":1539950384000,"userName":"garden6cg"},{"userId":4300000467,"ranking":7,"appId":10,"UUT":1550221196000,"userName":"fourautumn1024"},{"userId":2959616949,"ranking":8,"appId":10,"UUT":1539936723000,"userName":"Eason057"},{"userId":41830698,"ranking":9,"appId":10,"UUT":1551407418000,"userName":"clarkzhangss"},{"userId":1901271742,"ranking":10,"appId":10,"UUT":1554260602000,"userName":"testingya"},{"userId":2140464915,"ranking":11,"appId":10,"UUT":1555470925000,"userName":"1231"},{"userId":4300000437,"ranking":12,"appId":10,"UUT":1527132787000,"userName":"LANEYU"},{"userId":4300000120,"ranking":13,"appId":10,"UUT":1554286185000,"userName":"bigcat004"},{"userId":4300000390,"ranking":14,"appId":10,"UUT":1547805199000,"userName":"Candy"},{"userId":4300000535,"ranking":15,"appId":10,"UUT":1554968876000,"userName":"Clementine"},{"userId":4300000208,"ranking":16,"appId":10,"UUT":1532690675000,"userName":"lily7"},{"userId":4300000431,"ranking":17,"appId":10,"UUT":1529404645377,"userName":"zhouxiyuan"},{"userId":3093119117,"ranking":18,"appId":10,"UUT":1555987639000,"userName":"zyftest"},{"userId":4300000213,"ranking":19,"appId":10,"UUT":1547607296000,"userName":"taozi"},{"userId":2760955332,"ranking":20,"appId":10,"UUT":1516946520000,"userName":"QStack"},{"userId":2140047512,"ranking":21,"appId":10,"UUT":1527044971000,"userName":"Eeee"},{"userId":4300000215,"ranking":22,"appId":10,"UUT":1547523864000,"userName":"Cinnamoroll"},{"userId":3892951244,"ranking":23,"appId":10,"UUT":1509601774217,"userName":"clark"},{"userId":4300000429,"ranking":24,"appId":10,"UUT":1542102687000,"userName":"xixi"},{"userId":4060368390,"ranking":25,"appId":10,"UUT":1548308522000,"userName":"Amy4060368390y"},{"userId":2223904916,"ranking":26,"appId":10,"UUT":1506600937142,"userName":"yuewen"},{"userId":4300000246,"ranking":27,"appId":10,"UUT":1534487506000,"userName":"dsr"},{"userId":4300001087,"ranking":28,"appId":10,"UUT":1544601130000,"userName":"Candy_hd001"},{"userId":4300000427,"ranking":29,"appId":10,"UUT":1547522817000,"userName":"term"},{"userId":689890031,"ranking":30,"appId":10,"UUT":1532518708000,"userName":"Jose"}]
   */
  items?: {
    userId?: number;
    /**
     * 1
     */
    ranking?: number;
    appId?: number;
    /**
     * 65452
     */
    votingCount?: number;
  }[];
  my?: {
    /**
     * 755
     */
    votingCount?: number;
    /**
     * 13
     */
    ranking?: number;
  };
  /**
   * 63
   */
  total?: number;
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 30
   */
  pageSize?: number;
  isLast?: number;
  /**
   * "fans"
   */
  rankType?: string;
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300000120/1/1.jpg?mt=1553072138000"
     */
    avatar?: string;
    /**
     * "bigcat004"
     */
    nickName?: string;
    /**
     * "bigcat004"
     */
    userName?: string;
    /**
     * "4300000120"
     */
    guid?: string;
    status?: number;
    role?: number;
    penName?: null;
    /**
     * 16
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 6
     */
    grade?: number;
    /**
     * 3
     */
    ES?: number;
    /**
     * 3
     */
    totalES?: number;
    /**
     * 2
     */
    PS?: number;
    /**
     * 3
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: boolean;
    /**
     * 1553072138000
     */
    UUT?: number;
  };
}

/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/2309/interface/api/191951) 的 **请求配置的类型**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRanking`
 * @更新时间 `2021-04-29 17:12:28`
 */
type GoPcmFansGetBookFansRankingRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/fans/getBookFansRanking",
    "data",
    string,
    "bookId" | "pageIndex",
    false
  >
>;

/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/2309/interface/api/191951) 的 **请求配置**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRanking`
 * @更新时间 `2021-04-29 17:12:28`
 */
const goPcmFansGetBookFansRankingRequestConfig: GoPcmFansGetBookFansRankingRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_27,
    devUrl: devUrl_0_0_0_27,
    prodUrl: prodUrl_0_0_0_27,
    path: "/go/pcm/fans/getBookFansRanking",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_27,
    paramNames: [],
    queryNames: ["bookId", "pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmFansGetBookFansRanking",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/2309/interface/api/191951) 的 **请求函数**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRanking`
 * @更新时间 `2021-04-29 17:12:28`
 */
export const goPcmFansGetBookFansRanking = /*#__PURE__*/ (
  requestData: GoPcmFansGetBookFansRankingRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmFansGetBookFansRankingResponse>(
    prepare(goPcmFansGetBookFansRankingRequestConfig, requestData),
    ...args
  );
};

goPcmFansGetBookFansRanking.requestConfig =
  goPcmFansGetBookFansRankingRequestConfig;

const mockUrl_0_0_0_28 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_28 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_28 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_28 = "data" as any;

/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/2309/interface/api/191970) 的 **请求类型**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/needCaptcha`
 * @更新时间 `2021-01-20 16:34:15`
 */
export interface GoPcmCdkeyNeedCaptchaRequest {}

/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/2309/interface/api/191970) 的 **返回类型**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/needCaptcha`
 * @更新时间 `2021-01-20 16:34:15`
 */
export interface GoPcmCdkeyNeedCaptchaResponse {
  needCaptcha?: number;
}

/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/2309/interface/api/191970) 的 **请求配置的类型**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/needCaptcha`
 * @更新时间 `2021-01-20 16:34:15`
 */
type GoPcmCdkeyNeedCaptchaRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/cdkey/needCaptcha",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/2309/interface/api/191970) 的 **请求配置**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/needCaptcha`
 * @更新时间 `2021-01-20 16:34:15`
 */
const goPcmCdkeyNeedCaptchaRequestConfig: GoPcmCdkeyNeedCaptchaRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_28,
    devUrl: devUrl_0_0_0_28,
    prodUrl: prodUrl_0_0_0_28,
    path: "/go/pcm/cdkey/needCaptcha",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCdkeyNeedCaptcha",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/2309/interface/api/191970) 的 **请求函数**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/needCaptcha`
 * @更新时间 `2021-01-20 16:34:15`
 */
export const goPcmCdkeyNeedCaptcha = /*#__PURE__*/ (
  requestData?: GoPcmCdkeyNeedCaptchaRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmCdkeyNeedCaptchaResponse>(
    prepare(goPcmCdkeyNeedCaptchaRequestConfig, requestData),
    ...args
  );
};

goPcmCdkeyNeedCaptcha.requestConfig = goPcmCdkeyNeedCaptchaRequestConfig;

/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/2309/interface/api/191976) 的 **请求类型**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `POST /go/pcm/cdkey/redeem`
 * @更新时间 `2021-01-20 16:38:25`
 */
export interface GoPcmCdkeyRedeemRequest {
  /**
   * 礼品卡code
   */
  cdkey: string;
  /**
   * 两次错误之后，需要输入谷歌验证码
   */
  "g-recaptcha-response"?: string;
}

/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/2309/interface/api/191976) 的 **返回类型**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `POST /go/pcm/cdkey/redeem`
 * @更新时间 `2021-01-20 16:38:25`
 */
export interface GoPcmCdkeyRedeemResponse {}

/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/2309/interface/api/191976) 的 **请求配置的类型**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `POST /go/pcm/cdkey/redeem`
 * @更新时间 `2021-01-20 16:38:25`
 */
type GoPcmCdkeyRedeemRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/cdkey/redeem",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/2309/interface/api/191976) 的 **请求配置**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `POST /go/pcm/cdkey/redeem`
 * @更新时间 `2021-01-20 16:38:25`
 */
const goPcmCdkeyRedeemRequestConfig: GoPcmCdkeyRedeemRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_28,
    devUrl: devUrl_0_0_0_28,
    prodUrl: prodUrl_0_0_0_28,
    path: "/go/pcm/cdkey/redeem",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCdkeyRedeem",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/2309/interface/api/191976) 的 **请求函数**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `POST /go/pcm/cdkey/redeem`
 * @更新时间 `2021-01-20 16:38:25`
 */
export const goPcmCdkeyRedeem = /*#__PURE__*/ (
  requestData: GoPcmCdkeyRedeemRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmCdkeyRedeemResponse>(
    prepare(goPcmCdkeyRedeemRequestConfig, requestData),
    ...args
  );
};

goPcmCdkeyRedeem.requestConfig = goPcmCdkeyRedeemRequestConfig;

/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/2309/interface/api/191982) 的 **请求类型**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/userStatus`
 * @更新时间 `2021-01-20 17:40:17`
 */
export interface GoPcmCdkeyUserStatusRequest {}

/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/2309/interface/api/191982) 的 **返回类型**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/userStatus`
 * @更新时间 `2021-01-20 17:40:17`
 */
export interface GoPcmCdkeyUserStatusResponse {
  hours?: number;
  userStatus?: number;
  user?: {
    /**
     * "2959616949"
     */
    guid?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/2959616949/1/1.jpg?mt=1527475612000"
     */
    avatar?: string;
    /**
     * "Eason"
     */
    userName?: string;
    nickName?: null;
    penName?: string;
    role?: number;
    status?: number;
    /**
     * 16751
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 3
     */
    userLevel?: number;
    /**
     * 1
     */
    availablePower?: number;
    /**
     * 1
     */
    totalPower?: number;
    /**
     * 2
     */
    availableEnergy?: number;
    /**
     * 2
     */
    totalEnergy?: number;
    /**
     * 1
     */
    emailStatus?: number;
  };
}

/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/2309/interface/api/191982) 的 **请求配置的类型**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/userStatus`
 * @更新时间 `2021-01-20 17:40:17`
 */
type GoPcmCdkeyUserStatusRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/cdkey/userStatus",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/2309/interface/api/191982) 的 **请求配置**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/userStatus`
 * @更新时间 `2021-01-20 17:40:17`
 */
const goPcmCdkeyUserStatusRequestConfig: GoPcmCdkeyUserStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_28,
    devUrl: devUrl_0_0_0_28,
    prodUrl: prodUrl_0_0_0_28,
    path: "/go/pcm/cdkey/userStatus",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCdkeyUserStatus",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/2309/interface/api/191982) 的 **请求函数**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/userStatus`
 * @更新时间 `2021-01-20 17:40:17`
 */
export const goPcmCdkeyUserStatus = /*#__PURE__*/ (
  requestData?: GoPcmCdkeyUserStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmCdkeyUserStatusResponse>(
    prepare(goPcmCdkeyUserStatusRequestConfig, requestData),
    ...args
  );
};

goPcmCdkeyUserStatus.requestConfig = goPcmCdkeyUserStatusRequestConfig;

const mockUrl_0_0_0_29 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_29 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_29 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_29 = "data" as any;

/**
 * 接口 [获取我的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/191988) 的 **请求类型**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getMyBadges`
 * @更新时间 `2021-01-20 17:43:31`
 */
export interface GoPcmBadgeGetMyBadgesRequest {
  /**
   * 对PC一次给全 m分页
   */
  pageIndex: string;
}

/**
 * 接口 [获取我的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/191988) 的 **返回类型**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getMyBadges`
 * @更新时间 `2021-01-20 17:43:31`
 */
export interface GoPcmBadgeGetMyBadgesResponse {
  /**
   * [{"badgeId":1,"badgeType":"Achievement","badgeName":"Endeavor","maxGrade":4,"isAchieved":0,"achievedMaxGrade":1,"achievedTime":"","achievedGradeGoal":"Cumulative Sign in 30 days","baseUrl":"https://actimg.webnovel.com/badge/10001/1/","updateTime":0},{"badgeId":10002,"badgeType":"Achievement","badgeName":"Such Rich!","maxGrade":4,"isAchieved":0,"achievedMaxGrade":1,"achievedTime":"","achievedGradeGoal":"Accumulative obtain 1,000 Spirit Stones","baseUrl":"https://actimg.webnovel.com/badge/10002/1/","updateTime":0},{"badgeId":10003,"badgeType":"Achievement","badgeName":"Premium","maxGrade":4,"isAchieved":0,"achievedMaxGrade":1,"achievedTime":"","achievedGradeGoal":"To be a Premium user","baseUrl":"https://actimg.webnovel.com/badge/10003/1/","updateTime":0},{"badgeId":10004,"badgeType":"Achievement","badgeName":"My Treasures","maxGrade":4,"isAchieved":0,"achievedMaxGrade":1,"achievedTime":"","achievedGradeGoal":"61-100 contributors in Contribution ranking","baseUrl":"https://actimg.webnovel.com/badge/10004/1/","updateTime":0},{"badgeId":10005,"badgeType":"Achievement","badgeName":"Glory!","maxGrade":1,"isAchieved":0,"achievedMaxGrade":1,"achievedTime":"","achievedGradeGoal":"First 100 Premium users","baseUrl":"https://actimg.webnovel.com/badge/10005/1/","updateTime":0},{"badgeId":10006,"badgeType":"General","badgeName":"Cultivator","maxGrade":4,"isAchieved":0,"achievedMaxGrade":1,"achievedTime":"","achievedGradeGoal":"Register for over 1 year","baseUrl":"https://actimg.webnovel.com/badge/10006/1/","updateTime":0},{"badgeId":10007,"badgeType":"General","badgeName":"Who am I?","maxGrade":2,"isAchieved":1,"achievedMaxGrade":1,"achievedTime":"2018-01-24","achievedGradeGoal":"Add email","baseUrl":"https://actimg.webnovel.com/badge/10007/1/","updateTime":0}]
   */
  items?: {
    /**
     * 1
     */
    badgeId?: number;
    /**
     * "Achievement"
     */
    badgeType?: string;
    /**
     * "Endeavor"
     */
    badgeName?: string;
    /**
     * 4
     */
    maxGrade?: number;
    isAchieved?: number;
    /**
     * 1
     */
    achievedMaxGrade?: number;
    achievedTime?: string;
    /**
     * "Cumulative Sign in 30 days"
     */
    achievedGradeGoal?: string;
    /**
     * "https://actimg.webnovel.com/badge/10001/1/"
     */
    baseUrl?: string;
    updateTime?: number;
  }[];
  /**
   * 1
   */
  userTotal?: number;
  /**
   * 7
   */
  totalCount?: number;
  /**
   * 1
   */
  isLast?: number;
  user?: {
    /**
     * "3627871248"
     */
    guid?: string;
    /**
     * "//oauserimg.webnovel.com/userheadimg/3627871248/1/1.jpg?mt=1514354221000"
     */
    avatar?: string;
    /**
     * "1111qq"
     */
    userName?: string;
    nickName?: null;
    penName?: null;
    role?: number;
    status?: number;
    /**
     * 7377
     */
    SS?: number;
    isCheckin?: number;
    /**
     * 2
     */
    userLevel?: number;
    /**
     * 1
     */
    availablePower?: number;
    /**
     * 1
     */
    totalPower?: number;
    /**
     * 1
     */
    availableEnergy?: number;
    /**
     * 1
     */
    totalEnergy?: number;
    emailStatus?: number;
  };
}

/**
 * 接口 [获取我的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/191988) 的 **请求配置的类型**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getMyBadges`
 * @更新时间 `2021-01-20 17:43:31`
 */
type GoPcmBadgeGetMyBadgesRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/badge/getMyBadges",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [获取我的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/191988) 的 **请求配置**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getMyBadges`
 * @更新时间 `2021-01-20 17:43:31`
 */
const goPcmBadgeGetMyBadgesRequestConfig: GoPcmBadgeGetMyBadgesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_29,
    devUrl: devUrl_0_0_0_29,
    prodUrl: prodUrl_0_0_0_29,
    path: "/go/pcm/badge/getMyBadges",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_29,
    paramNames: [],
    queryNames: ["pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBadgeGetMyBadges",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取我的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/191988) 的 **请求函数**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getMyBadges`
 * @更新时间 `2021-01-20 17:43:31`
 */
export const goPcmBadgeGetMyBadges = /*#__PURE__*/ (
  requestData: GoPcmBadgeGetMyBadgesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBadgeGetMyBadgesResponse>(
    prepare(goPcmBadgeGetMyBadgesRequestConfig, requestData),
    ...args
  );
};

goPcmBadgeGetMyBadges.requestConfig = goPcmBadgeGetMyBadgesRequestConfig;

/**
 * 接口 [获取徽章详情↗](https://yapi.yuewen.com/project/2309/interface/api/191994) 的 **请求类型**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getBadgeDetail`
 * @更新时间 `2021-01-20 17:45:53`
 */
export interface GoPcmBadgeGetBadgeDetailRequest {
  /**
   * 徽章ID
   */
  badgeId: string;
}

/**
 * 接口 [获取徽章详情↗](https://yapi.yuewen.com/project/2309/interface/api/191994) 的 **返回类型**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getBadgeDetail`
 * @更新时间 `2021-01-20 17:45:53`
 */
export interface GoPcmBadgeGetBadgeDetailResponse {
  /**
   * 1
   */
  badgeId?: number;
  /**
   * "Endeavor"
   */
  badgeName?: string;
  /**
   * 4
   */
  maxGrade?: number;
  /**
   * [{"gradeName":"等级名","badgeGrade":1,"badgeType":"General","achievedGoal":"到达该等级的描述，如： 连续签到100天","baseUrl":"https://actimg.webnovel.com/badge/10007/2/ 徽章的baseUrl","updateTime":"徽章图片更新时间","isAchieved":"1","achievedTime":"2017-12-12","ranking":123}]
   */
  gradeItems?: {
    /**
     * "等级名"
     */
    gradeName?: string;
    /**
     * 1
     */
    badgeGrade?: number;
    /**
     * "General"
     */
    badgeType?: string;
    /**
     * "到达该等级的描述，如： 连续签到100天"
     */
    achievedGoal?: string;
    /**
     * "https://actimg.webnovel.com/badge/10007/2/ 徽章的baseUrl"
     */
    baseUrl?: string;
    /**
     * "徽章图片更新时间"
     */
    updateTime?: string;
    /**
     * "1"
     */
    isAchieved?: string;
    /**
     * "2017-12-12"
     */
    achievedTime?: string;
    /**
     * 123
     */
    ranking?: number;
  }[];
}

/**
 * 接口 [获取徽章详情↗](https://yapi.yuewen.com/project/2309/interface/api/191994) 的 **请求配置的类型**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getBadgeDetail`
 * @更新时间 `2021-01-20 17:45:53`
 */
type GoPcmBadgeGetBadgeDetailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/badge/getBadgeDetail",
    "data",
    string,
    "badgeId",
    false
  >
>;

/**
 * 接口 [获取徽章详情↗](https://yapi.yuewen.com/project/2309/interface/api/191994) 的 **请求配置**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getBadgeDetail`
 * @更新时间 `2021-01-20 17:45:53`
 */
const goPcmBadgeGetBadgeDetailRequestConfig: GoPcmBadgeGetBadgeDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_29,
    devUrl: devUrl_0_0_0_29,
    prodUrl: prodUrl_0_0_0_29,
    path: "/go/pcm/badge/getBadgeDetail",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_29,
    paramNames: [],
    queryNames: ["badgeId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBadgeGetBadgeDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取徽章详情↗](https://yapi.yuewen.com/project/2309/interface/api/191994) 的 **请求函数**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getBadgeDetail`
 * @更新时间 `2021-01-20 17:45:53`
 */
export const goPcmBadgeGetBadgeDetail = /*#__PURE__*/ (
  requestData: GoPcmBadgeGetBadgeDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBadgeGetBadgeDetailResponse>(
    prepare(goPcmBadgeGetBadgeDetailRequestConfig, requestData),
    ...args
  );
};

goPcmBadgeGetBadgeDetail.requestConfig = goPcmBadgeGetBadgeDetailRequestConfig;

const mockUrl_0_0_0_30 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_30 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_30 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_30 = "data" as any;

/**
 * 接口 [getGearInfo↗](https://yapi.yuewen.com/project/2309/interface/api/175513) 的 **请求类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2021-03-29 11:26:42`
 */
export interface GoPcmRechargeGetGearInfo2Request {}

/**
 * 接口 [getGearInfo↗](https://yapi.yuewen.com/project/2309/interface/api/175513) 的 **返回类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2021-03-29 11:26:42`
 */
export interface GoPcmRechargeGetGearInfo2Response {
  /**
   * [{"channelCode":"paypal","channelName":"paypal","gearGroupId":68,"channelImageUrl":"https://actimg.webnovel.com/gear/paypal.png","gearDataList":[{"realAmount":"4.99","virtualAmount":"250","propId":"pp_pack_of_250_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"9.99","virtualAmount":"500","propId":"pp_pack_of_500_spirit_stones","content":"50 coins","currencyName":"USD"},{"realAmount":"19.99","virtualAmount":"1000","propId":"pp_pack_of_1000_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"49.99","virtualAmount":"2500","propId":"pp_pack_of_2500_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"99.99","virtualAmount":"5000","propId":"pp_pack_of_5000_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"149.99","virtualAmount":"7500","propId":"pp_pack_of_7500_spirit_stones","content":"","currencyName":"USD"}],"gearActText":"","membershipInfo":null},{"channelCode":"stripe","channelName":"stripe","gearGroupId":65,"channelImageUrl":"https://actimg.webnovel.com/gear/stripe.png","gearDataList":[{"realAmount":"0.99","virtualAmount":"50","propId":"price_1Gzb6LKOXSdtjQFQ55faiwAt","content":"1 FP","currencyName":"USD"},{"realAmount":"4.99","virtualAmount":"250","propId":"price_1Gzb77KOXSdtjQFQ86dcyaYm","content":"","currencyName":"USD"},{"realAmount":"9.99","virtualAmount":"500","propId":"price_1Gzb7gKOXSdtjQFQpsDsj2mQ","content":"50 coins","currencyName":"USD"},{"realAmount":"19.99","virtualAmount":"1000","propId":"price_1Gzb8bKOXSdtjQFQhhcXpMPs","content":"","currencyName":"USD"},{"realAmount":"49.99","virtualAmount":"2500","propId":"price_1Gzb9ZKOXSdtjQFQxwTp6e0X","content":"","currencyName":"USD"},{"realAmount":"99.99","virtualAmount":"5000","propId":"price_1GzbA5KOXSdtjQFQhQM3nojS","content":"","currencyName":"USD"}],"gearActText":"","membershipInfo":null}]
   */
  payChannels?: {
    /**
     * "paypal"
     */
    channelCode?: string;
    /**
     * "paypal"
     */
    channelName?: string;
    /**
     * 68
     */
    gearGroupId?: number;
    /**
     * "https://actimg.webnovel.com/gear/paypal.png"
     */
    channelImageUrl?: string;
    /**
     * [{"realAmount":"4.99","virtualAmount":"250","propId":"pp_pack_of_250_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"9.99","virtualAmount":"500","propId":"pp_pack_of_500_spirit_stones","content":"50 coins","currencyName":"USD"},{"realAmount":"19.99","virtualAmount":"1000","propId":"pp_pack_of_1000_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"49.99","virtualAmount":"2500","propId":"pp_pack_of_2500_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"99.99","virtualAmount":"5000","propId":"pp_pack_of_5000_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"149.99","virtualAmount":"7500","propId":"pp_pack_of_7500_spirit_stones","content":"","currencyName":"USD"}]
     */
    gearDataList?: {
      /**
       * "4.99"
       */
      realAmount?: string;
      /**
       * "250"
       */
      virtualAmount?: string;
      /**
       * "pp_pack_of_250_spirit_stones"
       */
      propId?: string;
      content?: string;
      /**
       * "USD"
       */
      currencyName?: string;
    }[];
    gearActText?: string;
    membershipInfo?: null;
  }[];
  /**
   * [{"amount":4.99,"benefits":[{"imageUrl":"https://webbannertest.webnovel.com/utils/1610609045_581577.png","title":"Obtain 250 Coins at once"},{"imageUrl":"https://webbannertest.webnovel.com/utils/1610609078_427837.png","title":"Earn an additional 180 Coins a month (claimed daily)"},{"imageUrl":"https://webbannertest.webnovel.com/utils/1610609085_790781.png","title":"More Coming Soon11"}],"channelCode":"paypal","country":"PH","currency":"USD","discountAmount":3.99,"itemId":"P-7NG68734R8023221KL77L35A","itemType":2,"msg":"Spend $4.99 to get $9.99(feivip)","tag":"","title":"Monthly"}]
   */
  membershipItems?: {
    /**
     * 4.99
     */
    amount?: number;
    /**
     * [{"imageUrl":"https://webbannertest.webnovel.com/utils/1610609045_581577.png","title":"Obtain 250 Coins at once"},{"imageUrl":"https://webbannertest.webnovel.com/utils/1610609078_427837.png","title":"Earn an additional 180 Coins a month (claimed daily)"},{"imageUrl":"https://webbannertest.webnovel.com/utils/1610609085_790781.png","title":"More Coming Soon11"}]
     */
    benefits?: {
      /**
       * "https://webbannertest.webnovel.com/utils/1610609045_581577.png"
       */
      imageUrl?: string;
      /**
       * "Obtain 250 Coins at once"
       */
      title?: string;
    }[];
    /**
     * "paypal"
     */
    channelCode?: string;
    /**
     * "PH"
     */
    country?: string;
    /**
     * "USD"
     */
    currency?: string;
    /**
     * 3.99
     */
    discountAmount?: number;
    /**
     * "P-7NG68734R8023221KL77L35A"
     */
    itemId?: string;
    /**
     * 2
     */
    itemType?: number;
    /**
     * "Spend $4.99 to get $9.99(feivip)"
     */
    msg?: string;
    tag?: string;
    /**
     * "Monthly"
     */
    title?: string;
  }[];
}

/**
 * 接口 [getGearInfo↗](https://yapi.yuewen.com/project/2309/interface/api/175513) 的 **请求配置的类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2021-03-29 11:26:42`
 */
type GoPcmRechargeGetGearInfo2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/recharge/getGearInfo",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [getGearInfo↗](https://yapi.yuewen.com/project/2309/interface/api/175513) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2021-03-29 11:26:42`
 */
const goPcmRechargeGetGearInfo2RequestConfig: GoPcmRechargeGetGearInfo2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_30,
    devUrl: devUrl_0_0_0_30,
    prodUrl: prodUrl_0_0_0_30,
    path: "/go/pcm/recharge/getGearInfo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRechargeGetGearInfo2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getGearInfo↗](https://yapi.yuewen.com/project/2309/interface/api/175513) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2021-03-29 11:26:42`
 */
export const goPcmRechargeGetGearInfo2 = /*#__PURE__*/ (
  requestData?: GoPcmRechargeGetGearInfo2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmRechargeGetGearInfo2Response>(
    prepare(goPcmRechargeGetGearInfo2RequestConfig, requestData),
    ...args
  );
};

goPcmRechargeGetGearInfo2.requestConfig =
  goPcmRechargeGetGearInfo2RequestConfig;

/**
 * 接口 [m站获取充值接口↗](https://yapi.yuewen.com/project/2309/interface/api/195497) 的 **请求类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfoByMobileNew`
 * @更新时间 `2021-05-28 14:26:17`
 */
export interface GoPcmRechargeGetGearInfoByMobileNewRequest {}

/**
 * 接口 [m站获取充值接口↗](https://yapi.yuewen.com/project/2309/interface/api/195497) 的 **返回类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfoByMobileNew`
 * @更新时间 `2021-05-28 14:26:17`
 */
export interface GoPcmRechargeGetGearInfoByMobileNewResponse {
  isFree?: boolean;
  user?: {
    /**
     * 4300014654
     */
    guid?: number;
    /**
     * "liwen369170"
     */
    userName?: string;
    status?: number;
    UUT?: number;
    /**
     * "liwen369170@163.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    gender?: number;
  };
  /**
   * 1
   */
  vipStatus?: number;
  /**
   * [{"channelCode":"paypal","channelName":"paypal","gearGroupId":67,"channelImageUrl":"https://actimg.webnovel.com/gear/paypal.png","gearActText":"20% off","gearDataList":[{"realAmount":"4.99","virtualAmount":"250","propId":"pp_pack_of_250_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"9.99","virtualAmount":"500","propId":"pp_pack_of_500_spirit_stones","content":"50 coins","currencyName":"USD"},{"realAmount":"19.99","virtualAmount":"1000","propId":"pp_pack_of_1000_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"49.99","virtualAmount":"2500","propId":"pp_pack_of_2500_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"99.99","virtualAmount":"5000","propId":"pp_pack_of_5000_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"149.99","virtualAmount":"7500","propId":"pp_pack_of_7500_spirit_stones","content":"","currencyName":"USD"}],"membershipInfo":[{"isFirstCharge":false,"actionText":"20% off","amount":4.99,"benefits":[{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581577746_853095.png","title":"Obtain 250 Coins at once"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904774_427573.jpg","title":"Earn an additional 150 Coins a month (from daily login)"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904809_248340.jpg","title":"More Coming Soon..."}],"channelCode":"paypal","country":"PH","currency":"USD","delayAward":5,"discountAmount":4.98,"itemId":"membership_basic_paypal_t2_h5","itemType":2,"msg":"Spend $9.99 to get $15.99(feivip)","tag":"","title":"Monthly","totalAmount":150,"totalAward":0}],"membershipInfoPeriod":{"isFirstCharge":false,"actionText":"20% off","amount":4.99,"benefits":[{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581577746_853095.png","title":"Obtain 250 Coins at once"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904774_427573.jpg","title":"Earn an additional 150 Coins a month (from daily login)"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904809_248340.jpg","title":"More Coming Soon..."}],"channelCode":"paypal","country":"PH","currency":"USD","delayAward":5,"discountAmount":4.98,"itemId":"membership_basic_paypal_t2_h5","itemType":2,"msg":"Spend $9.99 to get $15.99(feivip)","tag":"","title":"Monthly","totalAmount":150,"totalAward":0}},{"channelCode":"stripe","channelName":"stripe","gearGroupId":67,"channelImageUrl":"https://actimg.webnovel.com/gear/stripe.png","gearActText":"20%OFF","gearDataList":[{"realAmount":"5.00","virtualAmount":"250","propId":"pp_pack_of_250_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"9.99","virtualAmount":"500","propId":"pp_pack_of_500_spirit_stones","content":"50 coins","currencyName":"USD"},{"realAmount":"19.99","virtualAmount":"1000","propId":"pp_pack_of_1000_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"49.99","virtualAmount":"2500","propId":"pp_pack_of_2500_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"99.99","virtualAmount":"5000","propId":"pp_pack_of_5000_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"149.99","virtualAmount":"7500","propId":"pp_pack_of_7500_spirit_stones","content":"","currencyName":"USD"}],"membershipInfo":[{"isFirstCharge":false,"actionText":"20% off","amount":4.99,"benefits":[{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581577746_853095.png","title":"Obtain 250 Coins at once"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904774_427573.jpg","title":"Earn an additional 150 Coins a month (from daily login)"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904809_248340.jpg","title":"More Coming Soon..."}],"channelCode":"paypal","country":"PH","currency":"USD","delayAward":5,"discountAmount":4.98,"itemId":"membership_basic_paypal_t2_h5","itemType":2,"msg":"Spend $9.99 to get $15.99(feivip)","tag":"","title":"Monthly","totalAmount":150,"totalAward":0}],"membershipInfoPeriod":{"isFirstCharge":false,"actionText":"20% off","amount":4.99,"benefits":[{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581577746_853095.png","title":"Obtain 250 Coins at once"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904774_427573.jpg","title":"Earn an additional 150 Coins a month (from daily login)"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904809_248340.jpg","title":"More Coming Soon..."}],"channelCode":"paypal","country":"PH","currency":"USD","delayAward":5,"discountAmount":4.98,"itemId":"membership_basic_paypal_t2_h5","itemType":2,"msg":"Spend $9.99 to get $15.99(feivip)","tag":"","title":"Monthly","totalAmount":150,"totalAward":0}}]
   */
  channels?: {
    /**
     * "paypal"
     */
    channelCode?: string;
    /**
     * "paypal"
     */
    channelName?: string;
    /**
     * 67
     */
    gearGroupId?: number;
    /**
     * "https://actimg.webnovel.com/gear/paypal.png"
     */
    channelImageUrl?: string;
    /**
     * "20% off"
     */
    gearActText?: string;
    /**
     * [{"realAmount":"4.99","virtualAmount":"250","propId":"pp_pack_of_250_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"9.99","virtualAmount":"500","propId":"pp_pack_of_500_spirit_stones","content":"50 coins","currencyName":"USD"},{"realAmount":"19.99","virtualAmount":"1000","propId":"pp_pack_of_1000_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"49.99","virtualAmount":"2500","propId":"pp_pack_of_2500_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"99.99","virtualAmount":"5000","propId":"pp_pack_of_5000_spirit_stones","content":"","currencyName":"USD"},{"realAmount":"149.99","virtualAmount":"7500","propId":"pp_pack_of_7500_spirit_stones","content":"","currencyName":"USD"}]
     */
    gearDataList?: {
      /**
       * "4.99"
       */
      realAmount?: string;
      /**
       * "250"
       */
      virtualAmount?: string;
      /**
       * "pp_pack_of_250_spirit_stones"
       */
      propId?: string;
      content?: string;
      /**
       * "USD"
       */
      currencyName?: string;
    }[];
    /**
     * [{"isFirstCharge":false,"actionText":"20% off","amount":4.99,"benefits":[{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581577746_853095.png","title":"Obtain 250 Coins at once"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904774_427573.jpg","title":"Earn an additional 150 Coins a month (from daily login)"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904809_248340.jpg","title":"More Coming Soon..."}],"channelCode":"paypal","country":"PH","currency":"USD","delayAward":5,"discountAmount":4.98,"itemId":"membership_basic_paypal_t2_h5","itemType":2,"msg":"Spend $9.99 to get $15.99(feivip)","tag":"","title":"Monthly","totalAmount":150,"totalAward":0}]
     */
    membershipInfo?: {
      isFirstCharge?: boolean;
      /**
       * "20% off"
       */
      actionText?: string;
      /**
       * 4.99
       */
      amount?: number;
      /**
       * [{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581577746_853095.png","title":"Obtain 250 Coins at once"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904774_427573.jpg","title":"Earn an additional 150 Coins a month (from daily login)"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904809_248340.jpg","title":"More Coming Soon..."}]
       */
      benefits?: {
        actionUrl?: string;
        /**
         * "https://webbannertest.webnovel.com/utils/1581577746_853095.png"
         */
        imageUrl?: string;
        /**
         * "Obtain 250 Coins at once"
         */
        title?: string;
      }[];
      /**
       * "paypal"
       */
      channelCode?: string;
      /**
       * "PH"
       */
      country?: string;
      /**
       * "USD"
       */
      currency?: string;
      /**
       * 5
       */
      delayAward?: number;
      /**
       * 4.98
       */
      discountAmount?: number;
      /**
       * "membership_basic_paypal_t2_h5"
       */
      itemId?: string;
      /**
       * 2
       */
      itemType?: number;
      /**
       * "Spend $9.99 to get $15.99(feivip)"
       */
      msg?: string;
      tag?: string;
      /**
       * "Monthly"
       */
      title?: string;
      /**
       * 150
       */
      totalAmount?: number;
      totalAward?: number;
    }[];
    membershipInfoPeriod?: {
      isFirstCharge?: boolean;
      /**
       * "20% off"
       */
      actionText?: string;
      /**
       * 4.99
       */
      amount?: number;
      /**
       * [{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581577746_853095.png","title":"Obtain 250 Coins at once"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904774_427573.jpg","title":"Earn an additional 150 Coins a month (from daily login)"},{"actionUrl":"","imageUrl":"https://webbannertest.webnovel.com/utils/1581904809_248340.jpg","title":"More Coming Soon..."}]
       */
      benefits?: {
        actionUrl?: string;
        /**
         * "https://webbannertest.webnovel.com/utils/1581577746_853095.png"
         */
        imageUrl?: string;
        /**
         * "Obtain 250 Coins at once"
         */
        title?: string;
      }[];
      /**
       * "paypal"
       */
      channelCode?: string;
      /**
       * "PH"
       */
      country?: string;
      /**
       * "USD"
       */
      currency?: string;
      /**
       * 5
       */
      delayAward?: number;
      /**
       * 4.98
       */
      discountAmount?: number;
      /**
       * "membership_basic_paypal_t2_h5"
       */
      itemId?: string;
      /**
       * 2
       */
      itemType?: number;
      /**
       * "Spend $9.99 to get $15.99(feivip)"
       */
      msg?: string;
      tag?: string;
      /**
       * "Monthly"
       */
      title?: string;
      /**
       * 150
       */
      totalAmount?: number;
      totalAward?: number;
    };
  }[];
}

/**
 * 接口 [m站获取充值接口↗](https://yapi.yuewen.com/project/2309/interface/api/195497) 的 **请求配置的类型**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfoByMobileNew`
 * @更新时间 `2021-05-28 14:26:17`
 */
type GoPcmRechargeGetGearInfoByMobileNewRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/recharge/getGearInfoByMobileNew",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [m站获取充值接口↗](https://yapi.yuewen.com/project/2309/interface/api/195497) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfoByMobileNew`
 * @更新时间 `2021-05-28 14:26:17`
 */
const goPcmRechargeGetGearInfoByMobileNewRequestConfig: GoPcmRechargeGetGearInfoByMobileNewRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_30,
    devUrl: devUrl_0_0_0_30,
    prodUrl: prodUrl_0_0_0_30,
    path: "/go/pcm/recharge/getGearInfoByMobileNew",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRechargeGetGearInfoByMobileNew",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [m站获取充值接口↗](https://yapi.yuewen.com/project/2309/interface/api/195497) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfoByMobileNew`
 * @更新时间 `2021-05-28 14:26:17`
 */
export const goPcmRechargeGetGearInfoByMobileNew = /*#__PURE__*/ (
  requestData?: GoPcmRechargeGetGearInfoByMobileNewRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmRechargeGetGearInfoByMobileNewResponse>(
    prepare(goPcmRechargeGetGearInfoByMobileNewRequestConfig, requestData),
    ...args
  );
};

goPcmRechargeGetGearInfoByMobileNew.requestConfig =
  goPcmRechargeGetGearInfoByMobileNewRequestConfig;

const mockUrl_0_0_0_31 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_31 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_31 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_31 = "data" as any;

/**
 * 接口 [addContent - 新增机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195180) 的 **请求类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/addContent`
 * @更新时间 `2021-01-25 20:02:30`
 */
export interface GoPcmMachineTransAddContentRequest {
  /**
   * 书籍id
   */
  bookId: string;
  /**
   * 章节id
   */
  chapterId: string;
  /**
   * 段落id
   */
  paragraphId: string;
  /**
   * 内容
   */
  content: string;
}

/**
 * 接口 [addContent - 新增机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195180) 的 **返回类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/addContent`
 * @更新时间 `2021-01-25 20:02:30`
 */
export interface GoPcmMachineTransAddContentResponse {}

/**
 * 接口 [addContent - 新增机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195180) 的 **请求配置的类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/addContent`
 * @更新时间 `2021-01-25 20:02:30`
 */
type GoPcmMachineTransAddContentRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/machineTrans/addContent",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [addContent - 新增机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195180) 的 **请求配置**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/addContent`
 * @更新时间 `2021-01-25 20:02:30`
 */
const goPcmMachineTransAddContentRequestConfig: GoPcmMachineTransAddContentRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_31,
    devUrl: devUrl_0_0_0_31,
    prodUrl: prodUrl_0_0_0_31,
    path: "/go/pcm/machineTrans/addContent",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMachineTransAddContent",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [addContent - 新增机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195180) 的 **请求函数**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/addContent`
 * @更新时间 `2021-01-25 20:02:30`
 */
export const goPcmMachineTransAddContent = /*#__PURE__*/ (
  requestData: GoPcmMachineTransAddContentRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMachineTransAddContentResponse>(
    prepare(goPcmMachineTransAddContentRequestConfig, requestData),
    ...args
  );
};

goPcmMachineTransAddContent.requestConfig =
  goPcmMachineTransAddContentRequestConfig;

/**
 * 接口 [updateContent - 修改机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195187) 的 **请求类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/updateContent`
 * @更新时间 `2021-01-25 20:01:57`
 */
export interface GoPcmMachineTransUpdateContentRequest {
  /**
   * 章节ID
   */
  chapterId: string;
  /**
   * 机翻的ID
   */
  contentId: string;
  /**
   * 机翻的内容
   */
  content: string;
}

/**
 * 接口 [updateContent - 修改机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195187) 的 **返回类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/updateContent`
 * @更新时间 `2021-01-25 20:01:57`
 */
export interface GoPcmMachineTransUpdateContentResponse {}

/**
 * 接口 [updateContent - 修改机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195187) 的 **请求配置的类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/updateContent`
 * @更新时间 `2021-01-25 20:01:57`
 */
type GoPcmMachineTransUpdateContentRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/machineTrans/updateContent",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [updateContent - 修改机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195187) 的 **请求配置**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/updateContent`
 * @更新时间 `2021-01-25 20:01:57`
 */
const goPcmMachineTransUpdateContentRequestConfig: GoPcmMachineTransUpdateContentRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_31,
    devUrl: devUrl_0_0_0_31,
    prodUrl: prodUrl_0_0_0_31,
    path: "/go/pcm/machineTrans/updateContent",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMachineTransUpdateContent",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [updateContent - 修改机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195187) 的 **请求函数**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/updateContent`
 * @更新时间 `2021-01-25 20:01:57`
 */
export const goPcmMachineTransUpdateContent = /*#__PURE__*/ (
  requestData: GoPcmMachineTransUpdateContentRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMachineTransUpdateContentResponse>(
    prepare(goPcmMachineTransUpdateContentRequestConfig, requestData),
    ...args
  );
};

goPcmMachineTransUpdateContent.requestConfig =
  goPcmMachineTransUpdateContentRequestConfig;

/**
 * 接口 [delContent - 删除机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195194) 的 **请求类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/delContent`
 * @更新时间 `2021-01-25 20:01:28`
 */
export interface GoPcmMachineTransDelContentRequest {
  /**
   * 章节的ID
   */
  chapterId: string;
  /**
   * 机翻的ID
   */
  contentId: string;
  /**
   * 书籍ID
   */
  bookId: string;
  /**
   * 段ID
   */
  paragraphId: string;
}

/**
 * 接口 [delContent - 删除机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195194) 的 **返回类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/delContent`
 * @更新时间 `2021-01-25 20:01:28`
 */
export interface GoPcmMachineTransDelContentResponse {}

/**
 * 接口 [delContent - 删除机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195194) 的 **请求配置的类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/delContent`
 * @更新时间 `2021-01-25 20:01:28`
 */
type GoPcmMachineTransDelContentRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/machineTrans/delContent",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [delContent - 删除机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195194) 的 **请求配置**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/delContent`
 * @更新时间 `2021-01-25 20:01:28`
 */
const goPcmMachineTransDelContentRequestConfig: GoPcmMachineTransDelContentRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_31,
    devUrl: devUrl_0_0_0_31,
    prodUrl: prodUrl_0_0_0_31,
    path: "/go/pcm/machineTrans/delContent",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMachineTransDelContent",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [delContent - 删除机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195194) 的 **请求函数**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/delContent`
 * @更新时间 `2021-01-25 20:01:28`
 */
export const goPcmMachineTransDelContent = /*#__PURE__*/ (
  requestData: GoPcmMachineTransDelContentRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMachineTransDelContentResponse>(
    prepare(goPcmMachineTransDelContentRequestConfig, requestData),
    ...args
  );
};

goPcmMachineTransDelContent.requestConfig =
  goPcmMachineTransDelContentRequestConfig;

/**
 * 接口 [like - 对机翻内容点赞和取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/195201) 的 **请求类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/like`
 * @更新时间 `2021-01-25 20:00:52`
 */
export interface GoPcmMachineTransLikeRequest {
  /**
   * 书ID
   */
  bookId: string;
  /**
   * 章节ID
   */
  chapterId: string;
  /**
   * 机翻的ID
   */
  contentId: string;
  /**
   * 点赞，1点赞，2取消点赞
   */
  operateType: string;
}

/**
 * 接口 [like - 对机翻内容点赞和取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/195201) 的 **返回类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/like`
 * @更新时间 `2021-01-25 20:00:52`
 */
export interface GoPcmMachineTransLikeResponse {}

/**
 * 接口 [like - 对机翻内容点赞和取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/195201) 的 **请求配置的类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/like`
 * @更新时间 `2021-01-25 20:00:52`
 */
type GoPcmMachineTransLikeRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/machineTrans/like",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [like - 对机翻内容点赞和取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/195201) 的 **请求配置**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/like`
 * @更新时间 `2021-01-25 20:00:52`
 */
const goPcmMachineTransLikeRequestConfig: GoPcmMachineTransLikeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_31,
    devUrl: devUrl_0_0_0_31,
    prodUrl: prodUrl_0_0_0_31,
    path: "/go/pcm/machineTrans/like",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMachineTransLike",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [like - 对机翻内容点赞和取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/195201) 的 **请求函数**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/like`
 * @更新时间 `2021-01-25 20:00:52`
 */
export const goPcmMachineTransLike = /*#__PURE__*/ (
  requestData: GoPcmMachineTransLikeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMachineTransLikeResponse>(
    prepare(goPcmMachineTransLikeRequestConfig, requestData),
    ...args
  );
};

goPcmMachineTransLike.requestConfig = goPcmMachineTransLikeRequestConfig;

/**
 * 接口 [getContentList - 获取机翻内容列表↗](https://yapi.yuewen.com/project/2309/interface/api/195207) 的 **请求类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `GET /go/pcm/machineTrans/getContentList`
 * @更新时间 `2021-01-25 20:00:07`
 */
export interface GoPcmMachineTransGetContentListRequest {
  /**
   * 章节ID
   */
  chapterId: string;
  /**
   * 段落ID
   */
  paragraphId: string;
  /**
   * 分页
   */
  pageIndex: string;
}

/**
 * 接口 [getContentList - 获取机翻内容列表↗](https://yapi.yuewen.com/project/2309/interface/api/195207) 的 **返回类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `GET /go/pcm/machineTrans/getContentList`
 * @更新时间 `2021-01-25 20:00:07`
 */
export interface GoPcmMachineTransGetContentListResponse {}

/**
 * 接口 [getContentList - 获取机翻内容列表↗](https://yapi.yuewen.com/project/2309/interface/api/195207) 的 **请求配置的类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `GET /go/pcm/machineTrans/getContentList`
 * @更新时间 `2021-01-25 20:00:07`
 */
type GoPcmMachineTransGetContentListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/machineTrans/getContentList",
    "data",
    string,
    "chapterId" | "paragraphId" | "pageIndex",
    false
  >
>;

/**
 * 接口 [getContentList - 获取机翻内容列表↗](https://yapi.yuewen.com/project/2309/interface/api/195207) 的 **请求配置**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `GET /go/pcm/machineTrans/getContentList`
 * @更新时间 `2021-01-25 20:00:07`
 */
const goPcmMachineTransGetContentListRequestConfig: GoPcmMachineTransGetContentListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_31,
    devUrl: devUrl_0_0_0_31,
    prodUrl: prodUrl_0_0_0_31,
    path: "/go/pcm/machineTrans/getContentList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_31,
    paramNames: [],
    queryNames: ["chapterId", "paragraphId", "pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMachineTransGetContentList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getContentList - 获取机翻内容列表↗](https://yapi.yuewen.com/project/2309/interface/api/195207) 的 **请求函数**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `GET /go/pcm/machineTrans/getContentList`
 * @更新时间 `2021-01-25 20:00:07`
 */
export const goPcmMachineTransGetContentList = /*#__PURE__*/ (
  requestData: GoPcmMachineTransGetContentListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMachineTransGetContentListResponse>(
    prepare(goPcmMachineTransGetContentListRequestConfig, requestData),
    ...args
  );
};

goPcmMachineTransGetContentList.requestConfig =
  goPcmMachineTransGetContentListRequestConfig;

/**
 * 接口 [report - 对机翻内容举报↗](https://yapi.yuewen.com/project/2309/interface/api/195213) 的 **请求类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/report`
 * @更新时间 `2021-01-25 19:59:30`
 */
export interface GoPcmMachineTransReportRequest {
  /**
   * 1广告，2色情，3人身攻击，4其他
   */
  reportType: string;
  /**
   * 书id
   */
  bookId: string;
  /**
   * 章节id
   */
  chapterId: string;
  /**
   * 机翻id
   */
  contentId: string;
  /**
   * 举报理由
   */
  reason: string;
}

/**
 * 接口 [report - 对机翻内容举报↗](https://yapi.yuewen.com/project/2309/interface/api/195213) 的 **返回类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/report`
 * @更新时间 `2021-01-25 19:59:30`
 */
export interface GoPcmMachineTransReportResponse {}

/**
 * 接口 [report - 对机翻内容举报↗](https://yapi.yuewen.com/project/2309/interface/api/195213) 的 **请求配置的类型**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/report`
 * @更新时间 `2021-01-25 19:59:30`
 */
type GoPcmMachineTransReportRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/machineTrans/report",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [report - 对机翻内容举报↗](https://yapi.yuewen.com/project/2309/interface/api/195213) 的 **请求配置**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/report`
 * @更新时间 `2021-01-25 19:59:30`
 */
const goPcmMachineTransReportRequestConfig: GoPcmMachineTransReportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_31,
    devUrl: devUrl_0_0_0_31,
    prodUrl: prodUrl_0_0_0_31,
    path: "/go/pcm/machineTrans/report",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMachineTransReport",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [report - 对机翻内容举报↗](https://yapi.yuewen.com/project/2309/interface/api/195213) 的 **请求函数**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/report`
 * @更新时间 `2021-01-25 19:59:30`
 */
export const goPcmMachineTransReport = /*#__PURE__*/ (
  requestData: GoPcmMachineTransReportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMachineTransReportResponse>(
    prepare(goPcmMachineTransReportRequestConfig, requestData),
    ...args
  );
};

goPcmMachineTransReport.requestConfig = goPcmMachineTransReportRequestConfig;

const mockUrl_0_0_0_32 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_32 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_32 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_32 = "data" as any;

/**
 * 接口 [ readingHistoryAjax - 历史记录列表↗](https://yapi.yuewen.com/project/2309/interface/api/195906) 的 **请求类型**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryAjax`
 * @更新时间 `2021-01-28 15:36:35`
 */
export interface GoPcmReadingHistoryReadingHistoryAjaxRequest {
  /**
   * 页码
   */
  pageIndex: string;
}

/**
 * 接口 [ readingHistoryAjax - 历史记录列表↗](https://yapi.yuewen.com/project/2309/interface/api/195906) 的 **返回类型**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryAjax`
 * @更新时间 `2021-01-28 15:36:35`
 */
export interface GoPcmReadingHistoryReadingHistoryAjaxResponse {
  /**
   * [{"bookId":"@id","bookName":"@name","novelType":"200","categoryName":"Sci-Fi","newChapterId":"-1","newChapterIndex":1,"readToChapterId":"@id","readToChapterIndex":1,"firstChapterId":"@id","newChapterTime":1,"readToChapterNum":"40"}]
   */
  historyItems?: {
    /**
     * "@id"
     */
    bookId?: string;
    /**
     * "@name"
     */
    bookName?: string;
    /**
     * "200"
     */
    novelType?: string;
    /**
     * "Sci-Fi"
     */
    categoryName?: string;
    /**
     * "-1"
     */
    newChapterId?: string;
    /**
     * 1
     */
    newChapterIndex?: number;
    /**
     * "@id"
     */
    readToChapterId?: string;
    /**
     * 1
     */
    readToChapterIndex?: number;
    /**
     * "@id"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    newChapterTime?: number;
    /**
     * "40"
     */
    readToChapterNum?: string;
  }[];
  /**
   * 1
   */
  isLast?: number;
  /**
   * "123"
   */
  total?: string;
}

/**
 * 接口 [ readingHistoryAjax - 历史记录列表↗](https://yapi.yuewen.com/project/2309/interface/api/195906) 的 **请求配置的类型**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryAjax`
 * @更新时间 `2021-01-28 15:36:35`
 */
type GoPcmReadingHistoryReadingHistoryAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/readingHistory/readingHistoryAjax",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [ readingHistoryAjax - 历史记录列表↗](https://yapi.yuewen.com/project/2309/interface/api/195906) 的 **请求配置**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryAjax`
 * @更新时间 `2021-01-28 15:36:35`
 */
const goPcmReadingHistoryReadingHistoryAjaxRequestConfig: GoPcmReadingHistoryReadingHistoryAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_32,
    devUrl: devUrl_0_0_0_32,
    prodUrl: prodUrl_0_0_0_32,
    path: "/go/pcm/readingHistory/readingHistoryAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_32,
    paramNames: [],
    queryNames: ["pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingHistoryReadingHistoryAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [ readingHistoryAjax - 历史记录列表↗](https://yapi.yuewen.com/project/2309/interface/api/195906) 的 **请求函数**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryAjax`
 * @更新时间 `2021-01-28 15:36:35`
 */
export const goPcmReadingHistoryReadingHistoryAjax = /*#__PURE__*/ (
  requestData: GoPcmReadingHistoryReadingHistoryAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmReadingHistoryReadingHistoryAjaxResponse>(
    prepare(goPcmReadingHistoryReadingHistoryAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmReadingHistoryReadingHistoryAjax.requestConfig =
  goPcmReadingHistoryReadingHistoryAjaxRequestConfig;

/**
 * 接口 [ readingHistoryPage - 历史记录列表直出↗](https://yapi.yuewen.com/project/2309/interface/api/195917) 的 **请求类型**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryPage`
 * @更新时间 `2021-01-28 15:38:09`
 */
export interface GoPcmReadingHistoryReadingHistoryPageRequest {
  /**
   * 页码
   */
  pageIndex: string;
}

/**
 * 接口 [ readingHistoryPage - 历史记录列表直出↗](https://yapi.yuewen.com/project/2309/interface/api/195917) 的 **返回类型**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryPage`
 * @更新时间 `2021-01-28 15:38:09`
 */
export interface GoPcmReadingHistoryReadingHistoryPageResponse {
  /**
   * [{"bookId":"@id","bookName":"@name","novelType":"200","categoryName":"Sci-Fi","newChapterId":"-1","newChapterIndex":1,"readToChapterId":"@id","readToChapterIndex":1,"firstChapterId":"@id","newChapterTime":1,"readToChapterNum":"40"}]
   */
  historyItems?: {
    /**
     * "@id"
     */
    bookId?: string;
    /**
     * "@name"
     */
    bookName?: string;
    /**
     * "200"
     */
    novelType?: string;
    /**
     * "Sci-Fi"
     */
    categoryName?: string;
    /**
     * "-1"
     */
    newChapterId?: string;
    /**
     * 1
     */
    newChapterIndex?: number;
    /**
     * "@id"
     */
    readToChapterId?: string;
    /**
     * 1
     */
    readToChapterIndex?: number;
    /**
     * "@id"
     */
    firstChapterId?: string;
    /**
     * 1
     */
    newChapterTime?: number;
    /**
     * "40"
     */
    readToChapterNum?: string;
  }[];
  /**
   * 1
   */
  isLast?: number;
  /**
   * "123"
   */
  total?: string;
  user?: {
    /**
     * "null"
     */
    avatar?: string;
    /**
     * "null"
     */
    nickName?: string;
    /**
     * "null"
     */
    userName?: string;
    /**
     * "41830698"
     */
    guid?: string;
    status?: number;
    /**
     * "null"
     */
    role?: string;
    /**
     * "null"
     */
    penName?: string;
  };
}

/**
 * 接口 [ readingHistoryPage - 历史记录列表直出↗](https://yapi.yuewen.com/project/2309/interface/api/195917) 的 **请求配置的类型**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryPage`
 * @更新时间 `2021-01-28 15:38:09`
 */
type GoPcmReadingHistoryReadingHistoryPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/readingHistory/readingHistoryPage",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [ readingHistoryPage - 历史记录列表直出↗](https://yapi.yuewen.com/project/2309/interface/api/195917) 的 **请求配置**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryPage`
 * @更新时间 `2021-01-28 15:38:09`
 */
const goPcmReadingHistoryReadingHistoryPageRequestConfig: GoPcmReadingHistoryReadingHistoryPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_32,
    devUrl: devUrl_0_0_0_32,
    prodUrl: prodUrl_0_0_0_32,
    path: "/go/pcm/readingHistory/readingHistoryPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_32,
    paramNames: [],
    queryNames: ["pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingHistoryReadingHistoryPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [ readingHistoryPage - 历史记录列表直出↗](https://yapi.yuewen.com/project/2309/interface/api/195917) 的 **请求函数**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryPage`
 * @更新时间 `2021-01-28 15:38:09`
 */
export const goPcmReadingHistoryReadingHistoryPage = /*#__PURE__*/ (
  requestData: GoPcmReadingHistoryReadingHistoryPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmReadingHistoryReadingHistoryPageResponse>(
    prepare(goPcmReadingHistoryReadingHistoryPageRequestConfig, requestData),
    ...args
  );
};

goPcmReadingHistoryReadingHistoryPage.requestConfig =
  goPcmReadingHistoryReadingHistoryPageRequestConfig;

/**
 * 接口 [deleteReadingHistory - 删除阅读历史↗](https://yapi.yuewen.com/project/2309/interface/api/195923) 的 **请求类型**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/deleteReadingHistory`
 * @更新时间 `2021-01-28 15:42:55`
 */
export interface GoPcmReadingHistoryDeleteReadingHistoryRequest {
  bookId: string;
}

/**
 * 接口 [deleteReadingHistory - 删除阅读历史↗](https://yapi.yuewen.com/project/2309/interface/api/195923) 的 **返回类型**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/deleteReadingHistory`
 * @更新时间 `2021-01-28 15:42:55`
 */
export interface GoPcmReadingHistoryDeleteReadingHistoryResponse {
  code?: number;
  /**
   * "Success"
   */
  msg?: string;
}

/**
 * 接口 [deleteReadingHistory - 删除阅读历史↗](https://yapi.yuewen.com/project/2309/interface/api/195923) 的 **请求配置的类型**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/deleteReadingHistory`
 * @更新时间 `2021-01-28 15:42:55`
 */
type GoPcmReadingHistoryDeleteReadingHistoryRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/readingHistory/deleteReadingHistory",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [deleteReadingHistory - 删除阅读历史↗](https://yapi.yuewen.com/project/2309/interface/api/195923) 的 **请求配置**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/deleteReadingHistory`
 * @更新时间 `2021-01-28 15:42:55`
 */
const goPcmReadingHistoryDeleteReadingHistoryRequestConfig: GoPcmReadingHistoryDeleteReadingHistoryRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_32,
    devUrl: devUrl_0_0_0_32,
    prodUrl: prodUrl_0_0_0_32,
    path: "/go/pcm/readingHistory/deleteReadingHistory",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_32,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingHistoryDeleteReadingHistory",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [deleteReadingHistory - 删除阅读历史↗](https://yapi.yuewen.com/project/2309/interface/api/195923) 的 **请求函数**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/deleteReadingHistory`
 * @更新时间 `2021-01-28 15:42:55`
 */
export const goPcmReadingHistoryDeleteReadingHistory = /*#__PURE__*/ (
  requestData: GoPcmReadingHistoryDeleteReadingHistoryRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmReadingHistoryDeleteReadingHistoryResponse>(
    prepare(goPcmReadingHistoryDeleteReadingHistoryRequestConfig, requestData),
    ...args
  );
};

goPcmReadingHistoryDeleteReadingHistory.requestConfig =
  goPcmReadingHistoryDeleteReadingHistoryRequestConfig;

/**
 * 接口 [clearReadingHistory - 清除所有历史记录↗](https://yapi.yuewen.com/project/2309/interface/api/195924) 的 **请求类型**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/clearReadingHistory`
 * @更新时间 `2021-01-28 15:49:51`
 */
export interface GoPcmReadingHistoryClearReadingHistoryRequest {}

/**
 * 接口 [clearReadingHistory - 清除所有历史记录↗](https://yapi.yuewen.com/project/2309/interface/api/195924) 的 **返回类型**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/clearReadingHistory`
 * @更新时间 `2021-01-28 15:49:51`
 */
export interface GoPcmReadingHistoryClearReadingHistoryResponse {}

/**
 * 接口 [clearReadingHistory - 清除所有历史记录↗](https://yapi.yuewen.com/project/2309/interface/api/195924) 的 **请求配置的类型**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/clearReadingHistory`
 * @更新时间 `2021-01-28 15:49:51`
 */
type GoPcmReadingHistoryClearReadingHistoryRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/readingHistory/clearReadingHistory",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [clearReadingHistory - 清除所有历史记录↗](https://yapi.yuewen.com/project/2309/interface/api/195924) 的 **请求配置**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/clearReadingHistory`
 * @更新时间 `2021-01-28 15:49:51`
 */
const goPcmReadingHistoryClearReadingHistoryRequestConfig: GoPcmReadingHistoryClearReadingHistoryRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_32,
    devUrl: devUrl_0_0_0_32,
    prodUrl: prodUrl_0_0_0_32,
    path: "/go/pcm/readingHistory/clearReadingHistory",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_32,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingHistoryClearReadingHistory",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [clearReadingHistory - 清除所有历史记录↗](https://yapi.yuewen.com/project/2309/interface/api/195924) 的 **请求函数**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/clearReadingHistory`
 * @更新时间 `2021-01-28 15:49:51`
 */
export const goPcmReadingHistoryClearReadingHistory = /*#__PURE__*/ (
  requestData?: GoPcmReadingHistoryClearReadingHistoryRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmReadingHistoryClearReadingHistoryResponse>(
    prepare(goPcmReadingHistoryClearReadingHistoryRequestConfig, requestData),
    ...args
  );
};

goPcmReadingHistoryClearReadingHistory.requestConfig =
  goPcmReadingHistoryClearReadingHistoryRequestConfig;

const mockUrl_0_0_0_33 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_33 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_33 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_33 = "data" as any;

/**
 * 接口 [GetMessages 消息页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/196778) 的 **请求类型**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessages`
 * @更新时间 `2021-02-07 14:57:25`
 */
export interface GoPcmMessageGetMessagesRequest {
  /**
   * lastId 上次返回的最后一条id.如果是第一次调用,传空字符串
   */
  lastId?: string;
}

/**
 * 接口 [GetMessages 消息页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/196778) 的 **返回类型**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessages`
 * @更新时间 `2021-02-07 14:57:25`
 */
export interface GoPcmMessageGetMessagesResponse {
  /**
   * [{"id":"@id","createTime":"@timestamp","createTimeFormat":"11, Nov","title":"@title","content":"@string","imageUrl":"@url","actionUrl":"@url"}]
   */
  messageItems?: {
    /**
     * "@id"
     */
    id?: string;
    /**
     * "@timestamp"
     */
    createTime?: string;
    /**
     * "11, Nov"
     */
    createTimeFormat?: string;
    /**
     * "@title"
     */
    title?: string;
    /**
     * "@string"
     */
    content?: string;
    /**
     * "@url"
     */
    imageUrl?: string;
    /**
     * "@url"
     */
    actionUrl?: string;
  }[];
  user?: {
    avatar?: string;
    nickName?: string;
    userName?: string;
    guid?: string;
    /**
     * -1
     */
    status?: number;
    penName?: null;
    UUT?: null;
    role?: null;
    userLevel?: null;
    availablePower?: null;
    totalPower?: null;
    availableEnergy?: null;
    totalEnergy?: null;
  };
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [GetMessages 消息页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/196778) 的 **请求配置的类型**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessages`
 * @更新时间 `2021-02-07 14:57:25`
 */
type GoPcmMessageGetMessagesRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/message/getMessages",
    "data",
    string,
    "lastId",
    false
  >
>;

/**
 * 接口 [GetMessages 消息页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/196778) 的 **请求配置**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessages`
 * @更新时间 `2021-02-07 14:57:25`
 */
const goPcmMessageGetMessagesRequestConfig: GoPcmMessageGetMessagesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_33,
    devUrl: devUrl_0_0_0_33,
    prodUrl: prodUrl_0_0_0_33,
    path: "/go/pcm/message/getMessages",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_33,
    paramNames: [],
    queryNames: ["lastId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMessageGetMessages",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [GetMessages 消息页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/196778) 的 **请求函数**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessages`
 * @更新时间 `2021-02-07 14:57:25`
 */
export const goPcmMessageGetMessages = /*#__PURE__*/ (
  requestData: GoPcmMessageGetMessagesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMessageGetMessagesResponse>(
    prepare(goPcmMessageGetMessagesRequestConfig, requestData),
    ...args
  );
};

goPcmMessageGetMessages.requestConfig = goPcmMessageGetMessagesRequestConfig;

/**
 * 接口 [GetMessagesAjax 消息列表ajax请求接口↗](https://yapi.yuewen.com/project/2309/interface/api/196787) 的 **请求类型**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessagesAjax`
 * @更新时间 `2021-02-07 14:20:59`
 */
export interface GoPcmMessageGetMessagesAjaxRequest {
  /**
   * lastId 上次返回的最后一条id.如果是第一次调用,传空字符串
   */
  lastId: string;
}

/**
 * 接口 [GetMessagesAjax 消息列表ajax请求接口↗](https://yapi.yuewen.com/project/2309/interface/api/196787) 的 **返回类型**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessagesAjax`
 * @更新时间 `2021-02-07 14:20:59`
 */
export interface GoPcmMessageGetMessagesAjaxResponse {
  user?: {
    avatar?: string;
    nickName?: string;
    userName?: string;
    guid?: string;
    /**
     * -1
     */
    status?: number;
    penName?: null;
    UUT?: null;
    role?: null;
    userLevel?: null;
    availablePower?: null;
    totalPower?: null;
    availableEnergy?: null;
    totalEnergy?: null;
  };
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [GetMessagesAjax 消息列表ajax请求接口↗](https://yapi.yuewen.com/project/2309/interface/api/196787) 的 **请求配置的类型**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessagesAjax`
 * @更新时间 `2021-02-07 14:20:59`
 */
type GoPcmMessageGetMessagesAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/message/getMessagesAjax",
    "data",
    string,
    "lastId",
    false
  >
>;

/**
 * 接口 [GetMessagesAjax 消息列表ajax请求接口↗](https://yapi.yuewen.com/project/2309/interface/api/196787) 的 **请求配置**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessagesAjax`
 * @更新时间 `2021-02-07 14:20:59`
 */
const goPcmMessageGetMessagesAjaxRequestConfig: GoPcmMessageGetMessagesAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_33,
    devUrl: devUrl_0_0_0_33,
    prodUrl: prodUrl_0_0_0_33,
    path: "/go/pcm/message/getMessagesAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_33,
    paramNames: [],
    queryNames: ["lastId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMessageGetMessagesAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [GetMessagesAjax 消息列表ajax请求接口↗](https://yapi.yuewen.com/project/2309/interface/api/196787) 的 **请求函数**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessagesAjax`
 * @更新时间 `2021-02-07 14:20:59`
 */
export const goPcmMessageGetMessagesAjax = /*#__PURE__*/ (
  requestData: GoPcmMessageGetMessagesAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMessageGetMessagesAjaxResponse>(
    prepare(goPcmMessageGetMessagesAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmMessageGetMessagesAjax.requestConfig =
  goPcmMessageGetMessagesAjaxRequestConfig;

const mockUrl_0_0_0_34 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_34 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_34 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_34 = "data" as any;

/**
 * 接口 [claimTaskReward↗](https://yapi.yuewen.com/project/2309/interface/api/197973) 的 **请求类型**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `POST /go/pcm/task/claimTaskReward`
 * @更新时间 `2021-02-23 19:39:41`
 */
export interface GoPcmTaskClaimTaskRewardRequest {
  taskId: string;
}

/**
 * 接口 [claimTaskReward↗](https://yapi.yuewen.com/project/2309/interface/api/197973) 的 **返回类型**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `POST /go/pcm/task/claimTaskReward`
 * @更新时间 `2021-02-23 19:39:41`
 */
export interface GoPcmTaskClaimTaskRewardResponse {
  taskInfo?: {
    /**
     * 30
     */
    ss?: number;
    /**
     * 50
     */
    exp?: number;
    /**
     * [{"awardType":1,"amount":1},{"awardType":2,"amount":2},{"awardType":3,"amount":3},{"awardType":4,"amount":4},{"awardType":5,"amount":5}]
     */
    awards?: {
      /**
       * 1
       */
      awardType?: number;
      /**
       * 1
       */
      amount?: number;
    }[];
  };
}

/**
 * 接口 [claimTaskReward↗](https://yapi.yuewen.com/project/2309/interface/api/197973) 的 **请求配置的类型**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `POST /go/pcm/task/claimTaskReward`
 * @更新时间 `2021-02-23 19:39:41`
 */
type GoPcmTaskClaimTaskRewardRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/task/claimTaskReward",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [claimTaskReward↗](https://yapi.yuewen.com/project/2309/interface/api/197973) 的 **请求配置**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `POST /go/pcm/task/claimTaskReward`
 * @更新时间 `2021-02-23 19:39:41`
 */
const goPcmTaskClaimTaskRewardRequestConfig: GoPcmTaskClaimTaskRewardRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_34,
    devUrl: devUrl_0_0_0_34,
    prodUrl: prodUrl_0_0_0_34,
    path: "/go/pcm/task/claimTaskReward",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_34,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTaskClaimTaskReward",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [claimTaskReward↗](https://yapi.yuewen.com/project/2309/interface/api/197973) 的 **请求函数**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `POST /go/pcm/task/claimTaskReward`
 * @更新时间 `2021-02-23 19:39:41`
 */
export const goPcmTaskClaimTaskReward = /*#__PURE__*/ (
  requestData: GoPcmTaskClaimTaskRewardRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmTaskClaimTaskRewardResponse>(
    prepare(goPcmTaskClaimTaskRewardRequestConfig, requestData),
    ...args
  );
};

goPcmTaskClaimTaskReward.requestConfig = goPcmTaskClaimTaskRewardRequestConfig;

/**
 * 接口 [getTaskList↗](https://yapi.yuewen.com/project/2309/interface/api/197990) 的 **请求类型**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `GET /go/pcm/task/getTaskList`
 * @更新时间 `2021-02-23 19:42:22`
 */
export interface GoPcmTaskGetTaskListRequest {
  /**
   * 1为daily 2为upgrade 3为reading
   */
  taskType: string;
}

/**
 * 接口 [getTaskList↗](https://yapi.yuewen.com/project/2309/interface/api/197990) 的 **返回类型**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `GET /go/pcm/task/getTaskList`
 * @更新时间 `2021-02-23 19:42:22`
 */
export interface GoPcmTaskGetTaskListResponse {
  /**
   * [{"taskId":100101,"taskName":"checkin","completeStatus":1,"completePercentage":30,"taskType":1,"ss":30,"exp":20,"awards":[{"awardType":1,"amount":1},{"awardType":2,"amount":2},{"awardType":3,"amount":3},{"awardType":4,"amount":4},{"awardType":5,"amount":5}]},{"taskId":100102,"taskName":"gift two book","completeStatus":2,"completePercentage":100,"taskType":1,"ss":33,"exp":21,"awards":[{"awardType":1,"amount":1}]}]
   */
  taskList?: {
    /**
     * 100101
     */
    taskId?: number;
    /**
     * "checkin"
     */
    taskName?: string;
    /**
     * 1
     */
    completeStatus?: number;
    /**
     * 30
     */
    completePercentage?: number;
    /**
     * 1
     */
    taskType?: number;
    /**
     * 30
     */
    ss?: number;
    /**
     * 20
     */
    exp?: number;
    /**
     * [{"awardType":1,"amount":1},{"awardType":2,"amount":2},{"awardType":3,"amount":3},{"awardType":4,"amount":4},{"awardType":5,"amount":5}]
     */
    awards?: {
      /**
       * 1
       */
      awardType?: number;
      /**
       * 1
       */
      amount?: number;
    }[];
  }[];
  /**
   * 1
   */
  taskType?: number;
}

/**
 * 接口 [getTaskList↗](https://yapi.yuewen.com/project/2309/interface/api/197990) 的 **请求配置的类型**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `GET /go/pcm/task/getTaskList`
 * @更新时间 `2021-02-23 19:42:22`
 */
type GoPcmTaskGetTaskListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/task/getTaskList",
    "data",
    string,
    "taskType",
    false
  >
>;

/**
 * 接口 [getTaskList↗](https://yapi.yuewen.com/project/2309/interface/api/197990) 的 **请求配置**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `GET /go/pcm/task/getTaskList`
 * @更新时间 `2021-02-23 19:42:22`
 */
const goPcmTaskGetTaskListRequestConfig: GoPcmTaskGetTaskListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_34,
    devUrl: devUrl_0_0_0_34,
    prodUrl: prodUrl_0_0_0_34,
    path: "/go/pcm/task/getTaskList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_34,
    paramNames: [],
    queryNames: ["taskType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTaskGetTaskList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getTaskList↗](https://yapi.yuewen.com/project/2309/interface/api/197990) 的 **请求函数**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `GET /go/pcm/task/getTaskList`
 * @更新时间 `2021-02-23 19:42:22`
 */
export const goPcmTaskGetTaskList = /*#__PURE__*/ (
  requestData: GoPcmTaskGetTaskListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmTaskGetTaskListResponse>(
    prepare(goPcmTaskGetTaskListRequestConfig, requestData),
    ...args
  );
};

goPcmTaskGetTaskList.requestConfig = goPcmTaskGetTaskListRequestConfig;

const mockUrl_0_0_0_35 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_35 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_35 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_35 = "data" as any;

/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/198180) 的 **请求类型**
 *
 * @分类 [PublishBook↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26333)
 * @请求头 `POST /go/pcm/publishBook/getBookDetailPage`
 * @更新时间 `2021-03-09 15:48:24`
 */
export interface GoPcmPublishBookGetBookDetailPageRequest {
  bookId: string;
}

/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/198180) 的 **返回类型**
 *
 * @分类 [PublishBook↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26333)
 * @请求头 `POST /go/pcm/publishBook/getBookDetailPage`
 * @更新时间 `2021-03-09 15:48:24`
 */
export interface GoPcmPublishBookGetBookDetailPageResponse {
  bookInfo?: {
    /**
     * "13656936905634105"
     */
    bookId?: string;
    /**
     * "What is Coming? A Forecast of Things after the War"
     */
    bookName?: string;
    /**
     * " H. G. (Herbert George) Wells"
     */
    authorName?: string;
    /**
     * "Trajectory, Inc."
     */
    publisher?: string;
    /**
     * "65.4K"
     */
    words?: string;
    /**
     * 1
     */
    language?: number;
    /**
     * "en"
     */
    languageName?: string;
    /**
     * 1412092800000
     */
    publishTime?: number;
    /**
     * "\"What is Coming? A Forecast of Things after the War\" by H.G. Wells is a book that was influenced by World War I.  H.G. Wells examines a solution and dream for world peace."
     */
    description?: string;
    /**
     * 95008
     */
    categoryId?: number;
    /**
     * "Literature & Fiction"
     */
    categoryName?: string;
    /**
     * 50
     */
    status?: number;
    /**
     * 15
     */
    checkLevel?: number;
    inLibrary?: number;
    giftNum?: number;
    giftInfo?: {
      giftNum?: number;
      giftMax?: {
        /**
         * 21329
         */
        id?: number;
        /**
         * "13656936905634105"
         */
        bookId?: string;
        chapterId?: number;
        /**
         * 1901271742
         */
        userId?: number;
        /**
         * 1
         */
        giftAmount?: number;
        /**
         * "6738627264389584405"
         */
        orderId?: string;
        /**
         * 20002
         */
        giftId?: number;
        /**
         * 25
         */
        totalPrice?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Lollipop"
         */
        giftName?: string;
        /**
         * 25
         */
        giftPrice?: number;
        /**
         * "https://webbanner.webnovel.com/gift/1539660166_6913.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        /**
         * 1599553888781
         */
        UUT?: number;
        /**
         * "190_prot"
         */
        userName?: string;
      };
      /**
       * [{"id":30367,"userId":1901271742,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1599553888781,"userName":"190_prot"},{"id":25133,"userId":1901271742,"giftId":20001,"appId":10,"giftName":"Balloon","giftPrice":5,"iconUrl":"https://webbanner.webnovel.com/gift/1539660206_9513.png","status":1,"order":1,"UUT":1599553888781,"userName":"190_prot"}]
       */
      giftRecords?: {
        /**
         * 30367
         */
        id?: number;
        /**
         * 1901271742
         */
        userId?: number;
        /**
         * 20001
         */
        giftId?: number;
        /**
         * 10
         */
        appId?: number;
        /**
         * "Balloon"
         */
        giftName?: string;
        /**
         * 5
         */
        giftPrice?: number;
        /**
         * "https://webbanner.webnovel.com/gift/1539660206_9513.png"
         */
        iconUrl?: string;
        /**
         * 1
         */
        status?: number;
        /**
         * 1
         */
        order?: number;
        /**
         * 1599553888781
         */
        UUT?: number;
        /**
         * "190_prot"
         */
        userName?: string;
      }[];
    };
    /**
     * [{"userId":4300009639,"appId":10,"votingCount":39382,"UUT":1604656231478,"userName":"liwenwen"},{"userId":4300009639,"appId":10,"votingCount":39382,"UUT":1604656231478,"userName":"liwenwen"}]
     */
    topFanItems?: {
      /**
       * 4300009639
       */
      userId?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * 39382
       */
      votingCount?: number;
      /**
       * 1604656231478
       */
      UUT?: number;
      /**
       * "liwenwen"
       */
      userName?: string;
    }[];
  };
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300002453/1/1.jpg?mt=1568770071000"
     */
    avatar?: string;
    /**
     * "sunmeiye"
     */
    nickName?: string;
    /**
     * "sunmeiye"
     */
    userName?: string;
    /**
     * "4300002453"
     */
    guid?: string;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * "sunmeiye"
     */
    penName?: string;
    /**
     * 9861
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    bSS?: number;
    /**
     * 1
     */
    grade?: number;
    /**
     * 1
     */
    ES?: number;
    /**
     * 1
     */
    totalES?: number;
    /**
     * 1
     */
    PS?: number;
    /**
     * 1
     */
    totalPS?: number;
    /**
     * 1
     */
    emailStatus?: number;
    /**
     * true
     */
    isCheckIn?: boolean;
    UUT?: number;
    /**
     * 102
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
  };
}

/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/198180) 的 **请求配置的类型**
 *
 * @分类 [PublishBook↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26333)
 * @请求头 `POST /go/pcm/publishBook/getBookDetailPage`
 * @更新时间 `2021-03-09 15:48:24`
 */
type GoPcmPublishBookGetBookDetailPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/publishBook/getBookDetailPage",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/198180) 的 **请求配置**
 *
 * @分类 [PublishBook↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26333)
 * @请求头 `POST /go/pcm/publishBook/getBookDetailPage`
 * @更新时间 `2021-03-09 15:48:24`
 */
const goPcmPublishBookGetBookDetailPageRequestConfig: GoPcmPublishBookGetBookDetailPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_35,
    devUrl: devUrl_0_0_0_35,
    prodUrl: prodUrl_0_0_0_35,
    path: "/go/pcm/publishBook/getBookDetailPage",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_35,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPublishBookGetBookDetailPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/198180) 的 **请求函数**
 *
 * @分类 [PublishBook↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26333)
 * @请求头 `POST /go/pcm/publishBook/getBookDetailPage`
 * @更新时间 `2021-03-09 15:48:24`
 */
export const goPcmPublishBookGetBookDetailPage = /*#__PURE__*/ (
  requestData: GoPcmPublishBookGetBookDetailPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPublishBookGetBookDetailPageResponse>(
    prepare(goPcmPublishBookGetBookDetailPageRequestConfig, requestData),
    ...args
  );
};

goPcmPublishBookGetBookDetailPage.requestConfig =
  goPcmPublishBookGetBookDetailPageRequestConfig;

const mockUrl_0_0_0_36 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_36 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_36 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_36 = "data" as any;

/**
 * 接口 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/198696) 的 **请求类型**
 *
 * @分类 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26488)
 * @请求头 `GET /go/pcm/ranking/getRanking`
 * @更新时间 `2021-03-16 15:05:40`
 */
export interface GoPcmRankingGetRankingRequest {
  rankId: string;
  /**
   * 榜单的类型，总榜日榜月榜，24h 7day 14day等
   */
  timeType: string;
  /**
   * 0小说，100漫画
   */
  novelType: string;
  /**
   * 1:小说 4：Fan-fic
   */
  categoryType: string;
  /**
   * 0总榜，1新书榜
   */
  listType: string;
  /**
   * 传语言过来
   */
  language: string;
  /**
   * 分页，一页默认20条，可修改
   */
  pageIndex: string;
  /**
   * 区分原创和翻译书，1是翻译，2是原创，不传就是全部
   */
  bookType: string;
  /**
   * 默认 传 -1   男 - 1， 女 - 2
   */
  sex: string;
  /**
   * 0:所有 1:ongoing 2:completed， 出版书无该选项 默认1
   */
  bookStatus: string;
}

/**
 * 接口 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/198696) 的 **返回类型**
 *
 * @分类 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26488)
 * @请求头 `GET /go/pcm/ranking/getRanking`
 * @更新时间 `2021-03-16 15:05:40`
 */
export interface GoPcmRankingGetRankingResponse {}

/**
 * 接口 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/198696) 的 **请求配置的类型**
 *
 * @分类 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26488)
 * @请求头 `GET /go/pcm/ranking/getRanking`
 * @更新时间 `2021-03-16 15:05:40`
 */
type GoPcmRankingGetRankingRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/ranking/getRanking",
    "data",
    string,
    | "rankId"
    | "timeType"
    | "novelType"
    | "categoryType"
    | "listType"
    | "language"
    | "pageIndex"
    | "bookType"
    | "sex"
    | "bookStatus",
    false
  >
>;

/**
 * 接口 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/198696) 的 **请求配置**
 *
 * @分类 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26488)
 * @请求头 `GET /go/pcm/ranking/getRanking`
 * @更新时间 `2021-03-16 15:05:40`
 */
const goPcmRankingGetRankingRequestConfig: GoPcmRankingGetRankingRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_36,
    devUrl: devUrl_0_0_0_36,
    prodUrl: prodUrl_0_0_0_36,
    path: "/go/pcm/ranking/getRanking",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_36,
    paramNames: [],
    queryNames: [
      "rankId",
      "timeType",
      "novelType",
      "categoryType",
      "listType",
      "language",
      "pageIndex",
      "bookType",
      "sex",
      "bookStatus",
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRankingGetRanking",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/198696) 的 **请求函数**
 *
 * @分类 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26488)
 * @请求头 `GET /go/pcm/ranking/getRanking`
 * @更新时间 `2021-03-16 15:05:40`
 */
export const goPcmRankingGetRanking = /*#__PURE__*/ (
  requestData: GoPcmRankingGetRankingRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmRankingGetRankingResponse>(
    prepare(goPcmRankingGetRankingRequestConfig, requestData),
    ...args
  );
};

goPcmRankingGetRanking.requestConfig = goPcmRankingGetRankingRequestConfig;

const mockUrl_0_0_0_37 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_37 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_37 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_37 = "data" as any;

/**
 * 接口 [like 投票↗](https://yapi.yuewen.com/project/2309/interface/api/206970) 的 **请求类型**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/like`
 * @更新时间 `2021-05-11 19:11:59`
 */
export interface GoPcmVoteLikeRequest {
  /**
   * 书id
   */
  bookId: string;
}

/**
 * 接口 [like 投票↗](https://yapi.yuewen.com/project/2309/interface/api/206970) 的 **返回类型**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/like`
 * @更新时间 `2021-05-11 19:11:59`
 */
export interface GoPcmVoteLikeResponse {
  /**
   * 5
   */
  SS?: number;
  /**
   * [{"awardType":5,"amount":1,"probability":1000,"content":"{\"pointsTypeId\":1001,\"amount\":1,\"fastPassId\":\"\",\"bookType\":0,\"num\":1}"}]
   */
  awards?: {
    /**
     * 5
     */
    awardType?: number;
    /**
     * 1
     */
    amount?: number;
    /**
     * 1000
     */
    probability?: number;
    /**
     * "{\"pointsTypeId\":1001,\"amount\":1,\"fastPassId\":\"\",\"bookType\":0,\"num\":1}"
     */
    content?: string;
  }[];
}

/**
 * 接口 [like 投票↗](https://yapi.yuewen.com/project/2309/interface/api/206970) 的 **请求配置的类型**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/like`
 * @更新时间 `2021-05-11 19:11:59`
 */
type GoPcmVoteLikeRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/vote/like",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [like 投票↗](https://yapi.yuewen.com/project/2309/interface/api/206970) 的 **请求配置**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/like`
 * @更新时间 `2021-05-11 19:11:59`
 */
const goPcmVoteLikeRequestConfig: GoPcmVoteLikeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_37,
  devUrl: devUrl_0_0_0_37,
  prodUrl: prodUrl_0_0_0_37,
  path: "/go/pcm/vote/like",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_37,
  paramNames: [],
  queryNames: ["bookId"],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "goPcmVoteLike",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [like 投票↗](https://yapi.yuewen.com/project/2309/interface/api/206970) 的 **请求函数**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/like`
 * @更新时间 `2021-05-11 19:11:59`
 */
export const goPcmVoteLike = /*#__PURE__*/ (
  requestData: GoPcmVoteLikeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmVoteLikeResponse>(
    prepare(goPcmVoteLikeRequestConfig, requestData),
    ...args
  );
};

goPcmVoteLike.requestConfig = goPcmVoteLikeRequestConfig;

/**
 * 接口 [list 拉取投票书列表↗](https://yapi.yuewen.com/project/2309/interface/api/207456) 的 **请求类型**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/list`
 * @更新时间 `2021-05-11 19:12:16`
 */
export interface GoPcmVoteListRequest {
  /**
   * 页码
   */
  pageIndex: string;
}

/**
 * 接口 [list 拉取投票书列表↗](https://yapi.yuewen.com/project/2309/interface/api/207456) 的 **返回类型**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/list`
 * @更新时间 `2021-05-11 19:12:16`
 */
export interface GoPcmVoteListResponse {
  topLastWeek?: {
    female?: {
      /**
       * "nanuat"
       */
      authorName?: string;
      /**
       * "19704557301133305"
       */
      bookId?: string;
      /**
       * "webnovel hh hhh"
       */
      bookName?: string;
      /**
       * 1618901484837
       */
      coverUpdateTime?: number;
      energyNum?: number;
      /**
       * "en"
       */
      languageName?: string;
      /**
       * 2
       */
      sex?: number;
      /**
       * "0"
       */
      totalScore?: string;
      voteCount?: number;
      /**
       * "0.0"
       */
      votes?: string;
    };
    male?: {
      /**
       * "webnoveltest8"
       */
      authorName?: string;
      /**
       * "19704530101133005"
       */
      bookId?: string;
      /**
       * "webnoveltest safari"
       */
      bookName?: string;
      /**
       * 1617087115373
       */
      coverUpdateTime?: number;
      /**
       * 1
       */
      energyNum?: number;
      /**
       * "en"
       */
      languageName?: string;
      /**
       * 1
       */
      sex?: number;
      /**
       * "0"
       */
      totalScore?: string;
      /**
       * 1
       */
      voteCount?: number;
      /**
       * "0.0"
       */
      votes?: string;
    };
  };
  /**
   * [{"awardType":5,"amount":1,"probability":1000,"content":"{\"pointsTypeId\":1001,\"amount\":1,\"fastPassId\":\"\",\"bookType\":0,\"num\":1}"}]
   */
  awards?: {
    /**
     * 5
     */
    awardType?: number;
    /**
     * 1
     */
    amount?: number;
    /**
     * 1000
     */
    probability?: number;
    /**
     * "{\"pointsTypeId\":1001,\"amount\":1,\"fastPassId\":\"\",\"bookType\":0,\"num\":1}"
     */
    content?: string;
  }[];
  /**
   * [{"authorName":"Butterfly Blue","bookId":"7366916601012405","bookName":"The King's Avatar","coverUpdateTime":1581418734974,"energyNum":80,"sex":1,"voteCount":80},{"authorName":"nanuat","bookId":"19704557301133305","bookName":"webnovel hh hhh","coverUpdateTime":1618901484837,"energyNum":0,"sex":2,"voteCount":0},{"authorName":"123","bookId":"14095554801057905","bookName":"TEST0620","coverUpdateTime":1618901485311,"energyNum":2,"sex":2,"voteCount":2},{"authorName":"The Enlightened Master Crouching Cow","bookId":"6831119801006905","bookName":"Forty Millenniums of Cultivation","coverUpdateTime":1581421901380,"energyNum":23,"sex":1,"voteCount":23},{"authorName":"TYPO 1","bookId":"15230547501140405","bookName":"Genesis, field 550123802","coverUpdateTime":1606879626493,"energyNum":204,"sex":2,"voteCount":204}]
   */
  items?: {
    /**
     * "Butterfly Blue"
     */
    authorName?: string;
    /**
     * "7366916601012405"
     */
    bookId?: string;
    /**
     * "The King's Avatar"
     */
    bookName?: string;
    /**
     * 1581418734974
     */
    coverUpdateTime?: number;
    /**
     * 80
     */
    energyNum?: number;
    /**
     * 1
     */
    sex?: number;
    /**
     * 80
     */
    voteCount?: number;
  }[];
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300012720/1/1.jpg?mt=1608694770961"
     */
    avatar?: string;
    /**
     * "peter"
     */
    nickName?: string;
    /**
     * "peter"
     */
    userName?: string;
    /**
     * "peter"
     */
    authorName?: string;
    /**
     * "peter"
     */
    penName?: string;
    /**
     * 4300012720
     */
    guid?: number;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * 1
     */
    gender?: number;
    /**
     * 9985
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    /**
     * 14
     */
    bSS?: number;
    /**
     * 1637251200000
     */
    expiringTime?: number;
    /**
     * 1
     */
    grade?: number;
    /**
     * 1
     */
    ES?: number;
    /**
     * 1
     */
    totalES?: number;
    /**
     * 1
     */
    PS?: number;
    /**
     * 1
     */
    totalPS?: number;
    /**
     * "402374739@qq.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: number;
    /**
     * 1608694770961
     */
    UUT?: number;
    /**
     * 1
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 1
     */
    membershipStatus?: number;
    /**
     * 1622882786000
     */
    membershipExpireTime?: number;
    membershipClaimStatus?: boolean;
    /**
     * true
     */
    membershipIsFree?: boolean;
  };
  /**
   * 5
   */
  voteSs?: number;
  /**
   * 5
   */
  total?: number;
  /**
   * 1
   */
  isLast?: number;
}

/**
 * 接口 [list 拉取投票书列表↗](https://yapi.yuewen.com/project/2309/interface/api/207456) 的 **请求配置的类型**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/list`
 * @更新时间 `2021-05-11 19:12:16`
 */
type GoPcmVoteListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/vote/list",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [list 拉取投票书列表↗](https://yapi.yuewen.com/project/2309/interface/api/207456) 的 **请求配置**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/list`
 * @更新时间 `2021-05-11 19:12:16`
 */
const goPcmVoteListRequestConfig: GoPcmVoteListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_37,
  devUrl: devUrl_0_0_0_37,
  prodUrl: prodUrl_0_0_0_37,
  path: "/go/pcm/vote/list",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_37,
  paramNames: [],
  queryNames: ["pageIndex"],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "goPcmVoteList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [list 拉取投票书列表↗](https://yapi.yuewen.com/project/2309/interface/api/207456) 的 **请求函数**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/list`
 * @更新时间 `2021-05-11 19:12:16`
 */
export const goPcmVoteList = /*#__PURE__*/ (
  requestData: GoPcmVoteListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmVoteListResponse>(
    prepare(goPcmVoteListRequestConfig, requestData),
    ...args
  );
};

goPcmVoteList.requestConfig = goPcmVoteListRequestConfig;

const mockUrl_0_0_0_38 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_38 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_38 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_38 = "data" as any;

/**
 * 接口 [拉取更新信息 - 通知、消息、书架↗](https://yapi.yuewen.com/project/2309/interface/api/206975) 的 **请求类型**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/getUpdateNums`
 * @更新时间 `2021-04-28 15:14:33`
 */
export interface GoPcmBookstoreGetUpdateNumsRequest {}

/**
 * 接口 [拉取更新信息 - 通知、消息、书架↗](https://yapi.yuewen.com/project/2309/interface/api/206975) 的 **返回类型**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/getUpdateNums`
 * @更新时间 `2021-04-28 15:14:33`
 */
export interface GoPcmBookstoreGetUpdateNumsResponse {
  library?: {
    /**
     * 6
     */
    unReadNum?: number;
    /**
     * 1608341451000
     */
    timestamp?: number;
  };
  message?: {
    unReadNum?: number;
  };
  notification?: {
    unReadNum?: number;
  };
}

/**
 * 接口 [拉取更新信息 - 通知、消息、书架↗](https://yapi.yuewen.com/project/2309/interface/api/206975) 的 **请求配置的类型**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/getUpdateNums`
 * @更新时间 `2021-04-28 15:14:33`
 */
type GoPcmBookstoreGetUpdateNumsRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookstore/getUpdateNums",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [拉取更新信息 - 通知、消息、书架↗](https://yapi.yuewen.com/project/2309/interface/api/206975) 的 **请求配置**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/getUpdateNums`
 * @更新时间 `2021-04-28 15:14:33`
 */
const goPcmBookstoreGetUpdateNumsRequestConfig: GoPcmBookstoreGetUpdateNumsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_38,
    devUrl: devUrl_0_0_0_38,
    prodUrl: prodUrl_0_0_0_38,
    path: "/go/pcm/bookstore/getUpdateNums",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookstoreGetUpdateNums",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [拉取更新信息 - 通知、消息、书架↗](https://yapi.yuewen.com/project/2309/interface/api/206975) 的 **请求函数**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/getUpdateNums`
 * @更新时间 `2021-04-28 15:14:33`
 */
export const goPcmBookstoreGetUpdateNums = /*#__PURE__*/ (
  requestData?: GoPcmBookstoreGetUpdateNumsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookstoreGetUpdateNumsResponse>(
    prepare(goPcmBookstoreGetUpdateNumsRequestConfig, requestData),
    ...args
  );
};

goPcmBookstoreGetUpdateNums.requestConfig =
  goPcmBookstoreGetUpdateNumsRequestConfig;

/**
 * 接口 [拉取用户优先级最高的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/206993) 的 **请求类型**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/UserBadge`
 * @更新时间 `2021-04-28 15:50:50`
 */
export interface GoPcmBookstoreUserBadgeRequest {}

/**
 * 接口 [拉取用户优先级最高的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/206993) 的 **返回类型**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/UserBadge`
 * @更新时间 `2021-04-28 15:50:50`
 */
export interface GoPcmBookstoreUserBadgeResponse {
  badgeInfo?: {
    /**
     * 10007
     */
    badgeId?: number;
    /**
     * "Growth"
     */
    badgeType?: string;
    /**
     * "Who am I?"
     */
    badgeName?: string;
    /**
     * 2
     */
    maxGrade?: number;
    /**
     * "https://actimgtest.webnovel.com/badge/10007/2/"
     */
    baseUrl?: string;
    /**
     * 1619596178000
     */
    updateTime?: number;
  };
}

/**
 * 接口 [拉取用户优先级最高的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/206993) 的 **请求配置的类型**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/UserBadge`
 * @更新时间 `2021-04-28 15:50:50`
 */
type GoPcmBookstoreUserBadgeRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookstore/UserBadge",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [拉取用户优先级最高的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/206993) 的 **请求配置**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/UserBadge`
 * @更新时间 `2021-04-28 15:50:50`
 */
const goPcmBookstoreUserBadgeRequestConfig: GoPcmBookstoreUserBadgeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_38,
    devUrl: devUrl_0_0_0_38,
    prodUrl: prodUrl_0_0_0_38,
    path: "/go/pcm/bookstore/UserBadge",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookstoreUserBadge",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [拉取用户优先级最高的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/206993) 的 **请求函数**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/UserBadge`
 * @更新时间 `2021-04-28 15:50:50`
 */
export const goPcmBookstoreUserBadge = /*#__PURE__*/ (
  requestData?: GoPcmBookstoreUserBadgeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookstoreUserBadgeResponse>(
    prepare(goPcmBookstoreUserBadgeRequestConfig, requestData),
    ...args
  );
};

goPcmBookstoreUserBadge.requestConfig = goPcmBookstoreUserBadgeRequestConfig;

/**
 * 接口 [Topic↗](https://yapi.yuewen.com/project/2309/interface/api/207370) 的 **请求类型**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/topic`
 * @更新时间 `2021-05-10 17:48:09`
 */
export interface GoPcmBookstoreTopicRequest {
  /**
   * 111,112,123
   */
  id: string;
}

/**
 * 接口 [Topic↗](https://yapi.yuewen.com/project/2309/interface/api/207370) 的 **返回类型**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/topic`
 * @更新时间 `2021-05-10 17:48:09`
 */
export interface GoPcmBookstoreTopicResponse {
  /**
   * "Reincarnation in another world"
   */
  title?: string;
  /**
   * "Fulfil your dream in another world."
   */
  description?: string;
  /**
   * "https://preview.ibb.co/mZMNC9/image.jpg "
   */
  imageUrl?: string;
  /**
   * [{"bookId":6831850602000905,"storyInfoItems":["#Academy","#Empire","#Paranormal"],"characterItems":["#Teacher","#Knowledgeable","#Powerful"],"storyBuildingItems":["#Comedy","#Defeat the Enemies"],"motto":"The most popular webnovel of 2017!","synopsis":"Traversing into another world!","CUT":"0","inLibrary":false,"firstChapterId":0,"readToChapterId":0,"readToChapterIndex":0},{"bookId":8445263505000705,"storyInfoItems":["#DND","#Apocalyptic"],"characterItems":["#Domain Lord","#Assassin","#Decisive"],"storyBuildingItems":["#Save The World","#Romantic"],"motto":"When an MMORPG becomes real, and Marvin is its only player","synopsis":"After transmigrating into a weak noble body, Marvin discovered that he was familiar with the world, this was the game he played in his previous life and... Damn! He only had six months before the Great Calamity! As a former top player, he would obviously fight to save the world... ","CUT":"0","inLibrary":false,"firstChapterId":0,"readToChapterId":0,"readToChapterIndex":0},{"bookId":7931338406001705,"storyInfoItems":["#Middle Ages","#Paranormal"],"characterItems":["#Prince","#Witch","#Domain Lord"],"storyBuildingItems":["#Kingdom Building","#Romantic","#Engineer"],"motto":"A story about a prince who has modern engineering knowledge, and a group of beautiful witches.","synopsis":"Cheng Yan travels through time, only to end up becoming an honorable prince in the Middle Ages of Europe. Witches with magical powers abound, but they're treated as heretics and discriminated against by everyone. Enjoy Cheng Yan's new life as Prince Roland as he saves the witches and develops his kingdom to a modern industrial society by relying on witchs' power.","CUT":"0","inLibrary":false,"firstChapterId":0,"readToChapterId":0,"readToChapterIndex":0},{"bookId":6838665602003405,"storyInfoItems":["#Martial Arts","#Fantasy World"],"characterItems":["#mChef","#Boss","#Gourmet"],"storyBuildingItems":["#Cooking","#Enjoying Gourmet Food"],"motto":"Conquer the world with delicious food!","synopsis":"This is the story of a gourmet from Earth who opens a little restaurant in another world. Of course, not only is his food delicious, it also grants powerful effects! His food is capable of helping cultivators and martial artists become stronger! There's countless delectable dishes and interesting characters in Gourmet of Another World.","CUT":"0","inLibrary":false,"firstChapterId":0,"readToChapterId":0,"readToChapterIndex":0},{"bookId":6838665602002905,"storyInfoItems":["#Ancient Times","#Kingdom"],"characterItems":["#Assassin","#Young Master"],"storyBuildingItems":["#Brotherhood","#Harem","#Family"],"motto":"A top-level assassin wanders through another world!","synopsis":"Top-level assassin Jun Xie transmigrates to another world and becomes a sickly young master. A wondrous mini tower transmigrated to this world together with him. Jun Xie meets many true friends, defeats countless enemies, and obtains precious loves thanks to this mini tower and experience as an assassin.","CUT":"0","inLibrary":false,"firstChapterId":0,"readToChapterId":0,"readToChapterIndex":0}]
   */
  items?: {
    /**
     * 6831850602000905
     */
    bookId?: number;
    /**
     * ["#Academy","#Empire","#Paranormal"]
     */
    storyInfoItems?: string[];
    /**
     * ["#Teacher","#Knowledgeable","#Powerful"]
     */
    characterItems?: string[];
    /**
     * ["#Comedy","#Defeat the Enemies"]
     */
    storyBuildingItems?: string[];
    /**
     * "The most popular webnovel of 2017!"
     */
    motto?: string;
    /**
     * "Traversing into another world!"
     */
    synopsis?: string;
    /**
     * "0"
     */
    CUT?: string;
    inLibrary?: boolean;
    firstChapterId?: number;
    readToChapterId?: number;
    readToChapterIndex?: number;
  }[];
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300012720/1/1.jpg?mt=1608694770961"
     */
    avatar?: string;
    /**
     * "peter"
     */
    nickName?: string;
    /**
     * "peter"
     */
    userName?: string;
    /**
     * "peter"
     */
    authorName?: string;
    /**
     * "peter"
     */
    penName?: string;
    /**
     * 4300012720
     */
    guid?: number;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * 1
     */
    gender?: number;
    /**
     * 9985
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    /**
     * 14
     */
    bSS?: number;
    /**
     * 1637251200000
     */
    expiringTime?: number;
    /**
     * 1
     */
    grade?: number;
    /**
     * 1
     */
    ES?: number;
    /**
     * 1
     */
    totalES?: number;
    /**
     * 1
     */
    PS?: number;
    /**
     * 1
     */
    totalPS?: number;
    /**
     * "402374739@qq.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: number;
    /**
     * 1608694770961
     */
    UUT?: number;
    /**
     * 1
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 1
     */
    membershipStatus?: number;
    /**
     * 1622882786000
     */
    membershipExpireTime?: number;
    membershipClaimStatus?: boolean;
    /**
     * true
     */
    membershipIsFree?: boolean;
  };
}

/**
 * 接口 [Topic↗](https://yapi.yuewen.com/project/2309/interface/api/207370) 的 **请求配置的类型**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/topic`
 * @更新时间 `2021-05-10 17:48:09`
 */
type GoPcmBookstoreTopicRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookstore/topic",
    "data",
    string,
    "id",
    false
  >
>;

/**
 * 接口 [Topic↗](https://yapi.yuewen.com/project/2309/interface/api/207370) 的 **请求配置**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/topic`
 * @更新时间 `2021-05-10 17:48:09`
 */
const goPcmBookstoreTopicRequestConfig: GoPcmBookstoreTopicRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_38,
    devUrl: devUrl_0_0_0_38,
    prodUrl: prodUrl_0_0_0_38,
    path: "/go/pcm/bookstore/topic",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_38,
    paramNames: [],
    queryNames: ["id"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookstoreTopic",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [Topic↗](https://yapi.yuewen.com/project/2309/interface/api/207370) 的 **请求函数**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/topic`
 * @更新时间 `2021-05-10 17:48:09`
 */
export const goPcmBookstoreTopic = /*#__PURE__*/ (
  requestData: GoPcmBookstoreTopicRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookstoreTopicResponse>(
    prepare(goPcmBookstoreTopicRequestConfig, requestData),
    ...args
  );
};

goPcmBookstoreTopic.requestConfig = goPcmBookstoreTopicRequestConfig;

/**
 * 接口 [indexV3Page 3.2迭代后的新版首页↗](https://yapi.yuewen.com/project/2309/interface/api/207394) 的 **请求类型**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/indexV3Page`
 * @更新时间 `2021-05-11 15:10:15`
 */
export interface GoPcmBookstoreIndexV3PageRequest {}

/**
 * 接口 [indexV3Page 3.2迭代后的新版首页↗](https://yapi.yuewen.com/project/2309/interface/api/207394) 的 **返回类型**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/indexV3Page`
 * @更新时间 `2021-05-11 15:10:15`
 */
export interface GoPcmBookstoreIndexV3PageResponse {
  banner?: {
    /**
     * [{"id":"56","imageUrl":"https://webbannertest.webnovel.com/1_banner_1565691854_4985.jpg","jumpUrl":"https://oaactivity.webnovel.com/noah/855446053"},{"id":"26","imageUrl":"https://webbannertest.webnovel.com/1_banner_1544755053_5169.png","jumpUrl":"https://oaactivity.webnovel.com/63592169/index?debug=1&time=2018-12-20"},{"id":"6","imageUrl":"//webbannertest.webnovel.com/1_banner_1503647192_2242.jpg","jumpUrl":"https://oaactivity.webnovel.com/2019/64169591/womansday"},{"id":"48","imageUrl":"https://webbannertest.webnovel.com/1_banner_1544755212_3688.png","jumpUrl":"https://oaactivity.webnovel.com/63592169/sale?debug=1&time=2018-12-27%2010:00:00"},{"id":"4","imageUrl":"//webbannertest.webnovel.com/1_banner_1503646894_2501.jpg","jumpUrl":"https://oaactivity.webnovel.com/noah/353101233"}]
     */
    items?: {
      /**
       * "56"
       */
      id?: string;
      /**
       * "https://webbannertest.webnovel.com/1_banner_1565691854_4985.jpg"
       */
      imageUrl?: string;
      /**
       * "https://oaactivity.webnovel.com/noah/855446053"
       */
      jumpUrl?: string;
    }[];
  };
  highlyRecommended?: {
    /**
     * [{"authorName":"","bookId":"10382151301024805","bookName":"webnovel Test0416","bookType":2,"categoryId":70002,"categoryName":"Fantasy","coverUpdateTime":"0","status":0,"totalScore":"4.0","type":0,"voters":11},{"authorName":"","bookId":"9087880901018705","bookName":"Tales of Demons and God","bookType":1,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0","status":0,"totalScore":"3.8","type":0,"voters":64},{"authorName":"","bookId":"6789521301000305","bookName":"Gourmet Food Supplier","bookType":1,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0","status":0,"totalScore":"4.2","type":0,"voters":34},{"authorName":"","bookId":"6820980401004005","bookName":"The Sacred Ruins","bookType":1,"categoryId":20001,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"3.6","type":0,"voters":30},{"authorName":"","bookId":"6831119801007305","bookName":"A Sorcerer's Journey","bookType":1,"categoryId":70009,"categoryName":"Eastern Fantasy","coverUpdateTime":"1617073208847","status":0,"totalScore":"4.4","type":0,"voters":18},{"authorName":"","bookId":"6831119801007805","bookName":"Age of Cosmic Exploration","bookType":1,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"1617083336827","status":0,"totalScore":"0","type":0,"voters":0}]
     */
    items?: {
      authorName?: string;
      /**
       * "10382151301024805"
       */
      bookId?: string;
      /**
       * "webnovel Test0416"
       */
      bookName?: string;
      /**
       * 2
       */
      bookType?: number;
      /**
       * 70002
       */
      categoryId?: number;
      /**
       * "Fantasy"
       */
      categoryName?: string;
      /**
       * "0"
       */
      coverUpdateTime?: string;
      status?: number;
      /**
       * "4.0"
       */
      totalScore?: string;
      type?: number;
      /**
       * 11
       */
      voters?: number;
    }[];
    /**
     * 6
     */
    total?: number;
  };
  newOngoing?: {
    /**
     * [{"authorName":"","bookId":"11529913001011205","bookName":"webnovel test0827002","bookType":2,"categoryId":70009,"categoryName":"Eastern Fantasy","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":2},{"authorName":"","bookId":"11678014501018005","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":1},{"authorName":"","bookId":"12379703501035905","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":2},{"authorName":"","bookId":"6831119801008505","bookName":"Plundering the Heavens","bookType":1,"categoryId":70005,"categoryName":"Romance","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":6},{"authorName":"","bookId":"14374904801067405","bookName":"webnovel test xinjianjingpai","bookType":2,"categoryId":81007,"categoryName":"Movies","coverUpdateTime":"1581421922022","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"14011360801055005","bookName":"lidengfu test 1","bookType":2,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"12023249501024705","bookName":"webnovel Test102301AA","bookType":2,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"12352651101035505","bookName":"webnovel test113002","bookType":2,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"12159915201027005","bookName":"Webnovel Test1108dddd","bookType":2,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":1}]
     */
    items?: {
      authorName?: string;
      /**
       * "11529913001011205"
       */
      bookId?: string;
      /**
       * "webnovel test0827002"
       */
      bookName?: string;
      /**
       * 2
       */
      bookType?: number;
      /**
       * 70009
       */
      categoryId?: number;
      /**
       * "Eastern Fantasy"
       */
      categoryName?: string;
      /**
       * "0"
       */
      coverUpdateTime?: string;
      status?: number;
      /**
       * "0"
       */
      totalScore?: string;
      type?: number;
      /**
       * 2
       */
      voters?: number;
    }[];
    /**
     * 9
     */
    total?: number;
  };
  popular?: null;
  editorsChoice?: null;
  dailyComics?: {
    /**
     * [{"BUT":"1617276618000","chapterDescription":"","chapterId":"51090676917533419","chapterIndex":"1","chapterName":"漫画1","comicId":"17707486601063501","comicName":"新建漫画不关联作品811","hasChapterCover":"1","pvNum":"257"},{"BUT":"0","chapterDescription":"","chapterId":"39140384877631967","chapterIndex":"11","chapterName":"testcmz","comicId":"13137795401042201","comicName":"Webnovel TestComic0301","hasChapterCover":"0","pvNum":"150.2K"},{"BUT":"1608365472000","chapterDescription":"","chapterId":"50552312162217718","chapterIndex":"4","chapterName":"hgh","comicId":"11712262601019101","comicName":"webnonel test0917","hasChapterCover":"1","pvNum":"5K"},{"BUT":"1608365058000","chapterDescription":"","chapterId":"50552591066659664","chapterIndex":"20","chapterName":"jjj","comicId":"11540953701012201","comicName":"Judge not from appearances","hasChapterCover":"1","pvNum":"81.1K"}]
     */
    items?: {
      /**
       * "1617276618000"
       */
      BUT?: string;
      chapterDescription?: string;
      /**
       * "51090676917533419"
       */
      chapterId?: string;
      /**
       * "1"
       */
      chapterIndex?: string;
      /**
       * "漫画1"
       */
      chapterName?: string;
      /**
       * "17707486601063501"
       */
      comicId?: string;
      /**
       * "新建漫画不关联作品811"
       */
      comicName?: string;
      /**
       * "1"
       */
      hasChapterCover?: string;
      /**
       * "257"
       */
      pvNum?: string;
    }[];
  };
  ladiesPick?: {
    /**
     * [{"authorName":"","bookId":"6820980401004005","bookName":"The Sacred Ruins","bookType":1,"categoryId":20001,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"3.6","type":0,"voters":30},{"authorName":"","bookId":"6831119801007205","bookName":"Throne of Magical Arcana","bookType":1,"categoryId":70004,"categoryName":"Horror&Thriller","coverUpdateTime":"1607654522184","status":0,"totalScore":"4.1","type":0,"voters":35},{"authorName":"","bookId":"6789521301000305","bookName":"Gourmet Food Supplier","bookType":1,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0","status":0,"totalScore":"4.2","type":0,"voters":34},{"authorName":"","bookId":"14229200001059305","bookName":"Cherry Cherry","bookType":2,"categoryId":70003,"categoryName":"History","coverUpdateTime":"1581421916126","status":0,"totalScore":"0","type":0,"voters":2},{"authorName":"","bookId":"14157960901058705","bookName":"webnovel test0627","bookType":2,"categoryId":70002,"categoryName":"Fantasy","coverUpdateTime":"1581421911264","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"11470916601010005","bookName":"Webnovel Test0820","bookType":2,"categoryId":70003,"categoryName":"History","coverUpdateTime":"1581421925858","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"12159915201027005","bookName":"Webnovel Test1108dddd","bookType":2,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":1},{"authorName":"","bookId":"6831119801008505","bookName":"Plundering the Heavens","bookType":1,"categoryId":70005,"categoryName":"Romance","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":6},{"authorName":"","bookId":"12379703501035905","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":2}]
     */
    items?: {
      authorName?: string;
      /**
       * "6820980401004005"
       */
      bookId?: string;
      /**
       * "The Sacred Ruins"
       */
      bookName?: string;
      /**
       * 1
       */
      bookType?: number;
      /**
       * 20001
       */
      categoryId?: number;
      categoryName?: string;
      /**
       * "0"
       */
      coverUpdateTime?: string;
      status?: number;
      /**
       * "3.6"
       */
      totalScore?: string;
      type?: number;
      /**
       * 30
       */
      voters?: number;
    }[];
    /**
     * 9
     */
    total?: number;
  };
  tags?: {
    /**
     * [{"tagId":41000010,"tagName":"FANTACYS"},{"tagId":41000121,"tagName":"ANTIHERO"},{"tagId":41000120,"tagName":"SWORD AND MAGIC"},{"tagId":41000075,"tagName":"CHEAT MC"},{"tagId":41000170,"tagName":"ARTIFICIAL INTEL MC"},{"tagId":41000113,"tagName":"FANTASY"},{"tagId":41000147,"tagName":"SLOW ROMANCE"},{"tagId":41000016,"tagName":"SYSTEM"},{"tagId":41000037,"tagName":"LOLICON"},{"tagId":41000224,"tagName":"BEAUTIFUL FEMALE LEAD"}]
     */
    items?: {
      /**
       * 41000010
       */
      tagId?: number;
      /**
       * "FANTACYS"
       */
      tagName?: string;
    }[];
  };
  pickedOriginal?: {
    /**
     * [{"authorName":"","bookId":"10234821601022105","bookName":"Webnovel Test013","bookType":2,"categoryId":70013,"categoryName":"War&Military","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":4},{"authorName":"","bookId":"10159021801021405","bookName":"Webnovel Test009","bookType":2,"categoryId":70005,"categoryName":"Romance","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"10226471001021905","bookName":"Webnovel Test012","bookType":2,"categoryId":70001,"categoryName":"Realisme Ajaib","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"10166607401021505","bookName":"Webnovel Test007","bookType":2,"categoryId":70006,"categoryName":"Sci-fi","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"10159021801021405","bookName":"Webnovel Test009","bookType":2,"categoryId":70005,"categoryName":"Romance","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"10046487201020005","bookName":"Webnovel Test006","bookType":2,"categoryId":70013,"categoryName":"War&Military","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"10226265701021705","bookName":"Webnovel Test008","bookType":2,"categoryId":70001,"categoryName":"Realisme Ajaib","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"10156046401020805","bookName":"Webnovel Test010","bookType":2,"categoryId":70004,"categoryName":"Horror&Thriller","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"10226265701021705","bookName":"Webnovel Test008","bookType":2,"categoryId":70001,"categoryName":"Realisme Ajaib","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0}]
     */
    items?: {
      authorName?: string;
      /**
       * "10234821601022105"
       */
      bookId?: string;
      /**
       * "Webnovel Test013"
       */
      bookName?: string;
      /**
       * 2
       */
      bookType?: number;
      /**
       * 70013
       */
      categoryId?: number;
      /**
       * "War&Military"
       */
      categoryName?: string;
      /**
       * "0"
       */
      coverUpdateTime?: string;
      status?: number;
      /**
       * "0"
       */
      totalScore?: string;
      type?: number;
      /**
       * 4
       */
      voters?: number;
    }[];
    /**
     * 9
     */
    total?: number;
  };
  powerRanking?: {
    /**
     * "Mar 28, 2021"
     */
    date?: string;
    /**
     * [{"bookId":"7366916601012405","bookName":"The King's Avatar","categoryName":"Video Games","cateogryId":70008,"coverUpdateTime":"1581418734974","powerNums":2,"type":1}]
     */
    items?: {
      /**
       * "7366916601012405"
       */
      bookId?: string;
      /**
       * "The King's Avatar"
       */
      bookName?: string;
      /**
       * "Video Games"
       */
      categoryName?: string;
      /**
       * 70008
       */
      cateogryId?: number;
      /**
       * "1581418734974"
       */
      coverUpdateTime?: string;
      /**
       * 2
       */
      powerNums?: number;
      /**
       * 1
       */
      type?: number;
    }[];
  };
  middleAds?: null;
  trending?: {
    /**
     * [{"authorName":"","bookId":"6822887201006405","bookName":"The Magus Era","bookType":1,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"1610453737838","status":0,"totalScore":"3.9","type":0,"voters":39},{"authorName":"","bookId":"6820998101004605","bookName":"Realms In The Firmament","bookType":1,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":3},{"authorName":"","bookId":"6820974301003605","bookName":"Dominating Sword Immortal","bookType":1,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"1581421901151","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"7213448101011305","bookName":"Swallowed Star","bookType":1,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"1610096958835","status":0,"totalScore":"0","type":0,"voters":8},{"authorName":"","bookId":"7366916601012405","bookName":"The King's Avatar","bookType":1,"categoryId":70008,"categoryName":"Video Games","coverUpdateTime":"1581418734974","status":0,"totalScore":"4.2","type":0,"voters":266},{"authorName":"","bookId":"7213464501011405","bookName":"God and Devil World","bookType":1,"categoryId":20042,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"6820919701003005","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"1610613054887","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"7731137901014305","bookName":"Diba","bookType":1,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"0","status":0,"totalScore":"4.7","type":0,"voters":137},{"authorName":"","bookId":"7213474601011505","bookName":"The Ultimate Evolution","bookType":1,"categoryId":70001,"categoryName":"Magical Realism","coverUpdateTime":"1617083133834","status":0,"totalScore":"0","type":0,"voters":1}]
     */
    items?: {
      authorName?: string;
      /**
       * "6822887201006405"
       */
      bookId?: string;
      /**
       * "The Magus Era"
       */
      bookName?: string;
      /**
       * 1
       */
      bookType?: number;
      /**
       * 70001
       */
      categoryId?: number;
      /**
       * "Magical Realism"
       */
      categoryName?: string;
      /**
       * "1610453737838"
       */
      coverUpdateTime?: string;
      status?: number;
      /**
       * "3.9"
       */
      totalScore?: string;
      type?: number;
      /**
       * 39
       */
      voters?: number;
    }[];
    /**
     * 9
     */
    total?: number;
  };
  rankings?: {
    dailyBest?: {
      /**
       * [{"authorName":"","bookId":"8022472105002805","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"14205835806705305","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"16709365405930105","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"8212987205006305","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"17319692206490105","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0}]
       */
      items?: {
        authorName?: string;
        /**
         * "8022472105002805"
         */
        bookId?: string;
        bookName?: string;
        bookType?: number;
        categoryId?: number;
        categoryName?: string;
        /**
         * "0"
         */
        coverUpdateTime?: string;
        status?: number;
        /**
         * "0"
         */
        totalScore?: string;
        type?: number;
        voters?: number;
      }[];
    };
    massiveRelease?: {
      /**
       * [{"authorName":"","bookId":"17633164606057605","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"19618131106906205","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"19618127205763905","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"19195918706755605","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"12284796705198105","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0}]
       */
      items?: {
        authorName?: string;
        /**
         * "17633164606057605"
         */
        bookId?: string;
        bookName?: string;
        bookType?: number;
        categoryId?: number;
        categoryName?: string;
        /**
         * "0"
         */
        coverUpdateTime?: string;
        status?: number;
        /**
         * "0"
         */
        totalScore?: string;
        type?: number;
        voters?: number;
      }[];
    };
    newPremium?: {
      /**
       * [{"authorName":"","bookId":"19449410506496705","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"19589246505698605","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"19588753805697505","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"19636035005801905","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0},{"authorName":"","bookId":"19551476206748005","bookName":"","bookType":0,"categoryId":0,"categoryName":"","coverUpdateTime":"0","status":0,"totalScore":"0","type":0,"voters":0}]
       */
      items?: {
        authorName?: string;
        /**
         * "19449410506496705"
         */
        bookId?: string;
        bookName?: string;
        bookType?: number;
        categoryId?: number;
        categoryName?: string;
        /**
         * "0"
         */
        coverUpdateTime?: string;
        status?: number;
        /**
         * "0"
         */
        totalScore?: string;
        type?: number;
        voters?: number;
      }[];
    };
  };
  dailyUpdates?: {
    /**
     * [{"authorName":"eason","bookId":"14476162801070005","bookName":"test  0803 xiu gai","bookType":2,"categoryId":81001,"categoryName":"Book&Literature","coverUpdateTime":"1608013269913","status":0,"totalScore":"3.8","type":0,"voters":21}]
     */
    items?: {
      /**
       * "eason"
       */
      authorName?: string;
      /**
       * "14476162801070005"
       */
      bookId?: string;
      /**
       * "test  0803 xiu gai"
       */
      bookName?: string;
      /**
       * 2
       */
      bookType?: number;
      /**
       * 81001
       */
      categoryId?: number;
      /**
       * "Book&Literature"
       */
      categoryName?: string;
      /**
       * "1608013269913"
       */
      coverUpdateTime?: string;
      status?: number;
      /**
       * "3.8"
       */
      totalScore?: string;
      type?: number;
      /**
       * 21
       */
      voters?: number;
    }[];
  };
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300012720/1/1.jpg?mt=1608694770961"
     */
    avatar?: string;
    /**
     * "peter"
     */
    nickName?: string;
    /**
     * "peter"
     */
    userName?: string;
    /**
     * "peter"
     */
    authorName?: string;
    /**
     * "peter"
     */
    penName?: string;
    /**
     * 4300012720
     */
    guid?: number;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * 1
     */
    gender?: number;
    /**
     * 9985
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    /**
     * 14
     */
    bSS?: number;
    /**
     * 1637251200000
     */
    expiringTime?: number;
    /**
     * 1
     */
    grade?: number;
    /**
     * 1
     */
    ES?: number;
    /**
     * 1
     */
    totalES?: number;
    /**
     * 1
     */
    PS?: number;
    /**
     * 1
     */
    totalPS?: number;
    /**
     * "402374739@qq.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: number;
    /**
     * 1608694770961
     */
    UUT?: number;
    /**
     * 1
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 1
     */
    membershipStatus?: number;
    /**
     * 1622882786000
     */
    membershipExpireTime?: number;
    membershipClaimStatus?: boolean;
    /**
     * true
     */
    membershipIsFree?: boolean;
  };
}

/**
 * 接口 [indexV3Page 3.2迭代后的新版首页↗](https://yapi.yuewen.com/project/2309/interface/api/207394) 的 **请求配置的类型**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/indexV3Page`
 * @更新时间 `2021-05-11 15:10:15`
 */
type GoPcmBookstoreIndexV3PageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/bookstore/indexV3Page",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [indexV3Page 3.2迭代后的新版首页↗](https://yapi.yuewen.com/project/2309/interface/api/207394) 的 **请求配置**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/indexV3Page`
 * @更新时间 `2021-05-11 15:10:15`
 */
const goPcmBookstoreIndexV3PageRequestConfig: GoPcmBookstoreIndexV3PageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_38,
    devUrl: devUrl_0_0_0_38,
    prodUrl: prodUrl_0_0_0_38,
    path: "/go/pcm/bookstore/indexV3Page",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookstoreIndexV3Page",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [indexV3Page 3.2迭代后的新版首页↗](https://yapi.yuewen.com/project/2309/interface/api/207394) 的 **请求函数**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/indexV3Page`
 * @更新时间 `2021-05-11 15:10:15`
 */
export const goPcmBookstoreIndexV3Page = /*#__PURE__*/ (
  requestData?: GoPcmBookstoreIndexV3PageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmBookstoreIndexV3PageResponse>(
    prepare(goPcmBookstoreIndexV3PageRequestConfig, requestData),
    ...args
  );
};

goPcmBookstoreIndexV3Page.requestConfig =
  goPcmBookstoreIndexV3PageRequestConfig;

const mockUrl_0_0_0_39 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_39 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_39 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_39 = "data" as any;

/**
 * 接口 [书阅读进度数据↗](https://yapi.yuewen.com/project/2309/interface/api/207008) 的 **请求类型**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/addReview`
 * @更新时间 `2022-12-07 17:00:09`
 */
export interface GoPcmReviewAddReviewRequest {
  /**
   * 书id
   */
  bookId: string;
  /**
   * 小说类型
   */
  novelType: string;
}

/**
 * 接口 [书阅读进度数据↗](https://yapi.yuewen.com/project/2309/interface/api/207008) 的 **返回类型**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/addReview`
 * @更新时间 `2022-12-07 17:00:09`
 */
export interface GoPcmReviewAddReviewResponse {
  /**
   * "7479922501012705"
   */
  bookId?: string;
  /**
   * 1
   */
  bookType?: number;
  novelType?: number;
  /**
   * 12
   */
  readToChapterIndex?: number;
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300012720/1/1.jpg?mt=1608694770961"
     */
    avatar?: string;
    /**
     * "peter"
     */
    nickName?: string;
    /**
     * "peter"
     */
    userName?: string;
    /**
     * "peter"
     */
    authorName?: string;
    /**
     * "peter"
     */
    penName?: string;
    /**
     * 4300012720
     */
    guid?: number;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * 1
     */
    gender?: number;
    /**
     * 9985
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    /**
     * 14
     */
    bSS?: number;
    /**
     * 1637251200000
     */
    expiringTime?: number;
    /**
     * 1
     */
    grade?: number;
    /**
     * 1
     */
    ES?: number;
    /**
     * 1
     */
    totalES?: number;
    /**
     * 1
     */
    PS?: number;
    /**
     * 1
     */
    totalPS?: number;
    /**
     * "402374739@qq.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: number;
    /**
     * 1608694770961
     */
    UUT?: number;
    /**
     * 1
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 1
     */
    membershipStatus?: number;
    /**
     * 1622882786000
     */
    membershipExpireTime?: number;
    membershipClaimStatus?: boolean;
    /**
     * true
     */
    membershipIsFree?: boolean;
  };
}

/**
 * 接口 [书阅读进度数据↗](https://yapi.yuewen.com/project/2309/interface/api/207008) 的 **请求配置的类型**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/addReview`
 * @更新时间 `2022-12-07 17:00:09`
 */
type GoPcmReviewAddReviewRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/review/addReview",
    "data",
    string,
    "bookId" | "novelType",
    false
  >
>;

/**
 * 接口 [书阅读进度数据↗](https://yapi.yuewen.com/project/2309/interface/api/207008) 的 **请求配置**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/addReview`
 * @更新时间 `2022-12-07 17:00:09`
 */
const goPcmReviewAddReviewRequestConfig: GoPcmReviewAddReviewRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_39,
    devUrl: devUrl_0_0_0_39,
    prodUrl: prodUrl_0_0_0_39,
    path: "/go/pcm/review/addReview",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_39,
    paramNames: [],
    queryNames: ["bookId", "novelType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReviewAddReview",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [书阅读进度数据↗](https://yapi.yuewen.com/project/2309/interface/api/207008) 的 **请求函数**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/addReview`
 * @更新时间 `2022-12-07 17:00:09`
 */
export const goPcmReviewAddReview = /*#__PURE__*/ (
  requestData: GoPcmReviewAddReviewRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmReviewAddReviewResponse>(
    prepare(goPcmReviewAddReviewRequestConfig, requestData),
    ...args
  );
};

goPcmReviewAddReview.requestConfig = goPcmReviewAddReviewRequestConfig;

/**
 * 接口 [【下线】拉取书评列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/207344) 的 **请求类型**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/GetReviewsAjax`
 * @更新时间 `2022-12-07 17:01:34`
 */
export interface GoPcmReviewGetReviewsAjaxRequest {
  /**
   * 分页
   */
  pageIndex: string;
  /**
   * 书id
   */
  bookId: string;
  /**
   * 是否需要平均评分信息
   */
  bookScore?: string;
  /**
   * 1 - like, 2 -time （默认值为1）
   */
  orderBy: string;
}

/**
 * 接口 [【下线】拉取书评列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/207344) 的 **返回类型**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/GetReviewsAjax`
 * @更新时间 `2022-12-07 17:01:34`
 */
export interface GoPcmReviewGetReviewsAjaxResponse {
  /**
   * [{"reviewId":15128724,"userId":101087995,"content":"LOL哦5米看情况咯精疲力尽咯可劲愧疚ggzgfhcn class vg Vggxhfzxfg gh cs3 ZBxdj class Vghj bxbdjdj brn Xd c'ch bxhdjdj vg Jhappy Kehu logo fgh Fghh Gg gh Hhappy dhhdhdhd dhhdhdhd Gg bxhdjdj Android qq.com happy happy ll logo Kehu Kehu logo Kehu nnnzbdjdj nnnzbdjdj nnnzbdjdj nnnzbdjdj nnnzbdjdj nrnbn Qb nwnw","createTime":"3yr","totalScore":"4.8","readToChapterIndex":"1","likeNums":33,"replyNums":104,"isSpoiler":1,"isLiked":0,"appId":10,"topStatus":0,"userLevel":4,"UUT":1590032108000,"userName":"garden6cg","avatar":0,"penName":"garden6cg","role":0,"badgeInfo":{"badgeId":10003,"badgeType":"Achievement","badgeName":"Premium","maxGrade":4,"baseUrl":"https://actimgtest.webnovel.com/badge/10003/1/","updateTime":1620468450000}},{"reviewId":15128397,"userId":1901271742,"content":"djdjdjfjdnnxbxhxbxbbxxhxh bxbx ","createTime":"3yr","totalScore":"5.0","readToChapterIndex":"658","likeNums":30,"replyNums":88,"isSpoiler":0,"isLiked":0,"appId":10,"topStatus":0,"userLevel":7,"UUT":1585032434000,"userName":"yang190","avatar":0,"penName":"yang190","role":0,"badgeInfo":{"badgeId":10005,"badgeType":"Achievement","badgeName":"Glory!","maxGrade":1,"baseUrl":"https://actimgtest.webnovel.com/badge/10005/1/","updateTime":1620468450000}},{"reviewId":12388019106351600,"userId":4300000390,"content":"updatingStability updatingStability updatingStability ","createTime":"2yr","totalScore":"5.0","readToChapterIndex":"","likeNums":17,"replyNums":31,"isSpoiler":0,"isLiked":0,"appId":10,"topStatus":0,"userLevel":4,"UUT":1547805199000,"userName":"Candy","avatar":0,"penName":"Candy","role":0,"badgeInfo":{"badgeId":10003,"badgeType":"Achievement","badgeName":"Premium","maxGrade":4,"baseUrl":"https://actimgtest.webnovel.com/badge/10003/1/","updateTime":1620468450000}},{"reviewId":13802709806110000,"userId":4300000732,"content":"1233684559669999988553658555558888282882882828575768686868686868383686868585858585750282858585868686868372828286868585828282828282828282858685882828282828686868686868686858f,fcttcg","createTime":"1yr","totalScore":"3.0","readToChapterIndex":"","likeNums":8,"replyNums":14,"isSpoiler":0,"isLiked":0,"appId":10,"topStatus":0,"userLevel":3,"UUT":1602325291000,"userName":"zhoujielun","avatar":1609240706240,"penName":"zhoujielun","role":0,"badgeInfo":{"badgeId":10003,"badgeType":"Achievement","badgeName":"Premium","maxGrade":4,"baseUrl":"https://actimgtest.webnovel.com/badge/10003/1/","updateTime":1620468450000}},{"reviewId":10959708906918900,"userId":4060368390,"content":"新增了一条书评!","createTime":"2yr","totalScore":"2.4","readToChapterIndex":"649","likeNums":8,"replyNums":5,"isSpoiler":1,"isLiked":0,"appId":10,"topStatus":0,"userLevel":6,"UUT":1599480406000,"userName":"Amy4060368390ya","avatar":1599480378657,"penName":"Amy4060368390ya","role":0,"badgeInfo":{"badgeId":10008,"badgeType":"Growth","badgeName":"Author","maxGrade":4,"baseUrl":"https://actimgtest.webnovel.com/badge/10008/4/","updateTime":1620468450000}},{"reviewId":15128672,"userId":1488022067,"content":"sdafasdfdsafsdfsdfasfasfsdfadsmfjlakdsfjasdk;fjas;dfdasfadsfasdfsadfdsafsdfsdfdsfasdfdsafdsafadsfasdf fddasfdsfdsafasdfadfdsafasdfsdafasfdsafdsafsdafasdfdsafadsfdsafsadf","createTime":"3yr","totalScore":"4.0","readToChapterIndex":"0","likeNums":6,"replyNums":33,"isSpoiler":0,"isLiked":0,"appId":10,"topStatus":0,"userLevel":2,"UUT":1510739506000,"userName":"zhangdroid123","avatar":0,"penName":"zhangdroid123","role":0,"badgeInfo":{"badgeId":10006,"badgeType":"Growth","badgeName":"Cultivator","maxGrade":4,"baseUrl":"https://actimgtest.webnovel.com/badge/10006/1/","updateTime":1620468450000}},{"reviewId":16465213206191100,"userId":4300000889,"content":"Translation Quality","createTime":"1yr","totalScore":"4.0","readToChapterIndex":"2","likeNums":5,"replyNums":15,"isSpoiler":0,"isLiked":0,"appId":10,"topStatus":0,"userLevel":4,"UUT":1609324312000,"userName":"yabger","avatar":1599056425650,"penName":"yabger","role":0,"badgeInfo":{"badgeId":10003,"badgeType":"Achievement","badgeName":"Premium","maxGrade":4,"baseUrl":"https://actimgtest.webnovel.com/badge/10003/1/","updateTime":1620468450000}},{"reviewId":18502233506094100,"userId":4300000298,"content":"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa","createTime":"5mth","totalScore":"4.0","readToChapterIndex":"18","likeNums":4,"replyNums":0,"isSpoiler":0,"isLiked":0,"appId":10,"topStatus":0,"userLevel":9,"UUT":1598875085000,"userName":"aaaa","avatar":1596779123506,"penName":"aaaa","role":0,"badgeInfo":{"badgeId":10002,"badgeType":"Achievement","badgeName":"Such Rich!","maxGrade":4,"baseUrl":"https://actimgtest.webnovel.com/badge/10002/2/","updateTime":1620468450000}},{"reviewId":14805531506335900,"userId":4300000832,"content":"My bhh is my bhh is my hhh is my bhh is my hhh is my bhh is my hhh is my bhh is my hhh is my bhh is my hhh is my bhh is my hhh is my bhh is my hhh is my bhh is my hhh is my bhh is my hhh is my bhh is my hhh is my bhh is my hhh is ","createTime":"1yr","totalScore":"4.6","readToChapterIndex":"1","likeNums":4,"replyNums":7,"isSpoiler":0,"isLiked":0,"appId":10,"topStatus":0,"userLevel":3,"UUT":1620467467000,"userName":"uat_yuewen1234","avatar":1611808244594,"penName":"uat_yuewen1234","role":0,"badgeInfo":{"badgeId":10008,"badgeType":"Growth","badgeName":"Author","maxGrade":4,"baseUrl":"https://actimgtest.webnovel.com/badge/10008/4/","updateTime":1620468450000}},{"reviewId":14565271606334900,"userId":4300000728,"content":"test-6","createTime":"1yr","totalScore":"4.0","readToChapterIndex":"","likeNums":4,"replyNums":6,"isSpoiler":0,"isLiked":0,"appId":10,"topStatus":0,"userLevel":2,"UUT":1570688344000,"userName":"testuat","avatar":1570621694405,"penName":"testuat","role":0,"badgeInfo":{"badgeId":10008,"badgeType":"Growth","badgeName":"Author","maxGrade":4,"baseUrl":"https://actimgtest.webnovel.com/badge/10008/1/","updateTime":1620468450000}}]
   */
  reviewItems?: {
    /**
     * 15128724
     */
    reviewId?: number;
    /**
     * 101087995
     */
    userId?: number;
    /**
     * "LOL哦5米看情况咯精疲力尽咯可劲愧疚ggzgfhcn class vg Vggxhfzxfg gh cs3 ZBxdj class Vghj bxbdjdj brn Xd c'ch bxhdjdj vg Jhappy Kehu logo fgh Fghh Gg gh Hhappy dhhdhdhd dhhdhdhd Gg bxhdjdj Android qq.com happy happy ll logo Kehu Kehu logo Kehu nnnzbdjdj nnnzbdjdj nnnzbdjdj nnnzbdjdj nnnzbdjdj nrnbn Qb nwnw"
     */
    content?: string;
    /**
     * "3yr"
     */
    createTime?: string;
    /**
     * "4.8"
     */
    totalScore?: string;
    /**
     * "1"
     */
    readToChapterIndex?: string;
    /**
     * 33
     */
    likeNums?: number;
    /**
     * 104
     */
    replyNums?: number;
    /**
     * 1
     */
    isSpoiler?: number;
    isLiked?: number;
    /**
     * 10
     */
    appId?: number;
    topStatus?: number;
    /**
     * 4
     */
    userLevel?: number;
    /**
     * 1590032108000
     */
    UUT?: number;
    /**
     * "garden6cg"
     */
    userName?: string;
    avatar?: number;
    /**
     * "garden6cg"
     */
    penName?: string;
    role?: number;
    badgeInfo?: {
      /**
       * 10003
       */
      badgeId?: number;
      /**
       * "Achievement"
       */
      badgeType?: string;
      /**
       * "Premium"
       */
      badgeName?: string;
      /**
       * 4
       */
      maxGrade?: number;
      /**
       * "https://actimgtest.webnovel.com/badge/10003/1/"
       */
      baseUrl?: string;
      /**
       * 1620468450000
       */
      updateTime?: number;
    };
  }[];
  /**
   * 266
   */
  totalReviewNum?: number;
  isLast?: number;
  bookInfo?: {
    /**
     * 7366916601012405
     */
    bookId?: number;
    /**
     * "4.2"
     */
    cdScore?: string;
    /**
     * "4.2"
     */
    wbScore?: string;
    /**
     * "4.2"
     */
    usScore?: string;
    /**
     * "4.2"
     */
    tqScore?: string;
    /**
     * "4.2"
     */
    sdScore?: string;
    /**
     * "4.2"
     */
    realTotalScore?: string;
    bookType?: number;
  };
}

/**
 * 接口 [【下线】拉取书评列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/207344) 的 **请求配置的类型**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/GetReviewsAjax`
 * @更新时间 `2022-12-07 17:01:34`
 */
type GoPcmReviewGetReviewsAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/review/GetReviewsAjax",
    "data",
    string,
    "pageIndex" | "bookId" | "bookScore" | "orderBy",
    false
  >
>;

/**
 * 接口 [【下线】拉取书评列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/207344) 的 **请求配置**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/GetReviewsAjax`
 * @更新时间 `2022-12-07 17:01:34`
 */
const goPcmReviewGetReviewsAjaxRequestConfig: GoPcmReviewGetReviewsAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_39,
    devUrl: devUrl_0_0_0_39,
    prodUrl: prodUrl_0_0_0_39,
    path: "/go/pcm/review/GetReviewsAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_39,
    paramNames: [],
    queryNames: ["pageIndex", "bookId", "bookScore", "orderBy"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReviewGetReviewsAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [【下线】拉取书评列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/207344) 的 **请求函数**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/GetReviewsAjax`
 * @更新时间 `2022-12-07 17:01:34`
 */
export const goPcmReviewGetReviewsAjax = /*#__PURE__*/ (
  requestData: GoPcmReviewGetReviewsAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmReviewGetReviewsAjaxResponse>(
    prepare(goPcmReviewGetReviewsAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmReviewGetReviewsAjax.requestConfig =
  goPcmReviewGetReviewsAjaxRequestConfig;

const mockUrl_0_0_0_40 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_40 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_40 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_40 = "data" as any;

/**
 * 接口 [直出获取投票历史↗](https://yapi.yuewen.com/project/2309/interface/api/207125) 的 **请求类型**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPage`
 * @更新时间 `2024-08-23 15:49:18`
 */
export interface GoPcmTranslationVoteGetHistoryPageRequest {
  /**
   * 页码
   */
  pageIndex: string;
}

/**
 * 接口 [直出获取投票历史↗](https://yapi.yuewen.com/project/2309/interface/api/207125) 的 **返回类型**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPage`
 * @更新时间 `2024-08-23 15:49:18`
 */
export interface GoPcmTranslationVoteGetHistoryPageResponse {
  /**
   * [{"bookId":8161851201016505,"time":1619433928631,"platform":"iOS"},{"bookId":8161851201016505,"time":1619433927539,"platform":"iOS"},{"bookId":8161851201016505,"time":1619433925236,"platform":"iOS"},{"bookId":8161851201016505,"time":1619432765333,"platform":"iOS"},{"bookId":8161851201016505,"time":1619432697237,"platform":"iOS"},{"bookId":11721745101021604,"time":1619347208882,"platform":"iOS"}]
   */
  items?: {
    /**
     * 8161851201016505
     */
    bookId?: number;
    /**
     * 1619433928631
     */
    time?: number;
    /**
     * "iOS"
     */
    platform?: string;
  }[];
  /**
   * 6
   */
  total?: number;
  /**
   * 29809
   */
  time?: number;
  pageIndex?: number;
  pageSize?: number;
  user?: {
    /**
     * "//userimg.webnovel.com/userheadimg/4300012720/1/1.jpg?mt=1608694770961"
     */
    avatar?: string;
    /**
     * "peter"
     */
    nickName?: string;
    /**
     * "peter"
     */
    userName?: string;
    /**
     * "peter"
     */
    authorName?: string;
    /**
     * "peter"
     */
    penName?: string;
    /**
     * 4300012720
     */
    guid?: number;
    status?: number;
    /**
     * 4
     */
    role?: number;
    /**
     * 1
     */
    gender?: number;
    /**
     * 9985
     */
    SS?: number;
    vSS?: number;
    vbSS?: number;
    /**
     * 14
     */
    bSS?: number;
    /**
     * 1637251200000
     */
    expiringTime?: number;
    /**
     * 1
     */
    grade?: number;
    /**
     * 1
     */
    ES?: number;
    /**
     * 1
     */
    totalES?: number;
    /**
     * 1
     */
    PS?: number;
    /**
     * 1
     */
    totalPS?: number;
    /**
     * "402374739@qq.com"
     */
    email?: string;
    /**
     * 1
     */
    emailStatus?: number;
    isCheckIn?: number;
    /**
     * 1608694770961
     */
    UUT?: number;
    /**
     * 1
     */
    fastPass?: number;
    /**
     * 1
     */
    membershipQua?: number;
    /**
     * 1
     */
    membershipStatus?: number;
    /**
     * 1622882786000
     */
    membershipExpireTime?: number;
    membershipClaimStatus?: boolean;
    /**
     * true
     */
    membershipIsFree?: boolean;
  };
}

/**
 * 接口 [直出获取投票历史↗](https://yapi.yuewen.com/project/2309/interface/api/207125) 的 **请求配置的类型**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPage`
 * @更新时间 `2024-08-23 15:49:18`
 */
type GoPcmTranslationVoteGetHistoryPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/translationVote/getHistoryPage",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [直出获取投票历史↗](https://yapi.yuewen.com/project/2309/interface/api/207125) 的 **请求配置**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPage`
 * @更新时间 `2024-08-23 15:49:18`
 */
const goPcmTranslationVoteGetHistoryPageRequestConfig: GoPcmTranslationVoteGetHistoryPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_40,
    devUrl: devUrl_0_0_0_40,
    prodUrl: prodUrl_0_0_0_40,
    path: "/go/pcm/translationVote/getHistoryPage",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_40,
    paramNames: [],
    queryNames: ["pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTranslationVoteGetHistoryPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [直出获取投票历史↗](https://yapi.yuewen.com/project/2309/interface/api/207125) 的 **请求函数**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPage`
 * @更新时间 `2024-08-23 15:49:18`
 */
export const goPcmTranslationVoteGetHistoryPage = /*#__PURE__*/ (
  requestData: GoPcmTranslationVoteGetHistoryPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmTranslationVoteGetHistoryPageResponse>(
    prepare(goPcmTranslationVoteGetHistoryPageRequestConfig, requestData),
    ...args
  );
};

goPcmTranslationVoteGetHistoryPage.requestConfig =
  goPcmTranslationVoteGetHistoryPageRequestConfig;

/**
 * 接口 [ajax获取历史投票记录↗](https://yapi.yuewen.com/project/2309/interface/api/207130) 的 **请求类型**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPageAjax`
 * @更新时间 `2021-04-29 16:02:08`
 */
export interface GoPcmTranslationVoteGetHistoryPageAjaxRequest {
  /**
   * 页码
   */
  pageIndex: string;
}

/**
 * 接口 [ajax获取历史投票记录↗](https://yapi.yuewen.com/project/2309/interface/api/207130) 的 **返回类型**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPageAjax`
 * @更新时间 `2021-04-29 16:02:08`
 */
export interface GoPcmTranslationVoteGetHistoryPageAjaxResponse {
  /**
   * [{"bookId":8161851201016505,"time":1619433928631,"platform":"iOS"},{"bookId":8161851201016505,"time":1619433927539,"platform":"iOS"},{"bookId":8161851201016505,"time":1619433925236,"platform":"iOS"},{"bookId":8161851201016505,"time":1619432765333,"platform":"iOS"},{"bookId":8161851201016505,"time":1619432697237,"platform":"iOS"},{"bookId":11721745101021604,"time":1619347208882,"platform":"iOS"}]
   */
  items?: {
    /**
     * 8161851201016505
     */
    bookId?: number;
    /**
     * 1619433928631
     */
    time?: number;
    /**
     * "iOS"
     */
    platform?: string;
  }[];
  /**
   * 6
   */
  total?: number;
  /**
   * 28730
   */
  time?: number;
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 20
   */
  pageSize?: number;
}

/**
 * 接口 [ajax获取历史投票记录↗](https://yapi.yuewen.com/project/2309/interface/api/207130) 的 **请求配置的类型**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPageAjax`
 * @更新时间 `2021-04-29 16:02:08`
 */
type GoPcmTranslationVoteGetHistoryPageAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/translationVote/getHistoryPageAjax",
    "data",
    string,
    "pageIndex",
    false
  >
>;

/**
 * 接口 [ajax获取历史投票记录↗](https://yapi.yuewen.com/project/2309/interface/api/207130) 的 **请求配置**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPageAjax`
 * @更新时间 `2021-04-29 16:02:08`
 */
const goPcmTranslationVoteGetHistoryPageAjaxRequestConfig: GoPcmTranslationVoteGetHistoryPageAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_40,
    devUrl: devUrl_0_0_0_40,
    prodUrl: prodUrl_0_0_0_40,
    path: "/go/pcm/translationVote/getHistoryPageAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_40,
    paramNames: [],
    queryNames: ["pageIndex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTranslationVoteGetHistoryPageAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [ajax获取历史投票记录↗](https://yapi.yuewen.com/project/2309/interface/api/207130) 的 **请求函数**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPageAjax`
 * @更新时间 `2021-04-29 16:02:08`
 */
export const goPcmTranslationVoteGetHistoryPageAjax = /*#__PURE__*/ (
  requestData: GoPcmTranslationVoteGetHistoryPageAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmTranslationVoteGetHistoryPageAjaxResponse>(
    prepare(goPcmTranslationVoteGetHistoryPageAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmTranslationVoteGetHistoryPageAjax.requestConfig =
  goPcmTranslationVoteGetHistoryPageAjaxRequestConfig;

/**
 * 接口 [getAjax↗](https://yapi.yuewen.com/project/2309/interface/api/207238) 的 **请求类型**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getAjax`
 * @更新时间 `2021-04-29 19:04:58`
 */
export interface GoPcmTranslationVoteGetAjaxRequest {
  /**
   * 页码
   */
  pageIndex: string;
  /**
   * 性别
   */
  gender: string;
}

/**
 * 接口 [getAjax↗](https://yapi.yuewen.com/project/2309/interface/api/207238) 的 **返回类型**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getAjax`
 * @更新时间 `2021-04-29 19:04:58`
 */
export interface GoPcmTranslationVoteGetAjaxResponse {
  /**
   * [{"bookId":15230547501140404,"total":"Genesis, field 550123802","hasVote":"TYPO 1","sex":2,"groupItems":null,"editorItems":null,"translatorItems":null,"voteCount":198,"coverUpdateTime":1606879626493},{"bookId":7366916601012405,"total":"The King's Avatar","hasVote":"Butterfly Blue","sex":1,"groupItems":[{"id":19363452317401370,"name":"Translation Nation"}],"editorItems":[{"id":7635959101023305,"userId":3514016596,"guid":3514016596,"name":"xujin1111111"},{"id":8161817001026805,"userId":3823689966,"guid":3823689966,"name":"RENREN"}],"translatorItems":[{"id":8161817001026805,"userId":3823689966,"guid":3823689966,"name":"RENREN"}],"voteCount":76,"coverUpdateTime":1581418734974},{"bookId":6831119801006905,"total":"Forty Millenniums of Cultivation","hasVote":"The Enlightened Master Crouching Cow","sex":1,"groupItems":null,"editorItems":null,"translatorItems":null,"voteCount":23,"coverUpdateTime":1581421901380},{"bookId":19704557301133304,"total":"webnovel hh hhh","hasVote":"nanuat","sex":2,"groupItems":null,"editorItems":null,"translatorItems":null,"voteCount":0,"coverUpdateTime":1618901484837},{"bookId":14095554801057904,"total":"TEST0620","hasVote":"123","sex":2,"groupItems":null,"editorItems":null,"translatorItems":null,"voteCount":0,"coverUpdateTime":1618901485311}]
   */
  items?: {
    /**
     * 15230547501140404
     */
    bookId?: number;
    /**
     * "Genesis, field 550123802"
     */
    total?: string;
    /**
     * "TYPO 1"
     */
    hasVote?: string;
    /**
     * 2
     */
    sex?: number;
    groupItems?: null;
    editorItems?: null;
    translatorItems?: null;
    /**
     * 198
     */
    voteCount?: number;
    /**
     * 1606879626493
     */
    coverUpdateTime?: number;
  }[];
  /**
   * 5
   */
  total?: number;
  /**
   * 1
   */
  hasVote?: number;
  /**
   * 1
   */
  gender?: number;
}

/**
 * 接口 [getAjax↗](https://yapi.yuewen.com/project/2309/interface/api/207238) 的 **请求配置的类型**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getAjax`
 * @更新时间 `2021-04-29 19:04:58`
 */
type GoPcmTranslationVoteGetAjaxRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/translationVote/getAjax",
    "data",
    string,
    "pageIndex" | "gender",
    false
  >
>;

/**
 * 接口 [getAjax↗](https://yapi.yuewen.com/project/2309/interface/api/207238) 的 **请求配置**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getAjax`
 * @更新时间 `2021-04-29 19:04:58`
 */
const goPcmTranslationVoteGetAjaxRequestConfig: GoPcmTranslationVoteGetAjaxRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_40,
    devUrl: devUrl_0_0_0_40,
    prodUrl: prodUrl_0_0_0_40,
    path: "/go/pcm/translationVote/getAjax",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_40,
    paramNames: [],
    queryNames: ["pageIndex", "gender"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTranslationVoteGetAjax",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getAjax↗](https://yapi.yuewen.com/project/2309/interface/api/207238) 的 **请求函数**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getAjax`
 * @更新时间 `2021-04-29 19:04:58`
 */
export const goPcmTranslationVoteGetAjax = /*#__PURE__*/ (
  requestData: GoPcmTranslationVoteGetAjaxRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmTranslationVoteGetAjaxResponse>(
    prepare(goPcmTranslationVoteGetAjaxRequestConfig, requestData),
    ...args
  );
};

goPcmTranslationVoteGetAjax.requestConfig =
  goPcmTranslationVoteGetAjaxRequestConfig;

const mockUrl_0_0_0_41 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_41 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_41 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_41 = "data" as any;

/**
 * 接口 [GetCosKey↗](https://yapi.yuewen.com/project/2309/interface/api/207272) 的 **请求类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/utils/get-cos-temp-key`
 * @更新时间 `2024-09-05 10:35:14`
 */
export interface GoPcmUtilsGetCosTempKeyRequest {
  fileName: string;
}

/**
 * 接口 [GetCosKey↗](https://yapi.yuewen.com/project/2309/interface/api/207272) 的 **返回类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/utils/get-cos-temp-key`
 * @更新时间 `2024-09-05 10:35:14`
 */
export interface GoPcmUtilsGetCosTempKeyResponse {
  Result?: number;
  Data?: {
    Cos?: {
      Credentials?: {
        /**
         * "asjkdakjsdka"
         */
        Token?: string;
        /**
         * "asdqweqw"
         */
        TmpSecretId?: string;
        /**
         * "ryjrtgregdfd"
         */
        TmpSecretKey?: string;
      };
      /**
       * 1620286555
       */
      ExpiredTime?: number;
      /**
       * "1620284755-"
       */
      Path?: string;
    };
  };
  /**
   * "Success"
   */
  Message?: string;
}

/**
 * 接口 [GetCosKey↗](https://yapi.yuewen.com/project/2309/interface/api/207272) 的 **请求配置的类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/utils/get-cos-temp-key`
 * @更新时间 `2024-09-05 10:35:14`
 */
type GoPcmUtilsGetCosTempKeyRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/utils/get-cos-temp-key",
    "data",
    string,
    "fileName",
    false
  >
>;

/**
 * 接口 [GetCosKey↗](https://yapi.yuewen.com/project/2309/interface/api/207272) 的 **请求配置**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/utils/get-cos-temp-key`
 * @更新时间 `2024-09-05 10:35:14`
 */
const goPcmUtilsGetCosTempKeyRequestConfig: GoPcmUtilsGetCosTempKeyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_41,
    devUrl: devUrl_0_0_0_41,
    prodUrl: prodUrl_0_0_0_41,
    path: "/go/pcm/utils/get-cos-temp-key",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_41,
    paramNames: [],
    queryNames: ["fileName"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUtilsGetCosTempKey",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [GetCosKey↗](https://yapi.yuewen.com/project/2309/interface/api/207272) 的 **请求函数**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/utils/get-cos-temp-key`
 * @更新时间 `2024-09-05 10:35:14`
 */
export const goPcmUtilsGetCosTempKey = /*#__PURE__*/ (
  requestData: GoPcmUtilsGetCosTempKeyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUtilsGetCosTempKeyResponse>(
    prepare(goPcmUtilsGetCosTempKeyRequestConfig, requestData),
    ...args
  );
};

goPcmUtilsGetCosTempKey.requestConfig = goPcmUtilsGetCosTempKeyRequestConfig;

/**
 * 接口 [gaIdReport↗](https://yapi.yuewen.com/project/2309/interface/api/215726) 的 **请求类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/gaIdReport`
 * @更新时间 `2022-06-23 11:17:59`
 */
export interface GoPcmUtilsGaIdReportRequest {
  gaId?: string;
  fbp?: string;
  fbc?: string;
  ssCid?: string;
}

/**
 * 接口 [gaIdReport↗](https://yapi.yuewen.com/project/2309/interface/api/215726) 的 **返回类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/gaIdReport`
 * @更新时间 `2022-06-23 11:17:59`
 */
export interface GoPcmUtilsGaIdReportResponse {}

/**
 * 接口 [gaIdReport↗](https://yapi.yuewen.com/project/2309/interface/api/215726) 的 **请求配置的类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/gaIdReport`
 * @更新时间 `2022-06-23 11:17:59`
 */
type GoPcmUtilsGaIdReportRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/utils/gaIdReport",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [gaIdReport↗](https://yapi.yuewen.com/project/2309/interface/api/215726) 的 **请求配置**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/gaIdReport`
 * @更新时间 `2022-06-23 11:17:59`
 */
const goPcmUtilsGaIdReportRequestConfig: GoPcmUtilsGaIdReportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_41,
    devUrl: devUrl_0_0_0_41,
    prodUrl: prodUrl_0_0_0_41,
    path: "/go/pcm/utils/gaIdReport",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUtilsGaIdReport",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [gaIdReport↗](https://yapi.yuewen.com/project/2309/interface/api/215726) 的 **请求函数**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/gaIdReport`
 * @更新时间 `2022-06-23 11:17:59`
 */
export const goPcmUtilsGaIdReport = /*#__PURE__*/ (
  requestData: GoPcmUtilsGaIdReportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUtilsGaIdReportResponse>(
    prepare(goPcmUtilsGaIdReportRequestConfig, requestData),
    ...args
  );
};

goPcmUtilsGaIdReport.requestConfig = goPcmUtilsGaIdReportRequestConfig;

/**
 * 接口 [realtimeReport↗](https://yapi.yuewen.com/project/2309/interface/api/256811) 的 **请求类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/realtimeReport`
 * @更新时间 `2023-03-13 16:23:20`
 */
export interface GoPcmUtilsRealtimeReportRequest {
  /**
   * "@string"
   */
  key?: string;
  /**
   * "@string"
   */
  key1?: string;
  /**
   * "@string"
   */
  value?: string;
}

/**
 * 接口 [realtimeReport↗](https://yapi.yuewen.com/project/2309/interface/api/256811) 的 **返回类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/realtimeReport`
 * @更新时间 `2023-03-13 16:23:20`
 */
export interface GoPcmUtilsRealtimeReportResponse {}

/**
 * 接口 [realtimeReport↗](https://yapi.yuewen.com/project/2309/interface/api/256811) 的 **请求配置的类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/realtimeReport`
 * @更新时间 `2023-03-13 16:23:20`
 */
type GoPcmUtilsRealtimeReportRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/utils/realtimeReport",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [realtimeReport↗](https://yapi.yuewen.com/project/2309/interface/api/256811) 的 **请求配置**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/realtimeReport`
 * @更新时间 `2023-03-13 16:23:20`
 */
const goPcmUtilsRealtimeReportRequestConfig: GoPcmUtilsRealtimeReportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_41,
    devUrl: devUrl_0_0_0_41,
    prodUrl: prodUrl_0_0_0_41,
    path: "/go/pcm/utils/realtimeReport",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUtilsRealtimeReport",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [realtimeReport↗](https://yapi.yuewen.com/project/2309/interface/api/256811) 的 **请求函数**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/realtimeReport`
 * @更新时间 `2023-03-13 16:23:20`
 */
export const goPcmUtilsRealtimeReport = /*#__PURE__*/ (
  requestData: GoPcmUtilsRealtimeReportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUtilsRealtimeReportResponse>(
    prepare(goPcmUtilsRealtimeReportRequestConfig, requestData),
    ...args
  );
};

goPcmUtilsRealtimeReport.requestConfig = goPcmUtilsRealtimeReportRequestConfig;

/**
 * 接口 [ping 探活接口↗](https://yapi.yuewen.com/project/2309/interface/api/289508) 的 **请求类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/ping`
 * @更新时间 `2024-07-22 10:44:32`
 */
export interface GoPcmPingRequest {}

/**
 * 接口 [ping 探活接口↗](https://yapi.yuewen.com/project/2309/interface/api/289508) 的 **返回类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/ping`
 * @更新时间 `2024-07-22 10:44:32`
 */
export interface GoPcmPingResponse {}

/**
 * 接口 [ping 探活接口↗](https://yapi.yuewen.com/project/2309/interface/api/289508) 的 **请求配置的类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/ping`
 * @更新时间 `2024-07-22 10:44:32`
 */
type GoPcmPingRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/ping",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [ping 探活接口↗](https://yapi.yuewen.com/project/2309/interface/api/289508) 的 **请求配置**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/ping`
 * @更新时间 `2024-07-22 10:44:32`
 */
const goPcmPingRequestConfig: GoPcmPingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_41,
  devUrl: devUrl_0_0_0_41,
  prodUrl: prodUrl_0_0_0_41,
  path: "/go/pcm/ping",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_41,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "goPcmPing",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [ping 探活接口↗](https://yapi.yuewen.com/project/2309/interface/api/289508) 的 **请求函数**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/ping`
 * @更新时间 `2024-07-22 10:44:32`
 */
export const goPcmPing = /*#__PURE__*/ (
  requestData?: GoPcmPingRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmPingResponse>(
    prepare(goPcmPingRequestConfig, requestData),
    ...args
  );
};

goPcmPing.requestConfig = goPcmPingRequestConfig;

/**
 * 接口 [uploadImage↗](https://yapi.yuewen.com/project/2309/interface/api/291868) 的 **请求类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/uploadImage`
 * @更新时间 `2024-09-02 19:59:40`
 */
export interface GoPcmUtilsUploadImageRequest {
  reviewImage: FileData;
}

/**
 * 接口 [uploadImage↗](https://yapi.yuewen.com/project/2309/interface/api/291868) 的 **返回类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/uploadImage`
 * @更新时间 `2024-09-02 19:59:40`
 */
export interface GoPcmUtilsUploadImageResponse {
  Result?: number;
  /**
   * "Success"
   */
  Message?: string;
  Data?: {
    /**
     * "https://webbannertest.webnovel.com/utils/1557223872_730084.png"
     */
    ImageUrl?: string;
  };
}

/**
 * 接口 [uploadImage↗](https://yapi.yuewen.com/project/2309/interface/api/291868) 的 **请求配置的类型**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/uploadImage`
 * @更新时间 `2024-09-02 19:59:40`
 */
type GoPcmUtilsUploadImageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/utils/uploadImage",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [uploadImage↗](https://yapi.yuewen.com/project/2309/interface/api/291868) 的 **请求配置**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/uploadImage`
 * @更新时间 `2024-09-02 19:59:40`
 */
const goPcmUtilsUploadImageRequestConfig: GoPcmUtilsUploadImageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_41,
    devUrl: devUrl_0_0_0_41,
    prodUrl: prodUrl_0_0_0_41,
    path: "/go/pcm/utils/uploadImage",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUtilsUploadImage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [uploadImage↗](https://yapi.yuewen.com/project/2309/interface/api/291868) 的 **请求函数**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/uploadImage`
 * @更新时间 `2024-09-02 19:59:40`
 */
export const goPcmUtilsUploadImage = /*#__PURE__*/ (
  requestData: GoPcmUtilsUploadImageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmUtilsUploadImageResponse>(
    prepare(goPcmUtilsUploadImageRequestConfig, requestData),
    ...args
  );
};

goPcmUtilsUploadImage.requestConfig = goPcmUtilsUploadImageRequestConfig;

const mockUrl_0_0_0_42 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_42 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_42 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_42 = "data" as any;

/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/2309/interface/api/214797) 的 **请求类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2022-10-14 13:48:37`
 */
export interface GoPcmSeoGetTagBookList2Request {
  tagId?: string;
  tagName?: string;
  /**
   * 1 搜索书籍  4 搜索fan-fic
   */
  type: string;
  pageIndex: string;
  /**
   * 1:Popular 2:Updated 3:Collection 默认1
   */
  order: string;
}

/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/2309/interface/api/214797) 的 **返回类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2022-10-14 13:48:37`
 */
export interface GoPcmSeoGetTagBookList2Response {
  /**
   * [{"bookId":7765027801015505,"bookName":"War Sovereign Soaring The Heavens","bookType":0,"categoryId":12,"categoryName":"test","bookCoverId":1513319976161,"pvNum":"2M","topFanItems":[{"userId":4300009639,"appId":10,"UUT":1604656231478},{"userId":4300011791,"appId":10,"UUT":1608805208979}],"bookReview":{"reviewId":"@id","content":"[img=fp]@paragraph","userName":"@name"}}]
   */
  recommend?: {
    /**
     * 7765027801015505
     */
    bookId?: number;
    /**
     * "War Sovereign Soaring The Heavens"
     */
    bookName?: string;
    bookType?: number;
    /**
     * 12
     */
    categoryId?: number;
    /**
     * "test"
     */
    categoryName?: string;
    /**
     * 1513319976161
     */
    bookCoverId?: number;
    /**
     * "2M"
     */
    pvNum?: string;
    /**
     * [{"userId":4300009639,"appId":10,"UUT":1604656231478},{"userId":4300011791,"appId":10,"UUT":1608805208979}]
     */
    topFanItems?: {
      /**
       * 4300009639
       */
      userId?: number;
      /**
       * 10
       */
      appId?: number;
      /**
       * 1604656231478
       */
      UUT?: number;
    }[];
    bookReview?: {
      /**
       * "@id"
       */
      reviewId?: string;
      /**
       * "[img=fp]@paragraph"
       */
      content?: string;
      /**
       * "@name"
       */
      userName?: string;
    };
  }[];
  /**
   * [{"bookId":7765027801015505,"bookName":"War Sovereign Soaring The Heavens","bookType":0,"categoryId":12,"categoryName":"test","authorName":"aaa","bookCoverId":1513319976161,"totalScore":5,"tagInfo":[{"tagId":1,"tagName":"tag","isLiked":0,"likeNums":0}],"description":"dfrastraytrdhgdshghfdjtsyyt","chapterNum":100,"publishTime":1412092800000,"firstChapterId":19775416453662908,"firstChapterName":"The Banished Battle God"}]
   */
  items?: {
    /**
     * 7765027801015505
     */
    bookId?: number;
    /**
     * "War Sovereign Soaring The Heavens"
     */
    bookName?: string;
    bookType?: number;
    /**
     * 12
     */
    categoryId?: number;
    /**
     * "test"
     */
    categoryName?: string;
    /**
     * "aaa"
     */
    authorName?: string;
    /**
     * 1513319976161
     */
    bookCoverId?: number;
    /**
     * 5
     */
    totalScore?: number;
    /**
     * [{"tagId":1,"tagName":"tag","isLiked":0,"likeNums":0}]
     */
    tagInfo?: {
      /**
       * 1
       */
      tagId?: number;
      /**
       * "tag"
       */
      tagName?: string;
      isLiked?: number;
      likeNums?: number;
    }[];
    /**
     * "dfrastraytrdhgdshghfdjtsyyt"
     */
    description?: string;
    /**
     * 100
     */
    chapterNum?: number;
    /**
     * 1412092800000
     */
    publishTime?: number;
    /**
     * 19775416453662908
     */
    firstChapterId?: number;
    /**
     * "The Banished Battle God"
     */
    firstChapterName?: string;
  }[];
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 1
   */
  total?: number;
  isLast?: number;
  /**
   * 1
   */
  orderBy?: number;
  /**
   * 1
   */
  tagId?: number;
  /**
   * "xxx"
   */
  tagName?: string;
  /**
   * 1
   */
  type?: number;
}

/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/2309/interface/api/214797) 的 **请求配置的类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2022-10-14 13:48:37`
 */
type GoPcmSeoGetTagBookList2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/getTagBookList",
    "data",
    string,
    "tagId" | "tagName" | "type" | "pageIndex" | "order",
    false
  >
>;

/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/2309/interface/api/214797) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2022-10-14 13:48:37`
 */
const goPcmSeoGetTagBookList2RequestConfig: GoPcmSeoGetTagBookList2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_42,
    devUrl: devUrl_0_0_0_42,
    prodUrl: prodUrl_0_0_0_42,
    path: "/go/pcm/seo/getTagBookList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_42,
    paramNames: [],
    queryNames: ["tagId", "tagName", "type", "pageIndex", "order"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetTagBookList2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/2309/interface/api/214797) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2022-10-14 13:48:37`
 */
export const goPcmSeoGetTagBookList2 = /*#__PURE__*/ (
  requestData: GoPcmSeoGetTagBookList2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoGetTagBookList2Response>(
    prepare(goPcmSeoGetTagBookList2RequestConfig, requestData),
    ...args
  );
};

goPcmSeoGetTagBookList2.requestConfig = goPcmSeoGetTagBookList2RequestConfig;

/**
 * 接口 [getBookDetail↗](https://yapi.yuewen.com/project/2309/interface/api/290511) 的 **请求类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getBookDetail`
 * @更新时间 `2024-08-21 14:04:17`
 */
export interface GoPcmSeoBookGetBookDetailRequest {
  bookId: string;
}

/**
 * 接口 [getBookDetail↗](https://yapi.yuewen.com/project/2309/interface/api/290511) 的 **返回类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getBookDetail`
 * @更新时间 `2024-08-21 14:04:17`
 */
export interface GoPcmSeoBookGetBookDetailResponse {
  bookInfo?: {
    /**
     * "147936688682908905"
     */
    bookId?: string;
    /**
     * "The saint is cute and soft"
     */
    name?: string;
    shortName?: string;
    /**
     * "圣女她萌又软"
     */
    originalName?: string;
    /**
     * "It was rumored that the Saintess of the Wuqi Tribe was doted on by thousands of people and was a figure that was doted on by the High Priest. However, this Saintess had nothing to do all day and did nothing proper. She relied on the High Priest's favor to be unrestrained.\nSu Yan, who was busy acting cute and obedient, was speechless.\nNo, I didn't. Don't frame me.\nThe first time Ye Xuan saw Su Yan was at a sacrificial ceremony. The little girl was surrounded by everyone and looked soft and small. She was obediently pulled step by step by the old high priest to the altar and was pushed to the position of Saintess by the high priest!\nAt that time, her eyes were clear and clear, with some confusion. When faced with the doubts of her clansmen, she would solemnly protect the High Priest and argue with them in a simple and crude manner. She was extremely cute.\nWhen she smiled, she had a pair of dimples. She was very cute and sweet, as if she could reach his heart.\nTherefore, when the High Priest found out that his beloved granddaughter had been abducted by a brat who came out of nowhere, he almost broke his leg…"
     */
    description?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * 70015
     */
    categoryId?: number;
    subcategoryId?: number;
    /**
     * "History"
     */
    categoryName?: string;
    subcategoryName?: string;
    /**
     * "7971965204770601"
     */
    authorId?: string;
    /**
     * "A handful of jelly beans"
     */
    authorName?: string;
    /**
     * 1
     */
    sourceType?: number;
    /**
     * 30
     */
    status?: number;
    /**
     * 49768
     */
    pvNum?: number;
    /**
     * 30
     */
    actionStatus?: number;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * 1623478150000
     */
    checkTime?: number;
    /**
     * -1
     */
    vipStatus?: number;
    /**
     * 1722347116000
     */
    vipTime?: number;
    /**
     * 3594
     */
    wordCount?: number;
    unitPrice?: number;
    essayIds?: null;
    /**
     * 1722347116000
     */
    createTime?: number;
    /**
     * 1722347116000
     */
    updateTime?: number;
    /**
     * 144
     */
    totalChapterCount?: number;
    beforeChapterCount?: number;
    /**
     * 3594
     */
    contentChapterCount?: number;
    lastChapterId?: number;
    lastChapterName?: string;
    lastChapterTime?: number;
    scheduleUpdateFrequency?: number;
    /**
     * "chs / week"
     */
    scheduleUpdateFrequencyUnit?: string;
    /**
     * "Unselected"
     */
    ageGroup?: string;
    /**
     * 1
     */
    language?: number;
    expected?: number;
    /**
     * -1
     */
    sex?: number;
    updateFrequency?: number;
    /**
     * "chs / week"
     */
    updateFrequencyUnit?: string;
    ageGroupDescription?: string;
    firstChapterId?: number;
    languageName?: string;
    signType?: number;
    signed?: number;
    nextChapterTime?: number;
    translateMode?: number;
    words?: string;
    serialStartTime?: number;
    shield?: number;
    site?: number;
    form?: number;
    sideStoryType?: number;
    editorRecommendation?: string;
    noGift?: boolean;
    auditStatus?: number;
    transChannel?: number;
    cpid?: number;
    scbid?: number;
    acbid?: number;
    chargeChapterStartIndex?: number;
    vipChapterWordsCount?: number;
  };
  firstChapter?: {
    bookId?: number;
    /**
     * "7623366892645429"
     */
    chapterId?: string;
    /**
     * "The Witchcraft Tribe"
     */
    chapterName?: string;
    uuid?: number;
    volumeId?: number;
    index?: number;
    /**
     * 1
     */
    sortIndex?: number;
    wordCount?: number;
    chargeWordCount?: number;
    chargeType?: number;
    hasRichContent?: number;
    vipStatus?: number;
    price?: number;
    status?: number;
    contentMD5?: string;
    createTime?: number;
    reverseIndex?: number;
    bonusFlag?: number;
    type?: number;
    transChannel?: number;
    chapterIndex?: number;
    /**
     * -1
     */
    preChapterId?: number;
    preChapterName?: string;
    /**
     * "7623366896827414"
     */
    nextChapterId?: string;
    nextChapterName?: string;
    isVip?: number;
    ssSPrice?: number;
    originalPrice?: number;
    discountInfo?: string;
    chapterLevel?: number;
    userLevel?: number;
    /**
     * [{"contentId":"","content":"    In the ninth year of Tianyuan, the Wuqi Tribe had been in seclusion for twenty-five years. It had been ten years since the previous Saintess had died. During this time, the High Priest had never paid any attention to the request of the Elders to be conferred the title of Saintess. He had only kept his little granddaughter by his side and pampered her.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Therefore, the outside world speculated that the High Priest had raised this little granddaughter as a candidate for Saintess. When she reached a certain age, she would be conferred the title of Saintess.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  This little granddaughter was named Su Yan, the eldest daughter of the high priest. She was the descendant of the previous Holy Maiden. It was said that the high priest had done a divination when this child was born. The divination was very good and was regarded as a colorful phoenix. It was an auspicious sign. The phoenix soared between heaven and earth, spread its wings, and soared straight up. It was an excellent fate.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Since then, Su Yan had been brought to the High Priest's side since she was young and rarely showed her face. Outsiders did not know how this little granddaughter had been raised over the years.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Some guessed that the future Saintess would be extremely arrogant and not easy to discipline. The High Priest was famous for spoiling her. Some guessed that the future Saintess would be obedient and sensible. She would be worthy of the high priest's years of discipline.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Moreover, the person involved was still too sick to get out of bed. How could he have the time to care about the worries and speculations of the outside world?","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  When Su Yan woke up, her head was dizzy and her throat was a little itchy. She couldn't help but frown. Why wasn't her illness cured?","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Girl, how do you feel?\" Suddenly, an old voice sounded.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan shook her head and said in a very soft voice,\"I'm not feeling very well, but I'm not too uncomfortable. I'm a little hungry.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  The high priest took the cold shredded chicken porridge and a small spoon.\" Have some porridge to fill your stomach. The school pharmacy has also let you rest for a few days. You just need to rest in peace.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan blinked.\"Don't tell me I have to make up for it after I recover.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Do you really think they're that kind?\" The High Priest smiled and said lightly.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Grandma, this is called exploitation!\" Su Yan could not help but complain.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Got it. I'll get it back for you another day.\" The high priest's expression was calm. He picked up a small spoon and scooped some porridge. He tested the temperature before feeding it to Su Yan.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  After a while. The High Priest continued,\" You caught a cold this time. Your illness is indeed a little serious. Do you want to instruct the pharmacist to prescribe a new set?\" If we miss this sacrifice, who knows how long we'll have to wait.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Is Grandma anxious?\" Su Yan asked.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \" I've waited for so many years. It's just that those people are always asking about the conferment of titles in the open and in the dark. It's getting a little annoying when they ask too many questions. Now that you're up, I can still relax. It's been so tiring to take care of you these past few years...\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan adjusted her posture for a while and tried her best to make herself more comfortable. Then, she said,\"Grandma, you've been complaining for many years. I'm still young. You don't need this time.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  The high priest rolled his eyes at her. He probably took into account that Su Yan was still sick. Otherwise, he would have twisted Su Yan's ears.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  He was really pampered, loved, and irritable.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \" Look at you. Everyone else is fighting for the position of Saintess. They're trying their best to get the right to participate in the election. You're the only one who keeps pushing it away. No matter how calm she is, she's going to be forced into a corner by you. Do you know that?\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan smiled apologetically.\"I'm not in good health. I have to take care of myself. Otherwise, if I fall down after taking a few steps, how embarrassing would that be?\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"That makes sense.\" The High Priest nodded and pondered for a moment before saying,\" Why don't I go up with you?\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0}]
     */
    contents?: {
      contentId?: string;
      /**
       * "    In the ninth year of Tianyuan, the Wuqi Tribe had been in seclusion for twenty-five years. It had been ten years since the previous Saintess had died. During this time, the High Priest had never paid any attention to the request of the Elders to be conferred the title of Saintess. He had only kept his little granddaughter by his side and pampered her."
       */
      content?: string;
      appId?: number;
      userId?: number;
      paragraphId?: string;
      likeAmount?: number;
      contentAmount?: number;
      userName?: string;
      UUT?: number;
      isLiked?: number;
    }[];
    /**
     * 1
     */
    isAuth?: number;
    batchUnlockStatus?: number;
    isRichFormat?: number;
    /**
     * []
     */
    announcementItems?: unknown[];
    firstChapterId?: string;
    firstChapterIndex?: number;
    reviewTotal?: number;
    notes?: {
      name?: string;
      guid?: string;
      penName?: string;
      avatar?: string;
      UUT?: number;
      role?: string;
      note?: string;
    };
    orderIndex?: number;
    noArchive?: number;
    transRating?: number;
    banner?: {
      coverUrl?: string;
      desc?: string;
    };
    encryptType?: number;
    encryptKeyPool?: string;
    /**
     * 1724219468
     */
    encryptVersion?: number;
    nextChapterEncrypt?: {};
    fastPassNum?: number;
    /**
     * true
     */
    isToApp?: boolean;
    /**
     * 1722347116000
     */
    updateTime?: number;
    /**
     * 1722347116000
     */
    publishTime?: number;
  };
  chapterList?: {
    bookInfo?: {
      /**
       * "147936688682908905"
       */
      bookId?: string;
      /**
       * "The saint is cute and soft"
       */
      name?: string;
      shortName?: string;
      /**
       * "圣女她萌又软"
       */
      originalName?: string;
      /**
       * "It was rumored that the Saintess of the Wuqi Tribe was doted on by thousands of people and was a figure that was doted on by the High Priest. However, this Saintess had nothing to do all day and did nothing proper. She relied on the High Priest's favor to be unrestrained.\nSu Yan, who was busy acting cute and obedient, was speechless.\nNo, I didn't. Don't frame me.\nThe first time Ye Xuan saw Su Yan was at a sacrificial ceremony. The little girl was surrounded by everyone and looked soft and small. She was obediently pulled step by step by the old high priest to the altar and was pushed to the position of Saintess by the high priest!\nAt that time, her eyes were clear and clear, with some confusion. When faced with the doubts of her clansmen, she would solemnly protect the High Priest and argue with them in a simple and crude manner. She was extremely cute.\nWhen she smiled, she had a pair of dimples. She was very cute and sweet, as if she could reach his heart.\nTherefore, when the High Priest found out that his beloved granddaughter had been abducted by a brat who came out of nowhere, he almost broke his leg…"
       */
      description?: string;
      /**
       * 1
       */
      categoryType?: number;
      /**
       * 70015
       */
      categoryId?: number;
      subcategoryId?: number;
      /**
       * "History"
       */
      categoryName?: string;
      subcategoryName?: string;
      /**
       * "7971965204770601"
       */
      authorId?: string;
      /**
       * "A handful of jelly beans"
       */
      authorName?: string;
      /**
       * 1
       */
      sourceType?: number;
      /**
       * 30
       */
      status?: number;
      /**
       * 49768
       */
      pvNum?: number;
      /**
       * 30
       */
      actionStatus?: number;
      /**
       * 15
       */
      checkLevel?: number;
      /**
       * 1623478150000
       */
      checkTime?: number;
      /**
       * -1
       */
      vipStatus?: number;
      /**
       * 1722347116000
       */
      vipTime?: number;
      /**
       * 3594
       */
      wordCount?: number;
      unitPrice?: number;
      essayIds?: null;
      /**
       * 1722347116000
       */
      createTime?: number;
      /**
       * 1722347116000
       */
      updateTime?: number;
      /**
       * 144
       */
      totalChapterCount?: number;
      beforeChapterCount?: number;
      /**
       * 3594
       */
      contentChapterCount?: number;
      lastChapterId?: number;
      lastChapterName?: string;
      lastChapterTime?: number;
      scheduleUpdateFrequency?: number;
      /**
       * "chs / week"
       */
      scheduleUpdateFrequencyUnit?: string;
      /**
       * "Unselected"
       */
      ageGroup?: string;
      /**
       * 1
       */
      language?: number;
      expected?: number;
      /**
       * -1
       */
      sex?: number;
      updateFrequency?: number;
      /**
       * "chs / week"
       */
      updateFrequencyUnit?: string;
      ageGroupDescription?: string;
      firstChapterId?: number;
      languageName?: string;
      signType?: number;
      signed?: number;
      nextChapterTime?: number;
      translateMode?: number;
      words?: string;
      serialStartTime?: number;
      shield?: number;
      site?: number;
      form?: number;
      sideStoryType?: number;
      editorRecommendation?: string;
      noGift?: boolean;
      auditStatus?: number;
      transChannel?: number;
      cpid?: number;
      scbid?: number;
      acbid?: number;
      chargeChapterStartIndex?: number;
      vipChapterWordsCount?: number;
    };
    lastChapter?: {
      bookId?: number;
      /**
       * "7623366900919385"
       */
      chapterId?: string;
      /**
       * "The Tailor Storm (1)"
       */
      chapterName?: string;
      uuid?: number;
      volumeId?: number;
      index?: number;
      /**
       * 4
       */
      sortIndex?: number;
      wordCount?: number;
      chargeWordCount?: number;
      chargeType?: number;
      hasRichContent?: number;
      vipStatus?: number;
      price?: number;
      status?: number;
      contentMD5?: string;
      createTime?: number;
      reverseIndex?: number;
      bonusFlag?: number;
      type?: number;
      transChannel?: number;
      /**
       * 3000
       */
      chapterIndex?: number;
      /**
       * "7623366898043991"
       */
      preChapterId?: string;
      preChapterName?: string;
      /**
       * -1
       */
      nextChapterId?: number;
      nextChapterName?: string;
      isVip?: number;
      ssSPrice?: number;
      originalPrice?: number;
      discountInfo?: string;
      chapterLevel?: number;
      userLevel?: number;
      /**
       * [{"contentId":"","content":"    Today, Su Yan woke up especially early. She wanted to take her size so that she could make the clothes for the sacrifice.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan yawned. She didn't sleep well. She looked a little listless, like a doll that the tailor could fiddle with.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  The high priest was choosing suitable fabrics. From time to time, he would discuss with an old tailor beside him. Occasionally, he would divert his attention to check on Su Yan's progress.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  At this moment, a beautiful woman came in, followed by a young girl. The shadow of the woman could be vaguely seen between the girl's eyes, just like a mother and daughter.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  As soon as the woman entered the door, she saw the high priest and smiled.\"The high priest is choosing a fabric for Su Yan. An Ran, come over. Greetings to the high priest.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"An Ran greets the High Priest.\" The young girl stepped forward and bowed gracefully.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  The high priest looked up at the mother and daughter and nodded as a gesture. He said to the woman,\" You came at the right time. Come and help me take a look at these fabrics. These fabrics are dazzling for an old woman like me.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Madam Su smiled and joined the discussion between the high priest and the old tailor. She was like a good hand as she commented on the fabric in front of her one by one,\"Su Yan's skin is fair. This color suits Su Yan, but it's not good to embroider some patterns on this fabric. This light yellow one looks more lively. Sacrifice is a big event, so it has to be worn more solemnly. This dark green one is steady and steady. It can't help but make Su Yan look old...\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Anran took advantage of the fact that Mrs. Su had no time to pay attention to her while she was discussing the fabric and clothes with the high priest. She could only find a seat and sit down, playing with the flowers on her clothes in boredom.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan opened her eyes when Su Anran sat next to her. Her delicate eyebrows furrowed slightly, but she didn't say anything. After all, there was only a seat next to her.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  The two of them didn't communicate the entire time, and the atmosphere was a little awkward.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  In the end, Su Anran couldn't hold it in anymore and couldn't help but say,\"Are you a blockhead? Why aren't you talking?\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan was originally squinting her eyes to rest. When she heard this, her almond-shaped eyes turned to Su Anran. There was confusion in her eyes.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Anran choked. Why did she have to speak? However, it was not right to ask such a question. However, since they had already spoken, they had to have a place.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Anran lowered her voice and said coldly,\"With your useless appearance, if it weren't for the High Priest, how could you have succeeded the position of Saintess?\" The position of Saintess should have been mine!\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  When An Ran approached, Su Yan smelled a fragrance. She only said,\"The position of Saintess is mine now. What do you want?\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Anran looked her up and down and said,\"Which of the previous Holy Maidens was not dignified, polite, gentle, and amiable?\" You're such a weak and sickly person. You've really embarrassed uncle and the previous Holy Maiden!\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \" It's another matter if I'm embarrassed or not. I don't need an outsider like you to say whether I'm qualified to be the Holy Maiden or not. Now that it's a foregone conclusion, you'd better relax. Otherwise, we won't be able to do anything when we meet every day in the future. It's so embarrassing!\" Su Yan said.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"You!\" Su Anran was provoked.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Anran was furious.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  But Su Anran was helpless.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \" You…\" Her face alternated between green and white as she muttered,\" The position of Saintess originally belonged to me. It was originally mine…\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  As she spoke, Su Anran ran out like crazy.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan stared at Su Anran's back as she ran out, deep in thought.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Anran didn't feel right.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0}]
       */
      contents?: {
        contentId?: string;
        /**
         * "    Today, Su Yan woke up especially early. She wanted to take her size so that she could make the clothes for the sacrifice."
         */
        content?: string;
        appId?: number;
        userId?: number;
        paragraphId?: string;
        likeAmount?: number;
        contentAmount?: number;
        userName?: string;
        UUT?: number;
        isLiked?: number;
      }[];
      /**
       * 1
       */
      isAuth?: number;
      batchUnlockStatus?: number;
      isRichFormat?: number;
      /**
       * []
       */
      announcementItems?: unknown[];
      firstChapterId?: string;
      firstChapterIndex?: number;
      reviewTotal?: number;
      notes?: {
        name?: string;
        guid?: string;
        penName?: string;
        avatar?: string;
        UUT?: number;
        role?: string;
        note?: string;
      };
      orderIndex?: number;
      noArchive?: number;
      transRating?: number;
      banner?: {
        coverUrl?: string;
        desc?: string;
      };
      encryptType?: number;
      encryptKeyPool?: string;
      /**
       * 1724219468
       */
      encryptVersion?: number;
      nextChapterEncrypt?: {};
      fastPassNum?: number;
      /**
       * true
       */
      isToApp?: boolean;
      /**
       * 1722347120000
       */
      updateTime?: number;
      /**
       * 1722347120000
       */
      publishTime?: number;
    };
    /**
     * [{"volumeName":"","volumeId":1,"chapterItems":[{"bookId":0,"chapterId":"7623366894140432","chapterName":"Old Things","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":1,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":0,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347118000,"publishTime":1722347118000},{"bookId":0,"chapterId":"7623366896827414","chapterName":"The Emperor's Illness","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":2,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":1000,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347118000,"publishTime":1722347118000},{"bookId":0,"chapterId":"7623366898043991","chapterName":"The Rising Su Yan","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":3,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":2000,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347120000,"publishTime":1722347120000},{"bookId":0,"chapterId":"7623366900919385","chapterName":"The Tailor Storm (1)","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":4,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":3000,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347120000,"publishTime":1722347120000}]},{"volumeName":"","volumeId":2,"chapterItems":[{"bookId":0,"chapterId":"7623366892645429","chapterName":"The Witchcraft Tribe","uuid":0,"volumeId":"46886830909924557","index":0,"sortIndex":1,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":0,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347116000,"publishTime":1722347116000}]}]
     */
    chapterList?: {
      volumeName?: string;
      /**
       * 1
       */
      volumeId?: number;
      /**
       * [{"bookId":0,"chapterId":"7623366894140432","chapterName":"Old Things","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":1,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":0,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347118000,"publishTime":1722347118000},{"bookId":0,"chapterId":"7623366896827414","chapterName":"The Emperor's Illness","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":2,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":1000,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347118000,"publishTime":1722347118000},{"bookId":0,"chapterId":"7623366898043991","chapterName":"The Rising Su Yan","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":3,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":2000,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347120000,"publishTime":1722347120000},{"bookId":0,"chapterId":"7623366900919385","chapterName":"The Tailor Storm (1)","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":4,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":3000,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347120000,"publishTime":1722347120000}]
       */
      chapterItems?: {
        bookId?: number;
        /**
         * "7623366894140432"
         */
        chapterId?: string;
        /**
         * "Old Things"
         */
        chapterName?: string;
        uuid?: number;
        /**
         * "54610036320079839"
         */
        volumeId?: string;
        index?: number;
        /**
         * 1
         */
        sortIndex?: number;
        wordCount?: number;
        chargeWordCount?: number;
        chargeType?: number;
        hasRichContent?: number;
        vipStatus?: number;
        price?: number;
        status?: number;
        contentMD5?: string;
        createTime?: number;
        reverseIndex?: number;
        bonusFlag?: number;
        type?: number;
        transChannel?: number;
        chapterIndex?: number;
        preChapterId?: number;
        preChapterName?: string;
        nextChapterId?: number;
        nextChapterName?: string;
        isVip?: number;
        ssSPrice?: number;
        originalPrice?: number;
        discountInfo?: string;
        chapterLevel?: number;
        userLevel?: number;
        /**
         * []
         */
        contents?: unknown[];
        /**
         * 1
         */
        isAuth?: number;
        batchUnlockStatus?: number;
        isRichFormat?: number;
        /**
         * []
         */
        announcementItems?: unknown[];
        firstChapterId?: string;
        firstChapterIndex?: number;
        reviewTotal?: number;
        notes?: {
          name?: string;
          guid?: string;
          penName?: string;
          avatar?: string;
          UUT?: number;
          role?: string;
          note?: string;
        };
        orderIndex?: number;
        noArchive?: number;
        transRating?: number;
        banner?: {
          coverUrl?: string;
          desc?: string;
        };
        encryptType?: number;
        encryptKeyPool?: string;
        /**
         * 1724219468
         */
        encryptVersion?: number;
        nextChapterEncrypt?: {};
        fastPassNum?: number;
        /**
         * true
         */
        isToApp?: boolean;
        /**
         * 1722347118000
         */
        updateTime?: number;
        /**
         * 1722347118000
         */
        publishTime?: number;
      }[];
    }[];
    curReadChapter?: number;
    /**
     * true
     */
    last?: boolean;
  };
  youMayAlsoLikeList?: {
    /**
     * [{"bookId":"14804020600439904","bookName":"起点女醭568081806","categoryId":70005,"categoryName":"General","novelType":0,"description":"这是一本测试书籍，创建时间为：1568081806.7029243发软\", \"撩拨\", \"腿软","alg":"","authorName":"字写错1","totalScore":0,"totalChapterNum":17,"tagInfo":null,"translateMode":1,"coverUpdateTime":0},{"bookId":"6820980401004005","bookName":"The Sacred Ruins","categoryId":20001,"categoryName":"","novelType":0,"description":"Hark as the tides ebb and flow. \r\nWatch as the moon wanes and grows.\r\nAs that trail of misty haze enshrouds the earth, \r\nBehold!\r\nThat once quenched fire enkindles amidst the holy ruins,\r\nAnd that yoke that shackles the world tardily unravels. \r\nA brave new world is on the offing,\r\nAs the secrets ‘neath its cryptic cloak slowly unbosom…\r\n\r\n------\r\nRelease Rate: 5 Chapters/Week; will be released on Mon, Wed, Fri and Weekend; ","alg":"","authorName":"Chen Dong","totalScore":3.6,"totalChapterNum":66,"tagInfo":null,"translateMode":3,"coverUpdateTime":1635129690797},{"bookId":"8387192301017505","bookName":"daizhehuoyingxitong","categoryId":20001,"categoryName":"","novelType":0,"description":"erhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre g","alg":"","authorName":"YTgdsg rfgh","totalScore":0,"totalChapterNum":2,"tagInfo":null,"translateMode":1,"coverUpdateTime":1581421902714},{"bookId":"13535193600155904","bookName":"云起，蚕555393536","categoryId":70011,"categoryName":"ACG","novelType":0,"description":"这是一本测试书籍1555393536.42","alg":"","authorName":"字写错1","totalScore":0,"totalChapterNum":32,"tagInfo":null,"translateMode":1,"coverUpdateTime":0},{"bookId":"18885797200687304","bookName":"保底分成1225203252","categoryId":70005,"categoryName":"General","novelType":0,"description":"这是一本测试书籍，创建时间为：2020-12-25 20:32","alg":"","authorName":"字写错","totalScore":0,"totalChapterNum":2,"tagInfo":null,"translateMode":-1,"coverUpdateTime":1638347032499}]
     */
    recommendList?: {
      /**
       * "14804020600439904"
       */
      bookId?: string;
      /**
       * "起点女醭568081806"
       */
      bookName?: string;
      /**
       * 70005
       */
      categoryId?: number;
      /**
       * "General"
       */
      categoryName?: string;
      novelType?: number;
      /**
       * "这是一本测试书籍，创建时间为：1568081806.7029243发软\", \"撩拨\", \"腿软"
       */
      description?: string;
      alg?: string;
      /**
       * "字写错1"
       */
      authorName?: string;
      totalScore?: number;
      /**
       * 17
       */
      totalChapterNum?: number;
      tagInfo?: null;
      /**
       * 1
       */
      translateMode?: number;
      coverUpdateTime?: number;
    }[];
  };
}

/**
 * 接口 [getBookDetail↗](https://yapi.yuewen.com/project/2309/interface/api/290511) 的 **请求配置的类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getBookDetail`
 * @更新时间 `2024-08-21 14:04:17`
 */
type GoPcmSeoBookGetBookDetailRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/book/getBookDetail",
    "data",
    string,
    "bookId",
    false
  >
>;

/**
 * 接口 [getBookDetail↗](https://yapi.yuewen.com/project/2309/interface/api/290511) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getBookDetail`
 * @更新时间 `2024-08-21 14:04:17`
 */
const goPcmSeoBookGetBookDetailRequestConfig: GoPcmSeoBookGetBookDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_42,
    devUrl: devUrl_0_0_0_42,
    prodUrl: prodUrl_0_0_0_42,
    path: "/go/pcm/seo/book/getBookDetail",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_42,
    paramNames: [],
    queryNames: ["bookId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoBookGetBookDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getBookDetail↗](https://yapi.yuewen.com/project/2309/interface/api/290511) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getBookDetail`
 * @更新时间 `2024-08-21 14:04:17`
 */
export const goPcmSeoBookGetBookDetail = /*#__PURE__*/ (
  requestData: GoPcmSeoBookGetBookDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoBookGetBookDetailResponse>(
    prepare(goPcmSeoBookGetBookDetailRequestConfig, requestData),
    ...args
  );
};

goPcmSeoBookGetBookDetail.requestConfig =
  goPcmSeoBookGetBookDetailRequestConfig;

/**
 * 接口 [getChapterInfo↗](https://yapi.yuewen.com/project/2309/interface/api/290716) 的 **请求类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterInfo`
 * @更新时间 `2024-08-21 14:03:38`
 */
export interface GoPcmSeoBookGetChapterInfoRequest {
  bookId: string;
  chapterId: string;
  /**
   * 0  正常无加密状态
   * 1 只fockjs
   * 2 只字体加密
   * 3 fockjs + 字体加密状态
   */
  encryptType?: string;
  font?: string;
}

/**
 * 接口 [getChapterInfo↗](https://yapi.yuewen.com/project/2309/interface/api/290716) 的 **返回类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterInfo`
 * @更新时间 `2024-08-21 14:03:38`
 */
export interface GoPcmSeoBookGetChapterInfoResponse {
  bookInfo?: {
    /**
     * "147936688682908905"
     */
    bookId?: string;
    /**
     * "The saint is cute and soft"
     */
    name?: string;
    shortName?: string;
    /**
     * "圣女她萌又软"
     */
    originalName?: string;
    /**
     * "It was rumored that the Saintess of the Wuqi Tribe was doted on by thousands of people and was a figure that was doted on by the High Priest. However, this Saintess had nothing to do all day and did nothing proper. She relied on the High Priest's favor to be unrestrained.\nSu Yan, who was busy acting cute and obedient, was speechless.\nNo, I didn't. Don't frame me.\nThe first time Ye Xuan saw Su Yan was at a sacrificial ceremony. The little girl was surrounded by everyone and looked soft and small. She was obediently pulled step by step by the old high priest to the altar and was pushed to the position of Saintess by the high priest!\nAt that time, her eyes were clear and clear, with some confusion. When faced with the doubts of her clansmen, she would solemnly protect the High Priest and argue with them in a simple and crude manner. She was extremely cute.\nWhen she smiled, she had a pair of dimples. She was very cute and sweet, as if she could reach his heart.\nTherefore, when the High Priest found out that his beloved granddaughter had been abducted by a brat who came out of nowhere, he almost broke his leg…"
     */
    description?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * 70015
     */
    categoryId?: number;
    subcategoryId?: number;
    /**
     * "History"
     */
    categoryName?: string;
    subcategoryName?: string;
    /**
     * "7971965204770601"
     */
    authorId?: string;
    /**
     * "A handful of jelly beans"
     */
    authorName?: string;
    /**
     * 1
     */
    sourceType?: number;
    /**
     * 30
     */
    status?: number;
    /**
     * 49768
     */
    pvNum?: number;
    /**
     * 30
     */
    actionStatus?: number;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * 1623478150000
     */
    checkTime?: number;
    /**
     * -1
     */
    vipStatus?: number;
    /**
     * 1722347116000
     */
    vipTime?: number;
    /**
     * 3594
     */
    wordCount?: number;
    unitPrice?: number;
    essayIds?: null;
    /**
     * 1722347116000
     */
    createTime?: number;
    /**
     * 1722347116000
     */
    updateTime?: number;
    /**
     * 144
     */
    totalChapterCount?: number;
    beforeChapterCount?: number;
    /**
     * 3594
     */
    contentChapterCount?: number;
    lastChapterId?: number;
    lastChapterName?: string;
    lastChapterTime?: number;
    scheduleUpdateFrequency?: number;
    /**
     * "chs / week"
     */
    scheduleUpdateFrequencyUnit?: string;
    /**
     * "Unselected"
     */
    ageGroup?: string;
    /**
     * 1
     */
    language?: number;
    expected?: number;
    /**
     * -1
     */
    sex?: number;
    updateFrequency?: number;
    /**
     * "chs / week"
     */
    updateFrequencyUnit?: string;
    ageGroupDescription?: string;
    firstChapterId?: number;
    languageName?: string;
    signType?: number;
    signed?: number;
    nextChapterTime?: number;
    translateMode?: number;
    words?: string;
    serialStartTime?: number;
    shield?: number;
    site?: number;
    form?: number;
    sideStoryType?: number;
    editorRecommendation?: string;
    noGift?: boolean;
    auditStatus?: number;
    transChannel?: number;
    cpid?: number;
    scbid?: number;
    acbid?: number;
    chargeChapterStartIndex?: number;
    vipChapterWordsCount?: number;
  };
  chapterInfo?: {
    bookId?: number;
    /**
     * "7623366892645429"
     */
    chapterId?: string;
    /**
     * "The Witchcraft Tribe"
     */
    chapterName?: string;
    uuid?: number;
    volumeId?: number;
    index?: number;
    /**
     * 1
     */
    sortIndex?: number;
    wordCount?: number;
    chargeWordCount?: number;
    chargeType?: number;
    hasRichContent?: number;
    vipStatus?: number;
    price?: number;
    status?: number;
    contentMD5?: string;
    createTime?: number;
    reverseIndex?: number;
    bonusFlag?: number;
    type?: number;
    transChannel?: number;
    chapterIndex?: number;
    /**
     * -1
     */
    preChapterId?: number;
    preChapterName?: string;
    /**
     * "7623366896827414"
     */
    nextChapterId?: string;
    nextChapterName?: string;
    isVip?: number;
    ssSPrice?: number;
    originalPrice?: number;
    discountInfo?: string;
    chapterLevel?: number;
    userLevel?: number;
    /**
     * [{"contentId":"","content":"    In the ninth year of Tianyuan, the Wuqi Tribe had been in seclusion for twenty-five years. It had been ten years since the previous Saintess had died. During this time, the High Priest had never paid any attention to the request of the Elders to be conferred the title of Saintess. He had only kept his little granddaughter by his side and pampered her.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Therefore, the outside world speculated that the High Priest had raised this little granddaughter as a candidate for Saintess. When she reached a certain age, she would be conferred the title of Saintess.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  This little granddaughter was named Su Yan, the eldest daughter of the high priest. She was the descendant of the previous Holy Maiden. It was said that the high priest had done a divination when this child was born. The divination was very good and was regarded as a colorful phoenix. It was an auspicious sign. The phoenix soared between heaven and earth, spread its wings, and soared straight up. It was an excellent fate.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Since then, Su Yan had been brought to the High Priest's side since she was young and rarely showed her face. Outsiders did not know how this little granddaughter had been raised over the years.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Some guessed that the future Saintess would be extremely arrogant and not easy to discipline. The High Priest was famous for spoiling her. Some guessed that the future Saintess would be obedient and sensible. She would be worthy of the high priest's years of discipline.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Moreover, the person involved was still too sick to get out of bed. How could he have the time to care about the worries and speculations of the outside world?","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  When Su Yan woke up, her head was dizzy and her throat was a little itchy. She couldn't help but frown. Why wasn't her illness cured?","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Girl, how do you feel?\" Suddenly, an old voice sounded.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan shook her head and said in a very soft voice,\"I'm not feeling very well, but I'm not too uncomfortable. I'm a little hungry.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  The high priest took the cold shredded chicken porridge and a small spoon.\" Have some porridge to fill your stomach. The school pharmacy has also let you rest for a few days. You just need to rest in peace.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan blinked.\"Don't tell me I have to make up for it after I recover.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Do you really think they're that kind?\" The High Priest smiled and said lightly.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Grandma, this is called exploitation!\" Su Yan could not help but complain.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Got it. I'll get it back for you another day.\" The high priest's expression was calm. He picked up a small spoon and scooped some porridge. He tested the temperature before feeding it to Su Yan.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  After a while. The High Priest continued,\" You caught a cold this time. Your illness is indeed a little serious. Do you want to instruct the pharmacist to prescribe a new set?\" If we miss this sacrifice, who knows how long we'll have to wait.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Is Grandma anxious?\" Su Yan asked.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \" I've waited for so many years. It's just that those people are always asking about the conferment of titles in the open and in the dark. It's getting a little annoying when they ask too many questions. Now that you're up, I can still relax. It's been so tiring to take care of you these past few years...\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan adjusted her posture for a while and tried her best to make herself more comfortable. Then, she said,\"Grandma, you've been complaining for many years. I'm still young. You don't need this time.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  The high priest rolled his eyes at her. He probably took into account that Su Yan was still sick. Otherwise, he would have twisted Su Yan's ears.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  He was really pampered, loved, and irritable.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \" Look at you. Everyone else is fighting for the position of Saintess. They're trying their best to get the right to participate in the election. You're the only one who keeps pushing it away. No matter how calm she is, she's going to be forced into a corner by you. Do you know that?\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan smiled apologetically.\"I'm not in good health. I have to take care of myself. Otherwise, if I fall down after taking a few steps, how embarrassing would that be?\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"That makes sense.\" The High Priest nodded and pondered for a moment before saying,\" Why don't I go up with you?\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0}]
     */
    contents?: {
      contentId?: string;
      /**
       * "    In the ninth year of Tianyuan, the Wuqi Tribe had been in seclusion for twenty-five years. It had been ten years since the previous Saintess had died. During this time, the High Priest had never paid any attention to the request of the Elders to be conferred the title of Saintess. He had only kept his little granddaughter by his side and pampered her."
       */
      content?: string;
      appId?: number;
      userId?: number;
      paragraphId?: string;
      likeAmount?: number;
      contentAmount?: number;
      userName?: string;
      UUT?: number;
      isLiked?: number;
    }[];
    /**
     * 1
     */
    isAuth?: number;
    batchUnlockStatus?: number;
    isRichFormat?: number;
    /**
     * []
     */
    announcementItems?: unknown[];
    firstChapterId?: string;
    firstChapterIndex?: number;
    reviewTotal?: number;
    notes?: {
      name?: string;
      guid?: string;
      penName?: string;
      avatar?: string;
      UUT?: number;
      role?: string;
      note?: string;
    };
    orderIndex?: number;
    noArchive?: number;
    transRating?: number;
    banner?: {
      coverUrl?: string;
      desc?: string;
    };
    encryptType?: number;
    encryptKeyPool?: string;
    /**
     * 1724219468
     */
    encryptVersion?: number;
    nextChapterEncrypt?: {};
    fastPassNum?: number;
    /**
     * true
     */
    isToApp?: boolean;
    /**
     * 1722347116000
     */
    updateTime?: number;
    /**
     * 1722347116000
     */
    publishTime?: number;
  };
  youMayAlsoLikeList?: {
    /**
     * [{"bookId":"10486246401027205","bookName":"0428 zhengwen cehsi 01","categoryId":70009,"categoryName":"Eastern","novelType":0,"description":"synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis","alg":"","authorName":"Amy4060368390ya","totalScore":0,"totalChapterNum":10,"tagInfo":null,"translateMode":1,"coverUpdateTime":1651803450156},{"bookId":"8342885301016705","bookName":"feitian","categoryId":20014,"categoryName":"","novelType":0,"description":"feitianfeitianfeitianfeitianfeitianfeitianfeitianfeitianfeitianfeitianfeitian","alg":"","authorName":"ft","totalScore":0,"totalChapterNum":6,"tagInfo":null,"translateMode":1,"coverUpdateTime":1581421902622},{"bookId":"17665882400816904","bookName":"暑期活动屏蔽作品2","categoryId":70002,"categoryName":"Fantasy","novelType":0,"description":"发放发放付付付付付付付付付付付付付付发放发放付付付付付付付付付付付付发放发放付付付付付付付付付发放发放付付付付付付付付","alg":"","authorName":"灰度账号B","totalScore":0,"totalChapterNum":1,"tagInfo":null,"translateMode":-1,"coverUpdateTime":1638347031178},{"bookId":"10764181401029205","bookName":"asdf","categoryId":70001,"categoryName":"Urban","novelType":0,"description":"asdfasf","alg":"","authorName":"asdfsdaf","totalScore":0,"totalChapterNum":1,"tagInfo":null,"translateMode":1,"coverUpdateTime":1581421900766},{"bookId":"22444246000816302","bookName":"斗战八荒","categoryId":70009,"categoryName":"Eastern","novelType":0,"description":"。。。","alg":"","authorName":"策虎横刀.QD","totalScore":0,"totalChapterNum":276,"tagInfo":null,"translateMode":1,"coverUpdateTime":0}]
     */
    recommendList?: {
      /**
       * "10486246401027205"
       */
      bookId?: string;
      /**
       * "0428 zhengwen cehsi 01"
       */
      bookName?: string;
      /**
       * 70009
       */
      categoryId?: number;
      /**
       * "Eastern"
       */
      categoryName?: string;
      novelType?: number;
      /**
       * "synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis synopsis"
       */
      description?: string;
      alg?: string;
      /**
       * "Amy4060368390ya"
       */
      authorName?: string;
      totalScore?: number;
      /**
       * 10
       */
      totalChapterNum?: number;
      tagInfo?: null;
      /**
       * 1
       */
      translateMode?: number;
      /**
       * 1651803450156
       */
      coverUpdateTime?: number;
    }[];
  };
  isWhiteUser?: number;
  waitPayStatus?: number;
  membershipStatus?: number;
}

/**
 * 接口 [getChapterInfo↗](https://yapi.yuewen.com/project/2309/interface/api/290716) 的 **请求配置的类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterInfo`
 * @更新时间 `2024-08-21 14:03:38`
 */
type GoPcmSeoBookGetChapterInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/book/getChapterInfo",
    "data",
    string,
    "bookId" | "chapterId" | "encryptType" | "font",
    false
  >
>;

/**
 * 接口 [getChapterInfo↗](https://yapi.yuewen.com/project/2309/interface/api/290716) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterInfo`
 * @更新时间 `2024-08-21 14:03:38`
 */
const goPcmSeoBookGetChapterInfoRequestConfig: GoPcmSeoBookGetChapterInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_42,
    devUrl: devUrl_0_0_0_42,
    prodUrl: prodUrl_0_0_0_42,
    path: "/go/pcm/seo/book/getChapterInfo",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_42,
    paramNames: [],
    queryNames: ["bookId", "chapterId", "encryptType", "font"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoBookGetChapterInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getChapterInfo↗](https://yapi.yuewen.com/project/2309/interface/api/290716) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterInfo`
 * @更新时间 `2024-08-21 14:03:38`
 */
export const goPcmSeoBookGetChapterInfo = /*#__PURE__*/ (
  requestData: GoPcmSeoBookGetChapterInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoBookGetChapterInfoResponse>(
    prepare(goPcmSeoBookGetChapterInfoRequestConfig, requestData),
    ...args
  );
};

goPcmSeoBookGetChapterInfo.requestConfig =
  goPcmSeoBookGetChapterInfoRequestConfig;

/**
 * 接口 [getChapterList↗](https://yapi.yuewen.com/project/2309/interface/api/291197) 的 **请求类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterList`
 * @更新时间 `2024-08-21 15:43:39`
 */
export interface GoPcmSeoBookGetChapterListRequest {
  bookId: string;
  pageIndex: string;
  pageSize: string;
  encryptType?: string;
}

/**
 * 接口 [getChapterList↗](https://yapi.yuewen.com/project/2309/interface/api/291197) 的 **返回类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterList`
 * @更新时间 `2024-08-21 15:43:39`
 */
export interface GoPcmSeoBookGetChapterListResponse {
  bookInfo?: {
    /**
     * "147936688682908905"
     */
    bookId?: string;
    /**
     * "The saint is cute and soft"
     */
    name?: string;
    shortName?: string;
    /**
     * "圣女她萌又软"
     */
    originalName?: string;
    /**
     * "It was rumored that the Saintess of the Wuqi Tribe was doted on by thousands of people and was a figure that was doted on by the High Priest. However, this Saintess had nothing to do all day and did nothing proper. She relied on the High Priest's favor to be unrestrained.\nSu Yan, who was busy acting cute and obedient, was speechless.\nNo, I didn't. Don't frame me.\nThe first time Ye Xuan saw Su Yan was at a sacrificial ceremony. The little girl was surrounded by everyone and looked soft and small. She was obediently pulled step by step by the old high priest to the altar and was pushed to the position of Saintess by the high priest!\nAt that time, her eyes were clear and clear, with some confusion. When faced with the doubts of her clansmen, she would solemnly protect the High Priest and argue with them in a simple and crude manner. She was extremely cute.\nWhen she smiled, she had a pair of dimples. She was very cute and sweet, as if she could reach his heart.\nTherefore, when the High Priest found out that his beloved granddaughter had been abducted by a brat who came out of nowhere, he almost broke his leg…"
     */
    description?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * 70015
     */
    categoryId?: number;
    subcategoryId?: number;
    /**
     * "History"
     */
    categoryName?: string;
    subcategoryName?: string;
    /**
     * "7971965204770601"
     */
    authorId?: string;
    /**
     * "A handful of jelly beans"
     */
    authorName?: string;
    /**
     * 1
     */
    sourceType?: number;
    /**
     * 30
     */
    status?: number;
    /**
     * 49768
     */
    pvNum?: number;
    /**
     * 30
     */
    actionStatus?: number;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * 1623478150000
     */
    checkTime?: number;
    /**
     * -1
     */
    vipStatus?: number;
    /**
     * 1722347116000
     */
    vipTime?: number;
    /**
     * 3594
     */
    wordCount?: number;
    unitPrice?: number;
    essayIds?: null;
    /**
     * 1722347116000
     */
    createTime?: number;
    /**
     * 1722347116000
     */
    updateTime?: number;
    /**
     * 144
     */
    totalChapterCount?: number;
    beforeChapterCount?: number;
    /**
     * 3594
     */
    contentChapterCount?: number;
    lastChapterId?: number;
    lastChapterName?: string;
    lastChapterTime?: number;
    scheduleUpdateFrequency?: number;
    /**
     * "chs / week"
     */
    scheduleUpdateFrequencyUnit?: string;
    /**
     * "Unselected"
     */
    ageGroup?: string;
    /**
     * 1
     */
    language?: number;
    expected?: number;
    /**
     * -1
     */
    sex?: number;
    updateFrequency?: number;
    /**
     * "chs / week"
     */
    updateFrequencyUnit?: string;
    ageGroupDescription?: string;
    firstChapterId?: number;
    languageName?: string;
    signType?: number;
    signed?: number;
    nextChapterTime?: number;
    translateMode?: number;
    words?: string;
    serialStartTime?: number;
    shield?: number;
    site?: number;
    form?: number;
    sideStoryType?: number;
    editorRecommendation?: string;
    noGift?: boolean;
    auditStatus?: number;
    transChannel?: number;
    cpid?: number;
    scbid?: number;
    acbid?: number;
    chargeChapterStartIndex?: number;
    vipChapterWordsCount?: number;
  };
  firstChapter?: {
    bookId?: number;
    /**
     * "7623366892645429"
     */
    chapterId?: string;
    /**
     * "The Witchcraft Tribe"
     */
    chapterName?: string;
    uuid?: number;
    volumeId?: number;
    index?: number;
    /**
     * 1
     */
    sortIndex?: number;
    wordCount?: number;
    chargeWordCount?: number;
    chargeType?: number;
    hasRichContent?: number;
    vipStatus?: number;
    price?: number;
    status?: number;
    contentMD5?: string;
    createTime?: number;
    reverseIndex?: number;
    bonusFlag?: number;
    type?: number;
    transChannel?: number;
    chapterIndex?: number;
    /**
     * -1
     */
    preChapterId?: number;
    preChapterName?: string;
    /**
     * "7623366896827414"
     */
    nextChapterId?: string;
    nextChapterName?: string;
    isVip?: number;
    ssSPrice?: number;
    originalPrice?: number;
    discountInfo?: string;
    chapterLevel?: number;
    userLevel?: number;
    /**
     * [{"contentId":"","content":"    In the ninth year of Tianyuan, the Wuqi Tribe had been in seclusion for twenty-five years. It had been ten years since the previous Saintess had died. During this time, the High Priest had never paid any attention to the request of the Elders to be conferred the title of Saintess. He had only kept his little granddaughter by his side and pampered her.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Therefore, the outside world speculated that the High Priest had raised this little granddaughter as a candidate for Saintess. When she reached a certain age, she would be conferred the title of Saintess.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  This little granddaughter was named Su Yan, the eldest daughter of the high priest. She was the descendant of the previous Holy Maiden. It was said that the high priest had done a divination when this child was born. The divination was very good and was regarded as a colorful phoenix. It was an auspicious sign. The phoenix soared between heaven and earth, spread its wings, and soared straight up. It was an excellent fate.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Since then, Su Yan had been brought to the High Priest's side since she was young and rarely showed her face. Outsiders did not know how this little granddaughter had been raised over the years.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Some guessed that the future Saintess would be extremely arrogant and not easy to discipline. The High Priest was famous for spoiling her. Some guessed that the future Saintess would be obedient and sensible. She would be worthy of the high priest's years of discipline.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Moreover, the person involved was still too sick to get out of bed. How could he have the time to care about the worries and speculations of the outside world?","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  When Su Yan woke up, her head was dizzy and her throat was a little itchy. She couldn't help but frown. Why wasn't her illness cured?","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Girl, how do you feel?\" Suddenly, an old voice sounded.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan shook her head and said in a very soft voice,\"I'm not feeling very well, but I'm not too uncomfortable. I'm a little hungry.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  The high priest took the cold shredded chicken porridge and a small spoon.\" Have some porridge to fill your stomach. The school pharmacy has also let you rest for a few days. You just need to rest in peace.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan blinked.\"Don't tell me I have to make up for it after I recover.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Do you really think they're that kind?\" The High Priest smiled and said lightly.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Grandma, this is called exploitation!\" Su Yan could not help but complain.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Got it. I'll get it back for you another day.\" The high priest's expression was calm. He picked up a small spoon and scooped some porridge. He tested the temperature before feeding it to Su Yan.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  After a while. The High Priest continued,\" You caught a cold this time. Your illness is indeed a little serious. Do you want to instruct the pharmacist to prescribe a new set?\" If we miss this sacrifice, who knows how long we'll have to wait.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"Is Grandma anxious?\" Su Yan asked.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \" I've waited for so many years. It's just that those people are always asking about the conferment of titles in the open and in the dark. It's getting a little annoying when they ask too many questions. Now that you're up, I can still relax. It's been so tiring to take care of you these past few years...\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan adjusted her posture for a while and tried her best to make herself more comfortable. Then, she said,\"Grandma, you've been complaining for many years. I'm still young. You don't need this time.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  The high priest rolled his eyes at her. He probably took into account that Su Yan was still sick. Otherwise, he would have twisted Su Yan's ears.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  He was really pampered, loved, and irritable.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \" Look at you. Everyone else is fighting for the position of Saintess. They're trying their best to get the right to participate in the election. You're the only one who keeps pushing it away. No matter how calm she is, she's going to be forced into a corner by you. Do you know that?\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan smiled apologetically.\"I'm not in good health. I have to take care of myself. Otherwise, if I fall down after taking a few steps, how embarrassing would that be?\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"That makes sense.\" The High Priest nodded and pondered for a moment before saying,\" Why don't I go up with you?\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0}]
     */
    contents?: {
      contentId?: string;
      /**
       * "    In the ninth year of Tianyuan, the Wuqi Tribe had been in seclusion for twenty-five years. It had been ten years since the previous Saintess had died. During this time, the High Priest had never paid any attention to the request of the Elders to be conferred the title of Saintess. He had only kept his little granddaughter by his side and pampered her."
       */
      content?: string;
      appId?: number;
      userId?: number;
      paragraphId?: string;
      likeAmount?: number;
      contentAmount?: number;
      userName?: string;
      UUT?: number;
      isLiked?: number;
    }[];
    /**
     * 1
     */
    isAuth?: number;
    batchUnlockStatus?: number;
    isRichFormat?: number;
    /**
     * []
     */
    announcementItems?: unknown[];
    firstChapterId?: string;
    firstChapterIndex?: number;
    reviewTotal?: number;
    notes?: {
      name?: string;
      guid?: string;
      penName?: string;
      avatar?: string;
      UUT?: number;
      role?: string;
      note?: string;
    };
    orderIndex?: number;
    noArchive?: number;
    transRating?: number;
    banner?: {
      coverUrl?: string;
      desc?: string;
    };
    encryptType?: number;
    encryptKeyPool?: string;
    /**
     * 1724219468
     */
    encryptVersion?: number;
    nextChapterEncrypt?: {};
    fastPassNum?: number;
    /**
     * true
     */
    isToApp?: boolean;
    /**
     * 1722347116000
     */
    updateTime?: number;
    /**
     * 1722347116000
     */
    publishTime?: number;
  };
  chapterList?: {
    bookInfo?: {
      /**
       * "147936688682908905"
       */
      bookId?: string;
      /**
       * "The saint is cute and soft"
       */
      name?: string;
      shortName?: string;
      /**
       * "圣女她萌又软"
       */
      originalName?: string;
      /**
       * "It was rumored that the Saintess of the Wuqi Tribe was doted on by thousands of people and was a figure that was doted on by the High Priest. However, this Saintess had nothing to do all day and did nothing proper. She relied on the High Priest's favor to be unrestrained.\nSu Yan, who was busy acting cute and obedient, was speechless.\nNo, I didn't. Don't frame me.\nThe first time Ye Xuan saw Su Yan was at a sacrificial ceremony. The little girl was surrounded by everyone and looked soft and small. She was obediently pulled step by step by the old high priest to the altar and was pushed to the position of Saintess by the high priest!\nAt that time, her eyes were clear and clear, with some confusion. When faced with the doubts of her clansmen, she would solemnly protect the High Priest and argue with them in a simple and crude manner. She was extremely cute.\nWhen she smiled, she had a pair of dimples. She was very cute and sweet, as if she could reach his heart.\nTherefore, when the High Priest found out that his beloved granddaughter had been abducted by a brat who came out of nowhere, he almost broke his leg…"
       */
      description?: string;
      /**
       * 1
       */
      categoryType?: number;
      /**
       * 70015
       */
      categoryId?: number;
      subcategoryId?: number;
      /**
       * "History"
       */
      categoryName?: string;
      subcategoryName?: string;
      /**
       * "7971965204770601"
       */
      authorId?: string;
      /**
       * "A handful of jelly beans"
       */
      authorName?: string;
      /**
       * 1
       */
      sourceType?: number;
      /**
       * 30
       */
      status?: number;
      /**
       * 49768
       */
      pvNum?: number;
      /**
       * 30
       */
      actionStatus?: number;
      /**
       * 15
       */
      checkLevel?: number;
      /**
       * 1623478150000
       */
      checkTime?: number;
      /**
       * -1
       */
      vipStatus?: number;
      /**
       * 1722347116000
       */
      vipTime?: number;
      /**
       * 3594
       */
      wordCount?: number;
      unitPrice?: number;
      essayIds?: null;
      /**
       * 1722347116000
       */
      createTime?: number;
      /**
       * 1722347116000
       */
      updateTime?: number;
      /**
       * 144
       */
      totalChapterCount?: number;
      beforeChapterCount?: number;
      /**
       * 3594
       */
      contentChapterCount?: number;
      lastChapterId?: number;
      lastChapterName?: string;
      lastChapterTime?: number;
      scheduleUpdateFrequency?: number;
      /**
       * "chs / week"
       */
      scheduleUpdateFrequencyUnit?: string;
      /**
       * "Unselected"
       */
      ageGroup?: string;
      /**
       * 1
       */
      language?: number;
      expected?: number;
      /**
       * -1
       */
      sex?: number;
      updateFrequency?: number;
      /**
       * "chs / week"
       */
      updateFrequencyUnit?: string;
      ageGroupDescription?: string;
      firstChapterId?: number;
      languageName?: string;
      signType?: number;
      signed?: number;
      nextChapterTime?: number;
      translateMode?: number;
      words?: string;
      serialStartTime?: number;
      shield?: number;
      site?: number;
      form?: number;
      sideStoryType?: number;
      editorRecommendation?: string;
      noGift?: boolean;
      auditStatus?: number;
      transChannel?: number;
      cpid?: number;
      scbid?: number;
      acbid?: number;
      chargeChapterStartIndex?: number;
      vipChapterWordsCount?: number;
    };
    lastChapter?: {
      bookId?: number;
      /**
       * "7623366900919385"
       */
      chapterId?: string;
      /**
       * "The Tailor Storm (1)"
       */
      chapterName?: string;
      uuid?: number;
      volumeId?: number;
      index?: number;
      /**
       * 4
       */
      sortIndex?: number;
      wordCount?: number;
      chargeWordCount?: number;
      chargeType?: number;
      hasRichContent?: number;
      vipStatus?: number;
      price?: number;
      status?: number;
      contentMD5?: string;
      createTime?: number;
      reverseIndex?: number;
      bonusFlag?: number;
      type?: number;
      transChannel?: number;
      /**
       * 3000
       */
      chapterIndex?: number;
      /**
       * "7623366898043991"
       */
      preChapterId?: string;
      preChapterName?: string;
      /**
       * -1
       */
      nextChapterId?: number;
      nextChapterName?: string;
      isVip?: number;
      ssSPrice?: number;
      originalPrice?: number;
      discountInfo?: string;
      chapterLevel?: number;
      userLevel?: number;
      /**
       * [{"contentId":"","content":"    Today, Su Yan woke up especially early. She wanted to take her size so that she could make the clothes for the sacrifice.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan yawned. She didn't sleep well. She looked a little listless, like a doll that the tailor could fiddle with.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  The high priest was choosing suitable fabrics. From time to time, he would discuss with an old tailor beside him. Occasionally, he would divert his attention to check on Su Yan's progress.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  At this moment, a beautiful woman came in, followed by a young girl. The shadow of the woman could be vaguely seen between the girl's eyes, just like a mother and daughter.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  As soon as the woman entered the door, she saw the high priest and smiled.\"The high priest is choosing a fabric for Su Yan. An Ran, come over. Greetings to the high priest.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"An Ran greets the High Priest.\" The young girl stepped forward and bowed gracefully.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  The high priest looked up at the mother and daughter and nodded as a gesture. He said to the woman,\" You came at the right time. Come and help me take a look at these fabrics. These fabrics are dazzling for an old woman like me.\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Madam Su smiled and joined the discussion between the high priest and the old tailor. She was like a good hand as she commented on the fabric in front of her one by one,\"Su Yan's skin is fair. This color suits Su Yan, but it's not good to embroider some patterns on this fabric. This light yellow one looks more lively. Sacrifice is a big event, so it has to be worn more solemnly. This dark green one is steady and steady. It can't help but make Su Yan look old...\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Anran took advantage of the fact that Mrs. Su had no time to pay attention to her while she was discussing the fabric and clothes with the high priest. She could only find a seat and sit down, playing with the flowers on her clothes in boredom.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan opened her eyes when Su Anran sat next to her. Her delicate eyebrows furrowed slightly, but she didn't say anything. After all, there was only a seat next to her.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  The two of them didn't communicate the entire time, and the atmosphere was a little awkward.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  In the end, Su Anran couldn't hold it in anymore and couldn't help but say,\"Are you a blockhead? Why aren't you talking?\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan was originally squinting her eyes to rest. When she heard this, her almond-shaped eyes turned to Su Anran. There was confusion in her eyes.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Anran choked. Why did she have to speak? However, it was not right to ask such a question. However, since they had already spoken, they had to have a place.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Anran lowered her voice and said coldly,\"With your useless appearance, if it weren't for the High Priest, how could you have succeeded the position of Saintess?\" The position of Saintess should have been mine!\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  When An Ran approached, Su Yan smelled a fragrance. She only said,\"The position of Saintess is mine now. What do you want?\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Anran looked her up and down and said,\"Which of the previous Holy Maidens was not dignified, polite, gentle, and amiable?\" You're such a weak and sickly person. You've really embarrassed uncle and the previous Holy Maiden!\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \" It's another matter if I'm embarrassed or not. I don't need an outsider like you to say whether I'm qualified to be the Holy Maiden or not. Now that it's a foregone conclusion, you'd better relax. Otherwise, we won't be able to do anything when we meet every day in the future. It's so embarrassing!\" Su Yan said.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \"You!\" Su Anran was provoked.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Anran was furious.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  But Su Anran was helpless.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  \" You…\" Her face alternated between green and white as she muttered,\" The position of Saintess originally belonged to me. It was originally mine…\"","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  As she spoke, Su Anran ran out like crazy.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Yan stared at Su Anran's back as she ran out, deep in thought.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0},{"contentId":"","content":"  Su Anran didn't feel right.","appId":0,"userId":0,"paragraphId":"","likeAmount":0,"contentAmount":0,"userName":"","UUT":0,"isLiked":0}]
       */
      contents?: {
        contentId?: string;
        /**
         * "    Today, Su Yan woke up especially early. She wanted to take her size so that she could make the clothes for the sacrifice."
         */
        content?: string;
        appId?: number;
        userId?: number;
        paragraphId?: string;
        likeAmount?: number;
        contentAmount?: number;
        userName?: string;
        UUT?: number;
        isLiked?: number;
      }[];
      /**
       * 1
       */
      isAuth?: number;
      batchUnlockStatus?: number;
      isRichFormat?: number;
      /**
       * []
       */
      announcementItems?: unknown[];
      firstChapterId?: string;
      firstChapterIndex?: number;
      reviewTotal?: number;
      notes?: {
        name?: string;
        guid?: string;
        penName?: string;
        avatar?: string;
        UUT?: number;
        role?: string;
        note?: string;
      };
      orderIndex?: number;
      noArchive?: number;
      transRating?: number;
      banner?: {
        coverUrl?: string;
        desc?: string;
      };
      encryptType?: number;
      encryptKeyPool?: string;
      /**
       * 1724219468
       */
      encryptVersion?: number;
      nextChapterEncrypt?: {};
      fastPassNum?: number;
      /**
       * true
       */
      isToApp?: boolean;
      /**
       * 1722347120000
       */
      updateTime?: number;
      /**
       * 1722347120000
       */
      publishTime?: number;
    };
    /**
     * [{"volumeName":"","volumeId":1,"chapterItems":[{"bookId":0,"chapterId":"7623366894140432","chapterName":"Old Things","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":1,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":0,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347118000,"publishTime":1722347118000},{"bookId":0,"chapterId":"7623366896827414","chapterName":"The Emperor's Illness","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":2,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":1000,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347118000,"publishTime":1722347118000},{"bookId":0,"chapterId":"7623366898043991","chapterName":"The Rising Su Yan","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":3,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":2000,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347120000,"publishTime":1722347120000},{"bookId":0,"chapterId":"7623366900919385","chapterName":"The Tailor Storm (1)","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":4,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":3000,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347120000,"publishTime":1722347120000}]},{"volumeName":"","volumeId":2,"chapterItems":[{"bookId":0,"chapterId":"7623366892645429","chapterName":"The Witchcraft Tribe","uuid":0,"volumeId":"46886830909924557","index":0,"sortIndex":1,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":0,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347116000,"publishTime":1722347116000}]}]
     */
    chapterList?: {
      volumeName?: string;
      /**
       * 1
       */
      volumeId?: number;
      /**
       * [{"bookId":0,"chapterId":"7623366894140432","chapterName":"Old Things","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":1,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":0,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347118000,"publishTime":1722347118000},{"bookId":0,"chapterId":"7623366896827414","chapterName":"The Emperor's Illness","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":2,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":1000,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347118000,"publishTime":1722347118000},{"bookId":0,"chapterId":"7623366898043991","chapterName":"The Rising Su Yan","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":3,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":2000,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347120000,"publishTime":1722347120000},{"bookId":0,"chapterId":"7623366900919385","chapterName":"The Tailor Storm (1)","uuid":0,"volumeId":"54610036320079839","index":0,"sortIndex":4,"wordCount":0,"chargeWordCount":0,"chargeType":0,"hasRichContent":0,"vipStatus":0,"price":0,"status":0,"contentMD5":"","createTime":0,"reverseIndex":0,"bonusFlag":0,"type":0,"transChannel":0,"chapterIndex":3000,"preChapterId":0,"preChapterName":"","nextChapterId":0,"nextChapterName":"","isVip":0,"ssSPrice":0,"originalPrice":0,"discountInfo":"","chapterLevel":0,"userLevel":0,"contents":[],"isAuth":1,"batchUnlockStatus":0,"isRichFormat":0,"announcementItems":[],"firstChapterId":"","firstChapterIndex":0,"reviewTotal":0,"notes":{"name":"","guid":"","penName":"","avatar":"","UUT":0,"role":"","note":""},"orderIndex":0,"noArchive":0,"transRating":0,"banner":{"coverUrl":"","desc":""},"encryptType":0,"encryptKeyPool":"","encryptVersion":1724219468,"nextChapterEncrypt":{},"fastPassNum":0,"isToApp":true,"updateTime":1722347120000,"publishTime":1722347120000}]
       */
      chapterItems?: {
        bookId?: number;
        /**
         * "7623366894140432"
         */
        chapterId?: string;
        /**
         * "Old Things"
         */
        chapterName?: string;
        uuid?: number;
        /**
         * "54610036320079839"
         */
        volumeId?: string;
        index?: number;
        /**
         * 1
         */
        sortIndex?: number;
        wordCount?: number;
        chargeWordCount?: number;
        chargeType?: number;
        hasRichContent?: number;
        vipStatus?: number;
        price?: number;
        status?: number;
        contentMD5?: string;
        createTime?: number;
        reverseIndex?: number;
        bonusFlag?: number;
        type?: number;
        transChannel?: number;
        chapterIndex?: number;
        preChapterId?: number;
        preChapterName?: string;
        nextChapterId?: number;
        nextChapterName?: string;
        isVip?: number;
        ssSPrice?: number;
        originalPrice?: number;
        discountInfo?: string;
        chapterLevel?: number;
        userLevel?: number;
        /**
         * []
         */
        contents?: unknown[];
        /**
         * 1
         */
        isAuth?: number;
        batchUnlockStatus?: number;
        isRichFormat?: number;
        /**
         * []
         */
        announcementItems?: unknown[];
        firstChapterId?: string;
        firstChapterIndex?: number;
        reviewTotal?: number;
        notes?: {
          name?: string;
          guid?: string;
          penName?: string;
          avatar?: string;
          UUT?: number;
          role?: string;
          note?: string;
        };
        orderIndex?: number;
        noArchive?: number;
        transRating?: number;
        banner?: {
          coverUrl?: string;
          desc?: string;
        };
        encryptType?: number;
        encryptKeyPool?: string;
        /**
         * 1724219468
         */
        encryptVersion?: number;
        nextChapterEncrypt?: {};
        fastPassNum?: number;
        /**
         * true
         */
        isToApp?: boolean;
        /**
         * 1722347118000
         */
        updateTime?: number;
        /**
         * 1722347118000
         */
        publishTime?: number;
      }[];
    }[];
    curReadChapter?: number;
    /**
     * true
     */
    last?: boolean;
  };
  youMayAlsoLikeList?: {
    /**
     * [{"bookId":"14804020600439904","bookName":"起点女醭568081806","categoryId":70005,"categoryName":"General","novelType":0,"description":"这是一本测试书籍，创建时间为：1568081806.7029243发软\", \"撩拨\", \"腿软","alg":"","authorName":"字写错1","totalScore":0,"totalChapterNum":17,"tagInfo":null,"translateMode":1,"coverUpdateTime":0},{"bookId":"6820980401004005","bookName":"The Sacred Ruins","categoryId":20001,"categoryName":"","novelType":0,"description":"Hark as the tides ebb and flow. \r\nWatch as the moon wanes and grows.\r\nAs that trail of misty haze enshrouds the earth, \r\nBehold!\r\nThat once quenched fire enkindles amidst the holy ruins,\r\nAnd that yoke that shackles the world tardily unravels. \r\nA brave new world is on the offing,\r\nAs the secrets ‘neath its cryptic cloak slowly unbosom…\r\n\r\n------\r\nRelease Rate: 5 Chapters/Week; will be released on Mon, Wed, Fri and Weekend; ","alg":"","authorName":"Chen Dong","totalScore":3.6,"totalChapterNum":66,"tagInfo":null,"translateMode":3,"coverUpdateTime":1635129690797},{"bookId":"8387192301017505","bookName":"daizhehuoyingxitong","categoryId":20001,"categoryName":"","novelType":0,"description":"erhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre gerhehh gre g","alg":"","authorName":"YTgdsg rfgh","totalScore":0,"totalChapterNum":2,"tagInfo":null,"translateMode":1,"coverUpdateTime":1581421902714},{"bookId":"13535193600155904","bookName":"云起，蚕555393536","categoryId":70011,"categoryName":"ACG","novelType":0,"description":"这是一本测试书籍1555393536.42","alg":"","authorName":"字写错1","totalScore":0,"totalChapterNum":32,"tagInfo":null,"translateMode":1,"coverUpdateTime":0},{"bookId":"18885797200687304","bookName":"保底分成1225203252","categoryId":70005,"categoryName":"General","novelType":0,"description":"这是一本测试书籍，创建时间为：2020-12-25 20:32","alg":"","authorName":"字写错","totalScore":0,"totalChapterNum":2,"tagInfo":null,"translateMode":-1,"coverUpdateTime":1638347032499}]
     */
    recommendList?: {
      /**
       * "14804020600439904"
       */
      bookId?: string;
      /**
       * "起点女醭568081806"
       */
      bookName?: string;
      /**
       * 70005
       */
      categoryId?: number;
      /**
       * "General"
       */
      categoryName?: string;
      novelType?: number;
      /**
       * "这是一本测试书籍，创建时间为：1568081806.7029243发软\", \"撩拨\", \"腿软"
       */
      description?: string;
      alg?: string;
      /**
       * "字写错1"
       */
      authorName?: string;
      totalScore?: number;
      /**
       * 17
       */
      totalChapterNum?: number;
      tagInfo?: null;
      /**
       * 1
       */
      translateMode?: number;
      coverUpdateTime?: number;
    }[];
  };
}

/**
 * 接口 [getChapterList↗](https://yapi.yuewen.com/project/2309/interface/api/291197) 的 **请求配置的类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterList`
 * @更新时间 `2024-08-21 15:43:39`
 */
type GoPcmSeoBookGetChapterListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/book/getChapterList",
    "data",
    string,
    "bookId" | "pageIndex" | "pageSize" | "encryptType",
    false
  >
>;

/**
 * 接口 [getChapterList↗](https://yapi.yuewen.com/project/2309/interface/api/291197) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterList`
 * @更新时间 `2024-08-21 15:43:39`
 */
const goPcmSeoBookGetChapterListRequestConfig: GoPcmSeoBookGetChapterListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_42,
    devUrl: devUrl_0_0_0_42,
    prodUrl: prodUrl_0_0_0_42,
    path: "/go/pcm/seo/book/getChapterList",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_42,
    paramNames: [],
    queryNames: ["bookId", "pageIndex", "pageSize", "encryptType"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoBookGetChapterList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getChapterList↗](https://yapi.yuewen.com/project/2309/interface/api/291197) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterList`
 * @更新时间 `2024-08-21 15:43:39`
 */
export const goPcmSeoBookGetChapterList = /*#__PURE__*/ (
  requestData: GoPcmSeoBookGetChapterListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoBookGetChapterListResponse>(
    prepare(goPcmSeoBookGetChapterListRequestConfig, requestData),
    ...args
  );
};

goPcmSeoBookGetChapterList.requestConfig =
  goPcmSeoBookGetChapterListRequestConfig;

/**
 * 接口 [getTopicDetail↗](https://yapi.yuewen.com/project/2309/interface/api/295540) 的 **请求类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-11-05 15:52:56`
 */
export interface GoPcmSeoTopicDetail2Request {
  topicId: string;
}

/**
 * 接口 [getTopicDetail↗](https://yapi.yuewen.com/project/2309/interface/api/295540) 的 **返回类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-11-05 15:52:56`
 */
export interface GoPcmSeoTopicDetail2Response {
  topicInfo?: {
    /**
     * 345219126197336
     */
    topicId?: number;
    /**
     * "harry potter forced blowjob fanfiction"
     */
    topicName?: string;
  };
  bookInfo?: {
    /**
     * "13915522306315405"
     */
    bookId?: string;
    /**
     * "Harry Potter and the Fortunate Queen"
     */
    name?: string;
    /**
     * "Powerful"
     */
    shortName?: string;
    /**
     * "en"
     */
    language?: string;
    /**
     * "13427215505427301"
     */
    authorId?: string;
    /**
     * "Mystical_Snowflake"
     */
    authorName?: string;
    itemType?: number;
    /**
     * "Parental Guidance Suggested"
     */
    ageGroup?: string;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * "Book&Literature"
     */
    categoryName?: string;
    /**
     * 81001
     */
    categoryId?: number;
    scheduleUpdateFrq?: number;
    scheduleUpdateFrqUnit?: number;
    frequencyUnit?: string;
    /**
     * 459
     */
    totalChapterNum?: number;
    /**
     * 30
     */
    actionStatus?: number;
    /**
     * 4.37
     */
    totalScore?: number;
    /**
     * "“You will hear many of his Death Eaters claiming that they are in his confidence, that they alone are close to him, even understand him. They are deluded. Lord Voldemort has never had a friend, nor do I believe that he has ever wanted one,” Dumbledore told Harry Potter with absolute certainty.\r\nBut what if Voldemort did have a friend? Not just a friend but the friend? A millennia-old wizard, who learned the secret of Hogwarts from the great Four founders, and had his own goals to take over the world?\r\nTo stop that ancient wizard, an ancient power is called upon . . . in the form of a girl. A Muggle-born at that.\r\nChristina Norton has powers beyond anyone's imagination but she is too caught up in the Chosen One Harry Potter's life and catastrophes. But as she starts to uncover the plans of Voldemort, she realizes someone else is working with him. Someone who wants her dead. Why? She doesn't know. She just knows she has to save her loved ones and Hogwarts from Malgino and for that she is ready to go to the end of the world.\r\n\r\nAnd fight whoever comes in her way.\r\n\r\nWarning: It was my first book, so the first volume is going to be a bumpy ride. Things start to change at the end of the second volume, so if you can hang in there till then, welcome.\r\n\r\nDisclaimer: I neither own the original Harry Potter book series (I mean y'all already know that but still) nor the book cover (I guess I edited it but it doesn't count).\r\n\r\nIf you want to support me:\r\nhttps://ko-fi.com/thewordsiren"
     */
    description?: string;
    /**
     * 7587636
     */
    pvNum?: number;
    /**
     * 1559197477000
     */
    checkTime?: number;
    /**
     * 1730776460000
     */
    updateTime?: number;
    /**
     * [{"id":41000074,"name":"WEAKTOSTRONG","likeCount":0,"like":false},{"id":41000052,"name":"SURVIVAL","likeCount":0,"like":false},{"id":41000024,"name":"VAMPIRE","likeCount":0,"like":false},{"id":41000459,"name":"TEEN","likeCount":0,"like":false},{"id":41000413,"name":"HARRYPOTTER","likeCount":0,"like":false}]
     */
    tagInfo?: {
      /**
       * 41000074
       */
      id?: number;
      /**
       * "WEAKTOSTRONG"
       */
      name?: string;
      likeCount?: number;
      like?: boolean;
    }[];
    expected?: number;
    /**
     * "37354371129862036"
     */
    firstChapterId?: string;
    /**
     * -1
     */
    translateMode?: number;
    /**
     * 8
     */
    categoryType?: number;
    /**
     * 4305441188
     */
    authorUserId?: number;
    /**
     * []
     */
    groupItems?: unknown[];
    /**
     * []
     */
    editorItems?: unknown[];
    /**
     * []
     */
    translatorItems?: unknown[];
    /**
     * 1708932912218
     */
    coverId?: number;
    inLibrary?: number;
    /**
     * "Best Birthday Ever"
     */
    firstChapterName?: string;
    /**
     * []
     */
    animationItems?: unknown[];
    /**
     * []
     */
    notes?: unknown[];
    advText?: string;
    advActionUrl?: string;
    picPC?: string;
    feverLink?: string;
    /**
     * [{"name":"ROMANCE"},{"name":"FEMALELEAD"},{"name":"ADVENTURE"},{"name":"ACTION"},{"name":"WIZARDINGWORLD"}]
     */
    relatedWords?: {
      /**
       * "ROMANCE"
       */
      name?: string;
    }[];
    readToChapterId?: number;
  };
  chapterInfo?: {
    lastChapterItem?: {
      /**
       * "83411143053340891"
       */
      chapterId?: string;
      /**
       * 459
       */
      chapterIndex?: number;
      chapterLevel?: number;
      /**
       * "Evil and Greater Evil"
       */
      chapterName?: string;
      /**
       * 1
       */
      isAuth?: number;
      isVip?: number;
      /**
       * 1730776460000
       */
      publishTime?: number;
      /**
       * "4 hours ago"
       */
      publishTimeFormat?: string;
      userLevel?: number;
    };
    /**
     * [{"chapterItems":[{"chapterId":"37354371129862036","chapterName":"Best Birthday Ever","chapterIndex":1,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559197476000},{"chapterId":"37362598408151977","chapterName":"Ginevra","chapterIndex":2,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559228125000},{"chapterId":"37380731760066691","chapterName":"A Wand","chapterIndex":3,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559295677000},{"chapterId":"37387743294183009","chapterName":"Missing Boys","chapterIndex":4,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559321798000},{"chapterId":"37405118030737586","chapterName":"The Sorting Ceremony","chapterIndex":5,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559386523000},{"chapterId":"37413968347720556","chapterName":"Dumbledore","chapterIndex":6,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559419493000},{"chapterId":"37430592018639834","chapterName":"A Howler","chapterIndex":7,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559481421000},{"chapterId":"37459038140687513","chapterName":"Signed Photos","chapterIndex":8,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559587391000},{"chapterId":"37475279559521598","chapterName":"Quidditch Field","chapterIndex":9,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559647895000},{"chapterId":"37502484419235969","chapterName":"Slytherins","chapterIndex":10,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559749241000},{"chapterId":"37528030599504660","chapterName":"A Slytherin Boy","chapterIndex":11,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559844408000},{"chapterId":"37551958399184242","chapterName":"A Party","chapterIndex":12,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559933546000},{"chapterId":"37567820803916255","chapterName":"A Party pt. 2","chapterIndex":13,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559992638000},{"chapterId":"37574475855755527","chapterName":"Mrs. Norris","chapterIndex":14,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560017430000},{"chapterId":"37597278642437576","chapterName":"Squib","chapterIndex":15,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560102377000},{"chapterId":"37613430387033802","chapterName":"The Chamber of Secrets","chapterIndex":16,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560162547000},{"chapterId":"37635687712881425","chapterName":"Potions Class","chapterIndex":17,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560245462000},{"chapterId":"37658562725473170","chapterName":"The First Match","chapterIndex":18,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560330678000},{"chapterId":"37666202398542995","chapterName":"Attack","chapterIndex":19,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560359138000},{"chapterId":"37679946545550944","chapterName":"It Can't Wait","chapterIndex":20,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560410339000},{"chapterId":"39902778147009622","chapterName":"Preparations","chapterIndex":21,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568691032000},{"chapterId":"39902802306187541","chapterName":"Parseltongue","chapterIndex":22,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568691122000},{"chapterId":"39902828361219931","chapterName":"The Dueling Club","chapterIndex":23,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568691219000},{"chapterId":"39902847671781520","chapterName":"Ghostly Incident","chapterIndex":24,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568691291000},{"chapterId":"39902865136877561","chapterName":"Headmaster's Office","chapterIndex":25,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568691356000},{"chapterId":"39902886880133503","chapterName":"Malfoy","chapterIndex":26,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568691437000},{"chapterId":"39932392751823915","chapterName":"A Diary","chapterIndex":27,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568801355000},{"chapterId":"39938618038472965","chapterName":"Valentine's Day","chapterIndex":28,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568824546000},{"chapterId":"39938653757164543","chapterName":"Fifty Years Ago","chapterIndex":29,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568824679000},{"chapterId":"39962736444106610","chapterName":"Memory","chapterIndex":30,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568914394000},{"chapterId":"39972916590334886","chapterName":"Confrontation","chapterIndex":31,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568952318000},{"chapterId":"39972927327753164","chapterName":"Mystery","chapterIndex":32,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568952358000},{"chapterId":"39982072906967881","chapterName":"A Dagger","chapterIndex":33,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568986428000},{"chapterId":"39982115873415566","chapterName":"The Chamber","chapterIndex":34,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568986588000},{"chapterId":"39982330353349171","chapterName":"The Basilisk","chapterIndex":35,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568987387000},{"chapterId":"39982604962813577","chapterName":"The Sword","chapterIndex":36,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568988410000},{"chapterId":"39983065061184917","chapterName":"A Key","chapterIndex":37,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568990124000},{"chapterId":"39983626611387588","chapterName":"First Year Ends","chapterIndex":38,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568992216000}],"volumeId":1,"volumeName":"The Journey Begins"},{"chapterItems":[{"chapterId":"37748680786241954","chapterName":"Owl Post","chapterIndex":39,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560666394000},{"chapterId":"37757812960458427","chapterName":"Leaky Cauldron","chapterIndex":40,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560700414000},{"chapterId":"37771491625985053","chapterName":"Nine and Three Quarter","chapterIndex":41,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560751371000},{"chapterId":"37781050629345571","chapterName":"Dementors","chapterIndex":42,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560786981000},{"chapterId":"37806014036235350","chapterName":"Thestrals","chapterIndex":43,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560879977000},{"chapterId":"37821847701608438","chapterName":"Fortuna Major","chapterIndex":44,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560938962000},{"chapterId":"37828615781541764","chapterName":"Herbology","chapterIndex":45,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560964175000},{"chapterId":"37842876666800810","chapterName":"Hippogriff","chapterIndex":46,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561017301000},{"chapterId":"37852315679510277","chapterName":"Butterbeer Corks","chapterIndex":47,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561052464000},{"chapterId":"37873784610406986","chapterName":"Quidditch","chapterIndex":48,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561132442000},{"chapterId":"37916269067952260","chapterName":"Practices","chapterIndex":49,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561290709000},{"chapterId":"37916311749190068","chapterName":"Magical Pets","chapterIndex":50,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561290869000},{"chapterId":"37955045391648256","chapterName":"Grindylow","chapterIndex":51,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561435162000},{"chapterId":"37987074019753785","chapterName":"Halloween Attack","chapterIndex":52,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561554486000},{"chapterId":"38012345892530822","chapterName":"Anything Different","chapterIndex":53,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561648623000},{"chapterId":"38030248641621246","chapterName":"Snape and Lupin","chapterIndex":54,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561715316000},{"chapterId":"38031802346031850","chapterName":"Who She Is. . .","chapterIndex":55,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561721104000},{"chapterId":"38051397597448236","chapterName":"Queen","chapterIndex":56,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561794102000},{"chapterId":"38061347174415569","chapterName":"Helping Each Other","chapterIndex":57,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561831167000},{"chapterId":"38073598820274878","chapterName":"The Story of Black and Potter","chapterIndex":58,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1561876808000},{"chapterId":"42305606459122197","chapterName":"Confrontation","chapterIndex":59,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577642266000},{"chapterId":"42318785583043304","chapterName":"Christmas and Firebolt","chapterIndex":60,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577691361000},{"chapterId":"42319256955704752","chapterName":"Right and Wrong","chapterIndex":61,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577693117000},{"chapterId":"42320127760326319","chapterName":"Biggest Fear","chapterIndex":62,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577696361000},{"chapterId":"42341233498059227","chapterName":"The Match","chapterIndex":63,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577774986000},{"chapterId":"42344493915108140","chapterName":"The Attack","chapterIndex":64,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577787133000},{"chapterId":"42344867828915472","chapterName":"Reunion","chapterIndex":65,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577788525000},{"chapterId":"42345497846926726","chapterName":"Quidditch Finals","chapterIndex":66,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577790873000},{"chapterId":"42347229792500740","chapterName":"Quidditch Finals pt. two","chapterIndex":67,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577797324000},{"chapterId":"42349019720106901","chapterName":"An Encounter","chapterIndex":68,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577803992000},{"chapterId":"42349491898075088","chapterName":"Peter Pettigrew","chapterIndex":69,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577805751000},{"chapterId":"42350165687845832","chapterName":"The Story of Marauders","chapterIndex":70,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577808261000},{"chapterId":"42352788839123218","chapterName":"The Rat","chapterIndex":71,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577818033000},{"chapterId":"42353179395945198","chapterName":"Werewolf","chapterIndex":72,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577819488000},{"chapterId":"42366445224513902","chapterName":"Aftermath","chapterIndex":73,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577868907000},{"chapterId":"42366904249139893","chapterName":"End of the Term","chapterIndex":74,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577870617000}],"volumeId":2,"volumeName":"A New Friend"},{"chapterItems":[{"chapterId":"38184491134539497","chapterName":"The Burrow","chapterIndex":75,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1562289914000},{"chapterId":"38196301204092023","chapterName":"A Dinner of thirteen","chapterIndex":76,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1562333910000},{"chapterId":"38214058226283537","chapterName":"Portkey","chapterIndex":77,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1562400060000},{"chapterId":"38239066478673377","chapterName":"Ludo Bagman","chapterIndex":78,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1562493223000},{"chapterId":"38266802572155531","chapterName":"Quidditch World Cup   pt.1","chapterIndex":79,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1562596548000},{"chapterId":"38291869863574998","chapterName":"Quidditch World Cup pt. 2","chapterIndex":80,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1562689931000},{"chapterId":"38314470803561572","chapterName":"You Don't Belong","chapterIndex":81,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1562774126000},{"chapterId":"38333156578877620","chapterName":"The Dark Mark","chapterIndex":82,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1562843736000},{"chapterId":"38384484139191175","chapterName":"Unfogging the Future","chapterIndex":83,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563034946000},{"chapterId":"38402922417018573","chapterName":"Conflicts","chapterIndex":84,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563103634000},{"chapterId":"38425338388208447","chapterName":"Triwizard Tournament","chapterIndex":85,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563187140000},{"chapterId":"38432334101407129","chapterName":"Saint?","chapterIndex":86,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563213201000},{"chapterId":"38446743699906889","chapterName":"Mad-Eye","chapterIndex":87,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563266881000},{"chapterId":"38453777262505747","chapterName":"The Kitchen","chapterIndex":88,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563293083000},{"chapterId":"38478553838307180","chapterName":"Feelings","chapterIndex":89,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563385383000},{"chapterId":"38514240469911843","chapterName":"Three Riddles","chapterIndex":90,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563518326000},{"chapterId":"38517638862787800","chapterName":"Beauxbatons and Durmstrangs","chapterIndex":91,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563530986000},{"chapterId":"38525450854646023","chapterName":"The Goblet of Fire","chapterIndex":92,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563560104000},{"chapterId":"38558241587788776","chapterName":"Championship","chapterIndex":93,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563682243000},{"chapterId":"38565107378210006","chapterName":"Unexpected","chapterIndex":94,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563707820000},{"chapterId":"38586683666520398","chapterName":"Help","chapterIndex":95,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563788198000},{"chapterId":"38627591350962274","chapterName":"Rita Skeeter","chapterIndex":96,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563940591000},{"chapterId":"38633436264582327","chapterName":"Quibbler","chapterIndex":97,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1563962365000},{"chapterId":"38720150043681465","chapterName":"Dead","chapterIndex":98,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564285399000},{"chapterId":"38722656442316906","chapterName":"Therapy","chapterIndex":99,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564294736000},{"chapterId":"38722960311238918","chapterName":"Interesting","chapterIndex":100,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564295868000},{"chapterId":"38723160564098544","chapterName":"Flying","chapterIndex":101,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564296614000},{"chapterId":"38723541725661807","chapterName":"The First Task","chapterIndex":102,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564298034000},{"chapterId":"38724861085937381","chapterName":"Hungary Horntail","chapterIndex":103,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564302949000},{"chapterId":"38725216494474765","chapterName":"Research","chapterIndex":104,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564304273000},{"chapterId":"38725545344682004","chapterName":"Yule Ball","chapterIndex":105,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564305498000},{"chapterId":"38725815642410701","chapterName":"Date","chapterIndex":106,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564306505000},{"chapterId":"38726095620593065","chapterName":"Christmas E've","chapterIndex":107,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564307548000},{"chapterId":"38729957601495269","chapterName":"Astoria","chapterIndex":108,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564321935000},{"chapterId":"38729988471572955","chapterName":"Giant","chapterIndex":109,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564322050000},{"chapterId":"38746366809272028","chapterName":"Mr Crouch","chapterIndex":110,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564383064000},{"chapterId":"38767408642578996","chapterName":"Hagrid","chapterIndex":111,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564461451000},{"chapterId":"38780562802015696","chapterName":"The Golden Egg","chapterIndex":112,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564510454000},{"chapterId":"38799711628491012","chapterName":"Animagus","chapterIndex":113,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564581789000},{"chapterId":"38818423190388556","chapterName":"Gillyweed","chapterIndex":114,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1564651495000},{"chapterId":"39053448381004817","chapterName":"The Grey Lady","chapterIndex":115,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1565528006000},{"chapterId":"39058184907835601","chapterName":"The Second Task","chapterIndex":116,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1565544677000},{"chapterId":"39067221535804319","chapterName":"Trouble","chapterIndex":117,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1565578341000},{"chapterId":"39076169026427450","chapterName":"House-elves","chapterIndex":118,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1565611673000},{"chapterId":"39081393837373937","chapterName":"Future","chapterIndex":119,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1565631137000},{"chapterId":"39092388148334877","chapterName":"Letters","chapterIndex":120,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1565672094000},{"chapterId":"39122495348987615","chapterName":"Easter Holidays","chapterIndex":121,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1565784252000},{"chapterId":"39141162333823246","chapterName":"Problems","chapterIndex":122,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1565853792000},{"chapterId":"39166321178502130","chapterName":"Inner Struggles","chapterIndex":123,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1565947517000},{"chapterId":"39191441636915082","chapterName":"Pensive","chapterIndex":124,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566041097000},{"chapterId":"39230666784701278","chapterName":"Red and Green","chapterIndex":125,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566187222000},{"chapterId":"39267230915022820","chapterName":"Creatures","chapterIndex":126,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566323434000},{"chapterId":"39282327976736140","chapterName":"True Seer","chapterIndex":127,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566379675000},{"chapterId":"39313512945739187","chapterName":"The Third Task","chapterIndex":128,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566495848000},{"chapterId":"39375207449815609","chapterName":"Vines with Thorns","chapterIndex":129,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566725678000},{"chapterId":"39378507326868662","chapterName":"Familiar Voices","chapterIndex":130,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566737971000},{"chapterId":"39383909858854175","chapterName":"Lord Voldemort","chapterIndex":131,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566758097000},{"chapterId":"39384033070729602","chapterName":"Duel","chapterIndex":132,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566758556000},{"chapterId":"39397887041391038","chapterName":"Golden Threads and Lights","chapterIndex":133,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566810166000},{"chapterId":"39398208878737577","chapterName":"Intruder","chapterIndex":134,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566811365000},{"chapterId":"39400029424770981","chapterName":"Polyjuice Potion","chapterIndex":135,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566818148000},{"chapterId":"39407541574226227","chapterName":"The Story of Crouch","chapterIndex":136,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566846132000},{"chapterId":"39407558217224501","chapterName":"Stubbornness","chapterIndex":137,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566846194000},{"chapterId":"39416461684435129","chapterName":"Dreamless Night","chapterIndex":138,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566879362000},{"chapterId":"39441255456890178","chapterName":"A Beetle","chapterIndex":139,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1566971726000},{"chapterId":"39452017587963743","chapterName":"End of the Year","chapterIndex":140,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1567011818000},{"chapterId":"39476699691277927","chapterName":"Not Butterflies but Dragons pt 1","chapterIndex":141,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1567103766000},{"chapterId":"39485199414774656","chapterName":"Not Butterflies but Dragons pt. 2","chapterIndex":142,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1567135430000}],"volumeId":3,"volumeName":"The Triwizard Tournament"},{"chapterItems":[{"chapterId":"39499155927789222","chapterName":"Normal Nortons","chapterIndex":143,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1567187422000},{"chapterId":"39541665635037234","chapterName":"Grimmauld Place, London","chapterIndex":144,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1567345783000},{"chapterId":"39568213616418171","chapterName":"Order of the Phoenix pt 1","chapterIndex":145,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1567444683000},{"chapterId":"39580311750769731","chapterName":"Order of the Phoenix pt. 2","chapterIndex":146,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1567489752000},{"chapterId":"39584333450769153","chapterName":"Weasleys","chapterIndex":147,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1567504733000},{"chapterId":"39615473825935523","chapterName":"New Alliance","chapterIndex":148,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1567620740000},{"chapterId":"39638270438603709","chapterName":"Late Night Talks","chapterIndex":149,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1567705664000},{"chapterId":"39678499266545891","chapterName":"Kreacher","chapterIndex":150,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1567855528000},{"chapterId":"39715685076628671","chapterName":"Owls","chapterIndex":151,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1567994057000},{"chapterId":"39723300070417578","chapterName":"Joke Shop","chapterIndex":152,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568022424000},{"chapterId":"39731296477434424","chapterName":"Black House","chapterIndex":153,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568052213000},{"chapterId":"39754068679256904","chapterName":"Locked Cabinets","chapterIndex":154,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568137046000},{"chapterId":"39794862815505852","chapterName":"Letters","chapterIndex":155,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568289016000},{"chapterId":"40048627720183405","chapterName":"The Prophecy","chapterIndex":156,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1569234364000},{"chapterId":"40055873866876236","chapterName":"Harry's Arrival","chapterIndex":157,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1569261358000},{"chapterId":"40073959454071039","chapterName":"Anger Issues","chapterIndex":158,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1569328732000},{"chapterId":"40074158079538332","chapterName":"Questions","chapterIndex":159,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1569329473000},{"chapterId":"40096324942622561","chapterName":"Followers","chapterIndex":160,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1569412050000},{"chapterId":"40101939018523696","chapterName":"Kreacher's Secret","chapterIndex":161,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1569432964000},{"chapterId":"40124871174313621","chapterName":"Harry Potter","chapterIndex":162,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1569518393000},{"chapterId":"40159964026688360","chapterName":"The Hearing","chapterIndex":163,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1569649124000},{"chapterId":"40171280174998258","chapterName":"Prefect","chapterIndex":164,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1569691280000},{"chapterId":"40214269324743580","chapterName":"Adaptation","chapterIndex":165,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1569851427000},{"chapterId":"40251279846468663","chapterName":"The Changing Boggart","chapterIndex":166,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1569989302000},{"chapterId":"40280025810919068","chapterName":"Hogwarts Express","chapterIndex":167,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1570096389000},{"chapterId":"40419763897291409","chapterName":"Back to Hogwarts","chapterIndex":168,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1570616954000},{"chapterId":"40460184371394014","chapterName":"The Song","chapterIndex":169,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1570767532000},{"chapterId":"40483400565455804","chapterName":"Self-Control","chapterIndex":170,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1570854019000},{"chapterId":"40507771535278156","chapterName":"Assumptions","chapterIndex":171,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1570944809000},{"chapterId":"40534368137037132","chapterName":"The Surrounding","chapterIndex":172,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1571043888000},{"chapterId":"40552028505700192","chapterName":"First Day Back","chapterIndex":173,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1571109679000},{"chapterId":"40556711630657050","chapterName":"The Transformation","chapterIndex":174,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1571127125000},{"chapterId":"40575435792252920","chapterName":"Animagus Friends","chapterIndex":175,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1571196877000},{"chapterId":"40621328054674161","chapterName":"Chemistry","chapterIndex":176,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1571367839000},{"chapterId":"40644207362233791","chapterName":"Midnight","chapterIndex":177,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1571453071000},{"chapterId":"40669717840580251","chapterName":"Tryouts","chapterIndex":178,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1571548105000},{"chapterId":"40693210523172197","chapterName":"Surprises","chapterIndex":179,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1571635622000},{"chapterId":"40715471338667949","chapterName":"Quidditch Disaster","chapterIndex":180,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1571718550000},{"chapterId":"40739500338500837","chapterName":"Birthday","chapterIndex":181,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1571808065000},{"chapterId":"40761205744255169","chapterName":"Percy's Letter","chapterIndex":182,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1571888924000},{"chapterId":"40764931108296553","chapterName":"Padfoot","chapterIndex":183,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1571902802000},{"chapterId":"40807864926781923","chapterName":"Detention","chapterIndex":184,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1572062743000},{"chapterId":"40830743949135661","chapterName":"Blame Game","chapterIndex":185,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1572147974000},{"chapterId":"40838208602297531","chapterName":"Hermione's Plan","chapterIndex":186,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1572175782000},{"chapterId":"40857251413555686","chapterName":"Hog's Head","chapterIndex":187,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1572246722000},{"chapterId":"40876773398862862","chapterName":"The Meeting","chapterIndex":188,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1572319447000},{"chapterId":"40901529573585176","chapterName":"Unexpected Encounter","chapterIndex":189,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1572411672000},{"chapterId":"40927597072280826","chapterName":"Death Claims All","chapterIndex":190,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1572508780000},{"chapterId":"40971758194442968","chapterName":"Dreams","chapterIndex":191,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1572673293000},{"chapterId":"40980616849715019","chapterName":"Dumbledore's Army","chapterIndex":192,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1572706294000},{"chapterId":"40995717417854209","chapterName":"Communication Methods","chapterIndex":193,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1572762548000},{"chapterId":"41017244850910513","chapterName":"Practice","chapterIndex":194,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1572842744000},{"chapterId":"41062725333352005","chapterName":"A New Notice","chapterIndex":195,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573012172000},{"chapterId":"41097841808035662","chapterName":"Sweet Knife","chapterIndex":196,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573142991000},{"chapterId":"41120779349315288","chapterName":"The Crown Badge","chapterIndex":197,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573228440000},{"chapterId":"41155420944914369","chapterName":"The Song","chapterIndex":198,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573357490000},{"chapterId":"41183116487872633","chapterName":"Powerful People","chapterIndex":199,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573460664000},{"chapterId":"41201473446538448","chapterName":"The Hut Light","chapterIndex":200,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573529049000},{"chapterId":"41210269287895408","chapterName":"Hagrid's Tale","chapterIndex":201,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573561816000},{"chapterId":"41211495215849214","chapterName":"Gift for Gurg","chapterIndex":202,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573566383000},{"chapterId":"41211567156553833","chapterName":"Gigantic Problems","chapterIndex":203,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573566651000},{"chapterId":"41213477343249976","chapterName":"Coldness","chapterIndex":204,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573573767000},{"chapterId":"41231227637790936","chapterName":"Late Night","chapterIndex":205,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573639892000},{"chapterId":"41251374524064896","chapterName":"Christmas Arrangements","chapterIndex":206,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573714945000},{"chapterId":"41272013184093967","chapterName":"The Seeker","chapterIndex":207,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573791830000},{"chapterId":"41296704682641637","chapterName":"Mr. Weasley","chapterIndex":208,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573883814000},{"chapterId":"41317966649806590","chapterName":"Waiting","chapterIndex":209,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1573963020000},{"chapterId":"41344789811090982","chapterName":"Breakfast","chapterIndex":210,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1574062944000},{"chapterId":"41345636171304656","chapterName":"St. Mungo's","chapterIndex":211,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1574066097000},{"chapterId":"41352195676883855","chapterName":"Stupid","chapterIndex":212,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1574090533000},{"chapterId":"41376128291620213","chapterName":"Confession","chapterIndex":213,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1574179689000},{"chapterId":"41397766873729635","chapterName":"Christmas Gifts","chapterIndex":214,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1574260299000},{"chapterId":"41434836736459849","chapterName":"Old Wounds","chapterIndex":215,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1574398395000},{"chapterId":"41456348902259646","chapterName":"Past","chapterIndex":216,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1574478534000},{"chapterId":"41525902659615213","chapterName":"The Knight Bus","chapterIndex":217,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1574737642000},{"chapterId":"41625313704199237","chapterName":"Hogwarts: a history","chapterIndex":218,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1575107977000},{"chapterId":"41628464347926113","chapterName":"Hogwarts: a history 2","chapterIndex":219,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1575119714000},{"chapterId":"41645188682147063","chapterName":"Expecto Patronum","chapterIndex":220,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1575182017000},{"chapterId":"41700240767636141","chapterName":"Occlumency","chapterIndex":221,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1575387102000},{"chapterId":"41817031112185345","chapterName":"Conflicts and Compromises","chapterIndex":222,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1575822180000},{"chapterId":"42045798803895917","chapterName":"Everyone Is Important","chapterIndex":223,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1576674406000},{"chapterId":"42063974820279361","chapterName":"Snitch and Bludger","chapterIndex":224,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1576742117000},{"chapterId":"42111285780856905","chapterName":"Friends and Foes","chapterIndex":225,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1576918364000},{"chapterId":"42133146879193497","chapterName":"Two-way Mirror","chapterIndex":226,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1576999803000},{"chapterId":"42177727565987221","chapterName":"Explosion","chapterIndex":227,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577165879000},{"chapterId":"42209309534241315","chapterName":"Aurelia","chapterIndex":228,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577283531000},{"chapterId":"42210763129016030","chapterName":"Trelawney","chapterIndex":229,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577288946000},{"chapterId":"42211513137689757","chapterName":"Warning","chapterIndex":230,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577291740000},{"chapterId":"42223495022696848","chapterName":"Hagrid's Secret","chapterIndex":231,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577336376000},{"chapterId":"42225906093186314","chapterName":"Grawp","chapterIndex":232,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577345358000},{"chapterId":"42229313075989218","chapterName":"Silver Vapor","chapterIndex":233,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577358051000},{"chapterId":"42233568314840938","chapterName":"New Creations and Troubles","chapterIndex":234,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577373902000},{"chapterId":"42249981549149921","chapterName":"The Escape","chapterIndex":235,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577435046000},{"chapterId":"42293499483187900","chapterName":"New Notice","chapterIndex":236,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577597163000},{"chapterId":"42345785341297634","chapterName":"Fireworks","chapterIndex":237,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577791943000},{"chapterId":"42387559266963699","chapterName":"The Quidditch Cup","chapterIndex":238,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1577947563000},{"chapterId":"42623017427191199","chapterName":"Mayhem","chapterIndex":239,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1578824713000},{"chapterId":"42665254672457805","chapterName":"The Legends","chapterIndex":240,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1578982059000},{"chapterId":"42692235120138953","chapterName":"Exam Pressures","chapterIndex":241,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579082569000},{"chapterId":"42735626654635724","chapterName":"Commotion","chapterIndex":242,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579244215000},{"chapterId":"42739570491581407","chapterName":"The Ministry of Magic","chapterIndex":243,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579258907000},{"chapterId":"42742799770108163","chapterName":"Blood","chapterIndex":244,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579270937000},{"chapterId":"42779186196172822","chapterName":"The Trap","chapterIndex":245,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579406487000},{"chapterId":"42783334866151879","chapterName":"The Fight","chapterIndex":246,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579421942000},{"chapterId":"42787472798704899","chapterName":"Stormy","chapterIndex":247,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579437357000},{"chapterId":"42792377382919465","chapterName":"The Sisters","chapterIndex":248,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579455628000},{"chapterId":"42807270987319397","chapterName":"Destroyer","chapterIndex":249,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579511111000},{"chapterId":"42810961437972267","chapterName":"The Glorious Battle","chapterIndex":250,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579524859000},{"chapterId":"42833604774002669","chapterName":"Neither Can Live. . .","chapterIndex":251,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579609212000},{"chapterId":"42836350331845462","chapterName":"The Great Four","chapterIndex":252,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579619440000},{"chapterId":"42854354297878346","chapterName":"Together","chapterIndex":253,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579686510000},{"chapterId":"42873601656930825","chapterName":"Umbridge's Destiny","chapterIndex":254,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579758212000},{"chapterId":"42898267939339014","chapterName":"The Past","chapterIndex":255,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1579850101000},{"chapterId":"42943067401024497","chapterName":"A New Beginning","chapterIndex":256,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580016992000}],"volumeId":4,"volumeName":"The Secret Behind Her Birth"},{"chapterItems":[{"chapterId":"42965071323782636","chapterName":"Plans and Problems","chapterIndex":257,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580098963000},{"chapterId":"42999682300966336","chapterName":"Love","chapterIndex":258,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580227899000},{"chapterId":"43037735727984144","chapterName":"Snape","chapterIndex":259,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580369659000},{"chapterId":"43062803019390618","chapterName":"Forgotten Birthday","chapterIndex":260,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580463043000},{"chapterId":"43080575325622302","chapterName":"Phlegm","chapterIndex":261,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580529249000},{"chapterId":"43106490906638630","chapterName":"Perfect Prefect","chapterIndex":262,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580625792000},{"chapterId":"43129676213829706","chapterName":"Deserted Diagon Alley","chapterIndex":263,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580712164000},{"chapterId":"43131969709590376","chapterName":"HEAVENLEIGH","chapterIndex":264,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580720708000},{"chapterId":"43134047953675740","chapterName":"Christina Creations","chapterIndex":265,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580728450000},{"chapterId":"43138614829303890","chapterName":"Cruel World","chapterIndex":266,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580745464000},{"chapterId":"43159929141386902","chapterName":"Compartment C","chapterIndex":267,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580824865000},{"chapterId":"43160470055613757","chapterName":"The Carriages","chapterIndex":268,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580826880000},{"chapterId":"43160875644803165","chapterName":"Slughorn and Snape","chapterIndex":269,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580828391000},{"chapterId":"43186008736453702","chapterName":"Busy Monday","chapterIndex":270,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1580922019000},{"chapterId":"43224226966062105","chapterName":"Surprise Test","chapterIndex":271,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1581064393000},{"chapterId":"43245549314430089","chapterName":"A Memory","chapterIndex":272,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1581143825000},{"chapterId":"43296816745209656","chapterName":"Adrian Rivers","chapterIndex":273,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1581334811000},{"chapterId":"43326061429179593","chapterName":"Play or Not to Play","chapterIndex":274,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1581443756000},{"chapterId":"43363768306032304","chapterName":"Confundus Charm","chapterIndex":275,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1581584225000},{"chapterId":"43382979409542349","chapterName":"A Sluggish Party","chapterIndex":276,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1581655792000},{"chapterId":"43410496476473546","chapterName":"Surprises and Surprises!","chapterIndex":277,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1581758301000},{"chapterId":"43428843771448772","chapterName":"Two Places at Once","chapterIndex":278,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1581826650000},{"chapterId":"43460469226264965","chapterName":"It's Alive?","chapterIndex":279,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1581944464000},{"chapterId":"43500121958185240","chapterName":"A Girl","chapterIndex":280,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1582092182000},{"chapterId":"43551184824360989","chapterName":"Kreacher's Story","chapterIndex":281,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1582282406000},{"chapterId":"43573354371799361","chapterName":"Guests","chapterIndex":282,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1582364994000},{"chapterId":"43616994460753429","chapterName":"Gleaming Heart","chapterIndex":283,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1582527566000},{"chapterId":"43650679352392077","chapterName":"A Bloody Memory","chapterIndex":284,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1582653052000},{"chapterId":"43732992132181045","chapterName":"The Flamels","chapterIndex":285,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1582959691000},{"chapterId":"43919106218447508","chapterName":"Approaching Christmas","chapterIndex":286,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1583653020000},{"chapterId":"43948021565681888","chapterName":"Fights","chapterIndex":287,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1583760738000},{"chapterId":"43992120410830276","chapterName":"Confusing Thoughts","chapterIndex":288,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1583925019000},{"chapterId":"44062091048437823","chapterName":"Fleur","chapterIndex":289,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1584185680000},{"chapterId":"44106369208478175","chapterName":"The Green Pond","chapterIndex":290,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1584350629000},{"chapterId":"44159542799429077","chapterName":"A Good Surprise and A Bad One","chapterIndex":291,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1584548716000},{"chapterId":"44172402451596966","chapterName":"Dumbledore's Man","chapterIndex":292,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1584596622000},{"chapterId":"44221798333602306","chapterName":"Keep Safe","chapterIndex":293,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1584780636000},{"chapterId":"44269424152206060","chapterName":"Trust","chapterIndex":294,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1584958057000},{"chapterId":"44290689340597144","chapterName":"Suspicious Thoughts","chapterIndex":295,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1585037275000},{"chapterId":"44341099656968090","chapterName":"Families","chapterIndex":296,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1585225068000},{"chapterId":"44384493036952061","chapterName":"Jealousy and Weirdness","chapterIndex":297,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1585386721000},{"chapterId":"44459348428113483","chapterName":"Deceiving","chapterIndex":298,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1585665579000},{"chapterId":"44549659242322867","chapterName":"Ron's Birthday","chapterIndex":299,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586002013000},{"chapterId":"44593146054627715","chapterName":"Commentary","chapterIndex":300,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586164014000},{"chapterId":"44600628139320362","chapterName":"Perfect Pretense","chapterIndex":301,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586191887000},{"chapterId":"44620674379085814","chapterName":"Seven","chapterIndex":302,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586266565000},{"chapterId":"44622831241199495","chapterName":"Platonic","chapterIndex":303,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586274600000},{"chapterId":"44624955119298333","chapterName":"Career Advice","chapterIndex":304,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586282512000},{"chapterId":"44637009465100014","chapterName":"The Blank Wall","chapterIndex":305,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586327418000},{"chapterId":"44658550873572606","chapterName":"O.W.L.s","chapterIndex":306,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586407666000},{"chapterId":"44669696045282004","chapterName":"Ginny's Secret","chapterIndex":307,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586449185000},{"chapterId":"44691239601237446","chapterName":"Trustworthy?","chapterIndex":308,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586529441000},{"chapterId":"44718027849122272","chapterName":"The Easiest Part","chapterIndex":309,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586629235000},{"chapterId":"44752387855935919","chapterName":"The First Danger","chapterIndex":310,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586757237000},{"chapterId":"44780978933130963","chapterName":"The Dark Mark","chapterIndex":311,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586863747000},{"chapterId":"44795940451705061","chapterName":"Truths and Lies","chapterIndex":312,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586919482000},{"chapterId":"44803754607828486","chapterName":"Not True","chapterIndex":313,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586948592000},{"chapterId":"44809926727485936","chapterName":"Losing Control","chapterIndex":314,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1586971585000},{"chapterId":"44821912118950112","chapterName":"Madness","chapterIndex":315,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1587016234000},{"chapterId":"44825052796996273","chapterName":"Breaking the News","chapterIndex":316,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1587027934000},{"chapterId":"44856113480394393","chapterName":"Replica","chapterIndex":317,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1587143644000},{"chapterId":"44890169618262339","chapterName":"The Wand","chapterIndex":318,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1587270513000},{"chapterId":"45006256678693138","chapterName":"The Funeral","chapterIndex":319,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1587702971000}],"volumeId":5,"volumeName":"Growing Darkness and Growing Powers"},{"chapterItems":[{"chapterId":"45319469316242601","chapterName":"A Little Girl and Her Saviour","chapterIndex":320,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1588869779000},{"chapterId":"45381769679132046","chapterName":"The Wizarding World","chapterIndex":321,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1589101866000},{"chapterId":"45424757201487954","chapterName":"> Yours Christina Norton","chapterIndex":322,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1589262007000},{"chapterId":"45551729319659699","chapterName":"Far Away","chapterIndex":323,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1589735015000},{"chapterId":"45828650037212738","chapterName":"Titian Forest","chapterIndex":324,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1590766625000},{"chapterId":"45897880598280352","chapterName":"The Vampires' Region","chapterIndex":325,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1591024529000},{"chapterId":"45946086505903436","chapterName":"Luxury","chapterIndex":326,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1591204110000},{"chapterId":"48115450881563839","chapterName":"Killed","chapterIndex":327,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1599285622000},{"chapterId":"48173070552194586","chapterName":"The Tea . . . Party?","chapterIndex":328,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1599500272000},{"chapterId":"48281286531409625","chapterName":"Anxiety","chapterIndex":329,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1599903408000},{"chapterId":"48516466609282840","chapterName":"Illusions","chapterIndex":330,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1600779522000},{"chapterId":"48636234976778611","chapterName":"The First Princess","chapterIndex":331,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1601225694000},{"chapterId":"48914658379233662","chapterName":"A Stroll . . .","chapterIndex":332,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1602262902000},{"chapterId":"49008028300661839","chapterName":". . . Through the Garden","chapterIndex":333,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1602610732000},{"chapterId":"49333028727604916","chapterName":"Secrets","chapterIndex":334,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1603821453000},{"chapterId":"49448935416185034","chapterName":"Watching","chapterIndex":335,"isVip":0,"isAuth":1,"publishTimeFormat":"4 years ago","chapterLevel":0,"userLevel":0,"publishTime":1604253239000},{"chapterId":"49609292029936989","chapterName":"A Little Spy","chapterIndex":336,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1604850614000},{"chapterId":"49812451784445699","chapterName":"The Challenge","chapterIndex":337,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1605607443000},{"chapterId":"50157785945534109","chapterName":"Midnight Duel","chapterIndex":338,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1606893913000},{"chapterId":"50443101143103664","chapterName":"Blue and Black","chapterIndex":339,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1607956795000},{"chapterId":"50668091679498426","chapterName":"A Feast","chapterIndex":340,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1608794950000},{"chapterId":"50887169086122701","chapterName":"Attention","chapterIndex":341,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1609611077000},{"chapterId":"51021605052141396","chapterName":"Gryffindor","chapterIndex":342,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1610111890000},{"chapterId":"51327212929994702","chapterName":"Lovers","chapterIndex":343,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1611250369000},{"chapterId":"51489726707858949","chapterName":"Family Issues and Secrets","chapterIndex":344,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1611855780000},{"chapterId":"51699430902004948","chapterName":"The Exception","chapterIndex":345,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1612637190000},{"chapterId":"52069571183567515","chapterName":"In Love","chapterIndex":346,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1614015868000},{"chapterId":"52501301027725047","chapterName":"The Connection","chapterIndex":347,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1615624187000},{"chapterId":"52765619203923117","chapterName":"Unexpected News","chapterIndex":348,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1616608849000},{"chapterId":"53018362476806966","chapterName":"Broken Resolve","chapterIndex":349,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1617550391000},{"chapterId":"53338667179113183","chapterName":"The Half-Blood","chapterIndex":350,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1618743620000},{"chapterId":"53612939747325119","chapterName":"The Stag","chapterIndex":351,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1619765364000},{"chapterId":"53970374710326087","chapterName":"A Familiar Face from the Past","chapterIndex":352,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1621096914000},{"chapterId":"54450847081352030","chapterName":"Recovery","chapterIndex":353,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1622886813000},{"chapterId":"54474176001536903","chapterName":"Prisoners","chapterIndex":354,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1622973720000},{"chapterId":"54525796928250388","chapterName":"Start Talking","chapterIndex":355,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1623166023000},{"chapterId":"54724859283954013","chapterName":"The Sick Queens","chapterIndex":356,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1623907588000},{"chapterId":"54802788512749794","chapterName":"The Dreams and Realities","chapterIndex":357,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1624197896000},{"chapterId":"54968130794999094","chapterName":"The Ones with Us","chapterIndex":358,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1624813845000},{"chapterId":"55038235935566522","chapterName":"The Will","chapterIndex":359,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1625075007000},{"chapterId":"55130373721475412","chapterName":"Believe","chapterIndex":360,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1625418246000},{"chapterId":"55199711656722634","chapterName":"Realization Face","chapterIndex":361,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1625676551000},{"chapterId":"55314753429492290","chapterName":"The First Goddess","chapterIndex":362,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1626105114000},{"chapterId":"55502886955696416","chapterName":"The Curse","chapterIndex":363,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1626805967000},{"chapterId":"55687642238472274","chapterName":"On Our Side","chapterIndex":364,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1627494233000},{"chapterId":"55802480268732568","chapterName":"Uncertainty","chapterIndex":365,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1627922038000},{"chapterId":"55828496227825267","chapterName":"The Snallygaster","chapterIndex":366,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1628018955000},{"chapterId":"55912671396029013","chapterName":"The Underground Temple","chapterIndex":367,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1628332533000},{"chapterId":"56059244402761197","chapterName":"Looking for Answers","chapterIndex":368,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1628878560000},{"chapterId":"56174844538058716","chapterName":"Fountain of Fair Fortune","chapterIndex":369,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1629309204000},{"chapterId":"56257819816555601","chapterName":"The Pool of Answers","chapterIndex":370,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1629618311000},{"chapterId":"56418570778771325","chapterName":"A Boy With Green Eyes","chapterIndex":371,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1630217154000},{"chapterId":"56776170275927464","chapterName":"Friends","chapterIndex":372,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1631549316000},{"chapterId":"56813848681824636","chapterName":"The Founders' Children","chapterIndex":373,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1631689680000},{"chapterId":"56893530810940522","chapterName":"Venomous","chapterIndex":374,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1631986519000},{"chapterId":"56962798952962587","chapterName":"The Explosion","chapterIndex":375,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1632244563000},{"chapterId":"57125116772934836","chapterName":"Deadly Pt1","chapterIndex":376,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1632849243000},{"chapterId":"57142504964809820","chapterName":"Deadly Pt2","chapterIndex":377,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1632914019000},{"chapterId":"57328708708525127","chapterName":"The Crown","chapterIndex":378,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1633607683000},{"chapterId":"57355222346947730","chapterName":"Like A Beating Heart","chapterIndex":379,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1633706454000},{"chapterId":"57515251201002048","chapterName":"The Unfortunate Night Pt 1","chapterIndex":380,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1634302608000},{"chapterId":"57539883106885021","chapterName":"The Unfortunate Night Pt 2","chapterIndex":381,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1634394369000},{"chapterId":"57702883843430683","chapterName":"The Vampire Family [Bonus chapter]","chapterIndex":382,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1635001610000},{"chapterId":"57703108255473009","chapterName":"A Little Paradise","chapterIndex":383,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1635002430000},{"chapterId":"57907581431104666","chapterName":"Stunning Secrets","chapterIndex":384,"isVip":0,"isAuth":1,"publishTimeFormat":"3 years ago","chapterLevel":0,"userLevel":0,"publishTime":1635764152000},{"chapterId":"58393789194097336","chapterName":"Loved Ones","chapterIndex":385,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1637575416000},{"chapterId":"59188306067389114","chapterName":"Found Her","chapterIndex":386,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1640535223000},{"chapterId":"59328362249771591","chapterName":"The Massacre","chapterIndex":387,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1641056972000},{"chapterId":"59509430017900811","chapterName":"Silver Stakes","chapterIndex":388,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1641731503000},{"chapterId":"59724988520912331","chapterName":"Raining Spells","chapterIndex":389,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1642534520000},{"chapterId":"59833280769353540","chapterName":"Sister's Sacrifice","chapterIndex":390,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1642937941000},{"chapterId":"60040982955094497","chapterName":"First Snow","chapterIndex":391,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1643711692000},{"chapterId":"60742839415401648","chapterName":"Burned","chapterIndex":392,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1646326311000},{"chapterId":"60743271059610965","chapterName":"Mother","chapterIndex":393,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1646327919000},{"chapterId":"61044181837085492","chapterName":"The Night Meeting","chapterIndex":394,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1647448899000},{"chapterId":"61160982382177504","chapterName":"The Wireless Connection","chapterIndex":395,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1647884015000},{"chapterId":"61532236419221150","chapterName":"Past and Present","chapterIndex":396,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1649267044000},{"chapterId":"61783382484374707","chapterName":"Going Back","chapterIndex":397,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1650202636000},{"chapterId":"62091877352004595","chapterName":"Life and Lies","chapterIndex":398,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1651351868000},{"chapterId":"62148537651091782","chapterName":"Lost","chapterIndex":399,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1651562945000},{"chapterId":"62275776057236605","chapterName":"Finding Him","chapterIndex":400,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1652036945000},{"chapterId":"62716725317140078","chapterName":"Godric's Hollow","chapterIndex":401,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1653679609000},{"chapterId":"63355422924399074","chapterName":"Perfect","chapterIndex":402,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1656058942000},{"chapterId":"64708894626208284","chapterName":"The Vampire","chapterIndex":403,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1661101018000},{"chapterId":"65219719229134436","chapterName":"Shell Cottage","chapterIndex":404,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1663003987000},{"chapterId":"65219802460902851","chapterName":"Familiar People","chapterIndex":405,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1663005337000},{"chapterId":"65939327309378099","chapterName":"Celebrate Now","chapterIndex":406,"isVip":0,"isAuth":1,"publishTimeFormat":"2 years ago","chapterLevel":0,"userLevel":0,"publishTime":1665684736000},{"chapterId":"68071050860097307","chapterName":"The Sunrise","chapterIndex":407,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1673768833000},{"chapterId":"68275775308099670","chapterName":"Heartbreak, Confusion and Looming Danger","chapterIndex":408,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1677048270000},{"chapterId":"68989110034954577","chapterName":"So Just One?","chapterIndex":409,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1679500886000},{"chapterId":"69906432371249953","chapterName":"Kindness and Unkindness","chapterIndex":410,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1680624380000},{"chapterId":"69949714098879284","chapterName":"The Boy Who Loved","chapterIndex":411,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1682183855000},{"chapterId":"70366015900416618","chapterName":"Bitter Smiles","chapterIndex":412,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1683400301000},{"chapterId":"70694856581771055","chapterName":"Towards the End","chapterIndex":413,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1683716373000},{"chapterId":"70779722971271941","chapterName":"Homecoming","chapterIndex":414,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1684504755000},{"chapterId":"71108743504387944","chapterName":"Brothers and Sisters","chapterIndex":415,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1685171793000},{"chapterId":"71136442016907862","chapterName":"Brothers and Sisters Pt.2","chapterIndex":416,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1685172524000},{"chapterId":"71169521066503990","chapterName":"Brothers and Sisters pt. 3","chapterIndex":417,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1685544352000},{"chapterId":"71270545928274038","chapterName":"A Different Hogwarts","chapterIndex":418,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1685950826000},{"chapterId":"71379149293412537","chapterName":"The Lost Diadem","chapterIndex":419,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1686121525000},{"chapterId":"71425752356148916","chapterName":"The Carrows","chapterIndex":420,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1686638574000},{"chapterId":"71555555126198495","chapterName":"Wait is Over","chapterIndex":421,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1687210578000},{"chapterId":"71717652560673938","chapterName":"Flight of Snape","chapterIndex":422,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1687610539000},{"chapterId":"71825073199177767","chapterName":"We Are Fighting","chapterIndex":423,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1687962805000},{"chapterId":"71918080967626049","chapterName":"The Battle of Hogwarts Pt. 1","chapterIndex":424,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1688026261000},{"chapterId":"71926604883871687","chapterName":"The Battle of Hogwarts Pt. 2","chapterIndex":425,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1688243018000},{"chapterId":"72106763461122226","chapterName":"Charming Boys","chapterIndex":426,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1689232733000},{"chapterId":"72260456181456459","chapterName":"New Problems","chapterIndex":427,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1690475003000},{"chapterId":"72593937826639162","chapterName":"The War of Magic","chapterIndex":428,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1691523574000},{"chapterId":"72875552138127664","chapterName":"Witches and Monsters","chapterIndex":429,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1691843521000},{"chapterId":"72961280222229706","chapterName":"Death","chapterIndex":430,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1692738480000},{"chapterId":"73201599211698719","chapterName":"Her Monsters","chapterIndex":431,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1692809848000},{"chapterId":"73220861334707777","chapterName":"We Lost Again","chapterIndex":432,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1694806831000},{"chapterId":"73893078997464221","chapterName":"Loss, Grief and Determination","chapterIndex":433,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1695400642000},{"chapterId":"73916181911748937","chapterName":"Recovering","chapterIndex":434,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1697228911000},{"chapterId":"74406503196457725","chapterName":"Blood Traitor","chapterIndex":435,"isVip":0,"isAuth":1,"publishTimeFormat":"1 years ago","chapterLevel":0,"userLevel":0,"publishTime":1698870852000},{"chapterId":"74842034891978023","chapterName":"The Start of The End (Part1)","chapterIndex":436,"isVip":0,"isAuth":1,"publishTimeFormat":"11 months ago","chapterLevel":0,"userLevel":0,"publishTime":1700157787000},{"chapterId":"75193202289727111","chapterName":"The Start of The End (Part 2)","chapterIndex":437,"isVip":0,"isAuth":1,"publishTimeFormat":"11 months ago","chapterLevel":0,"userLevel":0,"publishTime":1701292561000},{"chapterId":"75445041857873353","chapterName":"Always","chapterIndex":438,"isVip":0,"isAuth":1,"publishTimeFormat":"10 months ago","chapterLevel":0,"userLevel":0,"publishTime":1703439647000},{"chapterId":"76074209469592430","chapterName":"Ready for The End","chapterIndex":439,"isVip":0,"isAuth":1,"publishTimeFormat":"10 months ago","chapterLevel":0,"userLevel":0,"publishTime":1704563608000},{"chapterId":"76375653762522934","chapterName":"Nothing","chapterIndex":440,"isVip":0,"isAuth":1,"publishTimeFormat":"9 months ago","chapterLevel":0,"userLevel":0,"publishTime":1705257050000},{"chapterId":"76702981944295899","chapterName":"Ginny and Draco Pt 1","chapterIndex":441,"isVip":0,"isAuth":1,"publishTimeFormat":"9 months ago","chapterLevel":0,"userLevel":0,"publishTime":1705872185000},{"chapterId":"76879589657335522","chapterName":"Ginny and Draco Pt2","chapterIndex":442,"isVip":0,"isAuth":1,"publishTimeFormat":"9 months ago","chapterLevel":0,"userLevel":0,"publishTime":1706636181000},{"chapterId":"76932176834264455","chapterName":"Ginny and Draco Pt3","chapterIndex":443,"isVip":0,"isAuth":1,"publishTimeFormat":"9 months ago","chapterLevel":0,"userLevel":0,"publishTime":1706728474000},{"chapterId":"77186750685961550","chapterName":"They Won and We Lost","chapterIndex":444,"isVip":0,"isAuth":1,"publishTimeFormat":"8 months ago","chapterLevel":0,"userLevel":0,"publishTime":1707645738000},{"chapterId":"77389558907467640","chapterName":"The First Light","chapterIndex":445,"isVip":0,"isAuth":1,"publishTimeFormat":"8 months ago","chapterLevel":0,"userLevel":0,"publishTime":1708341819000},{"chapterId":"77601846927095480","chapterName":"987 Years","chapterIndex":446,"isVip":0,"isAuth":1,"publishTimeFormat":"8 months ago","chapterLevel":0,"userLevel":0,"publishTime":1709131401000},{"chapterId":"78091055110615056","chapterName":"Taking Everything Back","chapterIndex":447,"isVip":0,"isAuth":1,"publishTimeFormat":"7 months ago","chapterLevel":0,"userLevel":0,"publishTime":1710953455000},{"chapterId":"78719169381591299","chapterName":"The Turned Tables","chapterIndex":448,"isVip":0,"isAuth":1,"publishTimeFormat":"6 months ago","chapterLevel":0,"userLevel":0,"publishTime":1713293381000},{"chapterId":"79322649464993745","chapterName":"Mothers","chapterIndex":449,"isVip":0,"isAuth":1,"publishTimeFormat":"5 months ago","chapterLevel":0,"userLevel":0,"publishTime":1715541499000},{"chapterId":"79645274523358966","chapterName":"Show Some Respect","chapterIndex":450,"isVip":0,"isAuth":1,"publishTimeFormat":"5 months ago","chapterLevel":0,"userLevel":0,"publishTime":1716743392000},{"chapterId":"79685452734449026","chapterName":"The END","chapterIndex":451,"isVip":0,"isAuth":1,"publishTimeFormat":"5 months ago","chapterLevel":0,"userLevel":0,"publishTime":1716894047000},{"chapterId":"80664888887790589","chapterName":"From Author","chapterIndex":452,"isVip":0,"isAuth":1,"publishTimeFormat":"3 months ago","chapterLevel":0,"userLevel":0,"publishTime":1720541736000},{"chapterId":"80780146482673899","chapterName":"Back to the Beginning","chapterIndex":453,"isVip":0,"isAuth":1,"publishTimeFormat":"3 months ago","chapterLevel":0,"userLevel":0,"publishTime":1720971100000},{"chapterId":"81663753157929816","chapterName":"Albus Percival Wulfric Brian Dumbledore","chapterIndex":454,"isVip":0,"isAuth":1,"publishTimeFormat":"2 months ago","chapterLevel":0,"userLevel":0,"publishTime":1724264048000},{"chapterId":"81917451943602970","chapterName":"Red, Blue, Green and Yellow","chapterIndex":455,"isVip":0,"isAuth":1,"publishTimeFormat":"2 months ago","chapterLevel":0,"userLevel":0,"publishTime":1725210216000},{"chapterId":"82288006286866508","chapterName":"Forgiveness","chapterIndex":456,"isVip":0,"isAuth":1,"publishTimeFormat":"1 months ago","chapterLevel":0,"userLevel":0,"publishTime":1726589686000},{"chapterId":"82777660207461251","chapterName":"Trapped and Bloody","chapterIndex":457,"isVip":0,"isAuth":1,"publishTimeFormat":"27 days ago","chapterLevel":0,"userLevel":0,"publishTime":1728414800000},{"chapterId":"83216159456947112","chapterName":"Irony","chapterIndex":458,"isVip":0,"isAuth":1,"publishTimeFormat":"8 days ago","chapterLevel":0,"userLevel":0,"publishTime":1730048090000},{"chapterId":"83411143053340891","chapterName":"Evil and Greater Evil","chapterIndex":459,"isVip":0,"isAuth":1,"publishTimeFormat":"4 hours ago","chapterLevel":0,"userLevel":0,"publishTime":1730776460000}],"volumeId":6,"volumeName":"The Last Attempt and The Last Sacrifice"}]
     */
    volumeItems?: {
      /**
       * [{"chapterId":"37354371129862036","chapterName":"Best Birthday Ever","chapterIndex":1,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559197476000},{"chapterId":"37362598408151977","chapterName":"Ginevra","chapterIndex":2,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559228125000},{"chapterId":"37380731760066691","chapterName":"A Wand","chapterIndex":3,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559295677000},{"chapterId":"37387743294183009","chapterName":"Missing Boys","chapterIndex":4,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559321798000},{"chapterId":"37405118030737586","chapterName":"The Sorting Ceremony","chapterIndex":5,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559386523000},{"chapterId":"37413968347720556","chapterName":"Dumbledore","chapterIndex":6,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559419493000},{"chapterId":"37430592018639834","chapterName":"A Howler","chapterIndex":7,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559481421000},{"chapterId":"37459038140687513","chapterName":"Signed Photos","chapterIndex":8,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559587391000},{"chapterId":"37475279559521598","chapterName":"Quidditch Field","chapterIndex":9,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559647895000},{"chapterId":"37502484419235969","chapterName":"Slytherins","chapterIndex":10,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559749241000},{"chapterId":"37528030599504660","chapterName":"A Slytherin Boy","chapterIndex":11,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559844408000},{"chapterId":"37551958399184242","chapterName":"A Party","chapterIndex":12,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559933546000},{"chapterId":"37567820803916255","chapterName":"A Party pt. 2","chapterIndex":13,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1559992638000},{"chapterId":"37574475855755527","chapterName":"Mrs. Norris","chapterIndex":14,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560017430000},{"chapterId":"37597278642437576","chapterName":"Squib","chapterIndex":15,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560102377000},{"chapterId":"37613430387033802","chapterName":"The Chamber of Secrets","chapterIndex":16,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560162547000},{"chapterId":"37635687712881425","chapterName":"Potions Class","chapterIndex":17,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560245462000},{"chapterId":"37658562725473170","chapterName":"The First Match","chapterIndex":18,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560330678000},{"chapterId":"37666202398542995","chapterName":"Attack","chapterIndex":19,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560359138000},{"chapterId":"37679946545550944","chapterName":"It Can't Wait","chapterIndex":20,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1560410339000},{"chapterId":"39902778147009622","chapterName":"Preparations","chapterIndex":21,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568691032000},{"chapterId":"39902802306187541","chapterName":"Parseltongue","chapterIndex":22,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568691122000},{"chapterId":"39902828361219931","chapterName":"The Dueling Club","chapterIndex":23,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568691219000},{"chapterId":"39902847671781520","chapterName":"Ghostly Incident","chapterIndex":24,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568691291000},{"chapterId":"39902865136877561","chapterName":"Headmaster's Office","chapterIndex":25,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568691356000},{"chapterId":"39902886880133503","chapterName":"Malfoy","chapterIndex":26,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568691437000},{"chapterId":"39932392751823915","chapterName":"A Diary","chapterIndex":27,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568801355000},{"chapterId":"39938618038472965","chapterName":"Valentine's Day","chapterIndex":28,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568824546000},{"chapterId":"39938653757164543","chapterName":"Fifty Years Ago","chapterIndex":29,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568824679000},{"chapterId":"39962736444106610","chapterName":"Memory","chapterIndex":30,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568914394000},{"chapterId":"39972916590334886","chapterName":"Confrontation","chapterIndex":31,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568952318000},{"chapterId":"39972927327753164","chapterName":"Mystery","chapterIndex":32,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568952358000},{"chapterId":"39982072906967881","chapterName":"A Dagger","chapterIndex":33,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568986428000},{"chapterId":"39982115873415566","chapterName":"The Chamber","chapterIndex":34,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568986588000},{"chapterId":"39982330353349171","chapterName":"The Basilisk","chapterIndex":35,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568987387000},{"chapterId":"39982604962813577","chapterName":"The Sword","chapterIndex":36,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568988410000},{"chapterId":"39983065061184917","chapterName":"A Key","chapterIndex":37,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568990124000},{"chapterId":"39983626611387588","chapterName":"First Year Ends","chapterIndex":38,"isVip":0,"isAuth":1,"publishTimeFormat":"5 years ago","chapterLevel":0,"userLevel":0,"publishTime":1568992216000}]
       */
      chapterItems?: {
        /**
         * "37354371129862036"
         */
        chapterId?: string;
        /**
         * "Best Birthday Ever"
         */
        chapterName?: string;
        /**
         * 1
         */
        chapterIndex?: number;
        isVip?: number;
        /**
         * 1
         */
        isAuth?: number;
        /**
         * "5 years ago"
         */
        publishTimeFormat?: string;
        chapterLevel?: number;
        userLevel?: number;
        /**
         * 1559197476000
         */
        publishTime?: number;
      }[];
      /**
       * 1
       */
      volumeId?: number;
      /**
       * "The Journey Begins"
       */
      volumeName?: string;
    }[];
  };
  /**
   * [{"content":"Would you accept a Harry Potter/ avengers MCU Fanfiction challenge, or a Harry Potter/ Game of thrones fanfiction challenge ?\r\n\r\n\r\n———————————————-———————————————-———————————————-———————————————-———————————————-\r\n———————————————-———————————————-———————————————-———————————————-———————————————-\r\n———————————————-———————————————-———————————————-———————————————-———————————————-","userId":4309541542,"userName":"Tim_Barney","headImageId":0,"createTime":1593364826000,"bookInfo":{"bookId":"16380484005743805","bookName":"Cultivator in the MCU","checkLevel":15,"authorName":"Phoenixrd","bookType":0,"categoryName":"Action","categoryId":70012,"score":"3.940000057220459","totalChapterNum":36,"pvNum":0,"coverId":1583859923593}},{"content":"Be sure to read this awesome Harry Potter fanfic. Be sure to read this awesome Harry Potter fanfic. Be sure to read this awesome Harry Potter fanfiction.","userId":4317964586,"userName":"Selectials","headImageId":1642695303449,"createTime":1639643167000,"bookInfo":{"bookId":"21960061705445205","bookName":"Harry Potter Cousins","checkLevel":15,"authorName":"Selectials","bookType":0,"categoryName":"Book&Literature","categoryId":81001,"score":0,"totalChapterNum":56,"pvNum":0,"coverId":1639642932007}},{"content":"Surprisingly nice for a Harry Potter fanfiction,  I've read so many of those that I've become intolerant to their classic tropes, like \"children marriage\" or \"forced to come in hoggward\"\n\nFor now the story has started pretty well.","userId":4304808592,"userName":"RuberDF","headImageId":1708010897336,"createTime":1623689417000,"bookInfo":{"bookId":"19734319605086005","bookName":"Harry Potter and the Tragic Path","checkLevel":15,"authorName":"Niggross","bookType":0,"categoryName":"Book&Literature","categoryId":81001,"score":"4.420000076293945","totalChapterNum":129,"pvNum":0,"coverId":1622053027061}},{"content":"Well, I am not complaining, but Harry Potter world is not much of a fanfiction story material. It's boring. Just skip the Harry Potter vers and go somewhere else.","userId":4322378086,"userName":"Durjoy_Jack","headImageId":1662545902121,"createTime":1692897068000,"bookInfo":{"bookId":"27062952805230305","bookName":"Multiverse's Ghost Rider","checkLevel":15,"authorName":"TheMightyZeus","bookType":0,"categoryName":"Movies","categoryId":81007,"score":"4.46999979019165","totalChapterNum":182,"pvNum":0,"coverId":1690671468244}}]
   */
  relationReviews?: {
    /**
     * "Would you accept a Harry Potter/ avengers MCU Fanfiction challenge, or a Harry Potter/ Game of thrones fanfiction challenge ?\r\n\r\n\r\n———————————————-———————————————-———————————————-———————————————-———————————————-\r\n———————————————-———————————————-———————————————-———————————————-———————————————-\r\n———————————————-———————————————-———————————————-———————————————-———————————————-"
     */
    content?: string;
    /**
     * 4309541542
     */
    userId?: number;
    /**
     * "Tim_Barney"
     */
    userName?: string;
    headImageId?: number;
    /**
     * 1593364826000
     */
    createTime?: number;
    bookInfo?: {
      /**
       * "16380484005743805"
       */
      bookId?: string;
      /**
       * "Cultivator in the MCU"
       */
      bookName?: string;
      /**
       * 15
       */
      checkLevel?: number;
      /**
       * "Phoenixrd"
       */
      authorName?: string;
      bookType?: number;
      /**
       * "Action"
       */
      categoryName?: string;
      /**
       * 70012
       */
      categoryId?: number;
      /**
       * "3.940000057220459"
       */
      score?: string;
      /**
       * 36
       */
      totalChapterNum?: number;
      pvNum?: number;
      /**
       * 1583859923593
       */
      coverId?: number;
    };
  }[];
  recommendInfo?: {
    /**
     * "harry potter forced blowjob fanfiction"
     */
    title?: string;
    /**
     * [{"bookId":"17719009305516905","name":"Attuoria | Harry Potter Fanfiction","itemType":0,"description":"Never before had a demon or angel from the spiritual dimension entered the mortal realm. Not until her. Attuoria receives a request for help from a certain Dark Wizard, and finds herself in a world of wizards and witches. She is sent to gather information on a boy named Harry Potter at Hogwarts School of Witchcraft and Wizardry. But what started out as a mission soon turned into a journey of friendship, love, and humanity. The future of the wizarding world now rested in her hands: to betray, or not?\n\n“I don’t think there is any way of stopping her, Albus. She could change everything.”\n“Then I think we both know what we should do.”\n\n{Golden Era}\n[ps, ootp-dh]\nupdates every weekend\n+ coming-of-age story +\n\nAvailable on Wattpad and Quotev","categoryId":81001,"categoryName":"Book&Literature","authorName":"sayhellotohanna","score":0,"coverId":1597233771656,"translateMode":-1},{"bookId":"19337489706185205","name":"Harry Potter: New World","itemType":0,"description":"It is enough just to be in the wrong place at the wrong time. Whether a series of accidents, or a coincidence, but now I have to be reborn in a completely different world.\r\nA forced entity that controls the flows of souls in one of the branches of the worlds, contrary to its desire and dislikes for \"anomalies\", is obliged to give out powers and bonuses - these are the rules.\r\nWhat will life be like for someone who was not destined to survive?\r\n\r\nIf you want to support me or read ahead: https://www.patreon.com/HPMan\r\n\r\nAt least one chapter every day!","categoryId":81007,"categoryName":"Movies","authorName":"HPMan","score":4.4,"coverId":1614003965259,"translateMode":-1},{"bookId":"20565748805514205","name":"Harry Potter: Dimensional Wizard","itemType":0,"description":"Edward was reincarnated into the world of Harry Potter, an act which excites him giving the fact that this was one of his favorite books. So, he embarks on the path of wizardry in the hope of discovering the way it works, the laws or theories that govern it; he wanted to find its essence.\nWhen Edward finally uncovers the answers to the question he pondered on, he suddenly thought to himself: \"Since the world of Harry Potter is real, what about all the other anime, movies, games, and books that I read from my past life? And if they are indeed real, how I can I get there?\"\n\nThis story is an Infinite Stream novel where the mc travels through different anime and movie worlds acquiring various magical abilities and knowledge in order to become a supreme wizard that stands on the top of countless dimensions and universes.\n\nThis is a wish-fulfillment and Mary Sue novel so read at your own risk, and stop complaining about it.\n\nThis is not a villain story, more like a morally gray one.\n\nWarnings: The MC will spend a great deal of time in the Harry Potter World before going to other worlds.\nI have not decided whether the [Curse Child] is canon or not. I do not care what JK Rowling said.\nAlthough this fanfic will be a Harem, the mc will not have a thousand women. Most likely, I will write so that he has a certain relationship with some female characters, then he will leave her in her own universe. Only a few will follow him in his journey. Also, a few men will also be in his group. THIS IS NOT A YAOI.\n\nIf you enjoy my writing, please go read my other novel. [Journey of the Fate Destroying Emperor] Although the story is slow in the beginning, it is worth the wait for the later plots. \n\nAlso published on royalroad.com\n\nGo check out my Pa.tr.eon:\n.https://www.patreon.com/LazySageDao\nOr just go into the site and search for my author name (LazySageDao). So, go and support me if you can.\n\nDiscord: https://discord.gg/bnsezTApeY\n\nDisclaimer: All the characters in this novel belong to JK Rowling, and I'm just using them to write my own story.\nIf the creator of the cover wants me to remove it, comment so in one of the newest chapters.","categoryId":81001,"categoryName":"Book&Literature","authorName":"LazySageDao","score":4.4,"coverId":1625703515057,"translateMode":-1}]
     */
    contentItems?: {
      /**
       * "17719009305516905"
       */
      bookId?: string;
      /**
       * "Attuoria | Harry Potter Fanfiction"
       */
      name?: string;
      itemType?: number;
      /**
       * "Never before had a demon or angel from the spiritual dimension entered the mortal realm. Not until her. Attuoria receives a request for help from a certain Dark Wizard, and finds herself in a world of wizards and witches. She is sent to gather information on a boy named Harry Potter at Hogwarts School of Witchcraft and Wizardry. But what started out as a mission soon turned into a journey of friendship, love, and humanity. The future of the wizarding world now rested in her hands: to betray, or not?\n\n“I don’t think there is any way of stopping her, Albus. She could change everything.”\n“Then I think we both know what we should do.”\n\n{Golden Era}\n[ps, ootp-dh]\nupdates every weekend\n+ coming-of-age story +\n\nAvailable on Wattpad and Quotev"
       */
      description?: string;
      /**
       * 81001
       */
      categoryId?: number;
      /**
       * "Book&Literature"
       */
      categoryName?: string;
      /**
       * "sayhellotohanna"
       */
      authorName?: string;
      score?: number;
      /**
       * 1597233771656
       */
      coverId?: number;
      /**
       * -1
       */
      translateMode?: number;
    }[];
  };
  /**
   * [{"id":1589,"lang":"en","searchWord":"perfex test"},{"id":1603,"lang":"en","searchWord":"takuma ino"},{"id":3225,"lang":"en","searchWord":"cerita hidup"},{"id":6054,"lang":"en","searchWord":"zayn imagines"},{"id":6212,"lang":"en","searchWord":"prime evils diablo"},{"id":6411,"lang":"en","searchWord":"emoji oh my god"},{"id":7606,"lang":"en","searchWord":"naruto game hentai"},{"id":7744,"lang":"en","searchWord":"words to white wedding"},{"id":7865,"lang":"en","searchWord":"read kingdom manga"},{"id":8097,"lang":"en","searchWord":"the love doctor manga"}]
   */
  popularSearches?: {
    /**
     * 1589
     */
    id?: number;
    /**
     * "en"
     */
    lang?: string;
    /**
     * "perfex test"
     */
    searchWord?: string;
  }[];
  /**
   * [{"topicId":345219126015122,"lang":"","topicName":"harry potter forced to be a baby fanfiction"},{"topicId":345219129001064,"lang":"","topicName":"harry potter forced handjob fanfiction"},{"topicId":345219129676844,"lang":"","topicName":"forced betrothal harry potter fanfiction"},{"topicId":345219132861492,"lang":"","topicName":"harry potter forced marriage fanfiction"},{"topicId":345219142538296,"lang":"","topicName":"harry potter forced sex fanfiction"},{"topicId":345219171026021,"lang":"","topicName":"harry potter forced by ginny fanfiction"},{"topicId":345219171513440,"lang":"","topicName":"harry potter forced orgasm fanfiction"},{"topicId":345218965677157,"lang":"","topicName":"harry potter is forced to orgasm fanfiction"},{"topicId":345218964931674,"lang":"","topicName":"harry potter forced threesome fanfiction"},{"topicId":345218949770301,"lang":"","topicName":"harry potter forced to marry fanfiction"}]
   */
  relationTopics?: {
    /**
     * 345219126015122
     */
    topicId?: number;
    lang?: string;
    /**
     * "harry potter forced to be a baby fanfiction"
     */
    topicName?: string;
  }[];
  /**
   * [{"askInfo":{"aid":350532097959035,"title":"Forced Betrothal in Harry Potter Fanfiction: An Exploration","desc":"","answerCount":1,"showTime":1729765836915},"answerInfos":[{"answerId":350532097959036,"aid":350532097959035,"marked":0,"text":"Well, forced betrothal in Harry Potter fanfiction can really change the whole tone of the story. It often brings in elements of angst and conflict. For instance, if Harry was...","showTime":1729777019000}]},{"askInfo":{"aid":350531656377502,"title":"How can 'Harry Potter Bound and Forced' fanfiction contribute to the overall 'Harry Potter' fandom?","desc":"","answerCount":3,"showTime":1730246444469},"answerInfos":[{"answerId":350531656377503,"aid":350531656377502,"marked":0,"text":"It can add new perspectives. For example, when characters are bound or forced in a fanfiction, it shows different sides of their personalities. This enriches the understanding of the characters...","showTime":1730254218000}]},{"askInfo":{"aid":351563288755325,"title":"Is there any good 'Harry Potter Forced Marriage' slash fanfiction?","desc":"","answerCount":2,"showTime":1730501896491},"answerInfos":[{"answerId":351563288755326,"aid":351563288755325,"marked":0,"text":"Yes, there are some. But keep in mind that fanfiction varies greatly in quality. Some might focus on exploring the complex relationships within the forced - marriage scenario in a...","showTime":1730517750000}]},{"askInfo":{"aid":350532097959037,"title":"How Does Forced Betrothal Work in Harry Potter Fanfiction?","desc":"","answerCount":2,"showTime":1729759109877},"answerInfos":[{"answerId":350532097959038,"aid":350532097959037,"marked":0,"text":"Forced betrothal can also be a result of a magical curse or prophecy in some fanfictions. The characters are then bound by this magical force to get married. It creates...","showTime":1729771491000}]},{"askInfo":{"aid":345715310355664,"title":"In a Harry Potter fanfic, how could Lily Potter win a blowjob competition?","desc":"","answerCount":2,"showTime":1728063001636},"answerInfos":[{"answerId":345715310355665,"aid":345715310355664,"marked":0,"text":"This is a rather unusual and inappropriate premise for a Harry Potter fanfic. Fanfics usually focus on creative and respectful storylines within the established magical world.","showTime":1728079321000}]},{"askInfo":{"aid":351563288755328,"title":"What are the common themes in 'Harry Potter Forced Marriage' slash fanfiction?","desc":"","answerCount":2,"showTime":1730500112451},"answerInfos":[{"answerId":351563288755329,"aid":351563288755328,"marked":0,"text":"Well, power struggle is a very common theme. In a forced marriage situation in Harry Potter fanfiction, there are often different factions or families with different levels of power involved....","showTime":1730507710000}]},{"askInfo":{"aid":350531895256157,"title":"What are the negative impacts of 'Harry Potter Gay Forced Slash Fanfiction'?","desc":"","answerCount":1,"showTime":1729949209900},"answerInfos":[{"answerId":350531895256158,"aid":350531895256157,"marked":0,"text":"One negative impact is that it can alienate the original fan base. Many fans love the story as it was originally written and may not appreciate such forced interpretations. Another...","showTime":1729952970000}]},{"askInfo":{"aid":350532102909015,"title":"Is 'Harry Potter Forced Underage Sex Fanfiction' appropriate and why should it be condemned?","desc":"","answerCount":1,"showTime":1730076750633},"answerInfos":[{"answerId":350532102909016,"aid":350532102909015,"marked":0,"text":"It is highly inappropriate. The Harry Potter series is a beloved story for many, with themes of friendship, courage, and good versus evil. Forced underage sex fanfiction is a perversion...","showTime":1730076950000}]},{"askInfo":{"aid":350532151278659,"title":"What are the negative impacts of 'birthday blowjob harry potter adult fan fiction'?","desc":"","answerCount":3,"showTime":1729814597696},"answerInfos":[{"answerId":350532151278660,"aid":350532151278659,"marked":0,"text":"One negative impact is that it can be very offensive to fans who enjoy the original Harry Potter for its family - friendly and positive themes. It also gives a...","showTime":1729817763000}]},{"askInfo":{"aid":351563158349007,"title":"Is there a 'Harry Potter Forced to Sit on Man's Lap' fanfiction that is appropriate for all ages?","desc":"","answerCount":1,"showTime":1730593202447},"answerInfos":[{"answerId":351563158349008,"aid":351563158349007,"marked":0,"text":"Yes, it's possible. There are many different interpretations in fanfiction. Maybe in this particular fanfic, the 'forced' part isn't as sinister as it sounds. It could be that a magical...","showTime":1730605616000}]}]
   */
  relationAsks?: {
    askInfo?: {
      /**
       * 350532097959035
       */
      aid?: number;
      /**
       * "Forced Betrothal in Harry Potter Fanfiction: An Exploration"
       */
      title?: string;
      desc?: string;
      /**
       * 1
       */
      answerCount?: number;
      /**
       * 1729765836915
       */
      showTime?: number;
    };
    /**
     * [{"answerId":350532097959036,"aid":350532097959035,"marked":0,"text":"Well, forced betrothal in Harry Potter fanfiction can really change the whole tone of the story. It often brings in elements of angst and conflict. For instance, if Harry was...","showTime":1729777019000}]
     */
    answerInfos?: {
      /**
       * 350532097959036
       */
      answerId?: number;
      /**
       * 350532097959035
       */
      aid?: number;
      marked?: number;
      /**
       * "Well, forced betrothal in Harry Potter fanfiction can really change the whole tone of the story. It often brings in elements of angst and conflict. For instance, if Harry was..."
       */
      text?: string;
      /**
       * 1729777019000
       */
      showTime?: number;
    }[];
  }[];
  /**
   * [{"bookId":"148056517471750505","name":"The Rebirth of a Concubine's Daughter","shortName":"","originalName":"庶女重生手札","description":"Ling Yinke was the daughter of Huang Shang, the wealthiest man in the Great Chen Kingdom.\nHer stepmother's framing caused her mother to run into a pillar and die with her unborn brother. She fell from being a proud son of heaven to the clouds.\nHer father's neglect had made it difficult for her to move forward and she had suffered.\nHis bloodline was noble, but he was in the same boat as her. He told her,\"Ah Ke, I will never betray you!\"\nShe had helped him become the most respected person in the world, but after he ascended to that noble position, she had been ruthlessly stabbed by him!\nShe gritted her teeth in hatred, but she was helpless. She did not want the heavens to drop a curtain and let her live again.\nWhen one's life was restarted, everything was confusing.\nThe noblest man in the Great Chen Kingdom frequently appeared in her line of sight.\nHe crossed mountains and ridges just to let her gain her father's appreciation, he sent her gold and silver just to solve her urgent needs, he taught her the way of being a person, taught her the method of disciplining others, she was confused and confused;\nLove, hate, love, hatred, past life, this life, which one was real?\n  ","categoryType":1,"categoryId":70015,"subcategoryId":0,"categoryName":"History","subcategoryName":"","authorId":"14194848503402901","authorName":"Lilantai","sourceType":1,"status":30,"checkLevel":15,"checkTime":1626419823000,"vipStatus":-1,"vipTime":1722932217000,"wordCount":9144,"unitPrice":0,"translation":{"translators":null,"editors":null,"groups":null},"essayIds":null,"createTime":1722932217000,"updateTime":1730562552000,"totalChapterCount":5,"beforeChapterCount":0,"contentChapterCount":9144,"lastChapterId":0,"lastChapterName":"","lastChapterTime":0,"scheduleUpdateFrequency":0,"scheduleUpdateFrequencyUnit":0,"ageGroup":0,"language":1,"expected":0,"sex":-1,"updateFrequency":0,"updateFrequencyUnit":0,"ageGroupDescription":"","firstChapterId":0,"languageName":"","signType":0,"filter":{"blackCountries":"","whiteCountries":""},"signed":0,"nextChapterTime":0,"translateMode":0,"words":"","serialStartTime":0,"shield":0,"site":0,"form":0,"sideStoryType":0,"editorRecommendation":"","noGift":false,"auditStatus":0,"transChannel":0,"cpid":0,"scbid":0,"acbid":0,"chargeChapterStartIndex":0,"vipChapterWordsCount":0,"pvNum":1446,"coverUrl":"https://book-pic.webnovel.com/novelcover/148056517471750505?imageMogr2/format/webp&imageMogr2/thumbnail/180x"},{"bookId":"148070508079825405","name":"The Beacon Smoke of Jiuzhou","shortName":"","originalName":"九州烽烟记","description":"The fierce battle between dragons and tigers had been going on since ancient times. Pondering and judging talents, how much is right and wrong, success and failure. Rich and noble singing and dancing pavilions, seek the king's hegemony and war. All kinds of things turn back to dust, only the green mountains do not change.","categoryType":1,"categoryId":70003,"subcategoryId":0,"categoryName":"History","subcategoryName":"","authorId":"19055788808994201","authorName":"Fu Jiangshan","sourceType":1,"status":30,"checkLevel":15,"checkTime":1672551251000,"vipStatus":-1,"vipTime":1723000530000,"wordCount":12937,"unitPrice":0,"translation":{"translators":null,"editors":null,"groups":null},"essayIds":null,"createTime":1723000530000,"updateTime":1729644249000,"totalChapterCount":5,"beforeChapterCount":0,"contentChapterCount":12937,"lastChapterId":0,"lastChapterName":"","lastChapterTime":0,"scheduleUpdateFrequency":0,"scheduleUpdateFrequencyUnit":0,"ageGroup":0,"language":1,"expected":0,"sex":-1,"updateFrequency":0,"updateFrequencyUnit":0,"ageGroupDescription":"","firstChapterId":0,"languageName":"","signType":0,"filter":{"blackCountries":"","whiteCountries":""},"signed":0,"nextChapterTime":0,"translateMode":0,"words":"","serialStartTime":0,"shield":0,"site":0,"form":0,"sideStoryType":0,"editorRecommendation":"","noGift":false,"auditStatus":0,"transChannel":0,"cpid":0,"scbid":0,"acbid":0,"chargeChapterStartIndex":0,"vipChapterWordsCount":0,"pvNum":7561,"coverUrl":"https://book-pic.webnovel.com/novelcover/148070508079825405?imageMogr2/format/webp&imageMogr2/thumbnail/180x"},{"bookId":"148070561505792305","name":"Tyrant's Salted Fish Concubine is a spoiled brat","shortName":"","originalName":"暴君的咸鱼娇妃是个撒娇精","description":"\"Emperor, ChenQie doesn't want to eat alone. Can ChenQie come with you?\"\n\"Emperor, it's too dark. Chenqie is afraid. Can Chenqie stay?\"\n……\nThe stubborn tyrant was surprised to find that the little Jiao Fei who only wanted to leave the palace all day had suddenly become a little demon who tortured people.\nAt the same time, the other concubines in the palace also discovered that Consort Xiao Shu, who did not want to compete for favor, began to work hard to compete with them.\nToday, he discovered that Consort Xiao Shu had personally stewed a nourishing soup to deliver to the Emperor in the Imperial Study.\nThe next day he saw Consort Xiao Shu dressed up gorgeously to accompany the Emperor to stroll around the Imperial Garden.\nThe day after tomorrow…\n\"Consort Xiao Shu, this is the token bengong obtained from the empress dowager for you to leave the palace. Quickly take it and leave the palace.\"\nOne of the concubines handed her a golden token to leave the palace. Just as she was about to reach out, a bloodthirsty voice came from behind.\" If you dare to take it, I'll break your legs right now.\"\nXiao Yunchan was speechless.\nShe just wanted to see if the token was made of pure gold. And gold-plated?","categoryType":1,"categoryId":70015,"subcategoryId":0,"categoryName":"History","subcategoryName":"","authorId":"17196310404750101","authorName":"Manfei","sourceType":1,"status":30,"checkLevel":15,"checkTime":1617251764000,"vipStatus":-1,"vipTime":1723000791000,"wordCount":3497,"unitPrice":0,"translation":{"translators":null,"editors":null,"groups":null},"essayIds":null,"createTime":1723000791000,"updateTime":1730547399000,"totalChapterCount":5,"beforeChapterCount":0,"contentChapterCount":3497,"lastChapterId":0,"lastChapterName":"","lastChapterTime":0,"scheduleUpdateFrequency":0,"scheduleUpdateFrequencyUnit":0,"ageGroup":0,"language":1,"expected":0,"sex":0,"updateFrequency":0,"updateFrequencyUnit":0,"ageGroupDescription":"","firstChapterId":0,"languageName":"","signType":0,"filter":{"blackCountries":"","whiteCountries":""},"signed":0,"nextChapterTime":0,"translateMode":0,"words":"","serialStartTime":0,"shield":0,"site":0,"form":0,"sideStoryType":0,"editorRecommendation":"","noGift":false,"auditStatus":0,"transChannel":0,"cpid":0,"scbid":0,"acbid":0,"chargeChapterStartIndex":0,"vipChapterWordsCount":0,"pvNum":6938,"coverUrl":"https://book-pic.webnovel.com/novelcover/148070561505792305?imageMogr2/format/webp&imageMogr2/thumbnail/180x"},{"bookId":"148070656443702305","name":"Mrs. Pei, her disguise is different every day","shortName":"","originalName":"裴夫人她马甲每天不重样","description":"[New book,\" After dressing up as a cannon fodder supporting actress, I won't divorce you even if you beat me to death!\"] The full text is free]\n[The handsome man and the valiant woman are super sweet!]\nBefore his rebirth, Ye Qianxi only had that scumbag in his heart. After being deceived until he was covered in bruises, he realized that the person who had been silently protecting him behind his back was Pei Jinyue.\nAfter her rebirth, Ye Qianxi decided to run away from the marriage. In this life, it was her turn to protect Pei Jinyue.\nSaying that she was useless and weak like an idiot?\nThe big shots from all walks of life shouted directly!\nThe antique world thought,\"You guys are saying that this little ancestor is an idiot?\"\nThe medical world thought,'You guys call this freak an idiot?'\nThe literary world: You guys actually said that this genius is an idiot?\nEveryone was dumbfounded-the idiot actually knew the big shots from all walks of life!\nHer identity was exposed one by one. The low-key talented girl, Ye Jinxi, successfully made a comeback, making those who had once looked down on her worship her three feet.\nThe man who treated her as a flower in a greenhouse suddenly found that she was a troublesome wild rose.\n\"Since Madam is so powerful, why don't you take me in?\"","categoryType":1,"categoryId":70014,"subcategoryId":0,"categoryName":"Urban","subcategoryName":"","authorId":"7459918704960801","authorName":"There is ink in the forest","sourceType":1,"status":30,"checkLevel":15,"checkTime":1635137358000,"vipStatus":-1,"vipTime":1723001255000,"wordCount":3348,"unitPrice":0,"translation":{"translators":null,"editors":null,"groups":null},"essayIds":null,"createTime":1723001255000,"updateTime":1730490017000,"totalChapterCount":5,"beforeChapterCount":0,"contentChapterCount":3348,"lastChapterId":0,"lastChapterName":"","lastChapterTime":0,"scheduleUpdateFrequency":0,"scheduleUpdateFrequencyUnit":0,"ageGroup":0,"language":1,"expected":0,"sex":-1,"updateFrequency":0,"updateFrequencyUnit":0,"ageGroupDescription":"","firstChapterId":0,"languageName":"","signType":0,"filter":{"blackCountries":"","whiteCountries":""},"signed":0,"nextChapterTime":0,"translateMode":0,"words":"","serialStartTime":0,"shield":0,"site":0,"form":0,"sideStoryType":0,"editorRecommendation":"","noGift":false,"auditStatus":0,"transChannel":0,"cpid":0,"scbid":0,"acbid":0,"chargeChapterStartIndex":0,"vipChapterWordsCount":0,"pvNum":7096,"coverUrl":"https://book-pic.webnovel.com/novelcover/148070656443702305?imageMogr2/format/webp&imageMogr2/thumbnail/180x"},{"bookId":"148070671706220505","name":"The evil villain's plan to clear his name","shortName":"","originalName":"恶毒反派的洗白计划","description":"After transmigrating into a world where women were superior to men, Mo Jiu was forced to play the role of a vicious villain. He had to constantly seek death to promote the development of the plot and promote the relationship between the male and female leads.\nIn response, he said,\"F * ck her father\" and began to think of ways to clear his name.\nThe arrogant, domineering, and condescending young master?\nOn the surface, he bullied and humiliated you, but behind your back, he sacrificed everything for you.\nA cold master who was ready to refine his disciple into a human pill?\nHuman pill that harms others for personal gain (×) Nature pill that is specially refined for disciples (tick)\nA black-hearted lotus elf who wanted to replace someone else?\n\"I just want you to pay more attention to me…Even if she couldn't compare to him…Even if it's just one more look at me…\"\nLater on, when Mo Jiu ascended, he realized that the female protagonists and villains who had forced him to his death were actually…All of them followed?\nP.S.: The Goddess abused the Lord and was cool. Don't enter if you don't like it.\nGroup ID: 1150788889\nFull-order group: 864510897","categoryType":1,"categoryId":70009,"subcategoryId":0,"categoryName":"Eastern","subcategoryName":"","authorId":"16631229704063401","authorName":"Drunken Moon","sourceType":1,"status":30,"checkLevel":15,"checkTime":1627868898000,"vipStatus":-1,"vipTime":1723001329000,"wordCount":7209,"unitPrice":0,"translation":{"translators":null,"editors":null,"groups":null},"essayIds":null,"createTime":1723001329000,"updateTime":1728759205000,"totalChapterCount":5,"beforeChapterCount":0,"contentChapterCount":7209,"lastChapterId":0,"lastChapterName":"","lastChapterTime":0,"scheduleUpdateFrequency":0,"scheduleUpdateFrequencyUnit":0,"ageGroup":0,"language":1,"expected":0,"sex":-1,"updateFrequency":0,"updateFrequencyUnit":0,"ageGroupDescription":"","firstChapterId":0,"languageName":"","signType":0,"filter":{"blackCountries":"","whiteCountries":""},"signed":0,"nextChapterTime":0,"translateMode":0,"words":"","serialStartTime":0,"shield":0,"site":0,"form":0,"sideStoryType":0,"editorRecommendation":"","noGift":false,"auditStatus":0,"transChannel":0,"cpid":0,"scbid":0,"acbid":0,"chargeChapterStartIndex":0,"vipChapterWordsCount":0,"pvNum":2474,"coverUrl":"https://book-pic.webnovel.com/novelcover/148070671706220505?imageMogr2/format/webp&imageMogr2/thumbnail/180x"}]
   */
  newArrivals?: {
    /**
     * "148056517471750505"
     */
    bookId?: string;
    /**
     * "The Rebirth of a Concubine's Daughter"
     */
    name?: string;
    shortName?: string;
    /**
     * "庶女重生手札"
     */
    originalName?: string;
    /**
     * "Ling Yinke was the daughter of Huang Shang, the wealthiest man in the Great Chen Kingdom.\nHer stepmother's framing caused her mother to run into a pillar and die with her unborn brother. She fell from being a proud son of heaven to the clouds.\nHer father's neglect had made it difficult for her to move forward and she had suffered.\nHis bloodline was noble, but he was in the same boat as her. He told her,\"Ah Ke, I will never betray you!\"\nShe had helped him become the most respected person in the world, but after he ascended to that noble position, she had been ruthlessly stabbed by him!\nShe gritted her teeth in hatred, but she was helpless. She did not want the heavens to drop a curtain and let her live again.\nWhen one's life was restarted, everything was confusing.\nThe noblest man in the Great Chen Kingdom frequently appeared in her line of sight.\nHe crossed mountains and ridges just to let her gain her father's appreciation, he sent her gold and silver just to solve her urgent needs, he taught her the way of being a person, taught her the method of disciplining others, she was confused and confused;\nLove, hate, love, hatred, past life, this life, which one was real?\n  "
     */
    description?: string;
    /**
     * 1
     */
    categoryType?: number;
    /**
     * 70015
     */
    categoryId?: number;
    subcategoryId?: number;
    /**
     * "History"
     */
    categoryName?: string;
    subcategoryName?: string;
    /**
     * "14194848503402901"
     */
    authorId?: string;
    /**
     * "Lilantai"
     */
    authorName?: string;
    /**
     * 1
     */
    sourceType?: number;
    /**
     * 30
     */
    status?: number;
    /**
     * 15
     */
    checkLevel?: number;
    /**
     * 1626419823000
     */
    checkTime?: number;
    /**
     * -1
     */
    vipStatus?: number;
    /**
     * 1722932217000
     */
    vipTime?: number;
    /**
     * 9144
     */
    wordCount?: number;
    unitPrice?: number;
    translation?: {
      translators?: null;
      editors?: null;
      groups?: null;
    };
    essayIds?: null;
    /**
     * 1722932217000
     */
    createTime?: number;
    /**
     * 1730562552000
     */
    updateTime?: number;
    /**
     * 5
     */
    totalChapterCount?: number;
    beforeChapterCount?: number;
    /**
     * 9144
     */
    contentChapterCount?: number;
    lastChapterId?: number;
    lastChapterName?: string;
    lastChapterTime?: number;
    scheduleUpdateFrequency?: number;
    scheduleUpdateFrequencyUnit?: number;
    ageGroup?: number;
    /**
     * 1
     */
    language?: number;
    expected?: number;
    /**
     * -1
     */
    sex?: number;
    updateFrequency?: number;
    updateFrequencyUnit?: number;
    ageGroupDescription?: string;
    firstChapterId?: number;
    languageName?: string;
    signType?: number;
    filter?: {
      blackCountries?: string;
      whiteCountries?: string;
    };
    signed?: number;
    nextChapterTime?: number;
    translateMode?: number;
    words?: string;
    serialStartTime?: number;
    shield?: number;
    site?: number;
    form?: number;
    sideStoryType?: number;
    editorRecommendation?: string;
    noGift?: boolean;
    auditStatus?: number;
    transChannel?: number;
    cpid?: number;
    scbid?: number;
    acbid?: number;
    chargeChapterStartIndex?: number;
    vipChapterWordsCount?: number;
    /**
     * 1446
     */
    pvNum?: number;
    /**
     * "https://book-pic.webnovel.com/novelcover/148056517471750505?imageMogr2/format/webp&imageMogr2/thumbnail/180x"
     */
    coverUrl?: string;
  }[];
}

/**
 * 接口 [getTopicDetail↗](https://yapi.yuewen.com/project/2309/interface/api/295540) 的 **请求配置的类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-11-05 15:52:56`
 */
type GoPcmSeoTopicDetail2RequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/topic/detail",
    "data",
    string,
    "topicId",
    false
  >
>;

/**
 * 接口 [getTopicDetail↗](https://yapi.yuewen.com/project/2309/interface/api/295540) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-11-05 15:52:56`
 */
const goPcmSeoTopicDetail2RequestConfig: GoPcmSeoTopicDetail2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_42,
    devUrl: devUrl_0_0_0_42,
    prodUrl: prodUrl_0_0_0_42,
    path: "/go/pcm/seo/topic/detail",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_42,
    paramNames: [],
    queryNames: ["topicId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoTopicDetail2",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getTopicDetail↗](https://yapi.yuewen.com/project/2309/interface/api/295540) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-11-05 15:52:56`
 */
export const goPcmSeoTopicDetail2 = /*#__PURE__*/ (
  requestData: GoPcmSeoTopicDetail2Request,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoTopicDetail2Response>(
    prepare(goPcmSeoTopicDetail2RequestConfig, requestData),
    ...args
  );
};

goPcmSeoTopicDetail2.requestConfig = goPcmSeoTopicDetail2RequestConfig;

/**
 * 接口 [getFriendShipLink↗](https://yapi.yuewen.com/project/2309/interface/api/295600) 的 **请求类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getFriendShipLink`
 * @更新时间 `2024-11-08 11:09:16`
 */
export interface GoPcmSeoGetFriendShipLinkRequest {
  domainIds: string;
  linkTypes: string;
  pubStates: string;
}

/**
 * 接口 [getFriendShipLink↗](https://yapi.yuewen.com/project/2309/interface/api/295600) 的 **返回类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getFriendShipLink`
 * @更新时间 `2024-11-08 11:09:16`
 */
export interface GoPcmSeoGetFriendShipLinkResponse {
  /**
   * [{"linkName":"2112","linkAddress":"1212","linkContact":"1212","noFollow":false},{"linkName":"2112","linkAddress":"1212","linkContact":"1212","noFollow":false},{"linkName":"第1条","linkAddress":"1212","linkContact":"1212","noFollow":false},{"linkName":"第5条","linkAddress":"123sdfsdf","linkContact":"123","noFollow":false},{"linkName":"123","linkAddress":"12311","linkContact":"123","noFollow":true},{"linkName":"第10条","linkAddress":"1212xcvxv","linkContact":"121211","noFollow":false},{"linkName":"第2条","linkAddress":"cxvcxv","linkContact":"123","noFollow":true},{"linkName":"第4条","linkAddress":"4444","linkContact":"44444","noFollow":false},{"linkName":"第9条","linkAddress":"123","linkContact":"123","noFollow":true},{"linkName":"第11条","linkAddress":"11","linkContact":"11","noFollow":false},{"linkName":"第3条","linkAddress":"123想吃v现场v","linkContact":"123","noFollow":false},{"linkName":"第6条","linkAddress":"6","linkContact":"6","noFollow":false},{"linkName":"第6条","linkAddress":"sds","linkContact":"sfdsf","noFollow":false},{"linkName":"第7条","linkAddress":"777","linkContact":"77777","noFollow":false}]
   */
  friendLink?: {
    /**
     * "2112"
     */
    linkName?: string;
    /**
     * "1212"
     */
    linkAddress?: string;
    /**
     * "1212"
     */
    linkContact?: string;
    noFollow?: boolean;
  }[];
  /**
   * [{"linkName":"内页链接测试2","linkAddress":"https://m.webnovel.com/","linkContact":"大赛服三房三方","noFollow":true},{"linkName":"内页链接测试1","linkAddress":"https://www.webnovel.com/","linkContact":"大赛服三房三方","noFollow":false}]
   */
  innerLink?: {
    /**
     * "内页链接测试2"
     */
    linkName?: string;
    /**
     * "https://m.webnovel.com/"
     */
    linkAddress?: string;
    /**
     * "大赛服三房三方"
     */
    linkContact?: string;
    /**
     * true
     */
    noFollow?: boolean;
  }[];
  /**
   * [{"linkName":"我是快捷入口","linkAddress":"http://www.haha.com","linkContact":"hahaha","noFollow":false},{"linkName":"快捷入口2","linkAddress":"https://www.baidu.com","linkContact":"baidu","noFollow":true}]
   */
  quickLink?: {
    /**
     * "我是快捷入口"
     */
    linkName?: string;
    /**
     * "http://www.haha.com"
     */
    linkAddress?: string;
    /**
     * "hahaha"
     */
    linkContact?: string;
    noFollow?: boolean;
  }[];
}

/**
 * 接口 [getFriendShipLink↗](https://yapi.yuewen.com/project/2309/interface/api/295600) 的 **请求配置的类型**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getFriendShipLink`
 * @更新时间 `2024-11-08 11:09:16`
 */
type GoPcmSeoGetFriendShipLinkRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/seo/getFriendShipLink",
    "data",
    string,
    "domainIds" | "linkTypes" | "pubStates",
    false
  >
>;

/**
 * 接口 [getFriendShipLink↗](https://yapi.yuewen.com/project/2309/interface/api/295600) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getFriendShipLink`
 * @更新时间 `2024-11-08 11:09:16`
 */
const goPcmSeoGetFriendShipLinkRequestConfig: GoPcmSeoGetFriendShipLinkRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_42,
    devUrl: devUrl_0_0_0_42,
    prodUrl: prodUrl_0_0_0_42,
    path: "/go/pcm/seo/getFriendShipLink",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_42,
    paramNames: [],
    queryNames: ["domainIds", "linkTypes", "pubStates"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetFriendShipLink",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [getFriendShipLink↗](https://yapi.yuewen.com/project/2309/interface/api/295600) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getFriendShipLink`
 * @更新时间 `2024-11-08 11:09:16`
 */
export const goPcmSeoGetFriendShipLink = /*#__PURE__*/ (
  requestData: GoPcmSeoGetFriendShipLinkRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmSeoGetFriendShipLinkResponse>(
    prepare(goPcmSeoGetFriendShipLinkRequestConfig, requestData),
    ...args
  );
};

goPcmSeoGetFriendShipLink.requestConfig =
  goPcmSeoGetFriendShipLinkRequestConfig;

const mockUrl_0_0_0_43 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_43 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_43 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_43 = "data" as any;

/**
 * 接口 [Affiliate申请↗](https://yapi.yuewen.com/project/2309/interface/api/225293) 的 **请求类型**
 *
 * @分类 [Affiliate↗](https://yapi.yuewen.com/project/2309/interface/api/cat_29300)
 * @请求头 `POST /go/pcm/affiliate/add`
 * @更新时间 `2022-06-23 16:14:42`
 */
export interface GoPcmAffiliateAddRequest {
  /**
   * Affiliate类型：1 personal ，2 Supplier
   */
  affiliateType: string;
  /**
   * your name
   */
  affiliateName: string;
  /**
   * Affiliate邮箱，需要验证。
   */
  affiliateEmail: string;
  /**
   * Affiliate链接
   */
  affiliateLink: string;
  /**
   * 开户银行名
   */
  bankName: string;
}

/**
 * 接口 [Affiliate申请↗](https://yapi.yuewen.com/project/2309/interface/api/225293) 的 **返回类型**
 *
 * @分类 [Affiliate↗](https://yapi.yuewen.com/project/2309/interface/api/cat_29300)
 * @请求头 `POST /go/pcm/affiliate/add`
 * @更新时间 `2022-06-23 16:14:42`
 */
export interface GoPcmAffiliateAddResponse {}

/**
 * 接口 [Affiliate申请↗](https://yapi.yuewen.com/project/2309/interface/api/225293) 的 **请求配置的类型**
 *
 * @分类 [Affiliate↗](https://yapi.yuewen.com/project/2309/interface/api/cat_29300)
 * @请求头 `POST /go/pcm/affiliate/add`
 * @更新时间 `2022-06-23 16:14:42`
 */
type GoPcmAffiliateAddRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/affiliate/add",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [Affiliate申请↗](https://yapi.yuewen.com/project/2309/interface/api/225293) 的 **请求配置**
 *
 * @分类 [Affiliate↗](https://yapi.yuewen.com/project/2309/interface/api/cat_29300)
 * @请求头 `POST /go/pcm/affiliate/add`
 * @更新时间 `2022-06-23 16:14:42`
 */
const goPcmAffiliateAddRequestConfig: GoPcmAffiliateAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_43,
    devUrl: devUrl_0_0_0_43,
    prodUrl: prodUrl_0_0_0_43,
    path: "/go/pcm/affiliate/add",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_43,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmAffiliateAdd",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [Affiliate申请↗](https://yapi.yuewen.com/project/2309/interface/api/225293) 的 **请求函数**
 *
 * @分类 [Affiliate↗](https://yapi.yuewen.com/project/2309/interface/api/cat_29300)
 * @请求头 `POST /go/pcm/affiliate/add`
 * @更新时间 `2022-06-23 16:14:42`
 */
export const goPcmAffiliateAdd = /*#__PURE__*/ (
  requestData: GoPcmAffiliateAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmAffiliateAddResponse>(
    prepare(goPcmAffiliateAddRequestConfig, requestData),
    ...args
  );
};

goPcmAffiliateAdd.requestConfig = goPcmAffiliateAddRequestConfig;

const mockUrl_0_0_0_44 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_44 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_44 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_44 = "data" as any;

/**
 * 接口 [get-pool 获取广告池↗](https://yapi.yuewen.com/project/2309/interface/api/234593) 的 **请求类型**
 *
 * @分类 [ad 广告↗](https://yapi.yuewen.com/project/2309/interface/api/cat_30340)
 * @请求头 `GET /go/pcm/ad/get-pool`
 * @更新时间 `2022-03-09 13:35:09`
 */
export interface GoPcmAdGetPoolRequest {}

/**
 * 接口 [get-pool 获取广告池↗](https://yapi.yuewen.com/project/2309/interface/api/234593) 的 **返回类型**
 *
 * @分类 [ad 广告↗](https://yapi.yuewen.com/project/2309/interface/api/cat_30340)
 * @请求头 `GET /go/pcm/ad/get-pool`
 * @更新时间 `2022-03-09 13:35:09`
 */
export interface GoPcmAdGetPoolResponse {
  /**
   * [{"advId":"6951698800","platform":102,"positionType":10801},{"advId":"7333862247","platform":102,"positionType":10802},{"advId":"6951698800","platform":102,"positionType":10803},{"advId":"6210985281","platform":102,"positionType":10804}]
   */
  adList?: {
    /**
     * "6951698800"
     */
    advId?: string;
    /**
     * 102
     */
    platform?: number;
    /**
     * 10801
     */
    positionType?: number;
  }[];
  /**
   * true
   */
  isShow?: boolean;
}

/**
 * 接口 [get-pool 获取广告池↗](https://yapi.yuewen.com/project/2309/interface/api/234593) 的 **请求配置的类型**
 *
 * @分类 [ad 广告↗](https://yapi.yuewen.com/project/2309/interface/api/cat_30340)
 * @请求头 `GET /go/pcm/ad/get-pool`
 * @更新时间 `2022-03-09 13:35:09`
 */
type GoPcmAdGetPoolRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/ad/get-pool",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [get-pool 获取广告池↗](https://yapi.yuewen.com/project/2309/interface/api/234593) 的 **请求配置**
 *
 * @分类 [ad 广告↗](https://yapi.yuewen.com/project/2309/interface/api/cat_30340)
 * @请求头 `GET /go/pcm/ad/get-pool`
 * @更新时间 `2022-03-09 13:35:09`
 */
const goPcmAdGetPoolRequestConfig: GoPcmAdGetPoolRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_44,
  devUrl: devUrl_0_0_0_44,
  prodUrl: prodUrl_0_0_0_44,
  path: "/go/pcm/ad/get-pool",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_44,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "goPcmAdGetPool",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * 接口 [get-pool 获取广告池↗](https://yapi.yuewen.com/project/2309/interface/api/234593) 的 **请求函数**
 *
 * @分类 [ad 广告↗](https://yapi.yuewen.com/project/2309/interface/api/cat_30340)
 * @请求头 `GET /go/pcm/ad/get-pool`
 * @更新时间 `2022-03-09 13:35:09`
 */
export const goPcmAdGetPool = /*#__PURE__*/ (
  requestData?: GoPcmAdGetPoolRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmAdGetPoolResponse>(
    prepare(goPcmAdGetPoolRequestConfig, requestData),
    ...args
  );
};

goPcmAdGetPool.requestConfig = goPcmAdGetPoolRequestConfig;

const mockUrl_0_0_0_45 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_45 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_45 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_45 = "data" as any;

/**
 * 接口 [获取矩阵page↗](https://yapi.yuewen.com/project/2309/interface/api/250623) 的 **请求类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/page`
 * @更新时间 `2022-12-02 15:33:35`
 */
export interface GoPcmMatrixBookcityPageRequest {
  country: string;
  /**
   * CR默认2
   */
  sex: string;
  /**
   * 默认en
   */
  language: string;
}

/**
 * 接口 [获取矩阵page↗](https://yapi.yuewen.com/project/2309/interface/api/250623) 的 **返回类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/page`
 * @更新时间 `2022-12-02 15:33:35`
 */
export interface GoPcmMatrixBookcityPageResponse {}

/**
 * 接口 [获取矩阵page↗](https://yapi.yuewen.com/project/2309/interface/api/250623) 的 **请求配置的类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/page`
 * @更新时间 `2022-12-02 15:33:35`
 */
type GoPcmMatrixBookcityPageRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/matrix/bookcity/page",
    "data",
    string,
    "country" | "sex" | "language",
    false
  >
>;

/**
 * 接口 [获取矩阵page↗](https://yapi.yuewen.com/project/2309/interface/api/250623) 的 **请求配置**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/page`
 * @更新时间 `2022-12-02 15:33:35`
 */
const goPcmMatrixBookcityPageRequestConfig: GoPcmMatrixBookcityPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_45,
    devUrl: devUrl_0_0_0_45,
    prodUrl: prodUrl_0_0_0_45,
    path: "/go/pcm/matrix/bookcity/page",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_45,
    paramNames: [],
    queryNames: ["country", "sex", "language"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixBookcityPage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取矩阵page↗](https://yapi.yuewen.com/project/2309/interface/api/250623) 的 **请求函数**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/page`
 * @更新时间 `2022-12-02 15:33:35`
 */
export const goPcmMatrixBookcityPage = /*#__PURE__*/ (
  requestData: GoPcmMatrixBookcityPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMatrixBookcityPageResponse>(
    prepare(goPcmMatrixBookcityPageRequestConfig, requestData),
    ...args
  );
};

goPcmMatrixBookcityPage.requestConfig = goPcmMatrixBookcityPageRequestConfig;

/**
 * 接口 [获取feed流数据↗](https://yapi.yuewen.com/project/2309/interface/api/253258) 的 **请求类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-feed-list`
 * @更新时间 `2022-12-05 13:50:15`
 */
export interface GoPcmMatrixBookcityGetFeedListRequest {
  /**
   * 页码，进入书城已经拿了第一页数据。第二次请求拿2
   */
  pageIndex: string;
  /**
   * 1 男 2 女
   */
  sex: string;
}

/**
 * 接口 [获取feed流数据↗](https://yapi.yuewen.com/project/2309/interface/api/253258) 的 **返回类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-feed-list`
 * @更新时间 `2022-12-05 13:50:15`
 */
export interface GoPcmMatrixBookcityGetFeedListResponse {}

/**
 * 接口 [获取feed流数据↗](https://yapi.yuewen.com/project/2309/interface/api/253258) 的 **请求配置的类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-feed-list`
 * @更新时间 `2022-12-05 13:50:15`
 */
type GoPcmMatrixBookcityGetFeedListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/matrix/bookcity/get-feed-list",
    "data",
    string,
    "pageIndex" | "sex",
    false
  >
>;

/**
 * 接口 [获取feed流数据↗](https://yapi.yuewen.com/project/2309/interface/api/253258) 的 **请求配置**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-feed-list`
 * @更新时间 `2022-12-05 13:50:15`
 */
const goPcmMatrixBookcityGetFeedListRequestConfig: GoPcmMatrixBookcityGetFeedListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_45,
    devUrl: devUrl_0_0_0_45,
    prodUrl: prodUrl_0_0_0_45,
    path: "/go/pcm/matrix/bookcity/get-feed-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_45,
    paramNames: [],
    queryNames: ["pageIndex", "sex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixBookcityGetFeedList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取feed流数据↗](https://yapi.yuewen.com/project/2309/interface/api/253258) 的 **请求函数**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-feed-list`
 * @更新时间 `2022-12-05 13:50:15`
 */
export const goPcmMatrixBookcityGetFeedList = /*#__PURE__*/ (
  requestData: GoPcmMatrixBookcityGetFeedListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMatrixBookcityGetFeedListResponse>(
    prepare(goPcmMatrixBookcityGetFeedListRequestConfig, requestData),
    ...args
  );
};

goPcmMatrixBookcityGetFeedList.requestConfig =
  goPcmMatrixBookcityGetFeedListRequestConfig;

/**
 * 接口 [获取书城content里面的信息↗](https://yapi.yuewen.com/project/2309/interface/api/253282) 的 **请求类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-content-info`
 * @更新时间 `2022-12-15 15:11:22`
 */
export interface GoPcmMatrixBookcityGetContentInfoRequest {
  contentId: string;
}

/**
 * 接口 [获取书城content里面的信息↗](https://yapi.yuewen.com/project/2309/interface/api/253282) 的 **返回类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-content-info`
 * @更新时间 `2022-12-15 15:11:22`
 */
export interface GoPcmMatrixBookcityGetContentInfoResponse {
  /**
   * [{"bookId":"23255606606779805","itemType":0,"name":"Divorced My Scum Husband, Married His Evil brother","authorName":"ForeverPupa","coverId":1661751830586,"recommendMsg":"I know what you want Chloe, you want my money after we divorced. ","status":30,"chapterCnt":396,"isInBookshelf":false}]
   */
  contentItems?: {
    /**
     * "23255606606779805"
     */
    bookId?: string;
    itemType?: number;
    /**
     * "Divorced My Scum Husband, Married His Evil brother"
     */
    name?: string;
    /**
     * "ForeverPupa"
     */
    authorName?: string;
    /**
     * 1661751830586
     */
    coverId?: number;
    /**
     * "I know what you want Chloe, you want my money after we divorced. "
     */
    recommendMsg?: string;
    /**
     * 30
     */
    status?: number;
    /**
     * 396
     */
    chapterCnt?: number;
    isInBookshelf?: boolean;
  }[];
}

/**
 * 接口 [获取书城content里面的信息↗](https://yapi.yuewen.com/project/2309/interface/api/253282) 的 **请求配置的类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-content-info`
 * @更新时间 `2022-12-15 15:11:22`
 */
type GoPcmMatrixBookcityGetContentInfoRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/matrix/bookcity/get-content-info",
    "data",
    string,
    "contentId",
    false
  >
>;

/**
 * 接口 [获取书城content里面的信息↗](https://yapi.yuewen.com/project/2309/interface/api/253282) 的 **请求配置**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-content-info`
 * @更新时间 `2022-12-15 15:11:22`
 */
const goPcmMatrixBookcityGetContentInfoRequestConfig: GoPcmMatrixBookcityGetContentInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_45,
    devUrl: devUrl_0_0_0_45,
    prodUrl: prodUrl_0_0_0_45,
    path: "/go/pcm/matrix/bookcity/get-content-info",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_45,
    paramNames: [],
    queryNames: ["contentId"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixBookcityGetContentInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取书城content里面的信息↗](https://yapi.yuewen.com/project/2309/interface/api/253282) 的 **请求函数**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-content-info`
 * @更新时间 `2022-12-15 15:11:22`
 */
export const goPcmMatrixBookcityGetContentInfo = /*#__PURE__*/ (
  requestData: GoPcmMatrixBookcityGetContentInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMatrixBookcityGetContentInfoResponse>(
    prepare(goPcmMatrixBookcityGetContentInfoRequestConfig, requestData),
    ...args
  );
};

goPcmMatrixBookcityGetContentInfo.requestConfig =
  goPcmMatrixBookcityGetContentInfoRequestConfig;

/**
 * 接口 [获取榜单↗](https://yapi.yuewen.com/project/2309/interface/api/253348) 的 **请求类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-list`
 * @更新时间 `2022-12-07 19:03:10`
 */
export interface GoPcmMatrixRankGetListRequest {
  /**
   * 暂时都为0
   */
  listType: string;
  /**
   * 榜单配置下发  0 小说 100 漫画
   */
  bookType: string;
  /**
   * 榜单配置下发
   */
  rankId: string;
  /**
   *
   * TOTAL   =   1,  // 总榜单
   * DAILY   =   2,  // 日榜单
   * WEEKLY  =   3,  // 周榜单
   * MONTHLY =   4,   // 月榜单
   * TWENTY_FOUR_HOURS = 5, // 24h
   */
  rankType: string;
  /**
   * zh、en等
   */
  language: string;
  pageIndex: string;
  /**
   * 默认0 ALL = -1,
   *         TRANSLATION = 1,
   *         ORIGINAL = 2
   */
  sourceType: string;
  /**
   * 男女频，-1 all 1：男，2：女 默认-1
   */
  sex: string;
  /**
   *  -1:所有 30:ongoing 50:completed
   */
  status: string;
  /**
   * -1:所有 1：签约
   */
  signed: string;
  /**
   * -1:所有
   */
  vipStatus: string;
  /**
   * 5 小说 8 fanfic
   */
  categoryType: string;
}

/**
 * 接口 [获取榜单↗](https://yapi.yuewen.com/project/2309/interface/api/253348) 的 **返回类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-list`
 * @更新时间 `2022-12-07 19:03:10`
 */
export interface GoPcmMatrixRankGetListResponse {
  /**
   * [{"rankNo":1,"amount":41516,"bookInfo":{"bookId":"10234821601022105","itemType":0,"name":"发布超过6个月，首次winwin","authorName":"yang190","coverId":1645183066498,"chapterCnt":42,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1621498688000,"lastChapterTime":1621498596000,"isInBookshelf":false}},{"rankNo":2,"amount":39270,"bookInfo":{"bookId":"14883978401129905","itemType":0,"name":"Test 0925 test","authorName":"uat_yuewen1234","coverId":1641548298084,"chapterCnt":1171,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1660299427000,"lastChapterTime":1660299426000,"isInBookshelf":false}},{"rankNo":3,"amount":28369,"bookInfo":{"bookId":"13743109901051005","itemType":0,"name":"Gourmet Food Supplier0521","authorName":"4300001087","coverId":1643652337574,"chapterCnt":109,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1641284330000,"lastChapterTime":1608180820000,"isInBookshelf":false}},{"rankNo":4,"amount":27852,"bookInfo":{"bookId":"17224100801047005","itemType":0,"name":"Auto new book: 1592282607804","authorName":"4300001087","coverId":1643652023434,"chapterCnt":52,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1638432420000,"lastChapterTime":1614047889000,"isInBookshelf":false}},{"rankNo":5,"amount":22151,"bookInfo":{"bookId":"18796019301103605","itemType":0,"name":"test_book 11.15开通特权 12.1生效","authorName":"darkamo","coverId":1643652290559,"chapterCnt":38,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1636338142000,"lastChapterTime":1636338142000,"isInBookshelf":false}},{"rankNo":6,"amount":15803,"bookInfo":{"bookId":"19400561701116605","itemType":0,"name":"happynew1","authorName":"liwen369088_9413","coverId":1641352311749,"chapterCnt":47,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1641370636000,"lastChapterTime":1641370635000,"isInBookshelf":false}},{"rankNo":7,"amount":8350,"bookInfo":{"bookId":"7765063201015805","itemType":0,"name":"Jun Jiuling","authorName":"Xi Xing","coverId":1643652206694,"chapterCnt":38,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1628672052000,"lastChapterTime":1582514408000,"isInBookshelf":false}},{"rankNo":8,"amount":3610,"bookInfo":{"bookId":"14715446801126105","itemType":0,"name":"test vip words","authorName":"zmy9thqq","coverId":1645183143650,"chapterCnt":11,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1639462824000,"lastChapterTime":1612340270000,"isInBookshelf":false}},{"rankNo":9,"amount":1896,"bookInfo":{"bookId":"17224109901047105","itemType":0,"name":"lyytest: 1592282699041","authorName":"4300001087","coverId":1643652337623,"chapterCnt":68,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1625637548000,"lastChapterTime":1614221693000,"isInBookshelf":false}},{"rankNo":10,"amount":1326,"bookInfo":{"bookId":"15909797701004605","itemType":0,"name":"当天有免费和收费，且更新了免费","authorName":"webnoveltest6","coverId":1643652337498,"chapterCnt":8,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1608792663000,"lastChapterTime":1608703253000,"isInBookshelf":false}},{"rankNo":11,"amount":1175,"bookInfo":{"bookId":"18806545201104305","itemType":0,"name":"Fang Chronicles","authorName":"D'Elen McClain","coverId":1645183161629,"chapterCnt":13,"status":50,"statusDesc":"Completed","recommendMsg":"","updateTime":1615861596000,"lastChapterTime":1608107098000,"isInBookshelf":false}},{"rankNo":12,"amount":830,"bookInfo":{"bookId":"14095554801057905","itemType":0,"name":"TEST0620","authorName":"123","coverId":1641890464752,"chapterCnt":1,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1641890448000,"lastChapterTime":1562912621000,"isInBookshelf":false}},{"rankNo":13,"amount":363,"bookInfo":{"bookId":"21657767301166705","itemType":0,"name":"webnovel test 20211111个人定制","authorName":"DaoistWBEiTR","coverId":1643652060377,"chapterCnt":44,"status":30,"statusDesc":"Ongoing","recommendMsg":"Don't be sad! Because God sends hope in the most !","updateTime":1652085496000,"lastChapterTime":1652085495000,"isInBookshelf":false}},{"rankNo":14,"amount":325,"bookInfo":{"bookId":"18796015101102405","itemType":0,"name":"test_book Ac ut enim.","authorName":"darkamo","coverId":1645183154459,"chapterCnt":15,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1640684048000,"lastChapterTime":1640684048000,"isInBookshelf":false}},{"rankNo":15,"amount":249,"bookInfo":{"bookId":"19705541001134905","itemType":0,"name":"test_book Phasellus aliquet nascetur?","authorName":"460423883","coverId":1645183227621,"chapterCnt":10,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1636458502000,"lastChapterTime":1628152862000,"isInBookshelf":false}},{"rankNo":16,"amount":63,"bookInfo":{"bookId":"20794111401157105","itemType":0,"name":"test_book Semper ipsum a!","authorName":"2778872801","coverId":1645183274364,"chapterCnt":4,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1635747228000,"lastChapterTime":1635747228000,"isInBookshelf":false}},{"rankNo":17,"amount":7,"bookInfo":{"bookId":"19702771301129605","itemType":0,"name":"test_book Quisque fermentum sit!","authorName":"4300001087","coverId":1641437549751,"chapterCnt":66,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1657001739000,"lastChapterTime":1641437698000,"isInBookshelf":false}}]
   */
  bookItems?: {
    /**
     * 1
     */
    rankNo?: number;
    /**
     * 41516
     */
    amount?: number;
    bookInfo?: {
      /**
       * "10234821601022105"
       */
      bookId?: string;
      itemType?: number;
      /**
       * "发布超过6个月，首次winwin"
       */
      name?: string;
      /**
       * "yang190"
       */
      authorName?: string;
      /**
       * 1645183066498
       */
      coverId?: number;
      /**
       * 42
       */
      chapterCnt?: number;
      /**
       * 30
       */
      status?: number;
      /**
       * "Ongoing"
       */
      statusDesc?: string;
      recommendMsg?: string;
      /**
       * 1621498688000
       */
      updateTime?: number;
      /**
       * 1621498596000
       */
      lastChapterTime?: number;
      isInBookshelf?: boolean;
    };
  }[];
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * true
   */
  isLast?: boolean;
}

/**
 * 接口 [获取榜单↗](https://yapi.yuewen.com/project/2309/interface/api/253348) 的 **请求配置的类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-list`
 * @更新时间 `2022-12-07 19:03:10`
 */
type GoPcmMatrixRankGetListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/matrix/rank/get-list",
    "data",
    string,
    | "listType"
    | "bookType"
    | "rankId"
    | "rankType"
    | "language"
    | "pageIndex"
    | "sourceType"
    | "sex"
    | "status"
    | "signed"
    | "vipStatus"
    | "categoryType",
    false
  >
>;

/**
 * 接口 [获取榜单↗](https://yapi.yuewen.com/project/2309/interface/api/253348) 的 **请求配置**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-list`
 * @更新时间 `2022-12-07 19:03:10`
 */
const goPcmMatrixRankGetListRequestConfig: GoPcmMatrixRankGetListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_45,
    devUrl: devUrl_0_0_0_45,
    prodUrl: prodUrl_0_0_0_45,
    path: "/go/pcm/matrix/rank/get-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_45,
    paramNames: [],
    queryNames: [
      "listType",
      "bookType",
      "rankId",
      "rankType",
      "language",
      "pageIndex",
      "sourceType",
      "sex",
      "status",
      "signed",
      "vipStatus",
      "categoryType",
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixRankGetList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取榜单↗](https://yapi.yuewen.com/project/2309/interface/api/253348) 的 **请求函数**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-list`
 * @更新时间 `2022-12-07 19:03:10`
 */
export const goPcmMatrixRankGetList = /*#__PURE__*/ (
  requestData: GoPcmMatrixRankGetListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMatrixRankGetListResponse>(
    prepare(goPcmMatrixRankGetListRequestConfig, requestData),
    ...args
  );
};

goPcmMatrixRankGetList.requestConfig = goPcmMatrixRankGetListRequestConfig;

/**
 * 接口 [获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/253678) 的 **请求类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-config`
 * @更新时间 `2022-12-14 10:27:50`
 */
export interface GoPcmMatrixRankGetConfigRequest {}

/**
 * 接口 [获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/253678) 的 **返回类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-config`
 * @更新时间 `2022-12-14 10:27:50`
 */
export interface GoPcmMatrixRankGetConfigResponse {}

/**
 * 接口 [获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/253678) 的 **请求配置的类型**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-config`
 * @更新时间 `2022-12-14 10:27:50`
 */
type GoPcmMatrixRankGetConfigRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/matrix/rank/get-config",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/253678) 的 **请求配置**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-config`
 * @更新时间 `2022-12-14 10:27:50`
 */
const goPcmMatrixRankGetConfigRequestConfig: GoPcmMatrixRankGetConfigRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_45,
    devUrl: devUrl_0_0_0_45,
    prodUrl: prodUrl_0_0_0_45,
    path: "/go/pcm/matrix/rank/get-config",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_45,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixRankGetConfig",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/253678) 的 **请求函数**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-config`
 * @更新时间 `2022-12-14 10:27:50`
 */
export const goPcmMatrixRankGetConfig = /*#__PURE__*/ (
  requestData?: GoPcmMatrixRankGetConfigRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMatrixRankGetConfigResponse>(
    prepare(goPcmMatrixRankGetConfigRequestConfig, requestData),
    ...args
  );
};

goPcmMatrixRankGetConfig.requestConfig = goPcmMatrixRankGetConfigRequestConfig;

const mockUrl_0_0_0_46 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_46 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_46 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_46 = "data" as any;

/**
 * 接口 [同步接口↗](https://yapi.yuewen.com/project/2309/interface/api/252522) 的 **请求类型**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `POST /go/pcm/readsdk/setConfig`
 * @更新时间 `2022-11-24 14:52:16`
 */
export interface GoPcmReadsdkSetConfigRequest {
  siteId: string;
  identity: string;
  config: string;
  /**
   * 校验字段
   */
  nonce: string;
}

/**
 * 接口 [同步接口↗](https://yapi.yuewen.com/project/2309/interface/api/252522) 的 **返回类型**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `POST /go/pcm/readsdk/setConfig`
 * @更新时间 `2022-11-24 14:52:16`
 */
export interface GoPcmReadsdkSetConfigResponse {}

/**
 * 接口 [同步接口↗](https://yapi.yuewen.com/project/2309/interface/api/252522) 的 **请求配置的类型**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `POST /go/pcm/readsdk/setConfig`
 * @更新时间 `2022-11-24 14:52:16`
 */
type GoPcmReadsdkSetConfigRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/readsdk/setConfig",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [同步接口↗](https://yapi.yuewen.com/project/2309/interface/api/252522) 的 **请求配置**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `POST /go/pcm/readsdk/setConfig`
 * @更新时间 `2022-11-24 14:52:16`
 */
const goPcmReadsdkSetConfigRequestConfig: GoPcmReadsdkSetConfigRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_46,
    devUrl: devUrl_0_0_0_46,
    prodUrl: prodUrl_0_0_0_46,
    path: "/go/pcm/readsdk/setConfig",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_46,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadsdkSetConfig",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [同步接口↗](https://yapi.yuewen.com/project/2309/interface/api/252522) 的 **请求函数**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `POST /go/pcm/readsdk/setConfig`
 * @更新时间 `2022-11-24 14:52:16`
 */
export const goPcmReadsdkSetConfig = /*#__PURE__*/ (
  requestData: GoPcmReadsdkSetConfigRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmReadsdkSetConfigResponse>(
    prepare(goPcmReadsdkSetConfigRequestConfig, requestData),
    ...args
  );
};

goPcmReadsdkSetConfig.requestConfig = goPcmReadsdkSetConfigRequestConfig;

/**
 * 接口 [获取配置↗](https://yapi.yuewen.com/project/2309/interface/api/252540) 的 **请求类型**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `GET /go/pcm/readsdk/getConfig`
 * @更新时间 `2022-11-24 14:56:51`
 */
export interface GoPcmReadsdkGetConfigRequest {
  siteId: string;
  identity: string;
}

/**
 * 接口 [获取配置↗](https://yapi.yuewen.com/project/2309/interface/api/252540) 的 **返回类型**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `GET /go/pcm/readsdk/getConfig`
 * @更新时间 `2022-11-24 14:56:51`
 */
export interface GoPcmReadsdkGetConfigResponse {
  /**
   * "@JSON"
   */
  config?: string;
}

/**
 * 接口 [获取配置↗](https://yapi.yuewen.com/project/2309/interface/api/252540) 的 **请求配置的类型**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `GET /go/pcm/readsdk/getConfig`
 * @更新时间 `2022-11-24 14:56:51`
 */
type GoPcmReadsdkGetConfigRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/readsdk/getConfig",
    "data",
    string,
    "siteId" | "identity",
    false
  >
>;

/**
 * 接口 [获取配置↗](https://yapi.yuewen.com/project/2309/interface/api/252540) 的 **请求配置**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `GET /go/pcm/readsdk/getConfig`
 * @更新时间 `2022-11-24 14:56:51`
 */
const goPcmReadsdkGetConfigRequestConfig: GoPcmReadsdkGetConfigRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_46,
    devUrl: devUrl_0_0_0_46,
    prodUrl: prodUrl_0_0_0_46,
    path: "/go/pcm/readsdk/getConfig",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_46,
    paramNames: [],
    queryNames: ["siteId", "identity"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadsdkGetConfig",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取配置↗](https://yapi.yuewen.com/project/2309/interface/api/252540) 的 **请求函数**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `GET /go/pcm/readsdk/getConfig`
 * @更新时间 `2022-11-24 14:56:51`
 */
export const goPcmReadsdkGetConfig = /*#__PURE__*/ (
  requestData: GoPcmReadsdkGetConfigRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmReadsdkGetConfigResponse>(
    prepare(goPcmReadsdkGetConfigRequestConfig, requestData),
    ...args
  );
};

goPcmReadsdkGetConfig.requestConfig = goPcmReadsdkGetConfigRequestConfig;

const mockUrl_0_0_0_47 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_47 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_47 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_47 = "data" as any;

/**
 * 接口 [获取联想结果↗](https://yapi.yuewen.com/project/2309/interface/api/253096) 的 **请求类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-auto-complete`
 * @更新时间 `2022-12-02 15:45:58`
 */
export interface GoPcmMatrixSearchGetAutoCompleteRequest {
  /**
   * 关键字
   */
  keyWord: string;
}

/**
 * 接口 [获取联想结果↗](https://yapi.yuewen.com/project/2309/interface/api/253096) 的 **返回类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-auto-complete`
 * @更新时间 `2022-12-02 15:45:58`
 */
export interface GoPcmMatrixSearchGetAutoCompleteResponse {
  /**
   * [{"itemType":1,"itemId":"@long","itemName":"@string"}]
   */
  autoComplete?: {
    /**
     * 1
     */
    itemType?: number;
    /**
     * "@long"
     */
    itemId?: string;
    /**
     * "@string"
     */
    itemName?: string;
  }[];
  /**
   * [{"bookId":1,"itemType":1,"name":"@string","coverId":"@timestamp"}]
   */
  inBookShelf?: {
    /**
     * 1
     */
    bookId?: number;
    /**
     * 1
     */
    itemType?: number;
    /**
     * "@string"
     */
    name?: string;
    /**
     * "@timestamp"
     */
    coverId?: string;
  }[];
}

/**
 * 接口 [获取联想结果↗](https://yapi.yuewen.com/project/2309/interface/api/253096) 的 **请求配置的类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-auto-complete`
 * @更新时间 `2022-12-02 15:45:58`
 */
type GoPcmMatrixSearchGetAutoCompleteRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/matrix/search/get-auto-complete",
    "data",
    string,
    "keyWord",
    false
  >
>;

/**
 * 接口 [获取联想结果↗](https://yapi.yuewen.com/project/2309/interface/api/253096) 的 **请求配置**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-auto-complete`
 * @更新时间 `2022-12-02 15:45:58`
 */
const goPcmMatrixSearchGetAutoCompleteRequestConfig: GoPcmMatrixSearchGetAutoCompleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_47,
    devUrl: devUrl_0_0_0_47,
    prodUrl: prodUrl_0_0_0_47,
    path: "/go/pcm/matrix/search/get-auto-complete",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_47,
    paramNames: [],
    queryNames: ["keyWord"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixSearchGetAutoComplete",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取联想结果↗](https://yapi.yuewen.com/project/2309/interface/api/253096) 的 **请求函数**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-auto-complete`
 * @更新时间 `2022-12-02 15:45:58`
 */
export const goPcmMatrixSearchGetAutoComplete = /*#__PURE__*/ (
  requestData: GoPcmMatrixSearchGetAutoCompleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMatrixSearchGetAutoCompleteResponse>(
    prepare(goPcmMatrixSearchGetAutoCompleteRequestConfig, requestData),
    ...args
  );
};

goPcmMatrixSearchGetAutoComplete.requestConfig =
  goPcmMatrixSearchGetAutoCompleteRequestConfig;

/**
 * 接口 [获取搜索结果↗](https://yapi.yuewen.com/project/2309/interface/api/253105) 的 **请求类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-result`
 * @更新时间 `2022-12-08 13:57:39`
 */
export interface GoPcmMatrixSearchGetResultRequest {
  pageIndex: string;
  pageSize: string;
  /**
   * 搜索关键字
   */
  keyWord: string;
  /**
   * 0 popular 1 updated
   */
  sortType: string;
  /**
   * -1 all
   * 1 <50
   * 2 50~100
   * 3 100-200
   * 4 200-500
   * 5 500-1000
   * 6 >1000
   */
  chapters: string;
  /**
   * -1 all
   * 30 ongoing
   * 50 completed
   */
  status: string;
  /**
   * 0 小说，100 漫画， 200 出版书
   */
  itemType: string;
}

/**
 * 接口 [获取搜索结果↗](https://yapi.yuewen.com/project/2309/interface/api/253105) 的 **返回类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-result`
 * @更新时间 `2022-12-08 13:57:39`
 */
export interface GoPcmMatrixSearchGetResultResponse {
  /**
   * [{"bookId":"19977889406331605","itemType":0,"name":"The Hidden Wife Of The Cold CEO","categoryId":70014,"categoryName":"Contemporary Romance","authorName":"Paschalinelily","coverId":1648800552000,"chapterCnt":790,"status":50,"statusDesc":"Completed","recommendMsg":"What happens when a Powerful CEO is forced to marry a woman against his wish?","updateTime":1654866502000,"lastChapterTime":1654012039000,"isInBookshelf":false}]
   */
  bookInfos?: {
    /**
     * "19977889406331605"
     */
    bookId?: string;
    itemType?: number;
    /**
     * "The Hidden Wife Of The Cold CEO"
     */
    name?: string;
    /**
     * 70014
     */
    categoryId?: number;
    /**
     * "Contemporary Romance"
     */
    categoryName?: string;
    /**
     * "Paschalinelily"
     */
    authorName?: string;
    /**
     * 1648800552000
     */
    coverId?: number;
    /**
     * 790
     */
    chapterCnt?: number;
    /**
     * 50
     */
    status?: number;
    /**
     * "Completed"
     */
    statusDesc?: string;
    /**
     * "What happens when a Powerful CEO is forced to marry a woman against his wish?"
     */
    recommendMsg?: string;
    /**
     * 1654866502000
     */
    updateTime?: number;
    /**
     * 1654012039000
     */
    lastChapterTime?: number;
    isInBookshelf?: boolean;
  }[];
  /**
   * [{"bookId":"23515067606304405","itemType":0,"name":"Alpha’s Rejected Mate Returns as Queen","categoryId":70014,"categoryName":"Contemporary Romance","authorName":"Mountain Springs","coverId":1656474860856,"chapterCnt":258,"status":30,"statusDesc":"Ongoing","recommendMsg":"","updateTime":1670421675000,"lastChapterTime":1670421600000,"isInBookshelf":false}]
   */
  emptyInfos?: {
    /**
     * "23515067606304405"
     */
    bookId?: string;
    itemType?: number;
    /**
     * "Alpha’s Rejected Mate Returns as Queen"
     */
    name?: string;
    /**
     * 70014
     */
    categoryId?: number;
    /**
     * "Contemporary Romance"
     */
    categoryName?: string;
    /**
     * "Mountain Springs"
     */
    authorName?: string;
    /**
     * 1656474860856
     */
    coverId?: number;
    /**
     * 258
     */
    chapterCnt?: number;
    /**
     * 30
     */
    status?: number;
    /**
     * "Ongoing"
     */
    statusDesc?: string;
    recommendMsg?: string;
    /**
     * 1670421675000
     */
    updateTime?: number;
    /**
     * 1670421600000
     */
    lastChapterTime?: number;
    isInBookshelf?: boolean;
  }[];
  tagInfo?: {
    /**
     * "ceo"
     */
    name?: string;
    /**
     * 41000316
     */
    id?: number;
    /**
     * [{"bookId":"20975083806682605","itemType":0,"name":"She Becomes Glamorous After The Engagement Annulment","categoryId":70014,"categoryName":"Contemporary Romance","authorName":"Mr.Yan","coverId":1656062499189,"chapterCnt":1065,"status":50,"statusDesc":"Completed","recommendMsg":"She’s back gorgeously with huge inheritance five years after being rejected","updateTime":1670443722000,"lastChapterTime":1659283500000,"isInBookshelf":false}]
     */
    tagItems?: {
      /**
       * "20975083806682605"
       */
      bookId?: string;
      itemType?: number;
      /**
       * "She Becomes Glamorous After The Engagement Annulment"
       */
      name?: string;
      /**
       * 70014
       */
      categoryId?: number;
      /**
       * "Contemporary Romance"
       */
      categoryName?: string;
      /**
       * "Mr.Yan"
       */
      authorName?: string;
      /**
       * 1656062499189
       */
      coverId?: number;
      /**
       * 1065
       */
      chapterCnt?: number;
      /**
       * 50
       */
      status?: number;
      /**
       * "Completed"
       */
      statusDesc?: string;
      /**
       * "She’s back gorgeously with huge inheritance five years after being rejected"
       */
      recommendMsg?: string;
      /**
       * 1670443722000
       */
      updateTime?: number;
      /**
       * 1659283500000
       */
      lastChapterTime?: number;
      isInBookshelf?: boolean;
    }[];
  };
  /**
   * 1
   */
  pageIndex?: number;
  /**
   * 838
   */
  totalCount?: number;
  isLast?: boolean;
}

/**
 * 接口 [获取搜索结果↗](https://yapi.yuewen.com/project/2309/interface/api/253105) 的 **请求配置的类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-result`
 * @更新时间 `2022-12-08 13:57:39`
 */
type GoPcmMatrixSearchGetResultRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/matrix/search/get-result",
    "data",
    string,
    | "pageIndex"
    | "pageSize"
    | "keyWord"
    | "sortType"
    | "chapters"
    | "status"
    | "itemType",
    false
  >
>;

/**
 * 接口 [获取搜索结果↗](https://yapi.yuewen.com/project/2309/interface/api/253105) 的 **请求配置**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-result`
 * @更新时间 `2022-12-08 13:57:39`
 */
const goPcmMatrixSearchGetResultRequestConfig: GoPcmMatrixSearchGetResultRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_47,
    devUrl: devUrl_0_0_0_47,
    prodUrl: prodUrl_0_0_0_47,
    path: "/go/pcm/matrix/search/get-result",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_47,
    paramNames: [],
    queryNames: [
      "pageIndex",
      "pageSize",
      "keyWord",
      "sortType",
      "chapters",
      "status",
      "itemType",
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixSearchGetResult",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取搜索结果↗](https://yapi.yuewen.com/project/2309/interface/api/253105) 的 **请求函数**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-result`
 * @更新时间 `2022-12-08 13:57:39`
 */
export const goPcmMatrixSearchGetResult = /*#__PURE__*/ (
  requestData: GoPcmMatrixSearchGetResultRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMatrixSearchGetResultResponse>(
    prepare(goPcmMatrixSearchGetResultRequestConfig, requestData),
    ...args
  );
};

goPcmMatrixSearchGetResult.requestConfig =
  goPcmMatrixSearchGetResultRequestConfig;

/**
 * 接口 [筛选项配置↗](https://yapi.yuewen.com/project/2309/interface/api/253114) 的 **请求类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-filter-config`
 * @更新时间 `2022-12-02 15:47:03`
 */
export interface GoPcmMatrixSearchGetFilterConfigRequest {}

/**
 * 接口 [筛选项配置↗](https://yapi.yuewen.com/project/2309/interface/api/253114) 的 **返回类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-filter-config`
 * @更新时间 `2022-12-02 15:47:03`
 */
export interface GoPcmMatrixSearchGetFilterConfigResponse {
  /**
   * [{"filterType":"chapterConfigItems","value":-1,"text":"All","searchParam":""},{"filterType":"chapterConfigItems","value":1,"text":"&lt;50","searchParam":"-50"},{"filterType":"chapterConfigItems","value":2,"text":"50~100","searchParam":"50-100"},{"filterType":"chapterConfigItems","value":3,"text":"100~200","searchParam":"100-200"},{"filterType":"chapterConfigItems","value":4,"text":"200~500","searchParam":"200-500"},{"filterType":"chapterConfigItems","value":5,"text":"500~1000","searchParam":"500-1000"},{"filterType":"chapterConfigItems","value":6,"text":"&gt;1000","searchParam":"1000-"}]
   */
  chapterConfigItems?: {
    /**
     * "chapterConfigItems"
     */
    filterType?: string;
    /**
     * -1
     */
    value?: number;
    /**
     * "All"
     */
    text?: string;
    searchParam?: string;
  }[];
  /**
   * [{"filterType":"comicChapterConfigItems","value":-1,"text":"All","searchParam":""},{"filterType":"comicChapterConfigItems","value":1,"text":"&lt;50","searchParam":"-50"},{"filterType":"comicChapterConfigItems","value":2,"text":"50~100","searchParam":"50-100"},{"filterType":"comicChapterConfigItems","value":3,"text":"100~200","searchParam":"100-200"},{"filterType":"comicChapterConfigItems","value":7,"text":"&gt;200","searchParam":"200-"}]
   */
  comicChapterConfigItems?: {
    /**
     * "comicChapterConfigItems"
     */
    filterType?: string;
    /**
     * -1
     */
    value?: number;
    /**
     * "All"
     */
    text?: string;
    searchParam?: string;
  }[];
  /**
   * [{"filterType":"sortConfigItems","value":0,"text":"Popular","searchParam":""},{"filterType":"sortConfigItems","value":1,"text":"Last updated","searchParam":""}]
   */
  sortConfigItems?: {
    /**
     * "sortConfigItems"
     */
    filterType?: string;
    value?: number;
    /**
     * "Popular"
     */
    text?: string;
    searchParam?: string;
  }[];
  /**
   * [{"filterType":"statusConfigItems","value":-1,"text":"All","searchParam":""},{"filterType":"statusConfigItems","value":30,"text":"Ongoing","searchParam":""},{"filterType":"statusConfigItems","value":50,"text":"Completed","searchParam":""}]
   */
  statusConfigItems?: {
    /**
     * "statusConfigItems"
     */
    filterType?: string;
    /**
     * -1
     */
    value?: number;
    /**
     * "All"
     */
    text?: string;
    searchParam?: string;
  }[];
}

/**
 * 接口 [筛选项配置↗](https://yapi.yuewen.com/project/2309/interface/api/253114) 的 **请求配置的类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-filter-config`
 * @更新时间 `2022-12-02 15:47:03`
 */
type GoPcmMatrixSearchGetFilterConfigRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/matrix/search/get-filter-config",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [筛选项配置↗](https://yapi.yuewen.com/project/2309/interface/api/253114) 的 **请求配置**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-filter-config`
 * @更新时间 `2022-12-02 15:47:03`
 */
const goPcmMatrixSearchGetFilterConfigRequestConfig: GoPcmMatrixSearchGetFilterConfigRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_47,
    devUrl: devUrl_0_0_0_47,
    prodUrl: prodUrl_0_0_0_47,
    path: "/go/pcm/matrix/search/get-filter-config",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_47,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixSearchGetFilterConfig",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [筛选项配置↗](https://yapi.yuewen.com/project/2309/interface/api/253114) 的 **请求函数**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-filter-config`
 * @更新时间 `2022-12-02 15:47:03`
 */
export const goPcmMatrixSearchGetFilterConfig = /*#__PURE__*/ (
  requestData?: GoPcmMatrixSearchGetFilterConfigRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMatrixSearchGetFilterConfigResponse>(
    prepare(goPcmMatrixSearchGetFilterConfigRequestConfig, requestData),
    ...args
  );
};

goPcmMatrixSearchGetFilterConfig.requestConfig =
  goPcmMatrixSearchGetFilterConfigRequestConfig;

/**
 * 接口 [获取搜索热词↗](https://yapi.yuewen.com/project/2309/interface/api/253123) 的 **请求类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-hot-word`
 * @更新时间 `2022-12-02 15:47:34`
 */
export interface GoPcmMatrixSearchGetHotWordRequest {
  /**
   * 男女频，0 all 1：男，2：女 默认 0
   */
  sex: string;
}

/**
 * 接口 [获取搜索热词↗](https://yapi.yuewen.com/project/2309/interface/api/253123) 的 **返回类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-hot-word`
 * @更新时间 `2022-12-02 15:47:34`
 */
export interface GoPcmMatrixSearchGetHotWordResponse {
  /**
   * [{"text":"@string","isHot":true,"type":1,"actionUrl":"@url"}]
   */
  hotWordItems?: {
    /**
     * "@string"
     */
    text?: string;
    /**
     * true
     */
    isHot?: boolean;
    /**
     * 1
     */
    type?: number;
    /**
     * "@url"
     */
    actionUrl?: string;
  }[];
}

/**
 * 接口 [获取搜索热词↗](https://yapi.yuewen.com/project/2309/interface/api/253123) 的 **请求配置的类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-hot-word`
 * @更新时间 `2022-12-02 15:47:34`
 */
type GoPcmMatrixSearchGetHotWordRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/matrix/search/get-hot-word",
    "data",
    string,
    "sex",
    false
  >
>;

/**
 * 接口 [获取搜索热词↗](https://yapi.yuewen.com/project/2309/interface/api/253123) 的 **请求配置**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-hot-word`
 * @更新时间 `2022-12-02 15:47:34`
 */
const goPcmMatrixSearchGetHotWordRequestConfig: GoPcmMatrixSearchGetHotWordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_47,
    devUrl: devUrl_0_0_0_47,
    prodUrl: prodUrl_0_0_0_47,
    path: "/go/pcm/matrix/search/get-hot-word",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_47,
    paramNames: [],
    queryNames: ["sex"],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixSearchGetHotWord",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取搜索热词↗](https://yapi.yuewen.com/project/2309/interface/api/253123) 的 **请求函数**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-hot-word`
 * @更新时间 `2022-12-02 15:47:34`
 */
export const goPcmMatrixSearchGetHotWord = /*#__PURE__*/ (
  requestData: GoPcmMatrixSearchGetHotWordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMatrixSearchGetHotWordResponse>(
    prepare(goPcmMatrixSearchGetHotWordRequestConfig, requestData),
    ...args
  );
};

goPcmMatrixSearchGetHotWord.requestConfig =
  goPcmMatrixSearchGetHotWordRequestConfig;

/**
 * 接口 [获取推荐榜单list↗](https://yapi.yuewen.com/project/2309/interface/api/253128) 的 **请求类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-top-list`
 * @更新时间 `2022-12-02 15:47:58`
 */
export interface GoPcmMatrixSearchGetTopListRequest {}

/**
 * 接口 [获取推荐榜单list↗](https://yapi.yuewen.com/project/2309/interface/api/253128) 的 **返回类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-top-list`
 * @更新时间 `2022-12-02 15:47:58`
 */
export interface GoPcmMatrixSearchGetTopListResponse {
  /**
   * [{"id":450394789662294000,"title":"Top 10 Best Sellers","topIcon":1,"topList":[{"index":0,"bookId":20749237801156404,"itemType":0,"name":"@string","isHot":true}]}]
   */
  topRankingInfo?: {
    /**
     * 450394789662294000
     */
    id?: number;
    /**
     * "Top 10 Best Sellers"
     */
    title?: string;
    /**
     * 1
     */
    topIcon?: number;
    /**
     * [{"index":0,"bookId":20749237801156404,"itemType":0,"name":"@string","isHot":true}]
     */
    topList?: {
      index?: number;
      /**
       * 20749237801156404
       */
      bookId?: number;
      itemType?: number;
      /**
       * "@string"
       */
      name?: string;
      /**
       * true
       */
      isHot?: boolean;
    }[];
  }[];
}

/**
 * 接口 [获取推荐榜单list↗](https://yapi.yuewen.com/project/2309/interface/api/253128) 的 **请求配置的类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-top-list`
 * @更新时间 `2022-12-02 15:47:58`
 */
type GoPcmMatrixSearchGetTopListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/matrix/search/get-top-list",
    "data",
    string,
    string,
    true
  >
>;

/**
 * 接口 [获取推荐榜单list↗](https://yapi.yuewen.com/project/2309/interface/api/253128) 的 **请求配置**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-top-list`
 * @更新时间 `2022-12-02 15:47:58`
 */
const goPcmMatrixSearchGetTopListRequestConfig: GoPcmMatrixSearchGetTopListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_47,
    devUrl: devUrl_0_0_0_47,
    prodUrl: prodUrl_0_0_0_47,
    path: "/go/pcm/matrix/search/get-top-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_47,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixSearchGetTopList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取推荐榜单list↗](https://yapi.yuewen.com/project/2309/interface/api/253128) 的 **请求函数**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-top-list`
 * @更新时间 `2022-12-02 15:47:58`
 */
export const goPcmMatrixSearchGetTopList = /*#__PURE__*/ (
  requestData?: GoPcmMatrixSearchGetTopListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMatrixSearchGetTopListResponse>(
    prepare(goPcmMatrixSearchGetTopListRequestConfig, requestData),
    ...args
  );
};

goPcmMatrixSearchGetTopList.requestConfig =
  goPcmMatrixSearchGetTopListRequestConfig;

/**
 * 接口 [获取tag书↗](https://yapi.yuewen.com/project/2309/interface/api/253360) 的 **请求类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-tag-book-list`
 * @更新时间 `2024-10-16 17:02:16`
 */
export interface GoPcmMatrixSearchGetTagBookListRequest {
  tagId: string;
  /**
   * 分页，每页20条
   */
  pageIndex: string;
  /**
   * 0:Popular 1:Updated 2:Collection 默认1
   */
  sortType: string;
  /**
   * 章节数>=多少章
   * -1 all
   * 1 <50
   * 2 50~100
   * 3 100-200
   * 4 200-500
   * 5 500-1000
   * 6 >1000
   *
   * 规则：
   * 如果选了-1，就不能再选其他，-1和其他的互斥。
   * 可以选多个，比如选<50&&50~100,传参数：1,2
   */
  chapters: string;
  /**
   * -1 all
   * 30 ongoing
   * 50 completed
   */
  status: string;
  pageSize?: string;
  /**
   * 1 小说 默认
   * 2 漫画
   * 3 public
   * 4 fanfic
   */
  categoryType: string;
}

/**
 * 接口 [获取tag书↗](https://yapi.yuewen.com/project/2309/interface/api/253360) 的 **返回类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-tag-book-list`
 * @更新时间 `2024-10-16 17:02:16`
 */
export interface GoPcmMatrixSearchGetTagBookListResponse {}

/**
 * 接口 [获取tag书↗](https://yapi.yuewen.com/project/2309/interface/api/253360) 的 **请求配置的类型**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-tag-book-list`
 * @更新时间 `2024-10-16 17:02:16`
 */
type GoPcmMatrixSearchGetTagBookListRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/matrix/search/get-tag-book-list",
    "data",
    string,
    | "tagId"
    | "pageIndex"
    | "sortType"
    | "chapters"
    | "status"
    | "pageSize"
    | "categoryType",
    false
  >
>;

/**
 * 接口 [获取tag书↗](https://yapi.yuewen.com/project/2309/interface/api/253360) 的 **请求配置**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-tag-book-list`
 * @更新时间 `2024-10-16 17:02:16`
 */
const goPcmMatrixSearchGetTagBookListRequestConfig: GoPcmMatrixSearchGetTagBookListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_47,
    devUrl: devUrl_0_0_0_47,
    prodUrl: prodUrl_0_0_0_47,
    path: "/go/pcm/matrix/search/get-tag-book-list",
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_47,
    paramNames: [],
    queryNames: [
      "tagId",
      "pageIndex",
      "sortType",
      "chapters",
      "status",
      "pageSize",
      "categoryType",
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixSearchGetTagBookList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [获取tag书↗](https://yapi.yuewen.com/project/2309/interface/api/253360) 的 **请求函数**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-tag-book-list`
 * @更新时间 `2024-10-16 17:02:16`
 */
export const goPcmMatrixSearchGetTagBookList = /*#__PURE__*/ (
  requestData: GoPcmMatrixSearchGetTagBookListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmMatrixSearchGetTagBookListResponse>(
    prepare(goPcmMatrixSearchGetTagBookListRequestConfig, requestData),
    ...args
  );
};

goPcmMatrixSearchGetTagBookList.requestConfig =
  goPcmMatrixSearchGetTagBookListRequestConfig;

const mockUrl_0_0_0_48 = "https://yapi.yuewen.com/mock/2309" as any;
const devUrl_0_0_0_48 = "https://oawww.webnovel.com" as any;
const prodUrl_0_0_0_48 = "https://www.webnovel.com" as any;
const dataKey_0_0_0_48 = "data" as any;

/**
 * 接口 [Bind 账号绑定↗](https://yapi.yuewen.com/project/2309/interface/api/257620) 的 **请求类型**
 *
 * @分类 [discord↗](https://yapi.yuewen.com/project/2309/interface/api/cat_33460)
 * @请求头 `POST /go/pcm/discord/bind`
 * @更新时间 `2023-08-24 14:17:05`
 */
export interface GoPcmDiscordBindRequest {
  code: string;
  /**
   * state的格式：Wn用户id+时间戳+随机的字符串(字母数字)
   * 下划线连接
   */
  state: string;
  /**
   * 默认是空的，那就是绑定readers。
   */
  serverName: string;
}

/**
 * 接口 [Bind 账号绑定↗](https://yapi.yuewen.com/project/2309/interface/api/257620) 的 **返回类型**
 *
 * @分类 [discord↗](https://yapi.yuewen.com/project/2309/interface/api/cat_33460)
 * @请求头 `POST /go/pcm/discord/bind`
 * @更新时间 `2023-08-24 14:17:05`
 */
export interface GoPcmDiscordBindResponse {}

/**
 * 接口 [Bind 账号绑定↗](https://yapi.yuewen.com/project/2309/interface/api/257620) 的 **请求配置的类型**
 *
 * @分类 [discord↗](https://yapi.yuewen.com/project/2309/interface/api/cat_33460)
 * @请求头 `POST /go/pcm/discord/bind`
 * @更新时间 `2023-08-24 14:17:05`
 */
type GoPcmDiscordBindRequestConfig = Readonly<
  RequestConfig<
    "https://yapi.yuewen.com/mock/2309",
    "https://oawww.webnovel.com",
    "https://www.webnovel.com",
    "/go/pcm/discord/bind",
    "data",
    string,
    string,
    false
  >
>;

/**
 * 接口 [Bind 账号绑定↗](https://yapi.yuewen.com/project/2309/interface/api/257620) 的 **请求配置**
 *
 * @分类 [discord↗](https://yapi.yuewen.com/project/2309/interface/api/cat_33460)
 * @请求头 `POST /go/pcm/discord/bind`
 * @更新时间 `2023-08-24 14:17:05`
 */
const goPcmDiscordBindRequestConfig: GoPcmDiscordBindRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_48,
    devUrl: devUrl_0_0_0_48,
    prodUrl: prodUrl_0_0_0_48,
    path: "/go/pcm/discord/bind",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_48,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmDiscordBind",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
  };

/**
 * 接口 [Bind 账号绑定↗](https://yapi.yuewen.com/project/2309/interface/api/257620) 的 **请求函数**
 *
 * @分类 [discord↗](https://yapi.yuewen.com/project/2309/interface/api/cat_33460)
 * @请求头 `POST /go/pcm/discord/bind`
 * @更新时间 `2023-08-24 14:17:05`
 */
export const goPcmDiscordBind = /*#__PURE__*/ (
  requestData: GoPcmDiscordBindRequest,
  ...args: UserRequestRestArgs
) => {
  return request<GoPcmDiscordBindResponse>(
    prepare(goPcmDiscordBindRequestConfig, requestData),
    ...args
  );
};

goPcmDiscordBind.requestConfig = goPcmDiscordBindRequestConfig;

/* prettier-ignore-end */
